
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7E7Dk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5p76L"));

});
parcelRegister("5p76L", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3ef4cd0f3c0f7478$export$dca3b0875bd9a954; }, function (v) { return $3ef4cd0f3c0f7478$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3ef4cd0f3c0f7478$export$16fa2f45be04daa8; }, function (v) { return $3ef4cd0f3c0f7478$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3ef4cd0f3c0f7478$export$ffb0004e005737fa; }, function (v) { return $3ef4cd0f3c0f7478$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3ef4cd0f3c0f7478$export$e2c29f18771995cb; }, function (v) { return $3ef4cd0f3c0f7478$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3ef4cd0f3c0f7478$export$221d75b3f55bb0bd; }, function (v) { return $3ef4cd0f3c0f7478$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3ef4cd0f3c0f7478$export$5f8d39834fd61797; }, function (v) { return $3ef4cd0f3c0f7478$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3ef4cd0f3c0f7478$export$74bf444e3cd11ea5; }, function (v) { return $3ef4cd0f3c0f7478$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3ef4cd0f3c0f7478$export$ae55be85d98224ed; }, function (v) { return $3ef4cd0f3c0f7478$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3ef4cd0f3c0f7478$export$e530037191fcd5d7; }, function (v) { return $3ef4cd0f3c0f7478$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3ef4cd0f3c0f7478$export$fd42f52fd3ae1109; }, function (v) { return $3ef4cd0f3c0f7478$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3ef4cd0f3c0f7478$export$c8a8987d4410bf2d; }, function (v) { return $3ef4cd0f3c0f7478$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $3ef4cd0f3c0f7478$export$d38cd72104c1f0e9; }, function (v) { return $3ef4cd0f3c0f7478$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $3ef4cd0f3c0f7478$export$7d1e3a5e95ceca43; }, function (v) { return $3ef4cd0f3c0f7478$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3ef4cd0f3c0f7478$export$257a8862b851cb5b; }, function (v) { return $3ef4cd0f3c0f7478$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3ef4cd0f3c0f7478$export$a8257692ac88316c; }, function (v) { return $3ef4cd0f3c0f7478$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3ef4cd0f3c0f7478$export$488013bae63b21da; }, function (v) { return $3ef4cd0f3c0f7478$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3ef4cd0f3c0f7478$export$7c73462e0d25e514; }, function (v) { return $3ef4cd0f3c0f7478$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3ef4cd0f3c0f7478$export$7568632d0d33d16d; }, function (v) { return $3ef4cd0f3c0f7478$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $3ef4cd0f3c0f7478$export$88948ce120ea2619; }, function (v) { return $3ef4cd0f3c0f7478$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3ef4cd0f3c0f7478$export$35808ee640e87ca7; }, function (v) { return $3ef4cd0f3c0f7478$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3ef4cd0f3c0f7478$export$fae74005e78b1a27; }, function (v) { return $3ef4cd0f3c0f7478$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3ef4cd0f3c0f7478$export$dc8fbce3eb94dc1e; }, function (v) { return $3ef4cd0f3c0f7478$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3ef4cd0f3c0f7478$export$6a7bc4e911dc01cf; }, function (v) { return $3ef4cd0f3c0f7478$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3ef4cd0f3c0f7478$export$6d9c69b0de29b591; }, function (v) { return $3ef4cd0f3c0f7478$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3ef4cd0f3c0f7478$export$f680877a34711e37; }, function (v) { return $3ef4cd0f3c0f7478$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3ef4cd0f3c0f7478$export$d5a552a76deda3c2; }, function (v) { return $3ef4cd0f3c0f7478$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3ef4cd0f3c0f7478$export$aaabe4eda9ed9969; }, function (v) { return $3ef4cd0f3c0f7478$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3ef4cd0f3c0f7478$export$e5c5a5f917a5871c; }, function (v) { return $3ef4cd0f3c0f7478$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3ef4cd0f3c0f7478$export$1538c33de8887b59; }, function (v) { return $3ef4cd0f3c0f7478$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $3ef4cd0f3c0f7478$export$13e3392192263954; }, function (v) { return $3ef4cd0f3c0f7478$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3ef4cd0f3c0f7478$export$b8f5890fc79d6aca; }, function (v) { return $3ef4cd0f3c0f7478$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3ef4cd0f3c0f7478$export$60241385465d0a34; }, function (v) { return $3ef4cd0f3c0f7478$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3ef4cd0f3c0f7478$export$306c0aa65ff9ec16; }, function (v) { return $3ef4cd0f3c0f7478$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3ef4cd0f3c0f7478$export$7b286972b8d8ccbf; }, function (v) { return $3ef4cd0f3c0f7478$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3ef4cd0f3c0f7478$export$83d89fbfd8236492; }, function (v) { return $3ef4cd0f3c0f7478$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3ef4cd0f3c0f7478$export$dca3b0875bd9a954;
var $3ef4cd0f3c0f7478$export$16fa2f45be04daa8;
var $3ef4cd0f3c0f7478$export$ffb0004e005737fa;
var $3ef4cd0f3c0f7478$export$e2c29f18771995cb;
var $3ef4cd0f3c0f7478$export$221d75b3f55bb0bd;
var $3ef4cd0f3c0f7478$export$5f8d39834fd61797;
var $3ef4cd0f3c0f7478$export$74bf444e3cd11ea5;
var $3ef4cd0f3c0f7478$export$ae55be85d98224ed;
var $3ef4cd0f3c0f7478$export$e530037191fcd5d7;
var $3ef4cd0f3c0f7478$export$fd42f52fd3ae1109;
var $3ef4cd0f3c0f7478$export$c8a8987d4410bf2d;
var $3ef4cd0f3c0f7478$export$d38cd72104c1f0e9;
var $3ef4cd0f3c0f7478$export$7d1e3a5e95ceca43;
var $3ef4cd0f3c0f7478$export$257a8862b851cb5b;
var $3ef4cd0f3c0f7478$export$a8257692ac88316c;
var $3ef4cd0f3c0f7478$export$488013bae63b21da;
var $3ef4cd0f3c0f7478$export$7c73462e0d25e514;
var $3ef4cd0f3c0f7478$export$7568632d0d33d16d;
var $3ef4cd0f3c0f7478$export$88948ce120ea2619;
var $3ef4cd0f3c0f7478$export$35808ee640e87ca7;
var $3ef4cd0f3c0f7478$export$fae74005e78b1a27;
var $3ef4cd0f3c0f7478$export$dc8fbce3eb94dc1e;
var $3ef4cd0f3c0f7478$export$6a7bc4e911dc01cf;
var $3ef4cd0f3c0f7478$export$6d9c69b0de29b591;
var $3ef4cd0f3c0f7478$export$f680877a34711e37;
var $3ef4cd0f3c0f7478$export$d5a552a76deda3c2;
var $3ef4cd0f3c0f7478$export$aaabe4eda9ed9969;
var $3ef4cd0f3c0f7478$export$e5c5a5f917a5871c;
var $3ef4cd0f3c0f7478$export$1538c33de8887b59;
var $3ef4cd0f3c0f7478$export$13e3392192263954;
var $3ef4cd0f3c0f7478$export$b8f5890fc79d6aca;
var $3ef4cd0f3c0f7478$export$60241385465d0a34;
var $3ef4cd0f3c0f7478$export$306c0aa65ff9ec16;
var $3ef4cd0f3c0f7478$export$7b286972b8d8ccbf;
var $3ef4cd0f3c0f7478$export$83d89fbfd8236492;
"use strict";
var $3ef4cd0f3c0f7478$var$l = Symbol.for("react.element"), $3ef4cd0f3c0f7478$var$n = Symbol.for("react.portal"), $3ef4cd0f3c0f7478$var$p = Symbol.for("react.fragment"), $3ef4cd0f3c0f7478$var$q = Symbol.for("react.strict_mode"), $3ef4cd0f3c0f7478$var$r = Symbol.for("react.profiler"), $3ef4cd0f3c0f7478$var$t = Symbol.for("react.provider"), $3ef4cd0f3c0f7478$var$u = Symbol.for("react.context"), $3ef4cd0f3c0f7478$var$v = Symbol.for("react.forward_ref"), $3ef4cd0f3c0f7478$var$w = Symbol.for("react.suspense"), $3ef4cd0f3c0f7478$var$x = Symbol.for("react.memo"), $3ef4cd0f3c0f7478$var$y = Symbol.for("react.lazy"), $3ef4cd0f3c0f7478$var$z = Symbol.iterator;
function $3ef4cd0f3c0f7478$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3ef4cd0f3c0f7478$var$z && a[$3ef4cd0f3c0f7478$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3ef4cd0f3c0f7478$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $3ef4cd0f3c0f7478$var$C = Object.assign, $3ef4cd0f3c0f7478$var$D = {};
function $3ef4cd0f3c0f7478$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3ef4cd0f3c0f7478$var$D;
    this.updater = e || $3ef4cd0f3c0f7478$var$B;
}
$3ef4cd0f3c0f7478$var$E.prototype.isReactComponent = {};
$3ef4cd0f3c0f7478$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3ef4cd0f3c0f7478$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3ef4cd0f3c0f7478$var$F() {}
$3ef4cd0f3c0f7478$var$F.prototype = $3ef4cd0f3c0f7478$var$E.prototype;
function $3ef4cd0f3c0f7478$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3ef4cd0f3c0f7478$var$D;
    this.updater = e || $3ef4cd0f3c0f7478$var$B;
}
var $3ef4cd0f3c0f7478$var$H = $3ef4cd0f3c0f7478$var$G.prototype = new $3ef4cd0f3c0f7478$var$F;
$3ef4cd0f3c0f7478$var$H.constructor = $3ef4cd0f3c0f7478$var$G;
$3ef4cd0f3c0f7478$var$C($3ef4cd0f3c0f7478$var$H, $3ef4cd0f3c0f7478$var$E.prototype);
$3ef4cd0f3c0f7478$var$H.isPureReactComponent = !0;
var $3ef4cd0f3c0f7478$var$I = Array.isArray, $3ef4cd0f3c0f7478$var$J = Object.prototype.hasOwnProperty, $3ef4cd0f3c0f7478$var$K = {
    current: null
}, $3ef4cd0f3c0f7478$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3ef4cd0f3c0f7478$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3ef4cd0f3c0f7478$var$J.call(b, d) && !$3ef4cd0f3c0f7478$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3ef4cd0f3c0f7478$var$K.current
    };
}
function $3ef4cd0f3c0f7478$var$N(a, b) {
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3ef4cd0f3c0f7478$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3ef4cd0f3c0f7478$var$l;
}
function $3ef4cd0f3c0f7478$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3ef4cd0f3c0f7478$var$P = /\/+/g;
function $3ef4cd0f3c0f7478$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $3ef4cd0f3c0f7478$var$escape("" + a.key) : b.toString(36);
}
function $3ef4cd0f3c0f7478$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3ef4cd0f3c0f7478$var$l:
                case $3ef4cd0f3c0f7478$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3ef4cd0f3c0f7478$var$Q(h, 0) : d, $3ef4cd0f3c0f7478$var$I(c) ? (e = "", null != a && (e = a.replace($3ef4cd0f3c0f7478$var$P, "$&/") + "/"), $3ef4cd0f3c0f7478$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3ef4cd0f3c0f7478$var$O(c) && (c = $3ef4cd0f3c0f7478$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3ef4cd0f3c0f7478$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3ef4cd0f3c0f7478$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3ef4cd0f3c0f7478$var$Q(k, g);
        h += $3ef4cd0f3c0f7478$var$R(k, b, e, f, c);
    }
    else if (f = $3ef4cd0f3c0f7478$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3ef4cd0f3c0f7478$var$Q(k, g++), h += $3ef4cd0f3c0f7478$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3ef4cd0f3c0f7478$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3ef4cd0f3c0f7478$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3ef4cd0f3c0f7478$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3ef4cd0f3c0f7478$var$U = {
    current: null
}, $3ef4cd0f3c0f7478$var$V = {
    transition: null
}, $3ef4cd0f3c0f7478$var$W = {
    ReactCurrentDispatcher: $3ef4cd0f3c0f7478$var$U,
    ReactCurrentBatchConfig: $3ef4cd0f3c0f7478$var$V,
    ReactCurrentOwner: $3ef4cd0f3c0f7478$var$K
};
$3ef4cd0f3c0f7478$export$dca3b0875bd9a954 = {
    map: $3ef4cd0f3c0f7478$var$S,
    forEach: function(a, b, e) {
        $3ef4cd0f3c0f7478$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $3ef4cd0f3c0f7478$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $3ef4cd0f3c0f7478$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$3ef4cd0f3c0f7478$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3ef4cd0f3c0f7478$export$16fa2f45be04daa8 = $3ef4cd0f3c0f7478$var$E;
$3ef4cd0f3c0f7478$export$ffb0004e005737fa = $3ef4cd0f3c0f7478$var$p;
$3ef4cd0f3c0f7478$export$e2c29f18771995cb = $3ef4cd0f3c0f7478$var$r;
$3ef4cd0f3c0f7478$export$221d75b3f55bb0bd = $3ef4cd0f3c0f7478$var$G;
$3ef4cd0f3c0f7478$export$5f8d39834fd61797 = $3ef4cd0f3c0f7478$var$q;
$3ef4cd0f3c0f7478$export$74bf444e3cd11ea5 = $3ef4cd0f3c0f7478$var$w;
$3ef4cd0f3c0f7478$export$ae55be85d98224ed = $3ef4cd0f3c0f7478$var$W;
$3ef4cd0f3c0f7478$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3ef4cd0f3c0f7478$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3ef4cd0f3c0f7478$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3ef4cd0f3c0f7478$var$J.call(b, f) && !$3ef4cd0f3c0f7478$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3ef4cd0f3c0f7478$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3ef4cd0f3c0f7478$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3ef4cd0f3c0f7478$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3ef4cd0f3c0f7478$export$c8a8987d4410bf2d = $3ef4cd0f3c0f7478$var$M;
$3ef4cd0f3c0f7478$export$d38cd72104c1f0e9 = function(a) {
    var b = $3ef4cd0f3c0f7478$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3ef4cd0f3c0f7478$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3ef4cd0f3c0f7478$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$v,
        render: a
    };
};
$3ef4cd0f3c0f7478$export$a8257692ac88316c = $3ef4cd0f3c0f7478$var$O;
$3ef4cd0f3c0f7478$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3ef4cd0f3c0f7478$var$T
    };
};
$3ef4cd0f3c0f7478$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3ef4cd0f3c0f7478$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3ef4cd0f3c0f7478$export$7568632d0d33d16d = function(a) {
    var b = $3ef4cd0f3c0f7478$var$V.transition;
    $3ef4cd0f3c0f7478$var$V.transition = {};
    try {
        a();
    } finally{
        $3ef4cd0f3c0f7478$var$V.transition = b;
    }
};
$3ef4cd0f3c0f7478$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3ef4cd0f3c0f7478$export$35808ee640e87ca7 = function(a, b) {
    return $3ef4cd0f3c0f7478$var$U.current.useCallback(a, b);
};
$3ef4cd0f3c0f7478$export$fae74005e78b1a27 = function(a) {
    return $3ef4cd0f3c0f7478$var$U.current.useContext(a);
};
$3ef4cd0f3c0f7478$export$dc8fbce3eb94dc1e = function() {};
$3ef4cd0f3c0f7478$export$6a7bc4e911dc01cf = function(a) {
    return $3ef4cd0f3c0f7478$var$U.current.useDeferredValue(a);
};
$3ef4cd0f3c0f7478$export$6d9c69b0de29b591 = function(a, b) {
    return $3ef4cd0f3c0f7478$var$U.current.useEffect(a, b);
};
$3ef4cd0f3c0f7478$export$f680877a34711e37 = function() {
    return $3ef4cd0f3c0f7478$var$U.current.useId();
};
$3ef4cd0f3c0f7478$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3ef4cd0f3c0f7478$var$U.current.useImperativeHandle(a, b, e);
};
$3ef4cd0f3c0f7478$export$aaabe4eda9ed9969 = function(a, b) {
    return $3ef4cd0f3c0f7478$var$U.current.useInsertionEffect(a, b);
};
$3ef4cd0f3c0f7478$export$e5c5a5f917a5871c = function(a, b) {
    return $3ef4cd0f3c0f7478$var$U.current.useLayoutEffect(a, b);
};
$3ef4cd0f3c0f7478$export$1538c33de8887b59 = function(a, b) {
    return $3ef4cd0f3c0f7478$var$U.current.useMemo(a, b);
};
$3ef4cd0f3c0f7478$export$13e3392192263954 = function(a, b, e) {
    return $3ef4cd0f3c0f7478$var$U.current.useReducer(a, b, e);
};
$3ef4cd0f3c0f7478$export$b8f5890fc79d6aca = function(a) {
    return $3ef4cd0f3c0f7478$var$U.current.useRef(a);
};
$3ef4cd0f3c0f7478$export$60241385465d0a34 = function(a) {
    return $3ef4cd0f3c0f7478$var$U.current.useState(a);
};
$3ef4cd0f3c0f7478$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3ef4cd0f3c0f7478$var$U.current.useSyncExternalStore(a, b, e);
};
$3ef4cd0f3c0f7478$export$7b286972b8d8ccbf = function() {
    return $3ef4cd0f3c0f7478$var$U.current.useTransition();
};
$3ef4cd0f3c0f7478$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("9Sg2u", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $73059942aa1b7d8d$export$882461b6382ed46c; }, function (v) { return $73059942aa1b7d8d$export$882461b6382ed46c = v; });
var $73059942aa1b7d8d$export$882461b6382ed46c;
var $73059942aa1b7d8d$export$757ceba2d55c277e;
"use strict";

var $hzbSh = parcelRequire("hzbSh");
var $73059942aa1b7d8d$var$i;
$73059942aa1b7d8d$export$882461b6382ed46c = $hzbSh.createRoot;
$73059942aa1b7d8d$export$757ceba2d55c277e = $hzbSh.hydrateRoot;

});
parcelRegister("hzbSh", function(module, exports) {
"use strict";
function $cc9eea8f2916f791$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cc9eea8f2916f791$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cc9eea8f2916f791$var$checkDCE();

module.exports = (parcelRequire("l7r9e"));

});
parcelRegister("l7r9e", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f5ff4f6e5214f126$export$ae55be85d98224ed; }, function (v) { return $f5ff4f6e5214f126$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $f5ff4f6e5214f126$export$d39a5bbd09211389; }, function (v) { return $f5ff4f6e5214f126$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $f5ff4f6e5214f126$export$882461b6382ed46c; }, function (v) { return $f5ff4f6e5214f126$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $f5ff4f6e5214f126$export$466bfc07425424d5; }, function (v) { return $f5ff4f6e5214f126$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f5ff4f6e5214f126$export$cd75ccfd720a3cd4; }, function (v) { return $f5ff4f6e5214f126$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $f5ff4f6e5214f126$export$fa8d919ba61d84db; }, function (v) { return $f5ff4f6e5214f126$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f5ff4f6e5214f126$export$757ceba2d55c277e; }, function (v) { return $f5ff4f6e5214f126$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $f5ff4f6e5214f126$export$b3890eb0ae9dca99; }, function (v) { return $f5ff4f6e5214f126$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $f5ff4f6e5214f126$export$502457920280e6be; }, function (v) { return $f5ff4f6e5214f126$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f5ff4f6e5214f126$export$c78a37762a8d58e1; }, function (v) { return $f5ff4f6e5214f126$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $f5ff4f6e5214f126$export$dc54d992c10e8a18; }, function (v) { return $f5ff4f6e5214f126$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $f5ff4f6e5214f126$export$83d89fbfd8236492; }, function (v) { return $f5ff4f6e5214f126$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f5ff4f6e5214f126$export$ae55be85d98224ed;
var $f5ff4f6e5214f126$export$d39a5bbd09211389;
var $f5ff4f6e5214f126$export$882461b6382ed46c;
var $f5ff4f6e5214f126$export$466bfc07425424d5;
var $f5ff4f6e5214f126$export$cd75ccfd720a3cd4;
var $f5ff4f6e5214f126$export$fa8d919ba61d84db;
var $f5ff4f6e5214f126$export$757ceba2d55c277e;
var $f5ff4f6e5214f126$export$b3890eb0ae9dca99;
var $f5ff4f6e5214f126$export$502457920280e6be;
var $f5ff4f6e5214f126$export$c78a37762a8d58e1;
var $f5ff4f6e5214f126$export$dc54d992c10e8a18;
var $f5ff4f6e5214f126$export$83d89fbfd8236492;
"use strict";

var $7E7Dk = parcelRequire("7E7Dk");

var $7FBhF = parcelRequire("7FBhF");
function $f5ff4f6e5214f126$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f5ff4f6e5214f126$var$da = new Set, $f5ff4f6e5214f126$var$ea = {};
function $f5ff4f6e5214f126$var$fa(a, b) {
    $f5ff4f6e5214f126$var$ha(a, b);
    $f5ff4f6e5214f126$var$ha(a + "Capture", b);
}
function $f5ff4f6e5214f126$var$ha(a, b) {
    $f5ff4f6e5214f126$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f5ff4f6e5214f126$var$da.add(b[a]);
}
var $f5ff4f6e5214f126$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f5ff4f6e5214f126$var$ja = Object.prototype.hasOwnProperty, $f5ff4f6e5214f126$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f5ff4f6e5214f126$var$la = {}, $f5ff4f6e5214f126$var$ma = {};
function $f5ff4f6e5214f126$var$oa(a) {
    if ($f5ff4f6e5214f126$var$ja.call($f5ff4f6e5214f126$var$ma, a)) return !0;
    if ($f5ff4f6e5214f126$var$ja.call($f5ff4f6e5214f126$var$la, a)) return !1;
    if ($f5ff4f6e5214f126$var$ka.test(a)) return $f5ff4f6e5214f126$var$ma[a] = !0;
    $f5ff4f6e5214f126$var$la[a] = !0;
    return !1;
}
function $f5ff4f6e5214f126$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f5ff4f6e5214f126$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f5ff4f6e5214f126$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f5ff4f6e5214f126$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f5ff4f6e5214f126$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f5ff4f6e5214f126$var$z[b] = new $f5ff4f6e5214f126$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f5ff4f6e5214f126$var$ra = /[\-:]([a-z])/g;
function $f5ff4f6e5214f126$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f5ff4f6e5214f126$var$ra, $f5ff4f6e5214f126$var$sa);
    $f5ff4f6e5214f126$var$z[b] = new $f5ff4f6e5214f126$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f5ff4f6e5214f126$var$ra, $f5ff4f6e5214f126$var$sa);
    $f5ff4f6e5214f126$var$z[b] = new $f5ff4f6e5214f126$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f5ff4f6e5214f126$var$ra, $f5ff4f6e5214f126$var$sa);
    $f5ff4f6e5214f126$var$z[b] = new $f5ff4f6e5214f126$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f5ff4f6e5214f126$var$z.xlinkHref = new $f5ff4f6e5214f126$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f5ff4f6e5214f126$var$z[a] = new $f5ff4f6e5214f126$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f5ff4f6e5214f126$var$ta(a, b, c, d) {
    var e = $f5ff4f6e5214f126$var$z.hasOwnProperty(b) ? $f5ff4f6e5214f126$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f5ff4f6e5214f126$var$qa(b, c, e, d) && (c = null), d || null === e ? $f5ff4f6e5214f126$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f5ff4f6e5214f126$var$ua = $7E7Dk.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f5ff4f6e5214f126$var$va = Symbol.for("react.element"), $f5ff4f6e5214f126$var$wa = Symbol.for("react.portal"), $f5ff4f6e5214f126$var$ya = Symbol.for("react.fragment"), $f5ff4f6e5214f126$var$za = Symbol.for("react.strict_mode"), $f5ff4f6e5214f126$var$Aa = Symbol.for("react.profiler"), $f5ff4f6e5214f126$var$Ba = Symbol.for("react.provider"), $f5ff4f6e5214f126$var$Ca = Symbol.for("react.context"), $f5ff4f6e5214f126$var$Da = Symbol.for("react.forward_ref"), $f5ff4f6e5214f126$var$Ea = Symbol.for("react.suspense"), $f5ff4f6e5214f126$var$Fa = Symbol.for("react.suspense_list"), $f5ff4f6e5214f126$var$Ga = Symbol.for("react.memo"), $f5ff4f6e5214f126$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f5ff4f6e5214f126$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f5ff4f6e5214f126$var$Ja = Symbol.iterator;
function $f5ff4f6e5214f126$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f5ff4f6e5214f126$var$Ja && a[$f5ff4f6e5214f126$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f5ff4f6e5214f126$var$A = Object.assign, $f5ff4f6e5214f126$var$La;
function $f5ff4f6e5214f126$var$Ma(a) {
    if (void 0 === $f5ff4f6e5214f126$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f5ff4f6e5214f126$var$La = b && b[1] || "";
    }
    return "\n" + $f5ff4f6e5214f126$var$La + a;
}
var $f5ff4f6e5214f126$var$Na = !1;
function $f5ff4f6e5214f126$var$Oa(a, b) {
    if (!a || $f5ff4f6e5214f126$var$Na) return "";
    $f5ff4f6e5214f126$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f5ff4f6e5214f126$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f5ff4f6e5214f126$var$Ma(a) : "";
}
function $f5ff4f6e5214f126$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f5ff4f6e5214f126$var$Ma(a.type);
        case 16:
            return $f5ff4f6e5214f126$var$Ma("Lazy");
        case 13:
            return $f5ff4f6e5214f126$var$Ma("Suspense");
        case 19:
            return $f5ff4f6e5214f126$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f5ff4f6e5214f126$var$Oa(a.type, !1), a;
        case 11:
            return a = $f5ff4f6e5214f126$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f5ff4f6e5214f126$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f5ff4f6e5214f126$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f5ff4f6e5214f126$var$ya:
            return "Fragment";
        case $f5ff4f6e5214f126$var$wa:
            return "Portal";
        case $f5ff4f6e5214f126$var$Aa:
            return "Profiler";
        case $f5ff4f6e5214f126$var$za:
            return "StrictMode";
        case $f5ff4f6e5214f126$var$Ea:
            return "Suspense";
        case $f5ff4f6e5214f126$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f5ff4f6e5214f126$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f5ff4f6e5214f126$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f5ff4f6e5214f126$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f5ff4f6e5214f126$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f5ff4f6e5214f126$var$Qa(a.type) || "Memo";
        case $f5ff4f6e5214f126$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f5ff4f6e5214f126$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f5ff4f6e5214f126$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f5ff4f6e5214f126$var$Qa(b);
        case 8:
            return b === $f5ff4f6e5214f126$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f5ff4f6e5214f126$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f5ff4f6e5214f126$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f5ff4f6e5214f126$var$Ua(a) {
    var b = $f5ff4f6e5214f126$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f5ff4f6e5214f126$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f5ff4f6e5214f126$var$Ua(a));
}
function $f5ff4f6e5214f126$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f5ff4f6e5214f126$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f5ff4f6e5214f126$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f5ff4f6e5214f126$var$Ya(a, b) {
    var c = b.checked;
    return $f5ff4f6e5214f126$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f5ff4f6e5214f126$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f5ff4f6e5214f126$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f5ff4f6e5214f126$var$ab(a, b) {
    b = b.checked;
    null != b && $f5ff4f6e5214f126$var$ta(a, "checked", b, !1);
}
function $f5ff4f6e5214f126$var$bb(a, b) {
    $f5ff4f6e5214f126$var$ab(a, b);
    var c = $f5ff4f6e5214f126$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f5ff4f6e5214f126$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f5ff4f6e5214f126$var$cb(a, b.type, $f5ff4f6e5214f126$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f5ff4f6e5214f126$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f5ff4f6e5214f126$var$cb(a, b, c) {
    if ("number" !== b || $f5ff4f6e5214f126$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f5ff4f6e5214f126$var$eb = Array.isArray;
function $f5ff4f6e5214f126$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f5ff4f6e5214f126$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f5ff4f6e5214f126$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f5ff4f6e5214f126$var$p(91));
    return $f5ff4f6e5214f126$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f5ff4f6e5214f126$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f5ff4f6e5214f126$var$p(92));
            if ($f5ff4f6e5214f126$var$eb(c)) {
                if (1 < c.length) throw Error($f5ff4f6e5214f126$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f5ff4f6e5214f126$var$Sa(c)
    };
}
function $f5ff4f6e5214f126$var$ib(a, b) {
    var c = $f5ff4f6e5214f126$var$Sa(b.value), d = $f5ff4f6e5214f126$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f5ff4f6e5214f126$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f5ff4f6e5214f126$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f5ff4f6e5214f126$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f5ff4f6e5214f126$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f5ff4f6e5214f126$var$mb, $f5ff4f6e5214f126$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f5ff4f6e5214f126$var$mb = $f5ff4f6e5214f126$var$mb || document.createElement("div");
        $f5ff4f6e5214f126$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f5ff4f6e5214f126$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f5ff4f6e5214f126$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f5ff4f6e5214f126$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f5ff4f6e5214f126$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f5ff4f6e5214f126$var$pb).forEach(function(a) {
    $f5ff4f6e5214f126$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f5ff4f6e5214f126$var$pb[b] = $f5ff4f6e5214f126$var$pb[a];
    });
});
function $f5ff4f6e5214f126$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f5ff4f6e5214f126$var$pb.hasOwnProperty(a) && $f5ff4f6e5214f126$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f5ff4f6e5214f126$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f5ff4f6e5214f126$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f5ff4f6e5214f126$var$tb = $f5ff4f6e5214f126$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f5ff4f6e5214f126$var$ub(a, b) {
    if (b) {
        if ($f5ff4f6e5214f126$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f5ff4f6e5214f126$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f5ff4f6e5214f126$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f5ff4f6e5214f126$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f5ff4f6e5214f126$var$p(62));
    }
}
function $f5ff4f6e5214f126$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f5ff4f6e5214f126$var$wb = null;
function $f5ff4f6e5214f126$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f5ff4f6e5214f126$var$yb = null, $f5ff4f6e5214f126$var$zb = null, $f5ff4f6e5214f126$var$Ab = null;
function $f5ff4f6e5214f126$var$Bb(a) {
    if (a = $f5ff4f6e5214f126$var$Cb(a)) {
        if ("function" !== typeof $f5ff4f6e5214f126$var$yb) throw Error($f5ff4f6e5214f126$var$p(280));
        var b = a.stateNode;
        b && (b = $f5ff4f6e5214f126$var$Db(b), $f5ff4f6e5214f126$var$yb(a.stateNode, a.type, b));
    }
}
function $f5ff4f6e5214f126$var$Eb(a) {
    $f5ff4f6e5214f126$var$zb ? $f5ff4f6e5214f126$var$Ab ? $f5ff4f6e5214f126$var$Ab.push(a) : $f5ff4f6e5214f126$var$Ab = [
        a
    ] : $f5ff4f6e5214f126$var$zb = a;
}
function $f5ff4f6e5214f126$var$Fb() {
    if ($f5ff4f6e5214f126$var$zb) {
        var a = $f5ff4f6e5214f126$var$zb, b = $f5ff4f6e5214f126$var$Ab;
        $f5ff4f6e5214f126$var$Ab = $f5ff4f6e5214f126$var$zb = null;
        $f5ff4f6e5214f126$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f5ff4f6e5214f126$var$Bb(b[a]);
    }
}
function $f5ff4f6e5214f126$var$Gb(a, b) {
    return a(b);
}
function $f5ff4f6e5214f126$var$Hb() {}
var $f5ff4f6e5214f126$var$Ib = !1;
function $f5ff4f6e5214f126$var$Jb(a, b, c) {
    if ($f5ff4f6e5214f126$var$Ib) return a(b, c);
    $f5ff4f6e5214f126$var$Ib = !0;
    try {
        return $f5ff4f6e5214f126$var$Gb(a, b, c);
    } finally{
        if ($f5ff4f6e5214f126$var$Ib = !1, null !== $f5ff4f6e5214f126$var$zb || null !== $f5ff4f6e5214f126$var$Ab) $f5ff4f6e5214f126$var$Hb(), $f5ff4f6e5214f126$var$Fb();
    }
}
function $f5ff4f6e5214f126$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f5ff4f6e5214f126$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f5ff4f6e5214f126$var$p(231, b, typeof c));
    return c;
}
var $f5ff4f6e5214f126$var$Lb = !1;
if ($f5ff4f6e5214f126$var$ia) try {
    var $f5ff4f6e5214f126$var$Mb = {};
    Object.defineProperty($f5ff4f6e5214f126$var$Mb, "passive", {
        get: function() {
            $f5ff4f6e5214f126$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f5ff4f6e5214f126$var$Mb, $f5ff4f6e5214f126$var$Mb);
    window.removeEventListener("test", $f5ff4f6e5214f126$var$Mb, $f5ff4f6e5214f126$var$Mb);
} catch (a) {
    $f5ff4f6e5214f126$var$Lb = !1;
}
function $f5ff4f6e5214f126$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f5ff4f6e5214f126$var$Ob = !1, $f5ff4f6e5214f126$var$Pb = null, $f5ff4f6e5214f126$var$Qb = !1, $f5ff4f6e5214f126$var$Rb = null, $f5ff4f6e5214f126$var$Sb = {
    onError: function(a) {
        $f5ff4f6e5214f126$var$Ob = !0;
        $f5ff4f6e5214f126$var$Pb = a;
    }
};
function $f5ff4f6e5214f126$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f5ff4f6e5214f126$var$Ob = !1;
    $f5ff4f6e5214f126$var$Pb = null;
    $f5ff4f6e5214f126$var$Nb.apply($f5ff4f6e5214f126$var$Sb, arguments);
}
function $f5ff4f6e5214f126$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f5ff4f6e5214f126$var$Tb.apply(this, arguments);
    if ($f5ff4f6e5214f126$var$Ob) {
        if ($f5ff4f6e5214f126$var$Ob) {
            var l = $f5ff4f6e5214f126$var$Pb;
            $f5ff4f6e5214f126$var$Ob = !1;
            $f5ff4f6e5214f126$var$Pb = null;
        } else throw Error($f5ff4f6e5214f126$var$p(198));
        $f5ff4f6e5214f126$var$Qb || ($f5ff4f6e5214f126$var$Qb = !0, $f5ff4f6e5214f126$var$Rb = l);
    }
}
function $f5ff4f6e5214f126$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f5ff4f6e5214f126$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f5ff4f6e5214f126$var$Xb(a) {
    if ($f5ff4f6e5214f126$var$Vb(a) !== a) throw Error($f5ff4f6e5214f126$var$p(188));
}
function $f5ff4f6e5214f126$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f5ff4f6e5214f126$var$Vb(a);
        if (null === b) throw Error($f5ff4f6e5214f126$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f5ff4f6e5214f126$var$Xb(e), a;
                if (f === d) return $f5ff4f6e5214f126$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f5ff4f6e5214f126$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f5ff4f6e5214f126$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f5ff4f6e5214f126$var$p(190));
    }
    if (3 !== c.tag) throw Error($f5ff4f6e5214f126$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f5ff4f6e5214f126$var$Zb(a) {
    a = $f5ff4f6e5214f126$var$Yb(a);
    return null !== a ? $f5ff4f6e5214f126$var$$b(a) : null;
}
function $f5ff4f6e5214f126$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f5ff4f6e5214f126$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f5ff4f6e5214f126$var$ac = $7FBhF.unstable_scheduleCallback, $f5ff4f6e5214f126$var$bc = $7FBhF.unstable_cancelCallback, $f5ff4f6e5214f126$var$cc = $7FBhF.unstable_shouldYield, $f5ff4f6e5214f126$var$dc = $7FBhF.unstable_requestPaint, $f5ff4f6e5214f126$var$B = $7FBhF.unstable_now, $f5ff4f6e5214f126$var$ec = $7FBhF.unstable_getCurrentPriorityLevel, $f5ff4f6e5214f126$var$fc = $7FBhF.unstable_ImmediatePriority, $f5ff4f6e5214f126$var$gc = $7FBhF.unstable_UserBlockingPriority, $f5ff4f6e5214f126$var$hc = $7FBhF.unstable_NormalPriority, $f5ff4f6e5214f126$var$ic = $7FBhF.unstable_LowPriority, $f5ff4f6e5214f126$var$jc = $7FBhF.unstable_IdlePriority, $f5ff4f6e5214f126$var$kc = null, $f5ff4f6e5214f126$var$lc = null;
function $f5ff4f6e5214f126$var$mc(a) {
    if ($f5ff4f6e5214f126$var$lc && "function" === typeof $f5ff4f6e5214f126$var$lc.onCommitFiberRoot) try {
        $f5ff4f6e5214f126$var$lc.onCommitFiberRoot($f5ff4f6e5214f126$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f5ff4f6e5214f126$var$oc = Math.clz32 ? Math.clz32 : $f5ff4f6e5214f126$var$nc, $f5ff4f6e5214f126$var$pc = Math.log, $f5ff4f6e5214f126$var$qc = Math.LN2;
function $f5ff4f6e5214f126$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f5ff4f6e5214f126$var$pc(a) / $f5ff4f6e5214f126$var$qc | 0) | 0;
}
var $f5ff4f6e5214f126$var$rc = 64, $f5ff4f6e5214f126$var$sc = 4194304;
function $f5ff4f6e5214f126$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f5ff4f6e5214f126$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f5ff4f6e5214f126$var$tc(h) : (f &= g, 0 !== f && (d = $f5ff4f6e5214f126$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f5ff4f6e5214f126$var$tc(g) : 0 !== f && (d = $f5ff4f6e5214f126$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f5ff4f6e5214f126$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f5ff4f6e5214f126$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f5ff4f6e5214f126$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f5ff4f6e5214f126$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f5ff4f6e5214f126$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f5ff4f6e5214f126$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f5ff4f6e5214f126$var$yc() {
    var a = $f5ff4f6e5214f126$var$rc;
    $f5ff4f6e5214f126$var$rc <<= 1;
    0 === ($f5ff4f6e5214f126$var$rc & 4194240) && ($f5ff4f6e5214f126$var$rc = 64);
    return a;
}
function $f5ff4f6e5214f126$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f5ff4f6e5214f126$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f5ff4f6e5214f126$var$oc(b);
    a[b] = c;
}
function $f5ff4f6e5214f126$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f5ff4f6e5214f126$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f5ff4f6e5214f126$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f5ff4f6e5214f126$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f5ff4f6e5214f126$var$C = 0;
function $f5ff4f6e5214f126$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f5ff4f6e5214f126$var$Ec, $f5ff4f6e5214f126$var$Fc, $f5ff4f6e5214f126$var$Gc, $f5ff4f6e5214f126$var$Hc, $f5ff4f6e5214f126$var$Ic, $f5ff4f6e5214f126$var$Jc = !1, $f5ff4f6e5214f126$var$Kc = [], $f5ff4f6e5214f126$var$Lc = null, $f5ff4f6e5214f126$var$Mc = null, $f5ff4f6e5214f126$var$Nc = null, $f5ff4f6e5214f126$var$Oc = new Map, $f5ff4f6e5214f126$var$Pc = new Map, $f5ff4f6e5214f126$var$Qc = [], $f5ff4f6e5214f126$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f5ff4f6e5214f126$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f5ff4f6e5214f126$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f5ff4f6e5214f126$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f5ff4f6e5214f126$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f5ff4f6e5214f126$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f5ff4f6e5214f126$var$Pc.delete(b.pointerId);
    }
}
function $f5ff4f6e5214f126$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f5ff4f6e5214f126$var$Cb(b), null !== b && $f5ff4f6e5214f126$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f5ff4f6e5214f126$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f5ff4f6e5214f126$var$Lc = $f5ff4f6e5214f126$var$Tc($f5ff4f6e5214f126$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f5ff4f6e5214f126$var$Mc = $f5ff4f6e5214f126$var$Tc($f5ff4f6e5214f126$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f5ff4f6e5214f126$var$Nc = $f5ff4f6e5214f126$var$Tc($f5ff4f6e5214f126$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f5ff4f6e5214f126$var$Oc.set(f, $f5ff4f6e5214f126$var$Tc($f5ff4f6e5214f126$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f5ff4f6e5214f126$var$Pc.set(f, $f5ff4f6e5214f126$var$Tc($f5ff4f6e5214f126$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f5ff4f6e5214f126$var$Vc(a) {
    var b = $f5ff4f6e5214f126$var$Wc(a.target);
    if (null !== b) {
        var c = $f5ff4f6e5214f126$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f5ff4f6e5214f126$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f5ff4f6e5214f126$var$Ic(a.priority, function() {
                        $f5ff4f6e5214f126$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f5ff4f6e5214f126$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f5ff4f6e5214f126$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f5ff4f6e5214f126$var$wb = d;
            c.target.dispatchEvent(d);
            $f5ff4f6e5214f126$var$wb = null;
        } else return b = $f5ff4f6e5214f126$var$Cb(c), null !== b && $f5ff4f6e5214f126$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f5ff4f6e5214f126$var$Zc(a, b, c) {
    $f5ff4f6e5214f126$var$Xc(a) && c.delete(b);
}
function $f5ff4f6e5214f126$var$$c() {
    $f5ff4f6e5214f126$var$Jc = !1;
    null !== $f5ff4f6e5214f126$var$Lc && $f5ff4f6e5214f126$var$Xc($f5ff4f6e5214f126$var$Lc) && ($f5ff4f6e5214f126$var$Lc = null);
    null !== $f5ff4f6e5214f126$var$Mc && $f5ff4f6e5214f126$var$Xc($f5ff4f6e5214f126$var$Mc) && ($f5ff4f6e5214f126$var$Mc = null);
    null !== $f5ff4f6e5214f126$var$Nc && $f5ff4f6e5214f126$var$Xc($f5ff4f6e5214f126$var$Nc) && ($f5ff4f6e5214f126$var$Nc = null);
    $f5ff4f6e5214f126$var$Oc.forEach($f5ff4f6e5214f126$var$Zc);
    $f5ff4f6e5214f126$var$Pc.forEach($f5ff4f6e5214f126$var$Zc);
}
function $f5ff4f6e5214f126$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f5ff4f6e5214f126$var$Jc || ($f5ff4f6e5214f126$var$Jc = !0, $7FBhF.unstable_scheduleCallback($7FBhF.unstable_NormalPriority, $f5ff4f6e5214f126$var$$c)));
}
function $f5ff4f6e5214f126$var$bd(a) {
    function b(b) {
        return $f5ff4f6e5214f126$var$ad(b, a);
    }
    if (0 < $f5ff4f6e5214f126$var$Kc.length) {
        $f5ff4f6e5214f126$var$ad($f5ff4f6e5214f126$var$Kc[0], a);
        for(var c = 1; c < $f5ff4f6e5214f126$var$Kc.length; c++){
            var d = $f5ff4f6e5214f126$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f5ff4f6e5214f126$var$Lc && $f5ff4f6e5214f126$var$ad($f5ff4f6e5214f126$var$Lc, a);
    null !== $f5ff4f6e5214f126$var$Mc && $f5ff4f6e5214f126$var$ad($f5ff4f6e5214f126$var$Mc, a);
    null !== $f5ff4f6e5214f126$var$Nc && $f5ff4f6e5214f126$var$ad($f5ff4f6e5214f126$var$Nc, a);
    $f5ff4f6e5214f126$var$Oc.forEach(b);
    $f5ff4f6e5214f126$var$Pc.forEach(b);
    for(c = 0; c < $f5ff4f6e5214f126$var$Qc.length; c++)d = $f5ff4f6e5214f126$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f5ff4f6e5214f126$var$Qc.length && (c = $f5ff4f6e5214f126$var$Qc[0], null === c.blockedOn);)$f5ff4f6e5214f126$var$Vc(c), null === c.blockedOn && $f5ff4f6e5214f126$var$Qc.shift();
}
var $f5ff4f6e5214f126$var$cd = $f5ff4f6e5214f126$var$ua.ReactCurrentBatchConfig, $f5ff4f6e5214f126$var$dd = !0;
function $f5ff4f6e5214f126$var$ed(a, b, c, d) {
    var e = $f5ff4f6e5214f126$var$C, f = $f5ff4f6e5214f126$var$cd.transition;
    $f5ff4f6e5214f126$var$cd.transition = null;
    try {
        $f5ff4f6e5214f126$var$C = 1, $f5ff4f6e5214f126$var$fd(a, b, c, d);
    } finally{
        $f5ff4f6e5214f126$var$C = e, $f5ff4f6e5214f126$var$cd.transition = f;
    }
}
function $f5ff4f6e5214f126$var$gd(a, b, c, d) {
    var e = $f5ff4f6e5214f126$var$C, f = $f5ff4f6e5214f126$var$cd.transition;
    $f5ff4f6e5214f126$var$cd.transition = null;
    try {
        $f5ff4f6e5214f126$var$C = 4, $f5ff4f6e5214f126$var$fd(a, b, c, d);
    } finally{
        $f5ff4f6e5214f126$var$C = e, $f5ff4f6e5214f126$var$cd.transition = f;
    }
}
function $f5ff4f6e5214f126$var$fd(a, b, c, d) {
    if ($f5ff4f6e5214f126$var$dd) {
        var e = $f5ff4f6e5214f126$var$Yc(a, b, c, d);
        if (null === e) $f5ff4f6e5214f126$var$hd(a, b, d, $f5ff4f6e5214f126$var$id, c), $f5ff4f6e5214f126$var$Sc(a, d);
        else if ($f5ff4f6e5214f126$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f5ff4f6e5214f126$var$Sc(a, d), b & 4 && -1 < $f5ff4f6e5214f126$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f5ff4f6e5214f126$var$Cb(e);
                null !== f && $f5ff4f6e5214f126$var$Ec(f);
                f = $f5ff4f6e5214f126$var$Yc(a, b, c, d);
                null === f && $f5ff4f6e5214f126$var$hd(a, b, d, $f5ff4f6e5214f126$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f5ff4f6e5214f126$var$hd(a, b, d, null, c);
    }
}
var $f5ff4f6e5214f126$var$id = null;
function $f5ff4f6e5214f126$var$Yc(a, b, c, d) {
    $f5ff4f6e5214f126$var$id = null;
    a = $f5ff4f6e5214f126$var$xb(d);
    a = $f5ff4f6e5214f126$var$Wc(a);
    if (null !== a) {
        if (b = $f5ff4f6e5214f126$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f5ff4f6e5214f126$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f5ff4f6e5214f126$var$id = a;
    return null;
}
function $f5ff4f6e5214f126$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f5ff4f6e5214f126$var$ec()){
                case $f5ff4f6e5214f126$var$fc:
                    return 1;
                case $f5ff4f6e5214f126$var$gc:
                    return 4;
                case $f5ff4f6e5214f126$var$hc:
                case $f5ff4f6e5214f126$var$ic:
                    return 16;
                case $f5ff4f6e5214f126$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f5ff4f6e5214f126$var$kd = null, $f5ff4f6e5214f126$var$ld = null, $f5ff4f6e5214f126$var$md = null;
function $f5ff4f6e5214f126$var$nd() {
    if ($f5ff4f6e5214f126$var$md) return $f5ff4f6e5214f126$var$md;
    var a, b = $f5ff4f6e5214f126$var$ld, c = b.length, d, e = "value" in $f5ff4f6e5214f126$var$kd ? $f5ff4f6e5214f126$var$kd.value : $f5ff4f6e5214f126$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f5ff4f6e5214f126$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f5ff4f6e5214f126$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f5ff4f6e5214f126$var$pd() {
    return !0;
}
function $f5ff4f6e5214f126$var$qd() {
    return !1;
}
function $f5ff4f6e5214f126$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f5ff4f6e5214f126$var$pd : $f5ff4f6e5214f126$var$qd;
        this.isPropagationStopped = $f5ff4f6e5214f126$var$qd;
        return this;
    }
    $f5ff4f6e5214f126$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f5ff4f6e5214f126$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f5ff4f6e5214f126$var$pd);
        },
        persist: function() {},
        isPersistent: $f5ff4f6e5214f126$var$pd
    });
    return b;
}
var $f5ff4f6e5214f126$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f5ff4f6e5214f126$var$td = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$sd), $f5ff4f6e5214f126$var$ud = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$sd, {
    view: 0,
    detail: 0
}), $f5ff4f6e5214f126$var$vd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$ud), $f5ff4f6e5214f126$var$wd, $f5ff4f6e5214f126$var$xd, $f5ff4f6e5214f126$var$yd, $f5ff4f6e5214f126$var$Ad = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f5ff4f6e5214f126$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f5ff4f6e5214f126$var$yd && ($f5ff4f6e5214f126$var$yd && "mousemove" === a.type ? ($f5ff4f6e5214f126$var$wd = a.screenX - $f5ff4f6e5214f126$var$yd.screenX, $f5ff4f6e5214f126$var$xd = a.screenY - $f5ff4f6e5214f126$var$yd.screenY) : $f5ff4f6e5214f126$var$xd = $f5ff4f6e5214f126$var$wd = 0, $f5ff4f6e5214f126$var$yd = a);
        return $f5ff4f6e5214f126$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f5ff4f6e5214f126$var$xd;
    }
}), $f5ff4f6e5214f126$var$Bd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Ad), $f5ff4f6e5214f126$var$Cd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$Ad, {
    dataTransfer: 0
}), $f5ff4f6e5214f126$var$Dd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Cd), $f5ff4f6e5214f126$var$Ed = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$ud, {
    relatedTarget: 0
}), $f5ff4f6e5214f126$var$Fd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Ed), $f5ff4f6e5214f126$var$Gd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f5ff4f6e5214f126$var$Hd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Gd), $f5ff4f6e5214f126$var$Id = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f5ff4f6e5214f126$var$Jd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Id), $f5ff4f6e5214f126$var$Kd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$sd, {
    data: 0
}), $f5ff4f6e5214f126$var$Ld = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Kd), $f5ff4f6e5214f126$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f5ff4f6e5214f126$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f5ff4f6e5214f126$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f5ff4f6e5214f126$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f5ff4f6e5214f126$var$Od[a]) ? !!b[a] : !1;
}
function $f5ff4f6e5214f126$var$zd() {
    return $f5ff4f6e5214f126$var$Pd;
}
var $f5ff4f6e5214f126$var$Qd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f5ff4f6e5214f126$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f5ff4f6e5214f126$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f5ff4f6e5214f126$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f5ff4f6e5214f126$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f5ff4f6e5214f126$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f5ff4f6e5214f126$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f5ff4f6e5214f126$var$Rd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Qd), $f5ff4f6e5214f126$var$Sd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f5ff4f6e5214f126$var$Td = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Sd), $f5ff4f6e5214f126$var$Ud = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f5ff4f6e5214f126$var$zd
}), $f5ff4f6e5214f126$var$Vd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Ud), $f5ff4f6e5214f126$var$Wd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f5ff4f6e5214f126$var$Xd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Wd), $f5ff4f6e5214f126$var$Yd = $f5ff4f6e5214f126$var$A({}, $f5ff4f6e5214f126$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f5ff4f6e5214f126$var$Zd = $f5ff4f6e5214f126$var$rd($f5ff4f6e5214f126$var$Yd), $f5ff4f6e5214f126$var$$d = [
    9,
    13,
    27,
    32
], $f5ff4f6e5214f126$var$ae = $f5ff4f6e5214f126$var$ia && "CompositionEvent" in window, $f5ff4f6e5214f126$var$be = null;
$f5ff4f6e5214f126$var$ia && "documentMode" in document && ($f5ff4f6e5214f126$var$be = document.documentMode);
var $f5ff4f6e5214f126$var$ce = $f5ff4f6e5214f126$var$ia && "TextEvent" in window && !$f5ff4f6e5214f126$var$be, $f5ff4f6e5214f126$var$de = $f5ff4f6e5214f126$var$ia && (!$f5ff4f6e5214f126$var$ae || $f5ff4f6e5214f126$var$be && 8 < $f5ff4f6e5214f126$var$be && 11 >= $f5ff4f6e5214f126$var$be), $f5ff4f6e5214f126$var$ee = String.fromCharCode(32), $f5ff4f6e5214f126$var$fe = !1;
function $f5ff4f6e5214f126$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f5ff4f6e5214f126$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f5ff4f6e5214f126$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f5ff4f6e5214f126$var$ie = !1;
function $f5ff4f6e5214f126$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f5ff4f6e5214f126$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f5ff4f6e5214f126$var$fe = !0;
            return $f5ff4f6e5214f126$var$ee;
        case "textInput":
            return a = b.data, a === $f5ff4f6e5214f126$var$ee && $f5ff4f6e5214f126$var$fe ? null : a;
        default:
            return null;
    }
}
function $f5ff4f6e5214f126$var$ke(a, b) {
    if ($f5ff4f6e5214f126$var$ie) return "compositionend" === a || !$f5ff4f6e5214f126$var$ae && $f5ff4f6e5214f126$var$ge(a, b) ? (a = $f5ff4f6e5214f126$var$nd(), $f5ff4f6e5214f126$var$md = $f5ff4f6e5214f126$var$ld = $f5ff4f6e5214f126$var$kd = null, $f5ff4f6e5214f126$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f5ff4f6e5214f126$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f5ff4f6e5214f126$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f5ff4f6e5214f126$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f5ff4f6e5214f126$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f5ff4f6e5214f126$var$ne(a, b, c, d) {
    $f5ff4f6e5214f126$var$Eb(d);
    b = $f5ff4f6e5214f126$var$oe(b, "onChange");
    0 < b.length && (c = new $f5ff4f6e5214f126$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f5ff4f6e5214f126$var$pe = null, $f5ff4f6e5214f126$var$qe = null;
function $f5ff4f6e5214f126$var$re(a) {
    $f5ff4f6e5214f126$var$se(a, 0);
}
function $f5ff4f6e5214f126$var$te(a) {
    var b = $f5ff4f6e5214f126$var$ue(a);
    if ($f5ff4f6e5214f126$var$Wa(b)) return a;
}
function $f5ff4f6e5214f126$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f5ff4f6e5214f126$var$we = !1;
if ($f5ff4f6e5214f126$var$ia) {
    var $f5ff4f6e5214f126$var$xe;
    if ($f5ff4f6e5214f126$var$ia) {
        var $f5ff4f6e5214f126$var$ye = "oninput" in document;
        if (!$f5ff4f6e5214f126$var$ye) {
            var $f5ff4f6e5214f126$var$ze = document.createElement("div");
            $f5ff4f6e5214f126$var$ze.setAttribute("oninput", "return;");
            $f5ff4f6e5214f126$var$ye = "function" === typeof $f5ff4f6e5214f126$var$ze.oninput;
        }
        $f5ff4f6e5214f126$var$xe = $f5ff4f6e5214f126$var$ye;
    } else $f5ff4f6e5214f126$var$xe = !1;
    $f5ff4f6e5214f126$var$we = $f5ff4f6e5214f126$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f5ff4f6e5214f126$var$Ae() {
    $f5ff4f6e5214f126$var$pe && ($f5ff4f6e5214f126$var$pe.detachEvent("onpropertychange", $f5ff4f6e5214f126$var$Be), $f5ff4f6e5214f126$var$qe = $f5ff4f6e5214f126$var$pe = null);
}
function $f5ff4f6e5214f126$var$Be(a) {
    if ("value" === a.propertyName && $f5ff4f6e5214f126$var$te($f5ff4f6e5214f126$var$qe)) {
        var b = [];
        $f5ff4f6e5214f126$var$ne(b, $f5ff4f6e5214f126$var$qe, a, $f5ff4f6e5214f126$var$xb(a));
        $f5ff4f6e5214f126$var$Jb($f5ff4f6e5214f126$var$re, b);
    }
}
function $f5ff4f6e5214f126$var$Ce(a, b, c) {
    "focusin" === a ? ($f5ff4f6e5214f126$var$Ae(), $f5ff4f6e5214f126$var$pe = b, $f5ff4f6e5214f126$var$qe = c, $f5ff4f6e5214f126$var$pe.attachEvent("onpropertychange", $f5ff4f6e5214f126$var$Be)) : "focusout" === a && $f5ff4f6e5214f126$var$Ae();
}
function $f5ff4f6e5214f126$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f5ff4f6e5214f126$var$te($f5ff4f6e5214f126$var$qe);
}
function $f5ff4f6e5214f126$var$Ee(a, b) {
    if ("click" === a) return $f5ff4f6e5214f126$var$te(b);
}
function $f5ff4f6e5214f126$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f5ff4f6e5214f126$var$te(b);
}
function $f5ff4f6e5214f126$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f5ff4f6e5214f126$var$He = "function" === typeof Object.is ? Object.is : $f5ff4f6e5214f126$var$Ge;
function $f5ff4f6e5214f126$var$Ie(a, b) {
    if ($f5ff4f6e5214f126$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f5ff4f6e5214f126$var$ja.call(b, e) || !$f5ff4f6e5214f126$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f5ff4f6e5214f126$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f5ff4f6e5214f126$var$Ke(a, b) {
    var c = $f5ff4f6e5214f126$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f5ff4f6e5214f126$var$Je(c);
    }
}
function $f5ff4f6e5214f126$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f5ff4f6e5214f126$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f5ff4f6e5214f126$var$Me() {
    for(var a = window, b = $f5ff4f6e5214f126$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f5ff4f6e5214f126$var$Xa(a.document);
    }
    return b;
}
function $f5ff4f6e5214f126$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f5ff4f6e5214f126$var$Oe(a) {
    var b = $f5ff4f6e5214f126$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f5ff4f6e5214f126$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f5ff4f6e5214f126$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f5ff4f6e5214f126$var$Ke(c, f);
                var g = $f5ff4f6e5214f126$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f5ff4f6e5214f126$var$Pe = $f5ff4f6e5214f126$var$ia && "documentMode" in document && 11 >= document.documentMode, $f5ff4f6e5214f126$var$Qe = null, $f5ff4f6e5214f126$var$Re = null, $f5ff4f6e5214f126$var$Se = null, $f5ff4f6e5214f126$var$Te = !1;
function $f5ff4f6e5214f126$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f5ff4f6e5214f126$var$Te || null == $f5ff4f6e5214f126$var$Qe || $f5ff4f6e5214f126$var$Qe !== $f5ff4f6e5214f126$var$Xa(d) || (d = $f5ff4f6e5214f126$var$Qe, "selectionStart" in d && $f5ff4f6e5214f126$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f5ff4f6e5214f126$var$Se && $f5ff4f6e5214f126$var$Ie($f5ff4f6e5214f126$var$Se, d) || ($f5ff4f6e5214f126$var$Se = d, d = $f5ff4f6e5214f126$var$oe($f5ff4f6e5214f126$var$Re, "onSelect"), 0 < d.length && (b = new $f5ff4f6e5214f126$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f5ff4f6e5214f126$var$Qe)));
}
function $f5ff4f6e5214f126$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f5ff4f6e5214f126$var$We = {
    animationend: $f5ff4f6e5214f126$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f5ff4f6e5214f126$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f5ff4f6e5214f126$var$Ve("Animation", "AnimationStart"),
    transitionend: $f5ff4f6e5214f126$var$Ve("Transition", "TransitionEnd")
}, $f5ff4f6e5214f126$var$Xe = {}, $f5ff4f6e5214f126$var$Ye = {};
$f5ff4f6e5214f126$var$ia && ($f5ff4f6e5214f126$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f5ff4f6e5214f126$var$We.animationend.animation, delete $f5ff4f6e5214f126$var$We.animationiteration.animation, delete $f5ff4f6e5214f126$var$We.animationstart.animation), "TransitionEvent" in window || delete $f5ff4f6e5214f126$var$We.transitionend.transition);
function $f5ff4f6e5214f126$var$Ze(a) {
    if ($f5ff4f6e5214f126$var$Xe[a]) return $f5ff4f6e5214f126$var$Xe[a];
    if (!$f5ff4f6e5214f126$var$We[a]) return a;
    var b = $f5ff4f6e5214f126$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f5ff4f6e5214f126$var$Ye) return $f5ff4f6e5214f126$var$Xe[a] = b[c];
    return a;
}
var $f5ff4f6e5214f126$var$$e = $f5ff4f6e5214f126$var$Ze("animationend"), $f5ff4f6e5214f126$var$af = $f5ff4f6e5214f126$var$Ze("animationiteration"), $f5ff4f6e5214f126$var$bf = $f5ff4f6e5214f126$var$Ze("animationstart"), $f5ff4f6e5214f126$var$cf = $f5ff4f6e5214f126$var$Ze("transitionend"), $f5ff4f6e5214f126$var$df = new Map, $f5ff4f6e5214f126$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f5ff4f6e5214f126$var$ff(a, b) {
    $f5ff4f6e5214f126$var$df.set(a, b);
    $f5ff4f6e5214f126$var$fa(b, [
        a
    ]);
}
for(var $f5ff4f6e5214f126$var$gf = 0; $f5ff4f6e5214f126$var$gf < $f5ff4f6e5214f126$var$ef.length; $f5ff4f6e5214f126$var$gf++){
    var $f5ff4f6e5214f126$var$hf = $f5ff4f6e5214f126$var$ef[$f5ff4f6e5214f126$var$gf], $f5ff4f6e5214f126$var$jf = $f5ff4f6e5214f126$var$hf.toLowerCase(), $f5ff4f6e5214f126$var$kf = $f5ff4f6e5214f126$var$hf[0].toUpperCase() + $f5ff4f6e5214f126$var$hf.slice(1);
    $f5ff4f6e5214f126$var$ff($f5ff4f6e5214f126$var$jf, "on" + $f5ff4f6e5214f126$var$kf);
}
$f5ff4f6e5214f126$var$ff($f5ff4f6e5214f126$var$$e, "onAnimationEnd");
$f5ff4f6e5214f126$var$ff($f5ff4f6e5214f126$var$af, "onAnimationIteration");
$f5ff4f6e5214f126$var$ff($f5ff4f6e5214f126$var$bf, "onAnimationStart");
$f5ff4f6e5214f126$var$ff("dblclick", "onDoubleClick");
$f5ff4f6e5214f126$var$ff("focusin", "onFocus");
$f5ff4f6e5214f126$var$ff("focusout", "onBlur");
$f5ff4f6e5214f126$var$ff($f5ff4f6e5214f126$var$cf, "onTransitionEnd");
$f5ff4f6e5214f126$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f5ff4f6e5214f126$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f5ff4f6e5214f126$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f5ff4f6e5214f126$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f5ff4f6e5214f126$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f5ff4f6e5214f126$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f5ff4f6e5214f126$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f5ff4f6e5214f126$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f5ff4f6e5214f126$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f5ff4f6e5214f126$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f5ff4f6e5214f126$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f5ff4f6e5214f126$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f5ff4f6e5214f126$var$lf));
function $f5ff4f6e5214f126$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f5ff4f6e5214f126$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f5ff4f6e5214f126$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f5ff4f6e5214f126$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f5ff4f6e5214f126$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f5ff4f6e5214f126$var$Qb) throw a = $f5ff4f6e5214f126$var$Rb, $f5ff4f6e5214f126$var$Qb = !1, $f5ff4f6e5214f126$var$Rb = null, a;
}
function $f5ff4f6e5214f126$var$D(a, b) {
    var c = b[$f5ff4f6e5214f126$var$of];
    void 0 === c && (c = b[$f5ff4f6e5214f126$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f5ff4f6e5214f126$var$pf(b, a, 2, !1), c.add(d));
}
function $f5ff4f6e5214f126$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f5ff4f6e5214f126$var$pf(c, a, d, b);
}
var $f5ff4f6e5214f126$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f5ff4f6e5214f126$var$sf(a) {
    if (!a[$f5ff4f6e5214f126$var$rf]) {
        a[$f5ff4f6e5214f126$var$rf] = !0;
        $f5ff4f6e5214f126$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f5ff4f6e5214f126$var$mf.has(b) || $f5ff4f6e5214f126$var$qf(b, !1, a), $f5ff4f6e5214f126$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f5ff4f6e5214f126$var$rf] || (b[$f5ff4f6e5214f126$var$rf] = !0, $f5ff4f6e5214f126$var$qf("selectionchange", !1, b));
    }
}
function $f5ff4f6e5214f126$var$pf(a, b, c, d) {
    switch($f5ff4f6e5214f126$var$jd(b)){
        case 1:
            var e = $f5ff4f6e5214f126$var$ed;
            break;
        case 4:
            e = $f5ff4f6e5214f126$var$gd;
            break;
        default:
            e = $f5ff4f6e5214f126$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f5ff4f6e5214f126$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f5ff4f6e5214f126$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f5ff4f6e5214f126$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f5ff4f6e5214f126$var$Jb(function() {
        var d = f, e = $f5ff4f6e5214f126$var$xb(c), g = [];
        a: {
            var h = $f5ff4f6e5214f126$var$df.get(a);
            if (void 0 !== h) {
                var k = $f5ff4f6e5214f126$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f5ff4f6e5214f126$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f5ff4f6e5214f126$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f5ff4f6e5214f126$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f5ff4f6e5214f126$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f5ff4f6e5214f126$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f5ff4f6e5214f126$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f5ff4f6e5214f126$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f5ff4f6e5214f126$var$Vd;
                        break;
                    case $f5ff4f6e5214f126$var$$e:
                    case $f5ff4f6e5214f126$var$af:
                    case $f5ff4f6e5214f126$var$bf:
                        k = $f5ff4f6e5214f126$var$Hd;
                        break;
                    case $f5ff4f6e5214f126$var$cf:
                        k = $f5ff4f6e5214f126$var$Xd;
                        break;
                    case "scroll":
                        k = $f5ff4f6e5214f126$var$vd;
                        break;
                    case "wheel":
                        k = $f5ff4f6e5214f126$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f5ff4f6e5214f126$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f5ff4f6e5214f126$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f5ff4f6e5214f126$var$Kb(w, x), null != F && t.push($f5ff4f6e5214f126$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f5ff4f6e5214f126$var$wb && (n = c.relatedTarget || c.fromElement) && ($f5ff4f6e5214f126$var$Wc(n) || n[$f5ff4f6e5214f126$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f5ff4f6e5214f126$var$Wc(n) : null, null !== n && (J = $f5ff4f6e5214f126$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f5ff4f6e5214f126$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f5ff4f6e5214f126$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f5ff4f6e5214f126$var$ue(k);
                        u = null == n ? h : $f5ff4f6e5214f126$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f5ff4f6e5214f126$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f5ff4f6e5214f126$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f5ff4f6e5214f126$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f5ff4f6e5214f126$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f5ff4f6e5214f126$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f5ff4f6e5214f126$var$vf(t);
                                x = $f5ff4f6e5214f126$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f5ff4f6e5214f126$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f5ff4f6e5214f126$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f5ff4f6e5214f126$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f5ff4f6e5214f126$var$ve;
                else if ($f5ff4f6e5214f126$var$me(h)) {
                    if ($f5ff4f6e5214f126$var$we) na = $f5ff4f6e5214f126$var$Fe;
                    else {
                        na = $f5ff4f6e5214f126$var$De;
                        var xa = $f5ff4f6e5214f126$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f5ff4f6e5214f126$var$Ee);
                if (na && (na = na(a, d))) {
                    $f5ff4f6e5214f126$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f5ff4f6e5214f126$var$cb(h, "number", h.value);
            }
            xa = d ? $f5ff4f6e5214f126$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f5ff4f6e5214f126$var$me(xa) || "true" === xa.contentEditable) $f5ff4f6e5214f126$var$Qe = xa, $f5ff4f6e5214f126$var$Re = d, $f5ff4f6e5214f126$var$Se = null;
                    break;
                case "focusout":
                    $f5ff4f6e5214f126$var$Se = $f5ff4f6e5214f126$var$Re = $f5ff4f6e5214f126$var$Qe = null;
                    break;
                case "mousedown":
                    $f5ff4f6e5214f126$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f5ff4f6e5214f126$var$Te = !1;
                    $f5ff4f6e5214f126$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f5ff4f6e5214f126$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f5ff4f6e5214f126$var$Ue(g, c, e);
            }
            var $a;
            if ($f5ff4f6e5214f126$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f5ff4f6e5214f126$var$ie ? $f5ff4f6e5214f126$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f5ff4f6e5214f126$var$de && "ko" !== c.locale && ($f5ff4f6e5214f126$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f5ff4f6e5214f126$var$ie && ($a = $f5ff4f6e5214f126$var$nd()) : ($f5ff4f6e5214f126$var$kd = e, $f5ff4f6e5214f126$var$ld = "value" in $f5ff4f6e5214f126$var$kd ? $f5ff4f6e5214f126$var$kd.value : $f5ff4f6e5214f126$var$kd.textContent, $f5ff4f6e5214f126$var$ie = !0)), xa = $f5ff4f6e5214f126$var$oe(d, ba), 0 < xa.length && (ba = new $f5ff4f6e5214f126$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f5ff4f6e5214f126$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f5ff4f6e5214f126$var$ce ? $f5ff4f6e5214f126$var$je(a, c) : $f5ff4f6e5214f126$var$ke(a, c)) d = $f5ff4f6e5214f126$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f5ff4f6e5214f126$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f5ff4f6e5214f126$var$se(g, b);
    });
}
function $f5ff4f6e5214f126$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f5ff4f6e5214f126$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f5ff4f6e5214f126$var$Kb(a, c), null != f && d.unshift($f5ff4f6e5214f126$var$tf(a, f, e)), f = $f5ff4f6e5214f126$var$Kb(a, b), null != f && d.push($f5ff4f6e5214f126$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f5ff4f6e5214f126$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f5ff4f6e5214f126$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f5ff4f6e5214f126$var$Kb(c, f), null != k && g.unshift($f5ff4f6e5214f126$var$tf(c, k, h))) : e || (k = $f5ff4f6e5214f126$var$Kb(c, f), null != k && g.push($f5ff4f6e5214f126$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f5ff4f6e5214f126$var$xf = /\r\n?/g, $f5ff4f6e5214f126$var$yf = /\u0000|\uFFFD/g;
function $f5ff4f6e5214f126$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f5ff4f6e5214f126$var$xf, "\n").replace($f5ff4f6e5214f126$var$yf, "");
}
function $f5ff4f6e5214f126$var$Af(a, b, c) {
    b = $f5ff4f6e5214f126$var$zf(b);
    if ($f5ff4f6e5214f126$var$zf(a) !== b && c) throw Error($f5ff4f6e5214f126$var$p(425));
}
function $f5ff4f6e5214f126$var$Bf() {}
var $f5ff4f6e5214f126$var$Cf = null, $f5ff4f6e5214f126$var$Df = null;
function $f5ff4f6e5214f126$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f5ff4f6e5214f126$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f5ff4f6e5214f126$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f5ff4f6e5214f126$var$Hf = "function" === typeof Promise ? Promise : void 0, $f5ff4f6e5214f126$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f5ff4f6e5214f126$var$Hf ? function(a) {
    return $f5ff4f6e5214f126$var$Hf.resolve(null).then(a).catch($f5ff4f6e5214f126$var$If);
} : $f5ff4f6e5214f126$var$Ff;
function $f5ff4f6e5214f126$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f5ff4f6e5214f126$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f5ff4f6e5214f126$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f5ff4f6e5214f126$var$bd(b);
}
function $f5ff4f6e5214f126$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f5ff4f6e5214f126$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f5ff4f6e5214f126$var$Nf = Math.random().toString(36).slice(2), $f5ff4f6e5214f126$var$Of = "__reactFiber$" + $f5ff4f6e5214f126$var$Nf, $f5ff4f6e5214f126$var$Pf = "__reactProps$" + $f5ff4f6e5214f126$var$Nf, $f5ff4f6e5214f126$var$uf = "__reactContainer$" + $f5ff4f6e5214f126$var$Nf, $f5ff4f6e5214f126$var$of = "__reactEvents$" + $f5ff4f6e5214f126$var$Nf, $f5ff4f6e5214f126$var$Qf = "__reactListeners$" + $f5ff4f6e5214f126$var$Nf, $f5ff4f6e5214f126$var$Rf = "__reactHandles$" + $f5ff4f6e5214f126$var$Nf;
function $f5ff4f6e5214f126$var$Wc(a) {
    var b = a[$f5ff4f6e5214f126$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f5ff4f6e5214f126$var$uf] || c[$f5ff4f6e5214f126$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f5ff4f6e5214f126$var$Mf(a); null !== a;){
                if (c = a[$f5ff4f6e5214f126$var$Of]) return c;
                a = $f5ff4f6e5214f126$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f5ff4f6e5214f126$var$Cb(a) {
    a = a[$f5ff4f6e5214f126$var$Of] || a[$f5ff4f6e5214f126$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f5ff4f6e5214f126$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f5ff4f6e5214f126$var$p(33));
}
function $f5ff4f6e5214f126$var$Db(a) {
    return a[$f5ff4f6e5214f126$var$Pf] || null;
}
var $f5ff4f6e5214f126$var$Sf = [], $f5ff4f6e5214f126$var$Tf = -1;
function $f5ff4f6e5214f126$var$Uf(a) {
    return {
        current: a
    };
}
function $f5ff4f6e5214f126$var$E(a) {
    0 > $f5ff4f6e5214f126$var$Tf || (a.current = $f5ff4f6e5214f126$var$Sf[$f5ff4f6e5214f126$var$Tf], $f5ff4f6e5214f126$var$Sf[$f5ff4f6e5214f126$var$Tf] = null, $f5ff4f6e5214f126$var$Tf--);
}
function $f5ff4f6e5214f126$var$G(a, b) {
    $f5ff4f6e5214f126$var$Tf++;
    $f5ff4f6e5214f126$var$Sf[$f5ff4f6e5214f126$var$Tf] = a.current;
    a.current = b;
}
var $f5ff4f6e5214f126$var$Vf = {}, $f5ff4f6e5214f126$var$H = $f5ff4f6e5214f126$var$Uf($f5ff4f6e5214f126$var$Vf), $f5ff4f6e5214f126$var$Wf = $f5ff4f6e5214f126$var$Uf(!1), $f5ff4f6e5214f126$var$Xf = $f5ff4f6e5214f126$var$Vf;
function $f5ff4f6e5214f126$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f5ff4f6e5214f126$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f5ff4f6e5214f126$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f5ff4f6e5214f126$var$$f() {
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf);
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$H);
}
function $f5ff4f6e5214f126$var$ag(a, b, c) {
    if ($f5ff4f6e5214f126$var$H.current !== $f5ff4f6e5214f126$var$Vf) throw Error($f5ff4f6e5214f126$var$p(168));
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$H, b);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Wf, c);
}
function $f5ff4f6e5214f126$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f5ff4f6e5214f126$var$p(108, $f5ff4f6e5214f126$var$Ra(a) || "Unknown", e));
    return $f5ff4f6e5214f126$var$A({}, c, d);
}
function $f5ff4f6e5214f126$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f5ff4f6e5214f126$var$Vf;
    $f5ff4f6e5214f126$var$Xf = $f5ff4f6e5214f126$var$H.current;
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$H, a);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Wf, $f5ff4f6e5214f126$var$Wf.current);
    return !0;
}
function $f5ff4f6e5214f126$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f5ff4f6e5214f126$var$p(169));
    c ? (a = $f5ff4f6e5214f126$var$bg(a, b, $f5ff4f6e5214f126$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf), $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$H), $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$H, a)) : $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Wf, c);
}
var $f5ff4f6e5214f126$var$eg = null, $f5ff4f6e5214f126$var$fg = !1, $f5ff4f6e5214f126$var$gg = !1;
function $f5ff4f6e5214f126$var$hg(a) {
    null === $f5ff4f6e5214f126$var$eg ? $f5ff4f6e5214f126$var$eg = [
        a
    ] : $f5ff4f6e5214f126$var$eg.push(a);
}
function $f5ff4f6e5214f126$var$ig(a) {
    $f5ff4f6e5214f126$var$fg = !0;
    $f5ff4f6e5214f126$var$hg(a);
}
function $f5ff4f6e5214f126$var$jg() {
    if (!$f5ff4f6e5214f126$var$gg && null !== $f5ff4f6e5214f126$var$eg) {
        $f5ff4f6e5214f126$var$gg = !0;
        var a = 0, b = $f5ff4f6e5214f126$var$C;
        try {
            var c = $f5ff4f6e5214f126$var$eg;
            for($f5ff4f6e5214f126$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f5ff4f6e5214f126$var$eg = null;
            $f5ff4f6e5214f126$var$fg = !1;
        } catch (e) {
            throw null !== $f5ff4f6e5214f126$var$eg && ($f5ff4f6e5214f126$var$eg = $f5ff4f6e5214f126$var$eg.slice(a + 1)), $f5ff4f6e5214f126$var$ac($f5ff4f6e5214f126$var$fc, $f5ff4f6e5214f126$var$jg), e;
        } finally{
            $f5ff4f6e5214f126$var$C = b, $f5ff4f6e5214f126$var$gg = !1;
        }
    }
    return null;
}
var $f5ff4f6e5214f126$var$kg = [], $f5ff4f6e5214f126$var$lg = 0, $f5ff4f6e5214f126$var$mg = null, $f5ff4f6e5214f126$var$ng = 0, $f5ff4f6e5214f126$var$og = [], $f5ff4f6e5214f126$var$pg = 0, $f5ff4f6e5214f126$var$qg = null, $f5ff4f6e5214f126$var$rg = 1, $f5ff4f6e5214f126$var$sg = "";
function $f5ff4f6e5214f126$var$tg(a, b) {
    $f5ff4f6e5214f126$var$kg[$f5ff4f6e5214f126$var$lg++] = $f5ff4f6e5214f126$var$ng;
    $f5ff4f6e5214f126$var$kg[$f5ff4f6e5214f126$var$lg++] = $f5ff4f6e5214f126$var$mg;
    $f5ff4f6e5214f126$var$mg = a;
    $f5ff4f6e5214f126$var$ng = b;
}
function $f5ff4f6e5214f126$var$ug(a, b, c) {
    $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$rg;
    $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$sg;
    $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$qg;
    $f5ff4f6e5214f126$var$qg = a;
    var d = $f5ff4f6e5214f126$var$rg;
    a = $f5ff4f6e5214f126$var$sg;
    var e = 32 - $f5ff4f6e5214f126$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f5ff4f6e5214f126$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f5ff4f6e5214f126$var$rg = 1 << 32 - $f5ff4f6e5214f126$var$oc(b) + e | c << e | d;
        $f5ff4f6e5214f126$var$sg = f + a;
    } else $f5ff4f6e5214f126$var$rg = 1 << f | c << e | d, $f5ff4f6e5214f126$var$sg = a;
}
function $f5ff4f6e5214f126$var$vg(a) {
    null !== a.return && ($f5ff4f6e5214f126$var$tg(a, 1), $f5ff4f6e5214f126$var$ug(a, 1, 0));
}
function $f5ff4f6e5214f126$var$wg(a) {
    for(; a === $f5ff4f6e5214f126$var$mg;)$f5ff4f6e5214f126$var$mg = $f5ff4f6e5214f126$var$kg[--$f5ff4f6e5214f126$var$lg], $f5ff4f6e5214f126$var$kg[$f5ff4f6e5214f126$var$lg] = null, $f5ff4f6e5214f126$var$ng = $f5ff4f6e5214f126$var$kg[--$f5ff4f6e5214f126$var$lg], $f5ff4f6e5214f126$var$kg[$f5ff4f6e5214f126$var$lg] = null;
    for(; a === $f5ff4f6e5214f126$var$qg;)$f5ff4f6e5214f126$var$qg = $f5ff4f6e5214f126$var$og[--$f5ff4f6e5214f126$var$pg], $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg] = null, $f5ff4f6e5214f126$var$sg = $f5ff4f6e5214f126$var$og[--$f5ff4f6e5214f126$var$pg], $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg] = null, $f5ff4f6e5214f126$var$rg = $f5ff4f6e5214f126$var$og[--$f5ff4f6e5214f126$var$pg], $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg] = null;
}
var $f5ff4f6e5214f126$var$xg = null, $f5ff4f6e5214f126$var$yg = null, $f5ff4f6e5214f126$var$I = !1, $f5ff4f6e5214f126$var$zg = null;
function $f5ff4f6e5214f126$var$Ag(a, b) {
    var c = $f5ff4f6e5214f126$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f5ff4f6e5214f126$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f5ff4f6e5214f126$var$xg = a, $f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f5ff4f6e5214f126$var$xg = a, $f5ff4f6e5214f126$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f5ff4f6e5214f126$var$qg ? {
                id: $f5ff4f6e5214f126$var$rg,
                overflow: $f5ff4f6e5214f126$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f5ff4f6e5214f126$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f5ff4f6e5214f126$var$xg = a, $f5ff4f6e5214f126$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f5ff4f6e5214f126$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f5ff4f6e5214f126$var$Eg(a) {
    if ($f5ff4f6e5214f126$var$I) {
        var b = $f5ff4f6e5214f126$var$yg;
        if (b) {
            var c = b;
            if (!$f5ff4f6e5214f126$var$Cg(a, b)) {
                if ($f5ff4f6e5214f126$var$Dg(a)) throw Error($f5ff4f6e5214f126$var$p(418));
                b = $f5ff4f6e5214f126$var$Lf(c.nextSibling);
                var d = $f5ff4f6e5214f126$var$xg;
                b && $f5ff4f6e5214f126$var$Cg(a, b) ? $f5ff4f6e5214f126$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f5ff4f6e5214f126$var$I = !1, $f5ff4f6e5214f126$var$xg = a);
            }
        } else {
            if ($f5ff4f6e5214f126$var$Dg(a)) throw Error($f5ff4f6e5214f126$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f5ff4f6e5214f126$var$I = !1;
            $f5ff4f6e5214f126$var$xg = a;
        }
    }
}
function $f5ff4f6e5214f126$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f5ff4f6e5214f126$var$xg = a;
}
function $f5ff4f6e5214f126$var$Gg(a) {
    if (a !== $f5ff4f6e5214f126$var$xg) return !1;
    if (!$f5ff4f6e5214f126$var$I) return $f5ff4f6e5214f126$var$Fg(a), $f5ff4f6e5214f126$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f5ff4f6e5214f126$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f5ff4f6e5214f126$var$yg)) {
        if ($f5ff4f6e5214f126$var$Dg(a)) throw $f5ff4f6e5214f126$var$Hg(), Error($f5ff4f6e5214f126$var$p(418));
        for(; b;)$f5ff4f6e5214f126$var$Ag(a, b), b = $f5ff4f6e5214f126$var$Lf(b.nextSibling);
    }
    $f5ff4f6e5214f126$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f5ff4f6e5214f126$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f5ff4f6e5214f126$var$yg = null;
        }
    } else $f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$xg ? $f5ff4f6e5214f126$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f5ff4f6e5214f126$var$Hg() {
    for(var a = $f5ff4f6e5214f126$var$yg; a;)a = $f5ff4f6e5214f126$var$Lf(a.nextSibling);
}
function $f5ff4f6e5214f126$var$Ig() {
    $f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$xg = null;
    $f5ff4f6e5214f126$var$I = !1;
}
function $f5ff4f6e5214f126$var$Jg(a) {
    null === $f5ff4f6e5214f126$var$zg ? $f5ff4f6e5214f126$var$zg = [
        a
    ] : $f5ff4f6e5214f126$var$zg.push(a);
}
var $f5ff4f6e5214f126$var$Kg = $f5ff4f6e5214f126$var$ua.ReactCurrentBatchConfig;
function $f5ff4f6e5214f126$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $f5ff4f6e5214f126$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $f5ff4f6e5214f126$var$Mg = $f5ff4f6e5214f126$var$Uf(null), $f5ff4f6e5214f126$var$Ng = null, $f5ff4f6e5214f126$var$Og = null, $f5ff4f6e5214f126$var$Pg = null;
function $f5ff4f6e5214f126$var$Qg() {
    $f5ff4f6e5214f126$var$Pg = $f5ff4f6e5214f126$var$Og = $f5ff4f6e5214f126$var$Ng = null;
}
function $f5ff4f6e5214f126$var$Rg(a) {
    var b = $f5ff4f6e5214f126$var$Mg.current;
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Mg);
    a._currentValue = b;
}
function $f5ff4f6e5214f126$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f5ff4f6e5214f126$var$Tg(a, b) {
    $f5ff4f6e5214f126$var$Ng = a;
    $f5ff4f6e5214f126$var$Pg = $f5ff4f6e5214f126$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f5ff4f6e5214f126$var$Ug = !0), a.firstContext = null);
}
function $f5ff4f6e5214f126$var$Vg(a) {
    var b = a._currentValue;
    if ($f5ff4f6e5214f126$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f5ff4f6e5214f126$var$Og) {
            if (null === $f5ff4f6e5214f126$var$Ng) throw Error($f5ff4f6e5214f126$var$p(308));
            $f5ff4f6e5214f126$var$Og = a;
            $f5ff4f6e5214f126$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f5ff4f6e5214f126$var$Og = $f5ff4f6e5214f126$var$Og.next = a;
    }
    return b;
}
var $f5ff4f6e5214f126$var$Wg = null;
function $f5ff4f6e5214f126$var$Xg(a) {
    null === $f5ff4f6e5214f126$var$Wg ? $f5ff4f6e5214f126$var$Wg = [
        a
    ] : $f5ff4f6e5214f126$var$Wg.push(a);
}
function $f5ff4f6e5214f126$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f5ff4f6e5214f126$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f5ff4f6e5214f126$var$Zg(a, d);
}
function $f5ff4f6e5214f126$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f5ff4f6e5214f126$var$$g = !1;
function $f5ff4f6e5214f126$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f5ff4f6e5214f126$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f5ff4f6e5214f126$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f5ff4f6e5214f126$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f5ff4f6e5214f126$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f5ff4f6e5214f126$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f5ff4f6e5214f126$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f5ff4f6e5214f126$var$Zg(a, c);
}
function $f5ff4f6e5214f126$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f5ff4f6e5214f126$var$Cc(a, c);
    }
}
function $f5ff4f6e5214f126$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f5ff4f6e5214f126$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $f5ff4f6e5214f126$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f5ff4f6e5214f126$var$A({}, q, r);
                            break a;
                        case 2:
                            $f5ff4f6e5214f126$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f5ff4f6e5214f126$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f5ff4f6e5214f126$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f5ff4f6e5214f126$var$p(191, e));
            e.call(d);
        }
    }
}
var $f5ff4f6e5214f126$var$jh = (new $7E7Dk.Component).refs;
function $f5ff4f6e5214f126$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f5ff4f6e5214f126$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f5ff4f6e5214f126$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f5ff4f6e5214f126$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f5ff4f6e5214f126$var$L(), e = $f5ff4f6e5214f126$var$lh(a), f = $f5ff4f6e5214f126$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f5ff4f6e5214f126$var$dh(a, f, e);
        null !== b && ($f5ff4f6e5214f126$var$mh(b, a, e, d), $f5ff4f6e5214f126$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f5ff4f6e5214f126$var$L(), e = $f5ff4f6e5214f126$var$lh(a), f = $f5ff4f6e5214f126$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f5ff4f6e5214f126$var$dh(a, f, e);
        null !== b && ($f5ff4f6e5214f126$var$mh(b, a, e, d), $f5ff4f6e5214f126$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f5ff4f6e5214f126$var$L(), d = $f5ff4f6e5214f126$var$lh(a), e = $f5ff4f6e5214f126$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f5ff4f6e5214f126$var$dh(a, e, d);
        null !== b && ($f5ff4f6e5214f126$var$mh(b, a, d, c), $f5ff4f6e5214f126$var$eh(b, a, d));
    }
};
function $f5ff4f6e5214f126$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f5ff4f6e5214f126$var$Ie(c, d) || !$f5ff4f6e5214f126$var$Ie(e, f) : !0;
}
function $f5ff4f6e5214f126$var$ph(a, b, c) {
    var d = !1, e = $f5ff4f6e5214f126$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f5ff4f6e5214f126$var$Vg(f) : (e = $f5ff4f6e5214f126$var$Zf(b) ? $f5ff4f6e5214f126$var$Xf : $f5ff4f6e5214f126$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f5ff4f6e5214f126$var$Yf(a, e) : $f5ff4f6e5214f126$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f5ff4f6e5214f126$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f5ff4f6e5214f126$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f5ff4f6e5214f126$var$nh.enqueueReplaceState(b, b.state, null);
}
function $f5ff4f6e5214f126$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $f5ff4f6e5214f126$var$jh;
    $f5ff4f6e5214f126$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f5ff4f6e5214f126$var$Vg(f) : (f = $f5ff4f6e5214f126$var$Zf(b) ? $f5ff4f6e5214f126$var$Xf : $f5ff4f6e5214f126$var$H.current, e.context = $f5ff4f6e5214f126$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f5ff4f6e5214f126$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f5ff4f6e5214f126$var$nh.enqueueReplaceState(e, e.state, null), $f5ff4f6e5214f126$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f5ff4f6e5214f126$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f5ff4f6e5214f126$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f5ff4f6e5214f126$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $f5ff4f6e5214f126$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f5ff4f6e5214f126$var$p(284));
        if (!c._owner) throw Error($f5ff4f6e5214f126$var$p(290, a));
    }
    return a;
}
function $f5ff4f6e5214f126$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f5ff4f6e5214f126$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f5ff4f6e5214f126$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $f5ff4f6e5214f126$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f5ff4f6e5214f126$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f5ff4f6e5214f126$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f5ff4f6e5214f126$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f5ff4f6e5214f126$var$Ha && $f5ff4f6e5214f126$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $f5ff4f6e5214f126$var$sh(a, b, c), d.return = a, d;
        d = $f5ff4f6e5214f126$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f5ff4f6e5214f126$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f5ff4f6e5214f126$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f5ff4f6e5214f126$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f5ff4f6e5214f126$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f5ff4f6e5214f126$var$va:
                    return c = $f5ff4f6e5214f126$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $f5ff4f6e5214f126$var$sh(a, null, b), c.return = a, c;
                case $f5ff4f6e5214f126$var$wa:
                    return b = $f5ff4f6e5214f126$var$zh(b, a.mode, c), b.return = a, b;
                case $f5ff4f6e5214f126$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f5ff4f6e5214f126$var$eb(b) || $f5ff4f6e5214f126$var$Ka(b)) return b = $f5ff4f6e5214f126$var$Ah(b, a.mode, c, null), b.return = a, b;
            $f5ff4f6e5214f126$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f5ff4f6e5214f126$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f5ff4f6e5214f126$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f5ff4f6e5214f126$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f5ff4f6e5214f126$var$eb(c) || $f5ff4f6e5214f126$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f5ff4f6e5214f126$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f5ff4f6e5214f126$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f5ff4f6e5214f126$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f5ff4f6e5214f126$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f5ff4f6e5214f126$var$eb(d) || $f5ff4f6e5214f126$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f5ff4f6e5214f126$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f5ff4f6e5214f126$var$Ka(h);
        if ("function" !== typeof l) throw Error($f5ff4f6e5214f126$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f5ff4f6e5214f126$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f5ff4f6e5214f126$var$I && $f5ff4f6e5214f126$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f5ff4f6e5214f126$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f5ff4f6e5214f126$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f5ff4f6e5214f126$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f5ff4f6e5214f126$var$Ha && $f5ff4f6e5214f126$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f5ff4f6e5214f126$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f5ff4f6e5214f126$var$ya ? (d = $f5ff4f6e5214f126$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f5ff4f6e5214f126$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $f5ff4f6e5214f126$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f5ff4f6e5214f126$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f5ff4f6e5214f126$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f5ff4f6e5214f126$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f5ff4f6e5214f126$var$eb(f)) return n(a, d, f, h);
            if ($f5ff4f6e5214f126$var$Ka(f)) return t(a, d, f, h);
            $f5ff4f6e5214f126$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f5ff4f6e5214f126$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f5ff4f6e5214f126$var$Bh = $f5ff4f6e5214f126$var$vh(!0), $f5ff4f6e5214f126$var$Ch = $f5ff4f6e5214f126$var$vh(!1), $f5ff4f6e5214f126$var$Dh = {}, $f5ff4f6e5214f126$var$Eh = $f5ff4f6e5214f126$var$Uf($f5ff4f6e5214f126$var$Dh), $f5ff4f6e5214f126$var$Fh = $f5ff4f6e5214f126$var$Uf($f5ff4f6e5214f126$var$Dh), $f5ff4f6e5214f126$var$Gh = $f5ff4f6e5214f126$var$Uf($f5ff4f6e5214f126$var$Dh);
function $f5ff4f6e5214f126$var$Hh(a) {
    if (a === $f5ff4f6e5214f126$var$Dh) throw Error($f5ff4f6e5214f126$var$p(174));
    return a;
}
function $f5ff4f6e5214f126$var$Ih(a, b) {
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Gh, b);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Fh, a);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Eh, $f5ff4f6e5214f126$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f5ff4f6e5214f126$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f5ff4f6e5214f126$var$lb(b, a);
    }
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Eh);
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Eh, b);
}
function $f5ff4f6e5214f126$var$Jh() {
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Eh);
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Fh);
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Gh);
}
function $f5ff4f6e5214f126$var$Kh(a) {
    $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Gh.current);
    var b = $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Eh.current);
    var c = $f5ff4f6e5214f126$var$lb(b, a.type);
    b !== c && ($f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Fh, a), $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Eh, c));
}
function $f5ff4f6e5214f126$var$Lh(a) {
    $f5ff4f6e5214f126$var$Fh.current === a && ($f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Eh), $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Fh));
}
var $f5ff4f6e5214f126$var$M = $f5ff4f6e5214f126$var$Uf(0);
function $f5ff4f6e5214f126$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f5ff4f6e5214f126$var$Nh = [];
function $f5ff4f6e5214f126$var$Oh() {
    for(var a = 0; a < $f5ff4f6e5214f126$var$Nh.length; a++)$f5ff4f6e5214f126$var$Nh[a]._workInProgressVersionPrimary = null;
    $f5ff4f6e5214f126$var$Nh.length = 0;
}
var $f5ff4f6e5214f126$var$Ph = $f5ff4f6e5214f126$var$ua.ReactCurrentDispatcher, $f5ff4f6e5214f126$var$Qh = $f5ff4f6e5214f126$var$ua.ReactCurrentBatchConfig, $f5ff4f6e5214f126$var$Rh = 0, $f5ff4f6e5214f126$var$N = null, $f5ff4f6e5214f126$var$O = null, $f5ff4f6e5214f126$var$P = null, $f5ff4f6e5214f126$var$Sh = !1, $f5ff4f6e5214f126$var$Th = !1, $f5ff4f6e5214f126$var$Uh = 0, $f5ff4f6e5214f126$var$Vh = 0;
function $f5ff4f6e5214f126$var$Q() {
    throw Error($f5ff4f6e5214f126$var$p(321));
}
function $f5ff4f6e5214f126$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f5ff4f6e5214f126$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f5ff4f6e5214f126$var$Xh(a, b, c, d, e, f) {
    $f5ff4f6e5214f126$var$Rh = f;
    $f5ff4f6e5214f126$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f5ff4f6e5214f126$var$Ph.current = null === a || null === a.memoizedState ? $f5ff4f6e5214f126$var$Yh : $f5ff4f6e5214f126$var$Zh;
    a = c(d, e);
    if ($f5ff4f6e5214f126$var$Th) {
        f = 0;
        do {
            $f5ff4f6e5214f126$var$Th = !1;
            $f5ff4f6e5214f126$var$Uh = 0;
            if (25 <= f) throw Error($f5ff4f6e5214f126$var$p(301));
            f += 1;
            $f5ff4f6e5214f126$var$P = $f5ff4f6e5214f126$var$O = null;
            b.updateQueue = null;
            $f5ff4f6e5214f126$var$Ph.current = $f5ff4f6e5214f126$var$$h;
            a = c(d, e);
        }while ($f5ff4f6e5214f126$var$Th);
    }
    $f5ff4f6e5214f126$var$Ph.current = $f5ff4f6e5214f126$var$ai;
    b = null !== $f5ff4f6e5214f126$var$O && null !== $f5ff4f6e5214f126$var$O.next;
    $f5ff4f6e5214f126$var$Rh = 0;
    $f5ff4f6e5214f126$var$P = $f5ff4f6e5214f126$var$O = $f5ff4f6e5214f126$var$N = null;
    $f5ff4f6e5214f126$var$Sh = !1;
    if (b) throw Error($f5ff4f6e5214f126$var$p(300));
    return a;
}
function $f5ff4f6e5214f126$var$bi() {
    var a = 0 !== $f5ff4f6e5214f126$var$Uh;
    $f5ff4f6e5214f126$var$Uh = 0;
    return a;
}
function $f5ff4f6e5214f126$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f5ff4f6e5214f126$var$P ? $f5ff4f6e5214f126$var$N.memoizedState = $f5ff4f6e5214f126$var$P = a : $f5ff4f6e5214f126$var$P = $f5ff4f6e5214f126$var$P.next = a;
    return $f5ff4f6e5214f126$var$P;
}
function $f5ff4f6e5214f126$var$di() {
    if (null === $f5ff4f6e5214f126$var$O) {
        var a = $f5ff4f6e5214f126$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f5ff4f6e5214f126$var$O.next;
    var b = null === $f5ff4f6e5214f126$var$P ? $f5ff4f6e5214f126$var$N.memoizedState : $f5ff4f6e5214f126$var$P.next;
    if (null !== b) $f5ff4f6e5214f126$var$P = b, $f5ff4f6e5214f126$var$O = a;
    else {
        if (null === a) throw Error($f5ff4f6e5214f126$var$p(310));
        $f5ff4f6e5214f126$var$O = a;
        a = {
            memoizedState: $f5ff4f6e5214f126$var$O.memoizedState,
            baseState: $f5ff4f6e5214f126$var$O.baseState,
            baseQueue: $f5ff4f6e5214f126$var$O.baseQueue,
            queue: $f5ff4f6e5214f126$var$O.queue,
            next: null
        };
        null === $f5ff4f6e5214f126$var$P ? $f5ff4f6e5214f126$var$N.memoizedState = $f5ff4f6e5214f126$var$P = a : $f5ff4f6e5214f126$var$P = $f5ff4f6e5214f126$var$P.next = a;
    }
    return $f5ff4f6e5214f126$var$P;
}
function $f5ff4f6e5214f126$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f5ff4f6e5214f126$var$fi(a) {
    var b = $f5ff4f6e5214f126$var$di(), c = b.queue;
    if (null === c) throw Error($f5ff4f6e5214f126$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f5ff4f6e5214f126$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f5ff4f6e5214f126$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f5ff4f6e5214f126$var$N.lanes |= m;
                $f5ff4f6e5214f126$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f5ff4f6e5214f126$var$He(d, b.memoizedState) || ($f5ff4f6e5214f126$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f5ff4f6e5214f126$var$N.lanes |= f, $f5ff4f6e5214f126$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f5ff4f6e5214f126$var$gi(a) {
    var b = $f5ff4f6e5214f126$var$di(), c = b.queue;
    if (null === c) throw Error($f5ff4f6e5214f126$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f5ff4f6e5214f126$var$He(f, b.memoizedState) || ($f5ff4f6e5214f126$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f5ff4f6e5214f126$var$hi() {}
function $f5ff4f6e5214f126$var$ii(a, b) {
    var c = $f5ff4f6e5214f126$var$N, d = $f5ff4f6e5214f126$var$di(), e = b(), f = !$f5ff4f6e5214f126$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f5ff4f6e5214f126$var$Ug = !0);
    d = d.queue;
    $f5ff4f6e5214f126$var$ji($f5ff4f6e5214f126$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f5ff4f6e5214f126$var$P && $f5ff4f6e5214f126$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f5ff4f6e5214f126$var$li(9, $f5ff4f6e5214f126$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $f5ff4f6e5214f126$var$R) throw Error($f5ff4f6e5214f126$var$p(349));
        0 !== ($f5ff4f6e5214f126$var$Rh & 30) || $f5ff4f6e5214f126$var$ni(c, b, e);
    }
    return e;
}
function $f5ff4f6e5214f126$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f5ff4f6e5214f126$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f5ff4f6e5214f126$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f5ff4f6e5214f126$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f5ff4f6e5214f126$var$oi(b) && $f5ff4f6e5214f126$var$pi(a);
}
function $f5ff4f6e5214f126$var$ki(a, b, c) {
    return c(function() {
        $f5ff4f6e5214f126$var$oi(b) && $f5ff4f6e5214f126$var$pi(a);
    });
}
function $f5ff4f6e5214f126$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f5ff4f6e5214f126$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f5ff4f6e5214f126$var$pi(a) {
    var b = $f5ff4f6e5214f126$var$Zg(a, 1);
    null !== b && $f5ff4f6e5214f126$var$mh(b, a, 1, -1);
}
function $f5ff4f6e5214f126$var$qi(a) {
    var b = $f5ff4f6e5214f126$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f5ff4f6e5214f126$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f5ff4f6e5214f126$var$ri.bind(null, $f5ff4f6e5214f126$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f5ff4f6e5214f126$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f5ff4f6e5214f126$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f5ff4f6e5214f126$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f5ff4f6e5214f126$var$si() {
    return $f5ff4f6e5214f126$var$di().memoizedState;
}
function $f5ff4f6e5214f126$var$ti(a, b, c, d) {
    var e = $f5ff4f6e5214f126$var$ci();
    $f5ff4f6e5214f126$var$N.flags |= a;
    e.memoizedState = $f5ff4f6e5214f126$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f5ff4f6e5214f126$var$ui(a, b, c, d) {
    var e = $f5ff4f6e5214f126$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f5ff4f6e5214f126$var$O) {
        var g = $f5ff4f6e5214f126$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $f5ff4f6e5214f126$var$Wh(d, g.deps)) {
            e.memoizedState = $f5ff4f6e5214f126$var$li(b, c, f, d);
            return;
        }
    }
    $f5ff4f6e5214f126$var$N.flags |= a;
    e.memoizedState = $f5ff4f6e5214f126$var$li(1 | b, c, f, d);
}
function $f5ff4f6e5214f126$var$vi(a, b) {
    return $f5ff4f6e5214f126$var$ti(8390656, 8, a, b);
}
function $f5ff4f6e5214f126$var$ji(a, b) {
    return $f5ff4f6e5214f126$var$ui(2048, 8, a, b);
}
function $f5ff4f6e5214f126$var$wi(a, b) {
    return $f5ff4f6e5214f126$var$ui(4, 2, a, b);
}
function $f5ff4f6e5214f126$var$xi(a, b) {
    return $f5ff4f6e5214f126$var$ui(4, 4, a, b);
}
function $f5ff4f6e5214f126$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f5ff4f6e5214f126$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f5ff4f6e5214f126$var$ui(4, 4, $f5ff4f6e5214f126$var$yi.bind(null, b, a), c);
}
function $f5ff4f6e5214f126$var$Ai() {}
function $f5ff4f6e5214f126$var$Bi(a, b) {
    var c = $f5ff4f6e5214f126$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f5ff4f6e5214f126$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f5ff4f6e5214f126$var$Ci(a, b) {
    var c = $f5ff4f6e5214f126$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f5ff4f6e5214f126$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f5ff4f6e5214f126$var$Di(a, b, c) {
    if (0 === ($f5ff4f6e5214f126$var$Rh & 21)) return a.baseState && (a.baseState = !1, $f5ff4f6e5214f126$var$Ug = !0), a.memoizedState = c;
    $f5ff4f6e5214f126$var$He(c, b) || (c = $f5ff4f6e5214f126$var$yc(), $f5ff4f6e5214f126$var$N.lanes |= c, $f5ff4f6e5214f126$var$hh |= c, a.baseState = !0);
    return b;
}
function $f5ff4f6e5214f126$var$Ei(a, b) {
    var c = $f5ff4f6e5214f126$var$C;
    $f5ff4f6e5214f126$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f5ff4f6e5214f126$var$Qh.transition;
    $f5ff4f6e5214f126$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f5ff4f6e5214f126$var$C = c, $f5ff4f6e5214f126$var$Qh.transition = d;
    }
}
function $f5ff4f6e5214f126$var$Fi() {
    return $f5ff4f6e5214f126$var$di().memoizedState;
}
function $f5ff4f6e5214f126$var$Gi(a, b, c) {
    var d = $f5ff4f6e5214f126$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f5ff4f6e5214f126$var$Hi(a)) $f5ff4f6e5214f126$var$Ii(b, c);
    else if (c = $f5ff4f6e5214f126$var$Yg(a, b, c, d), null !== c) {
        var e = $f5ff4f6e5214f126$var$L();
        $f5ff4f6e5214f126$var$mh(c, a, d, e);
        $f5ff4f6e5214f126$var$Ji(c, b, d);
    }
}
function $f5ff4f6e5214f126$var$ri(a, b, c) {
    var d = $f5ff4f6e5214f126$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f5ff4f6e5214f126$var$Hi(a)) $f5ff4f6e5214f126$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f5ff4f6e5214f126$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f5ff4f6e5214f126$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f5ff4f6e5214f126$var$Yg(a, b, e, d);
        null !== c && (e = $f5ff4f6e5214f126$var$L(), $f5ff4f6e5214f126$var$mh(c, a, d, e), $f5ff4f6e5214f126$var$Ji(c, b, d));
    }
}
function $f5ff4f6e5214f126$var$Hi(a) {
    var b = a.alternate;
    return a === $f5ff4f6e5214f126$var$N || null !== b && b === $f5ff4f6e5214f126$var$N;
}
function $f5ff4f6e5214f126$var$Ii(a, b) {
    $f5ff4f6e5214f126$var$Th = $f5ff4f6e5214f126$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f5ff4f6e5214f126$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f5ff4f6e5214f126$var$Cc(a, c);
    }
}
var $f5ff4f6e5214f126$var$ai = {
    readContext: $f5ff4f6e5214f126$var$Vg,
    useCallback: $f5ff4f6e5214f126$var$Q,
    useContext: $f5ff4f6e5214f126$var$Q,
    useEffect: $f5ff4f6e5214f126$var$Q,
    useImperativeHandle: $f5ff4f6e5214f126$var$Q,
    useInsertionEffect: $f5ff4f6e5214f126$var$Q,
    useLayoutEffect: $f5ff4f6e5214f126$var$Q,
    useMemo: $f5ff4f6e5214f126$var$Q,
    useReducer: $f5ff4f6e5214f126$var$Q,
    useRef: $f5ff4f6e5214f126$var$Q,
    useState: $f5ff4f6e5214f126$var$Q,
    useDebugValue: $f5ff4f6e5214f126$var$Q,
    useDeferredValue: $f5ff4f6e5214f126$var$Q,
    useTransition: $f5ff4f6e5214f126$var$Q,
    useMutableSource: $f5ff4f6e5214f126$var$Q,
    useSyncExternalStore: $f5ff4f6e5214f126$var$Q,
    useId: $f5ff4f6e5214f126$var$Q,
    unstable_isNewReconciler: !1
}, $f5ff4f6e5214f126$var$Yh = {
    readContext: $f5ff4f6e5214f126$var$Vg,
    useCallback: function(a, b) {
        $f5ff4f6e5214f126$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f5ff4f6e5214f126$var$Vg,
    useEffect: $f5ff4f6e5214f126$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f5ff4f6e5214f126$var$ti(4194308, 4, $f5ff4f6e5214f126$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f5ff4f6e5214f126$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f5ff4f6e5214f126$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f5ff4f6e5214f126$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f5ff4f6e5214f126$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f5ff4f6e5214f126$var$Gi.bind(null, $f5ff4f6e5214f126$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f5ff4f6e5214f126$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f5ff4f6e5214f126$var$qi,
    useDebugValue: $f5ff4f6e5214f126$var$Ai,
    useDeferredValue: function(a) {
        return $f5ff4f6e5214f126$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $f5ff4f6e5214f126$var$qi(!1), b = a[0];
        a = $f5ff4f6e5214f126$var$Ei.bind(null, a[1]);
        $f5ff4f6e5214f126$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f5ff4f6e5214f126$var$N, e = $f5ff4f6e5214f126$var$ci();
        if ($f5ff4f6e5214f126$var$I) {
            if (void 0 === c) throw Error($f5ff4f6e5214f126$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f5ff4f6e5214f126$var$R) throw Error($f5ff4f6e5214f126$var$p(349));
            0 !== ($f5ff4f6e5214f126$var$Rh & 30) || $f5ff4f6e5214f126$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f5ff4f6e5214f126$var$vi($f5ff4f6e5214f126$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f5ff4f6e5214f126$var$li(9, $f5ff4f6e5214f126$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f5ff4f6e5214f126$var$ci(), b = $f5ff4f6e5214f126$var$R.identifierPrefix;
        if ($f5ff4f6e5214f126$var$I) {
            var c = $f5ff4f6e5214f126$var$sg;
            var d = $f5ff4f6e5214f126$var$rg;
            c = (d & ~(1 << 32 - $f5ff4f6e5214f126$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f5ff4f6e5214f126$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f5ff4f6e5214f126$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f5ff4f6e5214f126$var$Zh = {
    readContext: $f5ff4f6e5214f126$var$Vg,
    useCallback: $f5ff4f6e5214f126$var$Bi,
    useContext: $f5ff4f6e5214f126$var$Vg,
    useEffect: $f5ff4f6e5214f126$var$ji,
    useImperativeHandle: $f5ff4f6e5214f126$var$zi,
    useInsertionEffect: $f5ff4f6e5214f126$var$wi,
    useLayoutEffect: $f5ff4f6e5214f126$var$xi,
    useMemo: $f5ff4f6e5214f126$var$Ci,
    useReducer: $f5ff4f6e5214f126$var$fi,
    useRef: $f5ff4f6e5214f126$var$si,
    useState: function() {
        return $f5ff4f6e5214f126$var$fi($f5ff4f6e5214f126$var$ei);
    },
    useDebugValue: $f5ff4f6e5214f126$var$Ai,
    useDeferredValue: function(a) {
        var b = $f5ff4f6e5214f126$var$di();
        return $f5ff4f6e5214f126$var$Di(b, $f5ff4f6e5214f126$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f5ff4f6e5214f126$var$fi($f5ff4f6e5214f126$var$ei)[0], b = $f5ff4f6e5214f126$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f5ff4f6e5214f126$var$hi,
    useSyncExternalStore: $f5ff4f6e5214f126$var$ii,
    useId: $f5ff4f6e5214f126$var$Fi,
    unstable_isNewReconciler: !1
}, $f5ff4f6e5214f126$var$$h = {
    readContext: $f5ff4f6e5214f126$var$Vg,
    useCallback: $f5ff4f6e5214f126$var$Bi,
    useContext: $f5ff4f6e5214f126$var$Vg,
    useEffect: $f5ff4f6e5214f126$var$ji,
    useImperativeHandle: $f5ff4f6e5214f126$var$zi,
    useInsertionEffect: $f5ff4f6e5214f126$var$wi,
    useLayoutEffect: $f5ff4f6e5214f126$var$xi,
    useMemo: $f5ff4f6e5214f126$var$Ci,
    useReducer: $f5ff4f6e5214f126$var$gi,
    useRef: $f5ff4f6e5214f126$var$si,
    useState: function() {
        return $f5ff4f6e5214f126$var$gi($f5ff4f6e5214f126$var$ei);
    },
    useDebugValue: $f5ff4f6e5214f126$var$Ai,
    useDeferredValue: function(a) {
        var b = $f5ff4f6e5214f126$var$di();
        return null === $f5ff4f6e5214f126$var$O ? b.memoizedState = a : $f5ff4f6e5214f126$var$Di(b, $f5ff4f6e5214f126$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f5ff4f6e5214f126$var$gi($f5ff4f6e5214f126$var$ei)[0], b = $f5ff4f6e5214f126$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f5ff4f6e5214f126$var$hi,
    useSyncExternalStore: $f5ff4f6e5214f126$var$ii,
    useId: $f5ff4f6e5214f126$var$Fi,
    unstable_isNewReconciler: !1
};
function $f5ff4f6e5214f126$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $f5ff4f6e5214f126$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f5ff4f6e5214f126$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f5ff4f6e5214f126$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f5ff4f6e5214f126$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $f5ff4f6e5214f126$var$Oi(a, b, c) {
    c = $f5ff4f6e5214f126$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f5ff4f6e5214f126$var$Pi || ($f5ff4f6e5214f126$var$Pi = !0, $f5ff4f6e5214f126$var$Qi = d);
        $f5ff4f6e5214f126$var$Mi(a, b);
    };
    return c;
}
function $f5ff4f6e5214f126$var$Ri(a, b, c) {
    c = $f5ff4f6e5214f126$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f5ff4f6e5214f126$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f5ff4f6e5214f126$var$Mi(a, b);
        "function" !== typeof d && (null === $f5ff4f6e5214f126$var$Si ? $f5ff4f6e5214f126$var$Si = new Set([
            this
        ]) : $f5ff4f6e5214f126$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f5ff4f6e5214f126$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f5ff4f6e5214f126$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f5ff4f6e5214f126$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $f5ff4f6e5214f126$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f5ff4f6e5214f126$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f5ff4f6e5214f126$var$ch(-1, 1), b.tag = 2, $f5ff4f6e5214f126$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f5ff4f6e5214f126$var$Xi = $f5ff4f6e5214f126$var$ua.ReactCurrentOwner, $f5ff4f6e5214f126$var$Ug = !1;
function $f5ff4f6e5214f126$var$Yi(a, b, c, d) {
    b.child = null === a ? $f5ff4f6e5214f126$var$Ch(b, null, c, d) : $f5ff4f6e5214f126$var$Bh(b, a.child, c, d);
}
function $f5ff4f6e5214f126$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f5ff4f6e5214f126$var$Tg(b, e);
    d = $f5ff4f6e5214f126$var$Xh(a, b, c, d, f, e);
    c = $f5ff4f6e5214f126$var$bi();
    if (null !== a && !$f5ff4f6e5214f126$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f5ff4f6e5214f126$var$$i(a, b, e);
    $f5ff4f6e5214f126$var$I && c && $f5ff4f6e5214f126$var$vg(b);
    b.flags |= 1;
    $f5ff4f6e5214f126$var$Yi(a, b, d, e);
    return b.child;
}
function $f5ff4f6e5214f126$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f5ff4f6e5214f126$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f5ff4f6e5214f126$var$cj(a, b, f, d, e);
        a = $f5ff4f6e5214f126$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f5ff4f6e5214f126$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f5ff4f6e5214f126$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $f5ff4f6e5214f126$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f5ff4f6e5214f126$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f5ff4f6e5214f126$var$Ie(f, d) && a.ref === b.ref) {
            if ($f5ff4f6e5214f126$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f5ff4f6e5214f126$var$Ug = !0);
            else return b.lanes = a.lanes, $f5ff4f6e5214f126$var$$i(a, b, e);
        }
    }
    return $f5ff4f6e5214f126$var$dj(a, b, c, d, e);
}
function $f5ff4f6e5214f126$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$fj, $f5ff4f6e5214f126$var$gj), $f5ff4f6e5214f126$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$fj, $f5ff4f6e5214f126$var$gj), $f5ff4f6e5214f126$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$fj, $f5ff4f6e5214f126$var$gj);
            $f5ff4f6e5214f126$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$fj, $f5ff4f6e5214f126$var$gj), $f5ff4f6e5214f126$var$gj |= d;
    $f5ff4f6e5214f126$var$Yi(a, b, e, c);
    return b.child;
}
function $f5ff4f6e5214f126$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f5ff4f6e5214f126$var$dj(a, b, c, d, e) {
    var f = $f5ff4f6e5214f126$var$Zf(c) ? $f5ff4f6e5214f126$var$Xf : $f5ff4f6e5214f126$var$H.current;
    f = $f5ff4f6e5214f126$var$Yf(b, f);
    $f5ff4f6e5214f126$var$Tg(b, e);
    c = $f5ff4f6e5214f126$var$Xh(a, b, c, d, f, e);
    d = $f5ff4f6e5214f126$var$bi();
    if (null !== a && !$f5ff4f6e5214f126$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f5ff4f6e5214f126$var$$i(a, b, e);
    $f5ff4f6e5214f126$var$I && d && $f5ff4f6e5214f126$var$vg(b);
    b.flags |= 1;
    $f5ff4f6e5214f126$var$Yi(a, b, c, e);
    return b.child;
}
function $f5ff4f6e5214f126$var$ij(a, b, c, d, e) {
    if ($f5ff4f6e5214f126$var$Zf(c)) {
        var f = !0;
        $f5ff4f6e5214f126$var$cg(b);
    } else f = !1;
    $f5ff4f6e5214f126$var$Tg(b, e);
    if (null === b.stateNode) $f5ff4f6e5214f126$var$jj(a, b), $f5ff4f6e5214f126$var$ph(b, c, d), $f5ff4f6e5214f126$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f5ff4f6e5214f126$var$Vg(l) : (l = $f5ff4f6e5214f126$var$Zf(c) ? $f5ff4f6e5214f126$var$Xf : $f5ff4f6e5214f126$var$H.current, l = $f5ff4f6e5214f126$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f5ff4f6e5214f126$var$qh(b, g, d, l);
        $f5ff4f6e5214f126$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $f5ff4f6e5214f126$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f5ff4f6e5214f126$var$Wf.current || $f5ff4f6e5214f126$var$$g ? ("function" === typeof m && ($f5ff4f6e5214f126$var$kh(b, c, m, d), k = b.memoizedState), (h = $f5ff4f6e5214f126$var$$g || $f5ff4f6e5214f126$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f5ff4f6e5214f126$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f5ff4f6e5214f126$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f5ff4f6e5214f126$var$Vg(k) : (k = $f5ff4f6e5214f126$var$Zf(c) ? $f5ff4f6e5214f126$var$Xf : $f5ff4f6e5214f126$var$H.current, k = $f5ff4f6e5214f126$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f5ff4f6e5214f126$var$qh(b, g, d, k);
        $f5ff4f6e5214f126$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $f5ff4f6e5214f126$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f5ff4f6e5214f126$var$Wf.current || $f5ff4f6e5214f126$var$$g ? ("function" === typeof y && ($f5ff4f6e5214f126$var$kh(b, c, y, d), n = b.memoizedState), (l = $f5ff4f6e5214f126$var$$g || $f5ff4f6e5214f126$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f5ff4f6e5214f126$var$kj(a, b, c, d, f, e);
}
function $f5ff4f6e5214f126$var$kj(a, b, c, d, e, f) {
    $f5ff4f6e5214f126$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f5ff4f6e5214f126$var$dg(b, c, !1), $f5ff4f6e5214f126$var$$i(a, b, f);
    d = b.stateNode;
    $f5ff4f6e5214f126$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f5ff4f6e5214f126$var$Bh(b, a.child, null, f), b.child = $f5ff4f6e5214f126$var$Bh(b, null, h, f)) : $f5ff4f6e5214f126$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f5ff4f6e5214f126$var$dg(b, c, !0);
    return b.child;
}
function $f5ff4f6e5214f126$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f5ff4f6e5214f126$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f5ff4f6e5214f126$var$ag(a, b.context, !1);
    $f5ff4f6e5214f126$var$Ih(a, b.containerInfo);
}
function $f5ff4f6e5214f126$var$mj(a, b, c, d, e) {
    $f5ff4f6e5214f126$var$Ig();
    $f5ff4f6e5214f126$var$Jg(e);
    b.flags |= 256;
    $f5ff4f6e5214f126$var$Yi(a, b, c, d);
    return b.child;
}
var $f5ff4f6e5214f126$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f5ff4f6e5214f126$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f5ff4f6e5214f126$var$pj(a, b, c) {
    var d = b.pendingProps, e = $f5ff4f6e5214f126$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, e & 1);
    if (null === a) {
        $f5ff4f6e5214f126$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f5ff4f6e5214f126$var$qj(g, d, 0, null), a = $f5ff4f6e5214f126$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f5ff4f6e5214f126$var$oj(c), b.memoizedState = $f5ff4f6e5214f126$var$nj, a) : $f5ff4f6e5214f126$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f5ff4f6e5214f126$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f5ff4f6e5214f126$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f5ff4f6e5214f126$var$wh(h, f) : (f = $f5ff4f6e5214f126$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f5ff4f6e5214f126$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f5ff4f6e5214f126$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f5ff4f6e5214f126$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f5ff4f6e5214f126$var$rj(a, b) {
    b = $f5ff4f6e5214f126$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f5ff4f6e5214f126$var$tj(a, b, c, d) {
    null !== d && $f5ff4f6e5214f126$var$Jg(d);
    $f5ff4f6e5214f126$var$Bh(b, a.child, null, c);
    a = $f5ff4f6e5214f126$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f5ff4f6e5214f126$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f5ff4f6e5214f126$var$Li(Error($f5ff4f6e5214f126$var$p(422))), $f5ff4f6e5214f126$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f5ff4f6e5214f126$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f5ff4f6e5214f126$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f5ff4f6e5214f126$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $f5ff4f6e5214f126$var$oj(g);
        b.memoizedState = $f5ff4f6e5214f126$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f5ff4f6e5214f126$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f5ff4f6e5214f126$var$p(419));
        d = $f5ff4f6e5214f126$var$Li(f, d, void 0);
        return $f5ff4f6e5214f126$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f5ff4f6e5214f126$var$Ug || h) {
        d = $f5ff4f6e5214f126$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f5ff4f6e5214f126$var$Zg(a, e), $f5ff4f6e5214f126$var$mh(d, a, e, -1));
        }
        $f5ff4f6e5214f126$var$uj();
        d = $f5ff4f6e5214f126$var$Li(Error($f5ff4f6e5214f126$var$p(421)));
        return $f5ff4f6e5214f126$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f5ff4f6e5214f126$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$Lf(e.nextSibling);
    $f5ff4f6e5214f126$var$xg = b;
    $f5ff4f6e5214f126$var$I = !0;
    $f5ff4f6e5214f126$var$zg = null;
    null !== a && ($f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$rg, $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$sg, $f5ff4f6e5214f126$var$og[$f5ff4f6e5214f126$var$pg++] = $f5ff4f6e5214f126$var$qg, $f5ff4f6e5214f126$var$rg = a.id, $f5ff4f6e5214f126$var$sg = a.overflow, $f5ff4f6e5214f126$var$qg = b);
    b = $f5ff4f6e5214f126$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f5ff4f6e5214f126$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f5ff4f6e5214f126$var$Sg(a.return, b, c);
}
function $f5ff4f6e5214f126$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f5ff4f6e5214f126$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f5ff4f6e5214f126$var$Yi(a, b, d.children, c);
    d = $f5ff4f6e5214f126$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f5ff4f6e5214f126$var$wj(a, c, b);
            else if (19 === a.tag) $f5ff4f6e5214f126$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f5ff4f6e5214f126$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f5ff4f6e5214f126$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f5ff4f6e5214f126$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f5ff4f6e5214f126$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $f5ff4f6e5214f126$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f5ff4f6e5214f126$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f5ff4f6e5214f126$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f5ff4f6e5214f126$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f5ff4f6e5214f126$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f5ff4f6e5214f126$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f5ff4f6e5214f126$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f5ff4f6e5214f126$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $f5ff4f6e5214f126$var$lj(b);
            $f5ff4f6e5214f126$var$Ig();
            break;
        case 5:
            $f5ff4f6e5214f126$var$Kh(b);
            break;
        case 1:
            $f5ff4f6e5214f126$var$Zf(b.type) && $f5ff4f6e5214f126$var$cg(b);
            break;
        case 4:
            $f5ff4f6e5214f126$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, $f5ff4f6e5214f126$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f5ff4f6e5214f126$var$pj(a, b, c);
                $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, $f5ff4f6e5214f126$var$M.current & 1);
                a = $f5ff4f6e5214f126$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, $f5ff4f6e5214f126$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f5ff4f6e5214f126$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, $f5ff4f6e5214f126$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f5ff4f6e5214f126$var$ej(a, b, c);
    }
    return $f5ff4f6e5214f126$var$$i(a, b, c);
}
var $f5ff4f6e5214f126$var$Aj, $f5ff4f6e5214f126$var$Bj, $f5ff4f6e5214f126$var$Cj, $f5ff4f6e5214f126$var$Dj;
$f5ff4f6e5214f126$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f5ff4f6e5214f126$var$Bj = function() {};
$f5ff4f6e5214f126$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f5ff4f6e5214f126$var$Ya(a, e);
                d = $f5ff4f6e5214f126$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f5ff4f6e5214f126$var$A({}, e, {
                    value: void 0
                });
                d = $f5ff4f6e5214f126$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f5ff4f6e5214f126$var$gb(a, e);
                d = $f5ff4f6e5214f126$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f5ff4f6e5214f126$var$Bf);
        }
        $f5ff4f6e5214f126$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f5ff4f6e5214f126$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f5ff4f6e5214f126$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f5ff4f6e5214f126$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f5ff4f6e5214f126$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f5ff4f6e5214f126$var$Ej(a, b) {
    if (!$f5ff4f6e5214f126$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f5ff4f6e5214f126$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f5ff4f6e5214f126$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $f5ff4f6e5214f126$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f5ff4f6e5214f126$var$S(b), null;
        case 1:
            return $f5ff4f6e5214f126$var$Zf(b.type) && $f5ff4f6e5214f126$var$$f(), $f5ff4f6e5214f126$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f5ff4f6e5214f126$var$Jh();
            $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf);
            $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$H);
            $f5ff4f6e5214f126$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f5ff4f6e5214f126$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f5ff4f6e5214f126$var$zg && ($f5ff4f6e5214f126$var$Gj($f5ff4f6e5214f126$var$zg), $f5ff4f6e5214f126$var$zg = null));
            $f5ff4f6e5214f126$var$Bj(a, b);
            $f5ff4f6e5214f126$var$S(b);
            return null;
        case 5:
            $f5ff4f6e5214f126$var$Lh(b);
            var e = $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f5ff4f6e5214f126$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f5ff4f6e5214f126$var$p(166));
                    $f5ff4f6e5214f126$var$S(b);
                    return null;
                }
                a = $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Eh.current);
                if ($f5ff4f6e5214f126$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f5ff4f6e5214f126$var$Of] = b;
                    d[$f5ff4f6e5214f126$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f5ff4f6e5214f126$var$D("cancel", d);
                            $f5ff4f6e5214f126$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f5ff4f6e5214f126$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f5ff4f6e5214f126$var$lf.length; e++)$f5ff4f6e5214f126$var$D($f5ff4f6e5214f126$var$lf[e], d);
                            break;
                        case "source":
                            $f5ff4f6e5214f126$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f5ff4f6e5214f126$var$D("error", d);
                            $f5ff4f6e5214f126$var$D("load", d);
                            break;
                        case "details":
                            $f5ff4f6e5214f126$var$D("toggle", d);
                            break;
                        case "input":
                            $f5ff4f6e5214f126$var$Za(d, f);
                            $f5ff4f6e5214f126$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f5ff4f6e5214f126$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f5ff4f6e5214f126$var$hb(d, f), $f5ff4f6e5214f126$var$D("invalid", d);
                    }
                    $f5ff4f6e5214f126$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f5ff4f6e5214f126$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f5ff4f6e5214f126$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f5ff4f6e5214f126$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f5ff4f6e5214f126$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f5ff4f6e5214f126$var$Va(d);
                            $f5ff4f6e5214f126$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f5ff4f6e5214f126$var$Va(d);
                            $f5ff4f6e5214f126$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f5ff4f6e5214f126$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f5ff4f6e5214f126$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f5ff4f6e5214f126$var$Of] = b;
                    a[$f5ff4f6e5214f126$var$Pf] = d;
                    $f5ff4f6e5214f126$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f5ff4f6e5214f126$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f5ff4f6e5214f126$var$D("cancel", a);
                                $f5ff4f6e5214f126$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f5ff4f6e5214f126$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f5ff4f6e5214f126$var$lf.length; e++)$f5ff4f6e5214f126$var$D($f5ff4f6e5214f126$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f5ff4f6e5214f126$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f5ff4f6e5214f126$var$D("error", a);
                                $f5ff4f6e5214f126$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f5ff4f6e5214f126$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f5ff4f6e5214f126$var$Za(a, d);
                                e = $f5ff4f6e5214f126$var$Ya(a, d);
                                $f5ff4f6e5214f126$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f5ff4f6e5214f126$var$A({}, d, {
                                    value: void 0
                                });
                                $f5ff4f6e5214f126$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f5ff4f6e5214f126$var$hb(a, d);
                                e = $f5ff4f6e5214f126$var$gb(a, d);
                                $f5ff4f6e5214f126$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f5ff4f6e5214f126$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f5ff4f6e5214f126$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f5ff4f6e5214f126$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f5ff4f6e5214f126$var$ob(a, k) : "number" === typeof k && $f5ff4f6e5214f126$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f5ff4f6e5214f126$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f5ff4f6e5214f126$var$D("scroll", a) : null != k && $f5ff4f6e5214f126$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f5ff4f6e5214f126$var$Va(a);
                                $f5ff4f6e5214f126$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f5ff4f6e5214f126$var$Va(a);
                                $f5ff4f6e5214f126$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f5ff4f6e5214f126$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f5ff4f6e5214f126$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f5ff4f6e5214f126$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f5ff4f6e5214f126$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f5ff4f6e5214f126$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f5ff4f6e5214f126$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f5ff4f6e5214f126$var$p(166));
                c = $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Gh.current);
                $f5ff4f6e5214f126$var$Hh($f5ff4f6e5214f126$var$Eh.current);
                if ($f5ff4f6e5214f126$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f5ff4f6e5214f126$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f5ff4f6e5214f126$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f5ff4f6e5214f126$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f5ff4f6e5214f126$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f5ff4f6e5214f126$var$Of] = b, b.stateNode = d;
            }
            $f5ff4f6e5214f126$var$S(b);
            return null;
        case 13:
            $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f5ff4f6e5214f126$var$I && null !== $f5ff4f6e5214f126$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f5ff4f6e5214f126$var$Hg(), $f5ff4f6e5214f126$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f5ff4f6e5214f126$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f5ff4f6e5214f126$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f5ff4f6e5214f126$var$p(317));
                        f[$f5ff4f6e5214f126$var$Of] = b;
                    } else $f5ff4f6e5214f126$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f5ff4f6e5214f126$var$S(b);
                    f = !1;
                } else null !== $f5ff4f6e5214f126$var$zg && ($f5ff4f6e5214f126$var$Gj($f5ff4f6e5214f126$var$zg), $f5ff4f6e5214f126$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f5ff4f6e5214f126$var$M.current & 1) ? 0 === $f5ff4f6e5214f126$var$T && ($f5ff4f6e5214f126$var$T = 3) : $f5ff4f6e5214f126$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f5ff4f6e5214f126$var$S(b);
            return null;
        case 4:
            return $f5ff4f6e5214f126$var$Jh(), $f5ff4f6e5214f126$var$Bj(a, b), null === a && $f5ff4f6e5214f126$var$sf(b.stateNode.containerInfo), $f5ff4f6e5214f126$var$S(b), null;
        case 10:
            return $f5ff4f6e5214f126$var$Rg(b.type._context), $f5ff4f6e5214f126$var$S(b), null;
        case 17:
            return $f5ff4f6e5214f126$var$Zf(b.type) && $f5ff4f6e5214f126$var$$f(), $f5ff4f6e5214f126$var$S(b), null;
        case 19:
            $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M);
            f = b.memoizedState;
            if (null === f) return $f5ff4f6e5214f126$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f5ff4f6e5214f126$var$Ej(f, !1);
                else {
                    if (0 !== $f5ff4f6e5214f126$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f5ff4f6e5214f126$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f5ff4f6e5214f126$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, $f5ff4f6e5214f126$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f5ff4f6e5214f126$var$B() > $f5ff4f6e5214f126$var$Hj && (b.flags |= 128, d = !0, $f5ff4f6e5214f126$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f5ff4f6e5214f126$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f5ff4f6e5214f126$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f5ff4f6e5214f126$var$I) return $f5ff4f6e5214f126$var$S(b), null;
                    } else 2 * $f5ff4f6e5214f126$var$B() - f.renderingStartTime > $f5ff4f6e5214f126$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $f5ff4f6e5214f126$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f5ff4f6e5214f126$var$B(), b.sibling = null, c = $f5ff4f6e5214f126$var$M.current, $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$M, d ? c & 1 | 2 : c & 1), b;
            $f5ff4f6e5214f126$var$S(b);
            return null;
        case 22:
        case 23:
            return $f5ff4f6e5214f126$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f5ff4f6e5214f126$var$gj & 1073741824) && ($f5ff4f6e5214f126$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f5ff4f6e5214f126$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f5ff4f6e5214f126$var$p(156, b.tag));
}
function $f5ff4f6e5214f126$var$Jj(a, b) {
    $f5ff4f6e5214f126$var$wg(b);
    switch(b.tag){
        case 1:
            return $f5ff4f6e5214f126$var$Zf(b.type) && $f5ff4f6e5214f126$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f5ff4f6e5214f126$var$Jh(), $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf), $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$H), $f5ff4f6e5214f126$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f5ff4f6e5214f126$var$Lh(b), null;
        case 13:
            $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f5ff4f6e5214f126$var$p(340));
                $f5ff4f6e5214f126$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M), null;
        case 4:
            return $f5ff4f6e5214f126$var$Jh(), null;
        case 10:
            return $f5ff4f6e5214f126$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $f5ff4f6e5214f126$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f5ff4f6e5214f126$var$Kj = !1, $f5ff4f6e5214f126$var$U = !1, $f5ff4f6e5214f126$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $f5ff4f6e5214f126$var$V = null;
function $f5ff4f6e5214f126$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f5ff4f6e5214f126$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f5ff4f6e5214f126$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f5ff4f6e5214f126$var$W(a, b, d);
    }
}
var $f5ff4f6e5214f126$var$Oj = !1;
function $f5ff4f6e5214f126$var$Pj(a, b) {
    $f5ff4f6e5214f126$var$Cf = $f5ff4f6e5214f126$var$dd;
    a = $f5ff4f6e5214f126$var$Me();
    if ($f5ff4f6e5214f126$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f5ff4f6e5214f126$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f5ff4f6e5214f126$var$dd = !1;
    for($f5ff4f6e5214f126$var$V = b; null !== $f5ff4f6e5214f126$var$V;)if (b = $f5ff4f6e5214f126$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f5ff4f6e5214f126$var$V = a;
    else for(; null !== $f5ff4f6e5214f126$var$V;){
        b = $f5ff4f6e5214f126$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f5ff4f6e5214f126$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f5ff4f6e5214f126$var$p(163));
            }
        } catch (F) {
            $f5ff4f6e5214f126$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f5ff4f6e5214f126$var$V = a;
            break;
        }
        $f5ff4f6e5214f126$var$V = b.return;
    }
    n = $f5ff4f6e5214f126$var$Oj;
    $f5ff4f6e5214f126$var$Oj = !1;
    return n;
}
function $f5ff4f6e5214f126$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f5ff4f6e5214f126$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f5ff4f6e5214f126$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f5ff4f6e5214f126$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f5ff4f6e5214f126$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f5ff4f6e5214f126$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f5ff4f6e5214f126$var$Of], delete b[$f5ff4f6e5214f126$var$Pf], delete b[$f5ff4f6e5214f126$var$of], delete b[$f5ff4f6e5214f126$var$Qf], delete b[$f5ff4f6e5214f126$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f5ff4f6e5214f126$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f5ff4f6e5214f126$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f5ff4f6e5214f126$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f5ff4f6e5214f126$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f5ff4f6e5214f126$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f5ff4f6e5214f126$var$Wj(a, b, c), a = a.sibling; null !== a;)$f5ff4f6e5214f126$var$Wj(a, b, c), a = a.sibling;
}
function $f5ff4f6e5214f126$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f5ff4f6e5214f126$var$Xj(a, b, c), a = a.sibling; null !== a;)$f5ff4f6e5214f126$var$Xj(a, b, c), a = a.sibling;
}
var $f5ff4f6e5214f126$var$X = null, $f5ff4f6e5214f126$var$Yj = !1;
function $f5ff4f6e5214f126$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$f5ff4f6e5214f126$var$ak(a, b, c), c = c.sibling;
}
function $f5ff4f6e5214f126$var$ak(a, b, c) {
    if ($f5ff4f6e5214f126$var$lc && "function" === typeof $f5ff4f6e5214f126$var$lc.onCommitFiberUnmount) try {
        $f5ff4f6e5214f126$var$lc.onCommitFiberUnmount($f5ff4f6e5214f126$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f5ff4f6e5214f126$var$U || $f5ff4f6e5214f126$var$Mj(c, b);
        case 6:
            var d = $f5ff4f6e5214f126$var$X, e = $f5ff4f6e5214f126$var$Yj;
            $f5ff4f6e5214f126$var$X = null;
            $f5ff4f6e5214f126$var$Zj(a, b, c);
            $f5ff4f6e5214f126$var$X = d;
            $f5ff4f6e5214f126$var$Yj = e;
            null !== $f5ff4f6e5214f126$var$X && ($f5ff4f6e5214f126$var$Yj ? (a = $f5ff4f6e5214f126$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f5ff4f6e5214f126$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f5ff4f6e5214f126$var$X && ($f5ff4f6e5214f126$var$Yj ? (a = $f5ff4f6e5214f126$var$X, c = c.stateNode, 8 === a.nodeType ? $f5ff4f6e5214f126$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f5ff4f6e5214f126$var$Kf(a, c), $f5ff4f6e5214f126$var$bd(a)) : $f5ff4f6e5214f126$var$Kf($f5ff4f6e5214f126$var$X, c.stateNode));
            break;
        case 4:
            d = $f5ff4f6e5214f126$var$X;
            e = $f5ff4f6e5214f126$var$Yj;
            $f5ff4f6e5214f126$var$X = c.stateNode.containerInfo;
            $f5ff4f6e5214f126$var$Yj = !0;
            $f5ff4f6e5214f126$var$Zj(a, b, c);
            $f5ff4f6e5214f126$var$X = d;
            $f5ff4f6e5214f126$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f5ff4f6e5214f126$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f5ff4f6e5214f126$var$Nj(c, b, g) : 0 !== (f & 4) && $f5ff4f6e5214f126$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f5ff4f6e5214f126$var$Zj(a, b, c);
            break;
        case 1:
            if (!$f5ff4f6e5214f126$var$U && ($f5ff4f6e5214f126$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f5ff4f6e5214f126$var$W(c, b, h);
            }
            $f5ff4f6e5214f126$var$Zj(a, b, c);
            break;
        case 21:
            $f5ff4f6e5214f126$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f5ff4f6e5214f126$var$U = (d = $f5ff4f6e5214f126$var$U) || null !== c.memoizedState, $f5ff4f6e5214f126$var$Zj(a, b, c), $f5ff4f6e5214f126$var$U = d) : $f5ff4f6e5214f126$var$Zj(a, b, c);
            break;
        default:
            $f5ff4f6e5214f126$var$Zj(a, b, c);
    }
}
function $f5ff4f6e5214f126$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f5ff4f6e5214f126$var$Lj);
        b.forEach(function(b) {
            var d = $f5ff4f6e5214f126$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f5ff4f6e5214f126$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f5ff4f6e5214f126$var$X = h.stateNode;
                        $f5ff4f6e5214f126$var$Yj = !1;
                        break a;
                    case 3:
                        $f5ff4f6e5214f126$var$X = h.stateNode.containerInfo;
                        $f5ff4f6e5214f126$var$Yj = !0;
                        break a;
                    case 4:
                        $f5ff4f6e5214f126$var$X = h.stateNode.containerInfo;
                        $f5ff4f6e5214f126$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f5ff4f6e5214f126$var$X) throw Error($f5ff4f6e5214f126$var$p(160));
            $f5ff4f6e5214f126$var$ak(f, g, e);
            $f5ff4f6e5214f126$var$X = null;
            $f5ff4f6e5214f126$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f5ff4f6e5214f126$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f5ff4f6e5214f126$var$ek(b, a), b = b.sibling;
}
function $f5ff4f6e5214f126$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            if (d & 4) {
                try {
                    $f5ff4f6e5214f126$var$Qj(3, a, a.return), $f5ff4f6e5214f126$var$Rj(3, a);
                } catch (t) {
                    $f5ff4f6e5214f126$var$W(a, a.return, t);
                }
                try {
                    $f5ff4f6e5214f126$var$Qj(5, a, a.return);
                } catch (t) {
                    $f5ff4f6e5214f126$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            d & 512 && null !== c && $f5ff4f6e5214f126$var$Mj(c, c.return);
            break;
        case 5:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            d & 512 && null !== c && $f5ff4f6e5214f126$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f5ff4f6e5214f126$var$ob(e, "");
                } catch (t) {
                    $f5ff4f6e5214f126$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f5ff4f6e5214f126$var$ab(e, f);
                    $f5ff4f6e5214f126$var$vb(h, g);
                    var l = $f5ff4f6e5214f126$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f5ff4f6e5214f126$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f5ff4f6e5214f126$var$nb(e, q) : "children" === m ? $f5ff4f6e5214f126$var$ob(e, q) : $f5ff4f6e5214f126$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f5ff4f6e5214f126$var$bb(e, f);
                            break;
                        case "textarea":
                            $f5ff4f6e5214f126$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f5ff4f6e5214f126$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f5ff4f6e5214f126$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f5ff4f6e5214f126$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f5ff4f6e5214f126$var$Pf] = f;
                } catch (t) {
                    $f5ff4f6e5214f126$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f5ff4f6e5214f126$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f5ff4f6e5214f126$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f5ff4f6e5214f126$var$bd(b.containerInfo);
            } catch (t) {
                $f5ff4f6e5214f126$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            break;
        case 13:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f5ff4f6e5214f126$var$gk = $f5ff4f6e5214f126$var$B()));
            d & 4 && $f5ff4f6e5214f126$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f5ff4f6e5214f126$var$U = (l = $f5ff4f6e5214f126$var$U) || m, $f5ff4f6e5214f126$var$dk(b, a), $f5ff4f6e5214f126$var$U = l) : $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f5ff4f6e5214f126$var$V = a, m = a.child; null !== m;){
                    for(q = $f5ff4f6e5214f126$var$V = m; null !== $f5ff4f6e5214f126$var$V;){
                        r = $f5ff4f6e5214f126$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f5ff4f6e5214f126$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $f5ff4f6e5214f126$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f5ff4f6e5214f126$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f5ff4f6e5214f126$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f5ff4f6e5214f126$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f5ff4f6e5214f126$var$V = y) : $f5ff4f6e5214f126$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f5ff4f6e5214f126$var$rb("display", g));
                            } catch (t) {
                                $f5ff4f6e5214f126$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f5ff4f6e5214f126$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f5ff4f6e5214f126$var$dk(b, a);
            $f5ff4f6e5214f126$var$fk(a);
            d & 4 && $f5ff4f6e5214f126$var$bk(a);
            break;
        case 21:
            break;
        default:
            $f5ff4f6e5214f126$var$dk(b, a), $f5ff4f6e5214f126$var$fk(a);
    }
}
function $f5ff4f6e5214f126$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f5ff4f6e5214f126$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f5ff4f6e5214f126$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f5ff4f6e5214f126$var$ob(e, ""), d.flags &= -33);
                    var f = $f5ff4f6e5214f126$var$Vj(a);
                    $f5ff4f6e5214f126$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f5ff4f6e5214f126$var$Vj(a);
                    $f5ff4f6e5214f126$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($f5ff4f6e5214f126$var$p(161));
            }
        } catch (k) {
            $f5ff4f6e5214f126$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f5ff4f6e5214f126$var$ik(a, b, c) {
    $f5ff4f6e5214f126$var$V = a;
    $f5ff4f6e5214f126$var$jk(a, b, c);
}
function $f5ff4f6e5214f126$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f5ff4f6e5214f126$var$V;){
        var e = $f5ff4f6e5214f126$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f5ff4f6e5214f126$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f5ff4f6e5214f126$var$U;
                h = $f5ff4f6e5214f126$var$Kj;
                var l = $f5ff4f6e5214f126$var$U;
                $f5ff4f6e5214f126$var$Kj = g;
                if (($f5ff4f6e5214f126$var$U = k) && !l) for($f5ff4f6e5214f126$var$V = e; null !== $f5ff4f6e5214f126$var$V;)g = $f5ff4f6e5214f126$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f5ff4f6e5214f126$var$kk(e) : null !== k ? (k.return = g, $f5ff4f6e5214f126$var$V = k) : $f5ff4f6e5214f126$var$kk(e);
                for(; null !== f;)$f5ff4f6e5214f126$var$V = f, $f5ff4f6e5214f126$var$jk(f, b, c), f = f.sibling;
                $f5ff4f6e5214f126$var$V = e;
                $f5ff4f6e5214f126$var$Kj = h;
                $f5ff4f6e5214f126$var$U = l;
            }
            $f5ff4f6e5214f126$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f5ff4f6e5214f126$var$V = f) : $f5ff4f6e5214f126$var$lk(a, b, c);
    }
}
function $f5ff4f6e5214f126$var$lk(a) {
    for(; null !== $f5ff4f6e5214f126$var$V;){
        var b = $f5ff4f6e5214f126$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f5ff4f6e5214f126$var$U || $f5ff4f6e5214f126$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f5ff4f6e5214f126$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f5ff4f6e5214f126$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f5ff4f6e5214f126$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f5ff4f6e5214f126$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f5ff4f6e5214f126$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f5ff4f6e5214f126$var$p(163));
                }
                $f5ff4f6e5214f126$var$U || b.flags & 512 && $f5ff4f6e5214f126$var$Sj(b);
            } catch (r) {
                $f5ff4f6e5214f126$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f5ff4f6e5214f126$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f5ff4f6e5214f126$var$V = c;
            break;
        }
        $f5ff4f6e5214f126$var$V = b.return;
    }
}
function $f5ff4f6e5214f126$var$hk(a) {
    for(; null !== $f5ff4f6e5214f126$var$V;){
        var b = $f5ff4f6e5214f126$var$V;
        if (b === a) {
            $f5ff4f6e5214f126$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f5ff4f6e5214f126$var$V = c;
            break;
        }
        $f5ff4f6e5214f126$var$V = b.return;
    }
}
function $f5ff4f6e5214f126$var$kk(a) {
    for(; null !== $f5ff4f6e5214f126$var$V;){
        var b = $f5ff4f6e5214f126$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f5ff4f6e5214f126$var$Rj(4, b);
                    } catch (k) {
                        $f5ff4f6e5214f126$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f5ff4f6e5214f126$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f5ff4f6e5214f126$var$Sj(b);
                    } catch (k) {
                        $f5ff4f6e5214f126$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f5ff4f6e5214f126$var$Sj(b);
                    } catch (k) {
                        $f5ff4f6e5214f126$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f5ff4f6e5214f126$var$W(b, b.return, k);
        }
        if (b === a) {
            $f5ff4f6e5214f126$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f5ff4f6e5214f126$var$V = h;
            break;
        }
        $f5ff4f6e5214f126$var$V = b.return;
    }
}
var $f5ff4f6e5214f126$var$mk = Math.ceil, $f5ff4f6e5214f126$var$nk = $f5ff4f6e5214f126$var$ua.ReactCurrentDispatcher, $f5ff4f6e5214f126$var$ok = $f5ff4f6e5214f126$var$ua.ReactCurrentOwner, $f5ff4f6e5214f126$var$pk = $f5ff4f6e5214f126$var$ua.ReactCurrentBatchConfig, $f5ff4f6e5214f126$var$K = 0, $f5ff4f6e5214f126$var$R = null, $f5ff4f6e5214f126$var$Y = null, $f5ff4f6e5214f126$var$Z = 0, $f5ff4f6e5214f126$var$gj = 0, $f5ff4f6e5214f126$var$fj = $f5ff4f6e5214f126$var$Uf(0), $f5ff4f6e5214f126$var$T = 0, $f5ff4f6e5214f126$var$qk = null, $f5ff4f6e5214f126$var$hh = 0, $f5ff4f6e5214f126$var$rk = 0, $f5ff4f6e5214f126$var$sk = 0, $f5ff4f6e5214f126$var$tk = null, $f5ff4f6e5214f126$var$uk = null, $f5ff4f6e5214f126$var$gk = 0, $f5ff4f6e5214f126$var$Hj = Infinity, $f5ff4f6e5214f126$var$vk = null, $f5ff4f6e5214f126$var$Pi = !1, $f5ff4f6e5214f126$var$Qi = null, $f5ff4f6e5214f126$var$Si = null, $f5ff4f6e5214f126$var$wk = !1, $f5ff4f6e5214f126$var$xk = null, $f5ff4f6e5214f126$var$yk = 0, $f5ff4f6e5214f126$var$zk = 0, $f5ff4f6e5214f126$var$Ak = null, $f5ff4f6e5214f126$var$Bk = -1, $f5ff4f6e5214f126$var$Ck = 0;
function $f5ff4f6e5214f126$var$L() {
    return 0 !== ($f5ff4f6e5214f126$var$K & 6) ? $f5ff4f6e5214f126$var$B() : -1 !== $f5ff4f6e5214f126$var$Bk ? $f5ff4f6e5214f126$var$Bk : $f5ff4f6e5214f126$var$Bk = $f5ff4f6e5214f126$var$B();
}
function $f5ff4f6e5214f126$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f5ff4f6e5214f126$var$K & 2) && 0 !== $f5ff4f6e5214f126$var$Z) return $f5ff4f6e5214f126$var$Z & -$f5ff4f6e5214f126$var$Z;
    if (null !== $f5ff4f6e5214f126$var$Kg.transition) return 0 === $f5ff4f6e5214f126$var$Ck && ($f5ff4f6e5214f126$var$Ck = $f5ff4f6e5214f126$var$yc()), $f5ff4f6e5214f126$var$Ck;
    a = $f5ff4f6e5214f126$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f5ff4f6e5214f126$var$jd(a.type);
    return a;
}
function $f5ff4f6e5214f126$var$mh(a, b, c, d) {
    if (50 < $f5ff4f6e5214f126$var$zk) throw $f5ff4f6e5214f126$var$zk = 0, $f5ff4f6e5214f126$var$Ak = null, Error($f5ff4f6e5214f126$var$p(185));
    $f5ff4f6e5214f126$var$Ac(a, c, d);
    if (0 === ($f5ff4f6e5214f126$var$K & 2) || a !== $f5ff4f6e5214f126$var$R) a === $f5ff4f6e5214f126$var$R && (0 === ($f5ff4f6e5214f126$var$K & 2) && ($f5ff4f6e5214f126$var$rk |= c), 4 === $f5ff4f6e5214f126$var$T && $f5ff4f6e5214f126$var$Dk(a, $f5ff4f6e5214f126$var$Z)), $f5ff4f6e5214f126$var$Ek(a, d), 1 === c && 0 === $f5ff4f6e5214f126$var$K && 0 === (b.mode & 1) && ($f5ff4f6e5214f126$var$Hj = $f5ff4f6e5214f126$var$B() + 500, $f5ff4f6e5214f126$var$fg && $f5ff4f6e5214f126$var$jg());
}
function $f5ff4f6e5214f126$var$Ek(a, b) {
    var c = a.callbackNode;
    $f5ff4f6e5214f126$var$wc(a, b);
    var d = $f5ff4f6e5214f126$var$uc(a, a === $f5ff4f6e5214f126$var$R ? $f5ff4f6e5214f126$var$Z : 0);
    if (0 === d) null !== c && $f5ff4f6e5214f126$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f5ff4f6e5214f126$var$bc(c);
        if (1 === b) 0 === a.tag ? $f5ff4f6e5214f126$var$ig($f5ff4f6e5214f126$var$Fk.bind(null, a)) : $f5ff4f6e5214f126$var$hg($f5ff4f6e5214f126$var$Fk.bind(null, a)), $f5ff4f6e5214f126$var$Jf(function() {
            0 === ($f5ff4f6e5214f126$var$K & 6) && $f5ff4f6e5214f126$var$jg();
        }), c = null;
        else {
            switch($f5ff4f6e5214f126$var$Dc(d)){
                case 1:
                    c = $f5ff4f6e5214f126$var$fc;
                    break;
                case 4:
                    c = $f5ff4f6e5214f126$var$gc;
                    break;
                case 16:
                    c = $f5ff4f6e5214f126$var$hc;
                    break;
                case 536870912:
                    c = $f5ff4f6e5214f126$var$jc;
                    break;
                default:
                    c = $f5ff4f6e5214f126$var$hc;
            }
            c = $f5ff4f6e5214f126$var$Gk(c, $f5ff4f6e5214f126$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f5ff4f6e5214f126$var$Hk(a, b) {
    $f5ff4f6e5214f126$var$Bk = -1;
    $f5ff4f6e5214f126$var$Ck = 0;
    if (0 !== ($f5ff4f6e5214f126$var$K & 6)) throw Error($f5ff4f6e5214f126$var$p(327));
    var c = a.callbackNode;
    if ($f5ff4f6e5214f126$var$Ik() && a.callbackNode !== c) return null;
    var d = $f5ff4f6e5214f126$var$uc(a, a === $f5ff4f6e5214f126$var$R ? $f5ff4f6e5214f126$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f5ff4f6e5214f126$var$Jk(a, d);
    else {
        b = d;
        var e = $f5ff4f6e5214f126$var$K;
        $f5ff4f6e5214f126$var$K |= 2;
        var f = $f5ff4f6e5214f126$var$Kk();
        if ($f5ff4f6e5214f126$var$R !== a || $f5ff4f6e5214f126$var$Z !== b) $f5ff4f6e5214f126$var$vk = null, $f5ff4f6e5214f126$var$Hj = $f5ff4f6e5214f126$var$B() + 500, $f5ff4f6e5214f126$var$Lk(a, b);
        for(;;)try {
            $f5ff4f6e5214f126$var$Mk();
            break;
        } catch (h) {
            $f5ff4f6e5214f126$var$Nk(a, h);
        }
        $f5ff4f6e5214f126$var$Qg();
        $f5ff4f6e5214f126$var$nk.current = f;
        $f5ff4f6e5214f126$var$K = e;
        null !== $f5ff4f6e5214f126$var$Y ? b = 0 : ($f5ff4f6e5214f126$var$R = null, $f5ff4f6e5214f126$var$Z = 0, b = $f5ff4f6e5214f126$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f5ff4f6e5214f126$var$xc(a), 0 !== e && (d = e, b = $f5ff4f6e5214f126$var$Ok(a, e)));
        if (1 === b) throw c = $f5ff4f6e5214f126$var$qk, $f5ff4f6e5214f126$var$Lk(a, 0), $f5ff4f6e5214f126$var$Dk(a, d), $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B()), c;
        if (6 === b) $f5ff4f6e5214f126$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f5ff4f6e5214f126$var$Pk(e) && (b = $f5ff4f6e5214f126$var$Jk(a, d), 2 === b && (f = $f5ff4f6e5214f126$var$xc(a), 0 !== f && (d = f, b = $f5ff4f6e5214f126$var$Ok(a, f))), 1 === b)) throw c = $f5ff4f6e5214f126$var$qk, $f5ff4f6e5214f126$var$Lk(a, 0), $f5ff4f6e5214f126$var$Dk(a, d), $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f5ff4f6e5214f126$var$p(345));
                case 2:
                    $f5ff4f6e5214f126$var$Qk(a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk);
                    break;
                case 3:
                    $f5ff4f6e5214f126$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $f5ff4f6e5214f126$var$gk + 500 - $f5ff4f6e5214f126$var$B(), 10 < b)) {
                        if (0 !== $f5ff4f6e5214f126$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f5ff4f6e5214f126$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f5ff4f6e5214f126$var$Ff($f5ff4f6e5214f126$var$Qk.bind(null, a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk), b);
                        break;
                    }
                    $f5ff4f6e5214f126$var$Qk(a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk);
                    break;
                case 4:
                    $f5ff4f6e5214f126$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f5ff4f6e5214f126$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f5ff4f6e5214f126$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f5ff4f6e5214f126$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f5ff4f6e5214f126$var$Ff($f5ff4f6e5214f126$var$Qk.bind(null, a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk), d);
                        break;
                    }
                    $f5ff4f6e5214f126$var$Qk(a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk);
                    break;
                case 5:
                    $f5ff4f6e5214f126$var$Qk(a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk);
                    break;
                default:
                    throw Error($f5ff4f6e5214f126$var$p(329));
            }
        }
    }
    $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B());
    return a.callbackNode === c ? $f5ff4f6e5214f126$var$Hk.bind(null, a) : null;
}
function $f5ff4f6e5214f126$var$Ok(a, b) {
    var c = $f5ff4f6e5214f126$var$tk;
    a.current.memoizedState.isDehydrated && ($f5ff4f6e5214f126$var$Lk(a, b).flags |= 256);
    a = $f5ff4f6e5214f126$var$Jk(a, b);
    2 !== a && (b = $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$uk = c, null !== b && $f5ff4f6e5214f126$var$Gj(b));
    return a;
}
function $f5ff4f6e5214f126$var$Gj(a) {
    null === $f5ff4f6e5214f126$var$uk ? $f5ff4f6e5214f126$var$uk = a : $f5ff4f6e5214f126$var$uk.push.apply($f5ff4f6e5214f126$var$uk, a);
}
function $f5ff4f6e5214f126$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f5ff4f6e5214f126$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f5ff4f6e5214f126$var$Dk(a, b) {
    b &= ~$f5ff4f6e5214f126$var$sk;
    b &= ~$f5ff4f6e5214f126$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f5ff4f6e5214f126$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f5ff4f6e5214f126$var$Fk(a) {
    if (0 !== ($f5ff4f6e5214f126$var$K & 6)) throw Error($f5ff4f6e5214f126$var$p(327));
    $f5ff4f6e5214f126$var$Ik();
    var b = $f5ff4f6e5214f126$var$uc(a, 0);
    if (0 === (b & 1)) return $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B()), null;
    var c = $f5ff4f6e5214f126$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f5ff4f6e5214f126$var$xc(a);
        0 !== d && (b = d, c = $f5ff4f6e5214f126$var$Ok(a, d));
    }
    if (1 === c) throw c = $f5ff4f6e5214f126$var$qk, $f5ff4f6e5214f126$var$Lk(a, 0), $f5ff4f6e5214f126$var$Dk(a, b), $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B()), c;
    if (6 === c) throw Error($f5ff4f6e5214f126$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f5ff4f6e5214f126$var$Qk(a, $f5ff4f6e5214f126$var$uk, $f5ff4f6e5214f126$var$vk);
    $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B());
    return null;
}
function $f5ff4f6e5214f126$var$Rk(a, b) {
    var c = $f5ff4f6e5214f126$var$K;
    $f5ff4f6e5214f126$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f5ff4f6e5214f126$var$K = c, 0 === $f5ff4f6e5214f126$var$K && ($f5ff4f6e5214f126$var$Hj = $f5ff4f6e5214f126$var$B() + 500, $f5ff4f6e5214f126$var$fg && $f5ff4f6e5214f126$var$jg());
    }
}
function $f5ff4f6e5214f126$var$Sk(a) {
    null !== $f5ff4f6e5214f126$var$xk && 0 === $f5ff4f6e5214f126$var$xk.tag && 0 === ($f5ff4f6e5214f126$var$K & 6) && $f5ff4f6e5214f126$var$Ik();
    var b = $f5ff4f6e5214f126$var$K;
    $f5ff4f6e5214f126$var$K |= 1;
    var c = $f5ff4f6e5214f126$var$pk.transition, d = $f5ff4f6e5214f126$var$C;
    try {
        if ($f5ff4f6e5214f126$var$pk.transition = null, $f5ff4f6e5214f126$var$C = 1, a) return a();
    } finally{
        $f5ff4f6e5214f126$var$C = d, $f5ff4f6e5214f126$var$pk.transition = c, $f5ff4f6e5214f126$var$K = b, 0 === ($f5ff4f6e5214f126$var$K & 6) && $f5ff4f6e5214f126$var$jg();
    }
}
function $f5ff4f6e5214f126$var$Ij() {
    $f5ff4f6e5214f126$var$gj = $f5ff4f6e5214f126$var$fj.current;
    $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$fj);
}
function $f5ff4f6e5214f126$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f5ff4f6e5214f126$var$Gf(c));
    if (null !== $f5ff4f6e5214f126$var$Y) for(c = $f5ff4f6e5214f126$var$Y.return; null !== c;){
        var d = c;
        $f5ff4f6e5214f126$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f5ff4f6e5214f126$var$$f();
                break;
            case 3:
                $f5ff4f6e5214f126$var$Jh();
                $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$Wf);
                $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$H);
                $f5ff4f6e5214f126$var$Oh();
                break;
            case 5:
                $f5ff4f6e5214f126$var$Lh(d);
                break;
            case 4:
                $f5ff4f6e5214f126$var$Jh();
                break;
            case 13:
                $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M);
                break;
            case 19:
                $f5ff4f6e5214f126$var$E($f5ff4f6e5214f126$var$M);
                break;
            case 10:
                $f5ff4f6e5214f126$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $f5ff4f6e5214f126$var$Ij();
        }
        c = c.return;
    }
    $f5ff4f6e5214f126$var$R = a;
    $f5ff4f6e5214f126$var$Y = a = $f5ff4f6e5214f126$var$wh(a.current, null);
    $f5ff4f6e5214f126$var$Z = $f5ff4f6e5214f126$var$gj = b;
    $f5ff4f6e5214f126$var$T = 0;
    $f5ff4f6e5214f126$var$qk = null;
    $f5ff4f6e5214f126$var$sk = $f5ff4f6e5214f126$var$rk = $f5ff4f6e5214f126$var$hh = 0;
    $f5ff4f6e5214f126$var$uk = $f5ff4f6e5214f126$var$tk = null;
    if (null !== $f5ff4f6e5214f126$var$Wg) {
        for(b = 0; b < $f5ff4f6e5214f126$var$Wg.length; b++)if (c = $f5ff4f6e5214f126$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f5ff4f6e5214f126$var$Wg = null;
    }
    return a;
}
function $f5ff4f6e5214f126$var$Nk(a, b) {
    do {
        var c = $f5ff4f6e5214f126$var$Y;
        try {
            $f5ff4f6e5214f126$var$Qg();
            $f5ff4f6e5214f126$var$Ph.current = $f5ff4f6e5214f126$var$ai;
            if ($f5ff4f6e5214f126$var$Sh) {
                for(var d = $f5ff4f6e5214f126$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f5ff4f6e5214f126$var$Sh = !1;
            }
            $f5ff4f6e5214f126$var$Rh = 0;
            $f5ff4f6e5214f126$var$P = $f5ff4f6e5214f126$var$O = $f5ff4f6e5214f126$var$N = null;
            $f5ff4f6e5214f126$var$Th = !1;
            $f5ff4f6e5214f126$var$Uh = 0;
            $f5ff4f6e5214f126$var$ok.current = null;
            if (null === c || null === c.return) {
                $f5ff4f6e5214f126$var$T = 1;
                $f5ff4f6e5214f126$var$qk = b;
                $f5ff4f6e5214f126$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f5ff4f6e5214f126$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f5ff4f6e5214f126$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f5ff4f6e5214f126$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $f5ff4f6e5214f126$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f5ff4f6e5214f126$var$Ti(f, l, b);
                            $f5ff4f6e5214f126$var$uj();
                            break a;
                        }
                        k = Error($f5ff4f6e5214f126$var$p(426));
                    }
                } else if ($f5ff4f6e5214f126$var$I && h.mode & 1) {
                    var J = $f5ff4f6e5214f126$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f5ff4f6e5214f126$var$Wi(J, g, h, f, b);
                        $f5ff4f6e5214f126$var$Jg($f5ff4f6e5214f126$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $f5ff4f6e5214f126$var$Ki(k, h);
                4 !== $f5ff4f6e5214f126$var$T && ($f5ff4f6e5214f126$var$T = 2);
                null === $f5ff4f6e5214f126$var$tk ? $f5ff4f6e5214f126$var$tk = [
                    f
                ] : $f5ff4f6e5214f126$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f5ff4f6e5214f126$var$Oi(f, k, b);
                            $f5ff4f6e5214f126$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f5ff4f6e5214f126$var$Si || !$f5ff4f6e5214f126$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f5ff4f6e5214f126$var$Ri(f, h, b);
                                $f5ff4f6e5214f126$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f5ff4f6e5214f126$var$Tk(c);
        } catch (na) {
            b = na;
            $f5ff4f6e5214f126$var$Y === c && null !== c && ($f5ff4f6e5214f126$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f5ff4f6e5214f126$var$Kk() {
    var a = $f5ff4f6e5214f126$var$nk.current;
    $f5ff4f6e5214f126$var$nk.current = $f5ff4f6e5214f126$var$ai;
    return null === a ? $f5ff4f6e5214f126$var$ai : a;
}
function $f5ff4f6e5214f126$var$uj() {
    if (0 === $f5ff4f6e5214f126$var$T || 3 === $f5ff4f6e5214f126$var$T || 2 === $f5ff4f6e5214f126$var$T) $f5ff4f6e5214f126$var$T = 4;
    null === $f5ff4f6e5214f126$var$R || 0 === ($f5ff4f6e5214f126$var$hh & 268435455) && 0 === ($f5ff4f6e5214f126$var$rk & 268435455) || $f5ff4f6e5214f126$var$Dk($f5ff4f6e5214f126$var$R, $f5ff4f6e5214f126$var$Z);
}
function $f5ff4f6e5214f126$var$Jk(a, b) {
    var c = $f5ff4f6e5214f126$var$K;
    $f5ff4f6e5214f126$var$K |= 2;
    var d = $f5ff4f6e5214f126$var$Kk();
    if ($f5ff4f6e5214f126$var$R !== a || $f5ff4f6e5214f126$var$Z !== b) $f5ff4f6e5214f126$var$vk = null, $f5ff4f6e5214f126$var$Lk(a, b);
    for(;;)try {
        $f5ff4f6e5214f126$var$Uk();
        break;
    } catch (e) {
        $f5ff4f6e5214f126$var$Nk(a, e);
    }
    $f5ff4f6e5214f126$var$Qg();
    $f5ff4f6e5214f126$var$K = c;
    $f5ff4f6e5214f126$var$nk.current = d;
    if (null !== $f5ff4f6e5214f126$var$Y) throw Error($f5ff4f6e5214f126$var$p(261));
    $f5ff4f6e5214f126$var$R = null;
    $f5ff4f6e5214f126$var$Z = 0;
    return $f5ff4f6e5214f126$var$T;
}
function $f5ff4f6e5214f126$var$Uk() {
    for(; null !== $f5ff4f6e5214f126$var$Y;)$f5ff4f6e5214f126$var$Vk($f5ff4f6e5214f126$var$Y);
}
function $f5ff4f6e5214f126$var$Mk() {
    for(; null !== $f5ff4f6e5214f126$var$Y && !$f5ff4f6e5214f126$var$cc();)$f5ff4f6e5214f126$var$Vk($f5ff4f6e5214f126$var$Y);
}
function $f5ff4f6e5214f126$var$Vk(a) {
    var b = $f5ff4f6e5214f126$var$Wk(a.alternate, a, $f5ff4f6e5214f126$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f5ff4f6e5214f126$var$Tk(a) : $f5ff4f6e5214f126$var$Y = b;
    $f5ff4f6e5214f126$var$ok.current = null;
}
function $f5ff4f6e5214f126$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f5ff4f6e5214f126$var$Fj(c, b, $f5ff4f6e5214f126$var$gj), null !== c) {
                $f5ff4f6e5214f126$var$Y = c;
                return;
            }
        } else {
            c = $f5ff4f6e5214f126$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f5ff4f6e5214f126$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f5ff4f6e5214f126$var$T = 6;
                $f5ff4f6e5214f126$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f5ff4f6e5214f126$var$Y = b;
            return;
        }
        $f5ff4f6e5214f126$var$Y = b = a;
    }while (null !== b);
    0 === $f5ff4f6e5214f126$var$T && ($f5ff4f6e5214f126$var$T = 5);
}
function $f5ff4f6e5214f126$var$Qk(a, b, c) {
    var d = $f5ff4f6e5214f126$var$C, e = $f5ff4f6e5214f126$var$pk.transition;
    try {
        $f5ff4f6e5214f126$var$pk.transition = null, $f5ff4f6e5214f126$var$C = 1, $f5ff4f6e5214f126$var$Xk(a, b, c, d);
    } finally{
        $f5ff4f6e5214f126$var$pk.transition = e, $f5ff4f6e5214f126$var$C = d;
    }
    return null;
}
function $f5ff4f6e5214f126$var$Xk(a, b, c, d) {
    do $f5ff4f6e5214f126$var$Ik();
    while (null !== $f5ff4f6e5214f126$var$xk);
    if (0 !== ($f5ff4f6e5214f126$var$K & 6)) throw Error($f5ff4f6e5214f126$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f5ff4f6e5214f126$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f5ff4f6e5214f126$var$Bc(a, f);
    a === $f5ff4f6e5214f126$var$R && ($f5ff4f6e5214f126$var$Y = $f5ff4f6e5214f126$var$R = null, $f5ff4f6e5214f126$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f5ff4f6e5214f126$var$wk || ($f5ff4f6e5214f126$var$wk = !0, $f5ff4f6e5214f126$var$Gk($f5ff4f6e5214f126$var$hc, function() {
        $f5ff4f6e5214f126$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f5ff4f6e5214f126$var$pk.transition;
        $f5ff4f6e5214f126$var$pk.transition = null;
        var g = $f5ff4f6e5214f126$var$C;
        $f5ff4f6e5214f126$var$C = 1;
        var h = $f5ff4f6e5214f126$var$K;
        $f5ff4f6e5214f126$var$K |= 4;
        $f5ff4f6e5214f126$var$ok.current = null;
        $f5ff4f6e5214f126$var$Pj(a, c);
        $f5ff4f6e5214f126$var$ek(c, a);
        $f5ff4f6e5214f126$var$Oe($f5ff4f6e5214f126$var$Df);
        $f5ff4f6e5214f126$var$dd = !!$f5ff4f6e5214f126$var$Cf;
        $f5ff4f6e5214f126$var$Df = $f5ff4f6e5214f126$var$Cf = null;
        a.current = c;
        $f5ff4f6e5214f126$var$ik(c, a, e);
        $f5ff4f6e5214f126$var$dc();
        $f5ff4f6e5214f126$var$K = h;
        $f5ff4f6e5214f126$var$C = g;
        $f5ff4f6e5214f126$var$pk.transition = f;
    } else a.current = c;
    $f5ff4f6e5214f126$var$wk && ($f5ff4f6e5214f126$var$wk = !1, $f5ff4f6e5214f126$var$xk = a, $f5ff4f6e5214f126$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($f5ff4f6e5214f126$var$Si = null);
    $f5ff4f6e5214f126$var$mc(c.stateNode, d);
    $f5ff4f6e5214f126$var$Ek(a, $f5ff4f6e5214f126$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f5ff4f6e5214f126$var$Pi) throw $f5ff4f6e5214f126$var$Pi = !1, a = $f5ff4f6e5214f126$var$Qi, $f5ff4f6e5214f126$var$Qi = null, a;
    0 !== ($f5ff4f6e5214f126$var$yk & 1) && 0 !== a.tag && $f5ff4f6e5214f126$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f5ff4f6e5214f126$var$Ak ? $f5ff4f6e5214f126$var$zk++ : ($f5ff4f6e5214f126$var$zk = 0, $f5ff4f6e5214f126$var$Ak = a) : $f5ff4f6e5214f126$var$zk = 0;
    $f5ff4f6e5214f126$var$jg();
    return null;
}
function $f5ff4f6e5214f126$var$Ik() {
    if (null !== $f5ff4f6e5214f126$var$xk) {
        var a = $f5ff4f6e5214f126$var$Dc($f5ff4f6e5214f126$var$yk), b = $f5ff4f6e5214f126$var$pk.transition, c = $f5ff4f6e5214f126$var$C;
        try {
            $f5ff4f6e5214f126$var$pk.transition = null;
            $f5ff4f6e5214f126$var$C = 16 > a ? 16 : a;
            if (null === $f5ff4f6e5214f126$var$xk) var d = !1;
            else {
                a = $f5ff4f6e5214f126$var$xk;
                $f5ff4f6e5214f126$var$xk = null;
                $f5ff4f6e5214f126$var$yk = 0;
                if (0 !== ($f5ff4f6e5214f126$var$K & 6)) throw Error($f5ff4f6e5214f126$var$p(331));
                var e = $f5ff4f6e5214f126$var$K;
                $f5ff4f6e5214f126$var$K |= 4;
                for($f5ff4f6e5214f126$var$V = a.current; null !== $f5ff4f6e5214f126$var$V;){
                    var f = $f5ff4f6e5214f126$var$V, g = f.child;
                    if (0 !== ($f5ff4f6e5214f126$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f5ff4f6e5214f126$var$V = l; null !== $f5ff4f6e5214f126$var$V;){
                                    var m = $f5ff4f6e5214f126$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f5ff4f6e5214f126$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f5ff4f6e5214f126$var$V = q;
                                    else for(; null !== $f5ff4f6e5214f126$var$V;){
                                        m = $f5ff4f6e5214f126$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f5ff4f6e5214f126$var$Tj(m);
                                        if (m === l) {
                                            $f5ff4f6e5214f126$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f5ff4f6e5214f126$var$V = r;
                                            break;
                                        }
                                        $f5ff4f6e5214f126$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f5ff4f6e5214f126$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f5ff4f6e5214f126$var$V = g;
                    else b: for(; null !== $f5ff4f6e5214f126$var$V;){
                        f = $f5ff4f6e5214f126$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f5ff4f6e5214f126$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f5ff4f6e5214f126$var$V = x;
                            break b;
                        }
                        $f5ff4f6e5214f126$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f5ff4f6e5214f126$var$V = w; null !== $f5ff4f6e5214f126$var$V;){
                    g = $f5ff4f6e5214f126$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f5ff4f6e5214f126$var$V = u;
                    else b: for(g = w; null !== $f5ff4f6e5214f126$var$V;){
                        h = $f5ff4f6e5214f126$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f5ff4f6e5214f126$var$Rj(9, h);
                            }
                        } catch (na) {
                            $f5ff4f6e5214f126$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f5ff4f6e5214f126$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f5ff4f6e5214f126$var$V = F;
                            break b;
                        }
                        $f5ff4f6e5214f126$var$V = h.return;
                    }
                }
                $f5ff4f6e5214f126$var$K = e;
                $f5ff4f6e5214f126$var$jg();
                if ($f5ff4f6e5214f126$var$lc && "function" === typeof $f5ff4f6e5214f126$var$lc.onPostCommitFiberRoot) try {
                    $f5ff4f6e5214f126$var$lc.onPostCommitFiberRoot($f5ff4f6e5214f126$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f5ff4f6e5214f126$var$C = c, $f5ff4f6e5214f126$var$pk.transition = b;
        }
    }
    return !1;
}
function $f5ff4f6e5214f126$var$Yk(a, b, c) {
    b = $f5ff4f6e5214f126$var$Ki(c, b);
    b = $f5ff4f6e5214f126$var$Oi(a, b, 1);
    a = $f5ff4f6e5214f126$var$dh(a, b, 1);
    b = $f5ff4f6e5214f126$var$L();
    null !== a && ($f5ff4f6e5214f126$var$Ac(a, 1, b), $f5ff4f6e5214f126$var$Ek(a, b));
}
function $f5ff4f6e5214f126$var$W(a, b, c) {
    if (3 === a.tag) $f5ff4f6e5214f126$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f5ff4f6e5214f126$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f5ff4f6e5214f126$var$Si || !$f5ff4f6e5214f126$var$Si.has(d))) {
                a = $f5ff4f6e5214f126$var$Ki(c, a);
                a = $f5ff4f6e5214f126$var$Ri(b, a, 1);
                b = $f5ff4f6e5214f126$var$dh(b, a, 1);
                a = $f5ff4f6e5214f126$var$L();
                null !== b && ($f5ff4f6e5214f126$var$Ac(b, 1, a), $f5ff4f6e5214f126$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f5ff4f6e5214f126$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f5ff4f6e5214f126$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $f5ff4f6e5214f126$var$R === a && ($f5ff4f6e5214f126$var$Z & c) === c && (4 === $f5ff4f6e5214f126$var$T || 3 === $f5ff4f6e5214f126$var$T && ($f5ff4f6e5214f126$var$Z & 130023424) === $f5ff4f6e5214f126$var$Z && 500 > $f5ff4f6e5214f126$var$B() - $f5ff4f6e5214f126$var$gk ? $f5ff4f6e5214f126$var$Lk(a, 0) : $f5ff4f6e5214f126$var$sk |= c);
    $f5ff4f6e5214f126$var$Ek(a, b);
}
function $f5ff4f6e5214f126$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f5ff4f6e5214f126$var$sc, $f5ff4f6e5214f126$var$sc <<= 1, 0 === ($f5ff4f6e5214f126$var$sc & 130023424) && ($f5ff4f6e5214f126$var$sc = 4194304)));
    var c = $f5ff4f6e5214f126$var$L();
    a = $f5ff4f6e5214f126$var$Zg(a, b);
    null !== a && ($f5ff4f6e5214f126$var$Ac(a, b, c), $f5ff4f6e5214f126$var$Ek(a, c));
}
function $f5ff4f6e5214f126$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f5ff4f6e5214f126$var$Zk(a, c);
}
function $f5ff4f6e5214f126$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f5ff4f6e5214f126$var$p(314));
    }
    null !== d && d.delete(b);
    $f5ff4f6e5214f126$var$Zk(a, c);
}
var $f5ff4f6e5214f126$var$Wk;
$f5ff4f6e5214f126$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f5ff4f6e5214f126$var$Wf.current) $f5ff4f6e5214f126$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f5ff4f6e5214f126$var$Ug = !1, $f5ff4f6e5214f126$var$zj(a, b, c);
            $f5ff4f6e5214f126$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f5ff4f6e5214f126$var$Ug = !1, $f5ff4f6e5214f126$var$I && 0 !== (b.flags & 1048576) && $f5ff4f6e5214f126$var$ug(b, $f5ff4f6e5214f126$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f5ff4f6e5214f126$var$jj(a, b);
            a = b.pendingProps;
            var e = $f5ff4f6e5214f126$var$Yf(b, $f5ff4f6e5214f126$var$H.current);
            $f5ff4f6e5214f126$var$Tg(b, c);
            e = $f5ff4f6e5214f126$var$Xh(null, b, d, a, e, c);
            var f = $f5ff4f6e5214f126$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f5ff4f6e5214f126$var$Zf(d) ? (f = !0, $f5ff4f6e5214f126$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f5ff4f6e5214f126$var$ah(b), e.updater = $f5ff4f6e5214f126$var$nh, b.stateNode = e, e._reactInternals = b, $f5ff4f6e5214f126$var$rh(b, d, a, c), b = $f5ff4f6e5214f126$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $f5ff4f6e5214f126$var$I && f && $f5ff4f6e5214f126$var$vg(b), $f5ff4f6e5214f126$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f5ff4f6e5214f126$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f5ff4f6e5214f126$var$$k(d);
                a = $f5ff4f6e5214f126$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $f5ff4f6e5214f126$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f5ff4f6e5214f126$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f5ff4f6e5214f126$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f5ff4f6e5214f126$var$aj(null, b, d, $f5ff4f6e5214f126$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($f5ff4f6e5214f126$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f5ff4f6e5214f126$var$Lg(d, e), $f5ff4f6e5214f126$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f5ff4f6e5214f126$var$Lg(d, e), $f5ff4f6e5214f126$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $f5ff4f6e5214f126$var$lj(b);
                if (null === a) throw Error($f5ff4f6e5214f126$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f5ff4f6e5214f126$var$bh(a, b);
                $f5ff4f6e5214f126$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f5ff4f6e5214f126$var$Ki(Error($f5ff4f6e5214f126$var$p(423)), b);
                        b = $f5ff4f6e5214f126$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f5ff4f6e5214f126$var$Ki(Error($f5ff4f6e5214f126$var$p(424)), b);
                        b = $f5ff4f6e5214f126$var$mj(a, b, d, c, e);
                        break a;
                    } else for($f5ff4f6e5214f126$var$yg = $f5ff4f6e5214f126$var$Lf(b.stateNode.containerInfo.firstChild), $f5ff4f6e5214f126$var$xg = b, $f5ff4f6e5214f126$var$I = !0, $f5ff4f6e5214f126$var$zg = null, c = $f5ff4f6e5214f126$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f5ff4f6e5214f126$var$Ig();
                    if (d === e) {
                        b = $f5ff4f6e5214f126$var$$i(a, b, c);
                        break a;
                    }
                    $f5ff4f6e5214f126$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f5ff4f6e5214f126$var$Kh(b), null === a && $f5ff4f6e5214f126$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f5ff4f6e5214f126$var$Ef(d, e) ? g = null : null !== f && $f5ff4f6e5214f126$var$Ef(d, f) && (b.flags |= 32), $f5ff4f6e5214f126$var$hj(a, b), $f5ff4f6e5214f126$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $f5ff4f6e5214f126$var$Eg(b), null;
        case 13:
            return $f5ff4f6e5214f126$var$pj(a, b, c);
        case 4:
            return $f5ff4f6e5214f126$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f5ff4f6e5214f126$var$Bh(b, null, d, c) : $f5ff4f6e5214f126$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f5ff4f6e5214f126$var$Lg(d, e), $f5ff4f6e5214f126$var$Zi(a, b, d, e, c);
        case 7:
            return $f5ff4f6e5214f126$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f5ff4f6e5214f126$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f5ff4f6e5214f126$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f5ff4f6e5214f126$var$G($f5ff4f6e5214f126$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f5ff4f6e5214f126$var$He(f.value, g)) {
                        if (f.children === e.children && !$f5ff4f6e5214f126$var$Wf.current) {
                            b = $f5ff4f6e5214f126$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f5ff4f6e5214f126$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f5ff4f6e5214f126$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f5ff4f6e5214f126$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f5ff4f6e5214f126$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f5ff4f6e5214f126$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f5ff4f6e5214f126$var$Tg(b, c), e = $f5ff4f6e5214f126$var$Vg(e), d = d(e), b.flags |= 1, $f5ff4f6e5214f126$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f5ff4f6e5214f126$var$Lg(d, b.pendingProps), e = $f5ff4f6e5214f126$var$Lg(d.type, e), $f5ff4f6e5214f126$var$aj(a, b, d, e, c);
        case 15:
            return $f5ff4f6e5214f126$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f5ff4f6e5214f126$var$Lg(d, e), $f5ff4f6e5214f126$var$jj(a, b), b.tag = 1, $f5ff4f6e5214f126$var$Zf(d) ? (a = !0, $f5ff4f6e5214f126$var$cg(b)) : a = !1, $f5ff4f6e5214f126$var$Tg(b, c), $f5ff4f6e5214f126$var$ph(b, d, e), $f5ff4f6e5214f126$var$rh(b, d, e, c), $f5ff4f6e5214f126$var$kj(null, b, d, !0, a, c);
        case 19:
            return $f5ff4f6e5214f126$var$yj(a, b, c);
        case 22:
            return $f5ff4f6e5214f126$var$ej(a, b, c);
    }
    throw Error($f5ff4f6e5214f126$var$p(156, b.tag));
};
function $f5ff4f6e5214f126$var$Gk(a, b) {
    return $f5ff4f6e5214f126$var$ac(a, b);
}
function $f5ff4f6e5214f126$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f5ff4f6e5214f126$var$Bg(a, b, c, d) {
    return new $f5ff4f6e5214f126$var$al(a, b, c, d);
}
function $f5ff4f6e5214f126$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f5ff4f6e5214f126$var$$k(a) {
    if ("function" === typeof a) return $f5ff4f6e5214f126$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f5ff4f6e5214f126$var$Da) return 11;
        if (a === $f5ff4f6e5214f126$var$Ga) return 14;
    }
    return 2;
}
function $f5ff4f6e5214f126$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $f5ff4f6e5214f126$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f5ff4f6e5214f126$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f5ff4f6e5214f126$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f5ff4f6e5214f126$var$ya:
            return $f5ff4f6e5214f126$var$Ah(c.children, e, f, b);
        case $f5ff4f6e5214f126$var$za:
            g = 8;
            e |= 8;
            break;
        case $f5ff4f6e5214f126$var$Aa:
            return a = $f5ff4f6e5214f126$var$Bg(12, c, b, e | 2), a.elementType = $f5ff4f6e5214f126$var$Aa, a.lanes = f, a;
        case $f5ff4f6e5214f126$var$Ea:
            return a = $f5ff4f6e5214f126$var$Bg(13, c, b, e), a.elementType = $f5ff4f6e5214f126$var$Ea, a.lanes = f, a;
        case $f5ff4f6e5214f126$var$Fa:
            return a = $f5ff4f6e5214f126$var$Bg(19, c, b, e), a.elementType = $f5ff4f6e5214f126$var$Fa, a.lanes = f, a;
        case $f5ff4f6e5214f126$var$Ia:
            return $f5ff4f6e5214f126$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f5ff4f6e5214f126$var$Ba:
                    g = 10;
                    break a;
                case $f5ff4f6e5214f126$var$Ca:
                    g = 9;
                    break a;
                case $f5ff4f6e5214f126$var$Da:
                    g = 11;
                    break a;
                case $f5ff4f6e5214f126$var$Ga:
                    g = 14;
                    break a;
                case $f5ff4f6e5214f126$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f5ff4f6e5214f126$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f5ff4f6e5214f126$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f5ff4f6e5214f126$var$Ah(a, b, c, d) {
    a = $f5ff4f6e5214f126$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f5ff4f6e5214f126$var$qj(a, b, c, d) {
    a = $f5ff4f6e5214f126$var$Bg(22, a, d, b);
    a.elementType = $f5ff4f6e5214f126$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f5ff4f6e5214f126$var$xh(a, b, c) {
    a = $f5ff4f6e5214f126$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f5ff4f6e5214f126$var$zh(a, b, c) {
    b = $f5ff4f6e5214f126$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f5ff4f6e5214f126$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f5ff4f6e5214f126$var$zc(0);
    this.expirationTimes = $f5ff4f6e5214f126$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f5ff4f6e5214f126$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f5ff4f6e5214f126$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $f5ff4f6e5214f126$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f5ff4f6e5214f126$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f5ff4f6e5214f126$var$ah(f);
    return a;
}
function $f5ff4f6e5214f126$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f5ff4f6e5214f126$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f5ff4f6e5214f126$var$el(a) {
    if (!a) return $f5ff4f6e5214f126$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f5ff4f6e5214f126$var$Vb(a) !== a || 1 !== a.tag) throw Error($f5ff4f6e5214f126$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f5ff4f6e5214f126$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f5ff4f6e5214f126$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f5ff4f6e5214f126$var$Zf(c)) return $f5ff4f6e5214f126$var$bg(a, c, b);
    }
    return b;
}
function $f5ff4f6e5214f126$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $f5ff4f6e5214f126$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $f5ff4f6e5214f126$var$el(null);
    c = a.current;
    d = $f5ff4f6e5214f126$var$L();
    e = $f5ff4f6e5214f126$var$lh(c);
    f = $f5ff4f6e5214f126$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f5ff4f6e5214f126$var$dh(c, f, e);
    a.current.lanes = e;
    $f5ff4f6e5214f126$var$Ac(a, e, d);
    $f5ff4f6e5214f126$var$Ek(a, d);
    return a;
}
function $f5ff4f6e5214f126$var$gl(a, b, c, d) {
    var e = b.current, f = $f5ff4f6e5214f126$var$L(), g = $f5ff4f6e5214f126$var$lh(e);
    c = $f5ff4f6e5214f126$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f5ff4f6e5214f126$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f5ff4f6e5214f126$var$dh(e, b, g);
    null !== a && ($f5ff4f6e5214f126$var$mh(a, e, g, f), $f5ff4f6e5214f126$var$eh(a, e, g));
    return g;
}
function $f5ff4f6e5214f126$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f5ff4f6e5214f126$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f5ff4f6e5214f126$var$jl(a, b) {
    $f5ff4f6e5214f126$var$il(a, b);
    (a = a.alternate) && $f5ff4f6e5214f126$var$il(a, b);
}
function $f5ff4f6e5214f126$var$kl() {
    return null;
}
var $f5ff4f6e5214f126$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f5ff4f6e5214f126$var$ml(a) {
    this._internalRoot = a;
}
$f5ff4f6e5214f126$var$nl.prototype.render = $f5ff4f6e5214f126$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f5ff4f6e5214f126$var$p(409));
    $f5ff4f6e5214f126$var$gl(a, b, null, null);
};
$f5ff4f6e5214f126$var$nl.prototype.unmount = $f5ff4f6e5214f126$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f5ff4f6e5214f126$var$Sk(function() {
            $f5ff4f6e5214f126$var$gl(null, a, null, null);
        });
        b[$f5ff4f6e5214f126$var$uf] = null;
    }
};
function $f5ff4f6e5214f126$var$nl(a) {
    this._internalRoot = a;
}
$f5ff4f6e5214f126$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f5ff4f6e5214f126$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f5ff4f6e5214f126$var$Qc.length && 0 !== b && b < $f5ff4f6e5214f126$var$Qc[c].priority; c++);
        $f5ff4f6e5214f126$var$Qc.splice(c, 0, a);
        0 === c && $f5ff4f6e5214f126$var$Vc(a);
    }
};
function $f5ff4f6e5214f126$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f5ff4f6e5214f126$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f5ff4f6e5214f126$var$ql() {}
function $f5ff4f6e5214f126$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f5ff4f6e5214f126$var$hl(g);
                f.call(a);
            };
        }
        var g = $f5ff4f6e5214f126$var$fl(b, d, a, 0, null, !1, !1, "", $f5ff4f6e5214f126$var$ql);
        a._reactRootContainer = g;
        a[$f5ff4f6e5214f126$var$uf] = g.current;
        $f5ff4f6e5214f126$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f5ff4f6e5214f126$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f5ff4f6e5214f126$var$hl(k);
            h.call(a);
        };
    }
    var k = $f5ff4f6e5214f126$var$cl(a, 0, !1, null, null, !1, !1, "", $f5ff4f6e5214f126$var$ql);
    a._reactRootContainer = k;
    a[$f5ff4f6e5214f126$var$uf] = k.current;
    $f5ff4f6e5214f126$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f5ff4f6e5214f126$var$Sk(function() {
        $f5ff4f6e5214f126$var$gl(b, k, c, d);
    });
    return k;
}
function $f5ff4f6e5214f126$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f5ff4f6e5214f126$var$hl(g);
                h.call(a);
            };
        }
        $f5ff4f6e5214f126$var$gl(b, g, a, e);
    } else g = $f5ff4f6e5214f126$var$rl(c, b, a, e, d);
    return $f5ff4f6e5214f126$var$hl(g);
}
$f5ff4f6e5214f126$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f5ff4f6e5214f126$var$tc(b.pendingLanes);
                0 !== c && ($f5ff4f6e5214f126$var$Cc(b, c | 1), $f5ff4f6e5214f126$var$Ek(b, $f5ff4f6e5214f126$var$B()), 0 === ($f5ff4f6e5214f126$var$K & 6) && ($f5ff4f6e5214f126$var$Hj = $f5ff4f6e5214f126$var$B() + 500, $f5ff4f6e5214f126$var$jg()));
            }
            break;
        case 13:
            $f5ff4f6e5214f126$var$Sk(function() {
                var b = $f5ff4f6e5214f126$var$Zg(a, 1);
                if (null !== b) {
                    var c = $f5ff4f6e5214f126$var$L();
                    $f5ff4f6e5214f126$var$mh(b, a, 1, c);
                }
            }), $f5ff4f6e5214f126$var$jl(a, 1);
    }
};
$f5ff4f6e5214f126$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f5ff4f6e5214f126$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $f5ff4f6e5214f126$var$L();
            $f5ff4f6e5214f126$var$mh(b, a, 134217728, c);
        }
        $f5ff4f6e5214f126$var$jl(a, 134217728);
    }
};
$f5ff4f6e5214f126$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f5ff4f6e5214f126$var$lh(a), c = $f5ff4f6e5214f126$var$Zg(a, b);
        if (null !== c) {
            var d = $f5ff4f6e5214f126$var$L();
            $f5ff4f6e5214f126$var$mh(c, a, b, d);
        }
        $f5ff4f6e5214f126$var$jl(a, b);
    }
};
$f5ff4f6e5214f126$var$Hc = function() {
    return $f5ff4f6e5214f126$var$C;
};
$f5ff4f6e5214f126$var$Ic = function(a, b) {
    var c = $f5ff4f6e5214f126$var$C;
    try {
        return $f5ff4f6e5214f126$var$C = a, b();
    } finally{
        $f5ff4f6e5214f126$var$C = c;
    }
};
$f5ff4f6e5214f126$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f5ff4f6e5214f126$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f5ff4f6e5214f126$var$Db(d);
                        if (!e) throw Error($f5ff4f6e5214f126$var$p(90));
                        $f5ff4f6e5214f126$var$Wa(d);
                        $f5ff4f6e5214f126$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f5ff4f6e5214f126$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f5ff4f6e5214f126$var$fb(a, !!c.multiple, b, !1);
    }
};
$f5ff4f6e5214f126$var$Gb = $f5ff4f6e5214f126$var$Rk;
$f5ff4f6e5214f126$var$Hb = $f5ff4f6e5214f126$var$Sk;
var $f5ff4f6e5214f126$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $f5ff4f6e5214f126$var$Cb,
        $f5ff4f6e5214f126$var$ue,
        $f5ff4f6e5214f126$var$Db,
        $f5ff4f6e5214f126$var$Eb,
        $f5ff4f6e5214f126$var$Fb,
        $f5ff4f6e5214f126$var$Rk
    ]
}, $f5ff4f6e5214f126$var$ul = {
    findFiberByHostInstance: $f5ff4f6e5214f126$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $f5ff4f6e5214f126$var$vl = {
    bundleType: $f5ff4f6e5214f126$var$ul.bundleType,
    version: $f5ff4f6e5214f126$var$ul.version,
    rendererPackageName: $f5ff4f6e5214f126$var$ul.rendererPackageName,
    rendererConfig: $f5ff4f6e5214f126$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f5ff4f6e5214f126$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f5ff4f6e5214f126$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f5ff4f6e5214f126$var$ul.findFiberByHostInstance || $f5ff4f6e5214f126$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f5ff4f6e5214f126$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f5ff4f6e5214f126$var$wl.isDisabled && $f5ff4f6e5214f126$var$wl.supportsFiber) try {
        $f5ff4f6e5214f126$var$kc = $f5ff4f6e5214f126$var$wl.inject($f5ff4f6e5214f126$var$vl), $f5ff4f6e5214f126$var$lc = $f5ff4f6e5214f126$var$wl;
    } catch (a) {}
}
$f5ff4f6e5214f126$export$ae55be85d98224ed = $f5ff4f6e5214f126$var$tl;
$f5ff4f6e5214f126$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f5ff4f6e5214f126$var$ol(b)) throw Error($f5ff4f6e5214f126$var$p(200));
    return $f5ff4f6e5214f126$var$dl(a, b, null, c);
};
$f5ff4f6e5214f126$export$882461b6382ed46c = function(a, b) {
    if (!$f5ff4f6e5214f126$var$ol(a)) throw Error($f5ff4f6e5214f126$var$p(299));
    var c = !1, d = "", e = $f5ff4f6e5214f126$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f5ff4f6e5214f126$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$f5ff4f6e5214f126$var$uf] = b.current;
    $f5ff4f6e5214f126$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f5ff4f6e5214f126$var$ml(b);
};
$f5ff4f6e5214f126$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f5ff4f6e5214f126$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f5ff4f6e5214f126$var$p(268, a));
    }
    a = $f5ff4f6e5214f126$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f5ff4f6e5214f126$export$cd75ccfd720a3cd4 = function(a) {
    return $f5ff4f6e5214f126$var$Sk(a);
};
$f5ff4f6e5214f126$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f5ff4f6e5214f126$var$pl(b)) throw Error($f5ff4f6e5214f126$var$p(200));
    return $f5ff4f6e5214f126$var$sl(null, a, b, !0, c);
};
$f5ff4f6e5214f126$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f5ff4f6e5214f126$var$ol(a)) throw Error($f5ff4f6e5214f126$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f5ff4f6e5214f126$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f5ff4f6e5214f126$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f5ff4f6e5214f126$var$uf] = b.current;
    $f5ff4f6e5214f126$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f5ff4f6e5214f126$var$nl(b);
};
$f5ff4f6e5214f126$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f5ff4f6e5214f126$var$pl(b)) throw Error($f5ff4f6e5214f126$var$p(200));
    return $f5ff4f6e5214f126$var$sl(null, a, b, !1, c);
};
$f5ff4f6e5214f126$export$502457920280e6be = function(a) {
    if (!$f5ff4f6e5214f126$var$pl(a)) throw Error($f5ff4f6e5214f126$var$p(40));
    return a._reactRootContainer ? ($f5ff4f6e5214f126$var$Sk(function() {
        $f5ff4f6e5214f126$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f5ff4f6e5214f126$var$uf] = null;
        });
    }), !0) : !1;
};
$f5ff4f6e5214f126$export$c78a37762a8d58e1 = $f5ff4f6e5214f126$var$Rk;
$f5ff4f6e5214f126$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f5ff4f6e5214f126$var$pl(c)) throw Error($f5ff4f6e5214f126$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f5ff4f6e5214f126$var$p(38));
    return $f5ff4f6e5214f126$var$sl(a, b, c, !1, d);
};
$f5ff4f6e5214f126$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7FBhF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7CGxa"));

});
parcelRegister("7CGxa", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $58cd135ddf7e3587$export$c4744153514ff05d; }, function (v) { return $58cd135ddf7e3587$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $58cd135ddf7e3587$export$3e506c1ccc9cc1a7; }, function (v) { return $58cd135ddf7e3587$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $58cd135ddf7e3587$export$e26fe2ed2fa76875; }, function (v) { return $58cd135ddf7e3587$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $58cd135ddf7e3587$export$502329bbf4b505b1; }, function (v) { return $58cd135ddf7e3587$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $58cd135ddf7e3587$export$6e3807111c4874c4; }, function (v) { return $58cd135ddf7e3587$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $58cd135ddf7e3587$export$c27134553091fb3a; }, function (v) { return $58cd135ddf7e3587$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $58cd135ddf7e3587$export$33ee1acdc04fd2a2; }, function (v) { return $58cd135ddf7e3587$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $58cd135ddf7e3587$export$b00a404bbd5edef2; }, function (v) { return $58cd135ddf7e3587$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $58cd135ddf7e3587$export$8352ce38b91d0c62; }, function (v) { return $58cd135ddf7e3587$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $58cd135ddf7e3587$export$d66a1c1c77bd778b; }, function (v) { return $58cd135ddf7e3587$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $58cd135ddf7e3587$export$d3dfb8e4810cb555; }, function (v) { return $58cd135ddf7e3587$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $58cd135ddf7e3587$export$839f9183b0465a69; }, function (v) { return $58cd135ddf7e3587$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $58cd135ddf7e3587$export$72fdf0e06517287b; }, function (v) { return $58cd135ddf7e3587$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $58cd135ddf7e3587$export$4b844e58a3e414b4; }, function (v) { return $58cd135ddf7e3587$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $58cd135ddf7e3587$export$816d2913ae6b83b1; }, function (v) { return $58cd135ddf7e3587$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $58cd135ddf7e3587$export$61bcfe829111a1d0; }, function (v) { return $58cd135ddf7e3587$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $58cd135ddf7e3587$export$7ee8c9beb337bc3f; }, function (v) { return $58cd135ddf7e3587$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $58cd135ddf7e3587$export$b5836b71941fa3ed; }, function (v) { return $58cd135ddf7e3587$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $58cd135ddf7e3587$export$cf845f2c119da08a; }, function (v) { return $58cd135ddf7e3587$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $58cd135ddf7e3587$export$c4744153514ff05d;
var $58cd135ddf7e3587$export$3e506c1ccc9cc1a7;
var $58cd135ddf7e3587$export$e26fe2ed2fa76875;
var $58cd135ddf7e3587$export$502329bbf4b505b1;
var $58cd135ddf7e3587$export$6e3807111c4874c4;
var $58cd135ddf7e3587$export$c27134553091fb3a;
var $58cd135ddf7e3587$export$33ee1acdc04fd2a2;
var $58cd135ddf7e3587$export$b00a404bbd5edef2;
var $58cd135ddf7e3587$export$8352ce38b91d0c62;
var $58cd135ddf7e3587$export$d66a1c1c77bd778b;
var $58cd135ddf7e3587$export$d3dfb8e4810cb555;
var $58cd135ddf7e3587$export$839f9183b0465a69;
var $58cd135ddf7e3587$export$72fdf0e06517287b;
var $58cd135ddf7e3587$export$4b844e58a3e414b4;
var $58cd135ddf7e3587$export$816d2913ae6b83b1;
var $58cd135ddf7e3587$export$61bcfe829111a1d0;
var $58cd135ddf7e3587$export$7ee8c9beb337bc3f;
var $58cd135ddf7e3587$export$b5836b71941fa3ed;
var $58cd135ddf7e3587$export$cf845f2c119da08a;
"use strict";
function $58cd135ddf7e3587$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $58cd135ddf7e3587$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $58cd135ddf7e3587$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $58cd135ddf7e3587$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $58cd135ddf7e3587$var$g(C, c)) n < e && 0 > $58cd135ddf7e3587$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $58cd135ddf7e3587$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $58cd135ddf7e3587$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $58cd135ddf7e3587$var$l = performance;
    $58cd135ddf7e3587$export$c4744153514ff05d = function() {
        return $58cd135ddf7e3587$var$l.now();
    };
} else {
    var $58cd135ddf7e3587$var$p = Date, $58cd135ddf7e3587$var$q = $58cd135ddf7e3587$var$p.now();
    $58cd135ddf7e3587$export$c4744153514ff05d = function() {
        return $58cd135ddf7e3587$var$p.now() - $58cd135ddf7e3587$var$q;
    };
}
var $58cd135ddf7e3587$var$r = [], $58cd135ddf7e3587$var$t = [], $58cd135ddf7e3587$var$u = 1, $58cd135ddf7e3587$var$v = null, $58cd135ddf7e3587$var$y = 3, $58cd135ddf7e3587$var$z = !1, $58cd135ddf7e3587$var$A = !1, $58cd135ddf7e3587$var$B = !1, $58cd135ddf7e3587$var$D = "function" === typeof setTimeout ? setTimeout : null, $58cd135ddf7e3587$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $58cd135ddf7e3587$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $58cd135ddf7e3587$var$G(a) {
    for(var b = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$t); null !== b;){
        if (null === b.callback) $58cd135ddf7e3587$var$k($58cd135ddf7e3587$var$t);
        else if (b.startTime <= a) $58cd135ddf7e3587$var$k($58cd135ddf7e3587$var$t), b.sortIndex = b.expirationTime, $58cd135ddf7e3587$var$f($58cd135ddf7e3587$var$r, b);
        else break;
        b = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$t);
    }
}
function $58cd135ddf7e3587$var$H(a) {
    $58cd135ddf7e3587$var$B = !1;
    $58cd135ddf7e3587$var$G(a);
    if (!$58cd135ddf7e3587$var$A) {
        if (null !== $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r)) $58cd135ddf7e3587$var$A = !0, $58cd135ddf7e3587$var$I($58cd135ddf7e3587$var$J);
        else {
            var b = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$t);
            null !== b && $58cd135ddf7e3587$var$K($58cd135ddf7e3587$var$H, b.startTime - a);
        }
    }
}
function $58cd135ddf7e3587$var$J(a, b) {
    $58cd135ddf7e3587$var$A = !1;
    $58cd135ddf7e3587$var$B && ($58cd135ddf7e3587$var$B = !1, $58cd135ddf7e3587$var$E($58cd135ddf7e3587$var$L), $58cd135ddf7e3587$var$L = -1);
    $58cd135ddf7e3587$var$z = !0;
    var c = $58cd135ddf7e3587$var$y;
    try {
        $58cd135ddf7e3587$var$G(b);
        for($58cd135ddf7e3587$var$v = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r); null !== $58cd135ddf7e3587$var$v && (!($58cd135ddf7e3587$var$v.expirationTime > b) || a && !$58cd135ddf7e3587$var$M());){
            var d = $58cd135ddf7e3587$var$v.callback;
            if ("function" === typeof d) {
                $58cd135ddf7e3587$var$v.callback = null;
                $58cd135ddf7e3587$var$y = $58cd135ddf7e3587$var$v.priorityLevel;
                var e = d($58cd135ddf7e3587$var$v.expirationTime <= b);
                b = $58cd135ddf7e3587$export$c4744153514ff05d();
                "function" === typeof e ? $58cd135ddf7e3587$var$v.callback = e : $58cd135ddf7e3587$var$v === $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r) && $58cd135ddf7e3587$var$k($58cd135ddf7e3587$var$r);
                $58cd135ddf7e3587$var$G(b);
            } else $58cd135ddf7e3587$var$k($58cd135ddf7e3587$var$r);
            $58cd135ddf7e3587$var$v = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r);
        }
        if (null !== $58cd135ddf7e3587$var$v) var w = !0;
        else {
            var m = $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$t);
            null !== m && $58cd135ddf7e3587$var$K($58cd135ddf7e3587$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $58cd135ddf7e3587$var$v = null, $58cd135ddf7e3587$var$y = c, $58cd135ddf7e3587$var$z = !1;
    }
}
var $58cd135ddf7e3587$var$N = !1, $58cd135ddf7e3587$var$O = null, $58cd135ddf7e3587$var$L = -1, $58cd135ddf7e3587$var$P = 5, $58cd135ddf7e3587$var$Q = -1;
function $58cd135ddf7e3587$var$M() {
    return $58cd135ddf7e3587$export$c4744153514ff05d() - $58cd135ddf7e3587$var$Q < $58cd135ddf7e3587$var$P ? !1 : !0;
}
function $58cd135ddf7e3587$var$R() {
    if (null !== $58cd135ddf7e3587$var$O) {
        var a = $58cd135ddf7e3587$export$c4744153514ff05d();
        $58cd135ddf7e3587$var$Q = a;
        var b = !0;
        try {
            b = $58cd135ddf7e3587$var$O(!0, a);
        } finally{
            b ? $58cd135ddf7e3587$var$S() : ($58cd135ddf7e3587$var$N = !1, $58cd135ddf7e3587$var$O = null);
        }
    } else $58cd135ddf7e3587$var$N = !1;
}
var $58cd135ddf7e3587$var$S;
if ("function" === typeof $58cd135ddf7e3587$var$F) $58cd135ddf7e3587$var$S = function() {
    $58cd135ddf7e3587$var$F($58cd135ddf7e3587$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $58cd135ddf7e3587$var$T = new MessageChannel, $58cd135ddf7e3587$var$U = $58cd135ddf7e3587$var$T.port2;
    $58cd135ddf7e3587$var$T.port1.onmessage = $58cd135ddf7e3587$var$R;
    $58cd135ddf7e3587$var$S = function() {
        $58cd135ddf7e3587$var$U.postMessage(null);
    };
} else $58cd135ddf7e3587$var$S = function() {
    $58cd135ddf7e3587$var$D($58cd135ddf7e3587$var$R, 0);
};
function $58cd135ddf7e3587$var$I(a) {
    $58cd135ddf7e3587$var$O = a;
    $58cd135ddf7e3587$var$N || ($58cd135ddf7e3587$var$N = !0, $58cd135ddf7e3587$var$S());
}
function $58cd135ddf7e3587$var$K(a, b) {
    $58cd135ddf7e3587$var$L = $58cd135ddf7e3587$var$D(function() {
        a($58cd135ddf7e3587$export$c4744153514ff05d());
    }, b);
}
$58cd135ddf7e3587$export$3e506c1ccc9cc1a7 = 5;
$58cd135ddf7e3587$export$e26fe2ed2fa76875 = 1;
$58cd135ddf7e3587$export$502329bbf4b505b1 = 4;
$58cd135ddf7e3587$export$6e3807111c4874c4 = 3;
$58cd135ddf7e3587$export$c27134553091fb3a = null;
$58cd135ddf7e3587$export$33ee1acdc04fd2a2 = 2;
$58cd135ddf7e3587$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$58cd135ddf7e3587$export$8352ce38b91d0c62 = function() {
    $58cd135ddf7e3587$var$A || $58cd135ddf7e3587$var$z || ($58cd135ddf7e3587$var$A = !0, $58cd135ddf7e3587$var$I($58cd135ddf7e3587$var$J));
};
$58cd135ddf7e3587$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $58cd135ddf7e3587$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$58cd135ddf7e3587$export$d3dfb8e4810cb555 = function() {
    return $58cd135ddf7e3587$var$y;
};
$58cd135ddf7e3587$export$839f9183b0465a69 = function() {
    return $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r);
};
$58cd135ddf7e3587$export$72fdf0e06517287b = function(a) {
    switch($58cd135ddf7e3587$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $58cd135ddf7e3587$var$y;
    }
    var c = $58cd135ddf7e3587$var$y;
    $58cd135ddf7e3587$var$y = b;
    try {
        return a();
    } finally{
        $58cd135ddf7e3587$var$y = c;
    }
};
$58cd135ddf7e3587$export$4b844e58a3e414b4 = function() {};
$58cd135ddf7e3587$export$816d2913ae6b83b1 = function() {};
$58cd135ddf7e3587$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $58cd135ddf7e3587$var$y;
    $58cd135ddf7e3587$var$y = a;
    try {
        return b();
    } finally{
        $58cd135ddf7e3587$var$y = c;
    }
};
$58cd135ddf7e3587$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $58cd135ddf7e3587$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $58cd135ddf7e3587$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $58cd135ddf7e3587$var$f($58cd135ddf7e3587$var$t, a), null === $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$r) && a === $58cd135ddf7e3587$var$h($58cd135ddf7e3587$var$t) && ($58cd135ddf7e3587$var$B ? ($58cd135ddf7e3587$var$E($58cd135ddf7e3587$var$L), $58cd135ddf7e3587$var$L = -1) : $58cd135ddf7e3587$var$B = !0, $58cd135ddf7e3587$var$K($58cd135ddf7e3587$var$H, c - d))) : (a.sortIndex = e, $58cd135ddf7e3587$var$f($58cd135ddf7e3587$var$r, a), $58cd135ddf7e3587$var$A || $58cd135ddf7e3587$var$z || ($58cd135ddf7e3587$var$A = !0, $58cd135ddf7e3587$var$I($58cd135ddf7e3587$var$J)));
    return a;
};
$58cd135ddf7e3587$export$b5836b71941fa3ed = $58cd135ddf7e3587$var$M;
$58cd135ddf7e3587$export$cf845f2c119da08a = function(a) {
    var b = $58cd135ddf7e3587$var$y;
    return function() {
        var c = $58cd135ddf7e3587$var$y;
        $58cd135ddf7e3587$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $58cd135ddf7e3587$var$y = c;
        }
    };
};

});





parcelRegister("3um4r", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $28a54b38a681024a$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $28a54b38a681024a$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $28a54b38a681024a$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useHref", function () { return (parcelRequire("4AX6R")).useHref; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("4AX6R")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("4AX6R")).useNavigate; });
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $bBszO = parcelRequire("bBszO");
var $4AX6R = parcelRequire("4AX6R");

var $bBszO = parcelRequire("bBszO");
function $28a54b38a681024a$var$_extends() {
    $28a54b38a681024a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28a54b38a681024a$var$_extends.apply(this, arguments);
}
function $28a54b38a681024a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $28a54b38a681024a$var$defaultMethod = "get";
const $28a54b38a681024a$var$defaultEncType = "application/x-www-form-urlencoded";
function $28a54b38a681024a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $28a54b38a681024a$var$isButtonElement(object) {
    return $28a54b38a681024a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $28a54b38a681024a$var$isFormElement(object) {
    return $28a54b38a681024a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $28a54b38a681024a$var$isInputElement(object) {
    return $28a54b38a681024a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $28a54b38a681024a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $28a54b38a681024a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$28a54b38a681024a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $28a54b38a681024a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $28a54b38a681024a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $28a54b38a681024a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $28a54b38a681024a$var$_formDataSupportsSubmitter = null;
function $28a54b38a681024a$var$isFormDataSubmitterSupported() {
    if ($28a54b38a681024a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $28a54b38a681024a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $28a54b38a681024a$var$_formDataSupportsSubmitter = true;
    }
    return $28a54b38a681024a$var$_formDataSupportsSubmitter;
}
const $28a54b38a681024a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $28a54b38a681024a$var$getFormEncType(encType) {
    if (encType != null && !$28a54b38a681024a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $28a54b38a681024a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($28a54b38a681024a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $bBszO.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $28a54b38a681024a$var$defaultMethod;
        encType = $28a54b38a681024a$var$getFormEncType(target.getAttribute("enctype")) || $28a54b38a681024a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($28a54b38a681024a$var$isButtonElement(target) || $28a54b38a681024a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $bBszO.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $28a54b38a681024a$var$defaultMethod;
        encType = $28a54b38a681024a$var$getFormEncType(target.getAttribute("formenctype")) || $28a54b38a681024a$var$getFormEncType(form.getAttribute("enctype")) || $28a54b38a681024a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$28a54b38a681024a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($28a54b38a681024a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $28a54b38a681024a$var$defaultMethod;
        action = null;
        encType = $28a54b38a681024a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $28a54b38a681024a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $28a54b38a681024a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $28a54b38a681024a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $28a54b38a681024a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $28a54b38a681024a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $28a54b38a681024a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bBszO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $28a54b38a681024a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bBszO.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $28a54b38a681024a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4AX6R.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $28a54b38a681024a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bBszO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $28a54b38a681024a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bBszO.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $28a54b38a681024a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4AX6R.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $28a54b38a681024a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $28a54b38a681024a$var$_extends({}, state, {
        errors: $28a54b38a681024a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $28a54b38a681024a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bBszO.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $28a54b38a681024a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7E7Dk.createContext({
    isTransitioning: false
});
const $28a54b38a681024a$export$148fd98d095596d4 = /*#__PURE__*/ $7E7Dk.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $28a54b38a681024a$var$START_TRANSITION = "startTransition";
const $28a54b38a681024a$var$startTransitionImpl = $7E7Dk[$28a54b38a681024a$var$START_TRANSITION];
const $28a54b38a681024a$var$FLUSH_SYNC = "flushSync";
const $28a54b38a681024a$var$flushSyncImpl = $hzbSh[$28a54b38a681024a$var$FLUSH_SYNC];
const $28a54b38a681024a$var$USE_ID = "useId";
const $28a54b38a681024a$var$useIdImpl = $7E7Dk[$28a54b38a681024a$var$USE_ID];
function $28a54b38a681024a$var$startTransitionSafe(cb) {
    if ($28a54b38a681024a$var$startTransitionImpl) $28a54b38a681024a$var$startTransitionImpl(cb);
    else cb();
}
function $28a54b38a681024a$var$flushSyncSafe(cb) {
    if ($28a54b38a681024a$var$flushSyncImpl) $28a54b38a681024a$var$flushSyncImpl(cb);
    else cb();
}
class $28a54b38a681024a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $28a54b38a681024a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7E7Dk.useState(router.state);
    let [pendingState, setPendingState] = $7E7Dk.useState();
    let [vtContext, setVtContext] = $7E7Dk.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7E7Dk.useState();
    let [transition, setTransition] = $7E7Dk.useState();
    let [interruption, setInterruption] = $7E7Dk.useState();
    let fetcherData = $7E7Dk.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7E7Dk.useCallback((cb)=>{
        if (v7_startTransition) $28a54b38a681024a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7E7Dk.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $28a54b38a681024a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $28a54b38a681024a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $28a54b38a681024a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $28a54b38a681024a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $28a54b38a681024a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7E7Dk.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7E7Dk.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $28a54b38a681024a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7E7Dk.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7E7Dk.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7E7Dk.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7E7Dk.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7E7Dk.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7E7Dk.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $7E7Dk.createElement($28a54b38a681024a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7E7Dk.createElement($28a54b38a681024a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7E7Dk.createElement($28a54b38a681024a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $28a54b38a681024a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4AX6R.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $28a54b38a681024a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7E7Dk.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bBszO.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7E7Dk.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7E7Dk.useCallback((newState)=>{
        v7_startTransition && $28a54b38a681024a$var$startTransitionImpl ? $28a54b38a681024a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7E7Dk.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $28a54b38a681024a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7E7Dk.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bBszO.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7E7Dk.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7E7Dk.useCallback((newState)=>{
        v7_startTransition && $28a54b38a681024a$var$startTransitionImpl ? $28a54b38a681024a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7E7Dk.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $28a54b38a681024a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7E7Dk.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7E7Dk.useCallback((newState)=>{
        v7_startTransition && $28a54b38a681024a$var$startTransitionImpl ? $28a54b38a681024a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7E7Dk.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7E7Dk.createElement((0, $4AX6R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $28a54b38a681024a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $28a54b38a681024a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $28a54b38a681024a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7E7Dk.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $28a54b38a681024a$var$_objectWithoutPropertiesLoose(_ref7, $28a54b38a681024a$var$_excluded);
    let { basename: basename } = $7E7Dk.useContext((0, $4AX6R.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $28a54b38a681024a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($28a54b38a681024a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bBszO.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4AX6R.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $28a54b38a681024a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7E7Dk.createElement("a", $28a54b38a681024a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $28a54b38a681024a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7E7Dk.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $28a54b38a681024a$var$_objectWithoutPropertiesLoose(_ref8, $28a54b38a681024a$var$_excluded2);
    let path = (0, $4AX6R.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $4AX6R.useLocation)();
    let routerState = $7E7Dk.useContext((0, $4AX6R.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $7E7Dk.useContext((0, $4AX6R.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $28a54b38a681024a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $bBszO.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7E7Dk.createElement($28a54b38a681024a$export$a6c7ac8248d6e38a, $28a54b38a681024a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $28a54b38a681024a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7E7Dk.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $28a54b38a681024a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $28a54b38a681024a$var$_objectWithoutPropertiesLoose(_ref9, $28a54b38a681024a$var$_excluded3);
    let submit = $28a54b38a681024a$export$47c85c6e3a081d3();
    let formAction = $28a54b38a681024a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $7E7Dk.createElement("form", $28a54b38a681024a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $28a54b38a681024a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $28a54b38a681024a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $28a54b38a681024a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($28a54b38a681024a$var$DataRouterHook || ($28a54b38a681024a$var$DataRouterHook = {}));
var $28a54b38a681024a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($28a54b38a681024a$var$DataRouterStateHook || ($28a54b38a681024a$var$DataRouterStateHook = {}));
// Internal hooks
function $28a54b38a681024a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $28a54b38a681024a$var$useDataRouterContext(hookName) {
    let ctx = $7E7Dk.useContext((0, $4AX6R.UNSAFE_DataRouterContext));
    !ctx && (0, $bBszO.UNSAFE_invariant)(false);
    return ctx;
}
function $28a54b38a681024a$var$useDataRouterState(hookName) {
    let state = $7E7Dk.useContext((0, $4AX6R.UNSAFE_DataRouterStateContext));
    !state && (0, $bBszO.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $28a54b38a681024a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4AX6R.useNavigate)();
    let location = (0, $4AX6R.useLocation)();
    let path = (0, $4AX6R.useResolvedPath)(to, {
        relative: relative
    });
    return $7E7Dk.useCallback((event)=>{
        if ($28a54b38a681024a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bBszO.createPath)(location) === (0, $bBszO.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $28a54b38a681024a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7E7Dk.useRef($28a54b38a681024a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7E7Dk.useRef(false);
    let location = (0, $4AX6R.useLocation)();
    let searchParams = $7E7Dk.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $28a54b38a681024a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4AX6R.useNavigate)();
    let setSearchParams = $7E7Dk.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $28a54b38a681024a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $28a54b38a681024a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $28a54b38a681024a$var$fetcherId = 0;
let $28a54b38a681024a$var$getUniqueFetcherId = ()=>"__" + String(++$28a54b38a681024a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $28a54b38a681024a$export$47c85c6e3a081d3() {
    let { router: router } = $28a54b38a681024a$var$useDataRouterContext($28a54b38a681024a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7E7Dk.useContext((0, $4AX6R.UNSAFE_NavigationContext));
    let currentRouteId = (0, $4AX6R.UNSAFE_useRouteId)();
    return $7E7Dk.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $28a54b38a681024a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $28a54b38a681024a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $28a54b38a681024a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $28a54b38a681024a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7E7Dk.useContext((0, $4AX6R.UNSAFE_NavigationContext));
    let routeContext = $7E7Dk.useContext((0, $4AX6R.UNSAFE_RouteContext));
    !routeContext && (0, $bBszO.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $28a54b38a681024a$var$_extends({}, (0, $4AX6R.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4AX6R.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bBszO.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $bBszO.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $28a54b38a681024a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $28a54b38a681024a$var$useDataRouterContext($28a54b38a681024a$var$DataRouterHook.UseFetcher);
    let state = $28a54b38a681024a$var$useDataRouterState($28a54b38a681024a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7E7Dk.useContext($28a54b38a681024a$export$148fd98d095596d4);
    let route = $7E7Dk.useContext((0, $4AX6R.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $bBszO.UNSAFE_invariant)(false);
    !route && (0, $bBszO.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $bBszO.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $28a54b38a681024a$var$useIdImpl ? $28a54b38a681024a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7E7Dk.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($28a54b38a681024a$var$getUniqueFetcherId());
    // Registration/cleanup
    $7E7Dk.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7E7Dk.useCallback((href, opts)=>{
        !routeId && (0, $bBszO.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $28a54b38a681024a$export$47c85c6e3a081d3();
    let submit = $7E7Dk.useCallback((target, opts)=>{
        submitImpl(target, $28a54b38a681024a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7E7Dk.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7E7Dk.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7E7Dk.createElement($28a54b38a681024a$export$a7fed597f4b8afd8, $28a54b38a681024a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $bBszO.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7E7Dk.useMemo(()=>$28a54b38a681024a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $28a54b38a681024a$export$fa996778a3a31087() {
    let state = $28a54b38a681024a$var$useDataRouterState($28a54b38a681024a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $28a54b38a681024a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $28a54b38a681024a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $28a54b38a681024a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $28a54b38a681024a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $28a54b38a681024a$var$useDataRouterContext($28a54b38a681024a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $28a54b38a681024a$var$useDataRouterState($28a54b38a681024a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7E7Dk.useContext((0, $4AX6R.UNSAFE_NavigationContext));
    let location = (0, $4AX6R.useLocation)();
    let matches = (0, $4AX6R.useMatches)();
    let navigation = (0, $4AX6R.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $7E7Dk.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $28a54b38a681024a$var$usePageHide($7E7Dk.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $28a54b38a681024a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $28a54b38a681024a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($28a54b38a681024a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7E7Dk.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $28a54b38a681024a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $28a54b38a681024a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7E7Dk.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($28a54b38a681024a$var$_extends({}, location, {
                    pathname: (0, $bBszO.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($28a54b38a681024a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7E7Dk.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $28a54b38a681024a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7E7Dk.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $28a54b38a681024a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7E7Dk.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $28a54b38a681024a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4AX6R.useBlocker)(when);
    $7E7Dk.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7E7Dk.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $28a54b38a681024a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7E7Dk.useContext($28a54b38a681024a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $bBszO.UNSAFE_invariant)(false);
    let { basename: basename } = $28a54b38a681024a$var$useDataRouterContext($28a54b38a681024a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4AX6R.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $bBszO.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $bBszO.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $bBszO.matchPath)(path.pathname, nextPath) != null || (0, $bBszO.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("bBszO", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $8729511c495f0fc5$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $8729511c495f0fc5$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $8729511c495f0fc5$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $8729511c495f0fc5$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $8729511c495f0fc5$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $8729511c495f0fc5$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $8729511c495f0fc5$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $8729511c495f0fc5$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $8729511c495f0fc5$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $8729511c495f0fc5$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $8729511c495f0fc5$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $8729511c495f0fc5$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $8729511c495f0fc5$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $8729511c495f0fc5$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $8729511c495f0fc5$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $8729511c495f0fc5$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $8729511c495f0fc5$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $8729511c495f0fc5$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $8729511c495f0fc5$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $8729511c495f0fc5$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $8729511c495f0fc5$var$_extends() {
    $8729511c495f0fc5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8729511c495f0fc5$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $8729511c495f0fc5$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($8729511c495f0fc5$export$e19cd5f9376f8cee || ($8729511c495f0fc5$export$e19cd5f9376f8cee = {}));
const $8729511c495f0fc5$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $8729511c495f0fc5$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $8729511c495f0fc5$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $8729511c495f0fc5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $8729511c495f0fc5$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $8729511c495f0fc5$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $8729511c495f0fc5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $8729511c495f0fc5$export$fe53371bee54353d(to);
    }
    return $8729511c495f0fc5$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $8729511c495f0fc5$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $8729511c495f0fc5$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $8729511c495f0fc5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $8729511c495f0fc5$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $8729511c495f0fc5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $8729511c495f0fc5$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $8729511c495f0fc5$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $8729511c495f0fc5$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $8729511c495f0fc5$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $8729511c495f0fc5$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $8729511c495f0fc5$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $8729511c495f0fc5$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $8729511c495f0fc5$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $8729511c495f0fc5$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $8729511c495f0fc5$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $8729511c495f0fc5$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($8729511c495f0fc5$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Push;
        let location = $8729511c495f0fc5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $8729511c495f0fc5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace;
        let location = $8729511c495f0fc5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $8729511c495f0fc5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $8729511c495f0fc5$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $8729511c495f0fc5$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($8729511c495f0fc5$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($8729511c495f0fc5$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $8729511c495f0fc5$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($8729511c495f0fc5$var$ResultType || ($8729511c495f0fc5$var$ResultType = {}));
const $8729511c495f0fc5$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $8729511c495f0fc5$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $8729511c495f0fc5$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $8729511c495f0fc5$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $8729511c495f0fc5$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($8729511c495f0fc5$var$isIndexRoute(route)) {
            let indexRoute = $8729511c495f0fc5$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $8729511c495f0fc5$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $8729511c495f0fc5$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $8729511c495f0fc5$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $8729511c495f0fc5$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $8729511c495f0fc5$var$flattenRoutes(routes);
    $8729511c495f0fc5$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $8729511c495f0fc5$var$decodePath(pathname);
        matches = $8729511c495f0fc5$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $8729511c495f0fc5$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $8729511c495f0fc5$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $8729511c495f0fc5$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $8729511c495f0fc5$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $8729511c495f0fc5$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $8729511c495f0fc5$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $8729511c495f0fc5$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $8729511c495f0fc5$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $8729511c495f0fc5$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $8729511c495f0fc5$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $8729511c495f0fc5$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $8729511c495f0fc5$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $8729511c495f0fc5$var$paramRe = /^:[\w-]+$/;
const $8729511c495f0fc5$var$dynamicSegmentValue = 3;
const $8729511c495f0fc5$var$indexRouteValue = 2;
const $8729511c495f0fc5$var$emptySegmentValue = 1;
const $8729511c495f0fc5$var$staticSegmentValue = 10;
const $8729511c495f0fc5$var$splatPenalty = -2;
const $8729511c495f0fc5$var$isSplat = (s)=>s === "*";
function $8729511c495f0fc5$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($8729511c495f0fc5$var$isSplat)) initialScore += $8729511c495f0fc5$var$splatPenalty;
    if (index) initialScore += $8729511c495f0fc5$var$indexRouteValue;
    return segments.filter((s)=>!$8729511c495f0fc5$var$isSplat(s)).reduce((score, segment)=>score + ($8729511c495f0fc5$var$paramRe.test(segment) ? $8729511c495f0fc5$var$dynamicSegmentValue : segment === "" ? $8729511c495f0fc5$var$emptySegmentValue : $8729511c495f0fc5$var$staticSegmentValue), initialScore);
}
function $8729511c495f0fc5$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $8729511c495f0fc5$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $8729511c495f0fc5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $8729511c495f0fc5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $8729511c495f0fc5$export$a5c6d149b50c1d86($8729511c495f0fc5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $8729511c495f0fc5$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $8729511c495f0fc5$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $8729511c495f0fc5$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $8729511c495f0fc5$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $8729511c495f0fc5$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $8729511c495f0fc5$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $8729511c495f0fc5$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $8729511c495f0fc5$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $8729511c495f0fc5$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $8729511c495f0fc5$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $8729511c495f0fc5$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $8729511c495f0fc5$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $8729511c495f0fc5$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $8729511c495f0fc5$var$normalizeSearch(search),
        hash: $8729511c495f0fc5$var$normalizeHash(hash)
    };
}
function $8729511c495f0fc5$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $8729511c495f0fc5$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $8729511c495f0fc5$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $8729511c495f0fc5$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $8729511c495f0fc5$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $8729511c495f0fc5$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $8729511c495f0fc5$export$8ccf933b0513f8d0(toArg);
    else {
        to = $8729511c495f0fc5$var$_extends({}, toArg);
        $8729511c495f0fc5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $8729511c495f0fc5$var$getInvalidPathError("?", "pathname", "search", to));
        $8729511c495f0fc5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $8729511c495f0fc5$var$getInvalidPathError("#", "pathname", "hash", to));
        $8729511c495f0fc5$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $8729511c495f0fc5$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $8729511c495f0fc5$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $8729511c495f0fc5$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $8729511c495f0fc5$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $8729511c495f0fc5$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $8729511c495f0fc5$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $8729511c495f0fc5$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $8729511c495f0fc5$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $8729511c495f0fc5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $8729511c495f0fc5$export$42a99a7a4bc0e76a extends Error {
}
class $8729511c495f0fc5$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $8729511c495f0fc5$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $8729511c495f0fc5$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $8729511c495f0fc5$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $8729511c495f0fc5$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $8729511c495f0fc5$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $8729511c495f0fc5$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $8729511c495f0fc5$var$unwrapTrackedPromise(value) {
    if (!$8729511c495f0fc5$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $8729511c495f0fc5$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $8729511c495f0fc5$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8729511c495f0fc5$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $8729511c495f0fc5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8729511c495f0fc5$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $8729511c495f0fc5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $8729511c495f0fc5$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $8729511c495f0fc5$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $8729511c495f0fc5$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $8729511c495f0fc5$var$validMutationMethods = new Set($8729511c495f0fc5$var$validMutationMethodsArr);
const $8729511c495f0fc5$var$validRequestMethodsArr = [
    "get",
    ...$8729511c495f0fc5$var$validMutationMethodsArr
];
const $8729511c495f0fc5$var$validRequestMethods = new Set($8729511c495f0fc5$var$validRequestMethodsArr);
const $8729511c495f0fc5$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $8729511c495f0fc5$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $8729511c495f0fc5$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8729511c495f0fc5$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8729511c495f0fc5$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $8729511c495f0fc5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $8729511c495f0fc5$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $8729511c495f0fc5$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $8729511c495f0fc5$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $8729511c495f0fc5$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8729511c495f0fc5$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $8729511c495f0fc5$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $8729511c495f0fc5$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $8729511c495f0fc5$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $8729511c495f0fc5$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $8729511c495f0fc5$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $8729511c495f0fc5$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $8729511c495f0fc5$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $8729511c495f0fc5$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $8729511c495f0fc5$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $8729511c495f0fc5$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$8729511c495f0fc5$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($8729511c495f0fc5$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $8729511c495f0fc5$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $8729511c495f0fc5$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $8729511c495f0fc5$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $8729511c495f0fc5$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $8729511c495f0fc5$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $8729511c495f0fc5$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($8729511c495f0fc5$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $8729511c495f0fc5$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $8729511c495f0fc5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $8729511c495f0fc5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $8729511c495f0fc5$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $8729511c495f0fc5$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $8729511c495f0fc5$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $8729511c495f0fc5$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $8729511c495f0fc5$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $8729511c495f0fc5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8729511c495f0fc5$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $8729511c495f0fc5$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $8729511c495f0fc5$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $8729511c495f0fc5$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $8729511c495f0fc5$var$findNearestBoundary(matches).route.id,
            {
                type: $8729511c495f0fc5$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $8729511c495f0fc5$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $8729511c495f0fc5$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $8729511c495f0fc5$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $8729511c495f0fc5$var$_extends({
            matches: matches
        }, $8729511c495f0fc5$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $8729511c495f0fc5$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $8729511c495f0fc5$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $8729511c495f0fc5$var$ResultType.error,
            error: $8729511c495f0fc5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($8729511c495f0fc5$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $8729511c495f0fc5$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($8729511c495f0fc5$var$isDeferredResult(result)) throw $8729511c495f0fc5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($8729511c495f0fc5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8729511c495f0fc5$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $8729511c495f0fc5$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $8729511c495f0fc5$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $8729511c495f0fc5$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $8729511c495f0fc5$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $8729511c495f0fc5$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $8729511c495f0fc5$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $8729511c495f0fc5$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$8729511c495f0fc5$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($8729511c495f0fc5$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $8729511c495f0fc5$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8729511c495f0fc5$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $8729511c495f0fc5$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $8729511c495f0fc5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $8729511c495f0fc5$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $8729511c495f0fc5$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $8729511c495f0fc5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $8729511c495f0fc5$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $8729511c495f0fc5$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $8729511c495f0fc5$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8729511c495f0fc5$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $8729511c495f0fc5$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($8729511c495f0fc5$var$isRedirectResult(actionResult) || $8729511c495f0fc5$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $8729511c495f0fc5$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($8729511c495f0fc5$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $8729511c495f0fc5$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $8729511c495f0fc5$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($8729511c495f0fc5$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($8729511c495f0fc5$var$isDeferredResult(actionResult)) throw $8729511c495f0fc5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $8729511c495f0fc5$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $8729511c495f0fc5$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $8729511c495f0fc5$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $8729511c495f0fc5$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $8729511c495f0fc5$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $8729511c495f0fc5$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $8729511c495f0fc5$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8729511c495f0fc5$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $8729511c495f0fc5$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $8729511c495f0fc5$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $8729511c495f0fc5$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8729511c495f0fc5$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $8729511c495f0fc5$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($8729511c495f0fc5$var$isDeferredResult(result)) result = await $8729511c495f0fc5$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $8729511c495f0fc5$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($8729511c495f0fc5$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $8729511c495f0fc5$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($8729511c495f0fc5$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $8729511c495f0fc5$export$3e9cee6b33872309(!$8729511c495f0fc5$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $8729511c495f0fc5$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $8729511c495f0fc5$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $8729511c495f0fc5$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $8729511c495f0fc5$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($8729511c495f0fc5$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $8729511c495f0fc5$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $8729511c495f0fc5$export$e19cd5f9376f8cee.Replace : $8729511c495f0fc5$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $8729511c495f0fc5$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($8729511c495f0fc5$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $8729511c495f0fc5$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $8729511c495f0fc5$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $8729511c495f0fc5$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $8729511c495f0fc5$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($8729511c495f0fc5$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $8729511c495f0fc5$var$ResultType.redirect,
                        response: $8729511c495f0fc5$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $8729511c495f0fc5$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $8729511c495f0fc5$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $8729511c495f0fc5$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $8729511c495f0fc5$var$ResultType.error,
                    error: $8729511c495f0fc5$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $8729511c495f0fc5$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $8729511c495f0fc5$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $8729511c495f0fc5$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $8729511c495f0fc5$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $8729511c495f0fc5$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $8729511c495f0fc5$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $8729511c495f0fc5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $8729511c495f0fc5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $8729511c495f0fc5$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $8729511c495f0fc5$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $8729511c495f0fc5$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $8729511c495f0fc5$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $8729511c495f0fc5$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$8729511c495f0fc5$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $8729511c495f0fc5$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $8729511c495f0fc5$export$4d0306f8f6a4585b = Symbol("deferred");
function $8729511c495f0fc5$export$3336b097a6fbc59a(routes, opts) {
    $8729511c495f0fc5$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8729511c495f0fc5$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $8729511c495f0fc5$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $8729511c495f0fc5$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8729511c495f0fc5$var$createLocation("", $8729511c495f0fc5$export$fe53371bee54353d(url), null, "default");
        let matches = $8729511c495f0fc5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8729511c495f0fc5$var$isValidMethod(method) && method !== "HEAD") {
            let error = $8729511c495f0fc5$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $8729511c495f0fc5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $8729511c495f0fc5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8729511c495f0fc5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($8729511c495f0fc5$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $8729511c495f0fc5$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8729511c495f0fc5$var$createLocation("", $8729511c495f0fc5$export$fe53371bee54353d(url), null, "default");
        let matches = $8729511c495f0fc5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8729511c495f0fc5$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $8729511c495f0fc5$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $8729511c495f0fc5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $8729511c495f0fc5$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $8729511c495f0fc5$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $8729511c495f0fc5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($8729511c495f0fc5$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$8729511c495f0fc5$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $8729511c495f0fc5$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($8729511c495f0fc5$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $8729511c495f0fc5$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $8729511c495f0fc5$var$isResponse(result) ? result : $8729511c495f0fc5$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($8729511c495f0fc5$var$isHandlerResult(e) && $8729511c495f0fc5$var$isResponse(e.result)) {
                if (e.type === $8729511c495f0fc5$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($8729511c495f0fc5$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $8729511c495f0fc5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8729511c495f0fc5$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $8729511c495f0fc5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($8729511c495f0fc5$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($8729511c495f0fc5$var$isDeferredResult(result)) {
            let error = $8729511c495f0fc5$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8729511c495f0fc5$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($8729511c495f0fc5$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($8729511c495f0fc5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $8729511c495f0fc5$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $8729511c495f0fc5$var$_extends({}, context, {
                statusCode: $8729511c495f0fc5$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $8729511c495f0fc5$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $8729511c495f0fc5$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $8729511c495f0fc5$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? $8729511c495f0fc5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $8729511c495f0fc5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $8729511c495f0fc5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $8729511c495f0fc5$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $8729511c495f0fc5$var$callDataStrategyImpl(unstable_dataStrategy || $8729511c495f0fc5$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($8729511c495f0fc5$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $8729511c495f0fc5$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($8729511c495f0fc5$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $8729511c495f0fc5$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $8729511c495f0fc5$export$fec11da027c70692(routes, context, error) {
    let newContext = $8729511c495f0fc5$var$_extends({}, context, {
        statusCode: $8729511c495f0fc5$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $8729511c495f0fc5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $8729511c495f0fc5$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $8729511c495f0fc5$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $8729511c495f0fc5$export$cae722b0cc860f13(to ? to : ".", $8729511c495f0fc5$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $8729511c495f0fc5$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$8729511c495f0fc5$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $8729511c495f0fc5$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $8729511c495f0fc5$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $8729511c495f0fc5$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$8729511c495f0fc5$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$8729511c495f0fc5$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $8729511c495f0fc5$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $8729511c495f0fc5$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $8729511c495f0fc5$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$8729511c495f0fc5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$8729511c495f0fc5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $8729511c495f0fc5$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $8729511c495f0fc5$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $8729511c495f0fc5$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $8729511c495f0fc5$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $8729511c495f0fc5$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($8729511c495f0fc5$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $8729511c495f0fc5$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $8729511c495f0fc5$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $8729511c495f0fc5$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $8729511c495f0fc5$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $8729511c495f0fc5$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $8729511c495f0fc5$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($8729511c495f0fc5$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $8729511c495f0fc5$var$shouldRevalidateLoader(match, $8729511c495f0fc5$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $8729511c495f0fc5$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $8729511c495f0fc5$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $8729511c495f0fc5$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $8729511c495f0fc5$var$shouldRevalidateLoader(fetcherMatch, $8729511c495f0fc5$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $8729511c495f0fc5$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $8729511c495f0fc5$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $8729511c495f0fc5$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $8729511c495f0fc5$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $8729511c495f0fc5$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $8729511c495f0fc5$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$8729511c495f0fc5$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $8729511c495f0fc5$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $8729511c495f0fc5$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $8729511c495f0fc5$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $8729511c495f0fc5$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $8729511c495f0fc5$var$ResultType.data,
                    result: undefined
                });
            };
            return $8729511c495f0fc5$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$8729511c495f0fc5$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $8729511c495f0fc5$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $8729511c495f0fc5$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $8729511c495f0fc5$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $8729511c495f0fc5$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $8729511c495f0fc5$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $8729511c495f0fc5$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $8729511c495f0fc5$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $8729511c495f0fc5$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $8729511c495f0fc5$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($8729511c495f0fc5$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $8729511c495f0fc5$var$ResultType.error,
                error: e
            };
        }
        if (type === $8729511c495f0fc5$var$ResultType.error) return {
            type: $8729511c495f0fc5$var$ResultType.error,
            error: new $8729511c495f0fc5$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $8729511c495f0fc5$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $8729511c495f0fc5$var$ResultType.error) return {
        type: $8729511c495f0fc5$var$ResultType.error,
        error: result,
        statusCode: $8729511c495f0fc5$export$972111febbeef05b(result) ? result.status : status
    };
    if ($8729511c495f0fc5$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $8729511c495f0fc5$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $8729511c495f0fc5$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $8729511c495f0fc5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $8729511c495f0fc5$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$8729511c495f0fc5$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $8729511c495f0fc5$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $8729511c495f0fc5$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($8729511c495f0fc5$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $8729511c495f0fc5$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $8729511c495f0fc5$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($8729511c495f0fc5$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $8729511c495f0fc5$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $8729511c495f0fc5$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $8729511c495f0fc5$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $8729511c495f0fc5$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $8729511c495f0fc5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $8729511c495f0fc5$export$3e9cee6b33872309(!$8729511c495f0fc5$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($8729511c495f0fc5$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $8729511c495f0fc5$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $8729511c495f0fc5$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($8729511c495f0fc5$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $8729511c495f0fc5$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $8729511c495f0fc5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $8729511c495f0fc5$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($8729511c495f0fc5$var$isErrorResult(result)) {
            let boundaryMatch = $8729511c495f0fc5$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $8729511c495f0fc5$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($8729511c495f0fc5$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $8729511c495f0fc5$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($8729511c495f0fc5$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $8729511c495f0fc5$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $8729511c495f0fc5$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $8729511c495f0fc5$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $8729511c495f0fc5$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $8729511c495f0fc5$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $8729511c495f0fc5$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $8729511c495f0fc5$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $8729511c495f0fc5$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $8729511c495f0fc5$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $8729511c495f0fc5$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $8729511c495f0fc5$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($8729511c495f0fc5$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $8729511c495f0fc5$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(path) : path;
    return $8729511c495f0fc5$export$fe53371bee54353d($8729511c495f0fc5$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $8729511c495f0fc5$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $8729511c495f0fc5$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $8729511c495f0fc5$var$ResultType.data || result.type === $8729511c495f0fc5$var$ResultType.error);
}
function $8729511c495f0fc5$var$isRedirectHandlerResult(result) {
    return $8729511c495f0fc5$var$isResponse(result.result) && $8729511c495f0fc5$var$redirectStatusCodes.has(result.result.status);
}
function $8729511c495f0fc5$var$isDeferredResult(result) {
    return result.type === $8729511c495f0fc5$var$ResultType.deferred;
}
function $8729511c495f0fc5$var$isErrorResult(result) {
    return result.type === $8729511c495f0fc5$var$ResultType.error;
}
function $8729511c495f0fc5$var$isRedirectResult(result) {
    return (result && result.type) === $8729511c495f0fc5$var$ResultType.redirect;
}
function $8729511c495f0fc5$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $8729511c495f0fc5$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $8729511c495f0fc5$var$isRedirectResponse(result) {
    if (!$8729511c495f0fc5$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $8729511c495f0fc5$var$isValidMethod(method) {
    return $8729511c495f0fc5$var$validRequestMethods.has(method.toLowerCase());
}
function $8729511c495f0fc5$var$isMutationMethod(method) {
    return $8729511c495f0fc5$var$validMutationMethods.has(method.toLowerCase());
}
async function $8729511c495f0fc5$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$8729511c495f0fc5$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($8729511c495f0fc5$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $8729511c495f0fc5$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $8729511c495f0fc5$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $8729511c495f0fc5$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $8729511c495f0fc5$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $8729511c495f0fc5$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $8729511c495f0fc5$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $8729511c495f0fc5$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $8729511c495f0fc5$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $8729511c495f0fc5$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $8729511c495f0fc5$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $8729511c495f0fc5$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $8729511c495f0fc5$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $8729511c495f0fc5$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $8729511c495f0fc5$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $8729511c495f0fc5$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $8729511c495f0fc5$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $8729511c495f0fc5$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $8729511c495f0fc5$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($8729511c495f0fc5$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $8729511c495f0fc5$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($8729511c495f0fc5$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $8729511c495f0fc5$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("4AX6R", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $3588602d880b3dd8$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $3588602d880b3dd8$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $3588602d880b3dd8$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $3588602d880b3dd8$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $3588602d880b3dd8$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $3588602d880b3dd8$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $3588602d880b3dd8$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $3588602d880b3dd8$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $3588602d880b3dd8$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $3588602d880b3dd8$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $3588602d880b3dd8$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $3588602d880b3dd8$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $3588602d880b3dd8$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $3588602d880b3dd8$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $3588602d880b3dd8$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $3588602d880b3dd8$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $3588602d880b3dd8$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $3588602d880b3dd8$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $3588602d880b3dd8$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $3588602d880b3dd8$export$52b333d321859367; });
/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7E7Dk = parcelRequire("7E7Dk");

var $bBszO = parcelRequire("bBszO");
function $3588602d880b3dd8$var$_extends() {
    $3588602d880b3dd8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3588602d880b3dd8$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $3588602d880b3dd8$export$3add0d5dce533e2e = /*#__PURE__*/ $7E7Dk.createContext(null);
const $3588602d880b3dd8$export$145dfa71566a64dc = /*#__PURE__*/ $7E7Dk.createContext(null);
const $3588602d880b3dd8$var$AwaitContext = /*#__PURE__*/ $7E7Dk.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $3588602d880b3dd8$export$26749e8557646306 = /*#__PURE__*/ $7E7Dk.createContext(null);
const $3588602d880b3dd8$export$c7914228fb69b0f5 = /*#__PURE__*/ $7E7Dk.createContext(null);
const $3588602d880b3dd8$export$9072aa6dd1f93057 = /*#__PURE__*/ $7E7Dk.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $3588602d880b3dd8$var$RouteErrorContext = /*#__PURE__*/ $7E7Dk.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $3588602d880b3dd8$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $3588602d880b3dd8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bBszO.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $3588602d880b3dd8$export$9c954a9d03d32f4a() {
    return $7E7Dk.useContext($3588602d880b3dd8$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $3588602d880b3dd8$export$45d76561a5302f2b() {
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    return $7E7Dk.useContext($3588602d880b3dd8$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $3588602d880b3dd8$export$1b3f31771c5d07c() {
    return $7E7Dk.useContext($3588602d880b3dd8$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $3588602d880b3dd8$export$6c330e8992e8a295(pattern) {
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    let { pathname: pathname } = $3588602d880b3dd8$export$45d76561a5302f2b();
    return $7E7Dk.useMemo(()=>(0, $bBszO.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $3588602d880b3dd8$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $3588602d880b3dd8$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7E7Dk.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $3588602d880b3dd8$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $3588602d880b3dd8$var$useNavigateStable() : $3588602d880b3dd8$var$useNavigateUnstable();
}
function $3588602d880b3dd8$var$useNavigateUnstable() {
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    let dataRouterContext = $7E7Dk.useContext($3588602d880b3dd8$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306);
    let { matches: matches } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3588602d880b3dd8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bBszO.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $7E7Dk.useRef(false);
    $3588602d880b3dd8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7E7Dk.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bBszO.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bBszO.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $3588602d880b3dd8$var$OutletContext = /*#__PURE__*/ $7E7Dk.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $3588602d880b3dd8$export$4138103a3ae699cc() {
    return $7E7Dk.useContext($3588602d880b3dd8$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $3588602d880b3dd8$export$a3be3530d8e40d0b(context) {
    let outlet = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $3588602d880b3dd8$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $3588602d880b3dd8$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306);
    let { matches: matches } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3588602d880b3dd8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bBszO.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $7E7Dk.useMemo(()=>(0, $bBszO.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $3588602d880b3dd8$export$5d3fca4a98652595(routes, locationArg) {
    return $3588602d880b3dd8$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $3588602d880b3dd8$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    let { navigator: navigator } = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306);
    let { matches: parentMatches } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $3588602d880b3dd8$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bBszO.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bBszO.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $bBszO.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $3588602d880b3dd8$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bBszO.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bBszO.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $3588602d880b3dd8$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bBszO.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3588602d880b3dd8$var$DefaultErrorComponent() {
    let error = $3588602d880b3dd8$export$ed527bf60f6e05f2();
    let message = (0, $bBszO.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7E7Dk.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7E7Dk.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $3588602d880b3dd8$var$defaultErrorElement = /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$DefaultErrorComponent, null);
class $3588602d880b3dd8$var$RenderErrorBoundary extends $7E7Dk.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $3588602d880b3dd8$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7E7Dk.useContext($3588602d880b3dd8$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $3588602d880b3dd8$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $bBszO.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $3588602d880b3dd8$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3588602d880b3dd8$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7E7Dk.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $3588602d880b3dd8$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($3588602d880b3dd8$var$DataRouterHook || {});
var $3588602d880b3dd8$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($3588602d880b3dd8$var$DataRouterStateHook || {});
function $3588602d880b3dd8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $3588602d880b3dd8$var$useDataRouterContext(hookName) {
    let ctx = $7E7Dk.useContext($3588602d880b3dd8$export$3add0d5dce533e2e);
    !ctx && (0, $bBszO.UNSAFE_invariant)(false);
    return ctx;
}
function $3588602d880b3dd8$var$useDataRouterState(hookName) {
    let state = $7E7Dk.useContext($3588602d880b3dd8$export$145dfa71566a64dc);
    !state && (0, $bBszO.UNSAFE_invariant)(false);
    return state;
}
function $3588602d880b3dd8$var$useRouteContext(hookName) {
    let route = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    !route && (0, $bBszO.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $3588602d880b3dd8$var$useCurrentRouteId(hookName) {
    let route = $3588602d880b3dd8$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bBszO.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $3588602d880b3dd8$export$5fc8298006ad9e58() {
    return $3588602d880b3dd8$var$useCurrentRouteId($3588602d880b3dd8$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $3588602d880b3dd8$export$d0fd4b7106de2769() {
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $3588602d880b3dd8$export$600dc272ed516c15() {
    let dataRouterContext = $3588602d880b3dd8$var$useDataRouterContext($3588602d880b3dd8$var$DataRouterHook.UseRevalidator);
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseRevalidator);
    return $7E7Dk.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $3588602d880b3dd8$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseMatches);
    return $7E7Dk.useMemo(()=>matches.map((m)=>(0, $bBszO.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $3588602d880b3dd8$export$1448a5050d252c4d() {
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseLoaderData);
    let routeId = $3588602d880b3dd8$var$useCurrentRouteId($3588602d880b3dd8$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $3588602d880b3dd8$export$fd5d37484eab868d(routeId) {
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $3588602d880b3dd8$export$fdc00f3f26066d5e() {
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseActionData);
    let routeId = $3588602d880b3dd8$var$useCurrentRouteId($3588602d880b3dd8$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $3588602d880b3dd8$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7E7Dk.useContext($3588602d880b3dd8$var$RouteErrorContext);
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseRouteError);
    let routeId = $3588602d880b3dd8$var$useCurrentRouteId($3588602d880b3dd8$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $3588602d880b3dd8$export$78a72ddb39bdd145() {
    let value = $7E7Dk.useContext($3588602d880b3dd8$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $3588602d880b3dd8$export$17f53340677d5831() {
    let value = $7E7Dk.useContext($3588602d880b3dd8$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $3588602d880b3dd8$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $3588602d880b3dd8$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3588602d880b3dd8$var$useDataRouterContext($3588602d880b3dd8$var$DataRouterHook.UseBlocker);
    let state = $3588602d880b3dd8$var$useDataRouterState($3588602d880b3dd8$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7E7Dk.useState("");
    let blockerFunction = $7E7Dk.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $3588602d880b3dd8$var$_extends({}, currentLocation, {
                pathname: (0, $bBszO.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $3588602d880b3dd8$var$_extends({}, nextLocation, {
                pathname: (0, $bBszO.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7E7Dk.useEffect(()=>{
        let key = String(++$3588602d880b3dd8$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7E7Dk.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bBszO.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $3588602d880b3dd8$var$useNavigateStable() {
    let { router: router } = $3588602d880b3dd8$var$useDataRouterContext($3588602d880b3dd8$var$DataRouterHook.UseNavigateStable);
    let id = $3588602d880b3dd8$var$useCurrentRouteId($3588602d880b3dd8$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7E7Dk.useRef(false);
    $3588602d880b3dd8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7E7Dk.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $3588602d880b3dd8$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $3588602d880b3dd8$var$alreadyWarned = {};
function $3588602d880b3dd8$var$warningOnce(key, cond, message) {
    if (!cond && !$3588602d880b3dd8$var$alreadyWarned[key]) $3588602d880b3dd8$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3588602d880b3dd8$var$START_TRANSITION = "startTransition";
const $3588602d880b3dd8$var$startTransitionImpl = $7E7Dk[$3588602d880b3dd8$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3588602d880b3dd8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7E7Dk.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7E7Dk.useCallback((newState)=>{
        if (v7_startTransition && $3588602d880b3dd8$var$startTransitionImpl) $3588602d880b3dd8$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7E7Dk.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7E7Dk.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7E7Dk.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7E7Dk.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $3588602d880b3dd8$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $3588602d880b3dd8$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $3588602d880b3dd8$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7E7Dk.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bBszO.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7E7Dk.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7E7Dk.useCallback((newState)=>{
        v7_startTransition && $3588602d880b3dd8$var$startTransitionImpl ? $3588602d880b3dd8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7E7Dk.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $3588602d880b3dd8$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $7E7Dk.useContext($3588602d880b3dd8$export$26749e8557646306);
    let { matches: matches } = $7E7Dk.useContext($3588602d880b3dd8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3588602d880b3dd8$export$45d76561a5302f2b();
    let navigate = $3588602d880b3dd8$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bBszO.resolveTo)(to, (0, $bBszO.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7E7Dk.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $3588602d880b3dd8$export$910ae8079b2c2852(props) {
    return $3588602d880b3dd8$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $3588602d880b3dd8$export$e7b0ac011bb776c6(_props) {
    (0, $bBszO.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $3588602d880b3dd8$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $bBszO.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$3588602d880b3dd8$export$9c954a9d03d32f4a() && (0, $bBszO.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7E7Dk.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $3588602d880b3dd8$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bBszO.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7E7Dk.useMemo(()=>{
        let trailingPathname = (0, $bBszO.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $3588602d880b3dd8$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $3588602d880b3dd8$export$5d3fca4a98652595($3588602d880b3dd8$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $3588602d880b3dd8$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$ResolveAwait, null, children));
}
var $3588602d880b3dd8$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($3588602d880b3dd8$var$AwaitRenderStatus || {});
const $3588602d880b3dd8$var$neverSettledPromise = new Promise(()=>{});
class $3588602d880b3dd8$var$AwaitErrorBoundary extends $7E7Dk.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $3588602d880b3dd8$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $3588602d880b3dd8$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $3588602d880b3dd8$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $3588602d880b3dd8$var$AwaitRenderStatus.error : promise._data !== undefined ? $3588602d880b3dd8$var$AwaitRenderStatus.success : $3588602d880b3dd8$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $3588602d880b3dd8$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $3588602d880b3dd8$var$AwaitRenderStatus.error && promise._error instanceof (0, $bBszO.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $3588602d880b3dd8$var$neverSettledPromise;
        if (status === $3588602d880b3dd8$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $3588602d880b3dd8$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $3588602d880b3dd8$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7E7Dk.createElement($3588602d880b3dd8$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $3588602d880b3dd8$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $3588602d880b3dd8$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $3588602d880b3dd8$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7E7Dk.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7E7Dk.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7E7Dk.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $3588602d880b3dd8$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $3588602d880b3dd8$export$e7b0ac011bb776c6) && (0, $bBszO.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $bBszO.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3588602d880b3dd8$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $3588602d880b3dd8$export$daf73786167a7f72(matches) {
    return $3588602d880b3dd8$var$_renderMatches(matches);
}
function $3588602d880b3dd8$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7E7Dk.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7E7Dk.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7E7Dk.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $3588602d880b3dd8$export$f30f7e456d254e83(routes, opts) {
    return (0, $bBszO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3588602d880b3dd8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bBszO.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $3588602d880b3dd8$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}

});


parcelRegister("2rQNl", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $1c870e56aff9f33e$export$cc80c08dc91f1c00; });
$parcel$export(module.exports, "useSelector", function () { return $1c870e56aff9f33e$export$2105062e25df4afe; });
$parcel$export(module.exports, "shallowEqual", function () { return $1c870e56aff9f33e$export$d36bdfa510afb180; });
$parcel$export(module.exports, "Provider", function () { return $1c870e56aff9f33e$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useStore", function () { return $1c870e56aff9f33e$export$6ccbb43953eebf8; });
$parcel$export(module.exports, "useDispatch", function () { return $1c870e56aff9f33e$export$8ad76b76a4c905f8; });
$parcel$export(module.exports, "batch", function () { return $1c870e56aff9f33e$export$712ea50be43a7858; });

var $7E7Dk = parcelRequire("7E7Dk");

var $CBzEb = parcelRequire("CBzEb");
var $1c870e56aff9f33e$var$__defProp = Object.defineProperty;
var $1c870e56aff9f33e$var$__defProps = Object.defineProperties;
var $1c870e56aff9f33e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1c870e56aff9f33e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1c870e56aff9f33e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1c870e56aff9f33e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1c870e56aff9f33e$var$__defNormalProp = (obj, key, value)=>key in obj ? $1c870e56aff9f33e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1c870e56aff9f33e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1c870e56aff9f33e$var$__hasOwnProp.call(b, prop)) $1c870e56aff9f33e$var$__defNormalProp(a, prop, b[prop]);
    if ($1c870e56aff9f33e$var$__getOwnPropSymbols) {
        for (var prop of $1c870e56aff9f33e$var$__getOwnPropSymbols(b))if ($1c870e56aff9f33e$var$__propIsEnum.call(b, prop)) $1c870e56aff9f33e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1c870e56aff9f33e$var$__spreadProps = (a, b)=>$1c870e56aff9f33e$var$__defProps(a, $1c870e56aff9f33e$var$__getOwnPropDescs(b));
var $1c870e56aff9f33e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1c870e56aff9f33e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1c870e56aff9f33e$var$__getOwnPropSymbols) {
        for (var prop of $1c870e56aff9f33e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1c870e56aff9f33e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $1c870e56aff9f33e$var$React = // prettier-ignore
// @ts-ignore
"default" in $7E7Dk ? $7E7Dk["default"] : $7E7Dk;
// src/components/Context.ts
var $1c870e56aff9f33e$var$ContextKey = Symbol.for(`react-redux-context`);
var $1c870e56aff9f33e$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $1c870e56aff9f33e$var$getContext() {
    var _a;
    if (!$1c870e56aff9f33e$var$React.createContext) return {};
    const contextMap = (_a = $1c870e56aff9f33e$var$gT[$1c870e56aff9f33e$var$ContextKey]) != null ? _a : $1c870e56aff9f33e$var$gT[$1c870e56aff9f33e$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($1c870e56aff9f33e$var$React.createContext);
    if (!realContext) {
        realContext = $1c870e56aff9f33e$var$React.createContext(null);
        contextMap.set($1c870e56aff9f33e$var$React.createContext, realContext);
    }
    return realContext;
}
var $1c870e56aff9f33e$export$cc80c08dc91f1c00 = /* @__PURE__ */ $1c870e56aff9f33e$var$getContext();
// src/utils/useSyncExternalStore.ts
var $1c870e56aff9f33e$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $1c870e56aff9f33e$var$createReduxContextHook(context = $1c870e56aff9f33e$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $1c870e56aff9f33e$var$React.useContext(context);
        return contextValue;
    };
}
var $1c870e56aff9f33e$var$useReduxContext = /* @__PURE__ */ $1c870e56aff9f33e$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $1c870e56aff9f33e$var$useSyncExternalStoreWithSelector = $1c870e56aff9f33e$var$notInitialized;
var $1c870e56aff9f33e$var$initializeUseSelector = (fn)=>{
    $1c870e56aff9f33e$var$useSyncExternalStoreWithSelector = fn;
};
var $1c870e56aff9f33e$var$refEquality = (a, b)=>a === b;
function $1c870e56aff9f33e$export$2b53f90d2bd1cbfb(context = $1c870e56aff9f33e$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $1c870e56aff9f33e$export$cc80c08dc91f1c00 ? $1c870e56aff9f33e$var$useReduxContext : $1c870e56aff9f33e$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $1c870e56aff9f33e$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $1c870e56aff9f33e$var$React.useRef(true);
        const wrappedSelector = $1c870e56aff9f33e$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $1c870e56aff9f33e$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $1c870e56aff9f33e$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $1c870e56aff9f33e$export$2105062e25df4afe = /* @__PURE__ */ $1c870e56aff9f33e$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $1c870e56aff9f33e$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $1c870e56aff9f33e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $1c870e56aff9f33e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $1c870e56aff9f33e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $1c870e56aff9f33e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $1c870e56aff9f33e$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $1c870e56aff9f33e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $1c870e56aff9f33e$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $1c870e56aff9f33e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $1c870e56aff9f33e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $1c870e56aff9f33e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $1c870e56aff9f33e$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $1c870e56aff9f33e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $1c870e56aff9f33e$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $1c870e56aff9f33e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $1c870e56aff9f33e$var$ForwardRef = $1c870e56aff9f33e$var$REACT_FORWARD_REF_TYPE;
var $1c870e56aff9f33e$var$Memo = $1c870e56aff9f33e$var$REACT_MEMO_TYPE;
function $1c870e56aff9f33e$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $1c870e56aff9f33e$var$REACT_FRAGMENT_TYPE || type === $1c870e56aff9f33e$var$REACT_PROFILER_TYPE || type === $1c870e56aff9f33e$var$REACT_STRICT_MODE_TYPE || type === $1c870e56aff9f33e$var$REACT_SUSPENSE_TYPE || type === $1c870e56aff9f33e$var$REACT_SUSPENSE_LIST_TYPE || type === $1c870e56aff9f33e$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $1c870e56aff9f33e$var$REACT_LAZY_TYPE || type.$$typeof === $1c870e56aff9f33e$var$REACT_MEMO_TYPE || type.$$typeof === $1c870e56aff9f33e$var$REACT_PROVIDER_TYPE || type.$$typeof === $1c870e56aff9f33e$var$REACT_CONTEXT_TYPE || type.$$typeof === $1c870e56aff9f33e$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $1c870e56aff9f33e$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $1c870e56aff9f33e$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $1c870e56aff9f33e$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $1c870e56aff9f33e$var$REACT_FRAGMENT_TYPE:
                        case $1c870e56aff9f33e$var$REACT_PROFILER_TYPE:
                        case $1c870e56aff9f33e$var$REACT_STRICT_MODE_TYPE:
                        case $1c870e56aff9f33e$var$REACT_SUSPENSE_TYPE:
                        case $1c870e56aff9f33e$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $1c870e56aff9f33e$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $1c870e56aff9f33e$var$REACT_CONTEXT_TYPE:
                                    case $1c870e56aff9f33e$var$REACT_FORWARD_REF_TYPE:
                                    case $1c870e56aff9f33e$var$REACT_LAZY_TYPE:
                                    case $1c870e56aff9f33e$var$REACT_MEMO_TYPE:
                                    case $1c870e56aff9f33e$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $1c870e56aff9f33e$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $1c870e56aff9f33e$var$isContextConsumer(object) {
    return $1c870e56aff9f33e$var$typeOf(object) === $1c870e56aff9f33e$var$REACT_CONTEXT_TYPE;
}
function $1c870e56aff9f33e$var$isMemo(object) {
    return $1c870e56aff9f33e$var$typeOf(object) === $1c870e56aff9f33e$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $1c870e56aff9f33e$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $1c870e56aff9f33e$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $1c870e56aff9f33e$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $1c870e56aff9f33e$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $1c870e56aff9f33e$var$verify(mapStateToProps, "mapStateToProps");
    $1c870e56aff9f33e$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $1c870e56aff9f33e$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $1c870e56aff9f33e$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $1c870e56aff9f33e$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $1c870e56aff9f33e$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $1c870e56aff9f33e$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $1c870e56aff9f33e$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $1c870e56aff9f33e$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $1c870e56aff9f33e$var$verifyPlainObject(value, displayName, methodName) {
    if (!$1c870e56aff9f33e$var$isPlainObject(value)) $1c870e56aff9f33e$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $1c870e56aff9f33e$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $1c870e56aff9f33e$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $1c870e56aff9f33e$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $1c870e56aff9f33e$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $1c870e56aff9f33e$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $1c870e56aff9f33e$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $1c870e56aff9f33e$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $1c870e56aff9f33e$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $1c870e56aff9f33e$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $1c870e56aff9f33e$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $1c870e56aff9f33e$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $1c870e56aff9f33e$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $1c870e56aff9f33e$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $1c870e56aff9f33e$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $1c870e56aff9f33e$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $1c870e56aff9f33e$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $1c870e56aff9f33e$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $1c870e56aff9f33e$var$__spreadValues($1c870e56aff9f33e$var$__spreadValues($1c870e56aff9f33e$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $1c870e56aff9f33e$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $1c870e56aff9f33e$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$1c870e56aff9f33e$var$defaultMergeProps : typeof mergeProps === "function" ? $1c870e56aff9f33e$var$wrapMergePropsFunc(mergeProps) : $1c870e56aff9f33e$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $1c870e56aff9f33e$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $1c870e56aff9f33e$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $1c870e56aff9f33e$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $1c870e56aff9f33e$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $1c870e56aff9f33e$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $1c870e56aff9f33e$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $1c870e56aff9f33e$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $1c870e56aff9f33e$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $1c870e56aff9f33e$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $1c870e56aff9f33e$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $1c870e56aff9f33e$var$useIsomorphicLayoutEffect = $1c870e56aff9f33e$var$canUseDOM || $1c870e56aff9f33e$var$isReactNative ? $1c870e56aff9f33e$var$React.useLayoutEffect : $1c870e56aff9f33e$var$React.useEffect;
// src/utils/shallowEqual.ts
function $1c870e56aff9f33e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1c870e56aff9f33e$export$d36bdfa510afb180(objA, objB) {
    if ($1c870e56aff9f33e$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$1c870e56aff9f33e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $1c870e56aff9f33e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $1c870e56aff9f33e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $1c870e56aff9f33e$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $1c870e56aff9f33e$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $1c870e56aff9f33e$var$TYPE_STATICS = {
    [$1c870e56aff9f33e$var$ForwardRef]: $1c870e56aff9f33e$var$FORWARD_REF_STATICS,
    [$1c870e56aff9f33e$var$Memo]: $1c870e56aff9f33e$var$MEMO_STATICS
};
function $1c870e56aff9f33e$var$getStatics(component) {
    if ($1c870e56aff9f33e$var$isMemo(component)) return $1c870e56aff9f33e$var$MEMO_STATICS;
    return $1c870e56aff9f33e$var$TYPE_STATICS[component["$$typeof"]] || $1c870e56aff9f33e$var$REACT_STATICS;
}
var $1c870e56aff9f33e$var$defineProperty = Object.defineProperty;
var $1c870e56aff9f33e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $1c870e56aff9f33e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1c870e56aff9f33e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1c870e56aff9f33e$var$getPrototypeOf = Object.getPrototypeOf;
var $1c870e56aff9f33e$var$objectPrototype = Object.prototype;
function $1c870e56aff9f33e$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($1c870e56aff9f33e$var$objectPrototype) {
            const inheritedComponent = $1c870e56aff9f33e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $1c870e56aff9f33e$var$objectPrototype) $1c870e56aff9f33e$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $1c870e56aff9f33e$var$getOwnPropertyNames(sourceComponent);
        if ($1c870e56aff9f33e$var$getOwnPropertySymbols) keys = keys.concat($1c870e56aff9f33e$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $1c870e56aff9f33e$var$getStatics(targetComponent);
        const sourceStatics = $1c870e56aff9f33e$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$1c870e56aff9f33e$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $1c870e56aff9f33e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $1c870e56aff9f33e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $1c870e56aff9f33e$var$useSyncExternalStore = $1c870e56aff9f33e$var$notInitialized;
var $1c870e56aff9f33e$var$initializeConnect = (fn)=>{
    $1c870e56aff9f33e$var$useSyncExternalStore = fn;
};
var $1c870e56aff9f33e$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1c870e56aff9f33e$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1c870e56aff9f33e$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $1c870e56aff9f33e$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $1c870e56aff9f33e$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1c870e56aff9f33e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $1c870e56aff9f33e$var$strictEqual(a, b) {
    return a === b;
}
var $1c870e56aff9f33e$var$hasWarnedAboutDeprecatedPureOption = false;
function $1c870e56aff9f33e$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $1c870e56aff9f33e$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $1c870e56aff9f33e$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $1c870e56aff9f33e$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $1c870e56aff9f33e$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $1c870e56aff9f33e$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $1c870e56aff9f33e$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $1c870e56aff9f33e$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $1c870e56aff9f33e$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $1c870e56aff9f33e$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $1c870e56aff9f33e$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $1c870e56aff9f33e$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $1c870e56aff9f33e$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $1c870e56aff9f33e$var$React.useMemo(()=>{
                return $1c870e56aff9f33e$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $1c870e56aff9f33e$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $1c870e56aff9f33e$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $1c870e56aff9f33e$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $1c870e56aff9f33e$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $1c870e56aff9f33e$var$__spreadProps($1c870e56aff9f33e$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $1c870e56aff9f33e$var$React.useRef(void 0);
            const lastWrapperProps = $1c870e56aff9f33e$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $1c870e56aff9f33e$var$React.useRef(void 0);
            const renderIsScheduled = $1c870e56aff9f33e$var$React.useRef(false);
            const isMounted = $1c870e56aff9f33e$var$React.useRef(false);
            const latestSubscriptionCallbackError = $1c870e56aff9f33e$var$React.useRef(void 0);
            $1c870e56aff9f33e$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $1c870e56aff9f33e$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $1c870e56aff9f33e$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $1c870e56aff9f33e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $1c870e56aff9f33e$var$useIsomorphicLayoutEffectWithArgs($1c870e56aff9f33e$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $1c870e56aff9f33e$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $1c870e56aff9f33e$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $1c870e56aff9f33e$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $1c870e56aff9f33e$var$React.createElement(WrappedComponent, $1c870e56aff9f33e$var$__spreadProps($1c870e56aff9f33e$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $1c870e56aff9f33e$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $1c870e56aff9f33e$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $1c870e56aff9f33e$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $1c870e56aff9f33e$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $1c870e56aff9f33e$var$React.createElement(Connect, $1c870e56aff9f33e$var$__spreadProps($1c870e56aff9f33e$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $1c870e56aff9f33e$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $1c870e56aff9f33e$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $1c870e56aff9f33e$export$64605811ab45167f = $1c870e56aff9f33e$var$connect;
// src/components/Provider.tsx
function $1c870e56aff9f33e$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $1c870e56aff9f33e$var$React.useMemo(()=>{
        const subscription = $1c870e56aff9f33e$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $1c870e56aff9f33e$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $1c870e56aff9f33e$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $1c870e56aff9f33e$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $1c870e56aff9f33e$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $1c870e56aff9f33e$export$2881499e37b75b9a = $1c870e56aff9f33e$var$Provider;
// src/hooks/useStore.ts
function $1c870e56aff9f33e$export$671dba69185d0304(context = $1c870e56aff9f33e$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $1c870e56aff9f33e$export$cc80c08dc91f1c00 ? $1c870e56aff9f33e$var$useReduxContext : // @ts-ignore
    $1c870e56aff9f33e$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $1c870e56aff9f33e$export$6ccbb43953eebf8 = /* @__PURE__ */ $1c870e56aff9f33e$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $1c870e56aff9f33e$export$bc9b55530897c558(context = $1c870e56aff9f33e$export$cc80c08dc91f1c00) {
    const useStore2 = context === $1c870e56aff9f33e$export$cc80c08dc91f1c00 ? $1c870e56aff9f33e$export$6ccbb43953eebf8 : $1c870e56aff9f33e$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $1c870e56aff9f33e$export$8ad76b76a4c905f8 = /* @__PURE__ */ $1c870e56aff9f33e$export$bc9b55530897c558();
// src/exports.ts
var $1c870e56aff9f33e$export$712ea50be43a7858 = $1c870e56aff9f33e$var$defaultNoopBatch;
// src/index.ts
$1c870e56aff9f33e$var$initializeUseSelector((0, $CBzEb.useSyncExternalStoreWithSelector));
$1c870e56aff9f33e$var$initializeConnect($7E7Dk.useSyncExternalStore);

});
parcelRegister("CBzEb", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jKvIB"));

});
parcelRegister("jKvIB", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $e60aeaca9eb7a3b3$export$bf730a2d8bf68b42; }, function (v) { return $e60aeaca9eb7a3b3$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e60aeaca9eb7a3b3$export$bf730a2d8bf68b42;
"use strict";

var $7E7Dk = parcelRequire("7E7Dk");
function $e60aeaca9eb7a3b3$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e60aeaca9eb7a3b3$var$p = "function" === typeof Object.is ? Object.is : $e60aeaca9eb7a3b3$var$n, $e60aeaca9eb7a3b3$var$q = $7E7Dk.useSyncExternalStore, $e60aeaca9eb7a3b3$var$r = $7E7Dk.useRef, $e60aeaca9eb7a3b3$var$t = $7E7Dk.useEffect, $e60aeaca9eb7a3b3$var$u = $7E7Dk.useMemo, $e60aeaca9eb7a3b3$var$v = $7E7Dk.useDebugValue;
$e60aeaca9eb7a3b3$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $e60aeaca9eb7a3b3$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $e60aeaca9eb7a3b3$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($e60aeaca9eb7a3b3$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $e60aeaca9eb7a3b3$var$q(a, c[0], c[1]);
    $e60aeaca9eb7a3b3$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $e60aeaca9eb7a3b3$var$v(d);
    return d;
};

});



parcelRegister("eHYdO", function(module, exports) {

$parcel$export(module.exports, "FilterMatchMode", function () { return $ab53cba4f1f38789$export$b9fbdf9129f67822; });
$parcel$export(module.exports, "FilterOperator", function () { return $ab53cba4f1f38789$export$9cc7a9d8d8c733ca; });
$parcel$export(module.exports, "FilterService", function () { return $ab53cba4f1f38789$export$f4fb036b8adcc8c8; });
$parcel$export(module.exports, "localeOptions", function () { return $ab53cba4f1f38789$export$ef9c48731c26e22d; });
$parcel$export(module.exports, "localeOption", function () { return $ab53cba4f1f38789$export$aa1e8754cc4d1e7a; });
$parcel$export(module.exports, "ariaLabel", function () { return $ab53cba4f1f38789$export$eb839c9fd3d638b9; });
$parcel$export(module.exports, "PrimeIcons", function () { return $ab53cba4f1f38789$export$9daa7f1467519fd8; });
$parcel$export(module.exports, "PrimeReactContext", function () { return $ab53cba4f1f38789$export$43502877ff87a530; });
$parcel$export(module.exports, "PrimeReactProvider", function () { return $ab53cba4f1f38789$export$6a5b5c2279ff1e8d; });
$parcel$export(module.exports, "default", function () { return $ab53cba4f1f38789$export$2e2bcd8739ae039; });

var $7nrKB = parcelRequire("7nrKB");

var $7E7Dk = parcelRequire("7E7Dk");
"use client";
var $ab53cba4f1f38789$export$b9fbdf9129f67822 = Object.freeze({
    STARTS_WITH: "startsWith",
    CONTAINS: "contains",
    NOT_CONTAINS: "notContains",
    ENDS_WITH: "endsWith",
    EQUALS: "equals",
    NOT_EQUALS: "notEquals",
    IN: "in",
    NOT_IN: "notIn",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUAL_TO: "lte",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUAL_TO: "gte",
    BETWEEN: "between",
    DATE_IS: "dateIs",
    DATE_IS_NOT: "dateIsNot",
    DATE_BEFORE: "dateBefore",
    DATE_AFTER: "dateAfter",
    CUSTOM: "custom"
});
var $ab53cba4f1f38789$export$9cc7a9d8d8c733ca = Object.freeze({
    AND: "and",
    OR: "or"
});
function $ab53cba4f1f38789$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ab53cba4f1f38789$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ab53cba4f1f38789$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $ab53cba4f1f38789$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ab53cba4f1f38789$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $ab53cba4f1f38789$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $ab53cba4f1f38789$export$f4fb036b8adcc8c8 = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = $ab53cba4f1f38789$var$_createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === "string") {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = $ab53cba4f1f38789$var$_createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, $7nrKB.ObjectUtils).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            return (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            return (0, $7nrKB.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, $7nrKB.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $7nrKB.ObjectUtils).equals(value, filter[i])) return true;
            }
            return false;
        },
        notIn: function notIn(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $7nrKB.ObjectUtils).equals(value, filter[i])) return false;
            }
            return true;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function $ab53cba4f1f38789$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ab53cba4f1f38789$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab53cba4f1f38789$var$_typeof(o);
}
function $ab53cba4f1f38789$var$toPrimitive(t, r) {
    if ("object" != $ab53cba4f1f38789$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ab53cba4f1f38789$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab53cba4f1f38789$var$toPropertyKey(t) {
    var i = $ab53cba4f1f38789$var$toPrimitive(t, "string");
    return "symbol" == $ab53cba4f1f38789$var$_typeof(i) ? i : i + "";
}
function $ab53cba4f1f38789$var$_defineProperty(e, r, t) {
    return (r = $ab53cba4f1f38789$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab53cba4f1f38789$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ab53cba4f1f38789$var$toPropertyKey(o.key), o);
    }
}
function $ab53cba4f1f38789$var$_createClass(e, r, t) {
    return r && $ab53cba4f1f38789$var$_defineProperties(e.prototype, r), t && $ab53cba4f1f38789$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $ab53cba4f1f38789$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @deprecated please use PrimeReactContext
 */ var $ab53cba4f1f38789$var$PrimeReact$1 = /*#__PURE__*/ $ab53cba4f1f38789$var$_createClass(function PrimeReact() {
    $ab53cba4f1f38789$var$_classCallCheck(this, PrimeReact);
});
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "ripple", false);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "inputStyle", "outlined");
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "locale", "en");
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "appendTo", null);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "cssTransition", true);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "autoZIndex", true);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "hideOverlaysOnDocumentScrolling", false);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "nonce", null);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "nullSortOrder", 1);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "pt", undefined);
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "filterMatchModeOptions", {
    text: [
        $ab53cba4f1f38789$export$b9fbdf9129f67822.STARTS_WITH,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.CONTAINS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_CONTAINS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.ENDS_WITH,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.EQUALS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_EQUALS
    ],
    numeric: [
        $ab53cba4f1f38789$export$b9fbdf9129f67822.EQUALS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_EQUALS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.LESS_THAN,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.GREATER_THAN,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_IS,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_IS_NOT,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_BEFORE,
        $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_AFTER
    ]
});
$ab53cba4f1f38789$var$_defineProperty($ab53cba4f1f38789$var$PrimeReact$1, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
    var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
    var newLinkElement = document.createElement("link");
    newLinkElement.setAttribute("rel", "stylesheet");
    newLinkElement.setAttribute("id", linkElementId);
    newLinkElement.setAttribute("href", newThemeUrl);
    newLinkElement.addEventListener("load", function() {
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
});
function $ab53cba4f1f38789$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab53cba4f1f38789$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab53cba4f1f38789$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab53cba4f1f38789$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab53cba4f1f38789$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab53cba4f1f38789$var$locales = {
    en: {
        accept: "Yes",
        addRule: "Add Rule",
        am: "AM",
        apply: "Apply",
        cancel: "Cancel",
        choose: "Choose",
        chooseDate: "Choose Date",
        chooseMonth: "Choose Month",
        chooseYear: "Choose Year",
        clear: "Clear",
        completed: "Completed",
        contains: "Contains",
        custom: "Custom",
        dateAfter: "Date is after",
        dateBefore: "Date is before",
        dateFormat: "mm/dd/yy",
        dateIs: "Date is",
        dateIsNot: "Date is not",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        emptyFilterMessage: "No results found",
        emptyMessage: "No available options",
        emptySearchMessage: "No results found",
        emptySelectionMessage: "No selected item",
        endsWith: "Ends with",
        equals: "Equals",
        fileChosenMessage: "{0} files",
        fileSizeTypes: [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        filter: "Filter",
        firstDayOfWeek: 0,
        gt: "Greater than",
        gte: "Greater than or equal to",
        lt: "Less than",
        lte: "Less than or equal to",
        matchAll: "Match All",
        matchAny: "Match Any",
        medium: "Medium",
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        nextDecade: "Next Decade",
        nextHour: "Next Hour",
        nextMinute: "Next Minute",
        nextMonth: "Next Month",
        nextSecond: "Next Second",
        nextYear: "Next Year",
        noFileChosenMessage: "No file chosen",
        noFilter: "No Filter",
        notContains: "Not contains",
        notEquals: "Not equals",
        now: "Now",
        passwordPrompt: "Enter a password",
        pending: "Pending",
        pm: "PM",
        prevDecade: "Previous Decade",
        prevHour: "Previous Hour",
        prevMinute: "Previous Minute",
        prevMonth: "Previous Month",
        prevSecond: "Previous Second",
        prevYear: "Previous Year",
        reject: "No",
        removeRule: "Remove Rule",
        searchMessage: "{0} results are available",
        selectionMessage: "{0} items selected",
        showMonthAfterYear: false,
        startsWith: "Starts with",
        strong: "Strong",
        today: "Today",
        upload: "Upload",
        weak: "Weak",
        weekHeader: "Wk",
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Close",
            collapseLabel: "Collapse",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandLabel: "Expand",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listLabel: "Option List",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            otpLabel: "Please enter one time password character {0}",
            pageLabel: "Page {page}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            prevPageLabel: "Previous Page",
            removeLabel: "Remove",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectLabel: "Select",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectLabel: "Unselect",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
function $ab53cba4f1f38789$export$162ce11d62a1ca51(locale) {
    locale && ($ab53cba4f1f38789$var$PrimeReact$1.locale = locale);
    return {
        locale: $ab53cba4f1f38789$var$PrimeReact$1.locale,
        options: $ab53cba4f1f38789$var$locales[$ab53cba4f1f38789$var$PrimeReact$1.locale]
    };
}
function $ab53cba4f1f38789$export$3ab428da39598a54(locale, options) {
    if (locale.includes("__proto__") || locale.includes("prototype")) throw new Error("Unsafe locale detected");
    $ab53cba4f1f38789$var$locales[locale] = $ab53cba4f1f38789$var$_objectSpread($ab53cba4f1f38789$var$_objectSpread({}, $ab53cba4f1f38789$var$locales.en), options);
}
function $ab53cba4f1f38789$export$7cd3e26e5d06a8a9(key, value, locale) {
    if (key.includes("__proto__") || key.includes("prototype")) throw new Error("Unsafe key detected");
    $ab53cba4f1f38789$export$ef9c48731c26e22d(locale)[key] = value;
}
function $ab53cba4f1f38789$export$8024ed7ed764e4fc(options, locale) {
    if (locale.includes("__proto__") || locale.includes("prototype")) throw new Error("Unsafe locale detected");
    var _locale = locale || $ab53cba4f1f38789$var$PrimeReact$1.locale;
    $ab53cba4f1f38789$var$locales[_locale] = $ab53cba4f1f38789$var$_objectSpread($ab53cba4f1f38789$var$_objectSpread({}, $ab53cba4f1f38789$var$locales[_locale]), options);
}
function $ab53cba4f1f38789$export$aa1e8754cc4d1e7a(key, locale) {
    if (key.includes("__proto__") || key.includes("prototype")) throw new Error("Unsafe key detected");
    var _locale = locale || $ab53cba4f1f38789$var$PrimeReact$1.locale;
    try {
        return $ab53cba4f1f38789$export$ef9c48731c26e22d(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $ab53cba4f1f38789$export$eb839c9fd3d638b9(ariaKey, options) {
    if (ariaKey.includes("__proto__") || ariaKey.includes("prototype")) throw new Error("Unsafe ariaKey detected");
    var _locale = $ab53cba4f1f38789$var$PrimeReact$1.locale;
    try {
        var _ariaLabel = $ab53cba4f1f38789$export$ef9c48731c26e22d(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $ab53cba4f1f38789$export$ef9c48731c26e22d(locale) {
    var _locale = locale || $ab53cba4f1f38789$var$PrimeReact$1.locale;
    if (_locale.includes("__proto__") || _locale.includes("prototype")) throw new Error("Unsafe locale detected");
    return $ab53cba4f1f38789$var$locales[_locale];
}
var $ab53cba4f1f38789$export$bb45678bd9ad9127 = Object.freeze({
    SUCCESS: "success",
    INFO: "info",
    WARN: "warn",
    ERROR: "error",
    SECONDARY: "secondary",
    CONTRAST: "contrast"
});
var $ab53cba4f1f38789$export$9daa7f1467519fd8 = Object.freeze({
    ADDRESS_BOOK: "pi pi-address-book",
    ALIGN_CENTER: "pi pi-align-center",
    ALIGN_JUSTIFY: "pi pi-align-justify",
    ALIGN_LEFT: "pi pi-align-left",
    ALIGN_RIGHT: "pi pi-align-right",
    AMAZON: "pi pi-amazon",
    ANDROID: "pi pi-android",
    ANGLE_DOUBLE_DOWN: "pi pi-angle-double-down",
    ANGLE_DOUBLE_LEFT: "pi pi-angle-double-left",
    ANGLE_DOUBLE_RIGHT: "pi pi-angle-double-right",
    ANGLE_DOUBLE_UP: "pi pi-angle-double-up",
    ANGLE_DOWN: "pi pi-angle-down",
    ANGLE_LEFT: "pi pi-angle-left",
    ANGLE_RIGHT: "pi pi-angle-right",
    ANGLE_UP: "pi pi-angle-up",
    APPLE: "pi pi-apple",
    ARROW_CIRCLE_DOWN: "pi pi-arrow-circle-down",
    ARROW_CIRCLE_LEFT: "pi pi-arrow-circle-left",
    ARROW_CIRCLE_RIGHT: "pi pi-arrow-circle-right",
    ARROW_CIRCLE_UP: "pi pi-arrow-circle-up",
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: "pi pi-arrow-down-left-and-arrow-up-right-to-center",
    ARROW_DOWN_LEFT: "pi pi-arrow-down-left",
    ARROW_DOWN_RIGHT: "pi pi-arrow-down-right",
    ARROW_DOWN: "pi pi-arrow-down",
    ARROW_LEFT: "pi pi-arrow-left",
    ARROW_RIGHT_ARROW_LEFT: "pi pi-arrow-right-arrow-left",
    ARROW_RIGHT: "pi pi-arrow-right",
    ARROW_UP_LEFT: "pi pi-arrow-up-left",
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: "pi pi-arrow-up-right-and-arrow-down-left-from-center",
    ARROW_UP_RIGHT: "pi pi-arrow-up-right",
    ARROW_UP: "pi pi-arrow-up",
    ARROWS_ALT: "pi pi-arrows-alt",
    ARROWS_H: "pi pi-arrows-h",
    ARROWS_V: "pi pi-arrows-v",
    ASTERISK: "pi pi-asterisk",
    AT: "pi pi-at",
    BACKWARD: "pi pi-backward",
    BAN: "pi pi-ban",
    BARCODE: "pi pi-barcode",
    BARS: "pi pi-bars",
    BELL_SLASH: "pi pi-bell-slash",
    BELL: "pi pi-bell",
    BITCOIN: "pi pi-bitcoin",
    BOLT: "pi pi-bolt",
    BOOK: "pi pi-book",
    BOOKMARK_FILL: "pi pi-bookmark-fill",
    BOOKMARK: "pi pi-bookmark",
    BOX: "pi pi-box",
    BRIEFCASE: "pi pi-briefcase",
    BUILDING_COLUMNS: "pi pi-building-columns",
    BUILDING: "pi pi-building",
    BULLSEYE: "pi pi-bullseye",
    CALCULATOR: "pi pi-calculator",
    CALENDAR_CLOCK: "pi pi-calendar-clock",
    CALENDAR_MINUS: "pi pi-calendar-minus",
    CALENDAR_PLUS: "pi pi-calendar-plus",
    CALENDAR_TIMES: "pi pi-calendar-times",
    CALENDAR: "pi pi-calendar",
    CAMERA: "pi pi-camera",
    CAR: "pi pi-car",
    CARET_DOWN: "pi pi-caret-down",
    CARET_LEFT: "pi pi-caret-left",
    CARET_RIGHT: "pi pi-caret-right",
    CARET_UP: "pi pi-caret-up",
    CART_ARROW_DOWN: "pi pi-cart-arrow-down",
    CART_MINUS: "pi pi-cart-minus",
    CART_PLUS: "pi pi-cart-plus",
    CHART_BAR: "pi pi-chart-bar",
    CHART_LINE: "pi pi-chart-line",
    CHART_PIE: "pi pi-chart-pie",
    CHART_SCATTER: "pi pi-chart-scatter",
    CHECK_CIRCLE: "pi pi-check-circle",
    CHECK_SQUARE: "pi pi-check-square",
    CHECK: "pi pi-check",
    CHEVRON_CIRCLE_DOWN: "pi pi-chevron-circle-down",
    CHEVRON_CIRCLE_LEFT: "pi pi-chevron-circle-left",
    CHEVRON_CIRCLE_RIGHT: "pi pi-chevron-circle-right",
    CHEVRON_CIRCLE_UP: "pi pi-chevron-circle-up",
    CHEVRON_DOWN: "pi pi-chevron-down",
    CHEVRON_LEFT: "pi pi-chevron-left",
    CHEVRON_RIGHT: "pi pi-chevron-right",
    CHEVRON_UP: "pi pi-chevron-up",
    CIRCLE_FILL: "pi pi-circle-fill",
    CIRCLE_OFF: "pi pi-circle-off",
    CIRCLE_ON: "pi pi-circle-on",
    CIRCLE: "pi pi-circle",
    CLIPBOARD: "pi pi-clipboard",
    CLOCK: "pi pi-clock",
    CLONE: "pi pi-clone",
    CLOUD_DOWNLOAD: "pi pi-cloud-download",
    CLOUD_UPLOAD: "pi pi-cloud-upload",
    CLOUD: "pi pi-cloud",
    CODE: "pi pi-code",
    COG: "pi pi-cog",
    COMMENT: "pi pi-comment",
    COMMENTS: "pi pi-comments",
    COMPASS: "pi pi-compass",
    COPY: "pi pi-copy",
    CREDIT_CARD: "pi pi-credit-card",
    CROWN: "pi pi-crown",
    DATABASE: "pi pi-database",
    DELETE_LEFT: "pi pi-delete-left",
    DESKTOP: "pi pi-desktop",
    DIRECTIONS_ALT: "pi pi-directions-alt",
    DIRECTIONS: "pi pi-directions",
    DISCORD: "pi pi-discord",
    DOLLAR: "pi pi-dollar",
    DOWNLOAD: "pi pi-download",
    EJECT: "pi pi-eject",
    ELLIPSIS_H: "pi pi-ellipsis-h",
    ELLIPSIS_V: "pi pi-ellipsis-v",
    ENVELOPE: "pi pi-envelope",
    EQUALS: "pi pi-equals",
    ERASER: "pi pi-eraser",
    ETHEREUM: "pi pi-ethereum",
    EURO: "pi pi-euro",
    EXCLAMATION_CIRCLE: "pi pi-exclamation-circle",
    EXCLAMATION_TRIANGLE: "pi pi-exclamation-triangle",
    EXPAND: "pi pi-expand",
    EXTERNAL_LINK: "pi pi-external-link",
    EYE_SLASH: "pi pi-eye-slash",
    EYE: "pi pi-eye",
    FACE_SMILE: "pi pi-face-smile",
    FACEBOOK: "pi pi-facebook",
    FAST_BACKWARD: "pi pi-fast-backward",
    FAST_FORWARD: "pi pi-fast-forward",
    FILE_ARROW_UP: "pi pi-file-arrow-up",
    FILE_CHECK: "pi pi-file-check",
    FILE_EDIT: "pi pi-file-edit",
    FILE_EXCEL: "pi pi-file-excel",
    FILE_EXPORT: "pi pi-file-export",
    FILE_IMPORT: "pi pi-file-import",
    FILE_O: "pi pi-file-o",
    FILE_PDF: "pi pi-file-pdf",
    FILE_PLUS: "pi pi-file-plus",
    FILE_WORD: "pi pi-file-word",
    FILE: "pi pi-file",
    FILTER_FILL: "pi pi-filter-fill",
    FILTER_SLASH: "pi pi-filter-slash",
    FILTER: "pi pi-filter",
    FLAG_FILL: "pi pi-flag-fill",
    FLAG: "pi pi-flag",
    FOLDER_OPEN: "pi pi-folder-open",
    FOLDER_PLUS: "pi pi-folder-plus",
    FOLDER: "pi pi-folder",
    FORWARD: "pi pi-forward",
    GAUGE: "pi pi-gauge",
    GIFT: "pi pi-gift",
    GITHUB: "pi pi-github",
    GLOBE: "pi pi-globe",
    GOOGLE: "pi pi-google",
    GRADUATION_CAP: "pi pi-graduation-cap",
    HAMMER: "pi pi-hammer",
    HASHTAG: "pi pi-hashtag",
    HEADPHONES: "pi pi-headphones",
    HEART_FILL: "pi pi-heart-fill",
    HEART: "pi pi-heart",
    HISTORY: "pi pi-history",
    HOME: "pi pi-home",
    HOURGLASS: "pi pi-hourglass",
    ID_CARD: "pi pi-id-card",
    IMAGE: "pi pi-image",
    IMAGES: "pi pi-images",
    INBOX: "pi pi-inbox",
    INDIAN_RUPEE: "pi pi-indian-rupee",
    INFO_CIRCLE: "pi pi-info-circle",
    INFO: "pi pi-info",
    INSTAGRAM: "pi pi-instagram",
    KEY: "pi pi-key",
    LANGUAGE: "pi pi-language",
    LIGHTBULB: "pi pi-lightbulb",
    LINK: "pi pi-link",
    LINKEDIN: "pi pi-linkedin",
    LIST_CHECK: "pi pi-list-check",
    LIST: "pi pi-list",
    LOCK_OPEN: "pi pi-lock-open",
    LOCK: "pi pi-lock",
    MAP_MARKER: "pi pi-map-marker",
    MAP: "pi pi-map",
    MARS: "pi pi-mars",
    MEGAPHONE: "pi pi-megaphone",
    MICROCHIP_AI: "pi pi-microchip-ai",
    MICROCHIP: "pi pi-microchip",
    MICROPHONE: "pi pi-microphone",
    MICROSOFT: "pi pi-microsoft",
    MINUS_CIRCLE: "pi pi-minus-circle",
    MINUS: "pi pi-minus",
    MOBILE: "pi pi-mobile",
    MONEY_BILL: "pi pi-money-bill",
    MOON: "pi pi-moon",
    OBJECTS_COLUMN: "pi pi-objects-column",
    PALETTE: "pi pi-palette",
    PAPERCLIP: "pi pi-paperclip",
    PAUSE_CIRCLE: "pi pi-pause-circle",
    PAUSE: "pi pi-pause",
    PAYPAL: "pi pi-paypal",
    PEN_TO_SQUARE: "pi pi-pen-to-square",
    PENCIL: "pi pi-pencil",
    PERCENTAGE: "pi pi-percentage",
    PHONE: "pi pi-phone",
    PINTEREST: "pi pi-pinterest",
    PLAY_CIRCLE: "pi pi-play-circle",
    PLAY: "pi pi-play",
    PLUS_CIRCLE: "pi pi-plus-circle",
    PLUS: "pi pi-plus",
    POUND: "pi pi-pound",
    POWER_OFF: "pi pi-power-off",
    PRIME: "pi pi-prime",
    PRINT: "pi pi-print",
    QRCODE: "pi pi-qrcode",
    QUESTION_CIRCLE: "pi pi-question-circle",
    QUESTION: "pi pi-question",
    RECEIPT: "pi pi-receipt",
    REDDIT: "pi pi-reddit",
    REFRESH: "pi pi-refresh",
    REPLAY: "pi pi-replay",
    REPLY: "pi pi-reply",
    SAVE: "pi pi-save",
    SEARCH_MINUS: "pi pi-search-minus",
    SEARCH_PLUS: "pi pi-search-plus",
    SEARCH: "pi pi-search",
    SEND: "pi pi-send",
    SERVER: "pi pi-server",
    SHARE_ALT: "pi pi-share-alt",
    SHIELD: "pi pi-shield",
    SHOP: "pi pi-shop",
    SHOPPING_BAG: "pi pi-shopping-bag",
    SHOPPING_CART: "pi pi-shopping-cart",
    SIGN_IN: "pi pi-sign-in",
    SIGN_OUT: "pi pi-sign-out",
    SITEMAP: "pi pi-sitemap",
    SLACK: "pi pi-slack",
    SLIDERS_H: "pi pi-sliders-h",
    SLIDERS_V: "pi pi-sliders-v",
    SORT_ALPHA_DOWN_ALT: "pi pi-sort-alpha-down-alt",
    SORT_ALPHA_DOWN: "pi pi-sort-alpha-down",
    SORT_ALPHA_UP_ALT: "pi pi-sort-alpha-up-alt",
    SORT_ALPHA_UP: "pi pi-sort-alpha-up",
    SORT_ALT_SLASH: "pi pi-sort-alt-slash",
    SORT_ALT: "pi pi-sort-alt",
    SORT_AMOUNT_DOWN_ALT: "pi pi-sort-amount-down-alt",
    SORT_AMOUNT_DOWN: "pi pi-sort-amount-down",
    SORT_AMOUNT_UP_ALT: "pi pi-sort-amount-up-alt",
    SORT_AMOUNT_UP: "pi pi-sort-amount-up",
    SORT_DOWN_FILL: "pi pi-sort-down-fill",
    SORT_DOWN: "pi pi-sort-down",
    SORT_NUMERIC_DOWN_ALT: "pi pi-sort-numeric-down-alt",
    SORT_NUMERIC_DOWN: "pi pi-sort-numeric-down",
    SORT_NUMERIC_UP_ALT: "pi pi-sort-numeric-up-alt",
    SORT_NUMERIC_UP: "pi pi-sort-numeric-up",
    SORT_UP_FILL: "pi pi-sort-up-fill",
    SORT_UP: "pi pi-sort-up",
    SORT: "pi pi-sort",
    SPARKLES: "pi pi-sparkles",
    SPINNER_DOTTED: "pi pi-spinner-dotted",
    SPINNER: "pi pi-spinner",
    STAR_FILL: "pi pi-star-fill",
    STAR_HALF_FILL: "pi pi-star-half-fill",
    STAR_HALF: "pi pi-star-half",
    STAR: "pi pi-star",
    STEP_BACKWARD_ALT: "pi pi-step-backward-alt",
    STEP_BACKWARD: "pi pi-step-backward",
    STEP_FORWARD_ALT: "pi pi-step-forward-alt",
    STEP_FORWARD: "pi pi-step-forward",
    STOP_CIRCLE: "pi pi-stop-circle",
    STOP: "pi pi-stop",
    STOPWATCH: "pi pi-stopwatch",
    SUN: "pi pi-sun",
    SYNC: "pi pi-sync",
    TABLE: "pi pi-table",
    TABLET: "pi pi-tablet",
    TAG: "pi pi-tag",
    TAGS: "pi pi-tags",
    TELEGRAM: "pi pi-telegram",
    TH_LARGE: "pi pi-th-large",
    THUMBS_DOWN_FILL: "pi pi-thumbs-down-fill",
    THUMBS_DOWN: "pi pi-thumbs-down",
    THUMBS_UP_FILL: "pi pi-thumbs-up-fill",
    THUMBS_UP: "pi pi-thumbs-up",
    THUMBTACK: "pi pi-thumbtack",
    TICKET: "pi pi-ticket",
    TIKTOK: "pi pi-tiktok",
    TIMES_CIRCLE: "pi pi-times-circle",
    TIMES: "pi pi-times",
    TRASH: "pi pi-trash",
    TROPHY: "pi pi-trophy",
    TRUCK: "pi pi-truck",
    TURKISH_LIRA: "pi pi-turkish-lira",
    TWITCH: "pi pi-twitch",
    TWITTER: "pi pi-twitter",
    UNDO: "pi pi-undo",
    UNLOCK: "pi pi-unlock",
    UPLOAD: "pi pi-upload",
    USER_EDIT: "pi pi-user-edit",
    USER_MINUS: "pi pi-user-minus",
    USER_PLUS: "pi pi-user-plus",
    USER: "pi pi-user",
    USERS: "pi pi-users",
    VENUS: "pi pi-venus",
    VERIFIED: "pi pi-verified",
    VIDEO: "pi pi-video",
    VIMEO: "pi pi-vimeo",
    VOLUME_DOWN: "pi pi-volume-down",
    VOLUME_OFF: "pi pi-volume-off",
    VOLUME_UP: "pi pi-volume-up",
    WALLET: "pi pi-wallet",
    WAREHOUSE: "pi pi-warehouse",
    WAVE_PULSE: "pi pi-wave-pulse",
    WHATSAPP: "pi pi-whatsapp",
    WIFI: "pi pi-wifi",
    WINDOW_MAXIMIZE: "pi pi-window-maximize",
    WINDOW_MINIMIZE: "pi pi-window-minimize",
    WRENCH: "pi pi-wrench",
    YOUTUBE: "pi pi-youtube"
});
var $ab53cba4f1f38789$export$7ae723045d45777a = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});
function $ab53cba4f1f38789$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ab53cba4f1f38789$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ab53cba4f1f38789$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ab53cba4f1f38789$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ab53cba4f1f38789$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ab53cba4f1f38789$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ab53cba4f1f38789$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab53cba4f1f38789$var$_slicedToArray(r, e) {
    return $ab53cba4f1f38789$var$_arrayWithHoles(r) || $ab53cba4f1f38789$var$_iterableToArrayLimit(r, e) || $ab53cba4f1f38789$var$_unsupportedIterableToArray(r, e) || $ab53cba4f1f38789$var$_nonIterableRest();
}
var $ab53cba4f1f38789$export$43502877ff87a530 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext();
var $ab53cba4f1f38789$export$6a5b5c2279ff1e8d = function PrimeReactProvider(props) {
    var _props$value, _propsValue$ripple, _propsValue$inputStyl, _propsValue$locale, _propsValue$appendTo, _propsValue$styleCont, _propsValue$cssTransi, _propsValue$autoZInde, _propsValue$hideOverl, _propsValue$nonce, _propsValue$nullSortO, _propsValue$zIndex, _propsValue$ptOptions, _propsValue$pt, _propsValue$unstyled, _propsValue$filterMat;
    var propsValue = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : {};
    var _useState = (0, $7E7Dk.useState)((_propsValue$ripple = propsValue.ripple) !== null && _propsValue$ripple !== void 0 ? _propsValue$ripple : false), _useState2 = $ab53cba4f1f38789$var$_slicedToArray(_useState, 2), ripple = _useState2[0], setRipple = _useState2[1];
    var _useState3 = (0, $7E7Dk.useState)((_propsValue$inputStyl = propsValue.inputStyle) !== null && _propsValue$inputStyl !== void 0 ? _propsValue$inputStyl : "outlined"), _useState4 = $ab53cba4f1f38789$var$_slicedToArray(_useState3, 2), inputStyle = _useState4[0], setInputStyle = _useState4[1];
    var _useState5 = (0, $7E7Dk.useState)((_propsValue$locale = propsValue.locale) !== null && _propsValue$locale !== void 0 ? _propsValue$locale : "en"), _useState6 = $ab53cba4f1f38789$var$_slicedToArray(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, $7E7Dk.useState)((_propsValue$appendTo = propsValue.appendTo) !== null && _propsValue$appendTo !== void 0 ? _propsValue$appendTo : null), _useState8 = $ab53cba4f1f38789$var$_slicedToArray(_useState7, 2), appendTo = _useState8[0], setAppendTo = _useState8[1];
    var _useState9 = (0, $7E7Dk.useState)((_propsValue$styleCont = propsValue.styleContainer) !== null && _propsValue$styleCont !== void 0 ? _propsValue$styleCont : null), _useState10 = $ab53cba4f1f38789$var$_slicedToArray(_useState9, 2), styleContainer = _useState10[0], setStyleContainer = _useState10[1];
    var _useState11 = (0, $7E7Dk.useState)((_propsValue$cssTransi = propsValue.cssTransition) !== null && _propsValue$cssTransi !== void 0 ? _propsValue$cssTransi : true), _useState12 = $ab53cba4f1f38789$var$_slicedToArray(_useState11, 2), cssTransition = _useState12[0], setCssTransition = _useState12[1];
    var _useState13 = (0, $7E7Dk.useState)((_propsValue$autoZInde = propsValue.autoZIndex) !== null && _propsValue$autoZInde !== void 0 ? _propsValue$autoZInde : true), _useState14 = $ab53cba4f1f38789$var$_slicedToArray(_useState13, 2), autoZIndex = _useState14[0], setAutoZIndex = _useState14[1];
    var _useState15 = (0, $7E7Dk.useState)((_propsValue$hideOverl = propsValue.hideOverlaysOnDocumentScrolling) !== null && _propsValue$hideOverl !== void 0 ? _propsValue$hideOverl : false), _useState16 = $ab53cba4f1f38789$var$_slicedToArray(_useState15, 2), hideOverlaysOnDocumentScrolling = _useState16[0], setHideOverlaysOnDocumentScrolling = _useState16[1];
    var _useState17 = (0, $7E7Dk.useState)((_propsValue$nonce = propsValue.nonce) !== null && _propsValue$nonce !== void 0 ? _propsValue$nonce : null), _useState18 = $ab53cba4f1f38789$var$_slicedToArray(_useState17, 2), nonce = _useState18[0], setNonce = _useState18[1];
    var _useState19 = (0, $7E7Dk.useState)((_propsValue$nullSortO = propsValue.nullSortOrder) !== null && _propsValue$nullSortO !== void 0 ? _propsValue$nullSortO : 1), _useState20 = $ab53cba4f1f38789$var$_slicedToArray(_useState19, 2), nullSortOrder = _useState20[0], setNullSortOrder = _useState20[1];
    var _useState21 = (0, $7E7Dk.useState)((_propsValue$zIndex = propsValue.zIndex) !== null && _propsValue$zIndex !== void 0 ? _propsValue$zIndex : {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100,
        toast: 1200
    }), _useState22 = $ab53cba4f1f38789$var$_slicedToArray(_useState21, 2), zIndex = _useState22[0], setZIndex = _useState22[1];
    var _useState23 = (0, $7E7Dk.useState)((_propsValue$ptOptions = propsValue.ptOptions) !== null && _propsValue$ptOptions !== void 0 ? _propsValue$ptOptions : {
        mergeSections: true,
        mergeProps: true
    }), _useState24 = $ab53cba4f1f38789$var$_slicedToArray(_useState23, 2), ptOptions = _useState24[0], setPtOptions = _useState24[1];
    var _useState25 = (0, $7E7Dk.useState)((_propsValue$pt = propsValue.pt) !== null && _propsValue$pt !== void 0 ? _propsValue$pt : undefined), _useState26 = $ab53cba4f1f38789$var$_slicedToArray(_useState25, 2), pt = _useState26[0], setPt = _useState26[1];
    var _useState27 = (0, $7E7Dk.useState)((_propsValue$unstyled = propsValue.unstyled) !== null && _propsValue$unstyled !== void 0 ? _propsValue$unstyled : false), _useState28 = $ab53cba4f1f38789$var$_slicedToArray(_useState27, 2), unstyled = _useState28[0], setUnstyled = _useState28[1];
    var _useState29 = (0, $7E7Dk.useState)((_propsValue$filterMat = propsValue.filterMatchModeOptions) !== null && _propsValue$filterMat !== void 0 ? _propsValue$filterMat : {
        text: [
            $ab53cba4f1f38789$export$b9fbdf9129f67822.STARTS_WITH,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.CONTAINS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_CONTAINS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.ENDS_WITH,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.EQUALS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_EQUALS
        ],
        numeric: [
            $ab53cba4f1f38789$export$b9fbdf9129f67822.EQUALS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.NOT_EQUALS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.LESS_THAN,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.GREATER_THAN,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_IS,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_IS_NOT,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_BEFORE,
            $ab53cba4f1f38789$export$b9fbdf9129f67822.DATE_AFTER
        ]
    }), _useState30 = $ab53cba4f1f38789$var$_slicedToArray(_useState29, 2), filterMatchModeOptions = _useState30[0], setFilterMatchModeOptions = _useState30[1];
    var changeTheme = function changeTheme(currentTheme, newTheme, linkElementId, callback) {
        var _linkElement$parentNo;
        var linkElement = document.getElementById(linkElementId);
        if (!linkElement) throw Error("Element with id ".concat(linkElementId, " not found."));
        var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
        var newLinkElement = document.createElement("link");
        newLinkElement.setAttribute("rel", "stylesheet");
        newLinkElement.setAttribute("id", linkElementId);
        newLinkElement.setAttribute("href", newThemeUrl);
        newLinkElement.addEventListener("load", function() {
            if (callback) callback();
        });
        (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.replaceChild(newLinkElement, linkElement);
    };
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(function() {
        $ab53cba4f1f38789$var$PrimeReact$1.ripple = ripple;
    }, [
        ripple
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(function() {
        $ab53cba4f1f38789$var$PrimeReact$1.inputStyle = inputStyle;
    }, [
        inputStyle
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(function() {
        $ab53cba4f1f38789$var$PrimeReact$1.locale = locale;
    }, [
        locale
    ]);
    var value = {
        changeTheme: changeTheme,
        ripple: ripple,
        setRipple: setRipple,
        inputStyle: inputStyle,
        setInputStyle: setInputStyle,
        locale: locale,
        setLocale: setLocale,
        appendTo: appendTo,
        setAppendTo: setAppendTo,
        styleContainer: styleContainer,
        setStyleContainer: setStyleContainer,
        cssTransition: cssTransition,
        setCssTransition: setCssTransition,
        autoZIndex: autoZIndex,
        setAutoZIndex: setAutoZIndex,
        hideOverlaysOnDocumentScrolling: hideOverlaysOnDocumentScrolling,
        setHideOverlaysOnDocumentScrolling: setHideOverlaysOnDocumentScrolling,
        nonce: nonce,
        setNonce: setNonce,
        nullSortOrder: nullSortOrder,
        setNullSortOrder: setNullSortOrder,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ptOptions: ptOptions,
        setPtOptions: setPtOptions,
        pt: pt,
        setPt: setPt,
        filterMatchModeOptions: filterMatchModeOptions,
        setFilterMatchModeOptions: setFilterMatchModeOptions,
        unstyled: unstyled,
        setUnstyled: setUnstyled
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ab53cba4f1f38789$export$43502877ff87a530.Provider, {
        value: value
    }, props.children);
};
var $ab53cba4f1f38789$export$2e2bcd8739ae039 = $ab53cba4f1f38789$var$PrimeReact$1;

});
parcelRegister("7nrKB", function(module, exports) {

$parcel$export(module.exports, "classNames", function () { return $55f035118b475c06$export$ce4ab0c55987d1ff; });
$parcel$export(module.exports, "DomHandler", function () { return $55f035118b475c06$export$ff8ccbac9225de62; });
$parcel$export(module.exports, "EventBus", function () { return $55f035118b475c06$export$5087227eb54526; });
$parcel$export(module.exports, "ObjectUtils", function () { return $55f035118b475c06$export$4855211e6b8ad895; });
$parcel$export(module.exports, "UniqueComponentId", function () { return $55f035118b475c06$export$d5d9b89141473caf; });
$parcel$export(module.exports, "IconUtils", function () { return $55f035118b475c06$export$7114f767f3d3c711; });
$parcel$export(module.exports, "mask", function () { return $55f035118b475c06$export$d99f0801a68bbcf1; });
$parcel$export(module.exports, "mergeProps", function () { return $55f035118b475c06$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "ZIndexUtils", function () { return $55f035118b475c06$export$832931caede8e4b9; });

var $7E7Dk = parcelRequire("7E7Dk");
"use client";
function $55f035118b475c06$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $55f035118b475c06$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $55f035118b475c06$var$_arrayLikeToArray$2(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $55f035118b475c06$var$_unsupportedIterableToArray$2(r, a) {
    if (r) {
        if ("string" == typeof r) return $55f035118b475c06$var$_arrayLikeToArray$2(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $55f035118b475c06$var$_arrayLikeToArray$2(r, a) : void 0;
    }
}
function $55f035118b475c06$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $55f035118b475c06$var$_slicedToArray(r, e) {
    return $55f035118b475c06$var$_arrayWithHoles(r) || $55f035118b475c06$var$_iterableToArrayLimit(r, e) || $55f035118b475c06$var$_unsupportedIterableToArray$2(r, e) || $55f035118b475c06$var$_nonIterableRest();
}
function $55f035118b475c06$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $55f035118b475c06$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $55f035118b475c06$var$_typeof(o);
}
function $55f035118b475c06$export$ce4ab0c55987d1ff() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = $55f035118b475c06$var$_typeof(className);
            if (type === "string" || type === "number") classes.push(className);
            else if (type === "object") {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = $55f035118b475c06$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(" ").trim();
    }
    return undefined;
}
function $55f035118b475c06$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $55f035118b475c06$var$_arrayLikeToArray$2(r);
}
function $55f035118b475c06$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $55f035118b475c06$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $55f035118b475c06$var$_toConsumableArray(r) {
    return $55f035118b475c06$var$_arrayWithoutHoles(r) || $55f035118b475c06$var$_iterableToArray(r) || $55f035118b475c06$var$_unsupportedIterableToArray$2(r) || $55f035118b475c06$var$_nonIterableSpread();
}
function $55f035118b475c06$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $55f035118b475c06$var$toPrimitive(t, r) {
    if ("object" != $55f035118b475c06$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $55f035118b475c06$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $55f035118b475c06$var$toPropertyKey(t) {
    var i = $55f035118b475c06$var$toPrimitive(t, "string");
    return "symbol" == $55f035118b475c06$var$_typeof(i) ? i : i + "";
}
function $55f035118b475c06$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $55f035118b475c06$var$toPropertyKey(o.key), o);
    }
}
function $55f035118b475c06$var$_createClass(e, r, t) {
    return r && $55f035118b475c06$var$_defineProperties(e.prototype, r), t && $55f035118b475c06$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $55f035118b475c06$var$_defineProperty(e, r, t) {
    return (r = $55f035118b475c06$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $55f035118b475c06$var$_createForOfIteratorHelper$1(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $55f035118b475c06$var$_unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $55f035118b475c06$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $55f035118b475c06$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $55f035118b475c06$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $55f035118b475c06$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $55f035118b475c06$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    function DomHandler() {
        $55f035118b475c06$var$_classCallCheck(this, DomHandler);
    }
    return $55f035118b475c06$var$_createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width + (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var _width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    _width = _width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return _width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || "en";
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.getBoundingClientRect().width || el.offsetWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.getBoundingClientRect().height || el.offsetHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window;
                var d = document;
                var e = d.documentElement;
                var g = d.getElementsByTagName("body")[0];
                var w = win.innerWidth || e.clientWidth || g.clientWidth;
                var h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: "auto",
                    left: "auto"
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(" ");
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(" ");
                        for(var _i = 0; _i < _styles.length; _i++)element.className = element.className + (" " + _styles[_i]);
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(" ");
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(" ");
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp("(^|\\b)" + _styles2[_i2].split(" ").join("|") + "(\\b|$)", "gi"), " ");
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className = element.className + (" " + className);
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    return new RegExp("(^| )" + className + "( |$)", "gi").test(element.className);
                }
                return false;
            }
        },
        {
            key: "addStyles",
            value: function addStyles(element) {
                var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) Object.entries(styles).forEach(function(_ref) {
                    var _ref2 = $55f035118b475c06$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return element.style[key] = value;
                });
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(element) {
                var _this = this;
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) {
                    var _computedStyles = function computedStyles(rule, value) {
                        var _element$$attrs, _element$$attrs2;
                        var styles = element !== null && element !== void 0 && (_element$$attrs = element.$attrs) !== null && _element$$attrs !== void 0 && _element$$attrs[rule] ? [
                            element === null || element === void 0 || (_element$$attrs2 = element.$attrs) === null || _element$$attrs2 === void 0 ? void 0 : _element$$attrs2[rule]
                        ] : [];
                        return [
                            value
                        ].flat().reduce(function(cv, v) {
                            if (v !== null && v !== undefined) {
                                var type = $55f035118b475c06$var$_typeof(v);
                                if (type === "string" || type === "number") cv.push(v);
                                else if (type === "object") {
                                    var _cv = Array.isArray(v) ? _computedStyles(rule, v) : Object.entries(v).map(function(_ref3) {
                                        var _ref4 = $55f035118b475c06$var$_slicedToArray(_ref3, 2), _k = _ref4[0], _v = _ref4[1];
                                        return rule === "style" && (!!_v || _v === 0) ? "".concat(_k.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), ":").concat(_v) : _v ? _k : undefined;
                                    });
                                    cv = _cv.length ? cv.concat(_cv.filter(function(c) {
                                        return !!c;
                                    })) : cv;
                                }
                            }
                            return cv;
                        }, styles);
                    };
                    Object.entries(attributes).forEach(function(_ref5) {
                        var _ref6 = $55f035118b475c06$var$_slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
                        if (value !== undefined && value !== null) {
                            var matchedEvent = key.match(/^on(.+)/);
                            if (matchedEvent) element.addEventListener(matchedEvent[1].toLowerCase(), value);
                            else if (key === "p-bind") _this.setAttributes(element, value);
                            else {
                                value = key === "class" ? $55f035118b475c06$var$_toConsumableArray(new Set(_computedStyles("class", value))).join(" ").trim() : key === "style" ? _computedStyles("style", value).join(";").trim() : value;
                                element.$attrs = element.$attrs || {}, element.$attrs[key] = value;
                                element.setAttribute(key, value);
                            }
                        }
                    });
                }
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(element, name) {
                if (element) {
                    var value = element.getAttribute(name);
                    if (!isNaN(value)) return +value;
                    if (value === "true" || value === "false") return value === "true";
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "isAttributeEquals",
            value: function isAttributeEquals(element, name, value) {
                return element ? this.getAttribute(element, name) === value : false;
            }
        },
        {
            key: "isAttributeNotEquals",
            value: function isAttributeNotEquals(element, name, value) {
                return !this.isAttributeEquals(element, name, value);
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height = height - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === "self") this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + "px");
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left";
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = "bottom";
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = "top";
                    }
                    var targetOffsetPx = targetOffset.left;
                    if (align === "left") {
                        if (targetOffsetPx + elementOuterWidth > viewport.width) left = Math.max(0, targetOffsetPx + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                        else left = targetOffsetPx + windowScrollLeft;
                    } else if (targetOffsetPx + targetOuterWidth - elementOuterWidth < 0) left = windowScrollLeft;
                    else left = targetOffsetPx + targetOuterWidth - elementOuterWidth + windowScrollLeft;
                    element.style.top = top + "px";
                    element.style.left = left + "px";
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = "bottom";
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = "top";
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + "px";
                    element.style.left = left + "px";
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this2 = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left top";
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "left bottom";
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(" ");
                    var atArr = at.split(" ");
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === "left" ? 0 : -1 * (position.my.x === "center" ? _this2.getOuterWidth(element) / 2 : _this2.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === "top" ? 0 : -1 * (position.my.y === "center" ? _this2.getOuterHeight(element) / 2 : _this2.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + "px";
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + "px";
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = "left";
                                position.at.x = "right";
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + "px";
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + "px";
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = "right";
                                position.at.x = "left";
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + "px";
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + "px";
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = "top";
                                position.at.y = "bottom";
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + "px";
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + "px";
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = "bottom";
                                position.at.y = "top";
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === "y") {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + "px";
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + "px";
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]("x");
                    alignWithAt[position.at.y]("y");
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === "top" || position === "bottom";
                    var myXPosition = position === "left" ? "right" : "left";
                    var myYPosition = position === "top" ? "bottom" : "top";
                    if (isAxisY) return {
                        axis: "y",
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: "x",
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element.parentNode === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var _this3 = this;
                var scrollableParents = [];
                if (element) {
                    // Get all parent elements
                    var parents = this.getParents(element);
                    // Regex to match auto or scroll overflow values
                    var overflowRegex = /(auto|scroll)/;
                    /**
         * Checks if an element has overflow scroll/auto in any direction
         * @param {HTMLElement} node - Element to check
         * @returns {boolean} True if element has overflow scroll/auto
         */ var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue("overflow")) || overflowRegex.test(styleDeclaration.getPropertyValue("overflow-x")) || overflowRegex.test(styleDeclaration.getPropertyValue("overflow-y")));
                    };
                    /**
         * Adds a scrollable parent element to the collection
         * @param {HTMLElement} node - Element to add
         */ var addScrollableParent = function addScrollableParent(node) {
                        // For document/body/html elements, add window instead
                        scrollableParents.push(node.nodeName === "BODY" || node.nodeName === "HTML" || _this3.isDocument(node) ? window : node);
                    };
                    // Iterate through all parent elements
                    var _iterator = $55f035118b475c06$var$_createForOfIteratorHelper$1(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _parent$dataset;
                            var parent = _step.value;
                            // Check for custom scroll selectors in data attribute
                            var scrollSelectors = parent.nodeType === 1 && ((_parent$dataset = parent.dataset) === null || _parent$dataset === void 0 ? void 0 : _parent$dataset.scrollselectors);
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(",");
                                // Check each selector
                                var _iterator2 = $55f035118b475c06$var$_createForOfIteratorHelper$1(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) addScrollableParent(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            // Check if the parent itself is scrollable
                            if (parent.nodeType === 1 && overflowCheck(parent)) addScrollableParent(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    var elementHeight = element.offsetHeight;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    var elementWidth = element.offsetWidth;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var _tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(_tick) || setTimeout(_tick, 16);
                    };
                    _tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1;
                    var interval = 50;
                    var gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity = opacity - gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isChrome",
            value: function isChrome() {
                return /(chrome)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isClient",
            value: function isClient() {
                return !!(typeof window !== "undefined" && window.document && window.document.createElement);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error("Cannot append " + target + " to " + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error("Cannot remove " + element + " from " + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : $55f035118b475c06$var$_typeof(HTMLElement)) === "object" ? obj instanceof HTMLElement : obj && $55f035118b475c06$var$_typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
            }
        },
        {
            key: "isDocument",
            value: function isDocument(obj) {
                return (typeof Document === "undefined" ? "undefined" : $55f035118b475c06$var$_typeof(Document)) === "object" ? obj instanceof Document : obj && $55f035118b475c06$var$_typeof(obj) === "object" && obj !== null && obj.nodeType === 9;
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue("border-top-width");
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue("padding-top");
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document.selection && document.selection.empty) try {
                    document.selection.empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                }
                if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                var scrollDiv = document.createElement("div");
                scrollDiv.className = "p-scrollbar-measure";
                document.body.appendChild(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                this.calculatedScrollbarWidth = scrollbarWidth;
                return scrollbarWidth;
            }
        },
        {
            key: "calculateBodyScrollbarWidth",
            value: function calculateBodyScrollbarWidth() {
                return window.innerWidth - document.documentElement.offsetWidth;
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser.version = matched.version;
                    }
                    if (this.browser.chrome) this.browser.webkit = true;
                    else if (this.browser.webkit) this.browser.safari = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || "",
                    version: match[2] || "0"
                };
            }
        },
        {
            key: "blockBodyScroll",
            value: function blockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p-overflow-hidden";
                /* PR Ref: https://github.com/primefaces/primereact/pull/4976
       * @todo This method is called several times after this PR. Refactors will be made to prevent this in future releases.
       */ var hasScrollbarWidth = !!document.body.style.getPropertyValue("--scrollbar-width");
                !hasScrollbarWidth && document.body.style.setProperty("--scrollbar-width", this.calculateBodyScrollbarWidth() + "px");
                this.addClass(document.body, className);
            }
        },
        {
            key: "unblockBodyScroll",
            value: function unblockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p-overflow-hidden";
                document.body.style.removeProperty("--scrollbar-width");
                this.removeClass(document.body, className);
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== "none");
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return !!(element !== null && typeof element !== "undefined" && element.nodeName && element.parentNode);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var focusableElements = DomHandler.find(element, 'button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(selector, ',\n                [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = $55f035118b475c06$var$_createForOfIteratorHelper$1(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== "none" && getComputedStyle(focusableElement).visibility !== "hidden") visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "focusFirstElement",
            value: function focusFirstElement(el, scrollTo) {
                if (!el) return;
                var firstFocusableElement = DomHandler.getFirstFocusableElement(el);
                firstFocusableElement && DomHandler.focus(firstFocusableElement, scrollTo);
                return firstFocusableElement;
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement("div");
                    ghostDiv.style.position = "absolute";
                    ghostDiv.style.top = "0px";
                    ghostDiv.style.left = "0px";
                    ghostDiv.style.visibility = "hidden";
                    ghostDiv.style.pointerEvents = "none";
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, "<br />");
                    var ghostSpan = document.createElement("span");
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: "auto",
                    left: "auto"
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === "INPUT" || targetNode === "TEXTAREA" || targetNode === "BUTTON" || targetNode === "A" || parentNode === "INPUT" || parentNode === "TEXTAREA" || parentNode === "BUTTON" || parentNode === "A" || this.hasClass(element, "p-button") || this.hasClass(element.parentElement, "p-button") || this.hasClass(element.parentElement, "p-checkbox") || this.hasClass(element.parentElement, "p-radiobutton");
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === "string") element.style.cssText = style;
                else for(var prop in style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: "application/csv;charset=utf-8;"
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + ".csv");
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + ".csv",
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = "data:text/csv;charset=utf-8," + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement("a");
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute("href", src);
                        link.setAttribute("download", name);
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce, styleContainer) {
                var styleElement = document.createElement("style");
                DomHandler.addNonce(styleElement, nonce);
                if (!styleContainer) styleContainer = document.head;
                styleContainer.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        styleElement.parentNode.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "addNonce",
            value: function addNonce(styleElement, nonce) {
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute("nonce", nonce);
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === "document") return document;
                else if (target === "window") return window;
                else if ($55f035118b475c06$var$_typeof(target) === "object" && target.hasOwnProperty("current")) return this.isExist(target.current) ? target.current : null;
                var isFunction = function isFunction(obj) {
                    return !!(obj && obj.constructor && obj.call && obj.apply);
                };
                var element = isFunction(target) ? target() : target;
                return this.isDocument(element) || this.isExist(element) ? element : null;
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index;
                var rv;
                var attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1;
                var attrs2;
                var name;
                var node1;
                var node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(",") !== attrs2.join(",")) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === "style") {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                    return false;
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        },
        {
            key: "hasCSSAnimation",
            value: function hasCSSAnimation(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var animationDuration = parseFloat(style.getPropertyValue("animation-duration") || "0");
                    return animationDuration > 0;
                }
                return false;
            }
        },
        {
            key: "hasCSSTransition",
            value: function hasCSSTransition(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var transitionDuration = parseFloat(style.getPropertyValue("transition-duration") || "0");
                    return transitionDuration > 0;
                }
                return false;
            }
        }
    ]);
}();
/**
 * All data- properties like data-test-id
 */ $55f035118b475c06$var$_defineProperty($55f035118b475c06$export$ff8ccbac9225de62, "DATA_PROPS", [
    "data-"
]);
/**
 * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
 */ $55f035118b475c06$var$_defineProperty($55f035118b475c06$export$ff8ccbac9225de62, "ARIA_PROPS", [
    "aria",
    "focus-target"
]);
function $55f035118b475c06$export$5087227eb54526() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function $55f035118b475c06$var$_extends() {
    return $55f035118b475c06$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $55f035118b475c06$var$_extends.apply(null, arguments);
}
function $55f035118b475c06$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $55f035118b475c06$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $55f035118b475c06$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $55f035118b475c06$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $55f035118b475c06$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $55f035118b475c06$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $55f035118b475c06$export$4855211e6b8ad895 = /*#__PURE__*/ function() {
    function ObjectUtils() {
        $55f035118b475c06$var$_classCallCheck(this, ObjectUtils);
    }
    return $55f035118b475c06$var$_createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && $55f035118b475c06$var$_typeof(obj1) === "object" && obj2 && $55f035118b475c06$var$_typeof(obj2) === "object") return this.deepEquals(this.resolveFieldData(obj1, field), this.resolveFieldData(obj2, field));
                return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && $55f035118b475c06$var$_typeof(a) === "object" && $55f035118b475c06$var$_typeof(b) === "object") {
                    var arrA = Array.isArray(a);
                    var arrB = Array.isArray(b);
                    var i;
                    var length;
                    var key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date;
                    var dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp;
                    var regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (!data || !field) // short circuit if there is nothing to resolve
                return null;
                try {
                    var value = data[field];
                    if (this.isNotEmpty(value)) return value;
                } catch (_unused) {
                // Performance optimization: https://github.com/primefaces/primereact/issues/4797
                // do nothing and continue to other methods to resolve field data
                }
                if (Object.keys(data).length) {
                    if (this.isFunction(field)) return field(data);
                    else if (this.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf(".") === -1) return data[field];
                    var fields = field.split(".");
                    var _value = data;
                    for(var i = 0, len = fields.length; i < len; ++i){
                        if (_value == null) return null;
                        _value = _value[fields[i]];
                    }
                    return _value;
                }
                return null;
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                if (value && from !== to) {
                    if (to >= value.length) {
                        to = to % value.length;
                        from = from % value.length;
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getItemValue",
            value: function getItemValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getProp",
            value: function getProp(props) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var value = props ? props[prop] : undefined;
                return value === undefined ? defaultProps[prop] : value;
            }
        },
        {
            key: "getPropCaseInsensitive",
            value: function getPropCaseInsensitive(props, prop) {
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var fkey = this.toFlatCase(prop);
                for(var key in props){
                    if (props.hasOwnProperty(key) && this.toFlatCase(key) === fkey) return props[key];
                }
                for(var _key3 in defaultProps){
                    if (defaultProps.hasOwnProperty(_key3) && this.toFlatCase(_key3) === fkey) return defaultProps[_key3];
                }
                return undefined; // Property not found
            }
        },
        {
            key: "getMergedProps",
            value: function getMergedProps(props, defaultProps) {
                return Object.assign({}, defaultProps, props);
            }
        },
        {
            key: "getDiffProps",
            value: function getDiffProps(props, defaultProps) {
                return this.findDiffKeys(props, defaultProps);
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                // If obj is not a function, return it directly
                if (!this.isFunction(obj)) return obj;
                // Handle function invocation
                for(var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++)params[_key4 - 1] = arguments[_key4];
                if (params.length === 1) {
                    // For single parameter case, unwrap array if needed to avoid extra nesting
                    var param = params[0];
                    return obj(Array.isArray(param) ? param[0] : param);
                }
                // Pass all parameters to function
                return obj.apply(void 0, params);
            }
        },
        {
            key: "getComponentProp",
            value: function getComponentProp(component) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.isNotEmpty(component) ? this.getProp(component.props, prop, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentProps",
            value: function getComponentProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getMergedProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentDiffProps",
            value: function getComponentDiffProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getDiffProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "isValidChild",
            value: function isValidChild(child, type, validTypes) {
                /* eslint-disable */ if (child) {
                    var _child$type;
                    var childType = this.getComponentProp(child, "__TYPE") || (child.type ? child.type.displayName : undefined);
                    // for App Router in Next.js ^14,
                    if (!childType && child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && (_child$type = _child$type._payload) !== null && _child$type !== void 0 && _child$type.value) childType = child.type._payload.value.find(function(v) {
                        return v === type;
                    });
                    var isValid = childType === type;
                    try {
                        var messageTypes;
                    } catch (error) {
                    // NOOP
                    }
                    return isValid;
                }
                return false;
            /* eslint-enable */ }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return $55f035118b475c06$var$_typeof(ref) === "object" && ref.hasOwnProperty("current") ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === "function") forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y");
                return str;
            }
        },
        {
            key: "toFlatCase",
            value: function toFlatCase(str) {
                // convert snake, kebab, camel and pascal cases to flat case
                return this.isNotEmpty(str) && this.isString(str) ? str.replace(/(-|_)/g, "").toLowerCase() : str;
            }
        },
        {
            key: "toCapitalCase",
            value: function toCapitalCase(str) {
                return this.isNotEmpty(str) && this.isString(str) ? str[0].toUpperCase() + str.slice(1) : str;
            }
        },
        {
            key: "trim",
            value: function trim(value) {
                // trim only if the value is actually a string
                return this.isNotEmpty(value) && this.isString(value) ? value.trim() : value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && $55f035118b475c06$var$_typeof(value) === "object" && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "isFunction",
            value: function isFunction(value) {
                return !!(value && value.constructor && value.call && value.apply);
            }
        },
        {
            key: "isObject",
            value: function isObject(value) {
                return value !== null && value instanceof Object && value.constructor === Object;
            }
        },
        {
            key: "isDate",
            value: function isDate(value) {
                return value !== null && value instanceof Date && value.constructor === Date;
            }
        },
        {
            key: "isArray",
            value: function isArray(value) {
                return value !== null && Array.isArray(value);
            }
        },
        {
            key: "isString",
            value: function isString(value) {
                return value !== null && typeof value === "string";
            }
        },
        {
            key: "isPrintableCharacter",
            value: function isPrintableCharacter() {
                var _char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                return this.isNotEmpty(_char) && _char.length === 1 && _char.match(/\S| /);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char2) {
                return /^[a-zA-Z\u00C0-\u017F]$/.test(_char2);
            }
        },
        {
            key: "isScalar",
            value: function isScalar(value) {
                return value != null && (typeof value === "string" || typeof value === "number" || typeof value === "bigint" || typeof value === "boolean");
            }
        },
        {
            key: "findLast",
            value: function findLast(arr, callback) {
                var item;
                if (this.isNotEmpty(arr)) try {
                    item = arr.findLast(callback);
                } catch (_unused2) {
                    item = $55f035118b475c06$var$_toConsumableArray(arr).reverse().find(callback);
                }
                return item;
            }
        },
        {
            key: "findLastIndex",
            value: function findLastIndex(arr, callback) {
                var index = -1;
                if (this.isNotEmpty(arr)) try {
                    index = arr.findLastIndex(callback);
                } catch (_unused3) {
                    index = arr.lastIndexOf($55f035118b475c06$var$_toConsumableArray(arr).reverse().find(callback));
                }
                return index;
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var comparator = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = this.compare(value1, value2, comparator, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (this.isEmpty(value1) || this.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, comparator) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = this.isEmpty(value1);
                var emptyValue2 = this.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === "string" && typeof value2 === "string") result = comparator(value1, value2);
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        },
        {
            key: "localeComparator",
            value: function localeComparator(locale) {
                //performance gain using Int.Collator. It is not recommended to use localeCompare against large arrays.
                return new Intl.Collator(locale, {
                    numeric: true
                }).compare;
            }
        },
        {
            key: "findChildrenByKey",
            value: function findChildrenByKey(data, key) {
                var _iterator = $55f035118b475c06$var$_createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        if (item.key === key) return item.children || [];
                        else if (item.children) {
                            var result = this.findChildrenByKey(item.children, key);
                            if (result.length > 0) return result;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return [];
            }
        },
        {
            key: "mutateFieldData",
            value: function mutateFieldData(data, field, value) {
                if ($55f035118b475c06$var$_typeof(data) !== "object" || typeof field !== "string") // short circuit if there is nothing to resolve
                return;
                var fields = field.split(".");
                var obj = data;
                for(var i = 0, len = fields.length; i < len; ++i){
                    // Check if we are on the last field
                    if (i + 1 - len === 0) {
                        obj[fields[i]] = value;
                        break;
                    }
                    if (!obj[fields[i]]) obj[fields[i]] = {};
                    obj = obj[fields[i]];
                }
            }
        },
        {
            key: "getNestedValue",
            value: function getNestedValue(obj, path) {
                return path.split(".").reduce(function(acc, part) {
                    return acc && acc[part] !== undefined ? acc[part] : undefined;
                }, obj);
            }
        },
        {
            key: "absoluteCompare",
            value: function absoluteCompare(objA, objB) {
                var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var currentDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (!objA || !objB) return true;
                if (currentDepth > maxDepth) return true;
                if ($55f035118b475c06$var$_typeof(objA) !== $55f035118b475c06$var$_typeof(objB)) return false;
                var aKeys = Object.keys(objA);
                var bKeys = Object.keys(objB);
                if (aKeys.length !== bKeys.length) return false;
                for(var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++){
                    var key = _aKeys[_i];
                    var aValue = objA[key];
                    var bValue = objB[key];
                    // Skip comparison if values are objects
                    var isObject = ObjectUtils.isObject(aValue) && ObjectUtils.isObject(bValue);
                    var isFunction = ObjectUtils.isFunction(aValue) && ObjectUtils.isFunction(bValue);
                    if ((isObject || isFunction) && !this.absoluteCompare(aValue, bValue, maxDepth, currentDepth + 1)) return false;
                    if (!isObject && aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "selectiveCompare",
            value: function selectiveCompare(a, b, keysToCompare) {
                var maxDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                if (a === b) return true;
                if (!a || !b || $55f035118b475c06$var$_typeof(a) !== "object" || $55f035118b475c06$var$_typeof(b) !== "object") return false;
                if (!keysToCompare) return this.absoluteCompare(a, b, 1); // If no keys are provided, the comparison is limited to one depth level.
                var _iterator2 = $55f035118b475c06$var$_createForOfIteratorHelper(keysToCompare), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var key = _step2.value;
                        var aValue = this.getNestedValue(a, key);
                        var bValue = this.getNestedValue(b, key);
                        var isObject = $55f035118b475c06$var$_typeof(aValue) === "object" && aValue !== null && $55f035118b475c06$var$_typeof(bValue) === "object" && bValue !== null;
                        // If the current key is an object, they are compared in one further level only.
                        if (isObject && !this.absoluteCompare(aValue, bValue, maxDepth)) return false;
                        if (!isObject && aValue !== bValue) return false;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return true;
            }
        }
    ]);
}();
var $55f035118b475c06$var$lastId = 0;
function $55f035118b475c06$export$d5d9b89141473caf() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "pr_id_";
    $55f035118b475c06$var$lastId++;
    return "".concat(prefix).concat($55f035118b475c06$var$lastId);
}
function $55f035118b475c06$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55f035118b475c06$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55f035118b475c06$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $55f035118b475c06$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55f035118b475c06$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55f035118b475c06$export$7114f767f3d3c711 = /*#__PURE__*/ function() {
    function IconUtils() {
        $55f035118b475c06$var$_classCallCheck(this, IconUtils);
    }
    return $55f035118b475c06$var$_createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = $55f035118b475c06$var$_typeof(icon);
                    var className = $55f035118b475c06$export$ce4ab0c55987d1ff(iconProps.className, iconType === "string" && icon);
                    content = /*#__PURE__*/ $7E7Dk.createElement("span", $55f035118b475c06$var$_extends({}, iconProps, {
                        className: className,
                        key: $55f035118b475c06$export$d5d9b89141473caf("icon")
                    }));
                    if (iconType !== "string") {
                        var defaultContentOptions = $55f035118b475c06$var$_objectSpread$2({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return $55f035118b475c06$export$4855211e6b8ad895.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
}();
function $55f035118b475c06$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55f035118b475c06$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55f035118b475c06$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $55f035118b475c06$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55f035118b475c06$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $55f035118b475c06$export$d99f0801a68bbcf1(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: "_",
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = $55f035118b475c06$var$_objectSpread$1($55f035118b475c06$var$_objectSpread$1({}, defaultOptions), options);
    var tests;
    var partialPosition;
    var len;
    var firstNonMaskPos;
    var defs;
    var androidChrome;
    var lastRequiredNonMaskPos;
    var oldVal;
    var focusText;
    var caretTimeoutId;
    var buffer;
    var defaultBuffer;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === "number") {
            begin = first;
            end = typeof last === "number" ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(true);
                range.moveEnd("character", end);
                range.moveStart("character", begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                begin = 0 - range.duplicate().moveStart("character", -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent("HTMLEvents");
            event.initEvent("change", true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || $55f035118b475c06$export$ff8ccbac9225de62.isIOS() && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos = caret();
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if ($55f035118b475c06$export$ff8ccbac9225de62.isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join("");
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join("") === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = "";
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace("?", "").length) caret(0, pos);
            else caret(pos);
        }, 100);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join("");
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue();
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : "",
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    value: defaultBuffer !== val ? val : ""
                }
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener("focus", onFocus);
        el.addEventListener("blur", onBlur);
        el.addEventListener("keydown", onKeyDown);
        el.addEventListener("keypress", onKeyPress);
        el.addEventListener("input", onInput);
        el.addEventListener("paste", handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener("focus", onFocus);
        el.removeEventListener("blur", onBlur);
        el.removeEventListener("keydown", onKeyDown);
        el.removeEventListener("keypress", onKeyPress);
        el.removeEventListener("input", onInput);
        el.removeEventListener("paste", handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: "[0-9]",
            a: "[A-Za-z]",
            "*": "[A-Za-z0-9]"
        };
        androidChrome = $55f035118b475c06$export$ff8ccbac9225de62.isChrome() && $55f035118b475c06$export$ff8ccbac9225de62.isAndroid();
        var maskTokens = options.mask.split("");
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === "?") {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== "?") {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join("");
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function $55f035118b475c06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55f035118b475c06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55f035118b475c06$var$ownKeys(Object(t), !0).forEach(function(r) {
            $55f035118b475c06$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55f035118b475c06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Merges properties together taking an Array of props and merging into one single set of
 * properties. The options can contain a "classNameMergeFunction" which can be something
 * like Tailwind Merge for properly merging Tailwind classes.
 *
 * @param {object[]} props the array of object properties to merge
 * @param {*} options either empty or could contain a custom merge function like TailwindMerge
 * @returns the single properties value after merging
 */ function $55f035118b475c06$export$9d1611c77c2fe928(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!props) return undefined;
    var isFunction = function isFunction(obj) {
        return typeof obj === "function";
    };
    var classNameMergeFunction = options.classNameMergeFunction;
    var hasMergeFunction = isFunction(classNameMergeFunction);
    return props.reduce(function(merged, ps) {
        if (!ps) return merged;
        var _loop = function _loop() {
            var value = ps[key];
            if (key === "style") merged.style = $55f035118b475c06$var$_objectSpread($55f035118b475c06$var$_objectSpread({}, merged.style), ps.style);
            else if (key === "className") {
                var newClassName = "";
                if (hasMergeFunction) newClassName = classNameMergeFunction(merged.className, ps.className);
                else newClassName = [
                    merged.className,
                    ps.className
                ].join(" ").trim();
                merged.className = newClassName || undefined;
            } else if (isFunction(value)) {
                var existingFn = merged[key];
                merged[key] = existingFn ? function() {
                    existingFn.apply(void 0, arguments);
                    value.apply(void 0, arguments);
                } : value;
            } else merged[key] = value;
        };
        for(var key in ps)_loop();
        return merged;
    }, {});
}
function $55f035118b475c06$var$handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return $55f035118b475c06$var$_toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex($55f035118b475c06$export$832931caede8e4b9.get(el));
                el.style.zIndex = "";
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var $55f035118b475c06$export$832931caede8e4b9 = $55f035118b475c06$var$handler();

});


parcelRegister("aLIw2", function(module, exports) {
$parcel$export(module.exports, "AVAILABLE_LANGUAGES", function () { return (parcelRequire("4GCPM")).AVAILABLE_LANGUAGES; });
$parcel$export(module.exports, "AVAILABLE_LANGUAGES_LOCAL", function () { return (parcelRequire("4GCPM")).AVAILABLE_LANGUAGES_LOCAL; });
$parcel$export(module.exports, "LOCALE_CODE_MAP", function () { return (parcelRequire("4GCPM")).LOCALE_CODE_MAP; });
$parcel$export(module.exports, "LocalizationProvider", function () { return (parcelRequire("4GCPM")).LocalizationProvider; });
$parcel$export(module.exports, "useLocalizationContext", function () { return (parcelRequire("4GCPM")).useLocalizationContext; });
parcelRequire("4GCPM");

});
parcelRegister("4GCPM", function(module, exports) {

$parcel$export(module.exports, "AVAILABLE_LANGUAGES_LOCAL", function () { return $a05be003c71ca337$export$ae7d86b2ea986ec9; });
$parcel$export(module.exports, "AVAILABLE_LANGUAGES", function () { return $a05be003c71ca337$export$ffc6a8d1e43fcff0; });
$parcel$export(module.exports, "LOCALE_CODE_MAP", function () { return $a05be003c71ca337$export$a70693ca93159eb0; });
$parcel$export(module.exports, "LocalizationProvider", function () { return $a05be003c71ca337$export$dc45bdc734ce6f1e; });
$parcel$export(module.exports, "useLocalizationContext", function () { return $a05be003c71ca337$export$4b5a24245de9f7f9; });

var $7E7Dk = parcelRequire("7E7Dk");

var $bMTvp = parcelRequire("bMTvp");

var $64iKg = parcelRequire("64iKg");
var $4PKKQ = parcelRequire("4PKKQ");
var $1a4eI = parcelRequire("1a4eI");
var $kPUG3 = parcelRequire("kPUG3");
var $2qHB3 = parcelRequire("2qHB3");
var $4NT7r = parcelRequire("4NT7r");
var $evTZe = parcelRequire("evTZe");
var $d5Zuc = parcelRequire("d5Zuc");

var $1sDHO = parcelRequire("1sDHO");
const $a05be003c71ca337$export$ae7d86b2ea986ec9 = {
    de: "Deutsch",
    en: "English",
    es: "Espa\xf1ol",
    nl: "Nederlands",
    fr: "Fran\xe7ais",
    no: "Norsk",
    fi: "Suomen Kieli",
    sv: "Svenska"
};
const $a05be003c71ca337$export$ffc6a8d1e43fcff0 = [
    "de",
    "en",
    "es",
    "fi",
    "fr",
    "no",
    "sv",
    "nl"
];
const $a05be003c71ca337$export$a70693ca93159eb0 = {
    de: $64iKg.default,
    en: (0, $4PKKQ.default),
    es: $1a4eI.default,
    fi: $kPUG3.default,
    fr: $2qHB3.default,
    no: (0, $4NT7r.default),
    sv: $d5Zuc.default,
    nl: $evTZe.default
};
const $a05be003c71ca337$var$savedLocale = (0, $1sDHO.default).getItem("userLocale");
const $a05be003c71ca337$var$browserLocal = navigator.language.split(/[-_]/)[0];
const $a05be003c71ca337$var$initialLocale = ($a05be003c71ca337$var$savedLocale && $a05be003c71ca337$export$ffc6a8d1e43fcff0.includes($a05be003c71ca337$var$savedLocale) ? $a05be003c71ca337$var$savedLocale : undefined) || ($a05be003c71ca337$export$ffc6a8d1e43fcff0.includes($a05be003c71ca337$var$browserLocal) ? $a05be003c71ca337$var$browserLocal : undefined) || "en";
const $a05be003c71ca337$export$51216bcc3983e55d = /*#__PURE__*/ (0, $7E7Dk.createContext)({
    locale: $a05be003c71ca337$var$initialLocale
});








const $a05be003c71ca337$var$loadMessagesByLocale = (locale)=>{
    switch(locale){
        case "de":
            return (parcelRequire("ghF0i"));
        case "es":
            return (parcelRequire("6HhYn"));
        case "sv":
            return (parcelRequire("henI1"));
        case "fi":
            return (parcelRequire("gVOkF"));
        case "fr":
            return (parcelRequire("bQ5lY"));
        case "nl":
            return (parcelRequire("pztdu"));
        case "no":
            return (parcelRequire("a2a4f"));
        default:
            return (parcelRequire("aEbvB"));
    }
};
const $a05be003c71ca337$var$use = (promise)=>{
    if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else if (promise.status === "pending") throw promise;
    else {
        promise.status = "pending";
        promise.then((result)=>{
            promise.status = "fulfilled";
            promise.value = result;
        }, (reason)=>{
            promise.status = "rejected";
            promise.reason = reason;
        });
        throw promise;
    }
};
const $a05be003c71ca337$export$dc45bdc734ce6f1e = ({ children: children })=>{
    const [locale, setLocale] = (0, $7E7Dk.useState)($a05be003c71ca337$var$initialLocale);
    const messages = $a05be003c71ca337$var$use($a05be003c71ca337$var$loadMessagesByLocale(locale));
    (0, $7E7Dk.useEffect)(()=>{
        (0, $1sDHO.default).setItem("userLocale", locale);
        document.documentElement.setAttribute("lang", locale || "en");
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a05be003c71ca337$export$51216bcc3983e55d.Provider, {
        value: {
            locale: locale,
            setLocale: setLocale
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bMTvp.default), {
        locale: locale,
        messages: messages
    }, children));
};
const $a05be003c71ca337$export$4b5a24245de9f7f9 = ()=>{
    const context = (0, $7E7Dk.useContext)($a05be003c71ca337$export$51216bcc3983e55d);
    return context;
};

});
parcelRegister("bMTvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894f3ba39b355ccc$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $533Ow = parcelRequire("533Ow");

var $jLLCB = parcelRequire("jLLCB");

var $7E7Dk = parcelRequire("7E7Dk");

var $cfMpI = parcelRequire("cfMpI");

var $er4Ja = parcelRequire("er4Ja");

var $fLYEJ = parcelRequire("fLYEJ");
function $894f3ba39b355ccc$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $894f3ba39b355ccc$var$IntlProvider = /** @class */ function(_super) {
    (0, $533Ow.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $jLLCB.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $fLYEJ.createIntl)($894f3ba39b355ccc$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $894f3ba39b355ccc$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $894f3ba39b355ccc$var$processIntlConfig(props);
        if (!(0, $cfMpI.shallowEqual)(prevConfig, config)) return {
            intl: (0, $fLYEJ.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $cfMpI.invariantIntlContext)(this.state.intl);
        return $7E7Dk.createElement((0, $er4Ja.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $cfMpI.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($7E7Dk.PureComponent);
var $894f3ba39b355ccc$export$2e2bcd8739ae039 = $894f3ba39b355ccc$var$IntlProvider;

});
parcelRegister("533Ow", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $3ad030f03577b282$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $3ad030f03577b282$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $3ad030f03577b282$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $3ad030f03577b282$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3ad030f03577b282$var$extendStatics = function(d, b) {
    $3ad030f03577b282$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3ad030f03577b282$var$extendStatics(d, b);
};
function $3ad030f03577b282$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3ad030f03577b282$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3ad030f03577b282$export$18ce0697a983be9b = function() {
    $3ad030f03577b282$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ad030f03577b282$export$18ce0697a983be9b.apply(this, arguments);
};
function $3ad030f03577b282$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3ad030f03577b282$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3ad030f03577b282$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3ad030f03577b282$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3ad030f03577b282$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3ad030f03577b282$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3ad030f03577b282$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3ad030f03577b282$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3ad030f03577b282$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3ad030f03577b282$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3ad030f03577b282$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3ad030f03577b282$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3ad030f03577b282$export$45d3717a4c69092e(o, m, p);
}
function $3ad030f03577b282$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3ad030f03577b282$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3ad030f03577b282$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3ad030f03577b282$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3ad030f03577b282$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3ad030f03577b282$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3ad030f03577b282$export$10c90e4f7922046c(v) {
    return this instanceof $3ad030f03577b282$export$10c90e4f7922046c ? (this.v = v, this) : new $3ad030f03577b282$export$10c90e4f7922046c(v);
}
function $3ad030f03577b282$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3ad030f03577b282$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3ad030f03577b282$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3ad030f03577b282$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3ad030f03577b282$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3ad030f03577b282$export$19a8beecd37a4c45 === "function" ? $3ad030f03577b282$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3ad030f03577b282$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3ad030f03577b282$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3ad030f03577b282$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3ad030f03577b282$export$45d3717a4c69092e(result, mod, k);
    }
    $3ad030f03577b282$var$__setModuleDefault(result, mod);
    return result;
}
function $3ad030f03577b282$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3ad030f03577b282$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3ad030f03577b282$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3ad030f03577b282$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3ad030f03577b282$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3ad030f03577b282$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3ad030f03577b282$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3ad030f03577b282$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3ad030f03577b282$export$2e2bcd8739ae039 = {
    __extends: $3ad030f03577b282$export$a8ba968b8961cb8a,
    __assign: $3ad030f03577b282$export$18ce0697a983be9b,
    __rest: $3ad030f03577b282$export$3c9a16f847548506,
    __decorate: $3ad030f03577b282$export$29e00dfd3077644b,
    __param: $3ad030f03577b282$export$d5ad3fd78186038f,
    __metadata: $3ad030f03577b282$export$f1db080c865becb9,
    __awaiter: $3ad030f03577b282$export$1050f835b63b671e,
    __generator: $3ad030f03577b282$export$67ebef60e6f28a6,
    __createBinding: $3ad030f03577b282$export$45d3717a4c69092e,
    __exportStar: $3ad030f03577b282$export$f33643c0debef087,
    __values: $3ad030f03577b282$export$19a8beecd37a4c45,
    __read: $3ad030f03577b282$export$8d051b38c9118094,
    __spread: $3ad030f03577b282$export$afc72e2116322959,
    __spreadArrays: $3ad030f03577b282$export$6388937ca91ccae8,
    __spreadArray: $3ad030f03577b282$export$1216008129fb82ed,
    __await: $3ad030f03577b282$export$10c90e4f7922046c,
    __asyncGenerator: $3ad030f03577b282$export$e427f37a30a4de9b,
    __asyncDelegator: $3ad030f03577b282$export$bbd80228419bb833,
    __asyncValues: $3ad030f03577b282$export$e3b29a3d6162315f,
    __makeTemplateObject: $3ad030f03577b282$export$4fb47efe1390b86f,
    __importStar: $3ad030f03577b282$export$c21735bcef00d192,
    __importDefault: $3ad030f03577b282$export$da59b14a69baef04,
    __classPrivateFieldGet: $3ad030f03577b282$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3ad030f03577b282$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3ad030f03577b282$export$81fdc39f203e4e04,
    __addDisposableResource: $3ad030f03577b282$export$88ac25d8e944e405,
    __disposeResources: $3ad030f03577b282$export$8f076105dc360e92
};

});

parcelRegister("jLLCB", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $e64758c1d5265b98$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $e64758c1d5265b98$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $e64758c1d5265b98$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $e64758c1d5265b98$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $e64758c1d5265b98$export$4ee1db8ce44a209b; });

var $533Ow = parcelRequire("533Ow");
parcelRequire("3i30D");
var $lUfNv = parcelRequire("lUfNv");

var $bdhJI = parcelRequire("bdhJI");

var $9daRQ = parcelRequire("9daRQ");
function $e64758c1d5265b98$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $e64758c1d5265b98$var$defaultErrorHandler = function(error) {};
var $e64758c1d5265b98$var$defaultWarnHandler = function(warning) {};
var $e64758c1d5265b98$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $e64758c1d5265b98$var$defaultErrorHandler,
    onWarn: $e64758c1d5265b98$var$defaultWarnHandler
};
function $e64758c1d5265b98$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $e64758c1d5265b98$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $e64758c1d5265b98$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $e64758c1d5265b98$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $bdhJI.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $533Ow.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $bdhJI.strategies).variadic
    });
    var getNumberFormat = (0, $bdhJI.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $533Ow.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.number),
        strategy: (0, $bdhJI.strategies).variadic
    });
    var getPluralRules = (0, $bdhJI.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $533Ow.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $bdhJI.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $bdhJI.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $lUfNv.IntlMessageFormat)(message, locales, overrideFormats, (0, $533Ow.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.message),
            strategy: (0, $bdhJI.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $bdhJI.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $bdhJI.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $bdhJI.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.list),
            strategy: (0, $bdhJI.strategies).variadic
        }),
        getDisplayNames: (0, $bdhJI.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e64758c1d5265b98$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $bdhJI.strategies).variadic
        })
    };
}
function $e64758c1d5265b98$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $9daRQ.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("3i30D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("l1dje")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("l1dje")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("2iGuW")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("lUfNv")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $lUfNv = parcelRequire("lUfNv");
parcelRequire("l1dje");
parcelRequire("2iGuW");
var $2655631da418c04b$export$2e2bcd8739ae039 = (0, $lUfNv.IntlMessageFormat);

});
parcelRegister("lUfNv", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $ff2b14f885a657a0$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $533Ow = parcelRequire("533Ow");

var $65iPA = parcelRequire("65iPA");

var $bdhJI = parcelRequire("bdhJI");

var $2iGuW = parcelRequire("2iGuW");
// -- MessageFormat --------------------------------------------------------
function $ff2b14f885a657a0$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $533Ow.__assign)((0, $533Ow.__assign)((0, $533Ow.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $ff2b14f885a657a0$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $ff2b14f885a657a0$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $533Ow.__assign)({}, defaultConfig));
}
function $ff2b14f885a657a0$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $ff2b14f885a657a0$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $bdhJI.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ff2b14f885a657a0$var$createFastMemoizeCache(cache.number),
            strategy: (0, $bdhJI.strategies).variadic
        }),
        getDateTimeFormat: (0, $bdhJI.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ff2b14f885a657a0$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $bdhJI.strategies).variadic
        }),
        getPluralRules: (0, $bdhJI.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $533Ow.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $ff2b14f885a657a0$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $bdhJI.strategies).variadic
        })
    };
}
var $ff2b14f885a657a0$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $2iGuW.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $2iGuW.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $533Ow.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $533Ow.__assign)((0, $533Ow.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $ff2b14f885a657a0$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $ff2b14f885a657a0$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $65iPA.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("65iPA", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("fvEku")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("fvEku")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("fvEku")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("fvEku")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("fvEku")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("fvEku")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("fvEku")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("fvEku")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("fvEku")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("fvEku")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("fvEku")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("fvEku")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $46e1d125819d0dc6$export$98e6a39c04603d36; });

var $533Ow = parcelRequire("533Ow");

var $jqLLo = parcelRequire("jqLLo");

var $HGs7E = parcelRequire("HGs7E");

var $fvEku = parcelRequire("fvEku");
function $46e1d125819d0dc6$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $fvEku.isSelectElement)(el) || (0, $fvEku.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $46e1d125819d0dc6$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $fvEku.isNumberElement)(el) && (0, $fvEku.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $fvEku.isDateElement)(el) || (0, $fvEku.isTimeElement)(el)) && (0, $fvEku.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $fvEku.isTagElement)(el)) $46e1d125819d0dc6$var$pruneLocation(el.children);
    });
}
function $46e1d125819d0dc6$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $533Ow.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $HGs7E.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $jqLLo.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $46e1d125819d0dc6$var$pruneLocation(result.val);
    return result.val;
}
var $46e1d125819d0dc6$export$d3c1bfa0f7d806e9 = (0, $HGs7E.Parser);

});
parcelRegister("jqLLo", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $e2557ede66dde380$export$896afd8541959ee5; });
var $e2557ede66dde380$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($e2557ede66dde380$export$896afd8541959ee5 || ($e2557ede66dde380$export$896afd8541959ee5 = {}));

});

parcelRegister("HGs7E", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $0834f277594d09bd$export$7acfa6ed01010e37; });

var $533Ow = parcelRequire("533Ow");

var $jqLLo = parcelRequire("jqLLo");

var $fvEku = parcelRequire("fvEku");

var $86Veh = parcelRequire("86Veh");
parcelRequire("epMm3");
var $2zbq5 = parcelRequire("2zbq5");
var $cRJPY = parcelRequire("cRJPY");

var $c0oMZ = parcelRequire("c0oMZ");
var $0834f277594d09bd$var$_a;
var $0834f277594d09bd$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $86Veh.SPACE_SEPARATOR_REGEX).source, "*"));
var $0834f277594d09bd$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $86Veh.SPACE_SEPARATOR_REGEX).source, "*$"));
function $0834f277594d09bd$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $0834f277594d09bd$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $0834f277594d09bd$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $0834f277594d09bd$var$hasNativeFromEntries = !!Object.fromEntries;
var $0834f277594d09bd$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $0834f277594d09bd$var$hasTrimStart = !!String.prototype.trimStart;
var $0834f277594d09bd$var$hasTrimEnd = !!String.prototype.trimEnd;
var $0834f277594d09bd$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $0834f277594d09bd$var$isSafeInteger = $0834f277594d09bd$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $0834f277594d09bd$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $0834f277594d09bd$var$re = $0834f277594d09bd$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $0834f277594d09bd$var$REGEX_SUPPORTS_U_AND_Y = (($0834f277594d09bd$var$_a = $0834f277594d09bd$var$re.exec("a")) === null || $0834f277594d09bd$var$_a === void 0 ? void 0 : $0834f277594d09bd$var$_a[0]) === "a";
} catch (_) {
    $0834f277594d09bd$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $0834f277594d09bd$var$startsWith = $0834f277594d09bd$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $0834f277594d09bd$var$fromCodePoint = $0834f277594d09bd$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $0834f277594d09bd$var$fromEntries = // native
$0834f277594d09bd$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $0834f277594d09bd$var$codePointAt = $0834f277594d09bd$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $0834f277594d09bd$var$trimStart = $0834f277594d09bd$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($0834f277594d09bd$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $0834f277594d09bd$var$trimEnd = $0834f277594d09bd$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($0834f277594d09bd$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $0834f277594d09bd$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $0834f277594d09bd$var$matchIdentifierAtIndex;
if ($0834f277594d09bd$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $0834f277594d09bd$var$IDENTIFIER_PREFIX_RE_1 = $0834f277594d09bd$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $0834f277594d09bd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $0834f277594d09bd$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $0834f277594d09bd$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$0834f277594d09bd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $0834f277594d09bd$var$codePointAt(s, index);
        if (c === undefined || $0834f277594d09bd$var$_isWhiteSpace(c) || $0834f277594d09bd$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $0834f277594d09bd$var$fromCodePoint.apply(void 0, match);
};
var $0834f277594d09bd$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $fvEku.TYPE).pound,
                    location: $0834f277594d09bd$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $jqLLo.ErrorKind).UNMATCHED_CLOSING_TAG, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $0834f277594d09bd$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $fvEku.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $0834f277594d09bd$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$0834f277594d09bd$var$_isAlpha(this.char())) return this.error((0, $jqLLo.ErrorKind).INVALID_TAG, $0834f277594d09bd$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $jqLLo.ErrorKind).UNMATCHED_CLOSING_TAG, $0834f277594d09bd$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $jqLLo.ErrorKind).INVALID_TAG, $0834f277594d09bd$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $fvEku.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $0834f277594d09bd$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $jqLLo.ErrorKind).UNCLOSED_TAG, $0834f277594d09bd$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $jqLLo.ErrorKind).INVALID_TAG, $0834f277594d09bd$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $0834f277594d09bd$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $0834f277594d09bd$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $fvEku.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$0834f277594d09bd$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $0834f277594d09bd$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $0834f277594d09bd$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $jqLLo.ErrorKind).EMPTY_ARGUMENT, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $jqLLo.ErrorKind).MALFORMED_ARGUMENT, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $fvEku.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $jqLLo.ErrorKind).MALFORMED_ARGUMENT, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $0834f277594d09bd$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $0834f277594d09bd$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_TYPE, $0834f277594d09bd$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $0834f277594d09bd$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_STYLE, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $0834f277594d09bd$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $0834f277594d09bd$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $0834f277594d09bd$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $fvEku.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $jqLLo.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $c0oMZ.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $fvEku.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $2zbq5.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $fvEku.TYPE).date : (0, $fvEku.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $fvEku.TYPE).number : argType === "date" ? (0, $fvEku.TYPE).date : (0, $fvEku.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $jqLLo.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $0834f277594d09bd$var$createLocation(typeEndPosition_1, (0, $533Ow.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $jqLLo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $jqLLo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $jqLLo.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $fvEku.TYPE).select,
                        value: value,
                        options: $0834f277594d09bd$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $fvEku.TYPE).plural,
                        value: value,
                        options: $0834f277594d09bd$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $jqLLo.ErrorKind).INVALID_ARGUMENT_TYPE, $0834f277594d09bd$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $jqLLo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $jqLLo.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $0834f277594d09bd$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $cRJPY.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $jqLLo.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $fvEku.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $cRJPY.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $jqLLo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $jqLLo.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $0834f277594d09bd$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $jqLLo.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $jqLLo.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $jqLLo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $jqLLo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $0834f277594d09bd$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $jqLLo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $jqLLo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $jqLLo.ErrorKind).MISSING_OTHER_CLAUSE, $0834f277594d09bd$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $0834f277594d09bd$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$0834f277594d09bd$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $0834f277594d09bd$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($0834f277594d09bd$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $0834f277594d09bd$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $0834f277594d09bd$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $0834f277594d09bd$var$_isAlphaOrSlash(codepoint) {
    return $0834f277594d09bd$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $0834f277594d09bd$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0834f277594d09bd$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $0834f277594d09bd$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("fvEku", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $b4a908e255363bf3$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $b4a908e255363bf3$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $b4a908e255363bf3$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $b4a908e255363bf3$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $b4a908e255363bf3$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $b4a908e255363bf3$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $b4a908e255363bf3$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $b4a908e255363bf3$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $b4a908e255363bf3$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $b4a908e255363bf3$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $b4a908e255363bf3$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $b4a908e255363bf3$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $b4a908e255363bf3$export$7680c41f1a55f4cf; });
var $b4a908e255363bf3$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($b4a908e255363bf3$export$b87f371cbc396fcf || ($b4a908e255363bf3$export$b87f371cbc396fcf = {}));
var $b4a908e255363bf3$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($b4a908e255363bf3$export$906452485466fa53 || ($b4a908e255363bf3$export$906452485466fa53 = {}));
function $b4a908e255363bf3$export$cfa10c5697238752(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.literal;
}
function $b4a908e255363bf3$export$4f55724281bdfaf9(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.argument;
}
function $b4a908e255363bf3$export$e11187b219e191e1(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.number;
}
function $b4a908e255363bf3$export$32d811605da75f40(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.date;
}
function $b4a908e255363bf3$export$34ec46f596b1702f(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.time;
}
function $b4a908e255363bf3$export$dcfe1c11d168b5a1(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.select;
}
function $b4a908e255363bf3$export$6c796d116f0a4fbc(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.plural;
}
function $b4a908e255363bf3$export$c0ece297bdd0c082(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.pound;
}
function $b4a908e255363bf3$export$5c83de34745812b(el) {
    return el.type === $b4a908e255363bf3$export$b87f371cbc396fcf.tag;
}
function $b4a908e255363bf3$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $b4a908e255363bf3$export$906452485466fa53.number);
}
function $b4a908e255363bf3$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $b4a908e255363bf3$export$906452485466fa53.dateTime);
}
function $b4a908e255363bf3$export$f0ac572c1121c662(value) {
    return {
        type: $b4a908e255363bf3$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $b4a908e255363bf3$export$425e864b0ba114f1(value, style) {
    return {
        type: $b4a908e255363bf3$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("86Veh", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $5e7b46d2cd1752a6$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $5e7b46d2cd1752a6$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $5e7b46d2cd1752a6$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("epMm3", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("2zbq5")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("cRJPY")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("cRJPY")).parseNumberSkeletonFromString; });
parcelRequire("2zbq5");
parcelRequire("cRJPY");

});
parcelRegister("2zbq5", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $1de7b56459ad5706$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $1de7b56459ad5706$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $1de7b56459ad5706$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($1de7b56459ad5706$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("cRJPY", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $95ddfd9e42eabee6$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $95ddfd9e42eabee6$export$47c6f8480bda3e11; });

var $533Ow = parcelRequire("533Ow");

var $71bCL = parcelRequire("71bCL");
function $95ddfd9e42eabee6$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $71bCL.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $95ddfd9e42eabee6$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $95ddfd9e42eabee6$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $95ddfd9e42eabee6$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $95ddfd9e42eabee6$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $95ddfd9e42eabee6$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $95ddfd9e42eabee6$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($95ddfd9e42eabee6$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $95ddfd9e42eabee6$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $95ddfd9e42eabee6$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$95ddfd9e42eabee6$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $95ddfd9e42eabee6$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $95ddfd9e42eabee6$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $95ddfd9e42eabee6$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $95ddfd9e42eabee6$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $533Ow.__assign)((0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $533Ow.__assign)((0, $533Ow.__assign)({}, all), $95ddfd9e42eabee6$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $533Ow.__assign)((0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $533Ow.__assign)((0, $533Ow.__assign)({}, all), $95ddfd9e42eabee6$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($95ddfd9e42eabee6$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($95ddfd9e42eabee6$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($95ddfd9e42eabee6$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($95ddfd9e42eabee6$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), $95ddfd9e42eabee6$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($95ddfd9e42eabee6$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), $95ddfd9e42eabee6$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $95ddfd9e42eabee6$var$parseSign(token.stem);
        if (signOpts) result = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $95ddfd9e42eabee6$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("71bCL", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $51c1a4b72b5f766f$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $51c1a4b72b5f766f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("c0oMZ", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $8bd8b6b5b4be2989$export$29c5368be8904d27; });

var $e4jB1 = parcelRequire("e4jB1");
function $8bd8b6b5b4be2989$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $8bd8b6b5b4be2989$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $8bd8b6b5b4be2989$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $e4jB1.timeData)[regionTag || ""] || (0, $e4jB1.timeData)[languageTag || ""] || (0, $e4jB1.timeData)["".concat(languageTag, "-001")] || (0, $e4jB1.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("e4jB1", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $a3e0a3d1466f0436$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $a3e0a3d1466f0436$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("bdhJI", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $829eaaab53fab83b$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $829eaaab53fab83b$export$c5491a8691a23b9e; });
//
// Main
//
function $829eaaab53fab83b$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $829eaaab53fab83b$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $829eaaab53fab83b$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $829eaaab53fab83b$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $829eaaab53fab83b$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $829eaaab53fab83b$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $829eaaab53fab83b$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $829eaaab53fab83b$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $829eaaab53fab83b$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $829eaaab53fab83b$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $829eaaab53fab83b$var$monadic : $829eaaab53fab83b$var$variadic;
    return $829eaaab53fab83b$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $829eaaab53fab83b$var$strategyVariadic(fn, options) {
    return $829eaaab53fab83b$var$assemble(fn, this, $829eaaab53fab83b$var$variadic, options.cache.create(), options.serializer);
}
function $829eaaab53fab83b$var$strategyMonadic(fn, options) {
    return $829eaaab53fab83b$var$assemble(fn, this, $829eaaab53fab83b$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $829eaaab53fab83b$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $829eaaab53fab83b$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$829eaaab53fab83b$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$829eaaab53fab83b$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $829eaaab53fab83b$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $829eaaab53fab83b$var$ObjectWithoutPrototypeCache();
    }
};
var $829eaaab53fab83b$export$c5491a8691a23b9e = {
    variadic: $829eaaab53fab83b$var$strategyVariadic,
    monadic: $829eaaab53fab83b$var$strategyMonadic
};

});

parcelRegister("2iGuW", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $1ace3a6a35b79d4c$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $1ace3a6a35b79d4c$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $1ace3a6a35b79d4c$export$275d4a3bb5f66fda; });
parcelRequire("65iPA");
var $fvEku = parcelRequire("fvEku");

var $l1dje = parcelRequire("l1dje");
var $1ace3a6a35b79d4c$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($1ace3a6a35b79d4c$export$49694c2877b44c57 || ($1ace3a6a35b79d4c$export$49694c2877b44c57 = {}));
function $1ace3a6a35b79d4c$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $1ace3a6a35b79d4c$export$49694c2877b44c57.literal || part.type !== $1ace3a6a35b79d4c$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $1ace3a6a35b79d4c$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $1ace3a6a35b79d4c$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $fvEku.isLiteralElement)(els[0])) return [
        {
            type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $fvEku.isLiteralElement)(el)) {
            result.push({
                type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $fvEku.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $l1dje.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $fvEku.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $1ace3a6a35b79d4c$export$49694c2877b44c57.literal : $1ace3a6a35b79d4c$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $fvEku.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $fvEku.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fvEku.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $fvEku.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fvEku.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $fvEku.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $1ace3a6a35b79d4c$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $fvEku.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$1ace3a6a35b79d4c$export$df0c12a2d414a163(formatFn)) throw new (0, $l1dje.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $1ace3a6a35b79d4c$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $1ace3a6a35b79d4c$export$49694c2877b44c57.literal : $1ace3a6a35b79d4c$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $fvEku.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $l1dje.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $1ace3a6a35b79d4c$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $fvEku.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $l1dje.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $l1dje.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $l1dje.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $1ace3a6a35b79d4c$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $1ace3a6a35b79d4c$var$mergeLiteral(result);
}

});
parcelRegister("l1dje", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $f4d403eb43fc0cd0$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $f4d403eb43fc0cd0$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $f4d403eb43fc0cd0$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $f4d403eb43fc0cd0$export$8bfc137e4d23fdf0; });

var $533Ow = parcelRequire("533Ow");
var $f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb || ($f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb = {}));
var $f4d403eb43fc0cd0$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $f4d403eb43fc0cd0$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($f4d403eb43fc0cd0$export$7369836851cc1329);
var $f4d403eb43fc0cd0$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($f4d403eb43fc0cd0$export$7369836851cc1329);
var $f4d403eb43fc0cd0$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $f4d403eb43fc0cd0$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($f4d403eb43fc0cd0$export$7369836851cc1329);

});




parcelRegister("9daRQ", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $6b4dc2003861ce61$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $6b4dc2003861ce61$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $6b4dc2003861ce61$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $6b4dc2003861ce61$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $6b4dc2003861ce61$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $6b4dc2003861ce61$export$2ddcb436d0aa3688; });

var $533Ow = parcelRequire("533Ow");
var $6b4dc2003861ce61$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($6b4dc2003861ce61$export$557d6acb76e8a244 || ($6b4dc2003861ce61$export$557d6acb76e8a244 = {}));
var $6b4dc2003861ce61$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $6b4dc2003861ce61$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $6b4dc2003861ce61$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($6b4dc2003861ce61$export$c016d36112f6ddf8);
var $6b4dc2003861ce61$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $6b4dc2003861ce61$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($6b4dc2003861ce61$export$c016d36112f6ddf8);
var $6b4dc2003861ce61$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $6b4dc2003861ce61$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($6b4dc2003861ce61$export$c016d36112f6ddf8);
var $6b4dc2003861ce61$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $6b4dc2003861ce61$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($6b4dc2003861ce61$export$c016d36112f6ddf8);
var $6b4dc2003861ce61$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($6b4dc2003861ce61$export$e3b7eee1dbc44895);
var $6b4dc2003861ce61$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $533Ow.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $6b4dc2003861ce61$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($6b4dc2003861ce61$export$c016d36112f6ddf8);

});


parcelRegister("cfMpI", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $8ebc70b9fea1d254$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $8ebc70b9fea1d254$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $8ebc70b9fea1d254$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $8ebc70b9fea1d254$export$d36bdfa510afb180; });

var $533Ow = parcelRequire("533Ow");

var $7E7Dk = parcelRequire("7E7Dk");

var $eOyns = parcelRequire("eOyns");

var $jLLCB = parcelRequire("jLLCB");
function $8ebc70b9fea1d254$export$45c4bbf6e55bba1f(intl) {
    (0, $eOyns.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $8ebc70b9fea1d254$export$b52f8d6fc0d47415 = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, (0, $jLLCB.DEFAULT_INTL_CONFIG)), {
    textComponent: $7E7Dk.Fragment
});
function $8ebc70b9fea1d254$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($7E7Dk.Children.toArray(parts));
    };
}
function $8ebc70b9fea1d254$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("eOyns", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $ac9066cfe253deaf$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $ac9066cfe253deaf$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $ac9066cfe253deaf$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $ac9066cfe253deaf$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $ac9066cfe253deaf$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $ac9066cfe253deaf$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $ac9066cfe253deaf$export$3fae2929ed23c202(map, pl, field) {
    return $ac9066cfe253deaf$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $ac9066cfe253deaf$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $ac9066cfe253deaf$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $ac9066cfe253deaf$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $ac9066cfe253deaf$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $ac9066cfe253deaf$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});


parcelRegister("er4Ja", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $a827411a371d6fd2$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $a827411a371d6fd2$export$841858b892ce1f4c; });

var $533Ow = parcelRequire("533Ow");

var $7E7Dk = parcelRequire("7E7Dk");

var $2ZIlj = parcelRequire("2ZIlj");

var $cfMpI = parcelRequire("cfMpI");
function $a827411a371d6fd2$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $a827411a371d6fd2$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $7E7Dk.createContext(null)) : $7E7Dk.createContext(null);
var $a827411a371d6fd2$var$IntlConsumer = $a827411a371d6fd2$var$IntlContext.Consumer, $a827411a371d6fd2$var$IntlProvider = $a827411a371d6fd2$var$IntlContext.Provider;
var $a827411a371d6fd2$export$2881499e37b75b9a = $a827411a371d6fd2$var$IntlProvider;
var $a827411a371d6fd2$export$841858b892ce1f4c = $a827411a371d6fd2$var$IntlContext;
function $a827411a371d6fd2$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $7E7Dk.createElement($a827411a371d6fd2$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $cfMpI.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $7E7Dk.createElement(WrappedComponent, (0, $533Ow.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($a827411a371d6fd2$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($2ZIlj)))($7E7Dk.forwardRef(function(props, ref) {
        return $7E7Dk.createElement(WithIntl, (0, $533Ow.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2ZIlj)))(WithIntl, WrappedComponent);
}

});
parcelRegister("2ZIlj", function(module, exports) {
"use strict";

var $56ZCW = parcelRequire("56ZCW");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $22e3accca39b6b2b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $22e3accca39b6b2b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $22e3accca39b6b2b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $22e3accca39b6b2b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $22e3accca39b6b2b$var$TYPE_STATICS = {};
$22e3accca39b6b2b$var$TYPE_STATICS[$56ZCW.ForwardRef] = $22e3accca39b6b2b$var$FORWARD_REF_STATICS;
$22e3accca39b6b2b$var$TYPE_STATICS[$56ZCW.Memo] = $22e3accca39b6b2b$var$MEMO_STATICS;
function $22e3accca39b6b2b$var$getStatics(component) {
    // React v16.11 and below
    if ($56ZCW.isMemo(component)) return $22e3accca39b6b2b$var$MEMO_STATICS;
     // React v16.12 and above
    return $22e3accca39b6b2b$var$TYPE_STATICS[component["$$typeof"]] || $22e3accca39b6b2b$var$REACT_STATICS;
}
var $22e3accca39b6b2b$var$defineProperty = Object.defineProperty;
var $22e3accca39b6b2b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $22e3accca39b6b2b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $22e3accca39b6b2b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $22e3accca39b6b2b$var$getPrototypeOf = Object.getPrototypeOf;
var $22e3accca39b6b2b$var$objectPrototype = Object.prototype;
function $22e3accca39b6b2b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($22e3accca39b6b2b$var$objectPrototype) {
            var inheritedComponent = $22e3accca39b6b2b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $22e3accca39b6b2b$var$objectPrototype) $22e3accca39b6b2b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $22e3accca39b6b2b$var$getOwnPropertyNames(sourceComponent);
        if ($22e3accca39b6b2b$var$getOwnPropertySymbols) keys = keys.concat($22e3accca39b6b2b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $22e3accca39b6b2b$var$getStatics(targetComponent);
        var sourceStatics = $22e3accca39b6b2b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$22e3accca39b6b2b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $22e3accca39b6b2b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $22e3accca39b6b2b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $22e3accca39b6b2b$var$hoistNonReactStatics;

});
parcelRegister("56ZCW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5d2Fk"));

});
parcelRegister("5d2Fk", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $3cb03bf563257668$export$2b8d127b894957b9; }, function (v) { return $3cb03bf563257668$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $3cb03bf563257668$export$cea3a54a6425200c; }, function (v) { return $3cb03bf563257668$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $3cb03bf563257668$export$a7c73072b1a182ae; }, function (v) { return $3cb03bf563257668$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $3cb03bf563257668$export$9f27bc3417b4524d; }, function (v) { return $3cb03bf563257668$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $3cb03bf563257668$export$db77ccec0bb4ccac; }, function (v) { return $3cb03bf563257668$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $3cb03bf563257668$export$8392c0c9d3dcbd35; }, function (v) { return $3cb03bf563257668$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3cb03bf563257668$export$ffb0004e005737fa; }, function (v) { return $3cb03bf563257668$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $3cb03bf563257668$export$b624eff549462981; }, function (v) { return $3cb03bf563257668$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $3cb03bf563257668$export$7897aa7841a5380c; }, function (v) { return $3cb03bf563257668$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $3cb03bf563257668$export$602eac185826482c; }, function (v) { return $3cb03bf563257668$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $3cb03bf563257668$export$e2c29f18771995cb; }, function (v) { return $3cb03bf563257668$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3cb03bf563257668$export$5f8d39834fd61797; }, function (v) { return $3cb03bf563257668$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3cb03bf563257668$export$74bf444e3cd11ea5; }, function (v) { return $3cb03bf563257668$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $3cb03bf563257668$export$92387174baf9b227; }, function (v) { return $3cb03bf563257668$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $3cb03bf563257668$export$ec112efeb987d9c6; }, function (v) { return $3cb03bf563257668$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $3cb03bf563257668$export$b706b080d889d2c9; }, function (v) { return $3cb03bf563257668$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $3cb03bf563257668$export$5be5a87408f70ddc; }, function (v) { return $3cb03bf563257668$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $3cb03bf563257668$export$45a5e7f76e0caa8d; }, function (v) { return $3cb03bf563257668$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $3cb03bf563257668$export$455c2e768291efa6; }, function (v) { return $3cb03bf563257668$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $3cb03bf563257668$export$9522e17588c12572; }, function (v) { return $3cb03bf563257668$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $3cb03bf563257668$export$2110ac352bb060b9; }, function (v) { return $3cb03bf563257668$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $3cb03bf563257668$export$56885ab8b9c456ab; }, function (v) { return $3cb03bf563257668$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $3cb03bf563257668$export$d927fcb6adf8f9de; }, function (v) { return $3cb03bf563257668$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $3cb03bf563257668$export$b82d16f27459e05a; }, function (v) { return $3cb03bf563257668$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $3cb03bf563257668$export$522c17b4f5e123e8; }, function (v) { return $3cb03bf563257668$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $3cb03bf563257668$export$1aabd8a0274ecfd6; }, function (v) { return $3cb03bf563257668$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $3cb03bf563257668$export$9b621391a187a31a; }, function (v) { return $3cb03bf563257668$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $3cb03bf563257668$export$f5bbd400c2f4426f; }, function (v) { return $3cb03bf563257668$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3cb03bf563257668$export$2b8d127b894957b9;
var $3cb03bf563257668$export$cea3a54a6425200c;
var $3cb03bf563257668$export$a7c73072b1a182ae;
var $3cb03bf563257668$export$9f27bc3417b4524d;
var $3cb03bf563257668$export$db77ccec0bb4ccac;
var $3cb03bf563257668$export$8392c0c9d3dcbd35;
var $3cb03bf563257668$export$ffb0004e005737fa;
var $3cb03bf563257668$export$b624eff549462981;
var $3cb03bf563257668$export$7897aa7841a5380c;
var $3cb03bf563257668$export$602eac185826482c;
var $3cb03bf563257668$export$e2c29f18771995cb;
var $3cb03bf563257668$export$5f8d39834fd61797;
var $3cb03bf563257668$export$74bf444e3cd11ea5;
var $3cb03bf563257668$export$92387174baf9b227;
var $3cb03bf563257668$export$ec112efeb987d9c6;
var $3cb03bf563257668$export$b706b080d889d2c9;
var $3cb03bf563257668$export$5be5a87408f70ddc;
var $3cb03bf563257668$export$45a5e7f76e0caa8d;
var $3cb03bf563257668$export$455c2e768291efa6;
var $3cb03bf563257668$export$9522e17588c12572;
var $3cb03bf563257668$export$2110ac352bb060b9;
var $3cb03bf563257668$export$56885ab8b9c456ab;
var $3cb03bf563257668$export$d927fcb6adf8f9de;
var $3cb03bf563257668$export$b82d16f27459e05a;
var $3cb03bf563257668$export$522c17b4f5e123e8;
var $3cb03bf563257668$export$1aabd8a0274ecfd6;
var $3cb03bf563257668$export$9b621391a187a31a;
var $3cb03bf563257668$export$f5bbd400c2f4426f;
"use strict";
var $3cb03bf563257668$var$b = "function" === typeof Symbol && Symbol.for, $3cb03bf563257668$var$c = $3cb03bf563257668$var$b ? Symbol.for("react.element") : 60103, $3cb03bf563257668$var$d = $3cb03bf563257668$var$b ? Symbol.for("react.portal") : 60106, $3cb03bf563257668$var$e = $3cb03bf563257668$var$b ? Symbol.for("react.fragment") : 60107, $3cb03bf563257668$var$f = $3cb03bf563257668$var$b ? Symbol.for("react.strict_mode") : 60108, $3cb03bf563257668$var$g = $3cb03bf563257668$var$b ? Symbol.for("react.profiler") : 60114, $3cb03bf563257668$var$h = $3cb03bf563257668$var$b ? Symbol.for("react.provider") : 60109, $3cb03bf563257668$var$k = $3cb03bf563257668$var$b ? Symbol.for("react.context") : 60110, $3cb03bf563257668$var$l = $3cb03bf563257668$var$b ? Symbol.for("react.async_mode") : 60111, $3cb03bf563257668$var$m = $3cb03bf563257668$var$b ? Symbol.for("react.concurrent_mode") : 60111, $3cb03bf563257668$var$n = $3cb03bf563257668$var$b ? Symbol.for("react.forward_ref") : 60112, $3cb03bf563257668$var$p = $3cb03bf563257668$var$b ? Symbol.for("react.suspense") : 60113, $3cb03bf563257668$var$q = $3cb03bf563257668$var$b ? Symbol.for("react.suspense_list") : 60120, $3cb03bf563257668$var$r = $3cb03bf563257668$var$b ? Symbol.for("react.memo") : 60115, $3cb03bf563257668$var$t = $3cb03bf563257668$var$b ? Symbol.for("react.lazy") : 60116, $3cb03bf563257668$var$v = $3cb03bf563257668$var$b ? Symbol.for("react.block") : 60121, $3cb03bf563257668$var$w = $3cb03bf563257668$var$b ? Symbol.for("react.fundamental") : 60117, $3cb03bf563257668$var$x = $3cb03bf563257668$var$b ? Symbol.for("react.responder") : 60118, $3cb03bf563257668$var$y = $3cb03bf563257668$var$b ? Symbol.for("react.scope") : 60119;
function $3cb03bf563257668$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $3cb03bf563257668$var$c:
                switch(a = a.type, a){
                    case $3cb03bf563257668$var$l:
                    case $3cb03bf563257668$var$m:
                    case $3cb03bf563257668$var$e:
                    case $3cb03bf563257668$var$g:
                    case $3cb03bf563257668$var$f:
                    case $3cb03bf563257668$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3cb03bf563257668$var$k:
                            case $3cb03bf563257668$var$n:
                            case $3cb03bf563257668$var$t:
                            case $3cb03bf563257668$var$r:
                            case $3cb03bf563257668$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $3cb03bf563257668$var$d:
                return u;
        }
    }
}
function $3cb03bf563257668$var$A(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$m;
}
$3cb03bf563257668$export$2b8d127b894957b9 = $3cb03bf563257668$var$l;
$3cb03bf563257668$export$cea3a54a6425200c = $3cb03bf563257668$var$m;
$3cb03bf563257668$export$a7c73072b1a182ae = $3cb03bf563257668$var$k;
$3cb03bf563257668$export$9f27bc3417b4524d = $3cb03bf563257668$var$h;
$3cb03bf563257668$export$db77ccec0bb4ccac = $3cb03bf563257668$var$c;
$3cb03bf563257668$export$8392c0c9d3dcbd35 = $3cb03bf563257668$var$n;
$3cb03bf563257668$export$ffb0004e005737fa = $3cb03bf563257668$var$e;
$3cb03bf563257668$export$b624eff549462981 = $3cb03bf563257668$var$t;
$3cb03bf563257668$export$7897aa7841a5380c = $3cb03bf563257668$var$r;
$3cb03bf563257668$export$602eac185826482c = $3cb03bf563257668$var$d;
$3cb03bf563257668$export$e2c29f18771995cb = $3cb03bf563257668$var$g;
$3cb03bf563257668$export$5f8d39834fd61797 = $3cb03bf563257668$var$f;
$3cb03bf563257668$export$74bf444e3cd11ea5 = $3cb03bf563257668$var$p;
$3cb03bf563257668$export$92387174baf9b227 = function(a) {
    return $3cb03bf563257668$var$A(a) || $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$l;
};
$3cb03bf563257668$export$ec112efeb987d9c6 = $3cb03bf563257668$var$A;
$3cb03bf563257668$export$b706b080d889d2c9 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$k;
};
$3cb03bf563257668$export$5be5a87408f70ddc = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$h;
};
$3cb03bf563257668$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3cb03bf563257668$var$c;
};
$3cb03bf563257668$export$455c2e768291efa6 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$n;
};
$3cb03bf563257668$export$9522e17588c12572 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$e;
};
$3cb03bf563257668$export$2110ac352bb060b9 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$t;
};
$3cb03bf563257668$export$56885ab8b9c456ab = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$r;
};
$3cb03bf563257668$export$d927fcb6adf8f9de = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$d;
};
$3cb03bf563257668$export$b82d16f27459e05a = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$g;
};
$3cb03bf563257668$export$522c17b4f5e123e8 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$f;
};
$3cb03bf563257668$export$1aabd8a0274ecfd6 = function(a) {
    return $3cb03bf563257668$var$z(a) === $3cb03bf563257668$var$p;
};
$3cb03bf563257668$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3cb03bf563257668$var$e || a === $3cb03bf563257668$var$m || a === $3cb03bf563257668$var$g || a === $3cb03bf563257668$var$f || a === $3cb03bf563257668$var$p || a === $3cb03bf563257668$var$q || "object" === typeof a && null !== a && (a.$$typeof === $3cb03bf563257668$var$t || a.$$typeof === $3cb03bf563257668$var$r || a.$$typeof === $3cb03bf563257668$var$h || a.$$typeof === $3cb03bf563257668$var$k || a.$$typeof === $3cb03bf563257668$var$n || a.$$typeof === $3cb03bf563257668$var$w || a.$$typeof === $3cb03bf563257668$var$x || a.$$typeof === $3cb03bf563257668$var$y || a.$$typeof === $3cb03bf563257668$var$v);
};
$3cb03bf563257668$export$f5bbd400c2f4426f = $3cb03bf563257668$var$z;

});




parcelRegister("fLYEJ", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $b7ba4bd1e5cc0df4$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $533Ow = parcelRequire("533Ow");

var $fbz2O = parcelRequire("fbz2O");
var $gYZ8z = parcelRequire("gYZ8z");

var $7E7Dk = parcelRequire("7E7Dk");

var $cfMpI = parcelRequire("cfMpI");

var $2iGuW = parcelRequire("2iGuW");
function $b7ba4bd1e5cc0df4$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $2iGuW.isFormatXMLElementFn)(v) ? (0, $cfMpI.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $b7ba4bd1e5cc0df4$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $b7ba4bd1e5cc0df4$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $gYZ8z.formatMessage).apply(void 0, (0, $533Ow.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $7E7Dk.Children.toArray(chunks);
    return chunks;
};
var $b7ba4bd1e5cc0df4$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $533Ow.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $b7ba4bd1e5cc0df4$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $fbz2O.createIntl)((0, $533Ow.__assign)((0, $533Ow.__assign)((0, $533Ow.__assign)({}, (0, $cfMpI.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $533Ow.__assign)((0, $533Ow.__assign)({}, coreIntl), {
        formatMessage: $b7ba4bd1e5cc0df4$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $b7ba4bd1e5cc0df4$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("fbz2O", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $02da5f3e940c2abc$export$7e4cbedfdd7b4c0d; });

var $533Ow = parcelRequire("533Ow");

var $jLLCB = parcelRequire("jLLCB");

var $9daRQ = parcelRequire("9daRQ");

var $hy8No = parcelRequire("hy8No");

var $daIza = parcelRequire("daIza");

var $1O5PK = parcelRequire("1O5PK");

var $7ghQG = parcelRequire("7ghQG");

var $gYZ8z = parcelRequire("gYZ8z");

var $ijhOV = parcelRequire("ijhOV");

var $cFVuE = parcelRequire("cFVuE");
function $02da5f3e940c2abc$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $02da5f3e940c2abc$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $02da5f3e940c2abc$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $02da5f3e940c2abc$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $jLLCB.createFormatters)(cache);
    var resolvedConfig = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, (0, $jLLCB.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $9daRQ.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9daRQ.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9daRQ.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $02da5f3e940c2abc$var$verifyConfigMessages(resolvedConfig);
    return (0, $533Ow.__assign)((0, $533Ow.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $hy8No.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $hy8No.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $daIza.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $1O5PK.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $1O5PK.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $1O5PK.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $1O5PK.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $1O5PK.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $7ghQG.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $gYZ8z.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $gYZ8z.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $ijhOV.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $ijhOV.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $cFVuE.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("hy8No", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $cc6c6f46ccd8d093$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $cc6c6f46ccd8d093$export$6871080848f10b2f; });

var $9daRQ = parcelRequire("9daRQ");

var $jLLCB = parcelRequire("jLLCB");
var $cc6c6f46ccd8d093$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    // ES2023 NumberFormat
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $cc6c6f46ccd8d093$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $jLLCB.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $jLLCB.filterProps)(options, $cc6c6f46ccd8d093$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $cc6c6f46ccd8d093$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $cc6c6f46ccd8d093$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $cc6c6f46ccd8d093$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $cc6c6f46ccd8d093$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("daIza", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $996ec771910d9c02$export$b4ea3b48dcf921f6; });

var $jLLCB = parcelRequire("jLLCB");

var $l1dje = parcelRequire("l1dje");

var $9daRQ = parcelRequire("9daRQ");
var $996ec771910d9c02$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $996ec771910d9c02$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $jLLCB.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $jLLCB.filterProps)(options, $996ec771910d9c02$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $996ec771910d9c02$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $l1dje.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $l1dje.ErrorCode).MISSING_INTL_API));
    try {
        return $996ec771910d9c02$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("1O5PK", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $150efc6114be7bb9$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $150efc6114be7bb9$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $150efc6114be7bb9$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $150efc6114be7bb9$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $150efc6114be7bb9$export$af6e5d7a5c73edeb; });

var $533Ow = parcelRequire("533Ow");

var $jLLCB = parcelRequire("jLLCB");

var $9daRQ = parcelRequire("9daRQ");
var $150efc6114be7bb9$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $150efc6114be7bb9$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $jLLCB.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $jLLCB.filterProps)(options, $150efc6114be7bb9$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $150efc6114be7bb9$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $150efc6114be7bb9$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $150efc6114be7bb9$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $150efc6114be7bb9$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $150efc6114be7bb9$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $jLLCB.filterProps)(options, $150efc6114be7bb9$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $9daRQ.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $150efc6114be7bb9$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $150efc6114be7bb9$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $150efc6114be7bb9$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $150efc6114be7bb9$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9daRQ.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("7ghQG", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $5497df6df57d5dcf$export$bbbd05c900f3568d; });

var $jLLCB = parcelRequire("jLLCB");

var $9daRQ = parcelRequire("9daRQ");

var $l1dje = parcelRequire("l1dje");
var $5497df6df57d5dcf$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $5497df6df57d5dcf$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $l1dje.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $l1dje.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jLLCB.filterProps)(options, $5497df6df57d5dcf$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $9daRQ.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("gYZ8z", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $c5d1ac84e724ca8d$export$25868d1e8e76735f; });

var $533Ow = parcelRequire("533Ow");

var $eOyns = parcelRequire("eOyns");
parcelRequire("3i30D");
var $lUfNv = parcelRequire("lUfNv");

var $9daRQ = parcelRequire("9daRQ");
parcelRequire("65iPA");
var $fvEku = parcelRequire("fvEku");
function $c5d1ac84e724ca8d$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $533Ow.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $c5d1ac84e724ca8d$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $533Ow.__assign)((0, $533Ow.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $c5d1ac84e724ca8d$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $lUfNv.IntlMessageFormat).formats;
    return (0, $533Ow.__assign)((0, $533Ow.__assign)((0, $533Ow.__assign)({}, mfFormats), f1), {
        date: $c5d1ac84e724ca8d$var$deepMergeOptions($c5d1ac84e724ca8d$var$setTimeZoneInOptions(mfFormats.date, timeZone), $c5d1ac84e724ca8d$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $c5d1ac84e724ca8d$var$deepMergeOptions($c5d1ac84e724ca8d$var$setTimeZoneInOptions(mfFormats.time, timeZone), $c5d1ac84e724ca8d$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $c5d1ac84e724ca8d$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $eOyns.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $fvEku.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $533Ow.__assign)((0, $533Ow.__assign)({}, defaultRichTextElements), values || {});
    formats = $c5d1ac84e724ca8d$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $c5d1ac84e724ca8d$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $9daRQ.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $9daRQ.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $533Ow.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9daRQ.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9daRQ.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});

parcelRegister("ijhOV", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $d547d316930662ae$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $d547d316930662ae$export$6f284aad1934db69; });

var $533Ow = parcelRequire("533Ow");

var $jLLCB = parcelRequire("jLLCB");

var $l1dje = parcelRequire("l1dje");

var $9daRQ = parcelRequire("9daRQ");
var $d547d316930662ae$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $d547d316930662ae$var$now = Date.now();
function $d547d316930662ae$var$generateToken(i) {
    return "".concat($d547d316930662ae$var$now, "_").concat(i, "_").concat($d547d316930662ae$var$now);
}
function $d547d316930662ae$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $d547d316930662ae$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $d547d316930662ae$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $l1dje.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $l1dje.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jLLCB.filterProps)(options, $d547d316930662ae$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $d547d316930662ae$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $533Ow.__assign)((0, $533Ow.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $9daRQ.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("cFVuE", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $93a5e95b7a940798$export$62fe1a4d9e891fa2; });

var $jLLCB = parcelRequire("jLLCB");

var $l1dje = parcelRequire("l1dje");

var $9daRQ = parcelRequire("9daRQ");
var $93a5e95b7a940798$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $93a5e95b7a940798$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $l1dje.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $l1dje.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jLLCB.filterProps)(options, $93a5e95b7a940798$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $9daRQ.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});




parcelRegister("64iKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b1a839d615400f$export$2e2bcd8739ae039; });

var $hCvqD = parcelRequire("hCvqD");

var $kqN2G = parcelRequire("kqN2G");

var $cael3 = parcelRequire("cael3");

var $MMbAJ = parcelRequire("MMbAJ");

var $brfCA = parcelRequire("brfCA");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $46b1a839d615400f$var$locale = {
    code: "de",
    formatDistance: (0, $hCvqD.default),
    formatLong: (0, $kqN2G.default),
    formatRelative: (0, $cael3.default),
    localize: (0, $MMbAJ.default),
    match: (0, $brfCA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $46b1a839d615400f$export$2e2bcd8739ae039 = $46b1a839d615400f$var$locale;

});
parcelRegister("hCvqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd3e5d51858af283$export$2e2bcd8739ae039; });
var $cd3e5d51858af283$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "halbe Minute",
        withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
var $cd3e5d51858af283$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $cd3e5d51858af283$var$formatDistanceLocale[token].withPreposition : $cd3e5d51858af283$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
var $cd3e5d51858af283$export$2e2bcd8739ae039 = $cd3e5d51858af283$var$formatDistance;

});

parcelRegister("kqN2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edfc471b6395d25e$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $edfc471b6395d25e$var$dateFormats = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y" // 07.01.2018
};
var $edfc471b6395d25e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $edfc471b6395d25e$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $edfc471b6395d25e$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $edfc471b6395d25e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $edfc471b6395d25e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $edfc471b6395d25e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $edfc471b6395d25e$export$2e2bcd8739ae039 = $edfc471b6395d25e$var$formatLong;

});
parcelRegister("6wF66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c059c50f23a6f54$export$2e2bcd8739ae039; });
function $4c059c50f23a6f54$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("cael3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8db18a90fe0c11bd$export$2e2bcd8739ae039; });
var $8db18a90fe0c11bd$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
var $8db18a90fe0c11bd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8db18a90fe0c11bd$var$formatRelativeLocale[token];
};
var $8db18a90fe0c11bd$export$2e2bcd8739ae039 = $8db18a90fe0c11bd$var$formatRelative;

});

parcelRegister("MMbAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0929dc8992073499$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $0929dc8992073499$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
var $0929dc8992073499$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0929dc8992073499$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $0929dc8992073499$var$formattingMonthValues = {
    narrow: $0929dc8992073499$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $0929dc8992073499$var$monthValues.wide
};
var $0929dc8992073499$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $0929dc8992073499$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
var $0929dc8992073499$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
var $0929dc8992073499$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $0929dc8992073499$var$localize = {
    ordinalNumber: $0929dc8992073499$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $0929dc8992073499$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $0929dc8992073499$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $0929dc8992073499$var$monthValues,
        formattingValues: $0929dc8992073499$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $0929dc8992073499$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $0929dc8992073499$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0929dc8992073499$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0929dc8992073499$export$2e2bcd8739ae039 = $0929dc8992073499$var$localize;

});
parcelRegister("iSZtf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbfcf3ee98feb73b$export$2e2bcd8739ae039; });
function $dbfcf3ee98feb73b$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("brfCA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $853e556c0ba07e49$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $853e556c0ba07e49$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $853e556c0ba07e49$var$parseOrdinalNumberPattern = /\d+/i;
var $853e556c0ba07e49$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $853e556c0ba07e49$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $853e556c0ba07e49$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $853e556c0ba07e49$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $853e556c0ba07e49$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $853e556c0ba07e49$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $853e556c0ba07e49$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $853e556c0ba07e49$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $853e556c0ba07e49$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $853e556c0ba07e49$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $853e556c0ba07e49$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $853e556c0ba07e49$var$matchOrdinalNumberPattern,
        parsePattern: $853e556c0ba07e49$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $853e556c0ba07e49$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $853e556c0ba07e49$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $853e556c0ba07e49$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $853e556c0ba07e49$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $853e556c0ba07e49$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $853e556c0ba07e49$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $853e556c0ba07e49$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $853e556c0ba07e49$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $853e556c0ba07e49$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $853e556c0ba07e49$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $853e556c0ba07e49$export$2e2bcd8739ae039 = $853e556c0ba07e49$var$match;

});
parcelRegister("jnJi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1c34c51113f7f9d$export$2e2bcd8739ae039; });
function $e1c34c51113f7f9d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $e1c34c51113f7f9d$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $e1c34c51113f7f9d$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e1c34c51113f7f9d$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e1c34c51113f7f9d$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("fMT9w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7e61edff2d363ec$export$2e2bcd8739ae039; });
function $b7e61edff2d363ec$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("4PKKQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385031550130f97b$export$2e2bcd8739ae039; });

var $8QDAJ = parcelRequire("8QDAJ");

var $81Olm = parcelRequire("81Olm");

var $gxlxg = parcelRequire("gxlxg");

var $j5ImG = parcelRequire("j5ImG");

var $9UTWx = parcelRequire("9UTWx");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $385031550130f97b$var$locale = {
    code: "en-US",
    formatDistance: (0, $8QDAJ.default),
    formatLong: (0, $81Olm.default),
    formatRelative: (0, $gxlxg.default),
    localize: (0, $j5ImG.default),
    match: (0, $9UTWx.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $385031550130f97b$export$2e2bcd8739ae039 = $385031550130f97b$var$locale;

});
parcelRegister("8QDAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6711e4126962da3b$export$2e2bcd8739ae039; });
var $6711e4126962da3b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $6711e4126962da3b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6711e4126962da3b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $6711e4126962da3b$export$2e2bcd8739ae039 = $6711e4126962da3b$var$formatDistance;

});

parcelRegister("81Olm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8577e217dda9b1$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $5d8577e217dda9b1$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $5d8577e217dda9b1$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $5d8577e217dda9b1$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $5d8577e217dda9b1$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $5d8577e217dda9b1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $5d8577e217dda9b1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $5d8577e217dda9b1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5d8577e217dda9b1$export$2e2bcd8739ae039 = $5d8577e217dda9b1$var$formatLong;

});

parcelRegister("gxlxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0a06eecfc5cc936$export$2e2bcd8739ae039; });
var $c0a06eecfc5cc936$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $c0a06eecfc5cc936$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c0a06eecfc5cc936$var$formatRelativeLocale[token];
};
var $c0a06eecfc5cc936$export$2e2bcd8739ae039 = $c0a06eecfc5cc936$var$formatRelative;

});

parcelRegister("j5ImG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de60e5e3de3adb3d$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $de60e5e3de3adb3d$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $de60e5e3de3adb3d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $de60e5e3de3adb3d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $de60e5e3de3adb3d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $de60e5e3de3adb3d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $de60e5e3de3adb3d$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $de60e5e3de3adb3d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $de60e5e3de3adb3d$var$localize = {
    ordinalNumber: $de60e5e3de3adb3d$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $de60e5e3de3adb3d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $de60e5e3de3adb3d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $de60e5e3de3adb3d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $de60e5e3de3adb3d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $de60e5e3de3adb3d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $de60e5e3de3adb3d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $de60e5e3de3adb3d$export$2e2bcd8739ae039 = $de60e5e3de3adb3d$var$localize;

});

parcelRegister("9UTWx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7384bd26af77491b$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $7384bd26af77491b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7384bd26af77491b$var$parseOrdinalNumberPattern = /\d+/i;
var $7384bd26af77491b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7384bd26af77491b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7384bd26af77491b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7384bd26af77491b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7384bd26af77491b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7384bd26af77491b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7384bd26af77491b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7384bd26af77491b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7384bd26af77491b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7384bd26af77491b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7384bd26af77491b$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $7384bd26af77491b$var$matchOrdinalNumberPattern,
        parsePattern: $7384bd26af77491b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $7384bd26af77491b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7384bd26af77491b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $7384bd26af77491b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7384bd26af77491b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $7384bd26af77491b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7384bd26af77491b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $7384bd26af77491b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7384bd26af77491b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $7384bd26af77491b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7384bd26af77491b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7384bd26af77491b$export$2e2bcd8739ae039 = $7384bd26af77491b$var$match;

});


parcelRegister("1a4eI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d8a02dbc504520c$export$2e2bcd8739ae039; });

var $dugaW = parcelRequire("dugaW");

var $l787X = parcelRequire("l787X");

var $9WdiE = parcelRequire("9WdiE");

var $jer2p = parcelRequire("jer2p");

var $h6NZx = parcelRequire("h6NZx");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $0d8a02dbc504520c$var$locale = {
    code: "es",
    formatDistance: (0, $dugaW.default),
    formatLong: (0, $l787X.default),
    formatRelative: (0, $9WdiE.default),
    localize: (0, $jer2p.default),
    match: (0, $h6NZx.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0d8a02dbc504520c$export$2e2bcd8739ae039 = $0d8a02dbc504520c$var$locale;

});
parcelRegister("dugaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d1a9fd01d495cd1$export$2e2bcd8739ae039; });
var $9d1a9fd01d495cd1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $9d1a9fd01d495cd1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9d1a9fd01d495cd1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
var $9d1a9fd01d495cd1$export$2e2bcd8739ae039 = $9d1a9fd01d495cd1$var$formatDistance;

});

parcelRegister("l787X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5f08e5167184e06$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $f5f08e5167184e06$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $f5f08e5167184e06$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $f5f08e5167184e06$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f5f08e5167184e06$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $f5f08e5167184e06$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $f5f08e5167184e06$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $f5f08e5167184e06$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f5f08e5167184e06$export$2e2bcd8739ae039 = $f5f08e5167184e06$var$formatLong;

});

parcelRegister("9WdiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73c3d8e78207ce86$export$2e2bcd8739ae039; });
var $73c3d8e78207ce86$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var $73c3d8e78207ce86$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
var $73c3d8e78207ce86$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $73c3d8e78207ce86$var$formatRelativeLocalePlural[token];
    else return $73c3d8e78207ce86$var$formatRelativeLocale[token];
};
var $73c3d8e78207ce86$export$2e2bcd8739ae039 = $73c3d8e78207ce86$var$formatRelative;

});

parcelRegister("jer2p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0044c4d84d35737$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $e0044c4d84d35737$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
var $e0044c4d84d35737$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $e0044c4d84d35737$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
var $e0044c4d84d35737$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
var $e0044c4d84d35737$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
var $e0044c4d84d35737$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
var $e0044c4d84d35737$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $e0044c4d84d35737$var$localize = {
    ordinalNumber: $e0044c4d84d35737$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $e0044c4d84d35737$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $e0044c4d84d35737$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $e0044c4d84d35737$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $e0044c4d84d35737$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $e0044c4d84d35737$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e0044c4d84d35737$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $e0044c4d84d35737$export$2e2bcd8739ae039 = $e0044c4d84d35737$var$localize;

});

parcelRegister("h6NZx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c749c68066638f79$export$2e2bcd8739ae039; });

var $fMT9w = parcelRequire("fMT9w");

var $jnJi9 = parcelRequire("jnJi9");
var $c749c68066638f79$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $c749c68066638f79$var$parseOrdinalNumberPattern = /\d+/i;
var $c749c68066638f79$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $c749c68066638f79$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $c749c68066638f79$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $c749c68066638f79$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c749c68066638f79$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $c749c68066638f79$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $c749c68066638f79$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $c749c68066638f79$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $c749c68066638f79$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $c749c68066638f79$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $c749c68066638f79$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $c749c68066638f79$var$matchOrdinalNumberPattern,
        parsePattern: $c749c68066638f79$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $c749c68066638f79$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c749c68066638f79$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $c749c68066638f79$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c749c68066638f79$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $c749c68066638f79$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c749c68066638f79$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $c749c68066638f79$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c749c68066638f79$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $c749c68066638f79$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c749c68066638f79$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $c749c68066638f79$export$2e2bcd8739ae039 = $c749c68066638f79$var$match;

});


parcelRegister("kPUG3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2b488fedfb2f470$export$2e2bcd8739ae039; });

var $kk6oB = parcelRequire("kk6oB");

var $2TyPY = parcelRequire("2TyPY");

var $8EFQQ = parcelRequire("8EFQQ");

var $a1dU8 = parcelRequire("a1dU8");

var $6XjOA = parcelRequire("6XjOA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $f2b488fedfb2f470$var$locale = {
    code: "fi",
    formatDistance: (0, $kk6oB.default),
    formatLong: (0, $2TyPY.default),
    formatRelative: (0, $8EFQQ.default),
    localize: (0, $a1dU8.default),
    match: (0, $6XjOA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f2b488fedfb2f470$export$2e2bcd8739ae039 = $f2b488fedfb2f470$var$locale;

});
parcelRegister("kk6oB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecbaa2fd700817d5$export$2e2bcd8739ae039; });
function $ecbaa2fd700817d5$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $ecbaa2fd700817d5$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $ecbaa2fd700817d5$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $ecbaa2fd700817d5$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $ecbaa2fd700817d5$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $ecbaa2fd700817d5$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $ecbaa2fd700817d5$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
var $ecbaa2fd700817d5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $ecbaa2fd700817d5$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $ecbaa2fd700817d5$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: function futureTense(_text) {
            return "puolen minuutin";
        }
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $ecbaa2fd700817d5$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $ecbaa2fd700817d5$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $ecbaa2fd700817d5$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $ecbaa2fd700817d5$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $ecbaa2fd700817d5$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $ecbaa2fd700817d5$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $ecbaa2fd700817d5$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $ecbaa2fd700817d5$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $ecbaa2fd700817d5$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $ecbaa2fd700817d5$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $ecbaa2fd700817d5$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $ecbaa2fd700817d5$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $ecbaa2fd700817d5$var$futureYears
    }
};
var $ecbaa2fd700817d5$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $ecbaa2fd700817d5$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
var $ecbaa2fd700817d5$export$2e2bcd8739ae039 = $ecbaa2fd700817d5$var$formatDistance;

});

parcelRegister("2TyPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21bbbdcf6c4b25eb$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $21bbbdcf6c4b25eb$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
var $21bbbdcf6c4b25eb$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
var $21bbbdcf6c4b25eb$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $21bbbdcf6c4b25eb$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $21bbbdcf6c4b25eb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $21bbbdcf6c4b25eb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $21bbbdcf6c4b25eb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $21bbbdcf6c4b25eb$export$2e2bcd8739ae039 = $21bbbdcf6c4b25eb$var$formatLong;

});

parcelRegister("8EFQQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d285f9ff48da76$export$2e2bcd8739ae039; });
var $64d285f9ff48da76$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
var $64d285f9ff48da76$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $64d285f9ff48da76$var$formatRelativeLocale[token];
};
var $64d285f9ff48da76$export$2e2bcd8739ae039 = $64d285f9ff48da76$var$formatRelative;

});

parcelRegister("a1dU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74b4c883cf8782b7$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $74b4c883cf8782b7$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $74b4c883cf8782b7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
var $74b4c883cf8782b7$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
var $74b4c883cf8782b7$var$formattingMonthValues = {
    narrow: $74b4c883cf8782b7$var$monthValues.narrow,
    abbreviated: $74b4c883cf8782b7$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
var $74b4c883cf8782b7$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
var $74b4c883cf8782b7$var$formattingDayValues = {
    narrow: $74b4c883cf8782b7$var$dayValues.narrow,
    short: $74b4c883cf8782b7$var$dayValues.short,
    abbreviated: $74b4c883cf8782b7$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
var $74b4c883cf8782b7$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
var $74b4c883cf8782b7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $74b4c883cf8782b7$var$localize = {
    ordinalNumber: $74b4c883cf8782b7$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $74b4c883cf8782b7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $74b4c883cf8782b7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $74b4c883cf8782b7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $74b4c883cf8782b7$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $74b4c883cf8782b7$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $74b4c883cf8782b7$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $74b4c883cf8782b7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $74b4c883cf8782b7$export$2e2bcd8739ae039 = $74b4c883cf8782b7$var$localize;

});

parcelRegister("6XjOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51079f9e53d41082$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $51079f9e53d41082$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $51079f9e53d41082$var$parseOrdinalNumberPattern = /\d+/i;
var $51079f9e53d41082$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $51079f9e53d41082$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $51079f9e53d41082$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $51079f9e53d41082$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $51079f9e53d41082$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $51079f9e53d41082$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $51079f9e53d41082$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $51079f9e53d41082$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $51079f9e53d41082$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $51079f9e53d41082$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $51079f9e53d41082$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $51079f9e53d41082$var$matchOrdinalNumberPattern,
        parsePattern: $51079f9e53d41082$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $51079f9e53d41082$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51079f9e53d41082$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $51079f9e53d41082$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51079f9e53d41082$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $51079f9e53d41082$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51079f9e53d41082$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $51079f9e53d41082$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51079f9e53d41082$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $51079f9e53d41082$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $51079f9e53d41082$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $51079f9e53d41082$export$2e2bcd8739ae039 = $51079f9e53d41082$var$match;

});


parcelRegister("2qHB3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4fd3e3821cec1e$export$2e2bcd8739ae039; });

var $054tu = parcelRequire("054tu");

var $bayA1 = parcelRequire("bayA1");

var $5aPnE = parcelRequire("5aPnE");

var $8fnmr = parcelRequire("8fnmr");

var $5DBcH = parcelRequire("5DBcH");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $1c4fd3e3821cec1e$var$locale = {
    code: "fr",
    formatDistance: (0, $054tu.default),
    formatLong: (0, $bayA1.default),
    formatRelative: (0, $5aPnE.default),
    localize: (0, $8fnmr.default),
    match: (0, $5DBcH.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1c4fd3e3821cec1e$export$2e2bcd8739ae039 = $1c4fd3e3821cec1e$var$locale;

});
parcelRegister("054tu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f3f051674e025f$export$2e2bcd8739ae039; });
var $00f3f051674e025f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
var $00f3f051674e025f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $00f3f051674e025f$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
var $00f3f051674e025f$export$2e2bcd8739ae039 = $00f3f051674e025f$var$formatDistance;

});

parcelRegister("bayA1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $821b73be395b1f44$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $821b73be395b1f44$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $821b73be395b1f44$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $821b73be395b1f44$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $821b73be395b1f44$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $821b73be395b1f44$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $821b73be395b1f44$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $821b73be395b1f44$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $821b73be395b1f44$export$2e2bcd8739ae039 = $821b73be395b1f44$var$formatLong;

});

parcelRegister("5aPnE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c45be0637a66fd3$export$2e2bcd8739ae039; });
var $3c45be0637a66fd3$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
var $3c45be0637a66fd3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3c45be0637a66fd3$var$formatRelativeLocale[token];
};
var $3c45be0637a66fd3$export$2e2bcd8739ae039 = $3c45be0637a66fd3$var$formatRelative;

});

parcelRegister("8fnmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6011d86f9031d369$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $6011d86f9031d369$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $6011d86f9031d369$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $6011d86f9031d369$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
var $6011d86f9031d369$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
var $6011d86f9031d369$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
var $6011d86f9031d369$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return "0";
    var feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
var $6011d86f9031d369$var$localize = {
    ordinalNumber: $6011d86f9031d369$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $6011d86f9031d369$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $6011d86f9031d369$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $6011d86f9031d369$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $6011d86f9031d369$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $6011d86f9031d369$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $6011d86f9031d369$export$2e2bcd8739ae039 = $6011d86f9031d369$var$localize;

});

parcelRegister("5DBcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ad7429307cfe39$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $41ad7429307cfe39$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $41ad7429307cfe39$var$parseOrdinalNumberPattern = /\d+/i;
var $41ad7429307cfe39$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $41ad7429307cfe39$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $41ad7429307cfe39$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $41ad7429307cfe39$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $41ad7429307cfe39$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $41ad7429307cfe39$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $41ad7429307cfe39$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $41ad7429307cfe39$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $41ad7429307cfe39$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $41ad7429307cfe39$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $41ad7429307cfe39$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $41ad7429307cfe39$var$matchOrdinalNumberPattern,
        parsePattern: $41ad7429307cfe39$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $41ad7429307cfe39$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41ad7429307cfe39$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $41ad7429307cfe39$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41ad7429307cfe39$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $41ad7429307cfe39$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41ad7429307cfe39$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $41ad7429307cfe39$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41ad7429307cfe39$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $41ad7429307cfe39$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $41ad7429307cfe39$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $41ad7429307cfe39$export$2e2bcd8739ae039 = $41ad7429307cfe39$var$match;

});


parcelRegister("4NT7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f67e7f8f2958e1$export$2e2bcd8739ae039; });

var $hk6bp = parcelRequire("hk6bp");

var $kE6wb = parcelRequire("kE6wb");

var $i16co = parcelRequire("i16co");

var $3XnAz = parcelRequire("3XnAz");

var $inErw = parcelRequire("inErw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $37f67e7f8f2958e1$var$locale = {
    code: "nb",
    formatDistance: (0, $hk6bp.default),
    formatLong: (0, $kE6wb.default),
    formatRelative: (0, $i16co.default),
    localize: (0, $3XnAz.default),
    match: (0, $inErw.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $37f67e7f8f2958e1$export$2e2bcd8739ae039 = $37f67e7f8f2958e1$var$locale;

});
parcelRegister("hk6bp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03412dd5b3c31a50$export$2e2bcd8739ae039; });
var $03412dd5b3c31a50$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $03412dd5b3c31a50$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $03412dd5b3c31a50$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
var $03412dd5b3c31a50$export$2e2bcd8739ae039 = $03412dd5b3c31a50$var$formatDistance;

});

parcelRegister("kE6wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f07c996f61ed8312$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $f07c996f61ed8312$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $f07c996f61ed8312$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $f07c996f61ed8312$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $f07c996f61ed8312$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $f07c996f61ed8312$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $f07c996f61ed8312$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $f07c996f61ed8312$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f07c996f61ed8312$export$2e2bcd8739ae039 = $f07c996f61ed8312$var$formatLong;

});

parcelRegister("i16co", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1dd20f5e8ef7249$export$2e2bcd8739ae039; });
var $d1dd20f5e8ef7249$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $d1dd20f5e8ef7249$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d1dd20f5e8ef7249$var$formatRelativeLocale[token];
};
var $d1dd20f5e8ef7249$export$2e2bcd8739ae039 = $d1dd20f5e8ef7249$var$formatRelative;

});

parcelRegister("3XnAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e192e0ce106e820$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $2e192e0ce106e820$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
var $2e192e0ce106e820$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $2e192e0ce106e820$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
var $2e192e0ce106e820$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
var $2e192e0ce106e820$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $2e192e0ce106e820$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $2e192e0ce106e820$var$localize = {
    ordinalNumber: $2e192e0ce106e820$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $2e192e0ce106e820$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $2e192e0ce106e820$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $2e192e0ce106e820$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $2e192e0ce106e820$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $2e192e0ce106e820$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $2e192e0ce106e820$export$2e2bcd8739ae039 = $2e192e0ce106e820$var$localize;

});

parcelRegister("inErw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d619bf1a8ad34a5b$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $d619bf1a8ad34a5b$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $d619bf1a8ad34a5b$var$parseOrdinalNumberPattern = /\d+/i;
var $d619bf1a8ad34a5b$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $d619bf1a8ad34a5b$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $d619bf1a8ad34a5b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $d619bf1a8ad34a5b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d619bf1a8ad34a5b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $d619bf1a8ad34a5b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $d619bf1a8ad34a5b$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $d619bf1a8ad34a5b$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $d619bf1a8ad34a5b$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $d619bf1a8ad34a5b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $d619bf1a8ad34a5b$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $d619bf1a8ad34a5b$var$matchOrdinalNumberPattern,
        parsePattern: $d619bf1a8ad34a5b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $d619bf1a8ad34a5b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d619bf1a8ad34a5b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $d619bf1a8ad34a5b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d619bf1a8ad34a5b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $d619bf1a8ad34a5b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d619bf1a8ad34a5b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $d619bf1a8ad34a5b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d619bf1a8ad34a5b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $d619bf1a8ad34a5b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d619bf1a8ad34a5b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $d619bf1a8ad34a5b$export$2e2bcd8739ae039 = $d619bf1a8ad34a5b$var$match;

});


parcelRegister("evTZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a90f63b2cedb237e$export$2e2bcd8739ae039; });

var $edAqX = parcelRequire("edAqX");

var $f7Ly1 = parcelRequire("f7Ly1");

var $6tUPK = parcelRequire("6tUPK");

var $kwEjY = parcelRequire("kwEjY");

var $wZit6 = parcelRequire("wZit6");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $a90f63b2cedb237e$var$locale = {
    code: "nl",
    formatDistance: (0, $edAqX.default),
    formatLong: (0, $f7Ly1.default),
    formatRelative: (0, $6tUPK.default),
    localize: (0, $kwEjY.default),
    match: (0, $wZit6.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a90f63b2cedb237e$export$2e2bcd8739ae039 = $a90f63b2cedb237e$var$locale;

});
parcelRegister("edAqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59e8a9071fd75f1$export$2e2bcd8739ae039; });
var $a59e8a9071fd75f1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
var $a59e8a9071fd75f1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a59e8a9071fd75f1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
var $a59e8a9071fd75f1$export$2e2bcd8739ae039 = $a59e8a9071fd75f1$var$formatDistance;

});

parcelRegister("f7Ly1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b02c6476ece7e174$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $b02c6476ece7e174$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
var $b02c6476ece7e174$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $b02c6476ece7e174$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b02c6476ece7e174$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $b02c6476ece7e174$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $b02c6476ece7e174$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $b02c6476ece7e174$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b02c6476ece7e174$export$2e2bcd8739ae039 = $b02c6476ece7e174$var$formatLong;

});

parcelRegister("6tUPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b81897ffcf6b3f3$export$2e2bcd8739ae039; });
var $4b81897ffcf6b3f3$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $4b81897ffcf6b3f3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4b81897ffcf6b3f3$var$formatRelativeLocale[token];
};
var $4b81897ffcf6b3f3$export$2e2bcd8739ae039 = $4b81897ffcf6b3f3$var$formatRelative;

});

parcelRegister("kwEjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef1612ba2de1e0d4$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $ef1612ba2de1e0d4$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $ef1612ba2de1e0d4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
var $ef1612ba2de1e0d4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $ef1612ba2de1e0d4$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
var $ef1612ba2de1e0d4$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $ef1612ba2de1e0d4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $ef1612ba2de1e0d4$var$localize = {
    ordinalNumber: $ef1612ba2de1e0d4$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $ef1612ba2de1e0d4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $ef1612ba2de1e0d4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $ef1612ba2de1e0d4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $ef1612ba2de1e0d4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $ef1612ba2de1e0d4$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $ef1612ba2de1e0d4$export$2e2bcd8739ae039 = $ef1612ba2de1e0d4$var$localize;

});

parcelRegister("wZit6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0632898e9566baf4$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $0632898e9566baf4$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $0632898e9566baf4$var$parseOrdinalNumberPattern = /\d+/i;
var $0632898e9566baf4$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $0632898e9566baf4$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $0632898e9566baf4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $0632898e9566baf4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0632898e9566baf4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $0632898e9566baf4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $0632898e9566baf4$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $0632898e9566baf4$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $0632898e9566baf4$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $0632898e9566baf4$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $0632898e9566baf4$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $0632898e9566baf4$var$matchOrdinalNumberPattern,
        parsePattern: $0632898e9566baf4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $0632898e9566baf4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0632898e9566baf4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $0632898e9566baf4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0632898e9566baf4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $0632898e9566baf4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0632898e9566baf4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $0632898e9566baf4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0632898e9566baf4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $0632898e9566baf4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0632898e9566baf4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0632898e9566baf4$export$2e2bcd8739ae039 = $0632898e9566baf4$var$match;

});


parcelRegister("d5Zuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988b6fd396501490$export$2e2bcd8739ae039; });

var $b6Hhc = parcelRequire("b6Hhc");

var $bXZoE = parcelRequire("bXZoE");

var $ew0du = parcelRequire("ew0du");

var $hNRPe = parcelRequire("hNRPe");

var $c6Ojx = parcelRequire("c6Ojx");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $988b6fd396501490$var$locale = {
    code: "sv",
    formatDistance: (0, $b6Hhc.default),
    formatLong: (0, $bXZoE.default),
    formatRelative: (0, $ew0du.default),
    localize: (0, $hNRPe.default),
    match: (0, $c6Ojx.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $988b6fd396501490$export$2e2bcd8739ae039 = $988b6fd396501490$var$locale;

});
parcelRegister("b6Hhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8161d30494b65698$export$2e2bcd8739ae039; });
var $8161d30494b65698$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} vecka"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $8161d30494b65698$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
var $8161d30494b65698$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8161d30494b65698$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $8161d30494b65698$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
var $8161d30494b65698$export$2e2bcd8739ae039 = $8161d30494b65698$var$formatDistance;

});

parcelRegister("bXZoE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b64d47508a889b4$export$2e2bcd8739ae039; });

var $6wF66 = parcelRequire("6wF66");
var $8b64d47508a889b4$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
var $8b64d47508a889b4$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8b64d47508a889b4$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $8b64d47508a889b4$var$formatLong = {
    date: (0, $6wF66.default)({
        formats: $8b64d47508a889b4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $6wF66.default)({
        formats: $8b64d47508a889b4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $6wF66.default)({
        formats: $8b64d47508a889b4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8b64d47508a889b4$export$2e2bcd8739ae039 = $8b64d47508a889b4$var$formatLong;

});

parcelRegister("ew0du", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91438d4cb933ed2$export$2e2bcd8739ae039; });
var $a91438d4cb933ed2$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $a91438d4cb933ed2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a91438d4cb933ed2$var$formatRelativeLocale[token];
};
var $a91438d4cb933ed2$export$2e2bcd8739ae039 = $a91438d4cb933ed2$var$formatRelative;

});

parcelRegister("hNRPe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf60c3d78951c454$export$2e2bcd8739ae039; });

var $iSZtf = parcelRequire("iSZtf");
var $cf60c3d78951c454$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
var $cf60c3d78951c454$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
var $cf60c3d78951c454$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $cf60c3d78951c454$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $cf60c3d78951c454$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
var $cf60c3d78951c454$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $cf60c3d78951c454$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
var $cf60c3d78951c454$var$localize = {
    ordinalNumber: $cf60c3d78951c454$var$ordinalNumber,
    era: (0, $iSZtf.default)({
        values: $cf60c3d78951c454$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $iSZtf.default)({
        values: $cf60c3d78951c454$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iSZtf.default)({
        values: $cf60c3d78951c454$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $iSZtf.default)({
        values: $cf60c3d78951c454$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $iSZtf.default)({
        values: $cf60c3d78951c454$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $cf60c3d78951c454$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $cf60c3d78951c454$export$2e2bcd8739ae039 = $cf60c3d78951c454$var$localize;

});

parcelRegister("c6Ojx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d0d12e59be3ea0a$export$2e2bcd8739ae039; });

var $jnJi9 = parcelRequire("jnJi9");

var $fMT9w = parcelRequire("fMT9w");
var $8d0d12e59be3ea0a$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $8d0d12e59be3ea0a$var$parseOrdinalNumberPattern = /\d+/i;
var $8d0d12e59be3ea0a$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $8d0d12e59be3ea0a$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $8d0d12e59be3ea0a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $8d0d12e59be3ea0a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8d0d12e59be3ea0a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $8d0d12e59be3ea0a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $8d0d12e59be3ea0a$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $8d0d12e59be3ea0a$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $8d0d12e59be3ea0a$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $8d0d12e59be3ea0a$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $8d0d12e59be3ea0a$var$match = {
    ordinalNumber: (0, $fMT9w.default)({
        matchPattern: $8d0d12e59be3ea0a$var$matchOrdinalNumberPattern,
        parsePattern: $8d0d12e59be3ea0a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jnJi9.default)({
        matchPatterns: $8d0d12e59be3ea0a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d0d12e59be3ea0a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jnJi9.default)({
        matchPatterns: $8d0d12e59be3ea0a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d0d12e59be3ea0a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jnJi9.default)({
        matchPatterns: $8d0d12e59be3ea0a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d0d12e59be3ea0a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jnJi9.default)({
        matchPatterns: $8d0d12e59be3ea0a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d0d12e59be3ea0a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jnJi9.default)({
        matchPatterns: $8d0d12e59be3ea0a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8d0d12e59be3ea0a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8d0d12e59be3ea0a$export$2e2bcd8739ae039 = $8d0d12e59be3ea0a$var$match;

});


parcelRegister("1sDHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9236f03c640f10f0$export$2e2bcd8739ae039; });

var $aaPog = parcelRequire("aaPog");
const $9236f03c640f10f0$var$storage = {
    getItem: (key)=>{
        return (0, $aaPog.default)(window.localStorage.getItem(key));
    },
    setItem: (key, value)=>{
        window.localStorage.setItem(key, JSON.stringify(value));
    },
    removeItem: (key)=>{
        window.localStorage.removeItem(key);
    }
};
var $9236f03c640f10f0$export$2e2bcd8739ae039 = $9236f03c640f10f0$var$storage;

});
parcelRegister("aaPog", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $081df866979f75df$export$2e2bcd8739ae039; });
var $081df866979f75df$export$2e2bcd8739ae039 = function safeJsonParse(json, defaultValue = null) {
    if (json === null || json === undefined) return defaultValue;
    try {
        return JSON.parse(json) ?? defaultValue;
    } catch (error) {
        return defaultValue;
    }
};

});


parcelRegister("ghF0i", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("lXWfV").then(()=>parcelRequire("keyOP"));

});
parcelRegister("5J7cc", function(module, exports) {
"use strict";

function $42b6bca4e75bc493$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("l7tRt")).resolve(id));
}
module.exports = $42b6bca4e75bc493$var$load;

});
parcelRegister("l7tRt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f6016a4e07941f4c$export$6503ec6e8aabbaf; }, function (v) { return $f6016a4e07941f4c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f6016a4e07941f4c$export$f7ad0328861e2f03; }, function (v) { return $f6016a4e07941f4c$export$f7ad0328861e2f03 = v; });
var $f6016a4e07941f4c$export$6503ec6e8aabbaf;
var $f6016a4e07941f4c$export$f7ad0328861e2f03;
"use strict";
var $f6016a4e07941f4c$var$mapping = new Map();
function $f6016a4e07941f4c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f6016a4e07941f4c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f6016a4e07941f4c$var$resolve(id) {
    var resolved = $f6016a4e07941f4c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f6016a4e07941f4c$export$6503ec6e8aabbaf = $f6016a4e07941f4c$var$register;
$f6016a4e07941f4c$export$f7ad0328861e2f03 = $f6016a4e07941f4c$var$resolve;

});



parcelRegister("6HhYn", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("469Xb").then(()=>parcelRequire("dQ1Iw"));

});

parcelRegister("henI1", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("aZgqb").then(()=>parcelRequire("hNzI5"));

});

parcelRegister("gVOkF", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("kBSrY").then(()=>parcelRequire("jcCsl"));

});

parcelRegister("bQ5lY", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("ljvO1").then(()=>parcelRequire("lKMOc"));

});

parcelRegister("pztdu", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("dtz6e").then(()=>parcelRequire("cjmFi"));

});

parcelRegister("a2a4f", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("lQWN1").then(()=>parcelRequire("52hb1"));

});

parcelRegister("aEbvB", function(module, exports) {

var $5J7cc = parcelRequire("5J7cc");
module.exports = $5J7cc("1YOyx").then(()=>parcelRequire("glAQA"));

});



parcelRegister("1iD12", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("dj9kK")).ThemeProvider; });
parcelRequire("dj9kK");

});
parcelRegister("dj9kK", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", function () { return $74a56bafdc9559ff$export$d8964aec282183a3; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $fHToZ = parcelRequire("fHToZ");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");
// This implements the default behavior from styled-components v5
function $74a56bafdc9559ff$var$shouldForwardProp(propName, target) {
    if (typeof target === "string") // For HTML elements, forward the prop if it is a valid HTML attribute
    return (0, $fHToZ.default)(propName);
    // For other elements, forward all props
    return true;
}
const $74a56bafdc9559ff$export$d8964aec282183a3 = ({ children: children })=>{
    // disable CSSOM injection to fix Chromium styling issue https://issues.chromium.org/issues/379758212
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gRonV.StyleSheetManager), {
        shouldForwardProp: $74a56bafdc9559ff$var$shouldForwardProp,
        disableCSSOMInjection: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gRonV.ThemeProvider), {
        theme: (0, $3CLIQ.theme)
    }, children));
};

});
parcelRegister("gRonV", function(module, exports) {

$parcel$export(module.exports, "StyleSheetManager", function () { return $032ae9566818bb3a$export$a473771da2f0ff7c; });
$parcel$export(module.exports, "ThemeProvider", function () { return $032ae9566818bb3a$export$d8964aec282183a3; });
$parcel$export(module.exports, "css", function () { return $032ae9566818bb3a$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $032ae9566818bb3a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "keyframes", function () { return $032ae9566818bb3a$export$d25ddfdf17c3ad3e; });

var $e2nma = parcelRequire("e2nma");
parcelRequire("fHToZ");

var $7E7Dk = parcelRequire("7E7Dk");

var $52eHb = parcelRequire("52eHb");

var $9YrbU = parcelRequire("9YrbU");

var $aHGoA = parcelRequire("aHGoA");

var $4YPvm = parcelRequire("4YPvm");
var $032ae9566818bb3a$var$f = ("undefined" != typeof $4YPvm && void 0 !== $4YPvm.env && undefined, "data-styled"), $032ae9566818bb3a$var$m = "active", $032ae9566818bb3a$var$y = "data-styled-version", $032ae9566818bb3a$export$83d89fbfd8236492 = "6.1.8", $032ae9566818bb3a$var$g = "/*!sc*/\n", $032ae9566818bb3a$var$S = "undefined" != typeof window && "HTMLElement" in window, $032ae9566818bb3a$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4YPvm && $4YPvm.env, "undefined" != typeof $4YPvm && $4YPvm.env, false)), $032ae9566818bb3a$var$b = {}, $032ae9566818bb3a$var$E = /invalid hook call/i, $032ae9566818bb3a$var$N = new Set, $032ae9566818bb3a$var$P = function(t, n) {
    var o, s, i, a, e;
}, $032ae9566818bb3a$var$_ = Object.freeze([]), $032ae9566818bb3a$var$C = Object.freeze({});
function $032ae9566818bb3a$var$I(e, t, n) {
    return void 0 === n && (n = $032ae9566818bb3a$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $032ae9566818bb3a$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $032ae9566818bb3a$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $032ae9566818bb3a$var$D = /(^-|-$)/g;
function $032ae9566818bb3a$var$R(e) {
    return e.replace($032ae9566818bb3a$var$O, "-").replace($032ae9566818bb3a$var$D, "");
}
var $032ae9566818bb3a$var$T = /(a)(d)/gi, $032ae9566818bb3a$var$k = 52, $032ae9566818bb3a$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $032ae9566818bb3a$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $032ae9566818bb3a$var$k; t = t / $032ae9566818bb3a$var$k | 0)n = $032ae9566818bb3a$var$j(t % $032ae9566818bb3a$var$k) + n;
    return ($032ae9566818bb3a$var$j(t % $032ae9566818bb3a$var$k) + n).replace($032ae9566818bb3a$var$T, "$1-$2");
}
var $032ae9566818bb3a$var$V, $032ae9566818bb3a$var$F = 5381, $032ae9566818bb3a$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $032ae9566818bb3a$var$$ = function(e) {
    return $032ae9566818bb3a$var$M($032ae9566818bb3a$var$F, e);
};
function $032ae9566818bb3a$var$z(e) {
    return $032ae9566818bb3a$var$x($032ae9566818bb3a$var$$(e) >>> 0);
}
function $032ae9566818bb3a$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $032ae9566818bb3a$var$L(e) {
    return "string" == typeof e && true;
}
var $032ae9566818bb3a$var$G = "function" == typeof Symbol && Symbol.for, $032ae9566818bb3a$var$Y = $032ae9566818bb3a$var$G ? Symbol.for("react.memo") : 60115, $032ae9566818bb3a$var$W = $032ae9566818bb3a$var$G ? Symbol.for("react.forward_ref") : 60112, $032ae9566818bb3a$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $032ae9566818bb3a$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $032ae9566818bb3a$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $032ae9566818bb3a$var$J = (($032ae9566818bb3a$var$V = {})[$032ae9566818bb3a$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $032ae9566818bb3a$var$V[$032ae9566818bb3a$var$Y] = $032ae9566818bb3a$var$U, $032ae9566818bb3a$var$V);
function $032ae9566818bb3a$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $032ae9566818bb3a$var$Y ? $032ae9566818bb3a$var$U : "$$typeof" in e ? $032ae9566818bb3a$var$J[e.$$typeof] : $032ae9566818bb3a$var$q;
}
var $032ae9566818bb3a$var$Z = Object.defineProperty, $032ae9566818bb3a$var$K = Object.getOwnPropertyNames, $032ae9566818bb3a$var$Q = Object.getOwnPropertySymbols, $032ae9566818bb3a$var$ee = Object.getOwnPropertyDescriptor, $032ae9566818bb3a$var$te = Object.getPrototypeOf, $032ae9566818bb3a$var$ne = Object.prototype;
function $032ae9566818bb3a$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($032ae9566818bb3a$var$ne) {
            var o = $032ae9566818bb3a$var$te(t);
            o && o !== $032ae9566818bb3a$var$ne && $032ae9566818bb3a$var$oe(e, o, n);
        }
        var r = $032ae9566818bb3a$var$K(t);
        $032ae9566818bb3a$var$Q && (r = r.concat($032ae9566818bb3a$var$Q(t)));
        for(var s = $032ae9566818bb3a$var$X(e), i = $032ae9566818bb3a$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $032ae9566818bb3a$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $032ae9566818bb3a$var$ee(t, c);
                try {
                    $032ae9566818bb3a$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $032ae9566818bb3a$var$re(e) {
    return "function" == typeof e;
}
function $032ae9566818bb3a$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $032ae9566818bb3a$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $032ae9566818bb3a$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $032ae9566818bb3a$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $032ae9566818bb3a$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$032ae9566818bb3a$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $032ae9566818bb3a$var$le(e[o], t[o]);
    else if ($032ae9566818bb3a$var$ce(t)) for(var o in t)e[o] = $032ae9566818bb3a$var$le(e[o], t[o]);
    return e;
}
function $032ae9566818bb3a$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $032ae9566818bb3a$var$pe = {};
function $032ae9566818bb3a$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $032ae9566818bb3a$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $032ae9566818bb3a$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $032ae9566818bb3a$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($032ae9566818bb3a$var$g);
        return t;
    }, e;
}(), $032ae9566818bb3a$var$me = new Map, $032ae9566818bb3a$var$ye = new Map, $032ae9566818bb3a$var$ve = 1, $032ae9566818bb3a$var$ge = function(e) {
    if ($032ae9566818bb3a$var$me.has(e)) return $032ae9566818bb3a$var$me.get(e);
    for(; $032ae9566818bb3a$var$ye.has($032ae9566818bb3a$var$ve);)$032ae9566818bb3a$var$ve++;
    var t = $032ae9566818bb3a$var$ve++;
    return $032ae9566818bb3a$var$me.set(e, t), $032ae9566818bb3a$var$ye.set(t, e), t;
}, $032ae9566818bb3a$var$Se = function(e, t) {
    $032ae9566818bb3a$var$ve = t + 1, $032ae9566818bb3a$var$me.set(e, t), $032ae9566818bb3a$var$ye.set(t, e);
}, $032ae9566818bb3a$var$we = "style[".concat($032ae9566818bb3a$var$f, "][").concat($032ae9566818bb3a$var$y, '="').concat($032ae9566818bb3a$export$83d89fbfd8236492, '"]'), $032ae9566818bb3a$var$be = new RegExp("^".concat($032ae9566818bb3a$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $032ae9566818bb3a$var$Ee = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $032ae9566818bb3a$var$Ne = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($032ae9566818bb3a$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($032ae9566818bb3a$var$be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($032ae9566818bb3a$var$Se(u, l), $032ae9566818bb3a$var$Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $032ae9566818bb3a$var$Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $032ae9566818bb3a$var$_e = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($032ae9566818bb3a$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($032ae9566818bb3a$var$f, $032ae9566818bb3a$var$m), o.setAttribute($032ae9566818bb3a$var$y, $032ae9566818bb3a$export$83d89fbfd8236492);
    var i = $032ae9566818bb3a$var$Pe();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $032ae9566818bb3a$var$Ce = function() {
    function e(e) {
        this.element = $032ae9566818bb3a$var$_e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $032ae9566818bb3a$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $032ae9566818bb3a$var$Ie = function() {
    function e(e) {
        this.element = $032ae9566818bb3a$var$_e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $032ae9566818bb3a$var$Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $032ae9566818bb3a$var$Oe = $032ae9566818bb3a$var$S, $032ae9566818bb3a$var$De = {
    isServer: !$032ae9566818bb3a$var$S,
    useCSSOMInjection: !$032ae9566818bb3a$var$w
}, $032ae9566818bb3a$var$Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = $032ae9566818bb3a$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $e2nma.__assign)((0, $e2nma.__assign)({}, $032ae9566818bb3a$var$De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $032ae9566818bb3a$var$S && $032ae9566818bb3a$var$Oe && ($032ae9566818bb3a$var$Oe = !1, function(e) {
            for(var t = document.querySelectorAll($032ae9566818bb3a$var$we), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($032ae9566818bb3a$var$f) !== $032ae9566818bb3a$var$m && ($032ae9566818bb3a$var$Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $032ae9566818bb3a$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $032ae9566818bb3a$var$ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($032ae9566818bb3a$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($032ae9566818bb3a$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $032ae9566818bb3a$var$ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $e2nma.__assign)((0, $e2nma.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $032ae9566818bb3a$var$Ae(n) : t ? new $032ae9566818bb3a$var$Ce(n) : new $032ae9566818bb3a$var$Ie(n);
        }(this.options), new $032ae9566818bb3a$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($032ae9566818bb3a$var$ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($032ae9566818bb3a$var$ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($032ae9566818bb3a$var$ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $032ae9566818bb3a$var$Te = /&/g, $032ae9566818bb3a$var$ke = /^\s*\/\/.*$/gm;
function $032ae9566818bb3a$var$je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $032ae9566818bb3a$var$je(e.children, t)), e;
    });
}
function $032ae9566818bb3a$var$xe(e) {
    var t, n, o, r = void 0 === e ? $032ae9566818bb3a$var$C : e, s = r.options, i = void 0 === s ? $032ae9566818bb3a$var$C : s, a = r.plugins, c = void 0 === a ? $032ae9566818bb3a$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $9YrbU.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace($032ae9566818bb3a$var$Te, n).replace(o, l));
    }), i.prefix && u.push($9YrbU.prefixer), u.push($9YrbU.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($032ae9566818bb3a$var$ke, ""), l = $9YrbU.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $032ae9566818bb3a$var$je(l, i.namespace));
        var p = [];
        return $9YrbU.serialize(l, $9YrbU.middleware(u.concat($9YrbU.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $032ae9566818bb3a$var$he(15), $032ae9566818bb3a$var$M(e, t.name);
    }, $032ae9566818bb3a$var$F).toString() : "", p;
}
var $032ae9566818bb3a$var$Ve = new $032ae9566818bb3a$var$Re, $032ae9566818bb3a$var$Fe = $032ae9566818bb3a$var$xe(), $032ae9566818bb3a$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $032ae9566818bb3a$var$Ve,
    stylis: $032ae9566818bb3a$var$Fe
}), $032ae9566818bb3a$export$91317688fc694efa = $032ae9566818bb3a$export$8c190ef828af4c86.Consumer, $032ae9566818bb3a$var$ze = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext(void 0);
function $032ae9566818bb3a$var$Be() {
    return (0, $7E7Dk.useContext)($032ae9566818bb3a$export$8c190ef828af4c86);
}
function $032ae9566818bb3a$export$a473771da2f0ff7c(e) {
    var t = (0, $7E7Dk.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $032ae9566818bb3a$var$Be().styleSheet, l = (0, $7E7Dk.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $7E7Dk.useMemo)(function() {
        return $032ae9566818bb3a$var$xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $7E7Dk.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($52eHb)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $7E7Dk.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($032ae9566818bb3a$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($032ae9566818bb3a$var$ze.Provider, {
        value: u
    }, e.children));
}
var $032ae9566818bb3a$var$Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $032ae9566818bb3a$var$Fe);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $032ae9566818bb3a$var$ue(this, function() {
            throw $032ae9566818bb3a$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $032ae9566818bb3a$var$Fe), this.name + e.hash;
    }, e;
}(), $032ae9566818bb3a$var$Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function $032ae9566818bb3a$var$We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $032ae9566818bb3a$var$Ye(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $032ae9566818bb3a$var$qe = function(e) {
    return null == e || !1 === e || "" === e;
}, $032ae9566818bb3a$var$He = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$032ae9566818bb3a$var$qe(i) && (Array.isArray(i) && i.isCss || $032ae9566818bb3a$var$re(i) ? r.push("".concat($032ae9566818bb3a$var$We(s), ":"), i, ";") : $032ae9566818bb3a$var$ce(i) ? r.push.apply(r, (0, $e2nma.__spreadArray)((0, $e2nma.__spreadArray)([
            "".concat(s, " {")
        ], $032ae9566818bb3a$var$He(i), !1), [
            "}"
        ], !1)) : r.push("".concat($032ae9566818bb3a$var$We(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $aHGoA.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $032ae9566818bb3a$var$Ue(e, t, n, o) {
    if ($032ae9566818bb3a$var$qe(e)) return [];
    if ($032ae9566818bb3a$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($032ae9566818bb3a$var$re(e)) {
        if (!$032ae9566818bb3a$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $032ae9566818bb3a$var$Ue(r, t, n, o);
    }
    var s;
    return e instanceof $032ae9566818bb3a$var$Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $032ae9566818bb3a$var$ce(e) ? $032ae9566818bb3a$var$He(e) : Array.isArray(e) ? Array.prototype.concat.apply($032ae9566818bb3a$var$_, e.map(function(e) {
        return $032ae9566818bb3a$var$Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $032ae9566818bb3a$var$Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($032ae9566818bb3a$var$re(n) && !$032ae9566818bb3a$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $032ae9566818bb3a$var$Xe = $032ae9566818bb3a$var$$($032ae9566818bb3a$export$83d89fbfd8236492), $032ae9566818bb3a$var$Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $032ae9566818bb3a$var$Je(e), this.componentId = t, this.baseHash = $032ae9566818bb3a$var$M($032ae9566818bb3a$var$Xe, t), this.baseStyle = n, $032ae9566818bb3a$var$Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $032ae9566818bb3a$var$ie(o, this.staticRulesId);
            else {
                var r = $032ae9566818bb3a$var$ae($032ae9566818bb3a$var$Ue(this.rules, e, t, n)), s = $032ae9566818bb3a$var$x($032ae9566818bb3a$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $032ae9566818bb3a$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $032ae9566818bb3a$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $032ae9566818bb3a$var$ae($032ae9566818bb3a$var$Ue(u, e, t, n));
                    a = $032ae9566818bb3a$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $032ae9566818bb3a$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $032ae9566818bb3a$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $032ae9566818bb3a$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext(void 0), $032ae9566818bb3a$export$b631efc24e9d5e2f = $032ae9566818bb3a$export$2c657da244d00bd6.Consumer;
function $032ae9566818bb3a$export$93d4e7f90805808f() {
    var e = (0, $7E7Dk.useContext)($032ae9566818bb3a$export$2c657da244d00bd6);
    if (!e) throw $032ae9566818bb3a$var$he(18);
    return e;
}
function $032ae9566818bb3a$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext($032ae9566818bb3a$export$2c657da244d00bd6), r = (0, $7E7Dk.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $032ae9566818bb3a$var$he(14);
            if ($032ae9566818bb3a$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $032ae9566818bb3a$var$he(8);
            return n ? (0, $e2nma.__assign)((0, $e2nma.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($032ae9566818bb3a$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $032ae9566818bb3a$var$nt = {}, $032ae9566818bb3a$var$ot = new Set;
function $032ae9566818bb3a$var$rt(e, r, s) {
    var i = $032ae9566818bb3a$export$7ba318d8d2f06c76(e), a = e, c = !$032ae9566818bb3a$var$L(e), p = r.attrs, d = void 0 === p ? $032ae9566818bb3a$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $032ae9566818bb3a$var$R(e);
        $032ae9566818bb3a$var$nt[n] = ($032ae9566818bb3a$var$nt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($032ae9566818bb3a$var$z($032ae9566818bb3a$export$83d89fbfd8236492 + n + $032ae9566818bb3a$var$nt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $032ae9566818bb3a$var$L(e) ? "styled.".concat(e) : "Styled(".concat($032ae9566818bb3a$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($032ae9566818bb3a$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $032ae9566818bb3a$var$Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext($032ae9566818bb3a$export$2c657da244d00bd6), m = $032ae9566818bb3a$var$Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $032ae9566818bb3a$var$I(r, f, c) || $032ae9566818bb3a$var$C, g = function(e, n, o) {
                for(var r, s = (0, $e2nma.__assign)((0, $e2nma.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $032ae9566818bb3a$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $032ae9566818bb3a$var$ie(s[c], a[c]) : "style" === c ? (0, $e2nma.__assign)((0, $e2nma.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $032ae9566818bb3a$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $032ae9566818bb3a$var$Be(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $032ae9566818bb3a$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$032ae9566818bb3a$var$L(S) && !$032ae9566818bb3a$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $7E7Dk.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $032ae9566818bb3a$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$032ae9566818bb3a$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $032ae9566818bb3a$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $032ae9566818bb3a$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $032ae9566818bb3a$var$st(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $032ae9566818bb3a$var$it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $032ae9566818bb3a$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($032ae9566818bb3a$var$re(t) || $032ae9566818bb3a$var$ce(t)) return $032ae9566818bb3a$var$it($032ae9566818bb3a$var$Ue($032ae9566818bb3a$var$st($032ae9566818bb3a$var$_, (0, $e2nma.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $032ae9566818bb3a$var$Ue(r) : $032ae9566818bb3a$var$it($032ae9566818bb3a$var$Ue($032ae9566818bb3a$var$st(r, n)));
}
function $032ae9566818bb3a$var$ct(n, o, r) {
    if (void 0 === r && (r = $032ae9566818bb3a$var$C), !o) throw $032ae9566818bb3a$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $032ae9566818bb3a$export$dbf350e5966cf602.apply(void 0, (0, $e2nma.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $032ae9566818bb3a$var$ct(n, o, (0, $e2nma.__assign)((0, $e2nma.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $032ae9566818bb3a$var$ct(n, o, (0, $e2nma.__assign)((0, $e2nma.__assign)({}, r), e));
    }, s;
}
var $032ae9566818bb3a$var$lt = function(e) {
    return $032ae9566818bb3a$var$ct($032ae9566818bb3a$var$rt, e);
}, $032ae9566818bb3a$export$2e2bcd8739ae039 = $032ae9566818bb3a$var$lt;
$032ae9566818bb3a$var$A.forEach(function(e) {
    $032ae9566818bb3a$export$2e2bcd8739ae039[e] = $032ae9566818bb3a$var$lt(e);
});
var $032ae9566818bb3a$var$pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $032ae9566818bb3a$var$Je(e), $032ae9566818bb3a$var$Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($032ae9566818bb3a$var$ae($032ae9566818bb3a$var$Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $032ae9566818bb3a$var$Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $032ae9566818bb3a$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $032ae9566818bb3a$export$dbf350e5966cf602.apply(void 0, (0, $e2nma.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat($032ae9566818bb3a$var$z(JSON.stringify(i))), c = new $032ae9566818bb3a$var$pt(i, a);
    var l = function(e) {
        var t = $032ae9566818bb3a$var$Be(), n = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext($032ae9566818bb3a$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $032ae9566818bb3a$var$b, o, s);
        else {
            var i = (0, $e2nma.__assign)((0, $e2nma.__assign)({}, n), {
                theme: $032ae9566818bb3a$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(l);
}
function $032ae9566818bb3a$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $032ae9566818bb3a$var$ae($032ae9566818bb3a$export$dbf350e5966cf602.apply(void 0, (0, $e2nma.__spreadArray)([
        t
    ], n, !1))), s = $032ae9566818bb3a$var$z(r);
    return new $032ae9566818bb3a$var$Ge(s, r);
}
function $032ae9566818bb3a$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).forwardRef(function(n, r) {
        var s = $032ae9566818bb3a$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext($032ae9566818bb3a$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement(e, (0, $e2nma.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($032ae9566818bb3a$var$B(e), ")"), $032ae9566818bb3a$var$oe(n, e);
}
var $032ae9566818bb3a$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $032ae9566818bb3a$var$Pe(), o = $032ae9566818bb3a$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($032ae9566818bb3a$var$f, '="true"'),
                "".concat($032ae9566818bb3a$var$y, '="').concat($032ae9566818bb3a$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $032ae9566818bb3a$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $032ae9566818bb3a$var$he(2);
            var r = ((n = {})[$032ae9566818bb3a$var$f] = "", n[$032ae9566818bb3a$var$y] = $032ae9566818bb3a$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $032ae9566818bb3a$var$Pe();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("style", (0, $e2nma.__assign)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $032ae9566818bb3a$var$Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $032ae9566818bb3a$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($032ae9566818bb3a$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $032ae9566818bb3a$var$he(3);
    }, e;
}(), $032ae9566818bb3a$export$5c87cfe6c475f500 = {
    StyleSheet: $032ae9566818bb3a$var$Re,
    mainSheet: $032ae9566818bb3a$var$Ve
};
var $032ae9566818bb3a$var$vt = "__sc-".concat($032ae9566818bb3a$var$f, "__");

});
parcelRegister("e2nma", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $a3835eb47e3dc5bb$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spreadArray", function () { return $a3835eb47e3dc5bb$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a3835eb47e3dc5bb$var$extendStatics = function(d, b) {
    $a3835eb47e3dc5bb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a3835eb47e3dc5bb$var$extendStatics(d, b);
};
function $a3835eb47e3dc5bb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a3835eb47e3dc5bb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a3835eb47e3dc5bb$export$18ce0697a983be9b = function() {
    $a3835eb47e3dc5bb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a3835eb47e3dc5bb$export$18ce0697a983be9b.apply(this, arguments);
};
function $a3835eb47e3dc5bb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a3835eb47e3dc5bb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a3835eb47e3dc5bb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a3835eb47e3dc5bb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a3835eb47e3dc5bb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a3835eb47e3dc5bb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a3835eb47e3dc5bb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a3835eb47e3dc5bb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a3835eb47e3dc5bb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a3835eb47e3dc5bb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a3835eb47e3dc5bb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a3835eb47e3dc5bb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a3835eb47e3dc5bb$export$45d3717a4c69092e(o, m, p);
}
function $a3835eb47e3dc5bb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a3835eb47e3dc5bb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a3835eb47e3dc5bb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a3835eb47e3dc5bb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a3835eb47e3dc5bb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a3835eb47e3dc5bb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a3835eb47e3dc5bb$export$10c90e4f7922046c(v) {
    return this instanceof $a3835eb47e3dc5bb$export$10c90e4f7922046c ? (this.v = v, this) : new $a3835eb47e3dc5bb$export$10c90e4f7922046c(v);
}
function $a3835eb47e3dc5bb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a3835eb47e3dc5bb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a3835eb47e3dc5bb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a3835eb47e3dc5bb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a3835eb47e3dc5bb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a3835eb47e3dc5bb$export$19a8beecd37a4c45 === "function" ? $a3835eb47e3dc5bb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a3835eb47e3dc5bb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a3835eb47e3dc5bb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a3835eb47e3dc5bb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a3835eb47e3dc5bb$export$45d3717a4c69092e(result, mod, k);
    }
    $a3835eb47e3dc5bb$var$__setModuleDefault(result, mod);
    return result;
}
function $a3835eb47e3dc5bb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a3835eb47e3dc5bb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a3835eb47e3dc5bb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a3835eb47e3dc5bb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("fHToZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6f5d8dffbc836b0$export$2e2bcd8739ae039; });

var $iLRju = parcelRequire("iLRju");
var $b6f5d8dffbc836b0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b6f5d8dffbc836b0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $iLRju.default)(function(prop) {
    return $b6f5d8dffbc836b0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("iLRju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa5f8b2a9f5ace4$export$2e2bcd8739ae039; });
function $daa5f8b2a9f5ace4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("52eHb", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("9YrbU", function(module, exports) {

$parcel$export(module.exports, "RULESET", function () { return $60a9bba8ac646b8f$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "compile", function () { return $60a9bba8ac646b8f$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $60a9bba8ac646b8f$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $60a9bba8ac646b8f$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $60a9bba8ac646b8f$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $60a9bba8ac646b8f$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $60a9bba8ac646b8f$export$e08c7d021b829b7a; });
var $60a9bba8ac646b8f$export$71ad59f2e432cfe8 = "-ms-";
var $60a9bba8ac646b8f$export$2c0f367103c8d01c = "-moz-";
var $60a9bba8ac646b8f$export$39dfd62a25e0fe93 = "-webkit-";
var $60a9bba8ac646b8f$export$a29989082612d0d9 = "comm";
var $60a9bba8ac646b8f$export$aa3a2e812ca8570d = "rule";
var $60a9bba8ac646b8f$export$527d108ccf083c2b = "decl";
var $60a9bba8ac646b8f$export$d3d35020fa5b54f0 = "@page";
var $60a9bba8ac646b8f$export$500415a86c544f73 = "@media";
var $60a9bba8ac646b8f$export$a763edbf796b780a = "@import";
var $60a9bba8ac646b8f$export$2790aeb8b4e5c826 = "@charset";
var $60a9bba8ac646b8f$export$1cc683e23b84b133 = "@viewport";
var $60a9bba8ac646b8f$export$9447a5efea57e862 = "@supports";
var $60a9bba8ac646b8f$export$ef011b4e114b1fba = "@document";
var $60a9bba8ac646b8f$export$6aad947bda0f3f46 = "@namespace";
var $60a9bba8ac646b8f$export$b44a8529a35fcb60 = "@keyframes";
var $60a9bba8ac646b8f$export$2c16de31893252e6 = "@font-face";
var $60a9bba8ac646b8f$export$3d846dd52e150c6f = "@counter-style";
var $60a9bba8ac646b8f$export$22314bfbb57653fe = "@font-feature-values";
var $60a9bba8ac646b8f$export$d773506282b3cfe6 = "@layer";
var $60a9bba8ac646b8f$export$2335f513bbd82c6d = Math.abs;
var $60a9bba8ac646b8f$export$6788812c4e6611e6 = String.fromCharCode;
var $60a9bba8ac646b8f$export$e6e34fd1f2686227 = Object.assign;
function $60a9bba8ac646b8f$export$d6af199866bfb566(e, r) {
    return $60a9bba8ac646b8f$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $60a9bba8ac646b8f$export$a9db5e087081082d(e, 0)) << 2 ^ $60a9bba8ac646b8f$export$a9db5e087081082d(e, 1)) << 2 ^ $60a9bba8ac646b8f$export$a9db5e087081082d(e, 2)) << 2 ^ $60a9bba8ac646b8f$export$a9db5e087081082d(e, 3) : 0;
}
function $60a9bba8ac646b8f$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $60a9bba8ac646b8f$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $60a9bba8ac646b8f$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $60a9bba8ac646b8f$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $60a9bba8ac646b8f$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $60a9bba8ac646b8f$export$36776f635604f274(e) {
    return e.length;
}
function $60a9bba8ac646b8f$export$f9084667e487ed46(e) {
    return e.length;
}
function $60a9bba8ac646b8f$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $60a9bba8ac646b8f$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $60a9bba8ac646b8f$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$60a9bba8ac646b8f$export$4659b591c19bdf3d(e, r);
    });
}
var $60a9bba8ac646b8f$export$53f1d5ea8de3d7c = 1;
var $60a9bba8ac646b8f$export$4e0c71f277ca26b3 = 1;
var $60a9bba8ac646b8f$export$f24224f1c91d8156 = 0;
var $60a9bba8ac646b8f$export$5880b8b5730aff45 = 0;
var $60a9bba8ac646b8f$export$c0306caf338ac095 = 0;
var $60a9bba8ac646b8f$export$30a86d91af8ff6e6 = "";
function $60a9bba8ac646b8f$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $60a9bba8ac646b8f$export$53f1d5ea8de3d7c,
        column: $60a9bba8ac646b8f$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $60a9bba8ac646b8f$export$784d13d8ee351f07(e, r) {
    return $60a9bba8ac646b8f$export$e6e34fd1f2686227($60a9bba8ac646b8f$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $60a9bba8ac646b8f$export$590e8b2c435046d9(e) {
    while(e.root)e = $60a9bba8ac646b8f$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $60a9bba8ac646b8f$export$10d8903dec122b9d(e, e.siblings);
}
function $60a9bba8ac646b8f$export$eba6f6f03b0a92e7() {
    return $60a9bba8ac646b8f$export$c0306caf338ac095;
}
function $60a9bba8ac646b8f$export$232faf9add678146() {
    $60a9bba8ac646b8f$export$c0306caf338ac095 = $60a9bba8ac646b8f$export$5880b8b5730aff45 > 0 ? $60a9bba8ac646b8f$export$a9db5e087081082d($60a9bba8ac646b8f$export$30a86d91af8ff6e6, --$60a9bba8ac646b8f$export$5880b8b5730aff45) : 0;
    if ($60a9bba8ac646b8f$export$4e0c71f277ca26b3--, $60a9bba8ac646b8f$export$c0306caf338ac095 === 10) $60a9bba8ac646b8f$export$4e0c71f277ca26b3 = 1, $60a9bba8ac646b8f$export$53f1d5ea8de3d7c--;
    return $60a9bba8ac646b8f$export$c0306caf338ac095;
}
function $60a9bba8ac646b8f$export$48cfd1e771a65c4f() {
    $60a9bba8ac646b8f$export$c0306caf338ac095 = $60a9bba8ac646b8f$export$5880b8b5730aff45 < $60a9bba8ac646b8f$export$f24224f1c91d8156 ? $60a9bba8ac646b8f$export$a9db5e087081082d($60a9bba8ac646b8f$export$30a86d91af8ff6e6, $60a9bba8ac646b8f$export$5880b8b5730aff45++) : 0;
    if ($60a9bba8ac646b8f$export$4e0c71f277ca26b3++, $60a9bba8ac646b8f$export$c0306caf338ac095 === 10) $60a9bba8ac646b8f$export$4e0c71f277ca26b3 = 1, $60a9bba8ac646b8f$export$53f1d5ea8de3d7c++;
    return $60a9bba8ac646b8f$export$c0306caf338ac095;
}
function $60a9bba8ac646b8f$export$4d3fb11e950abb9e() {
    return $60a9bba8ac646b8f$export$a9db5e087081082d($60a9bba8ac646b8f$export$30a86d91af8ff6e6, $60a9bba8ac646b8f$export$5880b8b5730aff45);
}
function $60a9bba8ac646b8f$export$e88cb2efb12ae807() {
    return $60a9bba8ac646b8f$export$5880b8b5730aff45;
}
function $60a9bba8ac646b8f$export$58adb3bec8346d0f(e, r) {
    return $60a9bba8ac646b8f$export$2f35ab04d2335697($60a9bba8ac646b8f$export$30a86d91af8ff6e6, e, r);
}
function $60a9bba8ac646b8f$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $60a9bba8ac646b8f$export$2de70f21292aac9e(e) {
    return $60a9bba8ac646b8f$export$53f1d5ea8de3d7c = $60a9bba8ac646b8f$export$4e0c71f277ca26b3 = 1, $60a9bba8ac646b8f$export$f24224f1c91d8156 = $60a9bba8ac646b8f$export$36776f635604f274($60a9bba8ac646b8f$export$30a86d91af8ff6e6 = e), $60a9bba8ac646b8f$export$5880b8b5730aff45 = 0, [];
}
function $60a9bba8ac646b8f$export$45918ac1574455b1(e) {
    return $60a9bba8ac646b8f$export$30a86d91af8ff6e6 = "", e;
}
function $60a9bba8ac646b8f$export$410ac95b9ec204b8(e) {
    return $60a9bba8ac646b8f$export$87c2784dc9fc4ab($60a9bba8ac646b8f$export$58adb3bec8346d0f($60a9bba8ac646b8f$export$5880b8b5730aff45 - 1, $60a9bba8ac646b8f$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $60a9bba8ac646b8f$export$660b2ee2d4fb4eff(e) {
    return $60a9bba8ac646b8f$export$45918ac1574455b1($60a9bba8ac646b8f$export$5f8c09e3ae6f64e1($60a9bba8ac646b8f$export$2de70f21292aac9e(e)));
}
function $60a9bba8ac646b8f$export$7af1228ff777d175(e) {
    while($60a9bba8ac646b8f$export$c0306caf338ac095 = $60a9bba8ac646b8f$export$4d3fb11e950abb9e())if ($60a9bba8ac646b8f$export$c0306caf338ac095 < 33) $60a9bba8ac646b8f$export$48cfd1e771a65c4f();
    else break;
    return $60a9bba8ac646b8f$export$9e1725a4cfeada27(e) > 2 || $60a9bba8ac646b8f$export$9e1725a4cfeada27($60a9bba8ac646b8f$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $60a9bba8ac646b8f$export$5f8c09e3ae6f64e1(e) {
    while($60a9bba8ac646b8f$export$48cfd1e771a65c4f())switch($60a9bba8ac646b8f$export$9e1725a4cfeada27($60a9bba8ac646b8f$export$c0306caf338ac095)){
        case 0:
            $60a9bba8ac646b8f$export$10d8903dec122b9d($60a9bba8ac646b8f$export$c2ab62c7bf24634($60a9bba8ac646b8f$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $60a9bba8ac646b8f$export$10d8903dec122b9d($60a9bba8ac646b8f$export$410ac95b9ec204b8($60a9bba8ac646b8f$export$c0306caf338ac095), e);
            break;
        default:
            $60a9bba8ac646b8f$export$10d8903dec122b9d($60a9bba8ac646b8f$export$6788812c4e6611e6($60a9bba8ac646b8f$export$c0306caf338ac095), e);
    }
    return e;
}
function $60a9bba8ac646b8f$export$955ba06d119e085e(e, r) {
    while(--r && $60a9bba8ac646b8f$export$48cfd1e771a65c4f())if ($60a9bba8ac646b8f$export$c0306caf338ac095 < 48 || $60a9bba8ac646b8f$export$c0306caf338ac095 > 102 || $60a9bba8ac646b8f$export$c0306caf338ac095 > 57 && $60a9bba8ac646b8f$export$c0306caf338ac095 < 65 || $60a9bba8ac646b8f$export$c0306caf338ac095 > 70 && $60a9bba8ac646b8f$export$c0306caf338ac095 < 97) break;
    return $60a9bba8ac646b8f$export$58adb3bec8346d0f(e, $60a9bba8ac646b8f$export$e88cb2efb12ae807() + (r < 6 && $60a9bba8ac646b8f$export$4d3fb11e950abb9e() == 32 && $60a9bba8ac646b8f$export$48cfd1e771a65c4f() == 32));
}
function $60a9bba8ac646b8f$export$c889f2fcc19dbf12(e) {
    while($60a9bba8ac646b8f$export$48cfd1e771a65c4f())switch($60a9bba8ac646b8f$export$c0306caf338ac095){
        case e:
            return $60a9bba8ac646b8f$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $60a9bba8ac646b8f$export$c889f2fcc19dbf12($60a9bba8ac646b8f$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $60a9bba8ac646b8f$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $60a9bba8ac646b8f$export$48cfd1e771a65c4f();
            break;
    }
    return $60a9bba8ac646b8f$export$5880b8b5730aff45;
}
function $60a9bba8ac646b8f$export$4254d4e2b3745c4c(e, r) {
    while($60a9bba8ac646b8f$export$48cfd1e771a65c4f())if (e + $60a9bba8ac646b8f$export$c0306caf338ac095 === 57) break;
    else if (e + $60a9bba8ac646b8f$export$c0306caf338ac095 === 84 && $60a9bba8ac646b8f$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $60a9bba8ac646b8f$export$58adb3bec8346d0f(r, $60a9bba8ac646b8f$export$5880b8b5730aff45 - 1) + "*" + $60a9bba8ac646b8f$export$6788812c4e6611e6(e === 47 ? e : $60a9bba8ac646b8f$export$48cfd1e771a65c4f());
}
function $60a9bba8ac646b8f$export$c2ab62c7bf24634(e) {
    while(!$60a9bba8ac646b8f$export$9e1725a4cfeada27($60a9bba8ac646b8f$export$4d3fb11e950abb9e()))$60a9bba8ac646b8f$export$48cfd1e771a65c4f();
    return $60a9bba8ac646b8f$export$58adb3bec8346d0f(e, $60a9bba8ac646b8f$export$5880b8b5730aff45);
}
function $60a9bba8ac646b8f$export$ef7acd7185315e22(e) {
    return $60a9bba8ac646b8f$export$45918ac1574455b1($60a9bba8ac646b8f$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $60a9bba8ac646b8f$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $60a9bba8ac646b8f$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var m = "";
    var x = c;
    var y = s;
    var j = n;
    var A = m;
    while(w)switch(h = g, g = $60a9bba8ac646b8f$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $60a9bba8ac646b8f$export$a9db5e087081082d(A, l - 1) == 58) {
                if ($60a9bba8ac646b8f$export$f8e21b1e77979a08(A += $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed($60a9bba8ac646b8f$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $60a9bba8ac646b8f$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            A += $60a9bba8ac646b8f$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            A += $60a9bba8ac646b8f$export$7af1228ff777d175(h);
            break;
        case 92:
            A += $60a9bba8ac646b8f$export$955ba06d119e085e($60a9bba8ac646b8f$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($60a9bba8ac646b8f$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $60a9bba8ac646b8f$export$10d8903dec122b9d($60a9bba8ac646b8f$export$4a34f930e789283c($60a9bba8ac646b8f$export$4254d4e2b3745c4c($60a9bba8ac646b8f$export$48cfd1e771a65c4f(), $60a9bba8ac646b8f$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    A += "/";
            }
            break;
        case 123 * b:
            u[f++] = $60a9bba8ac646b8f$export$36776f635604f274(A) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) A = $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(A, /\f/g, "");
                    if (p > 0 && $60a9bba8ac646b8f$export$36776f635604f274(A) - l) $60a9bba8ac646b8f$export$10d8903dec122b9d(p > 32 ? $60a9bba8ac646b8f$export$f8483753829ec8f3(A + ";", n, a, l - 1, i) : $60a9bba8ac646b8f$export$f8483753829ec8f3($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(A, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    A += ";";
                default:
                    $60a9bba8ac646b8f$export$10d8903dec122b9d(j = $60a9bba8ac646b8f$export$3307ffa7023ede1e(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $60a9bba8ac646b8f$export$98e6a39c04603d36(A, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $60a9bba8ac646b8f$export$a9db5e087081082d(A, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $60a9bba8ac646b8f$export$98e6a39c04603d36(e, j, j, n && $60a9bba8ac646b8f$export$10d8903dec122b9d($60a9bba8ac646b8f$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $60a9bba8ac646b8f$export$98e6a39c04603d36(A, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, m = A = "", l = t;
            break;
        case 58:
            l = 1 + $60a9bba8ac646b8f$export$36776f635604f274(A), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $60a9bba8ac646b8f$export$232faf9add678146() == 125) continue;
            }
            switch(A += $60a9bba8ac646b8f$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (A += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($60a9bba8ac646b8f$export$36776f635604f274(A) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($60a9bba8ac646b8f$export$4d3fb11e950abb9e() === 45) A += $60a9bba8ac646b8f$export$410ac95b9ec204b8($60a9bba8ac646b8f$export$48cfd1e771a65c4f());
                    v = $60a9bba8ac646b8f$export$4d3fb11e950abb9e(), o = l = $60a9bba8ac646b8f$export$36776f635604f274(m = A += $60a9bba8ac646b8f$export$c2ab62c7bf24634($60a9bba8ac646b8f$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $60a9bba8ac646b8f$export$36776f635604f274(A) == 2) b = 0;
            }
    }
    return s;
}
function $60a9bba8ac646b8f$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $60a9bba8ac646b8f$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $60a9bba8ac646b8f$export$2f35ab04d2335697(e, p + 1, p = $60a9bba8ac646b8f$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $60a9bba8ac646b8f$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $60a9bba8ac646b8f$export$35059013cd4a06db(e, r, a, s === 0 ? $60a9bba8ac646b8f$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $60a9bba8ac646b8f$export$4a34f930e789283c(e, r, a, c) {
    return $60a9bba8ac646b8f$export$35059013cd4a06db(e, r, a, $60a9bba8ac646b8f$export$a29989082612d0d9, $60a9bba8ac646b8f$export$6788812c4e6611e6($60a9bba8ac646b8f$export$eba6f6f03b0a92e7()), $60a9bba8ac646b8f$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $60a9bba8ac646b8f$export$f8483753829ec8f3(e, r, a, n, c) {
    return $60a9bba8ac646b8f$export$35059013cd4a06db(e, r, a, $60a9bba8ac646b8f$export$527d108ccf083c2b, $60a9bba8ac646b8f$export$2f35ab04d2335697(e, 0, n), $60a9bba8ac646b8f$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $60a9bba8ac646b8f$export$82e9f45cca5ba907(n, c, s) {
    switch($60a9bba8ac646b8f$export$d6af199866bfb566(n, c)){
        case 5103:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $60a9bba8ac646b8f$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$2c0f367103c8d01c + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($60a9bba8ac646b8f$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "box-$1$2" + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "flex-item-" + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$60a9bba8ac646b8f$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "grid-row-" + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "flex-line-pack" + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "box-" + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "-grow", "") + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "box-pack:$3" + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$60a9bba8ac646b8f$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "grid-column-align" + $60a9bba8ac646b8f$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $60a9bba8ac646b8f$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$60a9bba8ac646b8f$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$60a9bba8ac646b8f$export$f8e21b1e77979a08(s, "span", 0) ? $60a9bba8ac646b8f$export$4659b591c19bdf3d(s, /\d+/) : +$60a9bba8ac646b8f$export$4659b591c19bdf3d(s, /\d+/) - +$60a9bba8ac646b8f$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $60a9bba8ac646b8f$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($60a9bba8ac646b8f$export$36776f635604f274(n) - 1 - c > 6) switch($60a9bba8ac646b8f$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($60a9bba8ac646b8f$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $60a9bba8ac646b8f$export$2c0f367103c8d01c + ($60a9bba8ac646b8f$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$60a9bba8ac646b8f$export$f8e21b1e77979a08(n, "stretch", 0) ? $60a9bba8ac646b8f$export$82e9f45cca5ba907($60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($60a9bba8ac646b8f$export$a9db5e087081082d(n, c + 6) === 121) return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, ":", ":" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($60a9bba8ac646b8f$export$a9db5e087081082d(n, $60a9bba8ac646b8f$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + ($60a9bba8ac646b8f$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, ":", ":" + $60a9bba8ac646b8f$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $60a9bba8ac646b8f$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $60a9bba8ac646b8f$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $60a9bba8ac646b8f$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $60a9bba8ac646b8f$export$a763edbf796b780a:
        case $60a9bba8ac646b8f$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $60a9bba8ac646b8f$export$a29989082612d0d9:
            return "";
        case $60a9bba8ac646b8f$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $60a9bba8ac646b8f$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $60a9bba8ac646b8f$export$aa3a2e812ca8570d:
            if (!$60a9bba8ac646b8f$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $60a9bba8ac646b8f$export$36776f635604f274(a = $60a9bba8ac646b8f$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $60a9bba8ac646b8f$export$5a7767152ae0305f(e) {
    var r = $60a9bba8ac646b8f$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $60a9bba8ac646b8f$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $60a9bba8ac646b8f$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $60a9bba8ac646b8f$export$527d108ccf083c2b:
                n.return = $60a9bba8ac646b8f$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $60a9bba8ac646b8f$export$b44a8529a35fcb60:
                return $60a9bba8ac646b8f$export$dfdc1655ccc5b9cb([
                    $60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                        value: $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $60a9bba8ac646b8f$export$aa3a2e812ca8570d:
                if (n.length) return $60a9bba8ac646b8f$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($60a9bba8ac646b8f$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $60a9bba8ac646b8f$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $60a9bba8ac646b8f$export$e6e34fd1f2686227(n, {
                                props: $60a9bba8ac646b8f$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $60a9bba8ac646b8f$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $60a9bba8ac646b8f$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    $60a9bba8ac646b8f$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $60a9bba8ac646b8f$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $60a9bba8ac646b8f$export$590e8b2c435046d9($60a9bba8ac646b8f$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $60a9bba8ac646b8f$export$e6e34fd1f2686227(n, {
                                props: $60a9bba8ac646b8f$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $60a9bba8ac646b8f$export$76a88f7de6507443(e) {
    switch(e.type){
        case $60a9bba8ac646b8f$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $60a9bba8ac646b8f$export$1be1fc439b849fdf($60a9bba8ac646b8f$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($60a9bba8ac646b8f$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $60a9bba8ac646b8f$export$2f35ab04d2335697(r, 1, $60a9bba8ac646b8f$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $60a9bba8ac646b8f$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $60a9bba8ac646b8f$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $60a9bba8ac646b8f$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("aHGoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7caece6da900a8ca$export$2e2bcd8739ae039; });
var $7caece6da900a8ca$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $7caece6da900a8ca$export$2e2bcd8739ae039 = $7caece6da900a8ca$var$unitlessKeys;

});

parcelRegister("4YPvm", function(module, exports) {
"use strict";

});


parcelRegister("eUJ8c", function(module, exports) {
$parcel$export(module.exports, "theme", function () { return (parcelRequire("3CLIQ")).theme; });
parcelRequire("3CLIQ");

});
parcelRegister("3CLIQ", function(module, exports) {

$parcel$export(module.exports, "theme", function () { return $1ea985b6bd6cd991$export$bca14c5b3b88a9c9; });

var $1WHAK = parcelRequire("1WHAK");

var $43jZP = parcelRequire("43jZP");
const $1ea985b6bd6cd991$export$bca14c5b3b88a9c9 = {
    breakPoints: {
        sm: "576px",
        md: "768px",
        lg: "992px",
        xl: "1200px"
    },
    font: {
        backgroundColor: (0, $1WHAK.colors).CA_Lightest_Gray,
        lightestColor: "#ffffff",
        darkestColor: (0, $1WHAK.colors).CA_Black,
        midDarkColor: (0, $1WHAK.colors).CA_Dark_Gray,
        midLightColor: "#a1a1a1",
        errorColor: "#df0017",
        warningColor: "#ffa500",
        infoColor: "#8ABFFF",
        linkColor: (0, $1WHAK.colors).CA_Blue,
        successColor: (0, $1WHAK.colors).CA_Green,
        successColorLight: (0, $1WHAK.colors).CA_Light_Green,
        textColor: "#6C757D",
        darkRed: "#a30000"
    },
    chartFont: {
        family: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        normalWeight: 400
    },
    darkBackground: "url('../../common/content/images/login_page_background_dark.png')",
    lightBackground: "url('../../common/content/images/login_page_background_light.png')",
    whiteBackground: "#ffffff",
    checkbox: {
        bgColor: (0, $1WHAK.colors).CA_Black,
        markColor: "#fff",
        invertedBgColor: "#fff",
        invertedMarkColor: "#000",
        disabledBgColor: "#a1a1a1",
        disabledMarkColor: "#ddd"
    },
    input: {
        borderColor: "#e7e7e7"
    },
    boxShadow: "rgba(0,0,0,0.1) 0px 5px 15px",
    brandColors: (0, $1WHAK.colors),
    sizing: (0, $43jZP.sizing),
    transition: "0.2s ease;"
};

});
parcelRegister("1WHAK", function(module, exports) {

$parcel$export(module.exports, "colors", function () { return $52b5b4768ccd62c1$export$8f45430ccf837300; });
const $52b5b4768ccd62c1$export$8f45430ccf837300 = {
    CA_Dark_Green: "#114A17",
    CA_Green: "#81E18B",
    CA_Light_Green: "#D9EDD9",
    CA_Error_Red: "#DF0017",
    CA_Coral: "#FF8B7C",
    CA_Light_Coral: "#FFE6E0",
    CA_Dark_Coral: "#FF6956",
    CA_Blue: "#006EF0",
    CA_Mid_Blue: "#8ABFFF",
    CA_Light_Blue: "#CCE2FC",
    CA_Lightest_Gray: "#f7f7f7",
    CA_Gray: "#F9F9F9",
    CA_Light_Gray: "#DDDDDD",
    CA_Mid_Gray: "#a1a1a1",
    CA_Dark_Gray: "#535353",
    CA_Black: "#000000",
    CA_White: "#ffffff",
    CA_Yellow: "#F2C94C",
    CA_Purple: "#BB6BD9"
};

});

parcelRegister("43jZP", function(module, exports) {

$parcel$export(module.exports, "sizing", function () { return $08fde3756a044fec$export$9758cac25f26dd85; });
const $08fde3756a044fec$export$9758cac25f26dd85 = {
    padding: {
        xs: "2px",
        s: "5px",
        m: "10px",
        l: "15px",
        xl: "30px",
        xxl: "60px"
    },
    margin: {
        xs: "2px",
        s: "5px",
        m: "10px",
        l: "15px",
        xl: "30px",
        xxl: "60px"
    }
};

});





parcelRegister("1IBeB", function(module, exports) {

$parcel$export(module.exports, "triggerAuthChange", function () { return $b50a7cb331f459b3$export$60ffe124fca13e5b; });
$parcel$export(module.exports, "initAuthChangeListener", function () { return $b50a7cb331f459b3$export$9de74211afbdab7c; });
const $b50a7cb331f459b3$export$8670271e2f9db395 = new BroadcastChannel("auth");
const $b50a7cb331f459b3$export$60ffe124fca13e5b = ()=>$b50a7cb331f459b3$export$8670271e2f9db395.postMessage("auth_change");
const $b50a7cb331f459b3$export$9de74211afbdab7c = ()=>{
    $b50a7cb331f459b3$export$8670271e2f9db395.addEventListener("message", ()=>{
        window.location.reload();
    });
};

});

parcelRegister("aCffN", function(module, exports) {
$parcel$export(module.exports, "ToastProvider", function () { return (parcelRequire("eBlmY")).ToastProvider; });
$parcel$export(module.exports, "useToast", function () { return (parcelRequire("eBlmY")).useToast; });
parcelRequire("eBlmY");

});
parcelRegister("eBlmY", function(module, exports) {

$parcel$export(module.exports, "ToastProvider", function () { return $303deb941d163ac3$export$f5d03d415824e0e; });
$parcel$export(module.exports, "useToast", function () { return $303deb941d163ac3$export$a407b657d3044108; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dNKlM = parcelRequire("dNKlM");
const $303deb941d163ac3$var$ToastContext = /*#__PURE__*/ (0, $7E7Dk.createContext)(null);
const $303deb941d163ac3$export$f5d03d415824e0e = ({ children: children })=>{
    const toastRef = (0, $7E7Dk.useRef)(null);
    const notify = (0, $7E7Dk.useCallback)((severity, summary, detail, life = 3000)=>{
        toastRef.current?.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: life
        });
    }, []);
    const notifySuccess = (0, $7E7Dk.useCallback)((summary, detail, life)=>{
        notify("success", summary, detail, life);
    }, [
        notify
    ]);
    const notifyError = (0, $7E7Dk.useCallback)((summary, detail, life)=>{
        notify("error", summary, detail, life);
    }, [
        notify
    ]);
    const notifyInfo = (0, $7E7Dk.useCallback)((summary, detail, life)=>{
        notify("info", summary, detail, life);
    }, [
        notify
    ]);
    const notifyWarn = (0, $7E7Dk.useCallback)((summary, detail, life)=>{
        notify("warn", summary, detail, life);
    }, [
        notify
    ]);
    const contextValue = (0, $7E7Dk.useMemo)(()=>({
            notify: notify,
            notifySuccess: notifySuccess,
            notifyError: notifyError,
            notifyInfo: notifyInfo,
            notifyWarn: notifyWarn
        }), [
        notify,
        notifySuccess,
        notifyError,
        notifyInfo,
        notifyWarn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($303deb941d163ac3$var$ToastContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dNKlM.Toast), {
        ref: toastRef
    }), children);
};
const $303deb941d163ac3$export$a407b657d3044108 = ()=>{
    const context = (0, $7E7Dk.useContext)($303deb941d163ac3$var$ToastContext);
    if (!context) throw new Error("useToast must be used within a ToastProvider");
    return context;
};

});
parcelRegister("dNKlM", function(module, exports) {

$parcel$export(module.exports, "Toast", function () { return $a0c3ce2c3ce91acc$export$8d8dc7d5f743331b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hySFd = parcelRequire("hySFd");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $ingJg = parcelRequire("ingJg");

var $7nrKB = parcelRequire("7nrKB");

var $eXeTx = parcelRequire("eXeTx");

var $dgIaN = parcelRequire("dgIaN");

var $8Murc = parcelRequire("8Murc");

var $2v3zC = parcelRequire("2v3zC");

var $f6Dhj = parcelRequire("f6Dhj");

var $1PxL0 = parcelRequire("1PxL0");
"use client";
function $a0c3ce2c3ce91acc$var$_extends() {
    return $a0c3ce2c3ce91acc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0c3ce2c3ce91acc$var$_extends.apply(null, arguments);
}
function $a0c3ce2c3ce91acc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a0c3ce2c3ce91acc$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $a0c3ce2c3ce91acc$var$_arrayLikeToArray(r);
}
function $a0c3ce2c3ce91acc$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $a0c3ce2c3ce91acc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a0c3ce2c3ce91acc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a0c3ce2c3ce91acc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a0c3ce2c3ce91acc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a0c3ce2c3ce91acc$var$_toConsumableArray(r) {
    return $a0c3ce2c3ce91acc$var$_arrayWithoutHoles(r) || $a0c3ce2c3ce91acc$var$_iterableToArray(r) || $a0c3ce2c3ce91acc$var$_unsupportedIterableToArray(r) || $a0c3ce2c3ce91acc$var$_nonIterableSpread();
}
function $a0c3ce2c3ce91acc$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $a0c3ce2c3ce91acc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a0c3ce2c3ce91acc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a0c3ce2c3ce91acc$var$_slicedToArray(r, e) {
    return $a0c3ce2c3ce91acc$var$_arrayWithHoles(r) || $a0c3ce2c3ce91acc$var$_iterableToArrayLimit(r, e) || $a0c3ce2c3ce91acc$var$_unsupportedIterableToArray(r, e) || $a0c3ce2c3ce91acc$var$_nonIterableRest();
}
function $a0c3ce2c3ce91acc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a0c3ce2c3ce91acc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a0c3ce2c3ce91acc$var$_typeof(o);
}
function $a0c3ce2c3ce91acc$var$toPrimitive(t, r) {
    if ("object" != $a0c3ce2c3ce91acc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a0c3ce2c3ce91acc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a0c3ce2c3ce91acc$var$toPropertyKey(t) {
    var i = $a0c3ce2c3ce91acc$var$toPrimitive(t, "string");
    return "symbol" == $a0c3ce2c3ce91acc$var$_typeof(i) ? i : i + "";
}
function $a0c3ce2c3ce91acc$var$_defineProperty(e, r, t) {
    return (r = $a0c3ce2c3ce91acc$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $a0c3ce2c3ce91acc$var$styles = "\n@layer primereact {\n    .p-toast {\n        width: calc(100% - var(--toast-indent, 0px));\n        max-width: 25rem;\n    }\n    \n    .p-toast-message-icon {\n        flex-shrink: 0;\n    }\n    \n    .p-toast-message-content {\n        display: flex;\n        align-items: flex-start;\n    }\n    \n    .p-toast-message-text {\n        flex: 1 1 auto;\n    }\n    \n    .p-toast-summary {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-detail {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-top-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-bottom-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-center {\n        min-width: 20vw;\n        transform: translate(-50%, -50%);\n    }\n    \n    .p-toast-icon-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-toast-icon-close.p-link {\n        cursor: pointer;\n    }\n    \n    /* Animations */\n    .p-toast-message-enter {\n        opacity: 0;\n        transform: translateY(50%);\n    }\n    \n    .p-toast-message-enter-active {\n        opacity: 1;\n        transform: translateY(0);\n        transition: transform 0.3s, opacity 0.3s;\n    }\n    \n    .p-toast-message-enter-done {\n        transform: none;\n    }\n    \n    .p-toast-message-exit {\n        opacity: 1;\n        max-height: 1000px;\n    }\n    \n    .p-toast .p-toast-message.p-toast-message-exit-active {\n        opacity: 0;\n        max-height: 0;\n        margin-bottom: 0;\n        overflow: hidden;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1), opacity 0.3s, margin-bottom 0.3s;\n    }\n}\n";
var $a0c3ce2c3ce91acc$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $7nrKB.classNames)("p-toast p-component p-toast-" + props.position, props.className, {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    message: {
        message: function message(_ref2) {
            var severity = _ref2.severity;
            return (0, $7nrKB.classNames)("p-toast-message", $a0c3ce2c3ce91acc$var$_defineProperty({}, "p-toast-message-".concat(severity), severity));
        },
        content: "p-toast-message-content",
        buttonicon: "p-toast-icon-close-icon",
        closeButton: "p-toast-icon-close p-link",
        icon: "p-toast-message-icon",
        text: "p-toast-message-text",
        summary: "p-toast-summary",
        detail: "p-toast-detail"
    },
    transition: "p-toast-message"
};
var $a0c3ce2c3ce91acc$var$inlineStyles = {
    root: function root(_ref3) {
        var props = _ref3.props;
        return {
            position: "fixed",
            top: props.position === "top-right" || props.position === "top-left" || props.position === "top-center" ? "20px" : props.position === "center" ? "50%" : null,
            right: (props.position === "top-right" || props.position === "bottom-right") && "20px",
            bottom: (props.position === "bottom-left" || props.position === "bottom-right" || props.position === "bottom-center") && "20px",
            left: props.position === "top-left" || props.position === "bottom-left" ? "20px" : props.position === "center" || props.position === "top-center" || props.position === "bottom-center" ? "50%" : null
        };
    }
};
var $a0c3ce2c3ce91acc$var$ToastBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Toast",
        id: null,
        className: null,
        content: null,
        style: null,
        baseZIndex: 0,
        position: "top-right",
        transitionOptions: null,
        appendTo: "self",
        onClick: null,
        onRemove: null,
        onShow: null,
        onHide: null,
        onMouseEnter: null,
        onMouseLeave: null,
        children: undefined
    },
    css: {
        classes: $a0c3ce2c3ce91acc$var$classes,
        styles: $a0c3ce2c3ce91acc$var$styles,
        inlineStyles: $a0c3ce2c3ce91acc$var$inlineStyles
    }
});
function $a0c3ce2c3ce91acc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0c3ce2c3ce91acc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0c3ce2c3ce91acc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a0c3ce2c3ce91acc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0c3ce2c3ce91acc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0c3ce2c3ce91acc$var$ToastMessage = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(props, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var messageInfo = props.messageInfo, parentMetaData = props.metaData, _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, index = props.index;
    var _messageInfo$message = messageInfo.message, severity = _messageInfo$message.severity, content = _messageInfo$message.content, summary = _messageInfo$message.summary, detail = _messageInfo$message.detail, closable = _messageInfo$message.closable, life = _messageInfo$message.life, sticky = _messageInfo$message.sticky, _className = _messageInfo$message.className, style = _messageInfo$message.style, _contentClassName = _messageInfo$message.contentClassName, contentStyle = _messageInfo$message.contentStyle, _icon = _messageInfo$message.icon, _closeIcon = _messageInfo$message.closeIcon, pt = _messageInfo$message.pt;
    var params = {
        index: index
    };
    var parentParams = $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, parentMetaData), params);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $a0c3ce2c3ce91acc$var$_slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _useTimeout = (0, $jr5t3.useTimeout)(function() {
        onClose();
    }, life || 3000, !sticky && !focused), _useTimeout2 = $a0c3ce2c3ce91acc$var$_slicedToArray(_useTimeout, 1), clearTimer = _useTimeout2[0];
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $a0c3ce2c3ce91acc$var$_objectSpread({
            hostName: props.hostName
        }, options));
    };
    var onClose = function onClose() {
        clearTimer();
        props.onClose && props.onClose(messageInfo);
    };
    var onClick = function onClick(event) {
        if (props.onClick && !((0, $7nrKB.DomHandler).hasClass(event.target, "p-toast-icon-close") || (0, $7nrKB.DomHandler).hasClass(event.target, "p-toast-icon-close-icon"))) props.onClick(messageInfo.message);
    };
    var onMouseEnter = function onMouseEnter(event) {
        props.onMouseEnter && props.onMouseEnter(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // stop timer while user has focused message
        if (!sticky) {
            clearTimer();
            setFocused(true);
        }
    };
    var onMouseLeave = function onMouseLeave(event) {
        props.onMouseLeave && props.onMouseLeave(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // restart timer when user has left message
        if (!sticky) setFocused(false);
    };
    var createCloseIcon = function createCloseIcon() {
        var buttonIconProps = mergeProps({
            className: cx("message.buttonicon")
        }, getPTOptions("buttonicon", parentParams), ptmo(pt, "buttonicon", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        var icon = _closeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), buttonIconProps);
        var closeIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $a0c3ce2c3ce91acc$var$_objectSpread({}, buttonIconProps), {
            props: props
        });
        var closeButtonProps = mergeProps({
            type: "button",
            className: cx("message.closeButton"),
            onClick: onClose,
            "aria-label": props.ariaCloseLabel || (0, $eHYdO.ariaLabel)("close")
        }, getPTOptions("closeButton", parentParams), ptmo(pt, "closeButton", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        if (closable !== false) return /*#__PURE__*/ $7E7Dk.createElement("div", null, /*#__PURE__*/ $7E7Dk.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
        return null;
    };
    var createMessage = function createMessage() {
        if (messageInfo) {
            var contentEl = (0, $7nrKB.ObjectUtils).getJSXElement(content, {
                message: messageInfo.message,
                onClick: onClick,
                onClose: onClose
            });
            var iconProps = mergeProps({
                className: cx("message.icon")
            }, getPTOptions("icon", parentParams), ptmo(pt, "icon", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _icon;
            if (!_icon) switch(severity){
                case "info":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $8Murc.InfoCircleIcon), iconProps);
                    break;
                case "warn":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $dgIaN.ExclamationTriangleIcon), iconProps);
                    break;
                case "error":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $f6Dhj.TimesCircleIcon), iconProps);
                    break;
                case "success":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), iconProps);
                    break;
            }
            var messageIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $a0c3ce2c3ce91acc$var$_objectSpread({}, iconProps), {
                props: props
            });
            var textProps = mergeProps({
                className: cx("message.text")
            }, getPTOptions("text", parentParams), ptmo(pt, "text", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var summaryProps = mergeProps({
                className: cx("message.summary")
            }, getPTOptions("summary", parentParams), ptmo(pt, "summary", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var detailProps = mergeProps({
                className: cx("message.detail")
            }, getPTOptions("detail", parentParams), ptmo(pt, "detail", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            return contentEl || /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, messageIcon, /*#__PURE__*/ $7E7Dk.createElement("div", textProps, /*#__PURE__*/ $7E7Dk.createElement("span", summaryProps, summary), detail && /*#__PURE__*/ $7E7Dk.createElement("div", detailProps, detail)));
        }
        return null;
    };
    var message = createMessage();
    var closeIcon = createCloseIcon();
    var messageProps = mergeProps({
        ref: ref,
        className: (0, $7nrKB.classNames)(_className, cx("message.message", {
            severity: severity
        })),
        style: style,
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, getPTOptions("message", parentParams), ptmo(pt, "root", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    var contentProps = mergeProps({
        className: (0, $7nrKB.classNames)(_contentClassName, cx("message.content")),
        style: contentStyle
    }, getPTOptions("content", parentParams), ptmo(pt, "content", $a0c3ce2c3ce91acc$var$_objectSpread($a0c3ce2c3ce91acc$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    return /*#__PURE__*/ $7E7Dk.createElement("div", messageProps, /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, message, closeIcon));
}));
$a0c3ce2c3ce91acc$var$ToastMessage.displayName = "ToastMessage";
var $a0c3ce2c3ce91acc$var$messageIdx = 0;
var $a0c3ce2c3ce91acc$export$8d8dc7d5f743331b = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $a0c3ce2c3ce91acc$var$ToastBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState([]), _React$useState2 = $a0c3ce2c3ce91acc$var$_slicedToArray(_React$useState, 2), messagesState = _React$useState2[0], setMessagesState = _React$useState2[1];
    var containerRef = $7E7Dk.useRef(null);
    var metaData = {
        props: props,
        state: {
            messages: messagesState
        }
    };
    var ptCallbacks = $a0c3ce2c3ce91acc$var$ToastBase.setMetaData(metaData);
    (0, $kHEnT.useHandleStyle)($a0c3ce2c3ce91acc$var$ToastBase.css.styles, ptCallbacks.isUnstyled, {
        name: "toast"
    });
    var show = function show(messageInfo) {
        if (messageInfo) setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, true);
        });
    };
    var assignIdentifiers = function assignIdentifiers(currentState, messageInfo, copy) {
        var messages;
        if (Array.isArray(messageInfo)) {
            var multipleMessages = messageInfo.reduce(function(acc, message) {
                acc.push({
                    _pId: $a0c3ce2c3ce91acc$var$messageIdx++,
                    message: message
                });
                return acc;
            }, []);
            if (copy) messages = currentState ? [].concat($a0c3ce2c3ce91acc$var$_toConsumableArray(currentState), $a0c3ce2c3ce91acc$var$_toConsumableArray(multipleMessages)) : multipleMessages;
            else messages = multipleMessages;
        } else {
            var message = {
                _pId: $a0c3ce2c3ce91acc$var$messageIdx++,
                message: messageInfo
            };
            if (copy) messages = currentState ? [].concat($a0c3ce2c3ce91acc$var$_toConsumableArray(currentState), [
                message
            ]) : [
                message
            ];
            else messages = [
                message
            ];
        }
        return messages;
    };
    var clear = function clear() {
        (0, $7nrKB.ZIndexUtils).clear(containerRef.current);
        setMessagesState([]);
    };
    var replace = function replace(messageInfo) {
        setMessagesState(function(previousMessagesState) {
            return assignIdentifiers(previousMessagesState, messageInfo, false);
        });
    };
    var remove = function remove(messageInfo) {
        // allow removal by ID or by message equality
        var removeMessage = (0, $7nrKB.ObjectUtils).isNotEmpty(messageInfo._pId) ? messageInfo._pId : messageInfo.message || messageInfo;
        setMessagesState(function(prev) {
            return prev.filter(function(msg) {
                return msg._pId !== messageInfo._pId && !(0, $7nrKB.ObjectUtils).deepEquals(msg.message, removeMessage);
            });
        });
        props.onRemove && props.onRemove(messageInfo.message || removeMessage);
    };
    var onClose = function onClose(messageInfo) {
        remove(messageInfo);
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
    };
    var onExited = function onExited() {
        messagesState.length === 1 && (0, $7nrKB.ZIndexUtils).clear(containerRef.current);
        props.onHide && props.onHide();
    };
    (0, $jr5t3.useUpdateEffect)(function() {
        (0, $7nrKB.ZIndexUtils).set("toast", containerRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, props.baseZIndex || context && context.zIndex.toast || (0, $eHYdO.default).zIndex.toast);
    }, [
        messagesState,
        props.baseZIndex
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        (0, $7nrKB.ZIndexUtils).clear(containerRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            replace: replace,
            remove: remove,
            clear: clear,
            getElement: function getElement() {
                return containerRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var rootProps = mergeProps({
            ref: containerRef,
            id: props.id,
            className: ptCallbacks.cx("root", {
                context: context
            }),
            style: ptCallbacks.sx("root")
        }, $a0c3ce2c3ce91acc$var$ToastBase.getOtherProps(props), ptCallbacks.ptm("root"));
        var transitionProps = mergeProps({
            classNames: ptCallbacks.cx("transition"),
            timeout: {
                enter: 300,
                exit: 300
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEntered: onEntered,
            onExited: onExited
        }, ptCallbacks.ptm("transition"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement((0, $hySFd.default), null, messagesState && messagesState.map(function(messageInfo, index) {
            var messageRef = /*#__PURE__*/ $7E7Dk.createRef();
            return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $a0c3ce2c3ce91acc$var$_extends({
                nodeRef: messageRef,
                key: messageInfo._pId
            }, transitionProps), inProps.content ? (0, $7nrKB.ObjectUtils).getJSXElement(inProps.content, {
                message: messageInfo.message
            }) : /*#__PURE__*/ $7E7Dk.createElement($a0c3ce2c3ce91acc$var$ToastMessage, {
                hostName: "Toast",
                ref: messageRef,
                messageInfo: messageInfo,
                index: index,
                onClick: props.onClick,
                onClose: onClose,
                onMouseEnter: props.onMouseEnter,
                onMouseLeave: props.onMouseLeave,
                closeIcon: props.closeIcon,
                ptCallbacks: ptCallbacks,
                metaData: metaData
            }));
        })));
    };
    var element = createElement();
    return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$a0c3ce2c3ce91acc$export$8d8dc7d5f743331b.displayName = "Toast";

});
parcelRegister("hySFd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc9003b77c0b8581$export$2e2bcd8739ae039; });

var $cq2Uw = parcelRequire("cq2Uw");

var $GZIIz = parcelRequire("GZIIz");

var $jUqC3 = parcelRequire("jUqC3");

var $lUyOW = parcelRequire("lUyOW");


var $7E7Dk = parcelRequire("7E7Dk");

var $cKH92 = parcelRequire("cKH92");

var $hh1vK = parcelRequire("hh1vK");
var $cc9003b77c0b8581$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $cc9003b77c0b8581$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $cc9003b77c0b8581$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $lUyOW.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $jUqC3.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $hh1vK.getInitialChildMapping)(nextProps, handleExited) : (0, $hh1vK.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $hh1vK.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $GZIIz.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cq2Uw.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $cc9003b77c0b8581$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cKH92.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cKH92.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Component);
$cc9003b77c0b8581$var$TransitionGroup.propTypes = {};
$cc9003b77c0b8581$var$TransitionGroup.defaultProps = $cc9003b77c0b8581$var$defaultProps;
var $cc9003b77c0b8581$export$2e2bcd8739ae039 = $cc9003b77c0b8581$var$TransitionGroup;

});
parcelRegister("cq2Uw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90aa2bb7950a0690$export$2e2bcd8739ae039; });
function $90aa2bb7950a0690$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("GZIIz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0813ccb7315b2d46$export$2e2bcd8739ae039; });
function $0813ccb7315b2d46$export$2e2bcd8739ae039() {
    $0813ccb7315b2d46$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0813ccb7315b2d46$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("jUqC3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7e7e40aa0d30690$export$2e2bcd8739ae039; });
function $e7e7e40aa0d30690$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("lUyOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff39d697c8924877$export$2e2bcd8739ae039; });

var $1QmDZ = parcelRequire("1QmDZ");
function $ff39d697c8924877$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $1QmDZ.default)(subClass, superClass);
}

});
parcelRegister("1QmDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $157c365fd15e2a5c$export$2e2bcd8739ae039; });
function $157c365fd15e2a5c$export$2e2bcd8739ae039(o, p) {
    $157c365fd15e2a5c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $157c365fd15e2a5c$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("cKH92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $948b3f8e65f2c81e$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
var $948b3f8e65f2c81e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext(null);

});

parcelRegister("hh1vK", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $c9353242e9a5efc1$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $c9353242e9a5efc1$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $c9353242e9a5efc1$export$36fd1af28d383ec0; });

var $7E7Dk = parcelRequire("7E7Dk");
function $c9353242e9a5efc1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7E7Dk.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7E7Dk.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c9353242e9a5efc1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c9353242e9a5efc1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c9353242e9a5efc1$export$fa71e2345c31d7a2(props, onExited) {
    return $c9353242e9a5efc1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7E7Dk.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c9353242e9a5efc1$var$getProp(child, "appear", props),
            enter: $c9353242e9a5efc1$var$getProp(child, "enter", props),
            exit: $c9353242e9a5efc1$var$getProp(child, "exit", props)
        });
    });
}
function $c9353242e9a5efc1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c9353242e9a5efc1$export$bbc8a025727ea824(nextProps.children);
    var children = $c9353242e9a5efc1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7E7Dk.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7E7Dk.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7E7Dk.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c9353242e9a5efc1$var$getProp(child, "exit", nextProps),
            enter: $c9353242e9a5efc1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7E7Dk.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7E7Dk.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7E7Dk.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c9353242e9a5efc1$var$getProp(child, "exit", nextProps),
            enter: $c9353242e9a5efc1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("kHEnT", function(module, exports) {

$parcel$export(module.exports, "ComponentBase", function () { return $f127264fef8d5c64$export$425c3e0a21b857e8; });
$parcel$export(module.exports, "useHandleStyle", function () { return $f127264fef8d5c64$export$142583cb150b394; });

var $eHYdO = parcelRequire("eHYdO");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $f127264fef8d5c64$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f127264fef8d5c64$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $f127264fef8d5c64$var$_arrayLikeToArray(r);
}
function $f127264fef8d5c64$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $f127264fef8d5c64$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f127264fef8d5c64$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f127264fef8d5c64$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f127264fef8d5c64$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f127264fef8d5c64$var$_toConsumableArray(r) {
    return $f127264fef8d5c64$var$_arrayWithoutHoles(r) || $f127264fef8d5c64$var$_iterableToArray(r) || $f127264fef8d5c64$var$_unsupportedIterableToArray(r) || $f127264fef8d5c64$var$_nonIterableSpread();
}
function $f127264fef8d5c64$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f127264fef8d5c64$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f127264fef8d5c64$var$_typeof(o);
}
function $f127264fef8d5c64$var$toPrimitive(t, r) {
    if ("object" != $f127264fef8d5c64$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f127264fef8d5c64$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f127264fef8d5c64$var$toPropertyKey(t) {
    var i = $f127264fef8d5c64$var$toPrimitive(t, "string");
    return "symbol" == $f127264fef8d5c64$var$_typeof(i) ? i : i + "";
}
function $f127264fef8d5c64$var$_defineProperty(e, r, t) {
    return (r = $f127264fef8d5c64$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f127264fef8d5c64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f127264fef8d5c64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f127264fef8d5c64$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f127264fef8d5c64$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f127264fef8d5c64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f127264fef8d5c64$var$baseStyle = "\n.p-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0;\n    pointer-events: none;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n}\n\n.p-overflow-hidden {\n    overflow: hidden;\n    padding-right: var(--scrollbar-width);\n}\n";
var $f127264fef8d5c64$var$buttonStyles = "\n.p-button {\n    margin: 0;\n    display: inline-flex;\n    cursor: pointer;\n    user-select: none;\n    align-items: center;\n    vertical-align: bottom;\n    text-align: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.p-button-label {\n    flex: 1 1 auto;\n}\n\n.p-button-icon-right {\n    order: 1;\n}\n\n.p-button:disabled {\n    cursor: default;\n}\n\n.p-button-icon-only {\n    justify-content: center;\n}\n\n.p-button-icon-only .p-button-label {\n    visibility: hidden;\n    width: 0;\n    flex: 0 0 auto;\n}\n\n.p-button-vertical {\n    flex-direction: column;\n}\n\n.p-button-icon-bottom {\n    order: 2;\n}\n\n.p-button-group .p-button {\n    margin: 0;\n}\n\n.p-button-group .p-button:not(:last-child) {\n    border-right: 0 none;\n}\n\n.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {\n    border-radius: 0;\n}\n\n.p-button-group .p-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.p-button-group .p-button:last-of-type {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.p-button-group .p-button:focus {\n    position: relative;\n    z-index: 1;\n}\n\n.p-button-group-single .p-button:first-of-type {\n    border-top-right-radius: var(--border-radius) !important;\n    border-bottom-right-radius: var(--border-radius) !important;\n}\n\n.p-button-group-single .p-button:last-of-type {\n    border-top-left-radius: var(--border-radius) !important;\n    border-bottom-left-radius: var(--border-radius) !important;\n}\n";
var $f127264fef8d5c64$var$inputTextStyles = "\n.p-inputtext {\n    margin: 0;\n}\n\n.p-fluid .p-inputtext {\n    width: 100%;\n}\n\n/* InputGroup */\n.p-inputgroup {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup-addon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-inputgroup .p-float-label {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup .p-inputtext,\n.p-fluid .p-inputgroup .p-inputtext,\n.p-inputgroup .p-inputwrapper,\n.p-fluid .p-inputgroup .p-input {\n    flex: 1 1 auto;\n    width: 1%;\n}\n\n/* Floating Label */\n.p-float-label {\n    display: block;\n    position: relative;\n}\n\n.p-float-label label {\n    position: absolute;\n    pointer-events: none;\n    top: 50%;\n    margin-top: -0.5rem;\n    transition-property: all;\n    transition-timing-function: ease;\n    line-height: 1;\n}\n\n.p-float-label textarea ~ label,\n.p-float-label .p-mention ~ label {\n    top: 1rem;\n}\n\n.p-float-label input:focus ~ label,\n.p-float-label input:-webkit-autofill ~ label,\n.p-float-label input.p-filled ~ label,\n.p-float-label textarea:focus ~ label,\n.p-float-label textarea.p-filled ~ label,\n.p-float-label .p-inputwrapper-focus ~ label,\n.p-float-label .p-inputwrapper-filled ~ label,\n.p-float-label .p-tooltip-target-wrapper ~ label {\n    top: -0.75rem;\n    font-size: 12px;\n}\n\n.p-float-label .p-placeholder,\n.p-float-label input::placeholder,\n.p-float-label .p-inputtext::placeholder {\n    opacity: 0;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-float-label .p-focus .p-placeholder,\n.p-float-label input:focus::placeholder,\n.p-float-label .p-inputtext:focus::placeholder {\n    opacity: 1;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-input-icon-left,\n.p-input-icon-right {\n    position: relative;\n    display: inline-block;\n}\n\n.p-input-icon-left > i,\n.p-input-icon-right > i,\n.p-input-icon-left > svg,\n.p-input-icon-right > svg,\n.p-input-icon-left > .p-input-prefix,\n.p-input-icon-right > .p-input-suffix {\n    position: absolute;\n    top: 50%;\n    margin-top: -0.5rem;\n}\n\n.p-fluid .p-input-icon-left,\n.p-fluid .p-input-icon-right {\n    display: block;\n    width: 100%;\n}\n";
var $f127264fef8d5c64$var$iconStyles = "\n.p-icon {\n    display: inline-block;\n}\n\n.p-icon-spin {\n    -webkit-animation: p-icon-spin 2s infinite linear;\n    animation: p-icon-spin 2s infinite linear;\n}\n\nsvg.p-icon {\n    pointer-events: auto;\n}\n\nsvg.p-icon g,\n.p-disabled svg.p-icon {\n    pointer-events: none;\n}\n\n@-webkit-keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n\n@keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n";
var $f127264fef8d5c64$var$commonStyle = "\n@layer primereact {\n    .p-component, .p-component * {\n        box-sizing: border-box;\n    }\n\n    .p-hidden {\n        display: none;\n    }\n\n    .p-hidden-space {\n        visibility: hidden;\n    }\n\n    .p-reset {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        text-decoration: none;\n        font-size: 100%;\n        list-style: none;\n    }\n\n    .p-disabled, .p-disabled * {\n        cursor: default;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    .p-component-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .p-unselectable-text {\n        user-select: none;\n    }\n\n    .p-scrollbar-measure {\n        width: 100px;\n        height: 100px;\n        overflow: scroll;\n        position: absolute;\n        top: -9999px;\n    }\n\n    @-webkit-keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n    @keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n\n    .p-link {\n        text-align: left;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        border: none;\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-link:disabled {\n        cursor: default;\n    }\n\n    /* Non react overlay animations */\n    .p-connected-overlay {\n        opacity: 0;\n        transform: scaleY(0.8);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-visible {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n\n    .p-connected-overlay-hidden {\n        opacity: 0;\n        transform: scaleY(1);\n        transition: opacity .1s linear;\n    }\n\n    /* React based overlay animations */\n    .p-connected-overlay-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    .p-connected-overlay-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-enter-done {\n        transform: none;\n    }\n\n    .p-connected-overlay-exit {\n        opacity: 1;\n    }\n\n    .p-connected-overlay-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n\n    /* Toggleable Content */\n    .p-toggleable-content-enter {\n        max-height: 0;\n    }\n\n    .p-toggleable-content-enter-active {\n        overflow: hidden;\n        max-height: 1000px;\n        transition: max-height 1s ease-in-out;\n    }\n\n    .p-toggleable-content-enter-done {\n        transform: none;\n    }\n\n    .p-toggleable-content-exit {\n        max-height: 1000px;\n    }\n\n    .p-toggleable-content-exit-active {\n        overflow: hidden;\n        max-height: 0;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n    }\n\n    /* @todo Refactor */\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    ".concat($f127264fef8d5c64$var$buttonStyles, "\n    ").concat($f127264fef8d5c64$var$inputTextStyles, "\n    ").concat($f127264fef8d5c64$var$iconStyles, "\n}\n");
var $f127264fef8d5c64$export$425c3e0a21b857e8 = {
    cProps: undefined,
    cParams: undefined,
    cName: undefined,
    defaultProps: {
        pt: undefined,
        ptOptions: undefined,
        unstyled: false
    },
    context: {},
    globalCSS: undefined,
    classes: {},
    styles: "",
    extend: function extend() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var css = props.css;
        var defaultProps = $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, props.defaultProps), $f127264fef8d5c64$export$425c3e0a21b857e8.defaultProps);
        var inlineStyles = {};
        var getProps = function getProps(props) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            $f127264fef8d5c64$export$425c3e0a21b857e8.context = context;
            $f127264fef8d5c64$export$425c3e0a21b857e8.cProps = props;
            return (0, $7nrKB.ObjectUtils).getMergedProps(props, defaultProps);
        };
        var getOtherProps = function getOtherProps(props) {
            return (0, $7nrKB.ObjectUtils).getDiffProps(props, defaultProps);
        };
        var getPTValue = function getPTValue() {
            var _ComponentBase$contex;
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var searchInDefaultPT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            // obj either is the passthrough options or has a .pt property.
            if (obj.hasOwnProperty("pt") && obj.pt !== undefined) obj = obj.pt;
            var originalkey = key;
            var isNestedParam = /./g.test(originalkey) && !!params[originalkey.split(".")[0]];
            var fkey = isNestedParam ? (0, $7nrKB.ObjectUtils).toFlatCase(originalkey.split(".")[1]) : (0, $7nrKB.ObjectUtils).toFlatCase(originalkey);
            var hostName = params.hostName && (0, $7nrKB.ObjectUtils).toFlatCase(params.hostName);
            var componentName = hostName || params.props && params.props.__TYPE && (0, $7nrKB.ObjectUtils).toFlatCase(params.props.__TYPE) || "";
            var isTransition = fkey === "transition";
            var datasetPrefix = "data-pc-";
            var _getHostInstance = function getHostInstance(params) {
                return params !== null && params !== void 0 && params.props ? params.hostName ? params.props.__TYPE === params.hostName ? params.props : _getHostInstance(params.parent) : params.parent : undefined;
            };
            var getPropValue = function getPropValue(name) {
                var _params$props, _getHostInstance2;
                return ((_params$props = params.props) === null || _params$props === void 0 ? void 0 : _params$props[name]) || ((_getHostInstance2 = _getHostInstance(params)) === null || _getHostInstance2 === void 0 ? void 0 : _getHostInstance2[name]);
            };
            $f127264fef8d5c64$export$425c3e0a21b857e8.cParams = params;
            $f127264fef8d5c64$export$425c3e0a21b857e8.cName = componentName;
            var _ref = getPropValue("ptOptions") || $f127264fef8d5c64$export$425c3e0a21b857e8.context.ptOptions || {}, _ref$mergeSections = _ref.mergeSections, mergeSections = _ref$mergeSections === void 0 ? true : _ref$mergeSections, _ref$mergeProps = _ref.mergeProps, useMergeProps = _ref$mergeProps === void 0 ? false : _ref$mergeProps;
            var getPTClassValue = function getPTClassValue() {
                var value = $f127264fef8d5c64$var$_getOptionValue.apply(void 0, arguments);
                if (Array.isArray(value)) return {
                    className: (0, $7nrKB.classNames).apply(void 0, $f127264fef8d5c64$var$_toConsumableArray(value))
                };
                if ((0, $7nrKB.ObjectUtils).isString(value)) return {
                    className: value
                };
                if (value !== null && value !== void 0 && value.hasOwnProperty("className") && Array.isArray(value.className)) return {
                    className: (0, $7nrKB.classNames).apply(void 0, $f127264fef8d5c64$var$_toConsumableArray(value.className))
                };
                return value;
            };
            var globalPT = searchInDefaultPT ? isNestedParam ? $f127264fef8d5c64$var$_useGlobalPT(getPTClassValue, originalkey, params) : $f127264fef8d5c64$var$_useDefaultPT(getPTClassValue, originalkey, params) : undefined;
            var self = isNestedParam ? undefined : $f127264fef8d5c64$var$_usePT($f127264fef8d5c64$var$_getPT(obj, componentName), getPTClassValue, originalkey, params);
            var datasetProps = !isTransition && $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, fkey === "root" && $f127264fef8d5c64$var$_defineProperty({}, "".concat(datasetPrefix, "name"), params.props && params.props.__parentMetadata ? (0, $7nrKB.ObjectUtils).toFlatCase(params.props.__TYPE) : componentName)), {}, $f127264fef8d5c64$var$_defineProperty({}, "".concat(datasetPrefix, "section"), fkey));
            return mergeSections || !mergeSections && self ? useMergeProps ? (0, $7nrKB.mergeProps)([
                globalPT,
                self,
                Object.keys(datasetProps).length ? datasetProps : {}
            ], {
                classNameMergeFunction: (_ComponentBase$contex = $f127264fef8d5c64$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex === void 0 ? void 0 : _ComponentBase$contex.classNameMergeFunction
            }) : $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, globalPT), self), Object.keys(datasetProps).length ? datasetProps : {}) : $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, self), Object.keys(datasetProps).length ? datasetProps : {});
        };
        var setMetaData = function setMetaData() {
            var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var props = metadata.props, state = metadata.state;
            var ptm = function ptm() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return getPTValue((props || {}).pt, key, $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, metadata), params));
            };
            var ptmo = function ptmo() {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return getPTValue(obj, key, params, false);
            };
            var isUnstyled = function isUnstyled() {
                return $f127264fef8d5c64$export$425c3e0a21b857e8.context.unstyled || (0, $eHYdO.default).unstyled || props.unstyled;
            };
            var cx = function cx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return !isUnstyled() ? $f127264fef8d5c64$var$_getOptionValue(css && css.classes, key, $f127264fef8d5c64$var$_objectSpread({
                    props: props,
                    state: state
                }, params)) : undefined;
            };
            var sx = function sx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                if (when) {
                    var _ComponentBase$contex2;
                    var self = $f127264fef8d5c64$var$_getOptionValue(css && css.inlineStyles, key, $f127264fef8d5c64$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    var base = $f127264fef8d5c64$var$_getOptionValue(inlineStyles, key, $f127264fef8d5c64$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    return (0, $7nrKB.mergeProps)([
                        base,
                        self
                    ], {
                        classNameMergeFunction: (_ComponentBase$contex2 = $f127264fef8d5c64$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex2 === void 0 ? void 0 : _ComponentBase$contex2.classNameMergeFunction
                    });
                }
                return undefined;
            };
            return {
                ptm: ptm,
                ptmo: ptmo,
                sx: sx,
                cx: cx,
                isUnstyled: isUnstyled
            };
        };
        return $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({
            getProps: getProps,
            getOtherProps: getOtherProps,
            setMetaData: setMetaData
        }, props), {}, {
            defaultProps: defaultProps
        });
    }
};
var $f127264fef8d5c64$var$_getOptionValue = function getOptionValue(obj) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var fKeys = String((0, $7nrKB.ObjectUtils).toFlatCase(key)).split(".");
    var fKey = fKeys.shift();
    var matchedPTOption = (0, $7nrKB.ObjectUtils).isNotEmpty(obj) ? Object.keys(obj).find(function(k) {
        return (0, $7nrKB.ObjectUtils).toFlatCase(k) === fKey;
    }) : "";
    return fKey ? (0, $7nrKB.ObjectUtils).isObject(obj) ? $f127264fef8d5c64$var$_getOptionValue((0, $7nrKB.ObjectUtils).getItemValue(obj[matchedPTOption], params), fKeys.join("."), params) : undefined : (0, $7nrKB.ObjectUtils).getItemValue(obj, params);
};
var $f127264fef8d5c64$var$_getPT = function _getPT(pt) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var _usept = pt === null || pt === void 0 ? void 0 : pt._usept;
    var getValue = function getValue(value) {
        var _ref3;
        var checkSameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _value = callback ? callback(value) : value;
        var _key = (0, $7nrKB.ObjectUtils).toFlatCase(key);
        return (_ref3 = checkSameKey ? _key !== $f127264fef8d5c64$export$425c3e0a21b857e8.cName ? _value === null || _value === void 0 ? void 0 : _value[_key] : undefined : _value === null || _value === void 0 ? void 0 : _value[_key]) !== null && _ref3 !== void 0 ? _ref3 : _value;
    };
    return (0, $7nrKB.ObjectUtils).isNotEmpty(_usept) ? {
        _usept: _usept,
        originalValue: getValue(pt.originalValue),
        value: getValue(pt.value)
    } : getValue(pt, true);
};
var $f127264fef8d5c64$var$_usePT = function _usePT(pt, callback, key, params) {
    var fn = function fn(value) {
        return callback(value, key, params);
    };
    if (pt !== null && pt !== void 0 && pt.hasOwnProperty("_usept")) {
        var _ref4 = pt._usept || $f127264fef8d5c64$export$425c3e0a21b857e8.context.ptOptions || {}, _ref4$mergeSections = _ref4.mergeSections, mergeSections = _ref4$mergeSections === void 0 ? true : _ref4$mergeSections, _ref4$mergeProps = _ref4.mergeProps, useMergeProps = _ref4$mergeProps === void 0 ? false : _ref4$mergeProps, classNameMergeFunction = _ref4.classNameMergeFunction;
        var originalValue = fn(pt.originalValue);
        var value = fn(pt.value);
        if (originalValue === undefined && value === undefined) return undefined;
        else if ((0, $7nrKB.ObjectUtils).isString(value)) return value;
        else if ((0, $7nrKB.ObjectUtils).isString(originalValue)) return originalValue;
        return mergeSections || !mergeSections && value ? useMergeProps ? (0, $7nrKB.mergeProps)([
            originalValue,
            value
        ], {
            classNameMergeFunction: classNameMergeFunction
        }) : $f127264fef8d5c64$var$_objectSpread($f127264fef8d5c64$var$_objectSpread({}, originalValue), value) : value;
    }
    return fn(pt);
};
var $f127264fef8d5c64$var$getGlobalPT = function getGlobalPT() {
    return $f127264fef8d5c64$var$_getPT($f127264fef8d5c64$export$425c3e0a21b857e8.context.pt || (0, $eHYdO.default).pt, undefined, function(value) {
        return (0, $7nrKB.ObjectUtils).getItemValue(value, $f127264fef8d5c64$export$425c3e0a21b857e8.cParams);
    });
};
var $f127264fef8d5c64$var$getDefaultPT = function getDefaultPT() {
    return $f127264fef8d5c64$var$_getPT($f127264fef8d5c64$export$425c3e0a21b857e8.context.pt || (0, $eHYdO.default).pt, undefined, function(value) {
        return $f127264fef8d5c64$var$_getOptionValue(value, $f127264fef8d5c64$export$425c3e0a21b857e8.cName, $f127264fef8d5c64$export$425c3e0a21b857e8.cParams) || (0, $7nrKB.ObjectUtils).getItemValue(value, $f127264fef8d5c64$export$425c3e0a21b857e8.cParams);
    });
};
var $f127264fef8d5c64$var$_useGlobalPT = function _useGlobalPT(callback, key, params) {
    return $f127264fef8d5c64$var$_usePT($f127264fef8d5c64$var$getGlobalPT(), callback, key, params);
};
var $f127264fef8d5c64$var$_useDefaultPT = function _useDefaultPT(callback, key, params) {
    return $f127264fef8d5c64$var$_usePT($f127264fef8d5c64$var$getDefaultPT(), callback, key, params);
};
var $f127264fef8d5c64$export$142583cb150b394 = function useHandleStyle(styles) {
    var _isUnstyled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {};
    var config = arguments.length > 2 ? arguments[2] : undefined;
    var name = config.name, _config$styled = config.styled, styled = _config$styled === void 0 ? false : _config$styled, _config$hostName = config.hostName, hostName = _config$hostName === void 0 ? "" : _config$hostName;
    var globalCSS = $f127264fef8d5c64$var$_useGlobalPT($f127264fef8d5c64$var$_getOptionValue, "global.css", $f127264fef8d5c64$export$425c3e0a21b857e8.cParams);
    var componentName = (0, $7nrKB.ObjectUtils).toFlatCase(name);
    var _useStyle = (0, $jr5t3.useStyle)($f127264fef8d5c64$var$baseStyle, {
        name: "base",
        manual: true
    }), loadBaseStyle = _useStyle.load;
    var _useStyle2 = (0, $jr5t3.useStyle)($f127264fef8d5c64$var$commonStyle, {
        name: "common",
        manual: true
    }), loadCommonStyle = _useStyle2.load;
    var _useStyle3 = (0, $jr5t3.useStyle)(globalCSS, {
        name: "global",
        manual: true
    }), loadGlobalStyle = _useStyle3.load;
    var _useStyle4 = (0, $jr5t3.useStyle)(styles, {
        name: name,
        manual: true
    }), loadComponentStyle = _useStyle4.load;
    var hook = function hook(hookName) {
        if (!hostName) {
            var selfHook = $f127264fef8d5c64$var$_usePT($f127264fef8d5c64$var$_getPT(($f127264fef8d5c64$export$425c3e0a21b857e8.cProps || {}).pt, componentName), $f127264fef8d5c64$var$_getOptionValue, "hooks.".concat(hookName));
            var defaultHook = $f127264fef8d5c64$var$_useDefaultPT($f127264fef8d5c64$var$_getOptionValue, "hooks.".concat(hookName));
            selfHook === null || selfHook === void 0 || selfHook();
            defaultHook === null || defaultHook === void 0 || defaultHook();
        }
    };
    hook("useMountEffect");
    (0, $jr5t3.useMountEffect)(function() {
        // Load base and global styles first as they are always needed
        loadBaseStyle();
        loadGlobalStyle();
        // Only load additional styles if component is styled
        if (!_isUnstyled()) {
            // Load common styles shared across components
            loadCommonStyle();
            // Load component-specific styles if not explicitly styled
            if (!styled) loadComponentStyle();
        }
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        hook("useUpdateEffect");
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        hook("useUnmountEffect");
    });
};

});
parcelRegister("jr5t3", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $e264c7afc28f3ba9$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useUnmountEffect", function () { return $e264c7afc28f3ba9$export$f3a192d0cbd30b96; });
$parcel$export(module.exports, "useEventListener", function () { return $e264c7afc28f3ba9$export$7080b3e976bc91ab; });
$parcel$export(module.exports, "useDebounce", function () { return $e264c7afc28f3ba9$export$21805fee57372823; });
$parcel$export(module.exports, "useMountEffect", function () { return $e264c7afc28f3ba9$export$51c44cea289ac0f6; });
$parcel$export(module.exports, "useDisplayOrder", function () { return $e264c7afc28f3ba9$export$6353a33119af9098; });
$parcel$export(module.exports, "ESC_KEY_HANDLING_PRIORITIES", function () { return $e264c7afc28f3ba9$export$5153c70e1a2d4b71; });
$parcel$export(module.exports, "useGlobalOnEscapeKey", function () { return $e264c7afc28f3ba9$export$dee4359f392495ae; });
$parcel$export(module.exports, "useMergeProps", function () { return $e264c7afc28f3ba9$export$9596428d77cc41ba; });
$parcel$export(module.exports, "useOverlayScrollListener", function () { return $e264c7afc28f3ba9$export$d04245b74d6bdcb8; });
$parcel$export(module.exports, "useResizeListener", function () { return $e264c7afc28f3ba9$export$158eb97be50d41ef; });
$parcel$export(module.exports, "useOverlayListener", function () { return $e264c7afc28f3ba9$export$2fef17345d27a5b4; });
$parcel$export(module.exports, "useStyle", function () { return $e264c7afc28f3ba9$export$72c85e333541e7f; });
$parcel$export(module.exports, "useTimeout", function () { return $e264c7afc28f3ba9$export$d8e6abf214c9ec0f; });
$parcel$export(module.exports, "useUpdateEffect", function () { return $e264c7afc28f3ba9$export$496315a1608d9602; });

var $7E7Dk = parcelRequire("7E7Dk");

var $7nrKB = parcelRequire("7nrKB");

var $eHYdO = parcelRequire("eHYdO");
"use client";
function $e264c7afc28f3ba9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e264c7afc28f3ba9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e264c7afc28f3ba9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e264c7afc28f3ba9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e264c7afc28f3ba9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e264c7afc28f3ba9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e264c7afc28f3ba9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e264c7afc28f3ba9$var$_slicedToArray(r, e) {
    return $e264c7afc28f3ba9$var$_arrayWithHoles(r) || $e264c7afc28f3ba9$var$_iterableToArrayLimit(r, e) || $e264c7afc28f3ba9$var$_unsupportedIterableToArray(r, e) || $e264c7afc28f3ba9$var$_nonIterableRest();
}
var $e264c7afc28f3ba9$export$5cae361ad82dce8b = function usePrevious(newValue) {
    var ref = $7E7Dk.useRef(null);
    $7E7Dk.useEffect(function() {
        ref.current = newValue;
        return function() {
            ref.current = null;
        };
    }, [
        newValue
    ]);
    return ref.current;
};
/* eslint-disable */ var $e264c7afc28f3ba9$export$f3a192d0cbd30b96 = function useUnmountEffect(fn) {
    return $7E7Dk.useEffect(function() {
        return fn;
    }, []);
};
/* eslint-enable */ var $e264c7afc28f3ba9$export$7080b3e976bc91ab = function useEventListener(_ref) {
    var _ref$target = _ref.target, target = _ref$target === void 0 ? "document" : _ref$target, type = _ref.type, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = $7E7Dk.useRef(null);
    var listenerRef = $7E7Dk.useRef(null);
    var prevListener = $e264c7afc28f3ba9$export$5cae361ad82dce8b(listener);
    var prevOptions = $e264c7afc28f3ba9$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var bindTarget = bindOptions.target;
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(bindTarget)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $7nrKB.DomHandler).getTargetElement(bindTarget));
        }
        if (!listenerRef.current && targetRef.current) {
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            targetRef.current.addEventListener(type, listenerRef.current, options);
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            targetRef.current.removeEventListener(type, listenerRef.current, options);
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // Prevent memory leak by releasing
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $7E7Dk.useCallback(function() {
        if (when) targetRef.current = (0, $7nrKB.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $7E7Dk.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $7E7Dk.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $e264c7afc28f3ba9$export$1896bab46732d207 = function useClickOutside(ref, callback) {
    var isOutsideClicked = function isOutsideClicked(event) {
        if (!ref.current || ref.current.contains(event.target)) return;
        callback(event);
    };
    var _useEventListener = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "mousedown",
        listener: isOutsideClicked
    }), _useEventListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener, 2), bindMouseDownListener = _useEventListener2[0], unbindMouseDownListener = _useEventListener2[1];
    var _useEventListener3 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "touchstart",
        listener: isOutsideClicked
    }), _useEventListener4 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener3, 2), bindTouchStartListener = _useEventListener4[0], unbindTouchStartListener = _useEventListener4[1];
    $7E7Dk.useEffect(function() {
        if (!ref.current) return;
        bindMouseDownListener();
        bindTouchStartListener();
        return function() {
            unbindMouseDownListener();
            unbindTouchStartListener();
        };
    });
    return [
        ref,
        callback
    ];
};
var $e264c7afc28f3ba9$export$70c4067197c60e2d = function useCounter() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        step: 1
    };
    var _React$useState = $7E7Dk.useState(initialValue), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), count = _React$useState2[0], setCount = _React$useState2[1];
    var increment = function increment() {
        if (options.max && count >= options.max) return;
        setCount(count + options.step);
    };
    var decrement = function decrement() {
        if (options.min || options.min === 0 && count <= options.min) return null;
        setCount(count - options.step);
    };
    var reset = function reset() {
        setCount(0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset
    };
};
var $e264c7afc28f3ba9$export$21805fee57372823 = function useDebounce(initialValue, delay) {
    var _React$useState = $7E7Dk.useState(initialValue), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), inputValue = _React$useState2[0], setInputValue = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(initialValue), _React$useState4 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState3, 2), debouncedValue = _React$useState4[0], setDebouncedValue = _React$useState4[1];
    var mountedRef = $7E7Dk.useRef(false);
    var timeoutRef = $7E7Dk.useRef(null);
    var cancelTimer = function cancelTimer() {
        return window.clearTimeout(timeoutRef.current);
    };
    $e264c7afc28f3ba9$export$51c44cea289ac0f6(function() {
        mountedRef.current = true;
    });
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        cancelTimer();
    });
    $7E7Dk.useEffect(function() {
        if (!mountedRef.current) return;
        cancelTimer();
        timeoutRef.current = window.setTimeout(function() {
            setDebouncedValue(inputValue);
        }, delay);
    }, [
        inputValue,
        delay
    ]);
    return [
        inputValue,
        debouncedValue,
        setInputValue
    ];
};
var $e264c7afc28f3ba9$var$groupToDisplayedElements = {};
var $e264c7afc28f3ba9$export$6353a33119af9098 = function useDisplayOrder(group) {
    var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $7E7Dk.useState(function() {
        return (0, $7nrKB.UniqueComponentId)();
    }), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 1), uid = _React$useState2[0];
    var _React$useState3 = $7E7Dk.useState(0), _React$useState4 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState3, 2), displayOrder = _React$useState4[0], setDisplayOrder = _React$useState4[1];
    $7E7Dk.useEffect(function() {
        if (isVisible) {
            if (!$e264c7afc28f3ba9$var$groupToDisplayedElements[group]) $e264c7afc28f3ba9$var$groupToDisplayedElements[group] = [];
            var newDisplayOrder = $e264c7afc28f3ba9$var$groupToDisplayedElements[group].push(uid);
            setDisplayOrder(newDisplayOrder);
            return function() {
                delete $e264c7afc28f3ba9$var$groupToDisplayedElements[group][newDisplayOrder - 1];
                // Reduce array length, by removing undefined elements at the end of array:
                var lastIndex = $e264c7afc28f3ba9$var$groupToDisplayedElements[group].length - 1;
                var lastOrder = (0, $7nrKB.ObjectUtils).findLastIndex($e264c7afc28f3ba9$var$groupToDisplayedElements[group], function(el) {
                    return el !== undefined;
                });
                if (lastOrder !== lastIndex) $e264c7afc28f3ba9$var$groupToDisplayedElements[group].splice(lastOrder + 1);
                setDisplayOrder(undefined);
            };
        }
    }, [
        group,
        uid,
        isVisible
    ]);
    return displayOrder;
};
var $e264c7afc28f3ba9$var$TYPE_MAP = {
    ico: "image/x-icon",
    png: "image/png",
    svg: "image/svg+xml",
    gif: "image/gif"
};
var $e264c7afc28f3ba9$export$1252d0179ae6292b = function useFavicon() {
    var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var rel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "shortcut icon";
    $7E7Dk.useLayoutEffect(function() {
        if (newIcon) {
            var linkElements = document.querySelectorAll("link[rel*='icon']");
            linkElements.forEach(function(linkEl) {
                document.head.removeChild(linkEl);
            });
            var link = document.createElement("link");
            link.setAttribute("type", $e264c7afc28f3ba9$var$TYPE_MAP[newIcon.split(".").pop()]);
            link.setAttribute("rel", rel);
            link.setAttribute("href", newIcon);
            document.head.appendChild(link);
        }
    }, [
        newIcon,
        rel
    ]);
};
function $e264c7afc28f3ba9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e264c7afc28f3ba9$var$_arrayLikeToArray(r);
}
function $e264c7afc28f3ba9$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e264c7afc28f3ba9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e264c7afc28f3ba9$var$_toConsumableArray(r) {
    return $e264c7afc28f3ba9$var$_arrayWithoutHoles(r) || $e264c7afc28f3ba9$var$_iterableToArray(r) || $e264c7afc28f3ba9$var$_unsupportedIterableToArray(r) || $e264c7afc28f3ba9$var$_nonIterableSpread();
}
/**
 * Priorities of different components (bigger number handled first)
 */ var $e264c7afc28f3ba9$export$5153c70e1a2d4b71 = {
    SIDEBAR: 100,
    SLIDE_MENU: 200,
    DIALOG: 300,
    IMAGE: 400,
    MENU: 500,
    OVERLAY_PANEL: 600,
    PASSWORD: 700,
    CASCADE_SELECT: 800,
    SPLIT_BUTTON: 900,
    SPEED_DIAL: 1000,
    TOOLTIP: 1200
};
/**
 * Object, that manages global escape key handling logic
 */ var $e264c7afc28f3ba9$var$globalEscKeyHandlingLogic = {
    /**
   * Mapping from ESC_KEY_HANDLING_PRIORITY to array of related listeners, grouped by priority
   * @example
   * Map<{
   *     [ESC_KEY_HANDLING_PRIORITIES.SIDEBAR]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>,
   *     [ESC_KEY_HANDLING_PRIORITIES.DIALOG]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>
   * }>;
   */ escKeyListeners: new Map(),
    /**
   * Keydown handler (attached to any keydown)
   */ onGlobalKeyDown: function onGlobalKeyDown(event) {
        // Do nothing if not an "esc" key is pressed:
        if (event.code !== "Escape") return;
        var escKeyListeners = $e264c7afc28f3ba9$var$globalEscKeyHandlingLogic.escKeyListeners;
        var maxPrimaryPriority = Math.max.apply(Math, $e264c7afc28f3ba9$var$_toConsumableArray(escKeyListeners.keys()));
        var theMostImportantEscHandlersSet = escKeyListeners.get(maxPrimaryPriority);
        var maxSecondaryPriority = Math.max.apply(Math, $e264c7afc28f3ba9$var$_toConsumableArray(theMostImportantEscHandlersSet.keys()));
        var theMostImportantEscHandler = theMostImportantEscHandlersSet.get(maxSecondaryPriority);
        theMostImportantEscHandler(event);
    },
    /**
   * Attach global keydown listener if there are any "esc" key handlers assigned,
   * otherwise detach.
   */ refreshGlobalKeyDownListener: function refreshGlobalKeyDownListener() {
        var document1 = (0, $7nrKB.DomHandler).getTargetElement("document");
        if (this.escKeyListeners.size > 0) document1.addEventListener("keydown", this.onGlobalKeyDown);
        else document1.removeEventListener("keydown", this.onGlobalKeyDown);
    },
    /**
   * Add "Esc" key handler
   */ addListener: function addListener(callback, _ref) {
        var _this = this;
        var _ref2 = $e264c7afc28f3ba9$var$_slicedToArray(_ref, 2), primaryPriority = _ref2[0], secondaryPriority = _ref2[1];
        var escKeyListeners = this.escKeyListeners;
        if (!escKeyListeners.has(primaryPriority)) escKeyListeners.set(primaryPriority, new Map());
        var primaryPriorityListeners = escKeyListeners.get(primaryPriority);
        // To prevent unexpected override of callback:
        if (primaryPriorityListeners.has(secondaryPriority)) throw new Error("Unexpected: global esc key listener with priority [".concat(primaryPriority, ", ").concat(secondaryPriority, "] already exists."));
        primaryPriorityListeners.set(secondaryPriority, callback);
        this.refreshGlobalKeyDownListener();
        return function() {
            primaryPriorityListeners["delete"](secondaryPriority);
            if (primaryPriorityListeners.size === 0) escKeyListeners["delete"](primaryPriority);
            _this.refreshGlobalKeyDownListener();
        };
    }
};
var $e264c7afc28f3ba9$export$dee4359f392495ae = function useGlobalOnEscapeKey(_ref3) {
    var callback = _ref3.callback, when = _ref3.when, priority = _ref3.priority;
    (0, $7E7Dk.useEffect)(function() {
        if (!when) return;
        return $e264c7afc28f3ba9$var$globalEscKeyHandlingLogic.addListener(callback, priority);
    }, [
        callback,
        when,
        priority
    ]);
};
var $e264c7afc28f3ba9$export$a7395f9832c00176 = function useIntersectionObserver(ref) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), isElementVisible = _React$useState2[0], setIsElementVisible = _React$useState2[1];
    $7E7Dk.useEffect(function() {
        if (!ref.current) return;
        var observer = new IntersectionObserver(function(_ref) {
            var _ref2 = $e264c7afc28f3ba9$var$_slicedToArray(_ref, 1), entry = _ref2[0];
            setIsElementVisible(entry.isIntersecting);
        }, options);
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        options,
        ref
    ]);
    return isElementVisible;
};
/* eslint-disable */ var $e264c7afc28f3ba9$export$f4b266cd2aae9cb1 = function useInterval(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $7E7Dk.useRef(null);
    var savedCallback = $7E7Dk.useRef(null);
    var clear = $7E7Dk.useCallback(function() {
        return clearInterval(timeout.current);
    }, [
        timeout.current
    ]);
    $7E7Dk.useEffect(function() {
        savedCallback.current = fn;
    });
    $7E7Dk.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setInterval(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ var $e264c7afc28f3ba9$export$dd42f485803cd57d = function useMatchMedia(query) {
    var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    var matchMedia = $7E7Dk.useRef(null);
    var handleChange = function handleChange(e) {
        return setMatches(e.matches);
    };
    var bind = function bind() {
        return matchMedia.current && matchMedia.current.addEventListener("change", handleChange);
    };
    var unbind = function unbind() {
        return matchMedia.current && matchMedia.current.removeEventListener("change", handleChange) && (matchMedia.current = null);
    };
    $7E7Dk.useEffect(function() {
        if (when) {
            matchMedia.current = window.matchMedia(query);
            setMatches(matchMedia.current.matches);
            bind();
        }
        return unbind;
    }, [
        query,
        when
    ]);
    return matches;
};
/* eslint-enable */ /**
 * Hook to merge properties including custom merge function for things like Tailwind merge.
 */ var $e264c7afc28f3ba9$export$9596428d77cc41ba = function useMergeProps() {
    var context = (0, $7E7Dk.useContext)((0, $eHYdO.PrimeReactContext));
    return function() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++)props[_key] = arguments[_key];
        return (0, $7nrKB.mergeProps)(props, context === null || context === void 0 ? void 0 : context.ptOptions);
    };
};
/* eslint-disable */ /**
 * Custom hook to run a mount effect only once.
 * @param {*} fn the callback function
 * @returns the hook
 */ var $e264c7afc28f3ba9$export$51c44cea289ac0f6 = function useMountEffect(fn) {
    var mounted = $7E7Dk.useRef(false);
    return $7E7Dk.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return fn && fn();
        }
    }, []);
};
/* eslint-enable */ function $e264c7afc28f3ba9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e264c7afc28f3ba9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e264c7afc28f3ba9$var$_typeof(o);
}
function $e264c7afc28f3ba9$var$toPrimitive(t, r) {
    if ("object" != $e264c7afc28f3ba9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e264c7afc28f3ba9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e264c7afc28f3ba9$var$toPropertyKey(t) {
    var i = $e264c7afc28f3ba9$var$toPrimitive(t, "string");
    return "symbol" == $e264c7afc28f3ba9$var$_typeof(i) ? i : i + "";
}
function $e264c7afc28f3ba9$var$_defineProperty(e, r, t) {
    return (r = $e264c7afc28f3ba9$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e264c7afc28f3ba9$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e264c7afc28f3ba9$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e264c7afc28f3ba9$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $e264c7afc28f3ba9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e264c7afc28f3ba9$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e264c7afc28f3ba9$export$70811b4970b0f258 = function useMouse() {
    var _React$useState = $7E7Dk.useState({
        x: 0,
        y: 0
    }), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), position = _React$useState2[0], setPosition = _React$useState2[1];
    var ref = $7E7Dk.useRef(null);
    var handleMouseMove = $7E7Dk.useCallback(function(event) {
        var x;
        var y;
        if (ref.current) {
            var rect = event.currentTarget.getBoundingClientRect();
            x = event.pageX - rect.left - (window.pageXOffset || window.scrollX);
            y = event.pageY - rect.top - (window.pageYOffset || window.scrollY);
        } else {
            x = event.clientX;
            y = event.clientY;
        }
        setPosition({
            x: Math.max(0, Math.round(x)),
            y: Math.max(0, Math.round(y))
        });
    }, []);
    var _useEventListener = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: ref,
        type: "mousemove",
        listener: handleMouseMove
    }), _useEventListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener, 2), bindMouseMoveEventListener = _useEventListener2[0], unbindMouseMoveEventListener = _useEventListener2[1];
    var _useEventListener3 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "mousemove",
        listener: handleMouseMove
    }), _useEventListener4 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener3, 2), bindDocumentMoveEventListener = _useEventListener4[0], unbindDocumentMoveEventListener = _useEventListener4[1];
    var reset = function reset() {
        return setPosition({
            x: 0,
            y: 0
        });
    };
    $7E7Dk.useEffect(function() {
        bindMouseMoveEventListener();
        if (!ref.current) bindDocumentMoveEventListener();
        return function() {
            unbindMouseMoveEventListener();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (!ref.current) unbindDocumentMoveEventListener();
        };
    }, [
        bindDocumentMoveEventListener,
        bindMouseMoveEventListener,
        unbindDocumentMoveEventListener,
        unbindMouseMoveEventListener
    ]);
    return $e264c7afc28f3ba9$var$_objectSpread$1($e264c7afc28f3ba9$var$_objectSpread$1({
        ref: ref
    }, position), {}, {
        reset: reset
    });
};
function $e264c7afc28f3ba9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e264c7afc28f3ba9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e264c7afc28f3ba9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e264c7afc28f3ba9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e264c7afc28f3ba9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e264c7afc28f3ba9$export$36da96379f79f245(_ref) {
    var _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "both" : _ref$mode, _ref$initialValue = _ref.initialValue, initialValue = _ref$initialValue === void 0 ? {
        x: 0,
        y: 0
    } : _ref$initialValue;
    var _React$useState = $7E7Dk.useState(initialValue), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), positions = _React$useState2[0], setPositions = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(false), _React$useState4 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState3, 2), active = _React$useState4[0], setActive = _React$useState4[1];
    var isMounted = $7E7Dk.useRef(false);
    var isSliding = $7E7Dk.useRef(false);
    var ref = $7E7Dk.useRef(null);
    var onMouseMove = function onMouseMove(event) {
        return updateMousePosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    var handlePositionChange = function handlePositionChange(_ref2) {
        var clampedX = _ref2.clampedX, clampedY = _ref2.clampedY;
        if (mode === "vertical") setPositions({
            y: 1 - clampedY
        });
        else if (mode === "horizontal") setPositions({
            x: clampedX
        });
        else if (mode === "both") setPositions({
            x: clampedX,
            y: clampedY
        });
    };
    var onMouseDown = function onMouseDown(event) {
        startScrubbing();
        event.preventDefault();
        onMouseMove(event);
    };
    var stopScrubbing = function stopScrubbing() {
        if (isSliding.current && isMounted.current) {
            isSliding.current = false;
            setActive(false);
            unbindListeners();
        }
    };
    var onTouchMove = function onTouchMove(event) {
        if (event.cancelable) event.preventDefault();
        updateMousePosition({
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        });
    };
    var onTouchStart = function onTouchStart(event) {
        if (event.cancelable) event.preventDefault();
        startScrubbing();
        onTouchMove(event);
    };
    var _useEventListener = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "mousemove",
        listener: onMouseMove
    }), _useEventListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "mouseup",
        listener: stopScrubbing
    }), _useEventListener4 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "touchmove",
        listener: onTouchMove
    }), _useEventListener6 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        type: "touchend",
        listener: stopScrubbing
    }), _useEventListener8 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _useEventListener9 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: ref,
        type: "mousedown",
        listener: onMouseDown
    }), _useEventListener10 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener9, 2), bindMouseDownListener = _useEventListener10[0], unbindMouseDownListener = _useEventListener10[1];
    var _useEventListener11 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: ref,
        type: "touchstart",
        listener: onTouchStart,
        options: {
            passive: false
        }
    }), _useEventListener12 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener11, 2), bindTouchStartListener = _useEventListener12[0], unbindTouchStartListener = _useEventListener12[1];
    var clamp = function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    var clampPositions = function clampPositions(_ref3) {
        var x = _ref3.x, y = _ref3.y;
        return {
            clampedX: clamp(x, 0, 1),
            clampedY: clamp(y, 0, 1)
        };
    };
    var bindListeners = function bindListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindListeners = function unbindListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var reset = function reset() {
        setPositions(initialValue);
    };
    $7E7Dk.useEffect(function() {
        isMounted.current = true;
    }, []);
    var startScrubbing = function startScrubbing() {
        if (!isSliding.current && isMounted.current) {
            isSliding.current = true;
            setActive(true);
            bindListeners();
        }
    };
    var updateMousePosition = function updateMousePosition(_ref4) {
        var x = _ref4.x, y = _ref4.y;
        if (isSliding.current) {
            var rect = ref.current.getBoundingClientRect();
            var _clampPositions = clampPositions({
                x: (x - rect.left) / rect.width,
                y: (y - rect.top) / rect.height
            }), clampedX = _clampPositions.clampedX, clampedY = _clampPositions.clampedY;
            handlePositionChange({
                clampedX: clampedX,
                clampedY: clampedY
            });
        }
    };
    $7E7Dk.useEffect(function() {
        if (ref.current) {
            bindMouseDownListener();
            bindTouchStartListener();
        }
        return function() {
            if (ref.current) {
                unbindMouseDownListener();
                unbindTouchStartListener();
            }
        };
    }, [
        bindMouseDownListener,
        bindTouchStartListener,
        positions,
        unbindMouseDownListener,
        unbindTouchStartListener
    ]);
    return $e264c7afc28f3ba9$var$_objectSpread($e264c7afc28f3ba9$var$_objectSpread({
        ref: ref
    }, positions), {}, {
        active: active,
        reset: reset
    });
}
var $e264c7afc28f3ba9$export$d04245b74d6bdcb8 = function useOverlayScrollListener(_ref) {
    var target = _ref.target, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var targetRef = $7E7Dk.useRef(null);
    var listenerRef = $7E7Dk.useRef(null);
    var scrollableParentsRef = $7E7Dk.useRef([]);
    var prevListener = $e264c7afc28f3ba9$export$5cae361ad82dce8b(listener);
    var prevOptions = $e264c7afc28f3ba9$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $7nrKB.DomHandler).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            var hideOnScroll = context ? context.hideOverlaysOnDocumentScrolling : (0, $eHYdO.default).hideOverlaysOnDocumentScrolling;
            var nodes = scrollableParentsRef.current = (0, $7nrKB.DomHandler).getScrollableParents(targetRef.current);
            // Ensure window/body is always included as fallback
            if (!nodes.some(function(node) {
                return node === document.body || node === window;
            })) nodes.push(hideOnScroll ? window : document.body);
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            nodes.forEach(function(node) {
                return node.addEventListener("scroll", listenerRef.current, options);
            });
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            var nodes = scrollableParentsRef.current;
            nodes.forEach(function(node) {
                return node.removeEventListener("scroll", listenerRef.current, options);
            });
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // #5927 prevent memory leak by releasing
        scrollableParentsRef.current = null;
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $7E7Dk.useCallback(function() {
        if (when) targetRef.current = (0, $7nrKB.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $7E7Dk.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $7E7Dk.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $e264c7afc28f3ba9$export$158eb97be50d41ef = function useResizeListener(_ref) {
    var listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: "window",
        type: "resize",
        listener: listener,
        when: when
    });
};
var $e264c7afc28f3ba9$export$2fef17345d27a5b4 = function useOverlayListener(_ref) {
    var target = _ref.target, overlay = _ref.overlay, _listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when, _ref$type = _ref.type, type = _ref$type === void 0 ? "click" : _ref$type;
    var targetRef = $7E7Dk.useRef(null);
    var overlayRef = $7E7Dk.useRef(null);
    /**
   * The parameters of the 'listener' method in the following event handlers;
   * @param {Event} event A click event of the document.
   * @param {string} options.type The custom type to detect event.
   * @param {boolean} options.valid It is controlled by PrimeReact. It is determined whether it is valid or not according to some custom validation.
   */ var _useEventListener = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: "window",
        type: type,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "outside",
                valid: event.which !== 3 && isOutsideClicked(event)
            });
        },
        when: when
    }), _useEventListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = $e264c7afc28f3ba9$export$158eb97be50d41ef({
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "resize",
                valid: !(0, $7nrKB.DomHandler).isTouchDevice()
            });
        },
        when: when
    }), _useResizeListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useEventListener3 = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: "window",
        type: "orientationchange",
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "orientationchange",
                valid: true
            });
        },
        when: when
    }), _useEventListener4 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener3, 2), bindWindowOrientationChangeListener = _useEventListener4[0], unbindWindowOrientationChangeListener = _useEventListener4[1];
    var _useOverlayScrollList = $e264c7afc28f3ba9$export$d04245b74d6bdcb8({
        target: target,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "scroll",
                valid: true
            });
        },
        when: when
    }), _useOverlayScrollList2 = $e264c7afc28f3ba9$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isOutsideClicked = function isOutsideClicked(event) {
        return targetRef.current && !(targetRef.current.isSameNode(event.target) || targetRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var bind = function bind() {
        bindDocumentClickListener();
        bindWindowResizeListener();
        bindWindowOrientationChangeListener();
        bindOverlayScrollListener();
    };
    var unbind = function unbind() {
        unbindDocumentClickListener();
        unbindWindowResizeListener();
        unbindWindowOrientationChangeListener();
        unbindOverlayScrollListener();
    };
    $7E7Dk.useEffect(function() {
        if (when) {
            targetRef.current = (0, $7nrKB.DomHandler).getTargetElement(target);
            overlayRef.current = (0, $7nrKB.DomHandler).getTargetElement(overlay);
        } else {
            unbind();
            targetRef.current = overlayRef.current = null;
        }
    }, [
        target,
        overlay,
        when
    ]);
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ /**
 * Hook to wrap around useState that stores the value in the browser local/session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local/session storage
 * @param {string} storage either 'local' or 'session' for what type of storage
 * @returns a stateful value, and a function to update it.
 */ var $e264c7afc28f3ba9$export$95809329f49ea9f9 = function useStorage(initialValue, key) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "local";
    // Since the local storage API isn't available in server-rendering environments,
    // we check that typeof window !== 'undefined' to make SSR and SSG work properly.
    var storageAvailable = typeof window !== "undefined";
    // subscribe to window storage event so changes in one tab to a stored value
    // are properly reflected in all tabs
    var _useEventListener = $e264c7afc28f3ba9$export$7080b3e976bc91ab({
        target: "window",
        type: "storage",
        listener: function listener(event) {
            var area = storage === "local" ? window.localStorage : window.sessionStorage;
            if (event.storageArea === area && event.key === key) {
                var newValue = event.newValue ? JSON.parse(event.newValue) : undefined;
                setStoredValue(newValue);
            }
        }
    }), _useEventListener2 = $e264c7afc28f3ba9$var$_slicedToArray(_useEventListener, 2), bindWindowStorageListener = _useEventListener2[0], unbindWindowStorageListener = _useEventListener2[1];
    var _React$useState = $7E7Dk.useState(initialValue), _React$useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_React$useState, 2), storedValue = _React$useState2[0], setStoredValue = _React$useState2[1];
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (storageAvailable) {
                var serializedValue = JSON.stringify(valueToStore);
                storage === "local" ? window.localStorage.setItem(key, serializedValue) : window.sessionStorage.setItem(key, serializedValue);
            }
        } catch (error) {
            throw new Error("PrimeReact useStorage: Failed to serialize the value at key: ".concat(key));
        }
    };
    $7E7Dk.useEffect(function() {
        if (!storageAvailable) setStoredValue(initialValue);
        try {
            var item = storage === "local" ? window.localStorage.getItem(key) : window.sessionStorage.getItem(key);
            setStoredValue(item ? JSON.parse(item) : initialValue);
        } catch (error) {
            // If error also return initialValue
            setStoredValue(initialValue);
        }
        bindWindowStorageListener();
        return function() {
            return unbindWindowStorageListener();
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
};
/**
 * Hook to wrap around useState that stores the value in the browser local storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local storage
 * @returns a stateful value, and a function to update it.
 */ var $e264c7afc28f3ba9$export$86e2cef2561044ac = function useLocalStorage(initialValue, key) {
    return $e264c7afc28f3ba9$export$95809329f49ea9f9(initialValue, key, "local");
};
/**
 * Hook to wrap around useState that stores the value in the browser session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in session storage
 * @returns a stateful value, and a function to update it.
 */ var $e264c7afc28f3ba9$export$864b6828bd07eda6 = function useSessionStorage(initialValue, key) {
    return $e264c7afc28f3ba9$export$95809329f49ea9f9(initialValue, key, "session");
};
/* eslint-enable */ var $e264c7afc28f3ba9$var$_id = 0;
var $e264c7afc28f3ba9$export$72c85e333541e7f = function useStyle(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _useState = (0, $7E7Dk.useState)(false), _useState2 = $e264c7afc28f3ba9$var$_slicedToArray(_useState, 2), isLoaded = _useState2[0], setIsLoaded = _useState2[1];
    var styleRef = (0, $7E7Dk.useRef)(null);
    var context = (0, $7E7Dk.useContext)((0, $eHYdO.PrimeReactContext));
    var defaultDocument = (0, $7nrKB.DomHandler).isClient() ? window.document : undefined;
    var _options$document = options.document, document1 = _options$document === void 0 ? defaultDocument : _options$document, _options$manual = options.manual, manual = _options$manual === void 0 ? false : _options$manual, _options$name = options.name, name = _options$name === void 0 ? "style_".concat(++$e264c7afc28f3ba9$var$_id) : _options$name, _options$id = options.id, id = _options$id === void 0 ? undefined : _options$id, _options$media = options.media, media = _options$media === void 0 ? undefined : _options$media;
    var getCurrentStyleRef = function getCurrentStyleRef(styleContainer) {
        var existingStyle = styleContainer.querySelector('style[data-primereact-style-id="'.concat(name, '"]'));
        if (existingStyle) return existingStyle;
        if (id !== undefined) {
            var existingElement = document1.getElementById(id);
            if (existingElement) return existingElement;
        }
        // finally if not found create the new style
        return document1.createElement("style");
    };
    var update = function update(newCSS) {
        isLoaded && css !== newCSS && (styleRef.current.textContent = newCSS);
    };
    var load = function load() {
        if (!document1 || isLoaded) return;
        var styleContainer = (context === null || context === void 0 ? void 0 : context.styleContainer) || document1.head;
        styleRef.current = getCurrentStyleRef(styleContainer);
        if (!styleRef.current.isConnected) {
            styleRef.current.type = "text/css";
            if (id) styleRef.current.id = id;
            if (media) styleRef.current.media = media;
            (0, $7nrKB.DomHandler).addNonce(styleRef.current, context && context.nonce || (0, $eHYdO.default).nonce);
            styleContainer.appendChild(styleRef.current);
            if (name) styleRef.current.setAttribute("data-primereact-style-id", name);
        }
        styleRef.current.textContent = css;
        setIsLoaded(true);
    };
    var unload = function unload() {
        if (!document1 || !styleRef.current) return;
        (0, $7nrKB.DomHandler).removeInlineStyle(styleRef.current);
        setIsLoaded(false);
    };
    (0, $7E7Dk.useEffect)(function() {
        if (!manual) load();
    // return () => {if (!manual) unload()}; /* @todo */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        manual
    ]);
    return {
        id: id,
        name: name,
        update: update,
        unload: unload,
        load: load,
        isLoaded: isLoaded
    };
};
/* eslint-disable */ var $e264c7afc28f3ba9$export$d8e6abf214c9ec0f = function useTimeout(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $7E7Dk.useRef(null);
    var savedCallback = $7E7Dk.useRef(null);
    var clear = $7E7Dk.useCallback(function() {
        return clearTimeout(timeout.current);
    }, [
        timeout.current
    ]);
    $7E7Dk.useEffect(function() {
        savedCallback.current = fn;
    });
    $7E7Dk.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setTimeout(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $e264c7afc28f3ba9$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ /* eslint-disable */ var $e264c7afc28f3ba9$export$496315a1608d9602 = function useUpdateEffect(fn, deps) {
    var mounted = $7E7Dk.useRef(false);
    return $7E7Dk.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        return fn && fn();
    }, deps);
};

});


parcelRegister("5B1eM", function(module, exports) {

$parcel$export(module.exports, "CSSTransition", function () { return $41315e26400b5370$export$a7a5590ad6d7af0; });

var $7E7Dk = parcelRequire("7E7Dk");

var $lbQIh = parcelRequire("lbQIh");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $eHYdO = parcelRequire("eHYdO");
"use client";
function $41315e26400b5370$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41315e26400b5370$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41315e26400b5370$var$_typeof(o);
}
function $41315e26400b5370$var$toPrimitive(t, r) {
    if ("object" != $41315e26400b5370$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41315e26400b5370$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $41315e26400b5370$var$toPropertyKey(t) {
    var i = $41315e26400b5370$var$toPrimitive(t, "string");
    return "symbol" == $41315e26400b5370$var$_typeof(i) ? i : i + "";
}
function $41315e26400b5370$var$_defineProperty(e, r, t) {
    return (r = $41315e26400b5370$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $41315e26400b5370$var$CSSTransitionBase = {
    defaultProps: {
        __TYPE: "CSSTransition",
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $7nrKB.ObjectUtils).getMergedProps(props, $41315e26400b5370$var$CSSTransitionBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $7nrKB.ObjectUtils).getDiffProps(props, $41315e26400b5370$var$CSSTransitionBase.defaultProps);
    }
};
function $41315e26400b5370$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41315e26400b5370$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41315e26400b5370$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41315e26400b5370$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41315e26400b5370$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $41315e26400b5370$export$a7a5590ad6d7af0 = /*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var props = $41315e26400b5370$var$CSSTransitionBase.getProps(inProps);
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var disabled = props.disabled || props.options && props.options.disabled || context && !context.cssTransition || !(0, $eHYdO.default).cssTransition;
    var onEnter = function onEnter(node, isAppearing) {
        props.onEnter && props.onEnter(node, isAppearing); // component
        props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
    };
    var onEntering = function onEntering(node, isAppearing) {
        props.onEntering && props.onEntering(node, isAppearing); // component
        props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
    };
    var onEntered = function onEntered(node, isAppearing) {
        props.onEntered && props.onEntered(node, isAppearing); // component
        props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
    };
    var onExit = function onExit(node) {
        props.onExit && props.onExit(node); // component
        props.options && props.options.onExit && props.options.onExit(node); // user option
    };
    var onExiting = function onExiting(node) {
        props.onExiting && props.onExiting(node); // component
        props.options && props.options.onExiting && props.options.onExiting(node); // user option
    };
    var onExited = function onExited(node) {
        props.onExited && props.onExited(node); // component
        props.options && props.options.onExited && props.options.onExited(node); // user option
    };
    (0, $jr5t3.useUpdateEffect)(function() {
        if (disabled) {
            // no animation
            var node = (0, $7nrKB.ObjectUtils).getRefElement(props.nodeRef);
            if (props["in"]) {
                onEnter(node, true);
                onEntering(node, true);
                onEntered(node, true);
            } else {
                onExit(node);
                onExiting(node);
                onExited(node);
            }
        }
    }, [
        props["in"]
    ]);
    if (disabled) return props["in"] ? props.children : null;
    var immutableProps = {
        nodeRef: props.nodeRef,
        "in": props["in"],
        appear: props.appear,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
    };
    var mutableProps = {
        classNames: props.classNames,
        timeout: props.timeout,
        unmountOnExit: props.unmountOnExit
    };
    var mergedProps = $41315e26400b5370$var$_objectSpread($41315e26400b5370$var$_objectSpread($41315e26400b5370$var$_objectSpread({}, mutableProps), props.options || {}), immutableProps);
    return /*#__PURE__*/ $7E7Dk.createElement((0, $lbQIh.default), mergedProps, props.children);
});
$41315e26400b5370$export$a7a5590ad6d7af0.displayName = "CSSTransition";

});
parcelRegister("lbQIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6d383c78e498344$export$2e2bcd8739ae039; });

var $GZIIz = parcelRequire("GZIIz");

var $cq2Uw = parcelRequire("cq2Uw");

var $lUyOW = parcelRequire("lUyOW");


var $6Aocj = parcelRequire("6Aocj");

var $2nla5 = parcelRequire("2nla5");

var $7E7Dk = parcelRequire("7E7Dk");

var $lOTXe = parcelRequire("lOTXe");


var $d73Bc = parcelRequire("d73Bc");
var $f6d383c78e498344$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $6Aocj.default)(node, c);
    });
};
var $f6d383c78e498344$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $2nla5.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f6d383c78e498344$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $lUyOW.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $d73Bc.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f6d383c78e498344$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f6d383c78e498344$var$removeClass(node, baseClassName);
        if (activeClassName) $f6d383c78e498344$var$removeClass(node, activeClassName);
        if (doneClassName) $f6d383c78e498344$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cq2Uw.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lOTXe.default), (0, $GZIIz.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Component);
$f6d383c78e498344$var$CSSTransition.defaultProps = {
    classNames: ""
};
$f6d383c78e498344$var$CSSTransition.propTypes = {};
var $f6d383c78e498344$export$2e2bcd8739ae039 = $f6d383c78e498344$var$CSSTransition;

});
parcelRegister("6Aocj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb8e002ae303b7c$export$2e2bcd8739ae039; });

var $lfazf = parcelRequire("lfazf");
function $4cb8e002ae303b7c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $lfazf.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("lfazf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03fdba9da5316eaf$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $03fdba9da5316eaf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("2nla5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bae25094803289c$export$2e2bcd8739ae039; });
function $1bae25094803289c$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $1bae25094803289c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $1bae25094803289c$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $1bae25094803289c$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("lOTXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe29abdbc9d1f30e$export$2e2bcd8739ae039; });

var $cq2Uw = parcelRequire("cq2Uw");

var $lUyOW = parcelRequire("lUyOW");


var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $aevdU = parcelRequire("aevdU");


var $cKH92 = parcelRequire("cKH92");

var $d73Bc = parcelRequire("d73Bc");
var $fe29abdbc9d1f30e$export$bb38bb9a1161268 = "unmounted";
var $fe29abdbc9d1f30e$export$84cbff306f539230 = "exited";
var $fe29abdbc9d1f30e$export$df38205c966be359 = "entering";
var $fe29abdbc9d1f30e$export$78e9e6e3e014d60a = "entered";
var $fe29abdbc9d1f30e$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $fe29abdbc9d1f30e$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $lUyOW.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $fe29abdbc9d1f30e$export$84cbff306f539230;
                _this.appearStatus = $fe29abdbc9d1f30e$export$df38205c966be359;
            } else initialStatus = $fe29abdbc9d1f30e$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $fe29abdbc9d1f30e$export$bb38bb9a1161268;
        else initialStatus = $fe29abdbc9d1f30e$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $fe29abdbc9d1f30e$export$bb38bb9a1161268) return {
            status: $fe29abdbc9d1f30e$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $fe29abdbc9d1f30e$export$df38205c966be359 && status !== $fe29abdbc9d1f30e$export$78e9e6e3e014d60a) nextStatus = $fe29abdbc9d1f30e$export$df38205c966be359;
            } else if (status === $fe29abdbc9d1f30e$export$df38205c966be359 || status === $fe29abdbc9d1f30e$export$78e9e6e3e014d60a) nextStatus = $fe29abdbc9d1f30e$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $fe29abdbc9d1f30e$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hzbSh))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $d73Bc.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $fe29abdbc9d1f30e$export$84cbff306f539230) this.setState({
            status: $fe29abdbc9d1f30e$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($hzbSh))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $aevdU.default).disabled) {
            this.safeSetState({
                status: $fe29abdbc9d1f30e$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $fe29abdbc9d1f30e$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $fe29abdbc9d1f30e$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($hzbSh))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $aevdU.default).disabled) {
            this.safeSetState({
                status: $fe29abdbc9d1f30e$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $fe29abdbc9d1f30e$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $fe29abdbc9d1f30e$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hzbSh))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $fe29abdbc9d1f30e$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cq2Uw.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cKH92.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Component);
$fe29abdbc9d1f30e$var$Transition.contextType = (0, $cKH92.default);
$fe29abdbc9d1f30e$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $fe29abdbc9d1f30e$var$noop() {}
$fe29abdbc9d1f30e$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $fe29abdbc9d1f30e$var$noop,
    onEntering: $fe29abdbc9d1f30e$var$noop,
    onEntered: $fe29abdbc9d1f30e$var$noop,
    onExit: $fe29abdbc9d1f30e$var$noop,
    onExiting: $fe29abdbc9d1f30e$var$noop,
    onExited: $fe29abdbc9d1f30e$var$noop
};
$fe29abdbc9d1f30e$var$Transition.UNMOUNTED = $fe29abdbc9d1f30e$export$bb38bb9a1161268;
$fe29abdbc9d1f30e$var$Transition.EXITED = $fe29abdbc9d1f30e$export$84cbff306f539230;
$fe29abdbc9d1f30e$var$Transition.ENTERING = $fe29abdbc9d1f30e$export$df38205c966be359;
$fe29abdbc9d1f30e$var$Transition.ENTERED = $fe29abdbc9d1f30e$export$78e9e6e3e014d60a;
$fe29abdbc9d1f30e$var$Transition.EXITING = $fe29abdbc9d1f30e$export$4aacc83d4d59139f;
var $fe29abdbc9d1f30e$export$2e2bcd8739ae039 = $fe29abdbc9d1f30e$var$Transition;

});
parcelRegister("aevdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77336e7b2bec555d$export$2e2bcd8739ae039; });
var $77336e7b2bec555d$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("d73Bc", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $98beb877ef4fa164$export$7d26bbb1236dafd6; });
var $98beb877ef4fa164$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});




parcelRegister("ingJg", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $d6075a07af190e9c$export$602eac185826482c; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $eHYdO = parcelRequire("eHYdO");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $d6075a07af190e9c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $d6075a07af190e9c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d6075a07af190e9c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d6075a07af190e9c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d6075a07af190e9c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d6075a07af190e9c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d6075a07af190e9c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d6075a07af190e9c$var$_slicedToArray(r, e) {
    return $d6075a07af190e9c$var$_arrayWithHoles(r) || $d6075a07af190e9c$var$_iterableToArrayLimit(r, e) || $d6075a07af190e9c$var$_unsupportedIterableToArray(r, e) || $d6075a07af190e9c$var$_nonIterableRest();
}
var $d6075a07af190e9c$var$PortalBase = {
    defaultProps: {
        __TYPE: "Portal",
        element: null,
        appendTo: null,
        visible: false,
        onMounted: null,
        onUnmounted: null,
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $7nrKB.ObjectUtils).getMergedProps(props, $d6075a07af190e9c$var$PortalBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $7nrKB.ObjectUtils).getDiffProps(props, $d6075a07af190e9c$var$PortalBase.defaultProps);
    }
};
var $d6075a07af190e9c$export$602eac185826482c = /*#__PURE__*/ $7E7Dk.memo(function(inProps) {
    var props = $d6075a07af190e9c$var$PortalBase.getProps(inProps);
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var _React$useState = $7E7Dk.useState(props.visible && (0, $7nrKB.DomHandler).isClient()), _React$useState2 = $d6075a07af190e9c$var$_slicedToArray(_React$useState, 2), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    (0, $jr5t3.useMountEffect)(function() {
        if ((0, $7nrKB.DomHandler).isClient() && !mountedState) {
            setMountedState(true);
            props.onMounted && props.onMounted();
        }
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        props.onMounted && props.onMounted();
    }, [
        mountedState
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        props.onUnmounted && props.onUnmounted();
    });
    var element = props.element || props.children;
    if (element && mountedState) {
        var appendTo = props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo;
        if ((0, $7nrKB.ObjectUtils).isFunction(appendTo)) appendTo = appendTo();
        if (!appendTo) appendTo = document.body;
        return appendTo === "self" ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hzbSh))).createPortal(element, appendTo);
    }
    return null;
});
$d6075a07af190e9c$export$602eac185826482c.displayName = "Portal";

});

parcelRegister("eXeTx", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", function () { return $ae32212552f40db4$export$7dd004358974b05d; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $ae32212552f40db4$var$_extends() {
    return $ae32212552f40db4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ae32212552f40db4$var$_extends.apply(null, arguments);
}
var $ae32212552f40db4$export$7dd004358974b05d = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $ae32212552f40db4$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
        fill: "currentColor"
    }));
}));
$ae32212552f40db4$export$7dd004358974b05d.displayName = "CheckIcon";

});
parcelRegister("dbTKA", function(module, exports) {

$parcel$export(module.exports, "IconBase", function () { return $99a78c4ad37e3e29$export$a188ecdd443fe91a; });

var $7nrKB = parcelRequire("7nrKB");
"use client";
var $99a78c4ad37e3e29$export$a188ecdd443fe91a = {
    defaultProps: {
        __TYPE: "IconBase",
        className: null,
        label: null,
        spin: false
    },
    getProps: function getProps(props) {
        return (0, $7nrKB.ObjectUtils).getMergedProps(props, $99a78c4ad37e3e29$export$a188ecdd443fe91a.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $7nrKB.ObjectUtils).getDiffProps(props, $99a78c4ad37e3e29$export$a188ecdd443fe91a.defaultProps);
    },
    getPTI: function getPTI(props) {
        var isLabelEmpty = (0, $7nrKB.ObjectUtils).isEmpty(props.label);
        var otherProps = $99a78c4ad37e3e29$export$a188ecdd443fe91a.getOtherProps(props);
        var ptiProps = {
            className: (0, $7nrKB.classNames)("p-icon", {
                "p-icon-spin": props.spin
            }, props.className),
            role: !isLabelEmpty ? "img" : undefined,
            "aria-label": !isLabelEmpty ? props.label : undefined,
            "aria-hidden": props.label ? isLabelEmpty : undefined
        };
        return (0, $7nrKB.ObjectUtils).getMergedProps(otherProps, ptiProps);
    }
};

});


parcelRegister("dgIaN", function(module, exports) {

$parcel$export(module.exports, "ExclamationTriangleIcon", function () { return $9a8f08d3de446047$export$b409b230b61d4724; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $9a8f08d3de446047$var$_extends() {
    return $9a8f08d3de446047$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9a8f08d3de446047$var$_extends.apply(null, arguments);
}
var $9a8f08d3de446047$export$b409b230b61d4724 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $9a8f08d3de446047$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M13.4018 13.1893H0.598161C0.49329 13.189 0.390283 13.1615 0.299143 13.1097C0.208003 13.0578 0.131826 12.9832 0.0780112 12.8932C0.0268539 12.8015 0 12.6982 0 12.5931C0 12.4881 0.0268539 12.3848 0.0780112 12.293L6.47985 1.08982C6.53679 1.00399 6.61408 0.933574 6.70484 0.884867C6.7956 0.836159 6.897 0.810669 7 0.810669C7.103 0.810669 7.2044 0.836159 7.29516 0.884867C7.38592 0.933574 7.46321 1.00399 7.52015 1.08982L13.922 12.293C13.9731 12.3848 14 12.4881 14 12.5931C14 12.6982 13.9731 12.8015 13.922 12.8932C13.8682 12.9832 13.792 13.0578 13.7009 13.1097C13.6097 13.1615 13.5067 13.189 13.4018 13.1893ZM1.63046 11.989H12.3695L7 2.59425L1.63046 11.989Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M6.99996 8.78801C6.84143 8.78594 6.68997 8.72204 6.57787 8.60993C6.46576 8.49782 6.40186 8.34637 6.39979 8.18784V5.38703C6.39979 5.22786 6.46302 5.0752 6.57557 4.96265C6.68813 4.85009 6.84078 4.78686 6.99996 4.78686C7.15914 4.78686 7.31179 4.85009 7.42435 4.96265C7.5369 5.0752 7.60013 5.22786 7.60013 5.38703V8.18784C7.59806 8.34637 7.53416 8.49782 7.42205 8.60993C7.30995 8.72204 7.15849 8.78594 6.99996 8.78801Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M6.99996 11.1887C6.84143 11.1866 6.68997 11.1227 6.57787 11.0106C6.46576 10.8985 6.40186 10.7471 6.39979 10.5885V10.1884C6.39979 10.0292 6.46302 9.87658 6.57557 9.76403C6.68813 9.65147 6.84078 9.58824 6.99996 9.58824C7.15914 9.58824 7.31179 9.65147 7.42435 9.76403C7.5369 9.87658 7.60013 10.0292 7.60013 10.1884V10.5885C7.59806 10.7471 7.53416 10.8985 7.42205 11.0106C7.30995 11.1227 7.15849 11.1866 6.99996 11.1887Z",
        fill: "currentColor"
    }));
}));
$9a8f08d3de446047$export$b409b230b61d4724.displayName = "ExclamationTriangleIcon";

});

parcelRegister("8Murc", function(module, exports) {

$parcel$export(module.exports, "InfoCircleIcon", function () { return $664a6ab1f4a6c08f$export$235e99e4cce237dc; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $664a6ab1f4a6c08f$var$_extends() {
    return $664a6ab1f4a6c08f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $664a6ab1f4a6c08f$var$_extends.apply(null, arguments);
}
var $664a6ab1f4a6c08f$export$235e99e4cce237dc = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $664a6ab1f4a6c08f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z",
        fill: "currentColor"
    }));
}));
$664a6ab1f4a6c08f$export$235e99e4cce237dc.displayName = "InfoCircleIcon";

});

parcelRegister("2v3zC", function(module, exports) {

$parcel$export(module.exports, "TimesIcon", function () { return $1d213faa980b4703$export$32edebbf2d9136cc; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $1d213faa980b4703$var$_extends() {
    return $1d213faa980b4703$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d213faa980b4703$var$_extends.apply(null, arguments);
}
var $1d213faa980b4703$export$32edebbf2d9136cc = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $1d213faa980b4703$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
        fill: "currentColor"
    }));
}));
$1d213faa980b4703$export$32edebbf2d9136cc.displayName = "TimesIcon";

});

parcelRegister("f6Dhj", function(module, exports) {

$parcel$export(module.exports, "TimesCircleIcon", function () { return $aff5e2645fe74aa3$export$4236c899190094ee; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $aff5e2645fe74aa3$var$_extends() {
    return $aff5e2645fe74aa3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aff5e2645fe74aa3$var$_extends.apply(null, arguments);
}
var $aff5e2645fe74aa3$export$4236c899190094ee = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $aff5e2645fe74aa3$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667ZM4.66662 9.91668C4.58998 9.91704 4.51404 9.90209 4.44325 9.87271C4.37246 9.84333 4.30826 9.8001 4.2544 9.74557C4.14516 9.6362 4.0838 9.48793 4.0838 9.33335C4.0838 9.17876 4.14516 9.0305 4.2544 8.92113L6.17553 7L4.25443 5.07891C4.15139 4.96832 4.09529 4.82207 4.09796 4.67094C4.10063 4.51982 4.16185 4.37563 4.26872 4.26876C4.3756 4.16188 4.51979 4.10066 4.67091 4.09799C4.82204 4.09532 4.96829 4.15142 5.07887 4.25446L6.99997 6.17556L8.92106 4.25446C9.03164 4.15142 9.1779 4.09532 9.32903 4.09799C9.48015 4.10066 9.62434 4.16188 9.73121 4.26876C9.83809 4.37563 9.89931 4.51982 9.90198 4.67094C9.90464 4.82207 9.84855 4.96832 9.74551 5.07891L7.82441 7L9.74554 8.92113C9.85478 9.0305 9.91614 9.17876 9.91614 9.33335C9.91614 9.48793 9.85478 9.6362 9.74554 9.74557C9.69168 9.8001 9.62748 9.84333 9.55669 9.87271C9.4859 9.90209 9.40996 9.91704 9.33332 9.91668C9.25668 9.91704 9.18073 9.90209 9.10995 9.87271C9.03916 9.84333 8.97495 9.8001 8.9211 9.74557L6.99997 7.82444L5.07884 9.74557C5.02499 9.8001 4.96078 9.84333 4.88999 9.87271C4.81921 9.90209 4.74326 9.91704 4.66662 9.91668Z",
        fill: "currentColor"
    }));
}));
$aff5e2645fe74aa3$export$4236c899190094ee.displayName = "TimesCircleIcon";

});

parcelRegister("1PxL0", function(module, exports) {

$parcel$export(module.exports, "Ripple", function () { return $1554bd51180e577e$export$9e9146f7e027fdaa; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $kHEnT = parcelRequire("kHEnT");
"use client";
function $1554bd51180e577e$var$_extends() {
    return $1554bd51180e577e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1554bd51180e577e$var$_extends.apply(null, arguments);
}
function $1554bd51180e577e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1554bd51180e577e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1554bd51180e577e$var$_typeof(o);
}
function $1554bd51180e577e$var$toPrimitive(t, r) {
    if ("object" != $1554bd51180e577e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1554bd51180e577e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1554bd51180e577e$var$toPropertyKey(t) {
    var i = $1554bd51180e577e$var$toPrimitive(t, "string");
    return "symbol" == $1554bd51180e577e$var$_typeof(i) ? i : i + "";
}
function $1554bd51180e577e$var$_defineProperty(e, r, t) {
    return (r = $1554bd51180e577e$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1554bd51180e577e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $1554bd51180e577e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1554bd51180e577e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1554bd51180e577e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1554bd51180e577e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1554bd51180e577e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1554bd51180e577e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1554bd51180e577e$var$_slicedToArray(r, e) {
    return $1554bd51180e577e$var$_arrayWithHoles(r) || $1554bd51180e577e$var$_iterableToArrayLimit(r, e) || $1554bd51180e577e$var$_unsupportedIterableToArray(r, e) || $1554bd51180e577e$var$_nonIterableRest();
}
var $1554bd51180e577e$var$styles = "\n@layer primereact {\n    .p-ripple {\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-ink {\n        display: block;\n        position: absolute;\n        background: rgba(255, 255, 255, 0.5);\n        border-radius: 100%;\n        transform: scale(0);\n    }\n    \n    .p-ink-active {\n        animation: ripple 0.4s linear;\n    }\n    \n    .p-ripple-disabled .p-ink {\n        display: none;\n    }\n}\n\n@keyframes ripple {\n    100% {\n        opacity: 0;\n        transform: scale(2.5);\n    }\n}\n\n";
var $1554bd51180e577e$var$classes = {
    root: "p-ink"
};
var $1554bd51180e577e$var$RippleBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Ripple",
        children: undefined
    },
    css: {
        styles: $1554bd51180e577e$var$styles,
        classes: $1554bd51180e577e$var$classes
    },
    getProps: function getProps(props) {
        return (0, $7nrKB.ObjectUtils).getMergedProps(props, $1554bd51180e577e$var$RippleBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $7nrKB.ObjectUtils).getDiffProps(props, $1554bd51180e577e$var$RippleBase.defaultProps);
    }
});
function $1554bd51180e577e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1554bd51180e577e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1554bd51180e577e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1554bd51180e577e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1554bd51180e577e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1554bd51180e577e$export$9e9146f7e027fdaa = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $1554bd51180e577e$var$_slicedToArray(_React$useState, 2), isMounted = _React$useState2[0], setMounted = _React$useState2[1];
    var inkRef = $7E7Dk.useRef(null);
    var targetRef = $7E7Dk.useRef(null);
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $1554bd51180e577e$var$RippleBase.getProps(inProps, context);
    var isRippleActive = context && context.ripple || (0, $eHYdO.default).ripple;
    var metaData = {
        props: props
    };
    (0, $jr5t3.useStyle)($1554bd51180e577e$var$RippleBase.css.styles, {
        name: "ripple",
        manual: !isRippleActive
    });
    var _RippleBase$setMetaDa = $1554bd51180e577e$var$RippleBase.setMetaData($1554bd51180e577e$var$_objectSpread({}, metaData)), ptm = _RippleBase$setMetaDa.ptm, cx = _RippleBase$setMetaDa.cx;
    var getTarget = function getTarget() {
        return inkRef.current && inkRef.current.parentElement;
    };
    var bindEvents = function bindEvents() {
        if (targetRef.current) targetRef.current.addEventListener("pointerdown", onPointerDown);
    };
    var unbindEvents = function unbindEvents() {
        if (targetRef.current) targetRef.current.removeEventListener("pointerdown", onPointerDown);
    };
    var onPointerDown = function onPointerDown(event) {
        var offset = (0, $7nrKB.DomHandler).getOffset(targetRef.current);
        var offsetX = event.pageX - offset.left + document.body.scrollTop - (0, $7nrKB.DomHandler).getWidth(inkRef.current) / 2;
        var offsetY = event.pageY - offset.top + document.body.scrollLeft - (0, $7nrKB.DomHandler).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var activateRipple = function activateRipple(offsetX, offsetY) {
        if (!inkRef.current || getComputedStyle(inkRef.current, null).display === "none") return;
        (0, $7nrKB.DomHandler).removeClass(inkRef.current, "p-ink-active");
        setDimensions();
        inkRef.current.style.top = offsetY + "px";
        inkRef.current.style.left = offsetX + "px";
        (0, $7nrKB.DomHandler).addClass(inkRef.current, "p-ink-active");
    };
    var onAnimationEnd = function onAnimationEnd(event) {
        (0, $7nrKB.DomHandler).removeClass(event.currentTarget, "p-ink-active");
    };
    var setDimensions = function setDimensions() {
        if (inkRef.current && !(0, $7nrKB.DomHandler).getHeight(inkRef.current) && !(0, $7nrKB.DomHandler).getWidth(inkRef.current)) {
            var d = Math.max((0, $7nrKB.DomHandler).getOuterWidth(targetRef.current), (0, $7nrKB.DomHandler).getOuterHeight(targetRef.current));
            inkRef.current.style.height = d + "px";
            inkRef.current.style.width = d + "px";
        }
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return inkRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $jr5t3.useMountEffect)(function() {
        // for App Router in Next.js ^14
        setMounted(true);
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        if (isMounted && inkRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    }, [
        isMounted
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (inkRef.current && !targetRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        if (inkRef.current) {
            targetRef.current = null;
            unbindEvents();
        }
    });
    if (!isRippleActive) return null;
    var rootProps = mergeProps({
        "aria-hidden": true,
        className: (0, $7nrKB.classNames)(cx("root"))
    }, $1554bd51180e577e$var$RippleBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement("span", $1554bd51180e577e$var$_extends({
        role: "presentation",
        ref: inkRef
    }, rootProps, {
        onAnimationEnd: onAnimationEnd
    }));
}));
$1554bd51180e577e$export$9e9146f7e027fdaa.displayName = "Ripple";

});




parcelRegister("jMvuK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e66aee4455003f7a$var$ReactIs, $e66aee4455003f7a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("flolC"))();

});
parcelRegister("flolC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $379Xa = parcelRequire("379Xa");
function $b2bbb4227636182c$var$emptyFunction() {}
function $b2bbb4227636182c$var$emptyFunctionWithReset() {}
$b2bbb4227636182c$var$emptyFunctionWithReset.resetWarningCache = $b2bbb4227636182c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $379Xa) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b2bbb4227636182c$var$emptyFunctionWithReset,
        resetWarningCache: $b2bbb4227636182c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("379Xa", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $2449bf0f26306474$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $2449bf0f26306474$var$ReactPropTypesSecret;

});



parcelRegister("9p3YO", function(module, exports) {
$parcel$export(module.exports, "confirm", function () { return (parcelRequire("iguOG")).confirm; });
$parcel$export(module.exports, "ConfirmDialog", function () { return (parcelRequire("iguOG")).ConfirmDialog; });
parcelRequire("iguOG");

});
parcelRegister("iguOG", function(module, exports) {

$parcel$export(module.exports, "confirm", function () { return $4e189cf4d22b0f2a$export$715f9d76bb8c1fea; });
$parcel$export(module.exports, "ConfirmDialog", function () { return $4e189cf4d22b0f2a$export$2cc85109a937009e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $c9GjL = parcelRequire("c9GjL");

var $56EgM = parcelRequire("56EgM");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("MMfqT");
var $eySth = parcelRequire("eySth");
const $4e189cf4d22b0f2a$var$ConfirmationFooter = ({ options: options, checkboxLabel: checkboxLabel })=>{
    const text = (0, $5u6k9.default)();
    const checkboxId = (0, $7E7Dk.useId)();
    const [checked, setChecked] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
        inputId: checkboxId,
        checked: checked,
        onChange: (event)=>setChecked(!!event.checked)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: checkboxId,
        className: "mb-0"
    }, checkboxLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("lblNo"),
        text: true,
        autoFocus: options.props.defaultFocus === "reject",
        onClick: ()=>options.reject()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnYes"),
        className: options.acceptClassName,
        autoFocus: options.props.defaultFocus === "accept",
        disabled: !checked,
        onClick: ()=>options.accept()
    })));
};
const $4e189cf4d22b0f2a$export$715f9d76bb8c1fea = ({ header: header, message: message, variant: variant = "normal", checkboxLabel: checkboxLabel })=>new Promise((resolve)=>{
        (0, $c9GjL.confirmDialog)({
            message: message,
            header: header,
            icon: variant === "danger" ? "pi pi-exclamation-triangle" : undefined,
            acceptClassName: variant === "danger" ? "p-button-danger" : "",
            defaultFocus: variant === "danger" ? "reject" : "accept",
            accept: ()=>resolve(true),
            reject: ()=>resolve(false),
            onHide: ()=>resolve(false),
            footer: checkboxLabel !== undefined ? (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($4e189cf4d22b0f2a$var$ConfirmationFooter, {
                    options: options,
                    checkboxLabel: checkboxLabel
                }) : undefined
        });
    });
const $4e189cf4d22b0f2a$export$2cc85109a937009e = ({ testId: testId = "confirm-dialog", className: className, style: style, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c9GjL.ConfirmDialog), {
        ...(0, $eySth.defaultDialogProps),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        "data-testid": testId,
        style: {
            ...(0, $eySth.defaultDialogProps).style,
            ...style
        },
        resizable: false,
        ...props
    });

});
parcelRegister("76MyM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("c9GjL", function(module, exports) {

$parcel$export(module.exports, "confirmDialog", function () { return $8d9726b4731347bf$export$8f50df58f957fd19; });
$parcel$export(module.exports, "ConfirmDialog", function () { return $8d9726b4731347bf$export$2cc85109a937009e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $1ot1u = parcelRequire("1ot1u");

var $kHEnT = parcelRequire("kHEnT");

var $h8dgv = parcelRequire("h8dgv");

var $jr5t3 = parcelRequire("jr5t3");

var $hB9Eg = parcelRequire("hB9Eg");

var $ingJg = parcelRequire("ingJg");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $8d9726b4731347bf$var$_extends() {
    return $8d9726b4731347bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8d9726b4731347bf$var$_extends.apply(null, arguments);
}
function $8d9726b4731347bf$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $8d9726b4731347bf$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8d9726b4731347bf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8d9726b4731347bf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8d9726b4731347bf$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8d9726b4731347bf$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8d9726b4731347bf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8d9726b4731347bf$var$_slicedToArray(r, e) {
    return $8d9726b4731347bf$var$_arrayWithHoles(r) || $8d9726b4731347bf$var$_iterableToArrayLimit(r, e) || $8d9726b4731347bf$var$_unsupportedIterableToArray(r, e) || $8d9726b4731347bf$var$_nonIterableRest();
}
function $8d9726b4731347bf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8d9726b4731347bf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8d9726b4731347bf$var$_typeof(o);
}
function $8d9726b4731347bf$var$toPrimitive(t, r) {
    if ("object" != $8d9726b4731347bf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8d9726b4731347bf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8d9726b4731347bf$var$toPropertyKey(t) {
    var i = $8d9726b4731347bf$var$toPrimitive(t, "string");
    return "symbol" == $8d9726b4731347bf$var$_typeof(i) ? i : i + "";
}
function $8d9726b4731347bf$var$_defineProperty(e, r, t) {
    return (r = $8d9726b4731347bf$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $8d9726b4731347bf$var$classes = {
    root: "p-confirm-dialog",
    message: "p-confirm-dialog-message",
    icon: "p-confirm-dialog-icon",
    acceptButton: "p-confirm-dialog-accept",
    rejectButton: function rejectButton(_ref) {
        var getPropValue = _ref.getPropValue;
        return (0, $7nrKB.classNames)("p-confirm-dialog-reject", {
            "p-button-text": !getPropValue("rejectClassName")
        });
    }
};
var $8d9726b4731347bf$var$ConfirmDialogBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "ConfirmDialog",
        accept: null,
        acceptClassName: null,
        acceptIcon: null,
        acceptLabel: null,
        appendTo: null,
        breakpoints: null,
        children: undefined,
        className: null,
        content: null,
        defaultFocus: "accept",
        footer: null,
        icon: null,
        message: null,
        onHide: null,
        reject: null,
        rejectClassName: null,
        rejectIcon: null,
        rejectLabel: null,
        tagKey: undefined,
        visible: undefined
    },
    css: {
        classes: $8d9726b4731347bf$var$classes
    }
});
function $8d9726b4731347bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d9726b4731347bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d9726b4731347bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8d9726b4731347bf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d9726b4731347bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d9726b4731347bf$export$8f50df58f957fd19 = function confirmDialog() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    props = $8d9726b4731347bf$var$_objectSpread($8d9726b4731347bf$var$_objectSpread({}, props), {
        visible: props.visible === undefined ? true : props.visible
    });
    props.visible && (0, $hB9Eg.OverlayService).emit("confirm-dialog", props);
    var show = function show() {
        var updatedProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $hB9Eg.OverlayService).emit("confirm-dialog", $8d9726b4731347bf$var$_objectSpread($8d9726b4731347bf$var$_objectSpread($8d9726b4731347bf$var$_objectSpread({}, props), updatedProps), {
            visible: true
        }));
    };
    var hide = function hide() {
        (0, $hB9Eg.OverlayService).emit("confirm-dialog", {
            visible: false
        });
    };
    return {
        show: show,
        hide: hide
    };
};
var $8d9726b4731347bf$export$2cc85109a937009e = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $8d9726b4731347bf$var$ConfirmDialogBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(props.visible), _React$useState2 = $8d9726b4731347bf$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(false), _React$useState4 = $8d9726b4731347bf$var$_slicedToArray(_React$useState3, 2), reshowState = _React$useState4[0], setReshowState = _React$useState4[1];
    var confirmProps = $7E7Dk.useRef(null);
    var isCallbackExecuting = $7E7Dk.useRef(false);
    var focusElementOnHide = $7E7Dk.useRef(null);
    var getCurrentProps = function getCurrentProps() {
        var group = props.group;
        if (confirmProps.current) group = confirmProps.current.group;
        return Object.assign({}, props, confirmProps.current, {
            group: group
        });
    };
    var getPropValue = function getPropValue(key) {
        return getCurrentProps()[key];
    };
    var callbackFromProp = function callbackFromProp(key) {
        for(var _len = arguments.length, param = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)param[_key - 1] = arguments[_key];
        return (0, $7nrKB.ObjectUtils).getPropValue(getPropValue(key), param);
    };
    var acceptLabel = getPropValue("acceptLabel") || (0, $eHYdO.localeOption)("accept");
    var rejectLabel = getPropValue("rejectLabel") || (0, $eHYdO.localeOption)("reject");
    var metaData = {
        props: props,
        state: {
            visible: visibleState
        }
    };
    var _ConfirmDialogBase$se = $8d9726b4731347bf$var$ConfirmDialogBase.setMetaData(metaData), ptm = _ConfirmDialogBase$se.ptm, cx = _ConfirmDialogBase$se.cx, isUnstyled = _ConfirmDialogBase$se.isUnstyled;
    (0, $kHEnT.useHandleStyle)($8d9726b4731347bf$var$ConfirmDialogBase.css.styles, isUnstyled, {
        name: "confirmdialog"
    });
    var accept = function accept() {
        if (!isCallbackExecuting.current) {
            isCallbackExecuting.current = true;
            callbackFromProp("accept");
            hide("accept");
        }
    };
    var reject = function reject() {
        if (!isCallbackExecuting.current) {
            isCallbackExecuting.current = true;
            callbackFromProp("reject");
            hide("reject");
        }
    };
    var show = function show() {
        var currentProps = getCurrentProps();
        if (currentProps.group === props.group) {
            setVisibleState(true);
            isCallbackExecuting.current = false;
            // Remember the focused element before we opened the dialog
            // so we can return focus to it once we close the dialog.
            focusElementOnHide.current = document.activeElement;
        }
    };
    var hide = function hide() {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cancel";
        if (visibleState) {
            if (typeof result !== "string") result = "cancel";
            setVisibleState(false);
            callbackFromProp("onHide", result);
            (0, $7nrKB.DomHandler).focus(focusElementOnHide.current);
            focusElementOnHide.current = null;
        }
    };
    var confirm = function confirm(updatedProps) {
        if (updatedProps.tagKey === props.tagKey) {
            var isVisibleChanged = visibleState !== updatedProps.visible;
            var targetChanged = getPropValue("target") !== updatedProps.target;
            if (targetChanged && !props.target) {
                hide();
                confirmProps.current = updatedProps;
                setReshowState(true);
            } else if (isVisibleChanged) {
                confirmProps.current = updatedProps;
                updatedProps.visible ? show() : hide();
            }
        }
    };
    $7E7Dk.useEffect(function() {
        props.visible ? show() : hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.visible
    ]);
    $7E7Dk.useEffect(function() {
        if (!props.target && !props.message) (0, $hB9Eg.OverlayService).on("confirm-dialog", confirm);
        return function() {
            (0, $hB9Eg.OverlayService).off("confirm-dialog", confirm);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.target
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        reshowState && show();
    }, [
        reshowState
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        (0, $hB9Eg.OverlayService).off("confirm-dialog", confirm);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            confirm: confirm
        };
    });
    var createFooter = function createFooter() {
        var defaultFocus = getPropValue("defaultFocus");
        var acceptClassName = (0, $7nrKB.classNames)("p-confirm-dialog-accept", getPropValue("acceptClassName"));
        var rejectClassName = (0, $7nrKB.classNames)("p-confirm-dialog-reject", {
            "p-button-text": !getPropValue("rejectClassName")
        }, getPropValue("rejectClassName"));
        var rejectButtonProps = mergeProps({
            label: rejectLabel,
            autoFocus: defaultFocus === "reject",
            icon: getPropValue("rejectIcon"),
            className: (0, $7nrKB.classNames)(getPropValue("rejectClassName"), cx("rejectButton", {
                getPropValue: getPropValue
            })),
            onClick: reject,
            pt: ptm("rejectButton"),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        }, ptm("rejectButton"));
        var acceptButtonProps = mergeProps({
            label: acceptLabel,
            autoFocus: defaultFocus === undefined || defaultFocus === "accept",
            icon: getPropValue("acceptIcon"),
            className: (0, $7nrKB.classNames)(getPropValue("acceptClassName"), cx("acceptButton")),
            onClick: accept,
            pt: ptm("acceptButton"),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        }, ptm("acceptButton"));
        var content = /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement((0, $1ot1u.Button), rejectButtonProps), /*#__PURE__*/ $7E7Dk.createElement((0, $1ot1u.Button), acceptButtonProps));
        if (getPropValue("footer")) {
            var defaultContentOptions = {
                accept: accept,
                reject: reject,
                acceptClassName: acceptClassName,
                rejectClassName: rejectClassName,
                acceptLabel: acceptLabel,
                rejectLabel: rejectLabel,
                element: content,
                props: getCurrentProps()
            };
            return (0, $7nrKB.ObjectUtils).getJSXElement(getPropValue("footer"), defaultContentOptions);
        }
        return content;
    };
    var createElement = function createElement() {
        var currentProps = getCurrentProps();
        var message = (0, $7nrKB.ObjectUtils).getJSXElement(getPropValue("message"), currentProps);
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var icon = (0, $7nrKB.IconUtils).getJSXIcon(getPropValue("icon"), $8d9726b4731347bf$var$_objectSpread({}, iconProps), {
            props: currentProps
        });
        var footer = createFooter();
        var messageProps = mergeProps({
            className: cx("message")
        }, ptm("message"));
        var rootProps = mergeProps({
            visible: visibleState,
            className: (0, $7nrKB.classNames)(getPropValue("className"), cx("root")),
            footer: footer,
            onHide: hide,
            breakpoints: getPropValue("breakpoints"),
            pt: currentProps.pt,
            unstyled: props.unstyled,
            appendTo: getPropValue("appendTo"),
            __parentMetadata: {
                parent: metaData
            }
        }, $8d9726b4731347bf$var$ConfirmDialogBase.getOtherProps(currentProps));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $h8dgv.Dialog), $8d9726b4731347bf$var$_extends({}, rootProps, {
            content: inProps === null || inProps === void 0 ? void 0 : inProps.content
        }), icon, /*#__PURE__*/ $7E7Dk.createElement("span", messageProps, message));
    };
    var element = createElement();
    return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: getPropValue("appendTo")
    });
}));
$8d9726b4731347bf$export$2cc85109a937009e.displayName = "ConfirmDialog";

});
parcelRegister("1ot1u", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $103e8bb247d8ad56$export$353f5b6fc5456de1; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $bRIbs = parcelRequire("bRIbs");

var $1PxL0 = parcelRequire("1PxL0");

var $cpfnh = parcelRequire("cpfnh");
"use client";
function $103e8bb247d8ad56$var$_extends() {
    return $103e8bb247d8ad56$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $103e8bb247d8ad56$var$_extends.apply(null, arguments);
}
function $103e8bb247d8ad56$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $103e8bb247d8ad56$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $103e8bb247d8ad56$var$_typeof(o);
}
function $103e8bb247d8ad56$var$toPrimitive(t, r) {
    if ("object" != $103e8bb247d8ad56$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $103e8bb247d8ad56$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $103e8bb247d8ad56$var$toPropertyKey(t) {
    var i = $103e8bb247d8ad56$var$toPrimitive(t, "string");
    return "symbol" == $103e8bb247d8ad56$var$_typeof(i) ? i : i + "";
}
function $103e8bb247d8ad56$var$_defineProperty(e, r, t) {
    return (r = $103e8bb247d8ad56$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $103e8bb247d8ad56$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $7nrKB.classNames)("p-badge p-component", $103e8bb247d8ad56$var$_defineProperty({
            "p-badge-no-gutter": (0, $7nrKB.ObjectUtils).isNotEmpty(props.value) && String(props.value).length === 1,
            "p-badge-dot": (0, $7nrKB.ObjectUtils).isEmpty(props.value),
            "p-badge-lg": props.size === "large",
            "p-badge-xl": props.size === "xlarge"
        }, "p-badge-".concat(props.severity), props.severity !== null));
    }
};
var $103e8bb247d8ad56$var$styles = "\n@layer primereact {\n    .p-badge {\n        display: inline-block;\n        border-radius: 10px;\n        text-align: center;\n        padding: 0 .5rem;\n    }\n    \n    .p-overlay-badge {\n        position: relative;\n    }\n    \n    .p-overlay-badge .p-badge {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%,-50%);\n        transform-origin: 100% 0;\n        margin: 0;\n    }\n    \n    .p-badge-dot {\n        width: .5rem;\n        min-width: .5rem;\n        height: .5rem;\n        border-radius: 50%;\n        padding: 0;\n    }\n    \n    .p-badge-no-gutter {\n        padding: 0;\n        border-radius: 50%;\n    }\n}\n";
var $103e8bb247d8ad56$var$BadgeBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Badge",
        __parentMetadata: null,
        value: null,
        severity: null,
        size: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $103e8bb247d8ad56$var$classes$1,
        styles: $103e8bb247d8ad56$var$styles
    }
});
function $103e8bb247d8ad56$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $103e8bb247d8ad56$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $103e8bb247d8ad56$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $103e8bb247d8ad56$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $103e8bb247d8ad56$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $103e8bb247d8ad56$var$Badge = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $103e8bb247d8ad56$var$BadgeBase.getProps(inProps, context);
    var _BadgeBase$setMetaDat = $103e8bb247d8ad56$var$BadgeBase.setMetaData($103e8bb247d8ad56$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata)), ptm = _BadgeBase$setMetaDat.ptm, cx = _BadgeBase$setMetaDat.cx, isUnstyled = _BadgeBase$setMetaDat.isUnstyled;
    (0, $kHEnT.useHandleStyle)($103e8bb247d8ad56$var$BadgeBase.css.styles, isUnstyled, {
        name: "badge"
    });
    var elementRef = $7E7Dk.useRef(null);
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        style: props.style,
        className: (0, $7nrKB.classNames)(props.className, cx("root"))
    }, $103e8bb247d8ad56$var$BadgeBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement("span", rootProps, props.value);
}));
$103e8bb247d8ad56$var$Badge.displayName = "Badge";
var $103e8bb247d8ad56$var$classes = {
    icon: function icon(_ref) {
        var props = _ref.props;
        return (0, $7nrKB.classNames)("p-button-icon p-c", $103e8bb247d8ad56$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
    },
    loadingIcon: function loadingIcon(_ref2) {
        var props = _ref2.props, className = _ref2.className;
        return (0, $7nrKB.classNames)(className, {
            "p-button-loading-icon": props.loading
        });
    },
    label: "p-button-label p-c",
    root: function root(_ref3) {
        var props = _ref3.props, size = _ref3.size, disabled = _ref3.disabled;
        return (0, $7nrKB.classNames)("p-button p-component", $103e8bb247d8ad56$var$_defineProperty($103e8bb247d8ad56$var$_defineProperty($103e8bb247d8ad56$var$_defineProperty($103e8bb247d8ad56$var$_defineProperty({
            "p-button-icon-only": (props.icon || props.loading) && !props.label && !props.children,
            "p-button-vertical": (props.iconPos === "top" || props.iconPos === "bottom") && props.label,
            "p-disabled": disabled,
            "p-button-loading": props.loading,
            "p-button-outlined": props.outlined,
            "p-button-raised": props.raised,
            "p-button-link": props.link,
            "p-button-text": props.text,
            "p-button-rounded": props.rounded,
            "p-button-loading-label-only": props.loading && !props.icon && props.label
        }, "p-button-loading-".concat(props.iconPos), props.loading && props.label), "p-button-".concat(size), size), "p-button-".concat(props.severity), props.severity), "p-button-plain", props.plain));
    }
};
var $103e8bb247d8ad56$var$ButtonBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Button",
        __parentMetadata: null,
        badge: null,
        badgeClassName: null,
        className: null,
        children: undefined,
        disabled: false,
        icon: null,
        iconPos: "left",
        label: null,
        link: false,
        loading: false,
        loadingIcon: null,
        outlined: false,
        plain: false,
        raised: false,
        rounded: false,
        severity: null,
        size: null,
        text: false,
        tooltip: null,
        tooltipOptions: null,
        visible: true
    },
    css: {
        classes: $103e8bb247d8ad56$var$classes
    }
});
function $103e8bb247d8ad56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $103e8bb247d8ad56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $103e8bb247d8ad56$var$ownKeys(Object(t), !0).forEach(function(r) {
            $103e8bb247d8ad56$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $103e8bb247d8ad56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $103e8bb247d8ad56$export$353f5b6fc5456de1 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $103e8bb247d8ad56$var$ButtonBase.getProps(inProps, context);
    var disabled = props.disabled || props.loading;
    var metaData = $103e8bb247d8ad56$var$_objectSpread($103e8bb247d8ad56$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: disabled
        }
    });
    var _ButtonBase$setMetaDa = $103e8bb247d8ad56$var$ButtonBase.setMetaData(metaData), ptm = _ButtonBase$setMetaDa.ptm, cx = _ButtonBase$setMetaDa.cx, isUnstyled = _ButtonBase$setMetaDa.isUnstyled;
    (0, $kHEnT.useHandleStyle)($103e8bb247d8ad56$var$ButtonBase.css.styles, isUnstyled, {
        name: "button",
        styled: true
    });
    var elementRef = $7E7Dk.useRef(ref);
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    if (props.visible === false) return null;
    var createIcon = function createIcon() {
        var className = (0, $7nrKB.classNames)("p-button-icon p-c", $103e8bb247d8ad56$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
        var iconsProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        className = (0, $7nrKB.classNames)(className, {
            "p-button-loading-icon": props.loading
        });
        var loadingIconProps = mergeProps({
            className: cx("loadingIcon", {
                className: className
            })
        }, ptm("loadingIcon"));
        var icon = props.loading ? props.loadingIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $bRIbs.SpinnerIcon), $103e8bb247d8ad56$var$_extends({}, loadingIconProps, {
            spin: true
        })) : props.icon;
        return (0, $7nrKB.IconUtils).getJSXIcon(icon, $103e8bb247d8ad56$var$_objectSpread({}, iconsProps), {
            props: props
        });
    };
    var createLabel = function createLabel() {
        var labelProps = mergeProps({
            className: cx("label")
        }, ptm("label"));
        if (props.label) return /*#__PURE__*/ $7E7Dk.createElement("span", labelProps, props.label);
        return !props.children && !props.label && /*#__PURE__*/ $7E7Dk.createElement("span", $103e8bb247d8ad56$var$_extends({}, labelProps, {
            dangerouslySetInnerHTML: {
                __html: "&nbsp;"
            }
        }));
    };
    var createBadge = function createBadge() {
        if (props.badge) {
            var badgeProps = mergeProps({
                className: (0, $7nrKB.classNames)(props.badgeClassName),
                value: props.badge,
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: metaData
                }
            }, ptm("badge"));
            return /*#__PURE__*/ $7E7Dk.createElement($103e8bb247d8ad56$var$Badge, badgeProps, props.badge);
        }
        return null;
    };
    var showTooltip = !disabled || props.tooltipOptions && props.tooltipOptions.showOnDisabled;
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip) && showTooltip;
    var sizeMapping = {
        large: "lg",
        small: "sm"
    };
    var size = sizeMapping[props.size];
    var icon = createIcon();
    var label = createLabel();
    var badge = createBadge();
    var defaultAriaLabel = props.label ? props.label + (props.badge ? " " + props.badge : "") : props["aria-label"];
    var rootProps = mergeProps({
        ref: elementRef,
        "aria-label": defaultAriaLabel,
        "data-pc-autofocus": props.autoFocus,
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            size: size,
            disabled: disabled
        })),
        disabled: disabled
    }, $103e8bb247d8ad56$var$ButtonBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("button", rootProps, icon, label, props.children, badge, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $103e8bb247d8ad56$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$103e8bb247d8ad56$export$353f5b6fc5456de1.displayName = "Button";

});
parcelRegister("bRIbs", function(module, exports) {

$parcel$export(module.exports, "SpinnerIcon", function () { return $8a36eaebeea97425$export$fe708d541030d854; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $8a36eaebeea97425$var$_extends() {
    return $8a36eaebeea97425$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8a36eaebeea97425$var$_extends.apply(null, arguments);
}
var $8a36eaebeea97425$export$fe708d541030d854 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $8a36eaebeea97425$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
        fill: "currentColor"
    }));
}));
$8a36eaebeea97425$export$fe708d541030d854.displayName = "SpinnerIcon";

});

parcelRegister("cpfnh", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $9083bee946187138$export$28c660c63b792dea; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $ingJg = parcelRequire("ingJg");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $9083bee946187138$var$_extends() {
    return $9083bee946187138$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9083bee946187138$var$_extends.apply(null, arguments);
}
function $9083bee946187138$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9083bee946187138$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9083bee946187138$var$_typeof(o);
}
function $9083bee946187138$var$toPrimitive(t, r) {
    if ("object" != $9083bee946187138$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9083bee946187138$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9083bee946187138$var$toPropertyKey(t) {
    var i = $9083bee946187138$var$toPrimitive(t, "string");
    return "symbol" == $9083bee946187138$var$_typeof(i) ? i : i + "";
}
function $9083bee946187138$var$_defineProperty(e, r, t) {
    return (r = $9083bee946187138$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9083bee946187138$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9083bee946187138$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9083bee946187138$var$_arrayLikeToArray(r);
}
function $9083bee946187138$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $9083bee946187138$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9083bee946187138$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9083bee946187138$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9083bee946187138$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9083bee946187138$var$_toConsumableArray(r) {
    return $9083bee946187138$var$_arrayWithoutHoles(r) || $9083bee946187138$var$_iterableToArray(r) || $9083bee946187138$var$_unsupportedIterableToArray(r) || $9083bee946187138$var$_nonIterableSpread();
}
function $9083bee946187138$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9083bee946187138$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9083bee946187138$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9083bee946187138$var$_slicedToArray(r, e) {
    return $9083bee946187138$var$_arrayWithHoles(r) || $9083bee946187138$var$_iterableToArrayLimit(r, e) || $9083bee946187138$var$_unsupportedIterableToArray(r, e) || $9083bee946187138$var$_nonIterableRest();
}
var $9083bee946187138$var$classes = {
    root: function root(_ref) {
        var positionState = _ref.positionState, classNameState = _ref.classNameState;
        return (0, $7nrKB.classNames)("p-tooltip p-component", $9083bee946187138$var$_defineProperty({}, "p-tooltip-".concat(positionState), true), classNameState);
    },
    arrow: "p-tooltip-arrow",
    text: "p-tooltip-text"
};
var $9083bee946187138$var$inlineStyles = {
    arrow: function arrow(_ref2) {
        var context = _ref2.context;
        return {
            top: context.bottom ? "0" : context.right || context.left || !context.right && !context.left && !context.top && !context.bottom ? "50%" : null,
            bottom: context.top ? "0" : null,
            left: context.right || !context.right && !context.left && !context.top && !context.bottom ? "0" : context.top || context.bottom ? "50%" : null,
            right: context.left ? "0" : null
        };
    }
};
var $9083bee946187138$var$styles = "\n@layer primereact {\n    .p-tooltip {\n        position: absolute;\n        padding: .25em .5rem;\n        /* #3687: Tooltip prevent scrollbar flickering */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-tooltip.p-tooltip-right,\n    .p-tooltip.p-tooltip-left {\n        padding: 0 .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top,\n    .p-tooltip.p-tooltip-bottom {\n        padding:.25em 0;\n    }\n    \n    .p-tooltip .p-tooltip-text {\n       white-space: pre-line;\n       word-break: break-word;\n    }\n    \n    .p-tooltip-arrow {\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-color: transparent;\n        border-style: solid;\n    }\n    \n    .p-tooltip-right .p-tooltip-arrow {\n        top: 50%;\n        left: 0;\n        margin-top: -.25rem;\n        border-width: .25em .25em .25em 0;\n    }\n    \n    .p-tooltip-left .p-tooltip-arrow {\n        top: 50%;\n        right: 0;\n        margin-top: -.25rem;\n        border-width: .25em 0 .25em .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top {\n        padding: .25em 0;\n    }\n    \n    .p-tooltip-top .p-tooltip-arrow {\n        bottom: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: .25em .25em 0;\n    }\n    \n    .p-tooltip-bottom .p-tooltip-arrow {\n        top: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: 0 .25em .25rem;\n    }\n\n    .p-tooltip-target-wrapper {\n        display: inline-flex;\n    }\n}\n";
var $9083bee946187138$var$TooltipBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Tooltip",
        appendTo: null,
        at: null,
        autoHide: true,
        autoZIndex: true,
        baseZIndex: 0,
        className: null,
        closeOnEscape: false,
        content: null,
        disabled: false,
        event: null,
        hideDelay: 0,
        hideEvent: "mouseleave",
        id: null,
        mouseTrack: false,
        mouseTrackLeft: 5,
        mouseTrackTop: 5,
        my: null,
        onBeforeHide: null,
        onBeforeShow: null,
        onHide: null,
        onShow: null,
        position: "right",
        showDelay: 0,
        showEvent: "mouseenter",
        showOnDisabled: false,
        style: null,
        target: null,
        updateDelay: 0,
        children: undefined
    },
    css: {
        classes: $9083bee946187138$var$classes,
        styles: $9083bee946187138$var$styles,
        inlineStyles: $9083bee946187138$var$inlineStyles
    }
});
function $9083bee946187138$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9083bee946187138$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9083bee946187138$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9083bee946187138$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9083bee946187138$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9083bee946187138$export$28c660c63b792dea = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $9083bee946187138$var$TooltipBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $9083bee946187138$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(props.position || "right"), _React$useState4 = $9083bee946187138$var$_slicedToArray(_React$useState3, 2), positionState = _React$useState4[0], setPositionState = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(""), _React$useState6 = $9083bee946187138$var$_slicedToArray(_React$useState5, 2), classNameState = _React$useState6[0], setClassNameState = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(false), _React$useState8 = $9083bee946187138$var$_slicedToArray(_React$useState7, 2), multipleFocusEvents = _React$useState8[0], setMultipleFocusEvents = _React$useState8[1];
    var isCloseOnEscape = visibleState && props.closeOnEscape;
    var overlayDisplayOrder = (0, $jr5t3.useDisplayOrder)("tooltip", isCloseOnEscape);
    var metaData = {
        props: props,
        state: {
            visible: visibleState,
            position: positionState,
            className: classNameState
        },
        context: {
            right: positionState === "right",
            left: positionState === "left",
            top: positionState === "top",
            bottom: positionState === "bottom"
        }
    };
    var _TooltipBase$setMetaD = $9083bee946187138$var$TooltipBase.setMetaData(metaData), ptm = _TooltipBase$setMetaD.ptm, cx = _TooltipBase$setMetaD.cx, sx = _TooltipBase$setMetaD.sx, isUnstyled = _TooltipBase$setMetaD.isUnstyled;
    (0, $kHEnT.useHandleStyle)($9083bee946187138$var$TooltipBase.css.styles, isUnstyled, {
        name: "tooltip"
    });
    (0, $jr5t3.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: isCloseOnEscape,
        priority: [
            (0, $jr5t3.ESC_KEY_HANDLING_PRIORITIES).TOOLTIP,
            overlayDisplayOrder
        ]
    });
    var elementRef = $7E7Dk.useRef(null);
    var textRef = $7E7Dk.useRef(null);
    var currentTargetRef = $7E7Dk.useRef(null);
    var containerSize = $7E7Dk.useRef(null);
    var allowHide = $7E7Dk.useRef(true);
    var timeouts = $7E7Dk.useRef({});
    var currentMouseEvent = $7E7Dk.useRef(null);
    var _useResizeListener = (0, $jr5t3.useResizeListener)({
        listener: function listener(event) {
            !(0, $7nrKB.DomHandler).isTouchDevice() && hide(event);
        }
    }), _useResizeListener2 = $9083bee946187138$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = (0, $jr5t3.useOverlayScrollListener)({
        target: currentTargetRef.current,
        listener: function listener(event) {
            hide(event);
        },
        when: visibleState
    }), _useOverlayScrollList2 = $9083bee946187138$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isTargetContentEmpty = function isTargetContentEmpty(target) {
        return !(props.content || getTargetOption(target, "tooltip"));
    };
    var isContentEmpty = function isContentEmpty(target) {
        return !(props.content || getTargetOption(target, "tooltip") || props.children);
    };
    var isMouseTrack = function isMouseTrack(target) {
        return getTargetOption(target, "mousetrack") || props.mouseTrack;
    };
    var isDisabled = function isDisabled(target) {
        return getTargetOption(target, "disabled") === "true" || hasTargetOption(target, "disabled") || props.disabled;
    };
    var isShowOnDisabled = function isShowOnDisabled(target) {
        return getTargetOption(target, "showondisabled") || props.showOnDisabled;
    };
    var isAutoHide = function isAutoHide() {
        return getTargetOption(currentTargetRef.current, "autohide") || props.autoHide;
    };
    var getTargetOption = function getTargetOption(target, option) {
        return hasTargetOption(target, "data-pr-".concat(option)) ? target.getAttribute("data-pr-".concat(option)) : null;
    };
    var hasTargetOption = function hasTargetOption(target, option) {
        return target && target.hasAttribute(option);
    };
    var getEvents = function getEvents(target) {
        var showEvents = [
            getTargetOption(target, "showevent") || props.showEvent
        ];
        var hideEvents = [
            getTargetOption(target, "hideevent") || props.hideEvent
        ];
        if (isMouseTrack(target)) {
            showEvents = [
                "mousemove"
            ];
            hideEvents = [
                "mouseleave"
            ];
        } else {
            var event = getTargetOption(target, "event") || props.event;
            if (event === "focus") {
                showEvents = [
                    "focus"
                ];
                hideEvents = [
                    "blur"
                ];
            }
            if (event === "both") {
                showEvents = [
                    "focus",
                    "mouseenter"
                ];
                hideEvents = multipleFocusEvents ? [
                    "blur"
                ] : [
                    "mouseleave",
                    "blur"
                ];
            }
        }
        return {
            showEvents: showEvents,
            hideEvents: hideEvents
        };
    };
    var getPosition = function getPosition(target) {
        return getTargetOption(target, "position") || positionState;
    };
    var getMouseTrackPosition = function getMouseTrackPosition(target) {
        var top = getTargetOption(target, "mousetracktop") || props.mouseTrackTop;
        var left = getTargetOption(target, "mousetrackleft") || props.mouseTrackLeft;
        return {
            top: top,
            left: left
        };
    };
    var updateText = function updateText(target, callback) {
        if (textRef.current) {
            var content = getTargetOption(target, "tooltip") || props.content;
            if (content) {
                textRef.current.innerHTML = ""; // remove children
                textRef.current.appendChild(document.createTextNode(content));
                callback();
            } else if (props.children) callback();
        }
    };
    var updateTooltipState = function updateTooltipState(position) {
        updateText(currentTargetRef.current, function() {
            var _currentMouseEvent$cu = currentMouseEvent.current, x = _currentMouseEvent$cu.pageX, y = _currentMouseEvent$cu.pageY;
            if (props.autoZIndex && !(0, $7nrKB.ZIndexUtils).get(elementRef.current)) (0, $7nrKB.ZIndexUtils).set("tooltip", elementRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, props.baseZIndex || context && context.zIndex.tooltip || (0, $eHYdO.default).zIndex.tooltip);
            elementRef.current.style.left = "";
            elementRef.current.style.top = "";
            // GitHub #2695 disable pointer events when autohiding
            if (isAutoHide()) elementRef.current.style.pointerEvents = "none";
            var mouseTrackCheck = isMouseTrack(currentTargetRef.current) || position === "mouse";
            if (mouseTrackCheck && !containerSize.current || mouseTrackCheck) containerSize.current = {
                width: (0, $7nrKB.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $7nrKB.DomHandler).getOuterHeight(elementRef.current)
            };
            align(currentTargetRef.current, {
                x: x,
                y: y
            }, position);
        });
    };
    var show = function show(e) {
        if (e.type && e.type === "focus") setMultipleFocusEvents(true);
        currentTargetRef.current = e.currentTarget;
        var disabled = isDisabled(currentTargetRef.current);
        var empty = isContentEmpty(isShowOnDisabled(currentTargetRef.current) && disabled ? currentTargetRef.current.firstChild : currentTargetRef.current);
        if (empty || disabled) return;
        currentMouseEvent.current = e;
        if (visibleState) applyDelay("updateDelay", updateTooltipState);
        else {
            // #2653 give the callback a chance to return false and not continue with display
            var success = sendCallback(props.onBeforeShow, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay("showDelay", function() {
                setVisibleState(true);
                sendCallback(props.onShow, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var hide = function hide(e) {
        if (e && e.type === "blur") setMultipleFocusEvents(false);
        clearTimeouts();
        if (visibleState) {
            var success = sendCallback(props.onBeforeHide, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay("hideDelay", function() {
                if (!isAutoHide() && allowHide.current === false) return;
                (0, $7nrKB.ZIndexUtils).clear(elementRef.current);
                (0, $7nrKB.DomHandler).removeClass(elementRef.current, "p-tooltip-active");
                setVisibleState(false);
                sendCallback(props.onHide, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        } else if (!props.onBeforeHide && !getDelay("hideDelay")) // handles the case when visibleState change from mouseenter was queued and mouseleave handler was called earlier than queued re-render
        setVisibleState(false);
    };
    var align = function align(target, coordinate, position) {
        var left = 0;
        var top = 0;
        var currentPosition = position || positionState;
        if ((isMouseTrack(target) || currentPosition == "mouse") && coordinate) {
            var _containerSize = {
                width: (0, $7nrKB.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $7nrKB.DomHandler).getOuterHeight(elementRef.current)
            };
            left = coordinate.x;
            top = coordinate.y;
            var _getMouseTrackPositio = getMouseTrackPosition(target), mouseTrackTop = _getMouseTrackPositio.top, mouseTrackLeft = _getMouseTrackPositio.left;
            switch(currentPosition){
                case "left":
                    left = left - (_containerSize.width + mouseTrackLeft);
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case "right":
                case "mouse":
                    left = left + mouseTrackLeft;
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case "top":
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top - (_containerSize.height + mouseTrackTop);
                    break;
                case "bottom":
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top + mouseTrackTop;
                    break;
            }
            if (left <= 0 || containerSize.current.width > _containerSize.width) {
                elementRef.current.style.left = "0px";
                elementRef.current.style.right = window.innerWidth - _containerSize.width - left + "px";
            } else {
                elementRef.current.style.right = "";
                elementRef.current.style.left = left + "px";
            }
            elementRef.current.style.top = top + "px";
            (0, $7nrKB.DomHandler).addClass(elementRef.current, "p-tooltip-active");
        } else {
            var pos = (0, $7nrKB.DomHandler).findCollisionPosition(currentPosition);
            var my = getTargetOption(target, "my") || props.my || pos.my;
            var at = getTargetOption(target, "at") || props.at || pos.at;
            elementRef.current.style.padding = "0px";
            (0, $7nrKB.DomHandler).flipfitCollision(elementRef.current, target, my, at, function(calculatedPosition) {
                var _calculatedPosition$a = calculatedPosition.at, atX = _calculatedPosition$a.x, atY = _calculatedPosition$a.y;
                var myX = calculatedPosition.my.x;
                var newPosition = props.at ? atX !== "center" && atX !== myX ? atX : atY : calculatedPosition.at["".concat(pos.axis)];
                elementRef.current.style.padding = "";
                setPositionState(newPosition);
                updateContainerPosition(newPosition);
                (0, $7nrKB.DomHandler).addClass(elementRef.current, "p-tooltip-active");
            });
        }
    };
    var updateContainerPosition = function updateContainerPosition(position) {
        if (elementRef.current) {
            var style = getComputedStyle(elementRef.current);
            if (position === "left") elementRef.current.style.left = parseFloat(style.left) - parseFloat(style.paddingLeft) * 2 + "px";
            else if (position === "top") elementRef.current.style.top = parseFloat(style.top) - parseFloat(style.paddingTop) * 2 + "px";
        }
    };
    var _onMouseEnter = function onMouseEnter() {
        if (!isAutoHide()) allowHide.current = false;
    };
    var _onMouseLeave = function onMouseLeave(e) {
        if (!isAutoHide()) {
            allowHide.current = true;
            hide(e);
        }
    };
    var bindTargetEvent = function bindTargetEvent(target) {
        if (target) {
            var _getEvents = getEvents(target), showEvents = _getEvents.showEvents, hideEvents = _getEvents.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, hide);
            });
        }
    };
    var unbindTargetEvent = function unbindTargetEvent(target) {
        if (target) {
            var _getEvents2 = getEvents(target), showEvents = _getEvents2.showEvents, hideEvents = _getEvents2.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, hide);
            });
        }
    };
    var getDelay = function getDelay(delayProp) {
        return getTargetOption(currentTargetRef.current, delayProp.toLowerCase()) || props[delayProp];
    };
    var applyDelay = function applyDelay(delayProp, callback) {
        clearTimeouts();
        var delay = getDelay(delayProp);
        delay ? timeouts.current["".concat(delayProp)] = setTimeout(function() {
            return callback();
        }, delay) : callback();
    };
    var sendCallback = function sendCallback(callback) {
        if (callback) {
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            var result = callback.apply(void 0, params);
            if (result === undefined) result = true;
            return result;
        }
        return true;
    };
    var clearTimeouts = function clearTimeouts() {
        Object.values(timeouts.current).forEach(function(t) {
            return clearTimeout(t);
        });
    };
    var getTarget = function getTarget(target) {
        if (target) {
            if (isShowOnDisabled(target)) {
                if (!target.hasWrapper) {
                    var wrapper = document.createElement("div");
                    var isInputElement = target.nodeName === "INPUT";
                    if (isInputElement) (0, $7nrKB.DomHandler).addMultipleClasses(wrapper, "p-tooltip-target-wrapper p-inputwrapper");
                    else (0, $7nrKB.DomHandler).addClass(wrapper, "p-tooltip-target-wrapper");
                    target.parentNode.insertBefore(wrapper, target);
                    wrapper.appendChild(target);
                    target.hasWrapper = true;
                    return wrapper;
                }
                return target.parentElement;
            } else if (target.hasWrapper) {
                var _target$parentElement;
                (_target$parentElement = target.parentElement).replaceWith.apply(_target$parentElement, $9083bee946187138$var$_toConsumableArray(target.parentElement.childNodes));
                delete target.hasWrapper;
            }
            return target;
        }
        return null;
    };
    var updateTargetEvents = function updateTargetEvents(target) {
        unloadTargetEvents(target);
        loadTargetEvents(target);
    };
    var loadTargetEvents = function loadTargetEvents(target) {
        setTargetEventOperations(target || props.target, bindTargetEvent);
    };
    var unloadTargetEvents = function unloadTargetEvents(target) {
        setTargetEventOperations(target || props.target, unbindTargetEvent);
    };
    var setTargetEventOperations = function setTargetEventOperations(target, operation) {
        target = (0, $7nrKB.ObjectUtils).getRefElement(target);
        if (target) {
            if ((0, $7nrKB.DomHandler).isElement(target)) operation(target);
            else {
                var setEvent = function setEvent(target) {
                    var element = (0, $7nrKB.DomHandler).find(document, target);
                    element.forEach(function(el) {
                        operation(el);
                    });
                };
                if (target instanceof Array) target.forEach(function(t) {
                    setEvent(t);
                });
                else setEvent(target);
            }
        }
    };
    (0, $jr5t3.useMountEffect)(function() {
        if (visibleState && currentTargetRef.current && isDisabled(currentTargetRef.current)) hide();
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        loadTargetEvents();
        return function() {
            unloadTargetEvents();
        };
    }, [
        show,
        hide,
        props.target
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (visibleState) {
            var position = getPosition(currentTargetRef.current);
            var classname = getTargetOption(currentTargetRef.current, "classname");
            setPositionState(position);
            setClassNameState(classname);
            updateTooltipState(position);
            bindWindowResizeListener();
            bindOverlayScrollListener();
        } else {
            setPositionState(props.position || "right");
            setClassNameState("");
            currentTargetRef.current = null;
            containerSize.current = null;
            allowHide.current = true;
        }
        return function() {
            unbindWindowResizeListener();
            unbindOverlayScrollListener();
        };
    }, [
        visibleState
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        var position = getPosition(currentTargetRef.current);
        if (visibleState && position !== "mouse") applyDelay("updateDelay", function() {
            updateText(currentTargetRef.current, function() {
                align(currentTargetRef.current);
            });
        });
    }, [
        props.content
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        hide();
        (0, $7nrKB.ZIndexUtils).clear(elementRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            updateTargetEvents: updateTargetEvents,
            loadTargetEvents: loadTargetEvents,
            unloadTargetEvents: unloadTargetEvents,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            },
            getTarget: function getTarget() {
                return currentTargetRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var empty = isTargetContentEmpty(currentTargetRef.current);
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $7nrKB.classNames)(props.className, cx("root", {
                positionState: positionState,
                classNameState: classNameState
            })),
            style: props.style,
            role: "tooltip",
            "aria-hidden": visibleState,
            onMouseEnter: function onMouseEnter(e) {
                return _onMouseEnter();
            },
            onMouseLeave: function onMouseLeave(e) {
                return _onMouseLeave(e);
            }
        }, $9083bee946187138$var$TooltipBase.getOtherProps(props), ptm("root"));
        var arrowProps = mergeProps({
            className: cx("arrow"),
            style: sx("arrow", $9083bee946187138$var$_objectSpread({}, metaData))
        }, ptm("arrow"));
        var textProps = mergeProps({
            className: cx("text")
        }, ptm("text"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", $9083bee946187138$var$_extends({
            ref: elementRef
        }, rootProps), /*#__PURE__*/ $7E7Dk.createElement("div", arrowProps), /*#__PURE__*/ $7E7Dk.createElement("div", $9083bee946187138$var$_extends({
            ref: textRef
        }, textProps), empty && props.children));
    };
    if (visibleState) {
        var element = createElement();
        return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    }
    return null;
}));
$9083bee946187138$export$28c660c63b792dea.displayName = "Tooltip";

});


parcelRegister("h8dgv", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $c78d793cf2188210$export$3ddf2d174ce01153; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $2v3zC = parcelRequire("2v3zC");

var $bgxh2 = parcelRequire("bgxh2");

var $iXDZm = parcelRequire("iXDZm");

var $ingJg = parcelRequire("ingJg");

var $1PxL0 = parcelRequire("1PxL0");
"use client";
function $c78d793cf2188210$var$_extends() {
    return $c78d793cf2188210$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c78d793cf2188210$var$_extends.apply(null, arguments);
}
function $c78d793cf2188210$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c78d793cf2188210$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c78d793cf2188210$var$_typeof(o);
}
function $c78d793cf2188210$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c78d793cf2188210$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $c78d793cf2188210$var$_arrayLikeToArray(r);
}
function $c78d793cf2188210$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $c78d793cf2188210$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c78d793cf2188210$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c78d793cf2188210$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c78d793cf2188210$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c78d793cf2188210$var$_toConsumableArray(r) {
    return $c78d793cf2188210$var$_arrayWithoutHoles(r) || $c78d793cf2188210$var$_iterableToArray(r) || $c78d793cf2188210$var$_unsupportedIterableToArray(r) || $c78d793cf2188210$var$_nonIterableSpread();
}
function $c78d793cf2188210$var$toPrimitive(t, r) {
    if ("object" != $c78d793cf2188210$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c78d793cf2188210$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c78d793cf2188210$var$toPropertyKey(t) {
    var i = $c78d793cf2188210$var$toPrimitive(t, "string");
    return "symbol" == $c78d793cf2188210$var$_typeof(i) ? i : i + "";
}
function $c78d793cf2188210$var$_defineProperty(e, r, t) {
    return (r = $c78d793cf2188210$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c78d793cf2188210$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $c78d793cf2188210$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c78d793cf2188210$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c78d793cf2188210$var$_slicedToArray(r, e) {
    return $c78d793cf2188210$var$_arrayWithHoles(r) || $c78d793cf2188210$var$_iterableToArrayLimit(r, e) || $c78d793cf2188210$var$_unsupportedIterableToArray(r, e) || $c78d793cf2188210$var$_nonIterableRest();
}
var $c78d793cf2188210$var$styles$1 = "";
var $c78d793cf2188210$var$FocusTrapBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "FocusTrap",
        children: undefined
    },
    css: {
        styles: $c78d793cf2188210$var$styles$1
    },
    getProps: function getProps(props) {
        return (0, $7nrKB.ObjectUtils).getMergedProps(props, $c78d793cf2188210$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $7nrKB.ObjectUtils).getDiffProps(props, $c78d793cf2188210$var$FocusTrapBase.defaultProps);
    }
});
function $c78d793cf2188210$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c78d793cf2188210$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c78d793cf2188210$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $c78d793cf2188210$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c78d793cf2188210$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c78d793cf2188210$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext((0, $eHYdO.PrimeReactContext));
    var props = $c78d793cf2188210$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $jr5t3.useStyle)($c78d793cf2188210$var$FocusTrapBase.css.styles, {
        name: "focustrap"
    });
    var _FocusTrapBase$setMet = $c78d793cf2188210$var$FocusTrapBase.setMetaData($c78d793cf2188210$var$_objectSpread$2({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $jr5t3.useMountEffect)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? "" : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? "" : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $7nrKB.DomHandler).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $7nrKB.DomHandler).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $7nrKB.DomHandler).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ':not(.p-hidden-focusable):not([data-p-hidden-focusable="true"])'.concat(selector !== null && selector !== void 0 ? selector : "");
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $7nrKB.DomHandler).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $7nrKB.DomHandler).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $7nrKB.DomHandler).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $7nrKB.DomHandler).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(inRef, onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
                ref: inRef,
                className: "p-hidden-accessible p-hidden-focusable",
                tabIndex: tabIndex,
                role: "presentation",
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(firstFocusableElementRef, onFirstHiddenElementFocus, "firstfocusableelement");
        var lastFocusableElement = createFocusableElement(lastFocusableElementRef, onLastHiddenElementFocus, "lastfocusableelement");
        if (firstFocusableElementRef.current && lastFocusableElementRef.current) {
            firstFocusableElementRef.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElementRef.current;
            lastFocusableElementRef.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElementRef.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $c78d793cf2188210$var$FocusTrap$1 = $c78d793cf2188210$var$FocusTrap;
function $c78d793cf2188210$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c78d793cf2188210$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c78d793cf2188210$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $c78d793cf2188210$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c78d793cf2188210$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c78d793cf2188210$var$classes = {
    closeButtonIcon: "p-dialog-header-close-icon",
    closeButton: "p-dialog-header-icon p-dialog-header-close p-link",
    maximizableIcon: "p-dialog-header-maximize-icon",
    maximizableButton: "p-dialog-header-icon p-dialog-header-maximize p-link",
    header: function header(_ref) {
        var props = _ref.props;
        return (0, $7nrKB.classNames)("p-dialog-header", props.headerClassName);
    },
    headerTitle: "p-dialog-title",
    headerIcons: "p-dialog-header-icons",
    content: function content(_ref2) {
        var props = _ref2.props;
        return (0, $7nrKB.classNames)("p-dialog-content", props.contentClassName);
    },
    footer: function footer(_ref3) {
        var props = _ref3.props;
        return (0, $7nrKB.classNames)("p-dialog-footer", props.footerClassName);
    },
    mask: function mask(_ref4) {
        var props = _ref4.props, maskVisibleState = _ref4.maskVisibleState;
        var positions = [
            "center",
            "left",
            "right",
            "top",
            "top-left",
            "top-right",
            "bottom",
            "bottom-left",
            "bottom-right"
        ];
        var pos = positions.find(function(item) {
            return item === props.position || item.replace("-", "") === props.position;
        });
        return (0, $7nrKB.classNames)("p-dialog-mask", pos ? "p-dialog-".concat(pos) : "", {
            "p-component-overlay p-component-overlay-enter": props.modal,
            "p-dialog-visible": maskVisibleState,
            "p-dialog-draggable": props.draggable,
            "p-dialog-resizable": props.resizable
        }, props.maskClassName);
    },
    root: function root(_ref5) {
        var props = _ref5.props, maximized = _ref5.maximized, context = _ref5.context;
        return (0, $7nrKB.classNames)("p-dialog p-component", {
            "p-dialog-rtl": props.rtl,
            "p-dialog-maximized": maximized,
            "p-dialog-default": !maximized,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    transition: "p-dialog"
};
var $c78d793cf2188210$var$styles = "\n@layer primereact {\n    .p-dialog-mask {\n        background-color: transparent;\n        transition-property: background-color;\n    }\n\n    .p-dialog-visible {\n        display: flex;\n    }\n\n    .p-dialog-mask.p-component-overlay {\n        pointer-events: auto;\n    }\n\n    .p-dialog {\n        display: flex;\n        flex-direction: column;\n        pointer-events: auto;\n        max-height: 90%;\n        transform: scale(1);\n        position: relative;\n    }\n\n    .p-dialog-content {\n        overflow-y: auto;\n        flex-grow: 1;\n    }\n\n    .p-dialog-header {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n    }\n\n    .p-dialog-footer {\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icons {\n        display: flex;\n        align-items: center;\n        align-self: flex-start;\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-dialog .p-dialog-title {\n        flex-grow: 1;\n    }\n\n    /* Fluid */\n    .p-fluid .p-dialog-footer .p-button {\n        width: auto;\n    }\n\n    /* Animation */\n    /* Center */\n    .p-dialog-enter {\n        opacity: 0;\n        transform: scale(0.7);\n    }\n\n    .p-dialog-enter-active {\n        opacity: 1;\n        transform: scale(1);\n        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-dialog-enter-done {\n        transform: none;\n    }\n\n    .p-dialog-exit-active {\n        opacity: 0;\n        transform: scale(0.7);\n        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    /* Top, Bottom, Left, Right, Top* and Bottom* */\n    .p-dialog-top .p-dialog,\n    .p-dialog-bottom .p-dialog,\n    .p-dialog-left .p-dialog,\n    .p-dialog-right .p-dialog,\n    .p-dialog-top-left .p-dialog,\n    .p-dialog-top-right .p-dialog,\n    .p-dialog-bottom-left .p-dialog,\n    .p-dialog-bottom-right .p-dialog {\n        margin: 0.75em;\n    }\n\n    .p-dialog-top .p-dialog-enter,\n    .p-dialog-top .p-dialog-exit-active {\n        transform: translate3d(0px, -100%, 0px);\n    }\n\n    .p-dialog-bottom .p-dialog-enter,\n    .p-dialog-bottom .p-dialog-exit-active {\n        transform: translate3d(0px, 100%, 0px);\n    }\n\n    .p-dialog-left .p-dialog-enter,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-enter,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-enter,\n    .p-dialog-bottom-left .p-dialog-exit-active {\n        transform: translate3d(-100%, 0px, 0px);\n    }\n\n    .p-dialog-right .p-dialog-enter,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-enter,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-enter,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transform: translate3d(100%, 0px, 0px);\n    }\n\n    .p-dialog-top .p-dialog-enter-active,\n    .p-dialog-bottom .p-dialog-enter-active,\n    .p-dialog-left .p-dialog-enter-active,\n    .p-dialog-top-left .p-dialog-enter-active,\n    .p-dialog-bottom-left .p-dialog-enter-active,\n    .p-dialog-right .p-dialog-enter-active,\n    .p-dialog-top-right .p-dialog-enter-active,\n    .p-dialog-bottom-right .p-dialog-enter-active {\n        transform: translate3d(0px, 0px, 0px);\n        transition: all 0.3s ease-out;\n    }\n\n    .p-dialog-top .p-dialog-exit-active,\n    .p-dialog-bottom .p-dialog-exit-active,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-exit-active,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transition: all 0.3s ease-out;\n    }\n\n    /* Maximize */\n    .p-dialog-maximized {\n        transition: none;\n        transform: none;\n        margin: 0;\n        width: 100vw !important;\n        height: 100vh !important;\n        max-height: 100%;\n        top: 0px !important;\n        left: 0px !important;\n    }\n\n    .p-dialog-maximized .p-dialog-content {\n        flex-grow: 1;\n    }\n\n    .p-confirm-dialog .p-dialog-content {\n        display: flex;\n        align-items: center;\n    }\n\n    /* Resizable */\n    .p-dialog .p-resizable-handle {\n        position: absolute;\n        font-size: 0.1px;\n        display: block;\n        cursor: se-resize;\n        width: 12px;\n        height: 12px;\n        right: 1px;\n        bottom: 1px;\n    }\n\n    .p-dialog-draggable .p-dialog-header {\n        cursor: move;\n    }\n}\n";
var $c78d793cf2188210$var$inlineStyles = {
    mask: function mask(_ref6) {
        var props = _ref6.props;
        return $c78d793cf2188210$var$_objectSpread$1({
            position: "fixed",
            height: "100%",
            width: "100%",
            left: 0,
            top: 0,
            display: "flex",
            justifyContent: props.position === "left" || props.position === "top-left" || props.position === "bottom-left" ? "flex-start" : props.position === "right" || props.position === "top-right" || props.position === "bottom-right" ? "flex-end" : "center",
            alignItems: props.position === "top" || props.position === "top-left" || props.position === "top-right" ? "flex-start" : props.position === "bottom" || props.position === "bottom-left" || props.position === "bottom-right" ? "flex-end" : "center",
            pointerEvents: !props.modal && "none"
        }, props.maskStyle);
    }
};
var $c78d793cf2188210$var$DialogBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Dialog",
        __parentMetadata: null,
        appendTo: null,
        ariaCloseIconLabel: null,
        baseZIndex: 0,
        blockScroll: false,
        breakpoints: null,
        className: null,
        closable: true,
        closeIcon: null,
        closeOnEscape: true,
        content: null,
        contentClassName: null,
        contentStyle: null,
        dismissableMask: false,
        draggable: true,
        focusOnShow: true,
        footer: null,
        footerClassName: null,
        header: null,
        headerClassName: null,
        headerStyle: null,
        icons: null,
        id: null,
        keepInViewport: true,
        maskClassName: null,
        maskStyle: null,
        maximizable: false,
        maximizeIcon: null,
        maximized: false,
        minX: 0,
        minY: 0,
        minimizeIcon: null,
        modal: true,
        onClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragStart: null,
        onHide: null,
        onMaskClick: null,
        onMaximize: null,
        onResize: null,
        onResizeEnd: null,
        onResizeStart: null,
        onShow: null,
        position: "center",
        resizable: true,
        rtl: false,
        showHeader: true,
        showCloseIcon: true,
        style: null,
        transitionOptions: null,
        visible: false,
        children: undefined
    },
    css: {
        classes: $c78d793cf2188210$var$classes,
        styles: $c78d793cf2188210$var$styles,
        inlineStyles: $c78d793cf2188210$var$inlineStyles
    }
});
function $c78d793cf2188210$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c78d793cf2188210$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c78d793cf2188210$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c78d793cf2188210$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c78d793cf2188210$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c78d793cf2188210$export$3ddf2d174ce01153 = /*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $c78d793cf2188210$var$DialogBase.getProps(inProps, context);
    var uniqueId = props.id ? props.id : (0, $7nrKB.UniqueComponentId)();
    var _React$useState = $7E7Dk.useState(uniqueId), _React$useState2 = $c78d793cf2188210$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0];
    _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(false), _React$useState4 = $c78d793cf2188210$var$_slicedToArray(_React$useState3, 2), maskVisibleState = _React$useState4[0], setMaskVisibleState = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(false), _React$useState6 = $c78d793cf2188210$var$_slicedToArray(_React$useState5, 2), visibleState = _React$useState6[0], setVisibleState = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(props.maximized), _React$useState8 = $c78d793cf2188210$var$_slicedToArray(_React$useState7, 2), maximizedState = _React$useState8[0], setMaximizedState = _React$useState8[1];
    var dialogRef = $7E7Dk.useRef(null);
    var maskRef = $7E7Dk.useRef(null);
    var pointerRef = $7E7Dk.useRef(null);
    var contentRef = $7E7Dk.useRef(null);
    var headerRef = $7E7Dk.useRef(null);
    var footerRef = $7E7Dk.useRef(null);
    var closeRef = $7E7Dk.useRef(null);
    var dragging = $7E7Dk.useRef(false);
    var resizing = $7E7Dk.useRef(false);
    var lastPageX = $7E7Dk.useRef(null);
    var lastPageY = $7E7Dk.useRef(null);
    var styleElement = $7E7Dk.useRef(null);
    var attributeSelector = $7E7Dk.useRef(uniqueId);
    var focusElementOnHide = $7E7Dk.useRef(null);
    var maximized = props.onMaximize ? props.maximized : maximizedState;
    var shouldBlockScroll = visibleState && (props.blockScroll || props.maximizable && maximized);
    var isCloseOnEscape = props.closable && props.closeOnEscape && visibleState;
    var displayOrder = (0, $jr5t3.useDisplayOrder)("dialog", isCloseOnEscape);
    var _DialogBase$setMetaDa = $c78d793cf2188210$var$DialogBase.setMetaData($c78d793cf2188210$var$_objectSpread($c78d793cf2188210$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            id: idState,
            maximized: maximized,
            containerVisible: maskVisibleState
        }
    })), ptm = _DialogBase$setMetaDa.ptm, cx = _DialogBase$setMetaDa.cx, sx = _DialogBase$setMetaDa.sx, isUnstyled = _DialogBase$setMetaDa.isUnstyled;
    (0, $kHEnT.useHandleStyle)($c78d793cf2188210$var$DialogBase.css.styles, isUnstyled, {
        name: "dialog"
    });
    (0, $jr5t3.useGlobalOnEscapeKey)({
        callback: function callback(event) {
            onClose(event);
        },
        when: isCloseOnEscape && displayOrder,
        priority: [
            (0, $jr5t3.ESC_KEY_HANDLING_PRIORITIES).DIALOG,
            displayOrder
        ]
    });
    var _useEventListener = (0, $jr5t3.useEventListener)({
        type: "mousemove",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener2 = $c78d793cf2188210$var$_slicedToArray(_useEventListener, 2), bindDocumentResizeListener = _useEventListener2[0], unbindDocumentResizeListener = _useEventListener2[1];
    var _useEventListener3 = (0, $jr5t3.useEventListener)({
        type: "mouseup",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResizeEnd(event);
        }
    }), _useEventListener4 = $c78d793cf2188210$var$_slicedToArray(_useEventListener3, 2), bindDocumentResizeEndListener = _useEventListener4[0], unbindDocumentResizEndListener = _useEventListener4[1];
    var _useEventListener5 = (0, $jr5t3.useEventListener)({
        type: "mousemove",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $c78d793cf2188210$var$_slicedToArray(_useEventListener5, 2), bindDocumentDragListener = _useEventListener6[0], unbindDocumentDragListener = _useEventListener6[1];
    var _useEventListener7 = (0, $jr5t3.useEventListener)({
        type: "mouseup",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $c78d793cf2188210$var$_slicedToArray(_useEventListener7, 2), bindDocumentDragEndListener = _useEventListener8[0], unbindDocumentDragEndListener = _useEventListener8[1];
    var onClose = function onClose(event) {
        props.onHide(event);
        event.preventDefault();
    };
    var focus = function focus() {
        var activeElement = document.activeElement;
        var isActiveElementInDialog = activeElement && dialogRef.current && dialogRef.current.contains(activeElement);
        if (!isActiveElementInDialog && props.closable && props.showCloseIcon && props.showHeader && closeRef.current) closeRef.current.focus();
    };
    var onDialogPointerDown = function onDialogPointerDown(event) {
        pointerRef.current = event.target;
        props.onPointerDown && props.onPointerDown(event);
    };
    var onMaskPointerUp = function onMaskPointerUp(event) {
        if (props.dismissableMask && props.modal && maskRef.current === event.target && !pointerRef.current) onClose(event);
        props.onMaskClick && props.onMaskClick(event);
        pointerRef.current = null;
    };
    var toggleMaximize = function toggleMaximize(event) {
        if (props.onMaximize) props.onMaximize({
            originalEvent: event,
            maximized: !maximized
        });
        else setMaximizedState(function(prevMaximized) {
            return !prevMaximized;
        });
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event) {
        if ((0, $7nrKB.DomHandler).hasClass(event.target, "p-dialog-header-icon") || (0, $7nrKB.DomHandler).hasClass(event.target.parentElement, "p-dialog-header-icon")) return;
        if (props.draggable) {
            dragging.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $7nrKB.DomHandler).addClass(document.body, "p-unselectable-text");
            props.onDragStart && props.onDragStart(event);
        }
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            var width = (0, $7nrKB.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $7nrKB.DomHandler).getOuterHeight(dialogRef.current);
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var offset = dialogRef.current.getBoundingClientRect();
            var leftPos = offset.left + deltaX;
            var topPos = offset.top + deltaY;
            var viewport = (0, $7nrKB.DomHandler).getViewport();
            var computedStyle = getComputedStyle(dialogRef.current);
            var leftMargin = parseFloat(computedStyle.marginLeft);
            var topMargin = parseFloat(computedStyle.marginTop);
            dialogRef.current.style.position = "fixed";
            if (props.keepInViewport) {
                if (leftPos >= props.minX && leftPos + width < viewport.width) {
                    lastPageX.current = event.pageX;
                    dialogRef.current.style.left = leftPos - leftMargin + "px";
                }
                if (topPos >= props.minY && topPos + height < viewport.height) {
                    lastPageY.current = event.pageY;
                    dialogRef.current.style.top = topPos - topMargin + "px";
                }
            } else {
                lastPageX.current = event.pageX;
                dialogRef.current.style.left = leftPos - leftMargin + "px";
                lastPageY.current = event.pageY;
                dialogRef.current.style.top = topPos - topMargin + "px";
            }
            props.onDrag && props.onDrag(event);
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            (0, $7nrKB.DomHandler).removeClass(document.body, "p-unselectable-text");
            props.onDragEnd && props.onDragEnd(event);
        }
    };
    var onResizeStart = function onResizeStart(event) {
        if (props.resizable) {
            resizing.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $7nrKB.DomHandler).addClass(document.body, "p-unselectable-text");
            props.onResizeStart && props.onResizeStart(event);
        }
    };
    var convertToPx = function convertToPx(value, property, viewport) {
        !viewport && (viewport = (0, $7nrKB.DomHandler).getViewport());
        var val = parseInt(value);
        if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(value)) return val * (viewport[property] / 100);
        return val;
    };
    var onResize = function onResize(event) {
        if (resizing.current) {
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var width = (0, $7nrKB.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $7nrKB.DomHandler).getOuterHeight(dialogRef.current);
            var offset = dialogRef.current.getBoundingClientRect();
            var viewport = (0, $7nrKB.DomHandler).getViewport();
            var hasBeenDragged = !parseInt(dialogRef.current.style.top) || !parseInt(dialogRef.current.style.left);
            var minWidth = convertToPx(dialogRef.current.style.minWidth, "width", viewport);
            var minHeight = convertToPx(dialogRef.current.style.minHeight, "height", viewport);
            var newWidth = width + deltaX;
            var newHeight = height + deltaY;
            if (hasBeenDragged) {
                newWidth = newWidth + deltaX;
                newHeight = newHeight + deltaY;
            }
            if ((!minWidth || newWidth > minWidth) && offset.left + newWidth < viewport.width) dialogRef.current.style.width = newWidth + "px";
            if ((!minHeight || newHeight > minHeight) && offset.top + newHeight < viewport.height) dialogRef.current.style.height = newHeight + "px";
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            props.onResize && props.onResize(event);
        }
    };
    var onResizeEnd = function onResizeEnd(event) {
        if (resizing.current) {
            resizing.current = false;
            (0, $7nrKB.DomHandler).removeClass(document.body, "p-unselectable-text");
            props.onResizeEnd && props.onResizeEnd(event);
        }
    };
    var resetPosition = function resetPosition() {
        dialogRef.current.style.position = "";
        dialogRef.current.style.left = "";
        dialogRef.current.style.top = "";
        dialogRef.current.style.margin = "";
    };
    var onEnter = function onEnter() {
        dialogRef.current.setAttribute(attributeSelector.current, "");
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
        if (props.focusOnShow) focus();
        enableDocumentSettings();
    };
    var onExiting = function onExiting() {
        if (props.modal) !isUnstyled() && (0, $7nrKB.DomHandler).addClass(maskRef.current, "p-component-overlay-leave");
    };
    var onExited = function onExited() {
        dragging.current = false;
        (0, $7nrKB.ZIndexUtils).clear(maskRef.current);
        setMaskVisibleState(false);
        disableDocumentSettings();
        // return focus to element before dialog was open
        (0, $7nrKB.DomHandler).focus(focusElementOnHide.current);
        focusElementOnHide.current = null;
    };
    var enableDocumentSettings = function enableDocumentSettings() {
        bindGlobalListeners();
    };
    var disableDocumentSettings = function disableDocumentSettings() {
        unbindGlobalListeners();
    };
    var updateScrollBlocker = function updateScrollBlocker() {
        // Scroll should be unblocked if there is at least one dialog that blocks scrolling:
        var isThereAnyDialogThatBlocksScrolling = document.primeDialogParams && document.primeDialogParams.some(function(i) {
            return i.hasBlockScroll;
        });
        if (isThereAnyDialogThatBlocksScrolling) (0, $7nrKB.DomHandler).blockBodyScroll();
        else (0, $7nrKB.DomHandler).unblockBodyScroll();
    };
    var updateGlobalDialogsRegistry = function updateGlobalDialogsRegistry(isMounted) {
        // Update current dialog info in global registry if it is mounted and visible:
        if (isMounted && visibleState) {
            var newParam = {
                id: idState,
                hasBlockScroll: shouldBlockScroll
            };
            // Create registry if not yet created:
            if (!document.primeDialogParams) document.primeDialogParams = [];
            var currentDialogIndexInRegistry = document.primeDialogParams.findIndex(function(dialogInRegistry) {
                return dialogInRegistry.id === idState;
            });
            if (currentDialogIndexInRegistry === -1) document.primeDialogParams = [].concat($c78d793cf2188210$var$_toConsumableArray(document.primeDialogParams), [
                newParam
            ]);
            else document.primeDialogParams = document.primeDialogParams.toSpliced(currentDialogIndexInRegistry, 1, newParam);
        } else document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(param) {
            return param.id !== idState;
        });
        // Always update scroll blocker after dialog registry - this way we ensure that
        // p-overflow-hidden class is properly added/removed:
        updateScrollBlocker();
    };
    var bindGlobalListeners = function bindGlobalListeners() {
        if (props.draggable) {
            bindDocumentDragListener();
            bindDocumentDragEndListener();
        }
        if (props.resizable) {
            bindDocumentResizeListener();
            bindDocumentResizeEndListener();
        }
    };
    var unbindGlobalListeners = function unbindGlobalListeners() {
        unbindDocumentDragListener();
        unbindDocumentDragEndListener();
        unbindDocumentResizeListener();
        unbindDocumentResizEndListener();
    };
    var createStyle = function createStyle() {
        styleElement.current = (0, $7nrKB.DomHandler).createInlineStyle(context && context.nonce || (0, $eHYdO.default).nonce, context && context.styleContainer);
        var innerHTML = "";
        for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                @media screen and (max-width: ".concat(breakpoint, ') {\n                     [data-pc-name="dialog"][').concat(attributeSelector.current, "] {\n                        width: ").concat(props.breakpoints[breakpoint], " !important;\n                    }\n                }\n            ");
        styleElement.current.innerHTML = innerHTML;
    };
    var destroyStyle = function destroyStyle() {
        styleElement.current = (0, $7nrKB.DomHandler).removeInlineStyle(styleElement.current);
    };
    (0, $jr5t3.useMountEffect)(function() {
        updateGlobalDialogsRegistry(true);
        if (props.visible) setMaskVisibleState(true);
    });
    $7E7Dk.useEffect(function() {
        if (props.breakpoints) createStyle();
        return function() {
            destroyStyle();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.breakpoints
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (props.visible && !maskVisibleState) setMaskVisibleState(true);
        if (props.visible !== visibleState && maskVisibleState) setVisibleState(props.visible);
        if (props.visible) // Remember the focused element before we opened the dialog
        // so we can return focus to it once we close the dialog.
        focusElementOnHide.current = document.activeElement;
    }, [
        props.visible,
        maskVisibleState
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (maskVisibleState) {
            (0, $7nrKB.ZIndexUtils).set("modal", maskRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, props.baseZIndex || context && context.zIndex.modal || (0, $eHYdO.default).zIndex.modal);
            setVisibleState(true);
        }
    }, [
        maskVisibleState
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        updateGlobalDialogsRegistry(true);
    }, [
        shouldBlockScroll,
        visibleState
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        disableDocumentSettings();
        updateGlobalDialogsRegistry(false);
        (0, $7nrKB.DomHandler).removeInlineStyle(styleElement.current);
        (0, $7nrKB.ZIndexUtils).clear(maskRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            resetPosition: resetPosition,
            getElement: function getElement() {
                return dialogRef.current;
            },
            getMask: function getMask() {
                return maskRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getHeader: function getHeader() {
                return headerRef.current;
            },
            getFooter: function getFooter() {
                return footerRef.current;
            },
            getCloseButton: function getCloseButton() {
                return closeRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        if (props.closable && props.showCloseIcon) {
            var labelAria = props.ariaCloseIconLabel || (0, $eHYdO.ariaLabel)("close");
            var closeButtonIconProps = mergeProps({
                className: cx("closeButtonIcon"),
                "aria-hidden": true
            }, ptm("closeButtonIcon"));
            var icon = props.closeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), closeButtonIconProps);
            var headerCloseIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $c78d793cf2188210$var$_objectSpread({}, closeButtonIconProps), {
                props: props
            });
            var closeButtonProps = mergeProps({
                ref: closeRef,
                type: "button",
                className: cx("closeButton"),
                "aria-label": labelAria,
                onClick: onClose,
                onKeyDown: function onKeyDown(ev) {
                    if (ev.key !== "Escape") ev.stopPropagation();
                }
            }, ptm("closeButton"));
            return /*#__PURE__*/ $7E7Dk.createElement("button", closeButtonProps, headerCloseIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
        }
        return null;
    };
    var createMaximizeIcon = function createMaximizeIcon() {
        var icon;
        var maximizableIconProps = mergeProps({
            className: cx("maximizableIcon")
        }, ptm("maximizableIcon"));
        if (!maximized) icon = props.maximizeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $bgxh2.WindowMaximizeIcon), maximizableIconProps);
        else icon = props.minimizeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $iXDZm.WindowMinimizeIcon), maximizableIconProps);
        var toggleIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, maximizableIconProps, {
            props: props
        });
        if (props.maximizable) {
            var maximizableButtonProps = mergeProps({
                type: "button",
                className: cx("maximizableButton"),
                onClick: toggleMaximize
            }, ptm("maximizableButton"));
            return /*#__PURE__*/ $7E7Dk.createElement("button", maximizableButtonProps, toggleIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.showHeader) {
            var closeIcon = createCloseIcon();
            var maximizeIcon = createMaximizeIcon();
            var icons = (0, $7nrKB.ObjectUtils).getJSXElement(props.icons, props);
            var header = (0, $7nrKB.ObjectUtils).getJSXElement(props.header, props);
            var headerId = idState + "_header";
            var headerProps = mergeProps({
                ref: headerRef,
                style: props.headerStyle,
                className: cx("header"),
                onMouseDown: onDragStart
            }, ptm("header"));
            var headerTitleProps = mergeProps({
                id: headerId,
                className: cx("headerTitle")
            }, ptm("headerTitle"));
            var headerIconsProps = mergeProps({
                className: cx("headerIcons")
            }, ptm("headerIcons"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", headerProps, /*#__PURE__*/ $7E7Dk.createElement("div", headerTitleProps, header), /*#__PURE__*/ $7E7Dk.createElement("div", headerIconsProps, icons, maximizeIcon, closeIcon));
        }
        return null;
    };
    var createContent = function createContent() {
        var contentId = idState + "_content";
        var contentProps = mergeProps({
            id: contentId,
            ref: contentRef,
            style: props.contentStyle,
            className: cx("content")
        }, ptm("content"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, props.children);
    };
    var createFooter = function createFooter() {
        var footer = (0, $7nrKB.ObjectUtils).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            ref: footerRef,
            className: cx("footer")
        }, ptm("footer"));
        return footer && /*#__PURE__*/ $7E7Dk.createElement("div", footerProps, footer);
    };
    var createResizer = function createResizer() {
        if (props.resizable) return /*#__PURE__*/ $7E7Dk.createElement("span", {
            className: "p-resizable-handle",
            style: {
                zIndex: 90
            },
            onMouseDown: onResizeStart
        });
        return null;
    };
    var createTemplateElement = function createTemplateElement() {
        var _props$children;
        var messageProps = {
            header: props.header,
            content: props.message,
            message: props === null || props === void 0 || (_props$children = props.children) === null || _props$children === void 0 || (_props$children = _props$children[1]) === null || _props$children === void 0 || (_props$children = _props$children.props) === null || _props$children === void 0 ? void 0 : _props$children.children
        };
        var templateElementProps = {
            headerRef: headerRef,
            contentRef: contentRef,
            footerRef: footerRef,
            closeRef: closeRef,
            hide: onClose,
            message: messageProps
        };
        return (0, $7nrKB.ObjectUtils).getJSXElement(inProps.content, templateElementProps);
    };
    var createElement = function createElement() {
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var resizer = createResizer();
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, header, content, footer, resizer);
    };
    var createDialog = function createDialog() {
        var headerId = idState + "_header";
        var contentId = idState + "_content";
        var transitionTimeout = {
            enter: props.position === "center" ? 150 : 300,
            exit: props.position === "center" ? 150 : 300
        };
        var maskProps = mergeProps({
            ref: maskRef,
            style: sx("mask"),
            className: cx("mask"),
            onPointerUp: onMaskPointerUp
        }, ptm("mask"));
        var rootProps = mergeProps({
            ref: dialogRef,
            id: idState,
            className: (0, $7nrKB.classNames)(props.className, cx("root", {
                props: props,
                maximized: maximized,
                context: context
            })),
            style: props.style,
            onClick: props.onClick,
            role: "dialog",
            "aria-labelledby": headerId,
            "aria-describedby": contentId,
            "aria-modal": props.modal,
            onPointerDown: onDialogPointerDown
        }, $c78d793cf2188210$var$DialogBase.getOtherProps(props), ptm("root"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            timeout: transitionTimeout,
            "in": visibleState,
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExiting: onExiting,
            onExited: onExited
        }, ptm("transition"));
        var contentElement = null;
        if (inProps !== null && inProps !== void 0 && inProps.content) contentElement = createTemplateElement();
        else contentElement = createElement();
        var rootElement = /*#__PURE__*/ $7E7Dk.createElement("div", maskProps, /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $c78d793cf2188210$var$_extends({
            nodeRef: dialogRef
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement($c78d793cf2188210$var$FocusTrap$1, {
            autoFocus: props.focusOnShow
        }, contentElement))));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
            element: rootElement,
            appendTo: props.appendTo,
            visible: true
        });
    };
    return maskVisibleState && createDialog();
});
$c78d793cf2188210$export$3ddf2d174ce01153.displayName = "Dialog";

});
parcelRegister("bgxh2", function(module, exports) {

$parcel$export(module.exports, "WindowMaximizeIcon", function () { return $833affd434b9e2bb$export$e9bf06badb7c79be; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $833affd434b9e2bb$var$_extends() {
    return $833affd434b9e2bb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $833affd434b9e2bb$var$_extends.apply(null, arguments);
}
var $833affd434b9e2bb$export$e9bf06badb7c79be = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $833affd434b9e2bb$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
        fill: "currentColor"
    }));
}));
$833affd434b9e2bb$export$e9bf06badb7c79be.displayName = "WindowMaximizeIcon";

});

parcelRegister("iXDZm", function(module, exports) {

$parcel$export(module.exports, "WindowMinimizeIcon", function () { return $dcdcc19682f58390$export$e1e96001ddb7b5e7; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $dcdcc19682f58390$var$_extends() {
    return $dcdcc19682f58390$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dcdcc19682f58390$var$_extends.apply(null, arguments);
}
var $dcdcc19682f58390$export$e1e96001ddb7b5e7 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $dcdcc19682f58390$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
        fill: "currentColor"
    }));
}));
$dcdcc19682f58390$export$e1e96001ddb7b5e7.displayName = "WindowMinimizeIcon";

});


parcelRegister("hB9Eg", function(module, exports) {

$parcel$export(module.exports, "OverlayService", function () { return $ccfd605252a61462$export$dbec172f58a34ef1; });

var $7nrKB = parcelRequire("7nrKB");
"use client";
var $ccfd605252a61462$export$dbec172f58a34ef1 = (0, $7nrKB.EventBus)();

});


parcelRegister("56EgM", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $3b7cc001c594a7a2$export$48513f6b9f8ce62d; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $eXeTx = parcelRequire("eXeTx");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $3b7cc001c594a7a2$var$_extends() {
    return $3b7cc001c594a7a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3b7cc001c594a7a2$var$_extends.apply(null, arguments);
}
function $3b7cc001c594a7a2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b7cc001c594a7a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b7cc001c594a7a2$var$_typeof(o);
}
function $3b7cc001c594a7a2$var$toPrimitive(t, r) {
    if ("object" != $3b7cc001c594a7a2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3b7cc001c594a7a2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3b7cc001c594a7a2$var$toPropertyKey(t) {
    var i = $3b7cc001c594a7a2$var$toPrimitive(t, "string");
    return "symbol" == $3b7cc001c594a7a2$var$_typeof(i) ? i : i + "";
}
function $3b7cc001c594a7a2$var$_defineProperty(e, r, t) {
    return (r = $3b7cc001c594a7a2$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3b7cc001c594a7a2$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $3b7cc001c594a7a2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3b7cc001c594a7a2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3b7cc001c594a7a2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3b7cc001c594a7a2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3b7cc001c594a7a2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3b7cc001c594a7a2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b7cc001c594a7a2$var$_slicedToArray(r, e) {
    return $3b7cc001c594a7a2$var$_arrayWithHoles(r) || $3b7cc001c594a7a2$var$_iterableToArrayLimit(r, e) || $3b7cc001c594a7a2$var$_unsupportedIterableToArray(r, e) || $3b7cc001c594a7a2$var$_nonIterableRest();
}
var $3b7cc001c594a7a2$var$classes = {
    box: "p-checkbox-box",
    input: "p-checkbox-input",
    icon: "p-checkbox-icon",
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $7nrKB.classNames)("p-checkbox p-component", {
            "p-highlight": checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $3b7cc001c594a7a2$var$CheckboxBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Checkbox",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $3b7cc001c594a7a2$var$classes
    }
});
function $3b7cc001c594a7a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b7cc001c594a7a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b7cc001c594a7a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3b7cc001c594a7a2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b7cc001c594a7a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b7cc001c594a7a2$export$48513f6b9f8ce62d = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $3b7cc001c594a7a2$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $3b7cc001c594a7a2$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $3b7cc001c594a7a2$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $kHEnT.useHandleStyle)($3b7cc001c594a7a2$var$CheckboxBase.css.styles, isUnstyled, {
        name: "checkbox"
    });
    var elementRef = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readOnly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: "checkbox",
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $7nrKB.DomHandler).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus(event) {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var _onBlur = function onBlur(event) {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $jr5t3.useMountEffect)(function() {
        if (props.autoFocus) (0, $7nrKB.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $3b7cc001c594a7a2$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            checked: checked,
            context: context
        })),
        style: props.style,
        "data-p-highlight": checked,
        "data-p-disabled": props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm("root"));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $7nrKB.ObjectUtils).reduceKeys(otherProps, (0, $7nrKB.DomHandler).ARIA_PROPS);
        var inputProps = mergeProps($3b7cc001c594a7a2$var$_objectSpread({
            id: props.inputId,
            type: "checkbox",
            className: cx("input"),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus(e);
            },
            onBlur: function onBlur(e) {
                return _onBlur(e);
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            "aria-invalid": props.invalid,
            checked: checked
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $7E7Dk.createElement("input", $3b7cc001c594a7a2$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var boxProps = mergeProps({
            className: cx("box", {
                checked: checked
            }),
            "data-p-highlight": checked,
            "data-p-disabled": props.disabled
        }, ptm("box"));
        var icon = checked ? props.icon || /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), iconProps) : null;
        var checkboxIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $3b7cc001c594a7a2$var$_objectSpread({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $7E7Dk.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", $3b7cc001c594a7a2$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $3b7cc001c594a7a2$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$3b7cc001c594a7a2$export$48513f6b9f8ce62d.displayName = "Checkbox";

});

parcelRegister("5u6k9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e681a986522b04$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $6BXTl = parcelRequire("6BXTl");
const $69e681a986522b04$var$useText = ()=>{
    const intl = (0, $6BXTl.default)();
    const text = (0, $7E7Dk.useCallback)((id, values)=>{
        return intl.formatMessage({
            id: id
        }, values) ?? id;
    }, [
        intl
    ]);
    return text;
};
var $69e681a986522b04$export$2e2bcd8739ae039 = $69e681a986522b04$var$useText;

});
parcelRegister("6BXTl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d04a807ae9a1ea6$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $er4Ja = parcelRequire("er4Ja");

var $cfMpI = parcelRequire("cfMpI");
function $4d04a807ae9a1ea6$export$2e2bcd8739ae039() {
    var intl = $7E7Dk.useContext((0, $er4Ja.Context));
    (0, $cfMpI.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("MMfqT", function(module, exports) {
$parcel$export(module.exports, "defaultDialogProps", function () { return (parcelRequire("eySth")).defaultDialogProps; });
$parcel$export(module.exports, "Dialog", function () { return (parcelRequire("eySth")).Dialog; });
parcelRequire("eySth");

});
parcelRegister("eySth", function(module, exports) {

$parcel$export(module.exports, "defaultDialogProps", function () { return $40ee9a47c101621a$export$1a17757f4e22f758; });
$parcel$export(module.exports, "Dialog", function () { return $40ee9a47c101621a$export$3ddf2d174ce01153; });

var $7E7Dk = parcelRequire("7E7Dk");

var $h8dgv = parcelRequire("h8dgv");

var $7nrKB = parcelRequire("7nrKB");
const $40ee9a47c101621a$export$1a17757f4e22f758 = {
    breakpoints: {
        "960px": "75vw",
        "641px": "90vw"
    },
    blockScroll: true,
    closable: true,
    dismissableMask: true,
    draggable: false,
    modal: true,
    style: {
        width: "40rem"
    }
};
const $40ee9a47c101621a$export$3ddf2d174ce01153 = ({ breakpoints: breakpoints = $40ee9a47c101621a$export$1a17757f4e22f758.breakpoints, style: style, maskStyle: maskStyle, ...props })=>{
    // Percentage and CSS viewport widths change when the root scrollbar gutter returns during exit.
    const [viewportWidth, setViewportWidth] = (0, $7E7Dk.useState)(()=>window.innerWidth);
    (0, $7E7Dk.useEffect)(()=>{
        const updateViewportWidth = ()=>setViewportWidth(window.innerWidth);
        window.addEventListener("resize", updateViewportWidth);
        return ()=>window.removeEventListener("resize", updateViewportWidth);
    }, []);
    (0, $7E7Dk.useLayoutEffect)(()=>{
        if (props.visible) (0, $7nrKB.DomHandler).blockBodyScroll();
    }, [
        props.visible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $h8dgv.Dialog), {
        ...props,
        ...$40ee9a47c101621a$export$1a17757f4e22f758,
        breakpoints: breakpoints,
        maskStyle: {
            ...maskStyle,
            width: viewportWidth
        },
        style: {
            ...$40ee9a47c101621a$export$1a17757f4e22f758.style,
            ...style
        }
    });
};

});




parcelRegister("10c6O", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $0baf2f1d9568c8df$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $0baf2f1d9568c8df$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $0baf2f1d9568c8df$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $0baf2f1d9568c8df$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $0baf2f1d9568c8df$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $0baf2f1d9568c8df$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $0baf2f1d9568c8df$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $0baf2f1d9568c8df$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $0baf2f1d9568c8df$var$symbol_observable_default = $0baf2f1d9568c8df$var$$$observable;
// src/utils/actionTypes.ts
var $0baf2f1d9568c8df$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $0baf2f1d9568c8df$var$ActionTypes = {
    INIT: `@@redux/INIT${$0baf2f1d9568c8df$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$0baf2f1d9568c8df$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$0baf2f1d9568c8df$var$randomString()}`
};
var $0baf2f1d9568c8df$export$4219e499db7ca678 = $0baf2f1d9568c8df$var$ActionTypes;
// src/utils/isPlainObject.ts
function $0baf2f1d9568c8df$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $0baf2f1d9568c8df$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($0baf2f1d9568c8df$var$isDate(val)) return "date";
    if ($0baf2f1d9568c8df$var$isError(val)) return "error";
    const constructorName = $0baf2f1d9568c8df$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $0baf2f1d9568c8df$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $0baf2f1d9568c8df$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $0baf2f1d9568c8df$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $0baf2f1d9568c8df$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $0baf2f1d9568c8df$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(1));
        return enhancer($0baf2f1d9568c8df$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$0baf2f1d9568c8df$export$53b83ca8eaab0383(action)) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $0baf2f1d9568c8df$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$0baf2f1d9568c8df$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $0baf2f1d9568c8df$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$0baf2f1d9568c8df$var$symbol_observable_default]: observable
    };
    return store;
}
function $0baf2f1d9568c8df$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $0baf2f1d9568c8df$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $0baf2f1d9568c8df$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $0baf2f1d9568c8df$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $0baf2f1d9568c8df$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$0baf2f1d9568c8df$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$0baf2f1d9568c8df$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $0baf2f1d9568c8df$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $0baf2f1d9568c8df$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $0baf2f1d9568c8df$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $0baf2f1d9568c8df$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(13));
    });
}
function $0baf2f1d9568c8df$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $0baf2f1d9568c8df$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $0baf2f1d9568c8df$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $0baf2f1d9568c8df$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $0baf2f1d9568c8df$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $0baf2f1d9568c8df$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $0baf2f1d9568c8df$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $0baf2f1d9568c8df$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($0baf2f1d9568c8df$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $0baf2f1d9568c8df$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $0baf2f1d9568c8df$export$b956e38827fca970(action) {
    return $0baf2f1d9568c8df$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("gtjDQ", function(module, exports) {

$parcel$export(module.exports, "createAction", function () { return $bfde97392fa8942e$export$309c7a02b0b0bc62; });
$parcel$export(module.exports, "formatProdErrorMessage", function () { return $bfde97392fa8942e$export$378fa86b259c0280; });
$parcel$export(module.exports, "SHOULD_AUTOBATCH", function () { return $bfde97392fa8942e$export$8fb31c0f05df007b; });
$parcel$export(module.exports, "prepareAutoBatched", function () { return $bfde97392fa8942e$export$39fcd5145ec5e4e2; });
$parcel$export(module.exports, "configureStore", function () { return $bfde97392fa8942e$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "isAnyOf", function () { return $bfde97392fa8942e$export$2c3435c7647f7b0d; });
$parcel$export(module.exports, "isAllOf", function () { return $bfde97392fa8942e$export$9dd1fb32974da385; });
$parcel$export(module.exports, "isPending", function () { return $bfde97392fa8942e$export$872dec21e9a69476; });
$parcel$export(module.exports, "isRejected", function () { return $bfde97392fa8942e$export$a5c5d27e3994c5be; });
$parcel$export(module.exports, "isRejectedWithValue", function () { return $bfde97392fa8942e$export$fcc3388fb56de601; });
$parcel$export(module.exports, "isFulfilled", function () { return $bfde97392fa8942e$export$1da80a6ef1307441; });
$parcel$export(module.exports, "isAsyncThunkAction", function () { return $bfde97392fa8942e$export$6aa4142d99c1abce; });
$parcel$export(module.exports, "nanoid", function () { return $bfde97392fa8942e$export$ac4959f4f1338dfc; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $bfde97392fa8942e$export$6abd22dc03e5063f; });
$parcel$export(module.exports, "createSlice", function () { return $bfde97392fa8942e$export$4d8d9bd83c24ae8b; });
$parcel$export(module.exports, "createNextState", function () { return (parcelRequire("j4Mta")).produce; });

var $10c6O = parcelRequire("10c6O");

var $j4Mta = parcelRequire("j4Mta");

var $2ATxG = parcelRequire("2ATxG");

var $kG3OK = parcelRequire("kG3OK");

var $4YPvm = parcelRequire("4YPvm");
var $bfde97392fa8942e$var$__defProp = Object.defineProperty;
var $bfde97392fa8942e$var$__defProps = Object.defineProperties;
var $bfde97392fa8942e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $bfde97392fa8942e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bfde97392fa8942e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bfde97392fa8942e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bfde97392fa8942e$var$__defNormalProp = (obj, key, value)=>key in obj ? $bfde97392fa8942e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bfde97392fa8942e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bfde97392fa8942e$var$__hasOwnProp.call(b, prop)) $bfde97392fa8942e$var$__defNormalProp(a, prop, b[prop]);
    if ($bfde97392fa8942e$var$__getOwnPropSymbols) {
        for (var prop of $bfde97392fa8942e$var$__getOwnPropSymbols(b))if ($bfde97392fa8942e$var$__propIsEnum.call(b, prop)) $bfde97392fa8942e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bfde97392fa8942e$var$__spreadProps = (a, b)=>$bfde97392fa8942e$var$__defProps(a, $bfde97392fa8942e$var$__getOwnPropDescs(b));
var $bfde97392fa8942e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($bfde97392fa8942e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $bfde97392fa8942e$var$__getOwnPropSymbols) {
        for (var prop of $bfde97392fa8942e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $bfde97392fa8942e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $bfde97392fa8942e$var$__publicField = (obj, key, value)=>$bfde97392fa8942e$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $bfde97392fa8942e$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $2ATxG.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $j4Mta.isDraft)(value) ? (0, $j4Mta.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $bfde97392fa8942e$export$a5d3c27355e35910 = /* @__PURE__ */ $bfde97392fa8942e$export$aab6de9e3dbb1473((0, $2ATxG.weakMapMemoize));
var $bfde97392fa8942e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $10c6O.compose;
    return (0, $10c6O.compose).apply(null, arguments);
};
var $bfde97392fa8942e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $bfde97392fa8942e$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $bfde97392fa8942e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(0));
            return $bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $10c6O.isAction)(action) && action.type === type;
    return actionCreator;
}
function $bfde97392fa8942e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $bfde97392fa8942e$var$hasMatchFunction(action);
}
function $bfde97392fa8942e$export$ebd532f9034651f3(action) {
    return (0, $10c6O.isAction)(action) && Object.keys(action).every($bfde97392fa8942e$var$isValidKey);
}
function $bfde97392fa8942e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $bfde97392fa8942e$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $bfde97392fa8942e$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $bfde97392fa8942e$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $bfde97392fa8942e$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $bfde97392fa8942e$var$freezeDraftable(val) {
    return (0, $j4Mta.isDraftable)(val) ? (0, $j4Mta.produce)(val, ()=>{}) : val;
}
function $bfde97392fa8942e$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $bfde97392fa8942e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $bfde97392fa8942e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $bfde97392fa8942e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $bfde97392fa8942e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $bfde97392fa8942e$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $bfde97392fa8942e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $bfde97392fa8942e$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $bfde97392fa8942e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $bfde97392fa8942e$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $bfde97392fa8942e$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $10c6O.isPlainObject)(val);
}
function $bfde97392fa8942e$export$ada5dca0b571bc7(value, path = "", isSerializable = $bfde97392fa8942e$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $bfde97392fa8942e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $bfde97392fa8942e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $bfde97392fa8942e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$bfde97392fa8942e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $bfde97392fa8942e$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $bfde97392fa8942e$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $bfde97392fa8942e$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $bfde97392fa8942e$export$1908877435b1d5e9();
        if (thunk) {
            if ($bfde97392fa8942e$var$isBoolean(thunk)) middlewareArray.push((0, $kG3OK.thunk));
            else middlewareArray.push((0, $kG3OK.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $bfde97392fa8942e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $bfde97392fa8942e$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$bfde97392fa8942e$export$8fb31c0f05df007b]: true
            }
        });
var $bfde97392fa8942e$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $bfde97392fa8942e$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $bfde97392fa8942e$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $bfde97392fa8942e$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$bfde97392fa8942e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $bfde97392fa8942e$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $bfde97392fa8942e$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($bfde97392fa8942e$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $bfde97392fa8942e$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $bfde97392fa8942e$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $10c6O.isPlainObject)(reducer)) rootReducer = (0, $10c6O.combineReducers)(reducer);
    else throw new Error($bfde97392fa8942e$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $10c6O.compose);
    if (devTools) finalCompose = $bfde97392fa8942e$var$composeWithDevTools($bfde97392fa8942e$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $10c6O.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $bfde97392fa8942e$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $10c6O.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $bfde97392fa8942e$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $bfde97392fa8942e$var$isStateFunction(x) {
    return typeof x === "function";
}
function $bfde97392fa8942e$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $bfde97392fa8942e$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($bfde97392fa8942e$var$isStateFunction(initialState)) getInitialState = ()=>$bfde97392fa8942e$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $bfde97392fa8942e$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $j4Mta.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $j4Mta.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $j4Mta.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $bfde97392fa8942e$var$matches = (matcher, action)=>{
    if ($bfde97392fa8942e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $bfde97392fa8942e$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$bfde97392fa8942e$var$matches(matcher, action));
    };
}
function $bfde97392fa8942e$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$bfde97392fa8942e$var$matches(matcher, action));
    };
}
function $bfde97392fa8942e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $bfde97392fa8942e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $bfde97392fa8942e$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$bfde97392fa8942e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$bfde97392fa8942e$var$isAsyncThunkArray(asyncThunks)) return $bfde97392fa8942e$export$872dec21e9a69476()(asyncThunks[0]);
    return $bfde97392fa8942e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $bfde97392fa8942e$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$bfde97392fa8942e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$bfde97392fa8942e$var$isAsyncThunkArray(asyncThunks)) return $bfde97392fa8942e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $bfde97392fa8942e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $bfde97392fa8942e$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $bfde97392fa8942e$export$9dd1fb32974da385($bfde97392fa8942e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$bfde97392fa8942e$var$isAsyncThunkArray(asyncThunks)) return $bfde97392fa8942e$export$fcc3388fb56de601()(asyncThunks[0]);
    return $bfde97392fa8942e$export$9dd1fb32974da385($bfde97392fa8942e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $bfde97392fa8942e$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$bfde97392fa8942e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$bfde97392fa8942e$var$isAsyncThunkArray(asyncThunks)) return $bfde97392fa8942e$export$1da80a6ef1307441()(asyncThunks[0]);
    return $bfde97392fa8942e$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $bfde97392fa8942e$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$bfde97392fa8942e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$bfde97392fa8942e$var$isAsyncThunkArray(asyncThunks)) return $bfde97392fa8942e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $bfde97392fa8942e$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $bfde97392fa8942e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $bfde97392fa8942e$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $bfde97392fa8942e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $bfde97392fa8942e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $bfde97392fa8942e$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $bfde97392fa8942e$var$__publicField(this, "_type");
    }
};
var $bfde97392fa8942e$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $bfde97392fa8942e$var$__publicField(this, "_type");
    }
};
var $bfde97392fa8942e$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $bfde97392fa8942e$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $bfde97392fa8942e$var$externalAbortMessage = "External signal was aborted";
var $bfde97392fa8942e$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $bfde97392fa8942e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $bfde97392fa8942e$var$__spreadProps($bfde97392fa8942e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $bfde97392fa8942e$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $bfde97392fa8942e$var$__spreadProps($bfde97392fa8942e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $bfde97392fa8942e$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $bfde97392fa8942e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $bfde97392fa8942e$var$__spreadProps($bfde97392fa8942e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $bfde97392fa8942e$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($bfde97392fa8942e$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($bfde97392fa8942e$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($bfde97392fa8942e$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $bfde97392fa8942e$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $bfde97392fa8942e$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $bfde97392fa8942e$var$RejectWithValue) throw result;
                                if (result instanceof $bfde97392fa8942e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $bfde97392fa8942e$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($bfde97392fa8942e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $bfde97392fa8942e$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $bfde97392fa8942e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $bfde97392fa8942e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $bfde97392fa8942e$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $bfde97392fa8942e$export$343355ed40c51c46 = {
    [$bfde97392fa8942e$var$asyncThunkSymbol]: $bfde97392fa8942e$export$6abd22dc03e5063f
};
var $bfde97392fa8942e$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($bfde97392fa8942e$export$23a094319a4b586 || {});
function $bfde97392fa8942e$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $bfde97392fa8942e$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$bfde97392fa8942e$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(11));
        typeof $4YPvm;
        const reducers = (typeof options.reducers === "function" ? options.reducers($bfde97392fa8942e$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $bfde97392fa8942e$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($bfde97392fa8942e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $bfde97392fa8942e$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $bfde97392fa8942e$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $bfde97392fa8942e$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $bfde97392fa8942e$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $bfde97392fa8942e$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $bfde97392fa8942e$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $bfde97392fa8942e$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $bfde97392fa8942e$var$wrapSelector(selector, selectState, ()=>$bfde97392fa8942e$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $bfde97392fa8942e$var$__spreadProps($bfde97392fa8942e$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $bfde97392fa8942e$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $bfde97392fa8942e$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $bfde97392fa8942e$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $bfde97392fa8942e$export$affdea4146de9cf5();
function $bfde97392fa8942e$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $bfde97392fa8942e$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $bfde97392fa8942e$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$bfde97392fa8942e$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $bfde97392fa8942e$export$309c7a02b0b0bc62(type, prepareCallback) : $bfde97392fa8942e$export$309c7a02b0b0bc62(type));
}
function $bfde97392fa8942e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $bfde97392fa8942e$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $bfde97392fa8942e$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $bfde97392fa8942e$var$noop,
        pending: pending || $bfde97392fa8942e$var$noop,
        rejected: rejected || $bfde97392fa8942e$var$noop,
        settled: settled || $bfde97392fa8942e$var$noop
    });
}
function $bfde97392fa8942e$var$noop() {}
// src/entities/entity_state.ts
function $bfde97392fa8942e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $bfde97392fa8942e$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($bfde97392fa8942e$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $bfde97392fa8942e$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $bfde97392fa8942e$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $bfde97392fa8942e$var$isDraftTyped = (0, $j4Mta.isDraft);
function $bfde97392fa8942e$var$createSingleArgumentStateOperator(mutator) {
    const operator = $bfde97392fa8942e$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $bfde97392fa8942e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $bfde97392fa8942e$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($bfde97392fa8942e$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $j4Mta.produce)(state, runMutator);
    };
}
function $bfde97392fa8942e$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $bfde97392fa8942e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $bfde97392fa8942e$var$getCurrent(value) {
    return (0, $j4Mta.isDraft)(value) ? (0, $j4Mta.current)(value) : value;
}
function $bfde97392fa8942e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $bfde97392fa8942e$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $bfde97392fa8942e$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $bfde97392fa8942e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $bfde97392fa8942e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $bfde97392fa8942e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $bfde97392fa8942e$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$bfde97392fa8942e$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $bfde97392fa8942e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $bfde97392fa8942e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $bfde97392fa8942e$var$createStateOperator(addOneMutably),
        addMany: $bfde97392fa8942e$var$createStateOperator(addManyMutably),
        setOne: $bfde97392fa8942e$var$createStateOperator(setOneMutably),
        setMany: $bfde97392fa8942e$var$createStateOperator(setManyMutably),
        setAll: $bfde97392fa8942e$var$createStateOperator(setAllMutably),
        updateOne: $bfde97392fa8942e$var$createStateOperator(updateOneMutably),
        updateMany: $bfde97392fa8942e$var$createStateOperator(updateManyMutably),
        upsertOne: $bfde97392fa8942e$var$createStateOperator(upsertOneMutably),
        upsertMany: $bfde97392fa8942e$var$createStateOperator(upsertManyMutably),
        removeOne: $bfde97392fa8942e$var$createStateOperator(removeOneMutably),
        removeMany: $bfde97392fa8942e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $bfde97392fa8942e$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $bfde97392fa8942e$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $bfde97392fa8942e$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $bfde97392fa8942e$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $bfde97392fa8942e$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $bfde97392fa8942e$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($bfde97392fa8942e$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $bfde97392fa8942e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $bfde97392fa8942e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $bfde97392fa8942e$var$getCurrent(state.entities);
        const currentIds = $bfde97392fa8942e$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $bfde97392fa8942e$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $bfde97392fa8942e$var$createStateOperator(addOneMutably),
        updateOne: $bfde97392fa8942e$var$createStateOperator(updateOneMutably),
        upsertOne: $bfde97392fa8942e$var$createStateOperator(upsertOneMutably),
        setOne: $bfde97392fa8942e$var$createStateOperator(setOneMutably),
        setMany: $bfde97392fa8942e$var$createStateOperator(setManyMutably),
        setAll: $bfde97392fa8942e$var$createStateOperator(setAllMutably),
        addMany: $bfde97392fa8942e$var$createStateOperator(addManyMutably),
        updateMany: $bfde97392fa8942e$var$createStateOperator(updateManyMutably),
        upsertMany: $bfde97392fa8942e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $bfde97392fa8942e$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $bfde97392fa8942e$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $bfde97392fa8942e$var$createSortedStateAdapter(selectId, sortComparer) : $bfde97392fa8942e$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $bfde97392fa8942e$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $bfde97392fa8942e$var$createSelectorsFactory();
    return $bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues($bfde97392fa8942e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $bfde97392fa8942e$var$task = "task";
var $bfde97392fa8942e$var$listener = "listener";
var $bfde97392fa8942e$var$completed = "completed";
var $bfde97392fa8942e$var$cancelled = "cancelled";
var $bfde97392fa8942e$var$taskCancelled = `task-${$bfde97392fa8942e$var$cancelled}`;
var $bfde97392fa8942e$var$taskCompleted = `task-${$bfde97392fa8942e$var$completed}`;
var $bfde97392fa8942e$var$listenerCancelled = `${$bfde97392fa8942e$var$listener}-${$bfde97392fa8942e$var$cancelled}`;
var $bfde97392fa8942e$var$listenerCompleted = `${$bfde97392fa8942e$var$listener}-${$bfde97392fa8942e$var$completed}`;
var $bfde97392fa8942e$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $bfde97392fa8942e$var$__publicField(this, "name", "TaskAbortError");
        $bfde97392fa8942e$var$__publicField(this, "message");
        this.message = `${$bfde97392fa8942e$var$task} ${$bfde97392fa8942e$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $bfde97392fa8942e$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($bfde97392fa8942e$export$378fa86b259c0280(32));
};
var $bfde97392fa8942e$var$noop2 = ()=>{};
var $bfde97392fa8942e$var$catchRejection = (promise, onError = $bfde97392fa8942e$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $bfde97392fa8942e$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $bfde97392fa8942e$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $bfde97392fa8942e$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $bfde97392fa8942e$export$cb1bdac908fed7f(reason);
    }
};
function $bfde97392fa8942e$var$raceWithSignal(signal, promise) {
    let cleanup = $bfde97392fa8942e$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $bfde97392fa8942e$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $bfde97392fa8942e$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $bfde97392fa8942e$var$noop2;
    });
}
var $bfde97392fa8942e$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $bfde97392fa8942e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $bfde97392fa8942e$var$createPause = (signal)=>{
    return (promise)=>{
        return $bfde97392fa8942e$var$catchRejection($bfde97392fa8942e$var$raceWithSignal(signal, promise).then((output)=>{
            $bfde97392fa8942e$var$validateActive(signal);
            return output;
        }));
    };
};
var $bfde97392fa8942e$var$createDelay = (signal)=>{
    const pause = $bfde97392fa8942e$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $bfde97392fa8942e$var$assign } = Object;
var $bfde97392fa8942e$var$INTERNAL_NIL_TOKEN = {};
var $bfde97392fa8942e$var$alm = "listenerMiddleware";
var $bfde97392fa8942e$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$bfde97392fa8942e$var$addAbortSignalListener(parentAbortSignal, ()=>$bfde97392fa8942e$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $bfde97392fa8942e$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $bfde97392fa8942e$var$runTask(async ()=>{
            $bfde97392fa8942e$var$validateActive(parentAbortSignal);
            $bfde97392fa8942e$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $bfde97392fa8942e$var$createPause(childAbortController.signal),
                delay: $bfde97392fa8942e$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $bfde97392fa8942e$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$bfde97392fa8942e$var$abortControllerWithReason(childAbortController, $bfde97392fa8942e$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($bfde97392fa8942e$var$noop2));
        return {
            result: $bfde97392fa8942e$var$createPause(parentAbortSignal)(result),
            cancel () {
                $bfde97392fa8942e$var$abortControllerWithReason(childAbortController, $bfde97392fa8942e$var$taskCancelled);
            }
        };
    };
};
var $bfde97392fa8942e$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $bfde97392fa8942e$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $bfde97392fa8942e$var$raceWithSignal(signal, Promise.race(promises));
            $bfde97392fa8942e$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$bfde97392fa8942e$var$catchRejection(take(predicate, timeout));
};
var $bfde97392fa8942e$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $bfde97392fa8942e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($bfde97392fa8942e$export$378fa86b259c0280(21));
    $bfde97392fa8942e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $bfde97392fa8942e$var$createListenerEntry = /* @__PURE__ */ $bfde97392fa8942e$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $bfde97392fa8942e$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $bfde97392fa8942e$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($bfde97392fa8942e$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$bfde97392fa8942e$var$createListenerEntry
});
var $bfde97392fa8942e$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $bfde97392fa8942e$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $bfde97392fa8942e$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $bfde97392fa8942e$var$abortControllerWithReason(controller, $bfde97392fa8942e$var$listenerCancelled);
    });
};
var $bfde97392fa8942e$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($bfde97392fa8942e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $bfde97392fa8942e$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $bfde97392fa8942e$export$f03a6b845d3fb58b = /* @__PURE__ */ $bfde97392fa8942e$var$assign(/* @__PURE__ */ $bfde97392fa8942e$export$309c7a02b0b0bc62(`${$bfde97392fa8942e$var$alm}/add`), {
    withTypes: ()=>$bfde97392fa8942e$export$f03a6b845d3fb58b
});
var $bfde97392fa8942e$export$b1b8022855fb2b71 = /* @__PURE__ */ $bfde97392fa8942e$export$309c7a02b0b0bc62(`${$bfde97392fa8942e$var$alm}/removeAll`);
var $bfde97392fa8942e$export$b03e9483f936dccb = /* @__PURE__ */ $bfde97392fa8942e$var$assign(/* @__PURE__ */ $bfde97392fa8942e$export$309c7a02b0b0bc62(`${$bfde97392fa8942e$var$alm}/remove`), {
    withTypes: ()=>$bfde97392fa8942e$export$b03e9483f936dccb
});
var $bfde97392fa8942e$var$defaultErrorHandler = (...args)=>{
    console.error(`${$bfde97392fa8942e$var$alm}/error`, ...args);
};
var $bfde97392fa8942e$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $bfde97392fa8942e$var$defaultErrorHandler } = middlewareOptions;
    $bfde97392fa8942e$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $bfde97392fa8942e$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $bfde97392fa8942e$var$findListenerEntry(listenerMap, options)) != null ? _a : $bfde97392fa8942e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $bfde97392fa8942e$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $bfde97392fa8942e$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $bfde97392fa8942e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $bfde97392fa8942e$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $bfde97392fa8942e$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $bfde97392fa8942e$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $bfde97392fa8942e$var$createDelay(internalTaskController.signal),
                pause: $bfde97392fa8942e$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $bfde97392fa8942e$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $bfde97392fa8942e$var$abortControllerWithReason(controller, $bfde97392fa8942e$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $bfde97392fa8942e$var$abortControllerWithReason(internalTaskController, $bfde97392fa8942e$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $bfde97392fa8942e$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $bfde97392fa8942e$export$cb1bdac908fed7f)) $bfde97392fa8942e$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $bfde97392fa8942e$var$abortControllerWithReason(internalTaskController, $bfde97392fa8942e$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $bfde97392fa8942e$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $10c6O.isAction)(action)) return next(action);
                if ($bfde97392fa8942e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($bfde97392fa8942e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($bfde97392fa8942e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $bfde97392fa8942e$var$INTERNAL_NIL_TOKEN) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $bfde97392fa8942e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $bfde97392fa8942e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $bfde97392fa8942e$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $bfde97392fa8942e$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $bfde97392fa8942e$export$4bb1606a79445586 = ()=>{
    const instanceId = $bfde97392fa8942e$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($bfde97392fa8942e$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $bfde97392fa8942e$var$getOrInsertComputed(middlewareMap, middleware2, $bfde97392fa8942e$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$bfde97392fa8942e$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $10c6O.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $bfde97392fa8942e$export$9dd1fb32974da385(withMiddleware, $bfde97392fa8942e$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $bfde97392fa8942e$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $bfde97392fa8942e$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$bfde97392fa8942e$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $bfde97392fa8942e$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $bfde97392fa8942e$var$isStateProxy = (value)=>!!value && !!value[$bfde97392fa8942e$var$ORIGINAL_STATE];
var $bfde97392fa8942e$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $bfde97392fa8942e$var$createStateProxy = (state, reducerMap, initialStateCache)=>$bfde97392fa8942e$var$getOrInsertComputed($bfde97392fa8942e$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $bfde97392fa8942e$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $bfde97392fa8942e$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($bfde97392fa8942e$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $bfde97392fa8942e$var$original = (state)=>{
    if (!$bfde97392fa8942e$var$isStateProxy(state)) throw new Error($bfde97392fa8942e$export$378fa86b259c0280(25));
    return state[$bfde97392fa8942e$var$ORIGINAL_STATE];
};
var $bfde97392fa8942e$var$emptyObject = {};
var $bfde97392fa8942e$var$noopReducer = (state = $bfde97392fa8942e$var$emptyObject)=>state;
function $bfde97392fa8942e$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($bfde97392fa8942e$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $10c6O.combineReducers)(reducerMap) : $bfde97392fa8942e$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $4YPvm;
            return combinedReducer;
        }
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($bfde97392fa8942e$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $bfde97392fa8942e$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $bfde97392fa8942e$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("j4Mta", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $de33fd0b434498d0$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $de33fd0b434498d0$export$16e3aed3edb85946; });
$parcel$export(module.exports, "original", function () { return $de33fd0b434498d0$export$22e8af3f75a010e3; });
$parcel$export(module.exports, "current", function () { return $de33fd0b434498d0$export$97aac956da55dae9; });
$parcel$export(module.exports, "enablePatches", function () { return $de33fd0b434498d0$export$d3a6659991a0696c; });
$parcel$export(module.exports, "produce", function () { return $de33fd0b434498d0$export$b46cabe22e78bc00; });
$parcel$export(module.exports, "produceWithPatches", function () { return $de33fd0b434498d0$export$4da66d41c9492c78; });
$parcel$export(module.exports, "applyPatches", function () { return $de33fd0b434498d0$export$a8b8e03e6bbe5473; });
var $de33fd0b434498d0$var$__defProp = Object.defineProperty;
var $de33fd0b434498d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $de33fd0b434498d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $de33fd0b434498d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $de33fd0b434498d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $de33fd0b434498d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $de33fd0b434498d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($de33fd0b434498d0$var$__hasOwnProp.call(b, prop)) $de33fd0b434498d0$var$__defNormalProp(a, prop, b[prop]);
    if ($de33fd0b434498d0$var$__getOwnPropSymbols) {
        for (var prop of $de33fd0b434498d0$var$__getOwnPropSymbols(b))if ($de33fd0b434498d0$var$__propIsEnum.call(b, prop)) $de33fd0b434498d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $de33fd0b434498d0$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $de33fd0b434498d0$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $de33fd0b434498d0$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $de33fd0b434498d0$var$errors = [];
function $de33fd0b434498d0$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $de33fd0b434498d0$var$getPrototypeOf = Object.getPrototypeOf;
function $de33fd0b434498d0$export$541ac630993a4c84(value) {
    return !!value && !!value[$de33fd0b434498d0$var$DRAFT_STATE];
}
function $de33fd0b434498d0$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $de33fd0b434498d0$var$isPlainObject(value) || Array.isArray(value) || !!value[$de33fd0b434498d0$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$de33fd0b434498d0$export$6ee2082928bcb0ee]) || $de33fd0b434498d0$var$isMap(value) || $de33fd0b434498d0$var$isSet(value);
}
var $de33fd0b434498d0$var$objectCtorString = Object.prototype.constructor.toString();
function $de33fd0b434498d0$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $de33fd0b434498d0$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $de33fd0b434498d0$var$objectCtorString;
}
function $de33fd0b434498d0$export$22e8af3f75a010e3(value) {
    if (!$de33fd0b434498d0$export$541ac630993a4c84(value)) $de33fd0b434498d0$var$die(15, value);
    return value[$de33fd0b434498d0$var$DRAFT_STATE].base_;
}
function $de33fd0b434498d0$var$each(obj, iter) {
    if ($de33fd0b434498d0$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $de33fd0b434498d0$var$getArchtype(thing) {
    const state = thing[$de33fd0b434498d0$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $de33fd0b434498d0$var$isMap(thing) ? 2 /* Map */  : $de33fd0b434498d0$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $de33fd0b434498d0$var$has(thing, prop) {
    return $de33fd0b434498d0$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $de33fd0b434498d0$var$get(thing, prop) {
    return $de33fd0b434498d0$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $de33fd0b434498d0$var$set(thing, propOrOldValue, value) {
    const t = $de33fd0b434498d0$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $de33fd0b434498d0$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $de33fd0b434498d0$var$isMap(target) {
    return target instanceof Map;
}
function $de33fd0b434498d0$var$isSet(target) {
    return target instanceof Set;
}
function $de33fd0b434498d0$var$latest(state) {
    return state.copy_ || state.base_;
}
function $de33fd0b434498d0$var$shallowCopy(base, strict) {
    if ($de33fd0b434498d0$var$isMap(base)) return new Map(base);
    if ($de33fd0b434498d0$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $de33fd0b434498d0$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$de33fd0b434498d0$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($de33fd0b434498d0$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $de33fd0b434498d0$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $de33fd0b434498d0$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $de33fd0b434498d0$export$792f3d81ea979f55(obj, deep = false) {
    if ($de33fd0b434498d0$var$isFrozen(obj) || $de33fd0b434498d0$export$541ac630993a4c84(obj) || !$de33fd0b434498d0$export$16e3aed3edb85946(obj)) return obj;
    if ($de33fd0b434498d0$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $de33fd0b434498d0$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$de33fd0b434498d0$export$792f3d81ea979f55(value, true));
    return obj;
}
function $de33fd0b434498d0$var$dontMutateFrozenCollections() {
    $de33fd0b434498d0$var$die(2);
}
function $de33fd0b434498d0$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $de33fd0b434498d0$var$plugins = {};
function $de33fd0b434498d0$var$getPlugin(pluginKey) {
    const plugin = $de33fd0b434498d0$var$plugins[pluginKey];
    if (!plugin) $de33fd0b434498d0$var$die(0, pluginKey);
    return plugin;
}
function $de33fd0b434498d0$var$loadPlugin(pluginKey, implementation) {
    if (!$de33fd0b434498d0$var$plugins[pluginKey]) $de33fd0b434498d0$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $de33fd0b434498d0$var$currentScope;
function $de33fd0b434498d0$var$getCurrentScope() {
    return $de33fd0b434498d0$var$currentScope;
}
function $de33fd0b434498d0$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $de33fd0b434498d0$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $de33fd0b434498d0$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $de33fd0b434498d0$var$revokeScope(scope) {
    $de33fd0b434498d0$var$leaveScope(scope);
    scope.drafts_.forEach($de33fd0b434498d0$var$revokeDraft);
    scope.drafts_ = null;
}
function $de33fd0b434498d0$var$leaveScope(scope) {
    if (scope === $de33fd0b434498d0$var$currentScope) $de33fd0b434498d0$var$currentScope = scope.parent_;
}
function $de33fd0b434498d0$var$enterScope(immer2) {
    return $de33fd0b434498d0$var$currentScope = $de33fd0b434498d0$var$createScope($de33fd0b434498d0$var$currentScope, immer2);
}
function $de33fd0b434498d0$var$revokeDraft(draft) {
    const state = draft[$de33fd0b434498d0$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $de33fd0b434498d0$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$de33fd0b434498d0$var$DRAFT_STATE].modified_) {
            $de33fd0b434498d0$var$revokeScope(scope);
            $de33fd0b434498d0$var$die(4);
        }
        if ($de33fd0b434498d0$export$16e3aed3edb85946(result)) {
            result = $de33fd0b434498d0$var$finalize(scope, result);
            if (!scope.parent_) $de33fd0b434498d0$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $de33fd0b434498d0$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$de33fd0b434498d0$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $de33fd0b434498d0$var$finalize(scope, baseDraft, []);
    $de33fd0b434498d0$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $de33fd0b434498d0$export$45b790e32b2810ee ? result : void 0;
}
function $de33fd0b434498d0$var$finalize(rootScope, value, path) {
    if ($de33fd0b434498d0$var$isFrozen(value)) return value;
    const state = value[$de33fd0b434498d0$var$DRAFT_STATE];
    if (!state) {
        $de33fd0b434498d0$var$each(value, (key, childValue)=>$de33fd0b434498d0$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $de33fd0b434498d0$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $de33fd0b434498d0$var$each(resultEach, (key, childValue)=>$de33fd0b434498d0$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $de33fd0b434498d0$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $de33fd0b434498d0$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $de33fd0b434498d0$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($de33fd0b434498d0$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$de33fd0b434498d0$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $de33fd0b434498d0$var$finalize(rootScope, childValue, path);
        $de33fd0b434498d0$var$set(targetObject, prop, res);
        if ($de33fd0b434498d0$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($de33fd0b434498d0$export$16e3aed3edb85946(childValue) && !$de33fd0b434498d0$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $de33fd0b434498d0$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $de33fd0b434498d0$var$maybeFreeze(rootScope, childValue);
    }
}
function $de33fd0b434498d0$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $de33fd0b434498d0$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $de33fd0b434498d0$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $de33fd0b434498d0$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $de33fd0b434498d0$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $de33fd0b434498d0$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $de33fd0b434498d0$var$objectTraps = {
    get (state, prop) {
        if (prop === $de33fd0b434498d0$var$DRAFT_STATE) return state;
        const source = $de33fd0b434498d0$var$latest(state);
        if (!$de33fd0b434498d0$var$has(source, prop)) return $de33fd0b434498d0$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$de33fd0b434498d0$export$16e3aed3edb85946(value)) return value;
        if (value === $de33fd0b434498d0$var$peek(state.base_, prop)) {
            $de33fd0b434498d0$var$prepareCopy(state);
            return state.copy_[prop] = $de33fd0b434498d0$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $de33fd0b434498d0$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($de33fd0b434498d0$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $de33fd0b434498d0$var$getDescriptorFromProto($de33fd0b434498d0$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $de33fd0b434498d0$var$peek($de33fd0b434498d0$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$de33fd0b434498d0$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($de33fd0b434498d0$var$is(value, current2) && (value !== void 0 || $de33fd0b434498d0$var$has(state.base_, prop))) return true;
            $de33fd0b434498d0$var$prepareCopy(state);
            $de33fd0b434498d0$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($de33fd0b434498d0$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $de33fd0b434498d0$var$prepareCopy(state);
            $de33fd0b434498d0$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $de33fd0b434498d0$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $de33fd0b434498d0$var$die(11);
    },
    getPrototypeOf (state) {
        return $de33fd0b434498d0$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $de33fd0b434498d0$var$die(12);
    }
};
var $de33fd0b434498d0$var$arrayTraps = {};
$de33fd0b434498d0$var$each($de33fd0b434498d0$var$objectTraps, (key, fn)=>{
    $de33fd0b434498d0$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$de33fd0b434498d0$var$arrayTraps.deleteProperty = function(state, prop) {
    return $de33fd0b434498d0$var$arrayTraps.set.call(this, state, prop, void 0);
};
$de33fd0b434498d0$var$arrayTraps.set = function(state, prop, value) {
    return $de33fd0b434498d0$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $de33fd0b434498d0$var$peek(draft, prop) {
    const state = draft[$de33fd0b434498d0$var$DRAFT_STATE];
    const source = state ? $de33fd0b434498d0$var$latest(state) : draft;
    return source[prop];
}
function $de33fd0b434498d0$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $de33fd0b434498d0$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $de33fd0b434498d0$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $de33fd0b434498d0$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $de33fd0b434498d0$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $de33fd0b434498d0$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $de33fd0b434498d0$var$markChanged(state.parent_);
    }
}
function $de33fd0b434498d0$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $de33fd0b434498d0$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $de33fd0b434498d0$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $de33fd0b434498d0$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $de33fd0b434498d0$var$die(7);
            let result;
            if ($de33fd0b434498d0$export$16e3aed3edb85946(base)) {
                const scope = $de33fd0b434498d0$var$enterScope(this);
                const proxy = $de33fd0b434498d0$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $de33fd0b434498d0$var$revokeScope(scope);
                    else $de33fd0b434498d0$var$leaveScope(scope);
                }
                $de33fd0b434498d0$var$usePatchesInScope(scope, patchListener);
                return $de33fd0b434498d0$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $de33fd0b434498d0$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $de33fd0b434498d0$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $de33fd0b434498d0$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $de33fd0b434498d0$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$de33fd0b434498d0$export$16e3aed3edb85946(base)) $de33fd0b434498d0$var$die(8);
        if ($de33fd0b434498d0$export$541ac630993a4c84(base)) base = $de33fd0b434498d0$export$97aac956da55dae9(base);
        const scope = $de33fd0b434498d0$var$enterScope(this);
        const proxy = $de33fd0b434498d0$var$createProxy(base, void 0);
        proxy[$de33fd0b434498d0$var$DRAFT_STATE].isManual_ = true;
        $de33fd0b434498d0$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$de33fd0b434498d0$var$DRAFT_STATE];
        if (!state || !state.isManual_) $de33fd0b434498d0$var$die(9);
        const { scope_: scope } = state;
        $de33fd0b434498d0$var$usePatchesInScope(scope, patchListener);
        return $de33fd0b434498d0$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $de33fd0b434498d0$var$getPlugin("Patches").applyPatches_;
        if ($de33fd0b434498d0$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $de33fd0b434498d0$var$createProxy(value, parent) {
    const draft = $de33fd0b434498d0$var$isMap(value) ? $de33fd0b434498d0$var$getPlugin("MapSet").proxyMap_(value, parent) : $de33fd0b434498d0$var$isSet(value) ? $de33fd0b434498d0$var$getPlugin("MapSet").proxySet_(value, parent) : $de33fd0b434498d0$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $de33fd0b434498d0$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $de33fd0b434498d0$export$97aac956da55dae9(value) {
    if (!$de33fd0b434498d0$export$541ac630993a4c84(value)) $de33fd0b434498d0$var$die(10, value);
    return $de33fd0b434498d0$var$currentImpl(value);
}
function $de33fd0b434498d0$var$currentImpl(value) {
    if (!$de33fd0b434498d0$export$16e3aed3edb85946(value) || $de33fd0b434498d0$var$isFrozen(value)) return value;
    const state = value[$de33fd0b434498d0$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $de33fd0b434498d0$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $de33fd0b434498d0$var$shallowCopy(value, true);
    $de33fd0b434498d0$var$each(copy, (key, childValue)=>{
        $de33fd0b434498d0$var$set(copy, key, $de33fd0b434498d0$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $de33fd0b434498d0$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $de33fd0b434498d0$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $de33fd0b434498d0$var$get(base_, key);
            const value = $de33fd0b434498d0$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $de33fd0b434498d0$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $de33fd0b434498d0$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $de33fd0b434498d0$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $de33fd0b434498d0$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $de33fd0b434498d0$var$die(errorOffset + 3);
                base = $de33fd0b434498d0$var$get(base, p);
                if (typeof base !== "object") $de33fd0b434498d0$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $de33fd0b434498d0$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $de33fd0b434498d0$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $de33fd0b434498d0$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$de33fd0b434498d0$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($de33fd0b434498d0$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($de33fd0b434498d0$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($de33fd0b434498d0$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($de33fd0b434498d0$var$has(obj, $de33fd0b434498d0$export$6ee2082928bcb0ee)) cloned[$de33fd0b434498d0$export$6ee2082928bcb0ee] = obj[$de33fd0b434498d0$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($de33fd0b434498d0$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $de33fd0b434498d0$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $de33fd0b434498d0$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$de33fd0b434498d0$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $de33fd0b434498d0$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $de33fd0b434498d0$var$latest(this[$de33fd0b434498d0$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $de33fd0b434498d0$var$latest(this[$de33fd0b434498d0$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$de33fd0b434498d0$var$latest(state).has(key) || $de33fd0b434498d0$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $de33fd0b434498d0$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $de33fd0b434498d0$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($de33fd0b434498d0$var$latest(state).size) {
                prepareMapCopy(state);
                $de33fd0b434498d0$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $de33fd0b434498d0$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            $de33fd0b434498d0$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $de33fd0b434498d0$var$latest(state).get(key);
            if (state.finalized_ || !$de33fd0b434498d0$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $de33fd0b434498d0$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $de33fd0b434498d0$var$latest(this[$de33fd0b434498d0$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($de33fd0b434498d0$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$de33fd0b434498d0$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $de33fd0b434498d0$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $de33fd0b434498d0$var$latest(this[$de33fd0b434498d0$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $de33fd0b434498d0$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $de33fd0b434498d0$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($de33fd0b434498d0$var$latest(state).size) {
                prepareSetCopy(state);
                $de33fd0b434498d0$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$de33fd0b434498d0$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($de33fd0b434498d0$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($de33fd0b434498d0$export$16e3aed3edb85946(value)) {
                    const draft = $de33fd0b434498d0$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $de33fd0b434498d0$var$die(3, JSON.stringify($de33fd0b434498d0$var$latest(state)));
    }
    $de33fd0b434498d0$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $de33fd0b434498d0$var$immer = new $de33fd0b434498d0$export$aaadc6ff0f822719();
var $de33fd0b434498d0$export$b46cabe22e78bc00 = $de33fd0b434498d0$var$immer.produce;
var $de33fd0b434498d0$export$4da66d41c9492c78 = $de33fd0b434498d0$var$immer.produceWithPatches.bind($de33fd0b434498d0$var$immer);
var $de33fd0b434498d0$export$573f26f60825c493 = $de33fd0b434498d0$var$immer.setAutoFreeze.bind($de33fd0b434498d0$var$immer);
var $de33fd0b434498d0$export$333ce65961cbe047 = $de33fd0b434498d0$var$immer.setUseStrictShallowCopy.bind($de33fd0b434498d0$var$immer);
var $de33fd0b434498d0$export$a8b8e03e6bbe5473 = $de33fd0b434498d0$var$immer.applyPatches.bind($de33fd0b434498d0$var$immer);
var $de33fd0b434498d0$export$3c3214997190395f = $de33fd0b434498d0$var$immer.createDraft.bind($de33fd0b434498d0$var$immer);
var $de33fd0b434498d0$export$c60f5e69c521b528 = $de33fd0b434498d0$var$immer.finishDraft.bind($de33fd0b434498d0$var$immer);
function $de33fd0b434498d0$export$c05b21e3257751e5(value) {
    return value;
}
function $de33fd0b434498d0$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("2ATxG", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $1e3a0720c44c2d59$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $1e3a0720c44c2d59$export$5943f4447f6ef248; });
$parcel$export(module.exports, "createSelector", function () { return $1e3a0720c44c2d59$export$595d22ed68ca2841; });
var $1e3a0720c44c2d59$var$__defProp = Object.defineProperty;
var $1e3a0720c44c2d59$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1e3a0720c44c2d59$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1e3a0720c44c2d59$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1e3a0720c44c2d59$var$__defNormalProp = (obj, key, value)=>key in obj ? $1e3a0720c44c2d59$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1e3a0720c44c2d59$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1e3a0720c44c2d59$var$__hasOwnProp.call(b, prop)) $1e3a0720c44c2d59$var$__defNormalProp(a, prop, b[prop]);
    if ($1e3a0720c44c2d59$var$__getOwnPropSymbols) {
        for (var prop of $1e3a0720c44c2d59$var$__getOwnPropSymbols(b))if ($1e3a0720c44c2d59$var$__propIsEnum.call(b, prop)) $1e3a0720c44c2d59$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1e3a0720c44c2d59$var$__publicField = (obj, key, value)=>{
    $1e3a0720c44c2d59$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $1e3a0720c44c2d59$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $1e3a0720c44c2d59$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $1e3a0720c44c2d59$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $1e3a0720c44c2d59$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($1e3a0720c44c2d59$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $1e3a0720c44c2d59$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $1e3a0720c44c2d59$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $1e3a0720c44c2d59$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $1e3a0720c44c2d59$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $1e3a0720c44c2d59$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $1e3a0720c44c2d59$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $1e3a0720c44c2d59$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $1e3a0720c44c2d59$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $1e3a0720c44c2d59$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $1e3a0720c44c2d59$var$__spreadValues($1e3a0720c44c2d59$var$__spreadValues({}, $1e3a0720c44c2d59$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $1e3a0720c44c2d59$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $1e3a0720c44c2d59$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $1e3a0720c44c2d59$var$$REVISION = 0;
var $1e3a0720c44c2d59$var$CURRENT_TRACKER = null;
var $1e3a0720c44c2d59$var$Cell = class {
    constructor(initialValue, isEqual = $1e3a0720c44c2d59$var$tripleEq){
        $1e3a0720c44c2d59$var$__publicField(this, "revision", $1e3a0720c44c2d59$var$$REVISION);
        $1e3a0720c44c2d59$var$__publicField(this, "_value");
        $1e3a0720c44c2d59$var$__publicField(this, "_lastValue");
        $1e3a0720c44c2d59$var$__publicField(this, "_isEqual", $1e3a0720c44c2d59$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $1e3a0720c44c2d59$var$CURRENT_TRACKER == null || $1e3a0720c44c2d59$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$1e3a0720c44c2d59$var$$REVISION;
    }
};
function $1e3a0720c44c2d59$var$tripleEq(a, b) {
    return a === b;
}
var $1e3a0720c44c2d59$var$TrackingCache = class {
    constructor(fn){
        $1e3a0720c44c2d59$var$__publicField(this, "_cachedValue");
        $1e3a0720c44c2d59$var$__publicField(this, "_cachedRevision", -1);
        $1e3a0720c44c2d59$var$__publicField(this, "_deps", []);
        $1e3a0720c44c2d59$var$__publicField(this, "hits", 0);
        $1e3a0720c44c2d59$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $1e3a0720c44c2d59$var$CURRENT_TRACKER;
            $1e3a0720c44c2d59$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $1e3a0720c44c2d59$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $1e3a0720c44c2d59$var$CURRENT_TRACKER == null || $1e3a0720c44c2d59$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $1e3a0720c44c2d59$var$getValue(cell) {
    if (!(cell instanceof $1e3a0720c44c2d59$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $1e3a0720c44c2d59$var$setValue(storage, value) {
    if (!(storage instanceof $1e3a0720c44c2d59$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $1e3a0720c44c2d59$var$createCell(initialValue, isEqual = $1e3a0720c44c2d59$var$tripleEq) {
    return new $1e3a0720c44c2d59$var$Cell(initialValue, isEqual);
}
function $1e3a0720c44c2d59$var$createCache(fn) {
    $1e3a0720c44c2d59$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $1e3a0720c44c2d59$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $1e3a0720c44c2d59$var$neverEq = (a, b)=>false;
function $1e3a0720c44c2d59$var$createTag() {
    return $1e3a0720c44c2d59$var$createCell(null, $1e3a0720c44c2d59$var$neverEq);
}
function $1e3a0720c44c2d59$var$dirtyTag(tag, value) {
    $1e3a0720c44c2d59$var$setValue(tag, value);
}
var $1e3a0720c44c2d59$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $1e3a0720c44c2d59$var$createTag();
    $1e3a0720c44c2d59$var$getValue(tag);
};
var $1e3a0720c44c2d59$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $1e3a0720c44c2d59$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $1e3a0720c44c2d59$var$REDUX_PROXY_LABEL = Symbol();
var $1e3a0720c44c2d59$var$nextId = 0;
var $1e3a0720c44c2d59$var$proto = Object.getPrototypeOf({});
var $1e3a0720c44c2d59$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $1e3a0720c44c2d59$var$__publicField(this, "proxy", new Proxy(this, $1e3a0720c44c2d59$var$objectProxyHandler));
        $1e3a0720c44c2d59$var$__publicField(this, "tag", $1e3a0720c44c2d59$var$createTag());
        $1e3a0720c44c2d59$var$__publicField(this, "tags", {});
        $1e3a0720c44c2d59$var$__publicField(this, "children", {});
        $1e3a0720c44c2d59$var$__publicField(this, "collectionTag", null);
        $1e3a0720c44c2d59$var$__publicField(this, "id", $1e3a0720c44c2d59$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $1e3a0720c44c2d59$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $1e3a0720c44c2d59$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $1e3a0720c44c2d59$var$createNode(childValue);
                if (childNode.tag) $1e3a0720c44c2d59$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $1e3a0720c44c2d59$var$createTag();
                    tag.value = childValue;
                }
                $1e3a0720c44c2d59$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $1e3a0720c44c2d59$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $1e3a0720c44c2d59$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $1e3a0720c44c2d59$var$__publicField(this, "proxy", new Proxy([
            this
        ], $1e3a0720c44c2d59$var$arrayProxyHandler));
        $1e3a0720c44c2d59$var$__publicField(this, "tag", $1e3a0720c44c2d59$var$createTag());
        $1e3a0720c44c2d59$var$__publicField(this, "tags", {});
        $1e3a0720c44c2d59$var$__publicField(this, "children", {});
        $1e3a0720c44c2d59$var$__publicField(this, "collectionTag", null);
        $1e3a0720c44c2d59$var$__publicField(this, "id", $1e3a0720c44c2d59$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $1e3a0720c44c2d59$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $1e3a0720c44c2d59$var$consumeCollection(node);
        return $1e3a0720c44c2d59$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $1e3a0720c44c2d59$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $1e3a0720c44c2d59$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $1e3a0720c44c2d59$var$objectProxyHandler.has(node, prop);
    }
};
function $1e3a0720c44c2d59$var$createNode(value) {
    if (Array.isArray(value)) return new $1e3a0720c44c2d59$var$ArrayTreeNode(value);
    return new $1e3a0720c44c2d59$var$ObjectTreeNode(value);
}
function $1e3a0720c44c2d59$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $1e3a0720c44c2d59$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $1e3a0720c44c2d59$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $1e3a0720c44c2d59$var$dirtyCollection(node);
            $1e3a0720c44c2d59$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $1e3a0720c44c2d59$var$updateNode(childNode, newChildValue);
        else {
            $1e3a0720c44c2d59$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $1e3a0720c44c2d59$var$deleteNode(node) {
    if (node.tag) $1e3a0720c44c2d59$var$dirtyTag(node.tag, null);
    $1e3a0720c44c2d59$var$dirtyCollection(node);
    for(const key in node.tags)$1e3a0720c44c2d59$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$1e3a0720c44c2d59$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $1e3a0720c44c2d59$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $1e3a0720c44c2d59$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $1e3a0720c44c2d59$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $1e3a0720c44c2d59$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $1e3a0720c44c2d59$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $1e3a0720c44c2d59$export$3f025202a230c6dd = (a, b)=>a === b;
function $1e3a0720c44c2d59$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $1e3a0720c44c2d59$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $1e3a0720c44c2d59$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $1e3a0720c44c2d59$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $1e3a0720c44c2d59$var$createSingletonCache(comparator) : $1e3a0720c44c2d59$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $1e3a0720c44c2d59$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $1e3a0720c44c2d59$export$c8f9cf88d9fdee55(func) {
    const node = $1e3a0720c44c2d59$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $1e3a0720c44c2d59$var$createCacheKeyComparator($1e3a0720c44c2d59$export$3f025202a230c6dd);
    const cache = $1e3a0720c44c2d59$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $1e3a0720c44c2d59$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $1e3a0720c44c2d59$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $1e3a0720c44c2d59$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $1e3a0720c44c2d59$var$StrongRef;
var $1e3a0720c44c2d59$var$UNTERMINATED = 0;
var $1e3a0720c44c2d59$var$TERMINATED = 1;
function $1e3a0720c44c2d59$var$createCacheNode() {
    return {
        s: $1e3a0720c44c2d59$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $1e3a0720c44c2d59$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $1e3a0720c44c2d59$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $1e3a0720c44c2d59$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $1e3a0720c44c2d59$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $1e3a0720c44c2d59$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $1e3a0720c44c2d59$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $1e3a0720c44c2d59$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $1e3a0720c44c2d59$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $1e3a0720c44c2d59$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $1e3a0720c44c2d59$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $1e3a0720c44c2d59$var$__spreadValues($1e3a0720c44c2d59$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $1e3a0720c44c2d59$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $1e3a0720c44c2d59$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $1e3a0720c44c2d59$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $1e3a0720c44c2d59$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $1e3a0720c44c2d59$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $1e3a0720c44c2d59$export$595d22ed68ca2841 = /* @__PURE__ */ $1e3a0720c44c2d59$export$5943f4447f6ef248($1e3a0720c44c2d59$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $1e3a0720c44c2d59$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $1e3a0720c44c2d59$export$595d22ed68ca2841)=>{
    $1e3a0720c44c2d59$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$1e3a0720c44c2d59$export$75979cfcd91bf38f
});

});

parcelRegister("kG3OK", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $f0dab0fbe018bc29$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $f0dab0fbe018bc29$export$16d06542a1949d9e; });
// src/index.ts
function $f0dab0fbe018bc29$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $f0dab0fbe018bc29$export$dd164f5517779f15 = $f0dab0fbe018bc29$var$createThunkMiddleware();
var $f0dab0fbe018bc29$export$16d06542a1949d9e = $f0dab0fbe018bc29$var$createThunkMiddleware;

});


parcelRegister("eLH3C", function(module, exports) {

$parcel$export(module.exports, "QueryStatus", function () { return $ac06dac7d42c7bee$export$f4258b89f6bad1d6; });
$parcel$export(module.exports, "fetchBaseQuery", function () { return $ac06dac7d42c7bee$export$adcf4c6133c49b4e; });
$parcel$export(module.exports, "setupListeners", function () { return $ac06dac7d42c7bee$export$120c0dbb0351414c; });
$parcel$export(module.exports, "skipToken", function () { return $ac06dac7d42c7bee$export$1aa5a89531b7670d; });
$parcel$export(module.exports, "defaultSerializeQueryArgs", function () { return $ac06dac7d42c7bee$export$db8e4edac9bbb67b; });
$parcel$export(module.exports, "buildCreateApi", function () { return $ac06dac7d42c7bee$export$f957748792d43646; });
$parcel$export(module.exports, "coreModule", function () { return $ac06dac7d42c7bee$export$eb718ff92afd6f9b; });

var $10c6O = parcelRequire("10c6O");
var $gtjDQ = parcelRequire("gtjDQ");
var $j4Mta = parcelRequire("j4Mta");
var $2ATxG = parcelRequire("2ATxG");

var $j4Mta = parcelRequire("j4Mta");

var $bQIfh = parcelRequire("bQIfh");

var $2ATxG = parcelRequire("2ATxG");

var $4YPvm = parcelRequire("4YPvm");
var $ac06dac7d42c7bee$var$__defProp = Object.defineProperty;
var $ac06dac7d42c7bee$var$__defProps = Object.defineProperties;
var $ac06dac7d42c7bee$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ac06dac7d42c7bee$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ac06dac7d42c7bee$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ac06dac7d42c7bee$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ac06dac7d42c7bee$var$__defNormalProp = (obj, key, value)=>key in obj ? $ac06dac7d42c7bee$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ac06dac7d42c7bee$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ac06dac7d42c7bee$var$__hasOwnProp.call(b, prop)) $ac06dac7d42c7bee$var$__defNormalProp(a, prop, b[prop]);
    if ($ac06dac7d42c7bee$var$__getOwnPropSymbols) {
        for (var prop of $ac06dac7d42c7bee$var$__getOwnPropSymbols(b))if ($ac06dac7d42c7bee$var$__propIsEnum.call(b, prop)) $ac06dac7d42c7bee$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ac06dac7d42c7bee$var$__spreadProps = (a, b)=>$ac06dac7d42c7bee$var$__defProps(a, $ac06dac7d42c7bee$var$__getOwnPropDescs(b));
var $ac06dac7d42c7bee$var$__restKey = (key)=>typeof key === "symbol" ? key : key + "";
var $ac06dac7d42c7bee$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ac06dac7d42c7bee$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ac06dac7d42c7bee$var$__getOwnPropSymbols) {
        for (var prop of $ac06dac7d42c7bee$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ac06dac7d42c7bee$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/query/core/apiState.ts
var $ac06dac7d42c7bee$export$f4258b89f6bad1d6 = /* @__PURE__ */ ((QueryStatus2)=>{
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
    return QueryStatus2;
})($ac06dac7d42c7bee$export$f4258b89f6bad1d6 || {});
function $ac06dac7d42c7bee$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === "uninitialized" /* uninitialized */ ,
        isLoading: status === "pending" /* pending */ ,
        isSuccess: status === "fulfilled" /* fulfilled */ ,
        isError: status === "rejected" /* rejected */ 
    };
}
// src/query/utils/copyWithStructuralSharing.ts
var $ac06dac7d42c7bee$var$isPlainObject2 = (0, $10c6O.isPlainObject);
function $ac06dac7d42c7bee$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($ac06dac7d42c7bee$var$isPlainObject2(oldObj) && $ac06dac7d42c7bee$var$isPlainObject2(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    const newKeys = Object.keys(newObj);
    const oldKeys = Object.keys(oldObj);
    let isSameObject = newKeys.length === oldKeys.length;
    const mergeObj = Array.isArray(newObj) ? [] : {};
    for (const key of newKeys){
        mergeObj[key] = $ac06dac7d42c7bee$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
// src/query/utils/countObjectKeys.ts
function $ac06dac7d42c7bee$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
// src/query/utils/flatten.ts
var $ac06dac7d42c7bee$var$flatten = (arr)=>[].concat(...arr);
// src/query/utils/isAbsoluteUrl.ts
function $ac06dac7d42c7bee$var$isAbsoluteUrl(url) {
    return new RegExp(`(^|:)//`).test(url);
}
// src/query/utils/isDocumentVisible.ts
function $ac06dac7d42c7bee$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
// src/query/utils/isNotNullish.ts
function $ac06dac7d42c7bee$var$isNotNullish(v) {
    return v != null;
}
// src/query/utils/isOnline.ts
function $ac06dac7d42c7bee$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/joinUrls.ts
var $ac06dac7d42c7bee$var$withoutTrailingSlash = (url)=>url.replace(/\/$/, "");
var $ac06dac7d42c7bee$var$withoutLeadingSlash = (url)=>url.replace(/^\//, "");
function $ac06dac7d42c7bee$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($ac06dac7d42c7bee$var$isAbsoluteUrl(url)) return url;
    const delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $ac06dac7d42c7bee$var$withoutTrailingSlash(base);
    url = $ac06dac7d42c7bee$var$withoutLeadingSlash(url);
    return `${base}${delimiter}${url}`;
}
// src/query/utils/getOrInsert.ts
function $ac06dac7d42c7bee$var$getOrInsert(map, key, value) {
    if (map.has(key)) return map.get(key);
    return map.set(key, value).get(key);
}
// src/query/fetchBaseQuery.ts
var $ac06dac7d42c7bee$var$defaultFetchFn = (...args)=>fetch(...args);
var $ac06dac7d42c7bee$var$defaultValidateStatus = (response)=>response.status >= 200 && response.status <= 299;
var $ac06dac7d42c7bee$var$defaultIsJsonContentType = (headers)=>/*applicat*/ /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
function $ac06dac7d42c7bee$var$stripUndefined(obj) {
    if (!(0, $10c6O.isPlainObject)(obj)) return obj;
    const copy = $ac06dac7d42c7bee$var$__spreadValues({}, obj);
    for (const [k, v] of Object.entries(copy))if (v === void 0) delete copy[k];
    return copy;
}
function $ac06dac7d42c7bee$export$adcf4c6133c49b4e(_a = {}) {
    var _b = _a, { baseUrl: baseUrl, prepareHeaders: prepareHeaders = (x)=>x, fetchFn: fetchFn = $ac06dac7d42c7bee$var$defaultFetchFn, paramsSerializer: paramsSerializer, isJsonContentType: isJsonContentType = $ac06dac7d42c7bee$var$defaultIsJsonContentType, jsonContentType: jsonContentType = "application/json", jsonReplacer: jsonReplacer, timeout: defaultTimeout, responseHandler: globalResponseHandler, validateStatus: globalValidateStatus } = _b, baseFetchOptions = $ac06dac7d42c7bee$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $ac06dac7d42c7bee$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return async (arg, api, extraOptions)=>{
        const { getState: getState, extra: extra, endpoint: endpoint, forced: forced, type: type } = api;
        let meta;
        let _a2 = typeof arg == "string" ? {
            url: arg
        } : arg, { url: url, headers: headers = new Headers(baseFetchOptions.headers), params: params, responseHandler: responseHandler = globalResponseHandler != null ? globalResponseHandler : "json", validateStatus: validateStatus = globalValidateStatus != null ? globalValidateStatus : $ac06dac7d42c7bee$var$defaultValidateStatus, timeout: timeout = defaultTimeout } = _a2, rest = $ac06dac7d42c7bee$var$__objRest(_a2, [
            "url",
            "headers",
            "params",
            "responseHandler",
            "validateStatus",
            "timeout"
        ]);
        let abortController, signal = api.signal;
        if (timeout) {
            abortController = new AbortController();
            api.signal.addEventListener("abort", abortController.abort);
            signal = abortController.signal;
        }
        let config = $ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, baseFetchOptions), {
            signal: signal
        }), rest);
        headers = new Headers($ac06dac7d42c7bee$var$stripUndefined(headers));
        config.headers = await prepareHeaders(headers, {
            getState: getState,
            arg: arg,
            extra: extra,
            endpoint: endpoint,
            forced: forced,
            type: type,
            extraOptions: extraOptions
        }) || headers;
        const isJsonifiable = (body)=>typeof body === "object" && ((0, $10c6O.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
        if (params) {
            const divider = ~url.indexOf("?") ? "&" : "?";
            const query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($ac06dac7d42c7bee$var$stripUndefined(params));
            url += divider + query;
        }
        url = $ac06dac7d42c7bee$var$joinUrls(baseUrl, url);
        const request = new Request(url, config);
        const requestClone = new Request(url, config);
        meta = {
            request: requestClone
        };
        let response, timedOut = false, timeoutId = abortController && setTimeout(()=>{
            timedOut = true;
            abortController.abort();
        }, timeout);
        try {
            response = await fetchFn(request);
        } catch (e) {
            return {
                error: {
                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                    error: String(e)
                },
                meta: meta
            };
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            abortController == null || abortController.signal.removeEventListener("abort", abortController.abort);
        }
        const responseClone = response.clone();
        meta.response = responseClone;
        let resultData;
        let responseText = "";
        try {
            let handleResponseError;
            await Promise.all([
                handleResponse(response, responseHandler).then((r)=>resultData = r, (e)=>handleResponseError = e),
                // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
                // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
                responseClone.text().then((r)=>responseText = r, ()=>{})
            ]);
            if (handleResponseError) throw handleResponseError;
        } catch (e) {
            return {
                error: {
                    status: "PARSING_ERROR",
                    originalStatus: response.status,
                    data: responseText,
                    error: String(e)
                },
                meta: meta
            };
        }
        return validateStatus(response, resultData) ? {
            data: resultData,
            meta: meta
        } : {
            error: {
                status: response.status,
                data: resultData
            },
            meta: meta
        };
    };
    async function handleResponse(response, responseHandler) {
        if (typeof responseHandler === "function") return responseHandler(response);
        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
        if (responseHandler === "json") {
            const text = await response.text();
            return text.length ? JSON.parse(text) : null;
        }
        return response.text();
    }
}
// src/query/HandledError.ts
var $ac06dac7d42c7bee$var$HandledError = class {
    constructor(value, meta){
        this.value = value;
        this.meta = meta;
    }
};
// src/query/retry.ts
async function $ac06dac7d42c7bee$var$defaultBackoff(attempt = 0, maxRetries = 5) {
    const attempts = Math.min(attempt, maxRetries);
    const timeout = ~~((Math.random() + 0.4) * (300 << attempts));
    await new Promise((resolve)=>setTimeout((res)=>resolve(res), timeout));
}
function $ac06dac7d42c7bee$var$fail(error, meta) {
    throw Object.assign(new $ac06dac7d42c7bee$var$HandledError({
        error: error,
        meta: meta
    }), {
        throwImmediately: true
    });
}
var $ac06dac7d42c7bee$var$EMPTY_OPTIONS = {};
var $ac06dac7d42c7bee$var$retryWithBackoff = (baseQuery, defaultOptions)=>async (args, api, extraOptions)=>{
        const possibleMaxRetries = [
            5,
            (defaultOptions || $ac06dac7d42c7bee$var$EMPTY_OPTIONS).maxRetries,
            (extraOptions || $ac06dac7d42c7bee$var$EMPTY_OPTIONS).maxRetries
        ].filter((x)=>x !== void 0);
        const [maxRetries] = possibleMaxRetries.slice(-1);
        const defaultRetryCondition = (_, __, { attempt: attempt })=>attempt <= maxRetries;
        const options = $ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues({
            maxRetries: maxRetries,
            backoff: $ac06dac7d42c7bee$var$defaultBackoff,
            retryCondition: defaultRetryCondition
        }, defaultOptions), extraOptions);
        let retry2 = 0;
        while(true)try {
            const result = await baseQuery(args, api, extraOptions);
            if (result.error) throw new $ac06dac7d42c7bee$var$HandledError(result);
            return result;
        } catch (e) {
            retry2++;
            if (e.throwImmediately) {
                if (e instanceof $ac06dac7d42c7bee$var$HandledError) return e.value;
                throw e;
            }
            if (e instanceof $ac06dac7d42c7bee$var$HandledError && !options.retryCondition(e.value.error, args, {
                attempt: retry2,
                baseQueryApi: api,
                extraOptions: extraOptions
            })) return e.value;
            await options.backoff(retry2, options.maxRetries);
        }
    };
var $ac06dac7d42c7bee$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($ac06dac7d42c7bee$var$retryWithBackoff, {
    fail: $ac06dac7d42c7bee$var$fail
});
// src/query/core/setupListeners.ts
var $ac06dac7d42c7bee$var$onFocus = /* @__PURE__ */ (0, $gtjDQ.createAction)("__rtkq/focused");
var $ac06dac7d42c7bee$var$onFocusLost = /* @__PURE__ */ (0, $gtjDQ.createAction)("__rtkq/unfocused");
var $ac06dac7d42c7bee$var$onOnline = /* @__PURE__ */ (0, $gtjDQ.createAction)("__rtkq/online");
var $ac06dac7d42c7bee$var$onOffline = /* @__PURE__ */ (0, $gtjDQ.createAction)("__rtkq/offline");
var $ac06dac7d42c7bee$var$initialized = false;
function $ac06dac7d42c7bee$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        const handleFocus = ()=>dispatch($ac06dac7d42c7bee$var$onFocus());
        const handleFocusLost = ()=>dispatch($ac06dac7d42c7bee$var$onFocusLost());
        const handleOnline = ()=>dispatch($ac06dac7d42c7bee$var$onOnline());
        const handleOffline = ()=>dispatch($ac06dac7d42c7bee$var$onOffline());
        const handleVisibilityChange = ()=>{
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$ac06dac7d42c7bee$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $ac06dac7d42c7bee$var$initialized = true;
            }
        }
        const unsubscribe = ()=>{
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $ac06dac7d42c7bee$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $ac06dac7d42c7bee$var$onFocus,
        onFocusLost: $ac06dac7d42c7bee$var$onFocusLost,
        onOffline: $ac06dac7d42c7bee$var$onOffline,
        onOnline: $ac06dac7d42c7bee$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
function $ac06dac7d42c7bee$var$isQueryDefinition(e) {
    return e.type === "query" /* query */ ;
}
function $ac06dac7d42c7bee$var$isMutationDefinition(e) {
    return e.type === "mutation" /* mutation */ ;
}
function $ac06dac7d42c7bee$var$isInfiniteQueryDefinition(e) {
    return e.type === "infinitequery" /* infinitequery */ ;
}
function $ac06dac7d42c7bee$var$isAnyQueryDefinition(e) {
    return $ac06dac7d42c7bee$var$isQueryDefinition(e) || $ac06dac7d42c7bee$var$isInfiniteQueryDefinition(e);
}
function $ac06dac7d42c7bee$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($ac06dac7d42c7bee$var$isFunction(description)) return description(result, error, queryArg, meta).filter($ac06dac7d42c7bee$var$isNotNullish).map($ac06dac7d42c7bee$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($ac06dac7d42c7bee$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $ac06dac7d42c7bee$var$isFunction(t) {
    return typeof t === "function";
}
function $ac06dac7d42c7bee$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/tsHelpers.ts
function $ac06dac7d42c7bee$var$asSafePromise(promise, fallback) {
    return promise.catch(fallback);
}
// src/query/core/buildInitiate.ts
var $ac06dac7d42c7bee$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $ac06dac7d42c7bee$var$isUpsertQuery = (arg)=>typeof arg[$ac06dac7d42c7bee$var$forceQueryFnSymbol] === "function";
function $ac06dac7d42c7bee$var$buildInitiate({ serializeQueryArgs: serializeQueryArgs, queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, api: api, context: context }) {
    const runningQueries = /* @__PURE__ */ new Map();
    const runningMutations = /* @__PURE__ */ new Map();
    const { unsubscribeQueryResult: unsubscribeQueryResult, removeMutationResult: removeMutationResult, updateSubscriptionOptions: updateSubscriptionOptions } = api.internalActions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateInfiniteQuery: buildInitiateInfiniteQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk
    };
    function getRunningQueryThunk(endpointName, queryArgs) {
        return (dispatch)=>{
            var _a;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return (dispatch)=>{
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return (dispatch)=>Object.values(runningQueries.get(dispatch) || {}).filter($ac06dac7d42c7bee$var$isNotNullish);
    }
    function getRunningMutationsThunk() {
        return (dispatch)=>Object.values(runningMutations.get(dispatch) || {}).filter($ac06dac7d42c7bee$var$isNotNullish);
    }
    function middlewareWarning(dispatch) {}
    function buildInitiateAnyQuery(endpointName, endpointDefinition) {
        const queryAction = (arg, _a = {})=>{
            var _b = _a, { subscribe: subscribe = true, forceRefetch: forceRefetch, subscriptionOptions: subscriptionOptions, [$ac06dac7d42c7bee$var$forceQueryFnSymbol]: forceQueryFn } = _b, rest = $ac06dac7d42c7bee$var$__objRest(_b, [
                "subscribe",
                "forceRefetch",
                "subscriptionOptions",
                $ac06dac7d42c7bee$var$__restKey($ac06dac7d42c7bee$var$forceQueryFnSymbol)
            ]);
            return (dispatch, getState)=>{
                var _a2;
                const queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                let thunk;
                const commonThunkArgs = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, rest), {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey,
                    [$ac06dac7d42c7bee$var$forceQueryFnSymbol]: forceQueryFn
                });
                if ($ac06dac7d42c7bee$var$isQueryDefinition(endpointDefinition)) thunk = queryThunk(commonThunkArgs);
                else {
                    const { direction: direction, initialPageParam: initialPageParam } = rest;
                    thunk = infiniteQueryThunk($ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, commonThunkArgs), {
                        direction: // Supply these even if undefined. This helps with a field existence
                        // check over in `buildSlice.ts`
                        direction,
                        initialPageParam: initialPageParam
                    }));
                }
                const selector = api.endpoints[endpointName].select(arg);
                const thunkResult = dispatch(thunk);
                const stateAfter = selector(getState());
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort } = thunkResult;
                const skippedSynchronously = stateAfter.requestId !== requestId;
                const runningQuery = (_a2 = runningQueries.get(dispatch)) == null ? void 0 : _a2[queryCacheKey];
                const selectFromState = ()=>selector(getState());
                const statePromise = Object.assign(forceQueryFn ? // a query has been forced (upsertQueryData)
                // -> we want to resolve it once data has been written with the data that will be written
                thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? // a query has been skipped due to a condition and we do not have any currently running query
                // -> we want to resolve it immediately with the current data
                Promise.resolve(stateAfter) : // query just started or one is already in flight
                // -> wait for the running query, then resolve with data from after that
                Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    async unwrap () {
                        const result = await statePromise;
                        if (result.isError) throw result.error;
                        return result.data;
                    },
                    refetch: ()=>dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        })),
                    unsubscribe () {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions (options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    const running = $ac06dac7d42c7bee$var$getOrInsert(runningQueries, dispatch, {});
                    running[queryCacheKey] = statePromise;
                    statePromise.then(()=>{
                        delete running[queryCacheKey];
                        if (!$ac06dac7d42c7bee$var$countObjectKeys(running)) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        const queryAction = buildInitiateAnyQuery(endpointName, endpointDefinition);
        return queryAction;
    }
    function buildInitiateInfiniteQuery(endpointName, endpointDefinition) {
        const infiniteQueryAction = buildInitiateAnyQuery(endpointName, endpointDefinition);
        return infiniteQueryAction;
    }
    function buildInitiateMutation(endpointName) {
        return (arg, { track: track = true, fixedCacheKey: fixedCacheKey } = {})=>(dispatch, getState)=>{
                const thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                const thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort, unwrap: unwrap } = thunkResult;
                const returnValuePromise = $ac06dac7d42c7bee$var$asSafePromise(thunkResult.unwrap().then((data)=>({
                        data: data
                    })), (error)=>({
                        error: error
                    }));
                const reset = ()=>{
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                const ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    reset: reset
                });
                const running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(()=>{
                    delete running[requestId];
                    if (!$ac06dac7d42c7bee$var$countObjectKeys(running)) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(()=>{
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!$ac06dac7d42c7bee$var$countObjectKeys(running)) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
    }
}
var $ac06dac7d42c7bee$export$6c822e36c9b9dfb4 = class extends (0, $bQIfh.SchemaError) {
    constructor(issues, value, schemaName, _bqMeta){
        super(issues);
        this.value = value;
        this.schemaName = schemaName;
        this._bqMeta = _bqMeta;
    }
};
async function $ac06dac7d42c7bee$var$parseWithSchema(schema, data, schemaName, bqMeta) {
    const result = await schema["~standard"].validate(data);
    if (result.issues) throw new $ac06dac7d42c7bee$export$6c822e36c9b9dfb4(result.issues, data, schemaName, bqMeta);
    return result.value;
}
// src/query/core/buildThunks.ts
function $ac06dac7d42c7bee$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
var $ac06dac7d42c7bee$var$addShouldAutoBatch = (arg = {})=>{
    return $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, arg), {
        [(0, $gtjDQ.SHOULD_AUTOBATCH)]: true
    });
};
function $ac06dac7d42c7bee$var$buildThunks({ reducerPath: reducerPath, baseQuery: baseQuery, context: { endpointDefinitions: endpointDefinitions }, serializeQueryArgs: serializeQueryArgs, api: api, assertTagType: assertTagType, selectors: selectors, onSchemaFailure: onSchemaFailure, catchSchemaFailure: globalCatchSchemaFailure, skipSchemaValidation: globalSkipSchemaValidation }) {
    const patchQueryData = (endpointName, arg, patches, updateProvided)=>(dispatch, getState)=>{
            const endpointDefinition = endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: arg,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            const newValue = api.endpoints[endpointName].select(arg)(// Work around TS 4.1 mismatch
            getState());
            const providedTags = $ac06dac7d42c7bee$var$calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, arg, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy([
                {
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }
            ]));
        };
    function addToStart(items, item, max = 0) {
        const newItems = [
            item,
            ...items
        ];
        return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
    }
    function addToEnd(items, item, max = 0) {
        const newItems = [
            ...items,
            item
        ];
        return max && newItems.length > max ? newItems.slice(1) : newItems;
    }
    const updateQueryData = (endpointName, arg, updateRecipe, updateProvided = true)=>(dispatch, getState)=>{
            const endpointDefinition = api.endpoints[endpointName];
            const currentState = endpointDefinition.select(arg)(// Work around TS 4.1 mismatch
            getState());
            const ret = {
                patches: [],
                inversePatches: [],
                undo: ()=>dispatch(api.util.patchQueryData(endpointName, arg, ret.inversePatches, updateProvided))
            };
            if (currentState.status === "uninitialized" /* uninitialized */ ) return ret;
            let newValue;
            if ("data" in currentState) {
                if ((0, $j4Mta.isDraftable)(currentState.data)) {
                    const [value, patches, inversePatches] = (0, $j4Mta.produceWithPatches)(currentState.data, updateRecipe);
                    ret.patches.push(...patches);
                    ret.inversePatches.push(...inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            if (ret.patches.length === 0) return ret;
            dispatch(api.util.patchQueryData(endpointName, arg, ret.patches, updateProvided));
            return ret;
        };
    const upsertQueryData = (endpointName, arg, value)=>(dispatch)=>{
            const res = dispatch(api.endpoints[endpointName].initiate(arg, {
                subscribe: false,
                forceRefetch: true,
                [$ac06dac7d42c7bee$var$forceQueryFnSymbol]: ()=>({
                        data: value
                    })
            }));
            return res;
        };
    const getTransformCallbackForEndpoint = (endpointDefinition, transformFieldName)=>{
        return endpointDefinition.query && endpointDefinition[transformFieldName] ? endpointDefinition[transformFieldName] : $ac06dac7d42c7bee$var$defaultTransformResponse;
    };
    const executeEndpoint = async (arg, { signal: signal, abort: abort, rejectWithValue: rejectWithValue, fulfillWithValue: fulfillWithValue, dispatch: dispatch, getState: getState, extra: extra })=>{
        var _a, _b, _c, _d;
        const endpointDefinition = endpointDefinitions[arg.endpointName];
        const { metaSchema: metaSchema, skipSchemaValidation: skipSchemaValidation = globalSkipSchemaValidation } = endpointDefinition;
        try {
            let transformResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformResponse");
            const baseQueryApi = {
                signal: signal,
                abort: abort,
                dispatch: dispatch,
                getState: getState,
                extra: extra,
                endpoint: arg.endpointName,
                type: arg.type,
                forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0,
                queryCacheKey: arg.type === "query" ? arg.queryCacheKey : void 0
            };
            const forceQueryFn = arg.type === "query" ? arg[$ac06dac7d42c7bee$var$forceQueryFnSymbol] : void 0;
            let finalQueryReturnValue;
            const fetchPage = async (data, param, maxPages, previous)=>{
                if (param == null && data.pages.length) return Promise.resolve({
                    data: data
                });
                const finalQueryArg = {
                    queryArg: arg.originalArgs,
                    pageParam: param
                };
                const pageResponse = await executeRequest(finalQueryArg);
                const addTo = previous ? addToStart : addToEnd;
                return {
                    data: {
                        pages: addTo(data.pages, pageResponse.data, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    },
                    meta: pageResponse.meta
                };
            };
            async function executeRequest(finalQueryArg) {
                let result;
                const { extraOptions: extraOptions, argSchema: argSchema, rawResponseSchema: rawResponseSchema, responseSchema: responseSchema } = endpointDefinition;
                if (argSchema && !skipSchemaValidation) finalQueryArg = await $ac06dac7d42c7bee$var$parseWithSchema(argSchema, finalQueryArg, "argSchema", {});
                if (forceQueryFn) result = forceQueryFn();
                else if (endpointDefinition.query) result = await baseQuery(endpointDefinition.query(finalQueryArg), baseQueryApi, extraOptions);
                else result = await endpointDefinition.queryFn(finalQueryArg, baseQueryApi, extraOptions, (arg2)=>baseQuery(arg2, baseQueryApi, extraOptions));
                typeof $4YPvm;
                if (result.error) throw new $ac06dac7d42c7bee$var$HandledError(result.error, result.meta);
                let { data: data } = result;
                if (rawResponseSchema && !skipSchemaValidation) data = await $ac06dac7d42c7bee$var$parseWithSchema(rawResponseSchema, result.data, "rawResponseSchema", result.meta);
                let transformedResponse = await transformResponse(data, result.meta, finalQueryArg);
                if (responseSchema && !skipSchemaValidation) transformedResponse = await $ac06dac7d42c7bee$var$parseWithSchema(responseSchema, transformedResponse, "responseSchema", result.meta);
                return $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, result), {
                    data: transformedResponse
                });
            }
            if (arg.type === "query" && "infiniteQueryOptions" in endpointDefinition) {
                const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
                const { maxPages: maxPages = Infinity } = infiniteQueryOptions;
                let result;
                const blankData = {
                    pages: [],
                    pageParams: []
                };
                const cachedData = (_a = selectors.selectQueryEntry(getState(), arg.queryCacheKey)) == null ? void 0 : _a.data;
                const isForcedQueryNeedingRefetch = // arg.forceRefetch
                isForcedQuery(arg, getState()) && !arg.direction;
                const existingData = isForcedQueryNeedingRefetch || !cachedData ? blankData : cachedData;
                if ("direction" in arg && arg.direction && existingData.pages.length) {
                    const previous = arg.direction === "backward";
                    const pageParamFn = previous ? $ac06dac7d42c7bee$var$getPreviousPageParam : $ac06dac7d42c7bee$var$getNextPageParam;
                    const param = pageParamFn(infiniteQueryOptions, existingData, arg.originalArgs);
                    result = await fetchPage(existingData, param, maxPages, previous);
                } else {
                    const { initialPageParam: initialPageParam = infiniteQueryOptions.initialPageParam } = arg;
                    const cachedPageParams = (_b = cachedData == null ? void 0 : cachedData.pageParams) != null ? _b : [];
                    const firstPageParam = (_c = cachedPageParams[0]) != null ? _c : initialPageParam;
                    const totalPages = cachedPageParams.length;
                    result = await fetchPage(existingData, firstPageParam, maxPages);
                    if (forceQueryFn) result = {
                        data: result.data.pages[0]
                    };
                    for(let i = 1; i < totalPages; i++){
                        const param = $ac06dac7d42c7bee$var$getNextPageParam(infiniteQueryOptions, result.data, arg.originalArgs);
                        result = await fetchPage(result.data, param, maxPages);
                    }
                }
                finalQueryReturnValue = result;
            } else finalQueryReturnValue = await executeRequest(arg.originalArgs);
            if (metaSchema && !skipSchemaValidation && finalQueryReturnValue.meta) finalQueryReturnValue.meta = await $ac06dac7d42c7bee$var$parseWithSchema(metaSchema, finalQueryReturnValue.meta, "metaSchema", finalQueryReturnValue.meta);
            return fulfillWithValue(finalQueryReturnValue.data, $ac06dac7d42c7bee$var$addShouldAutoBatch({
                fulfilledTimeStamp: Date.now(),
                baseQueryMeta: finalQueryReturnValue.meta
            }));
        } catch (error) {
            let caughtError = error;
            if (caughtError instanceof $ac06dac7d42c7bee$var$HandledError) {
                let transformErrorResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformErrorResponse");
                const { rawErrorResponseSchema: rawErrorResponseSchema, errorResponseSchema: errorResponseSchema } = endpointDefinition;
                let { value: value, meta: meta } = caughtError;
                try {
                    if (rawErrorResponseSchema && !skipSchemaValidation) value = await $ac06dac7d42c7bee$var$parseWithSchema(rawErrorResponseSchema, value, "rawErrorResponseSchema", meta);
                    if (metaSchema && !skipSchemaValidation) meta = await $ac06dac7d42c7bee$var$parseWithSchema(metaSchema, meta, "metaSchema", meta);
                    let transformedErrorResponse = await transformErrorResponse(value, meta, arg.originalArgs);
                    if (errorResponseSchema && !skipSchemaValidation) transformedErrorResponse = await $ac06dac7d42c7bee$var$parseWithSchema(errorResponseSchema, transformedErrorResponse, "errorResponseSchema", meta);
                    return rejectWithValue(transformedErrorResponse, $ac06dac7d42c7bee$var$addShouldAutoBatch({
                        baseQueryMeta: meta
                    }));
                } catch (e) {
                    caughtError = e;
                }
            }
            try {
                if (caughtError instanceof $ac06dac7d42c7bee$export$6c822e36c9b9dfb4) {
                    const info = {
                        endpoint: arg.endpointName,
                        arg: arg.originalArgs,
                        type: arg.type,
                        queryCacheKey: arg.type === "query" ? arg.queryCacheKey : void 0
                    };
                    (_d = endpointDefinition.onSchemaFailure) == null || _d.call(endpointDefinition, caughtError, info);
                    onSchemaFailure == null || onSchemaFailure(caughtError, info);
                    const { catchSchemaFailure: catchSchemaFailure = globalCatchSchemaFailure } = endpointDefinition;
                    if (catchSchemaFailure) return rejectWithValue(catchSchemaFailure(caughtError, info), $ac06dac7d42c7bee$var$addShouldAutoBatch({
                        baseQueryMeta: caughtError._bqMeta
                    }));
                }
            } catch (e) {
                caughtError = e;
            }
            typeof $4YPvm;
            console.error(caughtError);
            throw caughtError;
        }
    };
    function isForcedQuery(arg, state) {
        var _a;
        const requestState = selectors.selectQueryEntry(state, arg.queryCacheKey);
        const baseFetchOnMountOrArgChange = selectors.selectConfig(state).refetchOnMountOrArgChange;
        const fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        const refetchVal = (_a = arg.forceRefetch) != null ? _a : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(/* @__PURE__ */ new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    const createQueryThunk = ()=>{
        const generatedQueryThunk = (0, $gtjDQ.createAsyncThunk)(`${reducerPath}/executeQuery`, executeEndpoint, {
            getPendingMeta ({ arg: arg }) {
                const endpointDefinition = endpointDefinitions[arg.endpointName];
                return $ac06dac7d42c7bee$var$addShouldAutoBatch($ac06dac7d42c7bee$var$__spreadValues({
                    startedTimeStamp: Date.now()
                }, $ac06dac7d42c7bee$var$isInfiniteQueryDefinition(endpointDefinition) ? {
                    direction: arg.direction
                } : {}));
            },
            condition (queryThunkArg, { getState: getState }) {
                var _a;
                const state = getState();
                const requestState = selectors.selectQueryEntry(state, queryThunkArg.queryCacheKey);
                const fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
                const currentArg = queryThunkArg.originalArgs;
                const previousArg = requestState == null ? void 0 : requestState.originalArgs;
                const endpointDefinition = endpointDefinitions[queryThunkArg.endpointName];
                const direction = queryThunkArg.direction;
                if ($ac06dac7d42c7bee$var$isUpsertQuery(queryThunkArg)) return true;
                if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
                if (isForcedQuery(queryThunkArg, state)) return true;
                if ($ac06dac7d42c7bee$var$isQueryDefinition(endpointDefinition) && ((_a = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _a.call(endpointDefinition, {
                    currentArg: currentArg,
                    previousArg: previousArg,
                    endpointState: requestState,
                    state: state
                }))) return true;
                if (fulfilledVal && !direction) return false;
                return true;
            },
            dispatchConditionRejection: true
        });
        return generatedQueryThunk;
    };
    const queryThunk = createQueryThunk();
    const infiniteQueryThunk = createQueryThunk();
    const mutationThunk = (0, $gtjDQ.createAsyncThunk)(`${reducerPath}/executeMutation`, executeEndpoint, {
        getPendingMeta () {
            return $ac06dac7d42c7bee$var$addShouldAutoBatch({
                startedTimeStamp: Date.now()
            });
        }
    });
    const hasTheForce = (options)=>"force" in options;
    const hasMaxAge = (options)=>"ifOlderThan" in options;
    const prefetch = (endpointName, arg, options)=>(dispatch, getState)=>{
            const force = hasTheForce(options) && options.force;
            const maxAge = hasMaxAge(options) && options.ifOlderThan;
            const queryAction = (force2 = true)=>{
                const options2 = {
                    forceRefetch: force2,
                    isPrefetch: true
                };
                return api.endpoints[endpointName].initiate(arg, options2);
            };
            const latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                const lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                const shouldRetrigger = (Number(/* @__PURE__ */ new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    function matchesEndpoint(endpointName) {
        return (action)=>{
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $gtjDQ.isAllOf)((0, $gtjDQ.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $gtjDQ.isAllOf)((0, $gtjDQ.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $gtjDQ.isAllOf)((0, $gtjDQ.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        infiniteQueryThunk: infiniteQueryThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $ac06dac7d42c7bee$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams, queryArg);
}
function $ac06dac7d42c7bee$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams, queryArg);
}
function $ac06dac7d42c7bee$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $ac06dac7d42c7bee$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $gtjDQ.isFulfilled)(action) ? action.payload : void 0, (0, $gtjDQ.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $ac06dac7d42c7bee$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    const substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $ac06dac7d42c7bee$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $ac06dac7d42c7bee$var$updateMutationSubstateIfExists(state, id, update) {
    const substate = state[$ac06dac7d42c7bee$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $ac06dac7d42c7bee$var$initialState = {};
function $ac06dac7d42c7bee$var$buildSlice({ reducerPath: reducerPath, queryThunk: queryThunk, mutationThunk: mutationThunk, serializeQueryArgs: serializeQueryArgs, context: { endpointDefinitions: definitions, apiUid: apiUid, extractRehydrationInfo: extractRehydrationInfo, hasRehydrationInfo: hasRehydrationInfo }, assertTagType: assertTagType, config: config }) {
    const resetApiState = (0, $gtjDQ.createAction)(`${reducerPath}/resetApiState`);
    function writePendingCacheEntry(draft, arg, upserting, meta) {
        var _a, _b;
        (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
            status: "uninitialized" /* uninitialized */ ,
            endpointName: arg.endpointName
        };
        $ac06dac7d42c7bee$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
            substate.status = "pending" /* pending */ ;
            substate.requestId = upserting && substate.requestId ? // for `upsertQuery` **updates**, keep the current `requestId`
            substate.requestId : // for normal queries or `upsertQuery` **inserts** always update the `requestId`
            meta.requestId;
            if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
            substate.startedTimeStamp = meta.startedTimeStamp;
            const endpointDefinition = definitions[meta.arg.endpointName];
            if ($ac06dac7d42c7bee$var$isInfiniteQueryDefinition(endpointDefinition) && "direction" in arg) substate.direction = arg.direction;
        });
    }
    function writeFulfilledCacheEntry(draft, meta, payload, upserting) {
        $ac06dac7d42c7bee$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, (substate)=>{
            var _a;
            if (substate.requestId !== meta.requestId && !upserting) return;
            const { merge: merge } = definitions[meta.arg.endpointName];
            substate.status = "fulfilled" /* fulfilled */ ;
            if (merge) {
                if (substate.data !== void 0) {
                    const { fulfilledTimeStamp: fulfilledTimeStamp, arg: arg, baseQueryMeta: baseQueryMeta, requestId: requestId } = meta;
                    let newData = (0, $j4Mta.produce)(substate.data, (draftSubstateData)=>{
                        return merge(draftSubstateData, payload, {
                            arg: arg.originalArgs,
                            baseQueryMeta: baseQueryMeta,
                            fulfilledTimeStamp: fulfilledTimeStamp,
                            requestId: requestId
                        });
                    });
                    substate.data = newData;
                } else substate.data = payload;
            } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $ac06dac7d42c7bee$export$b64d4502a1c929bd((0, $j4Mta.isDraft)(substate.data) ? (0, $j4Mta.original)(substate.data) : substate.data, payload) : payload;
            delete substate.error;
            substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
        });
    }
    const querySlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/queries`,
        initialState: $ac06dac7d42c7bee$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey } }) {
                    delete draft[queryCacheKey];
                },
                prepare: (0, $gtjDQ.prepareAutoBatched)()
            },
            cacheEntriesUpserted: {
                reducer (draft, action) {
                    for (const entry of action.payload){
                        const { queryDescription: arg, value: value } = entry;
                        writePendingCacheEntry(draft, arg, true, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            startedTimeStamp: action.meta.timestamp
                        });
                        writeFulfilledCacheEntry(draft, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            fulfilledTimeStamp: action.meta.timestamp,
                            baseQueryMeta: {}
                        }, value, // We know we're upserting here
                        true);
                    }
                },
                prepare: (payload)=>{
                    const queryDescriptions = payload.map((entry)=>{
                        const { endpointName: endpointName, arg: arg, value: value } = entry;
                        const endpointDefinition = definitions[endpointName];
                        const queryDescription = {
                            type: "query",
                            endpointName: endpointName,
                            originalArgs: entry.arg,
                            queryCacheKey: serializeQueryArgs({
                                queryArgs: arg,
                                endpointDefinition: endpointDefinition,
                                endpointName: endpointName
                            })
                        };
                        return {
                            queryDescription: queryDescription,
                            value: value
                        };
                    });
                    const result = {
                        payload: queryDescriptions,
                        meta: {
                            [(0, $gtjDQ.SHOULD_AUTOBATCH)]: true,
                            requestId: (0, $gtjDQ.nanoid)(),
                            timestamp: Date.now()
                        }
                    };
                    return result;
                }
            },
            queryResultPatched: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey, patches: patches } }) {
                    $ac06dac7d42c7bee$var$updateQuerySubstateIfExists(draft, queryCacheKey, (substate)=>{
                        substate.data = (0, $j4Mta.applyPatches)(substate.data, patches.concat());
                    });
                },
                prepare: (0, $gtjDQ.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(queryThunk.pending, (draft, { meta: meta, meta: { arg: arg } })=>{
                const upserting = $ac06dac7d42c7bee$var$isUpsertQuery(arg);
                writePendingCacheEntry(draft, arg, upserting, meta);
            }).addCase(queryThunk.fulfilled, (draft, { meta: meta, payload: payload })=>{
                const upserting = $ac06dac7d42c7bee$var$isUpsertQuery(meta.arg);
                writeFulfilledCacheEntry(draft, meta, payload, upserting);
            }).addCase(queryThunk.rejected, (draft, { meta: { condition: condition, arg: arg, requestId: requestId }, error: error, payload: payload })=>{
                $ac06dac7d42c7bee$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = "rejected" /* rejected */ ;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { queries: queries } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(queries))if (// do not rehydrate entries that were currently in flight.
                (entry == null ? void 0 : entry.status) === "fulfilled" /* fulfilled */  || (entry == null ? void 0 : entry.status) === "rejected" /* rejected */ ) draft[key] = entry;
            });
        }
    });
    const mutationSlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/mutations`,
        initialState: $ac06dac7d42c7bee$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer (draft, { payload: payload }) {
                    const cacheKey = $ac06dac7d42c7bee$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $gtjDQ.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(mutationThunk.pending, (draft, { meta: meta, meta: { requestId: requestId, arg: arg, startedTimeStamp: startedTimeStamp } })=>{
                if (!arg.track) return;
                draft[$ac06dac7d42c7bee$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: "pending" /* pending */ ,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, (draft, { payload: payload, meta: meta })=>{
                if (!meta.arg.track) return;
                $ac06dac7d42c7bee$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = "fulfilled" /* fulfilled */ ;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, (draft, { payload: payload, error: error, meta: meta })=>{
                if (!meta.arg.track) return;
                $ac06dac7d42c7bee$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = "rejected" /* rejected */ ;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { mutations: mutations } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(mutations))if (// do not rehydrate entries that were currently in flight.
                ((entry == null ? void 0 : entry.status) === "fulfilled" /* fulfilled */  || (entry == null ? void 0 : entry.status) === "rejected" /* rejected */ ) && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
                key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
            });
        }
    });
    const initialInvalidationState = {
        tags: {},
        keys: {}
    };
    const invalidationSlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/invalidation`,
        initialState: initialInvalidationState,
        reducers: {
            updateProvidedBy: {
                reducer (draft, action) {
                    var _a, _b, _c, _d, _e;
                    for (const { queryCacheKey: queryCacheKey, providedTags: providedTags } of action.payload){
                        removeCacheKeyFromTags(draft, queryCacheKey);
                        for (const { type: type, id: id } of providedTags){
                            const subscribedQueries = (_e = (_c = (_b = (_a = draft.tags)[type]) != null ? _b : _a[type] = {})[_d = id || "__internal_without_id"]) != null ? _e : _c[_d] = [];
                            const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                        draft.keys[queryCacheKey] = providedTags;
                    }
                },
                prepare: (0, $gtjDQ.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(querySlice.actions.removeQueryResult, (draft, { payload: { queryCacheKey: queryCacheKey } })=>{
                removeCacheKeyFromTags(draft, queryCacheKey);
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                var _a, _b, _c, _d, _e;
                const { provided: provided } = extractRehydrationInfo(action);
                for (const [type, incomingTags] of Object.entries(provided))for (const [id, cacheKeys] of Object.entries(incomingTags)){
                    const subscribedQueries = (_e = (_c = (_b = (_a = draft.tags)[type]) != null ? _b : _a[type] = {})[_d = id || "__internal_without_id"]) != null ? _e : _c[_d] = [];
                    for (const queryCacheKey of cacheKeys){
                        const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                    }
                }
            }).addMatcher((0, $gtjDQ.isAnyOf)((0, $gtjDQ.isFulfilled)(queryThunk), (0, $gtjDQ.isRejectedWithValue)(queryThunk)), (draft, action)=>{
                writeProvidedTagsForQueries(draft, [
                    action
                ]);
            }).addMatcher(querySlice.actions.cacheEntriesUpserted.match, (draft, action)=>{
                const mockActions = action.payload.map(({ queryDescription: queryDescription, value: value })=>{
                    return {
                        type: "UNKNOWN",
                        payload: value,
                        meta: {
                            requestStatus: "fulfilled",
                            requestId: "UNKNOWN",
                            arg: queryDescription
                        }
                    };
                });
                writeProvidedTagsForQueries(draft, mockActions);
            });
        }
    });
    function removeCacheKeyFromTags(draft, queryCacheKey) {
        var _a, _b, _c;
        const existingTags = (_a = draft.keys[queryCacheKey]) != null ? _a : [];
        for (const tag of existingTags){
            const tagType = tag.type;
            const tagId = (_b = tag.id) != null ? _b : "__internal_without_id";
            const tagSubscriptions = (_c = draft.tags[tagType]) == null ? void 0 : _c[tagId];
            if (tagSubscriptions) draft.tags[tagType][tagId] = tagSubscriptions.filter((qc)=>qc !== queryCacheKey);
        }
        delete draft.keys[queryCacheKey];
    }
    function writeProvidedTagsForQueries(draft, actions2) {
        const providedByEntries = actions2.map((action)=>{
            const providedTags = $ac06dac7d42c7bee$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
            const { queryCacheKey: queryCacheKey } = action.meta.arg;
            return {
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            };
        });
        invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy(providedByEntries));
    }
    const subscriptionSlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/subscriptions`,
        initialState: $ac06dac7d42c7bee$var$initialState,
        reducers: {
            updateSubscriptionOptions (d, a) {},
            unsubscribeQueryResult (d, a) {},
            internal_getRTKQSubscriptions () {}
        }
    });
    const internalSubscriptionsSlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/internalSubscriptions`,
        initialState: $ac06dac7d42c7bee$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer (state, action) {
                    return (0, $j4Mta.applyPatches)(state, action.payload);
                },
                prepare: (0, $gtjDQ.prepareAutoBatched)()
            }
        }
    });
    const configSlice = (0, $gtjDQ.createSlice)({
        name: `${reducerPath}/config`,
        initialState: $ac06dac7d42c7bee$var$__spreadValues({
            online: $ac06dac7d42c7bee$var$isOnline(),
            focused: $ac06dac7d42c7bee$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered (state, { payload: payload }) {
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($ac06dac7d42c7bee$var$onOnline, (state)=>{
                state.online = true;
            }).addCase($ac06dac7d42c7bee$var$onOffline, (state)=>{
                state.online = false;
            }).addCase($ac06dac7d42c7bee$var$onFocus, (state)=>{
                state.focused = true;
            }).addCase($ac06dac7d42c7bee$var$onFocusLost, (state)=>{
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, (draft)=>$ac06dac7d42c7bee$var$__spreadValues({}, draft));
        }
    });
    const combinedReducer = (0, $10c6O.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    const reducer = (state, action)=>combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    const actions = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), invalidationSlice.actions), {
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $ac06dac7d42c7bee$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $ac06dac7d42c7bee$var$initialSubState = {
    status: "uninitialized" /* uninitialized */ 
};
var $ac06dac7d42c7bee$var$defaultQuerySubState = /* @__PURE__ */ (0, $j4Mta.produce)($ac06dac7d42c7bee$var$initialSubState, ()=>{});
var $ac06dac7d42c7bee$var$defaultMutationSubState = /* @__PURE__ */ (0, $j4Mta.produce)($ac06dac7d42c7bee$var$initialSubState, ()=>{});
function $ac06dac7d42c7bee$var$buildSelectors({ serializeQueryArgs: serializeQueryArgs, reducerPath: reducerPath, createSelector: createSelector2 }) {
    const selectSkippedQuery = (state)=>$ac06dac7d42c7bee$var$defaultQuerySubState;
    const selectSkippedMutation = (state)=>$ac06dac7d42c7bee$var$defaultMutationSubState;
    return {
        buildQuerySelector: buildQuerySelector,
        buildInfiniteQuerySelector: buildInfiniteQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy,
        selectCachedArgsForQuery: selectCachedArgsForQuery,
        selectApiState: selectApiState,
        selectQueries: selectQueries,
        selectMutations: selectMutations,
        selectQueryEntry: selectQueryEntry,
        selectConfig: selectConfig
    };
    function withRequestFlags(substate) {
        return $ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues({}, substate), $ac06dac7d42c7bee$var$getRequestStatusFlags(substate.status));
    }
    function selectApiState(rootState) {
        const state = rootState[reducerPath];
        return state;
    }
    function selectQueries(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.queries;
    }
    function selectQueryEntry(rootState, cacheKey) {
        var _a;
        return (_a = selectQueries(rootState)) == null ? void 0 : _a[cacheKey];
    }
    function selectMutations(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.mutations;
    }
    function selectConfig(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.config;
    }
    function buildAnyQuerySelector(endpointName, endpointDefinition, combiner) {
        return (queryArgs)=>{
            if (queryArgs === $ac06dac7d42c7bee$export$1aa5a89531b7670d) return createSelector2(selectSkippedQuery, combiner);
            const serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            const selectQuerySubstate = (state)=>{
                var _a;
                return (_a = selectQueryEntry(state, serializedArgs)) != null ? _a : $ac06dac7d42c7bee$var$defaultQuerySubState;
            };
            return createSelector2(selectQuerySubstate, combiner);
        };
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return buildAnyQuerySelector(endpointName, endpointDefinition, withRequestFlags);
    }
    function buildInfiniteQuerySelector(endpointName, endpointDefinition) {
        const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
        function withInfiniteQueryResultFlags(substate) {
            const stateWithRequestFlags = $ac06dac7d42c7bee$var$__spreadValues($ac06dac7d42c7bee$var$__spreadValues({}, substate), $ac06dac7d42c7bee$var$getRequestStatusFlags(substate.status));
            const { isLoading: isLoading, isError: isError, direction: direction } = stateWithRequestFlags;
            const isForward = direction === "forward";
            const isBackward = direction === "backward";
            return $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, stateWithRequestFlags), {
                hasNextPage: getHasNextPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                hasPreviousPage: getHasPreviousPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                isFetchingNextPage: isLoading && isForward,
                isFetchingPreviousPage: isLoading && isBackward,
                isFetchNextPageError: isError && isForward,
                isFetchPreviousPageError: isError && isBackward
            });
        }
        return buildAnyQuerySelector(endpointName, endpointDefinition, withInfiniteQueryResultFlags);
    }
    function buildMutationSelector() {
        return (id)=>{
            var _a;
            let mutationId;
            if (typeof id === "object") mutationId = (_a = $ac06dac7d42c7bee$var$getMutationCacheKey(id)) != null ? _a : $ac06dac7d42c7bee$export$1aa5a89531b7670d;
            else mutationId = id;
            const selectMutationSubstate = (state)=>{
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectApiState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $ac06dac7d42c7bee$var$defaultMutationSubState;
            };
            const finalSelectMutationSubstate = mutationId === $ac06dac7d42c7bee$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return createSelector2(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        const apiState = state[reducerPath];
        const toInvalidate = /* @__PURE__ */ new Set();
        for (const tag of tags.filter($ac06dac7d42c7bee$var$isNotNullish).map($ac06dac7d42c7bee$var$expandTagDescription)){
            const provided = apiState.provided.tags[tag.type];
            if (!provided) continue;
            let invalidateSubscriptions = (_a = tag.id !== void 0 ? // id given: invalidate all queries that provide this type & id
            provided[tag.id] : // no id: invalidate all queries that provide this type
            $ac06dac7d42c7bee$var$flatten(Object.values(provided))) != null ? _a : [];
            for (const invalidate of invalidateSubscriptions)toInvalidate.add(invalidate);
        }
        return $ac06dac7d42c7bee$var$flatten(Array.from(toInvalidate.values()).map((queryCacheKey)=>{
            const querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
    function selectCachedArgsForQuery(state, queryName) {
        return Object.values(selectQueries(state)).filter((entry)=>(entry == null ? void 0 : entry.endpointName) === queryName && entry.status !== "uninitialized" /* uninitialized */ ).map((entry)=>entry.originalArgs);
    }
    function getHasNextPage(options, data, queryArg) {
        if (!data) return false;
        return $ac06dac7d42c7bee$var$getNextPageParam(options, data, queryArg) != null;
    }
    function getHasPreviousPage(options, data, queryArg) {
        if (!data || !options.getPreviousPageParam) return false;
        return $ac06dac7d42c7bee$var$getPreviousPageParam(options, data, queryArg) != null;
    }
}
// src/query/defaultSerializeQueryArgs.ts
var $ac06dac7d42c7bee$var$cache = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0;
var $ac06dac7d42c7bee$export$db8e4edac9bbb67b = ({ endpointName: endpointName, queryArgs: queryArgs })=>{
    let serialized = "";
    const cached = $ac06dac7d42c7bee$var$cache == null ? void 0 : $ac06dac7d42c7bee$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        const stringified = JSON.stringify(queryArgs, (key, value)=>{
            value = typeof value === "bigint" ? {
                $bigint: value.toString()
            } : value;
            value = (0, $10c6O.isPlainObject)(value) ? Object.keys(value).sort().reduce((acc, key2)=>{
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
            return value;
        });
        if ((0, $10c6O.isPlainObject)(queryArgs)) $ac06dac7d42c7bee$var$cache == null || $ac06dac7d42c7bee$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return `${endpointName}(${serialized})`;
};
function $ac06dac7d42c7bee$export$f957748792d43646(...modules) {
    return function baseCreateApi(options) {
        const extractRehydrationInfo = (0, $2ATxG.weakMapMemoize)((action)=>{
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        const optionsWithDefaults = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false,
            invalidationBehavior: "delayed"
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs (queryArgsApi) {
                let finalSerializeQueryArgs = $ac06dac7d42c7bee$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    const endpointSQA = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = (queryArgsApi2)=>{
                        const initialResult = endpointSQA(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $ac06dac7d42c7bee$export$db8e4edac9bbb67b($ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: [
                ...options.tagTypes || []
            ]
        });
        const context = {
            endpointDefinitions: {},
            batch (fn) {
                fn();
            },
            apiUid: (0, $gtjDQ.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $2ATxG.weakMapMemoize)((action)=>extractRehydrationInfo(action) != null)
        };
        const api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints ({ addTagTypes: addTagTypes, endpoints: endpoints }) {
                if (addTagTypes) {
                    for (const eT of addTagTypes)if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) {
                    for (const [endpointName, partialDefinition] of Object.entries(endpoints))if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        const initializedModules = modules.map((m)=>m.init(api, optionsWithDefaults, context));
        function injectEndpoints(inject) {
            const evaluatedEndpoints = inject.endpoints({
                query: (x)=>$ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, x), {
                        type: "query" /* query */ 
                    }),
                mutation: (x)=>$ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, x), {
                        type: "mutation" /* mutation */ 
                    }),
                infiniteQuery: (x)=>$ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, x), {
                        type: "infinitequery" /* infinitequery */ 
                    })
            });
            for (const [endpointName, definition] of Object.entries(evaluatedEndpoints)){
                if (inject.overrideExisting !== true && endpointName in context.endpointDefinitions) {
                    if (inject.overrideExisting === "throw") throw new Error((0, $gtjDQ.formatProdErrorMessage)(39));
                    else typeof $4YPvm;
                    continue;
                }
                typeof $4YPvm;
                context.endpointDefinitions[endpointName] = definition;
                for (const m of initializedModules)m.injectEndpoint(endpointName, definition);
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
var $ac06dac7d42c7bee$export$b87087b3e686799a = /* @__PURE__ */ Symbol();
function $ac06dac7d42c7bee$export$f72b22d3ac378bae() {
    return function() {
        throw new Error((0, $gtjDQ.formatProdErrorMessage)(33));
    };
}
// src/query/tsHelpers.ts
function $ac06dac7d42c7bee$var$assertCast(v) {}
function $ac06dac7d42c7bee$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
var $ac06dac7d42c7bee$var$buildBatchedActionsHandler = ({ api: api, queryThunk: queryThunk, internalState: internalState })=>{
    const subscriptionsPrefix = `${api.reducerPath}/subscriptions`;
    let previousSubscriptions = null;
    let updateSyncTimer = null;
    const { updateSubscriptionOptions: updateSubscriptionOptions, unsubscribeQueryResult: unsubscribeQueryResult } = api.internalActions;
    const actuallyMutateSubscriptions = (mutableState, action)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId, options: options } = action.payload;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId } = action.payload;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            const { meta: { arg: arg, requestId: requestId } } = action;
            const substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
            substate[`${requestId}_running`] = {};
            if (arg.subscribe) substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
            return true;
        }
        let mutated = false;
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action)) {
            const state = mutableState[action.meta.arg.queryCacheKey] || {};
            const key = `${action.meta.requestId}_running`;
            mutated || (mutated = !!state[key]);
            delete state[key];
        }
        if (queryThunk.rejected.match(action)) {
            const { meta: { condition: condition, arg: arg, requestId: requestId } } = action;
            if (condition && arg.subscribe) {
                const substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                mutated = true;
            }
        }
        return mutated;
    };
    const getSubscriptions = ()=>internalState.currentSubscriptions;
    const getSubscriptionCount = (queryCacheKey)=>{
        var _a;
        const subscriptions = getSubscriptions();
        const subscriptionsForQueryArg = (_a = subscriptions[queryCacheKey]) != null ? _a : {};
        return $ac06dac7d42c7bee$var$countObjectKeys(subscriptionsForQueryArg);
    };
    const isRequestSubscribed = (queryCacheKey, requestId)=>{
        var _a;
        const subscriptions = getSubscriptions();
        return !!((_a = subscriptions == null ? void 0 : subscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
    };
    const subscriptionSelectors = {
        getSubscriptions: getSubscriptions,
        getSubscriptionCount: getSubscriptionCount,
        isRequestSubscribed: isRequestSubscribed
    };
    return (action, mwApi)=>{
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            updateSyncTimer = null;
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_getRTKQSubscriptions.match(action)) return [
            false,
            subscriptionSelectors
        ];
        const didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        let actionShouldContinue = true;
        if (didMutate) {
            if (!updateSyncTimer) updateSyncTimer = setTimeout(()=>{
                const newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                const [, patches] = (0, $j4Mta.produceWithPatches)(previousSubscriptions, ()=>newSubscriptions);
                mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                previousSubscriptions = newSubscriptions;
                updateSyncTimer = null;
            }, 500);
            const isSubscriptionSliceAction = typeof action.type == "string" && !!action.type.startsWith(subscriptionsPrefix);
            const isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
        }
        return [
            actionShouldContinue,
            false
        ];
    };
};
// src/query/core/buildMiddleware/cacheCollection.ts
function $ac06dac7d42c7bee$var$isObjectEmpty(obj) {
    for(const k in obj)return false;
    return true;
}
var $ac06dac7d42c7bee$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $ac06dac7d42c7bee$var$buildCacheCollectionHandler = ({ reducerPath: reducerPath, api: api, queryThunk: queryThunk, context: context, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectConfig: selectConfig } })=>{
    const { removeQueryResult: removeQueryResult, unsubscribeQueryResult: unsubscribeQueryResult, cacheEntriesUpserted: cacheEntriesUpserted } = api.internalActions;
    const canTriggerUnsubscribe = (0, $gtjDQ.isAnyOf)(unsubscribeQueryResult.match, queryThunk.fulfilled, queryThunk.rejected, cacheEntriesUpserted.match);
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$ac06dac7d42c7bee$var$isObjectEmpty(subscriptions);
    }
    const currentRemovalTimeouts = {};
    const handler = (action, mwApi, internalState2)=>{
        const state = mwApi.getState();
        const config = selectConfig(state);
        if (canTriggerUnsubscribe(action)) {
            let queryCacheKeys;
            if (cacheEntriesUpserted.match(action)) queryCacheKeys = action.payload.map((entry)=>entry.queryDescription.queryCacheKey);
            else {
                const { queryCacheKey: queryCacheKey } = unsubscribeQueryResult.match(action) ? action.payload : action.meta.arg;
                queryCacheKeys = [
                    queryCacheKey
                ];
            }
            handleUnsubscribeMany(queryCacheKeys, mwApi, config);
        }
        if (api.util.resetApiState.match(action)) for (const [key, timeout] of Object.entries(currentRemovalTimeouts)){
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            const { queries: queries } = context.extractRehydrationInfo(action);
            handleUnsubscribeMany(Object.keys(queries), mwApi, config);
        }
    };
    function handleUnsubscribeMany(cacheKeys, api2, config) {
        const state = api2.getState();
        for (const queryCacheKey of cacheKeys){
            const entry = selectQueryEntry(state, queryCacheKey);
            handleUnsubscribe(queryCacheKey, entry == null ? void 0 : entry.endpointName, api2, config);
        }
    }
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        const endpointDefinition = context.endpointDefinitions[endpointName];
        const keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        const finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $ac06dac7d42c7bee$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            const currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(()=>{
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
// src/query/core/buildMiddleware/cacheLifecycle.ts
var $ac06dac7d42c7bee$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $ac06dac7d42c7bee$var$buildCacheLifecycleHandler = ({ api: api, reducerPath: reducerPath, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectApiState: selectApiState } })=>{
    const isQueryThunk = (0, $gtjDQ.isAsyncThunkAction)(queryThunk);
    const isMutationThunk = (0, $gtjDQ.isAsyncThunkAction)(mutationThunk);
    const isFulfilledThunk = (0, $gtjDQ.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    function resolveLifecycleEntry(cacheKey, data, meta) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
            lifecycle.valueResolved({
                data: data,
                meta: meta
            });
            delete lifecycle.valueResolved;
        }
    }
    function removeLifecycleEntry(cacheKey) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle) {
            delete lifecycleMap[cacheKey];
            lifecycle.cacheEntryRemoved();
        }
    }
    const handler = (action, mwApi, stateBefore)=>{
        const cacheKey = getCacheKey(action);
        function checkForNewCacheKey(endpointName, cacheKey2, requestId, originalArgs) {
            const oldEntry = selectQueryEntry(stateBefore, cacheKey2);
            const newEntry = selectQueryEntry(mwApi.getState(), cacheKey2);
            if (!oldEntry && newEntry) handleNewKey(endpointName, originalArgs, cacheKey2, mwApi, requestId);
        }
        if (queryThunk.pending.match(action)) checkForNewCacheKey(action.meta.arg.endpointName, cacheKey, action.meta.requestId, action.meta.arg.originalArgs);
        else if (api.internalActions.cacheEntriesUpserted.match(action)) for (const { queryDescription: queryDescription, value: value } of action.payload){
            const { endpointName: endpointName, originalArgs: originalArgs, queryCacheKey: queryCacheKey } = queryDescription;
            checkForNewCacheKey(endpointName, queryCacheKey, action.meta.requestId, originalArgs);
            resolveLifecycleEntry(queryCacheKey, value, {});
        }
        else if (mutationThunk.pending.match(action)) {
            const state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) resolveLifecycleEntry(cacheKey, action.payload, action.meta.baseQueryMeta);
        else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) removeLifecycleEntry(cacheKey);
        else if (api.util.resetApiState.match(action)) for (const cacheKey2 of Object.keys(lifecycleMap))removeLifecycleEntry(cacheKey2);
    };
    function getCacheKey(action) {
        var _a;
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return (_a = action.meta.arg.fixedCacheKey) != null ? _a : action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $ac06dac7d42c7bee$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        const endpointDefinition = context.endpointDefinitions[endpointName];
        const onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        const lifecycle = {};
        const cacheEntryRemoved = new Promise((resolve)=>{
            lifecycle.cacheEntryRemoved = resolve;
        });
        const cacheDataLoaded = Promise.race([
            new Promise((resolve)=>{
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(()=>{
                throw $ac06dac7d42c7bee$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(()=>{});
        lifecycleMap[queryCacheKey] = lifecycle;
        const selector = api.endpoints[endpointName].select($ac06dac7d42c7bee$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : queryCacheKey);
        const extra = mwApi.dispatch((_, __, extra2)=>extra2);
        const lifecycleApi = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, mwApi), {
            getCacheEntry: ()=>selector(mwApi.getState()),
            requestId: requestId,
            extra: extra,
            updateCachedData: $ac06dac7d42c7bee$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        const runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch((e)=>{
            if (e === $ac06dac7d42c7bee$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $ac06dac7d42c7bee$var$buildDevCheckHandler = ({ api: api, context: { apiUid: apiUid }, reducerPath: reducerPath })=>{
    return (action, mwApi)=>{
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $4YPvm;
    };
};
// src/query/core/buildMiddleware/invalidationByTags.ts
var $ac06dac7d42c7bee$var$buildInvalidationByTagsHandler = ({ reducerPath: reducerPath, context: context, context: { endpointDefinitions: endpointDefinitions }, mutationThunk: mutationThunk, queryThunk: queryThunk, api: api, assertTagType: assertTagType, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const isThunkActionWithTags = (0, $gtjDQ.isAnyOf)((0, $gtjDQ.isFulfilled)(mutationThunk), (0, $gtjDQ.isRejectedWithValue)(mutationThunk));
    const isQueryEnd = (0, $gtjDQ.isAnyOf)((0, $gtjDQ.isFulfilled)(mutationThunk, queryThunk), (0, $gtjDQ.isRejected)(mutationThunk, queryThunk));
    let pendingTagInvalidations = [];
    const handler = (action, mwApi)=>{
        if (isThunkActionWithTags(action)) invalidateTags($ac06dac7d42c7bee$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        else if (isQueryEnd(action)) invalidateTags([], mwApi);
        else if (api.util.invalidateTags.match(action)) invalidateTags($ac06dac7d42c7bee$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function hasPendingRequests(state) {
        var _a;
        const { queries: queries, mutations: mutations } = state;
        for (const cacheRecord of [
            queries,
            mutations
        ])for(const key in cacheRecord){
            if (((_a = cacheRecord[key]) == null ? void 0 : _a.status) === "pending" /* pending */ ) return true;
        }
        return false;
    }
    function invalidateTags(newTags, mwApi) {
        const rootState = mwApi.getState();
        const state = rootState[reducerPath];
        pendingTagInvalidations.push(...newTags);
        if (state.config.invalidationBehavior === "delayed" && hasPendingRequests(state)) return;
        const tags = pendingTagInvalidations;
        pendingTagInvalidations = [];
        if (tags.length === 0) return;
        const toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(()=>{
            var _a;
            const valuesArray = Array.from(toInvalidate.values());
            for (const { queryCacheKey: queryCacheKey } of valuesArray){
                const querySubState = state.queries[queryCacheKey];
                const subscriptionSubState = (_a = internalState.currentSubscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if ($ac06dac7d42c7bee$var$countObjectKeys(subscriptionSubState) === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized" /* uninitialized */ ) mwApi.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $ac06dac7d42c7bee$var$buildPollingHandler = ({ reducerPath: reducerPath, queryThunk: queryThunk, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const currentPolls = {};
    const handler = (action, mwApi)=>{
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function getCacheEntrySubscriptions(queryCacheKey, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === "uninitialized" /* uninitialized */ ) return;
        return subscriptions;
    }
    function startNextPoll({ queryCacheKey: queryCacheKey }, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === "uninitialized" /* uninitialized */ ) return;
        const { lowestPollingInterval: lowestPollingInterval, skipPollingIfUnfocused: skipPollingIfUnfocused } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        const currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(()=>{
                if (state.config.focused || !skipPollingIfUnfocused) api2.dispatch(refetchQuery(querySubState));
                startNextPoll({
                    queryCacheKey: queryCacheKey
                }, api2);
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval({ queryCacheKey: queryCacheKey }, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === "uninitialized" /* uninitialized */ ) return;
        const { lowestPollingInterval: lowestPollingInterval } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        const currentPoll = currentPolls[queryCacheKey];
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        const existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for (const key of Object.keys(currentPolls))cleanupPollForKey(key);
    }
    function findLowestPollingInterval(subscribers = {}) {
        let skipPollingIfUnfocused = false;
        let lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(let key in subscribers)if (!!subscribers[key].pollingInterval) {
            lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
            skipPollingIfUnfocused = subscribers[key].skipPollingIfUnfocused || skipPollingIfUnfocused;
        }
        return {
            lowestPollingInterval: lowestPollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        };
    }
    return handler;
};
// src/query/core/buildMiddleware/queryLifecycle.ts
var $ac06dac7d42c7bee$var$buildQueryLifecycleHandler = ({ api: api, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk })=>{
    const isPendingThunk = (0, $gtjDQ.isPending)(queryThunk, mutationThunk);
    const isRejectedThunk = (0, $gtjDQ.isRejected)(queryThunk, mutationThunk);
    const isFullfilledThunk = (0, $gtjDQ.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const handler = (action, mwApi)=>{
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            const { requestId: requestId, arg: { endpointName: endpointName, originalArgs: originalArgs } } = action.meta;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            const onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                const lifecycle = {};
                const queryFulfilled = new Promise((resolve, reject)=>{
                    lifecycle.resolve = resolve;
                    lifecycle.reject = reject;
                });
                queryFulfilled.catch(()=>{});
                lifecycleMap[requestId] = lifecycle;
                const selector = api.endpoints[endpointName].select($ac06dac7d42c7bee$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : requestId);
                const extra = mwApi.dispatch((_, __, extra2)=>extra2);
                const lifecycleApi = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, mwApi), {
                    getCacheEntry: ()=>selector(mwApi.getState()),
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: $ac06dac7d42c7bee$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            const { requestId: requestId, baseQueryMeta: baseQueryMeta } = action.meta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            const { requestId: requestId, rejectedWithValue: rejectedWithValue, baseQueryMeta: baseQueryMeta } = action.meta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $ac06dac7d42c7bee$var$buildWindowEventHandler = ({ reducerPath: reducerPath, context: context, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const handler = (action, mwApi)=>{
        if ($ac06dac7d42c7bee$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($ac06dac7d42c7bee$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        const state = api2.getState()[reducerPath];
        const queries = state.queries;
        const subscriptions = internalState.currentSubscriptions;
        context.batch(()=>{
            for (const queryCacheKey of Object.keys(subscriptions)){
                const querySubState = queries[queryCacheKey];
                const subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                const shouldRefetch = Object.values(subscriptionSubState).some((sub)=>sub[type] === true) || Object.values(subscriptionSubState).every((sub)=>sub[type] === void 0) && state.config[type];
                if (shouldRefetch) {
                    if ($ac06dac7d42c7bee$var$countObjectKeys(subscriptionSubState) === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized" /* uninitialized */ ) api2.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/index.ts
function $ac06dac7d42c7bee$var$buildMiddleware(input) {
    const { reducerPath: reducerPath, queryThunk: queryThunk, api: api, context: context } = input;
    const { apiUid: apiUid } = context;
    const actions = {
        invalidateTags: (0, $gtjDQ.createAction)(`${reducerPath}/invalidateTags`)
    };
    const isThisApiSliceAction = (action)=>action.type.startsWith(`${reducerPath}/`);
    const handlerBuilders = [
        $ac06dac7d42c7bee$var$buildDevCheckHandler,
        $ac06dac7d42c7bee$var$buildCacheCollectionHandler,
        $ac06dac7d42c7bee$var$buildInvalidationByTagsHandler,
        $ac06dac7d42c7bee$var$buildPollingHandler,
        $ac06dac7d42c7bee$var$buildCacheLifecycleHandler,
        $ac06dac7d42c7bee$var$buildQueryLifecycleHandler
    ];
    const middleware = (mwApi)=>{
        let initialized2 = false;
        const internalState = {
            currentSubscriptions: {}
        };
        const builderArgs = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery,
            isThisApiSliceAction: isThisApiSliceAction
        });
        const handlers = handlerBuilders.map((build)=>build(builderArgs));
        const batchedActionsHandler = $ac06dac7d42c7bee$var$buildBatchedActionsHandler(builderArgs);
        const windowEventsHandler = $ac06dac7d42c7bee$var$buildWindowEventHandler(builderArgs);
        return (next)=>{
            return (action)=>{
                if (!(0, $10c6O.isAction)(action)) return next(action);
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                const mwApiWithNext = $ac06dac7d42c7bee$var$__spreadProps($ac06dac7d42c7bee$var$__spreadValues({}, mwApi), {
                    next: next
                });
                const stateBefore = mwApi.getState();
                const [actionShouldContinue, internalProbeResult] = batchedActionsHandler(action, mwApiWithNext, stateBefore);
                let res;
                if (actionShouldContinue) res = next(action);
                else res = internalProbeResult;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for (const handler of handlers)handler(action, mwApiWithNext, stateBefore);
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState) {
        return input.api.endpoints[querySubState.endpointName].initiate(querySubState.originalArgs, {
            subscribe: false,
            forceRefetch: true
        });
    }
}
// src/query/core/module.ts
var $ac06dac7d42c7bee$export$2902d0921e535c0 = /* @__PURE__ */ Symbol();
var $ac06dac7d42c7bee$export$eb718ff92afd6f9b = ({ createSelector: createSelector2 = (0, $2ATxG.createSelector) } = {})=>({
        name: $ac06dac7d42c7bee$export$2902d0921e535c0,
        init (api, { baseQuery: baseQuery, tagTypes: tagTypes, reducerPath: reducerPath, serializeQueryArgs: serializeQueryArgs, keepUnusedDataFor: keepUnusedDataFor, refetchOnMountOrArgChange: refetchOnMountOrArgChange, refetchOnFocus: refetchOnFocus, refetchOnReconnect: refetchOnReconnect, invalidationBehavior: invalidationBehavior, onSchemaFailure: onSchemaFailure, catchSchemaFailure: catchSchemaFailure, skipSchemaValidation: skipSchemaValidation }, context) {
            (0, $j4Mta.enablePatches)();
            $ac06dac7d42c7bee$var$assertCast(serializeQueryArgs);
            const assertTagType = (tag)=>{
                typeof $4YPvm;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $ac06dac7d42c7bee$var$onOnline,
                    onOffline: $ac06dac7d42c7bee$var$onOffline,
                    onFocus: $ac06dac7d42c7bee$var$onFocus,
                    onFocusLost: $ac06dac7d42c7bee$var$onFocusLost
                },
                util: {}
            });
            const selectors = $ac06dac7d42c7bee$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                createSelector: createSelector2
            });
            const { selectInvalidatedBy: selectInvalidatedBy, selectCachedArgsForQuery: selectCachedArgsForQuery, buildQuerySelector: buildQuerySelector, buildInfiniteQuerySelector: buildInfiniteQuerySelector, buildMutationSelector: buildMutationSelector } = selectors;
            $ac06dac7d42c7bee$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy,
                selectCachedArgsForQuery: selectCachedArgsForQuery
            });
            const { queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, patchQueryData: patchQueryData, updateQueryData: updateQueryData, upsertQueryData: upsertQueryData, prefetch: prefetch, buildMatchThunkActions: buildMatchThunkActions } = $ac06dac7d42c7bee$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType,
                selectors: selectors,
                onSchemaFailure: onSchemaFailure,
                catchSchemaFailure: catchSchemaFailure,
                skipSchemaValidation: skipSchemaValidation
            });
            const { reducer: reducer, actions: sliceActions } = $ac06dac7d42c7bee$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                mutationThunk: mutationThunk,
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath,
                    invalidationBehavior: invalidationBehavior
                }
            });
            $ac06dac7d42c7bee$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState,
                upsertQueryEntries: sliceActions.cacheEntriesUpserted
            });
            $ac06dac7d42c7bee$var$safeAssign(api.internalActions, sliceActions);
            const { middleware: middleware, actions: middlewareActions } = $ac06dac7d42c7bee$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                assertTagType: assertTagType,
                selectors: selectors
            });
            $ac06dac7d42c7bee$var$safeAssign(api.util, middlewareActions);
            $ac06dac7d42c7bee$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            const { buildInitiateQuery: buildInitiateQuery, buildInitiateInfiniteQuery: buildInitiateInfiniteQuery, buildInitiateMutation: buildInitiateMutation, getRunningMutationThunk: getRunningMutationThunk, getRunningMutationsThunk: getRunningMutationsThunk, getRunningQueriesThunk: getRunningQueriesThunk, getRunningQueryThunk: getRunningQueryThunk } = $ac06dac7d42c7bee$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $ac06dac7d42c7bee$var$safeAssign(api.util, {
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $ac06dac7d42c7bee$export$2902d0921e535c0,
                injectEndpoint (endpointName, definition) {
                    var _a, _b;
                    const anyApi = api;
                    const endpoint = (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($ac06dac7d42c7bee$var$isQueryDefinition(definition)) $ac06dac7d42c7bee$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    if ($ac06dac7d42c7bee$var$isMutationDefinition(definition)) $ac06dac7d42c7bee$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                    if ($ac06dac7d42c7bee$var$isInfiniteQueryDefinition(definition)) $ac06dac7d42c7bee$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildInfiniteQuerySelector(endpointName, definition),
                        initiate: buildInitiateInfiniteQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                }
            };
        }
    });
// src/query/core/index.ts
var $ac06dac7d42c7bee$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $ac06dac7d42c7bee$export$f957748792d43646($ac06dac7d42c7bee$export$eb718ff92afd6f9b());

});
parcelRegister("bQIfh", function(module, exports) {

$parcel$export(module.exports, "SchemaError", function () { return $8a06df413d03ef75$export$44dde8d2b17fc96a; });
// src/getDotPath/getDotPath.ts
function $8a06df413d03ef75$export$31d66bebc5d58a1(issue) {
    if (issue.path?.length) {
        let dotPath = "";
        for (const item of issue.path){
            const key = typeof item === "object" ? item.key : item;
            if (typeof key === "string" || typeof key === "number") {
                if (dotPath) dotPath += `.${key}`;
                else dotPath += key;
            } else return null;
        }
        return dotPath;
    }
    return null;
}
// src/SchemaError/SchemaError.ts
var $8a06df413d03ef75$export$44dde8d2b17fc96a = class extends Error {
    /**
   * The schema issues.
   */ issues;
    /**
   * Creates a schema error with useful information.
   *
   * @param issues The schema issues.
   */ constructor(issues){
        super(issues[0].message);
        this.name = "SchemaError";
        this.issues = issues;
    }
};

});


parcelRegister("7JRAZ", function(module, exports) {

$parcel$export(module.exports, "enhancedApi", function () { return $c8138a4d7108fb9e$export$327b9b2c02b069ca; });

var $1O9Jh = parcelRequire("1O9Jh");
const $c8138a4d7108fb9e$export$327b9b2c02b069ca = (0, $1O9Jh.enhancedApi).enhanceEndpoints({
    endpoints: {
        authRegister: {
            invalidatesTags: []
        },
        authRegisterPartnerCandidate: {
            invalidatesTags: []
        },
        authRequestPasswordReset: {
            invalidatesTags: []
        },
        poolGetChargePoints: {
            providesTags: [
                "Pool"
            ]
        },
        chargePointAddToPool: {
            invalidatesTags: [
                "ChargePoint",
                "Company",
                "Pool"
            ]
        },
        externalServerGetByChargePointId: {
            providesTags: [
                "ExternalServer",
                "ChargePoint"
            ]
        },
        nfcTagConnectToUser: {
            invalidatesTags: [
                "NfcTag",
                "Company"
            ]
        },
        nfcTagDisconnectFromUser: {
            invalidatesTags: [
                "NfcTag",
                "Company"
            ]
        },
        partnerGetAlarmsByPartnerId: {
            providesTags: [
                "Alarm"
            ]
        },
        partnerSetAcknowledged: {
            invalidatesTags: [
                "Alarm"
            ]
        },
        partnerGetCompaniesByPartnerId: {
            providesTags: [
                "Company"
            ]
        },
        companyTransferBatchTransfer: {
            invalidatesTags: [
                "CompanyTransfer",
                "Company",
                "Partner"
            ]
        },
        companyAddMeasurementDeviceToCompany: {
            async onQueryStarted (_, { dispatch: dispatch, queryFulfilled: queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch((0, $1O9Jh.enhancedApi).util.invalidateTags([
                        "MeasurementDevices"
                    ]));
                } catch  {
                // The mutation consumer handles request errors.
                }
            }
        },
        companyUpdateCompanySettings: {
            invalidatesTags: (_result, _error, { body: body })=>body.some((setting)=>setting.name === "BillingCountry") ? [
                    "Company",
                    "Payment"
                ] : [
                    "Company"
                ]
        },
        companyGetCompanyById: {
            providesTags: [
                "Company"
            ]
        },
        companyUpdateUser: {
            invalidatesTags: [
                "Company",
                "User"
            ]
        },
        companyGetServicePartnerCodeInformation: {
            invalidatesTags: []
        },
        partnerCreateServicePartnerInvitationCode: {
            invalidatesTags: [
                "Partner"
            ]
        },
        partnerGetCurrentServicePartnerInvitationCode: {
            providesTags: ()=>[
                    "Partner"
                ]
        },
        partnerGetNfcTags: {
            providesTags: [
                "Partner"
            ]
        },
        nfcTagCreate: {
            invalidatesTags: [
                "Company",
                "NfcTag",
                "Partner"
            ]
        },
        nfcTagUpdate: {
            invalidatesTags: [
                "Company",
                "NfcTag",
                "Partner"
            ]
        },
        nfcTagDelete: {
            invalidatesTags: [
                "Company",
                "NfcTag",
                "Partner"
            ]
        },
        chargePointDeleteRejectedTag: {
            invalidatesTags: [
                "NfcTag"
            ]
        },
        chargePointSetOwner: {
            invalidatesTags: [
                "User"
            ]
        },
        partnerGetLoadbalancerGroupsPaged: {
            providesTags: [
                "Partner",
                "LoadBalancerGroup"
            ]
        },
        companyGetLoadbalancerGroupsPaged: {
            providesTags: [
                "Company",
                "LoadBalancerGroup"
            ]
        },
        loadBalancerGroupValidateChargePointImports: {
            invalidatesTags: []
        },
        chargingSessionGetChargingSessionsForCurrentUser: {
            providesTags: [
                "ChargingSession",
                "ChargePoint",
                "User"
            ]
        }
    }
}).injectEndpoints({
    overrideExisting: true,
    endpoints: (build)=>({
            ocppLogsInfinite: build.infiniteQuery({
                query: ({ queryArg: { source: source, chargePointId: chargePointId, action: action = [], ...filters }, pageParam: pageParam })=>{
                    const params = new URLSearchParams();
                    Object.entries({
                        ...filters,
                        page: pageParam
                    }).forEach(([name, value])=>{
                        if (value !== undefined) params.set(name, String(value));
                    });
                    // The log service takes one `action` parameter per action, not a comma-separated list
                    action.forEach((value)=>params.append("action", value));
                    return {
                        url: `/chargepoints/${chargePointId}/ocpp-logs/${source}`,
                        params: params
                    };
                },
                infiniteQueryOptions: {
                    initialPageParam: 1,
                    getNextPageParam: (lastPage, _allPages, lastPageParam)=>lastPage.pagination?.hasMore ? lastPageParam + 1 : undefined
                },
                providesTags: [
                    "OcppLogs"
                ]
            })
        })
});

});
parcelRegister("1O9Jh", function(module, exports) {

$parcel$export(module.exports, "enhancedApi", function () { return $0d8528c14b31acb8$export$327b9b2c02b069ca; });
$parcel$export(module.exports, "useAlarmGetAllQuery", function () { return $0d8528c14b31acb8$export$3b9ed45176b3bd14; });
$parcel$export(module.exports, "useLazyApiCustomerGetHashedApiKeyQuery", function () { return $0d8528c14b31acb8$export$61a50ff21f26bf7; });
$parcel$export(module.exports, "useApiCustomerGetAllQuery", function () { return $0d8528c14b31acb8$export$1fed5c2974ced427; });
$parcel$export(module.exports, "useApiCustomerCreateMutation", function () { return $0d8528c14b31acb8$export$b60d4698631f7539; });
$parcel$export(module.exports, "useApiCustomerUpdateMutation", function () { return $0d8528c14b31acb8$export$c5b1abdda583ab8c; });
$parcel$export(module.exports, "useApiCustomerDeleteMutation", function () { return $0d8528c14b31acb8$export$9fe50e32e6c5d566; });
$parcel$export(module.exports, "useApiCustomerGetChargePointsQuery", function () { return $0d8528c14b31acb8$export$eb51539457612c05; });
$parcel$export(module.exports, "useAuthGetCurrentQuery", function () { return $0d8528c14b31acb8$export$ebafadf294b1a72; });
$parcel$export(module.exports, "useLazyAuthGetCurrentQuery", function () { return $0d8528c14b31acb8$export$5605c8031c403bdd; });
$parcel$export(module.exports, "useAuthLoginMutation", function () { return $0d8528c14b31acb8$export$6c057666085107c5; });
$parcel$export(module.exports, "useAuthLogoutMutation", function () { return $0d8528c14b31acb8$export$e804342f5a0d615a; });
$parcel$export(module.exports, "useAuthRegisterMutation", function () { return $0d8528c14b31acb8$export$525166814105e5cf; });
$parcel$export(module.exports, "useAuthVerifyEmailMutation", function () { return $0d8528c14b31acb8$export$864bc9a7b33e62e6; });
$parcel$export(module.exports, "useAuthRequestPasswordResetMutation", function () { return $0d8528c14b31acb8$export$fe969a0a9f39f937; });
$parcel$export(module.exports, "useAuthRegisterPartnerCandidateMutation", function () { return $0d8528c14b31acb8$export$21703c5233920746; });
$parcel$export(module.exports, "useChargePointUpdateMutation", function () { return $0d8528c14b31acb8$export$c42987bc9d92d1b0; });
$parcel$export(module.exports, "useChargePointUpdateChargerInformationMutation", function () { return $0d8528c14b31acb8$export$f415455a31da5660; });
$parcel$export(module.exports, "useChargePointGetChargePointsQuery", function () { return $0d8528c14b31acb8$export$363517bccf70e4f; });
$parcel$export(module.exports, "useChargePointGetQuery", function () { return $0d8528c14b31acb8$export$bb435671b8008bb6; });
$parcel$export(module.exports, "useLazyChargePointGetQuery", function () { return $0d8528c14b31acb8$export$20b9947a7035ebe2; });
$parcel$export(module.exports, "useChargePointGetPartnerQuery", function () { return $0d8528c14b31acb8$export$45c605d16bc9449d; });
$parcel$export(module.exports, "useChargePointGetCalibrationQuery", function () { return $0d8528c14b31acb8$export$259a46b5a1188ac4; });
$parcel$export(module.exports, "useChargePointGetChargingSessionsWithCountQuery", function () { return $0d8528c14b31acb8$export$cbd4fee63c466bbc; });
$parcel$export(module.exports, "useChargePointAddToPoolMutation", function () { return $0d8528c14b31acb8$export$a4884a2297d349df; });
$parcel$export(module.exports, "useChargePointSetOwnerMutation", function () { return $0d8528c14b31acb8$export$79ea6a424b4c7cdb; });
$parcel$export(module.exports, "useChargePointRemoveOwnerMutation", function () { return $0d8528c14b31acb8$export$f335423186bfe078; });
$parcel$export(module.exports, "useChargePointRebootMutation", function () { return $0d8528c14b31acb8$export$4b8ae7112ef8a75c; });
$parcel$export(module.exports, "useChargePointGetRemoteStartTagsQuery", function () { return $0d8528c14b31acb8$export$9dde748a445282fa; });
$parcel$export(module.exports, "useChargePointRemoteStartMutation", function () { return $0d8528c14b31acb8$export$8b179a4397477a9; });
$parcel$export(module.exports, "useChargePointRemoteStopMutation", function () { return $0d8528c14b31acb8$export$ce42f2812ddb9fac; });
$parcel$export(module.exports, "useChargePointOverrideScheduleForOngoingChargingSessionMutation", function () { return $0d8528c14b31acb8$export$78873b1513fa0d9f; });
$parcel$export(module.exports, "useChargePointGetMaintenanceLogsQuery", function () { return $0d8528c14b31acb8$export$2c6cc48bdc1aabde; });
$parcel$export(module.exports, "useLazyChargePointGetMaintenanceLogsQuery", function () { return $0d8528c14b31acb8$export$9ed8c81068784007; });
$parcel$export(module.exports, "useChargePointAddMaintenanceLogMutation", function () { return $0d8528c14b31acb8$export$b348df503d6c3f06; });
$parcel$export(module.exports, "useChargePointGetAlarmsQuery", function () { return $0d8528c14b31acb8$export$f2ee2edb9c8f6097; });
$parcel$export(module.exports, "useChargePointAcknowledgeAlarmMutation", function () { return $0d8528c14b31acb8$export$c41fefcc456b72a1; });
$parcel$export(module.exports, "useChargePointDeleteRejectedTagMutation", function () { return $0d8528c14b31acb8$export$7356d9837a49150a; });
$parcel$export(module.exports, "useChargePointDisableOcppMutation", function () { return $0d8528c14b31acb8$export$4d966625cfc5986f; });
$parcel$export(module.exports, "useChargePointEnableOcppMutation", function () { return $0d8528c14b31acb8$export$a9111c6db0f4f4ae; });
$parcel$export(module.exports, "useChargePointUpdateFirmwareMutation", function () { return $0d8528c14b31acb8$export$d0cd610d09d8ac3d; });
$parcel$export(module.exports, "useChargePointUpdateFirmware2Mutation", function () { return $0d8528c14b31acb8$export$d15ba6b880f65d68; });
$parcel$export(module.exports, "useChargePointResetMutation", function () { return $0d8528c14b31acb8$export$2c7302e5339241d8; });
$parcel$export(module.exports, "useChargePointResetAvailableFirmwareVersionMutation", function () { return $0d8528c14b31acb8$export$698a0d0f0fc548b7; });
$parcel$export(module.exports, "useChargePointGetStatusIntervalsQuery", function () { return $0d8528c14b31acb8$export$ce1d86c029686cb3; });
$parcel$export(module.exports, "useChargePointUpdateChargePointUserSettingsMutation", function () { return $0d8528c14b31acb8$export$6792efc2afcb53b6; });
$parcel$export(module.exports, "useChargePointPostChargingLimitationsMutation", function () { return $0d8528c14b31acb8$export$b913f8237059d410; });
$parcel$export(module.exports, "useChargePointWhitelistMutation", function () { return $0d8528c14b31acb8$export$a12ff6f4df7c1623; });
$parcel$export(module.exports, "useChargePointAddServicePartnerMutation", function () { return $0d8528c14b31acb8$export$882457c70f2dcd1d; });
$parcel$export(module.exports, "useChargePointDataGetLatestChargePointDataQuery", function () { return $0d8528c14b31acb8$export$67fcf14964bf1400; });
$parcel$export(module.exports, "useChargePointDataGetChargePointDataWithFilterQuery", function () { return $0d8528c14b31acb8$export$77e8cf3002f6a308; });
$parcel$export(module.exports, "useChargingSessionGetConsumptionForSessionQuery", function () { return $0d8528c14b31acb8$export$7804fdcd3e82b6eb; });
$parcel$export(module.exports, "useChargingSessionGetChargingSessionsForCurrentUserQuery", function () { return $0d8528c14b31acb8$export$c1fb5b3585a8a0fd; });
$parcel$export(module.exports, "useChargingSessionDeleteChargingSessionMutation", function () { return $0d8528c14b31acb8$export$ff6c48ddfd4515a1; });
$parcel$export(module.exports, "useCompanyGetAllOrFilteredQuery", function () { return $0d8528c14b31acb8$export$d616b9885fa4650b; });
$parcel$export(module.exports, "useCompanyCreateCompanyMutation", function () { return $0d8528c14b31acb8$export$a85b87168e210643; });
$parcel$export(module.exports, "useCompanyUpdateCompanyMutation", function () { return $0d8528c14b31acb8$export$1c7ee0742dc5814c; });
$parcel$export(module.exports, "useCompanyGetFilteredPagedQuery", function () { return $0d8528c14b31acb8$export$1ebd0dd03819fe0e; });
$parcel$export(module.exports, "useCompanyGetCompanyByIdQuery", function () { return $0d8528c14b31acb8$export$c2e45d0da8bee022; });
$parcel$export(module.exports, "useCompanyDeleteCompanyMutation", function () { return $0d8528c14b31acb8$export$988ab6f151f909f6; });
$parcel$export(module.exports, "useCompanyGetCompanySettingsQuery", function () { return $0d8528c14b31acb8$export$157c72be7872ffff; });
$parcel$export(module.exports, "useCompanyUpdateCompanySettingsMutation", function () { return $0d8528c14b31acb8$export$8d207656400bebe4; });
$parcel$export(module.exports, "useCompanyGetEntitlementWhitelistQuery", function () { return $0d8528c14b31acb8$export$57d37fa6a254453e; });
$parcel$export(module.exports, "useCompanyCreateEntitlementWhitelistMutation", function () { return $0d8528c14b31acb8$export$dc7167aba6fa92de; });
$parcel$export(module.exports, "useCompanyDeleteEntitlementWhitelistMutation", function () { return $0d8528c14b31acb8$export$df54924d28c4c0c6; });
$parcel$export(module.exports, "useCompanyGetAdministratedCompaniesQuery", function () { return $0d8528c14b31acb8$export$d3cc4d59d9924c3e; });
$parcel$export(module.exports, "useLazyCompanyGetAdministratedCompaniesQuery", function () { return $0d8528c14b31acb8$export$d2252f6f7ad40ca8; });
$parcel$export(module.exports, "useCompanyGetUsersQuery", function () { return $0d8528c14b31acb8$export$7cc43711859703f4; });
$parcel$export(module.exports, "useCompanyCreateUserMutation", function () { return $0d8528c14b31acb8$export$aff2f619920439a; });
$parcel$export(module.exports, "useCompanyUpdateUserMutation", function () { return $0d8528c14b31acb8$export$95cd1114a4526f2e; });
$parcel$export(module.exports, "useCompanyGetChargePointsPagedQuery", function () { return $0d8528c14b31acb8$export$59a08696f7fc7a66; });
$parcel$export(module.exports, "useCompanyGetPartnerQuery", function () { return $0d8528c14b31acb8$export$3007b1f1c171d527; });
$parcel$export(module.exports, "useCompanyGetServicePartnersQuery", function () { return $0d8528c14b31acb8$export$2f2d77d72fc15708; });
$parcel$export(module.exports, "useCompanyAddServicePartnerMutation", function () { return $0d8528c14b31acb8$export$2f75d364ad78725d; });
$parcel$export(module.exports, "useCompanyGetServicePartnerCodeInformationMutation", function () { return $0d8528c14b31acb8$export$d3a9ebe9c0ee3520; });
$parcel$export(module.exports, "useCompanyRemoveServicePartnerMutation", function () { return $0d8528c14b31acb8$export$923cdb8fe1f3688d; });
$parcel$export(module.exports, "useCompanyGetReportDeliverySchedulesQuery", function () { return $0d8528c14b31acb8$export$1678db909b27844f; });
$parcel$export(module.exports, "useCompanyCreateReportDeliveryScheduleMutation", function () { return $0d8528c14b31acb8$export$1bb5d8cdb39d99d6; });
$parcel$export(module.exports, "useCompanyUpdateReportDeliveryScheduleMutation", function () { return $0d8528c14b31acb8$export$37f31bf7dbbce085; });
$parcel$export(module.exports, "useCompanyDeleteReportDeliveryScheduleMutation", function () { return $0d8528c14b31acb8$export$c28117789a429b4b; });
$parcel$export(module.exports, "useLazyCompanyCreateImportStringQuery", function () { return $0d8528c14b31acb8$export$77893eef173c4d9e; });
$parcel$export(module.exports, "useCompanyGetPoolsQuery", function () { return $0d8528c14b31acb8$export$e0d8ff65f8950471; });
$parcel$export(module.exports, "useCompanyGetChargingSessionsByRangeQuery", function () { return $0d8528c14b31acb8$export$5fc1cea6b764fcf9; });
$parcel$export(module.exports, "useCompanyDeleteChargingSessionsMutation", function () { return $0d8528c14b31acb8$export$4b5fc92bf71467e9; });
$parcel$export(module.exports, "useCompanyGetNfcTagsQuery", function () { return $0d8528c14b31acb8$export$8a2f6d6738ace846; });
$parcel$export(module.exports, "useCompanyGetLoadbalancerGroupsPagedQuery", function () { return $0d8528c14b31acb8$export$732112fdbac45b2b; });
$parcel$export(module.exports, "useCompanyAddRoleToUserMutation", function () { return $0d8528c14b31acb8$export$d87a7ede857b2b32; });
$parcel$export(module.exports, "useCompanyUpdateRoleToUserMutation", function () { return $0d8528c14b31acb8$export$1c9a30f97b6cd273; });
$parcel$export(module.exports, "useCompanyAddChargePointToCompanyMutation", function () { return $0d8528c14b31acb8$export$2c978a0ef520d550; });
$parcel$export(module.exports, "useCompanyRemoveChargePointMutation", function () { return $0d8528c14b31acb8$export$18356fb5a15d5665; });
$parcel$export(module.exports, "useCompanyRemoveUserMutation", function () { return $0d8528c14b31acb8$export$975361f27d244f40; });
$parcel$export(module.exports, "useCompanyGetChargePointsWithNfcInfoQuery", function () { return $0d8528c14b31acb8$export$90b2c801eb28fede; });
$parcel$export(module.exports, "useCompanySetChargePointsNfcInfoMutation", function () { return $0d8528c14b31acb8$export$d88c115ad46b33e8; });
$parcel$export(module.exports, "useCompanyGetPoolsWithNfcInfoQuery", function () { return $0d8528c14b31acb8$export$46477c8474cf35a5; });
$parcel$export(module.exports, "useCompanySetPoolsNfcInfoMutation", function () { return $0d8528c14b31acb8$export$1c11799c30d7d286; });
$parcel$export(module.exports, "useCompanyGetChargePointsWithNfcInfoForTagQuery", function () { return $0d8528c14b31acb8$export$35519a6d993d3708; });
$parcel$export(module.exports, "useCompanySetChargePointsNfcInfoForTagMutation", function () { return $0d8528c14b31acb8$export$f3473afb1bdfedec; });
$parcel$export(module.exports, "useCompanyGetPoolsWithNfcInfoForTagQuery", function () { return $0d8528c14b31acb8$export$233e231d2673860f; });
$parcel$export(module.exports, "useCompanySetPoolsNfcInfoForTagMutation", function () { return $0d8528c14b31acb8$export$95f31563c4ef4bcf; });
$parcel$export(module.exports, "useCompanyGetNfcTagsForUserQuery", function () { return $0d8528c14b31acb8$export$c00cf6e9fe765604; });
$parcel$export(module.exports, "useCompanyGetChargePointsForUserQuery", function () { return $0d8528c14b31acb8$export$be30daf7ef1dbebf; });
$parcel$export(module.exports, "useCompanyInviteExistingUserToCompanyMutation", function () { return $0d8528c14b31acb8$export$30fb2a620567b76; });
$parcel$export(module.exports, "useCompanyAddMeasurementDeviceToCompanyMutation", function () { return $0d8528c14b31acb8$export$11d986f615786e11; });
$parcel$export(module.exports, "useCompanyGetDeviceByCompanyIdQuery", function () { return $0d8528c14b31acb8$export$9b23e072f3e94387; });
$parcel$export(module.exports, "useCompanyRemoveMeasurementDeviceMutation", function () { return $0d8528c14b31acb8$export$8d0f9b36cdc6610b; });
$parcel$export(module.exports, "useCompanyTransferGetPartnerTransferKeyQuery", function () { return $0d8528c14b31acb8$export$b3a709104b3e3eb6; });
$parcel$export(module.exports, "useCompanyTransferGetPartnerQuery", function () { return $0d8528c14b31acb8$export$95f7447cf8de286f; });
$parcel$export(module.exports, "useCompanyTransferGetRequestsForPartnerQuery", function () { return $0d8528c14b31acb8$export$a28ae8a9e537a80f; });
$parcel$export(module.exports, "useCompanyTransferGetRequestsQuery", function () { return $0d8528c14b31acb8$export$aa6cb02aa01e9757; });
$parcel$export(module.exports, "useCompanyTransferRequestTransferMutation", function () { return $0d8528c14b31acb8$export$159e8e086d7a5840; });
$parcel$export(module.exports, "useCompanyTransferAcceptRequestMutation", function () { return $0d8528c14b31acb8$export$ddf6449426f5a4c0; });
$parcel$export(module.exports, "useCompanyTransferRejectRequestMutation", function () { return $0d8528c14b31acb8$export$e3b2812549f44416; });
$parcel$export(module.exports, "useCompanyTransferBatchTransferMutation", function () { return $0d8528c14b31acb8$export$a50dd055eba7518b; });
$parcel$export(module.exports, "useCompanyTransferGetDecisionLogsQuery", function () { return $0d8528c14b31acb8$export$1cca321e2639c69; });
$parcel$export(module.exports, "useCompanyTransferGetPartnerDecisionLogsQuery", function () { return $0d8528c14b31acb8$export$2e185ab7e73f27ab; });
$parcel$export(module.exports, "useConsumptionDataChargingSessionQuery", function () { return $0d8528c14b31acb8$export$4d2916ecc13f1126; });
$parcel$export(module.exports, "useCountrySettingsGetAllCountrySettingsQuery", function () { return $0d8528c14b31acb8$export$518234d7c924f073; });
$parcel$export(module.exports, "useEntitlementsCreateContextTokenMutation", function () { return $0d8528c14b31acb8$export$c9c77fd03937a192; });
$parcel$export(module.exports, "useEntitlementsDeleteContextTokenMutation", function () { return $0d8528c14b31acb8$export$a359e6a20285fbba; });
$parcel$export(module.exports, "useExternalServerGetAllQuery", function () { return $0d8528c14b31acb8$export$7ae98e873be5a622; });
$parcel$export(module.exports, "useExternalServerCreateMutation", function () { return $0d8528c14b31acb8$export$31609f1020ce83c9; });
$parcel$export(module.exports, "useExternalServerGetByChargePointIdQuery", function () { return $0d8528c14b31acb8$export$1092db0b0c6ec1c7; });
$parcel$export(module.exports, "useExternalServerGetChargePointsQuery", function () { return $0d8528c14b31acb8$export$67e4a8ce13f19ecb; });
$parcel$export(module.exports, "useExternalServerGetPartnersQuery", function () { return $0d8528c14b31acb8$export$f4654392afe351fa; });
$parcel$export(module.exports, "useExternalServerUpdatePartnerConnectionsMutation", function () { return $0d8528c14b31acb8$export$cd5a3f32c9293dd8; });
$parcel$export(module.exports, "useExternalServerDeleteMutation", function () { return $0d8528c14b31acb8$export$337240799894367c; });
$parcel$export(module.exports, "useFirmwareGetFirmwaresByFilterQuery", function () { return $0d8528c14b31acb8$export$646dc2d3fc61fc73; });
$parcel$export(module.exports, "useFirmwareUploadFirmwareMutation", function () { return $0d8528c14b31acb8$export$7bc0f08612f54e6f; });
$parcel$export(module.exports, "useFirmwareUpdateFirmwareMutation", function () { return $0d8528c14b31acb8$export$b11da0bf9e2f8411; });
$parcel$export(module.exports, "useFirmwareDeleteFirmwareMutation", function () { return $0d8528c14b31acb8$export$414a83ef2478ba73; });
$parcel$export(module.exports, "useFirmwareSetActiveFirmwareMutation", function () { return $0d8528c14b31acb8$export$eb655f66edad2b9d; });
$parcel$export(module.exports, "useFirmwareGetActiveFirmwareQuery", function () { return $0d8528c14b31acb8$export$f7ed4990ff7a8ac4; });
$parcel$export(module.exports, "useGreenChargingGetLoadBalancerGroupQuery", function () { return $0d8528c14b31acb8$export$70fd2d91e328c35e; });
$parcel$export(module.exports, "useGreenChargingChargePointStatusQuery", function () { return $0d8528c14b31acb8$export$f3d33bc7d7a9fa83; });
$parcel$export(module.exports, "useLazyGreenChargingChargePointStatusQuery", function () { return $0d8528c14b31acb8$export$a3adae3edeea0927; });
$parcel$export(module.exports, "useGreenChargingUpdateLoadBalancerGroupMutation", function () { return $0d8528c14b31acb8$export$24b72b14d456cf25; });
$parcel$export(module.exports, "useInstallationSetupMutation", function () { return $0d8528c14b31acb8$export$80eb369ca5b8310; });
$parcel$export(module.exports, "useLoadBalancerGroupGetAllPagedQuery", function () { return $0d8528c14b31acb8$export$19f7a00af4452045; });
$parcel$export(module.exports, "useLoadBalancerGroupCreateMutation", function () { return $0d8528c14b31acb8$export$e30fe16b97a4b0b7; });
$parcel$export(module.exports, "useLoadBalancerGroupUpdateMutation", function () { return $0d8528c14b31acb8$export$ffd1c6b031703b28; });
$parcel$export(module.exports, "useLoadBalancerGroupDeleteMutation", function () { return $0d8528c14b31acb8$export$f0c227d20992923a; });
$parcel$export(module.exports, "useLoadBalancerGroupGetByIdQuery", function () { return $0d8528c14b31acb8$export$49bfeec35dd56e05; });
$parcel$export(module.exports, "useLoadBalancerGroupGetChargePointsForGroupQuery", function () { return $0d8528c14b31acb8$export$2ef27f08cb944fbf; });
$parcel$export(module.exports, "useLoadBalancerGroupGetCurrentLimitSchemeQuery", function () { return $0d8528c14b31acb8$export$f8f28f4ba1a81689; });
$parcel$export(module.exports, "useLoadBalancerGroupInsertOrUpdateCurrentLimitSchemeMutation", function () { return $0d8528c14b31acb8$export$b57ece852d0d6830; });
$parcel$export(module.exports, "useLoadBalancerGroupDisableGroupMutation", function () { return $0d8528c14b31acb8$export$ee93cfeb406978e; });
$parcel$export(module.exports, "useLoadBalancerGroupEnableGroupMutation", function () { return $0d8528c14b31acb8$export$f50ea22b576ef590; });
$parcel$export(module.exports, "useLoadBalancerGroupValidateChargePointImportsMutation", function () { return $0d8528c14b31acb8$export$28a819e5ce2e34f7; });
$parcel$export(module.exports, "useLoadBalancerGroupImportChargePointsMutation", function () { return $0d8528c14b31acb8$export$b0465d694d043775; });
$parcel$export(module.exports, "useLoadBalancerGroupImportChargePointsV2Mutation", function () { return $0d8528c14b31acb8$export$cad2858136be6e54; });
$parcel$export(module.exports, "useLoadBalancerGroupDeleteChargePointFromGroupMutation", function () { return $0d8528c14b31acb8$export$72ac24f7087a020d; });
$parcel$export(module.exports, "useLoadBalancerGroupGetSnapshotByDeviceIdQuery", function () { return $0d8528c14b31acb8$export$b255557a157483ac; });
$parcel$export(module.exports, "useLazyLoadBalancerGroupGetSnapshotByDeviceIdQuery", function () { return $0d8528c14b31acb8$export$fa019c5e268cae6c; });
$parcel$export(module.exports, "useLogGetErrorsQuery", function () { return $0d8528c14b31acb8$export$8b5d9ff98a32da21; });
$parcel$export(module.exports, "useLogGetByLatestChargePointExcludingOcppQuery", function () { return $0d8528c14b31acb8$export$3ff215c64c16041c; });
$parcel$export(module.exports, "useLogGetInteractionLogItemsQuery", function () { return $0d8528c14b31acb8$export$f32a9121e8116176; });
$parcel$export(module.exports, "useLazyLogGetInteractionLogItemsQuery", function () { return $0d8528c14b31acb8$export$46a0cfca03f74457; });
$parcel$export(module.exports, "useLogAddInteractionLogItemMutation", function () { return $0d8528c14b31acb8$export$11a6b1cbb1fa7ab4; });
$parcel$export(module.exports, "useLogDeleteInteractionLogItemMutation", function () { return $0d8528c14b31acb8$export$77d87d165e813e3f; });
$parcel$export(module.exports, "useMeasurementDevicesGetFilteredQuery", function () { return $0d8528c14b31acb8$export$3a117c89a29f6822; });
$parcel$export(module.exports, "useMeasurementDevicesCreateMutation", function () { return $0d8528c14b31acb8$export$cd72177bc6cf977; });
$parcel$export(module.exports, "useMeasurementDevicesGetFilteredPagedQuery", function () { return $0d8528c14b31acb8$export$7b6e8138034df4e8; });
$parcel$export(module.exports, "useMeasurementDevicesGetByIdQuery", function () { return $0d8528c14b31acb8$export$8a69104efdbbadea; });
$parcel$export(module.exports, "useMeasurementDevicesUpdateMutation", function () { return $0d8528c14b31acb8$export$a18d8645c678f1a3; });
$parcel$export(module.exports, "useMeasurementDevicesGetDevicesByUserIdQuery", function () { return $0d8528c14b31acb8$export$5f11b8c20f88e704; });
$parcel$export(module.exports, "useMeasurementDevicesRemoveMeasurementDeviceFromCompanyMutation", function () { return $0d8528c14b31acb8$export$5ae990b53f2087b8; });
$parcel$export(module.exports, "useMeasurementDevicesGetLatestMeasurementQuery", function () { return $0d8528c14b31acb8$export$2e7ac47262a4b34f; });
$parcel$export(module.exports, "useMeasurementDevicesGetMeasurementsForLatest24HoursQuery", function () { return $0d8528c14b31acb8$export$c96227187153e2ec; });
$parcel$export(module.exports, "useLazyMeasurementDevicesGetValidatedMeasurementDeviceQuery", function () { return $0d8528c14b31acb8$export$e004333d1d6c649a; });
$parcel$export(module.exports, "useNfcTagCreateMutation", function () { return $0d8528c14b31acb8$export$495a6f78305598e8; });
$parcel$export(module.exports, "useNfcTagUpdateMutation", function () { return $0d8528c14b31acb8$export$d4d3461fb63a3ef3; });
$parcel$export(module.exports, "useNfcTagConnectToUserMutation", function () { return $0d8528c14b31acb8$export$ab58f3b3edfc9ed3; });
$parcel$export(module.exports, "useNfcTagDisconnectFromUserMutation", function () { return $0d8528c14b31acb8$export$f2d058aeb105f39c; });
$parcel$export(module.exports, "useNfcTagDeleteMutation", function () { return $0d8528c14b31acb8$export$39f088f37ac37ba4; });
$parcel$export(module.exports, "useNfcTagGetRejectedTagsQuery", function () { return $0d8528c14b31acb8$export$5a5af2a436401c10; });
$parcel$export(module.exports, "useOcppCommandResetMutation", function () { return $0d8528c14b31acb8$export$f8764b26b9b4498d; });
$parcel$export(module.exports, "useOcppCommandClearCacheMutation", function () { return $0d8528c14b31acb8$export$c75bcb1cd9d6103d; });
$parcel$export(module.exports, "useOcppCommandDataTransferMutation", function () { return $0d8528c14b31acb8$export$5cb549297b6bf15b; });
$parcel$export(module.exports, "useOcppCommandGetConfigurationMutation", function () { return $0d8528c14b31acb8$export$9fdffb52b6084b06; });
$parcel$export(module.exports, "useOcppCommandGetDiagnosticsMutation", function () { return $0d8528c14b31acb8$export$6d8bddeeca5836e4; });
$parcel$export(module.exports, "useOcppCommandUnlockConnectorMutation", function () { return $0d8528c14b31acb8$export$cbee8c171673c55b; });
$parcel$export(module.exports, "useOcppCommandChangeAvailabilityMutation", function () { return $0d8528c14b31acb8$export$95635692900a310b; });
$parcel$export(module.exports, "useOcppCommandRemoteStartMutation", function () { return $0d8528c14b31acb8$export$30d5a3acf40920a5; });
$parcel$export(module.exports, "useOcppCommandRemoteStopMutation", function () { return $0d8528c14b31acb8$export$392294730b980489; });
$parcel$export(module.exports, "useOcppCommandTriggerMessageMutation", function () { return $0d8528c14b31acb8$export$404d7cabf585b706; });
$parcel$export(module.exports, "useOcppCommandUpdateFirmwareMutation", function () { return $0d8528c14b31acb8$export$59a563159e50729f; });
$parcel$export(module.exports, "useOcppCommandUpdateConfigKeysMutation", function () { return $0d8528c14b31acb8$export$d868ac7bc625c769; });
$parcel$export(module.exports, "useOcppCommandUpdateConfigKeyMutation", function () { return $0d8528c14b31acb8$export$cadfa007eac2dbb4; });
$parcel$export(module.exports, "usePartnerGetAllAllQuery", function () { return $0d8528c14b31acb8$export$f010ef6795c8d747; });
$parcel$export(module.exports, "usePartnerCreatePartnerMutation", function () { return $0d8528c14b31acb8$export$71d3a20d03257139; });
$parcel$export(module.exports, "usePartnerUpdatePartnerMutation", function () { return $0d8528c14b31acb8$export$c91c09948d22cd17; });
$parcel$export(module.exports, "usePartnerGetAllQuery", function () { return $0d8528c14b31acb8$export$7b6528535d7e17c6; });
$parcel$export(module.exports, "usePartnerGetByIdQuery", function () { return $0d8528c14b31acb8$export$cfd4f39902297de0; });
$parcel$export(module.exports, "usePartnerDeleteMutation", function () { return $0d8528c14b31acb8$export$a84a32fadc382fd; });
$parcel$export(module.exports, "usePartnerCreateServicePartnerInvitationCodeMutation", function () { return $0d8528c14b31acb8$export$9b8644fe88b1cb10; });
$parcel$export(module.exports, "usePartnerGetCurrentServicePartnerInvitationCodeQuery", function () { return $0d8528c14b31acb8$export$dfcc97f2bba1bba9; });
$parcel$export(module.exports, "usePartnerGetCompaniesByPartnerIdQuery", function () { return $0d8528c14b31acb8$export$eea1f48d07ad4e82; });
$parcel$export(module.exports, "usePartnerGetChargePointsPagedQuery", function () { return $0d8528c14b31acb8$export$30134f8e086bb236; });
$parcel$export(module.exports, "usePartnerGetAlarmsByPartnerIdQuery", function () { return $0d8528c14b31acb8$export$8c9744dad4a4370; });
$parcel$export(module.exports, "usePartnerSetAcknowledgedMutation", function () { return $0d8528c14b31acb8$export$bf793fdf8374ac39; });
$parcel$export(module.exports, "usePartnerGetUsersByPartnerIdQuery", function () { return $0d8528c14b31acb8$export$5993ca7a80dd1020; });
$parcel$export(module.exports, "usePartnerCreatePartnerUserMutation", function () { return $0d8528c14b31acb8$export$142c609922564748; });
$parcel$export(module.exports, "usePartnerUpdatePartnerUserMutation", function () { return $0d8528c14b31acb8$export$5572e0989e2d960b; });
$parcel$export(module.exports, "usePartnerAddUserAsPartnerMutation", function () { return $0d8528c14b31acb8$export$49ead860fae676e9; });
$parcel$export(module.exports, "usePartnerRemoveUserAsPartnerMutation", function () { return $0d8528c14b31acb8$export$2d9eace371761d91; });
$parcel$export(module.exports, "usePartnerGetLoadbalancerGroupsPagedQuery", function () { return $0d8528c14b31acb8$export$c1097b3bfdc8bd6d; });
$parcel$export(module.exports, "usePartnerGetNfcTagsQuery", function () { return $0d8528c14b31acb8$export$49c98b6ae0c8e38e; });
$parcel$export(module.exports, "usePartnerGetExternalServersQuery", function () { return $0d8528c14b31acb8$export$2e87dbc72f31f45; });
$parcel$export(module.exports, "usePaymentCreateOrganizationSubscriptionMutation", function () { return $0d8528c14b31acb8$export$c912fa9ac154e442; });
$parcel$export(module.exports, "usePaymentGetSubscriptionsByOrgQuery", function () { return $0d8528c14b31acb8$export$ba788864fae3c011; });
$parcel$export(module.exports, "useLazyPaymentGetSubscriptionsByOrgQuery", function () { return $0d8528c14b31acb8$export$25e4742d16b1e966; });
$parcel$export(module.exports, "usePaymentValidateDiscountCodeMutation", function () { return $0d8528c14b31acb8$export$94954c57899292ab; });
$parcel$export(module.exports, "usePaymentGetCustomerQuery", function () { return $0d8528c14b31acb8$export$fbccc4205da306d1; });
$parcel$export(module.exports, "usePaymentGetSubscriptionDetailsQuery", function () { return $0d8528c14b31acb8$export$28932fa82f672f40; });
$parcel$export(module.exports, "usePaymentGetBillableConnectorsQuery", function () { return $0d8528c14b31acb8$export$c527e99eb1b47b85; });
$parcel$export(module.exports, "usePaymentCreateOrganizationCheckoutSessionMutation", function () { return $0d8528c14b31acb8$export$cf58a0d796c7f855; });
$parcel$export(module.exports, "usePaymentCreateIndividualCheckoutSessionMutation", function () { return $0d8528c14b31acb8$export$39f5b526ca68ad54; });
$parcel$export(module.exports, "usePaymentCreateSelfServicePortalMutation", function () { return $0d8528c14b31acb8$export$bf11b2fde8835ef5; });
$parcel$export(module.exports, "usePaymentGetCommercialOfferingsQuery", function () { return $0d8528c14b31acb8$export$ad20073fbda8c3e6; });
$parcel$export(module.exports, "usePoolCreateMutation", function () { return $0d8528c14b31acb8$export$f7ac74521cc29298; });
$parcel$export(module.exports, "usePoolUpdateMutation", function () { return $0d8528c14b31acb8$export$6317cae65483ef68; });
$parcel$export(module.exports, "usePoolGetByIdQuery", function () { return $0d8528c14b31acb8$export$a0ebaacb616e8ffa; });
$parcel$export(module.exports, "usePoolDeletePoolMutation", function () { return $0d8528c14b31acb8$export$cc7d400d397c41d3; });
$parcel$export(module.exports, "usePoolGetChargePointsQuery", function () { return $0d8528c14b31acb8$export$650cedd391f8138e; });
$parcel$export(module.exports, "useProductGetOptionsQuery", function () { return $0d8528c14b31acb8$export$e6b45a2ecf8278ea; });
$parcel$export(module.exports, "useProductGetHardwareversionsQuery", function () { return $0d8528c14b31acb8$export$753741c465a943eb; });
$parcel$export(module.exports, "useReportGetReportsForAdminQuery", function () { return $0d8528c14b31acb8$export$b17ff0e45de1a64d; });
$parcel$export(module.exports, "useReportGetReportsForPartnerQuery", function () { return $0d8528c14b31acb8$export$998f1cfb73571472; });
$parcel$export(module.exports, "useLazyReportGetReportDataQuery", function () { return $0d8528c14b31acb8$export$f790d1b338880adb; });
$parcel$export(module.exports, "useScheduleDeleteScheduleMutation", function () { return $0d8528c14b31acb8$export$a772ad50b3f0a169; });
$parcel$export(module.exports, "useScheduleGetByChargePointQuery", function () { return $0d8528c14b31acb8$export$e005b5ecca8409a2; });
$parcel$export(module.exports, "useScheduleCreateScheduleMutation", function () { return $0d8528c14b31acb8$export$5591d0e6dcc2c0ea; });
$parcel$export(module.exports, "useScheduleUpdateScheduleMutation", function () { return $0d8528c14b31acb8$export$f4e2236bcbdc402; });
$parcel$export(module.exports, "useScheduleCopyScheduleFromChargePointMutation", function () { return $0d8528c14b31acb8$export$4081b33cbf9610f3; });
$parcel$export(module.exports, "useScopedAccessGetCurrentScopedAccessContextQuery", function () { return $0d8528c14b31acb8$export$78c1e2205c54a90c; });
$parcel$export(module.exports, "useLazyScopedAccessGetCurrentScopedAccessContextQuery", function () { return $0d8528c14b31acb8$export$a47730f54f06764e; });
$parcel$export(module.exports, "useScopedAccessStartScopedAccessContextMutation", function () { return $0d8528c14b31acb8$export$f7e4795c78af102; });
$parcel$export(module.exports, "useScopedAccessStopScopedAccessContextMutation", function () { return $0d8528c14b31acb8$export$cca9476058317417; });
$parcel$export(module.exports, "useSmartChargingScheduleClearMutation", function () { return $0d8528c14b31acb8$export$42a9c5e3022dc455; });
$parcel$export(module.exports, "useSmartChargingScheduleGetByChargePointQuery", function () { return $0d8528c14b31acb8$export$9d91582acb484f76; });
$parcel$export(module.exports, "useSmartChargingScheduleGetChargePointScheduleStatusQuery", function () { return $0d8528c14b31acb8$export$30d034af40585192; });
$parcel$export(module.exports, "useSmartChargingScheduleUpdateMutation", function () { return $0d8528c14b31acb8$export$4ad870682067ac0f; });
$parcel$export(module.exports, "useStatisticsGetChargePointStatusStatsForAllQuery", function () { return $0d8528c14b31acb8$export$24fb9e4587523db; });
$parcel$export(module.exports, "useStatisticsGetChargePointStatusStatsForPartnerQuery", function () { return $0d8528c14b31acb8$export$78f8303b3fc03d9c; });
$parcel$export(module.exports, "useStatisticsGetUserTotalConsumptionQuery", function () { return $0d8528c14b31acb8$export$4c7cf5776d56335d; });
$parcel$export(module.exports, "useStatisticsGetChargePointStatusStatsForCompanyQuery", function () { return $0d8528c14b31acb8$export$9686fa758fe8f2; });
$parcel$export(module.exports, "useStatisticsGetCompanyTotalConsumptionQuery", function () { return $0d8528c14b31acb8$export$9eba4218577b727f; });
$parcel$export(module.exports, "useStatisticsGetUserUsageStatisticsQuery", function () { return $0d8528c14b31acb8$export$9db48a1e1755a94; });
$parcel$export(module.exports, "useStatisticsGetCompanyUsageStatisticsQuery", function () { return $0d8528c14b31acb8$export$18668fbd9875d4f1; });
$parcel$export(module.exports, "useTroubleshootingGetErrorCodeTroubleshootingInfoQuery", function () { return $0d8528c14b31acb8$export$666efd9c11950fab; });
$parcel$export(module.exports, "useUserGetFilteredQuery", function () { return $0d8528c14b31acb8$export$830cffc4a6efbc3c; });
$parcel$export(module.exports, "useLazyUserGetFilteredQuery", function () { return $0d8528c14b31acb8$export$cb7ca20edb708078; });
$parcel$export(module.exports, "useUserUpdateLoggedInUserMutation", function () { return $0d8528c14b31acb8$export$8cf9f35f7fef6c07; });
$parcel$export(module.exports, "useUserGetFilteredPagedQuery", function () { return $0d8528c14b31acb8$export$eb23d8b0f3ef1795; });
$parcel$export(module.exports, "useUserGetUserByIdQuery", function () { return $0d8528c14b31acb8$export$bc64ed84199046ea; });
$parcel$export(module.exports, "useUserObfuscateUserMutation", function () { return $0d8528c14b31acb8$export$94e1839f94537e85; });
$parcel$export(module.exports, "useLazyUserGetUserSettingsQuery", function () { return $0d8528c14b31acb8$export$8fcbc3b7b48bd3d; });
$parcel$export(module.exports, "useUserUpdateUserSettingsMutation", function () { return $0d8528c14b31acb8$export$177cec91283d0043; });
$parcel$export(module.exports, "useUserLoggedInUserIsCompanyMemberQuery", function () { return $0d8528c14b31acb8$export$d2dcbc5cb00626d5; });
$parcel$export(module.exports, "useUserGetPoolsForSelectedCompanyQuery", function () { return $0d8528c14b31acb8$export$b382b03a87503d64; });
$parcel$export(module.exports, "useUserGetForUserByNfcAccessWithNfcAccessInfoQuery", function () { return $0d8528c14b31acb8$export$602255d25ca10a39; });
$parcel$export(module.exports, "useUserGetOwnedChargePointsQuery", function () { return $0d8528c14b31acb8$export$d4a9defa2e151633; });
$parcel$export(module.exports, "useLazyUserGetOwnedChargePointsWithIdsQuery", function () { return $0d8528c14b31acb8$export$720625aab6d802b; });
$parcel$export(module.exports, "useLazyUserIsUserHasChargePointsQuery", function () { return $0d8528c14b31acb8$export$d4cb51064ec856d9; });
$parcel$export(module.exports, "useUserGetOwnNfcTagsQuery", function () { return $0d8528c14b31acb8$export$c033d09657e3284e; });
$parcel$export(module.exports, "useUserUpdateUserGreenChargingSettingMutation", function () { return $0d8528c14b31acb8$export$f42e676e80abeef8; });
$parcel$export(module.exports, "useUserRemoveChargePointAccessMutation", function () { return $0d8528c14b31acb8$export$89c983eecf9bc2b2; });
$parcel$export(module.exports, "useUserAcceptTermsMutation", function () { return $0d8528c14b31acb8$export$5d73fe33ab3c7cd5; });
$parcel$export(module.exports, "useUserIsFavouriteQuery", function () { return $0d8528c14b31acb8$export$57987d4bbf0c1b5b; });
$parcel$export(module.exports, "useUserAddFavouriteMutation", function () { return $0d8528c14b31acb8$export$3f63a36da3d5bf13; });
$parcel$export(module.exports, "useUserRemoveFavouriteMutation", function () { return $0d8528c14b31acb8$export$2c140682f52cd193; });
$parcel$export(module.exports, "useUserGetFavouritesQuery", function () { return $0d8528c14b31acb8$export$aa4efa994c5ebf80; });
$parcel$export(module.exports, "useUserActivateUserMutation", function () { return $0d8528c14b31acb8$export$1005efb6d88ab1f9; });
$parcel$export(module.exports, "useUserUnlockUserMutation", function () { return $0d8528c14b31acb8$export$3ab42235d5dae9e0; });

var $Qfv2Q = parcelRequire("Qfv2Q");
const $0d8528c14b31acb8$export$324f7eb0c737e949 = [
    "Alarm",
    "ApiCustomer",
    "Article",
    "Auth",
    "ChargePoint",
    "ChargePointData",
    "ChargingSession",
    "CircuitBoard",
    "Company",
    "CompanyTransfer",
    "ComputedNfcAccess",
    "ConsumptionData",
    "CountrySettings",
    "Csrf",
    "Entitlements",
    "ExternalServer",
    "Firmware",
    "GreenCharging",
    "Installation",
    "LoadBalancerGroup",
    "Log",
    "MeasurementDevices",
    "Migration",
    "NfcTag",
    "Notification",
    "OcppCommand",
    "OcppLogs",
    "Partner",
    "Payment",
    "Pool",
    "Product",
    "Report",
    "Schedule",
    "ScopedAccess",
    "SimulatedChargePoint",
    "SmartChargingSchedule",
    "Statistics",
    "Troubleshooting",
    "User"
];
const $0d8528c14b31acb8$export$327b9b2c02b069ca = (0, $Qfv2Q.baseApi).enhanceEndpoints({
    addTagTypes: $0d8528c14b31acb8$export$324f7eb0c737e949
}).injectEndpoints({
    endpoints: (build)=>({
            alarmGetAll: build.query({
                query: (queryArg)=>({
                        url: `/alarms`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Alarm"
                ]
            }),
            apiCustomerGetHashedApiKey: build.query({
                query: ()=>({
                        url: `/apicustomers/generatekey`
                    }),
                providesTags: [
                    "ApiCustomer"
                ]
            }),
            apiCustomerGetAll: build.query({
                query: (queryArg)=>({
                        url: `/apicustomers`,
                        params: {
                            Enabled: queryArg.enabled,
                            CallbackEnabled: queryArg.callbackEnabled
                        }
                    }),
                providesTags: [
                    "ApiCustomer"
                ]
            }),
            apiCustomerCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/apicustomers`,
                        method: "POST",
                        body: queryArg.apiCustomer
                    }),
                invalidatesTags: [
                    "ApiCustomer"
                ]
            }),
            apiCustomerUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/apicustomers`,
                        method: "PUT",
                        body: queryArg.apiCustomer
                    }),
                invalidatesTags: [
                    "ApiCustomer"
                ]
            }),
            apiCustomerDelete: build.mutation({
                query: (queryArg)=>({
                        url: `/apicustomers/${queryArg.apiCustomerId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ApiCustomer"
                ]
            }),
            apiCustomerGetChargePoints: build.query({
                query: (queryArg)=>({
                        url: `/apicustomers/${queryArg.apiCustomerId}/chargepointids`
                    }),
                providesTags: [
                    "ApiCustomer"
                ]
            }),
            articleGetFilteredArticles: build.query({
                query: (queryArg)=>({
                        url: `/articles`,
                        params: {
                            ProductId: queryArg.productId
                        }
                    }),
                providesTags: [
                    "Article"
                ]
            }),
            authGetCurrent: build.query({
                query: ()=>({
                        url: `/auth/current`
                    }),
                providesTags: [
                    "Auth"
                ]
            }),
            authLogin: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/login`,
                        method: "POST",
                        body: queryArg.userCredentials
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authStartSupportLogin: build.query({
                query: ()=>({
                        url: `/auth/superuser-login`
                    }),
                providesTags: [
                    "Auth"
                ]
            }),
            authLoginCallback: build.query({
                query: (queryArg)=>({
                        url: `/auth/login-callback`,
                        params: {
                            code: queryArg.code,
                            state: queryArg.state,
                            error: queryArg.error,
                            error_description: queryArg.errorDescription
                        }
                    }),
                providesTags: [
                    "Auth"
                ]
            }),
            authLogout: build.mutation({
                query: ()=>({
                        url: `/auth/logout`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authRegister: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/register`,
                        method: "POST",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authVerifyEmail: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/email/verify/${queryArg.token}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authAcceptInvitation: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/invitation/accept/${queryArg.token}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authRequestPasswordReset: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/password/reset/request`,
                        method: "PUT",
                        body: queryArg.userCredentials
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authRequestPassword: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/password/reset/${queryArg.token}`,
                        method: "PUT",
                        body: queryArg.userCredentials
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            authRegisterPartnerCandidate: build.mutation({
                query: (queryArg)=>({
                        url: `/auth/${queryArg.userId}/register/partner/candidate`,
                        method: "POST",
                        body: queryArg.partner
                    }),
                invalidatesTags: [
                    "Auth"
                ]
            }),
            chargePointUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints`,
                        method: "PUT",
                        body: queryArg.chargePoint
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointUpdateChargerInformation: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/chargerInformation`,
                        method: "PUT",
                        body: queryArg.chargerInformation
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointCreateFromTemplate: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.monitorArticleId}/create`,
                        method: "POST",
                        params: {
                            processorId: queryArg.processorId
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetChargePoints: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/paged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            OcppOnly: queryArg.ocppOnly,
                            ProductId: queryArg.productId,
                            PartnerId: queryArg.partnerId,
                            CompanyId: queryArg.companyId,
                            CompanyIds: queryArg.companyIds,
                            CompanyName: queryArg.companyName,
                            InstalledFirmwareVersion: queryArg.installedFirmwareVersion,
                            FirmwareType: queryArg.firmwareType,
                            ImsiNumber: queryArg.imsiNumber,
                            OwnerName: queryArg.ownerName,
                            OwnerEmail: queryArg.ownerEmail,
                            OwnerMobile: queryArg.ownerMobile,
                            Status: queryArg.status,
                            ErrorCode: queryArg.errorCode,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems,
                            Column: queryArg.column,
                            SortOrder: queryArg.sortOrder,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGet: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}`,
                        headers: {
                            wifiPassword: queryArg.wifiPassword
                        },
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetPartner: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/partner`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointSaveCalibration: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/calibration`,
                        method: "POST",
                        body: queryArg.chargePointCalibration
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointSetupCallback: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/callback`,
                        method: "PUT",
                        body: queryArg.setupCallback
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetCalibration: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/calibration`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetNewest: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/newest`,
                        params: {
                            productId: queryArg.productId
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetChargingSessionsWithCount: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/chargingsessions`,
                        params: {
                            filterZero: queryArg.filterZero,
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointDeleteChargingSessions: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/chargingsessions`,
                        method: "DELETE",
                        params: {
                            startTime: queryArg.startTime,
                            endTime: queryArg.endTime
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointAddToPool: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/pools/${queryArg.poolId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointSetOwner: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/users/${queryArg.userId}/owner/${queryArg.name}/${queryArg.wifiPassword}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointRemoveOwner: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/owner`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetManual: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/manual`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointReboot: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/reboot`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetRemoteStartTags: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/${queryArg.connectorId}/remotestart/tags`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointRemoteStart: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/${queryArg.connectorId}/remotestart`,
                        method: "PUT",
                        params: {
                            rfidTag: queryArg.rfidTag
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointRemoteStop: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/${queryArg.connectorId}/remotestop`,
                        method: "PUT",
                        params: {
                            userId: queryArg.userId
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointOverrideScheduleForOngoingChargingSession: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/${queryArg.connectorId}/schedule/override`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetScheduleOverrideStatus: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/schedule/override/status`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointStartTest: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/starttest`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointSetProductionConfiguration: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/configuration`,
                        method: "PUT",
                        body: queryArg.chargePoint
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointChangeProcessorId: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/processorid`,
                        method: "PUT",
                        body: queryArg.changeProcessorId
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetMaintenanceLogs: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/maintenancelogs`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems,
                            accessLevel: queryArg.accessLevel
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointAddMaintenanceLog: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/maintenancelog`,
                        method: "POST",
                        body: queryArg.maintenanceLog
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetAlarms: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/alarms`,
                        params: {
                            showHidden: queryArg.showHidden,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointAcknowledgeAlarm: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/alarms/${queryArg.alarmId}/acknowledge`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointDeleteRejectedTag: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/nfctags/rejected/${queryArg.nfcTagId}/delete`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointAddChargePointProductionInfo: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/productioninfo`,
                        method: "POST",
                        body: queryArg.chargePointProductionInfo
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetLatestChargePointProductionInfo: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/productioninfo`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetChargePointProductionInfo: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/productioninfos`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointDisableOcpp: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp/disable`,
                        method: "POST",
                        params: {
                            forceUpdate: queryArg.forceUpdate
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointEnableOcpp: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp/enable`,
                        method: "POST",
                        params: {
                            forceUpdate: queryArg.forceUpdate
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointChangeOcppService: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp/services/change/${queryArg.ocppProxyServiceId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointSetOcppService: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp/services/set/${queryArg.ocppProxyServiceId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointUpdateFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/firmware/update`,
                        method: "POST",
                        body: queryArg.updateChargerFirmwareOnSeveralModel
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointUpdateFirmware2: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/firmware/update`,
                        method: "POST",
                        body: queryArg.updateChargerFirmwareModel
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointReset: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/reset`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointResetAvailableFirmwareVersion: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/resetfirmwareversion`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetStatusIntervals: build.query({
                query: ()=>({
                        url: `/chargepoints/statusintervals`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointUpdateChargePointUserSettings: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/updateusersettings`,
                        method: "PUT",
                        params: {
                            name: queryArg.name,
                            userCurrentConnector1: queryArg.userCurrentConnector1,
                            userCurrentConnector2: queryArg.userCurrentConnector2
                        }
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointClearCache: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/cache/clear`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetChargingLimitations: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/charginglimitations`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointPostChargingLimitations: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/charginglimitations`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointGetChargepointState: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/state`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointUpdateConnectorAvailability: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/${queryArg.connectorId}/changeavailability/${queryArg.availability}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointWhitelist: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ratelimit/whitelist`,
                        method: "PUT",
                        body: queryArg.whitelistPayload
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointBlockChargepoint: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ratelimit/block`,
                        method: "PUT",
                        body: queryArg.blockPayload
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointBlockStatusChargepoint: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ratelimit/status`
                    }),
                providesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointAddServicePartner: build.mutation({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/service-partners`,
                        method: "POST",
                        body: queryArg.addServicePartnerByCodeRequest
                    }),
                invalidatesTags: [
                    "ChargePoint"
                ]
            }),
            chargePointDataGetLatestChargePointData: build.query({
                query: (queryArg)=>({
                        url: `/chargepointdata/${queryArg.chargePointId}/latestitem`,
                        params: {
                            dataTypeId: queryArg.dataTypeId
                        }
                    }),
                providesTags: [
                    "ChargePointData"
                ]
            }),
            chargePointDataGetChargePointDataWithFilter: build.query({
                query: (queryArg)=>({
                        url: `/chargepointdata/${queryArg.chargePointId}`,
                        method: "POST",
                        body: queryArg.dataLogFilter,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "ChargePointData"
                ]
            }),
            chargePointDataGetChargePointData: build.query({
                query: (queryArg)=>({
                        url: `/chargepointdata/${queryArg.chargePointId}`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "ChargePointData"
                ]
            }),
            chargingSessionGetConsumptionForSession: build.query({
                query: (queryArg)=>({
                        url: `/chargingsessions/${queryArg.id}/consumption`
                    }),
                providesTags: [
                    "ChargingSession"
                ]
            }),
            chargingSessionGetChargingSessionsForCurrentUser: build.query({
                query: (queryArg)=>({
                        url: `/chargingsessions`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "ChargingSession"
                ]
            }),
            chargingSessionGetChargingSessionsForLoggedInUser: build.query({
                query: (queryArg)=>({
                        url: `/chargingsessions/${queryArg.userId}`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "ChargingSession"
                ]
            }),
            chargingSessionDeleteChargingSession: build.mutation({
                query: (queryArg)=>({
                        url: `/chargingsessions/${queryArg.id}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ChargingSession"
                ]
            }),
            circuitBoardCreateCircuitBoard: build.mutation({
                query: (queryArg)=>({
                        url: `/circuitboards`,
                        method: "POST",
                        body: queryArg.circuitBoard
                    }),
                invalidatesTags: [
                    "CircuitBoard"
                ]
            }),
            circuitBoardGetMacAddress: build.mutation({
                query: (queryArg)=>({
                        url: `/circuitboards/${queryArg.chargePointId}/mac`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "CircuitBoard"
                ]
            }),
            circuitBoardSetExternalOcppServer: build.mutation({
                query: (queryArg)=>({
                        url: `/circuitboards/${queryArg.chargePointId}/externalserver/${queryArg.externalServerId}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "CircuitBoard"
                ]
            }),
            companyGetAllOrFiltered: build.query({
                query: (queryArg)=>({
                        url: `/companies`,
                        params: {
                            IsPartnerRestricted: queryArg.isPartnerRestricted,
                            NumberOfItems: queryArg.numberOfItems,
                            Name: queryArg.name,
                            PartnerName: queryArg.partnerName,
                            PartnerId: queryArg.partnerId,
                            CompanyIds: queryArg.companyIds
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyCreateCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies`,
                        method: "POST",
                        body: queryArg.company
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyUpdateCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies`,
                        method: "PUT",
                        body: queryArg.company
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetFilteredPaged: build.query({
                query: (queryArg)=>({
                        url: `/companies/paged`,
                        params: {
                            IsPartnerRestricted: queryArg.isPartnerRestricted,
                            Name: queryArg.name,
                            PartnerName: queryArg.partnerName,
                            PartnerId: queryArg.partnerId,
                            CompanyIds: queryArg.companyIds,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetCompanyById: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyDeleteCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetCompanySettings: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/settings`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyUpdateCompanySettings: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/settings`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetEntitlementWhitelist: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/entitlementwhitelist`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyCreateEntitlementWhitelist: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/entitlementwhitelist`,
                        method: "POST",
                        body: queryArg.createCompanyEntitlementWhitelistRequest
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyUpdateEntitlementWhitelist: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/entitlementwhitelist`,
                        method: "PUT",
                        body: queryArg.updateCompanyEntitlementWhitelistRequest
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyDeleteEntitlementWhitelist: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/entitlementwhitelist`,
                        method: "DELETE",
                        body: queryArg.deleteCompanyEntitlementWhitelistRequest
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetAdministratedCompanies: build.query({
                query: ()=>({
                        url: `/companies/users/admin`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetUsers: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyCreateUser: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users`,
                        method: "POST",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyUpdateUser: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users`,
                        method: "PUT",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetChargePointsPaged: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepointspaged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            OcppOnly: queryArg.ocppOnly,
                            ProductId: queryArg.productId,
                            PartnerId: queryArg.partnerId,
                            CompanyId: queryArg.CompanyId,
                            CompanyIds: queryArg.companyIds,
                            CompanyName: queryArg.companyName,
                            InstalledFirmwareVersion: queryArg.installedFirmwareVersion,
                            FirmwareType: queryArg.firmwareType,
                            ImsiNumber: queryArg.imsiNumber,
                            OwnerName: queryArg.ownerName,
                            OwnerEmail: queryArg.ownerEmail,
                            OwnerMobile: queryArg.ownerMobile,
                            Status: queryArg.status,
                            ErrorCode: queryArg.errorCode,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems,
                            Column: queryArg.column,
                            SortOrder: queryArg.sortOrder,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetPartner: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/partner`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetServicePartners: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/service-partners`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyAddServicePartner: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/service-partners`,
                        method: "POST",
                        body: queryArg.addServicePartnerRequest
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetServicePartnerCodeInformation: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/service-partner-code`,
                        method: "POST",
                        body: queryArg.servicePartnerCodeLookupRequest
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyRemoveServicePartner: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/service-partners/${queryArg.servicePartnerConnectionId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetReportDeliverySchedules: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/reportdeliveryschedules`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyCreateReportDeliverySchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/reportdeliveryschedules`,
                        method: "POST",
                        body: queryArg.reportDeliverySchedule
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyUpdateReportDeliverySchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/reportdeliveryschedules`,
                        method: "PUT",
                        body: queryArg.reportDeliverySchedule
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyDeleteReportDeliverySchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/reportdeliveryschedules/${queryArg.reportDeliveryScheduleId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyValidateImportChargepoints: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepoints/validateimport`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyImportChargepoints: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepoints/import`,
                        method: "POST",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyCreateImportString: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepoints/getimportstring`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetPools: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/pools`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetChargingSessionsByRange: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargingsessions/interval`,
                        params: {
                            startTime: queryArg.startTime,
                            endTime: queryArg.endTime
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetChargingSessions: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargingsessions`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyDeleteChargingSessions: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargingsessions`,
                        method: "DELETE",
                        params: {
                            startTime: queryArg.startTime,
                            endTime: queryArg.endTime
                        }
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetNfcTags: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfctags`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetLoadbalancerGroupsPaged: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/loadbalancergroups/paged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            CompanyName: queryArg.companyName,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyAddRoleToUser: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/${queryArg.userId}/roles`,
                        method: "POST",
                        body: queryArg.role
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyUpdateRoleToUser: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/${queryArg.userId}/roles`,
                        method: "PUT",
                        body: queryArg.role
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyAddChargePointToCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepoints`,
                        method: "PUT",
                        body: queryArg.chargePointCredentials
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyRemoveChargePoint: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/chargepoints/${queryArg.chargePointId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyRemoveUser: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/${queryArg.userId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetChargePointsWithNfcInfo: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/users/${queryArg.userId}/chargepoints`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companySetChargePointsNfcInfo: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/users/${queryArg.userId}/chargepoints`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetPoolsWithNfcInfo: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/users/${queryArg.userId}/pools`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companySetPoolsNfcInfo: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/users/${queryArg.userId}/pools`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetChargePointsWithNfcInfoForTag: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/tags/${queryArg.nfcTagId}/chargepoints`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companySetChargePointsNfcInfoForTag: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/tags/${queryArg.nfcTagId}/chargepoints`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetPoolsWithNfcInfoForTag: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/tags/${queryArg.nfcTagId}/pools`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companySetPoolsNfcInfoForTag: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/nfc/tags/${queryArg.nfcTagId}/pools`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetNfcTagsForUser: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/${queryArg.userId}/nfctags`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyGetChargePointsForUser: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/${queryArg.userId}/chargepoints`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyInviteExistingUserToCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/users/invite/${queryArg.role}`,
                        method: "PUT",
                        body: queryArg.chargePointUser,
                        headers: {
                            origin: queryArg.origin
                        }
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyAddMeasurementDeviceToCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/measurementdevices`,
                        method: "PUT",
                        body: queryArg.measurementDeviceCredentials
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyGetDeviceByCompanyId: build.query({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/measurementdevices`
                    }),
                providesTags: [
                    "Company"
                ]
            }),
            companyRemoveMeasurementDevice: build.mutation({
                query: (queryArg)=>({
                        url: `/companies/${queryArg.companyId}/measurementdevices/${queryArg.measurementDeviceId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Company"
                ]
            }),
            companyTransferGetPartnerTransferKey: build.query({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/transferkey`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetPartner: build.query({
                query: (queryArg)=>({
                        url: `/companytransfer/company/${queryArg.companyId}/transferkey/${queryArg.transferKey}/partner`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetRequestForCompany: build.query({
                query: (queryArg)=>({
                        url: `/companytransfer/company/${queryArg.companyId}/requests`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetRequestsForPartner: build.query({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/requests`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetRequests: build.query({
                query: ()=>({
                        url: `/companytransfer/requests`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferRequestTransfer: build.mutation({
                query: (queryArg)=>({
                        url: `/companytransfer/transferkey/${queryArg.transferKey}/company/${queryArg.companyId}/request`,
                        method: "POST",
                        params: {
                            validToInUtc: queryArg.validToInUtc
                        }
                    }),
                invalidatesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferAcceptRequest: build.mutation({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/company/${queryArg.companyId}/accept`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferRejectRequest: build.mutation({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/company/${queryArg.companyId}/reject`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferBatchTransfer: build.mutation({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/batchtransfer`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetDecisionLogs: build.query({
                query: ()=>({
                        url: `/companytransfer/decisionlogs`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            companyTransferGetPartnerDecisionLogs: build.query({
                query: (queryArg)=>({
                        url: `/companytransfer/partner/${queryArg.partnerId}/decisionlogs`
                    }),
                providesTags: [
                    "CompanyTransfer"
                ]
            }),
            computedNfcAccessGetAccessesForChargePoint: build.query({
                query: (queryArg)=>({
                        url: `/computednfcaccess/chargepoints/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "ComputedNfcAccess"
                ]
            }),
            consumptionDataChargePoint: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/consumption-data`,
                        params: {
                            from: queryArg["from"],
                            to: queryArg.to,
                            connectorId: queryArg.connectorId,
                            resolution: queryArg.resolution
                        }
                    }),
                providesTags: [
                    "ConsumptionData"
                ]
            }),
            consumptionDataChargingSession: build.query({
                query: (queryArg)=>({
                        url: `/chargingsessions/${queryArg.id}/consumption-data`,
                        params: {
                            from: queryArg["from"],
                            to: queryArg.to,
                            resolution: queryArg.resolution
                        }
                    }),
                providesTags: [
                    "ConsumptionData"
                ]
            }),
            countrySettingsGetAllCountrySettings: build.query({
                query: ()=>({
                        url: `/countriessettings`
                    }),
                providesTags: [
                    "CountrySettings"
                ]
            }),
            csrfHandshake: build.query({
                query: ()=>({
                        url: `/csrf/handshake`
                    }),
                providesTags: [
                    "Csrf"
                ]
            }),
            entitlementsGetCurrentContext: build.query({
                query: ()=>({
                        url: `/entitlements/current`
                    }),
                providesTags: [
                    "Entitlements"
                ]
            }),
            entitlementsCreateContextToken: build.mutation({
                query: (queryArg)=>({
                        url: `/entitlements/context`,
                        method: "POST",
                        body: queryArg.authenticationServiceContextRequest
                    }),
                invalidatesTags: [
                    "Entitlements"
                ]
            }),
            entitlementsDeleteContextToken: build.mutation({
                query: ()=>({
                        url: `/entitlements/context`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Entitlements"
                ]
            }),
            externalServerGetAll: build.query({
                query: ()=>({
                        url: `/externalservers`
                    }),
                providesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/externalservers`,
                        method: "POST",
                        body: queryArg.externalServer
                    }),
                invalidatesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerGetByChargePointId: build.query({
                query: (queryArg)=>({
                        url: `/externalservers/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerGetChargePoints: build.query({
                query: (queryArg)=>({
                        url: `/externalservers/${queryArg.externalServerId}/chargepointids`
                    }),
                providesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerGetPartners: build.query({
                query: (queryArg)=>({
                        url: `/externalservers/${queryArg.externalServerId}/partners`
                    }),
                providesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerUpdatePartnerConnections: build.mutation({
                query: (queryArg)=>({
                        url: `/externalservers/${queryArg.externalServerId}/partners`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "ExternalServer"
                ]
            }),
            externalServerDelete: build.mutation({
                query: (queryArg)=>({
                        url: `/externalservers/${queryArg.externalServerId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ExternalServer"
                ]
            }),
            firmwareGetFirmwaresByFilter: build.query({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/firmwares`,
                        params: {
                            ProductId: queryArg.ProductId,
                            FirmwareType: queryArg.firmwareType,
                            IsActive: queryArg.isActive,
                            OcppEnabled: queryArg.ocppEnabled,
                            FirmwareStatuses: queryArg.firmwareStatuses,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Firmware"
                ]
            }),
            firmwareUploadFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/firmwares`,
                        method: "POST",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Firmware"
                ]
            }),
            firmwareUpdateFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/products/firmware`,
                        method: "PUT",
                        body: queryArg.firmwareGeneralModel
                    }),
                invalidatesTags: [
                    "Firmware"
                ]
            }),
            firmwareDeleteFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/firmwares/${queryArg.firmwareId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Firmware"
                ]
            }),
            firmwareSetActiveFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/firmwares/${queryArg.firmwareId}/active`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Firmware"
                ]
            }),
            firmwareGetActiveFirmware: build.query({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/firmwares/active`
                    }),
                providesTags: [
                    "Firmware"
                ]
            }),
            greenChargingGetLoadBalancerGroup: build.query({
                query: (queryArg)=>({
                        url: `/greencharging/loadbalancergroup/${queryArg.loadBalancerGroupId}/greencharginggroup`
                    }),
                providesTags: [
                    "GreenCharging"
                ]
            }),
            greenChargingChargePointStatus: build.query({
                query: (queryArg)=>({
                        url: `/greencharging/chargepoint/${queryArg.chargePointId}/greenchargingstatus`
                    }),
                providesTags: [
                    "GreenCharging"
                ]
            }),
            greenChargingUpdateLoadBalancerGroup: build.mutation({
                query: (queryArg)=>({
                        url: `/greencharging`,
                        method: "PUT",
                        body: queryArg.updateGreenChargingGroup
                    }),
                invalidatesTags: [
                    "GreenCharging"
                ]
            }),
            installationSetup: build.mutation({
                query: (queryArg)=>({
                        url: `/installation`,
                        method: "POST",
                        body: queryArg.setupModel
                    }),
                invalidatesTags: [
                    "Installation"
                ]
            }),
            loadBalancerGroupGetAllPaged: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/paged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            CompanyName: queryArg.companyName,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups`,
                        method: "POST",
                        body: queryArg.loadBalancerGroup
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups`,
                        method: "PUT",
                        body: queryArg.loadBalancerGroup
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupDelete: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupGetById: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}`
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupGetChargePointsForGroup: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/chargepoints`,
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupGetCurrentLimitScheme: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/currentlimitschemes/${queryArg.currentLimitSchemeId}`
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupInsertOrUpdateCurrentLimitScheme: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/currentlimitschemes`,
                        method: "POST",
                        body: queryArg.currentLimitScheme
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupDisableGroup: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/disable`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupEnableGroup: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/enable`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupValidateChargePointImports: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/chargepoints/validateimport`,
                        method: "POST",
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupImportChargePoints: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/chargepoints/import`,
                        method: "POST",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupImportChargePointsV2: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/chargepoints/import/v2`,
                        method: "POST",
                        body: queryArg.loadBalancerChargePointsImportModel
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupDeleteChargePointFromGroup: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/chargepoints/${queryArg.chargePointId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupGetSnapshotByDeviceId: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/snapshot/devices/${queryArg.measurementDeviceId}`
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupAddHierarchicalParent: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/hierarchy/parent`,
                        method: "POST",
                        body: queryArg.addHierarchicalParentRequest
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupAddHierarchicalChild: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/hierarchy/child`,
                        method: "POST",
                        body: queryArg.addHierarchicalChildRequest
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupUpdateGroupHierarchicalSettings: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/hierarchy/settings`,
                        method: "PUT",
                        body: queryArg.updateGroupHierarchicalSettingsRequest
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupGetGroupHierarchy: build.query({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/hierarchy`,
                        params: {
                            scope: queryArg.scope
                        }
                    }),
                providesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            loadBalancerGroupRemoveHierarchicalLink: build.mutation({
                query: (queryArg)=>({
                        url: `/loadbalancergroups/${queryArg.id}/hierarchy`,
                        method: "DELETE",
                        body: queryArg.removeHierarchicalLinkRequest
                    }),
                invalidatesTags: [
                    "LoadBalancerGroup"
                ]
            }),
            logCreateLog: build.mutation({
                query: (queryArg)=>({
                        url: `/logs`,
                        method: "POST",
                        body: queryArg.applicationLog
                    }),
                invalidatesTags: [
                    "Log"
                ]
            }),
            logGetFilteredLogs: build.query({
                query: (queryArg)=>({
                        url: `/logs`,
                        params: {
                            ChargePointUserId: queryArg.chargePointUserId,
                            LogLevel: queryArg.logLevel,
                            Origin: queryArg.origin,
                            ChargePointId: queryArg.chargePointId,
                            Start: queryArg.start,
                            End: queryArg.end,
                            Message: queryArg.message,
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logGetLog: build.query({
                query: (queryArg)=>({
                        url: `/logs/${queryArg.id}`
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logGetErrors: build.query({
                query: (queryArg)=>({
                        url: `/logs/errors`,
                        params: {
                            noOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logGetByLatestChargePointExcludingOcpp2: build.query({
                query: (queryArg)=>({
                        url: `/logs/chargepoints/${queryArg.chargePointId}`,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logGetByLatestChargePointExcludingOcpp: build.query({
                query: (queryArg)=>({
                        url: `/logs/chargepoints/${queryArg.chargePointId}`,
                        method: "POST",
                        body: queryArg.logFilter,
                        params: {
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logGetInteractionLogItems: build.query({
                query: (queryArg)=>({
                        url: `/logs/interactions`,
                        params: {
                            ChargePointId: queryArg.chargePointId,
                            CompanyId: queryArg.companyId,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Log"
                ]
            }),
            logAddInteractionLogItem: build.mutation({
                query: (queryArg)=>({
                        url: `/logs/interaction`,
                        method: "POST",
                        body: queryArg.addInteractionLogItem
                    }),
                invalidatesTags: [
                    "Log"
                ]
            }),
            logDeleteInteractionLogItem: build.mutation({
                query: (queryArg)=>({
                        url: `/logs/interaction/${queryArg.logItemId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Log"
                ]
            }),
            measurementDevicesGetFiltered: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1`,
                        params: {
                            SerialNumber: queryArg.serialNumber,
                            Name: queryArg.name,
                            CompanyName: queryArg.companyName,
                            PartnerName: queryArg.partnerName,
                            ProductId: queryArg.productId,
                            PartnerId: queryArg.partnerId,
                            CompanyId: queryArg.companyId,
                            Status: queryArg.status,
                            Limit: queryArg.limit
                        }
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1`,
                        method: "POST",
                        body: queryArg.createMeasurementDeviceApiModel
                    }),
                invalidatesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetFilteredPaged: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/paged`,
                        params: {
                            SerialNumber: queryArg.serialNumber,
                            Name: queryArg.name,
                            CompanyName: queryArg.companyName,
                            PartnerName: queryArg.partnerName,
                            ProductId: queryArg.productId,
                            PartnerId: queryArg.partnerId,
                            CompanyId: queryArg.companyId,
                            Status: queryArg.status,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetById: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/${queryArg.idOrSerialNumber}`
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/${queryArg.id}`,
                        method: "PUT",
                        body: queryArg.updateMeasurementDeviceModel
                    }),
                invalidatesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetDevicesByUserId: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/users/${queryArg.userId}`
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesRemoveMeasurementDeviceFromCompany: build.mutation({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/${queryArg.id}/remove`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetLatestMeasurement: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/${queryArg.id}/data/latest`
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetMeasurementsForLatest24Hours: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/${queryArg.id}/data/day`
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            measurementDevicesGetValidatedMeasurementDevice: build.query({
                query: (queryArg)=>({
                        url: `/measurementdevices/v1/installation/getvalidated`,
                        method: "POST",
                        body: queryArg.measurementDeviceCredentials
                    }),
                providesTags: [
                    "MeasurementDevices"
                ]
            }),
            migrationBackupMigrationState: build.mutation({
                query: (queryArg)=>({
                        url: `/migration/chargepoints/${queryArg.chargePointId}/createbackup`,
                        method: "POST",
                        params: {
                            token: queryArg.token
                        }
                    }),
                invalidatesTags: [
                    "Migration"
                ]
            }),
            migrationShouldMigrateSchedule: build.query({
                query: (queryArg)=>({
                        url: `/migration/chargepoints/${queryArg.chargePointId}/connector/${queryArg.connectorId}/shouldmigrateschedule`
                    }),
                providesTags: [
                    "Migration"
                ]
            }),
            nfcTagCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/nfctags`,
                        method: "POST",
                        body: queryArg.nfcTag
                    }),
                invalidatesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/nfctags`,
                        method: "PUT",
                        body: queryArg.nfcTag
                    }),
                invalidatesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagConnectToUser: build.mutation({
                query: (queryArg)=>({
                        url: `/nfctags/${queryArg.nfcTagId}/users/${queryArg.userId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagDisconnectFromUser: build.mutation({
                query: (queryArg)=>({
                        url: `/nfctags/${queryArg.nfcTagId}/users/${queryArg.userId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagGetAccessedChargePointsInCompany: build.query({
                query: (queryArg)=>({
                        url: `/nfctags/${queryArg.nfcTagId}/companies/${queryArg.companyId}/chargepoints`
                    }),
                providesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagGetAccessedPoolsInCompany: build.query({
                query: (queryArg)=>({
                        url: `/nfctags/${queryArg.nfcTagId}/companies/${queryArg.companyId}/pools`
                    }),
                providesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagDelete: build.mutation({
                query: (queryArg)=>({
                        url: `/nfctags/${queryArg.nfcTagId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagGetNfcTagsPaged: build.query({
                query: (queryArg)=>({
                        url: `/nfctags/paged`,
                        params: {
                            Rfid: queryArg.rfid,
                            Organisation: queryArg.organisation,
                            Owner: queryArg.owner,
                            ExternalId: queryArg.externalId,
                            Comment: queryArg.comment,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems,
                            Column: queryArg.column,
                            SortOrder: queryArg.sortOrder
                        }
                    }),
                providesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagGetRejectedTagsPaged: build.query({
                query: (queryArg)=>({
                        url: `/nfctags/rejected/paged`,
                        params: {
                            ChargePointId: queryArg.chargePointId,
                            NfcTagId: queryArg.nfcTagId,
                            From: queryArg["from"],
                            To: queryArg.to,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems,
                            Column: queryArg.column,
                            SortOrder: queryArg.sortOrder
                        }
                    }),
                providesTags: [
                    "NfcTag"
                ]
            }),
            nfcTagGetRejectedTags: build.query({
                query: (queryArg)=>({
                        url: `/nfctags/rejected`,
                        params: {
                            ChargePointId: queryArg.chargePointId,
                            CompanyId: queryArg.companyId,
                            PartnerId: queryArg.partnerId,
                            From: queryArg["from"],
                            To: queryArg.to,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "NfcTag"
                ]
            }),
            notificationGetAllOrFiltered: build.query({
                query: (queryArg)=>({
                        url: `/notifications`,
                        params: {
                            filter: queryArg.filter
                        }
                    }),
                providesTags: [
                    "Notification"
                ]
            }),
            notificationCreateNotification: build.mutation({
                query: (queryArg)=>({
                        url: `/notifications`,
                        method: "POST",
                        body: queryArg.notification
                    }),
                invalidatesTags: [
                    "Notification"
                ]
            }),
            notificationGetById: build.query({
                query: (queryArg)=>({
                        url: `/notifications/${queryArg.id}`
                    }),
                providesTags: [
                    "Notification"
                ]
            }),
            notificationUpdateNotification: build.mutation({
                query: (queryArg)=>({
                        url: `/notifications/${queryArg.id}`,
                        method: "PUT",
                        body: queryArg.notification
                    }),
                invalidatesTags: [
                    "Notification"
                ]
            }),
            notificationDeleteNotification: build.mutation({
                query: (queryArg)=>({
                        url: `/notifications/${queryArg.id}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Notification"
                ]
            }),
            notificationPublishNotification: build.mutation({
                query: (queryArg)=>({
                        url: `/notifications/${queryArg.id}/publish`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Notification"
                ]
            }),
            ocppCommandReset: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/reset`,
                        method: "PUT",
                        body: queryArg.resetReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandClearCache: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/clearcache`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandDataTransfer: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/datatransfer`,
                        method: "PUT",
                        body: queryArg.dataTransferReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandGetConfiguration: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/getconfiguration`,
                        method: "PUT",
                        body: queryArg.getConfigurationReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandGetDiagnostics: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/getdiagnostics`,
                        method: "PUT",
                        body: queryArg.getDiagnosticsReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandUnlockConnector: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/unlockconnector`,
                        method: "PUT",
                        body: queryArg.unlockConnectorReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandChangeAvailability: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/changeavailability`,
                        method: "PUT",
                        body: queryArg.changeAvailabilityReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandRemoteStart: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/remotestart`,
                        method: "PUT",
                        body: queryArg.remoteStartTransactionReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandRemoteStop: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/remotestop`,
                        method: "PUT",
                        body: queryArg.remoteStopTransactionReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandTriggerMessage: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/triggermessage`,
                        method: "PUT",
                        body: queryArg.triggerMessageReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandUpdateFirmware: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/updatefirmware`,
                        method: "PUT",
                        body: queryArg.updateFirmwareReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandTest: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/test`,
                        method: "PUT",
                        body: queryArg.testOcppCommand
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandUpdateConfigKeys: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/configkeys`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandUpdateConfigKey: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/configkey`,
                        method: "PUT",
                        body: queryArg.keyValue
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandInstallCertificate: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/certificate/install`,
                        method: "PUT",
                        body: queryArg.installCertificateReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandDeleteCertificate: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/certificate/delete`,
                        method: "PUT",
                        body: queryArg.deleteCertificateReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppCommandGetInstalledCerts: build.mutation({
                query: (queryArg)=>({
                        url: `/ocppcommands/${queryArg.chargePointId}/certificate/getinstalled`,
                        method: "PUT",
                        body: queryArg.getInstalledCertificateIdsReq
                    }),
                invalidatesTags: [
                    "OcppCommand"
                ]
            }),
            ocppLogsGateway: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp-logs/gateway`,
                        params: {
                            from: queryArg["from"],
                            to: queryArg.to,
                            action: queryArg.action,
                            page: queryArg.page,
                            pageSize: queryArg.pageSize,
                            newestFirst: queryArg.newestFirst,
                            errorsOnly: queryArg.errorsOnly
                        }
                    }),
                providesTags: [
                    "OcppLogs"
                ]
            }),
            ocppLogsRelay: build.query({
                query: (queryArg)=>({
                        url: `/chargepoints/${queryArg.chargePointId}/ocpp-logs/relay`,
                        params: {
                            from: queryArg["from"],
                            to: queryArg.to,
                            action: queryArg.action,
                            page: queryArg.page,
                            pageSize: queryArg.pageSize,
                            newestFirst: queryArg.newestFirst,
                            errorsOnly: queryArg.errorsOnly
                        }
                    }),
                providesTags: [
                    "OcppLogs"
                ]
            }),
            partnerGetAllAll: build.query({
                query: (queryArg)=>({
                        url: `/partners`,
                        params: {
                            excludeOrphans: queryArg.excludeOrphans
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerCreatePartner: build.mutation({
                query: (queryArg)=>({
                        url: `/partners`,
                        method: "POST",
                        body: queryArg.partner
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerUpdatePartner: build.mutation({
                query: (queryArg)=>({
                        url: `/partners`,
                        method: "PUT",
                        body: queryArg.partner
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerGetAll: build.query({
                query: (queryArg)=>({
                        url: `/partners/paged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            Email: queryArg.email,
                            ExcludeOrphans: queryArg.excludeOrphans,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetById: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerDelete: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerGetPartnerSettings: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/settings`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerUpdatePartnerSettings: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/settings`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerCreateServicePartnerInvitationCode: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/service-partner-codes`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerGetCurrentServicePartnerInvitationCode: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/service-partner-code`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetCompaniesByPartnerId: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/companies`,
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetChargePointsPaged: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/chargepointspaged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            OcppOnly: queryArg.ocppOnly,
                            ProductId: queryArg.productId,
                            PartnerId: queryArg.PartnerId,
                            CompanyId: queryArg.companyId,
                            CompanyIds: queryArg.companyIds,
                            CompanyName: queryArg.companyName,
                            InstalledFirmwareVersion: queryArg.installedFirmwareVersion,
                            FirmwareType: queryArg.firmwareType,
                            ImsiNumber: queryArg.imsiNumber,
                            OwnerName: queryArg.ownerName,
                            OwnerEmail: queryArg.ownerEmail,
                            OwnerMobile: queryArg.ownerMobile,
                            Status: queryArg.status,
                            ErrorCode: queryArg.errorCode,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems,
                            Column: queryArg.column,
                            SortOrder: queryArg.sortOrder,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetAlarmsByPartnerId: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/alarms`,
                        params: {
                            showConfirmed: queryArg.showConfirmed,
                            showHidden: queryArg.showHidden,
                            Offset: queryArg.offset,
                            NoOfItems: queryArg.noOfItems,
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerSetAcknowledged: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/alarms/${queryArg.alarmId}/acknowledge`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerGetUsersByPartnerId: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/users`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerCreatePartnerUser: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/users`,
                        method: "POST",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerUpdatePartnerUser: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/users`,
                        method: "PUT",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerAddUserAsPartner: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/users/${queryArg.userId}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerRemoveUserAsPartner: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/users/${queryArg.userId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerGetLoadbalancerGroupsPaged: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/loadbalancergroups/paged`,
                        params: {
                            Id: queryArg.id,
                            Name: queryArg.name,
                            CompanyName: queryArg.companyName,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetNfcTags: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/nfctags`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetExternalServers: build.query({
                query: (queryArg)=>({
                        url: `/partners/${queryArg.partnerId}/externalservers`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerGetPartnerCandidates: build.query({
                query: ()=>({
                        url: `/partners/candidates`
                    }),
                providesTags: [
                    "Partner"
                ]
            }),
            partnerApprovePartnerCandidate: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/candidates/${queryArg.partnerCandidateId}/approve`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            partnerDeletePartnerCandidate: build.mutation({
                query: (queryArg)=>({
                        url: `/partners/candidates/${queryArg.partnerCandidateId}/reject`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Partner"
                ]
            }),
            paymentCreateOrganizationSubscription: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/subscriptions/organization`,
                        method: "POST",
                        body: queryArg.paymentOrganizationSubscriptionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetSubscriptionsByOrg: build.query({
                query: (queryArg)=>({
                        url: `/payments/subscriptions/organization`,
                        params: {
                            status: queryArg.status
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentCreatePartnerSubscription: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/subscriptions/partner`,
                        method: "POST",
                        body: queryArg.paymentOrganizationSubscriptionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetSubscriptionsByPartner: build.query({
                query: (queryArg)=>({
                        url: `/payments/subscriptions/partner`,
                        params: {
                            status: queryArg.status
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentCreateIndividualSubscription: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/subscriptions/individual`,
                        method: "POST",
                        body: queryArg.paymentIndividualSubscriptionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentValidateDiscountCode: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/discountCodes/validate`,
                        method: "POST",
                        body: queryArg.paymentDiscountCodeValidationRequest,
                        params: {
                            scope: queryArg.scope
                        }
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetCustomer: build.query({
                query: (queryArg)=>({
                        url: `/payments/customer`,
                        params: {
                            organizationId: queryArg.organizationId,
                            partnerId: queryArg.partnerId
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetSubscriptionDetails: build.query({
                query: (queryArg)=>({
                        url: `/payments/customers/${queryArg.customerPublicId}/subscriptions/${queryArg.subscriptionPublicId}`,
                        params: {
                            organizationId: queryArg.organizationId,
                            partnerId: queryArg.partnerId
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetBillableConnectors: build.query({
                query: (queryArg)=>({
                        url: `/payments/customer/connectors/billable`,
                        params: {
                            organizationId: queryArg.organizationId,
                            partnerId: queryArg.partnerId
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentCreateOrganizationCheckoutSession: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/organization`,
                        method: "POST",
                        body: queryArg.paymentCheckoutSessionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentCreatePartnerCheckoutSession: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/partner`,
                        method: "POST",
                        body: queryArg.paymentCheckoutSessionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentCreateIndividualCheckoutSession: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/individual`,
                        method: "POST",
                        body: queryArg.paymentIndividualCheckoutSessionRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetOrganizationCheckoutSessionStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/organization/${queryArg.sessionId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetPartnerCheckoutSessionStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/partner/${queryArg.sessionId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetIndividualCheckoutSessionStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/checkoutSessions/individual/${queryArg.sessionId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentCreateOrganizationOneTimeCheckout: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/organization`,
                        method: "POST",
                        body: queryArg.paymentOneTimeCheckoutRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentCreatePartnerOneTimeCheckout: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/partner`,
                        method: "POST",
                        body: queryArg.paymentOneTimeCheckoutRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentCreateIndividualOneTimeCheckout: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/individual`,
                        method: "POST",
                        body: queryArg.paymentIndividualOneTimeCheckoutRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetOrganizationOneTimeCheckoutStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/organization/${queryArg.checkoutId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetPartnerOneTimeCheckoutStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/partner/${queryArg.checkoutId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetIndividualOneTimeCheckoutStatus: build.query({
                query: (queryArg)=>({
                        url: `/payments/oneTimeCheckouts/individual/${queryArg.checkoutId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentGetWarrantyExtensionStatusForChargePoint: build.query({
                query: (queryArg)=>({
                        url: `/payments/warrantyExtensions/chargePoints/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            paymentCreateSelfServicePortal: build.mutation({
                query: (queryArg)=>({
                        url: `/payments/selfservice/${queryArg.customerId}`,
                        method: "POST",
                        body: queryArg.paymentSelfServicePortalRequest
                    }),
                invalidatesTags: [
                    "Payment"
                ]
            }),
            paymentGetCommercialOfferings: build.query({
                query: (queryArg)=>({
                        url: `/payments/commercialOfferings`,
                        params: {
                            languageCode: queryArg.languageCode,
                            kind: queryArg.kind
                        }
                    }),
                providesTags: [
                    "Payment"
                ]
            }),
            poolCreate: build.mutation({
                query: (queryArg)=>({
                        url: `/pools`,
                        method: "POST",
                        body: queryArg.pool
                    }),
                invalidatesTags: [
                    "Pool"
                ]
            }),
            poolUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/pools`,
                        method: "PUT",
                        body: queryArg.pool
                    }),
                invalidatesTags: [
                    "Pool"
                ]
            }),
            poolGetById: build.query({
                query: (queryArg)=>({
                        url: `/pools/${queryArg.poolId}`
                    }),
                providesTags: [
                    "Pool"
                ]
            }),
            poolConnectToUser: build.mutation({
                query: (queryArg)=>({
                        url: `/pools/${queryArg.poolId}/users/${queryArg.userId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Pool"
                ]
            }),
            poolDisconnectFromUser: build.mutation({
                query: (queryArg)=>({
                        url: `/pools/${queryArg.poolId}/users/${queryArg.userId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Pool"
                ]
            }),
            poolDeletePool: build.mutation({
                query: (queryArg)=>({
                        url: `/pools/${queryArg.poolId}/company/${queryArg.companyId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Pool"
                ]
            }),
            poolGetChargePoints: build.query({
                query: (queryArg)=>({
                        url: `/pools/${queryArg.poolId}/chargepoints`,
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "Pool"
                ]
            }),
            productGetAll: build.query({
                query: (queryArg)=>({
                        url: `/products`,
                        params: {
                            productVariant: queryArg.productVariant
                        }
                    }),
                providesTags: [
                    "Product"
                ]
            }),
            productGetOptions: build.query({
                query: (queryArg)=>({
                        url: `/products/options`,
                        params: {
                            productVariant: queryArg.productVariant
                        }
                    }),
                providesTags: [
                    "Product"
                ]
            }),
            productGetHardwareversions: build.query({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/hardwareversions`
                    }),
                providesTags: [
                    "Product"
                ]
            }),
            productGetActiveHardwareVersion: build.query({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/hardwareversions/active`
                    }),
                providesTags: [
                    "Product"
                ]
            }),
            productSetActiveHardwareVersion: build.mutation({
                query: (queryArg)=>({
                        url: `/products/${queryArg.productId}/hardwareversions/${queryArg.hardwareVersionId}/active`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "Product"
                ]
            }),
            reportGetReports: build.query({
                query: (queryArg)=>({
                        url: `/reports`,
                        params: {
                            accessLevel: queryArg.accessLevel
                        }
                    }),
                providesTags: [
                    "Report"
                ]
            }),
            reportGetReportsForAdmin: build.query({
                query: (queryArg)=>({
                        url: `/reports/admin`,
                        params: {
                            selectedCompanyId: queryArg.selectedCompanyId
                        }
                    }),
                providesTags: [
                    "Report"
                ]
            }),
            reportGetReportsForPartner: build.query({
                query: (queryArg)=>({
                        url: `/reports/partner`,
                        params: {
                            partnerId: queryArg.partnerId
                        }
                    }),
                providesTags: [
                    "Report"
                ]
            }),
            reportGetReportData: build.query({
                query: (queryArg)=>({
                        url: `/reports/${queryArg.reportId}`,
                        params: {
                            PartnerId: queryArg.partnerId,
                            CompanyId: queryArg.companyId,
                            ChargePointUserId: queryArg.chargePointUserId,
                            TimeZone: queryArg.timeZone,
                            TimeZoneWindows: queryArg.timeZoneWindows,
                            Interval: queryArg.interval,
                            To: queryArg.to,
                            From: queryArg["from"],
                            FromInLocalTime: queryArg.fromInLocalTime,
                            ToInLocalTime: queryArg.toInLocalTime
                        }
                    }),
                providesTags: [
                    "Report"
                ]
            }),
            scheduleGetById: build.query({
                query: (queryArg)=>({
                        url: `/schedules/${queryArg.scheduleId}`
                    }),
                providesTags: [
                    "Schedule"
                ]
            }),
            scheduleDeleteSchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/schedules/${queryArg.scheduleId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "Schedule"
                ]
            }),
            scheduleGetByChargePoint: build.query({
                query: (queryArg)=>({
                        url: `/schedules/chargepoint/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "Schedule"
                ]
            }),
            scheduleCreateSchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/schedules`,
                        method: "POST",
                        body: queryArg.schedule
                    }),
                invalidatesTags: [
                    "Schedule"
                ]
            }),
            scheduleUpdateSchedule: build.mutation({
                query: (queryArg)=>({
                        url: `/schedules`,
                        method: "PUT",
                        body: queryArg.schedule
                    }),
                invalidatesTags: [
                    "Schedule"
                ]
            }),
            scheduleCopyScheduleFromChargePoint: build.mutation({
                query: (queryArg)=>({
                        url: `/schedules/copy/${queryArg.chargePointId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "Schedule"
                ]
            }),
            scopedAccessGetCurrentScopedAccessContext: build.query({
                query: ()=>({
                        url: `/scoped-access/current`
                    }),
                providesTags: [
                    "ScopedAccess"
                ]
            }),
            scopedAccessStartScopedAccessContext: build.mutation({
                query: (queryArg)=>({
                        url: `/scoped-access/context`,
                        method: "POST",
                        body: queryArg.scopedAccessContextStartRequest
                    }),
                invalidatesTags: [
                    "ScopedAccess"
                ]
            }),
            scopedAccessStopScopedAccessContext: build.mutation({
                query: ()=>({
                        url: `/scoped-access/context`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "ScopedAccess"
                ]
            }),
            simulatedChargePointCreateSimulated: build.mutation({
                query: (queryArg)=>({
                        url: `/simulatedchargepoints/${queryArg.productId}/createsimulated`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "SimulatedChargePoint"
                ]
            }),
            smartChargingScheduleGet: build.query({
                query: (queryArg)=>({
                        url: `/smartChargingSchedules/${queryArg.chargePointId}/${queryArg.connectorId}`
                    }),
                providesTags: [
                    "SmartChargingSchedule"
                ]
            }),
            smartChargingScheduleClear: build.mutation({
                query: (queryArg)=>({
                        url: `/smartChargingSchedules/${queryArg.chargePointId}/${queryArg.connectorId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "SmartChargingSchedule"
                ]
            }),
            smartChargingScheduleGetByChargePoint: build.query({
                query: (queryArg)=>({
                        url: `/smartChargingSchedules/chargepoint/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "SmartChargingSchedule"
                ]
            }),
            smartChargingScheduleGetChargePointScheduleStatus: build.query({
                query: (queryArg)=>({
                        url: `/smartChargingSchedules/chargepoint/${queryArg.chargePointId}/status`
                    }),
                providesTags: [
                    "SmartChargingSchedule"
                ]
            }),
            smartChargingScheduleUpdate: build.mutation({
                query: (queryArg)=>({
                        url: `/smartChargingSchedules`,
                        method: "PUT",
                        body: queryArg.smartChargingSchedule
                    }),
                invalidatesTags: [
                    "SmartChargingSchedule"
                ]
            }),
            statisticsGetChargePointStatusStatsForAll: build.query({
                query: ()=>({
                        url: `/stats/chargepoints`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetChargePointTotalConsumptionLastSevenDays: build.query({
                query: (queryArg)=>({
                        url: `/stats/chargepoints/${queryArg.chargePointId}/totalconsumption`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetChargePointStatusStatsForPartner: build.query({
                query: (queryArg)=>({
                        url: `/stats/partners/${queryArg.partnerId}/chargepoints`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetUserTotalConsumption: build.query({
                query: (queryArg)=>({
                        url: `/stats/users/${queryArg.userId}/totalconsumption`,
                        params: {
                            interval: queryArg.interval
                        }
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetChargePointStatusStatsForCompany: build.query({
                query: (queryArg)=>({
                        url: `/stats/companies/${queryArg.companyId}/chargepoints`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetCompanyTotalConsumption: build.query({
                query: (queryArg)=>({
                        url: `/stats/companies/${queryArg.companyId}/totalconsumption`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetUserUsageStatistics: build.query({
                query: (queryArg)=>({
                        url: `/stats/users/${queryArg.userId}`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetUserChargerUsageStatistics: build.query({
                query: (queryArg)=>({
                        url: `/stats/users/${queryArg.userId}/chargerusage`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            statisticsGetCompanyUsageStatistics: build.query({
                query: (queryArg)=>({
                        url: `/stats/companies/${queryArg.companyId}`
                    }),
                providesTags: [
                    "Statistics"
                ]
            }),
            troubleshootingGetErrorCodeTroubleshootingInfos: build.query({
                query: (queryArg)=>({
                        url: `/troubleshooting/errorcode/infos`,
                        params: {
                            productId: queryArg.productId
                        }
                    }),
                providesTags: [
                    "Troubleshooting"
                ]
            }),
            troubleshootingGetErrorCodeTroubleshootingInfo: build.query({
                query: (queryArg)=>({
                        url: `/troubleshooting/errorcode/${queryArg.errorCode}/info`,
                        params: {
                            productId: queryArg.productId
                        }
                    }),
                providesTags: [
                    "Troubleshooting"
                ]
            }),
            userGetFiltered: build.query({
                query: (queryArg)=>({
                        url: `/users`,
                        params: {
                            FirstName: queryArg.firstName,
                            LastName: queryArg.lastName,
                            Email: queryArg.email,
                            IsSuperAdmin: queryArg.isSuperAdmin,
                            noOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userUpdateLoggedInUser: build.mutation({
                query: (queryArg)=>({
                        url: `/users`,
                        method: "PUT",
                        body: queryArg.chargePointUser
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userGetFilteredPaged: build.query({
                query: (queryArg)=>({
                        url: `/users/paged`,
                        params: {
                            FirstName: queryArg.firstName,
                            LastName: queryArg.lastName,
                            Email: queryArg.email,
                            IsSuperAdmin: queryArg.isSuperAdmin,
                            Page: queryArg.page,
                            NoOfItems: queryArg.noOfItems
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetUserById: build.query({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}`,
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userObfuscateUser: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userGetUserSettings: build.query({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/settings`,
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userUpdateUserSettings: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/settings`,
                        method: "PUT",
                        body: queryArg.body,
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userLoggedInUserIsCompanyMember: build.query({
                query: ()=>({
                        url: `/users/iscompanymember`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetPoolsForSelectedCompany: build.query({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/pools`,
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetForUserByNfcAccessWithNfcAccessInfo: build.query({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/chargepoints/${queryArg.companyId}`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetOwnedChargePoints: build.query({
                query: (queryArg)=>({
                        url: `/users/chargepoints/owned`,
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetOwnedChargePointsWithIds: build.query({
                query: (queryArg)=>({
                        url: `/users/chargepoints/owned`,
                        method: "POST",
                        body: queryArg.body,
                        params: {
                            expand: queryArg.expand
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userIsUserHasChargePoints: build.query({
                query: ()=>({
                        url: `/users/chargepoints/existence`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetUserNotifications: build.query({
                query: (queryArg)=>({
                        url: `/users/notifications`,
                        params: {
                            filter: queryArg.filter
                        }
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userGetOwnNfcTags: build.query({
                query: ()=>({
                        url: `/users/nfctags/own`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userUpdateOwnNfcTags: build.mutation({
                query: (queryArg)=>({
                        url: `/users/nfctags/own`,
                        method: "PUT",
                        body: queryArg.body
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userUpdateUserGreenChargingSetting: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/settings/greencharging`,
                        method: "PUT",
                        params: {
                            companyId: queryArg.companyId
                        }
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userRemoveChargePointAccess: build.mutation({
                query: (queryArg)=>({
                        url: `/users/chargepoints/own/unregister/${queryArg.chargePointId}`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userGetLatestRejectedTag: build.query({
                query: ()=>({
                        url: `/users/nfctags/rejected`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userSetAllNotificationsToReadForUser: build.mutation({
                query: ()=>({
                        url: `/users/notifications/read`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userSetNotificationToReadForUser: build.mutation({
                query: (queryArg)=>({
                        url: `/users/notifications/${queryArg.notificationId}/read`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userAcceptTerms: build.mutation({
                query: ()=>({
                        url: `/users/acceptterms`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userIsFavourite: build.query({
                query: (queryArg)=>({
                        url: `/users/favourites/${queryArg.chargePointId}`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userAddFavourite: build.mutation({
                query: (queryArg)=>({
                        url: `/users/favourites/${queryArg.chargePointId}`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userRemoveFavourite: build.mutation({
                query: (queryArg)=>({
                        url: `/users/favourites/${queryArg.chargePointId}`,
                        method: "DELETE"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userGetFavourites: build.query({
                query: ()=>({
                        url: `/users/favourites`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userActivateUser: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/activate`,
                        method: "PUT"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userRevokeUserSessions: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/sessions/revoke`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "User"
                ]
            }),
            userGetPartnerCandidate: build.query({
                query: ()=>({
                        url: `/users/partner/candidate`
                    }),
                providesTags: [
                    "User"
                ]
            }),
            userUnlockUser: build.mutation({
                query: (queryArg)=>({
                        url: `/users/${queryArg.userId}/unlock`,
                        method: "POST"
                    }),
                invalidatesTags: [
                    "User"
                ]
            })
        }),
    overrideExisting: false
});
const { useAlarmGetAllQuery: $0d8528c14b31acb8$export$3b9ed45176b3bd14, useLazyAlarmGetAllQuery: $0d8528c14b31acb8$export$180a31c92c27cafa, useApiCustomerGetHashedApiKeyQuery: $0d8528c14b31acb8$export$69d6b78b86f49df6, useLazyApiCustomerGetHashedApiKeyQuery: $0d8528c14b31acb8$export$61a50ff21f26bf7, useApiCustomerGetAllQuery: $0d8528c14b31acb8$export$1fed5c2974ced427, useLazyApiCustomerGetAllQuery: $0d8528c14b31acb8$export$934aa12cf0f9e7ae, useApiCustomerCreateMutation: $0d8528c14b31acb8$export$b60d4698631f7539, useApiCustomerUpdateMutation: $0d8528c14b31acb8$export$c5b1abdda583ab8c, useApiCustomerDeleteMutation: $0d8528c14b31acb8$export$9fe50e32e6c5d566, useApiCustomerGetChargePointsQuery: $0d8528c14b31acb8$export$eb51539457612c05, useLazyApiCustomerGetChargePointsQuery: $0d8528c14b31acb8$export$eda3d9ec6a13974f, useArticleGetFilteredArticlesQuery: $0d8528c14b31acb8$export$ac44e91791c27d8c, useLazyArticleGetFilteredArticlesQuery: $0d8528c14b31acb8$export$d9711b68e0a778f8, useAuthGetCurrentQuery: $0d8528c14b31acb8$export$ebafadf294b1a72, useLazyAuthGetCurrentQuery: $0d8528c14b31acb8$export$5605c8031c403bdd, useAuthLoginMutation: $0d8528c14b31acb8$export$6c057666085107c5, useAuthStartSupportLoginQuery: $0d8528c14b31acb8$export$a970c5d9b3922dcc, useLazyAuthStartSupportLoginQuery: $0d8528c14b31acb8$export$5b023fedb3be62d6, useAuthLoginCallbackQuery: $0d8528c14b31acb8$export$eac50767d9633221, useLazyAuthLoginCallbackQuery: $0d8528c14b31acb8$export$401bf305ed28fdde, useAuthLogoutMutation: $0d8528c14b31acb8$export$e804342f5a0d615a, useAuthRegisterMutation: $0d8528c14b31acb8$export$525166814105e5cf, useAuthVerifyEmailMutation: $0d8528c14b31acb8$export$864bc9a7b33e62e6, useAuthAcceptInvitationMutation: $0d8528c14b31acb8$export$761940be474fae68, useAuthRequestPasswordResetMutation: $0d8528c14b31acb8$export$fe969a0a9f39f937, useAuthRequestPasswordMutation: $0d8528c14b31acb8$export$eba173e788365a2, useAuthRegisterPartnerCandidateMutation: $0d8528c14b31acb8$export$21703c5233920746, useChargePointUpdateMutation: $0d8528c14b31acb8$export$c42987bc9d92d1b0, useChargePointUpdateChargerInformationMutation: $0d8528c14b31acb8$export$f415455a31da5660, useChargePointCreateFromTemplateMutation: $0d8528c14b31acb8$export$12dd7f1d01d33f72, useChargePointGetChargePointsQuery: $0d8528c14b31acb8$export$363517bccf70e4f, useLazyChargePointGetChargePointsQuery: $0d8528c14b31acb8$export$20b2f3937ad01ebb, useChargePointGetQuery: $0d8528c14b31acb8$export$bb435671b8008bb6, useLazyChargePointGetQuery: $0d8528c14b31acb8$export$20b9947a7035ebe2, useChargePointGetPartnerQuery: $0d8528c14b31acb8$export$45c605d16bc9449d, useLazyChargePointGetPartnerQuery: $0d8528c14b31acb8$export$bd555177c6acc630, useChargePointSaveCalibrationMutation: $0d8528c14b31acb8$export$9ba175ae17b272, useChargePointSetupCallbackMutation: $0d8528c14b31acb8$export$db6db4b6e4a99a4d, useChargePointGetCalibrationQuery: $0d8528c14b31acb8$export$259a46b5a1188ac4, useLazyChargePointGetCalibrationQuery: $0d8528c14b31acb8$export$89320aa4cf1b87fc, useChargePointGetNewestQuery: $0d8528c14b31acb8$export$2dfdc9e35d8c2452, useLazyChargePointGetNewestQuery: $0d8528c14b31acb8$export$6f10500ec98371a8, useChargePointGetChargingSessionsWithCountQuery: $0d8528c14b31acb8$export$cbd4fee63c466bbc, useLazyChargePointGetChargingSessionsWithCountQuery: $0d8528c14b31acb8$export$665c033683e162cf, useChargePointDeleteChargingSessionsMutation: $0d8528c14b31acb8$export$1dbd3c556576632c, useChargePointAddToPoolMutation: $0d8528c14b31acb8$export$a4884a2297d349df, useChargePointSetOwnerMutation: $0d8528c14b31acb8$export$79ea6a424b4c7cdb, useChargePointRemoveOwnerMutation: $0d8528c14b31acb8$export$f335423186bfe078, useChargePointGetManualQuery: $0d8528c14b31acb8$export$9e71eedf19a17c75, useLazyChargePointGetManualQuery: $0d8528c14b31acb8$export$d48f39b9e2e87559, useChargePointRebootMutation: $0d8528c14b31acb8$export$4b8ae7112ef8a75c, useChargePointGetRemoteStartTagsQuery: $0d8528c14b31acb8$export$9dde748a445282fa, useLazyChargePointGetRemoteStartTagsQuery: $0d8528c14b31acb8$export$6f46e46e98d169d5, useChargePointRemoteStartMutation: $0d8528c14b31acb8$export$8b179a4397477a9, useChargePointRemoteStopMutation: $0d8528c14b31acb8$export$ce42f2812ddb9fac, useChargePointOverrideScheduleForOngoingChargingSessionMutation: $0d8528c14b31acb8$export$78873b1513fa0d9f, useChargePointGetScheduleOverrideStatusQuery: $0d8528c14b31acb8$export$c21978bddf8f82e2, useLazyChargePointGetScheduleOverrideStatusQuery: $0d8528c14b31acb8$export$ad825fff856ce48a, useChargePointStartTestMutation: $0d8528c14b31acb8$export$a55405541e0f34a, useChargePointSetProductionConfigurationMutation: $0d8528c14b31acb8$export$41c97f1562e53b71, useChargePointChangeProcessorIdMutation: $0d8528c14b31acb8$export$c88800624d557758, useChargePointGetMaintenanceLogsQuery: $0d8528c14b31acb8$export$2c6cc48bdc1aabde, useLazyChargePointGetMaintenanceLogsQuery: $0d8528c14b31acb8$export$9ed8c81068784007, useChargePointAddMaintenanceLogMutation: $0d8528c14b31acb8$export$b348df503d6c3f06, useChargePointGetAlarmsQuery: $0d8528c14b31acb8$export$f2ee2edb9c8f6097, useLazyChargePointGetAlarmsQuery: $0d8528c14b31acb8$export$f50738fb6077840b, useChargePointAcknowledgeAlarmMutation: $0d8528c14b31acb8$export$c41fefcc456b72a1, useChargePointDeleteRejectedTagMutation: $0d8528c14b31acb8$export$7356d9837a49150a, useChargePointAddChargePointProductionInfoMutation: $0d8528c14b31acb8$export$5813fc91e26ff200, useChargePointGetLatestChargePointProductionInfoQuery: $0d8528c14b31acb8$export$e49d076dfc165bdf, useLazyChargePointGetLatestChargePointProductionInfoQuery: $0d8528c14b31acb8$export$894e13d0d16266cd, useChargePointGetChargePointProductionInfoQuery: $0d8528c14b31acb8$export$75e7b73b1320c90, useLazyChargePointGetChargePointProductionInfoQuery: $0d8528c14b31acb8$export$ec0fd463aa91e231, useChargePointDisableOcppMutation: $0d8528c14b31acb8$export$4d966625cfc5986f, useChargePointEnableOcppMutation: $0d8528c14b31acb8$export$a9111c6db0f4f4ae, useChargePointChangeOcppServiceMutation: $0d8528c14b31acb8$export$522977d58e153597, useChargePointSetOcppServiceMutation: $0d8528c14b31acb8$export$d862b097f3c77f83, useChargePointUpdateFirmwareMutation: $0d8528c14b31acb8$export$d0cd610d09d8ac3d, useChargePointUpdateFirmware2Mutation: $0d8528c14b31acb8$export$d15ba6b880f65d68, useChargePointResetMutation: $0d8528c14b31acb8$export$2c7302e5339241d8, useChargePointResetAvailableFirmwareVersionMutation: $0d8528c14b31acb8$export$698a0d0f0fc548b7, useChargePointGetStatusIntervalsQuery: $0d8528c14b31acb8$export$ce1d86c029686cb3, useLazyChargePointGetStatusIntervalsQuery: $0d8528c14b31acb8$export$158e6322da8c03f4, useChargePointUpdateChargePointUserSettingsMutation: $0d8528c14b31acb8$export$6792efc2afcb53b6, useChargePointClearCacheMutation: $0d8528c14b31acb8$export$8b7b9c7e438ac5bc, useChargePointGetChargingLimitationsQuery: $0d8528c14b31acb8$export$d95275127ed8cf07, useLazyChargePointGetChargingLimitationsQuery: $0d8528c14b31acb8$export$fa30bb10914418f9, useChargePointPostChargingLimitationsMutation: $0d8528c14b31acb8$export$b913f8237059d410, useChargePointGetChargepointStateQuery: $0d8528c14b31acb8$export$6da04a05087764df, useLazyChargePointGetChargepointStateQuery: $0d8528c14b31acb8$export$4202a6a6a8780fe3, useChargePointUpdateConnectorAvailabilityMutation: $0d8528c14b31acb8$export$d7b2c9a91661c194, useChargePointWhitelistMutation: $0d8528c14b31acb8$export$a12ff6f4df7c1623, useChargePointBlockChargepointMutation: $0d8528c14b31acb8$export$22c6ef1124ef2f74, useChargePointBlockStatusChargepointQuery: $0d8528c14b31acb8$export$1d2f2d324f2a77ae, useLazyChargePointBlockStatusChargepointQuery: $0d8528c14b31acb8$export$d69c25a984a6b674, useChargePointAddServicePartnerMutation: $0d8528c14b31acb8$export$882457c70f2dcd1d, useChargePointDataGetLatestChargePointDataQuery: $0d8528c14b31acb8$export$67fcf14964bf1400, useLazyChargePointDataGetLatestChargePointDataQuery: $0d8528c14b31acb8$export$f0fff0a914e6e025, useChargePointDataGetChargePointDataWithFilterQuery: $0d8528c14b31acb8$export$77e8cf3002f6a308, useLazyChargePointDataGetChargePointDataWithFilterQuery: $0d8528c14b31acb8$export$39d7cab4588b5ea6, useChargePointDataGetChargePointDataQuery: $0d8528c14b31acb8$export$9be76c5c9bed8669, useLazyChargePointDataGetChargePointDataQuery: $0d8528c14b31acb8$export$9ef5824a720fe8e1, useChargingSessionGetConsumptionForSessionQuery: $0d8528c14b31acb8$export$7804fdcd3e82b6eb, useLazyChargingSessionGetConsumptionForSessionQuery: $0d8528c14b31acb8$export$fee506b843384a31, useChargingSessionGetChargingSessionsForCurrentUserQuery: $0d8528c14b31acb8$export$c1fb5b3585a8a0fd, useLazyChargingSessionGetChargingSessionsForCurrentUserQuery: $0d8528c14b31acb8$export$78bb7ebad8664028, useChargingSessionGetChargingSessionsForLoggedInUserQuery: $0d8528c14b31acb8$export$f6104600b27e604c, useLazyChargingSessionGetChargingSessionsForLoggedInUserQuery: $0d8528c14b31acb8$export$40810e3cc867ce53, useChargingSessionDeleteChargingSessionMutation: $0d8528c14b31acb8$export$ff6c48ddfd4515a1, useCircuitBoardCreateCircuitBoardMutation: $0d8528c14b31acb8$export$12e85b6ed578dcb3, useCircuitBoardGetMacAddressMutation: $0d8528c14b31acb8$export$f2526265cb04095a, useCircuitBoardSetExternalOcppServerMutation: $0d8528c14b31acb8$export$52228dee9af54188, useCompanyGetAllOrFilteredQuery: $0d8528c14b31acb8$export$d616b9885fa4650b, useLazyCompanyGetAllOrFilteredQuery: $0d8528c14b31acb8$export$8279507a9f94ee5c, useCompanyCreateCompanyMutation: $0d8528c14b31acb8$export$a85b87168e210643, useCompanyUpdateCompanyMutation: $0d8528c14b31acb8$export$1c7ee0742dc5814c, useCompanyGetFilteredPagedQuery: $0d8528c14b31acb8$export$1ebd0dd03819fe0e, useLazyCompanyGetFilteredPagedQuery: $0d8528c14b31acb8$export$131195fa78ff2ec1, useCompanyGetCompanyByIdQuery: $0d8528c14b31acb8$export$c2e45d0da8bee022, useLazyCompanyGetCompanyByIdQuery: $0d8528c14b31acb8$export$4b0e0ab14a5cdf42, useCompanyDeleteCompanyMutation: $0d8528c14b31acb8$export$988ab6f151f909f6, useCompanyGetCompanySettingsQuery: $0d8528c14b31acb8$export$157c72be7872ffff, useLazyCompanyGetCompanySettingsQuery: $0d8528c14b31acb8$export$d23ff62323ac5be3, useCompanyUpdateCompanySettingsMutation: $0d8528c14b31acb8$export$8d207656400bebe4, useCompanyGetEntitlementWhitelistQuery: $0d8528c14b31acb8$export$57d37fa6a254453e, useLazyCompanyGetEntitlementWhitelistQuery: $0d8528c14b31acb8$export$dd2cdc6c7d8c224a, useCompanyCreateEntitlementWhitelistMutation: $0d8528c14b31acb8$export$dc7167aba6fa92de, useCompanyUpdateEntitlementWhitelistMutation: $0d8528c14b31acb8$export$3bd3cf8da9745945, useCompanyDeleteEntitlementWhitelistMutation: $0d8528c14b31acb8$export$df54924d28c4c0c6, useCompanyGetAdministratedCompaniesQuery: $0d8528c14b31acb8$export$d3cc4d59d9924c3e, useLazyCompanyGetAdministratedCompaniesQuery: $0d8528c14b31acb8$export$d2252f6f7ad40ca8, useCompanyGetUsersQuery: $0d8528c14b31acb8$export$7cc43711859703f4, useLazyCompanyGetUsersQuery: $0d8528c14b31acb8$export$1f94f891bf733f1c, useCompanyCreateUserMutation: $0d8528c14b31acb8$export$aff2f619920439a, useCompanyUpdateUserMutation: $0d8528c14b31acb8$export$95cd1114a4526f2e, useCompanyGetChargePointsPagedQuery: $0d8528c14b31acb8$export$59a08696f7fc7a66, useLazyCompanyGetChargePointsPagedQuery: $0d8528c14b31acb8$export$adbd64467b1fea45, useCompanyGetPartnerQuery: $0d8528c14b31acb8$export$3007b1f1c171d527, useLazyCompanyGetPartnerQuery: $0d8528c14b31acb8$export$a2ccced9e2b84774, useCompanyGetServicePartnersQuery: $0d8528c14b31acb8$export$2f2d77d72fc15708, useLazyCompanyGetServicePartnersQuery: $0d8528c14b31acb8$export$70a01ba956bc9251, useCompanyAddServicePartnerMutation: $0d8528c14b31acb8$export$2f75d364ad78725d, useCompanyGetServicePartnerCodeInformationMutation: $0d8528c14b31acb8$export$d3a9ebe9c0ee3520, useCompanyRemoveServicePartnerMutation: $0d8528c14b31acb8$export$923cdb8fe1f3688d, useCompanyGetReportDeliverySchedulesQuery: $0d8528c14b31acb8$export$1678db909b27844f, useLazyCompanyGetReportDeliverySchedulesQuery: $0d8528c14b31acb8$export$765f20599d00baec, useCompanyCreateReportDeliveryScheduleMutation: $0d8528c14b31acb8$export$1bb5d8cdb39d99d6, useCompanyUpdateReportDeliveryScheduleMutation: $0d8528c14b31acb8$export$37f31bf7dbbce085, useCompanyDeleteReportDeliveryScheduleMutation: $0d8528c14b31acb8$export$c28117789a429b4b, useCompanyValidateImportChargepointsMutation: $0d8528c14b31acb8$export$1bd97fd67a2752bf, useCompanyImportChargepointsMutation: $0d8528c14b31acb8$export$b6294882b68fafa1, useCompanyCreateImportStringQuery: $0d8528c14b31acb8$export$df6afcc9be0bd7cf, useLazyCompanyCreateImportStringQuery: $0d8528c14b31acb8$export$77893eef173c4d9e, useCompanyGetPoolsQuery: $0d8528c14b31acb8$export$e0d8ff65f8950471, useLazyCompanyGetPoolsQuery: $0d8528c14b31acb8$export$763e178ef1fd7f33, useCompanyGetChargingSessionsByRangeQuery: $0d8528c14b31acb8$export$5fc1cea6b764fcf9, useLazyCompanyGetChargingSessionsByRangeQuery: $0d8528c14b31acb8$export$8446b01387b8a31b, useCompanyGetChargingSessionsQuery: $0d8528c14b31acb8$export$edcbfef278e25ad8, useLazyCompanyGetChargingSessionsQuery: $0d8528c14b31acb8$export$d8bcea021c3a6c4b, useCompanyDeleteChargingSessionsMutation: $0d8528c14b31acb8$export$4b5fc92bf71467e9, useCompanyGetNfcTagsQuery: $0d8528c14b31acb8$export$8a2f6d6738ace846, useLazyCompanyGetNfcTagsQuery: $0d8528c14b31acb8$export$ab31c68a05dd45c9, useCompanyGetLoadbalancerGroupsPagedQuery: $0d8528c14b31acb8$export$732112fdbac45b2b, useLazyCompanyGetLoadbalancerGroupsPagedQuery: $0d8528c14b31acb8$export$ebc79065e52de425, useCompanyAddRoleToUserMutation: $0d8528c14b31acb8$export$d87a7ede857b2b32, useCompanyUpdateRoleToUserMutation: $0d8528c14b31acb8$export$1c9a30f97b6cd273, useCompanyAddChargePointToCompanyMutation: $0d8528c14b31acb8$export$2c978a0ef520d550, useCompanyRemoveChargePointMutation: $0d8528c14b31acb8$export$18356fb5a15d5665, useCompanyRemoveUserMutation: $0d8528c14b31acb8$export$975361f27d244f40, useCompanyGetChargePointsWithNfcInfoQuery: $0d8528c14b31acb8$export$90b2c801eb28fede, useLazyCompanyGetChargePointsWithNfcInfoQuery: $0d8528c14b31acb8$export$62d804977e31dea4, useCompanySetChargePointsNfcInfoMutation: $0d8528c14b31acb8$export$d88c115ad46b33e8, useCompanyGetPoolsWithNfcInfoQuery: $0d8528c14b31acb8$export$46477c8474cf35a5, useLazyCompanyGetPoolsWithNfcInfoQuery: $0d8528c14b31acb8$export$813b39f1ddb479c7, useCompanySetPoolsNfcInfoMutation: $0d8528c14b31acb8$export$1c11799c30d7d286, useCompanyGetChargePointsWithNfcInfoForTagQuery: $0d8528c14b31acb8$export$35519a6d993d3708, useLazyCompanyGetChargePointsWithNfcInfoForTagQuery: $0d8528c14b31acb8$export$ec2c87753f7d012c, useCompanySetChargePointsNfcInfoForTagMutation: $0d8528c14b31acb8$export$f3473afb1bdfedec, useCompanyGetPoolsWithNfcInfoForTagQuery: $0d8528c14b31acb8$export$233e231d2673860f, useLazyCompanyGetPoolsWithNfcInfoForTagQuery: $0d8528c14b31acb8$export$b801bfd6fb4a037b, useCompanySetPoolsNfcInfoForTagMutation: $0d8528c14b31acb8$export$95f31563c4ef4bcf, useCompanyGetNfcTagsForUserQuery: $0d8528c14b31acb8$export$c00cf6e9fe765604, useLazyCompanyGetNfcTagsForUserQuery: $0d8528c14b31acb8$export$cc10cb471a66ab09, useCompanyGetChargePointsForUserQuery: $0d8528c14b31acb8$export$be30daf7ef1dbebf, useLazyCompanyGetChargePointsForUserQuery: $0d8528c14b31acb8$export$98a1efdce36f6687, useCompanyInviteExistingUserToCompanyMutation: $0d8528c14b31acb8$export$30fb2a620567b76, useCompanyAddMeasurementDeviceToCompanyMutation: $0d8528c14b31acb8$export$11d986f615786e11, useCompanyGetDeviceByCompanyIdQuery: $0d8528c14b31acb8$export$9b23e072f3e94387, useLazyCompanyGetDeviceByCompanyIdQuery: $0d8528c14b31acb8$export$9874cea254857ff7, useCompanyRemoveMeasurementDeviceMutation: $0d8528c14b31acb8$export$8d0f9b36cdc6610b, useCompanyTransferGetPartnerTransferKeyQuery: $0d8528c14b31acb8$export$b3a709104b3e3eb6, useLazyCompanyTransferGetPartnerTransferKeyQuery: $0d8528c14b31acb8$export$8b97bd846a96c598, useCompanyTransferGetPartnerQuery: $0d8528c14b31acb8$export$95f7447cf8de286f, useLazyCompanyTransferGetPartnerQuery: $0d8528c14b31acb8$export$208cef926a7d3055, useCompanyTransferGetRequestForCompanyQuery: $0d8528c14b31acb8$export$df0caf02e8b8762d, useLazyCompanyTransferGetRequestForCompanyQuery: $0d8528c14b31acb8$export$2c7f6c1cf69a0a2c, useCompanyTransferGetRequestsForPartnerQuery: $0d8528c14b31acb8$export$a28ae8a9e537a80f, useLazyCompanyTransferGetRequestsForPartnerQuery: $0d8528c14b31acb8$export$4d0ca99a6c748e7c, useCompanyTransferGetRequestsQuery: $0d8528c14b31acb8$export$aa6cb02aa01e9757, useLazyCompanyTransferGetRequestsQuery: $0d8528c14b31acb8$export$5c6c3bf1ed3b385, useCompanyTransferRequestTransferMutation: $0d8528c14b31acb8$export$159e8e086d7a5840, useCompanyTransferAcceptRequestMutation: $0d8528c14b31acb8$export$ddf6449426f5a4c0, useCompanyTransferRejectRequestMutation: $0d8528c14b31acb8$export$e3b2812549f44416, useCompanyTransferBatchTransferMutation: $0d8528c14b31acb8$export$a50dd055eba7518b, useCompanyTransferGetDecisionLogsQuery: $0d8528c14b31acb8$export$1cca321e2639c69, useLazyCompanyTransferGetDecisionLogsQuery: $0d8528c14b31acb8$export$a14fec892751d653, useCompanyTransferGetPartnerDecisionLogsQuery: $0d8528c14b31acb8$export$2e185ab7e73f27ab, useLazyCompanyTransferGetPartnerDecisionLogsQuery: $0d8528c14b31acb8$export$34f767c40f18e5a3, useComputedNfcAccessGetAccessesForChargePointQuery: $0d8528c14b31acb8$export$73ea468e5b177832, useLazyComputedNfcAccessGetAccessesForChargePointQuery: $0d8528c14b31acb8$export$7937354824c904d8, useConsumptionDataChargePointQuery: $0d8528c14b31acb8$export$bcc1f9004fa5976c, useLazyConsumptionDataChargePointQuery: $0d8528c14b31acb8$export$98834edcfb922ac, useConsumptionDataChargingSessionQuery: $0d8528c14b31acb8$export$4d2916ecc13f1126, useLazyConsumptionDataChargingSessionQuery: $0d8528c14b31acb8$export$828193b359e76731, useCountrySettingsGetAllCountrySettingsQuery: $0d8528c14b31acb8$export$518234d7c924f073, useLazyCountrySettingsGetAllCountrySettingsQuery: $0d8528c14b31acb8$export$6638802fc45c9e73, useCsrfHandshakeQuery: $0d8528c14b31acb8$export$9b615c461314e14d, useLazyCsrfHandshakeQuery: $0d8528c14b31acb8$export$ab3fa71f4a43dc6a, useEntitlementsGetCurrentContextQuery: $0d8528c14b31acb8$export$9bf4eba923793fb5, useLazyEntitlementsGetCurrentContextQuery: $0d8528c14b31acb8$export$e1c144b99fb7e54d, useEntitlementsCreateContextTokenMutation: $0d8528c14b31acb8$export$c9c77fd03937a192, useEntitlementsDeleteContextTokenMutation: $0d8528c14b31acb8$export$a359e6a20285fbba, useExternalServerGetAllQuery: $0d8528c14b31acb8$export$7ae98e873be5a622, useLazyExternalServerGetAllQuery: $0d8528c14b31acb8$export$f98271f67f7b5f71, useExternalServerCreateMutation: $0d8528c14b31acb8$export$31609f1020ce83c9, useExternalServerGetByChargePointIdQuery: $0d8528c14b31acb8$export$1092db0b0c6ec1c7, useLazyExternalServerGetByChargePointIdQuery: $0d8528c14b31acb8$export$adaa12099339f6f2, useExternalServerGetChargePointsQuery: $0d8528c14b31acb8$export$67e4a8ce13f19ecb, useLazyExternalServerGetChargePointsQuery: $0d8528c14b31acb8$export$f617e97c422aad26, useExternalServerGetPartnersQuery: $0d8528c14b31acb8$export$f4654392afe351fa, useLazyExternalServerGetPartnersQuery: $0d8528c14b31acb8$export$97f371c184d764f3, useExternalServerUpdatePartnerConnectionsMutation: $0d8528c14b31acb8$export$cd5a3f32c9293dd8, useExternalServerDeleteMutation: $0d8528c14b31acb8$export$337240799894367c, useFirmwareGetFirmwaresByFilterQuery: $0d8528c14b31acb8$export$646dc2d3fc61fc73, useLazyFirmwareGetFirmwaresByFilterQuery: $0d8528c14b31acb8$export$2957899a81598963, useFirmwareUploadFirmwareMutation: $0d8528c14b31acb8$export$7bc0f08612f54e6f, useFirmwareUpdateFirmwareMutation: $0d8528c14b31acb8$export$b11da0bf9e2f8411, useFirmwareDeleteFirmwareMutation: $0d8528c14b31acb8$export$414a83ef2478ba73, useFirmwareSetActiveFirmwareMutation: $0d8528c14b31acb8$export$eb655f66edad2b9d, useFirmwareGetActiveFirmwareQuery: $0d8528c14b31acb8$export$f7ed4990ff7a8ac4, useLazyFirmwareGetActiveFirmwareQuery: $0d8528c14b31acb8$export$4f5f7bcc451f6606, useGreenChargingGetLoadBalancerGroupQuery: $0d8528c14b31acb8$export$70fd2d91e328c35e, useLazyGreenChargingGetLoadBalancerGroupQuery: $0d8528c14b31acb8$export$dd6a98d72cfab568, useGreenChargingChargePointStatusQuery: $0d8528c14b31acb8$export$f3d33bc7d7a9fa83, useLazyGreenChargingChargePointStatusQuery: $0d8528c14b31acb8$export$a3adae3edeea0927, useGreenChargingUpdateLoadBalancerGroupMutation: $0d8528c14b31acb8$export$24b72b14d456cf25, useInstallationSetupMutation: $0d8528c14b31acb8$export$80eb369ca5b8310, useLoadBalancerGroupGetAllPagedQuery: $0d8528c14b31acb8$export$19f7a00af4452045, useLazyLoadBalancerGroupGetAllPagedQuery: $0d8528c14b31acb8$export$ab27bd21e5ca75c5, useLoadBalancerGroupCreateMutation: $0d8528c14b31acb8$export$e30fe16b97a4b0b7, useLoadBalancerGroupUpdateMutation: $0d8528c14b31acb8$export$ffd1c6b031703b28, useLoadBalancerGroupDeleteMutation: $0d8528c14b31acb8$export$f0c227d20992923a, useLoadBalancerGroupGetByIdQuery: $0d8528c14b31acb8$export$49bfeec35dd56e05, useLazyLoadBalancerGroupGetByIdQuery: $0d8528c14b31acb8$export$27f0d69819a31531, useLoadBalancerGroupGetChargePointsForGroupQuery: $0d8528c14b31acb8$export$2ef27f08cb944fbf, useLazyLoadBalancerGroupGetChargePointsForGroupQuery: $0d8528c14b31acb8$export$c6a8ac86c688b7f0, useLoadBalancerGroupGetCurrentLimitSchemeQuery: $0d8528c14b31acb8$export$f8f28f4ba1a81689, useLazyLoadBalancerGroupGetCurrentLimitSchemeQuery: $0d8528c14b31acb8$export$9bb2e93001459b38, useLoadBalancerGroupInsertOrUpdateCurrentLimitSchemeMutation: $0d8528c14b31acb8$export$b57ece852d0d6830, useLoadBalancerGroupDisableGroupMutation: $0d8528c14b31acb8$export$ee93cfeb406978e, useLoadBalancerGroupEnableGroupMutation: $0d8528c14b31acb8$export$f50ea22b576ef590, useLoadBalancerGroupValidateChargePointImportsMutation: $0d8528c14b31acb8$export$28a819e5ce2e34f7, useLoadBalancerGroupImportChargePointsMutation: $0d8528c14b31acb8$export$b0465d694d043775, useLoadBalancerGroupImportChargePointsV2Mutation: $0d8528c14b31acb8$export$cad2858136be6e54, useLoadBalancerGroupDeleteChargePointFromGroupMutation: $0d8528c14b31acb8$export$72ac24f7087a020d, useLoadBalancerGroupGetSnapshotByDeviceIdQuery: $0d8528c14b31acb8$export$b255557a157483ac, useLazyLoadBalancerGroupGetSnapshotByDeviceIdQuery: $0d8528c14b31acb8$export$fa019c5e268cae6c, useLoadBalancerGroupAddHierarchicalParentMutation: $0d8528c14b31acb8$export$e82993f49d247af7, useLoadBalancerGroupAddHierarchicalChildMutation: $0d8528c14b31acb8$export$596dd0e93d607c9a, useLoadBalancerGroupUpdateGroupHierarchicalSettingsMutation: $0d8528c14b31acb8$export$bc04fa4db99e5332, useLoadBalancerGroupGetGroupHierarchyQuery: $0d8528c14b31acb8$export$460b18560581072c, useLazyLoadBalancerGroupGetGroupHierarchyQuery: $0d8528c14b31acb8$export$9081d56a4d66168f, useLoadBalancerGroupRemoveHierarchicalLinkMutation: $0d8528c14b31acb8$export$24a7e7fe8f71bb04, useLogCreateLogMutation: $0d8528c14b31acb8$export$55be5f180bca2ecb, useLogGetFilteredLogsQuery: $0d8528c14b31acb8$export$7fb931296534cc49, useLazyLogGetFilteredLogsQuery: $0d8528c14b31acb8$export$1371cf05b51d70, useLogGetLogQuery: $0d8528c14b31acb8$export$bdf4a4295d536c19, useLazyLogGetLogQuery: $0d8528c14b31acb8$export$e11ef416976545aa, useLogGetErrorsQuery: $0d8528c14b31acb8$export$8b5d9ff98a32da21, useLazyLogGetErrorsQuery: $0d8528c14b31acb8$export$89fa20c17bda3609, useLogGetByLatestChargePointExcludingOcpp2Query: $0d8528c14b31acb8$export$a9874877bd023621, useLazyLogGetByLatestChargePointExcludingOcpp2Query: $0d8528c14b31acb8$export$c896b80c0068f207, useLogGetByLatestChargePointExcludingOcppQuery: $0d8528c14b31acb8$export$3ff215c64c16041c, useLazyLogGetByLatestChargePointExcludingOcppQuery: $0d8528c14b31acb8$export$4f6d232ec6b91311, useLogGetInteractionLogItemsQuery: $0d8528c14b31acb8$export$f32a9121e8116176, useLazyLogGetInteractionLogItemsQuery: $0d8528c14b31acb8$export$46a0cfca03f74457, useLogAddInteractionLogItemMutation: $0d8528c14b31acb8$export$11a6b1cbb1fa7ab4, useLogDeleteInteractionLogItemMutation: $0d8528c14b31acb8$export$77d87d165e813e3f, useMeasurementDevicesGetFilteredQuery: $0d8528c14b31acb8$export$3a117c89a29f6822, useLazyMeasurementDevicesGetFilteredQuery: $0d8528c14b31acb8$export$8558d547792575a6, useMeasurementDevicesCreateMutation: $0d8528c14b31acb8$export$cd72177bc6cf977, useMeasurementDevicesGetFilteredPagedQuery: $0d8528c14b31acb8$export$7b6e8138034df4e8, useLazyMeasurementDevicesGetFilteredPagedQuery: $0d8528c14b31acb8$export$63114ef195823db, useMeasurementDevicesGetByIdQuery: $0d8528c14b31acb8$export$8a69104efdbbadea, useLazyMeasurementDevicesGetByIdQuery: $0d8528c14b31acb8$export$a8a9dabd02eec15b, useMeasurementDevicesUpdateMutation: $0d8528c14b31acb8$export$a18d8645c678f1a3, useMeasurementDevicesGetDevicesByUserIdQuery: $0d8528c14b31acb8$export$5f11b8c20f88e704, useLazyMeasurementDevicesGetDevicesByUserIdQuery: $0d8528c14b31acb8$export$38d561b85a0e2b7c, useMeasurementDevicesRemoveMeasurementDeviceFromCompanyMutation: $0d8528c14b31acb8$export$5ae990b53f2087b8, useMeasurementDevicesGetLatestMeasurementQuery: $0d8528c14b31acb8$export$2e7ac47262a4b34f, useLazyMeasurementDevicesGetLatestMeasurementQuery: $0d8528c14b31acb8$export$8dabbd0c0ac4686e, useMeasurementDevicesGetMeasurementsForLatest24HoursQuery: $0d8528c14b31acb8$export$c96227187153e2ec, useLazyMeasurementDevicesGetMeasurementsForLatest24HoursQuery: $0d8528c14b31acb8$export$7fb6c55c0851e857, useMeasurementDevicesGetValidatedMeasurementDeviceQuery: $0d8528c14b31acb8$export$8f020107cf57d79, useLazyMeasurementDevicesGetValidatedMeasurementDeviceQuery: $0d8528c14b31acb8$export$e004333d1d6c649a, useMigrationBackupMigrationStateMutation: $0d8528c14b31acb8$export$d57028ebc96d93e8, useMigrationShouldMigrateScheduleQuery: $0d8528c14b31acb8$export$96b9ce0c66d974ee, useLazyMigrationShouldMigrateScheduleQuery: $0d8528c14b31acb8$export$ae4c36917e2342d2, useNfcTagCreateMutation: $0d8528c14b31acb8$export$495a6f78305598e8, useNfcTagUpdateMutation: $0d8528c14b31acb8$export$d4d3461fb63a3ef3, useNfcTagConnectToUserMutation: $0d8528c14b31acb8$export$ab58f3b3edfc9ed3, useNfcTagDisconnectFromUserMutation: $0d8528c14b31acb8$export$f2d058aeb105f39c, useNfcTagGetAccessedChargePointsInCompanyQuery: $0d8528c14b31acb8$export$8087e35ec16fe1f3, useLazyNfcTagGetAccessedChargePointsInCompanyQuery: $0d8528c14b31acb8$export$8f1f63ff6d2f830c, useNfcTagGetAccessedPoolsInCompanyQuery: $0d8528c14b31acb8$export$d23af1bf0271bd, useLazyNfcTagGetAccessedPoolsInCompanyQuery: $0d8528c14b31acb8$export$70e34a9fc434ee2c, useNfcTagDeleteMutation: $0d8528c14b31acb8$export$39f088f37ac37ba4, useNfcTagGetNfcTagsPagedQuery: $0d8528c14b31acb8$export$59183093e5f980a5, useLazyNfcTagGetNfcTagsPagedQuery: $0d8528c14b31acb8$export$919cedbd5e89c789, useNfcTagGetRejectedTagsPagedQuery: $0d8528c14b31acb8$export$a9669a01cfb53814, useLazyNfcTagGetRejectedTagsPagedQuery: $0d8528c14b31acb8$export$3bba717986183139, useNfcTagGetRejectedTagsQuery: $0d8528c14b31acb8$export$5a5af2a436401c10, useLazyNfcTagGetRejectedTagsQuery: $0d8528c14b31acb8$export$3431643b9c531d3, useNotificationGetAllOrFilteredQuery: $0d8528c14b31acb8$export$669840a4da57f525, useLazyNotificationGetAllOrFilteredQuery: $0d8528c14b31acb8$export$39baa6ddb81de6ef, useNotificationCreateNotificationMutation: $0d8528c14b31acb8$export$b6c0197ffeea54ae, useNotificationGetByIdQuery: $0d8528c14b31acb8$export$a67b384cd65c4947, useLazyNotificationGetByIdQuery: $0d8528c14b31acb8$export$8f501001f76c480, useNotificationUpdateNotificationMutation: $0d8528c14b31acb8$export$9bde321f3a1ca594, useNotificationDeleteNotificationMutation: $0d8528c14b31acb8$export$dcd42290b020f3a8, useNotificationPublishNotificationMutation: $0d8528c14b31acb8$export$870ee339237f757e, useOcppCommandResetMutation: $0d8528c14b31acb8$export$f8764b26b9b4498d, useOcppCommandClearCacheMutation: $0d8528c14b31acb8$export$c75bcb1cd9d6103d, useOcppCommandDataTransferMutation: $0d8528c14b31acb8$export$5cb549297b6bf15b, useOcppCommandGetConfigurationMutation: $0d8528c14b31acb8$export$9fdffb52b6084b06, useOcppCommandGetDiagnosticsMutation: $0d8528c14b31acb8$export$6d8bddeeca5836e4, useOcppCommandUnlockConnectorMutation: $0d8528c14b31acb8$export$cbee8c171673c55b, useOcppCommandChangeAvailabilityMutation: $0d8528c14b31acb8$export$95635692900a310b, useOcppCommandRemoteStartMutation: $0d8528c14b31acb8$export$30d5a3acf40920a5, useOcppCommandRemoteStopMutation: $0d8528c14b31acb8$export$392294730b980489, useOcppCommandTriggerMessageMutation: $0d8528c14b31acb8$export$404d7cabf585b706, useOcppCommandUpdateFirmwareMutation: $0d8528c14b31acb8$export$59a563159e50729f, useOcppCommandTestMutation: $0d8528c14b31acb8$export$6f426054c2423d05, useOcppCommandUpdateConfigKeysMutation: $0d8528c14b31acb8$export$d868ac7bc625c769, useOcppCommandUpdateConfigKeyMutation: $0d8528c14b31acb8$export$cadfa007eac2dbb4, useOcppCommandInstallCertificateMutation: $0d8528c14b31acb8$export$a9f37d5a9e061d37, useOcppCommandDeleteCertificateMutation: $0d8528c14b31acb8$export$20234f7071978c6a, useOcppCommandGetInstalledCertsMutation: $0d8528c14b31acb8$export$74953b05717e83b5, useOcppLogsGatewayQuery: $0d8528c14b31acb8$export$d0acb8baf546bcc8, useLazyOcppLogsGatewayQuery: $0d8528c14b31acb8$export$ad5502b06d5770d9, useOcppLogsRelayQuery: $0d8528c14b31acb8$export$b81a740db195e0df, useLazyOcppLogsRelayQuery: $0d8528c14b31acb8$export$fe961a45c7b71471, usePartnerGetAllAllQuery: $0d8528c14b31acb8$export$f010ef6795c8d747, useLazyPartnerGetAllAllQuery: $0d8528c14b31acb8$export$1658a5852ea4b40f, usePartnerCreatePartnerMutation: $0d8528c14b31acb8$export$71d3a20d03257139, usePartnerUpdatePartnerMutation: $0d8528c14b31acb8$export$c91c09948d22cd17, usePartnerGetAllQuery: $0d8528c14b31acb8$export$7b6528535d7e17c6, useLazyPartnerGetAllQuery: $0d8528c14b31acb8$export$1c7f432362720ce6, usePartnerGetByIdQuery: $0d8528c14b31acb8$export$cfd4f39902297de0, useLazyPartnerGetByIdQuery: $0d8528c14b31acb8$export$3f0668ee62dff91, usePartnerDeleteMutation: $0d8528c14b31acb8$export$a84a32fadc382fd, usePartnerGetPartnerSettingsQuery: $0d8528c14b31acb8$export$1827abb45170767e, useLazyPartnerGetPartnerSettingsQuery: $0d8528c14b31acb8$export$218ff91af1e99402, usePartnerUpdatePartnerSettingsMutation: $0d8528c14b31acb8$export$ee9434cc596d5934, usePartnerCreateServicePartnerInvitationCodeMutation: $0d8528c14b31acb8$export$9b8644fe88b1cb10, usePartnerGetCurrentServicePartnerInvitationCodeQuery: $0d8528c14b31acb8$export$dfcc97f2bba1bba9, useLazyPartnerGetCurrentServicePartnerInvitationCodeQuery: $0d8528c14b31acb8$export$20693144cae66ed0, usePartnerGetCompaniesByPartnerIdQuery: $0d8528c14b31acb8$export$eea1f48d07ad4e82, useLazyPartnerGetCompaniesByPartnerIdQuery: $0d8528c14b31acb8$export$55c83cedf0c27908, usePartnerGetChargePointsPagedQuery: $0d8528c14b31acb8$export$30134f8e086bb236, useLazyPartnerGetChargePointsPagedQuery: $0d8528c14b31acb8$export$7b54dabfc9f9f14d, usePartnerGetAlarmsByPartnerIdQuery: $0d8528c14b31acb8$export$8c9744dad4a4370, useLazyPartnerGetAlarmsByPartnerIdQuery: $0d8528c14b31acb8$export$b8013d5b2142903, usePartnerSetAcknowledgedMutation: $0d8528c14b31acb8$export$bf793fdf8374ac39, usePartnerGetUsersByPartnerIdQuery: $0d8528c14b31acb8$export$5993ca7a80dd1020, useLazyPartnerGetUsersByPartnerIdQuery: $0d8528c14b31acb8$export$3d834387571751, usePartnerCreatePartnerUserMutation: $0d8528c14b31acb8$export$142c609922564748, usePartnerUpdatePartnerUserMutation: $0d8528c14b31acb8$export$5572e0989e2d960b, usePartnerAddUserAsPartnerMutation: $0d8528c14b31acb8$export$49ead860fae676e9, usePartnerRemoveUserAsPartnerMutation: $0d8528c14b31acb8$export$2d9eace371761d91, usePartnerGetLoadbalancerGroupsPagedQuery: $0d8528c14b31acb8$export$c1097b3bfdc8bd6d, useLazyPartnerGetLoadbalancerGroupsPagedQuery: $0d8528c14b31acb8$export$c29eec0668495c5a, usePartnerGetNfcTagsQuery: $0d8528c14b31acb8$export$49c98b6ae0c8e38e, useLazyPartnerGetNfcTagsQuery: $0d8528c14b31acb8$export$a436a3144e4983e6, usePartnerGetExternalServersQuery: $0d8528c14b31acb8$export$2e87dbc72f31f45, useLazyPartnerGetExternalServersQuery: $0d8528c14b31acb8$export$1cad85c1e636715f, usePartnerGetPartnerCandidatesQuery: $0d8528c14b31acb8$export$7df2c0c066572831, useLazyPartnerGetPartnerCandidatesQuery: $0d8528c14b31acb8$export$fde8e5596d128d94, usePartnerApprovePartnerCandidateMutation: $0d8528c14b31acb8$export$525d2fe97da755e6, usePartnerDeletePartnerCandidateMutation: $0d8528c14b31acb8$export$e4511f7feb2870e0, usePaymentCreateOrganizationSubscriptionMutation: $0d8528c14b31acb8$export$c912fa9ac154e442, usePaymentGetSubscriptionsByOrgQuery: $0d8528c14b31acb8$export$ba788864fae3c011, useLazyPaymentGetSubscriptionsByOrgQuery: $0d8528c14b31acb8$export$25e4742d16b1e966, usePaymentCreatePartnerSubscriptionMutation: $0d8528c14b31acb8$export$c278d9594c980026, usePaymentGetSubscriptionsByPartnerQuery: $0d8528c14b31acb8$export$815b9139f8b48b75, useLazyPaymentGetSubscriptionsByPartnerQuery: $0d8528c14b31acb8$export$b43f414d64ab93b, usePaymentCreateIndividualSubscriptionMutation: $0d8528c14b31acb8$export$df9dfd55bea24483, usePaymentValidateDiscountCodeMutation: $0d8528c14b31acb8$export$94954c57899292ab, usePaymentGetCustomerQuery: $0d8528c14b31acb8$export$fbccc4205da306d1, useLazyPaymentGetCustomerQuery: $0d8528c14b31acb8$export$d9467ee9ef0d920b, usePaymentGetSubscriptionDetailsQuery: $0d8528c14b31acb8$export$28932fa82f672f40, useLazyPaymentGetSubscriptionDetailsQuery: $0d8528c14b31acb8$export$ca5769bf359b94ce, usePaymentGetBillableConnectorsQuery: $0d8528c14b31acb8$export$c527e99eb1b47b85, useLazyPaymentGetBillableConnectorsQuery: $0d8528c14b31acb8$export$e80c60a2d5963812, usePaymentCreateOrganizationCheckoutSessionMutation: $0d8528c14b31acb8$export$cf58a0d796c7f855, usePaymentCreatePartnerCheckoutSessionMutation: $0d8528c14b31acb8$export$9fab744931eefb91, usePaymentCreateIndividualCheckoutSessionMutation: $0d8528c14b31acb8$export$39f5b526ca68ad54, usePaymentGetOrganizationCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$8c33e7d0df0f0fa5, useLazyPaymentGetOrganizationCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$ed2677a9bd50214c, usePaymentGetPartnerCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$dce197c7991e3ad9, useLazyPaymentGetPartnerCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$c06e92787c34e064, usePaymentGetIndividualCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$83617b4a729659ed, useLazyPaymentGetIndividualCheckoutSessionStatusQuery: $0d8528c14b31acb8$export$a8ef92de212b736e, usePaymentCreateOrganizationOneTimeCheckoutMutation: $0d8528c14b31acb8$export$15b7e703e39a1c3a, usePaymentCreatePartnerOneTimeCheckoutMutation: $0d8528c14b31acb8$export$5e6fda9206bf2663, usePaymentCreateIndividualOneTimeCheckoutMutation: $0d8528c14b31acb8$export$6a61db53bfdb550d, usePaymentGetOrganizationOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$12396a236186dc1c, useLazyPaymentGetOrganizationOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$60417b86d58af747, usePaymentGetPartnerOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$1511a9e680a225ae, useLazyPaymentGetPartnerOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$920485098c1361c2, usePaymentGetIndividualOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$230328e1f6c6e1da, useLazyPaymentGetIndividualOneTimeCheckoutStatusQuery: $0d8528c14b31acb8$export$a5de99f8a9b6a8f1, usePaymentGetWarrantyExtensionStatusForChargePointQuery: $0d8528c14b31acb8$export$54cc5efa533f3c1a, useLazyPaymentGetWarrantyExtensionStatusForChargePointQuery: $0d8528c14b31acb8$export$7339960b3880f214, usePaymentCreateSelfServicePortalMutation: $0d8528c14b31acb8$export$bf11b2fde8835ef5, usePaymentGetCommercialOfferingsQuery: $0d8528c14b31acb8$export$ad20073fbda8c3e6, useLazyPaymentGetCommercialOfferingsQuery: $0d8528c14b31acb8$export$e640f919e13e7303, usePoolCreateMutation: $0d8528c14b31acb8$export$f7ac74521cc29298, usePoolUpdateMutation: $0d8528c14b31acb8$export$6317cae65483ef68, usePoolGetByIdQuery: $0d8528c14b31acb8$export$a0ebaacb616e8ffa, useLazyPoolGetByIdQuery: $0d8528c14b31acb8$export$9ac672aa33c1f6e2, usePoolConnectToUserMutation: $0d8528c14b31acb8$export$946a2e11845ded80, usePoolDisconnectFromUserMutation: $0d8528c14b31acb8$export$65a11acae7f0c035, usePoolDeletePoolMutation: $0d8528c14b31acb8$export$cc7d400d397c41d3, usePoolGetChargePointsQuery: $0d8528c14b31acb8$export$650cedd391f8138e, useLazyPoolGetChargePointsQuery: $0d8528c14b31acb8$export$a63f925e77f4826d, useProductGetAllQuery: $0d8528c14b31acb8$export$33abe9a06d476a80, useLazyProductGetAllQuery: $0d8528c14b31acb8$export$3b63143cd5e58aad, useProductGetOptionsQuery: $0d8528c14b31acb8$export$e6b45a2ecf8278ea, useLazyProductGetOptionsQuery: $0d8528c14b31acb8$export$c8b7512af256baa9, useProductGetHardwareversionsQuery: $0d8528c14b31acb8$export$753741c465a943eb, useLazyProductGetHardwareversionsQuery: $0d8528c14b31acb8$export$6c75e9c52530d2ae, useProductGetActiveHardwareVersionQuery: $0d8528c14b31acb8$export$a1af46dcacfc2c1a, useLazyProductGetActiveHardwareVersionQuery: $0d8528c14b31acb8$export$f48f23b8271929bd, useProductSetActiveHardwareVersionMutation: $0d8528c14b31acb8$export$5b2e7980b01d0be3, useReportGetReportsQuery: $0d8528c14b31acb8$export$7030ece4aa9b2bd5, useLazyReportGetReportsQuery: $0d8528c14b31acb8$export$ee5f4fbe1edb18b7, useReportGetReportsForAdminQuery: $0d8528c14b31acb8$export$b17ff0e45de1a64d, useLazyReportGetReportsForAdminQuery: $0d8528c14b31acb8$export$b80c1efd5baaab42, useReportGetReportsForPartnerQuery: $0d8528c14b31acb8$export$998f1cfb73571472, useLazyReportGetReportsForPartnerQuery: $0d8528c14b31acb8$export$64bb2c03188e8abc, useReportGetReportDataQuery: $0d8528c14b31acb8$export$4a50ac06b6a95670, useLazyReportGetReportDataQuery: $0d8528c14b31acb8$export$f790d1b338880adb, useScheduleGetByIdQuery: $0d8528c14b31acb8$export$a4130623476f247a, useLazyScheduleGetByIdQuery: $0d8528c14b31acb8$export$cc55e019bc69f806, useScheduleDeleteScheduleMutation: $0d8528c14b31acb8$export$a772ad50b3f0a169, useScheduleGetByChargePointQuery: $0d8528c14b31acb8$export$e005b5ecca8409a2, useLazyScheduleGetByChargePointQuery: $0d8528c14b31acb8$export$83b5521086619a23, useScheduleCreateScheduleMutation: $0d8528c14b31acb8$export$5591d0e6dcc2c0ea, useScheduleUpdateScheduleMutation: $0d8528c14b31acb8$export$f4e2236bcbdc402, useScheduleCopyScheduleFromChargePointMutation: $0d8528c14b31acb8$export$4081b33cbf9610f3, useScopedAccessGetCurrentScopedAccessContextQuery: $0d8528c14b31acb8$export$78c1e2205c54a90c, useLazyScopedAccessGetCurrentScopedAccessContextQuery: $0d8528c14b31acb8$export$a47730f54f06764e, useScopedAccessStartScopedAccessContextMutation: $0d8528c14b31acb8$export$f7e4795c78af102, useScopedAccessStopScopedAccessContextMutation: $0d8528c14b31acb8$export$cca9476058317417, useSimulatedChargePointCreateSimulatedMutation: $0d8528c14b31acb8$export$c3a2c159dc909579, useSmartChargingScheduleGetQuery: $0d8528c14b31acb8$export$db345a071b074fd6, useLazySmartChargingScheduleGetQuery: $0d8528c14b31acb8$export$73770e5e2ec570c2, useSmartChargingScheduleClearMutation: $0d8528c14b31acb8$export$42a9c5e3022dc455, useSmartChargingScheduleGetByChargePointQuery: $0d8528c14b31acb8$export$9d91582acb484f76, useLazySmartChargingScheduleGetByChargePointQuery: $0d8528c14b31acb8$export$82fb5634e6b05955, useSmartChargingScheduleGetChargePointScheduleStatusQuery: $0d8528c14b31acb8$export$30d034af40585192, useLazySmartChargingScheduleGetChargePointScheduleStatusQuery: $0d8528c14b31acb8$export$7ed3c36043e9119c, useSmartChargingScheduleUpdateMutation: $0d8528c14b31acb8$export$4ad870682067ac0f, useStatisticsGetChargePointStatusStatsForAllQuery: $0d8528c14b31acb8$export$24fb9e4587523db, useLazyStatisticsGetChargePointStatusStatsForAllQuery: $0d8528c14b31acb8$export$f2cc1b560d220dc9, useStatisticsGetChargePointTotalConsumptionLastSevenDaysQuery: $0d8528c14b31acb8$export$418078dca0774854, useLazyStatisticsGetChargePointTotalConsumptionLastSevenDaysQuery: $0d8528c14b31acb8$export$fc305e9402230e68, useStatisticsGetChargePointStatusStatsForPartnerQuery: $0d8528c14b31acb8$export$78f8303b3fc03d9c, useLazyStatisticsGetChargePointStatusStatsForPartnerQuery: $0d8528c14b31acb8$export$9ad65c67ed5ab15b, useStatisticsGetUserTotalConsumptionQuery: $0d8528c14b31acb8$export$4c7cf5776d56335d, useLazyStatisticsGetUserTotalConsumptionQuery: $0d8528c14b31acb8$export$7866e045312f101f, useStatisticsGetChargePointStatusStatsForCompanyQuery: $0d8528c14b31acb8$export$9686fa758fe8f2, useLazyStatisticsGetChargePointStatusStatsForCompanyQuery: $0d8528c14b31acb8$export$dc68b036b89ecee0, useStatisticsGetCompanyTotalConsumptionQuery: $0d8528c14b31acb8$export$9eba4218577b727f, useLazyStatisticsGetCompanyTotalConsumptionQuery: $0d8528c14b31acb8$export$695f91b431709746, useStatisticsGetUserUsageStatisticsQuery: $0d8528c14b31acb8$export$9db48a1e1755a94, useLazyStatisticsGetUserUsageStatisticsQuery: $0d8528c14b31acb8$export$2b1de10da86b190, useStatisticsGetUserChargerUsageStatisticsQuery: $0d8528c14b31acb8$export$94945a0978c523d2, useLazyStatisticsGetUserChargerUsageStatisticsQuery: $0d8528c14b31acb8$export$b4d80748a907495d, useStatisticsGetCompanyUsageStatisticsQuery: $0d8528c14b31acb8$export$18668fbd9875d4f1, useLazyStatisticsGetCompanyUsageStatisticsQuery: $0d8528c14b31acb8$export$ae0444fb6b601bfc, useTroubleshootingGetErrorCodeTroubleshootingInfosQuery: $0d8528c14b31acb8$export$62dfb92655b7d1ba, useLazyTroubleshootingGetErrorCodeTroubleshootingInfosQuery: $0d8528c14b31acb8$export$9cf0b2c497cb9a30, useTroubleshootingGetErrorCodeTroubleshootingInfoQuery: $0d8528c14b31acb8$export$666efd9c11950fab, useLazyTroubleshootingGetErrorCodeTroubleshootingInfoQuery: $0d8528c14b31acb8$export$f86ebc2ef548bbb9, useUserGetFilteredQuery: $0d8528c14b31acb8$export$830cffc4a6efbc3c, useLazyUserGetFilteredQuery: $0d8528c14b31acb8$export$cb7ca20edb708078, useUserUpdateLoggedInUserMutation: $0d8528c14b31acb8$export$8cf9f35f7fef6c07, useUserGetFilteredPagedQuery: $0d8528c14b31acb8$export$eb23d8b0f3ef1795, useLazyUserGetFilteredPagedQuery: $0d8528c14b31acb8$export$1b3d26a57cac114a, useUserGetUserByIdQuery: $0d8528c14b31acb8$export$bc64ed84199046ea, useLazyUserGetUserByIdQuery: $0d8528c14b31acb8$export$757899863918e762, useUserObfuscateUserMutation: $0d8528c14b31acb8$export$94e1839f94537e85, useUserGetUserSettingsQuery: $0d8528c14b31acb8$export$2738d4afa27e5e9f, useLazyUserGetUserSettingsQuery: $0d8528c14b31acb8$export$8fcbc3b7b48bd3d, useUserUpdateUserSettingsMutation: $0d8528c14b31acb8$export$177cec91283d0043, useUserLoggedInUserIsCompanyMemberQuery: $0d8528c14b31acb8$export$d2dcbc5cb00626d5, useLazyUserLoggedInUserIsCompanyMemberQuery: $0d8528c14b31acb8$export$a029aeba50da3c77, useUserGetPoolsForSelectedCompanyQuery: $0d8528c14b31acb8$export$b382b03a87503d64, useLazyUserGetPoolsForSelectedCompanyQuery: $0d8528c14b31acb8$export$d3923ee552b8cede, useUserGetForUserByNfcAccessWithNfcAccessInfoQuery: $0d8528c14b31acb8$export$602255d25ca10a39, useLazyUserGetForUserByNfcAccessWithNfcAccessInfoQuery: $0d8528c14b31acb8$export$393a6d9c49703d7b, useUserGetOwnedChargePointsQuery: $0d8528c14b31acb8$export$d4a9defa2e151633, useLazyUserGetOwnedChargePointsQuery: $0d8528c14b31acb8$export$1ebb4e85fd971a4, useUserGetOwnedChargePointsWithIdsQuery: $0d8528c14b31acb8$export$b8f4207601805c4f, useLazyUserGetOwnedChargePointsWithIdsQuery: $0d8528c14b31acb8$export$720625aab6d802b, useUserIsUserHasChargePointsQuery: $0d8528c14b31acb8$export$6d497978c7156b82, useLazyUserIsUserHasChargePointsQuery: $0d8528c14b31acb8$export$d4cb51064ec856d9, useUserGetUserNotificationsQuery: $0d8528c14b31acb8$export$1ed68831b43658e, useLazyUserGetUserNotificationsQuery: $0d8528c14b31acb8$export$a7ff1b7a1fcf9b16, useUserGetOwnNfcTagsQuery: $0d8528c14b31acb8$export$c033d09657e3284e, useLazyUserGetOwnNfcTagsQuery: $0d8528c14b31acb8$export$f135c0489ffc89a2, useUserUpdateOwnNfcTagsMutation: $0d8528c14b31acb8$export$3e0609ad5e3b8b7, useUserUpdateUserGreenChargingSettingMutation: $0d8528c14b31acb8$export$f42e676e80abeef8, useUserRemoveChargePointAccessMutation: $0d8528c14b31acb8$export$89c983eecf9bc2b2, useUserGetLatestRejectedTagQuery: $0d8528c14b31acb8$export$8518bd360d426d73, useLazyUserGetLatestRejectedTagQuery: $0d8528c14b31acb8$export$a2902be7143c0810, useUserSetAllNotificationsToReadForUserMutation: $0d8528c14b31acb8$export$fe173d2ee425158f, useUserSetNotificationToReadForUserMutation: $0d8528c14b31acb8$export$581ac59874bc2af4, useUserAcceptTermsMutation: $0d8528c14b31acb8$export$5d73fe33ab3c7cd5, useUserIsFavouriteQuery: $0d8528c14b31acb8$export$57987d4bbf0c1b5b, useLazyUserIsFavouriteQuery: $0d8528c14b31acb8$export$3904ce7f04a960aa, useUserAddFavouriteMutation: $0d8528c14b31acb8$export$3f63a36da3d5bf13, useUserRemoveFavouriteMutation: $0d8528c14b31acb8$export$2c140682f52cd193, useUserGetFavouritesQuery: $0d8528c14b31acb8$export$aa4efa994c5ebf80, useLazyUserGetFavouritesQuery: $0d8528c14b31acb8$export$548c33e34b0e9385, useUserActivateUserMutation: $0d8528c14b31acb8$export$1005efb6d88ab1f9, useUserRevokeUserSessionsMutation: $0d8528c14b31acb8$export$91454d1525c1eaa4, useUserGetPartnerCandidateQuery: $0d8528c14b31acb8$export$5e90166f1ba66294, useLazyUserGetPartnerCandidateQuery: $0d8528c14b31acb8$export$551a3df8ddfca3d5, useUserUnlockUserMutation: $0d8528c14b31acb8$export$3ab42235d5dae9e0 } = $0d8528c14b31acb8$export$327b9b2c02b069ca;

});
parcelRegister("Qfv2Q", function(module, exports) {

$parcel$export(module.exports, "baseApi", function () { return $f6bec1ae634e9df3$export$bcc8035e549759b4; });
/* eslint-disable */ 
var $cx6BW = parcelRequire("cx6BW");

var $73SrW = parcelRequire("73SrW");

var $gGcRO = parcelRequire("gGcRO");
const $f6bec1ae634e9df3$export$bcc8035e549759b4 = (0, $cx6BW.createApi)({
    reducerPath: "wapi",
    baseQuery: (args, api, extraOptions)=>(0, $gGcRO.baseQueryWithReauth)(args, api, {
            ...extraOptions,
            baseUrl: (0, $73SrW.default)()
        }),
    endpoints: ()=>({})
});

});
parcelRegister("cx6BW", function(module, exports) {

$parcel$export(module.exports, "createApi", function () { return $91fdb1ea542865d0$export$9cdc2b9a8d94c842; });

var $eLH3C = parcelRequire("eLH3C");

var $gtjDQ = parcelRequire("gtjDQ");

var $2rQNl = parcelRequire("2rQNl");

var $2ATxG = parcelRequire("2ATxG");

var $7E7Dk = parcelRequire("7E7Dk");

var $4YPvm = parcelRequire("4YPvm");
var $91fdb1ea542865d0$var$__defProp = Object.defineProperty;
var $91fdb1ea542865d0$var$__defProps = Object.defineProperties;
var $91fdb1ea542865d0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $91fdb1ea542865d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $91fdb1ea542865d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $91fdb1ea542865d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $91fdb1ea542865d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $91fdb1ea542865d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $91fdb1ea542865d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($91fdb1ea542865d0$var$__hasOwnProp.call(b, prop)) $91fdb1ea542865d0$var$__defNormalProp(a, prop, b[prop]);
    if ($91fdb1ea542865d0$var$__getOwnPropSymbols) {
        for (var prop of $91fdb1ea542865d0$var$__getOwnPropSymbols(b))if ($91fdb1ea542865d0$var$__propIsEnum.call(b, prop)) $91fdb1ea542865d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $91fdb1ea542865d0$var$__spreadProps = (a, b)=>$91fdb1ea542865d0$var$__defProps(a, $91fdb1ea542865d0$var$__getOwnPropDescs(b));
var $91fdb1ea542865d0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($91fdb1ea542865d0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $91fdb1ea542865d0$var$__getOwnPropSymbols) {
        for (var prop of $91fdb1ea542865d0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $91fdb1ea542865d0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/query/utils/capitalize.ts
function $91fdb1ea542865d0$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/utils/countObjectKeys.ts
function $91fdb1ea542865d0$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
// src/query/endpointDefinitions.ts
function $91fdb1ea542865d0$var$isQueryDefinition(e) {
    return e.type === "query" /* query */ ;
}
function $91fdb1ea542865d0$var$isMutationDefinition(e) {
    return e.type === "mutation" /* mutation */ ;
}
function $91fdb1ea542865d0$var$isInfiniteQueryDefinition(e) {
    return e.type === "infinitequery" /* infinitequery */ ;
}
// src/query/tsHelpers.ts
function $91fdb1ea542865d0$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
// src/query/react/constants.ts
var $91fdb1ea542865d0$export$3e5f293e15ab07c8 = Symbol();
function $91fdb1ea542865d0$var$useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    const incoming = (0, $7E7Dk.useMemo)(()=>({
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        }), [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    const cache = (0, $7E7Dk.useRef)(incoming);
    (0, $7E7Dk.useEffect)(()=>{
        if (cache.current.serialized !== incoming.serialized) cache.current = incoming;
    }, [
        incoming
    ]);
    return cache.current.serialized === incoming.serialized ? cache.current.queryArgs : queryArgs;
}
function $91fdb1ea542865d0$var$useShallowStableValue(value) {
    const cache = (0, $7E7Dk.useRef)(value);
    (0, $7E7Dk.useEffect)(()=>{
        if (!(0, $2rQNl.shallowEqual)(cache.current, value)) cache.current = value;
    }, [
        value
    ]);
    return (0, $2rQNl.shallowEqual)(cache.current, value) ? cache.current : value;
}
// src/query/react/buildHooks.ts
var $91fdb1ea542865d0$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $91fdb1ea542865d0$var$isDOM = /* @__PURE__ */ $91fdb1ea542865d0$var$canUseDOM();
var $91fdb1ea542865d0$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $91fdb1ea542865d0$var$isReactNative = /* @__PURE__ */ $91fdb1ea542865d0$var$isRunningInReactNative();
var $91fdb1ea542865d0$var$getUseIsomorphicLayoutEffect = ()=>$91fdb1ea542865d0$var$isDOM || $91fdb1ea542865d0$var$isReactNative ? (0, $7E7Dk.useLayoutEffect) : (0, $7E7Dk.useEffect);
var $91fdb1ea542865d0$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $91fdb1ea542865d0$var$getUseIsomorphicLayoutEffect();
var $91fdb1ea542865d0$var$noPendingQueryStateSelector = (selected)=>{
    if (selected.isUninitialized) return $91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $eLH3C.QueryStatus).pending
    });
    return selected;
};
function $91fdb1ea542865d0$var$pick(obj, ...keys) {
    const ret = {};
    keys.forEach((key)=>{
        ret[key] = obj[key];
    });
    return ret;
}
var $91fdb1ea542865d0$var$COMMON_HOOK_DEBUG_FIELDS = [
    "data",
    "status",
    "isLoading",
    "isSuccess",
    "isError",
    "error"
];
function $91fdb1ea542865d0$var$buildHooks({ api: api, moduleOptions: { batch: batch, hooks: { useDispatch: useDispatch, useSelector: useSelector, useStore: useStore }, unstable__sideEffectsInRender: unstable__sideEffectsInRender, createSelector: createSelector }, serializeQueryArgs: serializeQueryArgs, context: context }) {
    const usePossiblyImmediateEffect = unstable__sideEffectsInRender ? (cb)=>cb() : (0, $7E7Dk.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildInfiniteQueryHooks: buildInfiniteQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            if (queryArgs !== (0, $eLH3C.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || hasData && (isFetching && !(lastResult == null ? void 0 : lastResult.isError) || currentState.isUninitialized);
        return $91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function infiniteQueryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            if (queryArgs !== (0, $eLH3C.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || isFetching && hasData;
        return $91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        const dispatch = useDispatch();
        const stableDefaultOptions = $91fdb1ea542865d0$var$useShallowStableValue(defaultOptions);
        return (0, $7E7Dk.useCallback)((arg, options)=>dispatch(api.util.prefetch(endpointName, arg, $91fdb1ea542865d0$var$__spreadValues($91fdb1ea542865d0$var$__spreadValues({}, stableDefaultOptions), options))), [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function useQuerySubscriptionCommonImpl(endpointName, arg, _a = {}) {
        var _b = _a, { refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, refetchOnMountOrArgChange: refetchOnMountOrArgChange, skip: skip = false, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = _b, rest = $91fdb1ea542865d0$var$__objRest(_b, [
            "refetchOnReconnect",
            "refetchOnFocus",
            "refetchOnMountOrArgChange",
            "skip",
            "pollingInterval",
            "skipPollingIfUnfocused"
        ]);
        const { initiate: initiate } = api.endpoints[endpointName];
        const dispatch = useDispatch();
        const subscriptionSelectorsRef = (0, $7E7Dk.useRef)(void 0);
        if (!subscriptionSelectorsRef.current) {
            const returnedValue = dispatch(api.internalActions.internal_getRTKQSubscriptions());
            subscriptionSelectorsRef.current = returnedValue;
        }
        const stableArg = $91fdb1ea542865d0$var$useStableQueryArgs(skip ? (0, $eLH3C.skipToken) : arg, // Even if the user provided a per-endpoint `serializeQueryArgs` with
        // a consistent return value, _here_ we want to use the default behavior
        // so we can tell if _anything_ actually changed. Otherwise, we can end up
        // with a case where the query args did change but the serialization doesn't,
        // and then we never try to initiate a refetch.
        (0, $eLH3C.defaultSerializeQueryArgs), context.endpointDefinitions[endpointName], endpointName);
        const stableSubscriptionOptions = $91fdb1ea542865d0$var$useShallowStableValue({
            refetchOnReconnect: refetchOnReconnect,
            refetchOnFocus: refetchOnFocus,
            pollingInterval: pollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        });
        const initialPageParam = rest.initialPageParam;
        const stableInitialPageParam = $91fdb1ea542865d0$var$useShallowStableValue(initialPageParam);
        const promiseRef = (0, $7E7Dk.useRef)(void 0);
        let { queryCacheKey: queryCacheKey, requestId: requestId } = promiseRef.current || {};
        let currentRenderHasSubscription = false;
        if (queryCacheKey && requestId) currentRenderHasSubscription = subscriptionSelectorsRef.current.isRequestSubscribed(queryCacheKey, requestId);
        const subscriptionRemoved = !currentRenderHasSubscription && promiseRef.current !== void 0;
        usePossiblyImmediateEffect(()=>{
            if (subscriptionRemoved) promiseRef.current = void 0;
        }, [
            subscriptionRemoved
        ]);
        usePossiblyImmediateEffect(()=>{
            var _a2;
            const lastPromise = promiseRef.current;
            typeof $4YPvm;
            if (stableArg === (0, $eLH3C.skipToken)) {
                lastPromise == null || lastPromise.unsubscribe();
                promiseRef.current = void 0;
                return;
            }
            const lastSubscriptionOptions = (_a2 = promiseRef.current) == null ? void 0 : _a2.subscriptionOptions;
            if (!lastPromise || lastPromise.arg !== stableArg) {
                lastPromise == null || lastPromise.unsubscribe();
                const promise = dispatch(initiate(stableArg, $91fdb1ea542865d0$var$__spreadValues({
                    subscriptionOptions: stableSubscriptionOptions,
                    forceRefetch: refetchOnMountOrArgChange
                }, $91fdb1ea542865d0$var$isInfiniteQueryDefinition(context.endpointDefinitions[endpointName]) ? {
                    initialPageParam: stableInitialPageParam
                } : {})));
                promiseRef.current = promise;
            } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
        }, [
            dispatch,
            initiate,
            refetchOnMountOrArgChange,
            stableArg,
            stableSubscriptionOptions,
            subscriptionRemoved,
            stableInitialPageParam,
            endpointName
        ]);
        return [
            promiseRef,
            dispatch,
            initiate,
            stableSubscriptionOptions
        ];
    }
    function buildUseQueryState(endpointName, preSelector) {
        const useQueryState = (arg, { skip: skip = false, selectFromResult: selectFromResult } = {})=>{
            const { select: select } = api.endpoints[endpointName];
            const stableArg = $91fdb1ea542865d0$var$useStableQueryArgs(skip ? (0, $eLH3C.skipToken) : arg, serializeQueryArgs, context.endpointDefinitions[endpointName], endpointName);
            const lastValue = (0, $7E7Dk.useRef)(void 0);
            const selectDefaultResult = (0, $7E7Dk.useMemo)(()=>// Normally ts-ignores are bad and should be avoided, but we're
                // already casting this selector to be `Selector<any>` anyway,
                // so the inconsistencies don't matter here
                // @ts-ignore
                createSelector([
                    // @ts-ignore
                    select(stableArg),
                    (_, lastResult)=>lastResult,
                    (_)=>stableArg
                ], preSelector, {
                    memoizeOptions: {
                        resultEqualityCheck: (0, $2rQNl.shallowEqual)
                    }
                }), [
                select,
                stableArg
            ]);
            const querySelector = (0, $7E7Dk.useMemo)(()=>selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult, {
                    devModeChecks: {
                        identityFunctionCheck: "never"
                    }
                }) : selectDefaultResult, [
                selectDefaultResult,
                selectFromResult
            ]);
            const currentState = useSelector((state)=>querySelector(state, lastValue.current), (0, $2rQNl.shallowEqual));
            const store = useStore();
            const newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $91fdb1ea542865d0$var$useIsomorphicLayoutEffect(()=>{
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return useQueryState;
    }
    function usePromiseRefUnsubscribeOnUnmount(promiseRef) {
        (0, $7E7Dk.useEffect)(()=>{
            return ()=>{
                var _a, _b;
                (_b = (_a = promiseRef.current) == null ? void 0 : _a.unsubscribe) == null || _b.call(_a);
                promiseRef.current = void 0;
            };
        }, [
            promiseRef
        ]);
    }
    function refetchOrErrorIfUnmounted(promiseRef) {
        if (!promiseRef.current) throw new Error((0, $gtjDQ.formatProdErrorMessage)(38));
        return promiseRef.current.refetch();
    }
    function buildQueryHooks(endpointName) {
        const useQuerySubscription = (arg, options = {})=>{
            const [promiseRef] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            return (0, $7E7Dk.useMemo)(()=>({
                    /**
         * A method to manually refetch data for the query
         */ refetch: ()=>refetchOrErrorIfUnmounted(promiseRef)
                }), [
                promiseRef
            ]);
        };
        const useLazyQuerySubscription = ({ refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = {})=>{
            const { initiate: initiate } = api.endpoints[endpointName];
            const dispatch = useDispatch();
            const [arg, setArg] = (0, $7E7Dk.useState)($91fdb1ea542865d0$export$3e5f293e15ab07c8);
            const promiseRef = (0, $7E7Dk.useRef)(void 0);
            const stableSubscriptionOptions = $91fdb1ea542865d0$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval,
                skipPollingIfUnfocused: skipPollingIfUnfocused
            });
            usePossiblyImmediateEffect(()=>{
                var _a, _b;
                const lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            const subscriptionOptionsRef = (0, $7E7Dk.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const trigger = (0, $7E7Dk.useCallback)(function(arg2, preferCacheValue = false) {
                let promise;
                batch(()=>{
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            const reset = (0, $7E7Dk.useCallback)(()=>{
                var _a, _b;
                if ((_a = promiseRef.current) == null ? void 0 : _a.queryCacheKey) dispatch(api.internalActions.removeQueryResult({
                    queryCacheKey: (_b = promiseRef.current) == null ? void 0 : _b.queryCacheKey
                }));
            }, [
                dispatch
            ]);
            (0, $7E7Dk.useEffect)(()=>{
                return ()=>{
                    var _a;
                    (_a = promiseRef == null ? void 0 : promiseRef.current) == null || _a.unsubscribe();
                };
            }, []);
            (0, $7E7Dk.useEffect)(()=>{
                if (arg !== $91fdb1ea542865d0$export$3e5f293e15ab07c8 && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $7E7Dk.useMemo)(()=>[
                    trigger,
                    arg,
                    {
                        reset: reset
                    }
                ], [
                trigger,
                arg,
                reset
            ]);
        };
        const useQueryState = buildUseQueryState(endpointName, queryStatePreSelector);
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery (options) {
                const [trigger, arg, { reset: reset }] = useLazyQuerySubscription(options);
                const queryStateResults = useQueryState(arg, $91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, options), {
                    skip: arg === $91fdb1ea542865d0$export$3e5f293e15ab07c8
                }));
                const info = (0, $7E7Dk.useMemo)(()=>({
                        lastArg: arg
                    }), [
                    arg
                ]);
                return (0, $7E7Dk.useMemo)(()=>[
                        trigger,
                        $91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, queryStateResults), {
                            reset: reset
                        }),
                        info
                    ], [
                    trigger,
                    queryStateResults,
                    reset,
                    info
                ]);
            },
            useQuery (arg, options) {
                const querySubscriptionResults = useQuerySubscription(arg, options);
                const queryStateResults = useQueryState(arg, $91fdb1ea542865d0$var$__spreadValues({
                    selectFromResult: arg === (0, $eLH3C.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : $91fdb1ea542865d0$var$noPendingQueryStateSelector
                }, options));
                const debugValue = $91fdb1ea542865d0$var$pick(queryStateResults, ...$91fdb1ea542865d0$var$COMMON_HOOK_DEBUG_FIELDS);
                (0, $7E7Dk.useDebugValue)(debugValue);
                return (0, $7E7Dk.useMemo)(()=>$91fdb1ea542865d0$var$__spreadValues($91fdb1ea542865d0$var$__spreadValues({}, queryStateResults), querySubscriptionResults), [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildInfiniteQueryHooks(endpointName) {
        const useInfiniteQuerySubscription = (arg, options = {})=>{
            const [promiseRef, dispatch, initiate, stableSubscriptionOptions] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            const subscriptionOptionsRef = (0, $7E7Dk.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const trigger = (0, $7E7Dk.useCallback)(function(arg2, direction) {
                let promise;
                batch(()=>{
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        direction: direction
                    }));
                });
                return promise;
            }, [
                promiseRef,
                dispatch,
                initiate
            ]);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            const stableArg = $91fdb1ea542865d0$var$useStableQueryArgs(options.skip ? (0, $eLH3C.skipToken) : arg, // Even if the user provided a per-endpoint `serializeQueryArgs` with
            // a consistent return value, _here_ we want to use the default behavior
            // so we can tell if _anything_ actually changed. Otherwise, we can end up
            // with a case where the query args did change but the serialization doesn't,
            // and then we never try to initiate a refetch.
            (0, $eLH3C.defaultSerializeQueryArgs), context.endpointDefinitions[endpointName], endpointName);
            const refetch = (0, $7E7Dk.useCallback)(()=>refetchOrErrorIfUnmounted(promiseRef), [
                promiseRef
            ]);
            return (0, $7E7Dk.useMemo)(()=>{
                const fetchNextPage = ()=>{
                    return trigger(stableArg, "forward");
                };
                const fetchPreviousPage = ()=>{
                    return trigger(stableArg, "backward");
                };
                return {
                    trigger: trigger,
                    refetch: /**
           * A method to manually refetch data for the query
           */ refetch,
                    fetchNextPage: fetchNextPage,
                    fetchPreviousPage: fetchPreviousPage
                };
            }, [
                refetch,
                trigger,
                stableArg
            ]);
        };
        const useInfiniteQueryState = buildUseQueryState(endpointName, infiniteQueryStatePreSelector);
        return {
            useInfiniteQueryState: useInfiniteQueryState,
            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
            useInfiniteQuery (arg, options) {
                const { refetch: refetch, fetchNextPage: fetchNextPage, fetchPreviousPage: fetchPreviousPage } = useInfiniteQuerySubscription(arg, options);
                const queryStateResults = useInfiniteQueryState(arg, $91fdb1ea542865d0$var$__spreadValues({
                    selectFromResult: arg === (0, $eLH3C.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : $91fdb1ea542865d0$var$noPendingQueryStateSelector
                }, options));
                const debugValue = $91fdb1ea542865d0$var$pick(queryStateResults, ...$91fdb1ea542865d0$var$COMMON_HOOK_DEBUG_FIELDS, "hasNextPage", "hasPreviousPage");
                (0, $7E7Dk.useDebugValue)(debugValue);
                return (0, $7E7Dk.useMemo)(()=>$91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, queryStateResults), {
                        fetchNextPage: fetchNextPage,
                        fetchPreviousPage: fetchPreviousPage,
                        refetch: refetch
                    }), [
                    queryStateResults,
                    fetchNextPage,
                    fetchPreviousPage,
                    refetch
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return ({ selectFromResult: selectFromResult, fixedCacheKey: fixedCacheKey } = {})=>{
            const { select: select, initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const [promise, setPromise] = (0, $7E7Dk.useState)();
            (0, $7E7Dk.useEffect)(()=>()=>{
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                }, [
                promise
            ]);
            const triggerMutation = (0, $7E7Dk.useCallback)(function(arg) {
                const promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            const { requestId: requestId } = promise || {};
            const selectDefaultResult = (0, $7E7Dk.useMemo)(()=>select({
                    fixedCacheKey: fixedCacheKey,
                    requestId: promise == null ? void 0 : promise.requestId
                }), [
                fixedCacheKey,
                promise,
                select
            ]);
            const mutationSelector = (0, $7E7Dk.useMemo)(()=>selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult, [
                selectFromResult,
                selectDefaultResult
            ]);
            const currentState = useSelector(mutationSelector, (0, $2rQNl.shallowEqual));
            const originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            const reset = (0, $7E7Dk.useCallback)(()=>{
                batch(()=>{
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            const debugValue = $91fdb1ea542865d0$var$pick(currentState, ...$91fdb1ea542865d0$var$COMMON_HOOK_DEBUG_FIELDS, "endpointName");
            (0, $7E7Dk.useDebugValue)(debugValue);
            const finalState = (0, $7E7Dk.useMemo)(()=>$91fdb1ea542865d0$var$__spreadProps($91fdb1ea542865d0$var$__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                }), [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $7E7Dk.useMemo)(()=>[
                    triggerMutation,
                    finalState
                ], [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/react/module.ts
var $91fdb1ea542865d0$export$fba4c1b64338c09f = /* @__PURE__ */ Symbol();
var $91fdb1ea542865d0$export$8b98f9e72008ec90 = (_a = {})=>{
    var _b = _a, { batch: batch = (0, $2rQNl.batch), hooks: hooks = {
        useDispatch: (0, $2rQNl.useDispatch),
        useSelector: (0, $2rQNl.useSelector),
        useStore: (0, $2rQNl.useStore)
    }, createSelector: createSelector = (0, $2ATxG.createSelector), unstable__sideEffectsInRender: unstable__sideEffectsInRender = false } = _b, rest = $91fdb1ea542865d0$var$__objRest(_b, [
        "batch",
        "hooks",
        "createSelector",
        "unstable__sideEffectsInRender"
    ]);
    return {
        name: $91fdb1ea542865d0$export$fba4c1b64338c09f,
        init (api, { serializeQueryArgs: serializeQueryArgs }, context) {
            const anyApi = api;
            const { buildQueryHooks: buildQueryHooks, buildInfiniteQueryHooks: buildInfiniteQueryHooks, buildMutationHook: buildMutationHook, usePrefetch: usePrefetch } = $91fdb1ea542865d0$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    hooks: hooks,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender,
                    createSelector: createSelector
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $91fdb1ea542865d0$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $91fdb1ea542865d0$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint (endpointName, definition) {
                    if ($91fdb1ea542865d0$var$isQueryDefinition(definition)) {
                        const { useQuery: useQuery, useLazyQuery: useLazyQuery, useLazyQuerySubscription: useLazyQuerySubscription, useQueryState: useQueryState, useQuerySubscription: useQuerySubscription } = buildQueryHooks(endpointName);
                        $91fdb1ea542865d0$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api[`use${$91fdb1ea542865d0$var$capitalize(endpointName)}Query`] = useQuery;
                        api[`useLazy${$91fdb1ea542865d0$var$capitalize(endpointName)}Query`] = useLazyQuery;
                    }
                    if ($91fdb1ea542865d0$var$isMutationDefinition(definition)) {
                        const useMutation = buildMutationHook(endpointName);
                        $91fdb1ea542865d0$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api[`use${$91fdb1ea542865d0$var$capitalize(endpointName)}Mutation`] = useMutation;
                    } else if ($91fdb1ea542865d0$var$isInfiniteQueryDefinition(definition)) {
                        const { useInfiniteQuery: useInfiniteQuery, useInfiniteQuerySubscription: useInfiniteQuerySubscription, useInfiniteQueryState: useInfiniteQueryState } = buildInfiniteQueryHooks(endpointName);
                        $91fdb1ea542865d0$var$safeAssign(anyApi.endpoints[endpointName], {
                            useInfiniteQuery: useInfiniteQuery,
                            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
                            useInfiniteQueryState: useInfiniteQueryState
                        });
                        api[`use${$91fdb1ea542865d0$var$capitalize(endpointName)}InfiniteQuery`] = useInfiniteQuery;
                    }
                }
            };
        }
    };
};
function $91fdb1ea542865d0$export$f4e57f6132f56752(props) {
    const context = props.context || (0, $2rQNl.ReactReduxContext);
    const existingContext = (0, $7E7Dk.useContext)(context);
    if (existingContext) throw new Error((0, $gtjDQ.formatProdErrorMessage)(35));
    const [store] = $7E7Dk.useState(()=>(0, $gtjDQ.configureStore)({
            reducer: {
                [props.api.reducerPath]: props.api.reducer
            },
            middleware: (gDM)=>gDM().concat(props.api.middleware)
        }));
    (0, $7E7Dk.useEffect)(()=>props.setupListeners === false ? void 0 : (0, $eLH3C.setupListeners)(store.dispatch, props.setupListeners), [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ $7E7Dk.createElement((0, $2rQNl.Provider), {
        store: store,
        context: context
    }, props.children);
}
// src/query/react/index.ts
var $91fdb1ea542865d0$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $eLH3C.buildCreateApi)((0, $eLH3C.coreModule)(), $91fdb1ea542865d0$export$8b98f9e72008ec90());

});

parcelRegister("73SrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e88a83efb5a1908$export$2e2bcd8739ae039; });

var $eIymc = parcelRequire("eIymc");
const $3e88a83efb5a1908$var$getChargeAmpsApiPath = ()=>{
    if ((0, $eIymc.isPortalDomain) && (0, $eIymc.currentDomain)) return `/${0, $eIymc.currentDomain}/api`;
    if (location.hostname === "localhost" && "http://localhost:8001/api") return "http://localhost:8001/api";
    return "/api";
};
var $3e88a83efb5a1908$export$2e2bcd8739ae039 = $3e88a83efb5a1908$var$getChargeAmpsApiPath;

});
parcelRegister("eIymc", function(module, exports) {

$parcel$export(module.exports, "currentDomain", function () { return $06678f3f96d05fe9$export$ebdc50e4fef7d7fe; });
$parcel$export(module.exports, "isUserappDomain", function () { return $06678f3f96d05fe9$export$716c2d4f0f990fd5; });
$parcel$export(module.exports, "isAdminDomain", function () { return $06678f3f96d05fe9$export$c318965d8d339286; });
$parcel$export(module.exports, "isPartnerDomain", function () { return $06678f3f96d05fe9$export$45fed56390629ae9; });
$parcel$export(module.exports, "isSupportDomain", function () { return $06678f3f96d05fe9$export$d731c6d7f6fb8a59; });
$parcel$export(module.exports, "isPortalDomain", function () { return $06678f3f96d05fe9$export$71533bc4d3b56292; });
$parcel$export(module.exports, "currentPortalAudience", function () { return $06678f3f96d05fe9$export$4b28f7f50b876933; });
$parcel$export(module.exports, "isLandingPage", function () { return $06678f3f96d05fe9$export$32b5e5fecf41ac06; });
$parcel$export(module.exports, "default", function () { return $06678f3f96d05fe9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SiteDomain", function () { return (parcelRequire("fIpd8")).SiteDomain; });

var $fIpd8 = parcelRequire("fIpd8");
const $06678f3f96d05fe9$var$portalState = (0, $fIpd8.getPortalState)(window.location.pathname);
const $06678f3f96d05fe9$export$ebdc50e4fef7d7fe = $06678f3f96d05fe9$var$portalState.currentDomain;
const $06678f3f96d05fe9$export$716c2d4f0f990fd5 = $06678f3f96d05fe9$var$portalState.isUserappDomain;
const $06678f3f96d05fe9$export$c318965d8d339286 = $06678f3f96d05fe9$var$portalState.isAdminDomain;
const $06678f3f96d05fe9$export$45fed56390629ae9 = $06678f3f96d05fe9$var$portalState.isPartnerDomain;
const $06678f3f96d05fe9$export$d731c6d7f6fb8a59 = $06678f3f96d05fe9$var$portalState.isSupportDomain;
const $06678f3f96d05fe9$export$71533bc4d3b56292 = $06678f3f96d05fe9$var$portalState.isPortalDomain;
const $06678f3f96d05fe9$export$4b28f7f50b876933 = $06678f3f96d05fe9$var$portalState.currentPortalAudience;
const $06678f3f96d05fe9$export$32b5e5fecf41ac06 = (location)=>location === "/dashboard";
var $06678f3f96d05fe9$export$2e2bcd8739ae039 = $06678f3f96d05fe9$export$ebdc50e4fef7d7fe;

});
parcelRegister("fIpd8", function(module, exports) {

$parcel$export(module.exports, "SiteDomain", function () { return $00eea2bcb4e50ea3$export$d6f70d1fa17f24be; });
$parcel$export(module.exports, "getPortalState", function () { return $00eea2bcb4e50ea3$export$a55179a8b4759200; });
var $00eea2bcb4e50ea3$export$d6f70d1fa17f24be;
(function(SiteDomain) {
    SiteDomain["USERAPP"] = "userapp";
    SiteDomain["ADMIN"] = "admin";
    SiteDomain["PARTNER"] = "partner";
    SiteDomain["SUPPORT"] = "support";
})($00eea2bcb4e50ea3$export$d6f70d1fa17f24be || ($00eea2bcb4e50ea3$export$d6f70d1fa17f24be = {}));
const $00eea2bcb4e50ea3$export$80a8e1ee94cf4019 = (pathname)=>{
    const domain = (pathname.match(/^\/+([^/]+)(?:\/|$)/) || [])[1];
    switch(domain){
        case "admin":
            return "admin";
        case "partner":
            return "partner";
        case "support":
            return "support";
        case "userapp":
            return "userapp";
        default:
            return null;
    }
};
const $00eea2bcb4e50ea3$export$a55179a8b4759200 = (pathname)=>{
    const currentDomain = $00eea2bcb4e50ea3$export$80a8e1ee94cf4019(pathname);
    return {
        currentDomain: currentDomain,
        isUserappDomain: currentDomain === "userapp",
        isAdminDomain: currentDomain === "admin",
        isPartnerDomain: currentDomain === "partner",
        isSupportDomain: currentDomain === "support",
        isPortalDomain: Boolean(currentDomain),
        currentPortalAudience: currentDomain
    };
};

});



parcelRegister("gGcRO", function(module, exports) {

$parcel$export(module.exports, "isFetchBaseQueryError", function () { return $21dff231c22e5da6$export$99e6e72cbf59d989; });
$parcel$export(module.exports, "baseQueryWithReauth", function () { return $21dff231c22e5da6$export$117e03453ff24d93; });

var $eLH3C = parcelRequire("eLH3C");

var $ieP8o = parcelRequire("ieP8o");

var $eFTdF = parcelRequire("eFTdF");

var $eIymc = parcelRequire("eIymc");

var $96jRw = parcelRequire("96jRw");

var $ac4co = parcelRequire("ac4co");
const $21dff231c22e5da6$var$toFetchArgs = (args)=>typeof args === "string" ? {
        url: args
    } : {
        ...args
    };
const $21dff231c22e5da6$var$toBaseQueryCustomError = (error)=>({
        status: "BASE_QUERY_CUSTOM_ERROR",
        error: error instanceof Error ? error.message : "Unknown request error"
    });
const $21dff231c22e5da6$var$dynamicBaseQuery = async (args, api, extraOptions)=>{
    const baseUrl = extraOptions.baseUrl;
    const cookieAuthMode = (0, $eIymc.isPortalDomain);
    const createRawBaseQuery = (resolvedBaseUrl)=>(0, $eLH3C.fetchBaseQuery)({
            baseUrl: resolvedBaseUrl,
            credentials: cookieAuthMode ? "include" : undefined
        });
    const requestArgs = $21dff231c22e5da6$var$toFetchArgs(args);
    const rawBaseQuery = createRawBaseQuery(baseUrl);
    const executeQuery = async (nextRequestArgs, forceCsrfRefresh = false)=>{
        let finalArgs = nextRequestArgs;
        if ((0, $96jRw.shouldAttachPortalCsrf)({
            cookieAuthMode: cookieAuthMode,
            method: nextRequestArgs.method,
            url: nextRequestArgs.url
        })) {
            const csrfToken = await (0, $ieP8o.ensureCsrfToken)(async ()=>{
                const handshakeResult = await rawBaseQuery({
                    url: "/csrf/handshake"
                }, api, extraOptions);
                if (handshakeResult.error) throw handshakeResult.error;
                return (0, $ieP8o.readCsrfTokenFromResponse)(handshakeResult.meta?.response);
            }, {
                forceRefresh: forceCsrfRefresh
            });
            finalArgs = {
                ...nextRequestArgs,
                headers: (0, $ieP8o.withCsrfHeader)(nextRequestArgs.headers, csrfToken)
            };
        }
        return rawBaseQuery(finalArgs, api, extraOptions);
    };
    try {
        let result = await executeQuery(requestArgs);
        if (result.error && (0, $96jRw.shouldRetryPortalRequestWithFreshCsrf)({
            cookieAuthMode: cookieAuthMode,
            method: requestArgs.method,
            url: requestArgs.url,
            status: result.error.status
        })) result = await executeQuery(requestArgs, true);
        return result;
    } catch (error) {
        if ($21dff231c22e5da6$export$99e6e72cbf59d989(error)) return {
            error: error
        };
        return {
            error: $21dff231c22e5da6$var$toBaseQueryCustomError(error)
        };
    }
};
const $21dff231c22e5da6$export$117e03453ff24d93 = async (args, api, extraOptions)=>{
    const requestArgs = $21dff231c22e5da6$var$toFetchArgs(args);
    const result = await $21dff231c22e5da6$var$dynamicBaseQuery(args, api, extraOptions);
    if (result && result.error && (0, $ac4co.isScopedAccessEndedResponse)(result.error)) (0, $ac4co.notifyScopedAccessEnded)();
    if (result && result.error && (0, $96jRw.shouldInvalidatePortalSessionOnUnauthorized)({
        status: result.error.status,
        url: requestArgs.url
    })) api.dispatch((0, $eFTdF.requestPortalSessionReset)());
    return result;
};
function $21dff231c22e5da6$export$99e6e72cbf59d989(error) {
    if (typeof error !== "object" || error == null || !("status" in error)) return false;
    const status = error.status;
    return typeof status === "number" || status === "FETCH_ERROR" || status === "PARSING_ERROR" || status === "TIMEOUT_ERROR" || status === "CUSTOM_ERROR";
}

});
parcelRegister("ieP8o", function(module, exports) {

$parcel$export(module.exports, "setCsrfToken", function () { return $d8b6db5f75285775$export$9633cb13000da15a; });
$parcel$export(module.exports, "clearCsrfToken", function () { return $d8b6db5f75285775$export$eda54594e7b2d92b; });
$parcel$export(module.exports, "readCsrfTokenFromResponse", function () { return $d8b6db5f75285775$export$57acbd7e431184d; });
$parcel$export(module.exports, "isUnsafeMethod", function () { return $d8b6db5f75285775$export$1d15c060d646a79b; });
$parcel$export(module.exports, "withCsrfHeader", function () { return $d8b6db5f75285775$export$dca309dcf007dd2f; });
$parcel$export(module.exports, "ensureCsrfToken", function () { return $d8b6db5f75285775$export$84e83902d3a16987; });
const $d8b6db5f75285775$export$f39f459ffe3b5b2 = "ca_csrf";
const $d8b6db5f75285775$export$7f697e417cb7a5a8 = "X-CSRF-TOKEN";
const $d8b6db5f75285775$var$UNSAFE_METHODS = new Set([
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
]);
let $d8b6db5f75285775$var$csrfRequestToken;
const $d8b6db5f75285775$var$escapeCookieName = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const $d8b6db5f75285775$export$66592f1ba74f6ce6 = ()=>{
    const match = document.cookie.match(new RegExp(`(?:^|; )${$d8b6db5f75285775$var$escapeCookieName($d8b6db5f75285775$export$f39f459ffe3b5b2)}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
};
const $d8b6db5f75285775$export$52160ca23629dd6f = ()=>$d8b6db5f75285775$var$csrfRequestToken || null;
const $d8b6db5f75285775$export$9633cb13000da15a = (token)=>{
    $d8b6db5f75285775$var$csrfRequestToken = token || null;
    return $d8b6db5f75285775$var$csrfRequestToken;
};
const $d8b6db5f75285775$export$eda54594e7b2d92b = ()=>{
    $d8b6db5f75285775$var$csrfRequestToken = null;
};
const $d8b6db5f75285775$export$57acbd7e431184d = (response)=>response?.headers.get($d8b6db5f75285775$export$7f697e417cb7a5a8) || null;
const $d8b6db5f75285775$export$1d15c060d646a79b = (method)=>$d8b6db5f75285775$var$UNSAFE_METHODS.has((method || "GET").toUpperCase());
// Convert loose header input into a concrete Headers object while dropping undefined values.
const $d8b6db5f75285775$var$toHeaders = (headers)=>{
    if (headers instanceof Headers) return new Headers(headers);
    if (Array.isArray(headers)) {
        const normalizedTuples = headers.filter((entry)=>entry.length >= 2);
        return new Headers(normalizedTuples);
    }
    const normalizedHeaders = Object.entries(headers ?? {}).reduce((acc, [key, value])=>{
        if (typeof value !== "undefined") acc[key] = value;
        return acc;
    }, {});
    return new Headers(normalizedHeaders);
};
const $d8b6db5f75285775$export$dca309dcf007dd2f = (headers, csrfToken)=>{
    const nextHeaders = $d8b6db5f75285775$var$toHeaders(headers);
    nextHeaders.set($d8b6db5f75285775$export$7f697e417cb7a5a8, csrfToken);
    return nextHeaders;
};
const $d8b6db5f75285775$export$84e83902d3a16987 = async (handshake, { forceRefresh: forceRefresh = false } = {})=>{
    if (!forceRefresh) {
        const existingToken = $d8b6db5f75285775$export$52160ca23629dd6f();
        if (existingToken) return existingToken;
    }
    const refreshedToken = await handshake();
    if (!refreshedToken) throw new Error(`CSRF header "${$d8b6db5f75285775$export$7f697e417cb7a5a8}" is missing after handshake`);
    $d8b6db5f75285775$export$9633cb13000da15a(refreshedToken);
    return refreshedToken;
};

});

parcelRegister("eFTdF", function(module, exports) {

$parcel$export(module.exports, "requestPortalSessionReset", function () { return $7e5595f55654640c$export$bfe733ea6175fda0; });
$parcel$export(module.exports, "selectPortalSessionResetRequestCount", function () { return $7e5595f55654640c$export$be3583c811eb5f80; });
$parcel$export(module.exports, "default", function () { return $7e5595f55654640c$export$2e2bcd8739ae039; });

var $gtjDQ = parcelRequire("gtjDQ");
const $7e5595f55654640c$var$initialState = {
    requestCount: 0
};
const $7e5595f55654640c$var$portalSessionResetSlice = (0, $gtjDQ.createSlice)({
    name: "portalSessionReset",
    initialState: $7e5595f55654640c$var$initialState,
    reducers: {
        requestPortalSessionReset: (state)=>{
            state.requestCount += 1;
        }
    }
});
const { requestPortalSessionReset: $7e5595f55654640c$export$bfe733ea6175fda0 } = $7e5595f55654640c$var$portalSessionResetSlice.actions;
const $7e5595f55654640c$export$be3583c811eb5f80 = (state)=>state.portalSessionReset.requestCount;
var $7e5595f55654640c$export$2e2bcd8739ae039 = $7e5595f55654640c$var$portalSessionResetSlice.reducer;

});

parcelRegister("96jRw", function(module, exports) {

$parcel$export(module.exports, "shouldAttachPortalCsrf", function () { return $50d866b18a28fb06$export$6e9254ee2969a98; });
$parcel$export(module.exports, "shouldRetryPortalRequestWithFreshCsrf", function () { return $50d866b18a28fb06$export$a8ab726b1e2b449b; });
$parcel$export(module.exports, "shouldInvalidatePortalSessionOnUnauthorized", function () { return $50d866b18a28fb06$export$486b7bd916d2d675; });

var $ieP8o = parcelRequire("ieP8o");

var $fPtLP = parcelRequire("fPtLP");
const $50d866b18a28fb06$var$normalizePortalRequestPath = (url)=>{
    const pathname = new URL(url, window.location.origin).pathname;
    return pathname.replace(/^\/(?:admin|partner|support|userapp)\/api(?=\/)/, "").replace(/^\/api(?=\/)/, "");
};
const $50d866b18a28fb06$var$isPortalSessionBootstrapRoute = (url)=>$50d866b18a28fb06$var$normalizePortalRequestPath(url) === "/auth/current";
const $50d866b18a28fb06$export$6e9254ee2969a98 = ({ cookieAuthMode: cookieAuthMode, method: method, url: url })=>cookieAuthMode && (0, $ieP8o.isUnsafeMethod)(method) && !(0, $fPtLP.default)(url);
const $50d866b18a28fb06$export$a8ab726b1e2b449b = ({ cookieAuthMode: cookieAuthMode, method: method, url: url, status: status })=>$50d866b18a28fb06$export$6e9254ee2969a98({
        cookieAuthMode: cookieAuthMode,
        method: method,
        url: url
    }) && (status === 400 || status === 403);
const $50d866b18a28fb06$export$486b7bd916d2d675 = ({ status: status, url: url })=>status === 401 && !(0, $fPtLP.default)(url) && !$50d866b18a28fb06$var$isPortalSessionBootstrapRoute(url);

});
parcelRegister("fPtLP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d55d4b9ecf9c14da$export$2e2bcd8739ae039; });
const $d55d4b9ecf9c14da$var$PUBLIC_AUTH_ROUTE_PATTERNS = [
    /^\/auth\/login$/,
    /^\/auth\/register$/,
    /^\/auth\/[^/]+\/register\/partner\/candidate$/,
    /^\/auth\/password\/reset\/request$/,
    /^\/auth\/password\/reset\/[^/]+$/,
    /^\/auth\/email\/verify\/[^/]+$/,
    /^\/auth\/invitation\/accept\/[^/]+$/
];
const $d55d4b9ecf9c14da$var$normalizePublicAuthPath = (url)=>{
    const pathname = new URL(url, window.location.origin).pathname;
    return pathname.replace(/^\/(?:admin|partner|support|userapp)\/api(?=\/)/, "").replace(/^\/api(?=\/)/, "");
};
const $d55d4b9ecf9c14da$var$isPublicAuthRoute = (url)=>{
    const pathname = $d55d4b9ecf9c14da$var$normalizePublicAuthPath(url);
    return $d55d4b9ecf9c14da$var$PUBLIC_AUTH_ROUTE_PATTERNS.some((pattern)=>pattern.test(pathname));
};
var $d55d4b9ecf9c14da$export$2e2bcd8739ae039 = $d55d4b9ecf9c14da$var$isPublicAuthRoute;

});


parcelRegister("ac4co", function(module, exports) {

$parcel$export(module.exports, "SCOPED_ACCESS_RETURN_TO_PARAM", function () { return $769a9ce8cd93c491$export$8e2d4901774bdd73; });
$parcel$export(module.exports, "SCOPED_ACCESS_ENTRY_RETURN_TO_PARAM", function () { return $769a9ce8cd93c491$export$d5e862d3585b3ce9; });
$parcel$export(module.exports, "SCOPED_ACCESS_EXPECTED_COMPANY_ID_PARAM", function () { return $769a9ce8cd93c491$export$63c0267d9e775e1a; });
$parcel$export(module.exports, "readScopedAccessReturnToFromSearch", function () { return $769a9ce8cd93c491$export$1fe1af5a93571adc; });
$parcel$export(module.exports, "readScopedAccessEntryReturnToFromSearch", function () { return $769a9ce8cd93c491$export$52bc76213104b37c; });
$parcel$export(module.exports, "readScopedAccessExpectedCompanyIdFromSearch", function () { return $769a9ce8cd93c491$export$b854cd86a3b4ae9b; });
$parcel$export(module.exports, "storeScopedAccessReturnTo", function () { return $769a9ce8cd93c491$export$82c9fee2276a93de; });
$parcel$export(module.exports, "readScopedAccessReturnTo", function () { return $769a9ce8cd93c491$export$ad7924395abf9d76; });
$parcel$export(module.exports, "clearScopedAccessReturnTo", function () { return $769a9ce8cd93c491$export$e38cf43d4456d6a3; });
$parcel$export(module.exports, "storeScopedAccessExpectedCompanyId", function () { return $769a9ce8cd93c491$export$441679d11258579; });
$parcel$export(module.exports, "readScopedAccessExpectedCompanyId", function () { return $769a9ce8cd93c491$export$a71a361c83bc8ab4; });
$parcel$export(module.exports, "clearScopedAccessExpectedCompanyId", function () { return $769a9ce8cd93c491$export$86bdeac8b80265db; });
$parcel$export(module.exports, "getScopedAccessReturnTo", function () { return $769a9ce8cd93c491$export$4a4439921d02fee3; });
$parcel$export(module.exports, "runWithScopedAccessOperationLock", function () { return $769a9ce8cd93c491$export$7ebe1f5621c44f06; });
$parcel$export(module.exports, "redirectToScopedAccessAdminDashboard", function () { return $769a9ce8cd93c491$export$7cd382f4cedd5132; });
$parcel$export(module.exports, "redirectToStoredScopedAccessReturnTo", function () { return $769a9ce8cd93c491$export$5a47b440bc3b62f7; });
$parcel$export(module.exports, "isScopedAccessEndedResponse", function () { return $769a9ce8cd93c491$export$5c6cbb8a83e395f3; });
$parcel$export(module.exports, "notifyScopedAccessEnded", function () { return $769a9ce8cd93c491$export$d17ca38f3a7ed226; });
$parcel$export(module.exports, "broadcastScopedAccessEnded", function () { return $769a9ce8cd93c491$export$1f99233d2cb88a0e; });
$parcel$export(module.exports, "addScopedAccessEndedListener", function () { return $769a9ce8cd93c491$export$5af98c0275d20efe; });
const $769a9ce8cd93c491$export$8e2d4901774bdd73 = "scopedAccessReturnTo";
const $769a9ce8cd93c491$export$d5e862d3585b3ce9 = "returnTo";
const $769a9ce8cd93c491$export$63c0267d9e775e1a = "scopedAccessExpectedCompanyId";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY = "scoped-access:return-to";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_EXPECTED_COMPANY_ID_STORAGE_KEY = "scoped-access:expected-company-id";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_STORAGE_KEY = "scoped-access:operation-lock";
const $769a9ce8cd93c491$var$ALLOWED_SCOPED_ACCESS_RETURN_TO_PREFIXES = [
    "/support/",
    "/partner/"
];
const $769a9ce8cd93c491$var$MISSING_SCOPED_ACCESS_RETURN_TO_ERROR = "Missing scoped access return origin.";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_CODE = "SCOPED_ACCESS_ENDED";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME = "scoped-access-ended";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_CHANNEL_NAME = "scoped-access";
const $769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_TTL_MS = 30000;
const $769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_RETRY_MS = 75;
// Return-origin bootstrap and storage
const $769a9ce8cd93c491$var$normalizeScopedAccessReturnTo = (value)=>{
    if (!value) return null;
    try {
        const parsedUrl = new URL(value, window.location.origin);
        if (parsedUrl.origin !== window.location.origin || !$769a9ce8cd93c491$var$ALLOWED_SCOPED_ACCESS_RETURN_TO_PREFIXES.some((prefix)=>parsedUrl.pathname.startsWith(prefix))) return null;
        return `${parsedUrl.pathname}${parsedUrl.search}` || null;
    } catch  {
        return null;
    }
};
const $769a9ce8cd93c491$export$1fe1af5a93571adc = (search)=>{
    const searchParams = new URLSearchParams(search);
    return $769a9ce8cd93c491$var$normalizeScopedAccessReturnTo(searchParams.get($769a9ce8cd93c491$export$8e2d4901774bdd73));
};
const $769a9ce8cd93c491$export$52bc76213104b37c = (search)=>{
    const searchParams = new URLSearchParams(search);
    return $769a9ce8cd93c491$var$normalizeScopedAccessReturnTo(searchParams.get($769a9ce8cd93c491$export$d5e862d3585b3ce9));
};
const $769a9ce8cd93c491$var$normalizeScopedAccessExpectedCompanyId = (value)=>{
    const normalizedValue = value?.trim();
    return normalizedValue || null;
};
const $769a9ce8cd93c491$export$b854cd86a3b4ae9b = (search)=>{
    const searchParams = new URLSearchParams(search);
    return $769a9ce8cd93c491$var$normalizeScopedAccessExpectedCompanyId(searchParams.get($769a9ce8cd93c491$export$63c0267d9e775e1a));
};
const $769a9ce8cd93c491$export$82c9fee2276a93de = (returnTo)=>{
    const normalizedReturnTo = $769a9ce8cd93c491$var$normalizeScopedAccessReturnTo(returnTo);
    if (!normalizedReturnTo) return;
    window.sessionStorage.setItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY, normalizedReturnTo);
    window.localStorage.setItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY, normalizedReturnTo);
};
const $769a9ce8cd93c491$export$ad7924395abf9d76 = ()=>$769a9ce8cd93c491$var$normalizeScopedAccessReturnTo(window.sessionStorage.getItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY)) ?? $769a9ce8cd93c491$var$normalizeScopedAccessReturnTo(window.localStorage.getItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY));
const $769a9ce8cd93c491$export$e38cf43d4456d6a3 = ()=>{
    window.sessionStorage.removeItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY);
    window.localStorage.removeItem($769a9ce8cd93c491$var$SCOPED_ACCESS_RETURN_TO_STORAGE_KEY);
};
const $769a9ce8cd93c491$export$441679d11258579 = (companyId)=>{
    const normalizedCompanyId = $769a9ce8cd93c491$var$normalizeScopedAccessExpectedCompanyId(companyId);
    if (!normalizedCompanyId) return;
    window.sessionStorage.setItem($769a9ce8cd93c491$var$SCOPED_ACCESS_EXPECTED_COMPANY_ID_STORAGE_KEY, normalizedCompanyId);
};
const $769a9ce8cd93c491$export$a71a361c83bc8ab4 = ()=>$769a9ce8cd93c491$var$normalizeScopedAccessExpectedCompanyId(window.sessionStorage.getItem($769a9ce8cd93c491$var$SCOPED_ACCESS_EXPECTED_COMPANY_ID_STORAGE_KEY));
const $769a9ce8cd93c491$export$86bdeac8b80265db = ()=>{
    window.sessionStorage.removeItem($769a9ce8cd93c491$var$SCOPED_ACCESS_EXPECTED_COMPANY_ID_STORAGE_KEY);
};
const $769a9ce8cd93c491$export$4a4439921d02fee3 = ()=>{
    const returnTo = $769a9ce8cd93c491$export$ad7924395abf9d76();
    if (!returnTo) throw new Error($769a9ce8cd93c491$var$MISSING_SCOPED_ACCESS_RETURN_TO_ERROR);
    return returnTo;
};
const $769a9ce8cd93c491$var$createScopedAccessId = ()=>{
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `scoped-access-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $769a9ce8cd93c491$var$delay = (milliseconds)=>new Promise((resolve)=>{
        window.setTimeout(resolve, milliseconds);
    });
const $769a9ce8cd93c491$var$readScopedAccessOperationLock = ()=>{
    try {
        const value = window.localStorage.getItem($769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_STORAGE_KEY);
        if (!value) return null;
        const operationLock = JSON.parse(value);
        return typeof operationLock.ownerId === "string" && typeof operationLock.expiresAt === "number" ? {
            ownerId: operationLock.ownerId,
            expiresAt: operationLock.expiresAt
        } : null;
    } catch  {
        return null;
    }
};
const $769a9ce8cd93c491$var$tryAcquireScopedAccessOperationLock = (ownerId)=>{
    const currentLock = $769a9ce8cd93c491$var$readScopedAccessOperationLock();
    if (currentLock && currentLock.expiresAt > Date.now()) return currentLock.ownerId === ownerId;
    window.localStorage.setItem($769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_STORAGE_KEY, JSON.stringify({
        ownerId: ownerId,
        expiresAt: Date.now() + $769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_TTL_MS
    }));
    return $769a9ce8cd93c491$var$readScopedAccessOperationLock()?.ownerId === ownerId;
};
const $769a9ce8cd93c491$var$acquireScopedAccessOperationLock = async (ownerId)=>{
    let isOperationLockAcquired = false;
    while(!isOperationLockAcquired)if ($769a9ce8cd93c491$var$tryAcquireScopedAccessOperationLock(ownerId)) isOperationLockAcquired = true;
    else await $769a9ce8cd93c491$var$delay($769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_RETRY_MS);
};
const $769a9ce8cd93c491$var$releaseScopedAccessOperationLock = (ownerId)=>{
    if ($769a9ce8cd93c491$var$readScopedAccessOperationLock()?.ownerId === ownerId) window.localStorage.removeItem($769a9ce8cd93c491$var$SCOPED_ACCESS_OPERATION_LOCK_STORAGE_KEY);
};
const $769a9ce8cd93c491$export$7ebe1f5621c44f06 = async (operation)=>{
    const ownerId = $769a9ce8cd93c491$var$createScopedAccessId();
    await $769a9ce8cd93c491$var$acquireScopedAccessOperationLock(ownerId);
    try {
        return await operation();
    } finally{
        $769a9ce8cd93c491$var$releaseScopedAccessOperationLock(ownerId);
    }
};
// Admin entry and exit redirects
const $769a9ce8cd93c491$var$buildScopedAccessAdminDashboardUrl = (returnTo, expectedCompanyId)=>{
    const adminUrl = new URL("/admin/dashboard", window.location.origin);
    // This is a one-time bootstrap handoff param. Admin normalizes it into browser-shared storage and removes it from the URL.
    adminUrl.searchParams.set($769a9ce8cd93c491$export$8e2d4901774bdd73, returnTo);
    if (expectedCompanyId) adminUrl.searchParams.set($769a9ce8cd93c491$export$63c0267d9e775e1a, expectedCompanyId);
    return adminUrl.toString();
};
const $769a9ce8cd93c491$export$7cd382f4cedd5132 = (returnTo, expectedCompanyId)=>{
    window.location.assign($769a9ce8cd93c491$var$buildScopedAccessAdminDashboardUrl(returnTo, expectedCompanyId));
};
const $769a9ce8cd93c491$export$5a47b440bc3b62f7 = ()=>{
    const returnTo = $769a9ce8cd93c491$export$4a4439921d02fee3();
    window.location.assign(returnTo);
};
// Scoped-access response interpretation
const $769a9ce8cd93c491$var$getProblemDetailsCode = (data)=>{
    if (!data || typeof data !== "object") return null;
    const problem = data;
    if (typeof problem.code === "string") return problem.code;
    const extensionCode = problem.extensions?.code;
    return typeof extensionCode === "string" ? extensionCode : null;
};
const $769a9ce8cd93c491$export$5c6cbb8a83e395f3 = (error)=>Number(error?.status) === 409 && $769a9ce8cd93c491$var$getProblemDetailsCode(error?.data)?.toUpperCase() === $769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_CODE;
// Cross-tab invalidation transport
const $769a9ce8cd93c491$var$scopedAccessTabId = $769a9ce8cd93c491$var$createScopedAccessId();
const $769a9ce8cd93c491$var$createScopedAccessChannel = ()=>typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel($769a9ce8cd93c491$var$SCOPED_ACCESS_CHANNEL_NAME);
const $769a9ce8cd93c491$export$d17ca38f3a7ed226 = ()=>{
    window.dispatchEvent(new Event($769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME));
};
const $769a9ce8cd93c491$export$1f99233d2cb88a0e = ()=>{
    const scopedAccessChannel = $769a9ce8cd93c491$var$createScopedAccessChannel();
    scopedAccessChannel?.postMessage({
        type: $769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME,
        sourceTabId: $769a9ce8cd93c491$var$scopedAccessTabId
    });
    scopedAccessChannel?.close();
};
const $769a9ce8cd93c491$export$5af98c0275d20efe = (listener)=>{
    const scopedAccessChannel = $769a9ce8cd93c491$var$createScopedAccessChannel();
    const handleChannelMessage = (event)=>{
        if (event.data?.type === $769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME && typeof event.data.sourceTabId === "string" && event.data.sourceTabId !== $769a9ce8cd93c491$var$scopedAccessTabId) listener();
    };
    window.addEventListener($769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME, listener);
    scopedAccessChannel?.addEventListener("message", handleChannelMessage);
    return ()=>{
        window.removeEventListener($769a9ce8cd93c491$var$SCOPED_ACCESS_ENDED_EVENT_NAME, listener);
        scopedAccessChannel?.removeEventListener("message", handleChannelMessage);
        scopedAccessChannel?.close();
    };
};

});





parcelRegister("hw820", function(module, exports) {

$parcel$export(module.exports, "normalizeEntitlementsState", function () { return $ef8554986df8c7e3$export$766bd6e64c51907b; });
$parcel$export(module.exports, "setEntitlements", function () { return $ef8554986df8c7e3$export$ff8f438d25beaf9a; });
$parcel$export(module.exports, "clearEntitlements", function () { return $ef8554986df8c7e3$export$28b7a06eb82e487d; });
$parcel$export(module.exports, "default", function () { return $ef8554986df8c7e3$export$2e2bcd8739ae039; });

var $gtjDQ = parcelRequire("gtjDQ");
const $ef8554986df8c7e3$export$62121d23e81ff9f2 = {
    organizationId: "",
    entitlementsMask: 0,
    bypassEntitlementEnforcement: false,
    expiresAtUtc: "",
    schemaVersion: 0,
    isHydrated: false
};
const $ef8554986df8c7e3$export$766bd6e64c51907b = (entitlements, organizationId)=>{
    if (!entitlements && !organizationId) return $ef8554986df8c7e3$export$62121d23e81ff9f2;
    return {
        organizationId: organizationId ?? entitlements?.organizationId ?? "",
        entitlementsMask: Number(entitlements?.entitlementsMask ?? 0),
        bypassEntitlementEnforcement: Boolean(entitlements?.bypassEntitlementEnforcement),
        expiresAtUtc: entitlements?.expiresAtUtc ?? "",
        schemaVersion: entitlements?.schemaVersion ?? 0,
        isHydrated: true
    };
};
const $ef8554986df8c7e3$var$entitlementsSlice = (0, $gtjDQ.createSlice)({
    name: "entitlements",
    initialState: $ef8554986df8c7e3$export$62121d23e81ff9f2,
    reducers: {
        setEntitlements: (_, action)=>action.payload,
        clearEntitlements: ()=>$ef8554986df8c7e3$export$62121d23e81ff9f2
    }
});
const { setEntitlements: $ef8554986df8c7e3$export$ff8f438d25beaf9a, clearEntitlements: $ef8554986df8c7e3$export$28b7a06eb82e487d } = $ef8554986df8c7e3$var$entitlementsSlice.actions;
var $ef8554986df8c7e3$export$2e2bcd8739ae039 = $ef8554986df8c7e3$var$entitlementsSlice.reducer;

});

parcelRegister("jnDYy", function(module, exports) {

$parcel$export(module.exports, "setUser", function () { return $128d98efa5f36be6$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "reset", function () { return $128d98efa5f36be6$export$aad8462122ac592b; });
$parcel$export(module.exports, "default", function () { return $128d98efa5f36be6$export$2e2bcd8739ae039; });

var $gtjDQ = parcelRequire("gtjDQ");

var $cbseE = parcelRequire("cbseE");

var $cRXmD = parcelRequire("cRXmD");
const $128d98efa5f36be6$var$initialState = {
    isAdmin: false,
    id: "",
    firstName: "",
    lastName: "",
    password: "",
    passwordChange: null,
    mobile: "",
    email: "",
    userType: "",
    partnerId: 0,
    personalAccept: "",
    companyAccept: null,
    lastLogin: "",
    userName: "",
    fullName: "",
    claims: [],
    isPartner: false,
    userStatus: "Valid",
    roles: [],
    isSuperAdmin: false,
    roleInCompany: null,
    selectedCompanyId: "",
    features: []
};
const $128d98efa5f36be6$export$8dea1a5d9f48fb86 = (0, $gtjDQ.createSlice)({
    name: "user",
    initialState: $128d98efa5f36be6$var$initialState,
    reducers: {
        setUser: (_, action)=>{
            const isAdmin = action.payload?.isSuperAdmin || (0, $cbseE.default)(action.payload, action.payload?.selectedCompanyId, (0, $cRXmD.default).Admin);
            return {
                ...action.payload,
                isAdmin: isAdmin
            };
        },
        reset: ()=>{}
    }
});
const { setUser: $128d98efa5f36be6$export$8b6bb3dd62a01be2, reset: $128d98efa5f36be6$export$aad8462122ac592b } = $128d98efa5f36be6$export$8dea1a5d9f48fb86.actions;
var $128d98efa5f36be6$export$2e2bcd8739ae039 = $128d98efa5f36be6$export$8dea1a5d9f48fb86.reducer;

});
parcelRegister("cbseE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f78b05e0129d046d$export$2e2bcd8739ae039; });
const $f78b05e0129d046d$var$hasClaimForCompany = (user, companyId, claim)=>{
    if (!user) return false;
    if (user.isSuperAdmin) return true;
    if (!user.roles || user.roles.length === 0 || !companyId || !claim) return false;
    const role = user.roles.find((role)=>role.companyId === companyId);
    return role?.claim === claim;
};
var $f78b05e0129d046d$export$2e2bcd8739ae039 = $f78b05e0129d046d$var$hasClaimForCompany;

});

parcelRegister("cRXmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76ce6b51b27bd72e$export$2e2bcd8739ae039; });
const $76ce6b51b27bd72e$var$CLAIMS = {
    Admin: "Admin",
    AdminViewOnly: "AdminViewOnly"
};
var $76ce6b51b27bd72e$export$2e2bcd8739ae039 = $76ce6b51b27bd72e$var$CLAIMS;

});


parcelRegister("9Rf8k", function(module, exports) {
$parcel$export(module.exports, "SignInPage", function () { return (parcelRequire("dOFuF")).SignInPage; });
parcelRequire("dOFuF");

});
parcelRegister("dOFuF", function(module, exports) {

$parcel$export(module.exports, "SignInPage", function () { return $e527600979278578$export$cf0bcac4c4020f20; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $eIymc = parcelRequire("eIymc");
var $fIpd8 = parcelRequire("fIpd8");
parcelRequire("aBfUs");
var $1SJYY = parcelRequire("1SJYY");
parcelRequire("dXhIC");
var $g4tUM = parcelRequire("g4tUM");
parcelRequire("8Vsu4");
var $3Oq9E = parcelRequire("3Oq9E");
function $e527600979278578$export$cf0bcac4c4020f20({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        dark: (0, $eIymc.default) === (0, $fIpd8.SiteDomain).SUPPORT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g4tUM.SignInForm), null)), (0, $eIymc.isPartnerDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3Oq9E.PartnerSignInInfoBlock), null));
}

});
parcelRegister("aBfUs", function(module, exports) {
$parcel$export(module.exports, "LandingPageLayout", function () { return (parcelRequire("1SJYY")).LandingPageLayout; });
$parcel$export(module.exports, "SContentWrapper", function () { return (parcelRequire("1SJYY")).SContentWrapper; });
$parcel$export(module.exports, "SNotification", function () { return (parcelRequire("1SJYY")).SNotification; });
$parcel$export(module.exports, "SSpacer", function () { return (parcelRequire("1SJYY")).SSpacer; });
parcelRequire("1SJYY");

});
parcelRegister("1SJYY", function(module, exports) {

$parcel$export(module.exports, "SContentWrapper", function () { return $959797b032b4baa1$export$8f048d3f9e691bd7; });
$parcel$export(module.exports, "SSpacer", function () { return $959797b032b4baa1$export$232635f1f71a1af; });
$parcel$export(module.exports, "SNotification", function () { return $959797b032b4baa1$export$8796e7b68635e21c; });
$parcel$export(module.exports, "LandingPageLayout", function () { return $959797b032b4baa1$export$74685ae7d80874fd; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("1XnpB");
var $8zepY = parcelRequire("8zepY");
parcelRequire("lE9E6");
var $2cTiq = parcelRequire("2cTiq");
parcelRequire("8tfTg");
var $28PgI = parcelRequire("28PgI");
const $959797b032b4baa1$var$SWrapper = (0, $gRonV.default).div`
    min-height: 100vh;
    width: 100%;
    color: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.darkestColor};
    background: ${({ theme: theme, background: background, dark: dark })=>background ? background : dark ? theme.darkBackground : theme.lightBackground};
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
const $959797b032b4baa1$var$SChargeAmpsLandingPageLogo = (0, $gRonV.default)((0, $8zepY.ChargeAmpsLandingPageLogo))`
    fill: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.darkestColor};
`;
const $959797b032b4baa1$var$SHeader = (0, $gRonV.default).div`
    padding: 47px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 600;

    @media (max-width: 576px) {
        padding: 31px 8px;
    }
`;
const $959797b032b4baa1$var$SBody = (0, $gRonV.default).div`
    display: flex;
    justify-content: center;

    @media screen and (max-width: 600px) {
        margin-bottom: 50px;
    }
`;
const $959797b032b4baa1$export$8f048d3f9e691bd7 = (0, $gRonV.default).div`
    width: 100%;
    max-width: 450px;
    font-size: 16px;
    padding: 0 10px;
`;
const $959797b032b4baa1$export$232635f1f71a1af = (0, $gRonV.default).div`
    margin-bottom: 40px;
`;
const $959797b032b4baa1$export$8796e7b68635e21c = (0, $gRonV.default).div`
    display: block;
    width: 100%;
    padding: 14px;
    text-align: center;
    font-size: 14px;
    background-color: ${({ error: error })=>error ? "#FF8B7C" : "#81E18B"};
    border-radius: 6px;
`;
function $959797b032b4baa1$export$74685ae7d80874fd({ children: children, className: className, style: style, background: customBackground, dark: dark, hideLanguageSelect: hideLanguageSelect = false, headerContent: headerContent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($959797b032b4baa1$var$SWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: customBackground,
        dark: dark
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($959797b032b4baa1$var$SHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "caLogo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($959797b032b4baa1$var$SChargeAmpsLandingPageLogo, {
        dark: dark
    })), headerContent, !hideLanguageSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $28PgI.LanguageSelectDrawer), {
        dark: dark
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($959797b032b4baa1$var$SBody, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2cTiq.LandingPageFooter), {
        dark: dark
    })));
}

});
parcelRegister("1XnpB", function(module, exports) {
$parcel$export(module.exports, "ChargeAmpsLandingPageLogo", function () { return (parcelRequire("8zepY")).ChargeAmpsLandingPageLogo; });
parcelRequire("8zepY");

});
parcelRegister("8zepY", function(module, exports) {

$parcel$export(module.exports, "ChargeAmpsLandingPageLogo", function () { return $56150f102479cf3a$export$cca61b45a785b3f0; });

var $7E7Dk = parcelRequire("7E7Dk");

var $9Wtn2 = parcelRequire("9Wtn2");

var $76MyM = parcelRequire("76MyM");
function $56150f102479cf3a$export$cca61b45a785b3f0({ className: className, style: style }) {
    const isMobileScreen = (0, $9Wtn2.useMediaPredicate)("(max-width: 576px)");
    if (isMobileScreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: 185,
        height: 18,
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        fill: "#000000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M182.327 16.085H175.888C174.418 16.085 173.215 14.882 173.215 13.4116V12.2754H174.752V13.4116C174.752 14.0354 175.264 14.5478 175.888 14.5478H182.327C182.95 14.5478 183.463 14.0354 183.463 13.4116V10.5822C183.463 9.95845 182.95 9.44605 182.327 9.44605H175.888C174.418 9.44605 173.215 8.24301 173.215 6.77264V4.32201C173.215 2.85164 174.418 1.6486 175.888 1.6486H182.327C183.797 1.6486 185 2.85164 185 4.32201V5.45821H183.463V4.32201C183.463 3.69822 182.95 3.18581 182.327 3.18581H175.888C175.264 3.18581 174.752 3.69822 174.752 4.32201V6.77264C174.752 7.39643 175.264 7.90884 175.888 7.90884H182.327C183.797 7.90884 185 9.11187 185 10.5822V13.4116C185 14.882 183.797 16.085 182.327 16.085ZM160.36 10.2704H167.935C169.405 10.2704 170.608 9.06732 170.608 7.59694V4.29974C170.608 2.82936 169.405 1.62632 167.935 1.62632H160.004C159.335 1.62632 158.801 2.16101 158.801 2.82936V16.1741H160.338V10.2704H160.36ZM160.36 3.16354H167.935C168.559 3.16354 169.071 3.67594 169.071 4.29974V7.57466C169.071 8.19846 168.559 8.71086 167.935 8.71086H160.36V3.16354ZM89.2696 16.085H87.5542L84.8808 10.2704H78.6205V16.1741H77.0833V2.82936C77.0833 2.16101 77.618 1.62632 78.2864 1.62632H86.2175C87.6879 1.62632 88.8909 2.82936 88.8909 4.29974V7.57466C88.8909 8.93365 87.8884 10.0476 86.5962 10.2258L89.2696 16.085ZM78.6205 8.71086H86.1952C86.819 8.71086 87.3314 8.19846 87.3314 7.57466V4.29974C87.3314 3.67594 86.819 3.16354 86.1952 3.16354H78.6205V8.71086ZM155.949 2.67341C155.949 2.13873 155.615 1.69316 155.102 1.53721C154.59 1.38126 154.055 1.55949 153.766 1.98278L149.176 8.48808L144.609 1.98278C144.297 1.55949 143.763 1.35898 143.273 1.53721C142.76 1.69316 142.426 2.16101 142.426 2.67341V16.085H143.963V3.76505L148.196 9.78022C148.419 10.0921 148.798 10.2926 149.176 10.2926C149.577 10.2926 149.934 10.0921 150.157 9.78022L154.389 3.74277V16.085H155.927V2.67341H155.949ZM117.207 3.16354V1.62632H107.271C106.602 1.62632 106.068 2.16101 106.068 2.82936V14.882C106.068 15.5503 106.602 16.085 107.271 16.085H117.207V14.5478H107.627V9.46833H115.202V7.93112H107.627V3.16354H117.207ZM103.26 14.882V9.89162C103.26 9.22326 102.726 8.68858 102.057 8.68858H96.6215V10.2258H101.723V14.5255H95.8195C94.2823 14.5255 93.0124 13.2779 93.0124 11.7184V5.97062C93.0124 4.43341 94.26 3.16354 95.8195 3.16354H103.461V1.62632H95.8195C93.4134 1.62632 91.4752 3.58683 91.4752 5.97062V11.7184C91.4752 14.1245 93.4357 16.0627 95.8195 16.0627H102.08C102.726 16.085 103.26 15.5281 103.26 14.882ZM44.49 14.5255H37.0713C35.5341 14.5255 34.2642 13.2779 34.2642 11.7184V5.97062C34.2642 4.43341 35.5118 3.16354 37.0713 3.16354H44.4677V1.62632H37.0713C34.6652 1.62632 32.727 3.58683 32.727 5.97062V11.7184C32.727 14.1245 34.6875 16.0627 37.0713 16.0627H44.49V14.5255ZM57.3669 1.53721V8.68858H48.4333V1.53721H46.8961V16.1741H48.4333V10.2258H57.3669V16.1741H58.9041V1.53721H57.3669ZM140.376 16.085H138.683L137.035 12.2977H129.415L127.767 16.085H126.074L132.111 2.20556C132.312 1.76 132.735 1.49265 133.225 1.49265C133.693 1.49265 134.138 1.78227 134.317 2.20556L140.376 16.085ZM136.366 10.7382L133.225 3.54227L130.084 10.7382H136.366ZM75.0337 16.085H73.3406L71.692 12.2977H64.0727L62.4241 16.085H60.7533L66.7907 2.20556C66.9689 1.76 67.4145 1.49265 67.8823 1.49265C68.3502 1.49265 68.7958 1.78227 68.974 2.20556L75.0337 16.085ZM71.0236 10.7382L67.8823 3.54227L64.7634 10.7382H71.0236ZM19.0035 10.5154C18.5579 9.75795 17.7782 9.31238 16.9316 9.33466C16.085 9.35693 15.3053 9.84706 14.9043 10.6268L12.32 15.6617C12.1417 16.0182 11.8298 16.1296 11.5848 16.1296C11.3397 16.1296 11.0278 15.9959 10.8496 15.6617L8.24302 10.6045C7.842 9.82478 7.08454 9.33466 6.23796 9.31238C5.39138 9.2901 4.58935 9.73567 4.16606 10.4931L0 17.6445H1.73772L5.45821 11.2506C5.61416 10.961 5.90378 10.805 6.1934 10.805C6.48302 10.805 6.77264 11.0055 6.90631 11.2729L9.51289 16.3524C9.9139 17.1544 10.7159 17.6445 11.5848 17.6445C12.4536 17.6445 13.2557 17.1544 13.6567 16.3524L16.241 11.2952C16.3969 11.0055 16.6643 10.8273 16.9539 10.8273H16.9762C17.2658 10.8273 17.5331 10.9833 17.6891 11.2506L21.3873 17.6445H23.125L19.0035 10.5154ZM13.5898 1.15848C13.1665 0.42329 12.4091 0 11.5625 0C10.7159 0 9.95845 0.445568 9.53516 1.15848L5.63644 7.90884H7.37416L10.8719 1.91594C11.0947 1.53721 11.4511 1.49265 11.5848 1.49265C11.7184 1.49265 12.0972 1.53721 12.2977 1.91594L15.7731 7.90884H17.5108L13.5898 1.15848Z"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: 225,
        height: 22,
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        fill: "#000000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M221.749 19.563h-7.831a3.26 3.26 0 0 1-3.251-3.252V14.93h1.869v1.381c0 .76.623 1.382 1.382 1.382h7.831c.758 0 1.381-.623 1.381-1.382v-3.44c0-.76-.623-1.383-1.381-1.383h-7.831a3.26 3.26 0 0 1-3.251-3.251v-2.98a3.26 3.26 0 0 1 3.251-3.252h7.831A3.26 3.26 0 0 1 225 5.257v1.381h-1.87V5.257c0-.76-.623-1.382-1.381-1.382h-7.831c-.759 0-1.382.623-1.382 1.381v2.981c0 .759.623 1.382 1.382 1.382h7.831A3.26 3.26 0 0 1 225 12.87v3.441a3.26 3.26 0 0 1-3.251 3.252Zm-26.716-7.072h9.212a3.26 3.26 0 0 0 3.251-3.251V5.23a3.26 3.26 0 0 0-3.251-3.252h-9.646c-.813 0-1.463.65-1.463 1.463v16.23h1.869v-7.18h.028Zm0-8.643h9.212c.759 0 1.382.623 1.382 1.381v3.983c0 .76-.623 1.382-1.382 1.382h-9.212V3.848Zm-86.462 15.715h-2.086l-3.252-7.072H95.62v7.18h-1.87V3.441c0-.813.65-1.463 1.463-1.463h9.646a3.262 3.262 0 0 1 3.252 3.251v3.983a3.248 3.248 0 0 1-2.791 3.225l3.251 7.126ZM95.62 10.594h9.212c.759 0 1.382-.623 1.382-1.382V5.23c0-.758-.623-1.381-1.382-1.381H95.62v6.746Zm94.048-7.343c0-.65-.407-1.192-1.03-1.381-.623-.19-1.273.027-1.626.541l-5.581 7.912-5.555-7.912c-.379-.514-1.03-.758-1.626-.541a1.446 1.446 0 0 0-1.029 1.381v16.312h1.869V4.579l5.148 7.316c.271.38.732.623 1.193.623.487 0 .921-.244 1.192-.623l5.148-7.343v15.01h1.87V3.253h.027Zm-47.119.597v-1.87h-12.085c-.813 0-1.463.65-1.463 1.463V18.1c0 .813.65 1.463 1.463 1.463h12.085v-1.87h-11.651v-6.178h9.212v-1.87h-9.212V3.849h11.651ZM125.587 18.1v-6.07c0-.813-.65-1.463-1.463-1.463h-6.611v1.87h6.204v5.23h-7.18a3.417 3.417 0 0 1-3.414-3.415v-6.99a3.417 3.417 0 0 1 3.414-3.414h9.294v-1.87h-9.294a5.29 5.29 0 0 0-5.283 5.284v6.99a5.29 5.29 0 0 0 5.283 5.284h7.614c.786.027 1.436-.65 1.436-1.436Zm-71.478-.434h-9.022a3.417 3.417 0 0 1-3.414-3.414v-6.99a3.417 3.417 0 0 1 3.414-3.414h8.995v-1.87h-8.995a5.29 5.29 0 0 0-5.284 5.284v6.99a5.29 5.29 0 0 0 5.284 5.284h9.022v-1.87ZM69.772 1.87v8.697H58.905V1.87h-1.87V19.67h1.87v-7.234h10.866v7.234h1.87V1.87h-1.87Zm100.957 17.693h-2.059l-2.005-4.606h-9.267l-2.005 4.606h-2.059l7.343-16.88a1.454 1.454 0 0 1 1.354-.868c.569 0 1.111.353 1.328.867l7.37 16.88Zm-4.877-6.503-3.821-8.752-3.82 8.752h7.641Zm-74.594 6.503h-2.059l-2.005-4.606h-9.267l-2.005 4.606H73.89l7.343-16.88c.217-.542.759-.868 1.328-.868.569 0 1.11.353 1.327.867l7.37 16.88ZM86.38 13.06l-3.82-8.752-3.794 8.752h7.614Zm-63.268-.271c-.542-.921-1.49-1.463-2.52-1.436a2.868 2.868 0 0 0-2.465 1.572l-3.143 6.123a.98.98 0 0 1-.894.57c-.299 0-.678-.163-.895-.57l-3.17-6.15c-.487-.949-1.409-1.545-2.438-1.572a2.801 2.801 0 0 0-2.52 1.436L0 21.459h2.113l4.525-7.776c.19-.352.542-.542.895-.542.352 0 .704.244.867.57l3.17 6.177a2.816 2.816 0 0 0 2.52 1.571 2.816 2.816 0 0 0 2.52-1.571l3.143-6.15c.19-.353.514-.57.867-.57h.027c.352 0 .677.19.867.515l4.498 7.776h2.113l-5.013-8.67Zm-6.584-11.38C16.013.515 15.092 0 14.063 0c-1.03 0-1.951.542-2.466 1.409l-4.742 8.21H8.97l4.254-7.289c.27-.46.704-.515.867-.515.162 0 .623.055.867.515l4.226 7.289h2.114l-4.769-8.21Z"
    }));
}

});
parcelRegister("9Wtn2", function(module, exports) {

var $7E7Dk = parcelRequire("7E7Dk");
function $73d0503396ce731c$var$fallbackMathMedia(query) {
    if (typeof matchMedia !== "function") return null;
    return matchMedia(query);
}
function $73d0503396ce731c$var$omitMatchMediaResult(matchMediaResult) {
    if (!matchMediaResult) return null;
    return {
        media: matchMediaResult.media,
        matches: matchMediaResult.matches
    };
}
function $73d0503396ce731c$var$useMedia(query) {
    var result = $7E7Dk.useState(function() {
        return $73d0503396ce731c$var$omitMatchMediaResult($73d0503396ce731c$var$fallbackMathMedia(query));
    });
    var setResult = result[1];
    var callback = $7E7Dk.useCallback(function(matchMediaResult) {
        return setResult($73d0503396ce731c$var$omitMatchMediaResult(matchMediaResult));
    }, [
        setResult
    ]);
    $7E7Dk.useEffect(function() {
        var matchMediaResult = $73d0503396ce731c$var$fallbackMathMedia(query);
        callback(matchMediaResult);
        matchMediaResult.addListener(callback);
        return function() {
            return matchMediaResult.removeListener(callback);
        };
    }, [
        callback,
        query
    ]);
    return result[0];
}
function $73d0503396ce731c$var$useMediaPredicate(query) {
    var result = $73d0503396ce731c$var$useMedia(query);
    return result && result.matches || false;
}
module.exports = {
    useMedia: $73d0503396ce731c$var$useMedia,
    useMediaPredicate: $73d0503396ce731c$var$useMediaPredicate
};

});



parcelRegister("lE9E6", function(module, exports) {
$parcel$export(module.exports, "LandingPageFooter", function () { return (parcelRequire("2cTiq")).LandingPageFooter; });
parcelRequire("2cTiq");

});
parcelRegister("2cTiq", function(module, exports) {

$parcel$export(module.exports, "LandingPageFooter", function () { return $b4936a9d61aecf03$export$fcdd7dd387921d9f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $b4936a9d61aecf03$var$SLink = (0, $gRonV.default).a`
    font-size: 16px;

    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.midDarkColor};
    }
`;
const $b4936a9d61aecf03$var$SFooter = (0, $gRonV.default).div`
    padding: 42px;
    display: flex;
    gap: 37px;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 576px) {
        padding: 15px;
        gap: 19px 35px;
    }
`;
const $b4936a9d61aecf03$var$SCopyright = (0, $gRonV.default).span`
    font-weight: var(--font-weight-light);
    font-size: 16px;
`;
function $b4936a9d61aecf03$export$fcdd7dd387921d9f({ dark: dark, className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b4936a9d61aecf03$var$SFooter, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b4936a9d61aecf03$var$SCopyright, {
        "data-testid": "copyright"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblCopyright"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b4936a9d61aecf03$var$SLink, {
        href: `https://www.chargeamps.com/${text("linkLegal")}`,
        target: "_blank",
        rel: "noopener noreferrer",
        dark: dark,
        "data-testid": "termsOfService"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblTermsOfService"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b4936a9d61aecf03$var$SLink, {
        href: `https://www.chargeamps.com/${text("linkSupport")}`,
        target: "_blank",
        rel: "noopener noreferrer",
        dark: dark,
        "data-testid": "linkSupport"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lbllinkSupport"
    })));
}

});
parcelRegister("igvrl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $437e76872af531be$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $502r5 = parcelRequire("502r5");

var $gancV = parcelRequire("gancV");
function $437e76872af531be$export$2e2bcd8739ae039({ code: code, values: values }) {
    const memoValues = (0, $7E7Dk.useMemo)(()=>(0, $gancV.default)(values), [
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $502r5.default), {
        id: code,
        values: memoValues
    });
}

});
parcelRegister("502r5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a3ed788bb2487f1$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $533Ow = parcelRequire("533Ow");

var $7E7Dk = parcelRequire("7E7Dk");

var $6BXTl = parcelRequire("6BXTl");

var $cfMpI = parcelRequire("cfMpI");
function $3a3ed788bb2487f1$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $533Ow.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $533Ow.__rest)(nextProps, [
        "values"
    ]);
    return (0, $cfMpI.shallowEqual)(nextValues, values) && (0, $cfMpI.shallowEqual)(otherProps, nextOtherProps);
}
function $3a3ed788bb2487f1$var$FormattedMessage(props) {
    var intl = (0, $6BXTl.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $7E7Dk.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $7E7Dk.createElement(Component, null, $7E7Dk.Children.toArray(nodes));
    return $7E7Dk.createElement($7E7Dk.Fragment, null, nodes);
}
$3a3ed788bb2487f1$var$FormattedMessage.displayName = "FormattedMessage";
var $3a3ed788bb2487f1$var$MemoizedFormattedMessage = $7E7Dk.memo($3a3ed788bb2487f1$var$FormattedMessage, $3a3ed788bb2487f1$var$areEqual);
$3a3ed788bb2487f1$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $3a3ed788bb2487f1$export$2e2bcd8739ae039 = $3a3ed788bb2487f1$var$MemoizedFormattedMessage;

});

parcelRegister("gancV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f74542bbc3eb5c3$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
const $7f74542bbc3eb5c3$var$patchLocalizationValues = (values = {})=>({
        ...values,
        p: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {}, chunks),
        span: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {}, chunks),
        div: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {}, chunks),
        b: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("b", {}, chunks),
        i: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {}, chunks),
        strong: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("strong", {}, chunks),
        em: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("em", {}, chunks),
        small: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {}, chunks),
        u: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("u", {}, chunks),
        br: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("br", {}),
        ul: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("ul", {}, chunks),
        li: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("li", {}, chunks),
        ...values.link && {
            link: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("a", values.link, chunks)
        },
        ...values.link2 && {
            link2: (chunks)=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("a", values.link2, chunks)
        }
    });
var $7f74542bbc3eb5c3$export$2e2bcd8739ae039 = $7f74542bbc3eb5c3$var$patchLocalizationValues;

});




parcelRegister("8tfTg", function(module, exports) {
$parcel$export(module.exports, "LanguageSelectDrawer", function () { return (parcelRequire("28PgI")).LanguageSelectDrawer; });
parcelRequire("28PgI");

});
parcelRegister("28PgI", function(module, exports) {

$parcel$export(module.exports, "LanguageSelectDrawer", function () { return $554e3782f1c8cd25$export$4014a796383bff0f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("hyFRo");
var $gRg4a = parcelRequire("gRg4a");

var $43ttK = parcelRequire("43ttK");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");
parcelRequire("htz5i");
var $e6Hwq = parcelRequire("e6Hwq");
parcelRequire("aLIw2");
var $4GCPM = parcelRequire("4GCPM");
const $554e3782f1c8cd25$var$Wrapper = (0, $gRonV.default).div`
    color: ${({ isOpen: isOpen, dark: dark, theme: theme })=>{
    if (!isOpen && !dark) return theme.font.darkestColor;
    if (dark && isOpen) return theme.font.darkestColor;
    return theme.font.lightestColor;
}};
`;
const $554e3782f1c8cd25$var$SelectText = (0, $gRonV.default).div`
    font-size: 16px;
    padding-top: 4px;
`;
const $554e3782f1c8cd25$var$SelectButton = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: absolute;
    z-index: 9000;
    right: 46px;
    top: 51px;

    svg {
        transition: transform 0.2s;
        transform: rotate(${(p)=>p.rotation ? "180deg" : "0deg"});
    }

    &:hover {
        cursor: pointer;
    }

    @media (max-width: 576px) {
        top: 31px;
        right: 10px;
    }
`;
const $554e3782f1c8cd25$var$LanguageWrapper = (0, $gRonV.default).div`
    font-size: 16px;
    transition: all 0.2s ease;
    text-transform: capitalize;

    &:hover {
        cursor: pointer;
        color: ${({ theme: theme })=>theme.font.successColor};
    }
`;
function $554e3782f1c8cd25$export$4014a796383bff0f({ className: className, style: style, dark: dark = false }) {
    const { locale: locale, setLocale: setLocale } = (0, $4GCPM.useLocalizationContext)();
    const [openDrawer, setOpenDrawer] = (0, $7E7Dk.useState)(false);
    const drawerRef = (0, $7E7Dk.useRef)(null);
    (0, $43ttK.default)(drawerRef, ()=>setOpenDrawer(false));
    const changeLanguage = (l)=>{
        setLocale(l);
        setOpenDrawer(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($554e3782f1c8cd25$var$Wrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        ref: drawerRef,
        isOpen: openDrawer,
        dark: dark
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($554e3782f1c8cd25$var$SelectButton, {
        onClick: ()=>setOpenDrawer(!openDrawer),
        rotation: !openDrawer,
        "data-testid": "languageSelector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($554e3782f1c8cd25$var$SelectText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, locale.toUpperCase())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gRg4a.ArrowIcon), {
        color: (0, $3CLIQ.theme).font.successColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e6Hwq.Drawer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            open: openDrawer
        }),
        dark: dark
    }, Object.keys((0, $4GCPM.AVAILABLE_LANGUAGES_LOCAL)).filter((l)=>l !== locale).map((l, i)=>{
        const lang = (0, $4GCPM.AVAILABLE_LANGUAGES_LOCAL)[l] ?? l;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($554e3782f1c8cd25$var$LanguageWrapper, {
            key: i,
            onClick: ()=>changeLanguage(l),
            "data-testid": l
        }, lang);
    })));
}

});
parcelRegister("hyFRo", function(module, exports) {
$parcel$export(module.exports, "ArrowIcon", function () { return (parcelRequire("gRg4a")).ArrowIcon; });
parcelRequire("gRg4a");

});
parcelRegister("gRg4a", function(module, exports) {

$parcel$export(module.exports, "ArrowIcon", function () { return $8a7d810a3325efaa$export$26b09f677ead9482; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $8a7d810a3325efaa$export$26b09f677ead9482({ className: className, style: style, width: width = 20, height: height = 8, color: color = "#81E18B", ["data-testid"]: dataTestid = "arrow-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": dataTestid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M0.340034 8L7.17003 1.17C7.93003 0.420001 8.93003 9.38046e-07 10 8.44504e-07C11.07 7.50962e-07 12.07 0.420001 12.83 1.17L19.66 8L16.82 8L11.41 2.59C10.66 1.83 9.34003 1.83 8.59003 2.59L3.18003 8L0.340034 8Z",
        fill: color
    }));
}

});


parcelRegister("43ttK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba3446b343d32c8c$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
const $ba3446b343d32c8c$var$useOnClickOutside = (ref, handler)=>{
    (0, $7E7Dk.useEffect)(()=>{
        const listener = (event)=>{
            const elements = ref.current && (ref.current instanceof Array ? ref.current : [
                ref.current
            ]) || [];
            const clickedOnRef = elements.filter(Boolean).some((element)=>element?.contains(event.target));
            // Do nothing if clicking ref's element or descendent elements
            if (clickedOnRef) return;
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add refOrFilterFn and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler
    ]);
};
var $ba3446b343d32c8c$export$2e2bcd8739ae039 = $ba3446b343d32c8c$var$useOnClickOutside;

});

parcelRegister("htz5i", function(module, exports) {
$parcel$export(module.exports, "Drawer", function () { return (parcelRequire("e6Hwq")).Drawer; });
parcelRequire("e6Hwq");

});
parcelRegister("e6Hwq", function(module, exports) {

$parcel$export(module.exports, "Drawer", function () { return $d9b7d138f9579d6b$export$4071300121a182f5; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
const $d9b7d138f9579d6b$var$SDrawer = (0, $gRonV.default).div`
    transform: translate(0, 0);
    background-color: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.darkestColor};
    color: ${({ theme: theme, dark: dark })=>dark ? theme.font.darkestColor : theme.font.lightestColor};
    letter-spacing: 1%;

    position: fixed;
    z-index: 1040;
    top: 0;
    height: 100%;
    width: 240px;
    right: -240px;
    overflow-x: hidden;
    transition: right 0.25s ease-in-out;

    padding: 120px 30px;

    &.open {
        right: 0;
        transition: right 0.25s ease-in-out;
        overflow-y: hidden;
    }

    display: flex;
    flex-direction: column;
    gap: 18px;
`;
const $d9b7d138f9579d6b$export$4071300121a182f5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function Drawer({ children: children, className: className, style: style, dark: dark = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($d9b7d138f9579d6b$var$SDrawer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        dark: dark,
        "data-testid": "drawer"
    }, children);
});

});






parcelRegister("dXhIC", function(module, exports) {
$parcel$export(module.exports, "formatValidationErrorData", function () { return (parcelRequire("g4tUM")).formatValidationErrorData; });
$parcel$export(module.exports, "SignInForm", function () { return (parcelRequire("g4tUM")).SignInForm; });
parcelRequire("g4tUM");

});
parcelRegister("g4tUM", function(module, exports) {

$parcel$export(module.exports, "formatValidationErrorData", function () { return $89f2a42b8b4965f8$export$d9dd8b31dacabee; });
$parcel$export(module.exports, "SignInForm", function () { return $89f2a42b8b4965f8$export$88eb1f631f57c0a6; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
parcelRequire("7FGDK");
var $Gcg6o = parcelRequire("Gcg6o");
var $jpUpC = parcelRequire("jpUpC");

var $76MyM = parcelRequire("76MyM");
parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");
var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");
parcelRequire("7FZyo");
var $h1Lwc = parcelRequire("h1Lwc");
parcelRequire("3T14g");
var $aQa4T = parcelRequire("aQa4T");
parcelRequire("aBfUs");
var $1SJYY = parcelRequire("1SJYY");

var $fIpd8 = parcelRequire("fIpd8");
parcelRequire("ikjch");
var $57xxf = parcelRequire("57xxf");

var $1sDHO = parcelRequire("1sDHO");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aLIw2");
var $4GCPM = parcelRequire("4GCPM");

var $j1Rmu = parcelRequire("j1Rmu");
const $89f2a42b8b4965f8$var$SRow = (0, $gRonV.default).div`
    display: flex;
    justify-content: space-between;
`;
const $89f2a42b8b4965f8$var$SSignUpButton = (0, $gRonV.default).div`
    &:hover {
        cursor: pointer;
    }
`;
const $89f2a42b8b4965f8$var$SForgotPassword = (0, $gRonV.default).div`
    margin-left: auto;
`;
const $89f2a42b8b4965f8$var$SForgotPasswordLink = (0, $gRonV.default).span`
    color: #000;
    cursor: pointer;
    font-weight: var(--font-weight-extra-light);
`;
function $89f2a42b8b4965f8$export$d9dd8b31dacabee(errors, initialErrorData) {
    let errorData = initialErrorData;
    for (const err of errors.inner)if (err.path) errorData = {
        ...errorData,
        [err.path]: err.message
    };
    return errorData;
}
const $89f2a42b8b4965f8$var$initData = {
    email: "",
    password: ""
};
function $89f2a42b8b4965f8$export$88eb1f631f57c0a6() {
    const text = (0, $5u6k9.default)();
    const portal = (0, $fIpd8.getPortalState)(window.location.pathname);
    const routerLocation = (0, $4AX6R.useLocation)();
    const { locale: locale, setLocale: setLocale } = (0, $4GCPM.useLocalizationContext)();
    const from = routerLocation?.state?.from || "/";
    const navigate = (0, $4AX6R.useNavigate)();
    const [searchParams] = (0, $3um4r.useSearchParams)();
    const [submitError, setSubmitError] = (0, $7E7Dk.useState)("");
    const [showPassword, toggleShowPassword] = (0, $7E7Dk.useState)(false);
    const [formData, setFormData] = (0, $7E7Dk.useState)(()=>$89f2a42b8b4965f8$var$initData);
    const [formErrors, setFormErrors] = (0, $7E7Dk.useState)(()=>$89f2a42b8b4965f8$var$initData);
    const [notification, setNotification] = (0, $7E7Dk.useState)((0, $1sDHO.default).getItem("notification"));
    (0, $7E7Dk.useEffect)(()=>{
        (0, $1sDHO.default).removeItem("notification");
    }, []);
    const credentialsSchema = $Gcg6o.create().shape({
        email: $jpUpC.create().email(text("msgEmailFormatIsIncorrect")).required(text("msgEmailIsRequired")),
        password: $jpUpC.create().required(text("msgPasswordRequiredsignin"))
    });
    const showForgotPassword = !portal.isSupportDomain;
    const [verifyEmail] = (0, $1O9Jh.useAuthVerifyEmailMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        const token = searchParams?.get("token");
        if (token) verifyEmail({
            token: token
        }).unwrap().then(()=>{
            setNotification({
                text: "msgEmailVerified",
                type: "notice"
            });
        }).catch(()=>{
            setNotification({
                text: "msgEmailVerifiedFailed",
                type: "alert"
            });
        });
    }, [
        searchParams,
        verifyEmail
    ]);
    const { loading: loading, submitLogin: submitLogin } = (0, $j1Rmu.usePortalLoginFlow)({
        from: from,
        locale: locale,
        setLocale: setLocale,
        setNotification: setNotification,
        navigate: navigate
    });
    const handleSubmit = (event)=>{
        event.preventDefault();
        const fields = new FormData(event.currentTarget);
        const credentials = {
            email: String(fields.get("email") ?? ""),
            password: String(fields.get("password") ?? "")
        };
        setFormData(credentials);
        setNotification(null);
        setSubmitError("");
        credentialsSchema.validate(credentials, {
            abortEarly: false
        }).then(async ()=>{
            setFormErrors(()=>$89f2a42b8b4965f8$var$initData);
            const errorMessage = await submitLogin(credentials);
            if (errorMessage) setSubmitError(errorMessage);
        }).catch((error)=>{
            setFormErrors(()=>$89f2a42b8b4965f8$export$d9dd8b31dacabee(error, $89f2a42b8b4965f8$var$initData) || $89f2a42b8b4965f8$var$initData);
        });
    };
    const changeFormData = (value, parameterName)=>{
        setFormData((prev)=>({
                ...prev,
                [parameterName]: value
            }));
        setFormErrors((prev)=>({
                ...prev,
                [parameterName]: ""
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SContentWrapper), null, submitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SNotification), {
        "data-testid": "signInError",
        error: submitError !== ""
    }, submitError)), notification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SNotification), {
        error: notification?.type === "alert",
        "data-testid": "notification"
    }, text(notification.text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $h1Lwc.FormHeader), {
        inverted: portal.isSupportDomain,
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aQa4T.InputGroup), {
        label: formData.email.length > 0 ? text("lblEmail") : "",
        errorTestId: "signInEmailErrorMsg",
        errorMsg: formErrors.email,
        inverted: portal.isSupportDomain
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aQa4T.SInput), {
        inverted: portal.isSupportDomain,
        "data-testid": "emailInput",
        type: "email",
        name: "email",
        autoComplete: "username",
        placeholder: text("lblEmail"),
        onChange: (event)=>changeFormData(event.currentTarget.value, "email"),
        autoFocus: true,
        formNoValidate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $57xxf.PasswordInput), {
        name: "password",
        autoComplete: "current-password",
        label: formData.password.length > 0 ? text("lblPassword") : "",
        placeholder: text("lblPassword"),
        onChange: (value)=>changeFormData(value, "password"),
        showPassword: showPassword,
        error: formErrors.password,
        errorTestId: "signInPasswordErrorMsg",
        toggleShowPasswordFlag: toggleShowPassword,
        hasText: formData.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1SJYY.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        loading: loading,
        label: text("lblSignIn"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("sign-in-btn", "w-full"),
        "data-testid": "submitButton",
        type: "submit",
        icon: "pi pi-arrow-right pi-icon-green",
        iconPos: "right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($89f2a42b8b4965f8$var$SRow, null, (portal.isUserappDomain || portal.isPartnerDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($89f2a42b8b4965f8$var$SSignUpButton, {
        onClick: ()=>navigate(portal.isPartnerDomain ? "/register-partner" : "/register-user", {
                replace: true
            }),
        "data-testid": "signUpBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSignUp"
    })), showForgotPassword && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($89f2a42b8b4965f8$var$SForgotPassword, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($89f2a42b8b4965f8$var$SForgotPasswordLink, {
        onClick: ()=>navigate(`/reset-password-request`, {
                replace: true
            }),
        "data-testid": "forgotPasswordBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblForgotPassword"
    }))))));
}

});
parcelRegister("7FGDK", function(module, exports) {

$parcel$export(module.exports, "addMethod", function () { return $595d703265a00eae$export$20be359f745f973c; });
$parcel$export(module.exports, "mixed", function () { return (parcelRequire("hxRCq")).create; });
$parcel$export(module.exports, "boolean", function () { return (parcelRequire("kBMQz")).create; });
$parcel$export(module.exports, "string", function () { return (parcelRequire("jpUpC")).create; });
$parcel$export(module.exports, "number", function () { return (parcelRequire("bTUek")).create; });
$parcel$export(module.exports, "date", function () { return (parcelRequire("a4Jo5")).create; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("Gcg6o")).create; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("eQuBt")).create; });
$parcel$export(module.exports, "ValidationError", function () { return (parcelRequire("kRWYd")).default; });

var $hxRCq = parcelRequire("hxRCq");

var $kBMQz = parcelRequire("kBMQz");

var $jpUpC = parcelRequire("jpUpC");

var $bTUek = parcelRequire("bTUek");

var $a4Jo5 = parcelRequire("a4Jo5");

var $Gcg6o = parcelRequire("Gcg6o");

var $7GPfT = parcelRequire("7GPfT");

var $eQuBt = parcelRequire("eQuBt");

var $ivNSw = parcelRequire("ivNSw");

var $kRWYd = parcelRequire("kRWYd");

var $fabHC = parcelRequire("fabHC");

var $2QGDu = parcelRequire("2QGDu");

var $26JeK = parcelRequire("26JeK");

var $juS8c = parcelRequire("juS8c");
function $595d703265a00eae$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $2QGDu.default)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("hxRCq", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $cc5f1c4a6d3bffb9$export$185802fd694ee1f5; });

var $juS8c = parcelRequire("juS8c");
const $cc5f1c4a6d3bffb9$var$Mixed = (0, $juS8c.default);
var $cc5f1c4a6d3bffb9$export$2e2bcd8739ae039 = $cc5f1c4a6d3bffb9$var$Mixed;
function $cc5f1c4a6d3bffb9$export$185802fd694ee1f5() {
    return new $cc5f1c4a6d3bffb9$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$cc5f1c4a6d3bffb9$export$185802fd694ee1f5.prototype = $cc5f1c4a6d3bffb9$var$Mixed.prototype;

});
parcelRegister("juS8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e31acf06a1029751$export$2e2bcd8739ae039; });

var $l0bAT = parcelRequire("l0bAT");

var $fks50 = parcelRequire("fks50");

var $8qIYK = parcelRequire("8qIYK");

var $9JjUv = parcelRequire("9JjUv");

var $5aFP1 = parcelRequire("5aFP1");

var $5LXSO = parcelRequire("5LXSO");

var $eQuBt = parcelRequire("eQuBt");

var $fabHC = parcelRequire("fabHC");

var $kRWYd = parcelRequire("kRWYd");

var $K5raW = parcelRequire("K5raW");

var $9Q7ea = parcelRequire("9Q7ea");
function $e31acf06a1029751$var$_extends() {
    $e31acf06a1029751$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e31acf06a1029751$var$_extends.apply(this, arguments);
}
class $e31acf06a1029751$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $K5raW.default)();
        this._blacklist = new (0, $K5raW.default)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $fks50.mixed).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $e31acf06a1029751$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $e31acf06a1029751$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $l0bAT.default)($e31acf06a1029751$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $e31acf06a1029751$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($e31acf06a1029751$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $5LXSO.default)(value);
            let formattedResult = (0, $5LXSO.default)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $e31acf06a1029751$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $9JjUv.default)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $9JjUv.default)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($e31acf06a1029751$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($e31acf06a1029751$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $e31acf06a1029751$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $kRWYd.default).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $kRWYd.default).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $l0bAT.default)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $fks50.mixed).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $fks50.mixed).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $fks50.mixed).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $5aFP1.default)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $9Q7ea.default)(keys).map((key)=>new (0, $eQuBt.default)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $8qIYK.default)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $5aFP1.default)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $fks50.mixed).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $5aFP1.default)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $fks50.mixed).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $5aFP1.default)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$e31acf06a1029751$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$e31acf06a1029751$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $fabHC.getIn)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $e31acf06a1029751$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$e31acf06a1029751$export$2e2bcd8739ae039.prototype[alias] = $e31acf06a1029751$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$e31acf06a1029751$export$2e2bcd8739ae039.prototype[alias] = $e31acf06a1029751$export$2e2bcd8739ae039.prototype.notOneOf;
$e31acf06a1029751$export$2e2bcd8739ae039.prototype.optional = $e31acf06a1029751$export$2e2bcd8739ae039.prototype.notRequired;

});
parcelRegister("l0bAT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4a29766271e60ec$export$2e2bcd8739ae039; });
// ES6 Map
var $f4a29766271e60ec$var$map;
try {
    $f4a29766271e60ec$var$map = Map;
} catch (_) {}
var $f4a29766271e60ec$var$set;
// ES6 Set
try {
    $f4a29766271e60ec$var$set = Set;
} catch (_) {}
function $f4a29766271e60ec$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($f4a29766271e60ec$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($f4a29766271e60ec$var$map && src instanceof $f4a29766271e60ec$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($f4a29766271e60ec$var$set && src instanceof $f4a29766271e60ec$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $f4a29766271e60ec$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $f4a29766271e60ec$export$2e2bcd8739ae039(src) {
    return $f4a29766271e60ec$var$baseClone(src, [], []);
}

});

parcelRegister("fks50", function(module, exports) {

$parcel$export(module.exports, "mixed", function () { return $b28e815785133d38$export$9b30b6294c1449a8; });
$parcel$export(module.exports, "string", function () { return $b28e815785133d38$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $b28e815785133d38$export$98e628dec113755e; });
$parcel$export(module.exports, "date", function () { return $b28e815785133d38$export$324d90190a8b822a; });
$parcel$export(module.exports, "boolean", function () { return $b28e815785133d38$export$4a21f16c33752377; });
$parcel$export(module.exports, "object", function () { return $b28e815785133d38$export$be5493f9613cbbe; });
$parcel$export(module.exports, "array", function () { return $b28e815785133d38$export$2f23118c22fb2630; });
$parcel$export(module.exports, "default", function () { return $b28e815785133d38$export$2e2bcd8739ae039; });

var $5LXSO = parcelRequire("5LXSO");
let $b28e815785133d38$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $5LXSO.default)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $5LXSO.default)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $b28e815785133d38$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $b28e815785133d38$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $b28e815785133d38$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $b28e815785133d38$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $b28e815785133d38$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $b28e815785133d38$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $b28e815785133d38$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $b28e815785133d38$export$9b30b6294c1449a8,
    string: $b28e815785133d38$export$22b082955e083ec3,
    number: $b28e815785133d38$export$98e628dec113755e,
    date: $b28e815785133d38$export$324d90190a8b822a,
    object: $b28e815785133d38$export$be5493f9613cbbe,
    array: $b28e815785133d38$export$2f23118c22fb2630,
    boolean: $b28e815785133d38$export$4a21f16c33752377
});

});
parcelRegister("5LXSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $433fcb0b6029979b$export$2e2bcd8739ae039; });
const $433fcb0b6029979b$var$toString = Object.prototype.toString;
const $433fcb0b6029979b$var$errorToString = Error.prototype.toString;
const $433fcb0b6029979b$var$regExpToString = RegExp.prototype.toString;
const $433fcb0b6029979b$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $433fcb0b6029979b$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $433fcb0b6029979b$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $433fcb0b6029979b$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $433fcb0b6029979b$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $433fcb0b6029979b$var$symbolToString.call(val).replace($433fcb0b6029979b$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $433fcb0b6029979b$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $433fcb0b6029979b$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $433fcb0b6029979b$var$regExpToString.call(val);
    return null;
}
function $433fcb0b6029979b$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $433fcb0b6029979b$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $433fcb0b6029979b$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}

});


parcelRegister("8qIYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6233a44730a962fb$export$2e2bcd8739ae039; });

var $gAMvg = parcelRequire("gAMvg");

var $2QGDu = parcelRequire("2QGDu");
class $6233a44730a962fb$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gAMvg)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $2QGDu.default)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $6233a44730a962fb$export$2e2bcd8739ae039 = $6233a44730a962fb$var$Condition;

});
parcelRegister("gAMvg", function(module, exports) {

var $e3hp3 = parcelRequire("e3hp3");

var $7dagH = parcelRequire("7dagH");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $c145a1e1d05553fa$var$has(object, path) {
    return object != null && $7dagH(object, path, $e3hp3);
}
module.exports = $c145a1e1d05553fa$var$has;

});
parcelRegister("e3hp3", function(module, exports) {
/** Used for built-in method references. */ var $a3aed867d3d6c5c6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a3aed867d3d6c5c6$var$hasOwnProperty = $a3aed867d3d6c5c6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a3aed867d3d6c5c6$var$baseHas(object, key) {
    return object != null && $a3aed867d3d6c5c6$var$hasOwnProperty.call(object, key);
}
module.exports = $a3aed867d3d6c5c6$var$baseHas;

});

parcelRegister("7dagH", function(module, exports) {

var $ghLpj = parcelRequire("ghLpj");

var $142qw = parcelRequire("142qw");

var $cCHmB = parcelRequire("cCHmB");

var $bNaPK = parcelRequire("bNaPK");

var $4HWBA = parcelRequire("4HWBA");

var $hBTdo = parcelRequire("hBTdo");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $5401b65c36c6dc34$var$hasPath(object, path, hasFunc) {
    path = $ghLpj(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $hBTdo(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $4HWBA(length) && $bNaPK(key, length) && ($cCHmB(object) || $142qw(object));
}
module.exports = $5401b65c36c6dc34$var$hasPath;

});
parcelRegister("ghLpj", function(module, exports) {

var $cCHmB = parcelRequire("cCHmB");

var $b78Hk = parcelRequire("b78Hk");

var $gfH3V = parcelRequire("gfH3V");

var $1ZPOa = parcelRequire("1ZPOa");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $bdb301fb3bf87d90$var$castPath(value, object) {
    if ($cCHmB(value)) return value;
    return $b78Hk(value, object) ? [
        value
    ] : $gfH3V($1ZPOa(value));
}
module.exports = $bdb301fb3bf87d90$var$castPath;

});
parcelRegister("cCHmB", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $930aabbbb9c59589$var$isArray = Array.isArray;
module.exports = $930aabbbb9c59589$var$isArray;

});

parcelRegister("b78Hk", function(module, exports) {

var $cCHmB = parcelRequire("cCHmB");

var $3oRSI = parcelRequire("3oRSI");
/** Used to match property names within property paths. */ var $8177186462f45934$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $8177186462f45934$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $8177186462f45934$var$isKey(value, object) {
    if ($cCHmB(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $3oRSI(value)) return true;
    return $8177186462f45934$var$reIsPlainProp.test(value) || !$8177186462f45934$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $8177186462f45934$var$isKey;

});
parcelRegister("3oRSI", function(module, exports) {

var $j74ic = parcelRequire("j74ic");

var $75jXw = parcelRequire("75jXw");
/** `Object#toString` result references. */ var $279d68bc5330abb3$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $279d68bc5330abb3$var$isSymbol(value) {
    return typeof value == "symbol" || $75jXw(value) && $j74ic(value) == $279d68bc5330abb3$var$symbolTag;
}
module.exports = $279d68bc5330abb3$var$isSymbol;

});
parcelRegister("j74ic", function(module, exports) {

var $kj9as = parcelRequire("kj9as");

var $hIrIw = parcelRequire("hIrIw");

var $8s8pc = parcelRequire("8s8pc");
/** `Object#toString` result references. */ var $dea20030bb11acdb$var$nullTag = "[object Null]", $dea20030bb11acdb$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $dea20030bb11acdb$var$symToStringTag = $kj9as ? $kj9as.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $dea20030bb11acdb$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $dea20030bb11acdb$var$undefinedTag : $dea20030bb11acdb$var$nullTag;
    return $dea20030bb11acdb$var$symToStringTag && $dea20030bb11acdb$var$symToStringTag in Object(value) ? $hIrIw(value) : $8s8pc(value);
}
module.exports = $dea20030bb11acdb$var$baseGetTag;

});
parcelRegister("kj9as", function(module, exports) {

var $chdtz = parcelRequire("chdtz");
/** Built-in value references. */ var $ec8cb181f007cd68$var$Symbol = $chdtz.Symbol;
module.exports = $ec8cb181f007cd68$var$Symbol;

});
parcelRegister("chdtz", function(module, exports) {

var $kkYOp = parcelRequire("kkYOp");
/** Detect free variable `self`. */ var $8f01869f01e43c2d$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8f01869f01e43c2d$var$root = $kkYOp || $8f01869f01e43c2d$var$freeSelf || Function("return this")();
module.exports = $8f01869f01e43c2d$var$root;

});
parcelRegister("kkYOp", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ece4d8ef38b43cfb$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ece4d8ef38b43cfb$var$freeGlobal;

});



parcelRegister("hIrIw", function(module, exports) {

var $kj9as = parcelRequire("kj9as");
/** Used for built-in method references. */ var $ce5c0bbf78937e2c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ce5c0bbf78937e2c$var$hasOwnProperty = $ce5c0bbf78937e2c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ce5c0bbf78937e2c$var$nativeObjectToString = $ce5c0bbf78937e2c$var$objectProto.toString;
/** Built-in value references. */ var $ce5c0bbf78937e2c$var$symToStringTag = $kj9as ? $kj9as.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $ce5c0bbf78937e2c$var$getRawTag(value) {
    var isOwn = $ce5c0bbf78937e2c$var$hasOwnProperty.call(value, $ce5c0bbf78937e2c$var$symToStringTag), tag = value[$ce5c0bbf78937e2c$var$symToStringTag];
    try {
        value[$ce5c0bbf78937e2c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $ce5c0bbf78937e2c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$ce5c0bbf78937e2c$var$symToStringTag] = tag;
        else delete value[$ce5c0bbf78937e2c$var$symToStringTag];
    }
    return result;
}
module.exports = $ce5c0bbf78937e2c$var$getRawTag;

});

parcelRegister("8s8pc", function(module, exports) {
/** Used for built-in method references. */ var $627775626bbb4c96$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $627775626bbb4c96$var$nativeObjectToString = $627775626bbb4c96$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $627775626bbb4c96$var$objectToString(value) {
    return $627775626bbb4c96$var$nativeObjectToString.call(value);
}
module.exports = $627775626bbb4c96$var$objectToString;

});


parcelRegister("75jXw", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $52887b79e32ca46d$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $52887b79e32ca46d$var$isObjectLike;

});



parcelRegister("gfH3V", function(module, exports) {

var $9Oskx = parcelRequire("9Oskx");
/** Used to match property names within property paths. */ var $bd4f73566251916e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $bd4f73566251916e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $bd4f73566251916e$var$stringToPath = $9Oskx(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($bd4f73566251916e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($bd4f73566251916e$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $bd4f73566251916e$var$stringToPath;

});
parcelRegister("9Oskx", function(module, exports) {

var $lfUtm = parcelRequire("lfUtm");
/** Used as the maximum memoize cache size. */ var $724ec25ac82000c3$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $724ec25ac82000c3$var$memoizeCapped(func) {
    var result = $lfUtm(func, function(key) {
        if (cache.size === $724ec25ac82000c3$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $724ec25ac82000c3$var$memoizeCapped;

});
parcelRegister("lfUtm", function(module, exports) {

var $9t69A = parcelRequire("9t69A");
/** Error message constants. */ var $f796cdf1613b249b$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f796cdf1613b249b$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($f796cdf1613b249b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f796cdf1613b249b$var$memoize.Cache || $9t69A);
    return memoized;
}
// Expose `MapCache`.
$f796cdf1613b249b$var$memoize.Cache = $9t69A;
module.exports = $f796cdf1613b249b$var$memoize;

});
parcelRegister("9t69A", function(module, exports) {

var $5Gh5O = parcelRequire("5Gh5O");

var $dQxMP = parcelRequire("dQxMP");

var $27Cef = parcelRequire("27Cef");

var $Tg3Sv = parcelRequire("Tg3Sv");

var $fpkaW = parcelRequire("fpkaW");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6e4b987f1196fa89$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$6e4b987f1196fa89$var$MapCache.prototype.clear = $5Gh5O;
$6e4b987f1196fa89$var$MapCache.prototype["delete"] = $dQxMP;
$6e4b987f1196fa89$var$MapCache.prototype.get = $27Cef;
$6e4b987f1196fa89$var$MapCache.prototype.has = $Tg3Sv;
$6e4b987f1196fa89$var$MapCache.prototype.set = $fpkaW;
module.exports = $6e4b987f1196fa89$var$MapCache;

});
parcelRegister("5Gh5O", function(module, exports) {

var $fFwOT = parcelRequire("fFwOT");

var $cp2ZN = parcelRequire("cp2ZN");

var $3c5C8 = parcelRequire("3c5C8");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $422e223db899e06e$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $fFwOT,
        "map": new ($3c5C8 || $cp2ZN),
        "string": new $fFwOT
    };
}
module.exports = $422e223db899e06e$var$mapCacheClear;

});
parcelRegister("fFwOT", function(module, exports) {

var $iD3fe = parcelRequire("iD3fe");

var $ledCv = parcelRequire("ledCv");

var $bVWFD = parcelRequire("bVWFD");

var $ih65g = parcelRequire("ih65g");

var $7yFh6 = parcelRequire("7yFh6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b68424b0efe5d13a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$b68424b0efe5d13a$var$Hash.prototype.clear = $iD3fe;
$b68424b0efe5d13a$var$Hash.prototype["delete"] = $ledCv;
$b68424b0efe5d13a$var$Hash.prototype.get = $bVWFD;
$b68424b0efe5d13a$var$Hash.prototype.has = $ih65g;
$b68424b0efe5d13a$var$Hash.prototype.set = $7yFh6;
module.exports = $b68424b0efe5d13a$var$Hash;

});
parcelRegister("iD3fe", function(module, exports) {

var $3KMlh = parcelRequire("3KMlh");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $d8fe62d7b235015d$var$hashClear() {
    this.__data__ = $3KMlh ? $3KMlh(null) : {};
    this.size = 0;
}
module.exports = $d8fe62d7b235015d$var$hashClear;

});
parcelRegister("3KMlh", function(module, exports) {

var $53M2G = parcelRequire("53M2G");
/* Built-in method references that are verified to be native. */ var $2bbb2ab9c7a79951$var$nativeCreate = $53M2G(Object, "create");
module.exports = $2bbb2ab9c7a79951$var$nativeCreate;

});
parcelRegister("53M2G", function(module, exports) {

var $4ALeo = parcelRequire("4ALeo");

var $imdCT = parcelRequire("imdCT");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3af27fc3880a5a68$var$getNative(object, key) {
    var value = $imdCT(object, key);
    return $4ALeo(value) ? value : undefined;
}
module.exports = $3af27fc3880a5a68$var$getNative;

});
parcelRegister("4ALeo", function(module, exports) {

var $6XDa0 = parcelRequire("6XDa0");

var $lRrKO = parcelRequire("lRrKO");

var $lV9qR = parcelRequire("lV9qR");

var $cOlVo = parcelRequire("cOlVo");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $357f2951056a8792$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $357f2951056a8792$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $357f2951056a8792$var$funcProto = Function.prototype, $357f2951056a8792$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $357f2951056a8792$var$funcToString = $357f2951056a8792$var$funcProto.toString;
/** Used to check objects for own properties. */ var $357f2951056a8792$var$hasOwnProperty = $357f2951056a8792$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $357f2951056a8792$var$reIsNative = RegExp("^" + $357f2951056a8792$var$funcToString.call($357f2951056a8792$var$hasOwnProperty).replace($357f2951056a8792$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $357f2951056a8792$var$baseIsNative(value) {
    if (!$lV9qR(value) || $lRrKO(value)) return false;
    var pattern = $6XDa0(value) ? $357f2951056a8792$var$reIsNative : $357f2951056a8792$var$reIsHostCtor;
    return pattern.test($cOlVo(value));
}
module.exports = $357f2951056a8792$var$baseIsNative;

});
parcelRegister("6XDa0", function(module, exports) {

var $j74ic = parcelRequire("j74ic");

var $lV9qR = parcelRequire("lV9qR");
/** `Object#toString` result references. */ var $5116a13a484238a6$var$asyncTag = "[object AsyncFunction]", $5116a13a484238a6$var$funcTag = "[object Function]", $5116a13a484238a6$var$genTag = "[object GeneratorFunction]", $5116a13a484238a6$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5116a13a484238a6$var$isFunction(value) {
    if (!$lV9qR(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $j74ic(value);
    return tag == $5116a13a484238a6$var$funcTag || tag == $5116a13a484238a6$var$genTag || tag == $5116a13a484238a6$var$asyncTag || tag == $5116a13a484238a6$var$proxyTag;
}
module.exports = $5116a13a484238a6$var$isFunction;

});
parcelRegister("lV9qR", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ff563cde16cb42bc$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $ff563cde16cb42bc$var$isObject;

});


parcelRegister("lRrKO", function(module, exports) {

var $ebXgG = parcelRequire("ebXgG");
/** Used to detect methods masquerading as native. */ var $fea413965eb630f0$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($ebXgG && $ebXgG.keys && $ebXgG.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $fea413965eb630f0$var$isMasked(func) {
    return !!$fea413965eb630f0$var$maskSrcKey && $fea413965eb630f0$var$maskSrcKey in func;
}
module.exports = $fea413965eb630f0$var$isMasked;

});
parcelRegister("ebXgG", function(module, exports) {

var $chdtz = parcelRequire("chdtz");
/** Used to detect overreaching core-js shims. */ var $a550112f5a6d75d7$var$coreJsData = $chdtz["__core-js_shared__"];
module.exports = $a550112f5a6d75d7$var$coreJsData;

});


parcelRegister("cOlVo", function(module, exports) {
/** Used for built-in method references. */ var $953b2951dcd9b369$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $953b2951dcd9b369$var$funcToString = $953b2951dcd9b369$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $953b2951dcd9b369$var$toSource(func) {
    if (func != null) {
        try {
            return $953b2951dcd9b369$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $953b2951dcd9b369$var$toSource;

});


parcelRegister("imdCT", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d5d4d9fd7813a147$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d5d4d9fd7813a147$var$getValue;

});




parcelRegister("ledCv", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f745786a42cdcd36$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f745786a42cdcd36$var$hashDelete;

});

parcelRegister("bVWFD", function(module, exports) {

var $3KMlh = parcelRequire("3KMlh");
/** Used to stand-in for `undefined` hash values. */ var $8b02875822cdc929$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $8b02875822cdc929$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8b02875822cdc929$var$hasOwnProperty = $8b02875822cdc929$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8b02875822cdc929$var$hashGet(key) {
    var data = this.__data__;
    if ($3KMlh) {
        var result = data[key];
        return result === $8b02875822cdc929$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8b02875822cdc929$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $8b02875822cdc929$var$hashGet;

});

parcelRegister("ih65g", function(module, exports) {

var $3KMlh = parcelRequire("3KMlh");
/** Used for built-in method references. */ var $d4de88aa39c760a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4de88aa39c760a5$var$hasOwnProperty = $d4de88aa39c760a5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d4de88aa39c760a5$var$hashHas(key) {
    var data = this.__data__;
    return $3KMlh ? data[key] !== undefined : $d4de88aa39c760a5$var$hasOwnProperty.call(data, key);
}
module.exports = $d4de88aa39c760a5$var$hashHas;

});

parcelRegister("7yFh6", function(module, exports) {

var $3KMlh = parcelRequire("3KMlh");
/** Used to stand-in for `undefined` hash values. */ var $580bb9b31988ca16$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $580bb9b31988ca16$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3KMlh && value === undefined ? $580bb9b31988ca16$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $580bb9b31988ca16$var$hashSet;

});


parcelRegister("cp2ZN", function(module, exports) {

var $kbHto = parcelRequire("kbHto");

var $bL1Zw = parcelRequire("bL1Zw");

var $dTeGh = parcelRequire("dTeGh");

var $hke28 = parcelRequire("hke28");

var $er840 = parcelRequire("er840");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $02548cfac78bf43f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$02548cfac78bf43f$var$ListCache.prototype.clear = $kbHto;
$02548cfac78bf43f$var$ListCache.prototype["delete"] = $bL1Zw;
$02548cfac78bf43f$var$ListCache.prototype.get = $dTeGh;
$02548cfac78bf43f$var$ListCache.prototype.has = $hke28;
$02548cfac78bf43f$var$ListCache.prototype.set = $er840;
module.exports = $02548cfac78bf43f$var$ListCache;

});
parcelRegister("kbHto", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $eb268e90e0633583$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $eb268e90e0633583$var$listCacheClear;

});

parcelRegister("bL1Zw", function(module, exports) {

var $f4TzO = parcelRequire("f4TzO");
/** Used for built-in method references. */ var $88f5a0ee2e92a3ad$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $88f5a0ee2e92a3ad$var$splice = $88f5a0ee2e92a3ad$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $88f5a0ee2e92a3ad$var$listCacheDelete(key) {
    var data = this.__data__, index = $f4TzO(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $88f5a0ee2e92a3ad$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $88f5a0ee2e92a3ad$var$listCacheDelete;

});
parcelRegister("f4TzO", function(module, exports) {

var $3rQE1 = parcelRequire("3rQE1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $afa2571e1251f6de$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3rQE1(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $afa2571e1251f6de$var$assocIndexOf;

});
parcelRegister("3rQE1", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $282cbacc7595294e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $282cbacc7595294e$var$eq;

});



parcelRegister("dTeGh", function(module, exports) {

var $f4TzO = parcelRequire("f4TzO");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a1cbccbc78e8576d$var$listCacheGet(key) {
    var data = this.__data__, index = $f4TzO(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $a1cbccbc78e8576d$var$listCacheGet;

});

parcelRegister("hke28", function(module, exports) {

var $f4TzO = parcelRequire("f4TzO");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9cf30a6c019c024$var$listCacheHas(key) {
    return $f4TzO(this.__data__, key) > -1;
}
module.exports = $c9cf30a6c019c024$var$listCacheHas;

});

parcelRegister("er840", function(module, exports) {

var $f4TzO = parcelRequire("f4TzO");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $a829d78ea5a401d4$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f4TzO(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $a829d78ea5a401d4$var$listCacheSet;

});


parcelRegister("3c5C8", function(module, exports) {

var $53M2G = parcelRequire("53M2G");

var $chdtz = parcelRequire("chdtz");
/* Built-in method references that are verified to be native. */ var $2536d8ef10229165$var$Map = $53M2G($chdtz, "Map");
module.exports = $2536d8ef10229165$var$Map;

});


parcelRegister("dQxMP", function(module, exports) {

var $cZ81b = parcelRequire("cZ81b");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a14a56ff4c055638$var$mapCacheDelete(key) {
    var result = $cZ81b(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $a14a56ff4c055638$var$mapCacheDelete;

});
parcelRegister("cZ81b", function(module, exports) {

var $ciMHq = parcelRequire("ciMHq");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $974166c757cabb7f$var$getMapData(map, key) {
    var data = map.__data__;
    return $ciMHq(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $974166c757cabb7f$var$getMapData;

});
parcelRegister("ciMHq", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8f4cf129729caed7$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $8f4cf129729caed7$var$isKeyable;

});



parcelRegister("27Cef", function(module, exports) {

var $cZ81b = parcelRequire("cZ81b");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $18b9e3a74c7c8bf3$var$mapCacheGet(key) {
    return $cZ81b(this, key).get(key);
}
module.exports = $18b9e3a74c7c8bf3$var$mapCacheGet;

});

parcelRegister("Tg3Sv", function(module, exports) {

var $cZ81b = parcelRequire("cZ81b");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0a6198a86b533d53$var$mapCacheHas(key) {
    return $cZ81b(this, key).has(key);
}
module.exports = $0a6198a86b533d53$var$mapCacheHas;

});

parcelRegister("fpkaW", function(module, exports) {

var $cZ81b = parcelRequire("cZ81b");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b378d739e4ef68a5$var$mapCacheSet(key, value) {
    var data = $cZ81b(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $b378d739e4ef68a5$var$mapCacheSet;

});





parcelRegister("1ZPOa", function(module, exports) {

var $9dPMN = parcelRequire("9dPMN");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $1743acf904bd3964$var$toString(value) {
    return value == null ? "" : $9dPMN(value);
}
module.exports = $1743acf904bd3964$var$toString;

});
parcelRegister("9dPMN", function(module, exports) {

var $kj9as = parcelRequire("kj9as");

var $2MaAp = parcelRequire("2MaAp");

var $cCHmB = parcelRequire("cCHmB");

var $3oRSI = parcelRequire("3oRSI");
/** Used as references for various `Number` constants. */ var $6b6d7f8fe5a26b83$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $6b6d7f8fe5a26b83$var$symbolProto = $kj9as ? $kj9as.prototype : undefined, $6b6d7f8fe5a26b83$var$symbolToString = $6b6d7f8fe5a26b83$var$symbolProto ? $6b6d7f8fe5a26b83$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $6b6d7f8fe5a26b83$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($cCHmB(value)) // Recursively convert values (susceptible to call stack limits).
    return $2MaAp(value, $6b6d7f8fe5a26b83$var$baseToString) + "";
    if ($3oRSI(value)) return $6b6d7f8fe5a26b83$var$symbolToString ? $6b6d7f8fe5a26b83$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$6b6d7f8fe5a26b83$var$INFINITY ? "-0" : result;
}
module.exports = $6b6d7f8fe5a26b83$var$baseToString;

});
parcelRegister("2MaAp", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $205846a66eac156d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $205846a66eac156d$var$arrayMap;

});




parcelRegister("142qw", function(module, exports) {

var $kn835 = parcelRequire("kn835");

var $75jXw = parcelRequire("75jXw");
/** Used for built-in method references. */ var $0c680c17553cc635$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c680c17553cc635$var$hasOwnProperty = $0c680c17553cc635$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $0c680c17553cc635$var$propertyIsEnumerable = $0c680c17553cc635$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $0c680c17553cc635$var$isArguments = $kn835(function() {
    return arguments;
}()) ? $kn835 : function(value) {
    return $75jXw(value) && $0c680c17553cc635$var$hasOwnProperty.call(value, "callee") && !$0c680c17553cc635$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $0c680c17553cc635$var$isArguments;

});
parcelRegister("kn835", function(module, exports) {

var $j74ic = parcelRequire("j74ic");

var $75jXw = parcelRequire("75jXw");
/** `Object#toString` result references. */ var $ed4c32f4b4a31699$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ed4c32f4b4a31699$var$baseIsArguments(value) {
    return $75jXw(value) && $j74ic(value) == $ed4c32f4b4a31699$var$argsTag;
}
module.exports = $ed4c32f4b4a31699$var$baseIsArguments;

});


parcelRegister("bNaPK", function(module, exports) {
/** Used as references for various `Number` constants. */ var $895cacac46baf340$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $895cacac46baf340$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $895cacac46baf340$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $895cacac46baf340$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $895cacac46baf340$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $895cacac46baf340$var$isIndex;

});

parcelRegister("4HWBA", function(module, exports) {
/** Used as references for various `Number` constants. */ var $36d8a35d9223af29$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $36d8a35d9223af29$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $36d8a35d9223af29$var$MAX_SAFE_INTEGER;
}
module.exports = $36d8a35d9223af29$var$isLength;

});

parcelRegister("hBTdo", function(module, exports) {

var $3oRSI = parcelRequire("3oRSI");
/** Used as references for various `Number` constants. */ var $cd20b8e9bef9d38d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $cd20b8e9bef9d38d$var$toKey(value) {
    if (typeof value == "string" || $3oRSI(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$cd20b8e9bef9d38d$var$INFINITY ? "-0" : result;
}
module.exports = $cd20b8e9bef9d38d$var$toKey;

});



parcelRegister("2QGDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $213182b12975b5ed$export$2e2bcd8739ae039; });
const $213182b12975b5ed$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $213182b12975b5ed$export$2e2bcd8739ae039 = $213182b12975b5ed$var$isSchema;

});


parcelRegister("9JjUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7157c2cceba563e0$export$2e2bcd8739ae039; });

var $kRWYd = parcelRequire("kRWYd");
const $7157c2cceba563e0$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $7157c2cceba563e0$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $7157c2cceba563e0$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $kRWYd.default)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $kRWYd.default).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $kRWYd.default)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}

});
parcelRegister("kRWYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3168024c3859931$export$2e2bcd8739ae039; });

var $5LXSO = parcelRequire("5LXSO");

var $9Q7ea = parcelRequire("9Q7ea");
function $f3168024c3859931$var$_extends() {
    $f3168024c3859931$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f3168024c3859931$var$_extends.apply(this, arguments);
}
let $f3168024c3859931$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $f3168024c3859931$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $f3168024c3859931$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($f3168024c3859931$var$strReg, (_, key)=>(0, $5LXSO.default)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $9Q7ea.default)(errorOrErrors).forEach((err)=>{
            if ($f3168024c3859931$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f3168024c3859931$export$2e2bcd8739ae039);
    }
}

});
parcelRegister("9Q7ea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $729e93985fc66f73$export$2e2bcd8739ae039; });
function $729e93985fc66f73$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}

});



parcelRegister("5aFP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c3e53df64bdebcf$export$2e2bcd8739ae039; });

var $eXq1E = parcelRequire("eXq1E");

var $kRWYd = parcelRequire("kRWYd");

var $eQuBt = parcelRequire("eQuBt");
function $3c3e53df64bdebcf$var$_extends() {
    $3c3e53df64bdebcf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c3e53df64bdebcf$var$_extends.apply(this, arguments);
}
function $3c3e53df64bdebcf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3c3e53df64bdebcf$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = "", label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $3c3e53df64bdebcf$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $eQuBt.default).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($eXq1E)))($3c3e53df64bdebcf$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $kRWYd.default)((0, $kRWYd.default).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $3c3e53df64bdebcf$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $kRWYd.default).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $kRWYd.default).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}

});
parcelRegister("eXq1E", function(module, exports) {

var $kev44 = parcelRequire("kev44");

var $8I9P6 = parcelRequire("8I9P6");

var $kdg3I = parcelRequire("kdg3I");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $ae3ac38634e9146f$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $kdg3I(iteratee, 3);
    $8I9P6(object, function(value, key, object) {
        $kev44(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $ae3ac38634e9146f$var$mapValues;

});
parcelRegister("kev44", function(module, exports) {

var $HAeDX = parcelRequire("HAeDX");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ebad36394ca9064e$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $HAeDX) $HAeDX(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $ebad36394ca9064e$var$baseAssignValue;

});
parcelRegister("HAeDX", function(module, exports) {

var $53M2G = parcelRequire("53M2G");
var $08301fd1d3a76ee5$var$defineProperty = function() {
    try {
        var func = $53M2G(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $08301fd1d3a76ee5$var$defineProperty;

});


parcelRegister("8I9P6", function(module, exports) {

var $2gKZL = parcelRequire("2gKZL");

var $i03R5 = parcelRequire("i03R5");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $657a0d813cc80db3$var$baseForOwn(object, iteratee) {
    return object && $2gKZL(object, iteratee, $i03R5);
}
module.exports = $657a0d813cc80db3$var$baseForOwn;

});
parcelRegister("2gKZL", function(module, exports) {

var $a0E9j = parcelRequire("a0E9j");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1a7187a8b9c5f88b$var$baseFor = $a0E9j();
module.exports = $1a7187a8b9c5f88b$var$baseFor;

});
parcelRegister("a0E9j", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $74990c3edde7bbed$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $74990c3edde7bbed$var$createBaseFor;

});


parcelRegister("i03R5", function(module, exports) {

var $i9yNX = parcelRequire("i9yNX");

var $bgXTH = parcelRequire("bgXTH");

var $iSGGk = parcelRequire("iSGGk");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d1ab37a700ab95f6$var$keys(object) {
    return $iSGGk(object) ? $i9yNX(object) : $bgXTH(object);
}
module.exports = $d1ab37a700ab95f6$var$keys;

});
parcelRegister("i9yNX", function(module, exports) {

var $9X944 = parcelRequire("9X944");

var $142qw = parcelRequire("142qw");

var $cCHmB = parcelRequire("cCHmB");

var $h1bRa = parcelRequire("h1bRa");

var $bNaPK = parcelRequire("bNaPK");

var $bGv42 = parcelRequire("bGv42");
/** Used for built-in method references. */ var $d37410c91597d328$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d37410c91597d328$var$hasOwnProperty = $d37410c91597d328$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d37410c91597d328$var$arrayLikeKeys(value, inherited) {
    var isArr = $cCHmB(value), isArg = !isArr && $142qw(value), isBuff = !isArr && !isArg && $h1bRa(value), isType = !isArr && !isArg && !isBuff && $bGv42(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $9X944(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $d37410c91597d328$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $bNaPK(key, length)))) result.push(key);
    return result;
}
module.exports = $d37410c91597d328$var$arrayLikeKeys;

});
parcelRegister("9X944", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $73f0a7ceb96eeef7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $73f0a7ceb96eeef7$var$baseTimes;

});

parcelRegister("h1bRa", function(module, exports) {

var $chdtz = parcelRequire("chdtz");

var $6qx71 = parcelRequire("6qx71");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $chdtz.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6qx71;
module.exports = isBuffer;

});
parcelRegister("6qx71", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4adedb2a5015422f$var$stubFalse() {
    return false;
}
module.exports = $4adedb2a5015422f$var$stubFalse;

});


parcelRegister("bGv42", function(module, exports) {

var $4gE9x = parcelRequire("4gE9x");

var $jOfMI = parcelRequire("jOfMI");

var $jerrY = parcelRequire("jerrY");
/* Node.js helper references. */ var $881bb6a227271503$var$nodeIsTypedArray = $jerrY && $jerrY.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $881bb6a227271503$var$isTypedArray = $881bb6a227271503$var$nodeIsTypedArray ? $jOfMI($881bb6a227271503$var$nodeIsTypedArray) : $4gE9x;
module.exports = $881bb6a227271503$var$isTypedArray;

});
parcelRegister("4gE9x", function(module, exports) {

var $j74ic = parcelRequire("j74ic");

var $4HWBA = parcelRequire("4HWBA");

var $75jXw = parcelRequire("75jXw");
/** `Object#toString` result references. */ var $31b7cd91d846ae60$var$argsTag = "[object Arguments]", $31b7cd91d846ae60$var$arrayTag = "[object Array]", $31b7cd91d846ae60$var$boolTag = "[object Boolean]", $31b7cd91d846ae60$var$dateTag = "[object Date]", $31b7cd91d846ae60$var$errorTag = "[object Error]", $31b7cd91d846ae60$var$funcTag = "[object Function]", $31b7cd91d846ae60$var$mapTag = "[object Map]", $31b7cd91d846ae60$var$numberTag = "[object Number]", $31b7cd91d846ae60$var$objectTag = "[object Object]", $31b7cd91d846ae60$var$regexpTag = "[object RegExp]", $31b7cd91d846ae60$var$setTag = "[object Set]", $31b7cd91d846ae60$var$stringTag = "[object String]", $31b7cd91d846ae60$var$weakMapTag = "[object WeakMap]";
var $31b7cd91d846ae60$var$arrayBufferTag = "[object ArrayBuffer]", $31b7cd91d846ae60$var$dataViewTag = "[object DataView]", $31b7cd91d846ae60$var$float32Tag = "[object Float32Array]", $31b7cd91d846ae60$var$float64Tag = "[object Float64Array]", $31b7cd91d846ae60$var$int8Tag = "[object Int8Array]", $31b7cd91d846ae60$var$int16Tag = "[object Int16Array]", $31b7cd91d846ae60$var$int32Tag = "[object Int32Array]", $31b7cd91d846ae60$var$uint8Tag = "[object Uint8Array]", $31b7cd91d846ae60$var$uint8ClampedTag = "[object Uint8ClampedArray]", $31b7cd91d846ae60$var$uint16Tag = "[object Uint16Array]", $31b7cd91d846ae60$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $31b7cd91d846ae60$var$typedArrayTags = {};
$31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$float32Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$float64Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$int8Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$int16Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$int32Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$uint8Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$uint8ClampedTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$uint16Tag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$uint32Tag] = true;
$31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$argsTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$arrayTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$arrayBufferTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$boolTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$dataViewTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$dateTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$errorTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$funcTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$mapTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$numberTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$objectTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$regexpTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$setTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$stringTag] = $31b7cd91d846ae60$var$typedArrayTags[$31b7cd91d846ae60$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $31b7cd91d846ae60$var$baseIsTypedArray(value) {
    return $75jXw(value) && $4HWBA(value.length) && !!$31b7cd91d846ae60$var$typedArrayTags[$j74ic(value)];
}
module.exports = $31b7cd91d846ae60$var$baseIsTypedArray;

});

parcelRegister("jOfMI", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $03b8c1c78fef27e0$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $03b8c1c78fef27e0$var$baseUnary;

});

parcelRegister("jerrY", function(module, exports) {

var $kkYOp = parcelRequire("kkYOp");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $kkYOp.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("bgXTH", function(module, exports) {

var $a88fq = parcelRequire("a88fq");

var $1cFNI = parcelRequire("1cFNI");
/** Used for built-in method references. */ var $834fa6b82ef39f75$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $834fa6b82ef39f75$var$hasOwnProperty = $834fa6b82ef39f75$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $834fa6b82ef39f75$var$baseKeys(object) {
    if (!$a88fq(object)) return $1cFNI(object);
    var result = [];
    for(var key in Object(object))if ($834fa6b82ef39f75$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $834fa6b82ef39f75$var$baseKeys;

});
parcelRegister("a88fq", function(module, exports) {
/** Used for built-in method references. */ var $76010c8ee1db9d99$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $76010c8ee1db9d99$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $76010c8ee1db9d99$var$objectProto;
    return value === proto;
}
module.exports = $76010c8ee1db9d99$var$isPrototype;

});

parcelRegister("1cFNI", function(module, exports) {

var $9zvVr = parcelRequire("9zvVr");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0e07563c13d64c09$var$nativeKeys = $9zvVr(Object.keys, Object);
module.exports = $0e07563c13d64c09$var$nativeKeys;

});
parcelRegister("9zvVr", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $01cc63b453b3fcbe$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $01cc63b453b3fcbe$var$overArg;

});



parcelRegister("iSGGk", function(module, exports) {

var $6XDa0 = parcelRequire("6XDa0");

var $4HWBA = parcelRequire("4HWBA");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $dbee60d79281c666$var$isArrayLike(value) {
    return value != null && $4HWBA(value.length) && !$6XDa0(value);
}
module.exports = $dbee60d79281c666$var$isArrayLike;

});



parcelRegister("kdg3I", function(module, exports) {

var $jKjIy = parcelRequire("jKjIy");

var $9yb3Q = parcelRequire("9yb3Q");

var $7o35Z = parcelRequire("7o35Z");

var $cCHmB = parcelRequire("cCHmB");

var $dQr27 = parcelRequire("dQr27");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $eb717a84de42b047$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $7o35Z;
    if (typeof value == "object") return $cCHmB(value) ? $9yb3Q(value[0], value[1]) : $jKjIy(value);
    return $dQr27(value);
}
module.exports = $eb717a84de42b047$var$baseIteratee;

});
parcelRegister("jKjIy", function(module, exports) {

var $JxY5r = parcelRequire("JxY5r");

var $j9ryo = parcelRequire("j9ryo");

var $9H8WM = parcelRequire("9H8WM");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e6019bbb0c0fa7c8$var$baseMatches(source) {
    var matchData = $j9ryo(source);
    if (matchData.length == 1 && matchData[0][2]) return $9H8WM(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $JxY5r(object, source, matchData);
    };
}
module.exports = $e6019bbb0c0fa7c8$var$baseMatches;

});
parcelRegister("JxY5r", function(module, exports) {

var $ik4Tr = parcelRequire("ik4Tr");

var $1CqKC = parcelRequire("1CqKC");
/** Used to compose bitmasks for value comparisons. */ var $088e8d7309f1b367$var$COMPARE_PARTIAL_FLAG = 1, $088e8d7309f1b367$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $088e8d7309f1b367$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $ik4Tr;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1CqKC(srcValue, objValue, $088e8d7309f1b367$var$COMPARE_PARTIAL_FLAG | $088e8d7309f1b367$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $088e8d7309f1b367$var$baseIsMatch;

});
parcelRegister("ik4Tr", function(module, exports) {

var $cp2ZN = parcelRequire("cp2ZN");

var $kafqS = parcelRequire("kafqS");

var $9pAdl = parcelRequire("9pAdl");

var $kYT9x = parcelRequire("kYT9x");

var $kfGL2 = parcelRequire("kfGL2");

var $jjWVF = parcelRequire("jjWVF");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d56de3f2f985b032$var$Stack(entries) {
    var data = this.__data__ = new $cp2ZN(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d56de3f2f985b032$var$Stack.prototype.clear = $kafqS;
$d56de3f2f985b032$var$Stack.prototype["delete"] = $9pAdl;
$d56de3f2f985b032$var$Stack.prototype.get = $kYT9x;
$d56de3f2f985b032$var$Stack.prototype.has = $kfGL2;
$d56de3f2f985b032$var$Stack.prototype.set = $jjWVF;
module.exports = $d56de3f2f985b032$var$Stack;

});
parcelRegister("kafqS", function(module, exports) {

var $cp2ZN = parcelRequire("cp2ZN");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $eae0b65efc694563$var$stackClear() {
    this.__data__ = new $cp2ZN;
    this.size = 0;
}
module.exports = $eae0b65efc694563$var$stackClear;

});

parcelRegister("9pAdl", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6da28a3ee35bc44e$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $6da28a3ee35bc44e$var$stackDelete;

});

parcelRegister("kYT9x", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f464317817c3fac4$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $f464317817c3fac4$var$stackGet;

});

parcelRegister("kfGL2", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ebe6602a76b98499$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $ebe6602a76b98499$var$stackHas;

});

parcelRegister("jjWVF", function(module, exports) {

var $cp2ZN = parcelRequire("cp2ZN");

var $3c5C8 = parcelRequire("3c5C8");

var $9t69A = parcelRequire("9t69A");
/** Used as the size to enable large array optimizations. */ var $e10d80c923a17e42$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $e10d80c923a17e42$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $cp2ZN) {
        var pairs = data.__data__;
        if (!$3c5C8 || pairs.length < $e10d80c923a17e42$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9t69A(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $e10d80c923a17e42$var$stackSet;

});


parcelRegister("1CqKC", function(module, exports) {

var $dragO = parcelRequire("dragO");

var $75jXw = parcelRequire("75jXw");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $12de173fc8f6cdd9$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$75jXw(value) && !$75jXw(other)) return value !== value && other !== other;
    return $dragO(value, other, bitmask, customizer, $12de173fc8f6cdd9$var$baseIsEqual, stack);
}
module.exports = $12de173fc8f6cdd9$var$baseIsEqual;

});
parcelRegister("dragO", function(module, exports) {

var $ik4Tr = parcelRequire("ik4Tr");

var $lPCMJ = parcelRequire("lPCMJ");

var $llH75 = parcelRequire("llH75");

var $f3xWZ = parcelRequire("f3xWZ");

var $2u8zb = parcelRequire("2u8zb");

var $cCHmB = parcelRequire("cCHmB");

var $h1bRa = parcelRequire("h1bRa");

var $bGv42 = parcelRequire("bGv42");
/** Used to compose bitmasks for value comparisons. */ var $9c85c36a8acdb54d$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $9c85c36a8acdb54d$var$argsTag = "[object Arguments]", $9c85c36a8acdb54d$var$arrayTag = "[object Array]", $9c85c36a8acdb54d$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $9c85c36a8acdb54d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9c85c36a8acdb54d$var$hasOwnProperty = $9c85c36a8acdb54d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9c85c36a8acdb54d$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $cCHmB(object), othIsArr = $cCHmB(other), objTag = objIsArr ? $9c85c36a8acdb54d$var$arrayTag : $2u8zb(object), othTag = othIsArr ? $9c85c36a8acdb54d$var$arrayTag : $2u8zb(other);
    objTag = objTag == $9c85c36a8acdb54d$var$argsTag ? $9c85c36a8acdb54d$var$objectTag : objTag;
    othTag = othTag == $9c85c36a8acdb54d$var$argsTag ? $9c85c36a8acdb54d$var$objectTag : othTag;
    var objIsObj = objTag == $9c85c36a8acdb54d$var$objectTag, othIsObj = othTag == $9c85c36a8acdb54d$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $h1bRa(object)) {
        if (!$h1bRa(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $ik4Tr);
        return objIsArr || $bGv42(object) ? $lPCMJ(object, other, bitmask, customizer, equalFunc, stack) : $llH75(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $9c85c36a8acdb54d$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $9c85c36a8acdb54d$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $9c85c36a8acdb54d$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $ik4Tr);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $ik4Tr);
    return $f3xWZ(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $9c85c36a8acdb54d$var$baseIsEqualDeep;

});
parcelRegister("lPCMJ", function(module, exports) {

var $X6luI = parcelRequire("X6luI");

var $8Aom9 = parcelRequire("8Aom9");

var $c9djN = parcelRequire("c9djN");
/** Used to compose bitmasks for value comparisons. */ var $fe4c724b4faa62ef$var$COMPARE_PARTIAL_FLAG = 1, $fe4c724b4faa62ef$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $fe4c724b4faa62ef$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fe4c724b4faa62ef$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $fe4c724b4faa62ef$var$COMPARE_UNORDERED_FLAG ? new $X6luI : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$8Aom9(other, function(othValue, othIndex) {
                if (!$c9djN(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $fe4c724b4faa62ef$var$equalArrays;

});
parcelRegister("X6luI", function(module, exports) {

var $9t69A = parcelRequire("9t69A");

var $j6sKs = parcelRequire("j6sKs");

var $aJpmU = parcelRequire("aJpmU");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $0b1a6eec6dd98b0b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9t69A;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$0b1a6eec6dd98b0b$var$SetCache.prototype.add = $0b1a6eec6dd98b0b$var$SetCache.prototype.push = $j6sKs;
$0b1a6eec6dd98b0b$var$SetCache.prototype.has = $aJpmU;
module.exports = $0b1a6eec6dd98b0b$var$SetCache;

});
parcelRegister("j6sKs", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $de84e0b1ca322be3$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $de84e0b1ca322be3$var$setCacheAdd(value) {
    this.__data__.set(value, $de84e0b1ca322be3$var$HASH_UNDEFINED);
    return this;
}
module.exports = $de84e0b1ca322be3$var$setCacheAdd;

});

parcelRegister("aJpmU", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $7d01c8fca872c553$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $7d01c8fca872c553$var$setCacheHas;

});


parcelRegister("8Aom9", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6404942f710503f3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $6404942f710503f3$var$arraySome;

});

parcelRegister("c9djN", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $024844c63f717cac$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $024844c63f717cac$var$cacheHas;

});


parcelRegister("llH75", function(module, exports) {

var $kj9as = parcelRequire("kj9as");

var $4uwte = parcelRequire("4uwte");

var $3rQE1 = parcelRequire("3rQE1");

var $lPCMJ = parcelRequire("lPCMJ");

var $8WcfP = parcelRequire("8WcfP");

var $ceu6Y = parcelRequire("ceu6Y");
/** Used to compose bitmasks for value comparisons. */ var $f8ad00858a2dc948$var$COMPARE_PARTIAL_FLAG = 1, $f8ad00858a2dc948$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $f8ad00858a2dc948$var$boolTag = "[object Boolean]", $f8ad00858a2dc948$var$dateTag = "[object Date]", $f8ad00858a2dc948$var$errorTag = "[object Error]", $f8ad00858a2dc948$var$mapTag = "[object Map]", $f8ad00858a2dc948$var$numberTag = "[object Number]", $f8ad00858a2dc948$var$regexpTag = "[object RegExp]", $f8ad00858a2dc948$var$setTag = "[object Set]", $f8ad00858a2dc948$var$stringTag = "[object String]", $f8ad00858a2dc948$var$symbolTag = "[object Symbol]";
var $f8ad00858a2dc948$var$arrayBufferTag = "[object ArrayBuffer]", $f8ad00858a2dc948$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $f8ad00858a2dc948$var$symbolProto = $kj9as ? $kj9as.prototype : undefined, $f8ad00858a2dc948$var$symbolValueOf = $f8ad00858a2dc948$var$symbolProto ? $f8ad00858a2dc948$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f8ad00858a2dc948$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $f8ad00858a2dc948$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $f8ad00858a2dc948$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $4uwte(object), new $4uwte(other))) return false;
            return true;
        case $f8ad00858a2dc948$var$boolTag:
        case $f8ad00858a2dc948$var$dateTag:
        case $f8ad00858a2dc948$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $3rQE1(+object, +other);
        case $f8ad00858a2dc948$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $f8ad00858a2dc948$var$regexpTag:
        case $f8ad00858a2dc948$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $f8ad00858a2dc948$var$mapTag:
            var convert = $8WcfP;
        case $f8ad00858a2dc948$var$setTag:
            var isPartial = bitmask & $f8ad00858a2dc948$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $ceu6Y);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $f8ad00858a2dc948$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $lPCMJ(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $f8ad00858a2dc948$var$symbolTag:
            if ($f8ad00858a2dc948$var$symbolValueOf) return $f8ad00858a2dc948$var$symbolValueOf.call(object) == $f8ad00858a2dc948$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $f8ad00858a2dc948$var$equalByTag;

});
parcelRegister("4uwte", function(module, exports) {

var $chdtz = parcelRequire("chdtz");
/** Built-in value references. */ var $345326b63aad7f40$var$Uint8Array = $chdtz.Uint8Array;
module.exports = $345326b63aad7f40$var$Uint8Array;

});

parcelRegister("8WcfP", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $681d3ef7eb8ef79b$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $681d3ef7eb8ef79b$var$mapToArray;

});

parcelRegister("ceu6Y", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $8e7e265e4bac89dd$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $8e7e265e4bac89dd$var$setToArray;

});


parcelRegister("f3xWZ", function(module, exports) {

var $iskrg = parcelRequire("iskrg");
/** Used to compose bitmasks for value comparisons. */ var $af6178b078aec601$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $af6178b078aec601$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $af6178b078aec601$var$hasOwnProperty = $af6178b078aec601$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $af6178b078aec601$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $af6178b078aec601$var$COMPARE_PARTIAL_FLAG, objProps = $iskrg(object), objLength = objProps.length, othProps = $iskrg(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $af6178b078aec601$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $af6178b078aec601$var$equalObjects;

});
parcelRegister("iskrg", function(module, exports) {

var $jvHLN = parcelRequire("jvHLN");

var $aFotU = parcelRequire("aFotU");

var $i03R5 = parcelRequire("i03R5");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d6fab23509213873$var$getAllKeys(object) {
    return $jvHLN(object, $i03R5, $aFotU);
}
module.exports = $d6fab23509213873$var$getAllKeys;

});
parcelRegister("jvHLN", function(module, exports) {

var $70m5Z = parcelRequire("70m5Z");

var $cCHmB = parcelRequire("cCHmB");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e342dd60d0c8da95$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $cCHmB(object) ? result : $70m5Z(result, symbolsFunc(object));
}
module.exports = $e342dd60d0c8da95$var$baseGetAllKeys;

});
parcelRegister("70m5Z", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $5199ac329310ea33$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $5199ac329310ea33$var$arrayPush;

});


parcelRegister("aFotU", function(module, exports) {

var $3RZIL = parcelRequire("3RZIL");

var $fjSOp = parcelRequire("fjSOp");
/** Used for built-in method references. */ var $7c40b9349dc12c4a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $7c40b9349dc12c4a$var$propertyIsEnumerable = $7c40b9349dc12c4a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7c40b9349dc12c4a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7c40b9349dc12c4a$var$getSymbols = !$7c40b9349dc12c4a$var$nativeGetSymbols ? $fjSOp : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $3RZIL($7c40b9349dc12c4a$var$nativeGetSymbols(object), function(symbol) {
        return $7c40b9349dc12c4a$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $7c40b9349dc12c4a$var$getSymbols;

});
parcelRegister("3RZIL", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2d1632d13df6271d$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $2d1632d13df6271d$var$arrayFilter;

});

parcelRegister("fjSOp", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $b27325df574e7ab0$var$stubArray() {
    return [];
}
module.exports = $b27325df574e7ab0$var$stubArray;

});




parcelRegister("2u8zb", function(module, exports) {

var $lDoii = parcelRequire("lDoii");

var $3c5C8 = parcelRequire("3c5C8");

var $d5ftJ = parcelRequire("d5ftJ");

var $9iygx = parcelRequire("9iygx");

var $7h2RD = parcelRequire("7h2RD");

var $j74ic = parcelRequire("j74ic");

var $cOlVo = parcelRequire("cOlVo");
/** `Object#toString` result references. */ var $1cf50740548f437b$var$mapTag = "[object Map]", $1cf50740548f437b$var$objectTag = "[object Object]", $1cf50740548f437b$var$promiseTag = "[object Promise]", $1cf50740548f437b$var$setTag = "[object Set]", $1cf50740548f437b$var$weakMapTag = "[object WeakMap]";
var $1cf50740548f437b$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $1cf50740548f437b$var$dataViewCtorString = $cOlVo($lDoii), $1cf50740548f437b$var$mapCtorString = $cOlVo($3c5C8), $1cf50740548f437b$var$promiseCtorString = $cOlVo($d5ftJ), $1cf50740548f437b$var$setCtorString = $cOlVo($9iygx), $1cf50740548f437b$var$weakMapCtorString = $cOlVo($7h2RD);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $1cf50740548f437b$var$getTag = $j74ic;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($lDoii && $1cf50740548f437b$var$getTag(new $lDoii(new ArrayBuffer(1))) != $1cf50740548f437b$var$dataViewTag || $3c5C8 && $1cf50740548f437b$var$getTag(new $3c5C8) != $1cf50740548f437b$var$mapTag || $d5ftJ && $1cf50740548f437b$var$getTag($d5ftJ.resolve()) != $1cf50740548f437b$var$promiseTag || $9iygx && $1cf50740548f437b$var$getTag(new $9iygx) != $1cf50740548f437b$var$setTag || $7h2RD && $1cf50740548f437b$var$getTag(new $7h2RD) != $1cf50740548f437b$var$weakMapTag) $1cf50740548f437b$var$getTag = function(value) {
    var result = $j74ic(value), Ctor = result == $1cf50740548f437b$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $cOlVo(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $1cf50740548f437b$var$dataViewCtorString:
            return $1cf50740548f437b$var$dataViewTag;
        case $1cf50740548f437b$var$mapCtorString:
            return $1cf50740548f437b$var$mapTag;
        case $1cf50740548f437b$var$promiseCtorString:
            return $1cf50740548f437b$var$promiseTag;
        case $1cf50740548f437b$var$setCtorString:
            return $1cf50740548f437b$var$setTag;
        case $1cf50740548f437b$var$weakMapCtorString:
            return $1cf50740548f437b$var$weakMapTag;
    }
    return result;
};
module.exports = $1cf50740548f437b$var$getTag;

});
parcelRegister("lDoii", function(module, exports) {

var $53M2G = parcelRequire("53M2G");

var $chdtz = parcelRequire("chdtz");
/* Built-in method references that are verified to be native. */ var $fc0015c84256722e$var$DataView = $53M2G($chdtz, "DataView");
module.exports = $fc0015c84256722e$var$DataView;

});

parcelRegister("d5ftJ", function(module, exports) {

var $53M2G = parcelRequire("53M2G");

var $chdtz = parcelRequire("chdtz");
/* Built-in method references that are verified to be native. */ var $9867bfaf2c3fa972$var$Promise = $53M2G($chdtz, "Promise");
module.exports = $9867bfaf2c3fa972$var$Promise;

});

parcelRegister("9iygx", function(module, exports) {

var $53M2G = parcelRequire("53M2G");

var $chdtz = parcelRequire("chdtz");
/* Built-in method references that are verified to be native. */ var $6c505ff075945d90$var$Set = $53M2G($chdtz, "Set");
module.exports = $6c505ff075945d90$var$Set;

});

parcelRegister("7h2RD", function(module, exports) {

var $53M2G = parcelRequire("53M2G");

var $chdtz = parcelRequire("chdtz");
/* Built-in method references that are verified to be native. */ var $54bc57ad7a0e9385$var$WeakMap = $53M2G($chdtz, "WeakMap");
module.exports = $54bc57ad7a0e9385$var$WeakMap;

});





parcelRegister("j9ryo", function(module, exports) {

var $azNJY = parcelRequire("azNJY");

var $i03R5 = parcelRequire("i03R5");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $df143b289988fa1d$var$getMatchData(object) {
    var result = $i03R5(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $azNJY(value)
        ];
    }
    return result;
}
module.exports = $df143b289988fa1d$var$getMatchData;

});
parcelRegister("azNJY", function(module, exports) {

var $lV9qR = parcelRequire("lV9qR");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $7b33c1b6bfafebfe$var$isStrictComparable(value) {
    return value === value && !$lV9qR(value);
}
module.exports = $7b33c1b6bfafebfe$var$isStrictComparable;

});


parcelRegister("9H8WM", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $70ef11e41cf0f13d$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $70ef11e41cf0f13d$var$matchesStrictComparable;

});


parcelRegister("9yb3Q", function(module, exports) {

var $1CqKC = parcelRequire("1CqKC");

var $byYTa = parcelRequire("byYTa");

var $DOJc6 = parcelRequire("DOJc6");

var $b78Hk = parcelRequire("b78Hk");

var $azNJY = parcelRequire("azNJY");

var $9H8WM = parcelRequire("9H8WM");

var $hBTdo = parcelRequire("hBTdo");
/** Used to compose bitmasks for value comparisons. */ var $6f3fde7f4e93fb98$var$COMPARE_PARTIAL_FLAG = 1, $6f3fde7f4e93fb98$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6f3fde7f4e93fb98$var$baseMatchesProperty(path, srcValue) {
    if ($b78Hk(path) && $azNJY(srcValue)) return $9H8WM($hBTdo(path), srcValue);
    return function(object) {
        var objValue = $byYTa(object, path);
        return objValue === undefined && objValue === srcValue ? $DOJc6(object, path) : $1CqKC(srcValue, objValue, $6f3fde7f4e93fb98$var$COMPARE_PARTIAL_FLAG | $6f3fde7f4e93fb98$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $6f3fde7f4e93fb98$var$baseMatchesProperty;

});
parcelRegister("byYTa", function(module, exports) {

var $9IqC7 = parcelRequire("9IqC7");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $86b219ee01d57746$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $9IqC7(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $86b219ee01d57746$var$get;

});
parcelRegister("9IqC7", function(module, exports) {

var $ghLpj = parcelRequire("ghLpj");

var $hBTdo = parcelRequire("hBTdo");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $712cde0dfaf1622c$var$baseGet(object, path) {
    path = $ghLpj(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$hBTdo(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $712cde0dfaf1622c$var$baseGet;

});


parcelRegister("DOJc6", function(module, exports) {

var $lJeet = parcelRequire("lJeet");

var $7dagH = parcelRequire("7dagH");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $077afe251419ecb2$var$hasIn(object, path) {
    return object != null && $7dagH(object, path, $lJeet);
}
module.exports = $077afe251419ecb2$var$hasIn;

});
parcelRegister("lJeet", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $fd18d7372306e6da$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $fd18d7372306e6da$var$baseHasIn;

});



parcelRegister("7o35Z", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $560d2d06a4e4d7de$var$identity(value) {
    return value;
}
module.exports = $560d2d06a4e4d7de$var$identity;

});

parcelRegister("dQr27", function(module, exports) {

var $kqJo2 = parcelRequire("kqJo2");

var $4mZA5 = parcelRequire("4mZA5");

var $b78Hk = parcelRequire("b78Hk");

var $hBTdo = parcelRequire("hBTdo");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $a14519f0fba126bf$var$property(path) {
    return $b78Hk(path) ? $kqJo2($hBTdo(path)) : $4mZA5(path);
}
module.exports = $a14519f0fba126bf$var$property;

});
parcelRegister("kqJo2", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $edf971338f9c67da$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $edf971338f9c67da$var$baseProperty;

});

parcelRegister("4mZA5", function(module, exports) {

var $9IqC7 = parcelRequire("9IqC7");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $32e8fc399fe2296e$var$basePropertyDeep(path) {
    return function(object) {
        return $9IqC7(object, path);
    };
}
module.exports = $32e8fc399fe2296e$var$basePropertyDeep;

});




parcelRegister("eQuBt", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $aceda9356544d7b1$export$185802fd694ee1f5; });
$parcel$export(module.exports, "default", function () { return $aceda9356544d7b1$export$2e2bcd8739ae039; });

var $53Q3M = parcelRequire("53Q3M");
const $aceda9356544d7b1$var$prefixes = {
    context: "$",
    value: "."
};
function $aceda9356544d7b1$export$185802fd694ee1f5(key, options) {
    return new $aceda9356544d7b1$export$2e2bcd8739ae039(key, options);
}
class $aceda9356544d7b1$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $aceda9356544d7b1$var$prefixes.context;
        this.isValue = this.key[0] === $aceda9356544d7b1$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $aceda9356544d7b1$var$prefixes.context : this.isValue ? $aceda9356544d7b1$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $53Q3M.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$aceda9356544d7b1$export$2e2bcd8739ae039.prototype.__isYupRef = true;

});
parcelRegister("53Q3M", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $3af59d9545b4cc3c$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$3af59d9545b4cc3c$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$3af59d9545b4cc3c$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$3af59d9545b4cc3c$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $3af59d9545b4cc3c$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $3af59d9545b4cc3c$var$DIGIT_REGEX = /^\d+$/, $3af59d9545b4cc3c$var$LEAD_DIGIT_REGEX = /^\d/, $3af59d9545b4cc3c$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $3af59d9545b4cc3c$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $3af59d9545b4cc3c$var$MAX_CACHE_SIZE = 512;
var $3af59d9545b4cc3c$var$pathCache = new $3af59d9545b4cc3c$var$Cache($3af59d9545b4cc3c$var$MAX_CACHE_SIZE), $3af59d9545b4cc3c$var$setCache = new $3af59d9545b4cc3c$var$Cache($3af59d9545b4cc3c$var$MAX_CACHE_SIZE), $3af59d9545b4cc3c$var$getCache = new $3af59d9545b4cc3c$var$Cache($3af59d9545b4cc3c$var$MAX_CACHE_SIZE);
var $3af59d9545b4cc3c$var$config;
module.exports = {
    Cache: $3af59d9545b4cc3c$var$Cache,
    split: $3af59d9545b4cc3c$var$split,
    normalizePath: $3af59d9545b4cc3c$var$normalizePath,
    setter: function(path) {
        var parts = $3af59d9545b4cc3c$var$normalizePath(path);
        return $3af59d9545b4cc3c$var$setCache.get(path) || $3af59d9545b4cc3c$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $3af59d9545b4cc3c$var$normalizePath(path);
        return $3af59d9545b4cc3c$var$getCache.get(path) || $3af59d9545b4cc3c$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($3af59d9545b4cc3c$var$isQuoted(part) || $3af59d9545b4cc3c$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $3af59d9545b4cc3c$var$forEach(Array.isArray(path) ? path : $3af59d9545b4cc3c$var$split(path), cb, thisArg);
    }
};
function $3af59d9545b4cc3c$var$normalizePath(path) {
    return $3af59d9545b4cc3c$var$pathCache.get(path) || $3af59d9545b4cc3c$var$pathCache.set(path, $3af59d9545b4cc3c$var$split(path).map(function(part) {
        return part.replace($3af59d9545b4cc3c$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $3af59d9545b4cc3c$var$split(path) {
    return path.match($3af59d9545b4cc3c$var$SPLIT_REGEX) || [
        ""
    ];
}
function $3af59d9545b4cc3c$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($3af59d9545b4cc3c$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $3af59d9545b4cc3c$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $3af59d9545b4cc3c$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $3af59d9545b4cc3c$var$hasLeadingNumber(part) {
    return part.match($3af59d9545b4cc3c$var$LEAD_DIGIT_REGEX) && !part.match($3af59d9545b4cc3c$var$DIGIT_REGEX);
}
function $3af59d9545b4cc3c$var$hasSpecialChars(part) {
    return $3af59d9545b4cc3c$var$SPEC_CHAR_REGEX.test(part);
}
function $3af59d9545b4cc3c$var$shouldBeQuoted(part) {
    return !$3af59d9545b4cc3c$var$isQuoted(part) && ($3af59d9545b4cc3c$var$hasLeadingNumber(part) || $3af59d9545b4cc3c$var$hasSpecialChars(part));
}

});



parcelRegister("fabHC", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $b0a0de16d4ecc241$export$c52e5867d5879e24; });

var $53Q3M = parcelRequire("53Q3M");
let $b0a0de16d4ecc241$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $b0a0de16d4ecc241$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $53Q3M.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $b0a0de16d4ecc241$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $b0a0de16d4ecc241$var$reach = (obj, path, value, context)=>$b0a0de16d4ecc241$export$c52e5867d5879e24(obj, path, value, context).schema;
var $b0a0de16d4ecc241$export$2e2bcd8739ae039 = $b0a0de16d4ecc241$var$reach;

});

parcelRegister("K5raW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a883bae7388105$export$2e2bcd8739ae039; });

var $eQuBt = parcelRequire("eQuBt");
class $08a883bae7388105$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $eQuBt.default).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $eQuBt.default).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $eQuBt.default).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $08a883bae7388105$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}

});



parcelRegister("kBMQz", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f00d275a525dcf30$export$185802fd694ee1f5; });

var $juS8c = parcelRequire("juS8c");

var $fks50 = parcelRequire("fks50");

var $dnIUX = parcelRequire("dnIUX");
function $f00d275a525dcf30$export$185802fd694ee1f5() {
    return new $f00d275a525dcf30$export$2e2bcd8739ae039();
}
class $f00d275a525dcf30$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $fks50.boolean).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $fks50.boolean).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value === false;
            }
        });
    }
}
$f00d275a525dcf30$export$185802fd694ee1f5.prototype = $f00d275a525dcf30$export$2e2bcd8739ae039.prototype;

});
parcelRegister("dnIUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9be0441036add8da$export$2e2bcd8739ae039; });
const $9be0441036add8da$var$isAbsent = (value)=>value == null;
var $9be0441036add8da$export$2e2bcd8739ae039 = $9be0441036add8da$var$isAbsent;

});


parcelRegister("jpUpC", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $e22c1c6b04a75d0c$export$185802fd694ee1f5; });

var $fks50 = parcelRequire("fks50");

var $dnIUX = parcelRequire("dnIUX");

var $juS8c = parcelRequire("juS8c");
let $e22c1c6b04a75d0c$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $e22c1c6b04a75d0c$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $e22c1c6b04a75d0c$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $e22c1c6b04a75d0c$var$isTrimmed = (value)=>(0, $dnIUX.default)(value) || value === value.trim();
let $e22c1c6b04a75d0c$var$objStringTag = ({}).toString();
function $e22c1c6b04a75d0c$export$185802fd694ee1f5() {
    return new $e22c1c6b04a75d0c$export$2e2bcd8739ae039();
}
class $e22c1c6b04a75d0c$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $e22c1c6b04a75d0c$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $fks50.string).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $fks50.string).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $fks50.string).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $fks50.string).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $dnIUX.default)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $fks50.string).email) {
        return this.matches($e22c1c6b04a75d0c$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $fks50.string).url) {
        return this.matches($e22c1c6b04a75d0c$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $fks50.string).uuid) {
        return this.matches($e22c1c6b04a75d0c$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $fks50.string).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $e22c1c6b04a75d0c$var$isTrimmed
        });
    }
    lowercase(message = (0, $fks50.string).lowercase) {
        return this.transform((value)=>!(0, $dnIUX.default)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $dnIUX.default)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $fks50.string).uppercase) {
        return this.transform((value)=>!(0, $dnIUX.default)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $dnIUX.default)(value) || value === value.toUpperCase()
        });
    }
}
$e22c1c6b04a75d0c$export$185802fd694ee1f5.prototype = $e22c1c6b04a75d0c$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //

});

parcelRegister("bTUek", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $8aa072e9b4686350$export$185802fd694ee1f5; });

var $fks50 = parcelRequire("fks50");

var $dnIUX = parcelRequire("dnIUX");

var $juS8c = parcelRequire("juS8c");
let $8aa072e9b4686350$var$isNaN = (value)=>value != +value;
function $8aa072e9b4686350$export$185802fd694ee1f5() {
    return new $8aa072e9b4686350$export$2e2bcd8739ae039();
}
class $8aa072e9b4686350$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$8aa072e9b4686350$var$isNaN(value);
    }
    min(min, message = (0, $fks50.number).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $fks50.number).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $fks50.number).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $fks50.number).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $fks50.number).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $fks50.number).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $fks50.number).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $dnIUX.default)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $dnIUX.default)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $dnIUX.default)(value) ? Math[method](value) : value);
    }
}
$8aa072e9b4686350$export$185802fd694ee1f5.prototype = $8aa072e9b4686350$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //

});

parcelRegister("a4Jo5", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $01e49ac69b1d8580$export$185802fd694ee1f5; });
// @ts-ignore

var $gxfM3 = parcelRequire("gxfM3");

var $fks50 = parcelRequire("fks50");

var $dnIUX = parcelRequire("dnIUX");

var $eQuBt = parcelRequire("eQuBt");

var $juS8c = parcelRequire("juS8c");
let $01e49ac69b1d8580$var$invalidDate = new Date("");
let $01e49ac69b1d8580$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $01e49ac69b1d8580$export$185802fd694ee1f5() {
    return new $01e49ac69b1d8580$export$2e2bcd8739ae039();
}
class $01e49ac69b1d8580$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $gxfM3.default)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $01e49ac69b1d8580$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $01e49ac69b1d8580$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $eQuBt.default).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $fks50.date).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $fks50.date).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$01e49ac69b1d8580$export$2e2bcd8739ae039.INVALID_DATE = $01e49ac69b1d8580$var$invalidDate;
$01e49ac69b1d8580$export$185802fd694ee1f5.prototype = $01e49ac69b1d8580$export$2e2bcd8739ae039.prototype;
$01e49ac69b1d8580$export$185802fd694ee1f5.INVALID_DATE = $01e49ac69b1d8580$var$invalidDate;

});
parcelRegister("gxfM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c09bf6d54c6bf5fa$export$2e2bcd8739ae039; });
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $c09bf6d54c6bf5fa$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $c09bf6d54c6bf5fa$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $c09bf6d54c6bf5fa$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}

});


parcelRegister("Gcg6o", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $07ed6eaee769934e$export$185802fd694ee1f5; });

var $gAMvg = parcelRequire("gAMvg");

var $jRVQF = parcelRequire("jRVQF");

var $k9utQ = parcelRequire("k9utQ");

var $4Kgvm = parcelRequire("4Kgvm");

var $eXq1E = parcelRequire("eXq1E");

var $53Q3M = parcelRequire("53Q3M");

var $fks50 = parcelRequire("fks50");

var $bvNYp = parcelRequire("bvNYp");

var $5wWoa = parcelRequire("5wWoa");

var $9JjUv = parcelRequire("9JjUv");

var $kRWYd = parcelRequire("kRWYd");

var $juS8c = parcelRequire("juS8c");
function $07ed6eaee769934e$var$_extends() {
    $07ed6eaee769934e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07ed6eaee769934e$var$_extends.apply(this, arguments);
}
let $07ed6eaee769934e$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $07ed6eaee769934e$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $07ed6eaee769934e$var$defaultSort = (0, $5wWoa.default)([]);
class $07ed6eaee769934e$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $07ed6eaee769934e$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $07ed6eaee769934e$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $07ed6eaee769934e$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($gAMvg)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $kRWYd.default).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$07ed6eaee769934e$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $07ed6eaee769934e$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $9JjUv.default)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $07ed6eaee769934e$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $juS8c.default) && schemaOrRef instanceof (0, $juS8c.default)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $5wWoa.default)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $bvNYp.default)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $53Q3M.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gAMvg)))(obj, from)) {
                newObj = $07ed6eaee769934e$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $fks50.object).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $07ed6eaee769934e$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $fks50.object).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($4Kgvm)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($k9utQ))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($jRVQF))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($jRVQF)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($eXq1E)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $07ed6eaee769934e$export$185802fd694ee1f5(spec) {
    return new $07ed6eaee769934e$export$2e2bcd8739ae039(spec);
}
$07ed6eaee769934e$export$185802fd694ee1f5.prototype = $07ed6eaee769934e$export$2e2bcd8739ae039.prototype;

});
parcelRegister("jRVQF", function(module, exports) {

var $kJ9zf = parcelRequire("kJ9zf");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $e76fd71524504221$var$snakeCase = $kJ9zf(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
module.exports = $e76fd71524504221$var$snakeCase;

});
parcelRegister("kJ9zf", function(module, exports) {

var $4q79a = parcelRequire("4q79a");

var $3yDPw = parcelRequire("3yDPw");

var $jpeG3 = parcelRequire("jpeG3");
/** Used to compose unicode capture groups. */ var $f16f6e87eac99537$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $f16f6e87eac99537$var$reApos = RegExp($f16f6e87eac99537$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $f16f6e87eac99537$var$createCompounder(callback) {
    return function(string) {
        return $4q79a($jpeG3($3yDPw(string).replace($f16f6e87eac99537$var$reApos, "")), callback, "");
    };
}
module.exports = $f16f6e87eac99537$var$createCompounder;

});
parcelRegister("4q79a", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $337f2253ac4d37bd$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $337f2253ac4d37bd$var$arrayReduce;

});

parcelRegister("3yDPw", function(module, exports) {

var $lW2Z0 = parcelRequire("lW2Z0");

var $1ZPOa = parcelRequire("1ZPOa");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $297371777df862b1$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $297371777df862b1$var$rsComboMarksRange = "\\u0300-\\u036f", $297371777df862b1$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $297371777df862b1$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $297371777df862b1$var$rsComboRange = $297371777df862b1$var$rsComboMarksRange + $297371777df862b1$var$reComboHalfMarksRange + $297371777df862b1$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $297371777df862b1$var$rsCombo = "[" + $297371777df862b1$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $297371777df862b1$var$reComboMark = RegExp($297371777df862b1$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $297371777df862b1$var$deburr(string) {
    string = $1ZPOa(string);
    return string && string.replace($297371777df862b1$var$reLatin, $lW2Z0).replace($297371777df862b1$var$reComboMark, "");
}
module.exports = $297371777df862b1$var$deburr;

});
parcelRegister("lW2Z0", function(module, exports) {

var $2fYXK = parcelRequire("2fYXK");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $041efd3a4d943550$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $041efd3a4d943550$var$deburrLetter = $2fYXK($041efd3a4d943550$var$deburredLetters);
module.exports = $041efd3a4d943550$var$deburrLetter;

});
parcelRegister("2fYXK", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $1a4c456d5d76708a$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $1a4c456d5d76708a$var$basePropertyOf;

});



parcelRegister("jpeG3", function(module, exports) {

var $5dC16 = parcelRequire("5dC16");

var $gCDLi = parcelRequire("gCDLi");

var $1ZPOa = parcelRequire("1ZPOa");

var $fZOsS = parcelRequire("fZOsS");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $e20bbcb394402ee5$var$words(string, pattern, guard) {
    string = $1ZPOa(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $gCDLi(string) ? $fZOsS(string) : $5dC16(string);
    return string.match(pattern) || [];
}
module.exports = $e20bbcb394402ee5$var$words;

});
parcelRegister("5dC16", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $3ccba7fc5c489b22$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3ccba7fc5c489b22$var$asciiWords(string) {
    return string.match($3ccba7fc5c489b22$var$reAsciiWord) || [];
}
module.exports = $3ccba7fc5c489b22$var$asciiWords;

});

parcelRegister("gCDLi", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $c19f09d3070eab51$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $c19f09d3070eab51$var$hasUnicodeWord(string) {
    return $c19f09d3070eab51$var$reHasUnicodeWord.test(string);
}
module.exports = $c19f09d3070eab51$var$hasUnicodeWord;

});

parcelRegister("fZOsS", function(module, exports) {
/** Used to compose unicode character classes. */ var $ba53b2c545439fa8$var$rsAstralRange = "\ud800-\udfff", $ba53b2c545439fa8$var$rsComboMarksRange = "\\u0300-\\u036f", $ba53b2c545439fa8$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ba53b2c545439fa8$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ba53b2c545439fa8$var$rsComboRange = $ba53b2c545439fa8$var$rsComboMarksRange + $ba53b2c545439fa8$var$reComboHalfMarksRange + $ba53b2c545439fa8$var$rsComboSymbolsRange, $ba53b2c545439fa8$var$rsDingbatRange = "\\u2700-\\u27bf", $ba53b2c545439fa8$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $ba53b2c545439fa8$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $ba53b2c545439fa8$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $ba53b2c545439fa8$var$rsPunctuationRange = "\\u2000-\\u206f", $ba53b2c545439fa8$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $ba53b2c545439fa8$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $ba53b2c545439fa8$var$rsVarRange = "\\ufe0e\\ufe0f", $ba53b2c545439fa8$var$rsBreakRange = $ba53b2c545439fa8$var$rsMathOpRange + $ba53b2c545439fa8$var$rsNonCharRange + $ba53b2c545439fa8$var$rsPunctuationRange + $ba53b2c545439fa8$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $ba53b2c545439fa8$var$rsApos = "['\u2019]", $ba53b2c545439fa8$var$rsBreak = "[" + $ba53b2c545439fa8$var$rsBreakRange + "]", $ba53b2c545439fa8$var$rsCombo = "[" + $ba53b2c545439fa8$var$rsComboRange + "]", $ba53b2c545439fa8$var$rsDigits = "\\d+", $ba53b2c545439fa8$var$rsDingbat = "[" + $ba53b2c545439fa8$var$rsDingbatRange + "]", $ba53b2c545439fa8$var$rsLower = "[" + $ba53b2c545439fa8$var$rsLowerRange + "]", $ba53b2c545439fa8$var$rsMisc = "[^" + $ba53b2c545439fa8$var$rsAstralRange + $ba53b2c545439fa8$var$rsBreakRange + $ba53b2c545439fa8$var$rsDigits + $ba53b2c545439fa8$var$rsDingbatRange + $ba53b2c545439fa8$var$rsLowerRange + $ba53b2c545439fa8$var$rsUpperRange + "]", $ba53b2c545439fa8$var$rsFitz = "\ud83c[\udffb-\udfff]", $ba53b2c545439fa8$var$rsModifier = "(?:" + $ba53b2c545439fa8$var$rsCombo + "|" + $ba53b2c545439fa8$var$rsFitz + ")", $ba53b2c545439fa8$var$rsNonAstral = "[^" + $ba53b2c545439fa8$var$rsAstralRange + "]", $ba53b2c545439fa8$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $ba53b2c545439fa8$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $ba53b2c545439fa8$var$rsUpper = "[" + $ba53b2c545439fa8$var$rsUpperRange + "]", $ba53b2c545439fa8$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $ba53b2c545439fa8$var$rsMiscLower = "(?:" + $ba53b2c545439fa8$var$rsLower + "|" + $ba53b2c545439fa8$var$rsMisc + ")", $ba53b2c545439fa8$var$rsMiscUpper = "(?:" + $ba53b2c545439fa8$var$rsUpper + "|" + $ba53b2c545439fa8$var$rsMisc + ")", $ba53b2c545439fa8$var$rsOptContrLower = "(?:" + $ba53b2c545439fa8$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $ba53b2c545439fa8$var$rsOptContrUpper = "(?:" + $ba53b2c545439fa8$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $ba53b2c545439fa8$var$reOptMod = $ba53b2c545439fa8$var$rsModifier + "?", $ba53b2c545439fa8$var$rsOptVar = "[" + $ba53b2c545439fa8$var$rsVarRange + "]?", $ba53b2c545439fa8$var$rsOptJoin = "(?:" + $ba53b2c545439fa8$var$rsZWJ + "(?:" + [
    $ba53b2c545439fa8$var$rsNonAstral,
    $ba53b2c545439fa8$var$rsRegional,
    $ba53b2c545439fa8$var$rsSurrPair
].join("|") + ")" + $ba53b2c545439fa8$var$rsOptVar + $ba53b2c545439fa8$var$reOptMod + ")*", $ba53b2c545439fa8$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $ba53b2c545439fa8$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $ba53b2c545439fa8$var$rsSeq = $ba53b2c545439fa8$var$rsOptVar + $ba53b2c545439fa8$var$reOptMod + $ba53b2c545439fa8$var$rsOptJoin, $ba53b2c545439fa8$var$rsEmoji = "(?:" + [
    $ba53b2c545439fa8$var$rsDingbat,
    $ba53b2c545439fa8$var$rsRegional,
    $ba53b2c545439fa8$var$rsSurrPair
].join("|") + ")" + $ba53b2c545439fa8$var$rsSeq;
/** Used to match complex or compound words. */ var $ba53b2c545439fa8$var$reUnicodeWord = RegExp([
    $ba53b2c545439fa8$var$rsUpper + "?" + $ba53b2c545439fa8$var$rsLower + "+" + $ba53b2c545439fa8$var$rsOptContrLower + "(?=" + [
        $ba53b2c545439fa8$var$rsBreak,
        $ba53b2c545439fa8$var$rsUpper,
        "$"
    ].join("|") + ")",
    $ba53b2c545439fa8$var$rsMiscUpper + "+" + $ba53b2c545439fa8$var$rsOptContrUpper + "(?=" + [
        $ba53b2c545439fa8$var$rsBreak,
        $ba53b2c545439fa8$var$rsUpper + $ba53b2c545439fa8$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $ba53b2c545439fa8$var$rsUpper + "?" + $ba53b2c545439fa8$var$rsMiscLower + "+" + $ba53b2c545439fa8$var$rsOptContrLower,
    $ba53b2c545439fa8$var$rsUpper + "+" + $ba53b2c545439fa8$var$rsOptContrUpper,
    $ba53b2c545439fa8$var$rsOrdUpper,
    $ba53b2c545439fa8$var$rsOrdLower,
    $ba53b2c545439fa8$var$rsDigits,
    $ba53b2c545439fa8$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $ba53b2c545439fa8$var$unicodeWords(string) {
    return string.match($ba53b2c545439fa8$var$reUnicodeWord) || [];
}
module.exports = $ba53b2c545439fa8$var$unicodeWords;

});




parcelRegister("k9utQ", function(module, exports) {

var $3uA24 = parcelRequire("3uA24");

var $kJ9zf = parcelRequire("kJ9zf");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $eabc4aae290ec733$var$camelCase = $kJ9zf(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $3uA24(word) : word);
});
module.exports = $eabc4aae290ec733$var$camelCase;

});
parcelRegister("3uA24", function(module, exports) {

var $1ZPOa = parcelRequire("1ZPOa");

var $6V3SA = parcelRequire("6V3SA");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $28b01fb9db81096e$var$capitalize(string) {
    return $6V3SA($1ZPOa(string).toLowerCase());
}
module.exports = $28b01fb9db81096e$var$capitalize;

});
parcelRegister("6V3SA", function(module, exports) {

var $dnC1A = parcelRequire("dnC1A");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $509b1353265e0aa1$var$upperFirst = $dnC1A("toUpperCase");
module.exports = $509b1353265e0aa1$var$upperFirst;

});
parcelRegister("dnC1A", function(module, exports) {

var $hJP57 = parcelRequire("hJP57");

var $l9Z6Y = parcelRequire("l9Z6Y");

var $frENi = parcelRequire("frENi");

var $1ZPOa = parcelRequire("1ZPOa");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $9bdaeb37b166b1e0$var$createCaseFirst(methodName) {
    return function(string) {
        string = $1ZPOa(string);
        var strSymbols = $l9Z6Y(string) ? $frENi(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $hJP57(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $9bdaeb37b166b1e0$var$createCaseFirst;

});
parcelRegister("hJP57", function(module, exports) {

var $anRTq = parcelRequire("anRTq");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $ce9e4364edf02fd9$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $anRTq(array, start, end);
}
module.exports = $ce9e4364edf02fd9$var$castSlice;

});
parcelRegister("anRTq", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $78f5db5d29ca7383$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $78f5db5d29ca7383$var$baseSlice;

});


parcelRegister("l9Z6Y", function(module, exports) {
/** Used to compose unicode character classes. */ var $f679d7ae37f45ebc$var$rsAstralRange = "\ud800-\udfff", $f679d7ae37f45ebc$var$rsComboMarksRange = "\\u0300-\\u036f", $f679d7ae37f45ebc$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $f679d7ae37f45ebc$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $f679d7ae37f45ebc$var$rsComboRange = $f679d7ae37f45ebc$var$rsComboMarksRange + $f679d7ae37f45ebc$var$reComboHalfMarksRange + $f679d7ae37f45ebc$var$rsComboSymbolsRange, $f679d7ae37f45ebc$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $f679d7ae37f45ebc$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $f679d7ae37f45ebc$var$reHasUnicode = RegExp("[" + $f679d7ae37f45ebc$var$rsZWJ + $f679d7ae37f45ebc$var$rsAstralRange + $f679d7ae37f45ebc$var$rsComboRange + $f679d7ae37f45ebc$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $f679d7ae37f45ebc$var$hasUnicode(string) {
    return $f679d7ae37f45ebc$var$reHasUnicode.test(string);
}
module.exports = $f679d7ae37f45ebc$var$hasUnicode;

});

parcelRegister("frENi", function(module, exports) {

var $6L3Zb = parcelRequire("6L3Zb");

var $l9Z6Y = parcelRequire("l9Z6Y");

var $eSgIC = parcelRequire("eSgIC");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b3e9057720c423ad$var$stringToArray(string) {
    return $l9Z6Y(string) ? $eSgIC(string) : $6L3Zb(string);
}
module.exports = $b3e9057720c423ad$var$stringToArray;

});
parcelRegister("6L3Zb", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $4eba395e966e3584$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $4eba395e966e3584$var$asciiToArray;

});

parcelRegister("eSgIC", function(module, exports) {
/** Used to compose unicode character classes. */ var $ad4313cf7a55e54c$var$rsAstralRange = "\ud800-\udfff", $ad4313cf7a55e54c$var$rsComboMarksRange = "\\u0300-\\u036f", $ad4313cf7a55e54c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ad4313cf7a55e54c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ad4313cf7a55e54c$var$rsComboRange = $ad4313cf7a55e54c$var$rsComboMarksRange + $ad4313cf7a55e54c$var$reComboHalfMarksRange + $ad4313cf7a55e54c$var$rsComboSymbolsRange, $ad4313cf7a55e54c$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $ad4313cf7a55e54c$var$rsAstral = "[" + $ad4313cf7a55e54c$var$rsAstralRange + "]", $ad4313cf7a55e54c$var$rsCombo = "[" + $ad4313cf7a55e54c$var$rsComboRange + "]", $ad4313cf7a55e54c$var$rsFitz = "\ud83c[\udffb-\udfff]", $ad4313cf7a55e54c$var$rsModifier = "(?:" + $ad4313cf7a55e54c$var$rsCombo + "|" + $ad4313cf7a55e54c$var$rsFitz + ")", $ad4313cf7a55e54c$var$rsNonAstral = "[^" + $ad4313cf7a55e54c$var$rsAstralRange + "]", $ad4313cf7a55e54c$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $ad4313cf7a55e54c$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $ad4313cf7a55e54c$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $ad4313cf7a55e54c$var$reOptMod = $ad4313cf7a55e54c$var$rsModifier + "?", $ad4313cf7a55e54c$var$rsOptVar = "[" + $ad4313cf7a55e54c$var$rsVarRange + "]?", $ad4313cf7a55e54c$var$rsOptJoin = "(?:" + $ad4313cf7a55e54c$var$rsZWJ + "(?:" + [
    $ad4313cf7a55e54c$var$rsNonAstral,
    $ad4313cf7a55e54c$var$rsRegional,
    $ad4313cf7a55e54c$var$rsSurrPair
].join("|") + ")" + $ad4313cf7a55e54c$var$rsOptVar + $ad4313cf7a55e54c$var$reOptMod + ")*", $ad4313cf7a55e54c$var$rsSeq = $ad4313cf7a55e54c$var$rsOptVar + $ad4313cf7a55e54c$var$reOptMod + $ad4313cf7a55e54c$var$rsOptJoin, $ad4313cf7a55e54c$var$rsSymbol = "(?:" + [
    $ad4313cf7a55e54c$var$rsNonAstral + $ad4313cf7a55e54c$var$rsCombo + "?",
    $ad4313cf7a55e54c$var$rsCombo,
    $ad4313cf7a55e54c$var$rsRegional,
    $ad4313cf7a55e54c$var$rsSurrPair,
    $ad4313cf7a55e54c$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $ad4313cf7a55e54c$var$reUnicode = RegExp($ad4313cf7a55e54c$var$rsFitz + "(?=" + $ad4313cf7a55e54c$var$rsFitz + ")|" + $ad4313cf7a55e54c$var$rsSymbol + $ad4313cf7a55e54c$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ad4313cf7a55e54c$var$unicodeToArray(string) {
    return string.match($ad4313cf7a55e54c$var$reUnicode) || [];
}
module.exports = $ad4313cf7a55e54c$var$unicodeToArray;

});






parcelRegister("4Kgvm", function(module, exports) {

var $kev44 = parcelRequire("kev44");

var $8I9P6 = parcelRequire("8I9P6");

var $kdg3I = parcelRequire("kdg3I");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $374842cf945f67b8$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $kdg3I(iteratee, 3);
    $8I9P6(object, function(value, key, object) {
        $kev44(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $374842cf945f67b8$var$mapKeys;

});

parcelRegister("bvNYp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86195a99a5231ca5$export$2e2bcd8739ae039; });

var $gAMvg = parcelRequire("gAMvg");

var $cdV3r = parcelRequire("cdV3r");

var $53Q3M = parcelRequire("53Q3M");

var $eQuBt = parcelRequire("eQuBt");

var $2QGDu = parcelRequire("2QGDu");
function $86195a99a5231ca5$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $53Q3M.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($gAMvg)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $eQuBt.default).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $2QGDu.default)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cdV3r))).array(Array.from(nodes), edges).reverse();
}

});
parcelRegister("cdV3r", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $8e62f4c6612f8c05$var$toposort($8e62f4c6612f8c05$var$uniqueNodes(edges), edges);
};
module.exports.array = $8e62f4c6612f8c05$var$toposort;
function $8e62f4c6612f8c05$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $8e62f4c6612f8c05$var$makeOutgoingEdges(edges), nodesHash = $8e62f4c6612f8c05$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $8e62f4c6612f8c05$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $8e62f4c6612f8c05$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $8e62f4c6612f8c05$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("5wWoa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $406d3bb63712bf20$export$2e2bcd8739ae039; });
function $406d3bb63712bf20$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $406d3bb63712bf20$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $406d3bb63712bf20$var$findIndex(keys, a) - $406d3bb63712bf20$var$findIndex(keys, b);
    };
}

});


parcelRegister("7GPfT", function(module, exports) {

var $dnIUX = parcelRequire("dnIUX");

var $2QGDu = parcelRequire("2QGDu");

var $5LXSO = parcelRequire("5LXSO");

var $fks50 = parcelRequire("fks50");

var $9JjUv = parcelRequire("9JjUv");

var $kRWYd = parcelRequire("kRWYd");

var $juS8c = parcelRequire("juS8c");
function $599436df3a8eb3ea$var$_extends() {
    $599436df3a8eb3ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $599436df3a8eb3ea$var$_extends.apply(this, arguments);
}
function $599436df3a8eb3ea$export$185802fd694ee1f5(type) {
    return new $599436df3a8eb3ea$export$2e2bcd8739ae039(type);
}
class $599436df3a8eb3ea$export$2e2bcd8739ae039 extends (0, $juS8c.default) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $599436df3a8eb3ea$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $kRWYd.default).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $599436df3a8eb3ea$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $9JjUv.default)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $2QGDu.default)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $5LXSO.default)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $fks50.array).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $fks50.array).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $dnIUX.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $fks50.array).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $dnIUX.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$599436df3a8eb3ea$export$185802fd694ee1f5.prototype = $599436df3a8eb3ea$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //

});

parcelRegister("ivNSw", function(module, exports) {

var $2QGDu = parcelRequire("2QGDu");
function $d7a1d0122c3ca06e$export$185802fd694ee1f5(builder) {
    return new $d7a1d0122c3ca06e$var$Lazy(builder);
}
class $d7a1d0122c3ca06e$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $2QGDu.default)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $d7a1d0122c3ca06e$export$2e2bcd8739ae039 = $d7a1d0122c3ca06e$var$Lazy;

});

parcelRegister("26JeK", function(module, exports) {

var $fks50 = parcelRequire("fks50");
function $188f3b6ebf98a652$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $fks50.default)[type][method] = custom[type][method];
        });
    });
}

});


parcelRegister("7FZyo", function(module, exports) {
$parcel$export(module.exports, "FormHeader", function () { return (parcelRequire("h1Lwc")).FormHeader; });
$parcel$export(module.exports, "SFormHeader", function () { return (parcelRequire("h1Lwc")).SFormHeader; });
parcelRequire("h1Lwc");

});
parcelRegister("h1Lwc", function(module, exports) {

$parcel$export(module.exports, "SFormHeader", function () { return $c40aa72017793161$export$6bdc4b1f7bae06d8; });
$parcel$export(module.exports, "FormHeader", function () { return $c40aa72017793161$export$97ee2cbf37e5ebfe; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $eIymc = parcelRequire("eIymc");
const $c40aa72017793161$export$6bdc4b1f7bae06d8 = (0, $gRonV.default).h1`
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: 36px;
    font-weight: var(--font-weight-normal);
    color: ${({ inverted: inverted })=>!inverted ? "#000" : "#fff"};

    b {
        font-weight: var(--font-weight-bold);
    }
`;
const $c40aa72017793161$var$Container = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;
function $c40aa72017793161$export$97ee2cbf37e5ebfe({ inverted: inverted, className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c40aa72017793161$export$6bdc4b1f7bae06d8, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "formHeader",
        inverted: inverted
    }, (0, $eIymc.isAdminDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, "Charging ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("b", null, "Admin")) : (0, $eIymc.isPartnerDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, "Charging ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("b", null, "Partner")) : (0, $eIymc.isSupportDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c40aa72017793161$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "Charging"
    }, "Charging"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("b", {
        "data-testid": "Support"
    }, "Support")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("b", null, "MyChargeSpace"));
}

});


parcelRegister("3T14g", function(module, exports) {
$parcel$export(module.exports, "InputGroup", function () { return (parcelRequire("aQa4T")).InputGroup; });
$parcel$export(module.exports, "SInput", function () { return (parcelRequire("aQa4T")).SInput; });
parcelRequire("aQa4T");

});
parcelRegister("aQa4T", function(module, exports) {

$parcel$export(module.exports, "SInput", function () { return $1bf381bce8907187$export$ec02fdd2f81d7149; });
$parcel$export(module.exports, "InputGroup", function () { return $1bf381bce8907187$export$6e5a9cd40e0c9b97; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");
const $1bf381bce8907187$export$226ffa6bd9142a44 = (0, $gRonV.default).label`
    font-size: 12px;
    color: #535353;
    font-weight: var(--font-weight-extra-light);
    position: absolute;
    pointer-events: none;
    top: -16px;
    left: 10px;
    transition: all 0.2s ease;
`;
const $1bf381bce8907187$export$ec02fdd2f81d7149 = (0, $gRonV.default).input`
    display: block;
    width: 100%;
    padding: 10px;
    padding-right: ${({ password: password })=>password ? "55px" : "10px"};
    margin-bottom: 20px;
    border-radius: 0;
    line-height: 1.2em;
    height: 40px;
    background-color: transparent;
    background: none;
    border: none;
    outline: none;

    &[type='password'] {
        ${({ hasText: hasText })=>{
    if (hasText) return `
                    font-family: Verdana, sans-serif;
                    letter-spacing: 0.1em;
                `;
}}
    }

    &.hidden {
        opacity: 0;
        position: relative;
        left: -100%;
    }

    ::placeholder {
        color: ${({ theme: theme, inverted: inverted })=>inverted ? theme.font.lightestColor : theme.font.midDarkColor};
        opacity: 1;
        font-weight: var(--font-weight-light);
    }
`;
const $1bf381bce8907187$export$55b64a111183d1fd = (0, $gRonV.default).div`
    position: relative;

    ${$1bf381bce8907187$export$226ffa6bd9142a44} {
        color: ${({ error: error, inverted: inverted })=>{
    if (error && inverted) return "#FF8B7C";
    if (error) return "#DF0017";
    if (inverted) return "#fff";
    return "#000";
}};
    }

    ${$1bf381bce8907187$export$ec02fdd2f81d7149} {
        border: ${({ inverted: inverted, error: error })=>{
    if (error && inverted) return "1px solid #FF8B7C";
    if (error) return "1px solid #df0017";
    return "none";
}};
        border-bottom: 1px solid
            ${({ inverted: inverted, error: error })=>{
    if (error && inverted) return "#FF8B7C";
    if (error) return "#df0017";
    if (inverted) return "#fff";
    return "#535353";
}};
    }

    //Removes the ugly autofill background
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: background-color 5000s;
        -webkit-text-fill-color: ${({ inverted: inverted })=>inverted ? "#fff" : "#000"} !important;
    }
`;
const $1bf381bce8907187$export$e79468314f1295c3 = (0, $gRonV.default).div`
    display: block;
    height: 15px;
    position: relative;
    top: 10px;
    margin-top: -30px;
    padding: 2px 10px;
    font-size: 14px;
    color: ${({ inverted: inverted })=>inverted ? "#FF8B7C" : "#df0017"};
`;
const $1bf381bce8907187$var$SMessage = (0, $gRonV.default)($1bf381bce8907187$export$e79468314f1295c3)`
    color: ${({ theme: theme })=>theme.font.midDarkColor};
`;
function $1bf381bce8907187$export$6e5a9cd40e0c9b97({ children: children, label: label, errorTestId: errorTestId, errorMsg: errorMsg, message: message, inverted: inverted, className: className, style: style, inputGroupRef: inputGroupRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        ref: inputGroupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($1bf381bce8907187$export$55b64a111183d1fd, {
        error: errorMsg ? true : false,
        inverted: inverted || false
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($1bf381bce8907187$export$226ffa6bd9142a44, null, label), children), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gRonV.ThemeProvider), {
        theme: (0, $3CLIQ.theme)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($1bf381bce8907187$var$SMessage, {
        inverted: inverted || false
    }, message)), errorMsg && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($1bf381bce8907187$export$e79468314f1295c3, {
        "data-testid": errorTestId,
        inverted: inverted || false
    }, errorMsg));
}

});


parcelRegister("ikjch", function(module, exports) {
$parcel$export(module.exports, "PasswordInput", function () { return (parcelRequire("57xxf")).PasswordInput; });
$parcel$export(module.exports, "SShowPasswordToggle", function () { return (parcelRequire("57xxf")).SShowPasswordToggle; });
parcelRequire("57xxf");

});
parcelRegister("57xxf", function(module, exports) {

$parcel$export(module.exports, "SShowPasswordToggle", function () { return $56efb313d2c73d9a$export$8fc5700b1c13e686; });
$parcel$export(module.exports, "PasswordInput", function () { return $56efb313d2c73d9a$export$b28585a458fee016; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("3T14g");
var $aQa4T = parcelRequire("aQa4T");
parcelRequire("dZVPQ");
var $7X2f7 = parcelRequire("7X2f7");

var $eIymc = parcelRequire("eIymc");
const $56efb313d2c73d9a$export$8fc5700b1c13e686 = (0, $gRonV.default).button`
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    border: none;
    outline: 0;
    background-color: transparent;
    text-transform: uppercase;
    font-size: 11px;
`;
function $56efb313d2c73d9a$export$b28585a458fee016({ showPassword: showPassword, onChange: onChange, label: label, placeholder: placeholder, name: name, autoComplete: autoComplete, toggleShowPasswordFlag: toggleShowPasswordFlag, hasText: hasText = false, message: message, error: error, errorTestId: errorTestId, className: className, style: style }) {
    const handleMouseDown = (0, $7E7Dk.useCallback)(()=>{
        toggleShowPasswordFlag(true);
        document.addEventListener("mouseup", ()=>{
            toggleShowPasswordFlag(false);
        }, {
            once: true
        });
        document.addEventListener("touchend", ()=>{
            toggleShowPasswordFlag(false);
        }, {
            once: true
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aQa4T.InputGroup), {
        label: label,
        message: message,
        errorMsg: error,
        inverted: (0, $eIymc.isSupportDomain),
        errorTestId: errorTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aQa4T.SInput), {
        name: name,
        autoComplete: autoComplete,
        type: showPassword ? "text" : "password",
        password: true,
        placeholder: placeholder,
        onChange: (event)=>onChange(event.currentTarget.value),
        hasText: hasText,
        inverted: (0, $eIymc.isSupportDomain),
        "data-testid": "passwordInput"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($56efb313d2c73d9a$export$8fc5700b1c13e686, {
        tabIndex: -1,
        type: "button",
        onMouseDown: ()=>handleMouseDown(),
        onTouchStart: ()=>handleMouseDown(),
        "data-testid": "eyeIconBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7X2f7.EyeIcon), {
        color: (0, $eIymc.isSupportDomain) ? "#fff" : "#535353"
    }))));
}

});
parcelRegister("dZVPQ", function(module, exports) {
$parcel$export(module.exports, "EyeIcon", function () { return (parcelRequire("7X2f7")).EyeIcon; });
parcelRequire("7X2f7");

});
parcelRegister("7X2f7", function(module, exports) {

$parcel$export(module.exports, "EyeIcon", function () { return $bb960046fdc9deca$export$4b2c798a70974642; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $bb960046fdc9deca$export$4b2c798a70974642({ className: className, style: style, width: width = 25, height: height = 19, color: color = "#535353" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "eyeIcon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#clip0_1340_4076)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M8.016 10.073c0 2.348 1.976 4.264 4.414 4.264 2.438 0 4.415-1.909 4.415-4.264 0-2.356-1.983-4.264-4.415-4.264-2.431 0-4.414 1.915-4.414 4.264Zm7.876 0c0 1.848-1.556 3.35-3.469 3.35-1.913 0-3.468-1.502-3.468-3.35s1.555-3.344 3.468-3.344 3.469 1.503 3.469 3.344Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M24.629 9.795c-.126-.162-1.976-2.43-4.814-4.304l-.616.724a22.811 22.811 0 0 1 4.442 3.864c-1.086 1.24-5.753 6.166-11.218 6.166S2.291 11.311 1.205 10.073c1.086-1.239 5.753-6.166 11.218-6.166 1.899 0 3.693.602 5.283 1.428l.624-.73C16.592 3.676 14.58 3 12.423 3 5.74 3 .448 9.518.224 9.795L0 10.073l.224.277c.224.278 5.515 6.795 12.2 6.795 6.684 0 11.98-6.517 12.198-6.795l.224-.277-.217-.278Z",
        fill: color
    })));
}

});




parcelRegister("j1Rmu", function(module, exports) {

$parcel$export(module.exports, "usePortalLoginFlow", function () { return $1a9fd5cd229f26a5$export$b981b917c406679; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");
parcelRequire("gJ5zm");
var $iIvSb = parcelRequire("iIvSb");

var $fIpd8 = parcelRequire("fIpd8");

var $ieP8o = parcelRequire("ieP8o");

var $73SrW = parcelRequire("73SrW");

var $9NTz2 = parcelRequire("9NTz2");

var $1sDHO = parcelRequire("1sDHO");

var $1O9Jh = parcelRequire("1O9Jh");

var $hw820 = parcelRequire("hw820");

var $r38ZI = parcelRequire("r38ZI");

var $1IBeB = parcelRequire("1IBeB");

var $gGcRO = parcelRequire("gGcRO");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");

var $7y3ec = parcelRequire("7y3ec");

var $jZWFX = parcelRequire("jZWFX");

var $joOkM = parcelRequire("joOkM");

var $5u6k9 = parcelRequire("5u6k9");
const $1a9fd5cd229f26a5$var$PORTAL_ACCESS_DENIED_MESSAGE = "Portal access denied";
const $1a9fd5cd229f26a5$export$b981b917c406679 = ({ from: from, locale: locale, setLocale: setLocale, setNotification: setNotification, navigate: navigate })=>{
    const text = (0, $5u6k9.default)();
    const toast = (0, $eBlmY.useToast)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const portal = (0, $fIpd8.getPortalState)(window.location.pathname);
    const applyOrganisationSelection = (0, $7y3ec.useApplyOrganisationSelection)();
    const cleanupRejectedPortalLogin = (0, $joOkM.useRejectedPortalLoginCleanup)();
    const dispatchApiAction = (0, $7E7Dk.useCallback)((action)=>dispatch(action), [
        dispatch
    ]);
    const [login, { isLoading: loginIsLoading }] = (0, $1O9Jh.useAuthLoginMutation)();
    const [getAuthCurrent, { isFetching: authCurrentIsLoading }] = (0, $1O9Jh.useLazyAuthGetCurrentQuery)();
    const [getUserHasChargePoints, { isLoading: chargePointIsLoading }] = (0, $1O9Jh.useLazyUserIsUserHasChargePointsQuery)();
    const [getAdminCompanies] = (0, $1O9Jh.useLazyCompanyGetAdministratedCompaniesQuery)();
    const [getUserSettings] = (0, $1O9Jh.useLazyUserGetUserSettingsQuery)();
    const [saveUserSettings] = (0, $1O9Jh.useUserUpdateUserSettingsMutation)();
    const [getEntitlements] = (0, $1O9Jh.useEntitlementsCreateContextTokenMutation)();
    const getPortalAccessDeniedMessage = (0, $7E7Dk.useCallback)(()=>{
        if (portal.isAdminDomain) return text("msgDeniedForNonAdministrators");
        if (portal.isPartnerDomain) return text("msgDeniedForNonPartners");
        if (portal.isSupportDomain) return text("msgAccessDeniedMustBeAdmin");
        return text("lblSomethingWentWrong");
    }, [
        portal.isAdminDomain,
        portal.isPartnerDomain,
        portal.isSupportDomain,
        text
    ]);
    const getLoginErrorMessage = (0, $7E7Dk.useCallback)((error)=>{
        if ((0, $gGcRO.isFetchBaseQueryError)(error)) {
            if (error.status === 401) return text("msgWrongCredentialsError");
            const errorMessage = typeof error.data === "object" && error.data !== null && "message" in error.data ? error.data.message : null;
            if (error.status === 403 && errorMessage === $1a9fd5cd229f26a5$var$PORTAL_ACCESS_DENIED_MESSAGE) return getPortalAccessDeniedMessage();
        }
        return text("lblSomethingWentWrong");
    }, [
        getPortalAccessDeniedMessage,
        text
    ]);
    const checkChargePoints = (0, $7E7Dk.useCallback)(async ()=>{
        try {
            const chargePointsExistence = await getUserHasChargePoints().unwrap();
            const hasChargePoints = chargePointsExistence.hasChargePoints === true;
            if (hasChargePoints) navigate(from, {
                replace: true
            });
            else navigate("/registerchargepoint", {
                replace: true
            });
            return true;
        } catch  {
            setNotification({
                text: "msgPleaseTryLoginLater",
                type: "alert"
            });
            await cleanupRejectedPortalLogin();
            return false;
        }
    }, [
        cleanupRejectedPortalLogin,
        from,
        getUserHasChargePoints,
        navigate,
        setNotification
    ]);
    const checkForAvailableOrganisations = (0, $7E7Dk.useCallback)(async (user)=>{
        try {
            const { data: organisations, isError: isError, error: error } = await getAdminCompanies(undefined);
            if (isError) throw error;
            if (user.selectedCompanyId) {
                try {
                    const authenticationServiceContextRequest = {
                        organizationId: user.selectedCompanyId
                    };
                    await getEntitlements({
                        authenticationServiceContextRequest: authenticationServiceContextRequest
                    }).unwrap();
                    await applyOrganisationSelection({
                        organizationId: user.selectedCompanyId,
                        broadcastAuthChange: false
                    });
                } catch  {
                    dispatch((0, $hw820.clearEntitlements)());
                    toast.notifyError(text("lblCouldNotGetEntitlements"));
                    await cleanupRejectedPortalLogin();
                    return false;
                }
                navigate(from, {
                    replace: true
                });
                return true;
            }
            if (organisations?.length === 1) {
                const organizationId = organisations[0]?.id;
                if (!organizationId) throw new Error("Single organisation is missing id");
                try {
                    const authenticationServiceContextRequest = {
                        organizationId: organizationId
                    };
                    await getEntitlements({
                        authenticationServiceContextRequest: authenticationServiceContextRequest
                    }).unwrap();
                    await applyOrganisationSelection({
                        organizationId: organizationId,
                        broadcastAuthChange: false
                    });
                } catch  {
                    dispatch((0, $hw820.clearEntitlements)());
                    toast.notifyError(text("lblCouldNotGetEntitlements"));
                    await cleanupRejectedPortalLogin();
                    return false;
                }
                navigate(from, {
                    replace: true
                });
                return true;
            }
            navigate("/select-organisation", {
                replace: true,
                state: {
                    from: from
                }
            });
            return true;
        } catch (exception) {
            (0, $r38ZI.notifyError)(exception instanceof Error ? exception.message : String(exception));
            await cleanupRejectedPortalLogin();
            return false;
        }
    }, [
        applyOrganisationSelection,
        cleanupRejectedPortalLogin,
        dispatch,
        from,
        getAdminCompanies,
        getEntitlements,
        navigate,
        text,
        toast
    ]);
    const loadAuthenticatedPortalSession = (0, $7E7Dk.useCallback)(async ()=>{
        dispatchApiAction((0, $1O9Jh.enhancedApi).util.resetApiState());
        const sessionData = await getAuthCurrent(undefined, false).unwrap();
        const sessionSnapshot = (0, $jZWFX.buildPortalSessionSnapshot)(sessionData, {
            currentDomain: portal.currentDomain,
            currentPortalAudience: portal.currentPortalAudience
        });
        if (!sessionSnapshot.sessionUser || !(0, $jZWFX.canHydratePortalSession)(sessionSnapshot, false)) throw new Error("Authenticated portal session could not be hydrated");
        return sessionSnapshot.sessionUser;
    }, [
        dispatchApiAction,
        getAuthCurrent,
        portal.currentDomain,
        portal.currentPortalAudience
    ]);
    const handleAuthenticatedLogin = (0, $7E7Dk.useCallback)(async ()=>{
        let normalizedUser;
        try {
            normalizedUser = await loadAuthenticatedPortalSession();
        } catch  {
            setNotification({
                text: "msgPleaseTryLoginLater",
                type: "alert"
            });
            await cleanupRejectedPortalLogin();
            return false;
        }
        if (portal.isPortalDomain) try {
            const response = await (0, $9NTz2.default)({
                url: `${(0, $73SrW.default)()}/csrf/handshake`,
                method: "GET",
                credentials: "include"
            });
            if (response.status < 400) (0, $ieP8o.setCsrfToken)((0, $ieP8o.readCsrfTokenFromResponse)(response));
        } catch  {
        // Authenticated unsafe requests will bootstrap CSRF on demand if needed.
        }
        try {
            const { data: settingsData } = await getUserSettings({
                userId: normalizedUser.id
            });
            const settings = Array.isArray(settingsData) ? settingsData : [];
            if (settings.length > 0) {
                const savedLanguage = settings.find((setting)=>setting.name === (0, $iIvSb.SettingName).LANGUAGE)?.value;
                if (!savedLanguage || locale !== savedLanguage) await saveUserSettings({
                    userId: normalizedUser.id,
                    body: [
                        {
                            name: (0, $iIvSb.SettingName).LANGUAGE,
                            value: locale
                        }
                    ]
                }).unwrap();
                else if (savedLanguage) setLocale(savedLanguage);
            }
            const hasGreenChargingInformed = settings.some((setting)=>setting.name === (0, $iIvSb.SettingName).GREEN_CHARGING_INFORMED);
            if (portal.isUserappDomain && !hasGreenChargingInformed) (0, $1sDHO.default).setItem("showGreenChargingModal", "true");
        } catch (error) {
            (0, $r38ZI.notifyError)(`Cannot load user settings: ${error}`);
        }
        if (portal.isUserappDomain) {
            if (!normalizedUser.personalAccept && !normalizedUser.companyAccept) {
                navigate("/user-agreement", {
                    replace: true
                });
                return true;
            }
            return checkChargePoints();
        }
        if (portal.isAdminDomain) return checkForAvailableOrganisations(normalizedUser);
        navigate(from, {
            replace: true
        });
        return true;
    }, [
        checkChargePoints,
        checkForAvailableOrganisations,
        from,
        getUserSettings,
        loadAuthenticatedPortalSession,
        locale,
        navigate,
        portal.isAdminDomain,
        portal.isPortalDomain,
        portal.isUserappDomain,
        saveUserSettings,
        setNotification,
        setLocale,
        cleanupRejectedPortalLogin
    ]);
    const submitLogin = (0, $7E7Dk.useCallback)(async (credentials)=>{
        try {
            await login({
                userCredentials: credentials
            }).unwrap();
            const loginSucceeded = await handleAuthenticatedLogin();
            if (loginSucceeded) (0, $1IBeB.triggerAuthChange)();
            return null;
        } catch (error) {
            return getLoginErrorMessage(error);
        }
    }, [
        getLoginErrorMessage,
        handleAuthenticatedLogin,
        login
    ]);
    return {
        loading: loginIsLoading || authCurrentIsLoading || chargePointIsLoading,
        submitLogin: submitLogin
    };
};

});
parcelRegister("gJ5zm", function(module, exports) {
$parcel$export(module.exports, "SettingName", function () { return (parcelRequire("iIvSb")).SettingName; });
$parcel$export(module.exports, "UserProfileLanguageSelect", function () { return (parcelRequire("iIvSb")).UserProfileLanguageSelect; });
parcelRequire("iIvSb");

});
parcelRegister("iIvSb", function(module, exports) {

$parcel$export(module.exports, "SettingName", function () { return $3d8191e39919d223$export$6dd258733f07abab; });
$parcel$export(module.exports, "UserProfileLanguageSelect", function () { return $3d8191e39919d223$export$c69e1c4e33707907; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("hhXpq");
var $2z9iD = parcelRequire("2z9iD");

var $893V1 = parcelRequire("893V1");
parcelRequire("2nOeJ");
var $bJ69a = parcelRequire("bJ69a");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $5u6k9 = parcelRequire("5u6k9");
var $3d8191e39919d223$export$6dd258733f07abab;
(function(SettingName) {
    SettingName["LANGUAGE"] = "Language";
    SettingName["GREEN_CHARGING_INFORMED"] = "GreenChargingInformed";
})($3d8191e39919d223$export$6dd258733f07abab || ($3d8191e39919d223$export$6dd258733f07abab = {}));
function $3d8191e39919d223$export$c69e1c4e33707907({ userId: userId }) {
    const text = (0, $5u6k9.default)();
    const [updateUserSettingRequest] = (0, $1O9Jh.useUserUpdateUserSettingsMutation)();
    const changeUserSettingRequest = async (language)=>{
        try {
            await updateUserSettingRequest({
                userId: userId,
                body: [
                    {
                        name: "Language",
                        value: language
                    }
                ]
            });
        } catch (error) {
            (0, $r38ZI.notifyError)(text("lblFailedLanguageUpdate"));
        }
    };
    const onChangeLanguage = (language)=>{
        changeUserSettingRequest(language);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bJ69a.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2z9iD.Header), {
            code: "lblLanguagePreference",
            className: "white-space-nowrap",
            "data-testid": "languageHeader"
        }),
        "data-testid": "languageSelect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $893V1.default), {
        onChange: onChangeLanguage,
        styles: {},
        asWidget: true
    }));
}

});
parcelRegister("hhXpq", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return (parcelRequire("2z9iD")).Header; });
$parcel$export(module.exports, "SContainer", function () { return (parcelRequire("2z9iD")).SContainer; });
parcelRequire("2z9iD");

});
parcelRegister("2z9iD", function(module, exports) {

$parcel$export(module.exports, "SContainer", function () { return $63148deaeb7974c7$export$626d401ce90fce61; });
$parcel$export(module.exports, "Header", function () { return $63148deaeb7974c7$export$8b251419efc915eb; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $g7dDc = parcelRequire("g7dDc");

var $a9SdK = parcelRequire("a9SdK");

var $igvrl = parcelRequire("igvrl");
const $63148deaeb7974c7$export$626d401ce90fce61 = (0, $gRonV.default).div`
    font-weight: var(--font-weight-bold);
    font-size: ${({ size: size })=>{
    if (size === "sm") return "1rem";
    if (size === "md") return "1.25rem";
    else return "2rem";
}};
    display: flex;
    align-items: center;
    gap: 5px;
    width: 50%;
    max-width: 50%;

    @media (max-width: ${({ theme: theme })=>theme.breakPoints.xl}) {
        width: 100%;
        max-width: 100%;
    }
`;
const $63148deaeb7974c7$var$SHeader = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
`;
const $63148deaeb7974c7$var$SMessage = (0, $gRonV.default).div`
    font-weight: var(--font-weight-normal);
`;
function $63148deaeb7974c7$export$8b251419efc915eb({ code: code, message: message, className: className, style: style, loading: loading, size: size = "md", dataTestId: dataTestId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($63148deaeb7974c7$export$626d401ce90fce61, {
        style: style,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($63148deaeb7974c7$var$SHeader, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        "data-testid": dataTestId ?? "header"
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: code
    }), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($63148deaeb7974c7$var$SMessage, null, message), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
        icon: (0, $a9SdK.faSpinner),
        pulse: true,
        className: "aweFontSizeSmall",
        "data-testid": "spinner"
    })));
}

});
parcelRegister("g7dDc", function(module, exports) {

$parcel$export(module.exports, "FontAwesomeIcon", function () { return $bbb7dfa92b11cd95$export$2b9260d4a45c8710; });

var $5gtz7 = parcelRequire("5gtz7");

var $jMvuK = parcelRequire("jMvuK");

var $7E7Dk = parcelRequire("7E7Dk");
function $bbb7dfa92b11cd95$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbb7dfa92b11cd95$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbb7dfa92b11cd95$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbb7dfa92b11cd95$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbb7dfa92b11cd95$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbb7dfa92b11cd95$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bbb7dfa92b11cd95$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bbb7dfa92b11cd95$var$_typeof(obj);
}
function $bbb7dfa92b11cd95$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbb7dfa92b11cd95$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bbb7dfa92b11cd95$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbb7dfa92b11cd95$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bbb7dfa92b11cd95$var$_toConsumableArray(arr) {
    return $bbb7dfa92b11cd95$var$_arrayWithoutHoles(arr) || $bbb7dfa92b11cd95$var$_iterableToArray(arr) || $bbb7dfa92b11cd95$var$_unsupportedIterableToArray(arr) || $bbb7dfa92b11cd95$var$_nonIterableSpread();
}
function $bbb7dfa92b11cd95$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bbb7dfa92b11cd95$var$_arrayLikeToArray(arr);
}
function $bbb7dfa92b11cd95$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bbb7dfa92b11cd95$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bbb7dfa92b11cd95$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bbb7dfa92b11cd95$var$_arrayLikeToArray(o, minLen);
}
function $bbb7dfa92b11cd95$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bbb7dfa92b11cd95$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $bbb7dfa92b11cd95$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $bbb7dfa92b11cd95$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $bbb7dfa92b11cd95$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $bbb7dfa92b11cd95$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $bbb7dfa92b11cd95$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $bbb7dfa92b11cd95$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $bbb7dfa92b11cd95$var$camelize(string) {
    if ($bbb7dfa92b11cd95$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $bbb7dfa92b11cd95$var$_excluded$1 = [
    "style"
];
function $bbb7dfa92b11cd95$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $bbb7dfa92b11cd95$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $bbb7dfa92b11cd95$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$bbb7dfa92b11cd95$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $bbb7dfa92b11cd95$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $bbb7dfa92b11cd95$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $bbb7dfa92b11cd95$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$bbb7dfa92b11cd95$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $bbb7dfa92b11cd95$var$_objectWithoutProperties(extraProps, $bbb7dfa92b11cd95$var$_excluded$1);
    mixins.attrs["style"] = $bbb7dfa92b11cd95$var$_objectSpread2($bbb7dfa92b11cd95$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $bbb7dfa92b11cd95$var$_objectSpread2($bbb7dfa92b11cd95$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($bbb7dfa92b11cd95$var$_toConsumableArray(children)));
}
var $bbb7dfa92b11cd95$var$PRODUCTION = false;
try {
    $bbb7dfa92b11cd95$var$PRODUCTION = true;
} catch (e) {}
function $bbb7dfa92b11cd95$var$log() {
    if (!$bbb7dfa92b11cd95$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $bbb7dfa92b11cd95$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $bbb7dfa92b11cd95$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $5gtz7.parse).icon) return (0, $5gtz7.parse).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $bbb7dfa92b11cd95$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $bbb7dfa92b11cd95$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $bbb7dfa92b11cd95$var$_defineProperty({}, key, value) : {};
}
var $bbb7dfa92b11cd95$var$_excluded = [
    "forwardedRef"
];
function $bbb7dfa92b11cd95$export$2b9260d4a45c8710(_ref) {
    var forwardedRef = _ref.forwardedRef, props = $bbb7dfa92b11cd95$var$_objectWithoutProperties(_ref, $bbb7dfa92b11cd95$var$_excluded);
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $bbb7dfa92b11cd95$var$normalizeIconArgs(iconArgs);
    var classes = $bbb7dfa92b11cd95$var$objectWithKey("classes", [].concat($bbb7dfa92b11cd95$var$_toConsumableArray($bbb7dfa92b11cd95$var$classList(props)), $bbb7dfa92b11cd95$var$_toConsumableArray(className.split(" "))));
    var transform = $bbb7dfa92b11cd95$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $5gtz7.parse).transform(props.transform) : props.transform);
    var mask = $bbb7dfa92b11cd95$var$objectWithKey("mask", $bbb7dfa92b11cd95$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $5gtz7.icon)(iconLookup, $bbb7dfa92b11cd95$var$_objectSpread2($bbb7dfa92b11cd95$var$_objectSpread2($bbb7dfa92b11cd95$var$_objectSpread2($bbb7dfa92b11cd95$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $bbb7dfa92b11cd95$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: forwardedRef
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$bbb7dfa92b11cd95$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $bbb7dfa92b11cd95$var$convertCurry(abstract[0], extraProps);
}
$bbb7dfa92b11cd95$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$bbb7dfa92b11cd95$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($jMvuK))).bool
};
$bbb7dfa92b11cd95$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $bbb7dfa92b11cd95$var$convertCurry = $bbb7dfa92b11cd95$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement);

});
parcelRegister("5gtz7", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $3d5561738373812d$export$98e6a39c04603d36; });
$parcel$export(module.exports, "icon", function () { return $3d5561738373812d$export$1ca1ec8b29a4ce27; });
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ function $3d5561738373812d$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3d5561738373812d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $3d5561738373812d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3d5561738373812d$var$_typeof(obj);
}
function $3d5561738373812d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3d5561738373812d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3d5561738373812d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3d5561738373812d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3d5561738373812d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3d5561738373812d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3d5561738373812d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $3d5561738373812d$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $3d5561738373812d$var$_slicedToArray(arr, i) {
    return $3d5561738373812d$var$_arrayWithHoles(arr) || $3d5561738373812d$var$_iterableToArrayLimit(arr, i) || $3d5561738373812d$var$_nonIterableRest();
}
function $3d5561738373812d$var$_toConsumableArray(arr) {
    return $3d5561738373812d$var$_arrayWithoutHoles(arr) || $3d5561738373812d$var$_iterableToArray(arr) || $3d5561738373812d$var$_nonIterableSpread();
}
function $3d5561738373812d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $3d5561738373812d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3d5561738373812d$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $3d5561738373812d$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3d5561738373812d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $3d5561738373812d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var $3d5561738373812d$var$noop = function noop() {};
var $3d5561738373812d$var$_WINDOW = {};
var $3d5561738373812d$var$_DOCUMENT = {};
var $3d5561738373812d$var$_MUTATION_OBSERVER = null;
var $3d5561738373812d$var$_PERFORMANCE = {
    mark: $3d5561738373812d$var$noop,
    measure: $3d5561738373812d$var$noop
};
try {
    if (typeof window !== "undefined") $3d5561738373812d$var$_WINDOW = window;
    if (typeof document !== "undefined") $3d5561738373812d$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $3d5561738373812d$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $3d5561738373812d$var$_PERFORMANCE = performance;
} catch (e) {}
var $3d5561738373812d$var$_ref = $3d5561738373812d$var$_WINDOW.navigator || {}, $3d5561738373812d$var$_ref$userAgent = $3d5561738373812d$var$_ref.userAgent, $3d5561738373812d$var$userAgent = $3d5561738373812d$var$_ref$userAgent === void 0 ? "" : $3d5561738373812d$var$_ref$userAgent;
var $3d5561738373812d$var$WINDOW = $3d5561738373812d$var$_WINDOW;
var $3d5561738373812d$var$DOCUMENT = $3d5561738373812d$var$_DOCUMENT;
var $3d5561738373812d$var$MUTATION_OBSERVER = $3d5561738373812d$var$_MUTATION_OBSERVER;
var $3d5561738373812d$var$PERFORMANCE = $3d5561738373812d$var$_PERFORMANCE;
var $3d5561738373812d$var$IS_BROWSER = !!$3d5561738373812d$var$WINDOW.document;
var $3d5561738373812d$var$IS_DOM = !!$3d5561738373812d$var$DOCUMENT.documentElement && !!$3d5561738373812d$var$DOCUMENT.head && typeof $3d5561738373812d$var$DOCUMENT.addEventListener === "function" && typeof $3d5561738373812d$var$DOCUMENT.createElement === "function";
var $3d5561738373812d$var$IS_IE = ~$3d5561738373812d$var$userAgent.indexOf("MSIE") || ~$3d5561738373812d$var$userAgent.indexOf("Trident/");
var $3d5561738373812d$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $3d5561738373812d$var$UNITS_IN_GRID = 16;
var $3d5561738373812d$var$DEFAULT_FAMILY_PREFIX = "fa";
var $3d5561738373812d$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $3d5561738373812d$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $3d5561738373812d$var$DATA_PREFIX = "data-prefix";
var $3d5561738373812d$var$DATA_ICON = "data-icon";
var $3d5561738373812d$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $3d5561738373812d$var$MUTATION_APPROACH_ASYNC = "async";
var $3d5561738373812d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $3d5561738373812d$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $3d5561738373812d$var$PREFIX_TO_STYLE = {
    "fas": "solid",
    "far": "regular",
    "fal": "light",
    "fad": "duotone",
    "fab": "brands",
    "fak": "kit",
    "fa": "solid"
};
var $3d5561738373812d$var$STYLE_TO_PREFIX = {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "duotone": "fad",
    "brands": "fab",
    "kit": "fak"
};
var $3d5561738373812d$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $3d5561738373812d$var$FONT_FAMILY_PATTERN = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $3d5561738373812d$var$FONT_WEIGHT_TO_PREFIX = {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal"
};
var $3d5561738373812d$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $3d5561738373812d$var$oneToTwenty = $3d5561738373812d$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $3d5561738373812d$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $3d5561738373812d$var$DUOTONE_CLASSES = {
    GROUP: "group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $3d5561738373812d$var$RESERVED_CLASSES = [
    "xs",
    "sm",
    "lg",
    "fw",
    "ul",
    "li",
    "border",
    "pull-left",
    "pull-right",
    "spin",
    "pulse",
    "rotate-90",
    "rotate-180",
    "rotate-270",
    "flip-horizontal",
    "flip-vertical",
    "flip-both",
    "stack",
    "stack-1x",
    "stack-2x",
    "inverse",
    "layers",
    "layers-text",
    "layers-counter",
    $3d5561738373812d$var$DUOTONE_CLASSES.GROUP,
    $3d5561738373812d$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $3d5561738373812d$var$DUOTONE_CLASSES.PRIMARY,
    $3d5561738373812d$var$DUOTONE_CLASSES.SECONDARY
].concat($3d5561738373812d$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($3d5561738373812d$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $3d5561738373812d$var$initial = $3d5561738373812d$var$WINDOW.FontAwesomeConfig || {};
function $3d5561738373812d$var$getAttrConfig(attr) {
    var element = $3d5561738373812d$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $3d5561738373812d$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($3d5561738373812d$var$DOCUMENT && typeof $3d5561738373812d$var$DOCUMENT.querySelector === "function") {
    var $3d5561738373812d$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $3d5561738373812d$var$attrs.forEach(function(_ref) {
        var _ref2 = $3d5561738373812d$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $3d5561738373812d$var$coerce($3d5561738373812d$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $3d5561738373812d$var$initial[key] = val;
    });
}
var $3d5561738373812d$var$_default = {
    familyPrefix: $3d5561738373812d$var$DEFAULT_FAMILY_PREFIX,
    replacementClass: $3d5561738373812d$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $3d5561738373812d$var$_config = $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$_default, $3d5561738373812d$var$initial);
if (!$3d5561738373812d$var$_config.autoReplaceSvg) $3d5561738373812d$var$_config.observeMutations = false;
var $3d5561738373812d$export$e506a1d27d1eaa20 = $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$_config);
$3d5561738373812d$var$WINDOW.FontAwesomeConfig = $3d5561738373812d$export$e506a1d27d1eaa20;
var $3d5561738373812d$var$w = $3d5561738373812d$var$WINDOW || {};
if (!$3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER]) $3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER] = {};
if (!$3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].styles) $3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].hooks) $3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].shims) $3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER].shims = [];
var $3d5561738373812d$var$namespace = $3d5561738373812d$var$w[$3d5561738373812d$var$NAMESPACE_IDENTIFIER];
var $3d5561738373812d$var$functions = [];
var $3d5561738373812d$var$listener = function listener() {
    $3d5561738373812d$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $3d5561738373812d$var$loaded = 1;
    $3d5561738373812d$var$functions.map(function(fn) {
        return fn();
    });
};
var $3d5561738373812d$var$loaded = false;
if ($3d5561738373812d$var$IS_DOM) {
    $3d5561738373812d$var$loaded = ($3d5561738373812d$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($3d5561738373812d$var$DOCUMENT.readyState);
    if (!$3d5561738373812d$var$loaded) $3d5561738373812d$var$DOCUMENT.addEventListener("DOMContentLoaded", $3d5561738373812d$var$listener);
}
function $3d5561738373812d$var$domready(fn) {
    if (!$3d5561738373812d$var$IS_DOM) return;
    $3d5561738373812d$var$loaded ? setTimeout(fn, 0) : $3d5561738373812d$var$functions.push(fn);
}
var $3d5561738373812d$var$PENDING = "pending";
var $3d5561738373812d$var$SETTLED = "settled";
var $3d5561738373812d$var$FULFILLED = "fulfilled";
var $3d5561738373812d$var$REJECTED = "rejected";
var $3d5561738373812d$var$NOOP = function NOOP() {};
var $3d5561738373812d$var$isNode = typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && typeof $parcel$global.process.emit === "function";
var $3d5561738373812d$var$asyncSetTimer = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
var $3d5561738373812d$var$asyncQueue = [];
var $3d5561738373812d$var$asyncTimer;
function $3d5561738373812d$var$asyncFlush() {
    // run promise callbacks
    for(var i = 0; i < $3d5561738373812d$var$asyncQueue.length; i++)$3d5561738373812d$var$asyncQueue[i][0]($3d5561738373812d$var$asyncQueue[i][1]);
     // reset async asyncQueue
    $3d5561738373812d$var$asyncQueue = [];
    $3d5561738373812d$var$asyncTimer = false;
}
function $3d5561738373812d$var$asyncCall(callback, arg) {
    $3d5561738373812d$var$asyncQueue.push([
        callback,
        arg
    ]);
    if (!$3d5561738373812d$var$asyncTimer) {
        $3d5561738373812d$var$asyncTimer = true;
        $3d5561738373812d$var$asyncSetTimer($3d5561738373812d$var$asyncFlush, 0);
    }
}
function $3d5561738373812d$var$invokeResolver(resolver, promise) {
    function resolvePromise(value) {
        $3d5561738373812d$var$resolve(promise, value);
    }
    function rejectPromise(reason) {
        $3d5561738373812d$var$reject(promise, reason);
    }
    try {
        resolver(resolvePromise, rejectPromise);
    } catch (e) {
        rejectPromise(e);
    }
}
function $3d5561738373812d$var$invokeCallback(subscriber) {
    var owner = subscriber.owner;
    var settled = owner._state;
    var value = owner._data;
    var callback = subscriber[settled];
    var promise = subscriber.then;
    if (typeof callback === "function") {
        settled = $3d5561738373812d$var$FULFILLED;
        try {
            value = callback(value);
        } catch (e) {
            $3d5561738373812d$var$reject(promise, e);
        }
    }
    if (!$3d5561738373812d$var$handleThenable(promise, value)) {
        if (settled === $3d5561738373812d$var$FULFILLED) $3d5561738373812d$var$resolve(promise, value);
        if (settled === $3d5561738373812d$var$REJECTED) $3d5561738373812d$var$reject(promise, value);
    }
}
function $3d5561738373812d$var$handleThenable(promise, value) {
    var resolved;
    try {
        if (promise === value) throw new TypeError("A promises callback cannot return that same promise.");
        if (value && (typeof value === "function" || $3d5561738373812d$var$_typeof(value) === "object")) {
            // then should be retrieved only once
            var then = value.then;
            if (typeof then === "function") {
                then.call(value, function(val) {
                    if (!resolved) {
                        resolved = true;
                        if (value === val) $3d5561738373812d$var$fulfill(promise, val);
                        else $3d5561738373812d$var$resolve(promise, val);
                    }
                }, function(reason) {
                    if (!resolved) {
                        resolved = true;
                        $3d5561738373812d$var$reject(promise, reason);
                    }
                });
                return true;
            }
        }
    } catch (e) {
        if (!resolved) $3d5561738373812d$var$reject(promise, e);
        return true;
    }
    return false;
}
function $3d5561738373812d$var$resolve(promise, value) {
    if (promise === value || !$3d5561738373812d$var$handleThenable(promise, value)) $3d5561738373812d$var$fulfill(promise, value);
}
function $3d5561738373812d$var$fulfill(promise, value) {
    if (promise._state === $3d5561738373812d$var$PENDING) {
        promise._state = $3d5561738373812d$var$SETTLED;
        promise._data = value;
        $3d5561738373812d$var$asyncCall($3d5561738373812d$var$publishFulfillment, promise);
    }
}
function $3d5561738373812d$var$reject(promise, reason) {
    if (promise._state === $3d5561738373812d$var$PENDING) {
        promise._state = $3d5561738373812d$var$SETTLED;
        promise._data = reason;
        $3d5561738373812d$var$asyncCall($3d5561738373812d$var$publishRejection, promise);
    }
}
function $3d5561738373812d$var$publish(promise) {
    promise._then = promise._then.forEach($3d5561738373812d$var$invokeCallback);
}
function $3d5561738373812d$var$publishFulfillment(promise) {
    promise._state = $3d5561738373812d$var$FULFILLED;
    $3d5561738373812d$var$publish(promise);
}
function $3d5561738373812d$var$publishRejection(promise) {
    promise._state = $3d5561738373812d$var$REJECTED;
    $3d5561738373812d$var$publish(promise);
    if (!promise._handled && $3d5561738373812d$var$isNode) $parcel$global.process.emit("unhandledRejection", promise._data, promise);
}
function $3d5561738373812d$var$notifyRejectionHandled(promise) {
    $parcel$global.process.emit("rejectionHandled", promise);
}
/**
 * @class
 */ function $3d5561738373812d$var$P(resolver) {
    if (typeof resolver !== "function") throw new TypeError("Promise resolver " + resolver + " is not a function");
    if (this instanceof $3d5561738373812d$var$P === false) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    this._then = [];
    $3d5561738373812d$var$invokeResolver(resolver, this);
}
$3d5561738373812d$var$P.prototype = {
    constructor: $3d5561738373812d$var$P,
    _state: $3d5561738373812d$var$PENDING,
    _then: null,
    _data: undefined,
    _handled: false,
    then: function then(onFulfillment, onRejection) {
        var subscriber = {
            owner: this,
            then: new this.constructor($3d5561738373812d$var$NOOP),
            fulfilled: onFulfillment,
            rejected: onRejection
        };
        if ((onRejection || onFulfillment) && !this._handled) {
            this._handled = true;
            if (this._state === $3d5561738373812d$var$REJECTED && $3d5561738373812d$var$isNode) $3d5561738373812d$var$asyncCall($3d5561738373812d$var$notifyRejectionHandled, this);
        }
        if (this._state === $3d5561738373812d$var$FULFILLED || this._state === $3d5561738373812d$var$REJECTED) // already resolved, call callback async
        $3d5561738373812d$var$asyncCall($3d5561738373812d$var$invokeCallback, subscriber);
        else // subscribe
        this._then.push(subscriber);
        return subscriber.then;
    },
    catch: function _catch(onRejection) {
        return this.then(null, onRejection);
    }
};
$3d5561738373812d$var$P.all = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.all().");
    return new $3d5561738373812d$var$P(function(resolve, reject) {
        var results = [];
        var remaining = 0;
        function resolver(index) {
            remaining++;
            return function(value) {
                results[index] = value;
                if (!--remaining) resolve(results);
            };
        }
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolver(i), reject);
            else results[i] = promise;
        }
        if (!remaining) resolve(results);
    });
};
$3d5561738373812d$var$P.race = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.race().");
    return new $3d5561738373812d$var$P(function(resolve, reject) {
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolve, reject);
            else resolve(promise);
        }
    });
};
$3d5561738373812d$var$P.resolve = function(value) {
    if (value && $3d5561738373812d$var$_typeof(value) === "object" && value.constructor === $3d5561738373812d$var$P) return value;
    return new $3d5561738373812d$var$P(function(resolve) {
        resolve(value);
    });
};
$3d5561738373812d$var$P.reject = function(reason) {
    return new $3d5561738373812d$var$P(function(resolve, reject) {
        reject(reason);
    });
};
var $3d5561738373812d$var$picked = typeof Promise === "function" ? Promise : $3d5561738373812d$var$P;
var $3d5561738373812d$var$d = $3d5561738373812d$var$UNITS_IN_GRID;
var $3d5561738373812d$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $3d5561738373812d$var$isReserved(name) {
    return ~$3d5561738373812d$var$RESERVED_CLASSES.indexOf(name);
}
function $3d5561738373812d$var$insertCss(css) {
    if (!css || !$3d5561738373812d$var$IS_DOM) return;
    var style = $3d5561738373812d$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $3d5561738373812d$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $3d5561738373812d$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $3d5561738373812d$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $3d5561738373812d$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $3d5561738373812d$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $3d5561738373812d$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $3d5561738373812d$var$classArray(node) {
    if (node.classList) return $3d5561738373812d$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $3d5561738373812d$var$getIconName(familyPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === familyPrefix && iconName !== "" && !$3d5561738373812d$var$isReserved(iconName)) return iconName;
    else return null;
}
function $3d5561738373812d$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $3d5561738373812d$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($3d5561738373812d$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $3d5561738373812d$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, "");
}
function $3d5561738373812d$var$transformIsMeaningful(transform) {
    return transform.size !== $3d5561738373812d$var$meaninglessTransform.size || transform.x !== $3d5561738373812d$var$meaninglessTransform.x || transform.y !== $3d5561738373812d$var$meaninglessTransform.y || transform.rotate !== $3d5561738373812d$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $3d5561738373812d$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $3d5561738373812d$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $3d5561738373812d$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $3d5561738373812d$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $3d5561738373812d$var$IS_IE) val += "translate(".concat(transform.x / $3d5561738373812d$var$d - width / 2, "em, ").concat(transform.y / $3d5561738373812d$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $3d5561738373812d$var$d, "em), calc(-50% + ").concat(transform.y / $3d5561738373812d$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $3d5561738373812d$var$d, "em, ").concat(transform.y / $3d5561738373812d$var$d, "em) ");
    val += "scale(".concat(transform.size / $3d5561738373812d$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $3d5561738373812d$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $3d5561738373812d$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $3d5561738373812d$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $3d5561738373812d$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
function $3d5561738373812d$var$makeIconMasking(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
    var mainWidth = main.width, mainPath = main.icon;
    var maskWidth = mask.width, maskPath = mask.icon;
    var trans = $3d5561738373812d$var$transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
    });
    var maskRect = {
        tag: "rect",
        attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$ALL_SPACE, {
            fill: "white"
        })
    };
    var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map($3d5561738373812d$var$fillBlack)
    } : {};
    var maskInnerGroup = {
        tag: "g",
        attributes: $3d5561738373812d$var$_objectSpread({}, trans.inner),
        children: [
            $3d5561738373812d$var$fillBlack($3d5561738373812d$var$_objectSpread({
                tag: mainPath.tag,
                attributes: $3d5561738373812d$var$_objectSpread({}, mainPath.attributes, trans.path)
            }, maskInnerGroupChildrenMixin))
        ]
    };
    var maskOuterGroup = {
        tag: "g",
        attributes: $3d5561738373812d$var$_objectSpread({}, trans.outer),
        children: [
            maskInnerGroup
        ]
    };
    var maskId = "mask-".concat(explicitMaskId || $3d5561738373812d$var$nextUniqueId());
    var clipId = "clip-".concat(explicitMaskId || $3d5561738373812d$var$nextUniqueId());
    var maskTag = {
        tag: "mask",
        attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$ALL_SPACE, {
            id: maskId,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
        }),
        children: [
            maskRect,
            maskOuterGroup
        ]
    };
    var defs = {
        tag: "defs",
        children: [
            {
                tag: "clipPath",
                attributes: {
                    id: clipId
                },
                children: $3d5561738373812d$var$deGroup(maskPath)
            },
            maskTag
        ]
    };
    children.push(defs, {
        tag: "rect",
        attributes: $3d5561738373812d$var$_objectSpread({
            fill: "currentColor",
            "clip-path": "url(#".concat(clipId, ")"),
            mask: "url(#".concat(maskId, ")")
        }, $3d5561738373812d$var$ALL_SPACE)
    });
    return {
        children: children,
        attributes: attributes
    };
}
function $3d5561738373812d$var$makeIconStandard(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
    var styleString = $3d5561738373812d$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    if ($3d5561738373812d$var$transformIsMeaningful(transform)) {
        var trans = $3d5561738373812d$var$transformForSvg({
            transform: transform,
            containerWidth: main.width,
            iconWidth: main.width
        });
        children.push({
            tag: "g",
            attributes: $3d5561738373812d$var$_objectSpread({}, trans.outer),
            children: [
                {
                    tag: "g",
                    attributes: $3d5561738373812d$var$_objectSpread({}, trans.inner),
                    children: [
                        {
                            tag: main.icon.tag,
                            children: main.icon.children,
                            attributes: $3d5561738373812d$var$_objectSpread({}, main.icon.attributes, trans.path)
                        }
                    ]
                }
            ]
        });
    } else children.push(main.icon);
    return {
        children: children,
        attributes: attributes
    };
}
function $3d5561738373812d$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($3d5561738373812d$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $3d5561738373812d$var$joinStyles($3d5561738373812d$var$_objectSpread({}, styles, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $3d5561738373812d$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $3d5561738373812d$var$_objectSpread({}, attributes, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $3d5561738373812d$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var widthClass = isUploadedIcon ? "" : "fa-w-".concat(Math.ceil(width / height * 16));
    var attrClass = [
        $3d5561738373812d$export$e506a1d27d1eaa20.replacementClass,
        iconName ? "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : "",
        widthClass
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $3d5561738373812d$var$_objectSpread({}, extra.attributes, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$3d5561738373812d$var$DATA_FA_I2SVG] = "";
    if (title) content.children.push({
        tag: "title",
        attributes: {
            id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $3d5561738373812d$var$nextUniqueId())
        },
        children: [
            title
        ]
    });
    var args = $3d5561738373812d$var$_objectSpread({}, content, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $3d5561738373812d$var$_objectSpread({}, uploadedIconWidthStyle, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $3d5561738373812d$var$makeIconMasking(args) : $3d5561738373812d$var$makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $3d5561738373812d$var$asSymbol(args);
    else return $3d5561738373812d$var$asIcon(args);
}
function $3d5561738373812d$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $3d5561738373812d$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$3d5561738373812d$var$DATA_FA_I2SVG] = "";
    var styles = $3d5561738373812d$var$_objectSpread({}, extra.styles);
    if ($3d5561738373812d$var$transformIsMeaningful(transform)) {
        styles["transform"] = $3d5561738373812d$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $3d5561738373812d$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $3d5561738373812d$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $3d5561738373812d$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $3d5561738373812d$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $3d5561738373812d$var$noop$1 = function noop() {};
var $3d5561738373812d$var$p = $3d5561738373812d$export$e506a1d27d1eaa20.measurePerformance && $3d5561738373812d$var$PERFORMANCE && $3d5561738373812d$var$PERFORMANCE.mark && $3d5561738373812d$var$PERFORMANCE.measure ? $3d5561738373812d$var$PERFORMANCE : {
    mark: $3d5561738373812d$var$noop$1,
    measure: $3d5561738373812d$var$noop$1
};
var $3d5561738373812d$var$preamble = 'FA "5.15.4"';
var $3d5561738373812d$var$begin = function begin(name) {
    $3d5561738373812d$var$p.mark("".concat($3d5561738373812d$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $3d5561738373812d$var$end(name);
    };
};
var $3d5561738373812d$var$end = function end(name) {
    $3d5561738373812d$var$p.mark("".concat($3d5561738373812d$var$preamble, " ").concat(name, " ends"));
    $3d5561738373812d$var$p.measure("".concat($3d5561738373812d$var$preamble, " ").concat(name), "".concat($3d5561738373812d$var$preamble, " ").concat(name, " begins"), "".concat($3d5561738373812d$var$preamble, " ").concat(name, " ends"));
};
var $3d5561738373812d$var$perf = {
    begin: $3d5561738373812d$var$begin,
    end: $3d5561738373812d$var$end
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $3d5561738373812d$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $3d5561738373812d$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $3d5561738373812d$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
function $3d5561738373812d$var$toHex(unicode) {
    var result = "";
    for(var i = 0; i < unicode.length; i++){
        var hex = unicode.charCodeAt(i).toString(16);
        result += ("000" + hex).slice(-4);
    }
    return result;
}
function $3d5561738373812d$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
    if (typeof $3d5561738373812d$var$namespace.hooks.addPack === "function" && !skipHooks) $3d5561738373812d$var$namespace.hooks.addPack(prefix, normalized);
    else $3d5561738373812d$var$namespace.styles[prefix] = $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$namespace.styles[prefix] || {}, normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $3d5561738373812d$var$defineIcons("fa", icons);
}
var $3d5561738373812d$var$styles = $3d5561738373812d$var$namespace.styles, $3d5561738373812d$var$shims = $3d5561738373812d$var$namespace.shims;
var $3d5561738373812d$var$_byUnicode = {};
var $3d5561738373812d$var$_byLigature = {};
var $3d5561738373812d$var$_byOldName = {};
var $3d5561738373812d$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $3d5561738373812d$var$reduce($3d5561738373812d$var$styles, function(o, style, prefix) {
            o[prefix] = $3d5561738373812d$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $3d5561738373812d$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        return acc;
    });
    $3d5561738373812d$var$_byLigature = lookup(function(acc, icon, iconName) {
        var ligatures = icon[2];
        acc[iconName] = iconName;
        ligatures.forEach(function(ligature) {
            acc[ligature] = iconName;
        });
        return acc;
    });
    var hasRegular = "far" in $3d5561738373812d$var$styles;
    $3d5561738373812d$var$_byOldName = $3d5561738373812d$var$reduce($3d5561738373812d$var$shims, function(acc, shim) {
        var oldName = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        acc[oldName] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {});
};
$3d5561738373812d$var$build();
function $3d5561738373812d$var$byUnicode(prefix, unicode) {
    return ($3d5561738373812d$var$_byUnicode[prefix] || {})[unicode];
}
function $3d5561738373812d$var$byLigature(prefix, ligature) {
    return ($3d5561738373812d$var$_byLigature[prefix] || {})[ligature];
}
function $3d5561738373812d$var$byOldName(name) {
    return $3d5561738373812d$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
var $3d5561738373812d$var$styles$1 = $3d5561738373812d$var$namespace.styles;
var $3d5561738373812d$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $3d5561738373812d$var$getCanonicalIcon(values) {
    return values.reduce(function(acc, cls) {
        var iconName = $3d5561738373812d$var$getIconName($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, cls);
        if ($3d5561738373812d$var$styles$1[cls]) acc.prefix = cls;
        else if ($3d5561738373812d$export$e506a1d27d1eaa20.autoFetchSvg && Object.keys($3d5561738373812d$var$PREFIX_TO_STYLE).indexOf(cls) > -1) acc.prefix = cls;
        else if (iconName) {
            var shim = acc.prefix === "fa" ? $3d5561738373812d$var$byOldName(iconName) : {};
            acc.iconName = shim.iconName || iconName;
            acc.prefix = shim.prefix || acc.prefix;
        } else if (cls !== $3d5561738373812d$export$e506a1d27d1eaa20.replacementClass && cls.indexOf("fa-w-") !== 0) acc.rest.push(cls);
        return acc;
    }, $3d5561738373812d$var$emptyCanonicalIcon());
}
function $3d5561738373812d$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
function $3d5561738373812d$export$a10125c086a4df16(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $3d5561738373812d$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($3d5561738373812d$var$joinAttributes(attributes), ">").concat(children.map($3d5561738373812d$export$a10125c086a4df16).join(""), "</").concat(tag, ">");
}
var $3d5561738373812d$var$noop$2 = function noop() {};
function $3d5561738373812d$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($3d5561738373812d$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $3d5561738373812d$var$getMutator() {
    if ($3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg === true) return $3d5561738373812d$var$mutators.replace;
    var mutator = $3d5561738373812d$var$mutators[$3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg];
    return mutator || $3d5561738373812d$var$mutators.replace;
}
var $3d5561738373812d$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        var newOuterHTML = abstract.map(function(a) {
            return $3d5561738373812d$export$a10125c086a4df16(a);
        }).join("\n");
        if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + ($3d5561738373812d$export$e506a1d27d1eaa20.keepOriginalSource && node.tagName.toLowerCase() !== "svg" ? "<!-- ".concat(node.outerHTML, " Font Awesome fontawesome.com -->") : "");
        else if (node.parentNode) {
            var newNode = document.createElement("span");
            node.parentNode.replaceChild(newNode, node);
            newNode.outerHTML = newOuterHTML;
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$3d5561738373812d$var$classArray(node).indexOf($3d5561738373812d$export$e506a1d27d1eaa20.replacementClass)) return $3d5561738373812d$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-.*"));
        delete abstract[0].attributes.style;
        delete abstract[0].attributes.id;
        var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
            if (cls === $3d5561738373812d$export$e506a1d27d1eaa20.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
            else acc.toNode.push(cls);
            return acc;
        }, {
            toNode: [],
            toSvg: []
        });
        abstract[0].attributes.class = splitClasses.toSvg.join(" ");
        var newInnerHTML = abstract.map(function(a) {
            return $3d5561738373812d$export$a10125c086a4df16(a);
        }).join("\n");
        node.setAttribute("class", splitClasses.toNode.join(" "));
        node.setAttribute($3d5561738373812d$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $3d5561738373812d$var$performOperationSync(op) {
    op();
}
function $3d5561738373812d$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $3d5561738373812d$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $3d5561738373812d$var$performOperationSync;
        if ($3d5561738373812d$export$e506a1d27d1eaa20.mutateApproach === $3d5561738373812d$var$MUTATION_APPROACH_ASYNC) frame = $3d5561738373812d$var$WINDOW.requestAnimationFrame || $3d5561738373812d$var$performOperationSync;
        frame(function() {
            var mutator = $3d5561738373812d$var$getMutator();
            var mark = $3d5561738373812d$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $3d5561738373812d$var$disabled = false;
function $3d5561738373812d$var$disableObservation() {
    $3d5561738373812d$var$disabled = true;
}
function $3d5561738373812d$var$enableObservation() {
    $3d5561738373812d$var$disabled = false;
}
var $3d5561738373812d$var$mo = null;
function $3d5561738373812d$var$observe(options) {
    if (!$3d5561738373812d$var$MUTATION_OBSERVER) return;
    if (!$3d5561738373812d$export$e506a1d27d1eaa20.observeMutations) return;
    var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $3d5561738373812d$var$DOCUMENT : _options$observeMutat;
    $3d5561738373812d$var$mo = new $3d5561738373812d$var$MUTATION_OBSERVER(function(objects) {
        if ($3d5561738373812d$var$disabled) return;
        $3d5561738373812d$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$3d5561738373812d$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($3d5561738373812d$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $3d5561738373812d$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $3d5561738373812d$var$isWatched(mutationRecord.target) && ~$3d5561738373812d$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class") {
                    var _getCanonicalIcon = $3d5561738373812d$var$getCanonicalIcon($3d5561738373812d$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    if (prefix) mutationRecord.target.setAttribute("data-prefix", prefix);
                    if (iconName) mutationRecord.target.setAttribute("data-icon", iconName);
                } else nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$3d5561738373812d$var$IS_DOM) return;
    $3d5561738373812d$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $3d5561738373812d$var$disconnect() {
    if (!$3d5561738373812d$var$mo) return;
    $3d5561738373812d$var$mo.disconnect();
}
function $3d5561738373812d$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $3d5561738373812d$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $3d5561738373812d$var$getCanonicalIcon($3d5561738373812d$var$classArray(node));
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.prefix && innerText.length > 1) val.iconName = $3d5561738373812d$var$byLigature(val.prefix, node.innerText);
    else if (val.prefix && innerText.length === 1) val.iconName = $3d5561738373812d$var$byUnicode(val.prefix, $3d5561738373812d$var$toHex(node.innerText));
    return val;
}
var $3d5561738373812d$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    if (!transformString) return transform;
    else return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
function $3d5561738373812d$var$transformParser(node) {
    return $3d5561738373812d$var$parseTransformString(node.getAttribute("data-fa-transform"));
}
function $3d5561738373812d$var$symbolParser(node) {
    var symbol = node.getAttribute("data-fa-symbol");
    return symbol === null ? false : symbol === "" ? true : symbol;
}
function $3d5561738373812d$var$attributesParser(node) {
    var extraAttributes = $3d5561738373812d$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($3d5561738373812d$export$e506a1d27d1eaa20.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($3d5561738373812d$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $3d5561738373812d$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $3d5561738373812d$var$maskParser(node) {
    var mask = node.getAttribute("data-fa-mask");
    if (!mask) return $3d5561738373812d$var$emptyCanonicalIcon();
    else return $3d5561738373812d$var$getCanonicalIcon(mask.split(" ").map(function(i) {
        return i.trim();
    }));
}
function $3d5561738373812d$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $3d5561738373812d$var$meaninglessTransform,
        symbol: false,
        mask: null,
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $3d5561738373812d$var$parseMeta(node) {
    var _classParser = $3d5561738373812d$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraStyles = $3d5561738373812d$var$styleParser(node);
    var transform = $3d5561738373812d$var$transformParser(node);
    var symbol = $3d5561738373812d$var$symbolParser(node);
    var extraAttributes = $3d5561738373812d$var$attributesParser(node);
    var mask = $3d5561738373812d$var$maskParser(node);
    return {
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: transform,
        symbol: symbol,
        mask: mask,
        maskId: node.getAttribute("data-fa-mask-id"),
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    };
}
function $3d5561738373812d$var$MissingIcon(error) {
    this.name = "MissingIcon";
    this.message = error || "Icon unavailable";
    this.stack = new Error().stack;
}
$3d5561738373812d$var$MissingIcon.prototype = Object.create(Error.prototype);
$3d5561738373812d$var$MissingIcon.prototype.constructor = $3d5561738373812d$var$MissingIcon;
var $3d5561738373812d$var$FILL = {
    fill: "currentColor"
};
var $3d5561738373812d$var$ANIMATION_BASE = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s"
};
var $3d5561738373812d$var$RING = {
    tag: "path",
    attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$FILL, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
    })
};
var $3d5561738373812d$var$OPACITY_ANIMATE = $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$ANIMATION_BASE, {
    attributeName: "opacity"
});
var $3d5561738373812d$var$DOT = {
    tag: "circle",
    attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$FILL, {
        cx: "256",
        cy: "364",
        r: "28"
    }),
    children: [
        {
            tag: "animate",
            attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$ANIMATION_BASE, {
                attributeName: "r",
                values: "28;14;28;28;14;28;"
            })
        },
        {
            tag: "animate",
            attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$OPACITY_ANIMATE, {
                values: "1;0;1;1;0;1;"
            })
        }
    ]
};
var $3d5561738373812d$var$QUESTION = {
    tag: "path",
    attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$FILL, {
        opacity: "1",
        d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$OPACITY_ANIMATE, {
                values: "1;0;0;0;0;1;"
            })
        }
    ]
};
var $3d5561738373812d$var$EXCLAMATION = {
    tag: "path",
    attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$FILL, {
        opacity: "0",
        d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$OPACITY_ANIMATE, {
                values: "0;0;1;1;0;0;"
            })
        }
    ]
};
var $3d5561738373812d$var$missing = {
    tag: "g",
    children: [
        $3d5561738373812d$var$RING,
        $3d5561738373812d$var$DOT,
        $3d5561738373812d$var$QUESTION,
        $3d5561738373812d$var$EXCLAMATION
    ]
};
var $3d5561738373812d$var$styles$2 = $3d5561738373812d$var$namespace.styles;
function $3d5561738373812d$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $3d5561738373812d$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-").concat($3d5561738373812d$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-").concat($3d5561738373812d$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-").concat($3d5561738373812d$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
function $3d5561738373812d$var$findIcon(iconName, prefix) {
    return new $3d5561738373812d$var$picked(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $3d5561738373812d$var$missing
        };
        if (iconName && prefix && $3d5561738373812d$var$styles$2[prefix] && $3d5561738373812d$var$styles$2[prefix][iconName]) {
            var icon = $3d5561738373812d$var$styles$2[prefix][iconName];
            return resolve($3d5561738373812d$var$asFoundIcon(icon));
        }
        if (iconName && prefix && !$3d5561738373812d$export$e506a1d27d1eaa20.showMissingIcons) reject(new $3d5561738373812d$var$MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
        else resolve(val);
    });
}
var $3d5561738373812d$var$styles$3 = $3d5561738373812d$var$namespace.styles;
function $3d5561738373812d$var$generateSvgReplacementMutation(node, nodeMeta) {
    var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
    return new $3d5561738373812d$var$picked(function(resolve, reject) {
        $3d5561738373812d$var$picked.all([
            $3d5561738373812d$var$findIcon(iconName, prefix),
            $3d5561738373812d$var$findIcon(mask.iconName, mask.prefix)
        ]).then(function(_ref) {
            var _ref2 = $3d5561738373812d$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
            resolve([
                node,
                $3d5561738373812d$var$makeInlineSvgAbstract({
                    icons: {
                        main: main,
                        mask: mask
                    },
                    prefix: prefix,
                    iconName: iconName,
                    transform: transform,
                    symbol: symbol,
                    mask: mask,
                    maskId: maskId,
                    title: title,
                    titleId: titleId,
                    extra: extra,
                    watchable: true
                })
            ]);
        });
    });
}
function $3d5561738373812d$var$generateLayersText(node, nodeMeta) {
    var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
    var width = null;
    var height = null;
    if ($3d5561738373812d$var$IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
    }
    if ($3d5561738373812d$export$e506a1d27d1eaa20.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
    return $3d5561738373812d$var$picked.resolve([
        node,
        $3d5561738373812d$var$makeLayersTextAbstract({
            content: node.innerHTML,
            width: width,
            height: height,
            transform: transform,
            title: title,
            extra: extra,
            watchable: true
        })
    ]);
}
function $3d5561738373812d$var$generateMutation(node) {
    var nodeMeta = $3d5561738373812d$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($3d5561738373812d$var$LAYERS_TEXT_CLASSNAME)) return $3d5561738373812d$var$generateLayersText(node, nodeMeta);
    else return $3d5561738373812d$var$generateSvgReplacementMutation(node, nodeMeta);
}
function $3d5561738373812d$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$3d5561738373812d$var$IS_DOM) return;
    var htmlClassList = $3d5561738373812d$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($3d5561738373812d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($3d5561738373812d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $3d5561738373812d$export$e506a1d27d1eaa20.autoFetchSvg ? Object.keys($3d5561738373812d$var$PREFIX_TO_STYLE) : Object.keys($3d5561738373812d$var$styles$3);
    var prefixesDomQuery = [
        ".".concat($3d5561738373812d$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($3d5561738373812d$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($3d5561738373812d$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return;
    var candidates = [];
    try {
        candidates = $3d5561738373812d$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return;
    var mark = $3d5561738373812d$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $3d5561738373812d$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$3d5561738373812d$var$PRODUCTION) {
                if (e instanceof $3d5561738373812d$var$MissingIcon) console.error(e);
            }
        }
        return acc;
    }, []);
    return new $3d5561738373812d$var$picked(function(resolve, reject) {
        $3d5561738373812d$var$picked.all(mutations).then(function(resolvedMutations) {
            $3d5561738373812d$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function() {
            mark();
            reject();
        });
    });
}
function $3d5561738373812d$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $3d5561738373812d$var$generateMutation(node).then(function(mutation) {
        if (mutation) $3d5561738373812d$var$perform([
            mutation
        ], callback);
    });
}
function $3d5561738373812d$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new $3d5561738373812d$var$picked(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $3d5561738373812d$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $3d5561738373812d$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($3d5561738373812d$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $3d5561738373812d$var$STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : $3d5561738373812d$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var hexValue = $3d5561738373812d$var$toHex(_content.length === 3 ? _content.substr(1, 1) : _content);
            var iconName = $3d5561738373812d$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($3d5561738373812d$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($3d5561738373812d$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $3d5561738373812d$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $3d5561738373812d$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $3d5561738373812d$var$makeInlineSvgAbstract($3d5561738373812d$var$_objectSpread({}, meta, {
                        icons: {
                            main: main,
                            mask: $3d5561738373812d$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $3d5561738373812d$var$DOCUMENT.createElement("svg");
                    if (position === ":before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $3d5561738373812d$export$a10125c086a4df16(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $3d5561738373812d$var$replace(node) {
    return $3d5561738373812d$var$picked.all([
        $3d5561738373812d$var$replaceForPosition(node, ":before"),
        $3d5561738373812d$var$replaceForPosition(node, ":after")
    ]);
}
function $3d5561738373812d$var$processable(node) {
    return node.parentNode !== document.head && !~$3d5561738373812d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($3d5561738373812d$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $3d5561738373812d$var$searchPseudoElements(root) {
    if (!$3d5561738373812d$var$IS_DOM) return;
    return new $3d5561738373812d$var$picked(function(resolve, reject) {
        var operations = $3d5561738373812d$var$toArray(root.querySelectorAll("*")).filter($3d5561738373812d$var$processable).map($3d5561738373812d$var$replace);
        var end = $3d5561738373812d$var$perf.begin("searchPseudoElements");
        $3d5561738373812d$var$disableObservation();
        $3d5561738373812d$var$picked.all(operations).then(function() {
            end();
            $3d5561738373812d$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $3d5561738373812d$var$enableObservation();
            reject();
        });
    });
}
var $3d5561738373812d$var$baseStyles = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
function $3d5561738373812d$var$css() {
    var dfp = $3d5561738373812d$var$DEFAULT_FAMILY_PREFIX;
    var drc = $3d5561738373812d$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix;
    var rc = $3d5561738373812d$export$e506a1d27d1eaa20.replacementClass;
    var s = $3d5561738373812d$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $3d5561738373812d$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $3d5561738373812d$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $3d5561738373812d$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $3d5561738373812d$var$_objectSpread({}, _this.definitions[key] || {}, additions[key]);
                    $3d5561738373812d$var$defineIcons(key, additions[key]);
                    $3d5561738373812d$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    if (!additions[prefix]) additions[prefix] = {};
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
function $3d5561738373812d$var$ensureCss() {
    if ($3d5561738373812d$export$e506a1d27d1eaa20.autoAddCss && !$3d5561738373812d$var$_cssInserted) {
        $3d5561738373812d$var$insertCss($3d5561738373812d$var$css());
        $3d5561738373812d$var$_cssInserted = true;
    }
}
function $3d5561738373812d$var$apiObject(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $3d5561738373812d$export$a10125c086a4df16(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$3d5561738373812d$var$IS_DOM) return;
            var container = $3d5561738373812d$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $3d5561738373812d$export$221fed4a47f597a5(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix, iconName = iconLookup.iconName;
    if (!iconName) return;
    return $3d5561738373812d$var$iconFromMapping($3d5561738373812d$export$b839f963c7dc0e34.definitions, prefix, iconName) || $3d5561738373812d$var$iconFromMapping($3d5561738373812d$var$namespace.styles, prefix, iconName);
}
function $3d5561738373812d$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $3d5561738373812d$export$221fed4a47f597a5(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $3d5561738373812d$export$221fed4a47f597a5(mask || {});
        return next(iconDefinition, $3d5561738373812d$var$_objectSpread({}, params, {
            mask: mask
        }));
    };
}
var $3d5561738373812d$export$b839f963c7dc0e34 = new $3d5561738373812d$var$Library();
var $3d5561738373812d$export$4f8e844b2782642c = function noAuto() {
    $3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg = false;
    $3d5561738373812d$export$e506a1d27d1eaa20.observeMutations = false;
    $3d5561738373812d$var$disconnect();
};
var $3d5561738373812d$var$_cssInserted = false;
var $3d5561738373812d$export$df3a06d6289f983e = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($3d5561738373812d$var$IS_DOM) {
            $3d5561738373812d$var$ensureCss();
            var _params$node = params.node, node = _params$node === void 0 ? $3d5561738373812d$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            if ($3d5561738373812d$export$e506a1d27d1eaa20.searchPseudoElements) $3d5561738373812d$var$searchPseudoElements(node);
            return $3d5561738373812d$var$onTree(node, callback);
        } else return $3d5561738373812d$var$picked.reject("Operation requires a DOM of some kind.");
    },
    css: $3d5561738373812d$var$css,
    insertCss: function insertCss$$1() {
        if (!$3d5561738373812d$var$_cssInserted) {
            $3d5561738373812d$var$insertCss($3d5561738373812d$var$css());
            $3d5561738373812d$var$_cssInserted = true;
        }
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
        if ($3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg === false) $3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg = true;
        $3d5561738373812d$export$e506a1d27d1eaa20.observeMutations = true;
        $3d5561738373812d$var$domready(function() {
            $3d5561738373812d$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $3d5561738373812d$var$observe({
                treeCallback: $3d5561738373812d$var$onTree,
                nodeCallback: $3d5561738373812d$var$onNode,
                pseudoElementsCallback: $3d5561738373812d$var$searchPseudoElements,
                observeMutationsRoot: observeMutationsRoot
            });
        });
    }
};
var $3d5561738373812d$export$98e6a39c04603d36 = {
    transform: function transform(transformString) {
        return $3d5561738373812d$var$parseTransformString(transformString);
    }
};
var $3d5561738373812d$export$1ca1ec8b29a4ce27 = $3d5561738373812d$var$resolveIcons(function(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $3d5561738373812d$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $3d5561738373812d$var$apiObject($3d5561738373812d$var$_objectSpread({
        type: "icon"
    }, iconDefinition), function() {
        $3d5561738373812d$var$ensureCss();
        if ($3d5561738373812d$export$e506a1d27d1eaa20.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($3d5561738373812d$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $3d5561738373812d$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $3d5561738373812d$var$makeInlineSvgAbstract({
            icons: {
                main: $3d5561738373812d$var$asFoundIcon(icon),
                mask: mask ? $3d5561738373812d$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$meaninglessTransform, transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
});
var $3d5561738373812d$export$6f093cfa640b7166 = function text(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? $3d5561738373812d$var$meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
    return $3d5561738373812d$var$apiObject({
        type: "text",
        content: content
    }, function() {
        $3d5561738373812d$var$ensureCss();
        return $3d5561738373812d$var$makeLayersTextAbstract({
            content: content,
            transform: $3d5561738373812d$var$_objectSpread({}, $3d5561738373812d$var$meaninglessTransform, transform),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-layers-text")
                ].concat($3d5561738373812d$var$_toConsumableArray(classes))
            }
        });
    });
};
var $3d5561738373812d$export$e575061ef2a070eb = function counter(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
    return $3d5561738373812d$var$apiObject({
        type: "counter",
        content: content
    }, function() {
        $3d5561738373812d$var$ensureCss();
        return $3d5561738373812d$var$makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-layers-counter")
                ].concat($3d5561738373812d$var$_toConsumableArray(classes))
            }
        });
    });
};
var $3d5561738373812d$export$50a222d9023da98b = function layer(assembler) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
    return $3d5561738373812d$var$apiObject({
        type: "layer"
    }, function() {
        $3d5561738373812d$var$ensureCss();
        var children = [];
        assembler(function(args) {
            Array.isArray(args) ? args.map(function(a) {
                children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
        });
        return [
            {
                tag: "span",
                attributes: {
                    class: [
                        "".concat($3d5561738373812d$export$e506a1d27d1eaa20.familyPrefix, "-layers")
                    ].concat($3d5561738373812d$var$_toConsumableArray(classes)).join(" ")
                },
                children: children
            }
        ];
    });
};
var $3d5561738373812d$var$api = {
    noAuto: $3d5561738373812d$export$4f8e844b2782642c,
    config: $3d5561738373812d$export$e506a1d27d1eaa20,
    dom: $3d5561738373812d$export$df3a06d6289f983e,
    library: $3d5561738373812d$export$b839f963c7dc0e34,
    parse: $3d5561738373812d$export$98e6a39c04603d36,
    findIconDefinition: $3d5561738373812d$export$221fed4a47f597a5,
    icon: $3d5561738373812d$export$1ca1ec8b29a4ce27,
    text: $3d5561738373812d$export$6f093cfa640b7166,
    counter: $3d5561738373812d$export$e575061ef2a070eb,
    layer: $3d5561738373812d$export$50a222d9023da98b,
    toHtml: $3d5561738373812d$export$a10125c086a4df16
};
var $3d5561738373812d$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $3d5561738373812d$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($3d5561738373812d$var$namespace.styles).length > 0 || $3d5561738373812d$export$e506a1d27d1eaa20.autoFetchSvg) && $3d5561738373812d$var$IS_DOM && $3d5561738373812d$export$e506a1d27d1eaa20.autoReplaceSvg) $3d5561738373812d$var$api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};

});


parcelRegister("a9SdK", function(module, exports) {

$parcel$export(module.exports, "faBolt", function () { return $7654cdc1c6e28adf$export$6869964aa308dd31; });
$parcel$export(module.exports, "faChargingStation", function () { return $7654cdc1c6e28adf$export$bab2cd86f8c65657; });
$parcel$export(module.exports, "faEllipsisH", function () { return $7654cdc1c6e28adf$export$c9f2fedd4489a2ee; });
$parcel$export(module.exports, "faExclamation", function () { return $7654cdc1c6e28adf$export$de6218b649cbb6a9; });
$parcel$export(module.exports, "faLock", function () { return $7654cdc1c6e28adf$export$7aa08ad5d562578a; });
$parcel$export(module.exports, "faPaste", function () { return $7654cdc1c6e28adf$export$6f95f90dd1f6d86b; });
$parcel$export(module.exports, "faPause", function () { return $7654cdc1c6e28adf$export$da79f048408b1722; });
$parcel$export(module.exports, "faSpinner", function () { return $7654cdc1c6e28adf$export$1025ad641edb49c2; });
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var $7654cdc1c6e28adf$export$82e9f45cca5ba907 = "fas";
var $7654cdc1c6e28adf$export$7af266c3465b1ff2 = {
    prefix: "fas",
    iconName: "ad",
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var $7654cdc1c6e28adf$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $7654cdc1c6e28adf$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$cfa06e4b68edca2d = {
    prefix: "fas",
    iconName: "adjust",
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var $7654cdc1c6e28adf$export$a5e63e89b5ccee83 = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [
        512,
        512,
        [],
        "f5d0",
        "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
    ]
};
var $7654cdc1c6e28adf$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var $7654cdc1c6e28adf$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var $7654cdc1c6e28adf$export$dcae2101babbffff = {
    prefix: "fas",
    iconName: "allergies",
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$f5c7042778b51765 = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $7654cdc1c6e28adf$export$23a7517099ab1b86 = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var $7654cdc1c6e28adf$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var $7654cdc1c6e28adf$export$fd504117f273ca92 = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var $7654cdc1c6e28adf$export$21b0833b3cf929a7 = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var $7654cdc1c6e28adf$export$792931403404faf0 = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var $7654cdc1c6e28adf$export$9bb51e1a2c07db7c = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var $7654cdc1c6e28adf$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var $7654cdc1c6e28adf$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var $7654cdc1c6e28adf$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var $7654cdc1c6e28adf$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var $7654cdc1c6e28adf$export$3c96c08e234498c5 = {
    prefix: "fas",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var $7654cdc1c6e28adf$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var $7654cdc1c6e28adf$export$bcdd94f3977a0884 = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var $7654cdc1c6e28adf$export$26b3e1c454273f34 = {
    prefix: "fas",
    iconName: "archive",
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$ff3afbc8c0bc5d59 = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var $7654cdc1c6e28adf$export$5460a5b11a24996f = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$88962ffdad8b856d = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var $7654cdc1c6e28adf$export$3747a8ef0995eadf = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$6cfa36bbb3a057 = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var $7654cdc1c6e28adf$export$728262abb9f58d0a = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var $7654cdc1c6e28adf$export$7d3d828103aa3be7 = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var $7654cdc1c6e28adf$export$a2f6f3baa50af0b1 = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var $7654cdc1c6e28adf$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var $7654cdc1c6e28adf$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var $7654cdc1c6e28adf$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var $7654cdc1c6e28adf$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var $7654cdc1c6e28adf$export$3cdabfff52cfc73a = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var $7654cdc1c6e28adf$export$7937ea574fb1389 = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var $7654cdc1c6e28adf$export$138cb56a3f8f7040 = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var $7654cdc1c6e28adf$export$8eeef3dc0035b165 = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var $7654cdc1c6e28adf$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var $7654cdc1c6e28adf$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var $7654cdc1c6e28adf$export$380a9050e42fe5d7 = {
    prefix: "fas",
    iconName: "atlas",
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var $7654cdc1c6e28adf$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var $7654cdc1c6e28adf$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var $7654cdc1c6e28adf$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var $7654cdc1c6e28adf$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var $7654cdc1c6e28adf$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e43e3f67102fc526 = {
    prefix: "fas",
    iconName: "backspace",
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var $7654cdc1c6e28adf$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var $7654cdc1c6e28adf$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var $7654cdc1c6e28adf$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
    ]
};
var $7654cdc1c6e28adf$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
    ]
};
var $7654cdc1c6e28adf$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var $7654cdc1c6e28adf$export$fec323dcfd81d750 = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$786cb0c775487f19 = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var $7654cdc1c6e28adf$export$2238e05f8920005a = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var $7654cdc1c6e28adf$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var $7654cdc1c6e28adf$export$b14a1014df2fdf46 = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var $7654cdc1c6e28adf$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$63a3f8ceae07c7f3 = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var $7654cdc1c6e28adf$export$36550ab8ffcc5b28 = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var $7654cdc1c6e28adf$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var $7654cdc1c6e28adf$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var $7654cdc1c6e28adf$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var $7654cdc1c6e28adf$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var $7654cdc1c6e28adf$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var $7654cdc1c6e28adf$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var $7654cdc1c6e28adf$export$f74725691538983b = {
    prefix: "fas",
    iconName: "beer",
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var $7654cdc1c6e28adf$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $7654cdc1c6e28adf$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$2eac809b0670d139 = {
    prefix: "fas",
    iconName: "bible",
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $7654cdc1c6e28adf$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var $7654cdc1c6e28adf$export$a5bcf835dbf9c0b = {
    prefix: "fas",
    iconName: "biking",
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var $7654cdc1c6e28adf$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var $7654cdc1c6e28adf$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$bdcf98f725a7241a = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var $7654cdc1c6e28adf$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var $7654cdc1c6e28adf$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$923de21def6ea9b6 = {
    prefix: "fas",
    iconName: "blind",
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var $7654cdc1c6e28adf$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var $7654cdc1c6e28adf$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var $7654cdc1c6e28adf$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var $7654cdc1c6e28adf$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $7654cdc1c6e28adf$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var $7654cdc1c6e28adf$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var $7654cdc1c6e28adf$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var $7654cdc1c6e28adf$export$b98a3f8c3941a74a = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var $7654cdc1c6e28adf$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var $7654cdc1c6e28adf$export$cee14fe33262fa7d = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var $7654cdc1c6e28adf$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var $7654cdc1c6e28adf$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var $7654cdc1c6e28adf$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$c2867ca78120d644 = {
    prefix: "fas",
    iconName: "border-style",
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var $7654cdc1c6e28adf$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var $7654cdc1c6e28adf$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var $7654cdc1c6e28adf$export$2007320dd6cde6db = {
    prefix: "fas",
    iconName: "boxes",
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var $7654cdc1c6e28adf$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var $7654cdc1c6e28adf$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var $7654cdc1c6e28adf$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var $7654cdc1c6e28adf$export$f68b38d51f5c0ed = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var $7654cdc1c6e28adf$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var $7654cdc1c6e28adf$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var $7654cdc1c6e28adf$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var $7654cdc1c6e28adf$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var $7654cdc1c6e28adf$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var $7654cdc1c6e28adf$export$80ed4535efc60402 = {
    prefix: "fas",
    iconName: "burn",
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var $7654cdc1c6e28adf$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$40616edfab6d332a = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var $7654cdc1c6e28adf$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var $7654cdc1c6e28adf$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$cbc139f33cff356 = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var $7654cdc1c6e28adf$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var $7654cdc1c6e28adf$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var $7654cdc1c6e28adf$export$99b20d7352fbcf08 = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var $7654cdc1c6e28adf$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var $7654cdc1c6e28adf$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var $7654cdc1c6e28adf$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var $7654cdc1c6e28adf$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var $7654cdc1c6e28adf$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var $7654cdc1c6e28adf$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $7654cdc1c6e28adf$export$7937ed2462a665c0 = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $7654cdc1c6e28adf$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$8ff55566398404cd = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var $7654cdc1c6e28adf$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var $7654cdc1c6e28adf$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var $7654cdc1c6e28adf$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var $7654cdc1c6e28adf$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var $7654cdc1c6e28adf$export$61aea18df1c84401 = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var $7654cdc1c6e28adf$export$d0c8ba444f1f9581 = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var $7654cdc1c6e28adf$export$ae86c9de7e0f62fa = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var $7654cdc1c6e28adf$export$307ae80b26533ce5 = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var $7654cdc1c6e28adf$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var $7654cdc1c6e28adf$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var $7654cdc1c6e28adf$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var $7654cdc1c6e28adf$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var $7654cdc1c6e28adf$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var $7654cdc1c6e28adf$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var $7654cdc1c6e28adf$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$443fcf69b0155291 = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var $7654cdc1c6e28adf$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var $7654cdc1c6e28adf$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var $7654cdc1c6e28adf$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var $7654cdc1c6e28adf$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var $7654cdc1c6e28adf$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var $7654cdc1c6e28adf$export$be9e388158c74f29 = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var $7654cdc1c6e28adf$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var $7654cdc1c6e28adf$export$f0c8040f596df7fe = {
    prefix: "fas",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var $7654cdc1c6e28adf$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var $7654cdc1c6e28adf$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var $7654cdc1c6e28adf$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var $7654cdc1c6e28adf$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var $7654cdc1c6e28adf$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var $7654cdc1c6e28adf$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$9926124d75b2ecab = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var $7654cdc1c6e28adf$export$4a42c8c2451a33fd = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var $7654cdc1c6e28adf$export$2a5db4f6eba6f2b = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var $7654cdc1c6e28adf$export$b786cf5db03f2c36 = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var $7654cdc1c6e28adf$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var $7654cdc1c6e28adf$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var $7654cdc1c6e28adf$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var $7654cdc1c6e28adf$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var $7654cdc1c6e28adf$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var $7654cdc1c6e28adf$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var $7654cdc1c6e28adf$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var $7654cdc1c6e28adf$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var $7654cdc1c6e28adf$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var $7654cdc1c6e28adf$export$20d8a680febc7434 = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var $7654cdc1c6e28adf$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var $7654cdc1c6e28adf$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var $7654cdc1c6e28adf$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var $7654cdc1c6e28adf$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var $7654cdc1c6e28adf$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var $7654cdc1c6e28adf$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var $7654cdc1c6e28adf$export$351357a14c41f824 = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var $7654cdc1c6e28adf$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var $7654cdc1c6e28adf$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var $7654cdc1c6e28adf$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $7654cdc1c6e28adf$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var $7654cdc1c6e28adf$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var $7654cdc1c6e28adf$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var $7654cdc1c6e28adf$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $7654cdc1c6e28adf$export$e73b3e819b9d14a5 = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var $7654cdc1c6e28adf$export$4be708f1e41d387b = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var $7654cdc1c6e28adf$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var $7654cdc1c6e28adf$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var $7654cdc1c6e28adf$export$1d24a9e457278011 = {
    prefix: "fas",
    iconName: "coffee",
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var $7654cdc1c6e28adf$export$d6298bbfd1912a78 = {
    prefix: "fas",
    iconName: "cog",
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$af1575770afc9559 = {
    prefix: "fas",
    iconName: "cogs",
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var $7654cdc1c6e28adf$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var $7654cdc1c6e28adf$export$bb861166644ac28a = {
    prefix: "fas",
    iconName: "columns",
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var $7654cdc1c6e28adf$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var $7654cdc1c6e28adf$export$6e96904d9af0ec4a = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var $7654cdc1c6e28adf$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var $7654cdc1c6e28adf$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var $7654cdc1c6e28adf$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $7654cdc1c6e28adf$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var $7654cdc1c6e28adf$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var $7654cdc1c6e28adf$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var $7654cdc1c6e28adf$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$a05650ebe54bede = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var $7654cdc1c6e28adf$export$39205db0ea980efd = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$ad92ffbbfbc0fcf3 = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var $7654cdc1c6e28adf$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var $7654cdc1c6e28adf$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var $7654cdc1c6e28adf$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var $7654cdc1c6e28adf$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$d932915fde4f1010 = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var $7654cdc1c6e28adf$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var $7654cdc1c6e28adf$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var $7654cdc1c6e28adf$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var $7654cdc1c6e28adf$export$66847f2a71b260e7 = {
    prefix: "fas",
    iconName: "cut",
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var $7654cdc1c6e28adf$export$4b666adf83f0de01 = {
    prefix: "fas",
    iconName: "deaf",
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var $7654cdc1c6e28adf$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var $7654cdc1c6e28adf$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var $7654cdc1c6e28adf$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var $7654cdc1c6e28adf$export$68bad2b52a90d1fa = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var $7654cdc1c6e28adf$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var $7654cdc1c6e28adf$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$b3bf1994f0fefe98 = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var $7654cdc1c6e28adf$export$6a6973de44442fe5 = {
    prefix: "fas",
    iconName: "directions",
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var $7654cdc1c6e28adf$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$89a2b10dabc487e8 = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var $7654cdc1c6e28adf$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var $7654cdc1c6e28adf$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var $7654cdc1c6e28adf$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var $7654cdc1c6e28adf$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$f7c6efb60c53b285 = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$40050ae52860cde7 = {
    prefix: "fas",
    iconName: "donate",
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var $7654cdc1c6e28adf$export$92bc269cb244d66a = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var $7654cdc1c6e28adf$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $7654cdc1c6e28adf$export$c8c2b127d13b9d79 = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var $7654cdc1c6e28adf$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var $7654cdc1c6e28adf$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var $7654cdc1c6e28adf$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var $7654cdc1c6e28adf$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var $7654cdc1c6e28adf$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var $7654cdc1c6e28adf$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var $7654cdc1c6e28adf$export$7be713e57d023733 = {
    prefix: "fas",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var $7654cdc1c6e28adf$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var $7654cdc1c6e28adf$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var $7654cdc1c6e28adf$export$c9f2fedd4489a2ee = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var $7654cdc1c6e28adf$export$e58494c7fcb5380 = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var $7654cdc1c6e28adf$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var $7654cdc1c6e28adf$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var $7654cdc1c6e28adf$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var $7654cdc1c6e28adf$export$354e159473e73552 = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var $7654cdc1c6e28adf$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var $7654cdc1c6e28adf$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var $7654cdc1c6e28adf$export$f6c6fb20d374b128 = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var $7654cdc1c6e28adf$export$220e07e14c5d7e5d = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $7654cdc1c6e28adf$export$3d249b63b52cce7c = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $7654cdc1c6e28adf$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$bcb8d86a3a1d6eb6 = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var $7654cdc1c6e28adf$export$6219dcd88b5fa6c2 = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$d7f107e456ab0306 = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var $7654cdc1c6e28adf$export$e4cdf2977151ee26 = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var $7654cdc1c6e28adf$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var $7654cdc1c6e28adf$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var $7654cdc1c6e28adf$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e6246a3279a379b8 = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$61a8cdc53c2e078d = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var $7654cdc1c6e28adf$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var $7654cdc1c6e28adf$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var $7654cdc1c6e28adf$export$68cf766c786bcd78 = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var $7654cdc1c6e28adf$export$70e8e75e61dd7169 = {
    prefix: "fas",
    iconName: "female",
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var $7654cdc1c6e28adf$export$102b809faf56e033 = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var $7654cdc1c6e28adf$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$243b47dca32bf0b8 = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$bf2047a9946b5c3f = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var $7654cdc1c6e28adf$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var $7654cdc1c6e28adf$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$1013b9966d758343 = {
    prefix: "fas",
    iconName: "file-download",
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var $7654cdc1c6e28adf$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var $7654cdc1c6e28adf$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var $7654cdc1c6e28adf$export$ef02a0f5b39aa61f = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var $7654cdc1c6e28adf$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var $7654cdc1c6e28adf$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var $7654cdc1c6e28adf$export$dd55ded1264643d2 = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $7654cdc1c6e28adf$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var $7654cdc1c6e28adf$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var $7654cdc1c6e28adf$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var $7654cdc1c6e28adf$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $7654cdc1c6e28adf$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var $7654cdc1c6e28adf$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var $7654cdc1c6e28adf$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var $7654cdc1c6e28adf$export$70dc26b4926d0b1b = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var $7654cdc1c6e28adf$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$5b01ccb2da4c4387 = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$fa0323a4d7489a8d = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var $7654cdc1c6e28adf$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var $7654cdc1c6e28adf$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var $7654cdc1c6e28adf$export$dfd2bd012685aeac = {
    prefix: "fas",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var $7654cdc1c6e28adf$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var $7654cdc1c6e28adf$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var $7654cdc1c6e28adf$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var $7654cdc1c6e28adf$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var $7654cdc1c6e28adf$export$6e20d421a2e0f320 = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var $7654cdc1c6e28adf$export$e8fd664711e31704 = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var $7654cdc1c6e28adf$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var $7654cdc1c6e28adf$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$43b7108508aecc5f = {
    prefix: "fas",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var $7654cdc1c6e28adf$export$c4775e66bed5d96 = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$cebe38ad8f0a143d = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var $7654cdc1c6e28adf$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var $7654cdc1c6e28adf$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var $7654cdc1c6e28adf$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var $7654cdc1c6e28adf$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var $7654cdc1c6e28adf$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var $7654cdc1c6e28adf$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var $7654cdc1c6e28adf$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $7654cdc1c6e28adf$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var $7654cdc1c6e28adf$export$20007d7d74cb98fe = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var $7654cdc1c6e28adf$export$e96f280e39af4a91 = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var $7654cdc1c6e28adf$export$2258439b8f4e7acb = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var $7654cdc1c6e28adf$export$fdec0f5f1a169419 = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var $7654cdc1c6e28adf$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var $7654cdc1c6e28adf$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var $7654cdc1c6e28adf$export$64af36f3b403a57c = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var $7654cdc1c6e28adf$export$e96bcc7bde9498db = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var $7654cdc1c6e28adf$export$796fdfc909e603f4 = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var $7654cdc1c6e28adf$export$5318b8ede86cc96b = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var $7654cdc1c6e28adf$export$2251487a9a33c682 = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var $7654cdc1c6e28adf$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var $7654cdc1c6e28adf$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var $7654cdc1c6e28adf$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$3d08cd36ac1ef231 = {
    prefix: "fas",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var $7654cdc1c6e28adf$export$37e1f10b6de76621 = {
    prefix: "fas",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$b4abebfe416d36ba = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$734da5249381ec7e = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$14d0ccc54c5b6826 = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$c56cf0e0c3bc5ed2 = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var $7654cdc1c6e28adf$export$243ae757907b1580 = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$542206d6a85f3b42 = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var $7654cdc1c6e28adf$export$64347a5c8c402ef4 = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var $7654cdc1c6e28adf$export$b2f7512221512b5b = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $7654cdc1c6e28adf$export$ef222816a43a4b3a = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $7654cdc1c6e28adf$export$4edf34c3def09a31 = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var $7654cdc1c6e28adf$export$58099903d50aefb3 = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $7654cdc1c6e28adf$export$2397fcd34eb12177 = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var $7654cdc1c6e28adf$export$4a45308d6c8decc1 = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var $7654cdc1c6e28adf$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$f08bbcf8f59eafc2 = {
    prefix: "fas",
    iconName: "h-square",
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$bab3bb9f4f59363 = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var $7654cdc1c6e28adf$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $7654cdc1c6e28adf$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $7654cdc1c6e28adf$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var $7654cdc1c6e28adf$export$47d27bc305b59690 = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var $7654cdc1c6e28adf$export$4265371b99d38b95 = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $7654cdc1c6e28adf$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var $7654cdc1c6e28adf$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var $7654cdc1c6e28adf$export$6e6216c8b50471bb = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var $7654cdc1c6e28adf$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var $7654cdc1c6e28adf$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $7654cdc1c6e28adf$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var $7654cdc1c6e28adf$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $7654cdc1c6e28adf$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var $7654cdc1c6e28adf$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var $7654cdc1c6e28adf$export$97a81eba394c8c44 = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var $7654cdc1c6e28adf$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var $7654cdc1c6e28adf$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var $7654cdc1c6e28adf$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var $7654cdc1c6e28adf$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$287dbb1632da0d44 = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var $7654cdc1c6e28adf$export$996b5dea53b124e3 = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [
        576,
        512,
        [],
        "e05e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var $7654cdc1c6e28adf$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var $7654cdc1c6e28adf$export$ca302f956ae9f1bf = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [
        640,
        512,
        [],
        "e05f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var $7654cdc1c6e28adf$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var $7654cdc1c6e28adf$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var $7654cdc1c6e28adf$export$7b72177558a98b6f = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var $7654cdc1c6e28adf$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var $7654cdc1c6e28adf$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var $7654cdc1c6e28adf$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var $7654cdc1c6e28adf$export$62551e9c5ba7093f = {
    prefix: "fas",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var $7654cdc1c6e28adf$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var $7654cdc1c6e28adf$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        512,
        512,
        [],
        "e063",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var $7654cdc1c6e28adf$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var $7654cdc1c6e28adf$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var $7654cdc1c6e28adf$export$6f0433fa527dd5be = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var $7654cdc1c6e28adf$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var $7654cdc1c6e28adf$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var $7654cdc1c6e28adf$export$4a565395cb65b282 = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $7654cdc1c6e28adf$export$ca880e19206e80aa = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $7654cdc1c6e28adf$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var $7654cdc1c6e28adf$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var $7654cdc1c6e28adf$export$b2ab0105a901499e = {
    prefix: "fas",
    iconName: "hiking",
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var $7654cdc1c6e28adf$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$76d1986559ca7b7a = {
    prefix: "fas",
    iconName: "history",
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var $7654cdc1c6e28adf$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var $7654cdc1c6e28adf$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var $7654cdc1c6e28adf$export$48f10d71ec526479 = {
    prefix: "fas",
    iconName: "home",
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var $7654cdc1c6e28adf$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var $7654cdc1c6e28adf$export$cea7736417b94a3b = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $7654cdc1c6e28adf$export$c8a3c78d99c23fed = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var $7654cdc1c6e28adf$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var $7654cdc1c6e28adf$export$4842af92b516c40b = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var $7654cdc1c6e28adf$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var $7654cdc1c6e28adf$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $7654cdc1c6e28adf$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var $7654cdc1c6e28adf$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var $7654cdc1c6e28adf$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var $7654cdc1c6e28adf$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var $7654cdc1c6e28adf$export$8d7e943005ce0b49 = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var $7654cdc1c6e28adf$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var $7654cdc1c6e28adf$export$33d5f94bd6f75f59 = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var $7654cdc1c6e28adf$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var $7654cdc1c6e28adf$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var $7654cdc1c6e28adf$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var $7654cdc1c6e28adf$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var $7654cdc1c6e28adf$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $7654cdc1c6e28adf$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var $7654cdc1c6e28adf$export$dc37ebbac31f6c6c = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var $7654cdc1c6e28adf$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var $7654cdc1c6e28adf$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var $7654cdc1c6e28adf$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var $7654cdc1c6e28adf$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var $7654cdc1c6e28adf$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var $7654cdc1c6e28adf$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var $7654cdc1c6e28adf$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var $7654cdc1c6e28adf$export$aa9288aeadf882fa = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var $7654cdc1c6e28adf$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var $7654cdc1c6e28adf$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$66a0d8d45aab6631 = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var $7654cdc1c6e28adf$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var $7654cdc1c6e28adf$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var $7654cdc1c6e28adf$export$c762a77aabf64fd0 = {
    prefix: "fas",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$d6ff8a73c0812e63 = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var $7654cdc1c6e28adf$export$ebba617701dfb917 = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var $7654cdc1c6e28adf$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var $7654cdc1c6e28adf$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var $7654cdc1c6e28adf$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $7654cdc1c6e28adf$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $7654cdc1c6e28adf$export$efd983de5e4d6ad3 = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [
        640,
        512,
        [],
        "e066",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var $7654cdc1c6e28adf$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6c74e314e801a4fe = {
    prefix: "fas",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var $7654cdc1c6e28adf$export$a88d1f4073ea9369 = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $7654cdc1c6e28adf$export$b206e700cf7084e1 = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $7654cdc1c6e28adf$export$77ac40095f39933e = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $7654cdc1c6e28adf$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var $7654cdc1c6e28adf$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var $7654cdc1c6e28adf$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var $7654cdc1c6e28adf$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var $7654cdc1c6e28adf$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$c07eb6ff5a382cbd = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var $7654cdc1c6e28adf$export$d6f21a309b179c3d = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var $7654cdc1c6e28adf$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var $7654cdc1c6e28adf$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var $7654cdc1c6e28adf$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var $7654cdc1c6e28adf$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$c6327a203ffc65a3 = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var $7654cdc1c6e28adf$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var $7654cdc1c6e28adf$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var $7654cdc1c6e28adf$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var $7654cdc1c6e28adf$export$8b92530ca6418c2f = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var $7654cdc1c6e28adf$export$a8b3226b2bf323d = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var $7654cdc1c6e28adf$export$533e1f578f74c066 = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var $7654cdc1c6e28adf$export$43c8f2a46326c55f = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var $7654cdc1c6e28adf$export$7a65d2aa54cb4e93 = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var $7654cdc1c6e28adf$export$bd1e24dd3cde8514 = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var $7654cdc1c6e28adf$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var $7654cdc1c6e28adf$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var $7654cdc1c6e28adf$export$e58f9b502d4dd52d = {
    prefix: "fas",
    iconName: "magic",
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var $7654cdc1c6e28adf$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var $7654cdc1c6e28adf$export$dd24f40c5337e2e1 = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var $7654cdc1c6e28adf$export$2e21f9dba1630651 = {
    prefix: "fas",
    iconName: "male",
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $7654cdc1c6e28adf$export$df04458e7e32352c = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $7654cdc1c6e28adf$export$a977d47c74d8e86c = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $7654cdc1c6e28adf$export$10d360e4f1a554dd = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var $7654cdc1c6e28adf$export$4be92fa780613f93 = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var $7654cdc1c6e28adf$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var $7654cdc1c6e28adf$export$743f4b1071b3333a = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var $7654cdc1c6e28adf$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var $7654cdc1c6e28adf$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$5cb0daeafbcdabe3 = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $7654cdc1c6e28adf$export$ed7aa1c25104f333 = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $7654cdc1c6e28adf$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var $7654cdc1c6e28adf$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var $7654cdc1c6e28adf$export$e75f02bae5b7d34b = {
    prefix: "fas",
    iconName: "medkit",
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$6d2db489aaeeecd2 = {
    prefix: "fas",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e945435725f71e88 = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$fdc62a1bea767cc2 = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var $7654cdc1c6e28adf$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var $7654cdc1c6e28adf$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var $7654cdc1c6e28adf$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $7654cdc1c6e28adf$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var $7654cdc1c6e28adf$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var $7654cdc1c6e28adf$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$f08ef94fea14f5ac = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var $7654cdc1c6e28adf$export$d2a53a388f30780 = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var $7654cdc1c6e28adf$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$f3979b49bf57313c = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var $7654cdc1c6e28adf$export$ffe9387966b3e681 = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var $7654cdc1c6e28adf$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var $7654cdc1c6e28adf$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e9599bc6cd92234d = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var $7654cdc1c6e28adf$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $7654cdc1c6e28adf$export$a35d573395884c3d = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $7654cdc1c6e28adf$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var $7654cdc1c6e28adf$export$1613858e873cbb3e = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var $7654cdc1c6e28adf$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$8c6ccc9745897cb2 = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $7654cdc1c6e28adf$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var $7654cdc1c6e28adf$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var $7654cdc1c6e28adf$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var $7654cdc1c6e28adf$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var $7654cdc1c6e28adf$export$198b96b894c66074 = {
    prefix: "fas",
    iconName: "mouse",
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var $7654cdc1c6e28adf$export$2e19a69cc26b147 = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var $7654cdc1c6e28adf$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var $7654cdc1c6e28adf$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var $7654cdc1c6e28adf$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var $7654cdc1c6e28adf$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var $7654cdc1c6e28adf$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var $7654cdc1c6e28adf$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var $7654cdc1c6e28adf$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var $7654cdc1c6e28adf$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var $7654cdc1c6e28adf$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var $7654cdc1c6e28adf$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$594db3339e212bc9 = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var $7654cdc1c6e28adf$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var $7654cdc1c6e28adf$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var $7654cdc1c6e28adf$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var $7654cdc1c6e28adf$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var $7654cdc1c6e28adf$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var $7654cdc1c6e28adf$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var $7654cdc1c6e28adf$export$fda29c8f99573a4e = {
    prefix: "fas",
    iconName: "parking",
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var $7654cdc1c6e28adf$export$733efdaec97447be = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var $7654cdc1c6e28adf$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var $7654cdc1c6e28adf$export$d8cf08a0362da8db = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var $7654cdc1c6e28adf$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var $7654cdc1c6e28adf$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var $7654cdc1c6e28adf$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var $7654cdc1c6e28adf$export$a3d3e92e430d3beb = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var $7654cdc1c6e28adf$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var $7654cdc1c6e28adf$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var $7654cdc1c6e28adf$export$fbb231ccb3d960bc = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var $7654cdc1c6e28adf$export$8210adc172262df = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var $7654cdc1c6e28adf$export$e3a7a1affea005f5 = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var $7654cdc1c6e28adf$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        576,
        512,
        [],
        "e068",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var $7654cdc1c6e28adf$export$35fbd4ff1265acd5 = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var $7654cdc1c6e28adf$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var $7654cdc1c6e28adf$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var $7654cdc1c6e28adf$export$89333857fc063a2e = {
    prefix: "fas",
    iconName: "percentage",
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var $7654cdc1c6e28adf$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var $7654cdc1c6e28adf$export$a07a9b305deebf32 = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var $7654cdc1c6e28adf$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $7654cdc1c6e28adf$export$8ba22605a641ebdf = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var $7654cdc1c6e28adf$export$a41e77f0de98bba7 = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var $7654cdc1c6e28adf$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var $7654cdc1c6e28adf$export$739f6a6a12dfb6ed = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var $7654cdc1c6e28adf$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var $7654cdc1c6e28adf$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var $7654cdc1c6e28adf$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var $7654cdc1c6e28adf$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var $7654cdc1c6e28adf$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var $7654cdc1c6e28adf$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var $7654cdc1c6e28adf$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var $7654cdc1c6e28adf$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var $7654cdc1c6e28adf$export$cf04333781061c5e = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var $7654cdc1c6e28adf$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var $7654cdc1c6e28adf$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$d9cc3a81499af48c = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $7654cdc1c6e28adf$export$b6359eebfe900c35 = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $7654cdc1c6e28adf$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var $7654cdc1c6e28adf$export$bc8ca14ab51f93db = {
    prefix: "fas",
    iconName: "poll",
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var $7654cdc1c6e28adf$export$456a238f0144d430 = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var $7654cdc1c6e28adf$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var $7654cdc1c6e28adf$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var $7654cdc1c6e28adf$export$e3d25f819c7ee7d7 = {
    prefix: "fas",
    iconName: "portrait",
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $7654cdc1c6e28adf$export$9ce041dfec8319b = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$3b32c982141cad51 = {
    prefix: "fas",
    iconName: "pray",
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var $7654cdc1c6e28adf$export$95e08e91b0929943 = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var $7654cdc1c6e28adf$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var $7654cdc1c6e28adf$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$65d1c884b8581d1a = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var $7654cdc1c6e28adf$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$5f9e1870e1866dde = {
    prefix: "fas",
    iconName: "procedures",
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $7654cdc1c6e28adf$export$30bf9f5b96509df1 = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        384,
        512,
        [],
        "e06a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var $7654cdc1c6e28adf$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        384,
        512,
        [],
        "e06b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var $7654cdc1c6e28adf$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var $7654cdc1c6e28adf$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var $7654cdc1c6e28adf$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var $7654cdc1c6e28adf$export$5ba67d7f2265c1a5 = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var $7654cdc1c6e28adf$export$c00c446e6db1605f = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var $7654cdc1c6e28adf$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$46f29ea84ed4c5f1 = {
    prefix: "fas",
    iconName: "quran",
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $7654cdc1c6e28adf$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var $7654cdc1c6e28adf$export$2f048fa82bbddf6f = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var $7654cdc1c6e28adf$export$8357bf8cc666d5f0 = {
    prefix: "fas",
    iconName: "random",
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var $7654cdc1c6e28adf$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var $7654cdc1c6e28adf$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var $7654cdc1c6e28adf$export$3d9f98aa1c24c776 = {
    prefix: "fas",
    iconName: "redo",
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$50c037520c6cfdc1 = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var $7654cdc1c6e28adf$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var $7654cdc1c6e28adf$export$d91179f327329532 = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var $7654cdc1c6e28adf$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var $7654cdc1c6e28adf$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var $7654cdc1c6e28adf$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var $7654cdc1c6e28adf$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var $7654cdc1c6e28adf$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var $7654cdc1c6e28adf$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var $7654cdc1c6e28adf$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var $7654cdc1c6e28adf$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var $7654cdc1c6e28adf$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var $7654cdc1c6e28adf$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var $7654cdc1c6e28adf$export$89c9b1cca2c11484 = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var $7654cdc1c6e28adf$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var $7654cdc1c6e28adf$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var $7654cdc1c6e28adf$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var $7654cdc1c6e28adf$export$5dfd1cb43dc9eadb = {
    prefix: "fas",
    iconName: "running",
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var $7654cdc1c6e28adf$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var $7654cdc1c6e28adf$export$8e924e6bd422cef9 = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var $7654cdc1c6e28adf$export$4b5241926f692f91 = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var $7654cdc1c6e28adf$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var $7654cdc1c6e28adf$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var $7654cdc1c6e28adf$export$1aaa83ff70706e1e = {
    prefix: "fas",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var $7654cdc1c6e28adf$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var $7654cdc1c6e28adf$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var $7654cdc1c6e28adf$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var $7654cdc1c6e28adf$export$871a78837687ffe8 = {
    prefix: "fas",
    iconName: "search",
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var $7654cdc1c6e28adf$export$65b49a6767630708 = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var $7654cdc1c6e28adf$export$c33aba6c251a898a = {
    prefix: "fas",
    iconName: "search-location",
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$efca97eef6a7a17d = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $7654cdc1c6e28adf$export$378f00e6b1a8185 = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $7654cdc1c6e28adf$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var $7654cdc1c6e28adf$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var $7654cdc1c6e28adf$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var $7654cdc1c6e28adf$export$f8e8bb0b3aa8c658 = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var $7654cdc1c6e28adf$export$3799c2d8fd7e493b = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var $7654cdc1c6e28adf$export$ae9e1434571f373c = {
    prefix: "fas",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var $7654cdc1c6e28adf$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$d6508d18a824f291 = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var $7654cdc1c6e28adf$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var $7654cdc1c6e28adf$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var $7654cdc1c6e28adf$export$5e419f47aaeb3c05 = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $7654cdc1c6e28adf$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var $7654cdc1c6e28adf$export$5745f8adbc11eb01 = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$ca6d443595a6578f = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$51da406e5aa1388c = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var $7654cdc1c6e28adf$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var $7654cdc1c6e28adf$export$9d63d851db698c09 = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var $7654cdc1c6e28adf$export$d21d0d6c8e9e8bf9 = {
    prefix: "fas",
    iconName: "sign",
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var $7654cdc1c6e28adf$export$e6709746115bd2ea = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var $7654cdc1c6e28adf$export$20993813350f9671 = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var $7654cdc1c6e28adf$export$c844d6923b7096c2 = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var $7654cdc1c6e28adf$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var $7654cdc1c6e28adf$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
    ]
};
var $7654cdc1c6e28adf$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$21bd1d54bd4f2c5a = {
    prefix: "fas",
    iconName: "skating",
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$eae1acab6fb96708 = {
    prefix: "fas",
    iconName: "skiing",
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var $7654cdc1c6e28adf$export$6ea48260d7d09b1b = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var $7654cdc1c6e28adf$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var $7654cdc1c6e28adf$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var $7654cdc1c6e28adf$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var $7654cdc1c6e28adf$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var $7654cdc1c6e28adf$export$94d4dcb523f95563 = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$c632b2334f0913bc = {
    prefix: "fas",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var $7654cdc1c6e28adf$export$54ada6dc9690e0ca = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var $7654cdc1c6e28adf$export$f5dbb37f6801ee3f = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var $7654cdc1c6e28adf$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var $7654cdc1c6e28adf$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var $7654cdc1c6e28adf$export$e50452a49dec29f = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var $7654cdc1c6e28adf$export$9dbcc3443daa7323 = {
    prefix: "fas",
    iconName: "sms",
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var $7654cdc1c6e28adf$export$72683772d587302a = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var $7654cdc1c6e28adf$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var $7654cdc1c6e28adf$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [],
        "e06e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var $7654cdc1c6e28adf$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var $7654cdc1c6e28adf$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var $7654cdc1c6e28adf$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var $7654cdc1c6e28adf$export$7658045270aafde3 = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $7654cdc1c6e28adf$export$e12d23d82d5c8a89 = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $7654cdc1c6e28adf$export$3c4115b156be730d = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $7654cdc1c6e28adf$export$95ef20828693fb0f = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $7654cdc1c6e28adf$export$4b2a02d50e417b5f = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$e7d80d8c226cb77 = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $7654cdc1c6e28adf$export$28ef3e933e4b5364 = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6e87844b0f151b6a = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var $7654cdc1c6e28adf$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var $7654cdc1c6e28adf$export$835db7eb35b3c29b = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $7654cdc1c6e28adf$export$857385fda7a5a98e = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $7654cdc1c6e28adf$export$d213a3ba3cabed48 = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var $7654cdc1c6e28adf$export$d41859f1bbb9e086 = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $7654cdc1c6e28adf$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var $7654cdc1c6e28adf$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var $7654cdc1c6e28adf$export$4d1c12ba2b4ca565 = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var $7654cdc1c6e28adf$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var $7654cdc1c6e28adf$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var $7654cdc1c6e28adf$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var $7654cdc1c6e28adf$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var $7654cdc1c6e28adf$export$28e4b96627e00057 = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var $7654cdc1c6e28adf$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var $7654cdc1c6e28adf$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var $7654cdc1c6e28adf$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var $7654cdc1c6e28adf$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var $7654cdc1c6e28adf$export$c13575f42532efb3 = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var $7654cdc1c6e28adf$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var $7654cdc1c6e28adf$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var $7654cdc1c6e28adf$export$2884e379aed297d4 = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$b303329afce5de18 = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var $7654cdc1c6e28adf$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$80889adc5d98bf4a = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var $7654cdc1c6e28adf$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$47af2aad60ab3e7c = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var $7654cdc1c6e28adf$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var $7654cdc1c6e28adf$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var $7654cdc1c6e28adf$export$1f1871dab9cec9d8 = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var $7654cdc1c6e28adf$export$b932a586f6ff48b4 = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [
        640,
        512,
        [],
        "e070",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var $7654cdc1c6e28adf$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var $7654cdc1c6e28adf$export$ed81ab40fc4e904 = {
    prefix: "fas",
    iconName: "stream",
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var $7654cdc1c6e28adf$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var $7654cdc1c6e28adf$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$4cabc8a12d4e2f9 = {
    prefix: "fas",
    iconName: "subway",
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var $7654cdc1c6e28adf$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var $7654cdc1c6e28adf$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var $7654cdc1c6e28adf$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$46647c72213f53ba = {
    prefix: "fas",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var $7654cdc1c6e28adf$export$67daf2e2f88c1365 = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var $7654cdc1c6e28adf$export$4dee691631c67d5c = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var $7654cdc1c6e28adf$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var $7654cdc1c6e28adf$export$ff87319002e3dae9 = {
    prefix: "fas",
    iconName: "sync",
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var $7654cdc1c6e28adf$export$2ff2056be8c281e4 = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var $7654cdc1c6e28adf$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var $7654cdc1c6e28adf$export$f378fbb4e0ef7edf = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var $7654cdc1c6e28adf$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$db0cac088255eacc = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var $7654cdc1c6e28adf$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var $7654cdc1c6e28adf$export$38dd17b9f064c10f = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var $7654cdc1c6e28adf$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var $7654cdc1c6e28adf$export$2f6d5b2fec286d63 = {
    prefix: "fas",
    iconName: "tasks",
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var $7654cdc1c6e28adf$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var $7654cdc1c6e28adf$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $7654cdc1c6e28adf$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $7654cdc1c6e28adf$export$af6ebee83047b793 = {
    prefix: "fas",
    iconName: "tenge",
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var $7654cdc1c6e28adf$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var $7654cdc1c6e28adf$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var $7654cdc1c6e28adf$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var $7654cdc1c6e28adf$export$4d383c83efc0c819 = {
    prefix: "fas",
    iconName: "th",
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$69782f333e90cdc6 = {
    prefix: "fas",
    iconName: "th-large",
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var $7654cdc1c6e28adf$export$daf2614a457122c0 = {
    prefix: "fas",
    iconName: "th-list",
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var $7654cdc1c6e28adf$export$3dbedc487b0159ac = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var $7654cdc1c6e28adf$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var $7654cdc1c6e28adf$export$81a2f8298cf523f9 = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $7654cdc1c6e28adf$export$74e07083cef79a6f = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var $7654cdc1c6e28adf$export$2090f040324b4449 = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $7654cdc1c6e28adf$export$ed05754fcbec6e46 = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $7654cdc1c6e28adf$export$6c632d1dc30d4a77 = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $7654cdc1c6e28adf$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var $7654cdc1c6e28adf$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var $7654cdc1c6e28adf$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var $7654cdc1c6e28adf$export$75e38ba471fd89c4 = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var $7654cdc1c6e28adf$export$174bd7f477b115b4 = {
    prefix: "fas",
    iconName: "times",
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var $7654cdc1c6e28adf$export$ab0ec50720a747eb = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var $7654cdc1c6e28adf$export$60dd975bd5938c15 = {
    prefix: "fas",
    iconName: "tint",
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $7654cdc1c6e28adf$export$5d6f0943039b898f = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var $7654cdc1c6e28adf$export$3d016d62cda18371 = {
    prefix: "fas",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var $7654cdc1c6e28adf$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var $7654cdc1c6e28adf$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var $7654cdc1c6e28adf$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var $7654cdc1c6e28adf$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var $7654cdc1c6e28adf$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var $7654cdc1c6e28adf$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var $7654cdc1c6e28adf$export$646e4e7a8c6172aa = {
    prefix: "fas",
    iconName: "tools",
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var $7654cdc1c6e28adf$export$54d07baabd8c2acb = {
    prefix: "fas",
    iconName: "torah",
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var $7654cdc1c6e28adf$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var $7654cdc1c6e28adf$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var $7654cdc1c6e28adf$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var $7654cdc1c6e28adf$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var $7654cdc1c6e28adf$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var $7654cdc1c6e28adf$export$a7a36674c079f293 = {
    prefix: "fas",
    iconName: "tram",
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $7654cdc1c6e28adf$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$9c36cf9334c052f = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var $7654cdc1c6e28adf$export$88df7ff7eb32f9dc = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$d32f45a64ed40e8d = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$d075b19b21cb9856 = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var $7654cdc1c6e28adf$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var $7654cdc1c6e28adf$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $7654cdc1c6e28adf$export$f00c152db7d44638 = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $7654cdc1c6e28adf$export$36edce3ba87c2b17 = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var $7654cdc1c6e28adf$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $7654cdc1c6e28adf$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var $7654cdc1c6e28adf$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var $7654cdc1c6e28adf$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$a5e5ba60b1dfe2b2 = {
    prefix: "fas",
    iconName: "undo",
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var $7654cdc1c6e28adf$export$c8197b992c46c4a6 = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var $7654cdc1c6e28adf$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var $7654cdc1c6e28adf$export$f2e1460ebe1a8cb0 = {
    prefix: "fas",
    iconName: "university",
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var $7654cdc1c6e28adf$export$2f546f7d8ba01e18 = {
    prefix: "fas",
    iconName: "unlink",
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var $7654cdc1c6e28adf$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$b19f508797f3d9c3 = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var $7654cdc1c6e28adf$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $7654cdc1c6e28adf$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $7654cdc1c6e28adf$export$ae9b19c2ac726cfc = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var $7654cdc1c6e28adf$export$46185fab4772ada6 = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var $7654cdc1c6e28adf$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var $7654cdc1c6e28adf$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var $7654cdc1c6e28adf$export$be7d974e9e0dba1a = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var $7654cdc1c6e28adf$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var $7654cdc1c6e28adf$export$474108c2b86e730e = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var $7654cdc1c6e28adf$export$a68a6960fc8eef82 = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var $7654cdc1c6e28adf$export$46073bec205635d9 = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var $7654cdc1c6e28adf$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var $7654cdc1c6e28adf$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var $7654cdc1c6e28adf$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var $7654cdc1c6e28adf$export$ab0d33a2c03f1794 = {
    prefix: "fas",
    iconName: "user-md",
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var $7654cdc1c6e28adf$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $7654cdc1c6e28adf$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var $7654cdc1c6e28adf$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var $7654cdc1c6e28adf$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $7654cdc1c6e28adf$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var $7654cdc1c6e28adf$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var $7654cdc1c6e28adf$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var $7654cdc1c6e28adf$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var $7654cdc1c6e28adf$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var $7654cdc1c6e28adf$export$45b996d071667753 = {
    prefix: "fas",
    iconName: "user-times",
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $7654cdc1c6e28adf$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $7654cdc1c6e28adf$export$5e0b06753fc69b81 = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $7654cdc1c6e28adf$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
    ]
};
var $7654cdc1c6e28adf$export$fb7af5d245fb9053 = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var $7654cdc1c6e28adf$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var $7654cdc1c6e28adf$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var $7654cdc1c6e28adf$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $7654cdc1c6e28adf$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var $7654cdc1c6e28adf$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
    ]
};
var $7654cdc1c6e28adf$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
    ]
};
var $7654cdc1c6e28adf$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var $7654cdc1c6e28adf$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var $7654cdc1c6e28adf$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var $7654cdc1c6e28adf$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var $7654cdc1c6e28adf$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var $7654cdc1c6e28adf$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var $7654cdc1c6e28adf$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
    ]
};
var $7654cdc1c6e28adf$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var $7654cdc1c6e28adf$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var $7654cdc1c6e28adf$export$a15e6fc8e68a76b0 = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var $7654cdc1c6e28adf$export$69fdf57632b6cc29 = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var $7654cdc1c6e28adf$export$aa8decd057dfd29b = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var $7654cdc1c6e28adf$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var $7654cdc1c6e28adf$export$5940d3e475d90cc4 = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var $7654cdc1c6e28adf$export$e87bb3db1608b850 = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var $7654cdc1c6e28adf$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var $7654cdc1c6e28adf$export$4886811b7174ec35 = {
    prefix: "fas",
    iconName: "walking",
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var $7654cdc1c6e28adf$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var $7654cdc1c6e28adf$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var $7654cdc1c6e28adf$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var $7654cdc1c6e28adf$export$cf3bafa68a60bae4 = {
    prefix: "fas",
    iconName: "weight",
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var $7654cdc1c6e28adf$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $7654cdc1c6e28adf$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var $7654cdc1c6e28adf$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var $7654cdc1c6e28adf$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var $7654cdc1c6e28adf$export$18b7775f78a3e16 = {
    prefix: "fas",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var $7654cdc1c6e28adf$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var $7654cdc1c6e28adf$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var $7654cdc1c6e28adf$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var $7654cdc1c6e28adf$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var $7654cdc1c6e28adf$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var $7654cdc1c6e28adf$export$b8ff3fe2b78aef2f = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var $7654cdc1c6e28adf$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var $7654cdc1c6e28adf$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $7654cdc1c6e28adf$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var $7654cdc1c6e28adf$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var $7654cdc1c6e28adf$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $7654cdc1c6e28adf$export$da048c47c8dcd50a = {
    faAd: $7654cdc1c6e28adf$export$7af266c3465b1ff2,
    faAddressBook: $7654cdc1c6e28adf$export$853fd1561789e3bb,
    faAddressCard: $7654cdc1c6e28adf$export$6ea408c7266ed557,
    faAdjust: $7654cdc1c6e28adf$export$cfa06e4b68edca2d,
    faAirFreshener: $7654cdc1c6e28adf$export$a5e63e89b5ccee83,
    faAlignCenter: $7654cdc1c6e28adf$export$70e29dd05344623e,
    faAlignJustify: $7654cdc1c6e28adf$export$97c42b56d462df72,
    faAlignLeft: $7654cdc1c6e28adf$export$e490f662af4d1c78,
    faAlignRight: $7654cdc1c6e28adf$export$7370f36a39a38737,
    faAllergies: $7654cdc1c6e28adf$export$dcae2101babbffff,
    faAmbulance: $7654cdc1c6e28adf$export$f5c7042778b51765,
    faAmericanSignLanguageInterpreting: $7654cdc1c6e28adf$export$23a7517099ab1b86,
    faAnchor: $7654cdc1c6e28adf$export$12a35719f889cd1,
    faAngleDoubleDown: $7654cdc1c6e28adf$export$fd504117f273ca92,
    faAngleDoubleLeft: $7654cdc1c6e28adf$export$21b0833b3cf929a7,
    faAngleDoubleRight: $7654cdc1c6e28adf$export$792931403404faf0,
    faAngleDoubleUp: $7654cdc1c6e28adf$export$9bb51e1a2c07db7c,
    faAngleDown: $7654cdc1c6e28adf$export$4b5be0142d10f342,
    faAngleLeft: $7654cdc1c6e28adf$export$3cbcd1b7e35945d2,
    faAngleRight: $7654cdc1c6e28adf$export$6bce1afb61f2eb66,
    faAngleUp: $7654cdc1c6e28adf$export$887340269e6d6cac,
    faAngry: $7654cdc1c6e28adf$export$3c96c08e234498c5,
    faAnkh: $7654cdc1c6e28adf$export$8736909014b15ca9,
    faAppleAlt: $7654cdc1c6e28adf$export$bcdd94f3977a0884,
    faArchive: $7654cdc1c6e28adf$export$26b3e1c454273f34,
    faArchway: $7654cdc1c6e28adf$export$d56753dd2eb5c323,
    faArrowAltCircleDown: $7654cdc1c6e28adf$export$ff3afbc8c0bc5d59,
    faArrowAltCircleLeft: $7654cdc1c6e28adf$export$5460a5b11a24996f,
    faArrowAltCircleRight: $7654cdc1c6e28adf$export$88962ffdad8b856d,
    faArrowAltCircleUp: $7654cdc1c6e28adf$export$3747a8ef0995eadf,
    faArrowCircleDown: $7654cdc1c6e28adf$export$6cfa36bbb3a057,
    faArrowCircleLeft: $7654cdc1c6e28adf$export$728262abb9f58d0a,
    faArrowCircleRight: $7654cdc1c6e28adf$export$7d3d828103aa3be7,
    faArrowCircleUp: $7654cdc1c6e28adf$export$a2f6f3baa50af0b1,
    faArrowDown: $7654cdc1c6e28adf$export$9686eff8d817f770,
    faArrowLeft: $7654cdc1c6e28adf$export$b7fac681e7d09400,
    faArrowRight: $7654cdc1c6e28adf$export$b4da69a0247f3620,
    faArrowUp: $7654cdc1c6e28adf$export$8e144ed4d52eef49,
    faArrowsAlt: $7654cdc1c6e28adf$export$3cdabfff52cfc73a,
    faArrowsAltH: $7654cdc1c6e28adf$export$7937ea574fb1389,
    faArrowsAltV: $7654cdc1c6e28adf$export$138cb56a3f8f7040,
    faAssistiveListeningSystems: $7654cdc1c6e28adf$export$8eeef3dc0035b165,
    faAsterisk: $7654cdc1c6e28adf$export$19eff32c0fd4f99f,
    faAt: $7654cdc1c6e28adf$export$c115e8063ee02632,
    faAtlas: $7654cdc1c6e28adf$export$380a9050e42fe5d7,
    faAtom: $7654cdc1c6e28adf$export$b5bb295e8ad4ab31,
    faAudioDescription: $7654cdc1c6e28adf$export$b6b464c98c009494,
    faAward: $7654cdc1c6e28adf$export$f8db2747dadd48f7,
    faBaby: $7654cdc1c6e28adf$export$8afab767536f59ad,
    faBabyCarriage: $7654cdc1c6e28adf$export$3b3ab4d86bad7d26,
    faBackspace: $7654cdc1c6e28adf$export$e43e3f67102fc526,
    faBackward: $7654cdc1c6e28adf$export$ae65f96ea7a4078d,
    faBacon: $7654cdc1c6e28adf$export$ab07061fe21a3a8e,
    faBacteria: $7654cdc1c6e28adf$export$7fc18cf2d526c341,
    faBacterium: $7654cdc1c6e28adf$export$b0babe4230e35ebe,
    faBahai: $7654cdc1c6e28adf$export$6d636565b3ec36b4,
    faBalanceScale: $7654cdc1c6e28adf$export$fec323dcfd81d750,
    faBalanceScaleLeft: $7654cdc1c6e28adf$export$786cb0c775487f19,
    faBalanceScaleRight: $7654cdc1c6e28adf$export$2238e05f8920005a,
    faBan: $7654cdc1c6e28adf$export$76f704d256def3c7,
    faBandAid: $7654cdc1c6e28adf$export$b14a1014df2fdf46,
    faBarcode: $7654cdc1c6e28adf$export$3825a842b5afc5aa,
    faBars: $7654cdc1c6e28adf$export$36e9cf7887265da2,
    faBaseballBall: $7654cdc1c6e28adf$export$63a3f8ceae07c7f3,
    faBasketballBall: $7654cdc1c6e28adf$export$36550ab8ffcc5b28,
    faBath: $7654cdc1c6e28adf$export$1ea66a88b8f620c9,
    faBatteryEmpty: $7654cdc1c6e28adf$export$1344b64f6e922e12,
    faBatteryFull: $7654cdc1c6e28adf$export$9338fc4614cfc0cf,
    faBatteryHalf: $7654cdc1c6e28adf$export$e6dadc1155c4ee48,
    faBatteryQuarter: $7654cdc1c6e28adf$export$acec92052ac2183,
    faBatteryThreeQuarters: $7654cdc1c6e28adf$export$cfb37069d38f379e,
    faBed: $7654cdc1c6e28adf$export$f24e0fce77994d4d,
    faBeer: $7654cdc1c6e28adf$export$f74725691538983b,
    faBell: $7654cdc1c6e28adf$export$9b6162797ab1b255,
    faBellSlash: $7654cdc1c6e28adf$export$6b31a1e5968b2378,
    faBezierCurve: $7654cdc1c6e28adf$export$a527a6267c55a54c,
    faBible: $7654cdc1c6e28adf$export$2eac809b0670d139,
    faBicycle: $7654cdc1c6e28adf$export$36cb1885ad7a570f,
    faBiking: $7654cdc1c6e28adf$export$a5bcf835dbf9c0b,
    faBinoculars: $7654cdc1c6e28adf$export$8a910017964bb8c2,
    faBiohazard: $7654cdc1c6e28adf$export$ae3a453550dec95,
    faBirthdayCake: $7654cdc1c6e28adf$export$bdcf98f725a7241a,
    faBlender: $7654cdc1c6e28adf$export$db34f7a6de38784f,
    faBlenderPhone: $7654cdc1c6e28adf$export$f35a116a762ef8fc,
    faBlind: $7654cdc1c6e28adf$export$923de21def6ea9b6,
    faBlog: $7654cdc1c6e28adf$export$890d5e011054935a,
    faBold: $7654cdc1c6e28adf$export$7e0c7fd2a2e88823,
    faBolt: $7654cdc1c6e28adf$export$6869964aa308dd31,
    faBomb: $7654cdc1c6e28adf$export$d59078f6e80b4a67,
    faBone: $7654cdc1c6e28adf$export$5902c007d5703f2d,
    faBong: $7654cdc1c6e28adf$export$e74974fac77c468e,
    faBook: $7654cdc1c6e28adf$export$c9d7ef726d1a8742,
    faBookDead: $7654cdc1c6e28adf$export$b98a3f8c3941a74a,
    faBookMedical: $7654cdc1c6e28adf$export$6feb44fec53ba30d,
    faBookOpen: $7654cdc1c6e28adf$export$8a3071811b2b7979,
    faBookReader: $7654cdc1c6e28adf$export$cee14fe33262fa7d,
    faBookmark: $7654cdc1c6e28adf$export$4ed9da5c3cca0ef1,
    faBorderAll: $7654cdc1c6e28adf$export$93a5eb721c9c0d25,
    faBorderNone: $7654cdc1c6e28adf$export$2b488402ec335d97,
    faBorderStyle: $7654cdc1c6e28adf$export$c2867ca78120d644,
    faBowlingBall: $7654cdc1c6e28adf$export$5ee2640fe105312d,
    faBox: $7654cdc1c6e28adf$export$6e7cf270cda52323,
    faBoxOpen: $7654cdc1c6e28adf$export$9010ed816a8b9c97,
    faBoxTissue: $7654cdc1c6e28adf$export$f2adc06617bc0c7,
    faBoxes: $7654cdc1c6e28adf$export$2007320dd6cde6db,
    faBraille: $7654cdc1c6e28adf$export$983e9c27cac7ed1c,
    faBrain: $7654cdc1c6e28adf$export$97fa4f4c1006ab1,
    faBreadSlice: $7654cdc1c6e28adf$export$d78e8b0681279167,
    faBriefcase: $7654cdc1c6e28adf$export$8da450d063b0eb37,
    faBriefcaseMedical: $7654cdc1c6e28adf$export$5000f52ca9819bf5,
    faBroadcastTower: $7654cdc1c6e28adf$export$f68b38d51f5c0ed,
    faBroom: $7654cdc1c6e28adf$export$2a533051418ff4ca,
    faBrush: $7654cdc1c6e28adf$export$5824ffe6f8983c83,
    faBug: $7654cdc1c6e28adf$export$a18cfac400116d9f,
    faBuilding: $7654cdc1c6e28adf$export$f26673f8b10c3d46,
    faBullhorn: $7654cdc1c6e28adf$export$dacae2b4ec565333,
    faBullseye: $7654cdc1c6e28adf$export$554720e3bf74fe90,
    faBurn: $7654cdc1c6e28adf$export$80ed4535efc60402,
    faBus: $7654cdc1c6e28adf$export$ce69441578ff2fdb,
    faBusAlt: $7654cdc1c6e28adf$export$40616edfab6d332a,
    faBusinessTime: $7654cdc1c6e28adf$export$694b7e88782dec12,
    faCalculator: $7654cdc1c6e28adf$export$693bd40950ed2c3a,
    faCalendar: $7654cdc1c6e28adf$export$34f5c36a3e80efa2,
    faCalendarAlt: $7654cdc1c6e28adf$export$cbc139f33cff356,
    faCalendarCheck: $7654cdc1c6e28adf$export$5655108e1162ba45,
    faCalendarDay: $7654cdc1c6e28adf$export$80968bcfef6481ca,
    faCalendarMinus: $7654cdc1c6e28adf$export$23e8b4955c2d951b,
    faCalendarPlus: $7654cdc1c6e28adf$export$16768a660ae3ca9d,
    faCalendarTimes: $7654cdc1c6e28adf$export$99b20d7352fbcf08,
    faCalendarWeek: $7654cdc1c6e28adf$export$39be5cb4aed5a521,
    faCamera: $7654cdc1c6e28adf$export$84ffbd7161ca2008,
    faCameraRetro: $7654cdc1c6e28adf$export$41dbdadc07a89b05,
    faCampground: $7654cdc1c6e28adf$export$295287303c0e9c7c,
    faCandyCane: $7654cdc1c6e28adf$export$14d66ba7571ae0b9,
    faCannabis: $7654cdc1c6e28adf$export$8ec2f752344b69bd,
    faCapsules: $7654cdc1c6e28adf$export$ba6fd4a436804a48,
    faCar: $7654cdc1c6e28adf$export$9eefe7fcdf123b76,
    faCarAlt: $7654cdc1c6e28adf$export$7937ed2462a665c0,
    faCarBattery: $7654cdc1c6e28adf$export$a44d0c11093d9c1e,
    faCarCrash: $7654cdc1c6e28adf$export$8ff55566398404cd,
    faCarSide: $7654cdc1c6e28adf$export$6f7218565b1b8d0e,
    faCaravan: $7654cdc1c6e28adf$export$afb5d0eee7c1bdb,
    faCaretDown: $7654cdc1c6e28adf$export$f9395ef707603e40,
    faCaretLeft: $7654cdc1c6e28adf$export$85a918a11b7643c2,
    faCaretRight: $7654cdc1c6e28adf$export$f1011352b01c1c0,
    faCaretSquareDown: $7654cdc1c6e28adf$export$61aea18df1c84401,
    faCaretSquareLeft: $7654cdc1c6e28adf$export$d0c8ba444f1f9581,
    faCaretSquareRight: $7654cdc1c6e28adf$export$ae86c9de7e0f62fa,
    faCaretSquareUp: $7654cdc1c6e28adf$export$307ae80b26533ce5,
    faCaretUp: $7654cdc1c6e28adf$export$7de776bdab4e536d,
    faCarrot: $7654cdc1c6e28adf$export$28e93ec9f5e2ddf3,
    faCartArrowDown: $7654cdc1c6e28adf$export$9206260ff0c0c616,
    faCartPlus: $7654cdc1c6e28adf$export$6675e2bf21fdb87e,
    faCashRegister: $7654cdc1c6e28adf$export$6357093f67788b33,
    faCat: $7654cdc1c6e28adf$export$ab927dada03be4b3,
    faCertificate: $7654cdc1c6e28adf$export$a881f37164b11fbf,
    faChair: $7654cdc1c6e28adf$export$a339864ee3df7e9a,
    faChalkboard: $7654cdc1c6e28adf$export$49a36efd66df775,
    faChalkboardTeacher: $7654cdc1c6e28adf$export$443fcf69b0155291,
    faChargingStation: $7654cdc1c6e28adf$export$bab2cd86f8c65657,
    faChartArea: $7654cdc1c6e28adf$export$2acab8312b7a999b,
    faChartBar: $7654cdc1c6e28adf$export$b532f5d25de97633,
    faChartLine: $7654cdc1c6e28adf$export$e022f62a119e1d93,
    faChartPie: $7654cdc1c6e28adf$export$1de7b9cf7d1b153b,
    faCheck: $7654cdc1c6e28adf$export$62b2c752fccc6a9c,
    faCheckCircle: $7654cdc1c6e28adf$export$be9e388158c74f29,
    faCheckDouble: $7654cdc1c6e28adf$export$f178c8c2ad3cc861,
    faCheckSquare: $7654cdc1c6e28adf$export$f0c8040f596df7fe,
    faCheese: $7654cdc1c6e28adf$export$549b99473b7201e6,
    faChess: $7654cdc1c6e28adf$export$442fddbbd741c590,
    faChessBishop: $7654cdc1c6e28adf$export$a831eedd2f59c62f,
    faChessBoard: $7654cdc1c6e28adf$export$bd301515df6246af,
    faChessKing: $7654cdc1c6e28adf$export$d5713874f8fefe1b,
    faChessKnight: $7654cdc1c6e28adf$export$861b1f13085cf122,
    faChessPawn: $7654cdc1c6e28adf$export$3db75d5ac9e98468,
    faChessQueen: $7654cdc1c6e28adf$export$7b8ce73615739d30,
    faChessRook: $7654cdc1c6e28adf$export$5d65c40a109eb09c,
    faChevronCircleDown: $7654cdc1c6e28adf$export$9926124d75b2ecab,
    faChevronCircleLeft: $7654cdc1c6e28adf$export$4a42c8c2451a33fd,
    faChevronCircleRight: $7654cdc1c6e28adf$export$2a5db4f6eba6f2b,
    faChevronCircleUp: $7654cdc1c6e28adf$export$b786cf5db03f2c36,
    faChevronDown: $7654cdc1c6e28adf$export$8db9bc521720fccd,
    faChevronLeft: $7654cdc1c6e28adf$export$75702e3e3dd44a44,
    faChevronRight: $7654cdc1c6e28adf$export$930de8c26eb20490,
    faChevronUp: $7654cdc1c6e28adf$export$877e5ae47a854215,
    faChild: $7654cdc1c6e28adf$export$60b41e3581d1739a,
    faChurch: $7654cdc1c6e28adf$export$16a3f12c6ae9650,
    faCircle: $7654cdc1c6e28adf$export$4280b2387fbdad12,
    faCircleNotch: $7654cdc1c6e28adf$export$9429fd8df55155d,
    faCity: $7654cdc1c6e28adf$export$a9947c2888b3c8fd,
    faClinicMedical: $7654cdc1c6e28adf$export$20d8a680febc7434,
    faClipboard: $7654cdc1c6e28adf$export$97d84347d71ba297,
    faClipboardCheck: $7654cdc1c6e28adf$export$7babcb2c90eb609a,
    faClipboardList: $7654cdc1c6e28adf$export$2c5a9d8548d8810e,
    faClock: $7654cdc1c6e28adf$export$95b9968e7fceb821,
    faClone: $7654cdc1c6e28adf$export$76c1aa4bf9a39458,
    faClosedCaptioning: $7654cdc1c6e28adf$export$8e047801a8603af7,
    faCloud: $7654cdc1c6e28adf$export$8bb3c4d5c2f50243,
    faCloudDownloadAlt: $7654cdc1c6e28adf$export$351357a14c41f824,
    faCloudMeatball: $7654cdc1c6e28adf$export$5d120e8b87ad33f4,
    faCloudMoon: $7654cdc1c6e28adf$export$482eb125aaf0fbc2,
    faCloudMoonRain: $7654cdc1c6e28adf$export$301c3fab0c4545bd,
    faCloudRain: $7654cdc1c6e28adf$export$a6c308ee087b4ded,
    faCloudShowersHeavy: $7654cdc1c6e28adf$export$af51c741ee9cc090,
    faCloudSun: $7654cdc1c6e28adf$export$dcaadfd9c98e42a1,
    faCloudSunRain: $7654cdc1c6e28adf$export$dd9dc9b4227dbe94,
    faCloudUploadAlt: $7654cdc1c6e28adf$export$e73b3e819b9d14a5,
    faCocktail: $7654cdc1c6e28adf$export$4be708f1e41d387b,
    faCode: $7654cdc1c6e28adf$export$eba095993e51cc97,
    faCodeBranch: $7654cdc1c6e28adf$export$aa054a78ab078db3,
    faCoffee: $7654cdc1c6e28adf$export$1d24a9e457278011,
    faCog: $7654cdc1c6e28adf$export$d6298bbfd1912a78,
    faCogs: $7654cdc1c6e28adf$export$af1575770afc9559,
    faCoins: $7654cdc1c6e28adf$export$bc5da164799a0e,
    faColumns: $7654cdc1c6e28adf$export$bb861166644ac28a,
    faComment: $7654cdc1c6e28adf$export$805cd88398a70581,
    faCommentAlt: $7654cdc1c6e28adf$export$6e96904d9af0ec4a,
    faCommentDollar: $7654cdc1c6e28adf$export$7a088030853df12c,
    faCommentDots: $7654cdc1c6e28adf$export$63ffcb3d4e94cb92,
    faCommentMedical: $7654cdc1c6e28adf$export$101422b773924276,
    faCommentSlash: $7654cdc1c6e28adf$export$3786a0422a3f33ea,
    faComments: $7654cdc1c6e28adf$export$932912e74adb8939,
    faCommentsDollar: $7654cdc1c6e28adf$export$d477129b070e5ac4,
    faCompactDisc: $7654cdc1c6e28adf$export$84021631df0f831b,
    faCompass: $7654cdc1c6e28adf$export$b4d344633433e50e,
    faCompress: $7654cdc1c6e28adf$export$83632d1150d3541f,
    faCompressAlt: $7654cdc1c6e28adf$export$a05650ebe54bede,
    faCompressArrowsAlt: $7654cdc1c6e28adf$export$39205db0ea980efd,
    faConciergeBell: $7654cdc1c6e28adf$export$ad92ffbbfbc0fcf3,
    faCookie: $7654cdc1c6e28adf$export$b3e64f5f68c6623f,
    faCookieBite: $7654cdc1c6e28adf$export$317dde8664f7de71,
    faCopy: $7654cdc1c6e28adf$export$e9bd786d30cb716c,
    faCopyright: $7654cdc1c6e28adf$export$da61665fff8aebfe,
    faCouch: $7654cdc1c6e28adf$export$ce96e32767a7dd51,
    faCreditCard: $7654cdc1c6e28adf$export$3e7437bf6535bef0,
    faCrop: $7654cdc1c6e28adf$export$afa58590dfb6fca2,
    faCropAlt: $7654cdc1c6e28adf$export$d932915fde4f1010,
    faCross: $7654cdc1c6e28adf$export$9d0a89fcd084abb,
    faCrosshairs: $7654cdc1c6e28adf$export$721c101130c40043,
    faCrow: $7654cdc1c6e28adf$export$bfa312207b788ed9,
    faCrown: $7654cdc1c6e28adf$export$dc1083dcd1d7b9d6,
    faCrutch: $7654cdc1c6e28adf$export$e94134641c0e2,
    faCube: $7654cdc1c6e28adf$export$973ae4f1e4d2ce78,
    faCubes: $7654cdc1c6e28adf$export$30523a9441a31e97,
    faCut: $7654cdc1c6e28adf$export$66847f2a71b260e7,
    faDatabase: $7654cdc1c6e28adf$export$24680dede86b1883,
    faDeaf: $7654cdc1c6e28adf$export$4b666adf83f0de01,
    faDemocrat: $7654cdc1c6e28adf$export$a1672d808fbed0bd,
    faDesktop: $7654cdc1c6e28adf$export$6e6ddc253102e596,
    faDharmachakra: $7654cdc1c6e28adf$export$45cbd92c28deb2c7,
    faDiagnoses: $7654cdc1c6e28adf$export$68bad2b52a90d1fa,
    faDice: $7654cdc1c6e28adf$export$4ed8206e6619cc8f,
    faDiceD20: $7654cdc1c6e28adf$export$b06003a02c9055bd,
    faDiceD6: $7654cdc1c6e28adf$export$64bfd48ed353c031,
    faDiceFive: $7654cdc1c6e28adf$export$d9769fb795c2db82,
    faDiceFour: $7654cdc1c6e28adf$export$2df6451abf70a6ff,
    faDiceOne: $7654cdc1c6e28adf$export$d91800b7be5303b0,
    faDiceSix: $7654cdc1c6e28adf$export$3397c7b4679acccc,
    faDiceThree: $7654cdc1c6e28adf$export$221059e0d5fd8958,
    faDiceTwo: $7654cdc1c6e28adf$export$4d85df590065572f,
    faDigitalTachograph: $7654cdc1c6e28adf$export$b3bf1994f0fefe98,
    faDirections: $7654cdc1c6e28adf$export$6a6973de44442fe5,
    faDisease: $7654cdc1c6e28adf$export$c7675a37487adc45,
    faDivide: $7654cdc1c6e28adf$export$89fa217ec5503ac9,
    faDizzy: $7654cdc1c6e28adf$export$89a2b10dabc487e8,
    faDna: $7654cdc1c6e28adf$export$c062100d54a2da00,
    faDog: $7654cdc1c6e28adf$export$c6406747800cf702,
    faDollarSign: $7654cdc1c6e28adf$export$fb420d3e4d8c6a18,
    faDolly: $7654cdc1c6e28adf$export$5879d0bca1aa497b,
    faDollyFlatbed: $7654cdc1c6e28adf$export$f7c6efb60c53b285,
    faDonate: $7654cdc1c6e28adf$export$40050ae52860cde7,
    faDoorClosed: $7654cdc1c6e28adf$export$2c79e1a422528bba,
    faDoorOpen: $7654cdc1c6e28adf$export$41821b9a6fd703de,
    faDotCircle: $7654cdc1c6e28adf$export$92bc269cb244d66a,
    faDove: $7654cdc1c6e28adf$export$a1ab1e69a300089f,
    faDownload: $7654cdc1c6e28adf$export$8f734e51d72ca13a,
    faDraftingCompass: $7654cdc1c6e28adf$export$c8c2b127d13b9d79,
    faDragon: $7654cdc1c6e28adf$export$ae1875ba975aa0e9,
    faDrawPolygon: $7654cdc1c6e28adf$export$df9bd3777d1154d2,
    faDrum: $7654cdc1c6e28adf$export$5b9205e1042594b7,
    faDrumSteelpan: $7654cdc1c6e28adf$export$48d1206500db2e9d,
    faDrumstickBite: $7654cdc1c6e28adf$export$482976e9a4ab10f3,
    faDumbbell: $7654cdc1c6e28adf$export$56700074cf37be5c,
    faDumpster: $7654cdc1c6e28adf$export$3b934e22d1851a3b,
    faDumpsterFire: $7654cdc1c6e28adf$export$25e9b29b3f2230b5,
    faDungeon: $7654cdc1c6e28adf$export$1156dc6acb0058bd,
    faEdit: $7654cdc1c6e28adf$export$7be713e57d023733,
    faEgg: $7654cdc1c6e28adf$export$1199a8ce85311ab5,
    faEject: $7654cdc1c6e28adf$export$8484041d5b209494,
    faEllipsisH: $7654cdc1c6e28adf$export$c9f2fedd4489a2ee,
    faEllipsisV: $7654cdc1c6e28adf$export$e58494c7fcb5380,
    faEnvelope: $7654cdc1c6e28adf$export$6f095630677adc,
    faEnvelopeOpen: $7654cdc1c6e28adf$export$c6c3bd5f7d9b8bf2,
    faEnvelopeOpenText: $7654cdc1c6e28adf$export$f5c53ce8ec380d11,
    faEnvelopeSquare: $7654cdc1c6e28adf$export$354e159473e73552,
    faEquals: $7654cdc1c6e28adf$export$a7c5f5e4805fdab,
    faEraser: $7654cdc1c6e28adf$export$e7fc4fe34e767f28,
    faEthernet: $7654cdc1c6e28adf$export$6bad2c9f317b52e5,
    faEuroSign: $7654cdc1c6e28adf$export$902a3969bb113dff,
    faExchangeAlt: $7654cdc1c6e28adf$export$f6c6fb20d374b128,
    faExclamation: $7654cdc1c6e28adf$export$de6218b649cbb6a9,
    faExclamationCircle: $7654cdc1c6e28adf$export$220e07e14c5d7e5d,
    faExclamationTriangle: $7654cdc1c6e28adf$export$3d249b63b52cce7c,
    faExpand: $7654cdc1c6e28adf$export$1fe4a9976a241685,
    faExpandAlt: $7654cdc1c6e28adf$export$bcb8d86a3a1d6eb6,
    faExpandArrowsAlt: $7654cdc1c6e28adf$export$6219dcd88b5fa6c2,
    faExternalLinkAlt: $7654cdc1c6e28adf$export$d7f107e456ab0306,
    faExternalLinkSquareAlt: $7654cdc1c6e28adf$export$e4cdf2977151ee26,
    faEye: $7654cdc1c6e28adf$export$b8c3e79e8c99c95b,
    faEyeDropper: $7654cdc1c6e28adf$export$1bc3e0ad56dc9eb0,
    faEyeSlash: $7654cdc1c6e28adf$export$ed3f2918429d029a,
    faFan: $7654cdc1c6e28adf$export$55145a3dae4f984a,
    faFastBackward: $7654cdc1c6e28adf$export$e6246a3279a379b8,
    faFastForward: $7654cdc1c6e28adf$export$61a8cdc53c2e078d,
    faFaucet: $7654cdc1c6e28adf$export$a0856b225f3b0614,
    faFax: $7654cdc1c6e28adf$export$b5698497901d7197,
    faFeather: $7654cdc1c6e28adf$export$5e19aea195b31816,
    faFeatherAlt: $7654cdc1c6e28adf$export$68cf766c786bcd78,
    faFemale: $7654cdc1c6e28adf$export$70e8e75e61dd7169,
    faFighterJet: $7654cdc1c6e28adf$export$102b809faf56e033,
    faFile: $7654cdc1c6e28adf$export$cad54bead856a678,
    faFileAlt: $7654cdc1c6e28adf$export$243b47dca32bf0b8,
    faFileArchive: $7654cdc1c6e28adf$export$bf2047a9946b5c3f,
    faFileAudio: $7654cdc1c6e28adf$export$b8d24c57c9e64933,
    faFileCode: $7654cdc1c6e28adf$export$143d0ca7d2200f20,
    faFileContract: $7654cdc1c6e28adf$export$70fde3f3fdaa6a6a,
    faFileCsv: $7654cdc1c6e28adf$export$82cea4f586f6ec9,
    faFileDownload: $7654cdc1c6e28adf$export$1013b9966d758343,
    faFileExcel: $7654cdc1c6e28adf$export$77cb1a465c4fe84,
    faFileExport: $7654cdc1c6e28adf$export$364f19abcfac1b0a,
    faFileImage: $7654cdc1c6e28adf$export$6440b286d3cbac9b,
    faFileImport: $7654cdc1c6e28adf$export$d796c05153b1255c,
    faFileInvoice: $7654cdc1c6e28adf$export$bef39294aed2281a,
    faFileInvoiceDollar: $7654cdc1c6e28adf$export$a3dced32d48cb1ea,
    faFileMedical: $7654cdc1c6e28adf$export$56cbcd962389b090,
    faFileMedicalAlt: $7654cdc1c6e28adf$export$ef02a0f5b39aa61f,
    faFilePdf: $7654cdc1c6e28adf$export$38611f1c776aba73,
    faFilePowerpoint: $7654cdc1c6e28adf$export$c341daeecdea449a,
    faFilePrescription: $7654cdc1c6e28adf$export$a20cb90865b6beb8,
    faFileSignature: $7654cdc1c6e28adf$export$d0de575ac166712b,
    faFileUpload: $7654cdc1c6e28adf$export$dd55ded1264643d2,
    faFileVideo: $7654cdc1c6e28adf$export$b44eb38345c6a964,
    faFileWord: $7654cdc1c6e28adf$export$f0858dff6e769cf6,
    faFill: $7654cdc1c6e28adf$export$d3c2bcfd3b861e4a,
    faFillDrip: $7654cdc1c6e28adf$export$38320138fc0262d0,
    faFilm: $7654cdc1c6e28adf$export$c03de0cc616e77bb,
    faFilter: $7654cdc1c6e28adf$export$f253a38d7142e29f,
    faFingerprint: $7654cdc1c6e28adf$export$614dc068d88655af,
    faFire: $7654cdc1c6e28adf$export$7b24b34ef6cc130c,
    faFireAlt: $7654cdc1c6e28adf$export$70dc26b4926d0b1b,
    faFireExtinguisher: $7654cdc1c6e28adf$export$d75fb6743634a0a,
    faFirstAid: $7654cdc1c6e28adf$export$5b01ccb2da4c4387,
    faFish: $7654cdc1c6e28adf$export$24228a855c5f6812,
    faFistRaised: $7654cdc1c6e28adf$export$fa0323a4d7489a8d,
    faFlag: $7654cdc1c6e28adf$export$6591b1ea509be9da,
    faFlagCheckered: $7654cdc1c6e28adf$export$92fad97e19a9fea,
    faFlagUsa: $7654cdc1c6e28adf$export$19357abad396e723,
    faFlask: $7654cdc1c6e28adf$export$f9b579ba06048af,
    faFlushed: $7654cdc1c6e28adf$export$dfd2bd012685aeac,
    faFolder: $7654cdc1c6e28adf$export$72b780186370e953,
    faFolderMinus: $7654cdc1c6e28adf$export$758f1fb3784e4080,
    faFolderOpen: $7654cdc1c6e28adf$export$ff7e93418af88b78,
    faFolderPlus: $7654cdc1c6e28adf$export$e18e05ffa2045d3b,
    faFont: $7654cdc1c6e28adf$export$a5dc297d3f60936,
    faFontAwesomeLogoFull: $7654cdc1c6e28adf$export$6e20d421a2e0f320,
    faFootballBall: $7654cdc1c6e28adf$export$e8fd664711e31704,
    faForward: $7654cdc1c6e28adf$export$a8710cdb23198d53,
    faFrog: $7654cdc1c6e28adf$export$fe2358263efac504,
    faFrown: $7654cdc1c6e28adf$export$43b7108508aecc5f,
    faFrownOpen: $7654cdc1c6e28adf$export$c4775e66bed5d96,
    faFunnelDollar: $7654cdc1c6e28adf$export$cebe38ad8f0a143d,
    faFutbol: $7654cdc1c6e28adf$export$65a345b33858a655,
    faGamepad: $7654cdc1c6e28adf$export$6a66b1b639455bef,
    faGasPump: $7654cdc1c6e28adf$export$84666c793cb2a347,
    faGavel: $7654cdc1c6e28adf$export$c36fb40057e2c3aa,
    faGem: $7654cdc1c6e28adf$export$31ee86ac717db552,
    faGenderless: $7654cdc1c6e28adf$export$c093cc22e88981c2,
    faGhost: $7654cdc1c6e28adf$export$1a989eb1919c64c1,
    faGift: $7654cdc1c6e28adf$export$b2727de8ccdbb5ec,
    faGifts: $7654cdc1c6e28adf$export$de9a67b55dbe819a,
    faGlassCheers: $7654cdc1c6e28adf$export$20007d7d74cb98fe,
    faGlassMartini: $7654cdc1c6e28adf$export$e96f280e39af4a91,
    faGlassMartiniAlt: $7654cdc1c6e28adf$export$2258439b8f4e7acb,
    faGlassWhiskey: $7654cdc1c6e28adf$export$fdec0f5f1a169419,
    faGlasses: $7654cdc1c6e28adf$export$58d7d709c0a8ca5f,
    faGlobe: $7654cdc1c6e28adf$export$b1b1cdce4a19c682,
    faGlobeAfrica: $7654cdc1c6e28adf$export$64af36f3b403a57c,
    faGlobeAmericas: $7654cdc1c6e28adf$export$e96bcc7bde9498db,
    faGlobeAsia: $7654cdc1c6e28adf$export$796fdfc909e603f4,
    faGlobeEurope: $7654cdc1c6e28adf$export$5318b8ede86cc96b,
    faGolfBall: $7654cdc1c6e28adf$export$2251487a9a33c682,
    faGopuram: $7654cdc1c6e28adf$export$31f89d8ac1d14ed6,
    faGraduationCap: $7654cdc1c6e28adf$export$874e305fd7920cce,
    faGreaterThan: $7654cdc1c6e28adf$export$da07b6bc24a496ca,
    faGreaterThanEqual: $7654cdc1c6e28adf$export$7bf8dfe2e6661a54,
    faGrimace: $7654cdc1c6e28adf$export$3d08cd36ac1ef231,
    faGrin: $7654cdc1c6e28adf$export$37e1f10b6de76621,
    faGrinAlt: $7654cdc1c6e28adf$export$b4abebfe416d36ba,
    faGrinBeam: $7654cdc1c6e28adf$export$734da5249381ec7e,
    faGrinBeamSweat: $7654cdc1c6e28adf$export$14d0ccc54c5b6826,
    faGrinHearts: $7654cdc1c6e28adf$export$c56cf0e0c3bc5ed2,
    faGrinSquint: $7654cdc1c6e28adf$export$243ae757907b1580,
    faGrinSquintTears: $7654cdc1c6e28adf$export$542206d6a85f3b42,
    faGrinStars: $7654cdc1c6e28adf$export$64347a5c8c402ef4,
    faGrinTears: $7654cdc1c6e28adf$export$b2f7512221512b5b,
    faGrinTongue: $7654cdc1c6e28adf$export$ef222816a43a4b3a,
    faGrinTongueSquint: $7654cdc1c6e28adf$export$4edf34c3def09a31,
    faGrinTongueWink: $7654cdc1c6e28adf$export$58099903d50aefb3,
    faGrinWink: $7654cdc1c6e28adf$export$2397fcd34eb12177,
    faGripHorizontal: $7654cdc1c6e28adf$export$4a45308d6c8decc1,
    faGripLines: $7654cdc1c6e28adf$export$1412f35381064d7d,
    faGripLinesVertical: $7654cdc1c6e28adf$export$523960de087f5198,
    faGripVertical: $7654cdc1c6e28adf$export$cacbd95c283996ec,
    faGuitar: $7654cdc1c6e28adf$export$790dd5b32282b6fb,
    faHSquare: $7654cdc1c6e28adf$export$f08bbcf8f59eafc2,
    faHamburger: $7654cdc1c6e28adf$export$bab3bb9f4f59363,
    faHammer: $7654cdc1c6e28adf$export$6310f315e1ebbca5,
    faHamsa: $7654cdc1c6e28adf$export$38d20d399463edf9,
    faHandHolding: $7654cdc1c6e28adf$export$e6094d25274088ab,
    faHandHoldingHeart: $7654cdc1c6e28adf$export$97e5ef3e80a0fbef,
    faHandHoldingMedical: $7654cdc1c6e28adf$export$bb2a6b1b5e852300,
    faHandHoldingUsd: $7654cdc1c6e28adf$export$47d27bc305b59690,
    faHandHoldingWater: $7654cdc1c6e28adf$export$4265371b99d38b95,
    faHandLizard: $7654cdc1c6e28adf$export$54608d0a883fea4d,
    faHandMiddleFinger: $7654cdc1c6e28adf$export$bd40d3a3a16fb147,
    faHandPaper: $7654cdc1c6e28adf$export$6e6216c8b50471bb,
    faHandPeace: $7654cdc1c6e28adf$export$e49e3cfceea441cc,
    faHandPointDown: $7654cdc1c6e28adf$export$f6dcbf0a940428f4,
    faHandPointLeft: $7654cdc1c6e28adf$export$b276ec3dc9760d39,
    faHandPointRight: $7654cdc1c6e28adf$export$f7bc8714c970afa4,
    faHandPointUp: $7654cdc1c6e28adf$export$cdc9f5e7e94e76da,
    faHandPointer: $7654cdc1c6e28adf$export$d97ff927c450c87f,
    faHandRock: $7654cdc1c6e28adf$export$97a81eba394c8c44,
    faHandScissors: $7654cdc1c6e28adf$export$c578e919f2c5c135,
    faHandSparkles: $7654cdc1c6e28adf$export$72e2d874a963de0c,
    faHandSpock: $7654cdc1c6e28adf$export$2262d6b626de1120,
    faHands: $7654cdc1c6e28adf$export$f9712d0cf5150f0c,
    faHandsHelping: $7654cdc1c6e28adf$export$287dbb1632da0d44,
    faHandsWash: $7654cdc1c6e28adf$export$996b5dea53b124e3,
    faHandshake: $7654cdc1c6e28adf$export$b4c63e9bfc7906f1,
    faHandshakeAltSlash: $7654cdc1c6e28adf$export$ca302f956ae9f1bf,
    faHandshakeSlash: $7654cdc1c6e28adf$export$2cef3f81ad90fb76,
    faHanukiah: $7654cdc1c6e28adf$export$3dcd4ca3f7108a82,
    faHardHat: $7654cdc1c6e28adf$export$7b72177558a98b6f,
    faHashtag: $7654cdc1c6e28adf$export$c92c903bade56844,
    faHatCowboy: $7654cdc1c6e28adf$export$37672611144b857b,
    faHatCowboySide: $7654cdc1c6e28adf$export$ab6f71fd6878da90,
    faHatWizard: $7654cdc1c6e28adf$export$7daa48199dcb2ad1,
    faHdd: $7654cdc1c6e28adf$export$62551e9c5ba7093f,
    faHeadSideCough: $7654cdc1c6e28adf$export$3cd04b7c1624f598,
    faHeadSideCoughSlash: $7654cdc1c6e28adf$export$b293ee8fb8e6b0c4,
    faHeadSideMask: $7654cdc1c6e28adf$export$280300af4baa1a3e,
    faHeadSideVirus: $7654cdc1c6e28adf$export$5b64b916710da7c7,
    faHeading: $7654cdc1c6e28adf$export$4805b8d175aeb9fb,
    faHeadphones: $7654cdc1c6e28adf$export$ad02dd8ca5816958,
    faHeadphonesAlt: $7654cdc1c6e28adf$export$6f0433fa527dd5be,
    faHeadset: $7654cdc1c6e28adf$export$23b086400a31acfe,
    faHeart: $7654cdc1c6e28adf$export$e4b51a47a2f8b9db,
    faHeartBroken: $7654cdc1c6e28adf$export$4a565395cb65b282,
    faHeartbeat: $7654cdc1c6e28adf$export$ca880e19206e80aa,
    faHelicopter: $7654cdc1c6e28adf$export$612d3e1afaf45fa5,
    faHighlighter: $7654cdc1c6e28adf$export$73801ed54b42fabe,
    faHiking: $7654cdc1c6e28adf$export$b2ab0105a901499e,
    faHippo: $7654cdc1c6e28adf$export$d4c909619093de2d,
    faHistory: $7654cdc1c6e28adf$export$76d1986559ca7b7a,
    faHockeyPuck: $7654cdc1c6e28adf$export$a274b02dc75663dc,
    faHollyBerry: $7654cdc1c6e28adf$export$273296afacf93991,
    faHome: $7654cdc1c6e28adf$export$48f10d71ec526479,
    faHorse: $7654cdc1c6e28adf$export$5b05f097fa38352a,
    faHorseHead: $7654cdc1c6e28adf$export$5bcca85203ebd1e8,
    faHospital: $7654cdc1c6e28adf$export$7a76c9d35b42d691,
    faHospitalAlt: $7654cdc1c6e28adf$export$cea7736417b94a3b,
    faHospitalSymbol: $7654cdc1c6e28adf$export$c8a3c78d99c23fed,
    faHospitalUser: $7654cdc1c6e28adf$export$684703c93d630cc5,
    faHotTub: $7654cdc1c6e28adf$export$4842af92b516c40b,
    faHotdog: $7654cdc1c6e28adf$export$9fae219b4d3ce0be,
    faHotel: $7654cdc1c6e28adf$export$c402efcf01d5ca07,
    faHourglass: $7654cdc1c6e28adf$export$b9098a890f61e022,
    faHourglassEnd: $7654cdc1c6e28adf$export$52757ecc5b1e25b9,
    faHourglassHalf: $7654cdc1c6e28adf$export$703272eebf5e3eea,
    faHourglassStart: $7654cdc1c6e28adf$export$f0c28584caa8f4b,
    faHouseDamage: $7654cdc1c6e28adf$export$8d7e943005ce0b49,
    faHouseUser: $7654cdc1c6e28adf$export$9a513ee921e8e885,
    faHryvnia: $7654cdc1c6e28adf$export$33d5f94bd6f75f59,
    faICursor: $7654cdc1c6e28adf$export$7fddf76ec23943d8,
    faIceCream: $7654cdc1c6e28adf$export$dd52741c60cc638f,
    faIcicles: $7654cdc1c6e28adf$export$78792ed87d92a3ad,
    faIcons: $7654cdc1c6e28adf$export$7fe2894454d8eb8a,
    faIdBadge: $7654cdc1c6e28adf$export$a75288855ea05282,
    faIdCard: $7654cdc1c6e28adf$export$782ac893fc22249b,
    faIdCardAlt: $7654cdc1c6e28adf$export$dc37ebbac31f6c6c,
    faIgloo: $7654cdc1c6e28adf$export$4a284575edd6f1af,
    faImage: $7654cdc1c6e28adf$export$7e9f0928967e03b,
    faImages: $7654cdc1c6e28adf$export$74f06b41ed2ca28a,
    faInbox: $7654cdc1c6e28adf$export$366b69cbdce46334,
    faIndent: $7654cdc1c6e28adf$export$318208bc30aeebcc,
    faIndustry: $7654cdc1c6e28adf$export$5548c3eb51060fa8,
    faInfinity: $7654cdc1c6e28adf$export$a590003279d671b8,
    faInfo: $7654cdc1c6e28adf$export$d469b770895f47ac,
    faInfoCircle: $7654cdc1c6e28adf$export$aa9288aeadf882fa,
    faItalic: $7654cdc1c6e28adf$export$16e344bae4d495ed,
    faJedi: $7654cdc1c6e28adf$export$859f204e59641ca4,
    faJoint: $7654cdc1c6e28adf$export$e5a289fb22ffb8cb,
    faJournalWhills: $7654cdc1c6e28adf$export$66a0d8d45aab6631,
    faKaaba: $7654cdc1c6e28adf$export$ab1408bfbe914cc9,
    faKey: $7654cdc1c6e28adf$export$fa6ecc35e7315db,
    faKeyboard: $7654cdc1c6e28adf$export$fb61df5d98785fa8,
    faKhanda: $7654cdc1c6e28adf$export$8d41d1f1ba3f9217,
    faKiss: $7654cdc1c6e28adf$export$c762a77aabf64fd0,
    faKissBeam: $7654cdc1c6e28adf$export$d6ff8a73c0812e63,
    faKissWinkHeart: $7654cdc1c6e28adf$export$ebba617701dfb917,
    faKiwiBird: $7654cdc1c6e28adf$export$d9933d91e1314d02,
    faLandmark: $7654cdc1c6e28adf$export$2bebc54c51db6505,
    faLanguage: $7654cdc1c6e28adf$export$8a7bee49fdf8c954,
    faLaptop: $7654cdc1c6e28adf$export$c2dee3bd177275a2,
    faLaptopCode: $7654cdc1c6e28adf$export$94100f4c6ee29932,
    faLaptopHouse: $7654cdc1c6e28adf$export$efd983de5e4d6ad3,
    faLaptopMedical: $7654cdc1c6e28adf$export$ba2fa38f7bcc6930,
    faLaugh: $7654cdc1c6e28adf$export$6c74e314e801a4fe,
    faLaughBeam: $7654cdc1c6e28adf$export$a88d1f4073ea9369,
    faLaughSquint: $7654cdc1c6e28adf$export$b206e700cf7084e1,
    faLaughWink: $7654cdc1c6e28adf$export$77ac40095f39933e,
    faLayerGroup: $7654cdc1c6e28adf$export$a137712e11e257dd,
    faLeaf: $7654cdc1c6e28adf$export$7c497bae2754a087,
    faLemon: $7654cdc1c6e28adf$export$4fbda8f64648f3b5,
    faLessThan: $7654cdc1c6e28adf$export$7f24f1bf98af5411,
    faLessThanEqual: $7654cdc1c6e28adf$export$b2c723344cff0d8,
    faLevelDownAlt: $7654cdc1c6e28adf$export$c07eb6ff5a382cbd,
    faLevelUpAlt: $7654cdc1c6e28adf$export$d6f21a309b179c3d,
    faLifeRing: $7654cdc1c6e28adf$export$53dd2cacf674142a,
    faLightbulb: $7654cdc1c6e28adf$export$1e80f89fe84a215b,
    faLink: $7654cdc1c6e28adf$export$88bc01ff8dbecc55,
    faLiraSign: $7654cdc1c6e28adf$export$f0f37dbc60110b10,
    faList: $7654cdc1c6e28adf$export$6cfc59842fedbc16,
    faListAlt: $7654cdc1c6e28adf$export$c6327a203ffc65a3,
    faListOl: $7654cdc1c6e28adf$export$3db8f67cd0fc963b,
    faListUl: $7654cdc1c6e28adf$export$f8a219cf4f516384,
    faLocationArrow: $7654cdc1c6e28adf$export$4ac9c4c370f7b157,
    faLock: $7654cdc1c6e28adf$export$7aa08ad5d562578a,
    faLockOpen: $7654cdc1c6e28adf$export$84b5acad4436d02a,
    faLongArrowAltDown: $7654cdc1c6e28adf$export$8b92530ca6418c2f,
    faLongArrowAltLeft: $7654cdc1c6e28adf$export$a8b3226b2bf323d,
    faLongArrowAltRight: $7654cdc1c6e28adf$export$533e1f578f74c066,
    faLongArrowAltUp: $7654cdc1c6e28adf$export$43c8f2a46326c55f,
    faLowVision: $7654cdc1c6e28adf$export$7a65d2aa54cb4e93,
    faLuggageCart: $7654cdc1c6e28adf$export$bd1e24dd3cde8514,
    faLungs: $7654cdc1c6e28adf$export$ba9b387e84727819,
    faLungsVirus: $7654cdc1c6e28adf$export$895159d10626af74,
    faMagic: $7654cdc1c6e28adf$export$e58f9b502d4dd52d,
    faMagnet: $7654cdc1c6e28adf$export$78932e9c9abea6b7,
    faMailBulk: $7654cdc1c6e28adf$export$dd24f40c5337e2e1,
    faMale: $7654cdc1c6e28adf$export$2e21f9dba1630651,
    faMap: $7654cdc1c6e28adf$export$fc82fb79180cd17c,
    faMapMarked: $7654cdc1c6e28adf$export$df04458e7e32352c,
    faMapMarkedAlt: $7654cdc1c6e28adf$export$a977d47c74d8e86c,
    faMapMarker: $7654cdc1c6e28adf$export$10d360e4f1a554dd,
    faMapMarkerAlt: $7654cdc1c6e28adf$export$4be92fa780613f93,
    faMapPin: $7654cdc1c6e28adf$export$184725965b3402dc,
    faMapSigns: $7654cdc1c6e28adf$export$743f4b1071b3333a,
    faMarker: $7654cdc1c6e28adf$export$e6789173649caa25,
    faMars: $7654cdc1c6e28adf$export$a9f5c0b9c1e77a6f,
    faMarsDouble: $7654cdc1c6e28adf$export$2f8a28204bb4b86f,
    faMarsStroke: $7654cdc1c6e28adf$export$aa05fce255a5d269,
    faMarsStrokeH: $7654cdc1c6e28adf$export$5cb0daeafbcdabe3,
    faMarsStrokeV: $7654cdc1c6e28adf$export$ed7aa1c25104f333,
    faMask: $7654cdc1c6e28adf$export$7b028758c03b9655,
    faMedal: $7654cdc1c6e28adf$export$b48a5be96314835a,
    faMedkit: $7654cdc1c6e28adf$export$e75f02bae5b7d34b,
    faMeh: $7654cdc1c6e28adf$export$6d2db489aaeeecd2,
    faMehBlank: $7654cdc1c6e28adf$export$e945435725f71e88,
    faMehRollingEyes: $7654cdc1c6e28adf$export$fdc62a1bea767cc2,
    faMemory: $7654cdc1c6e28adf$export$5f9bd9f6df021f93,
    faMenorah: $7654cdc1c6e28adf$export$232452c59d77c56e,
    faMercury: $7654cdc1c6e28adf$export$e134ecd00b622a47,
    faMeteor: $7654cdc1c6e28adf$export$1439f0d6365138da,
    faMicrochip: $7654cdc1c6e28adf$export$4a7bb4be15f35178,
    faMicrophone: $7654cdc1c6e28adf$export$eed3c491effe6d12,
    faMicrophoneAlt: $7654cdc1c6e28adf$export$f08ef94fea14f5ac,
    faMicrophoneAltSlash: $7654cdc1c6e28adf$export$d2a53a388f30780,
    faMicrophoneSlash: $7654cdc1c6e28adf$export$843f63d64e6f7951,
    faMicroscope: $7654cdc1c6e28adf$export$6a99139787bf9967,
    faMinus: $7654cdc1c6e28adf$export$fee0376c250cdef,
    faMinusCircle: $7654cdc1c6e28adf$export$f3979b49bf57313c,
    faMinusSquare: $7654cdc1c6e28adf$export$ffe9387966b3e681,
    faMitten: $7654cdc1c6e28adf$export$5030322c5fc886d7,
    faMobile: $7654cdc1c6e28adf$export$59edacfad04cd121,
    faMobileAlt: $7654cdc1c6e28adf$export$e9599bc6cd92234d,
    faMoneyBill: $7654cdc1c6e28adf$export$608138a7337b5d1a,
    faMoneyBillAlt: $7654cdc1c6e28adf$export$a35d573395884c3d,
    faMoneyBillWave: $7654cdc1c6e28adf$export$53e23123cc9a6796,
    faMoneyBillWaveAlt: $7654cdc1c6e28adf$export$1613858e873cbb3e,
    faMoneyCheck: $7654cdc1c6e28adf$export$be069f641c85d0b3,
    faMoneyCheckAlt: $7654cdc1c6e28adf$export$8c6ccc9745897cb2,
    faMonument: $7654cdc1c6e28adf$export$6f9b0bfc012deb25,
    faMoon: $7654cdc1c6e28adf$export$c4c2f69a53bab720,
    faMortarPestle: $7654cdc1c6e28adf$export$55ceb5d0c144580a,
    faMosque: $7654cdc1c6e28adf$export$4999586d7e1087fb,
    faMotorcycle: $7654cdc1c6e28adf$export$f26017bdca99338d,
    faMountain: $7654cdc1c6e28adf$export$64f9eb99c9749cce,
    faMouse: $7654cdc1c6e28adf$export$198b96b894c66074,
    faMousePointer: $7654cdc1c6e28adf$export$2e19a69cc26b147,
    faMugHot: $7654cdc1c6e28adf$export$47a822c30184e8af,
    faMusic: $7654cdc1c6e28adf$export$fcb0647a5340b5b8,
    faNetworkWired: $7654cdc1c6e28adf$export$882cabd11f4943b8,
    faNeuter: $7654cdc1c6e28adf$export$771cf879fba0cf93,
    faNewspaper: $7654cdc1c6e28adf$export$d91b374112d4f8c1,
    faNotEqual: $7654cdc1c6e28adf$export$6a15ccae09bbaf93,
    faNotesMedical: $7654cdc1c6e28adf$export$b2d79133c81d6697,
    faObjectGroup: $7654cdc1c6e28adf$export$40cdac24aa94a57a,
    faObjectUngroup: $7654cdc1c6e28adf$export$887f6345573abcac,
    faOilCan: $7654cdc1c6e28adf$export$2599126c3a57f727,
    faOm: $7654cdc1c6e28adf$export$8de8eb94230028a5,
    faOtter: $7654cdc1c6e28adf$export$743cce3ca4eb1d7d,
    faOutdent: $7654cdc1c6e28adf$export$e21cfc4f23776bff,
    faPager: $7654cdc1c6e28adf$export$e1611f373a10a98c,
    faPaintBrush: $7654cdc1c6e28adf$export$594db3339e212bc9,
    faPaintRoller: $7654cdc1c6e28adf$export$d1de8d1b815d6a5,
    faPalette: $7654cdc1c6e28adf$export$5c390baea5db4f77,
    faPallet: $7654cdc1c6e28adf$export$d7ff2047dbc34562,
    faPaperPlane: $7654cdc1c6e28adf$export$b5378818301da1be,
    faPaperclip: $7654cdc1c6e28adf$export$4b24ca1552f410af,
    faParachuteBox: $7654cdc1c6e28adf$export$ca9e3368f1d9500a,
    faParagraph: $7654cdc1c6e28adf$export$dec46f8df1860e0,
    faParking: $7654cdc1c6e28adf$export$fda29c8f99573a4e,
    faPassport: $7654cdc1c6e28adf$export$2c31ca0d9bee400f,
    faPastafarianism: $7654cdc1c6e28adf$export$733efdaec97447be,
    faPaste: $7654cdc1c6e28adf$export$6f95f90dd1f6d86b,
    faPause: $7654cdc1c6e28adf$export$da79f048408b1722,
    faPauseCircle: $7654cdc1c6e28adf$export$d8cf08a0362da8db,
    faPaw: $7654cdc1c6e28adf$export$7bc6e4d977673e69,
    faPeace: $7654cdc1c6e28adf$export$8614cb1326eacd7a,
    faPen: $7654cdc1c6e28adf$export$8f4567331fb0d3bc,
    faPenAlt: $7654cdc1c6e28adf$export$a3d3e92e430d3beb,
    faPenFancy: $7654cdc1c6e28adf$export$8bdfe14ac72a8b17,
    faPenNib: $7654cdc1c6e28adf$export$a82594dcc75a49f5,
    faPenSquare: $7654cdc1c6e28adf$export$fbb231ccb3d960bc,
    faPencilAlt: $7654cdc1c6e28adf$export$8210adc172262df,
    faPencilRuler: $7654cdc1c6e28adf$export$e3a7a1affea005f5,
    faPeopleArrows: $7654cdc1c6e28adf$export$804bfc5c390e1a2a,
    faPeopleCarry: $7654cdc1c6e28adf$export$35fbd4ff1265acd5,
    faPepperHot: $7654cdc1c6e28adf$export$4894bf28f771e1f3,
    faPercent: $7654cdc1c6e28adf$export$89a1764fbb7ad2cb,
    faPercentage: $7654cdc1c6e28adf$export$89333857fc063a2e,
    faPersonBooth: $7654cdc1c6e28adf$export$2337c975289bdd84,
    faPhone: $7654cdc1c6e28adf$export$ddab067855cf34cb,
    faPhoneAlt: $7654cdc1c6e28adf$export$a07a9b305deebf32,
    faPhoneSlash: $7654cdc1c6e28adf$export$4c60a3aade08b6c2,
    faPhoneSquare: $7654cdc1c6e28adf$export$8ba22605a641ebdf,
    faPhoneSquareAlt: $7654cdc1c6e28adf$export$a41e77f0de98bba7,
    faPhoneVolume: $7654cdc1c6e28adf$export$c377f240bb8b5d74,
    faPhotoVideo: $7654cdc1c6e28adf$export$739f6a6a12dfb6ed,
    faPiggyBank: $7654cdc1c6e28adf$export$46d49a6734c4872a,
    faPills: $7654cdc1c6e28adf$export$6380e2ed6e69d350,
    faPizzaSlice: $7654cdc1c6e28adf$export$c9f93c4667edc585,
    faPlaceOfWorship: $7654cdc1c6e28adf$export$c5a9302c8c13c79a,
    faPlane: $7654cdc1c6e28adf$export$f654c69e66b466c0,
    faPlaneArrival: $7654cdc1c6e28adf$export$9b2dbe133273f284,
    faPlaneDeparture: $7654cdc1c6e28adf$export$6ccbeeccfea6dc8a,
    faPlaneSlash: $7654cdc1c6e28adf$export$cfee4df0d5df6d21,
    faPlay: $7654cdc1c6e28adf$export$436587205947bca5,
    faPlayCircle: $7654cdc1c6e28adf$export$cf04333781061c5e,
    faPlug: $7654cdc1c6e28adf$export$cae5752c3e3b6545,
    faPlus: $7654cdc1c6e28adf$export$a105e7b44ca0eb9e,
    faPlusCircle: $7654cdc1c6e28adf$export$d9cc3a81499af48c,
    faPlusSquare: $7654cdc1c6e28adf$export$b6359eebfe900c35,
    faPodcast: $7654cdc1c6e28adf$export$5c0b4709125e92f8,
    faPoll: $7654cdc1c6e28adf$export$bc8ca14ab51f93db,
    faPollH: $7654cdc1c6e28adf$export$456a238f0144d430,
    faPoo: $7654cdc1c6e28adf$export$dd0ede1713d2d2f9,
    faPooStorm: $7654cdc1c6e28adf$export$48a38da471b097a2,
    faPoop: $7654cdc1c6e28adf$export$bb45b6b87d1adf27,
    faPortrait: $7654cdc1c6e28adf$export$e3d25f819c7ee7d7,
    faPoundSign: $7654cdc1c6e28adf$export$9ce041dfec8319b,
    faPowerOff: $7654cdc1c6e28adf$export$a1cca9928dcf9798,
    faPray: $7654cdc1c6e28adf$export$3b32c982141cad51,
    faPrayingHands: $7654cdc1c6e28adf$export$95e08e91b0929943,
    faPrescription: $7654cdc1c6e28adf$export$8767bafb19515ee4,
    faPrescriptionBottle: $7654cdc1c6e28adf$export$214f9ce665590486,
    faPrescriptionBottleAlt: $7654cdc1c6e28adf$export$65d1c884b8581d1a,
    faPrint: $7654cdc1c6e28adf$export$ae64371e02ee8e56,
    faProcedures: $7654cdc1c6e28adf$export$5f9e1870e1866dde,
    faProjectDiagram: $7654cdc1c6e28adf$export$30bf9f5b96509df1,
    faPumpMedical: $7654cdc1c6e28adf$export$f1b881c73328720c,
    faPumpSoap: $7654cdc1c6e28adf$export$821aeede187f23c9,
    faPuzzlePiece: $7654cdc1c6e28adf$export$7ee0dbd1e92e2859,
    faQrcode: $7654cdc1c6e28adf$export$fc19ca0fe15e73bc,
    faQuestion: $7654cdc1c6e28adf$export$d96973f90e8f6e47,
    faQuestionCircle: $7654cdc1c6e28adf$export$5ba67d7f2265c1a5,
    faQuidditch: $7654cdc1c6e28adf$export$c00c446e6db1605f,
    faQuoteLeft: $7654cdc1c6e28adf$export$932a67a1b1a7a724,
    faQuoteRight: $7654cdc1c6e28adf$export$54e3a80c9875b74c,
    faQuran: $7654cdc1c6e28adf$export$46f29ea84ed4c5f1,
    faRadiation: $7654cdc1c6e28adf$export$4c4e509518093d6d,
    faRadiationAlt: $7654cdc1c6e28adf$export$2f048fa82bbddf6f,
    faRainbow: $7654cdc1c6e28adf$export$92ab27739d3a91b2,
    faRandom: $7654cdc1c6e28adf$export$8357bf8cc666d5f0,
    faReceipt: $7654cdc1c6e28adf$export$32b0cd6133c2742,
    faRecordVinyl: $7654cdc1c6e28adf$export$fe2d5012d9982673,
    faRecycle: $7654cdc1c6e28adf$export$a65c441f12cb6bd,
    faRedo: $7654cdc1c6e28adf$export$3d9f98aa1c24c776,
    faRedoAlt: $7654cdc1c6e28adf$export$50c037520c6cfdc1,
    faRegistered: $7654cdc1c6e28adf$export$5f519e9ac15ab8c3,
    faRemoveFormat: $7654cdc1c6e28adf$export$d91179f327329532,
    faReply: $7654cdc1c6e28adf$export$bb06d4a7bb6736fe,
    faReplyAll: $7654cdc1c6e28adf$export$ca6fd367f31ecbc5,
    faRepublican: $7654cdc1c6e28adf$export$929518bb4b66a588,
    faRestroom: $7654cdc1c6e28adf$export$5fbcef35138741a5,
    faRetweet: $7654cdc1c6e28adf$export$cebc76f79478e40e,
    faRibbon: $7654cdc1c6e28adf$export$838459d11f3971df,
    faRing: $7654cdc1c6e28adf$export$a95486586631edc7,
    faRoad: $7654cdc1c6e28adf$export$f224567a4851a5e9,
    faRobot: $7654cdc1c6e28adf$export$30a5bb4ad3fa716c,
    faRocket: $7654cdc1c6e28adf$export$b24d84ed5657d89a,
    faRoute: $7654cdc1c6e28adf$export$806c0a45a7ecd6e8,
    faRss: $7654cdc1c6e28adf$export$7329a1ca27b90c5b,
    faRssSquare: $7654cdc1c6e28adf$export$89c9b1cca2c11484,
    faRubleSign: $7654cdc1c6e28adf$export$1ae0a94c8ba4131a,
    faRuler: $7654cdc1c6e28adf$export$8e90575265a56cfc,
    faRulerCombined: $7654cdc1c6e28adf$export$613f406c1b5802a8,
    faRulerHorizontal: $7654cdc1c6e28adf$export$46c6347bff3e04a,
    faRulerVertical: $7654cdc1c6e28adf$export$a6ad5df9d9f29553,
    faRunning: $7654cdc1c6e28adf$export$5dfd1cb43dc9eadb,
    faRupeeSign: $7654cdc1c6e28adf$export$8bf9e3f7f57d486a,
    faSadCry: $7654cdc1c6e28adf$export$8e924e6bd422cef9,
    faSadTear: $7654cdc1c6e28adf$export$4b5241926f692f91,
    faSatellite: $7654cdc1c6e28adf$export$da3f1730d013e224,
    faSatelliteDish: $7654cdc1c6e28adf$export$219ccae0e4da3c92,
    faSave: $7654cdc1c6e28adf$export$1aaa83ff70706e1e,
    faSchool: $7654cdc1c6e28adf$export$51e9b8434982947d,
    faScrewdriver: $7654cdc1c6e28adf$export$7484ff654cd6474f,
    faScroll: $7654cdc1c6e28adf$export$7c265716d4399676,
    faSdCard: $7654cdc1c6e28adf$export$303efb6031da122,
    faSearch: $7654cdc1c6e28adf$export$871a78837687ffe8,
    faSearchDollar: $7654cdc1c6e28adf$export$65b49a6767630708,
    faSearchLocation: $7654cdc1c6e28adf$export$c33aba6c251a898a,
    faSearchMinus: $7654cdc1c6e28adf$export$efca97eef6a7a17d,
    faSearchPlus: $7654cdc1c6e28adf$export$378f00e6b1a8185,
    faSeedling: $7654cdc1c6e28adf$export$d7b60b8dbd03cfe4,
    faServer: $7654cdc1c6e28adf$export$1bf820d499b6202e,
    faShapes: $7654cdc1c6e28adf$export$b17d50542d1fc340,
    faShare: $7654cdc1c6e28adf$export$c08b4b0e2b0dc027,
    faShareAlt: $7654cdc1c6e28adf$export$f8e8bb0b3aa8c658,
    faShareAltSquare: $7654cdc1c6e28adf$export$3799c2d8fd7e493b,
    faShareSquare: $7654cdc1c6e28adf$export$ae9e1434571f373c,
    faShekelSign: $7654cdc1c6e28adf$export$3570be7b68efb8db,
    faShieldAlt: $7654cdc1c6e28adf$export$d6508d18a824f291,
    faShieldVirus: $7654cdc1c6e28adf$export$bea811bbf570f05a,
    faShip: $7654cdc1c6e28adf$export$6c645741140616af,
    faShippingFast: $7654cdc1c6e28adf$export$5e419f47aaeb3c05,
    faShoePrints: $7654cdc1c6e28adf$export$cdbdd2118099ae07,
    faShoppingBag: $7654cdc1c6e28adf$export$5745f8adbc11eb01,
    faShoppingBasket: $7654cdc1c6e28adf$export$ca6d443595a6578f,
    faShoppingCart: $7654cdc1c6e28adf$export$51da406e5aa1388c,
    faShower: $7654cdc1c6e28adf$export$f7f7c15f18cc19a1,
    faShuttleVan: $7654cdc1c6e28adf$export$9d63d851db698c09,
    faSign: $7654cdc1c6e28adf$export$d21d0d6c8e9e8bf9,
    faSignInAlt: $7654cdc1c6e28adf$export$e6709746115bd2ea,
    faSignLanguage: $7654cdc1c6e28adf$export$20993813350f9671,
    faSignOutAlt: $7654cdc1c6e28adf$export$c844d6923b7096c2,
    faSignal: $7654cdc1c6e28adf$export$79046b073b6c584d,
    faSignature: $7654cdc1c6e28adf$export$afa7b53ac8ebcb5d,
    faSimCard: $7654cdc1c6e28adf$export$3bee83bf278fddbe,
    faSink: $7654cdc1c6e28adf$export$2a9dda2096ce792e,
    faSitemap: $7654cdc1c6e28adf$export$b2ce5e79d0eccaf8,
    faSkating: $7654cdc1c6e28adf$export$21bd1d54bd4f2c5a,
    faSkiing: $7654cdc1c6e28adf$export$eae1acab6fb96708,
    faSkiingNordic: $7654cdc1c6e28adf$export$6ea48260d7d09b1b,
    faSkull: $7654cdc1c6e28adf$export$138b45e2afb1dfa4,
    faSkullCrossbones: $7654cdc1c6e28adf$export$8717352b90217272,
    faSlash: $7654cdc1c6e28adf$export$f54d004dd5f1cb5e,
    faSleigh: $7654cdc1c6e28adf$export$26a8fd1143d2d6c0,
    faSlidersH: $7654cdc1c6e28adf$export$94d4dcb523f95563,
    faSmile: $7654cdc1c6e28adf$export$c632b2334f0913bc,
    faSmileBeam: $7654cdc1c6e28adf$export$54ada6dc9690e0ca,
    faSmileWink: $7654cdc1c6e28adf$export$f5dbb37f6801ee3f,
    faSmog: $7654cdc1c6e28adf$export$aa11b8edb09fed14,
    faSmoking: $7654cdc1c6e28adf$export$c4ab83701fc591a5,
    faSmokingBan: $7654cdc1c6e28adf$export$e50452a49dec29f,
    faSms: $7654cdc1c6e28adf$export$9dbcc3443daa7323,
    faSnowboarding: $7654cdc1c6e28adf$export$72683772d587302a,
    faSnowflake: $7654cdc1c6e28adf$export$bab8f3647c394f48,
    faSnowman: $7654cdc1c6e28adf$export$b23df6bafb174693,
    faSnowplow: $7654cdc1c6e28adf$export$695fae58f55c3a87,
    faSoap: $7654cdc1c6e28adf$export$64f1c53b21f310ac,
    faSocks: $7654cdc1c6e28adf$export$8d36a54dbf1e6bce,
    faSolarPanel: $7654cdc1c6e28adf$export$b9c649c5e37017f3,
    faSort: $7654cdc1c6e28adf$export$4941c5969d5399b,
    faSortAlphaDown: $7654cdc1c6e28adf$export$7658045270aafde3,
    faSortAlphaDownAlt: $7654cdc1c6e28adf$export$e12d23d82d5c8a89,
    faSortAlphaUp: $7654cdc1c6e28adf$export$3c4115b156be730d,
    faSortAlphaUpAlt: $7654cdc1c6e28adf$export$95ef20828693fb0f,
    faSortAmountDown: $7654cdc1c6e28adf$export$4b2a02d50e417b5f,
    faSortAmountDownAlt: $7654cdc1c6e28adf$export$e7d80d8c226cb77,
    faSortAmountUp: $7654cdc1c6e28adf$export$28ef3e933e4b5364,
    faSortAmountUpAlt: $7654cdc1c6e28adf$export$6e87844b0f151b6a,
    faSortDown: $7654cdc1c6e28adf$export$58e2577a373e7d4,
    faSortNumericDown: $7654cdc1c6e28adf$export$835db7eb35b3c29b,
    faSortNumericDownAlt: $7654cdc1c6e28adf$export$857385fda7a5a98e,
    faSortNumericUp: $7654cdc1c6e28adf$export$d213a3ba3cabed48,
    faSortNumericUpAlt: $7654cdc1c6e28adf$export$d41859f1bbb9e086,
    faSortUp: $7654cdc1c6e28adf$export$f9dd5b1410e95035,
    faSpa: $7654cdc1c6e28adf$export$f9a38ef7b046ab51,
    faSpaceShuttle: $7654cdc1c6e28adf$export$4d1c12ba2b4ca565,
    faSpellCheck: $7654cdc1c6e28adf$export$761e747b06ed2e1f,
    faSpider: $7654cdc1c6e28adf$export$6daa96b1986e2ef0,
    faSpinner: $7654cdc1c6e28adf$export$1025ad641edb49c2,
    faSplotch: $7654cdc1c6e28adf$export$d6f21e17ea797702,
    faSprayCan: $7654cdc1c6e28adf$export$4952c502f544cf85,
    faSquare: $7654cdc1c6e28adf$export$90b4406457aae8cc,
    faSquareFull: $7654cdc1c6e28adf$export$7ec6541fee081990,
    faSquareRootAlt: $7654cdc1c6e28adf$export$28e4b96627e00057,
    faStamp: $7654cdc1c6e28adf$export$722e92d2d93ffc68,
    faStar: $7654cdc1c6e28adf$export$a3b0eb2cd7942125,
    faStarAndCrescent: $7654cdc1c6e28adf$export$cafa834c96ebcb1a,
    faStarHalf: $7654cdc1c6e28adf$export$228008b5e11032fa,
    faStarHalfAlt: $7654cdc1c6e28adf$export$c13575f42532efb3,
    faStarOfDavid: $7654cdc1c6e28adf$export$f823fee3712b2601,
    faStarOfLife: $7654cdc1c6e28adf$export$aa3c4c1c5a47bf98,
    faStepBackward: $7654cdc1c6e28adf$export$2884e379aed297d4,
    faStepForward: $7654cdc1c6e28adf$export$b303329afce5de18,
    faStethoscope: $7654cdc1c6e28adf$export$acb2d72d28cd92d9,
    faStickyNote: $7654cdc1c6e28adf$export$80889adc5d98bf4a,
    faStop: $7654cdc1c6e28adf$export$51577929c676143b,
    faStopCircle: $7654cdc1c6e28adf$export$47af2aad60ab3e7c,
    faStopwatch: $7654cdc1c6e28adf$export$b85a7300fc7960b6,
    faStopwatch20: $7654cdc1c6e28adf$export$df6244b0501f2112,
    faStore: $7654cdc1c6e28adf$export$de59c2657a8ace67,
    faStoreAlt: $7654cdc1c6e28adf$export$1f1871dab9cec9d8,
    faStoreAltSlash: $7654cdc1c6e28adf$export$b932a586f6ff48b4,
    faStoreSlash: $7654cdc1c6e28adf$export$4ab2f33219630bad,
    faStream: $7654cdc1c6e28adf$export$ed81ab40fc4e904,
    faStreetView: $7654cdc1c6e28adf$export$6aab6c3359c2554c,
    faStrikethrough: $7654cdc1c6e28adf$export$eff51ea25b4de135,
    faStroopwafel: $7654cdc1c6e28adf$export$195780ddabd8e0c6,
    faSubscript: $7654cdc1c6e28adf$export$34c1e678c32ed646,
    faSubway: $7654cdc1c6e28adf$export$4cabc8a12d4e2f9,
    faSuitcase: $7654cdc1c6e28adf$export$60710f3921019268,
    faSuitcaseRolling: $7654cdc1c6e28adf$export$957e62a9b80ff4e3,
    faSun: $7654cdc1c6e28adf$export$2fa35dcbc038dbe9,
    faSuperscript: $7654cdc1c6e28adf$export$4fa56a54e822dd25,
    faSurprise: $7654cdc1c6e28adf$export$46647c72213f53ba,
    faSwatchbook: $7654cdc1c6e28adf$export$c74a20c81b957b6a,
    faSwimmer: $7654cdc1c6e28adf$export$67daf2e2f88c1365,
    faSwimmingPool: $7654cdc1c6e28adf$export$4dee691631c67d5c,
    faSynagogue: $7654cdc1c6e28adf$export$20d991385719b5b4,
    faSync: $7654cdc1c6e28adf$export$ff87319002e3dae9,
    faSyncAlt: $7654cdc1c6e28adf$export$2ff2056be8c281e4,
    faSyringe: $7654cdc1c6e28adf$export$1aa9423ec6b1d609,
    faTable: $7654cdc1c6e28adf$export$36583f5d3d5a971f,
    faTableTennis: $7654cdc1c6e28adf$export$f378fbb4e0ef7edf,
    faTablet: $7654cdc1c6e28adf$export$1c92b67c45a4b4fc,
    faTabletAlt: $7654cdc1c6e28adf$export$db0cac088255eacc,
    faTablets: $7654cdc1c6e28adf$export$bed2b0ed4ae45e0d,
    faTachometerAlt: $7654cdc1c6e28adf$export$38dd17b9f064c10f,
    faTag: $7654cdc1c6e28adf$export$cb61f447f29887e,
    faTags: $7654cdc1c6e28adf$export$d55778e3ab6c933f,
    faTape: $7654cdc1c6e28adf$export$b88ed5e1e0eac4c6,
    faTasks: $7654cdc1c6e28adf$export$2f6d5b2fec286d63,
    faTaxi: $7654cdc1c6e28adf$export$9958afcdfece1b58,
    faTeeth: $7654cdc1c6e28adf$export$b4619aeaf0b9d18e,
    faTeethOpen: $7654cdc1c6e28adf$export$c88ac21fe7c88ae6,
    faTemperatureHigh: $7654cdc1c6e28adf$export$15d012277c3ecf9a,
    faTemperatureLow: $7654cdc1c6e28adf$export$9e9af12b90a1abd2,
    faTenge: $7654cdc1c6e28adf$export$af6ebee83047b793,
    faTerminal: $7654cdc1c6e28adf$export$5e63e8b85b5f119c,
    faTextHeight: $7654cdc1c6e28adf$export$3313bce3924ea7da,
    faTextWidth: $7654cdc1c6e28adf$export$d8724cf433389700,
    faTh: $7654cdc1c6e28adf$export$4d383c83efc0c819,
    faThLarge: $7654cdc1c6e28adf$export$69782f333e90cdc6,
    faThList: $7654cdc1c6e28adf$export$daf2614a457122c0,
    faTheaterMasks: $7654cdc1c6e28adf$export$3dbedc487b0159ac,
    faThermometer: $7654cdc1c6e28adf$export$f576739e9b18ea4f,
    faThermometerEmpty: $7654cdc1c6e28adf$export$81a2f8298cf523f9,
    faThermometerFull: $7654cdc1c6e28adf$export$74e07083cef79a6f,
    faThermometerHalf: $7654cdc1c6e28adf$export$2090f040324b4449,
    faThermometerQuarter: $7654cdc1c6e28adf$export$ed05754fcbec6e46,
    faThermometerThreeQuarters: $7654cdc1c6e28adf$export$6c632d1dc30d4a77,
    faThumbsDown: $7654cdc1c6e28adf$export$aba24ca305bbe8c1,
    faThumbsUp: $7654cdc1c6e28adf$export$47e4e0d519d33497,
    faThumbtack: $7654cdc1c6e28adf$export$b6314cdc01bb5c43,
    faTicketAlt: $7654cdc1c6e28adf$export$75e38ba471fd89c4,
    faTimes: $7654cdc1c6e28adf$export$174bd7f477b115b4,
    faTimesCircle: $7654cdc1c6e28adf$export$ab0ec50720a747eb,
    faTint: $7654cdc1c6e28adf$export$60dd975bd5938c15,
    faTintSlash: $7654cdc1c6e28adf$export$5d6f0943039b898f,
    faTired: $7654cdc1c6e28adf$export$3d016d62cda18371,
    faToggleOff: $7654cdc1c6e28adf$export$d20aaceb882ca545,
    faToggleOn: $7654cdc1c6e28adf$export$5cffc34afa81e517,
    faToilet: $7654cdc1c6e28adf$export$505476859b9691c0,
    faToiletPaper: $7654cdc1c6e28adf$export$c8cc083ccc72b17,
    faToiletPaperSlash: $7654cdc1c6e28adf$export$7a494edbf9b65575,
    faToolbox: $7654cdc1c6e28adf$export$b34d64c205c732a9,
    faTools: $7654cdc1c6e28adf$export$646e4e7a8c6172aa,
    faTooth: $7654cdc1c6e28adf$export$3a1fa2d16f90d635,
    faTorah: $7654cdc1c6e28adf$export$54d07baabd8c2acb,
    faToriiGate: $7654cdc1c6e28adf$export$75825a4c2b3375e,
    faTractor: $7654cdc1c6e28adf$export$e87e41787bbedc98,
    faTrademark: $7654cdc1c6e28adf$export$9c9b2fbddd59047d,
    faTrafficLight: $7654cdc1c6e28adf$export$bf0b19daceaec9c2,
    faTrailer: $7654cdc1c6e28adf$export$3a48b9820e92f5ab,
    faTrain: $7654cdc1c6e28adf$export$17cde74bf6f1ee89,
    faTram: $7654cdc1c6e28adf$export$a7a36674c079f293,
    faTransgender: $7654cdc1c6e28adf$export$7e3f1701aa95ef01,
    faTransgenderAlt: $7654cdc1c6e28adf$export$9c36cf9334c052f,
    faTrash: $7654cdc1c6e28adf$export$ed8c149a0ea54bb4,
    faTrashAlt: $7654cdc1c6e28adf$export$88df7ff7eb32f9dc,
    faTrashRestore: $7654cdc1c6e28adf$export$d32f45a64ed40e8d,
    faTrashRestoreAlt: $7654cdc1c6e28adf$export$d075b19b21cb9856,
    faTree: $7654cdc1c6e28adf$export$1744430f718caf6b,
    faTrophy: $7654cdc1c6e28adf$export$29c432d69ccf85a5,
    faTruck: $7654cdc1c6e28adf$export$d7895f386f8bd8b8,
    faTruckLoading: $7654cdc1c6e28adf$export$f00c152db7d44638,
    faTruckMonster: $7654cdc1c6e28adf$export$24b8a0147653649a,
    faTruckMoving: $7654cdc1c6e28adf$export$a06617a1a4ccea67,
    faTruckPickup: $7654cdc1c6e28adf$export$f846b848b3ba3064,
    faTshirt: $7654cdc1c6e28adf$export$36edce3ba87c2b17,
    faTty: $7654cdc1c6e28adf$export$7c85aba0f9624b29,
    faTv: $7654cdc1c6e28adf$export$e0cfed4ba2fe562c,
    faUmbrella: $7654cdc1c6e28adf$export$9ff64ffae70e08c0,
    faUmbrellaBeach: $7654cdc1c6e28adf$export$20932e4d438e4e4c,
    faUnderline: $7654cdc1c6e28adf$export$22346afd6a3cddf8,
    faUndo: $7654cdc1c6e28adf$export$a5e5ba60b1dfe2b2,
    faUndoAlt: $7654cdc1c6e28adf$export$c8197b992c46c4a6,
    faUniversalAccess: $7654cdc1c6e28adf$export$e119aada7f690d05,
    faUniversity: $7654cdc1c6e28adf$export$f2e1460ebe1a8cb0,
    faUnlink: $7654cdc1c6e28adf$export$2f546f7d8ba01e18,
    faUnlock: $7654cdc1c6e28adf$export$db1382cd406cc506,
    faUnlockAlt: $7654cdc1c6e28adf$export$b19f508797f3d9c3,
    faUpload: $7654cdc1c6e28adf$export$a9578350255b2b79,
    faUser: $7654cdc1c6e28adf$export$f5699fa0844e0188,
    faUserAlt: $7654cdc1c6e28adf$export$ae9b19c2ac726cfc,
    faUserAltSlash: $7654cdc1c6e28adf$export$46185fab4772ada6,
    faUserAstronaut: $7654cdc1c6e28adf$export$94363e983c225a04,
    faUserCheck: $7654cdc1c6e28adf$export$76de2a120043c9f8,
    faUserCircle: $7654cdc1c6e28adf$export$be7d974e9e0dba1a,
    faUserClock: $7654cdc1c6e28adf$export$b00596a09aa07311,
    faUserCog: $7654cdc1c6e28adf$export$474108c2b86e730e,
    faUserEdit: $7654cdc1c6e28adf$export$a68a6960fc8eef82,
    faUserFriends: $7654cdc1c6e28adf$export$46073bec205635d9,
    faUserGraduate: $7654cdc1c6e28adf$export$10f5839059d22f7e,
    faUserInjured: $7654cdc1c6e28adf$export$c950c1ba7f227d5b,
    faUserLock: $7654cdc1c6e28adf$export$d9b89b5872b67a4f,
    faUserMd: $7654cdc1c6e28adf$export$ab0d33a2c03f1794,
    faUserMinus: $7654cdc1c6e28adf$export$d6e17c0df8ed1bf7,
    faUserNinja: $7654cdc1c6e28adf$export$a9174995732e03c5,
    faUserNurse: $7654cdc1c6e28adf$export$ab9af5aa013d2162,
    faUserPlus: $7654cdc1c6e28adf$export$4c17261776a709f2,
    faUserSecret: $7654cdc1c6e28adf$export$597826232327559b,
    faUserShield: $7654cdc1c6e28adf$export$d1886bc596424e6c,
    faUserSlash: $7654cdc1c6e28adf$export$3924ab4d3ef9b5ef,
    faUserTag: $7654cdc1c6e28adf$export$9eec597148166b36,
    faUserTie: $7654cdc1c6e28adf$export$48c51dda34e9f04c,
    faUserTimes: $7654cdc1c6e28adf$export$45b996d071667753,
    faUsers: $7654cdc1c6e28adf$export$e5a8f011aef571ac,
    faUsersCog: $7654cdc1c6e28adf$export$5e0b06753fc69b81,
    faUsersSlash: $7654cdc1c6e28adf$export$b71a093b86e3da1f,
    faUtensilSpoon: $7654cdc1c6e28adf$export$fb7af5d245fb9053,
    faUtensils: $7654cdc1c6e28adf$export$750d52edc1dafc7,
    faVectorSquare: $7654cdc1c6e28adf$export$567d5631a7b0599f,
    faVenus: $7654cdc1c6e28adf$export$f89d028573ffc0a6,
    faVenusDouble: $7654cdc1c6e28adf$export$6a6f9cba7a1e5fe4,
    faVenusMars: $7654cdc1c6e28adf$export$63f2d9e5f4689aa8,
    faVest: $7654cdc1c6e28adf$export$c8370e53051a657,
    faVestPatches: $7654cdc1c6e28adf$export$750a64470c2e0f3f,
    faVial: $7654cdc1c6e28adf$export$aa014b06d2d70598,
    faVials: $7654cdc1c6e28adf$export$507e8edd7676b2e9,
    faVideo: $7654cdc1c6e28adf$export$5c6bd8729527871b,
    faVideoSlash: $7654cdc1c6e28adf$export$a714fc79f58cc9ef,
    faVihara: $7654cdc1c6e28adf$export$ee4b92e89fe0dfaf,
    faVirus: $7654cdc1c6e28adf$export$37c67e0b3dc6bd1b,
    faVirusSlash: $7654cdc1c6e28adf$export$c4ff5306c5470939,
    faViruses: $7654cdc1c6e28adf$export$ee194b18f5c6f6b6,
    faVoicemail: $7654cdc1c6e28adf$export$4f1ce88b2b4cd5cd,
    faVolleyballBall: $7654cdc1c6e28adf$export$a15e6fc8e68a76b0,
    faVolumeDown: $7654cdc1c6e28adf$export$69fdf57632b6cc29,
    faVolumeMute: $7654cdc1c6e28adf$export$aa8decd057dfd29b,
    faVolumeOff: $7654cdc1c6e28adf$export$d94ba52e980ea0f1,
    faVolumeUp: $7654cdc1c6e28adf$export$5940d3e475d90cc4,
    faVoteYea: $7654cdc1c6e28adf$export$e87bb3db1608b850,
    faVrCardboard: $7654cdc1c6e28adf$export$248171cb6dad4307,
    faWalking: $7654cdc1c6e28adf$export$4886811b7174ec35,
    faWallet: $7654cdc1c6e28adf$export$79204db8777905c8,
    faWarehouse: $7654cdc1c6e28adf$export$e3a174a50618c208,
    faWater: $7654cdc1c6e28adf$export$efaeddad0a6e901b,
    faWaveSquare: $7654cdc1c6e28adf$export$c38cf504b3bc58a2,
    faWeight: $7654cdc1c6e28adf$export$cf3bafa68a60bae4,
    faWeightHanging: $7654cdc1c6e28adf$export$43d1fa6671908715,
    faWheelchair: $7654cdc1c6e28adf$export$76a9413fbe130a53,
    faWifi: $7654cdc1c6e28adf$export$1642419fe3db2857,
    faWind: $7654cdc1c6e28adf$export$cc58cb0f2257a6a9,
    faWindowClose: $7654cdc1c6e28adf$export$18b7775f78a3e16,
    faWindowMaximize: $7654cdc1c6e28adf$export$703cd98be31ec905,
    faWindowMinimize: $7654cdc1c6e28adf$export$26a3f9d2784b90d8,
    faWindowRestore: $7654cdc1c6e28adf$export$eccfff9bfd585652,
    faWineBottle: $7654cdc1c6e28adf$export$770be8b3d5776043,
    faWineGlass: $7654cdc1c6e28adf$export$e06d6607d3577d6e,
    faWineGlassAlt: $7654cdc1c6e28adf$export$b8ff3fe2b78aef2f,
    faWonSign: $7654cdc1c6e28adf$export$51790ddd26e431bc,
    faWrench: $7654cdc1c6e28adf$export$3c6c0c8185296ac5,
    faXRay: $7654cdc1c6e28adf$export$8cf137aceaaf4de0,
    faYenSign: $7654cdc1c6e28adf$export$30f1437f5a4e991d,
    faYinYang: $7654cdc1c6e28adf$export$6ec1acbf3f610b8f
};

});



parcelRegister("893V1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39468fbf3d3ca783$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("f7u8v");
var $gENUy = parcelRequire("gENUy");
parcelRequire("aLIw2");
var $4GCPM = parcelRequire("4GCPM");
const $39468fbf3d3ca783$var$transformLanguageToOption = (language)=>({
        value: language,
        label: language.toUpperCase()
    });
const $39468fbf3d3ca783$var$LanguageSelect = ({ onChange: onChange })=>{
    const { locale: locale, setLocale: setLocale } = (0, $4GCPM.useLocalizationContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gENUy.default), {
        id: "select-language",
        value: locale,
        enableDefaultOption: false,
        "data-testid": `${locale}-language`,
        options: (0, $4GCPM.AVAILABLE_LANGUAGES).map((language)=>$39468fbf3d3ca783$var$transformLanguageToOption(language)),
        onChange: (option)=>{
            if (option?.value) {
                onChange && onChange(option?.value);
                setLocale(option?.value);
            }
        }
    });
};
var $39468fbf3d3ca783$export$2e2bcd8739ae039 = $39468fbf3d3ca783$var$LanguageSelect;

});
parcelRegister("f7u8v", function(module, exports) {

$parcel$export(module.exports, "Combobox", function () { return (parcelRequire("gENUy")).default; });

var $gENUy = parcelRequire("gENUy");

});
parcelRegister("gENUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba516ad8cef0e87$export$2e2bcd8739ae039; });

var $76MyM = parcelRequire("76MyM");

var $7nrKB = parcelRequire("7nrKB");

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("79eRy");
var $6DTlZ = parcelRequire("6DTlZ");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $4lanN = parcelRequire("4lanN");

var $43ttK = parcelRequire("43ttK");

var $iKemc = parcelRequire("iKemc");

var $4ZuDP = parcelRequire("4ZuDP");

var $3D9q8 = parcelRequire("3D9q8");

var $7o6m2 = parcelRequire("7o6m2");
function $aba516ad8cef0e87$var$Combobox({ options: propsOptions = [], value: value, onChange: onChange, disabled: disabled, disabledReason: disabledReason, enableDefaultOption: enableDefaultOption = true, enableDefaultTextOption: enableDefaultTextOption = "", wrapperClassName: wrapperClassName, ...props }, ref) {
    const options = (0, $7E7Dk.useMemo)(()=>Array.isArray(propsOptions) ? propsOptions : [], [
        propsOptions
    ]);
    const [isOpen, setIsOpen] = (0, $7E7Dk.useState)(false);
    const containerRef = (0, $7E7Dk.useRef)(null);
    const dropdownMenuRef = (0, $7E7Dk.useRef)(null);
    const inputRef = (0, $7E7Dk.useRef)(null);
    const [search, setSearch] = (0, $7E7Dk.useState)("");
    (0, $43ttK.default)(dropdownMenuRef, (event)=>{
        if (!containerRef.current?.contains(event.target)) setIsOpen(false);
        setSearch("");
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (!dropdownMenuRef.current || !inputRef) return;
        const inputBoundingRect = inputRef?.current?.getBoundingClientRect();
        const containerBoundingRect = containerRef?.current?.getBoundingClientRect();
        const menuBoundingRect = dropdownMenuRef?.current?.getBoundingClientRect();
        if (isOpen && containerBoundingRect && menuBoundingRect && inputBoundingRect) {
            dropdownMenuRef.current.style.width = `${containerBoundingRect.width}px`;
            dropdownMenuRef.current.style.left = `${containerBoundingRect.x}px`;
            dropdownMenuRef.current.style.top = `${inputBoundingRect.y + window.scrollY + inputBoundingRect.height + 3}px`;
        }
    }, [
        isOpen
    ]);
    const activeOption = (0, $7E7Dk.useMemo)(()=>{
        return options.find((o)=>o.value === value);
    }, [
        options,
        value
    ]);
    const filteredOptions = (0, $7E7Dk.useMemo)(()=>(enableDefaultOption ? [
            {
                value: null,
                label: enableDefaultTextOption
            }
        ] : []).concat(options.filter((item)=>item?.label?.toLowerCase().includes(search.toLowerCase()))), [
        enableDefaultOption,
        enableDefaultTextOption,
        options,
        search
    ]);
    (0, $7E7Dk.useImperativeHandle)(ref, ()=>inputRef.current, []);
    (0, $7E7Dk.useEffect)(()=>{
        if (!inputRef.current) return;
        if (isOpen) inputRef.current.focus();
        else inputRef.current.blur();
    }, [
        isOpen,
        ref
    ]);
    const renderMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7o6m2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3D9q8.Menu), {
            ref: dropdownMenuRef,
            className: (0, $7nrKB.classNames)({
                open: isOpen
            }),
            onKeyDown: (event)=>{
                if (isOpen && event.code === (0, $4lanN.KeyEvents).ESCAPE) {
                    setIsOpen(false);
                    event.stopPropagation();
                }
            }
        }, filteredOptions.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3D9q8.MenuItem), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
                    "default-text": enableDefaultOption
                }),
                active: option.value === value,
                disabled: option.disabled,
                key: `${index}-${option.value}`,
                "data-testid": `${props["data-testid"] || "combobox"}-option-${index}`,
                "aria-disabled": option.disabled,
                onTouchStart: (event)=>{
                    event.stopPropagation();
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    if (option.disabled) return;
                    if (typeof onChange === "function") onChange(option);
                    setIsOpen(false);
                },
                tabIndex: 0
            }, option.label))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3D9q8.MenuContainer), {
        ref: containerRef,
        ...wrapperClassName && {
            className: wrapperClassName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        value: isOpen ? search : activeOption?.label || "",
        onChange: (event)=>{
            setSearch(event.target.value);
        },
        onClick: ()=>{
            if (!disabled) setIsOpen(!isOpen);
        },
        onKeyDown: (event)=>{
            if (!isOpen && (event.code === (0, $4lanN.KeyEvents).ARROW_DOWN || event.code === (0, $4lanN.KeyEvents).ENTER)) setIsOpen(true);
            else if (isOpen && event.code === (0, $4lanN.KeyEvents).ESCAPE) {
                setIsOpen(false);
                event.stopPropagation();
            }
        },
        autoComplete: "off",
        disabled: disabled,
        ...props,
        ref: inputRef,
        dropdownMenu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center gap-1 px-3"
        }, disabled && disabledReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4ZuDP.default), {
            content: disabledReason,
            "data-testid": `${props["data-testid"] ?? "combobox"}-disabled-reason`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6DTlZ.LockIcon), {
            size: 15,
            fill: (0, $3CLIQ.theme).brandColors.CA_Mid_Gray,
            "data-testid": `${props["data-testid"] ?? "combobox"}-lock-icon`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3D9q8.SArrowIcon), {
            flipped: isOpen,
            "data-testid": `${props["data-testid"] ?? "combobox"}-arrow-icon`,
            color: disabled ? (0, $3CLIQ.theme).brandColors.CA_Mid_Gray : (0, $3CLIQ.theme).brandColors.CA_Black,
            width: 15,
            height: 6
        })), renderMenu())
    }));
}
var $aba516ad8cef0e87$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.forwardRef)($aba516ad8cef0e87$var$Combobox);

});
parcelRegister("79eRy", function(module, exports) {
$parcel$export(module.exports, "LockIcon", function () { return (parcelRequire("6DTlZ")).LockIcon; });
parcelRequire("6DTlZ");

});
parcelRegister("6DTlZ", function(module, exports) {

$parcel$export(module.exports, "LockIcon", function () { return $9f9bd7d647d6d3d7$export$37ea31f99740f2be; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
const $9f9bd7d647d6d3d7$var$SSPan = (0, $gRonV.default).span`
    display: flex;
    align-items: center;
`;
function $9f9bd7d647d6d3d7$export$37ea31f99740f2be({ fill: fill, size: size = 14, title: title, id: id = "lock-icon", ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($9f9bd7d647d6d3d7$var$SSPan, {
        title: title,
        id: id,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-lock"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("rect", {
        x: "3",
        y: "11",
        width: "18",
        height: "11",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M7 11V7a5 5 0 0 1 10 0v4"
    })));
}

});


parcelRegister("4lanN", function(module, exports) {

$parcel$export(module.exports, "KeyEvents", function () { return $7f52296798b95c35$export$58e9761e734f364f; });
const $7f52296798b95c35$export$58e9761e734f364f = {
    ARROW_DOWN: "ArrowDown",
    ENTER: "Enter",
    ESCAPE: "Escape"
};

});

parcelRegister("iKemc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a6eccbceacd7ffc$export$2e2bcd8739ae039; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
parcelRequire("4jUgT");
var $4HbEa = parcelRequire("4HbEa");
parcelRequire("dZVPQ");
var $7X2f7 = parcelRequire("7X2f7");
parcelRequire("ikjch");
var $57xxf = parcelRequire("57xxf");

var $k5TB2 = parcelRequire("k5TB2");
const $0a6eccbceacd7ffc$var$SInput = (0, $gRonV.default).input`
    border: unset;
    padding: 10px 15px;
    font-size: 16px;
    font-weight: var(--font-weight-light);
    width: 100%;
    position: relative;
    cursor: inherit;
    background-color: ${({ theme: theme })=>theme.font.backgroundColor};
    max-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 600px) {
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        & ~ label {
            font-size: 12px;
        }
    }
    &.password {
        padding-right: 40px;
    }

    &:not(:placeholder-shown),
    &:focus {
        & ~ label {
            font-size: 12px;
            top: -10px;
            background-color: white;
            border-radius: 2px;
        }
    }

    &:disabled {
        border-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        color: ${({ theme: theme })=>theme.brandColors.CA_Dark_Gray};

        & ~ label {
            color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        }
    }

    &.read-only {
        background-color: #fff;
        font-weight: var(--font-weight-bold);
        padding: 5px 3px;
        color: ${({ theme: theme })=>theme.brandColors.CA_Black};
    }

    &.noBorder-input {
        border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        border-width: 0 0px 1px 0px;
        background-color: white;
        font-weight: var(--font-weight-normal);
        & ~ label {
            color: ${({ theme: theme })=>theme.brandColors.CA_Black};
        }
        &:read-only {
            border-width: 1px;
            border-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
            color: ${({ theme: theme })=>theme.brandColors.CA_Mid_Gray};
            background-color: unset;
        }
    }

    &::-ms-reveal {
        display: none;
    }

    &.search-input {
        background-color: none;
        border: 1px solid ${({ theme: theme })=>theme.input.borderColor};
        padding: 10px 15px;
        position: relative;
        @media (max-width: 600px) {
            width: 100%;
        }
    }

    &.checkbox-black {
        padding: 0;
        appearance: none;
        background-color: unset;
        border: none;
        position: relative;
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
    }

    &.rounded {
        border-radius: 24px;
    }
`;
const $0a6eccbceacd7ffc$var$Input = /*#__PURE__*/ (0, $7E7Dk.forwardRef)(({ onClick: onClick, ...props }, ref)=>{
    const [showPassword, setShowPassword] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k5TB2.default), {
        unit: props.unit,
        subtitle: props.subtitle,
        error: props.error,
        id: props.id,
        type: props.type,
        ...props.dropdownMenu && {
            dropdownMenu: props.dropdownMenu
        },
        ...props.disabled && {
            disabled: props.disabled
        },
        ...props.disabledReason && {
            disabledReason: props.disabledReason
        },
        ...props.wrapperClassName && {
            className: props.wrapperClassName
        },
        ...props.labelText && {
            labelText: props.labelText
        },
        ...props.required && {
            required: props.required
        },
        ...props.infoText && {
            infoText: props.infoText
        },
        ...props.infoTextValues && {
            infoTextValues: props.infoTextValues
        },
        onClick: onClick
    }, props.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "flex absolute z-1",
        style: {
            left: "1rem"
        }
    }, props.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0a6eccbceacd7ffc$var$SInput, {
        ref: ref,
        placeholder: " ",
        autoComplete: "off",
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(props.className, {
            password: props.type === "password",
            "read-only": props.readonly,
            "checkbox-black": props.type === "checkbox"
        }),
        readOnly: props.readOnly ?? props.readonly,
        required: props.required,
        type: props.type === "password" && showPassword ? "text" : props.type,
        ...props.required && {
            "aria-required": true
        }
    }), props.type === "password" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $57xxf.SShowPasswordToggle), {
        tabIndex: -1,
        type: "button",
        "data-testid": "eyeIconBtn",
        onClick: ()=>setShowPassword(!showPassword)
    }, showPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7X2f7.EyeIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4HbEa.CloseEyeIcon), null)) : null);
});
var $0a6eccbceacd7ffc$export$2e2bcd8739ae039 = $0a6eccbceacd7ffc$var$Input;

});
parcelRegister("4jUgT", function(module, exports) {
$parcel$export(module.exports, "CloseEyeIcon", function () { return (parcelRequire("4HbEa")).CloseEyeIcon; });
parcelRequire("4HbEa");

});
parcelRegister("4HbEa", function(module, exports) {

$parcel$export(module.exports, "CloseEyeIcon", function () { return $b2b7da632f64a77e$export$dd188d760efda9ff; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $b2b7da632f64a77e$export$dd188d760efda9ff({ className: className, style: style, width: width = 25, height: height = 19, color: color = "#535353" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "CloseEyeIcon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#clip0_1340_4076)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M8.016 10.073c0 2.348 1.976 4.264 4.414 4.264 2.438 0 4.415-1.909 4.415-4.264 0-2.356-1.983-4.264-4.415-4.264-2.431 0-4.414 1.915-4.414 4.264Zm7.876 0c0 1.848-1.556 3.35-3.469 3.35-1.913 0-3.468-1.502-3.468-3.35s1.555-3.344 3.468-3.344 3.469 1.503 3.469 3.344Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M24.629 9.795c-.126-.162-1.976-2.43-4.814-4.304l-.616.724a22.811 22.811 0 0 1 4.442 3.864c-1.086 1.24-5.753 6.166-11.218 6.166S2.291 11.311 1.205 10.073c1.086-1.239 5.753-6.166 11.218-6.166 1.899 0 3.693.602 5.283 1.428l.624-.73C16.592 3.676 14.58 3 12.423 3 5.74 3 .448 9.518.224 9.795L0 10.073l.224.277c.224.278 5.515 6.795 12.2 6.795 6.684 0 11.98-6.517 12.198-6.795l.224-.277-.217-.278Z",
        fill: color
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M3.646 18.646 21.218 1.075",
        stroke: color
    })));
}

});


parcelRegister("k5TB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b3bf039ee51aa7$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $76MyM = parcelRequire("76MyM");
parcelRequire("79eRy");
var $6DTlZ = parcelRequire("6DTlZ");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");
parcelRequire("eGqzt");
var $jPnjU = parcelRequire("jPnjU");

var $4ZuDP = parcelRequire("4ZuDP");
const $f6b3bf039ee51aa7$var$SDiv = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-weight: var(--font-weight-light);
    margin-top: 4px;

    &.rounded {
        > div,
        * input {
            border-radius: 99em;
        }
    }
`;
const $f6b3bf039ee51aa7$var$SLabel = (0, $gRonV.default).label`
    cursor: pointer;
    line-height: 1.5;
    position: absolute;
    font-size: 14px;
    margin: unset;
    transition: all 0.1s ease-in-out;
    padding: 0 1px;
    margin-left: 11px;
    top: 8px;
    font-weight: var(--font-weight-light);
    pointer-events: none;

    &.has-error {
        color: ${({ theme: theme })=>theme.font.errorColor};
    }

    ${({ required: required })=>required ? `&:after {
        content: ' *';
    }` : ""}
`;
const $f6b3bf039ee51aa7$var$SInputDiv = (0, $gRonV.default).div`
    border: 1px solid ${({ theme: theme })=>theme.input.borderColor};
    background-color: ${({ theme: theme })=>theme.font.backgroundColor};
    display: flex;
    align-items: center;
    position: relative;

    &.has-error {
        border-width: 1px;
        border-color: ${({ theme: theme })=>theme.font.errorColor};

        input:focus {
            outline: none;
        }
    }

    &.no-border {
        background-color: unset;
        border: none;
    }
`;
const $f6b3bf039ee51aa7$var$SUnitSpan = (0, $gRonV.default).div`
    display: flex;
    padding: 0 ${({ theme: theme })=>theme.sizing.margin.m};
`;
const $f6b3bf039ee51aa7$var$SSubtitleDiv = (0, $gRonV.default).div`
    color: ${({ theme: theme })=>theme.brandColors.CA_Dark_Gray};
    margin-top: 6px;

    &[disabled] {
        color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    }
`;
const $f6b3bf039ee51aa7$var$SErrorDiv = (0, $gRonV.default).div`
    margin-top: 5px;
    color: ${({ theme: theme })=>theme.font.errorColor};
`;
const $f6b3bf039ee51aa7$var$InputWrapper = /*#__PURE__*/ (0, $7E7Dk.memo)(function InputWrapper({ children: children, labelText: labelText, infoText: infoText, infoTextValues: infoTextValues, id: id, className: className, required: required, unit: unit, disabled: disabled, disabledReason: disabledReason, dropdownMenu: dropdownMenu, error: error, subtitle: subtitle, subtitlePosition: subtitlePosition, type: type, onClick: onClick }) {
    const showAdditionalInfo = unit || disabled && disabledReason || infoText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SDiv, {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SInputDiv, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            "no-border": type === "checkbox",
            "has-error": error
        }),
        onClick: onClick
    }, children, labelText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SLabel, {
        "data-testid": `label-text-${id}`,
        htmlFor: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            "has-error": error,
            "required-label": required
        })
    }, labelText), showAdditionalInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SUnitSpan, null, unit, disabledReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4ZuDP.default), {
        content: disabledReason
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6DTlZ.LockIcon), {
        size: 15,
        fill: (0, $3CLIQ.theme).brandColors.CA_Mid_Gray
    })), infoText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4ZuDP.default), {
        content: infoText,
        contentValues: infoTextValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jPnjU.InfoIcon), {
        size: 20,
        fill: (0, $3CLIQ.theme).brandColors.CA_Mid_Gray
    }))), dropdownMenu), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SErrorDiv, {
        "data-testid": `error-text-${id}`
    }, error), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f6b3bf039ee51aa7$var$SSubtitleDiv, {
        ...disabled && {
            disabled: disabled
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(subtitlePosition === "right" && "ml-auto")
    }, subtitle));
});
var $f6b3bf039ee51aa7$export$2e2bcd8739ae039 = $f6b3bf039ee51aa7$var$InputWrapper;

});
parcelRegister("eGqzt", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return (parcelRequire("jPnjU")).InfoIcon; });
parcelRequire("jPnjU");

});
parcelRegister("jPnjU", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", function () { return $36776e660358ee85$export$2957fc44b3d2481; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $hhoFb = parcelRequire("hhoFb");
function $36776e660358ee85$export$2957fc44b3d2481({ fill: fill = (0, $3CLIQ.theme).brandColors.CA_Blue, size: size = 14, title: title, id: id = "info-icon", ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 25 25",
        version: "1.1",
        id: "svg4",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", {
        id: "defs8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: fill,
        id: "path2",
        d: "M 12.330078 3.2519531 C 9.9732911 3.2950431 7.7233277 4.2357541 6.0371094 5.8828125 C 4.3509011 7.5298709 3.3562524 9.7581837 3.2578125 12.113281 C 3.1593726 14.468379 3.964934 16.772689 5.5078125 18.554688 C 7.050691 20.336686 9.2155898 21.461572 11.560547 21.701172 C 13.905445 21.940772 16.251549 21.276849 18.123047 19.84375 C 19.994445 18.410551 21.249007 16.316532 21.628906 13.990234 C 22.001706 11.707637 21.506386 9.3705381 20.242188 7.4375 L 20.072266 7.1796875 L 18.966797 8.2871094 L 19.072266 8.4550781 C 20.043765 10.009686 20.427184 11.864396 20.146484 13.683594 C 19.848685 15.614092 18.825755 17.359648 17.285156 18.560547 C 15.744558 19.761446 13.80232 20.326931 11.857422 20.144531 C 9.9125944 19.962031 8.1107712 19.044524 6.8203125 17.578125 C 5.5298538 16.111626 4.8477226 14.208057 4.9140625 12.255859 C 4.9803924 10.303581 5.7907158 8.4496674 7.1777344 7.0742188 C 8.564753 5.6987701 10.424255 4.9054487 12.376953 4.8554688 C 13.739852 4.8205888 15.076207 5.1499725 16.253906 5.7949219 L 16.417969 5.8847656 L 17.556641 4.7480469 L 17.283203 4.5820312 C 15.801205 3.6868621 14.085076 3.2198632 12.330078 3.2519531 z M 11.5 7.5 L 11.5 9.5 L 13.5 9.5 L 13.5 7.5 L 11.5 7.5 z M 11.5 11 L 11.5 17.5 L 13.5 17.5 L 13.5 11 L 11.5 11 z "
    })));
}
var $36776e660358ee85$export$2e2bcd8739ae039 = $36776e660358ee85$export$2957fc44b3d2481;

});
parcelRegister("hhoFb", function(module, exports) {

$parcel$export(module.exports, "SIconSpan", function () { return $39aa8204748bd8a5$export$6e1aa66f8a3a5c7b; });

var $gRonV = parcelRequire("gRonV");
const $39aa8204748bd8a5$export$6e1aa66f8a3a5c7b = (0, $gRonV.default).span`
    align-items: center;
    justify-content: center;
    display: inline-flex;
    width: ${(props)=>props.size}px;
    min-width: ${(props)=>props.size}px;
    height: ${(props)=>props.size}px;
    min-height: ${(props)=>props.size}px;
`;

});



parcelRegister("4ZuDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65b3d9127330ba9$export$2e2bcd8739ae039; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $gRonV = parcelRequire("gRonV");

var $igvrl = parcelRequire("igvrl");
const $f65b3d9127330ba9$var$TooltipConatiner = (0, $gRonV.default).div`
    position: relative;
    display: inline-block;
    cursor: help;
    display: flex;
    align-items: center;
`;
const $f65b3d9127330ba9$var$STooltip = (0, $gRonV.default).div`
    position: fixed;
    visibility: ${({ active: active })=>active ? "visible" : "hidden"};
    width: 300px;
    max-width: 90vw;
    background-color: ${({ theme: theme })=>theme.brandColors.CA_Black};
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 13px;
    padding: 8px 12px;
    z-index: 1050;
    color: ${({ theme: theme })=>theme.brandColors.CA_White};
    border-width: 1px 1px 1px 1px;
    border-style: solid;
    border-color: #535353;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    transform: translateX(-50%);
    margin-top: 10px;
    &.large-content {
        width: 600px;
    }

    &:after {
        content: ' ';
        position: absolute;
        top: -10px;
        left: 50%;
        margin-left: 5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent black transparent;
    }

    &.overflowLeft {
        transform: translateX(-10%);

        &:after {
            left: 10%;
        }

        &::before {
            left: 10%;
        }
    }
    &.overflowRight {
        transform: translateX(-90%);

        &:after {
            left: 90%;
        }

        &::before {
            left: 90%;
        }
    }
`;
var $f65b3d9127330ba9$export$2e2bcd8739ae039 = ({ content: content, contentValues: contentValues, children: children, className: className })=>{
    const [showTooltip, setShowTooltip] = (0, $7E7Dk.useState)(false);
    const [overflowClass, setOverflowClass] = (0, $7E7Dk.useState)(undefined);
    const containerRef = (0, $7E7Dk.useRef)();
    const ref = (0, $7E7Dk.useRef)();
    (0, $7E7Dk.useLayoutEffect)(()=>{
        if (!ref.current || !containerRef) return;
        const containerSize = containerRef?.current?.getBoundingClientRect();
        const tooltipSize = ref?.current?.getBoundingClientRect();
        if (showTooltip && containerSize) {
            ref.current.style.top = `${containerSize.y + containerSize.height}px`;
            ref.current.style.left = `${containerSize?.left}px`;
            if (containerSize.left + tooltipSize.width / 2 > window.innerWidth) setOverflowClass("overflowRight");
            if (containerSize.left - tooltipSize.width / 2 < 0) setOverflowClass("overflowLeft");
        } else if (overflowClass !== undefined) {
            setOverflowClass(undefined);
            ref.current.style.top = "0px";
            ref.current.style.left = "0px";
        }
    }, [
        showTooltip
    ]);
    const handleMouseEnter = ()=>{
        setShowTooltip(true);
    };
    const handleMouseLeave = ()=>{
        setShowTooltip(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f65b3d9127330ba9$var$TooltipConatiner, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: ()=>setShowTooltip(!showTooltip),
        ref: containerRef
    }, children, /*#__PURE__*/ (0, $hzbSh.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f65b3d9127330ba9$var$STooltip, {
        ref: ref,
        active: showTooltip,
        "data-testid": "tooltip",
        id: "tooltip-1",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            className: className
        }, overflowClass)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: content,
        values: contentValues
    })), document.body));
};

});



parcelRegister("3D9q8", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", function () { return $4bdedb4def2c6eea$export$b286f91cddfedb5a; });
$parcel$export(module.exports, "Menu", function () { return $4bdedb4def2c6eea$export$d9b273488cd8ce6f; });
$parcel$export(module.exports, "MenuItem", function () { return $4bdedb4def2c6eea$export$2ce376c2cc3355c8; });
$parcel$export(module.exports, "SArrowIcon", function () { return $4bdedb4def2c6eea$export$b745dc78e4e4d54b; });

var $gRonV = parcelRequire("gRonV");
parcelRequire("hyFRo");
var $gRg4a = parcelRequire("gRg4a");
const $4bdedb4def2c6eea$export$b286f91cddfedb5a = (0, $gRonV.default).div`
    position: relative;
    cursor: pointer;
`;
const $4bdedb4def2c6eea$export$d9b273488cd8ce6f = (0, $gRonV.default).ul`
    background-color: ${({ theme: theme })=>theme.brandColors.CA_White};
    position: absolute;
    width: 100%;
    box-shadow: ${({ theme: theme })=>theme.boxShadow};
    list-style: none;
    padding: unset;
    margin: unset;
    z-index: 1300;
    max-height: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    top: 100%;
    visibility: hidden;
    transition: max-height 0.3s ease;

    &.open {
        visibility: visible;
        max-height: 20vh;
    }
`;
const $4bdedb4def2c6eea$export$2ce376c2cc3355c8 = (0, $gRonV.default).li`
    padding: 4px 10px;
    height: 32px;
    transition: background-color ${({ theme: theme })=>theme.transition};
    background-color: ${({ theme: theme, active: active, disabled: disabled })=>active && !disabled ? theme.brandColors.CA_Mid_Blue : theme.brandColors.CA_White};
    color: ${({ theme: theme, active: active, disabled: disabled })=>{
    if (disabled) return theme.brandColors.CA_Mid_Gray;
    return active ? theme.brandColors.CA_Dark_Gray : theme.brandColors.CA_Black;
}};
    font-weight: var(--font-weight-light);
    font-size: 16px;
    line-height: 1.5;
    overflow: hidden;
    white-space: nowrap;
    min-height: 25px;
    text-overflow: ellipsis;
    cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};

    &:focus,
    &:hover {
        background-color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.brandColors.CA_White : theme.brandColors.CA_Light_Blue};
        color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.brandColors.CA_Mid_Gray : theme.brandColors.CA_Dark_Gray};
        width: 100%;
    }
    &.default-text {
        &:first-child {
            color: ${({ theme: theme })=>theme.brandColors.CA_Mid_Gray};
        }
    }
`;
const $4bdedb4def2c6eea$export$b745dc78e4e4d54b = (0, $gRonV.default)((0, $gRg4a.ArrowIcon))`
    top: 0;
    bottom: 0;
    right: 15px;
    margin: auto 0;
    transform: rotate(${({ flipped: flipped })=>flipped ? 0 : "180deg"});
    transition: transform 0.2s ease-in;
`;
const $4bdedb4def2c6eea$export$1bdc0f6c92ea7674 = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    padding-right: 1rem;
    gap: 5px;
    margin: auto 0;
    max-height: 20px;
    cursor: ${({ disabled: disabled })=>disabled ? "default" : "pointer"};

    transition: transform 0.2s ease-in;

    &.read-only {
        display: none;
    }
`;

});

parcelRegister("7o6m2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $739e5c1a7a86a2fb$export$2e2bcd8739ae039; });

var $hzbSh = parcelRequire("hzbSh");
const $739e5c1a7a86a2fb$var$Portal = ({ children: children })=>{
    let mount = document.getElementById("combobox-parent");
    if (!mount) {
        mount = document.createElement("div");
        mount.id = "combobox-parent";
        document.body.appendChild(mount);
    }
    return /*#__PURE__*/ (0, $hzbSh.createPortal)(children, mount);
};
var $739e5c1a7a86a2fb$export$2e2bcd8739ae039 = $739e5c1a7a86a2fb$var$Portal;

});




parcelRegister("2nOeJ", function(module, exports) {
$parcel$export(module.exports, "WidgetLayout", function () { return (parcelRequire("bJ69a")).WidgetLayout; });
parcelRequire("bJ69a");

});
parcelRegister("bJ69a", function(module, exports) {

$parcel$export(module.exports, "WidgetLayout", function () { return $e494088a79d23e6a$export$58cde0580204880a; });

var $8Pg02 = parcelRequire("8Pg02");

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("hhXpq");
var $2z9iD = parcelRequire("2z9iD");

var $9WSfA = parcelRequire("9WSfA");

var $dzjGc = parcelRequire("dzjGc");

var $1WeuN = parcelRequire("1WeuN");
const $e494088a79d23e6a$export$5855380f42380e4a = ({ title: title, loadingStatus: loadingStatus, headerInfoIcon: headerInfoIcon, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2z9iD.SContainer), {
        size: "md",
        "data-testid": `${props["data-testid"] ?? "widget"}-title`
    }, title, headerInfoIcon, loadingStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.SLoadingIcon), {
        icon: (0, $8Pg02.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }));
function $e494088a79d23e6a$export$58cde0580204880a({ children: children, actionButtons: actionButtons, title: title, loadingStatus: loadingStatus, isLoading: isLoading, headerText: headerText, headerInfoIcon: headerInfoIcon, headerButtons: headerButtons, contextMenuItems: contextMenuItems, disabled: disabled, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.SWidget), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.SWidgetHeader), null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e494088a79d23e6a$export$5855380f42380e4a, {
        title: title,
        loadingStatus: loadingStatus,
        "data-testid": props["data-testid"] ?? "widget",
        headerInfoIcon: headerInfoIcon
    }), headerText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.WidgetHeaderText), {
        "data-testid": "header-text"
    }, headerText), (headerButtons || contextMenuItems) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dzjGc.ButtonContainer), null, headerButtons, contextMenuItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9WSfA.default), null, contextMenuItems))), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-small",
        "data-testid": "loading"
    }) : children, actionButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.SWidgetActionButtons), null, actionButtons), disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1WeuN.SDisabledOverlay), {
        "data-testid": "disabledOverlay"
    }));
}
var $e494088a79d23e6a$export$2e2bcd8739ae039 = $e494088a79d23e6a$export$58cde0580204880a;

});
parcelRegister("8Pg02", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $66cf7f537f12d584$var$prefix = "fas";
var $66cf7f537f12d584$var$iconName = "spinner";
var $66cf7f537f12d584$var$width = 512;
var $66cf7f537f12d584$var$height = 512;
var $66cf7f537f12d584$var$ligatures = [];
var $66cf7f537f12d584$var$unicode = "f110";
var $66cf7f537f12d584$var$svgPathData = "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z";
module.exports.definition = {
    prefix: $66cf7f537f12d584$var$prefix,
    iconName: $66cf7f537f12d584$var$iconName,
    icon: [
        $66cf7f537f12d584$var$width,
        $66cf7f537f12d584$var$height,
        $66cf7f537f12d584$var$ligatures,
        $66cf7f537f12d584$var$unicode,
        $66cf7f537f12d584$var$svgPathData
    ]
};
module.exports.faSpinner = module.exports.definition;
module.exports.prefix = $66cf7f537f12d584$var$prefix;
module.exports.iconName = $66cf7f537f12d584$var$iconName;
module.exports.width = $66cf7f537f12d584$var$width;
module.exports.height = $66cf7f537f12d584$var$height;
module.exports.ligatures = $66cf7f537f12d584$var$ligatures;
module.exports.unicode = $66cf7f537f12d584$var$unicode;
module.exports.svgPathData = $66cf7f537f12d584$var$svgPathData;

});

parcelRegister("9WSfA", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuItem", function () { return $c717ddfcd85488c9$export$ed97964d1871885d; });
$parcel$export(module.exports, "default", function () { return $c717ddfcd85488c9$export$2e2bcd8739ae039; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $gRonV = parcelRequire("gRonV");

var $bpgPM = parcelRequire("bpgPM");

var $43ttK = parcelRequire("43ttK");

var $bacD4 = parcelRequire("bacD4");

var $77RHZ = parcelRequire("77RHZ");
const $c717ddfcd85488c9$var$SIconButton = (0, $gRonV.default)((0, $bacD4.IconButton))`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: unset;
    border-radius: 50%;
    padding: ${({ theme: theme })=>theme.sizing.padding.s};
`;
const $c717ddfcd85488c9$var$MenuContainer = (0, $gRonV.default).div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $c717ddfcd85488c9$var$MenuListItem = (0, $gRonV.default).li`
    cursor: pointer;
    padding: 10px 20px;
    transition: background-color ${({ theme: theme })=>theme.transition};
    line-height: 1;
    color: ${({ theme: theme })=>theme.brandColors.CA_Dark_Gray};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: grid;
    grid-template-columns: 24px 1fr;
    grid-template-areas: 'icon text';
    align-items: center;

    #icon {
        grid-area: icon;
    }

    #text {
        grid-area: text;
    }

    &:hover {
        background-color: ${({ theme: theme })=>theme.brandColors.CA_Black + "0a"};
    }

    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    }

    ${({ disabled: disabled })=>disabled ? `
        cursor: not-allowed;
        opacity: 0.6;
        ` : ""}
`;
const $c717ddfcd85488c9$export$ed97964d1871885d = ({ text: text, icon: icon, disabledReason: disabledReason, disabled: disabled, title: title, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c717ddfcd85488c9$var$MenuListItem, {
        title: disabled ? disabledReason : title,
        disabled: disabled,
        onClick: (e)=>{
            if (disabled) return;
            if (typeof onClick === "function") onClick(e);
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "text"
    }, text), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "icon"
    }, icon));
};
const $c717ddfcd85488c9$var$DropdownMenu = ({ children: menuItems, id: id, ...rest })=>{
    const [isOpen, setIsOpen] = (0, $7E7Dk.useState)(false);
    const menuContainerRef = (0, $7E7Dk.useRef)(null);
    const dropdownMenuRef = (0, $7E7Dk.useRef)(null);
    const onClickHandler = (e)=>{
        e.stopPropagation();
        setIsOpen(false);
    };
    (0, $43ttK.default)(dropdownMenuRef, onClickHandler);
    (0, $7E7Dk.useEffect)(()=>{
        if (!dropdownMenuRef.current || !menuContainerRef) return;
        const containerBoundingRect = menuContainerRef?.current?.getBoundingClientRect();
        const menuBoundingRect = dropdownMenuRef?.current?.getBoundingClientRect();
        if (isOpen && containerBoundingRect && menuBoundingRect) {
            dropdownMenuRef.current.style.left = `${containerBoundingRect.x + containerBoundingRect.width - menuBoundingRect.width}px`;
            dropdownMenuRef.current.style.top = `${containerBoundingRect.y + containerBoundingRect.height}px`;
        }
    }, [
        isOpen
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        const handleScroll = ()=>setIsOpen(false);
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c717ddfcd85488c9$var$MenuContainer, {
        ref: menuContainerRef,
        "data-testid": "dropdown-menu-container",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c717ddfcd85488c9$var$SIconButton, {
        onClick: (e)=>{
            e.stopPropagation();
            setIsOpen(!isOpen);
        },
        "data-testid": `${id ? id : "menu"}-toggle-btn`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bpgPM.default), {
        size: 20
    })), isOpen && /*#__PURE__*/ (0, $hzbSh.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $77RHZ.default), {
        ref: dropdownMenuRef,
        onClick: onClickHandler,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            open: isOpen
        }),
        "data-testid": "dropdown-menu"
    }, menuItems), document.body));
};
var $c717ddfcd85488c9$export$2e2bcd8739ae039 = $c717ddfcd85488c9$var$DropdownMenu;

});
parcelRegister("bpgPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49decdcfc31a6536$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $49decdcfc31a6536$var$MoreIcon = ({ fill: fill, size: size = 14, title: title, id: id = "more-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-more-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("circle", {
        cx: "12",
        cy: "5",
        r: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("circle", {
        cx: "12",
        cy: "19",
        r: "1"
    })));
};
var $49decdcfc31a6536$export$2e2bcd8739ae039 = $49decdcfc31a6536$var$MoreIcon;

});

parcelRegister("bacD4", function(module, exports) {

$parcel$export(module.exports, "IconButton", function () { return $954d78bc54190c7a$export$c25acd513dcc8062; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $76MyM = parcelRequire("76MyM");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");
const $954d78bc54190c7a$var$SIconButton = (0, $gRonV.default).button`
    background-color: transparent;
    border: none;
    color: ${({ color: color, theme: theme })=>color ?? theme.brandColors.CA_Mid_Gray};
    display: flex;
    align-items: center;
    gap: ${({ theme: theme })=>theme.sizing.margin.s};
    transition: ${({ theme: theme })=>`background-color ${theme.transition}`};
    color: ${({ theme: theme })=>theme.brandColors.CA_Mid_Gray};

    &:hover {
        color: ${({ theme: theme })=>theme.brandColors.CA_Black};
        background-color: rgba(0, 0, 0, 0.05);
    }
`;
const $954d78bc54190c7a$export$c25acd513dcc8062 = ({ children: children, className: className, color: color = (0, $3CLIQ.theme).font.darkestColor, dataTestId: dataTestId = "icon-button", ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($954d78bc54190c7a$var$SIconButton, {
        ...className && {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className)
        },
        type: "button",
        color: color,
        "data-testid": dataTestId,
        ...props
    }, children);
};

});

parcelRegister("77RHZ", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", function () { return $5d7c4e4b1be448b3$export$e44a253a59704894; });
$parcel$export(module.exports, "default", function () { return $5d7c4e4b1be448b3$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
const $5d7c4e4b1be448b3$export$e44a253a59704894 = (0, $gRonV.default).ul`
    background-color: ${({ theme: theme })=>theme.brandColors.CA_White};
    border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    position: fixed;
    border-radius: 8px;
    box-shadow: ${({ theme: theme })=>theme.boxShadow};
    z-index: 30;
    padding: 2rem;
    margin: unset;
    max-height: calc(100vh - 18rem);
    overflow: auto;
`;
const $5d7c4e4b1be448b3$var$SMenu = (0, $gRonV.default)($5d7c4e4b1be448b3$export$e44a253a59704894)`
    list-style: none;
    padding: unset;
    max-height: 0;
    top: calc(100% + 2px);
    visibility: hidden;
    transition: max-height 0.3s ease;
    overflow: hidden;

    &.open {
        visibility: visible;
        max-height: 70%;
    }
`;
const $5d7c4e4b1be448b3$var$Menu = /*#__PURE__*/ (0, $7E7Dk.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($5d7c4e4b1be448b3$var$SMenu, {
        ref: ref,
        ...props
    }, children);
});
var $5d7c4e4b1be448b3$export$2e2bcd8739ae039 = $5d7c4e4b1be448b3$var$Menu;

});


parcelRegister("dzjGc", function(module, exports) {

$parcel$export(module.exports, "ButtonContainer", function () { return $475ce5d6c4cae7c3$export$eddf54ea3db8d0f0; });

var $gRonV = parcelRequire("gRonV");
const $475ce5d6c4cae7c3$export$eddf54ea3db8d0f0 = (0, $gRonV.default).div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme: theme })=>theme.sizing.margin.sm};
    margin-left: auto;
    max-width: 50%;
    width: 50%;

    @media (max-width: ${({ theme: theme })=>theme.breakPoints.xl}) {
        width: 100%;
        max-width: 100%;
    }
`;

});

parcelRegister("1WeuN", function(module, exports) {

$parcel$export(module.exports, "SWidget", function () { return $dc7045eb5b0c267b$export$81122323e69f0e7c; });
$parcel$export(module.exports, "SWidgetHeader", function () { return $dc7045eb5b0c267b$export$592f2e2cecbdbd14; });
$parcel$export(module.exports, "WidgetHeaderText", function () { return $dc7045eb5b0c267b$export$cdd9fac7fc695812; });
$parcel$export(module.exports, "SDisabledOverlay", function () { return $dc7045eb5b0c267b$export$9707902ee0ac58bd; });
$parcel$export(module.exports, "SLoadingIcon", function () { return $dc7045eb5b0c267b$export$c22f656e98a10841; });
$parcel$export(module.exports, "SWidgetActionButtons", function () { return $dc7045eb5b0c267b$export$394049663815807a; });

var $g7dDc = parcelRequire("g7dDc");

var $gRonV = parcelRequire("gRonV");
const $dc7045eb5b0c267b$export$81122323e69f0e7c = (0, $gRonV.default).div`
    padding: 20px;
    display: flex;
    flex-flow: column;
    min-height: 300px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px;
`;
const $dc7045eb5b0c267b$export$592f2e2cecbdbd14 = (0, $gRonV.default).div`
    margin-bottom: ${({ theme: theme })=>theme.sizing.margin.m};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;
const $dc7045eb5b0c267b$export$cdd9fac7fc695812 = (0, $gRonV.default).div`
    padding: 10px 20px;
    display: flex;
    letter-spacing: 1%;
    font-weight: var(--font-weight-light);
    font-size: 16px;
`;
const $dc7045eb5b0c267b$export$8d75509f3923ce49 = (0, $gRonV.default).div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;
const $dc7045eb5b0c267b$export$9707902ee0ac58bd = (0, $gRonV.default).div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    background: rgba(212, 212, 212, 0.5);
`;
const $dc7045eb5b0c267b$export$c22f656e98a10841 = (0, $gRonV.default)((0, $g7dDc.FontAwesomeIcon))`
    margin-top: 3px;
`;
const $dc7045eb5b0c267b$export$394049663815807a = (0, $gRonV.default).div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
    gap: 10px;
`;

});



parcelRegister("r38ZI", function(module, exports) {

$parcel$export(module.exports, "notifySuccess", function () { return $50874a78700a85c5$export$26c553c966c0fb88; });
$parcel$export(module.exports, "notifyError", function () { return $50874a78700a85c5$export$740944ffd2f8d33e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $9Sg2u = parcelRequire("9Sg2u");

var $gRonV = parcelRequire("gRonV");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $fxo9Q = parcelRequire("fxo9Q");

var $ffc3A = parcelRequire("ffc3A");

var $kQeZn = parcelRequire("kQeZn");
const $50874a78700a85c5$var$containerElement = (0, $fxo9Q.default)();
const $50874a78700a85c5$var$root = (0, $9Sg2u.createRoot)($50874a78700a85c5$var$containerElement);
function $50874a78700a85c5$export$5e14cdade93d6f7b(notification) {
    const NotificationsManagerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gRonV.ThemeProvider), {
        theme: (0, $3CLIQ.theme)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kQeZn.default), {
        notification: notification
    }));
    $50874a78700a85c5$var$root.render(NotificationsManagerElement);
}
function $50874a78700a85c5$export$444d0de426e176f6(message, autoClose) {
    return $50874a78700a85c5$export$5e14cdade93d6f7b({
        type: (0, $ffc3A.NotificationTypes).Info,
        message: message,
        autoClose: autoClose
    });
}
function $50874a78700a85c5$export$26c553c966c0fb88(message, autoClose) {
    return $50874a78700a85c5$export$5e14cdade93d6f7b({
        type: (0, $ffc3A.NotificationTypes).Success,
        message: message,
        autoClose: autoClose
    });
}
function $50874a78700a85c5$export$1cb38ad1a79bcece(message, autoClose) {
    return $50874a78700a85c5$export$5e14cdade93d6f7b({
        type: (0, $ffc3A.NotificationTypes).Warning,
        message: message,
        autoClose: autoClose
    });
}
function $50874a78700a85c5$export$740944ffd2f8d33e(message, autoClose) {
    return $50874a78700a85c5$export$5e14cdade93d6f7b({
        type: (0, $ffc3A.NotificationTypes).Error,
        message: message,
        autoClose: autoClose
    });
}

});
parcelRegister("fxo9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68ad0db8219042a6$export$2e2bcd8739ae039; });
const $68ad0db8219042a6$var$createContainer = ()=>{
    const portalId = "notifications";
    const modalContainer = document.getElementById(portalId);
    if (modalContainer) return modalContainer;
    const element = document.createElement("div");
    element.setAttribute("id", portalId);
    element.classList.add("notify-container");
    document.body.appendChild(element);
    return element;
};
var $68ad0db8219042a6$export$2e2bcd8739ae039 = $68ad0db8219042a6$var$createContainer;

});

parcelRegister("ffc3A", function(module, exports) {

$parcel$export(module.exports, "NotificationTypes", function () { return $fdfb7df7ac4b603c$export$fe557678fb9e25ed; });
$parcel$export(module.exports, "default", function () { return $fdfb7df7ac4b603c$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $gRonV = parcelRequire("gRonV");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $bacD4 = parcelRequire("bacD4");

var $dmi8V = parcelRequire("dmi8V");

var $fxo9Q = parcelRequire("fxo9Q");
var $fdfb7df7ac4b603c$export$fe557678fb9e25ed;
(function(NotificationTypes) {
    NotificationTypes[NotificationTypes["Info"] = 0] = "Info";
    NotificationTypes[NotificationTypes["Success"] = 1] = "Success";
    NotificationTypes[NotificationTypes["Warning"] = 2] = "Warning";
    NotificationTypes[NotificationTypes["Error"] = 3] = "Error";
})($fdfb7df7ac4b603c$export$fe557678fb9e25ed || ($fdfb7df7ac4b603c$export$fe557678fb9e25ed = {}));
const $fdfb7df7ac4b603c$var$fadeIn = (0, $gRonV.keyframes)`
    from {
        opacity: 0;
    }

    to {
        transform: 1;
    }
`;
const $fdfb7df7ac4b603c$var$SNotification = (0, $gRonV.default).div`
    position: relative;
    transform: translate(-50%, -50%);
    padding: 20px;
    margin-bottom: 8px;
    background-color: ${(props)=>{
    switch(props.type){
        case 1:
            return props.theme.brandColors.CA_Light_Green;
        case 2:
            return props.theme.brandColors.CA_Light_Gray;
        case 3:
            return props.theme.brandColors.CA_Coral;
        case 0:
        default:
            return props.theme.brandColors.CA_Dark_Gray;
    }
}};
    color: ${(props)=>{
    switch(props.type){
        case 1:
        case 2:
        case 3:
            return props.theme.brandColors.CA_Black;
        case 0:
        default:
            return props.theme.brandColors.CA_White;
    }
}};
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px;
    border-radius: 8px;
    max-width: 625px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    animation: ${$fdfb7df7ac4b603c$var$fadeIn} 0.2s ease-in-out;
    z-index: 100;

    @media screen and (max-width: 670px) {
        width: 90%;
    }
`;
const $fdfb7df7ac4b603c$var$Notification = ({ message: message, type: type = 1, onDismiss: onDismiss, autoClose: autoClose = true, index: index })=>{
    const [closing, setClosing] = (0, $7E7Dk.useState)(false);
    const timeToDismiss = 2000;
    (0, $7E7Dk.useEffect)(()=>{
        if (closing) {
            const timeoutId = setTimeout(onDismiss, timeToDismiss);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    }, [
        closing,
        onDismiss
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (autoClose) {
            const timeoutId = setTimeout(()=>setClosing(true), timeToDismiss);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    // Intentionally run only once on mount (use initial `autoClose` + `timeToDismiss` values).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $hzbSh.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fdfb7df7ac4b603c$var$SNotification, {
        type: type,
        $closing: closing,
        "data-testid": "notification-" + index
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bacD4.IconButton), {
        onClick: ()=>onDismiss(),
        color: (0, $3CLIQ.theme).brandColors.CA_Black
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dmi8V.CloseIcon), null))), (0, $fxo9Q.default)());
};
var $fdfb7df7ac4b603c$export$2e2bcd8739ae039 = $fdfb7df7ac4b603c$var$Notification;

});
parcelRegister("dmi8V", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", function () { return $4f3ebd7761027721$export$cae179f078f4b4a4; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $hhoFb = parcelRequire("hhoFb");
function $4f3ebd7761027721$export$cae179f078f4b4a4({ className: className, size: size = 22, color: color, title: title, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 22 22",
        fill: color ?? "currentcolor",
        "data-tesid": "close-icon",
        version: "1.1",
        id: "svg182",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#clip0_2_49)",
        id: "g175"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "m 10,11 c 0,1.07 -0.41999,2.07 -1.16999,2.83 l -4.17,4.17 h -2.84 l 5.59,-5.59 c 0.38,-0.37 0.59,-0.88 0.59,-1.41 0,-0.53 -0.21,-1.04 -0.59,-1.41 L 1.82001,4 h 2.84 l 4.17,4.17 C 9.58001,8.93 10,9.93 10,11 Z",
        id: "path171"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M 14.59,12.41 20.18,18 H 17.34 L 13.17,13.83 C 12.42,13.07 12,12.07 12,11 12,9.93 12.42,8.93 13.17,8.17 L 17.34,4 h 2.84 L 14.59,9.59 C 14.21,9.96 14,10.47 14,11 c 0,0.53 0.21,1.04 0.59,1.41 z",
        id: "path173"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", {
        id: "defs180"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("clipPath", {
        id: "clip0_2_49"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("rect", {
        width: "22",
        height: "22",
        fill: "white",
        id: "rect177"
    })))));
}

});


parcelRegister("kQeZn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae767f9e2fcd3109$export$2e2bcd8739ae039; });

var $5E6A5 = parcelRequire("5E6A5");

var $7E7Dk = parcelRequire("7E7Dk");

var $ffc3A = parcelRequire("ffc3A");
function $ae767f9e2fcd3109$export$2e2bcd8739ae039({ notification: notification }) {
    const [notifications, setNotifications] = (0, $7E7Dk.useState)([]);
    (0, $7E7Dk.useEffect)(()=>{
        const noOfNotifications = notifications.length;
        if (notifications.length === 3) notifications.shift();
        const newNotifications = (0, (/*@__PURE__*/$parcel$interopDefault($5E6A5))).uniq([
            ...notifications,
            {
                ...notification,
                key: noOfNotifications + 1
            }
        ]);
        setNotifications(newNotifications);
    }, [
        notification
    ]);
    const deleteNotification = ()=>{
        const test = (0, (/*@__PURE__*/$parcel$interopDefault($5E6A5))).minBy(notifications, "key");
        const newNotifications = notifications.filter((n)=>n.key !== test?.key);
        setNotifications(newNotifications);
    };
    return notifications.map((notification, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ffc3A.default), {
            autoClose: notification.autoClose,
            onDismiss: ()=>deleteNotification(),
            key: i,
            index: notification.key,
            message: notification?.message,
            type: notification?.type
        }));
}

});
parcelRegister("5E6A5", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});





parcelRegister("9NTz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b385057938a44c02$export$2e2bcd8739ae039; });
const $b385057938a44c02$var$stringifyQuery = (query)=>{
    return Object.keys(query).map((key)=>{
        const value = query[key];
        if (typeof value !== "undefined") {
            const encodedKey = encodeURIComponent(key);
            if (Array.isArray(value)) {
                const withoutEmptyValues = value.filter(Boolean);
                if (!withoutEmptyValues.length) return;
                return `${encodedKey}=${withoutEmptyValues.join(`&${encodedKey}=`)}`;
            }
            return `${encodedKey}=${encodeURIComponent(value)}`;
        }
    }).filter(Boolean).join("&");
};
const $b385057938a44c02$var$patchURLWithQuery = (path, query)=>query ? `${path}${path.includes("?") ? "&" : "?"}${$b385057938a44c02$var$stringifyQuery(query)}` : path;
const $b385057938a44c02$var$http = ({ method: method = "GET", url: url, query: query, body: body, headers: headers, credentials: credentials })=>fetch($b385057938a44c02$var$patchURLWithQuery(url, query), {
        method: method,
        headers: headers,
        body: body,
        credentials: credentials
    });
var $b385057938a44c02$export$2e2bcd8739ae039 = $b385057938a44c02$var$http;

});

parcelRegister("7y3ec", function(module, exports) {

$parcel$export(module.exports, "useApplyOrganisationSelection", function () { return $32506c27c205b960$export$b608b84c96415450; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $fIpd8 = parcelRequire("fIpd8");

var $1O9Jh = parcelRequire("1O9Jh");

var $hw820 = parcelRequire("hw820");

var $jnDYy = parcelRequire("jnDYy");

var $1IBeB = parcelRequire("1IBeB");

var $jZWFX = parcelRequire("jZWFX");
const $32506c27c205b960$export$b608b84c96415450 = ()=>{
    const dispatch = (0, $2rQNl.useDispatch)();
    const portal = (0, $fIpd8.getPortalState)(window.location.pathname);
    const [getAuthCurrent] = (0, $1O9Jh.useLazyAuthGetCurrentQuery)();
    return (0, $7E7Dk.useCallback)(async ({ organizationId: organizationId, broadcastAuthChange: broadcastAuthChange = true })=>{
        const sessionData = await getAuthCurrent(undefined, false).unwrap();
        const sessionSnapshot = (0, $jZWFX.buildPortalSessionSnapshot)(sessionData, {
            currentDomain: portal.currentDomain,
            currentPortalAudience: portal.currentPortalAudience
        });
        const hydratedOrganizationId = sessionSnapshot.selectedOrganizationId ?? sessionSnapshot.sessionEntitlements?.organizationId ?? null;
        if (!sessionSnapshot.sessionUser || !(0, $jZWFX.canHydratePortalSession)(sessionSnapshot, false)) throw new Error("Updated organisation session could not be hydrated");
        if (hydratedOrganizationId !== organizationId) throw new Error("Updated organisation session did not reflect the selected organisation");
        dispatch((0, $jnDYy.setUser)(sessionSnapshot.sessionUser));
        dispatch((0, $hw820.setEntitlements)((0, $hw820.normalizeEntitlementsState)(sessionSnapshot.sessionEntitlements, sessionSnapshot.selectedOrganizationId)));
        dispatch((0, $1O9Jh.enhancedApi).util.resetApiState());
        if (broadcastAuthChange) (0, $1IBeB.triggerAuthChange)();
        return sessionSnapshot.sessionUser;
    }, [
        dispatch,
        getAuthCurrent,
        portal.currentDomain,
        portal.currentPortalAudience
    ]);
};

});
parcelRegister("jZWFX", function(module, exports) {

$parcel$export(module.exports, "buildPortalSessionSnapshot", function () { return $7c25d22e0c51c9cd$export$ad04b496d0f39e8c; });
$parcel$export(module.exports, "canHydratePortalSession", function () { return $7c25d22e0c51c9cd$export$e57578223f91a410; });
$parcel$export(module.exports, "getPortalSessionStatus", function () { return $7c25d22e0c51c9cd$export$8cd665ea7ed1b8ad; });

var $s5QWi = parcelRequire("s5QWi");

var $fIpd8 = parcelRequire("fIpd8");

var $gs8NZ = parcelRequire("gs8NZ");
const $7c25d22e0c51c9cd$export$ad04b496d0f39e8c = (sessionData, { currentDomain: currentDomain, currentPortalAudience: currentPortalAudience })=>{
    const selectedOrganizationId = sessionData && "selectedOrganizationId" in sessionData ? sessionData.selectedOrganizationId ?? null : null;
    const sessionEntitlements = sessionData?.entitlements;
    const sessionPortalAudience = sessionData?.portalAudience ?? null;
    const sessionUser = (0, $s5QWi.normalizeCurrentUser)(sessionData && "user" in sessionData ? sessionData.user ?? null : null, selectedOrganizationId);
    const portalAudienceMatches = (0, $gs8NZ.hasMatchingPortalAudienceForAudience)(sessionPortalAudience, currentPortalAudience);
    const userHasPortalAccess = (0, $gs8NZ.hasPortalAccessForDomain)(sessionUser, currentDomain);
    const hasUnexpectedEntitlementsContext = currentDomain !== (0, $fIpd8.SiteDomain).ADMIN && Boolean(selectedOrganizationId || sessionEntitlements);
    return {
        selectedOrganizationId: selectedOrganizationId,
        sessionEntitlements: sessionEntitlements,
        sessionPortalAudience: sessionPortalAudience,
        sessionUser: sessionUser,
        portalAudienceMatches: portalAudienceMatches,
        userHasPortalAccess: userHasPortalAccess,
        hasUnexpectedEntitlementsContext: hasUnexpectedEntitlementsContext
    };
};
const $7c25d22e0c51c9cd$export$e57578223f91a410 = (snapshot, hasUnexpectedContextCleanupFailed)=>snapshot.portalAudienceMatches && snapshot.userHasPortalAccess && !hasUnexpectedContextCleanupFailed;
const $7c25d22e0c51c9cd$export$8cd665ea7ed1b8ad = ({ isSuccess: isSuccess, isLoading: isLoading, isFetching: isFetching, isClearingUnexpectedContext: isClearingUnexpectedContext, canHydrateSession: canHydrateSession })=>{
    if (isClearingUnexpectedContext) return "loading";
    if (isSuccess) return canHydrateSession ? "authenticated" : "unauthenticated";
    if (isLoading || isFetching) return "loading";
    return "unauthenticated";
};

});
parcelRegister("s5QWi", function(module, exports) {

$parcel$export(module.exports, "normalizeCurrentUser", function () { return $70e2c0ba1ba1c64d$export$fb14ccc8f566c8b; });
// Transitional replacement for the old localStorage-backed current user helper during auth migration cleanup.
let $70e2c0ba1ba1c64d$var$inMemoryUser;
const $70e2c0ba1ba1c64d$var$emptyCurrentUser = {
    id: "",
    firstName: "",
    lastName: "",
    password: "",
    passwordChange: null,
    mobile: "",
    email: "",
    userType: "",
    partnerId: 0,
    personalAccept: "",
    companyAccept: null,
    lastLogin: "",
    userName: "",
    fullName: "",
    claims: [],
    isPartner: false,
    userStatus: "Valid",
    roles: [],
    isSuperAdmin: false,
    roleInCompany: null,
    selectedCompanyId: "",
    features: []
};
const $70e2c0ba1ba1c64d$var$normalizePasswordChange = (passwordChange)=>passwordChange ? {
        currentPassword: passwordChange.currentPassword ?? "",
        newPassword: passwordChange.newPassword ?? "",
        passwordCompare: "passwordCompare" in passwordChange && typeof passwordChange.passwordCompare !== "undefined" ? passwordChange.passwordCompare ?? "" : ""
    } : null;
const $70e2c0ba1ba1c64d$var$getSelectedCompanyId = (user, selectedCompanyId)=>selectedCompanyId ?? ("selectedCompanyId" in user ? user.selectedCompanyId ?? "" : "");
const $70e2c0ba1ba1c64d$export$fb14ccc8f566c8b = (user, selectedCompanyId)=>{
    if (!user) return null;
    return {
        ...$70e2c0ba1ba1c64d$var$emptyCurrentUser,
        ...user,
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        password: user.password ?? "",
        passwordChange: $70e2c0ba1ba1c64d$var$normalizePasswordChange(user.passwordChange),
        mobile: user.mobile ?? "",
        email: user.email ?? "",
        userType: user.userType ?? "",
        partnerId: user.partnerId ?? 0,
        personalAccept: user.personalAccept ?? "",
        companyAccept: user.companyAccept ?? null,
        lastLogin: user.lastLogin ?? "",
        userName: user.userName ?? "",
        fullName: user.fullName ?? "",
        claims: user.claims ?? [],
        isPartner: user.isPartner ?? false,
        userStatus: user.userStatus ?? "Valid",
        roles: user.roles ?? [],
        isSuperAdmin: user.isSuperAdmin ?? false,
        roleInCompany: user.roleInCompany ?? null,
        selectedCompanyId: $70e2c0ba1ba1c64d$var$getSelectedCompanyId(user, selectedCompanyId),
        features: user.features ?? []
    };
};
const $70e2c0ba1ba1c64d$var$currentUser = (user)=>{
    if (user === null) {
        $70e2c0ba1ba1c64d$var$inMemoryUser = null;
        return null;
    }
    if (typeof user !== "undefined") {
        $70e2c0ba1ba1c64d$var$inMemoryUser = user;
        return user;
    }
    return $70e2c0ba1ba1c64d$var$inMemoryUser ?? null;
};
var $70e2c0ba1ba1c64d$export$2e2bcd8739ae039 = $70e2c0ba1ba1c64d$var$currentUser;

});

parcelRegister("gs8NZ", function(module, exports) {

$parcel$export(module.exports, "hasPortalAccessForDomain", function () { return $5fc32f71b01af0d1$export$896e597569522326; });
$parcel$export(module.exports, "hasMatchingPortalAudienceForAudience", function () { return $5fc32f71b01af0d1$export$9edae61fa694c069; });

var $cRXmD = parcelRequire("cRXmD");

var $eIymc = parcelRequire("eIymc");

var $fIpd8 = parcelRequire("fIpd8");
const $5fc32f71b01af0d1$export$896e597569522326 = (user, currentDomain)=>{
    if (!user?.id) return false;
    if (currentDomain === (0, $fIpd8.SiteDomain).SUPPORT) return Boolean(user.isSuperAdmin);
    if (currentDomain === (0, $fIpd8.SiteDomain).PARTNER) return Boolean(user.isPartner && user.partnerId);
    if (currentDomain === (0, $fIpd8.SiteDomain).ADMIN) return Boolean(user.isSuperAdmin || user.roles?.some((role)=>role?.claim === (0, $cRXmD.default).Admin || role?.claim === (0, $cRXmD.default).AdminViewOnly));
    return true;
};
const $5fc32f71b01af0d1$export$9469af676cb0c5f9 = (user)=>$5fc32f71b01af0d1$export$896e597569522326(user, (0, $eIymc.isSupportDomain) ? (0, $fIpd8.SiteDomain).SUPPORT : (0, $eIymc.isPartnerDomain) ? (0, $fIpd8.SiteDomain).PARTNER : (0, $eIymc.isAdminDomain) ? (0, $fIpd8.SiteDomain).ADMIN : null);
const $5fc32f71b01af0d1$export$9edae61fa694c069 = (portalAudience, currentAudience)=>Boolean(currentAudience && portalAudience && portalAudience === currentAudience);
const $5fc32f71b01af0d1$export$9f73a93cbf31b13c = (portalAudience)=>$5fc32f71b01af0d1$export$9edae61fa694c069(portalAudience, (0, $eIymc.currentPortalAudience));

});



parcelRegister("joOkM", function(module, exports) {

$parcel$export(module.exports, "useRejectedPortalLoginCleanup", function () { return $5c7b9b4476b6e175$export$cc14fbb85fc3687e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $fIpd8 = parcelRequire("fIpd8");

var $eFTdF = parcelRequire("eFTdF");

var $1O9Jh = parcelRequire("1O9Jh");

var $1IBeB = parcelRequire("1IBeB");
const $5c7b9b4476b6e175$export$cc14fbb85fc3687e = ()=>{
    const dispatch = (0, $2rQNl.useDispatch)();
    const portal = (0, $fIpd8.getPortalState)(window.location.pathname);
    const [logout] = (0, $1O9Jh.useAuthLogoutMutation)();
    return (0, $7E7Dk.useCallback)(async ({ broadcastAuthChange: broadcastAuthChange = true } = {})=>{
        if (portal.isPortalDomain) try {
            await logout().unwrap();
        } catch  {
        // Clear local state even if backend logout fails or the session is already gone.
        }
        dispatch((0, $eFTdF.requestPortalSessionReset)());
        if (broadcastAuthChange) (0, $1IBeB.triggerAuthChange)();
    }, [
        dispatch,
        logout,
        portal.isPortalDomain
    ]);
};

});




parcelRegister("8Vsu4", function(module, exports) {
$parcel$export(module.exports, "PartnerSignInInfoBlock", function () { return (parcelRequire("3Oq9E")).PartnerSignInInfoBlock; });
parcelRequire("3Oq9E");

});
parcelRegister("3Oq9E", function(module, exports) {

$parcel$export(module.exports, "PartnerSignInInfoBlock", function () { return $aa3f4b246271a485$export$4c14bd4ed50fa9c5; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $76MyM = parcelRequire("76MyM");

var $9Wtn2 = parcelRequire("9Wtn2");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $5pkxj = parcelRequire("5pkxj");

var $1sDHO = parcelRequire("1sDHO");

var $5u6k9 = parcelRequire("5u6k9");
const $aa3f4b246271a485$var$SInfoBlock = (0, $gRonV.default).div`
    transform: translate(0, 0);
    letter-spacing: 1%;
    background-color: white;
    color: black;
    position: fixed;
    z-index: 400;
    top: 0;
    height: 100%;
    width: 480px;
    left: -480px;
    overflow-x: hidden;
    transition: left 0.25s ease-in-out;

    padding: 120px 30px;

    &.open {
        left: 0;
        transition: left 0.25s ease-in-out;
        overflow-y: hidden;
    }

    display: flex;
    flex-direction: column;
    gap: 18px;
`;
const $aa3f4b246271a485$export$28f0c7306a485504 = (0, $gRonV.default).div`
    font-size: 1.25rem;
    align-items: center;
    line-height: 28px;
`;
const $aa3f4b246271a485$export$5416e40bb4703e28 = (0, $gRonV.default).div`
    font-weight: var(--font-weight-light);
    font-size: 1.25rem;
    line-height: 28px;
`;
const $aa3f4b246271a485$var$PARTNER_SIGN_IN_INFO_WAS_READ = "partnerSignInInfoWasRead";
const $aa3f4b246271a485$export$4c14bd4ed50fa9c5 = ()=>{
    const text = (0, $5u6k9.default)();
    const isMobileScreen = (0, $9Wtn2.useMediaPredicate)("(max-width: 990px)");
    const [isOpened, setIsOpened] = (0, $7E7Dk.useState)(()=>!(0, $1sDHO.default).getItem($aa3f4b246271a485$var$PARTNER_SIGN_IN_INFO_WAS_READ));
    const onClose = ()=>{
        (0, $1sDHO.default).setItem($aa3f4b246271a485$var$PARTNER_SIGN_IN_INFO_WAS_READ, true);
        setIsOpened(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5pkxj.default), {
        condition: !isMobileScreen,
        wrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($aa3f4b246271a485$var$SInfoBlock, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
                    open: isOpened
                })
            }, children)
    }, isOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(isMobileScreen && "p-5", "bg-white text-black w-full h-full flex flex-column")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($aa3f4b246271a485$export$28f0c7306a485504, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgPartnerSignInInfoBlockHeader"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($aa3f4b246271a485$export$5416e40bb4703e28, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgPartnerSignInInfoBlockBody"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($aa3f4b246271a485$export$28f0c7306a485504, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgPartnerSignInInfoBlockPricingHeader"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($aa3f4b246271a485$export$5416e40bb4703e28, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgPartnerSignInInfoBlockPricingBody"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(isMobileScreen ? "flex justify-content-center my-6" : "absolute left-0 bottom-0 mb-6 ml-6")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnClose"),
        onClick: onClose,
        outlined: true,
        icon: "pi pi-times",
        "data-testid": "info-block-close-btn"
    }))));
};

});
parcelRegister("5pkxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde478cce2f6460f$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");
const $dde478cce2f6460f$var$ConditionalWrapper = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, children);
var $dde478cce2f6460f$export$2e2bcd8739ae039 = $dde478cce2f6460f$var$ConditionalWrapper;

});





parcelRegister("23wDf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38d06d60637d4258$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Status", function () { return $38d06d60637d4258$export$96e9906d6d93a972; });
// TODO: delete this hook and all usages ASAP

var $7E7Dk = parcelRequire("7E7Dk");
const $38d06d60637d4258$export$180a06aba1a82a44 = (defer, deps = [], immediateArgs)=>{
    const processesRef = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(0);
    const stateRef = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef({
        status: "idle"
    });
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState(stateRef.current);
    const update = (newState)=>{
        stateRef.current = newState;
        setState(newState);
    };
    const reset = ()=>update({
            status: "idle"
        });
    const execute = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback((...args)=>{
        ++processesRef.current;
        update({
            ...stateRef.current,
            status: "pending"
        });
        return new Promise((resolve)=>resolve(defer(...args))).then((response)=>{
            update({
                status: --processesRef.current ? stateRef.current.status : "success",
                value: response
            });
            return response;
        }, (error)=>{
            if (!--processesRef.current) update({
                status: "error",
                error: error
            });
            return Promise.reject(error);
        });
    }, deps);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if (immediateArgs) execute(...immediateArgs).catch(()=>{
        /* To prevent uncaught promise error message */ });
    }, [
        execute,
        ...immediateArgs || []
    ]);
    return {
        ...state,
        reset: reset,
        execute: execute
    };
};
var $38d06d60637d4258$export$2e2bcd8739ae039 = $38d06d60637d4258$export$180a06aba1a82a44;
var $38d06d60637d4258$export$96e9906d6d93a972;
(function(Status) {
    Status["IDLE"] = "idle";
    Status["PENDING"] = "pending";
    Status["SUCCESS"] = "success";
    Status["ERROR"] = "error";
})($38d06d60637d4258$export$96e9906d6d93a972 || ($38d06d60637d4258$export$96e9906d6d93a972 = {}));

});

parcelRegister("Ri8UW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f135645cfe2bb4a5$export$2e2bcd8739ae039; });

var $ieP8o = parcelRequire("ieP8o");

var $2gS28 = parcelRequire("2gS28");

var $9NTz2 = parcelRequire("9NTz2");

var $73SrW = parcelRequire("73SrW");

var $eIymc = parcelRequire("eIymc");

var $96jRw = parcelRequire("96jRw");
const $f135645cfe2bb4a5$var$isResponseLike = (error)=>typeof error === "object" && error !== null && "status" in error && "text" in error;
const $f135645cfe2bb4a5$export$ef84ea89ae505b5a = (response)=>{
    const responsePath = new URL(response.url).pathname;
    if ((0, $96jRw.shouldInvalidatePortalSessionOnUnauthorized)({
        status: response.status,
        url: responsePath
    })) (0, $2gS28.requestPortalSessionReset)();
    return response;
};
const $f135645cfe2bb4a5$export$b47f305f0be2da06 = (response)=>response.text().then((text)=>{
        if (!text) return null;
        return JSON.parse(text);
    }).then((result)=>{
        if (response.status < 400) return result;
        return Promise.reject(result);
    });
function $f135645cfe2bb4a5$var$api({ method: method, path: path, base: base = (0, $73SrW.default)(), query: query, body: body, headers: headers, parseResponse: parseResponse }) {
    const cookieAuthMode = (0, $eIymc.isPortalDomain);
    const url = `${base}${path.startsWith("/") ? path : `/${path}`}`;
    const execute = async (forceCsrfRefresh = false)=>{
        let requestHeaders = {
            ...!(body instanceof FormData) && typeof body !== "string" && {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            ...headers
        };
        if ((0, $96jRw.shouldAttachPortalCsrf)({
            cookieAuthMode: cookieAuthMode,
            method: method,
            url: path
        })) {
            const csrfToken = await (0, $ieP8o.ensureCsrfToken)(async ()=>{
                const response = await (0, $9NTz2.default)({
                    url: `${(0, $73SrW.default)()}/csrf/handshake`,
                    method: "GET",
                    credentials: "include"
                });
                if (response.status >= 400) throw response;
                return (0, $ieP8o.readCsrfTokenFromResponse)(response);
            }, {
                forceRefresh: forceCsrfRefresh
            });
            requestHeaders = (0, $ieP8o.withCsrfHeader)(requestHeaders, csrfToken);
        }
        return (0, $9NTz2.default)({
            url: url,
            query: query,
            method: method,
            headers: requestHeaders,
            body: body instanceof FormData || typeof body === "string" ? body : JSON.stringify(body),
            credentials: cookieAuthMode ? "include" : undefined
        });
    };
    const executeWithHttpErrorRecovery = (forceCsrfRefresh = false)=>execute(forceCsrfRefresh).catch((error)=>{
            if ($f135645cfe2bb4a5$var$isResponseLike(error)) return error;
            throw error;
        });
    return executeWithHttpErrorRecovery().then((response)=>{
        if ((0, $96jRw.shouldRetryPortalRequestWithFreshCsrf)({
            cookieAuthMode: cookieAuthMode,
            method: method,
            url: path,
            status: response.status
        })) return executeWithHttpErrorRecovery(true);
        return response;
    }).then($f135645cfe2bb4a5$export$ef84ea89ae505b5a).then((response)=>{
        if (parseResponse) return parseResponse(response, $f135645cfe2bb4a5$export$b47f305f0be2da06);
        return $f135645cfe2bb4a5$export$b47f305f0be2da06(response);
    });
}
var $f135645cfe2bb4a5$export$2e2bcd8739ae039 = Object.assign($f135645cfe2bb4a5$var$api, {
    get: (props)=>$f135645cfe2bb4a5$var$api({
            ...props,
            method: "GET"
        }),
    post: (props)=>$f135645cfe2bb4a5$var$api({
            ...props,
            method: "POST"
        }),
    put: (props)=>$f135645cfe2bb4a5$var$api({
            ...props,
            method: "PUT"
        }),
    del: (props)=>$f135645cfe2bb4a5$var$api({
            ...props,
            method: "DELETE"
        })
});

});
parcelRegister("2gS28", function(module, exports) {

$parcel$export(module.exports, "requestPortalSessionReset", function () { return $e0622d463ac908ba$export$bfe733ea6175fda0; });
$parcel$export(module.exports, "addPortalSessionResetListener", function () { return $e0622d463ac908ba$export$feb7384c57961c9f; });
const $e0622d463ac908ba$var$portalSessionResetEventName = "portal-session-reset-requested";
const $e0622d463ac908ba$export$bfe733ea6175fda0 = ()=>{
    window.dispatchEvent(new Event($e0622d463ac908ba$var$portalSessionResetEventName));
};
const $e0622d463ac908ba$export$feb7384c57961c9f = (listener)=>{
    window.addEventListener($e0622d463ac908ba$var$portalSessionResetEventName, listener);
    return ()=>{
        window.removeEventListener($e0622d463ac908ba$var$portalSessionResetEventName, listener);
    };
};

});


parcelRegister("gHig1", function(module, exports) {
$parcel$export(module.exports, "SignInArrowIcon", function () { return (parcelRequire("7SBXg")).SignInArrowIcon; });
parcelRequire("7SBXg");

});
parcelRegister("7SBXg", function(module, exports) {

$parcel$export(module.exports, "SignInArrowIcon", function () { return $bde6f210b4263c7b$export$642c2c278dce9fbe; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $bde6f210b4263c7b$export$642c2c278dce9fbe({ className: className, style: style, width: width = 23, height: height = 20, color: color = "#81E18B" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: {
            color: color,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M22.5 10C22.5 11.07 22.08 12.07 21.33 12.83L14.5 19.66V16.82L19.91 11.41C20.29 11.04 20.5 10.53 20.5 10C20.5 9.47 20.29 8.96 19.91 8.59L14.5 3.18V0.339996L21.33 7.17C22.08 7.93 22.5 8.93 22.5 10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M16.5 9H0.5V11H16.5V9Z",
        fill: "currentColor"
    }));
}

});


parcelRegister("aoz19", function(module, exports) {

$parcel$export(module.exports, "getErrorMessageCode", function () { return $e87cb92aec4a85dd$export$5d62030ea5cf256f; });

var $gGcRO = parcelRequire("gGcRO");
const $e87cb92aec4a85dd$export$5d62030ea5cf256f = (error)=>{
    if ((0, $gGcRO.isFetchBaseQueryError)(error) && typeof error.data === "object" && error.data !== null && "messageCode" in error.data && typeof error.data.messageCode === "string") return error.data.messageCode;
    return null;
};

});

parcelRegister("iUBfY", function(module, exports) {

$parcel$export(module.exports, "validateEmailFormat", function () { return $ed511cfc0c7d3105$export$e14e461e57c0336; });
$parcel$export(module.exports, "validatePhoneNumber", function () { return $ed511cfc0c7d3105$export$30dc0b291f505e34; });

var $30DEd = parcelRequire("30DEd");

var $c4hCO = parcelRequire("c4hCO");
const $ed511cfc0c7d3105$var$DEFAULT_PHONE_REGION = "SE";
let $ed511cfc0c7d3105$var$phoneNumberUtil;
const $ed511cfc0c7d3105$var$getPhoneNumberUtil = ()=>$ed511cfc0c7d3105$var$phoneNumberUtil ??= (0, $30DEd.PhoneNumberUtil).getInstance();
function $ed511cfc0c7d3105$export$e14e461e57c0336(email) {
    const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return email.slice(0, email.indexOf("@")).length < 64 && !!email.toLowerCase().match(regex);
}
function $ed511cfc0c7d3105$export$30dc0b291f505e34(phoneNumber) {
    if (!phoneNumber) return true;
    if (phoneNumber.length > (0, $c4hCO.MAX_ORG_PHONE_NO_LENGTH)) return false;
    try {
        const util = $ed511cfc0c7d3105$var$getPhoneNumberUtil();
        const parsedPhoneNumber = util.parseAndKeepRawInput(phoneNumber, $ed511cfc0c7d3105$var$DEFAULT_PHONE_REGION);
        return util.isValidNumber(parsedPhoneNumber);
    } catch  {
        return false;
    }
}
function $ed511cfc0c7d3105$export$5d2f8e30afbe9878(hostname) {
    const topLevelDomain = hostname.substring(0, hostname.indexOf("."));
    const containsOnlyLetters = (value)=>value.match(/^[A-Za-z]+$/);
    return topLevelDomain.length !== 0 && !!containsOnlyLetters(topLevelDomain) && `${topLevelDomain}.charge.space` === hostname;
}

});
parcelRegister("30DEd", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $jscomp = $jscomp || {};
                        $jscomp.scope = {};
                        $jscomp.createTemplateTagFirstArg = function(a) {
                            return a.raw = a;
                        };
                        $jscomp.createTemplateTagFirstArgWithRaw = function(a, b) {
                            a.raw = b;
                            return a;
                        };
                        $jscomp.arrayIteratorImpl = function(a) {
                            var b = 0;
                            return function() {
                                return b < a.length ? {
                                    done: !1,
                                    value: a[b++]
                                } : {
                                    done: !0
                                };
                            };
                        };
                        $jscomp.arrayIterator = function(a) {
                            return {
                                next: $jscomp.arrayIteratorImpl(a)
                            };
                        };
                        $jscomp.makeIterator = function(a) {
                            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                            return b ? b.call(a) : $jscomp.arrayIterator(a);
                        };
                        $jscomp.arrayFromIterator = function(a) {
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            return c;
                        };
                        $jscomp.arrayFromIterable = function(a) {
                            return a instanceof Array ? a : $jscomp.arrayFromIterator($jscomp.makeIterator(a));
                        };
                        $jscomp.checkStringArgs = function(a, b, c) {
                            if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
                            return a + "";
                        };
                        $jscomp.ASSUME_ES5 = !1;
                        $jscomp.ASSUME_NO_NATIVE_MAP = !1;
                        $jscomp.ASSUME_NO_NATIVE_SET = !1;
                        $jscomp.SIMPLE_FROUND_POLYFILL = !1;
                        $jscomp.ISOLATE_POLYFILLS = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
                        $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
                            if (a == Array.prototype || a == Object.prototype) return a;
                            a[b] = c.value;
                            return a;
                        };
                        $jscomp.getGlobal = function(a) {
                            a = [
                                "object" == typeof globalThis && globalThis,
                                a,
                                "object" == typeof window && window,
                                "object" == typeof self && self,
                                "object" == typeof global1 && global1
                            ];
                            for(var b = 0; b < a.length; ++b){
                                var c = a[b];
                                if (c && c.Math == Math) return c;
                            }
                            throw Error("Cannot find global object");
                        };
                        $jscomp.global = $jscomp.getGlobal(this);
                        $jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
                        $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
                        $jscomp.polyfills = {};
                        $jscomp.propertyToPolyfillSymbol = {};
                        $jscomp.POLYFILL_PREFIX = "$jscp$";
                        var $jscomp$lookupPolyfilledValue = function(a, b) {
                            var c = $jscomp.propertyToPolyfillSymbol[b];
                            if (null == c) return a[b];
                            c = a[c];
                            return void 0 !== c ? c : a[b];
                        };
                        $jscomp.polyfill = function(a, b, c, d) {
                            b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
                        };
                        $jscomp.polyfillUnisolated = function(a, b, c, d) {
                            c = $jscomp.global;
                            a = a.split(".");
                            for(d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) return;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && null != b && $jscomp.defineProperty(c, a, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            });
                        };
                        $jscomp.polyfillIsolated = function(a, b, c, d) {
                            var e = a.split(".");
                            a = 1 === e.length;
                            d = e[0];
                            d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
                            for(var f = 0; f < e.length - 1; f++){
                                var g = e[f];
                                if (!(g in d)) return;
                                d = d[g];
                            }
                            e = e[e.length - 1];
                            c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
                            b = b(c);
                            null != b && (a ? $jscomp.defineProperty($jscomp.polyfills, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            }) : b !== c && ($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e) : $jscomp.POLYFILL_PREFIX + e, e = $jscomp.propertyToPolyfillSymbol[e], $jscomp.defineProperty(d, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            })));
                        };
                        $jscomp.polyfill("String.prototype.endsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "endsWith");
                                b += "";
                                void 0 === c && (c = d.length);
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var e = b.length; 0 < e && 0 < c;)if (d[--c] != b[--e]) return !1;
                                return 0 >= e;
                            };
                        }, "es6", "es3");
                        $jscomp.findInternal = function(a, b, c) {
                            a instanceof String && (a = String(a));
                            for(var d = a.length, e = 0; e < d; e++){
                                var f = a[e];
                                if (b.call(c, f, e, a)) return {
                                    i: e,
                                    v: f
                                };
                            }
                            return {
                                i: -1,
                                v: void 0
                            };
                        };
                        $jscomp.polyfill("Array.prototype.find", function(a) {
                            return a ? a : function(b, c) {
                                return $jscomp.findInternal(this, b, c).v;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.startsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "startsWith");
                                b += "";
                                var e = d.length, f = b.length;
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                                return g >= f;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.repeat", function(a) {
                            return a ? a : function(b) {
                                var c = $jscomp.checkStringArgs(this, null, "repeat");
                                if (0 > b || 1342177279 < b) throw new RangeError("Invalid count value");
                                b |= 0;
                                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                                return d;
                            };
                        }, "es6", "es3");
                        $jscomp.initSymbol = function() {};
                        $jscomp.polyfill("Symbol", function(a) {
                            if (a) return a;
                            var b = function(e, f) {
                                this.$jscomp$symbol$id_ = e;
                                $jscomp.defineProperty(this, "description", {
                                    configurable: !0,
                                    writable: !0,
                                    value: f
                                });
                            };
                            b.prototype.toString = function() {
                                return this.$jscomp$symbol$id_;
                            };
                            var c = 0, d = function(e) {
                                if (this instanceof d) throw new TypeError("Symbol is not a constructor");
                                return new b("jscomp_symbol_" + (e || "") + "_" + c++, e);
                            };
                            return d;
                        }, "es6", "es3");
                        $jscomp.polyfill("Symbol.iterator", function(a) {
                            if (a) return a;
                            a = Symbol("Symbol.iterator");
                            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                                var d = $jscomp.global[b[c]];
                                "function" === typeof d && "function" != typeof d.prototype[a] && $jscomp.defineProperty(d.prototype, a, {
                                    configurable: !0,
                                    writable: !0,
                                    value: function() {
                                        return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                                    }
                                });
                            }
                            return a;
                        }, "es6", "es3");
                        $jscomp.iteratorPrototype = function(a) {
                            a = {
                                next: a
                            };
                            a[Symbol.iterator] = function() {
                                return this;
                            };
                            return a;
                        };
                        $jscomp.iteratorFromArray = function(a, b) {
                            a instanceof String && (a += "");
                            var c = 0, d = !1, e = {
                                next: function() {
                                    if (!d && c < a.length) {
                                        var f = c++;
                                        return {
                                            value: b(f, a[f]),
                                            done: !1
                                        };
                                    }
                                    d = !0;
                                    return {
                                        done: !0,
                                        value: void 0
                                    };
                                }
                            };
                            e[Symbol.iterator] = function() {
                                return e;
                            };
                            return e;
                        };
                        $jscomp.polyfill("Array.prototype.keys", function(a) {
                            return a ? a : function() {
                                return $jscomp.iteratorFromArray(this, function(b) {
                                    return b;
                                });
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Object.is", function(a) {
                            return a ? a : function(b, c) {
                                return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Array.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                var d = this;
                                d instanceof String && (d = String(d));
                                var e = d.length;
                                c = c || 0;
                                for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                    var f = d[c];
                                    if (f === b || Object.is(f, b)) return !0;
                                }
                                return !1;
                            };
                        }, "es7", "es3");
                        $jscomp.polyfill("String.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                return -1 !== $jscomp.checkStringArgs(this, b, "includes").indexOf(b, c || 0);
                            };
                        }, "es6", "es3");
                        var COMPILED = !0, goog = goog || {};
                        goog.global = this || self;
                        goog.exportPath_ = function(a, b, c, d) {
                            a = a.split(".");
                            d = d || goog.global;
                            a[0] in d || "undefined" == typeof d.execScript || d.execScript("var " + a[0]);
                            for(var e; a.length && (e = a.shift());)if (a.length || void 0 === b) d = d[e] && d[e] !== Object.prototype[e] ? d[e] : d[e] = {};
                            else if (!c && goog.isObject(b) && goog.isObject(d[e])) for(var f in b)b.hasOwnProperty(f) && (d[e][f] = b[f]);
                            else d[e] = b;
                        };
                        goog.define = function(a, b) {
                            if (!COMPILED) {
                                var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
                                c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a) ? b = c[a] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) && (b = d[a]);
                            }
                            return b;
                        };
                        goog.FEATURESET_YEAR = 2012;
                        goog.DEBUG = !0;
                        goog.LOCALE = "en";
                        goog.TRUSTED_SITE = !0;
                        goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
                        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
                        goog.provide = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
                            if (!COMPILED && goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                            goog.constructNamespace_(a);
                        };
                        goog.constructNamespace_ = function(a, b, c) {
                            if (!COMPILED) {
                                delete goog.implicitNamespaces_[a];
                                for(var d = a; (d = d.substring(0, d.lastIndexOf("."))) && !goog.getObjectByName(d);)goog.implicitNamespaces_[d] = !0;
                            }
                            goog.exportPath_(a, b, c);
                        };
                        goog.getScriptNonce = function(a) {
                            if (a && a != goog.global) return goog.getScriptNonce_(a.document);
                            null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
                            return goog.cspNonce_;
                        };
                        goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
                        goog.cspNonce_ = null;
                        goog.getScriptNonce_ = function(a) {
                            return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
                        };
                        goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
                        goog.module = function(a) {
                            if ("string" !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
                            if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
                            if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
                            goog.moduleLoaderState_.moduleName = a;
                            if (!COMPILED) {
                                if (goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                                delete goog.implicitNamespaces_[a];
                            }
                        };
                        goog.module.get = function(a) {
                            return goog.module.getInternal_(a);
                        };
                        goog.module.getInternal_ = function(a) {
                            if (!COMPILED) {
                                if (a in goog.loadedModules_) return goog.loadedModules_[a].exports;
                                if (!goog.implicitNamespaces_[a]) return a = goog.getObjectByName(a), null != a ? a : null;
                            }
                            return null;
                        };
                        goog.ModuleType = {
                            ES6: "es6",
                            GOOG: "goog"
                        };
                        goog.moduleLoaderState_ = null;
                        goog.isInModuleLoader_ = function() {
                            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
                        };
                        goog.isInGoogModuleLoader_ = function() {
                            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
                        };
                        goog.isInEs6ModuleLoader_ = function() {
                            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
                            var a = goog.global.$jscomp;
                            return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
                        };
                        goog.module.declareLegacyNamespace = function() {
                            if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
                            if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
                            goog.moduleLoaderState_.declareLegacyNamespace = !0;
                        };
                        goog.declareModuleId = function(a) {
                            if (!COMPILED) {
                                if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
                                if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
                                if (a in goog.loadedModules_) throw Error('Module with namespace "' + a + '" already exists.');
                            }
                            if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;
                            else {
                                var b = goog.global.$jscomp;
                                if (!b || "function" != typeof b.getCurrentModulePath) throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
                                b = b.require(b.getCurrentModulePath());
                                goog.loadedModules_[a] = {
                                    exports: b,
                                    type: goog.ModuleType.ES6,
                                    moduleId: a
                                };
                            }
                        };
                        goog.setTestOnly = function(a) {
                            if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
                        };
                        goog.forwardDeclare = function(a) {};
                        COMPILED || (goog.isProvided_ = function(a) {
                            return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && null != goog.getObjectByName(a);
                        }, goog.implicitNamespaces_ = {
                            "goog.module": !0
                        });
                        goog.getObjectByName = function(a, b) {
                            a = a.split(".");
                            b = b || goog.global;
                            for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
                            return b;
                        };
                        goog.addDependency = function(a, b, c, d) {
                            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
                        };
                        goog.ENABLE_DEBUG_LOADER = !0;
                        goog.logToConsole_ = function(a) {
                            goog.global.console && goog.global.console.error(a);
                        };
                        goog.require = function(a) {
                            if (!COMPILED) {
                                goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
                                if (goog.isProvided_(a)) {
                                    if (goog.isInModuleLoader_()) return goog.module.getInternal_(a);
                                } else if (goog.ENABLE_DEBUG_LOADER) {
                                    var b = goog.moduleLoaderState_;
                                    goog.moduleLoaderState_ = null;
                                    try {
                                        goog.debugLoader_.load_(a);
                                    } finally{
                                        goog.moduleLoaderState_ = b;
                                    }
                                }
                                return null;
                            }
                        };
                        goog.requireType = function(a) {
                            return {};
                        };
                        goog.basePath = "";
                        goog.nullFunction = function() {};
                        goog.abstractMethod = function() {
                            throw Error("unimplemented abstract method");
                        };
                        goog.addSingletonGetter = function(a) {
                            a.instance_ = void 0;
                            a.getInstance = function() {
                                if (a.instance_) return a.instance_;
                                goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
                                return a.instance_ = new a;
                            };
                        };
                        goog.instantiatedSingletons_ = [];
                        goog.LOAD_MODULE_USING_EVAL = !0;
                        goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
                        goog.loadedModules_ = {};
                        goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
                        goog.TRANSPILE = "detect";
                        goog.ASSUME_ES_MODULES_TRANSPILED = !1;
                        goog.TRANSPILE_TO_LANGUAGE = "";
                        goog.TRANSPILER = "transpile.js";
                        goog.hasBadLetScoping = null;
                        goog.useSafari10Workaround = function() {
                            if (null == goog.hasBadLetScoping) {
                                try {
                                    var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                                } catch (b) {
                                    a = !1;
                                }
                                goog.hasBadLetScoping = a;
                            }
                            return goog.hasBadLetScoping;
                        };
                        goog.workaroundSafari10EvalBug = function(a) {
                            return "(function(){" + a + "\n;})();\n";
                        };
                        goog.loadModule = function(a) {
                            var b = goog.moduleLoaderState_;
                            try {
                                goog.moduleLoaderState_ = {
                                    moduleName: "",
                                    declareLegacyNamespace: !1,
                                    type: goog.ModuleType.GOOG
                                };
                                var c = {}, d = c;
                                if ("function" === typeof a) d = a.call(void 0, d);
                                else if ("string" === typeof a) goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), d = goog.loadModuleFromSource_.call(void 0, d, a);
                                else throw Error("Invalid module definition");
                                var e = goog.moduleLoaderState_.moduleName;
                                if ("string" === typeof e && e) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e, d, c !== d) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof d && null != d && Object.seal(d), goog.loadedModules_[e] = {
                                    exports: d,
                                    type: goog.ModuleType.GOOG,
                                    moduleId: goog.moduleLoaderState_.moduleName
                                };
                                else throw Error('Invalid module name "' + e + '"');
                            } finally{
                                goog.moduleLoaderState_ = b;
                            }
                        };
                        goog.loadModuleFromSource_ = function(a, b) {
                            eval(b);
                            return a;
                        };
                        goog.normalizePath_ = function(a) {
                            a = a.split("/");
                            for(var b = 0; b < a.length;)"." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
                            return a.join("/");
                        };
                        goog.loadFileSync_ = function(a) {
                            if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
                            try {
                                var b = new goog.global.XMLHttpRequest;
                                b.open("get", a, !1);
                                b.send();
                                return 0 == b.status || 200 == b.status ? b.responseText : null;
                            } catch (c) {
                                return null;
                            }
                        };
                        goog.transpile_ = function(a, b, c) {
                            var d = goog.global.$jscomp;
                            d || (goog.global.$jscomp = d = {});
                            var e = d.transpile;
                            if (!e) {
                                var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
                                if (g) {
                                    (function() {
                                        (0, eval)(g + "\n//# sourceURL=" + f);
                                    }).call(goog.global);
                                    if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                                    goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
                                    d = goog.global.$jscomp;
                                    e = d.transpile;
                                }
                            }
                            e || (e = d.transpile = function(h, k) {
                                goog.logToConsole_(k + " requires transpilation but no transpiler was found.");
                                return h;
                            });
                            return e(a, b, c);
                        };
                        goog.typeOf = function(a) {
                            var b = typeof a;
                            return "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
                        };
                        goog.isArrayLike = function(a) {
                            var b = goog.typeOf(a);
                            return "array" == b || "object" == b && "number" == typeof a.length;
                        };
                        goog.isDateLike = function(a) {
                            return goog.isObject(a) && "function" == typeof a.getFullYear;
                        };
                        goog.isObject = function(a) {
                            var b = typeof a;
                            return "object" == b && null != a || "function" == b;
                        };
                        goog.getUid = function(a) {
                            return Object.prototype.hasOwnProperty.call(a, goog.UID_PROPERTY_) && a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
                        };
                        goog.hasUid = function(a) {
                            return !!a[goog.UID_PROPERTY_];
                        };
                        goog.removeUid = function(a) {
                            null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
                            try {
                                delete a[goog.UID_PROPERTY_];
                            } catch (b) {}
                        };
                        goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
                        goog.uidCounter_ = 0;
                        goog.cloneObject = function(a) {
                            var b = goog.typeOf(a);
                            if ("object" == b || "array" == b) {
                                if ("function" === typeof a.clone) return a.clone();
                                b = "array" == b ? [] : {};
                                for(var c in a)b[c] = goog.cloneObject(a[c]);
                                return b;
                            }
                            return a;
                        };
                        goog.bindNative_ = function(a, b, c) {
                            return a.call.apply(a.bind, arguments);
                        };
                        goog.bindJs_ = function(a, b, c) {
                            if (!a) throw Error();
                            if (2 < arguments.length) {
                                var d = Array.prototype.slice.call(arguments, 2);
                                return function() {
                                    var e = Array.prototype.slice.call(arguments);
                                    Array.prototype.unshift.apply(e, d);
                                    return a.apply(b, e);
                                };
                            }
                            return function() {
                                return a.apply(b, arguments);
                            };
                        };
                        goog.bind = function(a, b, c) {
                            Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
                            return goog.bind.apply(null, arguments);
                        };
                        goog.partial = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = c.slice();
                                d.push.apply(d, arguments);
                                return a.apply(this, d);
                            };
                        };
                        goog.mixin = function(a, b) {
                            for(var c in b)a[c] = b[c];
                        };
                        goog.now = function() {
                            return Date.now();
                        };
                        goog.globalEval = function(a) {
                            (0, eval)(a);
                        };
                        goog.getCssName = function(a, b) {
                            if ("." == String(a).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
                            var c = function(e) {
                                return goog.cssNameMapping_[e] || e;
                            }, d = function(e) {
                                e = e.split("-");
                                for(var f = [], g = 0; g < e.length; g++)f.push(c(e[g]));
                                return f.join("-");
                            };
                            d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(e) {
                                return e;
                            };
                            a = b ? a + "-" + d(b) : d(a);
                            return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
                        };
                        goog.setCssNameMapping = function(a, b) {
                            goog.cssNameMapping_ = a;
                            goog.cssNameMappingStyle_ = b;
                        };
                        !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
                        goog.getMsg = function(a, b, c) {
                            c && c.html && (a = a.replace(/</g, "&lt;"));
                            c && c.unescapeHtmlEntities && (a = a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
                            b && (a = a.replace(/\{\$([^}]+)}/g, function(d, e) {
                                return null != b && e in b ? b[e] : d;
                            }));
                            return a;
                        };
                        goog.getMsgWithFallback = function(a, b) {
                            return a;
                        };
                        goog.exportSymbol = function(a, b, c) {
                            goog.exportPath_(a, b, !0, c);
                        };
                        goog.exportProperty = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.inherits = function(a, b) {
                            function c() {}
                            c.prototype = b.prototype;
                            a.superClass_ = b.prototype;
                            a.prototype = new c;
                            a.prototype.constructor = a;
                            a.base = function(d, e, f) {
                                for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
                                return b.prototype[e].apply(d, g);
                            };
                        };
                        goog.scope = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
                            a.call(goog.global);
                        };
                        COMPILED || (goog.global.COMPILED = COMPILED);
                        goog.defineClass = function(a, b) {
                            var c = b.constructor, d = b.statics;
                            c && c != Object.prototype.constructor || (c = function() {
                                throw Error("cannot instantiate an interface (no constructor defined).");
                            });
                            c = goog.defineClass.createSealingConstructor_(c, a);
                            a && goog.inherits(c, a);
                            delete b.constructor;
                            delete b.statics;
                            goog.defineClass.applyProperties_(c.prototype, b);
                            null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
                            return c;
                        };
                        goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
                        goog.defineClass.createSealingConstructor_ = function(a, b) {
                            return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
                                var c = a.apply(this, arguments) || this;
                                c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
                                return c;
                            } : a;
                        };
                        goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.defineClass.applyProperties_ = function(a, b) {
                            for(var c in b)Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                            for(var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                        };
                        !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
                            var a = goog.global.document;
                            return null != a && "write" in a;
                        }, goog.isDocumentLoading_ = function() {
                            var a = goog.global.document;
                            return a.attachEvent ? "complete" != a.readyState : "loading" == a.readyState;
                        }, goog.findBasePath_ = function() {
                            if (void 0 != goog.global.CLOSURE_BASE_PATH && "string" === typeof goog.global.CLOSURE_BASE_PATH) goog.basePath = goog.global.CLOSURE_BASE_PATH;
                            else if (goog.inHtmlDocument_()) {
                                var a = goog.global.document, b = a.currentScript;
                                a = b ? [
                                    b
                                ] : a.getElementsByTagName("SCRIPT");
                                for(b = a.length - 1; 0 <= b; --b){
                                    var c = a[b].src, d = c.lastIndexOf("?");
                                    d = -1 == d ? c.length : d;
                                    if ("base.js" == c.substr(d - 7, 7)) {
                                        goog.basePath = c.substr(0, d - 7);
                                        break;
                                    }
                                }
                            }
                        }, goog.findBasePath_(), goog.Transpiler = function() {
                            this.requiresTranspilation_ = null;
                            this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
                        }, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
                            function a(g, h) {
                                e ? d[g] = !0 : h() ? (c = g, d[g] = !1) : e = d[g] = !0;
                            }
                            function b(g) {
                                try {
                                    return !!eval(g);
                                } catch (h) {
                                    return !1;
                                }
                            }
                            var c = "es3", d = {
                                es3: !1
                            }, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
                            a("es5", function() {
                                return b("[1,].length==1");
                            });
                            a("es6", function() {
                                return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
                            });
                            a("es7", function() {
                                return b("2 ** 2 == 4");
                            });
                            a("es8", function() {
                                return b("async () => 1, true");
                            });
                            a("es9", function() {
                                return b("({...rest} = {}), true");
                            });
                            a("es_next", function() {
                                return !1;
                            });
                            return {
                                target: c,
                                map: d
                            };
                        }, goog.Transpiler.prototype.needsTranspile = function(a, b) {
                            if ("always" == goog.TRANSPILE) return !0;
                            if ("never" == goog.TRANSPILE) return !1;
                            if (!this.requiresTranspilation_) {
                                var c = this.createRequiresTranspilation_();
                                this.requiresTranspilation_ = c.map;
                                this.transpilationTarget_ = this.transpilationTarget_ || c.target;
                            }
                            if (a in this.requiresTranspilation_) return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || "es6" != b || "noModule" in goog.global.document.createElement("script") ? !1 : !0;
                            throw Error("Unknown language mode: " + a);
                        }, goog.Transpiler.prototype.transpile = function(a, b) {
                            return goog.transpile_(a, b, this.transpilationTarget_);
                        }, goog.transpiler_ = new goog.Transpiler, goog.protectScriptTag_ = function(a) {
                            return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
                        }, goog.DebugLoader_ = function() {
                            this.dependencies_ = {};
                            this.idToPath_ = {};
                            this.written_ = {};
                            this.loadingDeps_ = [];
                            this.depsToLoad_ = [];
                            this.paused_ = !1;
                            this.factory_ = new goog.DependencyFactory(goog.transpiler_);
                            this.deferredCallbacks_ = {};
                            this.deferredQueue_ = [];
                        }, goog.DebugLoader_.prototype.bootstrap = function(a, b) {
                            function c() {
                                d && (goog.global.setTimeout(d, 0), d = null);
                            }
                            var d = b;
                            if (a.length) {
                                b = [];
                                for(var e = 0; e < a.length; e++){
                                    var f = this.getPathFromDeps_(a[e]);
                                    if (!f) throw Error("Unregonized namespace: " + a[e]);
                                    b.push(this.dependencies_[f]);
                                }
                                f = goog.require;
                                var g = 0;
                                for(e = 0; e < a.length; e++)f(a[e]), b[e].onLoad(function() {
                                    ++g == a.length && c();
                                });
                            } else c();
                        }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
                            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, !1));
                            this.loadDeps_();
                        }, goog.DebugLoader_.prototype.requested = function(a, b) {
                            (a = this.getPathFromDeps_(a)) && (b || this.areDepsLoaded_(this.dependencies_[a].requires)) && (b = this.deferredCallbacks_[a]) && (delete this.deferredCallbacks_[a], b());
                        }, goog.DebugLoader_.prototype.setDependencyFactory = function(a) {
                            this.factory_ = a;
                        }, goog.DebugLoader_.prototype.load_ = function(a) {
                            if (this.getPathFromDeps_(a)) {
                                var b = this, c = [], d = function(e) {
                                    var f = b.getPathFromDeps_(e);
                                    if (!f) throw Error("Bad dependency path or symbol: " + e);
                                    if (!b.written_[f]) {
                                        b.written_[f] = !0;
                                        e = b.dependencies_[f];
                                        for(f = 0; f < e.requires.length; f++)goog.isProvided_(e.requires[f]) || d(e.requires[f]);
                                        c.push(e);
                                    }
                                };
                                d(a);
                                a = !!this.depsToLoad_.length;
                                this.depsToLoad_ = this.depsToLoad_.concat(c);
                                this.paused_ || a || this.loadDeps_();
                            } else throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
                        }, goog.DebugLoader_.prototype.loadDeps_ = function() {
                            for(var a = this, b = this.paused_; this.depsToLoad_.length && !b;)(function() {
                                var c = !1, d = a.depsToLoad_.shift(), e = !1;
                                a.loading_(d);
                                var f = {
                                    pause: function() {
                                        if (c) throw Error("Cannot call pause after the call to load.");
                                        b = !0;
                                    },
                                    resume: function() {
                                        c ? a.resume_() : b = !1;
                                    },
                                    loaded: function() {
                                        if (e) throw Error("Double call to loaded.");
                                        e = !0;
                                        a.loaded_(d);
                                    },
                                    pending: function() {
                                        for(var g = [], h = 0; h < a.loadingDeps_.length; h++)g.push(a.loadingDeps_[h]);
                                        return g;
                                    },
                                    setModuleState: function(g) {
                                        goog.moduleLoaderState_ = {
                                            type: g,
                                            moduleName: "",
                                            declareLegacyNamespace: !1
                                        };
                                    },
                                    registerEs6ModuleExports: function(g, h, k) {
                                        k && (goog.loadedModules_[k] = {
                                            exports: h,
                                            type: goog.ModuleType.ES6,
                                            moduleId: k || ""
                                        });
                                    },
                                    registerGoogModuleExports: function(g, h) {
                                        goog.loadedModules_[g] = {
                                            exports: h,
                                            type: goog.ModuleType.GOOG,
                                            moduleId: g
                                        };
                                    },
                                    clearModuleState: function() {
                                        goog.moduleLoaderState_ = null;
                                    },
                                    defer: function(g) {
                                        if (c) throw Error("Cannot register with defer after the call to load.");
                                        a.defer_(d, g);
                                    },
                                    areDepsLoaded: function() {
                                        return a.areDepsLoaded_(d.requires);
                                    }
                                };
                                try {
                                    d.load(f);
                                } finally{
                                    c = !0;
                                }
                            })();
                            b && this.pause_();
                        }, goog.DebugLoader_.prototype.pause_ = function() {
                            this.paused_ = !0;
                        }, goog.DebugLoader_.prototype.resume_ = function() {
                            this.paused_ && (this.paused_ = !1, this.loadDeps_());
                        }, goog.DebugLoader_.prototype.loading_ = function(a) {
                            this.loadingDeps_.push(a);
                        }, goog.DebugLoader_.prototype.loaded_ = function(a) {
                            for(var b = 0; b < this.loadingDeps_.length; b++)if (this.loadingDeps_[b] == a) {
                                this.loadingDeps_.splice(b, 1);
                                break;
                            }
                            for(b = 0; b < this.deferredQueue_.length; b++)if (this.deferredQueue_[b] == a.path) {
                                this.deferredQueue_.splice(b, 1);
                                break;
                            }
                            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for(; this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(), !0);
                            a.loaded();
                        }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a) {
                            for(var b = 0; b < a.length; b++){
                                var c = this.getPathFromDeps_(a[b]);
                                if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) return !1;
                            }
                            return !0;
                        }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a) {
                            return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
                        }, goog.DebugLoader_.prototype.defer_ = function(a, b) {
                            this.deferredCallbacks_[a.path] = b;
                            this.deferredQueue_.push(a.path);
                        }, goog.LoadController = function() {}, goog.LoadController.prototype.pause = function() {}, goog.LoadController.prototype.resume = function() {}, goog.LoadController.prototype.loaded = function() {}, goog.LoadController.prototype.pending = function() {}, goog.LoadController.prototype.registerEs6ModuleExports = function(a, b, c) {}, goog.LoadController.prototype.setModuleState = function(a) {}, goog.LoadController.prototype.clearModuleState = function() {}, goog.LoadController.prototype.defer = function(a) {}, goog.LoadController.prototype.areDepsLoaded = function() {}, goog.Dependency = function(a, b, c, d, e) {
                            this.path = a;
                            this.relativePath = b;
                            this.provides = c;
                            this.requires = d;
                            this.loadFlags = e;
                            this.loaded_ = !1;
                            this.loadCallbacks_ = [];
                        }, goog.Dependency.prototype.getPathName = function() {
                            var a = this.path, b = a.indexOf("://");
                            0 <= b && (a = a.substring(b + 3), b = a.indexOf("/"), 0 <= b && (a = a.substring(b + 1)));
                            return a;
                        }, goog.Dependency.prototype.onLoad = function(a) {
                            this.loaded_ ? a() : this.loadCallbacks_.push(a);
                        }, goog.Dependency.prototype.loaded = function() {
                            this.loaded_ = !0;
                            var a = this.loadCallbacks_;
                            this.loadCallbacks_ = [];
                            for(var b = 0; b < a.length; b++)a[b]();
                        }, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a) {
                            var b = Math.random().toString(32);
                            goog.Dependency.callbackMap_[b] = a;
                            return b;
                        }, goog.Dependency.unregisterCallback_ = function(a) {
                            delete goog.Dependency.callbackMap_[a];
                        }, goog.Dependency.callback_ = function(a, b) {
                            if (a in goog.Dependency.callbackMap_) {
                                for(var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++)d.push(arguments[e]);
                                c.apply(void 0, d);
                            } else throw Error("Callback key " + a + " does not exist (was base.js loaded more than once?).");
                        }, goog.Dependency.prototype.load = function(a) {
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var b = goog.global.document;
                                if ("complete" == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                                    if (/\bdeps.js$/.test(this.path)) {
                                        a.loaded();
                                        return;
                                    }
                                    throw Error('Cannot write "' + this.path + '" after document load');
                                }
                                var c = goog.getScriptNonce();
                                if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                                    var d = function(h) {
                                        h.readyState && "complete" != h.readyState ? h.onload = d : (goog.Dependency.unregisterCallback_(e), a.loaded());
                                    };
                                    var e = goog.Dependency.registerCallback_(d);
                                    c = c ? ' nonce="' + c + '"' : "";
                                    var f = '<script src="' + this.path + '"' + c + (goog.Dependency.defer_ ? " defer" : "") + ' id="script-' + e + '"></script>';
                                    f += "<script" + c + ">";
                                    f = goog.Dependency.defer_ ? f + ("document.getElementById('script-" + e + "').onload = function() {\n  goog.Dependency.callback_('" + e + "', this);\n};\n") : f + ("goog.Dependency.callback_('" + e + "', document.getElementById('script-" + e + "'));");
                                    f += "</script>";
                                    b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f) : f);
                                } else {
                                    var g = b.createElement("script");
                                    g.defer = goog.Dependency.defer_;
                                    g.async = !1;
                                    c && (g.nonce = c);
                                    goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), g.onreadystatechange = function() {
                                        if ("loaded" == g.readyState || "complete" == g.readyState) a.loaded(), a.resume();
                                    }) : g.onload = function() {
                                        g.onload = null;
                                        a.loaded();
                                    };
                                    g.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
                                    b.head.appendChild(g);
                                }
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a.loaded()) : a.pause();
                        }, goog.Es6ModuleDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a) {
                            function b(l, p) {
                                var m = "", n = goog.getScriptNonce();
                                n && (m = ' nonce="' + n + '"');
                                l = p ? '<script type="module" crossorigin' + m + ">" + p + "</script>" : '<script type="module" crossorigin src="' + l + '"' + m + "></script>";
                                d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(l) : l);
                            }
                            function c(l, p) {
                                var m = d.createElement("script");
                                m.defer = !0;
                                m.async = !1;
                                m.type = "module";
                                m.setAttribute("crossorigin", !0);
                                var n = goog.getScriptNonce();
                                n && (m.nonce = n);
                                p ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(p) : p : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l) : l;
                                d.head.appendChild(m);
                            }
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var d = goog.global.document, e = this;
                                if (goog.isDocumentLoading_()) {
                                    var f = b;
                                    goog.Dependency.defer_ = !0;
                                } else f = c;
                                var g = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(g);
                                    a.setModuleState(goog.ModuleType.ES6);
                                });
                                f(void 0, 'goog.Dependency.callback_("' + g + '")');
                                f(this.path, void 0);
                                var h = goog.Dependency.registerCallback_(function(l) {
                                    goog.Dependency.unregisterCallback_(h);
                                    a.registerEs6ModuleExports(e.path, l, goog.moduleLoaderState_.moduleName);
                                });
                                f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
                                var k = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(k);
                                    a.clearModuleState();
                                    a.loaded();
                                });
                                f(void 0, 'goog.Dependency.callback_("' + k + '")');
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a.pause();
                        }, goog.TransformedDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                            this.contents_ = null;
                            this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
                        }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a) {
                            function b() {
                                e.contents_ = goog.loadFileSync_(e.path);
                                e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
                            }
                            function c() {
                                e.lazyFetch_ && b();
                                if (e.contents_) {
                                    f && a.setModuleState(goog.ModuleType.ES6);
                                    try {
                                        var p = e.contents_;
                                        e.contents_ = null;
                                        goog.globalEval(p);
                                        if (f) var m = goog.moduleLoaderState_.moduleName;
                                    } finally{
                                        f && a.clearModuleState();
                                    }
                                    f && goog.global.$jscomp.require.ensure([
                                        e.getPathName()
                                    ], function() {
                                        a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), m);
                                    });
                                    a.loaded();
                                }
                            }
                            function d() {
                                var p = goog.global.document, m = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(m);
                                    c();
                                }), n = goog.getScriptNonce();
                                n = "<script" + (n ? ' nonce="' + n + '"' : "") + ">" + goog.protectScriptTag_('goog.Dependency.callback_("' + m + '");') + "</script>";
                                p.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n) : n);
                            }
                            var e = this;
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
                            else {
                                var f = this.loadFlags.module == goog.ModuleType.ES6;
                                this.lazyFetch_ || b();
                                var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
                                g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
                                if (h || g) a.defer(function() {
                                    c();
                                });
                                else {
                                    var k = goog.global.document;
                                    h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global;
                                    if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                                        goog.Dependency.defer_ = !0;
                                        a.pause();
                                        var l = k.onreadystatechange;
                                        k.onreadystatechange = function() {
                                            "interactive" == k.readyState && (k.onreadystatechange = l, c(), a.resume());
                                            "function" === typeof l && l.apply(void 0, arguments);
                                        };
                                    } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
                                }
                            }
                        }, goog.TransformedDependency.prototype.transform = function(a) {}, goog.TranspiledDependency = function(a, b, c, d, e, f) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.transpiler = f;
                        }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a) {
                            return this.transpiler.transpile(a, this.getPathName());
                        }, goog.PreTranspiledEs6ModuleDependency = function(a, b, c, d, e) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a) {
                            return a;
                        }, goog.GoogModuleDependency = function(a, b, c, d, e, f, g) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.needsTranspile_ = f;
                            this.transpiler_ = g;
                        }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a) {
                            this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
                            return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? "goog.loadModule(" + goog.global.JSON.stringify(a + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
                        }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a, b, c, d) {
                            b = b || [];
                            a = a.replace(/\\/g, "/");
                            var e = goog.normalizePath_(goog.basePath + a);
                            d && "boolean" !== typeof d || (d = d ? {
                                module: goog.ModuleType.GOOG
                            } : {});
                            c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || "es3", d.module));
                            this.dependencies_[e] = c;
                            for(c = 0; c < b.length; c++)this.idToPath_[b[c]] = e;
                            this.idToPath_[a] = e;
                        }, goog.DependencyFactory = function(a) {
                            this.transpiler = a;
                        }, goog.DependencyFactory.prototype.createDependency = function(a, b, c, d, e, f) {
                            return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? "never" == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
                        }, goog.debugLoader_ = new goog.DebugLoader_, goog.loadClosureDeps = function() {
                            goog.debugLoader_.loadClosureDeps();
                        }, goog.setDependencyFactory = function(a) {
                            goog.debugLoader_.setDependencyFactory(a);
                        }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a, b) {
                            goog.debugLoader_.bootstrap(a, b);
                        });
                        goog.TRUSTED_TYPES_POLICY_NAME = "goog";
                        goog.identity_ = function(a) {
                            return a;
                        };
                        goog.createTrustedTypesPolicy = function(a) {
                            var b = null, c = goog.global.trustedTypes;
                            if (!c || !c.createPolicy) return b;
                            try {
                                b = c.createPolicy(a, {
                                    createHTML: goog.identity_,
                                    createScript: goog.identity_,
                                    createScriptURL: goog.identity_
                                });
                            } catch (d) {
                                goog.logToConsole_(d.message);
                            }
                            return b;
                        };
                        goog.debug = {};
                        function module$contents$goog$debug$Error_DebugError(a) {
                            if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
                            else {
                                var b = Error().stack;
                                b && (this.stack = b);
                            }
                            a && (this.message = String(a));
                            this.reportErrorToServer = !0;
                        }
                        goog.inherits(module$contents$goog$debug$Error_DebugError, Error);
                        module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError";
                        goog.debug.Error = module$contents$goog$debug$Error_DebugError;
                        goog.dom = {};
                        goog.dom.NodeType = {
                            ELEMENT: 1,
                            ATTRIBUTE: 2,
                            TEXT: 3,
                            CDATA_SECTION: 4,
                            ENTITY_REFERENCE: 5,
                            ENTITY: 6,
                            PROCESSING_INSTRUCTION: 7,
                            COMMENT: 8,
                            DOCUMENT: 9,
                            DOCUMENT_TYPE: 10,
                            DOCUMENT_FRAGMENT: 11,
                            NOTATION: 12
                        };
                        goog.asserts = {};
                        goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
                        goog.asserts.AssertionError = function(a, b) {
                            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(a, b));
                            this.messagePattern = a;
                        };
                        goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError);
                        goog.asserts.AssertionError.prototype.name = "AssertionError";
                        goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
                            throw a;
                        };
                        goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
                        goog.asserts.subs_ = function(a, b) {
                            a = a.split("%s");
                            for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
                            return c + a[d];
                        };
                        goog.asserts.doAssertFailure_ = function(a, b, c, d) {
                            var e = "Assertion failed";
                            if (c) {
                                e += ": " + c;
                                var f = d;
                            } else a && (e += ": " + a, f = b);
                            a = new goog.asserts.AssertionError("" + e, f || []);
                            goog.asserts.errorHandler_(a);
                        };
                        goog.asserts.setErrorHandler = function(a) {
                            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
                        };
                        goog.asserts.assert = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertExists = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.fail = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
                        };
                        goog.asserts.assertNumber = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "number" !== typeof a && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertString = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "string" !== typeof a && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertFunction = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "function" !== typeof a && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObject = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertArray = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !Array.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertBoolean = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "boolean" !== typeof a && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertElement = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertInstanceof = function(a, b, c, d) {
                            !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [
                                goog.asserts.getType_(b),
                                goog.asserts.getType_(a)
                            ], c, Array.prototype.slice.call(arguments, 3));
                            return a;
                        };
                        goog.asserts.assertFinite = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObjectPrototypeIsIntact = function() {
                            for(var a in Object.prototype)goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
                        };
                        goog.asserts.getType_ = function(a) {
                            return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
                        };
                        goog.array = {};
                        goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
                        var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
                        goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
                        function module$contents$goog$array_peek(a) {
                            return a[a.length - 1];
                        }
                        goog.array.peek = module$contents$goog$array_peek;
                        goog.array.last = module$contents$goog$array_peek;
                        var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.indexOf.call(a, b, c);
                        } : function(a, b, c) {
                            c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, c);
                            for(; c < a.length; c++)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.indexOf = module$contents$goog$array_indexOf;
                        var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
                        } : function(a, b, c) {
                            c = null == c ? a.length - 1 : c;
                            0 > c && (c = Math.max(0, a.length + c));
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.lastIndexOf(b, c);
                            for(; 0 <= c; c--)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
                        var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            Array.prototype.forEach.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
                        };
                        goog.array.forEach = module$contents$goog$array_forEach;
                        function module$contents$goog$array_forEachRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; --d)d in e && b.call(c, e[d], d, a);
                        }
                        goog.array.forEachRight = module$contents$goog$array_forEachRight;
                        var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.filter.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = [], f = 0, g = "string" === typeof a ? a.split("") : a, h = 0; h < d; h++)if (h in g) {
                                var k = g[h];
                                b.call(c, k, h, a) && (e[f++] = k);
                            }
                            return e;
                        };
                        goog.array.filter = module$contents$goog$array_filter;
                        var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.map.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = Array(d), f = "string" === typeof a ? a.split("") : a, g = 0; g < d; g++)g in f && (e[g] = b.call(c, f[g], g, a));
                            return e;
                        };
                        goog.array.map = module$contents$goog$array_map;
                        var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduce.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEach(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduce = module$contents$goog$array_reduce;
                        var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            goog.asserts.assert(null != b);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduceRight.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEachRight(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduceRight = module$contents$goog$array_reduceRight;
                        var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.some.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return !0;
                            return !1;
                        };
                        goog.array.some = module$contents$goog$array_some;
                        var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.every.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && !b.call(c, e[f], f, a)) return !1;
                            return !0;
                        };
                        goog.array.every = module$contents$goog$array_every;
                        function module$contents$goog$array_count(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEach(a, function(e, f, g) {
                                b.call(c, e, f, g) && ++d;
                            }, c);
                            return d;
                        }
                        goog.array.count = module$contents$goog$array_count;
                        function module$contents$goog$array_find(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.find = module$contents$goog$array_find;
                        function module$contents$goog$array_findIndex(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return f;
                            return -1;
                        }
                        goog.array.findIndex = module$contents$goog$array_findIndex;
                        function module$contents$goog$array_findRight(a, b, c) {
                            b = module$contents$goog$array_findIndexRight(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.findRight = module$contents$goog$array_findRight;
                        function module$contents$goog$array_findIndexRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; d--)if (d in e && b.call(c, e[d], d, a)) return d;
                            return -1;
                        }
                        goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
                        function module$contents$goog$array_contains(a, b) {
                            return 0 <= module$contents$goog$array_indexOf(a, b);
                        }
                        goog.array.contains = module$contents$goog$array_contains;
                        function module$contents$goog$array_isEmpty(a) {
                            return 0 == a.length;
                        }
                        goog.array.isEmpty = module$contents$goog$array_isEmpty;
                        function module$contents$goog$array_clear(a) {
                            if (!Array.isArray(a)) for(var b = a.length - 1; 0 <= b; b--)delete a[b];
                            a.length = 0;
                        }
                        goog.array.clear = module$contents$goog$array_clear;
                        function module$contents$goog$array_insert(a, b) {
                            module$contents$goog$array_contains(a, b) || a.push(b);
                        }
                        goog.array.insert = module$contents$goog$array_insert;
                        function module$contents$goog$array_insertAt(a, b, c) {
                            module$contents$goog$array_splice(a, c, 0, b);
                        }
                        goog.array.insertAt = module$contents$goog$array_insertAt;
                        function module$contents$goog$array_insertArrayAt(a, b, c) {
                            goog.partial(module$contents$goog$array_splice, a, c, 0).apply(null, b);
                        }
                        goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
                        function module$contents$goog$array_insertBefore(a, b, c) {
                            var d;
                            2 == arguments.length || 0 > (d = module$contents$goog$array_indexOf(a, c)) ? a.push(b) : module$contents$goog$array_insertAt(a, b, d);
                        }
                        goog.array.insertBefore = module$contents$goog$array_insertBefore;
                        function module$contents$goog$array_remove(a, b) {
                            b = module$contents$goog$array_indexOf(a, b);
                            var c;
                            (c = 0 <= b) && module$contents$goog$array_removeAt(a, b);
                            return c;
                        }
                        goog.array.remove = module$contents$goog$array_remove;
                        function module$contents$goog$array_removeLast(a, b) {
                            b = module$contents$goog$array_lastIndexOf(a, b);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeLast = module$contents$goog$array_removeLast;
                        function module$contents$goog$array_removeAt(a, b) {
                            goog.asserts.assert(null != a.length);
                            return 1 == Array.prototype.splice.call(a, b, 1).length;
                        }
                        goog.array.removeAt = module$contents$goog$array_removeAt;
                        function module$contents$goog$array_removeIf(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeIf = module$contents$goog$array_removeIf;
                        function module$contents$goog$array_removeAllIf(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEachRight(a, function(e, f) {
                                b.call(c, e, f, a) && module$contents$goog$array_removeAt(a, f) && d++;
                            });
                            return d;
                        }
                        goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
                        function module$contents$goog$array_concat(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.concat = module$contents$goog$array_concat;
                        function module$contents$goog$array_join(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.join = module$contents$goog$array_join;
                        function module$contents$goog$array_toArray(a) {
                            var b = a.length;
                            if (0 < b) {
                                for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
                                return c;
                            }
                            return [];
                        }
                        var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
                        goog.array.clone = module$contents$goog$array_clone;
                        function module$contents$goog$array_extend(a, b) {
                            for(var c = 1; c < arguments.length; c++){
                                var d = arguments[c];
                                if (goog.isArrayLike(d)) {
                                    var e = a.length || 0, f = d.length || 0;
                                    a.length = e + f;
                                    for(var g = 0; g < f; g++)a[e + g] = d[g];
                                } else a.push(d);
                            }
                        }
                        goog.array.extend = module$contents$goog$array_extend;
                        function module$contents$goog$array_splice(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.splice.apply(a, module$contents$goog$array_slice(arguments, 1));
                        }
                        goog.array.splice = module$contents$goog$array_splice;
                        function module$contents$goog$array_slice(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
                        }
                        goog.array.slice = module$contents$goog$array_slice;
                        function module$contents$goog$array_removeDuplicates(a, b, c) {
                            b = b || a;
                            var d = function(k) {
                                return goog.isObject(k) ? "o" + goog.getUid(k) : (typeof k).charAt(0) + k;
                            };
                            c = c || d;
                            d = {};
                            for(var e = 0, f = 0; f < a.length;){
                                var g = a[f++], h = c(g);
                                Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
                            }
                            b.length = e;
                        }
                        goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
                        function module$contents$goog$array_binarySearch(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, c || module$contents$goog$array_defaultCompare, !1, b);
                        }
                        goog.array.binarySearch = module$contents$goog$array_binarySearch;
                        function module$contents$goog$array_binarySelect(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, b, !0, void 0, c);
                        }
                        goog.array.binarySelect = module$contents$goog$array_binarySelect;
                        function module$contents$goog$array_binarySearch_(a, b, c, d, e) {
                            for(var f = 0, g = a.length, h; f < g;){
                                var k = f + (g - f >>> 1);
                                var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
                                0 < l ? f = k + 1 : (g = k, h = !l);
                            }
                            return h ? f : -f - 1;
                        }
                        function module$contents$goog$array_sort(a, b) {
                            a.sort(b || module$contents$goog$array_defaultCompare);
                        }
                        goog.array.sort = module$contents$goog$array_sort;
                        function module$contents$goog$array_stableSort(a, b) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = {
                                index: d,
                                value: a[d]
                            };
                            var e = b || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(c, function(f, g) {
                                return e(f.value, g.value) || f.index - g.index;
                            });
                            for(d = 0; d < a.length; d++)a[d] = c[d].value;
                        }
                        goog.array.stableSort = module$contents$goog$array_stableSort;
                        function module$contents$goog$array_sortByKey(a, b, c) {
                            var d = c || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(a, function(e, f) {
                                return d(b(e), b(f));
                            });
                        }
                        goog.array.sortByKey = module$contents$goog$array_sortByKey;
                        function module$contents$goog$array_sortObjectsByKey(a, b, c) {
                            module$contents$goog$array_sortByKey(a, function(d) {
                                return d[b];
                            }, c);
                        }
                        goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
                        function module$contents$goog$array_isSorted(a, b, c) {
                            b = b || module$contents$goog$array_defaultCompare;
                            for(var d = 1; d < a.length; d++){
                                var e = b(a[d - 1], a[d]);
                                if (0 < e || 0 == e && c) return !1;
                            }
                            return !0;
                        }
                        goog.array.isSorted = module$contents$goog$array_isSorted;
                        function module$contents$goog$array_equals(a, b, c) {
                            if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) return !1;
                            var d = a.length;
                            c = c || module$contents$goog$array_defaultCompareEquality;
                            for(var e = 0; e < d; e++)if (!c(a[e], b[e])) return !1;
                            return !0;
                        }
                        goog.array.equals = module$contents$goog$array_equals;
                        function module$contents$goog$array_compare3(a, b, c) {
                            c = c || module$contents$goog$array_defaultCompare;
                            for(var d = Math.min(a.length, b.length), e = 0; e < d; e++){
                                var f = c(a[e], b[e]);
                                if (0 != f) return f;
                            }
                            return module$contents$goog$array_defaultCompare(a.length, b.length);
                        }
                        goog.array.compare3 = module$contents$goog$array_compare3;
                        function module$contents$goog$array_defaultCompare(a, b) {
                            return a > b ? 1 : a < b ? -1 : 0;
                        }
                        goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
                        function module$contents$goog$array_inverseDefaultCompare(a, b) {
                            return -module$contents$goog$array_defaultCompare(a, b);
                        }
                        goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
                        function module$contents$goog$array_defaultCompareEquality(a, b) {
                            return a === b;
                        }
                        goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
                        function module$contents$goog$array_binaryInsert(a, b, c) {
                            c = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 > c ? (module$contents$goog$array_insertAt(a, b, -(c + 1)), !0) : !1;
                        }
                        goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
                        function module$contents$goog$array_binaryRemove(a, b, c) {
                            b = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 <= b ? module$contents$goog$array_removeAt(a, b) : !1;
                        }
                        goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
                        function module$contents$goog$array_bucket(a, b, c) {
                            for(var d = {}, e = 0; e < a.length; e++){
                                var f = a[e], g = b.call(c, f, e, a);
                                void 0 !== g && (d[g] || (d[g] = [])).push(f);
                            }
                            return d;
                        }
                        goog.array.bucket = module$contents$goog$array_bucket;
                        function module$contents$goog$array_toObject(a, b, c) {
                            var d = {};
                            module$contents$goog$array_forEach(a, function(e, f) {
                                d[b.call(c, e, f, a)] = e;
                            });
                            return d;
                        }
                        goog.array.toObject = module$contents$goog$array_toObject;
                        function module$contents$goog$array_range(a, b, c) {
                            var d = [], e = 0, f = a;
                            c = c || 1;
                            void 0 !== b && (e = a, f = b);
                            if (0 > c * (f - e)) return [];
                            if (0 < c) for(a = e; a < f; a += c)d.push(a);
                            else for(a = e; a > f; a += c)d.push(a);
                            return d;
                        }
                        goog.array.range = module$contents$goog$array_range;
                        function module$contents$goog$array_repeat(a, b) {
                            for(var c = [], d = 0; d < b; d++)c[d] = a;
                            return c;
                        }
                        goog.array.repeat = module$contents$goog$array_repeat;
                        function module$contents$goog$array_flatten(a) {
                            for(var b = [], c = 0; c < arguments.length; c++){
                                var d = arguments[c];
                                if (Array.isArray(d)) for(var e = 0; e < d.length; e += 8192){
                                    var f = module$contents$goog$array_slice(d, e, e + 8192);
                                    f = module$contents$goog$array_flatten.apply(null, f);
                                    for(var g = 0; g < f.length; g++)b.push(f[g]);
                                }
                                else b.push(d);
                            }
                            return b;
                        }
                        goog.array.flatten = module$contents$goog$array_flatten;
                        function module$contents$goog$array_rotate(a, b) {
                            goog.asserts.assert(null != a.length);
                            a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
                            return a;
                        }
                        goog.array.rotate = module$contents$goog$array_rotate;
                        function module$contents$goog$array_moveItem(a, b, c) {
                            goog.asserts.assert(0 <= b && b < a.length);
                            goog.asserts.assert(0 <= c && c < a.length);
                            b = Array.prototype.splice.call(a, b, 1);
                            Array.prototype.splice.call(a, c, 0, b[0]);
                        }
                        goog.array.moveItem = module$contents$goog$array_moveItem;
                        function module$contents$goog$array_zip(a) {
                            if (!arguments.length) return [];
                            for(var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)arguments[d].length < c && (c = arguments[d].length);
                            for(d = 0; d < c; d++){
                                for(var e = [], f = 0; f < arguments.length; f++)e.push(arguments[f][d]);
                                b.push(e);
                            }
                            return b;
                        }
                        goog.array.zip = module$contents$goog$array_zip;
                        function module$contents$goog$array_shuffle(a, b) {
                            b = b || Math.random;
                            for(var c = a.length - 1; 0 < c; c--){
                                var d = Math.floor(b() * (c + 1)), e = a[c];
                                a[c] = a[d];
                                a[d] = e;
                            }
                        }
                        goog.array.shuffle = module$contents$goog$array_shuffle;
                        function module$contents$goog$array_copyByIndex(a, b) {
                            var c = [];
                            module$contents$goog$array_forEach(b, function(d) {
                                c.push(a[d]);
                            });
                            return c;
                        }
                        goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
                        function module$contents$goog$array_concatMap(a, b, c) {
                            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a, b, c));
                        }
                        goog.array.concatMap = module$contents$goog$array_concatMap;
                        goog.dom.asserts = {};
                        goog.dom.asserts.assertIsLocation = function(a) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var b = goog.dom.asserts.getWindow_(a);
                                b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsElementType_ = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var c = goog.dom.asserts.getWindow_(a);
                                c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsHTMLAnchorElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
                        };
                        goog.dom.asserts.assertIsHTMLButtonElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
                        };
                        goog.dom.asserts.assertIsHTMLLinkElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
                        };
                        goog.dom.asserts.assertIsHTMLImageElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
                        };
                        goog.dom.asserts.assertIsHTMLAudioElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
                        };
                        goog.dom.asserts.assertIsHTMLVideoElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
                        };
                        goog.dom.asserts.assertIsHTMLInputElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
                        };
                        goog.dom.asserts.assertIsHTMLTextAreaElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
                        };
                        goog.dom.asserts.assertIsHTMLCanvasElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
                        };
                        goog.dom.asserts.assertIsHTMLEmbedElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
                        };
                        goog.dom.asserts.assertIsHTMLFormElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
                        };
                        goog.dom.asserts.assertIsHTMLFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLIFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLObjectElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
                        };
                        goog.dom.asserts.assertIsHTMLScriptElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
                        };
                        goog.dom.asserts.debugStringForType_ = function(a) {
                            if (goog.isObject(a)) try {
                                return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
                            } catch (b) {
                                return "<object could not be stringified>";
                            }
                            else return void 0 === a ? "undefined" : null === a ? "null" : typeof a;
                        };
                        goog.dom.asserts.getWindow_ = function(a) {
                            try {
                                var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
                                c = c || goog.global;
                                if (c.Element && c.Location) return c;
                            } catch (d) {}
                            return null;
                        };
                        goog.dom.HtmlElement = function() {};
                        goog.functions = {};
                        goog.functions.constant = function(a) {
                            return function() {
                                return a;
                            };
                        };
                        goog.functions.FALSE = function() {
                            return !1;
                        };
                        goog.functions.TRUE = function() {
                            return !0;
                        };
                        goog.functions.NULL = function() {
                            return null;
                        };
                        goog.functions.identity = function(a, b) {
                            return a;
                        };
                        goog.functions.error = function(a) {
                            return function() {
                                throw Error(a);
                            };
                        };
                        goog.functions.fail = function(a) {
                            return function() {
                                throw a;
                            };
                        };
                        goog.functions.lock = function(a, b) {
                            b = b || 0;
                            return function() {
                                return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
                            };
                        };
                        goog.functions.nth = function(a) {
                            return function() {
                                return arguments[a];
                            };
                        };
                        goog.functions.partialRight = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = this;
                                d === goog.global && (d = void 0);
                                var e = Array.prototype.slice.call(arguments);
                                e.push.apply(e, c);
                                return a.apply(d, e);
                            };
                        };
                        goog.functions.withReturnValue = function(a, b) {
                            return goog.functions.sequence(a, goog.functions.constant(b));
                        };
                        goog.functions.equalTo = function(a, b) {
                            return function(c) {
                                return b ? a == c : a === c;
                            };
                        };
                        goog.functions.compose = function(a, b) {
                            var c = arguments, d = c.length;
                            return function() {
                                var e;
                                d && (e = c[d - 1].apply(this, arguments));
                                for(var f = d - 2; 0 <= f; f--)e = c[f].call(this, e);
                                return e;
                            };
                        };
                        goog.functions.sequence = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d, e = 0; e < c; e++)d = b[e].apply(this, arguments);
                                return d;
                            };
                        };
                        goog.functions.and = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (!b[d].apply(this, arguments)) return !1;
                                return !0;
                            };
                        };
                        goog.functions.or = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (b[d].apply(this, arguments)) return !0;
                                return !1;
                            };
                        };
                        goog.functions.not = function(a) {
                            return function() {
                                return !a.apply(this, arguments);
                            };
                        };
                        goog.functions.create = function(a, b) {
                            var c = function() {};
                            c.prototype = a.prototype;
                            c = new c;
                            a.apply(c, Array.prototype.slice.call(arguments, 1));
                            return c;
                        };
                        goog.functions.CACHE_RETURN_VALUE = !0;
                        goog.functions.cacheReturnValue = function(a) {
                            var b = !1, c;
                            return function() {
                                if (!goog.functions.CACHE_RETURN_VALUE) return a();
                                b || (c = a(), b = !0);
                                return c;
                            };
                        };
                        goog.functions.once = function(a) {
                            var b = a;
                            return function() {
                                if (b) {
                                    var c = b;
                                    b = null;
                                    c();
                                }
                            };
                        };
                        goog.functions.debounce = function(a, b, c) {
                            var d = 0;
                            return function(e) {
                                goog.global.clearTimeout(d);
                                var f = arguments;
                                d = goog.global.setTimeout(function() {
                                    a.apply(c, f);
                                }, b);
                            };
                        };
                        goog.functions.throttle = function(a, b, c) {
                            var d = 0, e = !1, f = [], g = function() {
                                d = 0;
                                e && (e = !1, h());
                            }, h = function() {
                                d = goog.global.setTimeout(g, b);
                                a.apply(c, f);
                            };
                            return function(k) {
                                f = arguments;
                                d ? e = !0 : h();
                            };
                        };
                        goog.functions.rateLimit = function(a, b, c) {
                            var d = 0, e = function() {
                                d = 0;
                            };
                            return function(f) {
                                d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
                            };
                        };
                        goog.functions.isFunction = function(a) {
                            return "function" === typeof a;
                        };
                        goog.dom.TagName = function() {};
                        goog.dom.TagName.cast = function(a, b) {
                            return a;
                        };
                        goog.dom.TagName.prototype.toString = function() {};
                        goog.dom.TagName.A = "A";
                        goog.dom.TagName.ABBR = "ABBR";
                        goog.dom.TagName.ACRONYM = "ACRONYM";
                        goog.dom.TagName.ADDRESS = "ADDRESS";
                        goog.dom.TagName.APPLET = "APPLET";
                        goog.dom.TagName.AREA = "AREA";
                        goog.dom.TagName.ARTICLE = "ARTICLE";
                        goog.dom.TagName.ASIDE = "ASIDE";
                        goog.dom.TagName.AUDIO = "AUDIO";
                        goog.dom.TagName.B = "B";
                        goog.dom.TagName.BASE = "BASE";
                        goog.dom.TagName.BASEFONT = "BASEFONT";
                        goog.dom.TagName.BDI = "BDI";
                        goog.dom.TagName.BDO = "BDO";
                        goog.dom.TagName.BIG = "BIG";
                        goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE";
                        goog.dom.TagName.BODY = "BODY";
                        goog.dom.TagName.BR = "BR";
                        goog.dom.TagName.BUTTON = "BUTTON";
                        goog.dom.TagName.CANVAS = "CANVAS";
                        goog.dom.TagName.CAPTION = "CAPTION";
                        goog.dom.TagName.CENTER = "CENTER";
                        goog.dom.TagName.CITE = "CITE";
                        goog.dom.TagName.CODE = "CODE";
                        goog.dom.TagName.COL = "COL";
                        goog.dom.TagName.COLGROUP = "COLGROUP";
                        goog.dom.TagName.COMMAND = "COMMAND";
                        goog.dom.TagName.DATA = "DATA";
                        goog.dom.TagName.DATALIST = "DATALIST";
                        goog.dom.TagName.DD = "DD";
                        goog.dom.TagName.DEL = "DEL";
                        goog.dom.TagName.DETAILS = "DETAILS";
                        goog.dom.TagName.DFN = "DFN";
                        goog.dom.TagName.DIALOG = "DIALOG";
                        goog.dom.TagName.DIR = "DIR";
                        goog.dom.TagName.DIV = "DIV";
                        goog.dom.TagName.DL = "DL";
                        goog.dom.TagName.DT = "DT";
                        goog.dom.TagName.EM = "EM";
                        goog.dom.TagName.EMBED = "EMBED";
                        goog.dom.TagName.FIELDSET = "FIELDSET";
                        goog.dom.TagName.FIGCAPTION = "FIGCAPTION";
                        goog.dom.TagName.FIGURE = "FIGURE";
                        goog.dom.TagName.FONT = "FONT";
                        goog.dom.TagName.FOOTER = "FOOTER";
                        goog.dom.TagName.FORM = "FORM";
                        goog.dom.TagName.FRAME = "FRAME";
                        goog.dom.TagName.FRAMESET = "FRAMESET";
                        goog.dom.TagName.H1 = "H1";
                        goog.dom.TagName.H2 = "H2";
                        goog.dom.TagName.H3 = "H3";
                        goog.dom.TagName.H4 = "H4";
                        goog.dom.TagName.H5 = "H5";
                        goog.dom.TagName.H6 = "H6";
                        goog.dom.TagName.HEAD = "HEAD";
                        goog.dom.TagName.HEADER = "HEADER";
                        goog.dom.TagName.HGROUP = "HGROUP";
                        goog.dom.TagName.HR = "HR";
                        goog.dom.TagName.HTML = "HTML";
                        goog.dom.TagName.I = "I";
                        goog.dom.TagName.IFRAME = "IFRAME";
                        goog.dom.TagName.IMG = "IMG";
                        goog.dom.TagName.INPUT = "INPUT";
                        goog.dom.TagName.INS = "INS";
                        goog.dom.TagName.ISINDEX = "ISINDEX";
                        goog.dom.TagName.KBD = "KBD";
                        goog.dom.TagName.KEYGEN = "KEYGEN";
                        goog.dom.TagName.LABEL = "LABEL";
                        goog.dom.TagName.LEGEND = "LEGEND";
                        goog.dom.TagName.LI = "LI";
                        goog.dom.TagName.LINK = "LINK";
                        goog.dom.TagName.MAIN = "MAIN";
                        goog.dom.TagName.MAP = "MAP";
                        goog.dom.TagName.MARK = "MARK";
                        goog.dom.TagName.MATH = "MATH";
                        goog.dom.TagName.MENU = "MENU";
                        goog.dom.TagName.MENUITEM = "MENUITEM";
                        goog.dom.TagName.META = "META";
                        goog.dom.TagName.METER = "METER";
                        goog.dom.TagName.NAV = "NAV";
                        goog.dom.TagName.NOFRAMES = "NOFRAMES";
                        goog.dom.TagName.NOSCRIPT = "NOSCRIPT";
                        goog.dom.TagName.OBJECT = "OBJECT";
                        goog.dom.TagName.OL = "OL";
                        goog.dom.TagName.OPTGROUP = "OPTGROUP";
                        goog.dom.TagName.OPTION = "OPTION";
                        goog.dom.TagName.OUTPUT = "OUTPUT";
                        goog.dom.TagName.P = "P";
                        goog.dom.TagName.PARAM = "PARAM";
                        goog.dom.TagName.PICTURE = "PICTURE";
                        goog.dom.TagName.PRE = "PRE";
                        goog.dom.TagName.PROGRESS = "PROGRESS";
                        goog.dom.TagName.Q = "Q";
                        goog.dom.TagName.RP = "RP";
                        goog.dom.TagName.RT = "RT";
                        goog.dom.TagName.RTC = "RTC";
                        goog.dom.TagName.RUBY = "RUBY";
                        goog.dom.TagName.S = "S";
                        goog.dom.TagName.SAMP = "SAMP";
                        goog.dom.TagName.SCRIPT = "SCRIPT";
                        goog.dom.TagName.SECTION = "SECTION";
                        goog.dom.TagName.SELECT = "SELECT";
                        goog.dom.TagName.SMALL = "SMALL";
                        goog.dom.TagName.SOURCE = "SOURCE";
                        goog.dom.TagName.SPAN = "SPAN";
                        goog.dom.TagName.STRIKE = "STRIKE";
                        goog.dom.TagName.STRONG = "STRONG";
                        goog.dom.TagName.STYLE = "STYLE";
                        goog.dom.TagName.SUB = "SUB";
                        goog.dom.TagName.SUMMARY = "SUMMARY";
                        goog.dom.TagName.SUP = "SUP";
                        goog.dom.TagName.SVG = "SVG";
                        goog.dom.TagName.TABLE = "TABLE";
                        goog.dom.TagName.TBODY = "TBODY";
                        goog.dom.TagName.TD = "TD";
                        goog.dom.TagName.TEMPLATE = "TEMPLATE";
                        goog.dom.TagName.TEXTAREA = "TEXTAREA";
                        goog.dom.TagName.TFOOT = "TFOOT";
                        goog.dom.TagName.TH = "TH";
                        goog.dom.TagName.THEAD = "THEAD";
                        goog.dom.TagName.TIME = "TIME";
                        goog.dom.TagName.TITLE = "TITLE";
                        goog.dom.TagName.TR = "TR";
                        goog.dom.TagName.TRACK = "TRACK";
                        goog.dom.TagName.TT = "TT";
                        goog.dom.TagName.U = "U";
                        goog.dom.TagName.UL = "UL";
                        goog.dom.TagName.VAR = "VAR";
                        goog.dom.TagName.VIDEO = "VIDEO";
                        goog.dom.TagName.WBR = "WBR";
                        goog.object = {};
                        goog.object.forEach = function(a, b, c) {
                            for(var d in a)b.call(c, a[d], d, a);
                        };
                        goog.object.filter = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)b.call(c, a[e], e, a) && (d[e] = a[e]);
                            return d;
                        };
                        goog.object.map = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)d[e] = b.call(c, a[e], e, a);
                            return d;
                        };
                        goog.object.some = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return !0;
                            return !1;
                        };
                        goog.object.every = function(a, b, c) {
                            for(var d in a)if (!b.call(c, a[d], d, a)) return !1;
                            return !0;
                        };
                        goog.object.getCount = function(a) {
                            var b = 0, c;
                            for(c in a)b++;
                            return b;
                        };
                        goog.object.getAnyKey = function(a) {
                            for(var b in a)return b;
                        };
                        goog.object.getAnyValue = function(a) {
                            for(var b in a)return a[b];
                        };
                        goog.object.contains = function(a, b) {
                            return goog.object.containsValue(a, b);
                        };
                        goog.object.getValues = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = a[d];
                            return b;
                        };
                        goog.object.getKeys = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = d;
                            return b;
                        };
                        goog.object.getValueByKeys = function(a, b) {
                            var c = goog.isArrayLike(b), d = c ? b : arguments;
                            for(c = c ? 0 : 1; c < d.length; c++){
                                if (null == a) return;
                                a = a[d[c]];
                            }
                            return a;
                        };
                        goog.object.containsKey = function(a, b) {
                            return null !== a && b in a;
                        };
                        goog.object.containsValue = function(a, b) {
                            for(var c in a)if (a[c] == b) return !0;
                            return !1;
                        };
                        goog.object.findKey = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return d;
                        };
                        goog.object.findValue = function(a, b, c) {
                            return (b = goog.object.findKey(a, b, c)) && a[b];
                        };
                        goog.object.isEmpty = function(a) {
                            for(var b in a)return !1;
                            return !0;
                        };
                        goog.object.clear = function(a) {
                            for(var b in a)delete a[b];
                        };
                        goog.object.remove = function(a, b) {
                            var c;
                            (c = b in a) && delete a[b];
                            return c;
                        };
                        goog.object.add = function(a, b, c) {
                            if (null !== a && b in a) throw Error('The object already contains the key "' + b + '"');
                            goog.object.set(a, b, c);
                        };
                        goog.object.get = function(a, b, c) {
                            return null !== a && b in a ? a[b] : c;
                        };
                        goog.object.set = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.object.setIfUndefined = function(a, b, c) {
                            return b in a ? a[b] : a[b] = c;
                        };
                        goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
                            if (b in a) return a[b];
                            c = c();
                            return a[b] = c;
                        };
                        goog.object.equals = function(a, b) {
                            for(var c in a)if (!(c in b) || a[c] !== b[c]) return !1;
                            for(var d in b)if (!(d in a)) return !1;
                            return !0;
                        };
                        goog.object.clone = function(a) {
                            var b = {}, c;
                            for(c in a)b[c] = a[c];
                            return b;
                        };
                        goog.object.unsafeClone = function(a) {
                            if (!a || "object" !== typeof a) return a;
                            if ("function" === typeof a.clone) return a.clone();
                            var b = Array.isArray(a) ? [] : "function" !== typeof ArrayBuffer || "function" !== typeof ArrayBuffer.isView || !ArrayBuffer.isView(a) || a instanceof DataView ? {} : new a.constructor(a.length), c;
                            for(c in a)b[c] = goog.object.unsafeClone(a[c]);
                            return b;
                        };
                        goog.object.transpose = function(a) {
                            var b = {}, c;
                            for(c in a)b[a[c]] = c;
                            return b;
                        };
                        goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.object.extend = function(a, b) {
                            for(var c, d, e = 1; e < arguments.length; e++){
                                d = arguments[e];
                                for(c in d)a[c] = d[c];
                                for(var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
                            }
                        };
                        goog.object.create = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
                            if (b % 2) throw Error("Uneven number of arguments");
                            for(var c = {}, d = 0; d < b; d += 2)c[arguments[d]] = arguments[d + 1];
                            return c;
                        };
                        goog.object.createSet = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
                            for(var c = {}, d = 0; d < b; d++)c[arguments[d]] = !0;
                            return c;
                        };
                        goog.object.createImmutableView = function(a) {
                            var b = a;
                            Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
                            return b;
                        };
                        goog.object.isImmutableView = function(a) {
                            return !!Object.isFrozen && Object.isFrozen(a);
                        };
                        goog.object.getAllPropertyNames = function(a, b, c) {
                            if (!a) return [];
                            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a);
                            for(var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);){
                                for(var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++)d[e[f]] = !0;
                                a = Object.getPrototypeOf(a);
                            }
                            return goog.object.getKeys(d);
                        };
                        goog.object.getSuperClass = function(a) {
                            return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
                        };
                        goog.dom.tags = {};
                        goog.dom.tags.VOID_TAGS_ = {
                            area: !0,
                            base: !0,
                            br: !0,
                            col: !0,
                            command: !0,
                            embed: !0,
                            hr: !0,
                            img: !0,
                            input: !0,
                            keygen: !0,
                            link: !0,
                            meta: !0,
                            param: !0,
                            source: !0,
                            track: !0,
                            wbr: !0
                        };
                        goog.dom.tags.isVoidTag = function(a) {
                            return !0 === goog.dom.tags.VOID_TAGS_[a];
                        };
                        goog.string = {};
                        goog.string.TypedString = function() {};
                        goog.string.Const = function(a, b) {
                            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
                            this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
                        };
                        goog.string.Const.prototype.implementsGoogStringTypedString = !0;
                        goog.string.Const.prototype.getTypedStringValue = function() {
                            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                        };
                        goog.DEBUG && (goog.string.Const.prototype.toString = function() {
                            return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
                        });
                        goog.string.Const.unwrap = function(a) {
                            if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                            goog.asserts.fail("expected object of type Const, got '" + a + "'");
                            return "type_error:Const";
                        };
                        goog.string.Const.from = function(a) {
                            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
                        };
                        goog.string.Const.TYPE_MARKER_ = {};
                        goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.string.Const.EMPTY = goog.string.Const.from("");
                        goog.html = {};
                        goog.html.trustedtypes = {};
                        goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
                            if (!goog.TRUSTED_TYPES_POLICY_NAME) return null;
                            void 0 === goog.html.trustedtypes.cachedPolicy_ && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html"));
                            return goog.html.trustedtypes.cachedPolicy_;
                        };
                        var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(a, b) {
                            this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = b === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            return 0 === a.length ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(a, b) {
                            for(var c = [], d = 1; d < arguments.length; d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromJson = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a));
                        };
                        module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrap = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(a) {
                            if (a instanceof module$contents$goog$html$SafeScript_SafeScript && a.constructor === module$contents$goog$html$SafeScript_SafeScript) return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeScript";
                        };
                        module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(a) {
                            return JSON.stringify(a).replace(/</g, "\\x3c");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScript(a) : a;
                            return new module$contents$goog$html$SafeScript_SafeScript(a, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
                            return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeScript_SafeScript.EMPTY = function() {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
                        }();
                        goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript;
                        goog.fs = {};
                        goog.fs.url = {};
                        goog.fs.url.createObjectUrl = function(a) {
                            return goog.fs.url.getUrlObject_().createObjectURL(a);
                        };
                        goog.fs.url.revokeObjectUrl = function(a) {
                            goog.fs.url.getUrlObject_().revokeObjectURL(a);
                        };
                        goog.fs.url.UrlObject_ = function() {};
                        goog.fs.url.UrlObject_.prototype.createObjectURL = function(a) {};
                        goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(a) {};
                        goog.fs.url.getUrlObject_ = function() {
                            var a = goog.fs.url.findUrlObject_();
                            if (null != a) return a;
                            throw Error("This browser doesn't seem to support blob URLs");
                        };
                        goog.fs.url.findUrlObject_ = function() {
                            return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
                        };
                        goog.fs.url.browserSupportsObjectUrls = function() {
                            return null != goog.fs.url.findUrlObject_();
                        };
                        goog.fs.blob = {};
                        goog.fs.blob.getBlob = function(a) {
                            var b = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== b) {
                                b = new b;
                                for(var c = 0; c < arguments.length; c++)b.append(arguments[c]);
                                return b.getBlob();
                            }
                            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
                        };
                        goog.fs.blob.getBlobWithProperties = function(a, b, c) {
                            var d = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== d) {
                                d = new d;
                                for(var e = 0; e < a.length; e++)d.append(a[e], c);
                                return d.getBlob(b);
                            }
                            if (void 0 !== goog.global.Blob) return d = {}, b && (d.type = b), c && (d.endings = c), new Blob(a, d);
                            throw Error("This browser doesn't seem to support creating Blobs");
                        };
                        goog.i18n = {};
                        goog.i18n.bidi = {};
                        goog.i18n.bidi.FORCE_RTL = !1;
                        goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
                        goog.i18n.bidi.Format = {
                            LRE: "\u202A",
                            RLE: "\u202B",
                            PDF: "\u202C",
                            LRM: "\u200E",
                            RLM: "\u200F"
                        };
                        goog.i18n.bidi.Dir = {
                            LTR: 1,
                            RTL: -1,
                            NEUTRAL: 0
                        };
                        goog.i18n.bidi.RIGHT = "right";
                        goog.i18n.bidi.LEFT = "left";
                        goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
                        goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
                        goog.i18n.bidi.toDir = function(a, b) {
                            return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.ltrChars_ = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\ud801\ud804-\ud839\ud83c-\udbff\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
                        goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\ud802-\ud803\ud83a-\ud83b\uFB1D-\uFDFF\uFE70-\uFEFC";
                        goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
                        goog.i18n.bidi.stripHtmlIfNeeded_ = function(a, b) {
                            return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
                        };
                        goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.hasAnyRtl = function(a, b) {
                            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
                        goog.i18n.bidi.hasAnyLtr = function(a, b) {
                            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.isRtlChar = function(a) {
                            return goog.i18n.bidi.rtlRe_.test(a);
                        };
                        goog.i18n.bidi.isLtrChar = function(a) {
                            return goog.i18n.bidi.ltrRe_.test(a);
                        };
                        goog.i18n.bidi.isNeutralChar = function(a) {
                            return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
                        };
                        goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.startsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
                        goog.i18n.bidi.startsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
                        goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
                        goog.i18n.bidi.isNeutralText = function(a, b) {
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
                            return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
                        };
                        goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
                        goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
                        goog.i18n.bidi.endsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
                        goog.i18n.bidi.endsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
                        goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
                        goog.i18n.bidi.isRtlLanguage = function(a) {
                            return goog.i18n.bidi.rtlLocalesRe_.test(a);
                        };
                        goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
                        goog.i18n.bidi.guardBracketInText = function(a, b) {
                            b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
                            return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
                        };
                        goog.i18n.bidi.enforceRtlInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceRtlInText = function(a) {
                            return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.enforceLtrInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceLtrInText = function(a) {
                            return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
                        goog.i18n.bidi.leftRe_ = /left/gi;
                        goog.i18n.bidi.rightRe_ = /right/gi;
                        goog.i18n.bidi.tempRe_ = /%%%%/g;
                        goog.i18n.bidi.mirrorCSS = function(a) {
                            return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
                        };
                        goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
                        goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
                        goog.i18n.bidi.normalizeHebrewQuote = function(a) {
                            return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
                        };
                        goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
                        goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
                        goog.i18n.bidi.rtlDetectionThreshold_ = .4;
                        goog.i18n.bidi.estimateDirection = function(a, b) {
                            var c = 0, d = 0, e = !1;
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);
                            for(b = 0; b < a.length; b++){
                                var f = a[b];
                                goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
                            }
                            return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.detectRtlDirectionality = function(a, b) {
                            return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
                        };
                        goog.i18n.bidi.setElementDirAndAlign = function(a, b) {
                            a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
                        };
                        goog.i18n.bidi.setElementDirByTextDirectionality = function(a, b) {
                            switch(goog.i18n.bidi.estimateDirection(b)){
                                case goog.i18n.bidi.Dir.LTR:
                                    "ltr" !== a.dir && (a.dir = "ltr");
                                    break;
                                case goog.i18n.bidi.Dir.RTL:
                                    "rtl" !== a.dir && (a.dir = "rtl");
                                    break;
                                default:
                                    a.removeAttribute("dir");
                            }
                        };
                        goog.i18n.bidi.DirectionalString = function() {};
                        goog.html.TrustedResourceUrl = function(a, b) {
                            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = b === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.TrustedResourceUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a, b) {
                            var c = goog.html.TrustedResourceUrl.unwrap(this);
                            c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
                            var d = c[3] || "";
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
                        };
                        goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
                            return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
                        });
                        goog.html.TrustedResourceUrl.unwrap = function(a) {
                            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
                        };
                        goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a) {
                            if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl) return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
                            goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:TrustedResourceUrl";
                        };
                        goog.html.TrustedResourceUrl.format = function(a, b) {
                            var c = goog.string.Const.unwrap(a);
                            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
                            a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(d, e) {
                                if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
                                d = b[e];
                                return d instanceof goog.string.Const ? goog.string.Const.unwrap(d) : encodeURIComponent(String(d));
                            });
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
                        goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
                        goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
                        goog.html.TrustedResourceUrl.formatWithParams = function(a, b, c, d) {
                            return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
                        };
                        goog.html.TrustedResourceUrl.fromConstant = function(a) {
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.TrustedResourceUrl.fromConstants = function(a) {
                            for(var b = "", c = 0; c < a.length; c++)b += goog.string.Const.unwrap(a[c]);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.TrustedResourceUrl.fromSafeScript = function(a) {
                            a = goog.fs.blob.getBlobWithProperties([
                                module$contents$goog$html$SafeScript_SafeScript.unwrap(a)
                            ], "text/javascript");
                            a = goog.fs.url.createObjectUrl(a);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScriptURL(a) : a;
                            return new goog.html.TrustedResourceUrl(a, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.TrustedResourceUrl.stringifyParams_ = function(a, b, c) {
                            if (null == c) return b;
                            if ("string" === typeof c) return c ? a + encodeURIComponent(c) : "";
                            for(var d in c)if (Object.prototype.hasOwnProperty.call(c, d)) {
                                var e = c[d];
                                e = Array.isArray(e) ? e : [
                                    e
                                ];
                                for(var f = 0; f < e.length; f++){
                                    var g = e[f];
                                    null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
                                }
                            }
                            return b;
                        };
                        goog.string.internal = {};
                        goog.string.internal.startsWith = function(a, b) {
                            return 0 == a.lastIndexOf(b, 0);
                        };
                        goog.string.internal.endsWith = function(a, b) {
                            var c = a.length - b.length;
                            return 0 <= c && a.indexOf(b, c) == c;
                        };
                        goog.string.internal.caseInsensitiveStartsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
                        };
                        goog.string.internal.caseInsensitiveEndsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
                        };
                        goog.string.internal.caseInsensitiveEquals = function(a, b) {
                            return a.toLowerCase() == b.toLowerCase();
                        };
                        goog.string.internal.isEmptyOrWhitespace = function(a) {
                            return /^[\s\xa0]*$/.test(a);
                        };
                        goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
                            return a.trim();
                        } : function(a) {
                            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
                        };
                        goog.string.internal.caseInsensitiveCompare = function(a, b) {
                            a = String(a).toLowerCase();
                            b = String(b).toLowerCase();
                            return a < b ? -1 : a == b ? 0 : 1;
                        };
                        goog.string.internal.newLineToBr = function(a, b) {
                            return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
                        };
                        goog.string.internal.htmlEscape = function(a, b) {
                            if (b) a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
                            else {
                                if (!goog.string.internal.ALL_RE_.test(a)) return a;
                                -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
                                -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
                                -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
                                -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
                                -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
                                -1 != a.indexOf("\0") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
                            }
                            return a;
                        };
                        goog.string.internal.AMP_RE_ = /&/g;
                        goog.string.internal.LT_RE_ = /</g;
                        goog.string.internal.GT_RE_ = />/g;
                        goog.string.internal.QUOT_RE_ = /"/g;
                        goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
                        goog.string.internal.NULL_RE_ = /\x00/g;
                        goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
                        goog.string.internal.whitespaceEscape = function(a, b) {
                            return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.internal.contains = function(a, b) {
                            return -1 != a.indexOf(b);
                        };
                        goog.string.internal.caseInsensitiveContains = function(a, b) {
                            return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
                        };
                        goog.string.internal.compareVersions = function(a, b) {
                            var c = 0;
                            a = goog.string.internal.trim(String(a)).split(".");
                            b = goog.string.internal.trim(String(b)).split(".");
                            for(var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++){
                                var f = a[e] || "", g = b[e] || "";
                                do {
                                    f = /(\d*)(\D*)(.*)/.exec(f) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    if (0 == f[0].length && 0 == g[0].length) break;
                                    c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
                                    var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
                                    c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
                                    f = f[3];
                                    g = g[3];
                                }while (0 == c);
                            }
                            return c;
                        };
                        goog.string.internal.compareElements_ = function(a, b) {
                            return a < b ? -1 : a > b ? 1 : 0;
                        };
                        goog.html.SafeUrl = function(a, b) {
                            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = b === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
                        goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
                        };
                        goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
                            return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
                        });
                        goog.html.SafeUrl.unwrap = function(a) {
                            if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl) return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeUrl";
                        };
                        goog.html.SafeUrl.fromConstant = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;
                        goog.html.SafeUrl.isSafeMimeType = function(a) {
                            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
                        };
                        goog.html.SafeUrl.fromBlob = function(a) {
                            a = goog.html.SafeUrl.isSafeMimeType(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.revokeObjectUrl = function(a) {
                            a = a.getTypedStringValue();
                            a !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(a);
                        };
                        goog.html.SafeUrl.fromMediaSource = function(a) {
                            goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource");
                            a = a instanceof MediaSource ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i;
                        goog.html.SafeUrl.tryFromDataUrl = function(a) {
                            a = String(a);
                            a = a.replace(/(%0A|%0D)/g, "");
                            var b = a.match(goog.html.DATA_URL_PATTERN_);
                            return b && goog.html.SafeUrl.isSafeMimeType(b[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : null;
                        };
                        goog.html.SafeUrl.fromDataUrl = function(a) {
                            return goog.html.SafeUrl.tryFromDataUrl(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.fromTelUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
                        goog.html.SafeUrl.fromSipUrl = function(a) {
                            goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromFacebookMessengerUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromWhatsAppUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromSmsUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a) {
                            var b = a.indexOf("#");
                            0 < b && (a = a.substring(0, b));
                            b = a.match(/[?&]body=/gi);
                            if (!b) return !0;
                            if (1 < b.length) return !1;
                            a = a.match(/[?&]body=([^&]*)/)[1];
                            if (!a) return !0;
                            try {
                                decodeURIComponent(a);
                            } catch (c) {
                                return !1;
                            }
                            return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
                        };
                        goog.html.SafeUrl.fromSshUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a, b, c) {
                            (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [
                                goog.string.Const.unwrap(c)
                            ] : c.map(function(d) {
                                return goog.string.Const.unwrap(d);
                            })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.SafeUrl.fromTrustedResourceUrl = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
                        };
                        goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
                        goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
                        goog.html.SafeUrl.trySanitize = function(a) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SAFE_URL_PATTERN_.test(a) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : goog.html.SafeUrl.tryFromDataUrl(a);
                        };
                        goog.html.SafeUrl.sanitize = function(a) {
                            return goog.html.SafeUrl.trySanitize(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.sanitizeAssertUnchanged = function(a, b) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a)) return b;
                            goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeUrl(a, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);
                        goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
                        goog.html.SafeStyle = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = b === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeStyle.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return goog.html.SafeStyle.EMPTY;
                            goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
                            goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeStyle.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                        };
                        goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
                            return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
                        });
                        goog.html.SafeStyle.unwrap = function(a) {
                            if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle) return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                            goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyle";
                        };
                        goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeStyle(a, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
                        goog.html.SafeStyle.create = function(a) {
                            var b = "", c;
                            for(c in a)if (Object.prototype.hasOwnProperty.call(a, c)) {
                                if (!/^[-_a-zA-Z0-9]+$/.test(c)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
                                var d = a[c];
                                null != d && (d = Array.isArray(d) ? module$contents$goog$array_map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
                            }
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        goog.html.SafeStyle.sanitizePropertyValue_ = function(a) {
                            if (a instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
                            a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
                            if (/[{;}]/.test(a)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [
                                a
                            ]);
                            return a;
                        };
                        goog.html.SafeStyle.sanitizePropertyValueString_ = function(a) {
                            var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
                            if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
                                if (goog.html.SafeStyle.COMMENT_RE_.test(a)) return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            return goog.html.SafeStyle.sanitizeUrl_(a);
                        };
                        goog.html.SafeStyle.hasBalancedQuotes_ = function(a) {
                            for(var b = !0, c = !0, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                "'" == e && c ? b = !b : '"' == e && b && (c = !c);
                            }
                            return b && c;
                        };
                        goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a) {
                            for(var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                if ("]" == e) {
                                    if (b) return !1;
                                    b = !0;
                                } else if ("[" == e) {
                                    if (!b) return !1;
                                    b = !1;
                                } else if (!b && !c.test(e)) return !1;
                            }
                            return b;
                        };
                        goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
                        goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
                        goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
                        goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
                        goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g");
                        goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
                        goog.html.SafeStyle.sanitizeUrl_ = function(a) {
                            return a.replace(goog.html.SafeStyle.URL_RE_, function(b, c, d, e) {
                                var f = "";
                                d = d.replace(/^(['"])(.*)\1$/, function(g, h, k) {
                                    f = h;
                                    return k;
                                });
                                b = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
                                return c + f + b + f + e;
                            });
                        };
                        goog.html.SafeStyle.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += goog.html.SafeStyle.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = b === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(a, b) {
                            if ((0, goog.string.internal.contains)(a, "<")) throw Error("Selector does not allow '<', got: " + a);
                            var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
                            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
                            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c)) throw Error("() and [] in selector must be balanced, got: " + a);
                            b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
                            a = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(a) {
                            for(var b = {
                                "(": ")",
                                "[": "]"
                            }, c = [], d = 0; d < a.length; d++){
                                var e = a[d];
                                if (b[e]) c.push(b[e]);
                                else if (goog.object.contains(b, e) && c.pop() != e) return !1;
                            }
                            return 0 == c.length;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;
                            (0, goog.asserts.assert)(!(0, goog.string.internal.contains)(a, "<"), "Forbidden '<' character in style sheet string: " + a);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(a) {
                            if (a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && a.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet) return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyleSheet";
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
                            return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;
                        goog.labs = {};
                        goog.labs.userAgent = {};
                        goog.labs.userAgent.util = {};
                        goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
                            var a = goog.labs.userAgent.util.getNavigator_();
                            return a && (a = a.userAgent) ? a : "";
                        };
                        goog.labs.userAgent.util.getNavigator_ = function() {
                            return goog.global.navigator;
                        };
                        goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
                        goog.labs.userAgent.util.setUserAgent = function(a) {
                            goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
                        };
                        goog.labs.userAgent.util.getUserAgent = function() {
                            return goog.labs.userAgent.util.userAgent_;
                        };
                        goog.labs.userAgent.util.matchUserAgent = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.contains(b, a);
                        };
                        goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.caseInsensitiveContains(b, a);
                        };
                        goog.labs.userAgent.util.extractVersionTuples = function(a) {
                            for(var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);)c.push([
                                d[1],
                                d[2],
                                d[3] || void 0
                            ]);
                            return c;
                        };
                        goog.labs.userAgent.browser = {};
                        goog.labs.userAgent.browser.matchOpera_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Opera");
                        };
                        goog.labs.userAgent.browser.matchIE_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
                        };
                        goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edge");
                        };
                        goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edg/");
                        };
                        goog.labs.userAgent.browser.matchOperaChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("OPR");
                        };
                        goog.labs.userAgent.browser.matchFirefox_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
                        };
                        goog.labs.userAgent.browser.matchSafari_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
                        };
                        goog.labs.userAgent.browser.matchCoast_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Coast");
                        };
                        goog.labs.userAgent.browser.matchIosWebview_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
                        };
                        goog.labs.userAgent.browser.matchChrome_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
                        };
                        goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
                        };
                        goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
                        goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
                        goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
                        goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
                        goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
                        goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
                        goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
                        goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
                        goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
                        goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
                        goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
                        goog.labs.userAgent.browser.isSilk = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Silk");
                        };
                        goog.labs.userAgent.browser.getVersion = function() {
                            function a(e) {
                                e = module$contents$goog$array_find(e, d);
                                return c[e] || "";
                            }
                            var b = goog.labs.userAgent.util.getUserAgent();
                            if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b);
                            b = goog.labs.userAgent.util.extractVersionTuples(b);
                            var c = {};
                            module$contents$goog$array_forEach(b, function(e) {
                                c[e[0]] = e[1];
                            });
                            var d = goog.partial(goog.object.containsKey, c);
                            return goog.labs.userAgent.browser.isOpera() ? a([
                                "Version",
                                "Opera"
                            ]) : goog.labs.userAgent.browser.isEdge() ? a([
                                "Edge"
                            ]) : goog.labs.userAgent.browser.isEdgeChromium() ? a([
                                "Edg"
                            ]) : goog.labs.userAgent.browser.isChrome() ? a([
                                "Chrome",
                                "CriOS",
                                "HeadlessChrome"
                            ]) : (b = b[2]) && b[1] || "";
                        };
                        goog.labs.userAgent.browser.isVersionOrHigher = function(a) {
                            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
                        };
                        goog.labs.userAgent.browser.getIEVersion_ = function(a) {
                            var b = /rv: *([\d\.]*)/.exec(a);
                            if (b && b[1]) return b[1];
                            b = "";
                            var c = /MSIE +([\d\.]+)/.exec(a);
                            if (c && c[1]) {
                                if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
                                    if (a && a[1]) switch(a[1]){
                                        case "4.0":
                                            b = "8.0";
                                            break;
                                        case "5.0":
                                            b = "9.0";
                                            break;
                                        case "6.0":
                                            b = "10.0";
                                            break;
                                        case "7.0":
                                            b = "11.0";
                                    }
                                    else b = "7.0";
                                } else b = c[1];
                            }
                            return b;
                        };
                        goog.html.SafeHtml = function(a, b, c) {
                            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = c === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                            this.dir_ = b;
                        };
                        goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG;
                        goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0;
                        goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeHtml.prototype.getDirection = function() {
                            return this.dir_;
                        };
                        goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeHtml.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
                        };
                        goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
                            return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
                        });
                        goog.html.SafeHtml.unwrap = function(a) {
                            return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
                        };
                        goog.html.SafeHtml.unwrapTrustedHTML = function(a) {
                            if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml) return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeHtml";
                        };
                        goog.html.SafeHtml.htmlEscape = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            var b = "object" == typeof a, c = null;
                            b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
                            a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
                        goog.html.SafeHtml.comment = function(a) {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(a) + "-->", null);
                        };
                        goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
                        goog.html.SafeHtml.URL_ATTRIBUTES_ = {
                            action: !0,
                            cite: !0,
                            data: !0,
                            formaction: !0,
                            href: !0,
                            manifest: !0,
                            poster: !0,
                            src: !0
                        };
                        goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE);
                        goog.html.SafeHtml.create = function(a, b, c) {
                            goog.html.SafeHtml.verifyTagName(String(a));
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
                        };
                        goog.html.SafeHtml.verifyTagName = function(a) {
                            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + a + ">." : "");
                            if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + a + "> is not allowed for SafeHtml." : "");
                        };
                        goog.html.SafeHtml.createIframe = function(a, b, c, d) {
                            a && goog.html.TrustedResourceUrl.unwrap(a);
                            var e = {};
                            e.src = a || null;
                            e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
                            a = goog.html.SafeHtml.combineAttributes(e, {
                                sandbox: ""
                            }, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.createSandboxIframe = function(a, b, c, d) {
                            if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
                            var e = {};
                            e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
                            e.srcdoc = b || null;
                            e.sandbox = "";
                            a = goog.html.SafeHtml.combineAttributes(e, {}, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.canUseSandboxIframe = function() {
                            return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
                        };
                        goog.html.SafeHtml.createScriptSrc = function(a, b) {
                            goog.html.TrustedResourceUrl.unwrap(a);
                            a = goog.html.SafeHtml.combineAttributes({
                                src: a
                            }, {}, b);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a);
                        };
                        goog.html.SafeHtml.createScript = function(a, b) {
                            for(var c in b)if (Object.prototype.hasOwnProperty.call(b, c)) {
                                var d = c.toLowerCase();
                                if ("language" == d || "src" == d || "text" == d || "type" == d) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d + '" attribute' : "");
                            }
                            c = "";
                            a = module$contents$goog$array_concat(a);
                            for(d = 0; d < a.length; d++)c += module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a);
                        };
                        goog.html.SafeHtml.createStyle = function(a, b) {
                            b = goog.html.SafeHtml.combineAttributes({
                                type: "text/css"
                            }, {}, b);
                            var c = "";
                            a = module$contents$goog$array_concat(a);
                            for(var d = 0; d < a.length; d++)c += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a);
                        };
                        goog.html.SafeHtml.createMetaRefresh = function(a, b) {
                            a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
                            (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'");
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
                                "http-equiv": "refresh",
                                content: (b || 0) + "; url=" + a
                            });
                        };
                        goog.html.SafeHtml.getAttrNameAndValue_ = function(a, b, c) {
                            if (c instanceof goog.string.Const) c = goog.string.Const.unwrap(c);
                            else if ("style" == b.toLowerCase()) {
                                if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) c = goog.html.SafeHtml.getStyleValue_(c);
                                else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
                            } else {
                                if (/^on/i.test(b)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.' : "");
                                if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
                                    if (c instanceof goog.html.TrustedResourceUrl) c = goog.html.TrustedResourceUrl.unwrap(c);
                                    else if (c instanceof goog.html.SafeUrl) c = goog.html.SafeUrl.unwrap(c);
                                    else if ("string" === typeof c) c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
                                    else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.' : "");
                                }
                            }
                            c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
                            goog.asserts.assert("string" === typeof c || "number" === typeof c, "String or number value expected, got " + typeof c + " with value: " + c);
                            return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
                        };
                        goog.html.SafeHtml.getStyleValue_ = function(a) {
                            if (!goog.isObject(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + " given: " + a : "");
                            a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
                            return goog.html.SafeStyle.unwrap(a);
                        };
                        goog.html.SafeHtml.createWithDir = function(a, b, c, d) {
                            b = goog.html.SafeHtml.create(b, c, d);
                            b.dir_ = a;
                            return b;
                        };
                        goog.html.SafeHtml.join = function(a, b) {
                            a = goog.html.SafeHtml.htmlEscape(a);
                            var c = a.getDirection(), d = [], e = function(f) {
                                Array.isArray(f) ? module$contents$goog$array_forEach(f, e) : (f = goog.html.SafeHtml.htmlEscape(f), d.push(goog.html.SafeHtml.unwrap(f)), f = f.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = f : f != goog.i18n.bidi.Dir.NEUTRAL && c != f && (c = null));
                            };
                            module$contents$goog$array_forEach(b, e);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
                        };
                        goog.html.SafeHtml.concat = function(a) {
                            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
                        };
                        goog.html.SafeHtml.concatWithDir = function(a, b) {
                            var c = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
                            c.dir_ = a;
                            return c;
                        };
                        goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a, b) {
                            var c = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = c ? c.createHTML(a) : a;
                            return new goog.html.SafeHtml(a, b, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a, b, c) {
                            var d = null;
                            var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
                            null == c ? c = [] : Array.isArray(c) || (c = [
                                c
                            ]);
                            goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
                            (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
                        };
                        goog.html.SafeHtml.stringifyAttributes = function(a, b) {
                            var c = "";
                            if (b) {
                                for(var d in b)if (Object.prototype.hasOwnProperty.call(b, d)) {
                                    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d + '".' : "");
                                    var e = b[d];
                                    null != e && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
                                }
                            }
                            return c;
                        };
                        goog.html.SafeHtml.combineAttributes = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)Object.prototype.hasOwnProperty.call(a, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e]);
                            for(e in b)Object.prototype.hasOwnProperty.call(b, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e]);
                            if (c) {
                                for(e in c)if (Object.prototype.hasOwnProperty.call(c, e)) {
                                    var f = e.toLowerCase();
                                    if (f in a) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"' : "");
                                    f in b && delete d[f];
                                    d[e] = c[e];
                                }
                            }
                            return d;
                        };
                        goog.html.SafeHtml.DOCTYPE_HTML = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        goog.html.SafeHtml.BR = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.uncheckedconversions = {};
                        goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a, b, c) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
                        };
                        goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.dom.safe = {};
                        goog.dom.safe.InsertAdjacentHtmlPosition = {
                            AFTERBEGIN: "afterbegin",
                            AFTEREND: "afterend",
                            BEFOREBEGIN: "beforebegin",
                            BEFOREEND: "beforeend"
                        };
                        goog.dom.safe.insertAdjacentHtml = function(a, b, c) {
                            a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
                        };
                        goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
                            MATH: !0,
                            SCRIPT: !0,
                            STYLE: !0,
                            SVG: !0,
                            TEMPLATE: !0
                        };
                        goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
                            if (goog.DEBUG && "undefined" === typeof document) return !1;
                            var a = document.createElement("div"), b = document.createElement("div");
                            b.appendChild(document.createElement("div"));
                            a.appendChild(b);
                            if (goog.DEBUG && !a.firstChild) return !1;
                            b = a.firstChild.firstChild;
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
                            return !b.parentElement;
                        });
                        goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a, b) {
                            if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for(; a.lastChild;)a.removeChild(a.lastChild);
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setInnerHtml = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS && a.tagName) {
                                var c = a.tagName.toUpperCase();
                                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
                            }
                            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
                        };
                        goog.dom.safe.setInnerHtmlFromConstant = function(a, b) {
                            goog.dom.safe.setInnerHtml(a, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(b)));
                        };
                        goog.dom.safe.setOuterHtml = function(a, b) {
                            a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setFormElementAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setButtonFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setInputFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setStyle = function(a, b) {
                            a.style.cssText = goog.html.SafeStyle.unwrap(b);
                        };
                        goog.dom.safe.documentWrite = function(a, b) {
                            a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
                        };
                        goog.dom.safe.setAnchorHref = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAnchorElement(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setImageSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLImageElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:image\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setAudioSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAudioElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:audio\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setVideoSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLVideoElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:video\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setEmbedSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLEmbedElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setFrameSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrcdoc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setLinkHrefAndRel = function(a, b, c) {
                            goog.dom.asserts.assertIsHTMLLinkElement(a);
                            a.rel = c;
                            goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrap(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(b) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
                        };
                        goog.dom.safe.setObjectData = function(a, b) {
                            goog.dom.asserts.assertIsHTMLObjectElement(a);
                            a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setScriptSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setScriptContent = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setNonceForScriptElement_ = function(a) {
                            var b = goog.getScriptNonce(a.ownerDocument && a.ownerDocument.defaultView);
                            b && a.setAttribute("nonce", b);
                        };
                        goog.dom.safe.setLocationHref = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.assignLocation = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.assign(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.replaceLocation = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.replace(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.openInWindow = function(a, b, c, d, e) {
                            a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
                            b = b || goog.global;
                            c = c instanceof goog.string.Const ? goog.string.Const.unwrap(c) : c || "";
                            return b.open(goog.html.SafeUrl.unwrap(a), c, d, e);
                        };
                        goog.dom.safe.parseFromStringHtml = function(a, b) {
                            return goog.dom.safe.parseFromString(a, b, "text/html");
                        };
                        goog.dom.safe.parseFromString = function(a, b, c) {
                            return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
                        };
                        goog.dom.safe.createImageFromBlob = function(a) {
                            if (!/^image\/.*/g.test(a.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
                            var b = goog.global.URL.createObjectURL(a);
                            a = new goog.global.Image;
                            a.onload = function() {
                                goog.global.URL.revokeObjectURL(b);
                            };
                            goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
                            return a;
                        };
                        goog.string.DETECT_DOUBLE_ESCAPING = !1;
                        goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
                        goog.string.Unicode = {
                            NBSP: "\xa0"
                        };
                        goog.string.startsWith = goog.string.internal.startsWith;
                        goog.string.endsWith = goog.string.internal.endsWith;
                        goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
                        goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
                        goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
                        goog.string.subs = function(a, b) {
                            for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
                            return d + c.join("%s");
                        };
                        goog.string.collapseWhitespace = function(a) {
                            return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
                        };
                        goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
                        goog.string.isEmptyString = function(a) {
                            return 0 == a.length;
                        };
                        goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
                        goog.string.isEmptyOrWhitespaceSafe = function(a) {
                            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
                        };
                        goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
                        goog.string.isBreakingWhitespace = function(a) {
                            return !/[^\t\n\r ]/.test(a);
                        };
                        goog.string.isAlpha = function(a) {
                            return !/[^a-zA-Z]/.test(a);
                        };
                        goog.string.isNumeric = function(a) {
                            return !/[^0-9]/.test(a);
                        };
                        goog.string.isAlphaNumeric = function(a) {
                            return !/[^a-zA-Z0-9]/.test(a);
                        };
                        goog.string.isSpace = function(a) {
                            return " " == a;
                        };
                        goog.string.isUnicodeChar = function(a) {
                            return 1 == a.length && " " <= a && "~" >= a || "\x80" <= a && "\uFFFD" >= a;
                        };
                        goog.string.stripNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)+/g, " ");
                        };
                        goog.string.canonicalizeNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)/g, "\n");
                        };
                        goog.string.normalizeWhitespace = function(a) {
                            return a.replace(/\xa0|\s/g, " ");
                        };
                        goog.string.normalizeSpaces = function(a) {
                            return a.replace(/\xa0|[ \t]+/g, " ");
                        };
                        goog.string.collapseBreakingSpaces = function(a) {
                            return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
                        };
                        goog.string.trim = goog.string.internal.trim;
                        goog.string.trimLeft = function(a) {
                            return a.replace(/^[\s\xa0]+/, "");
                        };
                        goog.string.trimRight = function(a) {
                            return a.replace(/[\s\xa0]+$/, "");
                        };
                        goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
                        goog.string.numberAwareCompare_ = function(a, b, c) {
                            if (a == b) return 0;
                            if (!a) return -1;
                            if (!b) return 1;
                            for(var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++){
                                c = d[g];
                                var h = e[g];
                                if (c != h) return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
                            }
                            return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
                        };
                        goog.string.intAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
                        };
                        goog.string.floatAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
                        };
                        goog.string.numerateCompare = goog.string.floatAwareCompare;
                        goog.string.urlEncode = function(a) {
                            return encodeURIComponent(String(a));
                        };
                        goog.string.urlDecode = function(a) {
                            return decodeURIComponent(a.replace(/\+/g, " "));
                        };
                        goog.string.newLineToBr = goog.string.internal.newLineToBr;
                        goog.string.htmlEscape = function(a, b) {
                            a = goog.string.internal.htmlEscape(a, b);
                            goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
                            return a;
                        };
                        goog.string.E_RE_ = /e/g;
                        goog.string.unescapeEntities = function(a) {
                            return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
                        };
                        goog.string.unescapeEntitiesWithDocument = function(a, b) {
                            return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
                        };
                        goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
                            var c = {
                                "&amp;": "&",
                                "&lt;": "<",
                                "&gt;": ">",
                                "&quot;": '"'
                            };
                            var d = b ? b.createElement("div") : goog.global.document.createElement("div");
                            return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(e, f) {
                                var g = c[e];
                                if (g) return g;
                                "#" == f.charAt(0) && (f = Number("0" + f.substr(1)), isNaN(f) || (g = String.fromCharCode(f)));
                                g || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e + " ")), g = d.firstChild.nodeValue.slice(0, -1));
                                return c[e] = g;
                            });
                        };
                        goog.string.unescapePureXmlEntities_ = function(a) {
                            return a.replace(/&([^;]+);/g, function(b, c) {
                                switch(c){
                                    case "amp":
                                        return "&";
                                    case "lt":
                                        return "<";
                                    case "gt":
                                        return ">";
                                    case "quot":
                                        return '"';
                                    default:
                                        return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? b : String.fromCharCode(c);
                                }
                            });
                        };
                        goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
                        goog.string.whitespaceEscape = function(a, b) {
                            return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.preserveSpaces = function(a) {
                            return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
                        };
                        goog.string.stripQuotes = function(a, b) {
                            for(var c = b.length, d = 0; d < c; d++){
                                var e = 1 == c ? b : b.charAt(d);
                                if (a.charAt(0) == e && a.charAt(a.length - 1) == e) return a.substring(1, a.length - 1);
                            }
                            return a;
                        };
                        goog.string.truncate = function(a, b, c) {
                            c && (a = goog.string.unescapeEntities(a));
                            a.length > b && (a = a.substring(0, b - 3) + "...");
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.truncateMiddle = function(a, b, c, d) {
                            c && (a = goog.string.unescapeEntities(a));
                            if (d && a.length > b) {
                                d > b && (d = b);
                                var e = a.length - d;
                                a = a.substring(0, b - d) + "..." + a.substring(e);
                            } else a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.specialEscapeChars_ = {
                            "\0": "\\0",
                            "\b": "\\b",
                            "\f": "\\f",
                            "\n": "\\n",
                            "\r": "\\r",
                            "	": "\\t",
                            "\v": "\\x0B",
                            '"': '\\"',
                            "\\": "\\\\",
                            "<": "\\u003C"
                        };
                        goog.string.jsEscapeCache_ = {
                            "'": "\\'"
                        };
                        goog.string.quote = function(a) {
                            a = String(a);
                            for(var b = [
                                '"'
                            ], c = 0; c < a.length; c++){
                                var d = a.charAt(c), e = d.charCodeAt(0);
                                b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
                            }
                            b.push('"');
                            return b.join("");
                        };
                        goog.string.escapeString = function(a) {
                            for(var b = [], c = 0; c < a.length; c++)b[c] = goog.string.escapeChar(a.charAt(c));
                            return b.join("");
                        };
                        goog.string.escapeChar = function(a) {
                            if (a in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a];
                            if (a in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
                            var b = a.charCodeAt(0);
                            if (31 < b && 127 > b) var c = a;
                            else {
                                if (256 > b) {
                                    if (c = "\\x", 16 > b || 256 < b) c += "0";
                                } else c = "\\u", 4096 > b && (c += "0");
                                c += b.toString(16).toUpperCase();
                            }
                            return goog.string.jsEscapeCache_[a] = c;
                        };
                        goog.string.contains = goog.string.internal.contains;
                        goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
                        goog.string.countOf = function(a, b) {
                            return a && b ? a.split(b).length - 1 : 0;
                        };
                        goog.string.removeAt = function(a, b, c) {
                            var d = a;
                            0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
                            return d;
                        };
                        goog.string.remove = function(a, b) {
                            return a.replace(b, "");
                        };
                        goog.string.removeAll = function(a, b) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, "");
                        };
                        goog.string.replaceAll = function(a, b, c) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, c.replace(/\$/g, "$$$$"));
                        };
                        goog.string.regExpEscape = function(a) {
                            return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
                        };
                        goog.string.repeat = String.prototype.repeat ? function(a, b) {
                            return a.repeat(b);
                        } : function(a, b) {
                            return Array(b + 1).join(a);
                        };
                        goog.string.padNumber = function(a, b, c) {
                            a = void 0 !== c ? a.toFixed(c) : String(a);
                            c = a.indexOf(".");
                            -1 == c && (c = a.length);
                            return goog.string.repeat("0", Math.max(0, b - c)) + a;
                        };
                        goog.string.makeSafe = function(a) {
                            return null == a ? "" : String(a);
                        };
                        goog.string.buildString = function(a) {
                            return Array.prototype.join.call(arguments, "");
                        };
                        goog.string.getRandomString = function() {
                            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
                        };
                        goog.string.compareVersions = goog.string.internal.compareVersions;
                        goog.string.hashCode = function(a) {
                            for(var b = 0, c = 0; c < a.length; ++c)b = 31 * b + a.charCodeAt(c) >>> 0;
                            return b;
                        };
                        goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
                        goog.string.createUniqueString = function() {
                            return "goog_" + goog.string.uniqueStringCounter_++;
                        };
                        goog.string.toNumber = function(a) {
                            var b = Number(a);
                            return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
                        };
                        goog.string.isLowerCamelCase = function(a) {
                            return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
                        };
                        goog.string.isUpperCamelCase = function(a) {
                            return /^([A-Z][a-z]*)+$/.test(a);
                        };
                        goog.string.toCamelCase = function(a) {
                            return String(a).replace(/\-([a-z])/g, function(b, c) {
                                return c.toUpperCase();
                            });
                        };
                        goog.string.toSelectorCase = function(a) {
                            return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
                        };
                        goog.string.toTitleCase = function(a, b) {
                            b = "string" === typeof b ? goog.string.regExpEscape(b) : "\\s";
                            return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(c, d, e) {
                                return d + e.toUpperCase();
                            });
                        };
                        goog.string.capitalize = function(a) {
                            return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
                        };
                        goog.string.parseInt = function(a) {
                            isFinite(a) && (a = String(a));
                            return "string" === typeof a ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
                        };
                        goog.string.splitLimit = function(a, b, c) {
                            a = a.split(b);
                            for(var d = []; 0 < c && a.length;)d.push(a.shift()), c--;
                            a.length && d.push(a.join(b));
                            return d;
                        };
                        goog.string.lastComponent = function(a, b) {
                            if (b) "string" == typeof b && (b = [
                                b
                            ]);
                            else return a;
                            for(var c = -1, d = 0; d < b.length; d++)if ("" != b[d]) {
                                var e = a.lastIndexOf(b[d]);
                                e > c && (c = e);
                            }
                            return -1 == c ? a : a.slice(c + 1);
                        };
                        goog.string.editDistance = function(a, b) {
                            var c = [], d = [];
                            if (a == b) return 0;
                            if (!a.length || !b.length) return Math.max(a.length, b.length);
                            for(var e = 0; e < b.length + 1; e++)c[e] = e;
                            for(e = 0; e < a.length; e++){
                                d[0] = e + 1;
                                for(var f = 0; f < b.length; f++)d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
                                for(f = 0; f < c.length; f++)c[f] = d[f];
                            }
                            return d[b.length];
                        };
                        goog.proto2 = {};
                        goog.proto2.Descriptor = function(a, b, c) {
                            this.messageType_ = a;
                            this.name_ = b.name || null;
                            this.fullName_ = b.fullName || null;
                            this.containingType_ = b.containingType;
                            this.fields_ = {};
                            for(a = 0; a < c.length; a++)b = c[a], this.fields_[b.getTag()] = b;
                        };
                        goog.proto2.Descriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.Descriptor.prototype.getFullName = function() {
                            return this.fullName_;
                        };
                        goog.proto2.Descriptor.prototype.getContainingType = function() {
                            return this.containingType_ ? this.containingType_.getDescriptor() : null;
                        };
                        goog.proto2.Descriptor.prototype.getFields = function() {
                            var a = goog.object.getValues(this.fields_);
                            module$contents$goog$array_sort(a, function(b, c) {
                                return b.getTag() - c.getTag();
                            });
                            return a;
                        };
                        goog.proto2.Descriptor.prototype.getFieldsMap = function() {
                            return this.fields_;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
                            return goog.object.findValue(this.fields_, function(b, c, d) {
                                return b.getName() == a;
                            }) || null;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
                            goog.asserts.assert(goog.string.isNumeric(a));
                            return this.fields_[parseInt(a, 10)] || null;
                        };
                        goog.proto2.Descriptor.prototype.createMessageInstance = function() {
                            return new this.messageType_;
                        };
                        goog.proto2.FieldDescriptor = function(a, b, c) {
                            this.parent_ = a;
                            goog.asserts.assert(goog.string.isNumeric(b));
                            this.tag_ = b;
                            this.name_ = c.name;
                            this.isPacked_ = !!c.packed;
                            this.isRepeated_ = !!c.repeated;
                            this.isRequired_ = !!c.required;
                            this.fieldType_ = c.fieldType;
                            this.nativeType_ = c.type;
                            this.deserializationConversionPermitted_ = !1;
                            switch(this.fieldType_){
                                case goog.proto2.FieldDescriptor.FieldType.INT64:
                                case goog.proto2.FieldDescriptor.FieldType.UINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                                case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                                    this.deserializationConversionPermitted_ = !0;
                            }
                            this.defaultValue_ = c.defaultValue;
                        };
                        goog.proto2.FieldDescriptor.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.FieldDescriptor.prototype.getTag = function() {
                            return this.tag_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
                            return this.parent_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
                            if (void 0 === this.defaultValue_) {
                                var a = this.nativeType_;
                                if (a === Boolean) this.defaultValue_ = !1;
                                else if (a === Number) this.defaultValue_ = 0;
                                else if (a === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
                                else return new a;
                            }
                            return this.defaultValue_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
                            return this.fieldType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
                            return this.nativeType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
                            return this.deserializationConversionPermitted_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
                            return this.nativeType_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
                            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
                        };
                        goog.proto2.FieldDescriptor.prototype.isPacked = function() {
                            return this.isPacked_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
                            return this.isRepeated_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRequired = function() {
                            return this.isRequired_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isOptional = function() {
                            return !this.isRepeated_ && !this.isRequired_;
                        };
                        goog.proto2.Message = function() {
                            this.values_ = {};
                            this.fields_ = this.getDescriptor().getFieldsMap();
                            this.deserializedFields_ = this.lazyDeserializer_ = null;
                        };
                        goog.proto2.Message.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
                            this.lazyDeserializer_ = a;
                            this.values_ = b;
                            this.deserializedFields_ = {};
                        };
                        goog.proto2.Message.prototype.setUnknown = function(a, b) {
                            goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
                            goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
                            goog.asserts.assert(null !== b, "Value cannot be null");
                            this.values_[a] = b;
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
                            b = b || this;
                            for(var c in this.values_){
                                var d = Number(c);
                                this.fields_[d] || a.call(b, d, this.values_[c]);
                            }
                        };
                        goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
                        goog.proto2.Message.prototype.has = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.has$Value(a.getTag());
                        };
                        goog.proto2.Message.prototype.arrayOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.array$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.countOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.count$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.get = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.getOrDefault = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$ValueOrDefault(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.set = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.set$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.add = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.add$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.clear = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.clear$Field(a.getTag());
                        };
                        goog.proto2.Message.prototype.equals = function(a) {
                            if (!a || this.constructor != a.constructor) return !1;
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (this.has$Value(e) != a.has$Value(e)) return !1;
                                if (this.has$Value(e)) {
                                    var f = d.isCompositeType(), g = this.getValueForTag_(e);
                                    e = a.getValueForTag_(e);
                                    if (d.isRepeated()) {
                                        if (g.length != e.length) return !1;
                                        for(d = 0; d < g.length; d++){
                                            var h = g[d], k = e[d];
                                            if (f ? !h.equals(k) : h != k) return !1;
                                        }
                                    } else if (f ? !g.equals(e) : g != e) return !1;
                                }
                            }
                            return !0;
                        };
                        goog.proto2.Message.prototype.copyFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
                        };
                        goog.proto2.Message.prototype.mergeFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (a.has$Value(e)) {
                                    this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
                                    var f = d.isCompositeType();
                                    if (d.isRepeated()) {
                                        d = a.array$Values(e);
                                        for(var g = 0; g < d.length; g++)this.add$Value(e, f ? d[g].clone() : d[g]);
                                    } else d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.clone = function() {
                            var a = new this.constructor;
                            a.copyFrom(this);
                            return a;
                        };
                        goog.proto2.Message.prototype.initDefaults = function(a) {
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag(), f = d.isCompositeType();
                                this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
                                if (f) {
                                    if (d.isRepeated()) for(d = this.array$Values(e), e = 0; e < d.length; e++)d[e].initDefaults(a);
                                    else this.get$Value(e).initDefaults(a);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.has$Value = function(a) {
                            return null != this.values_[a];
                        };
                        goog.proto2.Message.prototype.getValueForTag_ = function(a) {
                            var b = this.values_[a];
                            return null == b ? null : this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b;
                        };
                        goog.proto2.Message.prototype.get$Value = function(a, b) {
                            var c = this.getValueForTag_(a);
                            return this.fields_[a].isRepeated() ? (a = b || 0, goog.asserts.assert(0 <= a && a < c.length, "Given index %s is out of bounds.  Repeated field length: %s", a, c.length), c[a]) : c;
                        };
                        goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
                            return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
                        };
                        goog.proto2.Message.prototype.array$Values = function(a) {
                            return this.getValueForTag_(a) || [];
                        };
                        goog.proto2.Message.prototype.count$Values = function(a) {
                            return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
                        };
                        goog.proto2.Message.prototype.set$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] = b;
                            this.deserializedFields_ && (this.deserializedFields_[a] = b);
                        };
                        goog.proto2.Message.prototype.add$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] || (this.values_[a] = []);
                            this.values_[a].push(b);
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
                            a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
                        };
                        goog.proto2.Message.prototype.clear$Field = function(a) {
                            delete this.values_[a];
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.createDescriptor = function(a, b) {
                            var c = [], d = b[0], e;
                            for(e in b)0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
                            return new goog.proto2.Descriptor(a, d, c);
                        };
                        goog.proto2.Serializer = function() {};
                        goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
                        goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
                            return a.isCompositeType() ? this.serialize(b) : "number" !== typeof b || isFinite(b) ? b : b.toString();
                        };
                        goog.proto2.Serializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            this.deserializeTo(a, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
                            if (a.isCompositeType()) return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
                            if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && "string" === typeof b && (a = a.getNativeType(), a.hasOwnProperty(b)) ? a[b] : "string" === typeof b && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (a = Number(b), 0 < a) ? a : b;
                            if (!a.deserializationConversionPermitted()) return b;
                            a = a.getNativeType();
                            if (a === String) {
                                if ("number" === typeof b) return String(b);
                            } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) return Number(b);
                            return b;
                        };
                        goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
                        goog.proto2.LazyDeserializer = function() {};
                        goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
                        goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            a.initializeForLazyDeserializer(this, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
                            throw Error("Unimplemented");
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
                        goog.proto2.PbLiteSerializer = function() {};
                        goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
                        goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
                        goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
                            this.zeroIndexing_ = a;
                        };
                        goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
                            for(var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++){
                                var f = b[e];
                                if (a.has(f)) {
                                    var g = f.getTag();
                                    g = d ? g - 1 : g;
                                    if (f.isRepeated()) {
                                        c[g] = [];
                                        for(var h = 0; h < a.countOf(f); h++)c[g][h] = this.getSerializedValue(f, a.get(f, h));
                                    } else c[g] = this.getSerializedValue(f, a.get(f));
                                }
                            }
                            a.forEachUnknown(function(k, l) {
                                c[d ? k - 1 : k] = l;
                            });
                            return c;
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
                            if (null == c) return c;
                            if (b.isRepeated()) {
                                a = [];
                                goog.asserts.assert(Array.isArray(c), "Value must be array: %s", c);
                                for(var d = 0; d < c.length; d++)a[d] = this.getDeserializedValue(b, c[d]);
                                return a;
                            }
                            return this.getDeserializedValue(b, c);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert("number" === typeof b || "boolean" === typeof b, "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
                            var c = b;
                            if (this.zeroIndexing_) {
                                c = [];
                                for(var d in b)c[parseInt(d, 10) + 1] = b[d];
                            }
                            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
                        };
                        goog.string.StringBuffer = function(a, b) {
                            null != a && this.append.apply(this, arguments);
                        };
                        goog.string.StringBuffer.prototype.buffer_ = "";
                        goog.string.StringBuffer.prototype.set = function(a) {
                            this.buffer_ = "" + a;
                        };
                        goog.string.StringBuffer.prototype.append = function(a, b, c) {
                            this.buffer_ += String(a);
                            if (null != b) for(var d = 1; d < arguments.length; d++)this.buffer_ += arguments[d];
                            return this;
                        };
                        goog.string.StringBuffer.prototype.clear = function() {
                            this.buffer_ = "";
                        };
                        goog.string.StringBuffer.prototype.getLength = function() {
                            return this.buffer_.length;
                        };
                        goog.string.StringBuffer.prototype.toString = function() {
                            return this.buffer_;
                        }; /*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        var i18n = {
                            phonenumbers: {}
                        };
                        i18n.phonenumbers.NumberFormat = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
                        i18n.phonenumbers.NumberFormat.descriptor_ = null;
                        i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
                            return this.get$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
                            return this.get$ValueOrDefault(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
                            this.add$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
                            return this.array$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumberDesc = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
                            return this.get$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
                            return this.get$ValueOrDefault(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
                            this.add$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
                            return this.array$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
                            return this.get$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
                            return this.get$ValueOrDefault(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
                            this.add$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
                            return this.array$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
                            return this.get$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
                            return this.get$ValueOrDefault(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
                            this.set$Value(21, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
                            return this.has$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
                            return this.count$Values(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
                            this.clear$Field(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
                            return this.get$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
                            return this.get$ValueOrDefault(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
                            this.set$Value(25, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
                            return this.has$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
                            return this.count$Values(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
                            this.clear$Field(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
                            return this.get$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
                            return this.get$ValueOrDefault(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
                            this.set$Value(27, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
                            return this.has$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
                            return this.count$Values(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
                            this.clear$Field(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
                            return this.get$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
                            return this.get$ValueOrDefault(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
                            this.set$Value(28, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
                            return this.has$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
                            return this.count$Values(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
                            this.clear$Field(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
                            return this.get$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
                            return this.get$ValueOrDefault(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a) {
                            this.set$Value(29, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
                            return this.has$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
                            return this.count$Values(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
                            this.clear$Field(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
                            return this.get$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
                            return this.get$ValueOrDefault(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a) {
                            this.set$Value(30, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
                            return this.has$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
                            return this.count$Values(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
                            this.clear$Field(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
                            return this.get$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
                            return this.get$ValueOrDefault(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a) {
                            this.set$Value(31, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
                            return this.has$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
                            return this.count$Values(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
                            this.clear$Field(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
                            return this.get$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
                            return this.get$ValueOrDefault(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a) {
                            this.set$Value(33, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
                            return this.has$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
                            return this.count$Values(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
                            this.clear$Field(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
                            return this.get$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
                            return this.get$ValueOrDefault(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
                            this.set$Value(24, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
                            return this.has$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
                            return this.count$Values(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
                            this.clear$Field(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
                            return this.get$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
                            return this.get$ValueOrDefault(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
                            this.set$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
                            return this.get$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
                            this.set$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
                            return this.get$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
                            this.set$Value(11, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
                            return this.has$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
                            return this.count$Values(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
                            this.clear$Field(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
                            return this.get$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
                            this.set$Value(17, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
                            return this.has$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
                            return this.count$Values(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
                            this.clear$Field(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
                            return this.get$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
                            this.set$Value(12, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
                            return this.has$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
                            return this.count$Values(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
                            this.clear$Field(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
                            return this.get$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
                            this.set$Value(13, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
                            return this.has$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
                            return this.count$Values(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
                            this.clear$Field(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
                            return this.get$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
                            return this.get$ValueOrDefault(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
                            this.set$Value(15, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
                            return this.has$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
                            return this.count$Values(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
                            this.clear$Field(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
                            return this.get$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
                            return this.get$ValueOrDefault(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
                            this.set$Value(16, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
                            return this.has$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
                            return this.count$Values(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
                            this.clear$Field(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
                            return this.get$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
                            return this.get$ValueOrDefault(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
                            this.set$Value(18, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
                            return this.has$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
                            return this.count$Values(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
                            this.clear$Field(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
                            return this.get$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
                            this.add$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
                            return this.array$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
                            return this.has$Value(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
                            return this.count$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
                            this.clear$Field(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
                            return this.get$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
                            this.add$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
                            return this.array$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
                            return this.has$Value(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
                            return this.count$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
                            this.clear$Field(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
                            return this.get$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
                            return this.get$ValueOrDefault(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
                            this.set$Value(22, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
                            return this.has$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
                            return this.count$Values(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
                            this.clear$Field(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
                            return this.get$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
                            return this.get$ValueOrDefault(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
                            this.set$Value(23, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
                            return this.has$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
                            return this.count$Values(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
                            this.clear$Field(23);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
                            return this.get$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
                            return this.get$ValueOrDefault(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
                            this.add$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
                            return this.array$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.NumberFormat.descriptor_;
                            a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {
                                0: {
                                    name: "NumberFormat",
                                    fullName: "i18n.phonenumbers.NumberFormat"
                                },
                                1: {
                                    name: "pattern",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                2: {
                                    name: "format",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                3: {
                                    name: "leading_digits_pattern",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "national_prefix_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "national_prefix_optional_when_formatting",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                5: {
                                    name: "domestic_carrier_code_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                                0: {
                                    name: "PhoneNumberDesc",
                                    fullName: "i18n.phonenumbers.PhoneNumberDesc"
                                },
                                2: {
                                    name: "national_number_pattern",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                9: {
                                    name: "possible_length",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                10: {
                                    name: "possible_length_local_only",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                6: {
                                    name: "example_number",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                                0: {
                                    name: "PhoneMetadata",
                                    fullName: "i18n.phonenumbers.PhoneMetadata"
                                },
                                1: {
                                    name: "general_desc",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                2: {
                                    name: "fixed_line",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                3: {
                                    name: "mobile",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                4: {
                                    name: "toll_free",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                5: {
                                    name: "premium_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                6: {
                                    name: "shared_cost",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                7: {
                                    name: "personal_number",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                8: {
                                    name: "voip",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                21: {
                                    name: "pager",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                25: {
                                    name: "uan",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                27: {
                                    name: "emergency",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                28: {
                                    name: "voicemail",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                29: {
                                    name: "short_code",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                30: {
                                    name: "standard_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                31: {
                                    name: "carrier_specific",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                33: {
                                    name: "sms_services",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                24: {
                                    name: "no_international_dialling",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                9: {
                                    name: "id",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                10: {
                                    name: "country_code",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                11: {
                                    name: "international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                17: {
                                    name: "preferred_international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                12: {
                                    name: "national_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                13: {
                                    name: "preferred_extn_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                15: {
                                    name: "national_prefix_for_parsing",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                16: {
                                    name: "national_prefix_transform_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                18: {
                                    name: "same_mobile_and_fixed_line_pattern",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                19: {
                                    name: "number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                20: {
                                    name: "intl_number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                22: {
                                    name: "main_country_for_code",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                23: {
                                    name: "leading_digits",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {
                                0: {
                                    name: "PhoneMetadataCollection",
                                    fullName: "i18n.phonenumbers.PhoneMetadataCollection"
                                },
                                1: {
                                    name: "metadata",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneMetadata
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumber = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumber.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneNumber.CountryCodeSource = {
                            UNSPECIFIED: 0,
                            FROM_NUMBER_WITH_PLUS_SIGN: 1,
                            FROM_NUMBER_WITH_IDD: 5,
                            FROM_NUMBER_WITHOUT_PLUS_SIGN: 10,
                            FROM_DEFAULT_COUNTRY: 20
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumber.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                                0: {
                                    name: "PhoneNumber",
                                    fullName: "i18n.phonenumbers.PhoneNumber"
                                },
                                1: {
                                    name: "country_code",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                2: {
                                    name: "national_number",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.UINT64,
                                    type: Number
                                },
                                3: {
                                    name: "extension",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "italian_leading_zero",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    type: Boolean
                                },
                                8: {
                                    name: "number_of_leading_zeros",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    defaultValue: 1,
                                    type: Number
                                },
                                5: {
                                    name: "raw_input",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "country_code_source",
                                    fieldType: goog.proto2.Message.FieldType.ENUM,
                                    defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,
                                    type: i18n.phonenumbers.PhoneNumber.CountryCodeSource
                                },
                                7: {
                                    name: "preferred_domestic_carrier_code",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
                        i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor; /*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.metadata = {};
                        i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
                            1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
                            7: [
                                "RU",
                                "KZ"
                            ],
                            20: [
                                "EG"
                            ],
                            27: [
                                "ZA"
                            ],
                            30: [
                                "GR"
                            ],
                            31: [
                                "NL"
                            ],
                            32: [
                                "BE"
                            ],
                            33: [
                                "FR"
                            ],
                            34: [
                                "ES"
                            ],
                            36: [
                                "HU"
                            ],
                            39: [
                                "IT",
                                "VA"
                            ],
                            40: [
                                "RO"
                            ],
                            41: [
                                "CH"
                            ],
                            43: [
                                "AT"
                            ],
                            44: [
                                "GB",
                                "GG",
                                "IM",
                                "JE"
                            ],
                            45: [
                                "DK"
                            ],
                            46: [
                                "SE"
                            ],
                            47: [
                                "NO",
                                "SJ"
                            ],
                            48: [
                                "PL"
                            ],
                            49: [
                                "DE"
                            ],
                            51: [
                                "PE"
                            ],
                            52: [
                                "MX"
                            ],
                            53: [
                                "CU"
                            ],
                            54: [
                                "AR"
                            ],
                            55: [
                                "BR"
                            ],
                            56: [
                                "CL"
                            ],
                            57: [
                                "CO"
                            ],
                            58: [
                                "VE"
                            ],
                            60: [
                                "MY"
                            ],
                            61: [
                                "AU",
                                "CC",
                                "CX"
                            ],
                            62: [
                                "ID"
                            ],
                            63: [
                                "PH"
                            ],
                            64: [
                                "NZ"
                            ],
                            65: [
                                "SG"
                            ],
                            66: [
                                "TH"
                            ],
                            81: [
                                "JP"
                            ],
                            82: [
                                "KR"
                            ],
                            84: [
                                "VN"
                            ],
                            86: [
                                "CN"
                            ],
                            90: [
                                "TR"
                            ],
                            91: [
                                "IN"
                            ],
                            92: [
                                "PK"
                            ],
                            93: [
                                "AF"
                            ],
                            94: [
                                "LK"
                            ],
                            95: [
                                "MM"
                            ],
                            98: [
                                "IR"
                            ],
                            211: [
                                "SS"
                            ],
                            212: [
                                "MA",
                                "EH"
                            ],
                            213: [
                                "DZ"
                            ],
                            216: [
                                "TN"
                            ],
                            218: [
                                "LY"
                            ],
                            220: [
                                "GM"
                            ],
                            221: [
                                "SN"
                            ],
                            222: [
                                "MR"
                            ],
                            223: [
                                "ML"
                            ],
                            224: [
                                "GN"
                            ],
                            225: [
                                "CI"
                            ],
                            226: [
                                "BF"
                            ],
                            227: [
                                "NE"
                            ],
                            228: [
                                "TG"
                            ],
                            229: [
                                "BJ"
                            ],
                            230: [
                                "MU"
                            ],
                            231: [
                                "LR"
                            ],
                            232: [
                                "SL"
                            ],
                            233: [
                                "GH"
                            ],
                            234: [
                                "NG"
                            ],
                            235: [
                                "TD"
                            ],
                            236: [
                                "CF"
                            ],
                            237: [
                                "CM"
                            ],
                            238: [
                                "CV"
                            ],
                            239: [
                                "ST"
                            ],
                            240: [
                                "GQ"
                            ],
                            241: [
                                "GA"
                            ],
                            242: [
                                "CG"
                            ],
                            243: [
                                "CD"
                            ],
                            244: [
                                "AO"
                            ],
                            245: [
                                "GW"
                            ],
                            246: [
                                "IO"
                            ],
                            247: [
                                "AC"
                            ],
                            248: [
                                "SC"
                            ],
                            249: [
                                "SD"
                            ],
                            250: [
                                "RW"
                            ],
                            251: [
                                "ET"
                            ],
                            252: [
                                "SO"
                            ],
                            253: [
                                "DJ"
                            ],
                            254: [
                                "KE"
                            ],
                            255: [
                                "TZ"
                            ],
                            256: [
                                "UG"
                            ],
                            257: [
                                "BI"
                            ],
                            258: [
                                "MZ"
                            ],
                            260: [
                                "ZM"
                            ],
                            261: [
                                "MG"
                            ],
                            262: [
                                "RE",
                                "YT"
                            ],
                            263: [
                                "ZW"
                            ],
                            264: [
                                "NA"
                            ],
                            265: [
                                "MW"
                            ],
                            266: [
                                "LS"
                            ],
                            267: [
                                "BW"
                            ],
                            268: [
                                "SZ"
                            ],
                            269: [
                                "KM"
                            ],
                            290: [
                                "SH",
                                "TA"
                            ],
                            291: [
                                "ER"
                            ],
                            297: [
                                "AW"
                            ],
                            298: [
                                "FO"
                            ],
                            299: [
                                "GL"
                            ],
                            350: [
                                "GI"
                            ],
                            351: [
                                "PT"
                            ],
                            352: [
                                "LU"
                            ],
                            353: [
                                "IE"
                            ],
                            354: [
                                "IS"
                            ],
                            355: [
                                "AL"
                            ],
                            356: [
                                "MT"
                            ],
                            357: [
                                "CY"
                            ],
                            358: [
                                "FI",
                                "AX"
                            ],
                            359: [
                                "BG"
                            ],
                            370: [
                                "LT"
                            ],
                            371: [
                                "LV"
                            ],
                            372: [
                                "EE"
                            ],
                            373: [
                                "MD"
                            ],
                            374: [
                                "AM"
                            ],
                            375: [
                                "BY"
                            ],
                            376: [
                                "AD"
                            ],
                            377: [
                                "MC"
                            ],
                            378: [
                                "SM"
                            ],
                            380: [
                                "UA"
                            ],
                            381: [
                                "RS"
                            ],
                            382: [
                                "ME"
                            ],
                            383: [
                                "XK"
                            ],
                            385: [
                                "HR"
                            ],
                            386: [
                                "SI"
                            ],
                            387: [
                                "BA"
                            ],
                            389: [
                                "MK"
                            ],
                            420: [
                                "CZ"
                            ],
                            421: [
                                "SK"
                            ],
                            423: [
                                "LI"
                            ],
                            500: [
                                "FK"
                            ],
                            501: [
                                "BZ"
                            ],
                            502: [
                                "GT"
                            ],
                            503: [
                                "SV"
                            ],
                            504: [
                                "HN"
                            ],
                            505: [
                                "NI"
                            ],
                            506: [
                                "CR"
                            ],
                            507: [
                                "PA"
                            ],
                            508: [
                                "PM"
                            ],
                            509: [
                                "HT"
                            ],
                            590: [
                                "GP",
                                "BL",
                                "MF"
                            ],
                            591: [
                                "BO"
                            ],
                            592: [
                                "GY"
                            ],
                            593: [
                                "EC"
                            ],
                            594: [
                                "GF"
                            ],
                            595: [
                                "PY"
                            ],
                            596: [
                                "MQ"
                            ],
                            597: [
                                "SR"
                            ],
                            598: [
                                "UY"
                            ],
                            599: [
                                "CW",
                                "BQ"
                            ],
                            670: [
                                "TL"
                            ],
                            672: [
                                "NF"
                            ],
                            673: [
                                "BN"
                            ],
                            674: [
                                "NR"
                            ],
                            675: [
                                "PG"
                            ],
                            676: [
                                "TO"
                            ],
                            677: [
                                "SB"
                            ],
                            678: [
                                "VU"
                            ],
                            679: [
                                "FJ"
                            ],
                            680: [
                                "PW"
                            ],
                            681: [
                                "WF"
                            ],
                            682: [
                                "CK"
                            ],
                            683: [
                                "NU"
                            ],
                            685: [
                                "WS"
                            ],
                            686: [
                                "KI"
                            ],
                            687: [
                                "NC"
                            ],
                            688: [
                                "TV"
                            ],
                            689: [
                                "PF"
                            ],
                            690: [
                                "TK"
                            ],
                            691: [
                                "FM"
                            ],
                            692: [
                                "MH"
                            ],
                            800: [
                                "001"
                            ],
                            808: [
                                "001"
                            ],
                            850: [
                                "KP"
                            ],
                            852: [
                                "HK"
                            ],
                            853: [
                                "MO"
                            ],
                            855: [
                                "KH"
                            ],
                            856: [
                                "LA"
                            ],
                            870: [
                                "001"
                            ],
                            878: [
                                "001"
                            ],
                            880: [
                                "BD"
                            ],
                            881: [
                                "001"
                            ],
                            882: [
                                "001"
                            ],
                            883: [
                                "001"
                            ],
                            886: [
                                "TW"
                            ],
                            888: [
                                "001"
                            ],
                            960: [
                                "MV"
                            ],
                            961: [
                                "LB"
                            ],
                            962: [
                                "JO"
                            ],
                            963: [
                                "SY"
                            ],
                            964: [
                                "IQ"
                            ],
                            965: [
                                "KW"
                            ],
                            966: [
                                "SA"
                            ],
                            967: [
                                "YE"
                            ],
                            968: [
                                "OM"
                            ],
                            970: [
                                "PS"
                            ],
                            971: [
                                "AE"
                            ],
                            972: [
                                "IL"
                            ],
                            973: [
                                "BH"
                            ],
                            974: [
                                "QA"
                            ],
                            975: [
                                "BT"
                            ],
                            976: [
                                "MN"
                            ],
                            977: [
                                "NP"
                            ],
                            979: [
                                "001"
                            ],
                            992: [
                                "TJ"
                            ],
                            993: [
                                "TM"
                            ],
                            994: [
                                "AZ"
                            ],
                            995: [
                                "GE"
                            ],
                            996: [
                                "KG"
                            ],
                            998: [
                                "UZ"
                            ]
                        };
                        i18n.phonenumbers.metadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[01589]\\d|[2-467])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "62889",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AC",
                                247,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-9]|[1589]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "542011",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[78]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "712345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "690\\d{6}|[356]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180[02]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[19]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AD",
                                376,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[135-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4679][2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[02-68]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "400\\d{6}|800\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "700012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AE",
                                971,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,9})",
                                        "$1 $2",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[236]|[479][2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[479]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[25]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "600212345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AF",
                                93,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:268|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684601234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684641234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "26848[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684801234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "AG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([457]\\d{6})$|1",
                                "268$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "26840[69]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684061234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "268",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:264|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2644612345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:235|4(?:69|7[67])|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2642351234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2457]\\d{6})$|1",
                                "264$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "264724\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2647241234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "264",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[78][2-9]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "808123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AL",
                                355,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "80|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2358][2-5]|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[23578]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-489]\\d|55|60|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "10123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-4]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "60271234"
                                ],
                                "AM",
                                374,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2|3[12]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "1|47"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[3-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-79]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "923123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AO",
                                244,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "60[04579]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AR",
                                54,
                                "00",
                                "0",
                                ,
                                ,
                                "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                                "9$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "91"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|684|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "684(?:274|6(?:22|33|44|55|77|88|9[19]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6846221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "684(?:2(?:48|5[2468]|7[246])|7(?:3[13]|70|82))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6847331234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([267]\\d{6})$|1",
                                "684$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "684",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "1234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                                    ,
                                    ,
                                    ,
                                    "664123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "810123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "780123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                "AT",
                                43,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[18]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                                            "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                                            "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "AU",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "(183[12])|0",
                                ,
                                "0011",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "13"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1802"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "130"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "163\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "1631234",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-79]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:2\\d|8[1-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5601234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28\\d|501)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5011234"
                                ],
                                "AW",
                                297,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[25-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "181234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AX",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "18",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "123123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "401234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "881234567"
                                ],
                                [
                                    ,
                                    ,
                                    "900200\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "900200123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AZ",
                                994,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "61123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0246]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "82123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BA",
                                387,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70341234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:246|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2462501234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:246976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "24631\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2463101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "BB",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "246$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "246",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "27111234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1812345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[03]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9604123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "BD",
                                880,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1-$2",
                                        [
                                            "31[5-8]|[459]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1-$2",
                                        [
                                            "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,6})",
                                        "$1-$2",
                                        [
                                            "[13-9]|2[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1-$2",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "450001234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7879\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78791234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BE",
                                32,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:80|9)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[239]|4[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[15-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78102345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[024-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20491234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-7]|4[4-6]|5[0-8]|[67]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BF",
                                226,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[024-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "43012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00800\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BG",
                                359,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "17001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "36001234"
                                ],
                                [
                                    ,
                                    ,
                                    "8[02369]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:87|9[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "84\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "84123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BH",
                                973,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[13679]|8[02-4679]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[267]\\d|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:29|6[1-9]|7[125-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79561234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BI",
                                257,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2367]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01\\d|8)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "012\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "0120211234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "01(?:2[5-9]|[4-69]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0195123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "857[58]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "85751234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "BJ",
                                229,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "BL",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:441|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4414123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4413701234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "441$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "441",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[89]|[78]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[34]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5345678"
                                ],
                                "BN",
                                673,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]\\d\\d|8001)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:57|[67]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "800171234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "50123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                "BO",
                                591,
                                "00(?:1\\d)?",
                                "0",
                                ,
                                ,
                                "0(1\\d)?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[23]|4[46]|50"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "[5-7]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|7\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7151234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BQ",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "[347]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "11961234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[59]00\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "500123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40041234",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BR",
                                55,
                                "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
                                "0",
                                ,
                                ,
                                "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
                                "$2",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3,6})",
                                        "$1",
                                        [
                                            "1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37|86)",
                                            "300|4(?:0(?:0|20)|370|864)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-57]",
                                            "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37|86)",
                                            "300|4(?:0(?:0|20)|370|864)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:242|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423591234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([3-8]\\d{6})$|1",
                                "242$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "242",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242225\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2422250123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d{7}|[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[67]|[78]7)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "17123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BT",
                                975,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-6]|7[246]|8[2-4]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|[78]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-6]|7[246]|8[2-4]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|[78]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2401234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:321|7(?:[1-8]\\d|9[03]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0800012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "79101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "BW",
                                267,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3[15-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "152450911",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "294911911",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:810|902)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "249\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "249123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "BY",
                                375,
                                "810",
                                "8",
                                ,
                                ,
                                "0|80?",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                                            "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "1(?:[56]|7[467])|2[1-3]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-4]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800\\d|[2-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-35-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234123",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BZ",
                                501,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5219023456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6002012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "CA",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "310\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891621234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CC",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{5}|(?:8[0-69]|9[016-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CD",
                                243,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[1-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "8776\\d{4}|(?:[27]\\d|61)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12]|61)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21612345"
                                ],
                                [
                                    ,
                                    ,
                                    "7[02-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8776\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "87761234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CF",
                                236,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[26-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:0\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "222[1-589]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "061234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-2]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CG",
                                242,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[02]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{11}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[89]|7[235-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "781234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "878\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "878123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CH",
                                41,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8[047]|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]|81"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[18]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "581234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "860\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "860123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[02]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "0[157]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "0123456789"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CI",
                                225,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "21234"
                                ],
                                [
                                    ,
                                    ,
                                    "[578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CK",
                                682,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:[24]\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|(?:600|80[1-9])\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:(?:[24]\\d|50)\\d|3(?:[034679]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389])|600)|646[59])|80[1-8]\\d\\d|9(?:(?:10[0-2]|7[1-9]\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:123|8)00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "441234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CL",
                                56,
                                "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1(?:[03-589]|21)|[29]0|78"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "60|809"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:10|[2-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "60|809"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:10|[2-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[26]\\d{8}|88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:22|33)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:24[23]|6(?:[25-9]\\d|4[0-2]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "671234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "88012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CM",
                                237,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]|88"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                                    ,
                                    ,
                                    ,
                                    "1012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:610\\d|740[0-5])\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "13123456789",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "16[08]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16812345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    "4001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CN",
                                86,
                                "00|1(?:[12]\\d|79)\\d\\d00",
                                "0",
                                ,
                                ,
                                "(1(?:[12]\\d|79)\\d\\d)|0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5,6})",
                                        "$1",
                                        [
                                            "1(?:00|2[13])|9[56]",
                                            "1(?:00|2(?:1|39))|9[56]",
                                            "1(?:00|2(?:1|395))|9[56]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5,6})",
                                        "$1",
                                        [
                                            "1(?:0|23)|781|[1-9]12",
                                            "1(?:0|23)|7812|[1-9]123",
                                            "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                                            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                                            "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "16[08]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                                            "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                                            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                                            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6012345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "3211234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:19(?:0[01]|4[78])|901)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CO",
                                57,
                                "00(?:4(?:[14]4|56)|[579])",
                                "0",
                                ,
                                ,
                                "0([3579]|4(?:[14]4|56))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "46"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6|90"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|9[14]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "46"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6|90"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|9[14]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "83123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[059]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "CR",
                                506,
                                "00",
                                ,
                                ,
                                ,
                                "(19(?:0[0-2468]|1[09]|20|66|77|99))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[89]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d|6[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "807\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8071234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CU",
                                53,
                                "119",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "2[1-4]|[34]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-59]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:36|5[1-389]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9911234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[3-5]|4[356])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3401234"
                                ],
                                "CV",
                                238,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "94351234"
                                ],
                                [
                                    ,
                                    ,
                                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CW",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3467]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[4-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "955\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95581234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                1,
                                "[69]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891641234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CX",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|[58]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:10|[4-79]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "96123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234"
                                ],
                                [
                                    ,
                                    ,
                                    "90[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CY",
                                357,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[257-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:50|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7060\\d{5}|(?:60[1-8]|7(?:0[2-5]|19|[2379]\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[05689]|76)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[134]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[17]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "910123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CZ",
                                420,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]|9[015-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "96"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|7[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "972123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:3\\d{9}|6\\d{7,10})",
                                    ,
                                    ,
                                    ,
                                    "93123456789"
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                                    ,
                                    ,
                                    ,
                                    "30123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:6[023]|7\\d)\\d{7,8}|15(?:[0-25-9]\\d\\d|3(?:10|33))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "15123456789",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    "8001234567890",
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "70012345678",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DE",
                                49,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,13})",
                                        "$1 $2",
                                        [
                                            "3[02]|40|[68]9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "227",
                                            "2277"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                                            "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,11})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                                            "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "138"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,11})",
                                        "$1 $2",
                                        [
                                            "181"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{4,10})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:3|80)|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,12})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "185",
                                            "1850",
                                            "18500"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "18[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "15[1279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "15[03568]",
                                            "15(?:[0568]|3[13])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "18"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{7,8})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6[023]|7)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "15[279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{8})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,13})",
                                        "$1 $2",
                                        [
                                            "3[02]|40|[68]9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                                            "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,11})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                                            "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "138"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,11})",
                                        "$1 $2",
                                        [
                                            "181"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{4,10})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:3|80)|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,12})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "185",
                                            "1850",
                                            "18500"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "18[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "15[1279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "15[03568]",
                                            "15(?:[0568]|3[13])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "18"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{7,8})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6[023]|7)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "15[279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{8})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "16(?:4\\d{1,10}|[89]\\d{1,11})",
                                    ,
                                    ,
                                    ,
                                    "16412345",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18(?:1\\d{5,11}|[2-9]\\d{8})",
                                    ,
                                    ,
                                    ,
                                    "18500123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "177991234567",
                                    ,
                                    ,
                                    [
                                        12,
                                        13
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1[2-5]|7[45])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21360003"
                                ],
                                [
                                    ,
                                    ,
                                    "77\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77831001"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DJ",
                                253,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[27]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "32123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "34412345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DK",
                                45,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|767|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7674201234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7672251234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "767$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "767",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[024]9[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DO",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8001|8[024]9",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9619\\d{5}|(?:[1-3]\\d|4[013-689])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:4[0-29]|6[0-4])\\d{6}|(?:55|6\\d|7[7-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "551234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[3-689]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[12]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "98[23]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "983123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "DZ",
                                213,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7][2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}|1[78]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7]890\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "28901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "EC",
                                593,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[2-7]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|[2-79]\\d\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[013-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40\\d\\d|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[0-2]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EE",
                                372,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                                            "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[45]|8(?:00|[1-49])",
                                            "[45]|8(?:00[1-9]|[1-49])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[0-25]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "1001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EG",
                                20,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "1[35]|[4-6]|8[2468]|9[235-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "528[89]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "528812345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "EH",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8370362",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[1-3]|7\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ER",
                                291,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[178]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:400|[5-9]\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:400|8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    "96906(?:09|10)\\d\\d|(?:590(?:10[0-2]|600)|97390\\d)\\d{3}|(?:6\\d|7[1-48])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[367]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "803123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ES",
                                34,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "905"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[79]9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[4-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[4-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "511234567"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[2-57-9]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:11(?:[124]\\d\\d|3(?:[0-79]\\d|8[0-7])|5(?:[02-9]\\d|1[0-57-9])|6(?:[02-79]\\d|1[0-57-9]|8[0-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "111112345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|2[1-35-79]|3\\d|77|86|99)|(?:8[01]|9\\d)\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "911234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ET",
                                251,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-57-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "131234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FI",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "75[12]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "11"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "1[03-79]|[2-9]",
                                [
                                    ,
                                    ,
                                    "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FJ",
                                679,
                                "0(?:0|52)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[235-9]|45"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FK",
                                500,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[39]\\d\\d|820)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3201234"
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3501234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FM",
                                691,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[389]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20|[34]\\d|8[19])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[27][1-9]|5\\d|9[136])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[257-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "802123"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "901123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[0-36]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "601234"
                                ],
                                "FO",
                                298,
                                "00",
                                ,
                                ,
                                ,
                                "(10(?:01|[12]0|88))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[01]|2[0156]|4[024]|84)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                "FR",
                                33,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "10"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[6-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "806123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[01]1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "01441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "06031234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GA",
                                241,
                                "00",
                                ,
                                ,
                                ,
                                "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "11|[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1212345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7400123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GB",
                                44,
                                "00",
                                "0",
                                " x",
                                ,
                                "0|180020",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "800",
                                            "8001",
                                            "80011",
                                            "800111",
                                            "8001111"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "845",
                                            "8454",
                                            "84546",
                                            "845464"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "1(?:38|5[23]|69|76|94)",
                                            "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                                            "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "1(?:[2-69][02-9]|[78])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[25]|7(?:0|6[02-9])",
                                            "[25]|7(?:0|6(?:[03-9]|2[356]))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1389]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:473|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4732691234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4734031234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GD",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "473$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "473",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3-57]\\d\\d|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "322123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0(?:1[09]|70)|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|1[12]|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-6])|4\\d\\d)|2(?:228|555)|3555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|4(?:44|55))|6[89]\\d\\d|7(?:(?:[0147-9]\\d|22)\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "555123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "706123456"
                                ],
                                "GE",
                                995,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "32"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5(?:[0-46-9]|5[0-57-9])|7",
                                            "5(?:[0-46-9]|5(?:[0-357-9]|44))|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-58]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:694\\d|7093)\\d{5}|(?:59|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59(?:4(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)|88\\d)|80[6-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "594101234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "694201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "890123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GF",
                                594,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]|80[6-9]|9[47]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1481[25-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1481256789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7781123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GG",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-9]\\d{5})$|0|180020",
                                "1481$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[235]\\d{8}|800\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "302345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "231234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GH",
                                233,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[237]|8[0-2]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2358]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2358]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{5,6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25]\\d|60)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "57123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GI",
                                350,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:19|[2-689]\\d|70)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "321000"
                                ],
                                [
                                    ,
                                    ,
                                    "[245]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "221234"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[89]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234"
                                ],
                                "GL",
                                299,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "19|[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-389]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5661234"
                                ],
                                [
                                    ,
                                    ,
                                    "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[4-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GM",
                                220,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "722\\d{6}|(?:3|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30241234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-356]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "722\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "722123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "GN",
                                224,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "3"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[67]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59(?:0(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GP",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-79]|80[6-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "333091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:222|55\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GQ",
                                240,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "6912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[19]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[16]|12|[27]5|50)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GR",
                                30,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2689]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5005000123",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[267][2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22456789",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[01]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "18001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "19001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GT",
                                502,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|671|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[16-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[16-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GU",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "671$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "671",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d{8}|4\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "443\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "443201234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|6[569]|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "955012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "40\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "GW",
                                245,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "40"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-8]\\d{3}|9008)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-79]|[78]0))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2891234"
                                ],
                                [
                                    ,
                                    ,
                                    "9008\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9008123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "515\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5151234"
                                ],
                                "GY",
                                592,
                                "001",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:(?:09|24)[3-6]|44[0-35-9]|6(?:4[0-57-9]|6[0-6])|7(?:4[0-48]|6[0-5]))|5(?:25[3-7]|35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-467]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-35])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                                    ,
                                    ,
                                    ,
                                    "90012345678",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HK",
                                852,
                                "00(?:30|5[09]|[126-9]?)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,5})",
                                        "$1 $2",
                                        [
                                            "900",
                                            "9003"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30161234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{10}|[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-8]|5[57]|6[2458]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589]|80)|5(?:0[2357-9]|1[1-6]|4[03-58]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|2[01]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[37-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80021234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HN",
                                504,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "921234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "6[01459]\\d{6}|6[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[45]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "74123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HR",
                                385,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[01]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "6|7[245]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-57]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "62\\d{6,7}|72\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-589]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22453300"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[34]\\d|5[568])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "34101234"
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "98901234"
                                ],
                                "HT",
                                509,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[235-7]\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[257]0|3[01])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "HU",
                                36,
                                "00",
                                "06",
                                ,
                                ,
                                "06",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "06 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "381234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    "218350123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-35-9]\\d{7,10}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8041234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ID",
                                62,
                                "00[89]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})",
                                        "$1 $2 $3 $4",
                                        [
                                            "001"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1500|8071\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8071123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2212345",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:22|[35-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1520123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1850123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "761234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IE",
                                353,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2[24-9]|47|58|6[237-9]|9[35-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[45]0"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2569]|4[1-69]|7[14]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "81"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "818\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "818123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8551234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        11,
                                        12
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55(?:4(?:0[0-3]|[16]0)|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[3-5]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "502345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:255|80[019]\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1212\\d{4}|1(?:200|9(?:0[0-2]|19|9\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1919123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:38(?:[05]\\d|8[0138])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IL",
                                972,
                                "0(?:0|1[2-9])",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "125"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "121"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "12"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "159"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1-$2 $3-$4",
                                        [
                                            "15"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1599\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1599123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "151\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "15112340000",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1624(?:230|[5-8]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1624756789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7924123456"
                                ],
                                [
                                    ,
                                    ,
                                    "808162\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8081624567"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9016247890"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "IM",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-8]\\d{5})$|0|180020",
                                "1624$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "74576|(?:16|7[56])24",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2717(?:[2-7]\\d|95)|6828[235-7]\\d)\\d{4}|(?:170[24]|280[13468]|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:271[0-689]|682[0-79]|782[0-6])[2-7]\\d{5}|(?:2(?:[02][2-79]|90)|3(?:23|80)|683|79[1-7])\\d{7}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[14-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7410410123",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:1279|828[01489])|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:160[01]|6(?:(?:12|[2-4]1|5[17]|6[13]|80)[0189]|7(?:1[0189]|86))|7(?:1(?:2[0189]|9[0-5])|3(?:2[5-8]|[34][017-9]|9[016-9])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:731|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|4[0189]|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-5])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:[024]\\d|3[05-8]|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "000800\\d{7}|180(?:0\\d{4,9}|3\\d{9})",
                                    ,
                                    ,
                                    ,
                                    "1800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "186[12]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "1861123456789",
                                    ,
                                    ,
                                    [
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1860\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18603451234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IN",
                                91,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{7})",
                                        "$1",
                                        [
                                            "575"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "16|[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "18[06]",
                                            "18[06]0"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "16|[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "18[06]",
                                            "18[06]0"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1800\\d{4,9}|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    "140\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1409305260",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IO: [
                                ,
                                [
                                    ,
                                    ,
                                    "3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "37\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3709100"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IO",
                                246,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IQ",
                                964,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:[02689]0\\d|121)|4(?:111|40\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|3[0-2]|88)|9(?:[01359]\\d|21|69|77|8[7-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IR",
                                98,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "96"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                                    ,
                                    ,
                                    ,
                                    "9601",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:38\\d|[4-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6111234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "49[0-24-79]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4921234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "IS",
                                354,
                                "00|1(?:0(?:01|[12]0)|100)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[4-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8091234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6891234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "0212345678"
                                ],
                                [
                                    ,
                                    ,
                                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "IT",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1(?:0|9[246])",
                                            "1(?:0|9(?:2[2-9]|[46]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1(?:1|92)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]|43"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "[03]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]|43"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "[03]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "848\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1534[0-24-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1534456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7797712345"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:07(?:35|81)|8901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8007354567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9018105678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "701511\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7015115678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "JE",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([0-24-8]\\d{5})$|0|180020",
                                "1534$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|658|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8766060\\d{3}|(?:658(?:2(?:[5-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8765230123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6582(?:[0-4]\\d|95)|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8762101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "658|876",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "62001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:427|7(?:[78][0-25-9]|9\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "790123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JO",
                                962,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2356]|87"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[47]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74(?:66|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "746612345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|8\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[6-9]0[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                                    ,
                                    ,
                                    ,
                                    "120123456"
                                ],
                                [
                                    ,
                                    ,
                                    "990\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "JP",
                                81,
                                "010",
                                "0",
                                ,
                                ,
                                "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "007",
                                            "0077",
                                            "00777",
                                            "00777[01]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{8,10})",
                                        "$1",
                                        [
                                            "000"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "3|4(?:2[09]|7[01])|6[1-9]",
                                            "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "007",
                                            "0077"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "008"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[25-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})(\\d{5,6})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})(\\d{6,7})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "3|4(?:2[09]|7[01])|6[1-9]",
                                            "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[25-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "2012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
                                ],
                                [
                                    ,
                                    ,
                                    "570\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "570123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "202012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0[0-8]|[18]\\d|2[014]|30|4[0-5])|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[02-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800223456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[02-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900223456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KE",
                                254,
                                "000",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "[24-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[17]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[235-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KG",
                                996,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3(?:1[346]|[24-79])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235-79]|88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9}|[1-9]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                                    ,
                                    ,
                                    ,
                                    "23756789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800(?:1\\d|2[019])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900(?:1\\d|2[09])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KH",
                                855,
                                "00[14-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "30010000",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "KI",
                                686,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3478]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[4-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[34]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "3212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KM",
                                269,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[3478]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8692361234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8697652917",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KN",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "869$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "869",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19[1-3]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1921234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KP",
                                850,
                                "00|99",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "1020000000",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "602345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KR",
                                82,
                                "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
                                "0",
                                ,
                                ,
                                "0(8(?:[1-46-8]|5\\d\\d))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "1[016-9]1",
                                            "1[016-9]11",
                                            "1[016-9]114"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]0|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "003",
                                            "0030"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]0|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "1523456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "15441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KW",
                                965,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[169]|2(?:[235]|4[1-35-9])|52"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[245]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:345|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3452221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:32[1-9]|4(?:1[2-6]|2[0-4])|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3453231234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:345976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KY",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "345$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "345",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{13}|[78]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7710009998",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7511234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KZ",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "7",
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21212862",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2023123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LA",
                                856,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2[13]|3[14]|[4-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[27-9]\\d{7}|[13-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[0-4]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LB",
                                961,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|758|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7584305678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7582845678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-8]\\d{6})$|1",
                                "758$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "758",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-68]\\d|1[01]|3[7-9]|70))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "660234567"
                                ],
                                [
                                    ,
                                    ,
                                    "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8002222"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "9002222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LI",
                                423,
                                "00",
                                "0",
                                ,
                                ,
                                "(1001)|0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2379]|8(?:0[09]|7)",
                                            "[2379]|8(?:0(?:02|9)|7)"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "69"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "870(?:28|87)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8702812",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "697(?:42|56|[78]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "697861234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LK",
                                94,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[1-689]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1973\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "197312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "770123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "332(?:02|[34]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "332021234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LR",
                                231,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4[67]|[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-578]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800[1256]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80021234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LS",
                                266,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2568]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3469]\\d|52|[78]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1478]|4[124-6]|52)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567"
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "61234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[0239]|10)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    "70[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]01\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                "LT",
                                370,
                                "00",
                                "0",
                                ,
                                ,
                                "[08]",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "52[0-7]"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0 $1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "37|4(?:[15]|6[1-8])"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[3-6]"
                                        ],
                                        "(0-$1)",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70712345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "27123456"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[26][18]|5[1568]|7[189]|81|9[128])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "628123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[015]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:1\\d{5}|[2-689]\\d{1,7})",
                                    ,
                                    ,
                                    ,
                                    "20201234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                "LU",
                                352,
                                "00",
                                ,
                                ,
                                ,
                                "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "20[2-689]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "20"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "80[01]|90[015]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "20"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "20"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[268]\\d|78|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "63123456"
                                ],
                                [
                                    ,
                                    ,
                                    "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LV",
                                371,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2679]|8[01]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-6]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LY",
                                218,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:(?:18|4[0679]|5[03])\\d|2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-9])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "520123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "MA",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1-$2",
                                        [
                                            "892"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "8(?:0[0-7]|9)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[5-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[5-8]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3489]|[67]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:870|9[2-47-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "99123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|[67]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:800|90\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MC",
                                377,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8[07]0\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[235-7]\\d|[89]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62112345"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[056]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30123456"
                                ],
                                "MD",
                                373,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "22|3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[25-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "803\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "60123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[0-2578]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80080002"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4[1568]|5[178])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "94515151",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[1-49]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "78108780",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "ME",
                                382,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "77273012",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "MF",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "202123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "321234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                "MG",
                                261,
                                "00",
                                "0",
                                ,
                                ,
                                "([24-9]\\d{6})$|0",
                                "20$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:247|528|625)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2471234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:23|54)5|329|45[35-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2351234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "635\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6351234"
                                ],
                                "MH",
                                692,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-6]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22012345",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MK",
                                389,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2|34[47]|4(?:[37]7|5[47]|64)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[347]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[58]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[24-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20212345"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "65012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ML",
                                223,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "67[057-9]|74[045]",
                                            "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80080(?:0[1-9]|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8008001234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1333\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "13331234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MM",
                                95,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]|452|678|86",
                                            "[12]|452|6788|86"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[4-7]|8[1-35]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4,6})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:2[0-4]|[35-9]|4[137-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "92"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{7,9}|[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12](?:2[1-3]|(?:3[2-8]|4[2-68]|5[1-4689])\\d)\\d{5,6}|7(?:0(?:[0-5]\\d|7[078]|80)|128)\\d{4}|[12]27\\d{6}|(?:11|2[16]|5[368])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "53123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:87[01]|92[0139])\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "75123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MN",
                                976,
                                "001",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[16]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12]2[1-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "[12]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "28212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "66123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800501",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MO",
                                853,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[268]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:67|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MP",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "670$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "670",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "7091\\d{5}|(?:[56]9|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59(?:6(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|89\\d)|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "596301234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "696201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976612345"
                                ],
                                "MQ",
                                596,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-79]|8(?:0[6-9]|[36])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-4]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25[08]|35\\d|45[1-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "35123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4][0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MR",
                                222,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-48]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|664|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6644(?:1[0-3]|91)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644912345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644923456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([34]\\d{6})$|1",
                                "664$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "664",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "96961234"
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:02|[3467]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "50037123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3550\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "35501234"
                                ],
                                "MT",
                                356,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2357-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7117\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71171234"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "50112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[0-24-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "54480123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-7]|3[013]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "52512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "802\\d{7}|80[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:20|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3201234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "MU",
                                230,
                                "0(?:0|[24-7]0|3[03])",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "020",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-46]|8[013]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "219\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2190123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6701234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MV",
                                960,
                                "0(?:0|19)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[34679]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[01]|50)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[2-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "111\\d{6}|(?:2[12]|31|77|[89][89])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MW",
                                265,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-37-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2001234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2221234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "300\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "500\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5001234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MX",
                                52,
                                "0[09]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "53"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "323856789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|9\\d{7,8})|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-79]|6[02-4]|8[02-5]))|(?:[26]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[378]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1600\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1600123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1546012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "MY",
                                60,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "[4-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1-$2 $3",
                                        [
                                            "1(?:[02469]|[378][1-9]|53)|8",
                                            "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1(?:[367]|80)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|8\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:[2-79]\\d|80)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "821234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MZ",
                                258,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2|8[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61221234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:60|8[1245])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8701\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "870123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:3\\d\\d|86)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88612345"
                                ],
                                "NA",
                                264,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:050|[2-57-9]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[579]\\d|8[0-79])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "751234"
                                ],
                                [
                                    ,
                                    ,
                                    "050\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "050012"
                                ],
                                [
                                    ,
                                    ,
                                    "36\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "366711"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NC",
                                687,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "5[6-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[027-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:23|7[0467]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "93123456"
                                ],
                                [
                                    ,
                                    ,
                                    "08\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "08123456"
                                ],
                                [
                                    ,
                                    ,
                                    "09\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "09123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NE",
                                227,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "08"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[089]|2[013]|7[0467]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106609",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:14|3[58])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NF",
                                672,
                                "00",
                                ,
                                ,
                                ,
                                "([0-258]\\d{4})$",
                                "3$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1[0-3]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[13]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2033123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "80017591759"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NG",
                                234,
                                "009",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "20[129]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "7001234567"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1800|[25-8]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81234567"
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NI",
                                505,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[125-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[1-58]|970\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[069]\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "9061234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:85|91)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "851234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "NL",
                                31,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1[238]|[34]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "66\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "662345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                                    ,
                                    ,
                                    ,
                                    "14020",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0|[2-9]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-46-9]|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[49]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "40612345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "NO",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[02-689]|7[0-8]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "14567890",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9841234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:66001|800\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16600101234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NP",
                                977,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5551234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NR",
                                674,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]|888\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[47]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7012",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[56]|888[1-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8884012"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NU",
                                683,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "32345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "508\\d{6,7}|80\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NZ",
                                64,
                                "0(?:0|161)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,8})",
                                        "$1 $2",
                                        [
                                            "8[1-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "50[036-8]|8|90",
                                            "50(?:[0367]|88)|8|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "24|[346]|7[2-57-9]|9[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:10|74)|[589]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1|2[028]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,5})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:[169]|7[0-35-9])|7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "83012378"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "23123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1505|90[1-9]\\d)\\d{4}|(?:7[124-9]|9[1-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "OM",
                                968,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "[58]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[179]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[147]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[0147-9]\\d|[25][0-5]|33|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8601234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PA",
                                507,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-57-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[14-8]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "11234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "805\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[24]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PE",
                                51,
                                "00|19(?:1[124]|77|90)00",
                                "0",
                                " Anexo ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[4-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[4-689]|9[4-68])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40412345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[7-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "87123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "499\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "49901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "PF",
                                689,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4|8[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "440123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7\\d|8[1-48])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[0-57]|7[568])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2751234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "PG",
                                675,
                                "00|140[1-3]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "18|[2-69]|85"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[78]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "27[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2700123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "232345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9051234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "180012345678",
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PH",
                                63,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                                            "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "346|4(?:27|9[35])|883",
                                            "3469|4(?:279|9(?:30|56))|8834"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|8[2-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "122\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "122044444",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PK",
                                92,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,7})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                                            "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "58"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21111825888",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:30|47\\d\\d)\\d{5}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21(?:1[013-5]|2\\d|3[1-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01346-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "39\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "391234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PL",
                                48,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "11|20|64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                                            "30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[2-8]|[2-7]|8[1-79]|9[145]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "64\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "641234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "804123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[78]\\d{8}|[2-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[6-9]\\d{6}|(?:[236-9]\\d|4[1-35-9]|5[0-47-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "430123"
                                ],
                                [
                                    ,
                                    ,
                                    "708(?:4[0-5]|5[0-6])\\d{4}|(?:[236-9]\\d|4[02-489]|5[02-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "551234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[129]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "810123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PM",
                                508,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[589]\\d\\d|787)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PR",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "787|939",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[69]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "599123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PS",
                                970,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "760123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:8\\d|9[1579])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456"
                                ],
                                [
                                    ,
                                    ,
                                    "884[0-4689]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                "PT",
                                351,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[12]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|[236-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "6(?:222\\d|89(?:00|88|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "622212345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "707123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "600110000"
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[24-8]\\d\\d|345|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2771234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6201234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PW",
                                680,
                                "01[12]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[289]|4[246-8]|61|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:[14-68]\\d|2[4-68]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:1\\d|3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "961456789",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9800\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "98000123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8700[0-4]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "870012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PY",
                                595,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6,7})",
                                        "$1",
                                        [
                                            "[125]|4[01]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "[2-9]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3[289]|4[246-8]|61|7[1-3]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "9(?:[5-79]|8[1-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "[2-9]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3[289]|4[246-8]|61|7[1-3]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "9(?:[5-79]|8[1-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[245]0\\d{6,7}|[36-9]0\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:(?:[014]\\d\\d|999)\\d|2022)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "44123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[35-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "33123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:0080[01]|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "QA",
                                974,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "2[136]|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[136]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "709\\d{6}|(?:26|[689]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2631[0-6]\\d{4}|26(?:2\\d|30|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "262161234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "692123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-37-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[019]|2[0156]|84|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939901234"
                                ],
                                "RE",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[26-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "211234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712034567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[0136]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RO",
                                40,
                                "00",
                                "0",
                                " int ",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2[3-6]",
                                            "2[3-6]\\d9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219|31"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[236-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:37\\d|80[578])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    "10234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[0-689]|7\\d)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,9}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:78\\d|90[0169])\\d{3,7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RS",
                                381,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "(?:2[389]|39)0|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,10})",
                                        "$1 $2",
                                        [
                                            "[1-36]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[06]\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "700123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{13}|[347-9]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[12]|36|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[04]|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[39]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RU",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "[0-79]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[3489]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:06|2[23568]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "250123456"
                                ],
                                [
                                    ,
                                    ,
                                    "7[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "720123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RW",
                                250,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[15]\\d|800|92)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "579[0-8]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "925\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "925012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "920\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "920012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SA",
                                966,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[6-9]\\d{6}|[1-6]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7421234"
                                ],
                                [
                                    ,
                                    ,
                                    "1[38]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "18123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[12]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SB",
                                677,
                                "0[01]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2489]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[2-46]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4217123"
                                ],
                                [
                                    ,
                                    ,
                                    "2[125-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2510123"
                                ],
                                [
                                    ,
                                    ,
                                    "800[08]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8000000"
                                ],
                                [
                                    ,
                                    ,
                                    "85\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8512345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "971\\d{4}|(?:64|95)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6412345"
                                ],
                                "SC",
                                248,
                                "010|0[0-2]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[246]|9[57]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5\\d|8[35-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "153123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-2]|9[0-3569])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "911231234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SD",
                                249,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "8123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[023689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "20123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "75[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "751234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SE",
                                46,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "20"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1-$2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "10|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1-$2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "20"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "10|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "74[02-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "102345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:25[245]|67[3-68])\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "254123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-9]\\d{5}|(?:8[1-9]|9[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:18|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[12]\\d|666)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SG",
                                65,
                                "0[0-3]\\d",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1[013-9]|77",
                                            "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-9]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-9]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7000\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22158"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "262\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "26212",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SH",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[256]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[1-357][2-8]|4[24-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[013]|51|6[489])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-3]\\d{2,5}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "59012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SI",
                                386,
                                "00|10(?:22|66|88|99)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "8[09]|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "59|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37][01]|4[013]|51|6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-57]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[49]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "41234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SJ",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "79",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                [
                                    ,
                                    ,
                                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "912123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:00|[78]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:02|5[0-4]|9[0-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "690123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "SK",
                                421,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "909",
                                            "9090"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9090\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9090123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "961234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[237-9]\\d|66)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[2-4][2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25|3[0-5]|66|7\\d|8[08]|9[09])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "25123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SL",
                                232,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[236-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0549|[5-7]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0549(?:8[0157-9]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "0549886377",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[16]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "66661212",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[158]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "58001110",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SM",
                                378,
                                "00",
                                ,
                                ,
                                ,
                                "([89]\\d{5})$",
                                "0549$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[378]\\d|93)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "301012345"
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[015-8]\\d|21|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "88[4689]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81[02468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "933301234"
                                ],
                                "SN",
                                221,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[379]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[0-35-9]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SO",
                                252,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8[125]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[134]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "1|28|9[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[267]|904"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[346-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-5]|[6-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-3]|3[0-7]|4\\d|5[2-578])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[08]|7[1-7]|8[1-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7412345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:56|91\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "561234"
                                ],
                                "SR",
                                597,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "56"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-5]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[6-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "181234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|9[1257-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "977123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SS",
                                211,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2221234"
                                ],
                                [
                                    ,
                                    ,
                                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ST",
                                239,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[5-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{8}|80[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SV",
                                503,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[25-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:4[2-8]|8[39]|9[056])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215425678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:1[02]|2\\d|5[034679]|8[0-24-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215205678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SX",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "(5\\d{6})$|1",
                                "721$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "721",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-359]\\d{8}|[1-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:50|9[1-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "944567890",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SY",
                                963,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-4]|5[1-3]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[59]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][2-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22171234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[5-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "76123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "08001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SZ",
                                268,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[0237]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TA: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TA",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|649|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:266|712|9(?:4\\d|50))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497121234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6492311234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:71[01]|966)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-479]\\d{6})$|1",
                                "649$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "649",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|[3689]\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22501234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[01]|[69]\\d|77|8[5-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "63012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TD",
                                235,
                                "00|16",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[236-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[279]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[0-289]|9[0-36-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TG",
                                228,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[279]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:14|[89]\\d)\\d\\d|6(?:[1-6]\\d\\d|7(?:1[0-8]|2[4-7]|3[1-6])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:001800\\d|1800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[08]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "TH",
                                66,
                                "00[1-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[0-57-9]\\d|66)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|3[08]|40|5[05]|66|7[0157-9]|8[07-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "917123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TJ",
                                992,
                                "810",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})(\\d)(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "331",
                                            "3317"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44[02-479]|[34]7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[1245]|3[12])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "\\d"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-4]|[34]\\d)\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "3101"
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-4]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "7290"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TK",
                                690,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2112345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TL",
                                670,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-489]|70"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6\\d|7[12])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "66123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TM",
                                993,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "12"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-5]"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[67]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-57-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30010123"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8010\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80101234"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]10\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81101234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TN",
                                216,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7715123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55[0-37-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5510123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TO",
                                676,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:1[26]|[28][2468]|[3-5][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "561(?:011|61\\d)\\d{4}|5(?:[03-5]\\d|1[06]|24|6[24]|7[245]|9[46])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[89]8|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "592(?:21[12]|461)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5922121234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "850\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8500123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "TR",
                                90,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "444"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5[0-79]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5[0-79]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "512\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:444|811\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441444",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682211234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682911234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868800\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TT",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-46-8]\\d{6})$|1",
                                "868$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "868",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "868619\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8686191234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|7\\d\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[02-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[01]\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "901234",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TV",
                                688,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-79]\\d{6}|800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:[013-9]\\d\\d|2)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "203123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "99\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                "TW",
                                886,
                                "0(?:0[25-79]|19)",
                                "0",
                                "#",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "202"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "826"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "83"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "82"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[25]0|37|49|8[09]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23568]|4(?:0[02-48]|[1-478])|7[1-9]",
                                            "[23568]|4(?:0[2-48]|[1-478])|(?:400|7)[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "500123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-8]\\d|41|90)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "222345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[1-35-9]|7\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "621234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:40|6[01])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "412345678"
                                ],
                                "TZ",
                                255,
                                "00[056]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[24]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[89]\\d{9}|[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "311234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[239]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "900212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-579]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "UA",
                                380,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "0~0",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                                            "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|89|9[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7280\\d{5}|7(?:[014-8]\\d|2[01467]|3[0167]|9[0-589])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-3]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[1-3]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UG",
                                256,
                                "00[057]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "202",
                                            "2024"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[27-9]|4(?:6[45]|[7-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[34]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:472[2-47-9]|983[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:472[2-47-9]|983[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "US",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[24-9]|3(?:[02-9]|1[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "($1) $2-$3",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "94231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UY",
                                598,
                                "0(?:0|1[3-9]\\d)",
                                "0",
                                " int. ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "21"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[49]0|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[124]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "21123",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|33|[5-9]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "669050123"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[25]0|33|8[078]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UZ",
                                998,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "06698\\d{1,6}",
                                    ,
                                    ,
                                    ,
                                    "0669812345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "VA",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "06698",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|784|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7842661234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7844301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "78451[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7845101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "784$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "784",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2121234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:1[24-8]|2[246])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "4121234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[01]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VE",
                                58,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[24-689]"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5010123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:284|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2842291234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2843001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-578]\\d{6})$|1",
                                "284$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "284",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:34|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "340$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "340",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{6,7}|7\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "121[0-3]\\d{5}|(?:160|(?:3\\d|7[06-9])\\d|5(?:[1689]\\d|2[238]|59)|8(?:[1-8]\\d|9[6-9])|9(?:[0-8]\\d|9[013-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "672\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "VN",
                                84,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[17]99"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "69"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1(?:2[02]|[89])"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[26]|6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1(?:2[02]|[89])"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[26]|6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[17]99\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[17]99\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "1992000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d|7[0-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5912345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "81123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[1-9]|1[01])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9010123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VU",
                                678,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[03]|900\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "72\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "721234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:72|8[23])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "821234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[23]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "921234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                "WF",
                                681,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[47-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[48]0\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "401234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7212345",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "WS",
                                685,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "[2-5]|6[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
                                    ,
                                    ,
                                    ,
                                    "28012345"
                                ],
                                [
                                    ,
                                    ,
                                    "4[3-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "43201234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "XK",
                                383,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2|39"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[01378]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "YE",
                                967,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-6]|7(?:[24-6]|8[0-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:639\\d|7093)\\d{5}|(?:26|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "269601234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "639012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939801234"
                                ],
                                "YT",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-79]\\d{8}|8\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|[67]\\d\\d)\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "711234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "862345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "860\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "860123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "871234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "ZA",
                                27,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "860"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "861\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "861123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[59][5-8]|7[5-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "955123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "63\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "630123456"
                                ],
                                "ZM",
                                260,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1312345",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[1278]\\d|3[1-9]|9[01])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[01]\\d|20|8[0-8])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8686123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "ZW",
                                263,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                                            "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "29[013-9]|39|54"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "(?:25|54)8",
                                            "258|5483"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            800: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                800,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "\\d"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            808: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                808,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            870: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{11}|[235-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "001",
                                870,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            878: [
                                ,
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    "101234567890"
                                ],
                                "001",
                                878,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            881: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                881,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[0-37-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            882: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3421234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "390123456789"
                                ],
                                "001",
                                882,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "16|342"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "49"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[36]|9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3[23]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|23|3(?:[15]|4[57])|4|5[12]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "34"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[1-35]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "348[57]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "34851234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ]
                            ],
                            883: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]\\d|51)\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                                    ,
                                    ,
                                    ,
                                    "510012345"
                                ],
                                "001",
                                883,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,8})",
                                        "$1 $2 $3",
                                        [
                                            "[14]|2[24-689]|3[02-689]|51[24-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "510"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "51[13]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            888: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                888,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    "12345678901"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            979: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                979,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1359]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.PhoneNumberUtil = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
                        i18n.phonenumbers.Error = {
                            INVALID_COUNTRY_CODE: "Invalid country calling code",
                            NOT_A_NUMBER: "The string supplied did not seem to be a phone number",
                            TOO_SHORT_AFTER_IDD: "Phone number too short after IDD",
                            TOO_SHORT_NSN: "The string supplied is too short to be a phone number",
                            TOO_LONG: "The string supplied is too long to be a phone number"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
                        i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
                        i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {
                            54: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [
                            52,
                            54,
                            55
                        ];
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
                        i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
                        i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uFF10": "0",
                            "\uFF11": "1",
                            "\uFF12": "2",
                            "\uFF13": "3",
                            "\uFF14": "4",
                            "\uFF15": "5",
                            "\uFF16": "6",
                            "\uFF17": "7",
                            "\uFF18": "8",
                            "\uFF19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06F0": "0",
                            "\u06F1": "1",
                            "\u06F2": "2",
                            "\u06F3": "3",
                            "\u06F4": "4",
                            "\u06F5": "5",
                            "\u06F6": "6",
                            "\u06F7": "7",
                            "\u06F8": "8",
                            "\u06F9": "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,
                            "*": "*",
                            "#": "#"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uFF10": "0",
                            "\uFF11": "1",
                            "\uFF12": "2",
                            "\uFF13": "3",
                            "\uFF14": "4",
                            "\uFF15": "5",
                            "\uFF16": "6",
                            "\uFF17": "7",
                            "\uFF18": "8",
                            "\uFF19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06F0": "0",
                            "\u06F1": "1",
                            "\u06F2": "2",
                            "\u06F3": "3",
                            "\u06F4": "4",
                            "\u06F5": "5",
                            "\u06F6": "6",
                            "\u06F7": "7",
                            "\u06F8": "8",
                            "\u06F9": "9",
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            A: "A",
                            B: "B",
                            C: "C",
                            D: "D",
                            E: "E",
                            F: "F",
                            G: "G",
                            H: "H",
                            I: "I",
                            J: "J",
                            K: "K",
                            L: "L",
                            M: "M",
                            N: "N",
                            O: "O",
                            P: "P",
                            Q: "Q",
                            R: "R",
                            S: "S",
                            T: "T",
                            U: "U",
                            V: "V",
                            W: "W",
                            X: "X",
                            Y: "Y",
                            Z: "Z",
                            a: "A",
                            b: "B",
                            c: "C",
                            d: "D",
                            e: "E",
                            f: "F",
                            g: "G",
                            h: "H",
                            i: "I",
                            j: "J",
                            k: "K",
                            l: "L",
                            m: "M",
                            n: "N",
                            o: "O",
                            p: "P",
                            q: "Q",
                            r: "R",
                            s: "S",
                            t: "T",
                            u: "U",
                            v: "V",
                            w: "W",
                            x: "X",
                            y: "Y",
                            z: "Z",
                            "-": "-",
                            "\uFF0D": "-",
                            "\u2010": "-",
                            "\u2011": "-",
                            "\u2012": "-",
                            "\u2013": "-",
                            "\u2014": "-",
                            "\u2015": "-",
                            "\u2212": "-",
                            "/": "/",
                            "\uFF0F": "/",
                            " ": " ",
                            "\u3000": " ",
                            "\u2060": " ",
                            ".": ".",
                            "\uFF0E": "."
                        };
                        i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uFF0B";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
                        i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
                        i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
                        i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
                        i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_);
                        i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_;
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_);
                        i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(a) {
                            return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + a + "})";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
                            var a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), b = "[ \xa0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", c = "[ \xa0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", d = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", e = "[ \xa0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", f = "[ \xa0\\t]*(?:,)+[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
                            return a + "|" + b + "|" + c + "|" + d + "|" + e + "|" + f;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
                        i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
                        i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
                        i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
                        i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
                        i18n.phonenumbers.PhoneNumberFormat = {
                            E164: 0,
                            INTERNATIONAL: 1,
                            NATIONAL: 2,
                            RFC3966: 3
                        };
                        i18n.phonenumbers.PhoneNumberType = {
                            FIXED_LINE: 0,
                            MOBILE: 1,
                            FIXED_LINE_OR_MOBILE: 2,
                            TOLL_FREE: 3,
                            PREMIUM_RATE: 4,
                            SHARED_COST: 5,
                            VOIP: 6,
                            PERSONAL_NUMBER: 7,
                            PAGER: 8,
                            UAN: 9,
                            VOICEMAIL: 10,
                            UNKNOWN: -1
                        };
                        i18n.phonenumbers.PhoneNumberUtil.MatchType = {
                            NOT_A_NUMBER: 0,
                            NO_MATCH: 1,
                            SHORT_NSN_MATCH: 2,
                            NSN_MATCH: 3,
                            EXACT_MATCH: 4
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {
                            IS_POSSIBLE: 0,
                            IS_POSSIBLE_LOCAL_ONLY: 4,
                            INVALID_COUNTRY_CODE: 1,
                            TOO_SHORT: 2,
                            INVALID_LENGTH: 5,
                            TOO_LONG: 3
                        };
                        i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
                            var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
                            0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
                            return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
                            var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
                            a.clear();
                            a.append(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
                            if (a.hasExtension()) {
                                var b = a.clone();
                                b.clearExtension();
                            } else b = a;
                            b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
                            0 == b[0].length && b.shift();
                            return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return !isNaN(a);
                            }).map(function(a) {
                                return parseInt(a, 10);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
                            var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
                            return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(a.map(function(b) {
                                return parseInt(b, 10);
                            })));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
                            return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
                            return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
                            var b = [];
                            goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
                                if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                                    var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
                                    i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
                                }
                            });
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
                            a = this.getMetadataForNonGeographicalRegion(a);
                            return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
                            for(var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h)e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
                            return d.toString();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
                            return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
                            var b = this.getNumberType(a);
                            return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
                            return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
                            return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
                            if (0 == a.getNationalNumber() && a.hasRawInput()) {
                                var c = a.getRawInputOrDefault();
                                if (0 < c.length && a.hasCountryCode() && a.getCountryCodeSource() == i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY && b == i18n.phonenumbers.PhoneNumberFormat.E164) return a = a.getCountryCodeOrDefault(), this.prefixNumberWithCountryCallingCode_(a, b, c, "");
                                if (0 < c.length || !a.hasCountryCode()) return c;
                            }
                            c = a.getCountryCodeOrDefault();
                            var d = this.getNationalSignificantNumber(a);
                            if (b == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, b);
                            d = this.formatNsn_(d, e, b);
                            return this.prefixNumberWithCountryCallingCode_(c, b, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(d)) return e;
                            var f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            var g = this.chooseFormattingPatternForNumber_(c, e);
                            if (null != g) {
                                c = g.clone();
                                g = g.getNationalPrefixFormattingRuleOrDefault();
                                if (0 < g.length) {
                                    var h = f.getNationalPrefixOrDefault();
                                    0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
                                }
                                e = this.formatNsnUsingPattern_(e, c, b);
                            }
                            a = this.maybeGetFormattedExtension_(a, f, b);
                            return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            b = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
                            return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
                            return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
                            return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return a.hasRawInput() ? a.getRawInputOrDefault() : "";
                            var e = "";
                            a = a.clone();
                            a.clearExtension();
                            var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            if (b == f) e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f || "UZ" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            else if (h && this.canBeInternationallyDialled(a)) return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
                            return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
                            if (!this.isValidRegionCode_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            } else if (c == this.getCountryCodeForValidRegion_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault();
                            b = "";
                            e.hasPreferredInternationalPrefix() ? b = e.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) && (b = f);
                            e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + c + " " + d + a : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
                            if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) return a.getRawInputOrDefault();
                            if (!a.hasCountryCodeSource()) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            switch(a.getCountryCodeSource()){
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                                    b = this.formatOutOfCountryCallingNumber(a, b);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                                    break;
                                default:
                                    var c = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), d = this.getNddPrefixForRegion(c, !0);
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                                    if (null != d && 0 != d.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), d, c) && (c = this.getMetadataForRegion(c), d = this.getNationalSignificantNumber(a), c = this.chooseFormattingPatternForNumber_(c.numberFormatArray(), d), null != c)) {
                                        d = c.getNationalPrefixFormattingRuleOrDefault();
                                        var e = d.indexOf("$1");
                                        0 >= e || (d = d.substring(0, e), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d), 0 != d.length && (b = c.clone(), b.clearNationalPrefixFormattingRule(), b = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [
                                            b
                                        ])));
                                    }
                            }
                            a = a.getRawInputOrDefault();
                            null != b && 0 < a.length && (c = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a), c != d && (b = a));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
                            a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                            if (goog.string.startsWith(a, b)) try {
                                return this.isValidNumber(this.parse(a.substring(b.length), c));
                            } catch (d) {}
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
                            var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
                            b = this.getMetadataForRegionOrCallingCode_(b, c);
                            if (null == b) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
                            var c = a.getRawInputOrDefault();
                            if (0 == c.length) return this.formatOutOfCountryCallingNumber(a, b);
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return c;
                            c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
                            var e = this.getNationalSignificantNumber(a);
                            if (3 < e.length) {
                                var f = c.indexOf(e.substring(0, 3));
                                -1 != f && (c = c.substring(f));
                            }
                            f = this.getMetadataForRegion(b);
                            if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return d + " " + c;
                            } else if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
                                d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
                                if (null == d) return c;
                                d = d.clone();
                                d.setPattern("(\\d+)(.*)");
                                d.setFormat("$1$2");
                                return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            }
                            b = "";
                            null != f && (b = f.getInternationalPrefixOrDefault(), b = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, b) ? b : f.getPreferredInternationalPrefixOrDefault());
                            f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            a = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + d + " " + c + a : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberFormat.E164:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                                    return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
                                default:
                                    return c + d;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
                            b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
                            b = this.chooseFormattingPatternForNumber_(b, a);
                            return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
                            for(var c, d = a.length, e = 0; e < d; ++e){
                                c = a[e];
                                var f = c.leadingDigitsPatternCount();
                                if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
                                    if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b)) return c;
                                }
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
                            var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
                            c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
                            c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
                            return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
                            if (!this.isValidRegionCode_(a)) return null;
                            b = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
                            try {
                                if (b.hasExampleNumber()) return this.parse(b.getExampleNumber(), a);
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
                            var b = this.getMetadataForNonGeographicalRegion(a);
                            if (null != b && (b = [
                                b.getMobile(),
                                b.getTollFree(),
                                b.getSharedCost(),
                                b.getVoip(),
                                b.getVoicemail(),
                                b.getUan(),
                                b.getPremiumRate()
                            ].find(function(c, d) {
                                return c.hasExampleNumber();
                            }), void 0 !== b)) try {
                                return this.parse("+" + a + b.getExampleNumber(), "ZZ");
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
                            return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                                    return a.getPremiumRate();
                                case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                                    return a.getTollFree();
                                case i18n.phonenumbers.PhoneNumberType.MOBILE:
                                    return a.getMobile();
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                                    return a.getFixedLine();
                                case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                                    return a.getSharedCost();
                                case i18n.phonenumbers.PhoneNumberType.VOIP:
                                    return a.getVoip();
                                case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                                    return a.getPersonalNumber();
                                case i18n.phonenumbers.PhoneNumberType.PAGER:
                                    return a.getPager();
                                case i18n.phonenumbers.PhoneNumberType.UAN:
                                    return a.getUan();
                                case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                                    return a.getVoicemail();
                                default:
                                    return a.getGeneralDesc();
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
                            if (null == b) return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
                            return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
                            if (null == a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.metadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
                            return this.getMetadataForRegion("" + a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
                            var c = a.length;
                            return 0 < b.possibleLengthCount() && -1 == b.possibleLengthArray().indexOf(c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            return this.isValidNumberForRegion(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
                            if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
                            if (null == a) return null;
                            var b = a.getCountryCodeOrDefault();
                            b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
                            return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
                            a = this.getNationalSignificantNumber(a);
                            for(var c, d = b.length, e = 0; e < d; e++){
                                c = b[e];
                                var f = this.getMetadataForRegion(c);
                                if (f.hasLeadingDigits()) {
                                    if (0 == a.search(f.getLeadingDigits())) return c;
                                } else if (this.getNumberTypeHelper_(a, f) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return c;
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? [] : a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
                            var b = this.getMetadataForRegion(a);
                            if (null == b) throw Error("Invalid region code: " + a);
                            return b.getCountryCodeOrDefault();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
                            a = this.getMetadataForRegion(a);
                            if (null == a) return null;
                            a = a.getNationalPrefixOrDefault();
                            if (0 == a.length) return null;
                            b && (a = a.replace("~", ""));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
                            return null != a && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) return !1;
                            a = new goog.string.StringBuffer(a);
                            this.maybeStripExtension(a);
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
                            a = this.isPossibleNumberWithReason(a);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
                            a = this.isPossibleNumberForTypeWithReason(a, b);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
                            return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
                            d = d.possibleLengthLocalOnlyArray();
                            if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
                                if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), e.sort(), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), d.sort()));
                                else return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
                            }
                            if (-1 == e[0]) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                            a = a.length;
                            if (-1 < d.indexOf(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                            b = e[0];
                            return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < e.indexOf(a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
                            return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
                            var c = this.getNationalSignificantNumber(a);
                            a = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
                            var d = this.getRegionCodeForCountryCode(a);
                            a = this.getMetadataForRegionOrCallingCode_(a, d);
                            return this.testNumberLengthForType_(c, a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
                            try {
                                return this.isPossibleNumber(this.parse(a, b));
                            } catch (c) {
                                return !1;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
                            if (this.isValidNumber(a)) return !0;
                            var b = a.clone(), c = a.getNationalNumberOrDefault();
                            do if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return !1;
                            while (!this.isValidNumber(b));
                            a.setNationalNumber(c);
                            return !0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
                            a = a.toString();
                            if (0 == a.length || "0" == a.charAt(0)) return 0;
                            for(var c, d = a.length, e = 1; e <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && e <= d; ++e)if (c = parseInt(a.substring(0, e), 10), c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return b.append(a.substring(e)), c;
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
                            if (0 == a.length) return 0;
                            a = new goog.string.StringBuffer(a);
                            var f;
                            null != b && (f = b.getInternationalPrefix());
                            null == f && (f = "NonMatch");
                            f = this.maybeStripInternationalPrefixAndNormalize(a, f);
                            d && e.setCountryCodeSource(f);
                            if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                                if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                                b = this.extractCountryCode(a, c);
                                if (0 != b) return e.setCountryCode(b), b;
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            }
                            if (null != b) {
                                f = b.getCountryCodeOrDefault();
                                var g = "" + f, h = a.toString();
                                if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
                            }
                            e.setCountryCode(0);
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
                            var c = b.toString();
                            if (0 == c.search(a)) {
                                a = c.match(a)[0].length;
                                var d = c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                                if (d && null != d[1] && 0 < d[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1])) return !1;
                                b.clear();
                                b.append(c.substring(a));
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
                            var c = a.toString();
                            if (0 == c.length) return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c)) return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
                            b = new RegExp(b);
                            i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
                            return this.parsePrefixAsIdd_(b, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
                            var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
                            if (0 == e || null == f || 0 == f.length) return !1;
                            var g = new RegExp("^(?:" + f + ")");
                            if (e = g.exec(d)) {
                                f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
                                var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
                                b = b.getNationalPrefixTransformRule();
                                if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length))) return !1;
                                    null != c && 0 < k && null != e[k] && c.append(e[1]);
                                    a.set(d.substring(e[0].length));
                                } else {
                                    d = d.replace(g, b);
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d)) return !1;
                                    null != c && 0 < k && c.append(e[1]);
                                    a.set(d);
                                }
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
                            var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
                            if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
                                for(var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f)if (null != d[f] && 0 < d[f].length) return a.clear(), a.append(b.substring(0, c)), d[f];
                            }
                            return "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
                            return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
                            return this.parseHelper_(a, b, !1, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
                            if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            return this.parseHelper_(a, b, !0, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
                            if (1 < a.length && "0" == a.charAt(0)) {
                                b.setItalianLeadingZero(!0);
                                for(var c = 1; c < a.length - 1 && "0" == a.charAt(c);)c++;
                                1 != c && b.setNumberOfLeadingZeros(c);
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
                            if (null == a) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            var e = new goog.string.StringBuffer;
                            this.buildNationalNumberForParsing_(a, e);
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (d && !this.checkRegionForParsing_(e.toString(), b)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            d = new i18n.phonenumbers.PhoneNumber;
                            c && d.setRawInput(a);
                            a = this.maybeStripExtension(e);
                            0 < a.length && d.setExtension(a);
                            var f = this.getMetadataForRegion(b);
                            a = new goog.string.StringBuffer;
                            var g = 0, h = e.toString();
                            try {
                                g = this.maybeExtractCountryCode(h, f, a, c, d);
                            } catch (k) {
                                if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
                                    if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) throw k;
                                } else throw k;
                            }
                            0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
                            if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
                            c = a.toString();
                            a = c.length;
                            if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
                            d.setNationalNumber(parseInt(c, 10));
                            return d;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(a) {
                            var b = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                            if (-1 === b) return null;
                            b += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
                            if (b >= a.length) return "";
                            var c = a.indexOf(";", b);
                            return -1 !== c ? a.substring(b, c) : a.substring(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(a) {
                            if (null == a) return !0;
                            if (0 === a.length) return !1;
                            var b = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(a);
                            a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(a);
                            return null !== b || null !== a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
                            var c = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(a);
                            if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(c)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (null != c) {
                                c.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && b.append(c);
                                c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
                                c = 0 <= c ? c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
                                var d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                                b.append(a.substring(c, d));
                            } else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(null != a ? a : ""));
                            a = b.toString();
                            c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
                            0 < c && (b.clear(), b.append(a.substring(0, c)));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
                            var b = new i18n.phonenumbers.PhoneNumber;
                            b.setCountryCode(a.getCountryCodeOrDefault());
                            b.setNationalNumber(a.getNationalNumberOrDefault());
                            0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
                            a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
                            if ("string" == typeof a) try {
                                var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
                            } catch (f) {
                                if (f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                if ("string" != typeof b) {
                                    var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
                                    if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                                        try {
                                            c = this.parse(a, d);
                                        } catch (g) {
                                            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                        }
                                        var e = this.isNumberMatch(c, b);
                                        return e == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : e;
                                    }
                                }
                                try {
                                    c = this.parseHelper_(a, null, !1, !1);
                                } catch (g) {
                                    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                }
                            }
                            else c = a.clone();
                            if ("string" == typeof b) try {
                                return e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(a, e);
                            } catch (f) {
                                return f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
                            }
                            else e = b.clone();
                            a = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
                            e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
                            if (a.hasExtension() && e.hasExtension() && a.getExtension() != e.getExtension()) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            b = a.getCountryCodeOrDefault();
                            c = e.getCountryCodeOrDefault();
                            if (0 != b && 0 != c) return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : b == c && this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            a.setCountryCode(0);
                            e.setCountryCode(0);
                            return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
                            a = "" + a.getNationalNumber();
                            b = "" + b.getNationalNumber();
                            return goog.string.endsWith(a, b) || goog.string.endsWith(b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            if (null == b) return !0;
                            a = this.getNationalSignificantNumber(a);
                            return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a, b) {
                            return (a = b.match(new RegExp("^(?:" + ("string" == typeof a ? a : a.source) + ")$", "i"))) && a[0].length == b.length ? !0 : !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a, b) {
                            return (a = "string" == typeof a ? b.match("^(?:" + a + ")") : b.match(a)) && goog.string.startsWith(b, a[0]) ? !0 : !1;
                        };
                        i18n.phonenumbers.shortnumbermetadata = {};
                        i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = {
                            0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")
                        };
                        i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|445[16]|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "445\\d",
                                    ,
                                    ,
                                    ,
                                    "4450",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[15]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131|5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|8[1-7])\\d\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01389]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",
                                    ,
                                    ,
                                    ,
                                    "19",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[017]|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",
                                    ,
                                    ,
                                    ,
                                    "19"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "893\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:337|893\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "3370",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "40404|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1268]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[12]2|33|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:2(?:066|20)|61|8108[1-3])0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "220\\d|610|(?:206|810\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "610"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "206\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "20600",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-27]\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12|258885|55\\d)|733",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2(?:34|456)|9\\d{4,6})",
                                    ,
                                    ,
                                    ,
                                    "1234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12)",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1[09]\\d|24733)|225|767",
                                    ,
                                    ,
                                    ,
                                    "225",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:258885|55\\d)",
                                    ,
                                    ,
                                    ,
                                    "1550",
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "190000",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|18|76)|91[13]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|75[12]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)|(?:404|880)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16\\d{3}|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "12[2-4]",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2-689]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[468]11",
                                    ,
                                    ,
                                    ,
                                    "411"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-26]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11|2[13])|(?:501|959)\\d|786",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "959\\d",
                                    ,
                                    ,
                                    ,
                                    "9590",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1204",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0[167]|81)\\d{3}|[19]99",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    "9[148]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "91000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[19]99",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0[67]\\d{3}|88000|98555",
                                    ,
                                    ,
                                    ,
                                    "06000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "88000|98555",
                                    ,
                                    ,
                                    ,
                                    "88000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[16-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]|611",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "611|7(?:10|77)|888|900",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:71|90)0",
                                    ,
                                    ,
                                    ,
                                    "710",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[246-8]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[02-5]",
                                    ,
                                    ,
                                    ,
                                    "120",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18|3(?:00|1[0-689])\\d",
                                    ,
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "18|3(?:00[0-79]|1[0-689]\\d)|(?:118[02-9]|3[2469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-69]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|28|9[023])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "102|273\\d\\d|321",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",
                                    ,
                                    ,
                                    ,
                                    "151",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "321"
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[19]",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-6]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|90)",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|988|[29]11",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[235-7]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "10000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|23|77|88)|40404",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|22\\d)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|220)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[478]|220)",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[178]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[78]",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[126-8]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|6\\d{3})|4[247])|5200",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:14|8[0-2589])\\d|543|83111",
                                    ,
                                    ,
                                    ,
                                    "543",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[02-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                                    ,
                                    ,
                                    ,
                                    "140",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:200|35)",
                                    ,
                                    ,
                                    ,
                                    "535",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "200",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)|4443",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:213|3[1-3])|434\\d|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[1-3]|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:200|333)\\d",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])|8711",
                                    ,
                                    ,
                                    ,
                                    "13"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|2(?:[02]|1\\d\\d|395))",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|20)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "12110",
                                    ,
                                    ,
                                    ,
                                    "12110",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-589]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:385|5(?:0[34]|51))\\d",
                                    ,
                                    ,
                                    ,
                                    "3850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-7]|(?:116|204\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-6]",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|99)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-46-8]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[02]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|22(?:044|5(?:43|80)|7700|922)|33(?:11|3[34])|44844|600\\d\\d|7(?:0\\d{3}|464)|80808|118\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33[13]|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|600|70\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3310",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:333|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|600|70\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3330",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[24]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[248]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47]|54\\d)",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47])",
                                    ,
                                    ,
                                    ,
                                    "14",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:055|12|[47]|548)|730",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                                    ,
                                    ,
                                    ,
                                    "126",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|[679]\\d{3}|80)|34400",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2-46]|(?:12[47]|20[12])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ER",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-379]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:16|20|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "016",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                ,
                                ,
                                "ES",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "08[58]|112",
                                    ,
                                    ,
                                    ,
                                    "085",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[0-267]|2[0148]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:1[0-27]|2[148]|6[0-2]|80|9[12])|21\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3[34]|77)|[12]2\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ET",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|45|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "1[2-8]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "12000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-579]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",
                                    ,
                                    ,
                                    ,
                                    "22"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "320\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[24]|81\\d)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-8]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1000",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d\\d|1(?:[02459]|6(?:00[06]|11[17])|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "202\\d|6(?:1[14]|34)|70[06]",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                                    ,
                                    ,
                                    ,
                                    "224",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "114|[3-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18|1(?:3\\d|73)\\d",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-46-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",
                                    ,
                                    ,
                                    ,
                                    "202",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1250",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[014]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|40404|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:0\\d|1[0-689])\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|300[0-79]|(?:118[02-9]\\d|3(?:0[1-9]|1[0-689]|[2469]\\d))\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14589]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|40404|(?:54|83)00|999",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[158]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-69]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8100",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[09])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "150|87\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "150",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[1-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "12\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:00|1[0-689])\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:00[0-79]|1[0-689]\\d)|(?:118[02-9]|3[2469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|6\\d{3})|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "113\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "110|40404|1(?:2|[57]\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-4]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-4]",
                                    ,
                                    ,
                                    ,
                                    "002"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "109|1(?:08|85\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "109",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40404",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[016-9]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "06\\d|(?:118|[6-8]\\d{3})\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:06|[6-8]\\d{4})\\d|1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]|40404",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12)",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "184\\d",
                                    ,
                                    ,
                                    ,
                                    "1840",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ID",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02389]|40\\d\\d|50264)|71400|89887",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:714|898)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "714\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[159]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[37]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "53000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "51210|(?:118|5[037]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "8(?:64|98)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "86400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12578]\\d{2,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "11[67]\\d{4}|56161561",
                                    ,
                                    ,
                                    ,
                                    "1160000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-28]|12|298)|2611",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:14(?:2[5-9]|[34]\\d)|757555)",
                                    ,
                                    ,
                                    ,
                                    "51425",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",
                                    ,
                                    ,
                                    ,
                                    "118",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",
                                    ,
                                    ,
                                    ,
                                    "139",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1479]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)|4432|71117|9988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|9[0-579])|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[025]|25)|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5[0-469]|8[0-489])\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "990\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "990000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:0\\d|41)",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:415|90\\d)",
                                    ,
                                    ,
                                    ,
                                    "1415",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[2358]|6\\d{3})|87)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|14\\d|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "43000",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[029]|76)|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[235]|1[2-6]|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d(?:\\d{5,7})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[09]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[2569]\\d{4,6}|1(?:0[24]|1[089]|44|89)",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[2569]\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "00020000",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "90900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "141"
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]|4040",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[146]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|40404|666",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d(?:\\d{3})?)?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[27-9]|28|330|82)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[01679]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189])|55[15]\\d{4}|8(?:(?:11|44|66)\\d{4}|[28]))|1(?:0[015]|1\\d|2[01357-9]|41|8114)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[4-6]|41|8114)|1(?:[0679]1\\d|111)\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:55|8[146])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "15500000",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[0-7]\\d|89887",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "898\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-4]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)|212\\d",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-4]|12)|2121|(?:3040|404)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3489]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "355|4040|8(?:400|933)|911",
                                    ,
                                    ,
                                    ,
                                    "355"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[018]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1180|821\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11[023]",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "165\\d",
                                    ,
                                    ,
                                    ,
                                    "1650",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|41|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ME",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:00|1[0-689])\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3(?:00[0-79]|1[0-689]\\d)|(?:118[02-9]|3[2469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-8]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",
                                    ,
                                    ,
                                    ,
                                    "1220",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ML",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "37(?:433|575)|7400|8001\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3503\\d|(?:3[67]\\d|800)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "35030",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])|3[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "118\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "118000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "211|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|23)))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,4}|(?:8\\d\\d|99)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[45]1",
                                    ,
                                    ,
                                    ,
                                    "141",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|80400|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:530\\d|776)\\d",
                                    ,
                                    ,
                                    ,
                                    "7760",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-9]\\d|53053|7766|911",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:[249]0|[35][01])",
                                    ,
                                    ,
                                    ,
                                    "020",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1369]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "666\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "66600",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:3[23679]\\d|666)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "32000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02-5]\\d\\d|1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:10|93)111|(?:1\\d|9)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[135]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[5-8]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:67|88)",
                                    ,
                                    ,
                                    ,
                                    "567",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-3578]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723141",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40700",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12467]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])|737\\d",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1349]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "120\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]00\\d",
                                    ,
                                    ,
                                    ,
                                    "3000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8\\d\\d|90)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "04000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-36]|12)|1(?:09|11)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-2]|23|92)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "01[05]|101|999",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|999\\d",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "OM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|9999",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",
                                    ,
                                    ,
                                    ,
                                    "1111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[2-4]|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:1[01]|5\\d\\d|6\\d{2,5})",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "16\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "1600",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2\\d?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:22?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:122|3[014]|[56])|11[2457-9]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|310[0-245]|3(?:0\\d|1[1-689])\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2469]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|31(?:0[0-5]|[1-689]\\d)|(?:118[02-9]|3[02469])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "118\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "118000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3103",
                                    ,
                                    ,
                                    ,
                                    "3103",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|66)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|122|44|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "112\\d",
                                    ,
                                    ,
                                    ,
                                    "1120",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12459]\\d\\d(?:\\d{3,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1245][01]\\d{5}|(?:1[1-9]|[245]0\\d{3})\\d|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1245][01]\\d{5}|[245]0\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "200000",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[1245][01]\\d{5}|[245]0\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "200000",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99\\d",
                                    ,
                                    ,
                                    ,
                                    "990",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "QA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:18[39]|[24])|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[23]|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "113|(?:1[24]|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[189]\\d{1,4}|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-4]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[1245]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[12]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|9[79])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "141\\d",
                                    ,
                                    ,
                                    ,
                                    "1410",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:10|41)\\d|90[24679]",
                                    ,
                                    ,
                                    ,
                                    "902",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[127-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[1468]|60)|999",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-37-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "11811[89]|72\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "72000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90000",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
                                    ,
                                    ,
                                    ,
                                    "220",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "772\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "77200",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}|11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "04\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "04000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[069]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9|60400",
                                    ,
                                    ,
                                    ,
                                    "019"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:515|[78])|2(?:00|1)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[246]|[468])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",
                                    ,
                                    ,
                                    ,
                                    "12"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:01|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[46]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[468]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "555|777|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ST",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "116\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[13]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "919",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:011|1[078]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:113|2[23]\\d|5(?:09|56))",
                                    ,
                                    ,
                                    ,
                                    "1113",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:669|9[19])",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",
                                    ,
                                    ,
                                    ,
                                    "1103",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114[89]",
                                    ,
                                    ,
                                    ,
                                    "1148",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|1[25]|2[0138]|72|9[07])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|55)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:285|542)0",
                                    ,
                                    ,
                                    ,
                                    "2850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",
                                    ,
                                    ,
                                    ,
                                    "144",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[09]",
                                    ,
                                    ,
                                    ,
                                    "990"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0289]|1(?:81|92)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "10[56]",
                                    ,
                                    ,
                                    ,
                                    "105",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:65|9(?:1\\d|50|85|98))",
                                    ,
                                    ,
                                    ,
                                    "165"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-79]|9[09])|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-245]|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|9[09])|46400|999",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|1(?:2|6\\d{3}))",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:118|[89]00)\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|611|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
                                    ,
                                    ,
                                    ,
                                    "24280",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "US",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                                    ,
                                    ,
                                    ,
                                    "23333",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "336\\d\\d|[2-9]\\d{3}|[2356]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "20000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|911",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    "178\\d",
                                    ,
                                    ,
                                    ,
                                    "1780",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[04]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)|45400",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[0-6]",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "XK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[134]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01\\d\\d|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41(?:348|851)",
                                    ,
                                    ,
                                    ,
                                    "41348",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01(?:11|77)|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "107"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",
                                    ,
                                    ,
                                    ,
                                    "30782",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[139]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:5[023]|61|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[013-57-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[3-59]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114|9(?:5[023]|6[0-25])",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.ShortNumberInfo = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
                        i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [
                            "BR",
                            "CL",
                            "NI"
                        ];
                        i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {
                            TOLL_FREE: 0,
                            STANDARD_RATE: 1,
                            PREMIUM_RATE: 2,
                            UNKNOWN_COST: 3
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a) {
                            return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a, b) {
                            a = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            return null != b && a.includes(b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a).length;
                            return b.getGeneralDesc().possibleLengthArray().includes(a);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            a = this.getNationalSignificantNumber_(a).length;
                            for(var c = 0; c < b.length; c++){
                                var d = this.getMetadataForRegion_(b[c]);
                                if (d && d.getGeneralDesc().possibleLengthArray().includes(a)) return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            var c = b.getGeneralDesc();
                            if (!this.matchesPossibleNumberAndNationalNumber_(a, c)) return !1;
                            b = b.getShortCode();
                            return this.matchesPossibleNumberAndNationalNumber_(a, b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a, b) {
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return c.UNKNOWN_COST;
                            var d = this.getMetadataForRegion_(b);
                            if (!d) return c.UNKNOWN_COST;
                            a = this.getNationalSignificantNumber_(a);
                            return d.getGeneralDesc().possibleLengthArray().includes(a.length) ? this.matchesPossibleNumberAndNationalNumber_(a, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getTollFree()) || this.isEmergencyNumber(a, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a) {
                            var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            if (0 === c.length) return b.UNKNOWN_COST;
                            if (1 === c.length) return this.getExpectedCostForRegion(a, c[0]);
                            for(var d = b.TOLL_FREE, e = 0; e < c.length; e++){
                                var f = this.getExpectedCostForRegion(a, c[e]);
                                switch(f){
                                    case b.PREMIUM_RATE:
                                        return b.PREMIUM_RATE;
                                    case b.UNKNOWN_COST:
                                        d = b.UNKNOWN_COST;
                                        break;
                                    case b.STANDARD_RATE:
                                        d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
                                        break;
                                    case b.TOLL_FREE:
                                        break;
                                    default:
                                        throw Error("Unrecognized cost for region: " + f);
                                }
                            }
                            return d;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a, b) {
                            if (0 === b.length) return null;
                            if (1 === b.length) return b[0];
                            a = this.getNationalSignificantNumber_(a);
                            for(var c = 0; c < b.length; c++){
                                var d = b[c], e = this.getMetadataForRegion_(d);
                                if (e && this.matchesPossibleNumberAndNationalNumber_(a, e.getShortCode())) return d;
                            }
                            return null;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            a = a.getShortCode();
                            return a.hasExampleNumber() ? a.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a, b) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, d = null;
                            switch(b){
                                case c.TOLL_FREE:
                                    d = a.getTollFree();
                                    break;
                                case c.STANDARD_RATE:
                                    d = a.getStandardRate();
                                    break;
                                case c.PREMIUM_RATE:
                                    d = a.getPremiumRate();
                            }
                            return d && d.hasExampleNumber() ? d.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !0);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !1);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a) {
                            if (!a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) return !1;
                            a = this.getMetadataForRegion_(b);
                            if (null == a || !a.hasEmergency()) return !1;
                            d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
                            b = c && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);
                            c = a.getEmergency().getNationalNumberPatternOrDefault();
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            a = this.getNationalSignificantNumber_(a);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getSmsServices());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a, b) {
                            return 0 < b.possibleLengthArray().length && !b.possibleLengthArray().includes(a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
                        };
                        i18n.phonenumbers.AsYouTypeFormatter = function(a) {
                            this.DIGIT_PLACEHOLDER_ = "\u2008";
                            this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
                            this.currentOutput_ = "";
                            this.formattingTemplate_ = new goog.string.StringBuffer;
                            this.currentFormattingPattern_ = "";
                            this.accruedInput_ = new goog.string.StringBuffer;
                            this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
                            this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
                            this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
                            this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_ = new goog.string.StringBuffer;
                            this.possibleFormats_ = [];
                            this.defaultCountry_ = a;
                            this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
                        i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$");
                        i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
                        i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
                            a = this.phoneUtil_.getCountryCodeForRegion(a);
                            a = this.phoneUtil_.getRegionCodeForCountryCode(a);
                            a = this.phoneUtil_.getMetadataForRegion(a);
                            return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
                            for(var a = this.possibleFormats_.length, b = 0; b < a; ++b){
                                var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
                                if (this.currentFormattingPattern_ == d) return !1;
                                if (this.createFormattingTemplate_(c)) return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
                            }
                            return this.ableToFormat_ = !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
                            for(var b = this.isCompleteNumber_ && 0 == this.extractedNationalPrefix_.length && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d){
                                var e = b[d];
                                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) && !e.getNationalPrefixOptionalWhenFormatting() && !e.hasDomesticCarrierCodeFormattingRule() || (0 != this.extractedNationalPrefix_.length || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) || e.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
                            }
                            this.narrowDownPossibleFormats_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
                            for(var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e){
                                var f = this.possibleFormats_[e];
                                if (0 == f.leadingDigitsPatternCount()) b.push(this.possibleFormats_[e]);
                                else {
                                    var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
                                    f = f.getLeadingDigitsPattern(g);
                                    0 == a.search(f) && b.push(this.possibleFormats_[e]);
                                }
                            }
                            this.possibleFormats_ = b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
                            var b = a.getPatternOrDefault();
                            this.formattingTemplate_.clear();
                            a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
                            return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
                            var c = "999999999999999".match(a)[0];
                            if (c.length < this.nationalNumber_.getLength()) return "";
                            a = c.replace(new RegExp(a, "g"), b);
                            return a = a.replace(/9/g, this.DIGIT_PLACEHOLDER_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
                            this.currentOutput_ = "";
                            this.accruedInput_.clear();
                            this.accruedInputWithoutFormatting_.clear();
                            this.formattingTemplate_.clear();
                            this.lastMatchPosition_ = 0;
                            this.currentFormattingPattern_ = "";
                            this.prefixBeforeNationalNumber_.clear();
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_.clear();
                            this.ableToFormat_ = !0;
                            this.inputHasFormatting_ = !1;
                            this.originalPosition_ = this.positionToRemember_ = 0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
                            this.possibleFormats_ = [];
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
                            this.accruedInput_.append(a);
                            b && (this.originalPosition_ = this.accruedInput_.getLength());
                            this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
                            if (!this.ableToFormat_) {
                                if (!this.inputHasFormatting_) {
                                    if (this.attemptToExtractIdd_()) {
                                        if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                                    } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                                }
                                return this.accruedInput_.toString();
                            }
                            switch(this.accruedInputWithoutFormatting_.getLength()){
                                case 0:
                                case 1:
                                case 2:
                                    return this.accruedInput_.toString();
                                case 3:
                                    if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = !0;
                                    else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                                default:
                                    if (this.isExpectingCountryCallingCode_) return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
                                    if (0 < this.possibleFormats_.length) {
                                        a = this.inputDigitHelper_(a);
                                        b = this.attemptToFormatAccruedDigits_();
                                        if (0 < b.length) return b;
                                        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
                                        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(a) : this.accruedInput_.toString();
                                    }
                                    return this.attemptToChooseFormattingPattern_();
                            }
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = !1;
                            this.possibleFormats_ = [];
                            this.lastMatchPosition_ = 0;
                            this.formattingTemplate_.clear();
                            this.currentFormattingPattern_ = "";
                            return this.attemptToChooseFormattingPattern_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
                            return this.extractedNationalPrefix_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
                            if (0 < this.extractedNationalPrefix_.length) {
                                var a = this.nationalNumber_.toString();
                                this.nationalNumber_.clear();
                                this.nationalNumber_.append(this.extractedNationalPrefix_);
                                this.nationalNumber_.append(a);
                                a = this.prefixBeforeNationalNumber_.toString();
                                var b = a.lastIndexOf(this.extractedNationalPrefix_);
                                this.prefixBeforeNationalNumber_.clear();
                                this.prefixBeforeNationalNumber_.append(a.substring(0, b));
                            }
                            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
                            for(var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c){
                                var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
                                if (new RegExp("^(?:" + e + ")$").test(a) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), d = a.replace(new RegExp(e, "g"), d.getFormat()), d = this.appendNationalNumber_(d), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d) == this.accruedInputWithoutFormatting_)) return d;
                            }
                            return "";
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
                            var b = this.prefixBeforeNationalNumber_.getLength();
                            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
                            if (!this.ableToFormat_) return this.originalPosition_;
                            for(var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;)c.charAt(a) == d.charAt(b) && a++, b++;
                            return b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
                            var a = this.nationalNumber_.toString();
                            return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = a.length;
                            if (0 < b) {
                                for(var c = "", d = 0; d < b; d++)c = this.inputDigitHelper_(a.charAt(d));
                                return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
                            }
                            return this.prefixBeforeNationalNumber_.toString();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
                            if (1 != this.currentMetadata_.getCountryCode()) return !1;
                            var a = this.nationalNumber_.toString();
                            return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = 0;
                            if (this.isNanpaNumberWithNationalPrefix_()) b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
                            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                                var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
                                c = a.match(c);
                                null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
                            }
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.substring(b));
                            return a.substring(0, b);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
                            var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
                            b = a.match(b);
                            return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
                            if (0 == this.nationalNumber_.getLength()) return !1;
                            var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
                            if (0 == b) return !1;
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.toString());
                            a = this.phoneUtil_.getRegionCodeForCountryCode(b);
                            i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
                            this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
                            this.extractedNationalPrefix_ = "";
                            return !0;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
                            if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                                var c = a;
                                this.accruedInputWithoutFormatting_.append(a);
                            } else c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
                            b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
                            return c;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
                            var b = this.formattingTemplate_.toString();
                            if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                                var c = b.search(this.DIGIT_PATTERN_);
                                a = b.replace(this.DIGIT_PATTERN_, a);
                                this.formattingTemplate_.clear();
                                this.formattingTemplate_.append(a);
                                this.lastMatchPosition_ = c;
                                return a.substring(0, this.lastMatchPosition_ + 1);
                            }
                            1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
                            this.currentFormattingPattern_ = "";
                            return this.accruedInput_.toString();
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: !0
                        });
                        exports.default = i18n.phonenumbers;
                        module1.exports = exports["default"];
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("c4hCO", function(module, exports) {

$parcel$export(module.exports, "MAX_NAME_LENGTH", function () { return $d1632314a0fdea7a$export$cd2b108cbcd37452; });
$parcel$export(module.exports, "MAX_COMMENT_LENGTH", function () { return $d1632314a0fdea7a$export$f80aa74c7f458c0c; });
$parcel$export(module.exports, "MAX_EXTERNAL_ID_LENGTH", function () { return $d1632314a0fdea7a$export$d5e90f5ad473c3c6; });
$parcel$export(module.exports, "MAX_CHARGEPOINT_DESCRIPTION_LENGTH", function () { return $d1632314a0fdea7a$export$74c4ab0a710464db; });
$parcel$export(module.exports, "MAX_CHARGEPOINT_PARTNER_DESCRIPTION_LENGTH", function () { return $d1632314a0fdea7a$export$14c163b2193bc898; });
$parcel$export(module.exports, "MAX_WIFI_SSID_LENGTH", function () { return $d1632314a0fdea7a$export$9104e44a83084b14; });
$parcel$export(module.exports, "MAX_WIFI_PASSWORD_LENGTH", function () { return $d1632314a0fdea7a$export$1e503b2807d0cd0d; });
$parcel$export(module.exports, "MAX_ORG_EMAIL_LENGTH", function () { return $d1632314a0fdea7a$export$c7a347573f469cd7; });
$parcel$export(module.exports, "MAX_ORG_DESC_LENGTH", function () { return $d1632314a0fdea7a$export$6017f1f3d7a2ec97; });
$parcel$export(module.exports, "MAX_ORG_PHONE_NO_LENGTH", function () { return $d1632314a0fdea7a$export$d81744c2f6c51c9f; });
$parcel$export(module.exports, "MAX_ORG_CONTACT_PERSON_LENGTH", function () { return $d1632314a0fdea7a$export$57dcff69f3c9f6b3; });
$parcel$export(module.exports, "MAX_ORG_ADDRESS_1_LENGTH", function () { return $d1632314a0fdea7a$export$56f916aeddaf85c8; });
$parcel$export(module.exports, "MAX_ORG_ADDRESS_2_LENGTH", function () { return $d1632314a0fdea7a$export$f344f52e00c5684a; });
$parcel$export(module.exports, "MAX_ORG_COMMENT_LENGTH", function () { return $d1632314a0fdea7a$export$cb45ae05c4d74c4b; });
const $d1632314a0fdea7a$export$cd2b108cbcd37452 = 50;
const $d1632314a0fdea7a$export$f80aa74c7f458c0c = 40;
const $d1632314a0fdea7a$export$d5e90f5ad473c3c6 = 40;
const $d1632314a0fdea7a$export$74c4ab0a710464db = 100;
const $d1632314a0fdea7a$export$14c163b2193bc898 = 200;
const $d1632314a0fdea7a$export$9104e44a83084b14 = 64;
const $d1632314a0fdea7a$export$1e503b2807d0cd0d = 64;
const $d1632314a0fdea7a$export$c7a347573f469cd7 = 50;
const $d1632314a0fdea7a$export$6017f1f3d7a2ec97 = 250;
const $d1632314a0fdea7a$export$d81744c2f6c51c9f = 50;
const $d1632314a0fdea7a$export$57dcff69f3c9f6b3 = 100;
const $d1632314a0fdea7a$export$56f916aeddaf85c8 = 100;
const $d1632314a0fdea7a$export$f344f52e00c5684a = 100;
const $d1632314a0fdea7a$export$cb45ae05c4d74c4b = 500;

});


parcelRegister("PmdvF", function(module, exports) {

$parcel$export(module.exports, "usePortalSession", function () { return $8ea5def47420d775$export$18fb12d27cbe0685; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $hw820 = parcelRequire("hw820");

var $s5QWi = parcelRequire("s5QWi");

var $fIpd8 = parcelRequire("fIpd8");

var $cy4b3 = parcelRequire("cy4b3");

var $1O9Jh = parcelRequire("1O9Jh");

var $jnDYy = parcelRequire("jnDYy");

var $eFTdF = parcelRequire("eFTdF");

var $2gS28 = parcelRequire("2gS28");

var $2c4gm = parcelRequire("2c4gm");

var $jZWFX = parcelRequire("jZWFX");
const $8ea5def47420d775$var$emptySessionUser = (0, $s5QWi.normalizeCurrentUser)({});
const $8ea5def47420d775$export$18fb12d27cbe0685 = ()=>{
    const dispatch = (0, $2rQNl.useDispatch)();
    const portal = (0, $fIpd8.getPortalState)(window.location.pathname);
    const dispatchApiAction = (0, $7E7Dk.useCallback)((action)=>dispatch(action), [
        dispatch
    ]);
    const sessionQuery = (0, $1O9Jh.useAuthGetCurrentQuery)();
    const [deleteEntitlementsContext] = (0, $1O9Jh.useEntitlementsDeleteContextTokenMutation)();
    const [isClearingUnexpectedContext, setIsClearingUnexpectedContext] = (0, $7E7Dk.useState)(false);
    const [hasUnexpectedContextCleanupFailed, setHasUnexpectedContextCleanupFailed] = (0, $7E7Dk.useState)(false);
    const portalSessionResetCount = (0, $2rQNl.useSelector)((0, $eFTdF.selectPortalSessionResetRequestCount));
    const sessionSnapshot = (0, $7E7Dk.useMemo)(()=>(0, $jZWFX.buildPortalSessionSnapshot)(sessionQuery.data, {
            currentDomain: portal.currentDomain,
            currentPortalAudience: portal.currentPortalAudience
        }), [
        portal.currentDomain,
        portal.currentPortalAudience,
        sessionQuery.data
    ]);
    const { selectedOrganizationId: selectedOrganizationId, sessionEntitlements: sessionEntitlements, sessionUser: sessionUser, userHasPortalAccess: userHasPortalAccess, hasUnexpectedEntitlementsContext: hasUnexpectedEntitlementsContext } = sessionSnapshot;
    const canHydrateSession = (0, $jZWFX.canHydratePortalSession)(sessionSnapshot, hasUnexpectedContextCleanupFailed);
    const clearHydratedPortalViewState = (0, $7E7Dk.useCallback)(()=>{
        dispatch((0, $jnDYy.setUser)($8ea5def47420d775$var$emptySessionUser));
        dispatch((0, $hw820.clearEntitlements)());
    }, [
        dispatch
    ]);
    const handlePortalSessionReset = (0, $7E7Dk.useCallback)(()=>{
        dispatch((0, $eFTdF.requestPortalSessionReset)());
    }, [
        dispatch
    ]);
    const applyHydratedPortalSession = (0, $7E7Dk.useCallback)(()=>{
        dispatch((0, $jnDYy.setUser)(sessionUser));
        if (sessionEntitlements || selectedOrganizationId) dispatch((0, $hw820.setEntitlements)((0, $hw820.normalizeEntitlementsState)(sessionEntitlements, selectedOrganizationId)));
        else dispatch((0, $hw820.clearEntitlements)());
    }, [
        dispatch,
        selectedOrganizationId,
        sessionEntitlements,
        sessionUser
    ]);
    (0, $7E7Dk.useEffect)(()=>(0, $2gS28.addPortalSessionResetListener)(handlePortalSessionReset), [
        handlePortalSessionReset
    ]);
    // React owns same-tab portal-session reset by turning the shared reset signal into session state work.
    (0, $7E7Dk.useEffect)(()=>{
        if (portalSessionResetCount === 0) return;
        setIsClearingUnexpectedContext(false);
        setHasUnexpectedContextCleanupFailed(false);
        (0, $2c4gm.clearPortalSessionClientState)();
        dispatchApiAction((0, $1O9Jh.enhancedApi).util.resetApiState());
        dispatch((0, $jnDYy.reset)());
    }, [
        dispatch,
        dispatchApiAction,
        portalSessionResetCount
    ]);
    // Remove unexpected org-scoped context before authenticating non-admin portals.
    (0, $7E7Dk.useEffect)(()=>{
        if (!sessionQuery.isSuccess || !userHasPortalAccess || !hasUnexpectedEntitlementsContext) return;
        let isMounted = true;
        setIsClearingUnexpectedContext(true);
        setHasUnexpectedContextCleanupFailed(false);
        deleteEntitlementsContext().unwrap().then(()=>{
            if (!isMounted) return;
            dispatchApiAction((0, $1O9Jh.enhancedApi).util.upsertQueryData("authGetCurrent", undefined, (0, $cy4b3.mergeAuthCurrentCache)(sessionQuery.data, {
                selectedOrganizationId: null,
                entitlements: null
            })));
            dispatch((0, $hw820.clearEntitlements)());
        }).catch(()=>{
            if (!isMounted) return;
            setHasUnexpectedContextCleanupFailed(true);
        }).finally(()=>{
            if (!isMounted) return;
            setIsClearingUnexpectedContext(false);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        deleteEntitlementsContext,
        dispatch,
        dispatchApiAction,
        hasUnexpectedEntitlementsContext,
        selectedOrganizationId,
        sessionEntitlements,
        sessionQuery.data,
        sessionQuery.isSuccess,
        userHasPortalAccess
    ]);
    // Sync hydrated backend session data into local runtime state when the session is usable.
    (0, $7E7Dk.useEffect)(()=>{
        if (!sessionQuery.isSuccess) return;
        if (canHydrateSession) {
            applyHydratedPortalSession();
            return;
        }
        clearHydratedPortalViewState();
    }, [
        applyHydratedPortalSession,
        canHydrateSession,
        clearHydratedPortalViewState,
        sessionQuery.isSuccess
    ]);
    // Fail closed locally on unauthorized bootstrap without trying to manipulate the shared backend session.
    // No-current-session `204` is handled separately through the successful empty-payload path.
    (0, $7E7Dk.useEffect)(()=>{
        if (!sessionQuery.isError) return;
        const status = sessionQuery.error.status;
        if (status === 401) clearHydratedPortalViewState();
    }, [
        clearHydratedPortalViewState,
        sessionQuery.error,
        sessionQuery.isError
    ]);
    return (0, $7E7Dk.useMemo)(()=>{
        return (0, $jZWFX.getPortalSessionStatus)({
            isSuccess: sessionQuery.isSuccess,
            isLoading: sessionQuery.isLoading,
            isFetching: sessionQuery.isFetching,
            isClearingUnexpectedContext: isClearingUnexpectedContext,
            canHydrateSession: canHydrateSession
        });
    }, [
        canHydrateSession,
        isClearingUnexpectedContext,
        sessionQuery.isFetching,
        sessionQuery.isLoading,
        sessionQuery.isSuccess
    ]);
};

});
parcelRegister("cy4b3", function(module, exports) {

$parcel$export(module.exports, "mergeAuthCurrentCache", function () { return $5fa1cf6de221d270$export$8255383827b0ba53; });
// Preserve the current cached field unless the patch explicitly replaces or clears it.
const $5fa1cf6de221d270$var$resolvePatchedField = (currentValue, nextValue)=>{
    if (typeof nextValue === "undefined") return currentValue ?? null;
    return nextValue;
};
// Merge partial user updates into the cached auth/current user while still allowing explicit clear.
const $5fa1cf6de221d270$var$mergePatchedUser = (currentUser, nextUser)=>{
    if (typeof nextUser === "undefined") return currentUser ?? null;
    if (nextUser === null) return null;
    return {
        ...currentUser ?? {},
        ...nextUser
    };
};
const $5fa1cf6de221d270$export$8255383827b0ba53 = (current, patch)=>({
        user: $5fa1cf6de221d270$var$mergePatchedUser(current?.user, patch.user),
        selectedOrganizationId: $5fa1cf6de221d270$var$resolvePatchedField(current?.selectedOrganizationId, patch.selectedOrganizationId),
        entitlements: $5fa1cf6de221d270$var$resolvePatchedField(current?.entitlements, patch.entitlements),
        portalAudience: $5fa1cf6de221d270$var$resolvePatchedField(current?.portalAudience, patch.portalAudience),
        scopedAccess: $5fa1cf6de221d270$var$resolvePatchedField(current?.scopedAccess, patch.scopedAccess)
    });

});

parcelRegister("2c4gm", function(module, exports) {

$parcel$export(module.exports, "clearPortalSessionClientState", function () { return $bcf6d30592512bd4$export$66d29fa54d1a52d5; });

var $ieP8o = parcelRequire("ieP8o");
const $bcf6d30592512bd4$export$66d29fa54d1a52d5 = ()=>{
    (0, $ieP8o.clearCsrfToken)();
};

});


parcelRegister("kNBIm", function(module, exports) {

$parcel$export(module.exports, "PortalSessionLoader", function () { return $1c707a78aa1c924f$export$26c9c9005db3aa17; });

var $7E7Dk = parcelRequire("7E7Dk");

var $22lzE = parcelRequire("22lzE");
const $1c707a78aa1c924f$export$26c9c9005db3aa17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-center",
        style: {
            minHeight: "50vh"
        },
        "data-testid": "portal-session-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $22lzE.ProgressSpinner), null));

});
parcelRegister("22lzE", function(module, exports) {

$parcel$export(module.exports, "ProgressSpinner", function () { return $17bc80d5470e71f0$export$dcc7532e7120780d; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");
"use client";
var $17bc80d5470e71f0$var$classes = {
    root: "p-progress-spinner",
    spinner: "p-progress-spinner-svg",
    circle: "p-progress-spinner-circle"
};
var $17bc80d5470e71f0$var$styles = "\n@layer primereact {\n    .p-progress-spinner {\n        position: relative;\n        margin: 0 auto;\n        width: 100px;\n        height: 100px;\n        display: inline-block;\n    }\n    \n    .p-progress-spinner::before {\n        content: '';\n        display: block;\n        padding-top: 100%;\n    }\n    \n    .p-progress-spinner-svg {\n        animation: p-progress-spinner-rotate 2s linear infinite;\n        height: 100%;\n        transform-origin: center center;\n        width: 100%;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: auto;\n    }\n    \n    .p-progress-spinner-circle {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: 0;\n        stroke: #d62d20;\n        animation: p-progress-spinner-dash 1.5s ease-in-out infinite, p-progress-spinner-color 6s ease-in-out infinite;\n        stroke-linecap: round;\n    }\n}\n\n@keyframes p-progress-spinner-rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes p-progress-spinner-dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n@keyframes p-progress-spinner-color {\n    100%,\n    0% {\n        stroke: #d62d20;\n    }\n    40% {\n        stroke: #0057e7;\n    }\n    66% {\n        stroke: #008744;\n    }\n    80%,\n    90% {\n        stroke: #ffa700;\n    }\n}\n";
var $17bc80d5470e71f0$var$inlineStyles = {
    spinner: function spinner(_ref) {
        var props = _ref.props;
        return {
            animationDuration: props.animationDuration
        };
    }
};
var $17bc80d5470e71f0$var$ProgressSpinnerBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "ProgressSpinner",
        id: null,
        style: null,
        className: null,
        strokeWidth: "2",
        fill: "none",
        animationDuration: "2s",
        children: undefined
    },
    css: {
        classes: $17bc80d5470e71f0$var$classes,
        styles: $17bc80d5470e71f0$var$styles,
        inlineStyles: $17bc80d5470e71f0$var$inlineStyles
    }
});
var $17bc80d5470e71f0$export$dcc7532e7120780d = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $17bc80d5470e71f0$var$ProgressSpinnerBase.getProps(inProps, context);
    var elementRef = $7E7Dk.useRef(null);
    var _ProgressSpinnerBase$ = $17bc80d5470e71f0$var$ProgressSpinnerBase.setMetaData({
        props: props
    }), ptm = _ProgressSpinnerBase$.ptm, cx = _ProgressSpinnerBase$.cx, sx = _ProgressSpinnerBase$.sx, isUnstyled = _ProgressSpinnerBase$.isUnstyled;
    (0, $kHEnT.useHandleStyle)($17bc80d5470e71f0$var$ProgressSpinnerBase.css.styles, isUnstyled, {
        name: "progressspinner"
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        style: props.style,
        className: (0, $7nrKB.classNames)(props.className, cx("root")),
        role: "progressbar",
        "aria-busy": true
    }, $17bc80d5470e71f0$var$ProgressSpinnerBase.getOtherProps(props), ptm("root"));
    var spinnerProps = mergeProps({
        className: cx("spinner"),
        viewBox: "25 25 50 50",
        style: sx("spinner")
    }, ptm("spinner"));
    var circleProps = mergeProps({
        className: cx("circle"),
        cx: "50",
        cy: "50",
        r: "20",
        fill: props.fill,
        strokeWidth: props.strokeWidth,
        strokeMiterlimit: "10"
    }, ptm("circle"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement("svg", spinnerProps, /*#__PURE__*/ $7E7Dk.createElement("circle", circleProps)));
}));
$17bc80d5470e71f0$export$dcc7532e7120780d.displayName = "ProgressSpinner";

});


parcelRegister("gUTZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb27b72bd75d6307$export$2e2bcd8739ae039; });
const $cb27b72bd75d6307$var$ChargePointExpandOptions = {
    OcppConfig: "ocppConfig",
    AdditionalInfo: "additionalInfo",
    WifiSignal: "wifisignal",
    PartnerInfo: "partnerInfo",
    TopChargingLimitation: "topChargingLimitation"
};
var $cb27b72bd75d6307$export$2e2bcd8739ae039 = $cb27b72bd75d6307$var$ChargePointExpandOptions;

});

parcelRegister("4gSsL", function(module, exports) {

$parcel$export(module.exports, "useAdaptConnectorNaming", function () { return $01f493de02bd950e$export$1f8649133959f0d4; });

var $5u6k9 = parcelRequire("5u6k9");
const $01f493de02bd950e$export$1f8649133959f0d4 = ()=>{
    const text = (0, $5u6k9.default)();
    return (connectorName)=>{
        switch(connectorName){
            case "Left socket":
                return text("lblLeftSocket");
            case "Right socket":
                return text("lblRightSocket");
            case "Socket":
                return text("lblSocket");
            case "Charger":
                return text("lblCharger");
            case "Schuko":
                return text("lblSchuko");
            default:
                return connectorName || "";
        }
    };
};

});

parcelRegister("1hIPE", function(module, exports) {

$parcel$export(module.exports, "isAuraImport", function () { return $a95732609e5e6ced$export$b1052c87ae61cc8c; });
$parcel$export(module.exports, "default", function () { return $a95732609e5e6ced$export$2e2bcd8739ae039; });

var $4qITT = parcelRequire("4qITT");
const $a95732609e5e6ced$var$isAura = (entity)=>{
    const productId = typeof entity === "number" ? entity : entity?.productId;
    return productId === (0, $4qITT.ChargerProducts).Aura || productId === (0, $4qITT.ChargerProducts).Aura2;
};
const $a95732609e5e6ced$export$b1052c87ae61cc8c = (chargePoint)=>chargePoint?.productType === "Aura" || chargePoint?.productType === "Aura2";
var $a95732609e5e6ced$export$2e2bcd8739ae039 = $a95732609e5e6ced$var$isAura;

});
parcelRegister("4qITT", function(module, exports) {

$parcel$export(module.exports, "ChargerProducts", function () { return $fe5dc94a477384f2$export$7f5a9cbf2e5b90ea; });
$parcel$export(module.exports, "getChargerProductDefinition", function () { return $fe5dc94a477384f2$export$948d7ab7be119fdb; });
$parcel$export(module.exports, "getChargerProductModelName", function () { return $fe5dc94a477384f2$export$1ebad253904bac64; });
$parcel$export(module.exports, "MeasurementDeviceProducts", function () { return $fe5dc94a477384f2$export$58d44960e206b53f; });
var $fe5dc94a477384f2$export$7f5a9cbf2e5b90ea;
(function(ChargerProducts) {
    ChargerProducts[ChargerProducts["Halo1"] = 1] = "Halo1";
    ChargerProducts[ChargerProducts["Halo2"] = 3] = "Halo2";
    ChargerProducts[ChargerProducts["Aura"] = 4] = "Aura";
    ChargerProducts[ChargerProducts["Dawn"] = 7] = "Dawn";
    ChargerProducts[ChargerProducts["Luna"] = 9] = "Luna";
    ChargerProducts[ChargerProducts["Aura2"] = 10] = "Aura2";
})($fe5dc94a477384f2$export$7f5a9cbf2e5b90ea || ($fe5dc94a477384f2$export$7f5a9cbf2e5b90ea = {}));
const $fe5dc94a477384f2$export$e33336cb2c40092 = {
    [1]: {
        modelName: "Halo1",
        brandedName: "Charge Amps Halo",
        translationKey: "lblHaloControlWidget"
    },
    [3]: {
        modelName: "Halo2",
        brandedName: "Charge Amps Halo",
        translationKey: "lblHaloControlWidget"
    },
    [4]: {
        modelName: "Aura",
        brandedName: "Charge Amps Aura",
        translationKey: "lblAuraControl"
    },
    [7]: {
        modelName: "Dawn",
        brandedName: "Charge Amps Dawn",
        translationKey: "lblDawnControlOcppWidget"
    },
    [9]: {
        modelName: "Luna",
        brandedName: "Charge Amps Luna",
        translationKey: "lblLunaControlOcppWidget"
    },
    [10]: {
        modelName: "Aura 2",
        brandedName: "Charge Amps Aura 2",
        translationKey: "lblAura2Control"
    }
};
const $fe5dc94a477384f2$export$948d7ab7be119fdb = (productId)=>{
    if (productId == null) return undefined;
    return $fe5dc94a477384f2$export$e33336cb2c40092[Number(productId)];
};
const $fe5dc94a477384f2$export$1ebad253904bac64 = (productId, fallbackName = "")=>$fe5dc94a477384f2$export$948d7ab7be119fdb(productId)?.modelName ?? fallbackName;
var $fe5dc94a477384f2$export$58d44960e206b53f;
(function(MeasurementDeviceProducts) {
    MeasurementDeviceProducts[MeasurementDeviceProducts["AmpGuard"] = 5] = "AmpGuard";
    MeasurementDeviceProducts[MeasurementDeviceProducts["Enegic"] = 6] = "Enegic";
    MeasurementDeviceProducts[MeasurementDeviceProducts["AmpGuard2"] = 8] = "AmpGuard2";
})($fe5dc94a477384f2$export$58d44960e206b53f || ($fe5dc94a477384f2$export$58d44960e206b53f = {}));
var $fe5dc94a477384f2$export$728bce6e54e35d07;
(function(MiscProducts) {
    MiscProducts[MiscProducts["Ray"] = 2] = "Ray";
})($fe5dc94a477384f2$export$728bce6e54e35d07 || ($fe5dc94a477384f2$export$728bce6e54e35d07 = {}));
const $fe5dc94a477384f2$export$92e44ea1079b9ec6 = {
    ...$fe5dc94a477384f2$export$7f5a9cbf2e5b90ea,
    ...$fe5dc94a477384f2$export$58d44960e206b53f,
    ...$fe5dc94a477384f2$export$728bce6e54e35d07
};

});


parcelRegister("jwHtR", function(module, exports) {
$parcel$export(module.exports, "dateLocalize", function () { return (parcelRequire("89RyD")).dateLocalize; });
parcelRequire("89RyD");

});
parcelRegister("89RyD", function(module, exports) {

$parcel$export(module.exports, "dateLocalize", function () { return $01979c0ad7e029c6$export$638e95005c0a3da5; });
function $01979c0ad7e029c6$export$638e95005c0a3da5(utcDate) {
    if (!utcDate) return "---";
    return new Date(utcDate + "Z").toLocaleString("sv-SE");
}

});


parcelRegister("7PpdL", function(module, exports) {
$parcel$export(module.exports, "isMoreItemsToLoad", function () { return (parcelRequire("6n6Zs")).isMoreItemsToLoad; });
parcelRequire("6n6Zs");

});
parcelRegister("6n6Zs", function(module, exports) {

$parcel$export(module.exports, "isMoreItemsToLoad", function () { return $08c13976577cba1f$export$2383ed76621aa505; });
function $08c13976577cba1f$export$2383ed76621aa505(numberOfItems, items) {
    if (items === 0) return false;
    return items % numberOfItems === 0;
}

});


parcelRegister("1gy6g", function(module, exports) {

$parcel$export(module.exports, "CHARGE_POINT_REFRESH_TIMEOUT", function () { return $2bf10428cd3be436$export$83f584de9934ae38; });
const $2bf10428cd3be436$export$83f584de9934ae38 = 10000;

});

parcelRegister("54O4W", function(module, exports) {
$parcel$export(module.exports, "ChargePointOcppAuraControlWidget", function () { return (parcelRequire("dHGi6")).ChargePointOcppAuraControlWidget; });
parcelRequire("dHGi6");

});
parcelRegister("dHGi6", function(module, exports) {

$parcel$export(module.exports, "ChargePointOcppAuraControlWidget", function () { return $8a3efebc1d291d53$export$c8b91e68d36ddb44; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("aOtT6");
var $8jOMy = parcelRequire("8jOMy");
parcelRequire("gRHjN");
var $jsfFW = parcelRequire("jsfFW");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");
parcelRequire("idbtm");
var $jjP9q = parcelRequire("jjP9q");
parcelRequire("1cTx9");
var $3uHTN = parcelRequire("3uHTN");

var $1O9Jh = parcelRequire("1O9Jh");

var $8KtsS = parcelRequire("8KtsS");

var $eIymc = parcelRequire("eIymc");

var $6GGmy = parcelRequire("6GGmy");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
function $8a3efebc1d291d53$export$c8b91e68d36ddb44({ userId: userId, isReadOnly: isReadOnly = false, chargePoint: chargePoint }) {
    const isOnline = chargePoint.chargePointStatus !== "Offline";
    const [remoteStart] = (0, $1O9Jh.useChargePointRemoteStartMutation)();
    const [remoteStop] = (0, $1O9Jh.useChargePointRemoteStopMutation)();
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: chargePoint.id
    });
    const [selectRfidDialogIsOpen, setSelectRfidDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [currentConnector, setCurrentConnector] = (0, $7E7Dk.useState)(1);
    const [overrideSchedule] = (0, $1O9Jh.useChargePointOverrideScheduleForOngoingChargingSessionMutation)();
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const toast = (0, $eBlmY.useToast)();
    const [connectors, setConnectors] = (0, $7E7Dk.useState)(chargePoint.connectors ?? []);
    const text = (0, $5u6k9.default)();
    (0, $7E7Dk.useEffect)(()=>{
        setConnectors(chargePoint.connectors ?? []);
    }, [
        chargePoint.connectors
    ]);
    const handleRemoteStart = async (connectorId, rfidTag)=>{
        await remoteStart({
            chargePointId: chargePoint.id,
            connectorId: connectorId,
            rfidTag: rfidTag
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStartSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStartAdminFailed" : "msgRemoteStartFailed")));
    };
    const handleRemoteControl = async (connectorId, isNfcLockOn)=>{
        setCurrentConnector(connectorId);
        const connector = chargePoint?.connectors?.find((connector)=>connector.connectorId === connectorId);
        if ((0, $8KtsS.remoteStopIsAvailable)(connector ?? null)) await remoteStop({
            chargePointId: chargePoint.id,
            connectorId: connectorId
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStopSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStopAdminFailed" : "msgRemoteStopFailed")));
        else {
            if (isNfcLockOn) setSelectRfidDialogIsOpen(true);
            else if (connector?.defaultNfcTagId) handleRemoteStart(connectorId, connector?.defaultNfcTagId);
            else toast.notifyError(text("msgRemoteStartFailed"));
        }
    };
    const handleOverrideSchedule = async (connectorId)=>{
        setCurrentConnector(connectorId);
        await overrideSchedule({
            chargePointId: chargePoint.id,
            connectorId: connectorId
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgIgnoreScheduleSuccess"));
        }).catch((error)=>{
            toast.notifyError((0, $6GGmy.showErrorMessagesForIgnoreSchedule)(error.data.error));
        });
    };
    const handleConnectorUpdate = (connectorId, updatedConnector)=>{
        setConnectors((prev)=>prev.map((c)=>c.connectorId === connectorId ? updatedConnector : c));
        const updatedConnectors = connectors.map((c)=>c.connectorId === connectorId ? updatedConnector : c);
        updateChargePoint({
            chargePoint: {
                ...chargePoint,
                connectors: updatedConnectors
            }
        }).unwrap().catch(()=>{
            // Revert the optimistic update on error
            setConnectors(chargePoint.connectors ?? []);
            toast.notifyError(text("msgFailedToUpdateAvailability"));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblAuraControl"
    }, connectors.map((connector)=>{
        if (!(0, $8jOMy.isUserHasAccessToConnector)(connector, chargePoint?.ownerId, userId)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jsfFW.OcppAuraConnectorControl), {
            connector: connector,
            isReadOnly: isReadOnly,
            isOnline: isOnline,
            chargePoint: chargePoint,
            key: connector.connectorId,
            onRemoteControl: ({ connectorId: connectorId, isNfcLockOn: isNfcLockOn })=>handleRemoteControl(connectorId, isNfcLockOn),
            handleOverrideSchedule: handleOverrideSchedule,
            onConnectorUpdate: handleConnectorUpdate
        });
    }), (0, $8jOMy.isUserHasAccessToConnector)(connectors[0], chargePoint?.ownerId, userId) && (0, $8jOMy.isUserHasAccessToConnector)(connectors[1], chargePoint.ownerId, userId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jjP9q.RemoteOcppDimmerControl), {
        chargePoint: chargePoint,
        isReadOnly: isReadOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3uHTN.SelectRfidTagDialog), {
        visible: selectRfidDialogIsOpen,
        chargePointId: chargePoint.id,
        connectorId: currentConnector,
        onStartCharging: (rfidTag)=>{
            setSelectRfidDialogIsOpen(false);
            handleRemoteStart(currentConnector, rfidTag);
        },
        onHide: ()=>setSelectRfidDialogIsOpen(false)
    }));
}

});
parcelRegister("aOtT6", function(module, exports) {
$parcel$export(module.exports, "isUserHasAccessToAnyConnector", function () { return (parcelRequire("8jOMy")).isUserHasAccessToAnyConnector; });
$parcel$export(module.exports, "isUserHasAccessToConnector", function () { return (parcelRequire("8jOMy")).isUserHasAccessToConnector; });
parcelRequire("8jOMy");

});
parcelRegister("8jOMy", function(module, exports) {

$parcel$export(module.exports, "isUserHasAccessToConnector", function () { return $218154ac9c2f1e54$export$cd4b9c35d5bbbcab; });
$parcel$export(module.exports, "isUserHasAccessToAnyConnector", function () { return $218154ac9c2f1e54$export$60af8e63e3263631; });
function $218154ac9c2f1e54$export$cd4b9c35d5bbbcab(connector, ownerId, userId) {
    if (connector === null || connector === undefined) return false;
    return userId === undefined || userId === null || //Admin
    ownerId === userId || connector.connectorUserId === userId;
}
function $218154ac9c2f1e54$export$60af8e63e3263631(connectors, ownerId, userId) {
    return connectors.find((connector)=>$218154ac9c2f1e54$export$cd4b9c35d5bbbcab(connector, ownerId, userId)) !== undefined;
}

});


parcelRegister("gRHjN", function(module, exports) {
$parcel$export(module.exports, "KEY_CABLE_LOCK", function () { return (parcelRequire("jsfFW")).KEY_CABLE_LOCK; });
$parcel$export(module.exports, "KEY_FREE_CHARGING", function () { return (parcelRequire("jsfFW")).KEY_FREE_CHARGING; });
$parcel$export(module.exports, "OcppAuraConnectorControl", function () { return (parcelRequire("jsfFW")).OcppAuraConnectorControl; });
parcelRequire("jsfFW");

});
parcelRegister("jsfFW", function(module, exports) {

$parcel$export(module.exports, "KEY_FREE_CHARGING", function () { return $8fe7378878732c2d$export$ccb8679159077362; });
$parcel$export(module.exports, "KEY_CABLE_LOCK", function () { return $8fe7378878732c2d$export$8defa00be67e730b; });
$parcel$export(module.exports, "OcppAuraConnectorControl", function () { return $8fe7378878732c2d$export$277bea960e6158e6; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $c9GjL = parcelRequire("c9GjL");

var $ilUpc = parcelRequire("ilUpc");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $auuMO = parcelRequire("auuMO");
parcelRequire("2NaMI");
var $a7txM = parcelRequire("a7txM");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");

var $7xC39 = parcelRequire("7xC39");
parcelRequire("dxLcn");
var $8KtsS = parcelRequire("8KtsS");

var $eIymc = parcelRequire("eIymc");
parcelRequire("5DZBN");
var $2KaGD = parcelRequire("2KaGD");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
const $8fe7378878732c2d$export$ccb8679159077362 = "FreeCharging";
const $8fe7378878732c2d$export$8defa00be67e730b = "CableLock";
var $8fe7378878732c2d$export$911ae59f93836881;
(function(NfcLockState) {
    NfcLockState["ON"] = "0";
    NfcLockState["OFF"] = "1";
})($8fe7378878732c2d$export$911ae59f93836881 || ($8fe7378878732c2d$export$911ae59f93836881 = {}));
var $8fe7378878732c2d$export$ac9125e28e97424f;
(function(CableLockState) {
    CableLockState["ON"] = "1";
    CableLockState["OFF"] = "0";
})($8fe7378878732c2d$export$ac9125e28e97424f || ($8fe7378878732c2d$export$ac9125e28e97424f = {}));
function $8fe7378878732c2d$export$277bea960e6158e6({ connector: connector, isOnline: isOnline, chargePoint: chargePoint, isReadOnly: isReadOnly, onRemoteControl: onRemoteControl, handleOverrideSchedule: handleOverrideSchedule, onConnectorUpdate: onConnectorUpdate }) {
    const [configKeys, setConfigKeys] = (0, $7E7Dk.useState)(chargePoint.ocppConfigKeys);
    const toast = (0, $eBlmY.useToast)();
    const text = (0, $5u6k9.default)();
    const { data: schedules } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id
    });
    const connectorHasSchedule = (connectorId)=>{
        return schedules?.some((schedule)=>schedule.connectorId === connectorId);
    };
    (0, $7E7Dk.useEffect)(()=>{
        setConfigKeys(chargePoint.ocppConfigKeys);
    }, [
        chargePoint
    ]);
    const [saveConfigKey] = (0, $1O9Jh.useOcppCommandUpdateConfigKeyMutation)();
    const nfcLockValue = (0, $a7txM.getConfigValue)($8fe7378878732c2d$export$ccb8679159077362, configKeys, connector.connectorId);
    const isNfcLockOn = nfcLockValue ? nfcLockValue === "0" : false;
    const cableLockValue = (0, $a7txM.getConfigValue)($8fe7378878732c2d$export$8defa00be67e730b, configKeys, connector.connectorId);
    const isCableLockOn = cableLockValue ? cableLockValue === "1" : false;
    const remoteStartIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStartIsAvailable)(connector), [
        connector
    ]);
    const remoteStopIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStopIsAvailable)(connector), [
        connector
    ]);
    const setConnectorOcppConfigValue = async (key, value)=>{
        const prevValue = (0, $auuMO.default)(key, configKeys);
        if (!(prevValue && value && chargePoint)) return;
        const values = prevValue.split(",");
        values[connector.connectorId - 1] = `${connector.connectorId}.${value}`;
        const updatedConfigKeys = (0, $7xC39.default)(key, values.join(","), configKeys);
        if (!updatedConfigKeys) return;
        await saveConfigKey({
            chargePointId: chargePoint.id,
            keyValue: updatedConfigKeys.find((configKeys)=>configKeys.key === key)
        }).unwrap().then(()=>setConfigKeys(updatedConfigKeys)).catch(()=>toast.notifyError(text("msgRemoteControlCommandFailed")));
    };
    const showStartStopChargingButton = !(0, $eIymc.isUserappDomain) && isOnline && (remoteStartIsVisible || remoteStopIsVisible);
    const showIgnoreScheduleButton = !(0, $eIymc.isUserappDomain) && isOnline && remoteStopIsVisible && connector?.mode === "Schedule";
    const handleConnectorStateChange = (connectorId)=>async (state)=>{
            if (state === "Schedule" && !connectorHasSchedule(connectorId)) return (0, $c9GjL.confirmDialog)({
                header: text("msgNoSchedulesHeader"),
                message: text("msgNoSchedulesText"),
                acceptClassName: "hidden",
                rejectLabel: text("btnClose")
            });
            const updatedConnector = {
                ...connector,
                mode: state
            };
            onConnectorUpdate?.(connectorId, updatedConnector);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
            id: `connector-mode-${chargePoint.id}-${connector.connectorId}`,
            ariaLabel: text(connector.connectorId === 1 ? "lblLeftSocket" : "lblRightSocket"),
            options: [
                {
                    label: text("lblOff"),
                    value: "Off"
                },
                {
                    label: text("lblConnectorSchedule"),
                    value: "Schedule"
                },
                {
                    label: text("lblConnectorAlwaysOn"),
                    value: "On"
                }
            ],
            value: connector.mode,
            onChange: handleConnectorStateChange(connector.connectorId ?? 1),
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            className: "w-20rem max-w-full",
            "data-testid": `charger-${chargePoint.id}-connector-${connector.connectorId}`
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `charger-${chargePoint.id}-connector-label-${connector.connectorId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: connector.connectorId === 1 ? "lblLeftSocket" : "lblRightSocket"
        })),
        remoteChargingControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex gap-2 flex-column sm:flex-row"
        }, showStartStopChargingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            size: "small",
            "data-testid": `remote-control-button-${connector.connectorId}`,
            onClick: ()=>onRemoteControl({
                    connectorId: connector.connectorId,
                    isNfcLockOn: isNfcLockOn
                }),
            disabled: !isOnline,
            label: text(remoteStopIsVisible ? "lblStop" : "lblStart"),
            outlined: true,
            tooltip: remoteStartIsVisible ? text("lblStartChargingInfo") : text("lblStopSession"),
            severity: "info",
            icon: remoteStopIsVisible ? "pi pi-stop-circle" : "pi pi-play-circle"
        }), showIgnoreScheduleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: text("lblIgnoreSchedule"),
            style: {
                padding: "6px"
            },
            "data-testid": `ignore-schedule-button-${connector.connectorId}`,
            onClick: ()=>handleOverrideSchedule(connector.connectorId),
            outlined: true,
            severity: "info",
            icon: "pi pi-calendar-times"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>setConnectorOcppConfigValue($8fe7378878732c2d$export$ccb8679159077362, nfcLockValue === "0" ? "1" : "0"),
            disabled: isReadOnly || (0, $2KaGD.onGoingTransactionStates).includes(connector?.ocppStatus) || !isOnline || chargePoint?.ocppEnabled,
            isToggled: isNfcLockOn,
            "data-testid": `rfid-${chargePoint.id}-connector-${connector.connectorId}`
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `rfid-label-${chargePoint.id}-connector-${connector.connectorId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDLock"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>setConnectorOcppConfigValue($8fe7378878732c2d$export$8defa00be67e730b, cableLockValue === "1" ? "0" : "1"),
            disabled: !isOnline || chargePoint?.ocppEnabled || isReadOnly,
            isToggled: isCableLockOn,
            "data-testid": `cable-lock-toggle-${chargePoint.id}-connector-${connector.connectorId}`
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `cable-lock-label-${chargePoint.id}-connector-${connector.connectorId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCableLock"
        }))
    }));
}

});
parcelRegister("ilUpc", function(module, exports) {

$parcel$export(module.exports, "Toggle", function () { return $4d60eda497f1fc19$export$bea8ebba691c5813; });
$parcel$export(module.exports, "default", function () { return $4d60eda497f1fc19$export$2e2bcd8739ae039; });

var $a9SdK = parcelRequire("a9SdK");

var $g7dDc = parcelRequire("g7dDc");

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $5u6k9 = parcelRequire("5u6k9");

var $49Gcz = parcelRequire("49Gcz");
const $4d60eda497f1fc19$var$Label = (0, $gRonV.default).span`
    display: flex;
    align-items: center;
    gap: ${({ theme: theme })=>theme.sizing.margin.m};
`;
const $4d60eda497f1fc19$export$bea8ebba691c5813 = /*#__PURE__*/ (0, $7E7Dk.forwardRef)(function Toggle({ size: size = "md", showStateLabel: showStateLabel = false, loading: loading, labelPos: labelPos = "left", icon: icon, iconPos: iconPos = "right", toggleText: toggleText, isToggled: isToggled, disabled: disabled, toggleFn: toggleFn, ...props }, ref) {
    const text = (0, $5u6k9.default)();
    const renderStateLabel = isToggled ? text("lblOn") : text("lblOff");
    const label = (showStateLabel || toggleText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($4d60eda497f1fc19$var$Label, {
        "data-testid": `${props["data-testid"]}-toggleText`
    }, iconPos === "left" && icon, toggleText ?? renderStateLabel, iconPos === "right" && icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $49Gcz.SContainer), {
        onClick: (e)=>e.stopPropagation(),
        ...props
    }, labelPos === "left" && label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $49Gcz.SLabel), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            toggled: isToggled,
            disabled: disabled
        }),
        size: size,
        "data-testid": `${props["data-testid"]}-label`
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
        icon: (0, $a9SdK.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $49Gcz.Slider), {
        ref: ref,
        id: "slider",
        onClick: ()=>{
            if (!disabled && toggleFn) toggleFn();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            disabled: disabled
        }),
        "data-testid": `${props["data-testid"]}-slider`
    })), labelPos === "right" && label);
});
var $4d60eda497f1fc19$export$2e2bcd8739ae039 = $4d60eda497f1fc19$export$bea8ebba691c5813;

});
parcelRegister("49Gcz", function(module, exports) {

$parcel$export(module.exports, "SContainer", function () { return $5e0fa06f0646e9d9$export$626d401ce90fce61; });
$parcel$export(module.exports, "SLabel", function () { return $5e0fa06f0646e9d9$export$6fb71ba7b3169d46; });
$parcel$export(module.exports, "Slider", function () { return $5e0fa06f0646e9d9$export$472062a354075cee; });

var $gRonV = parcelRequire("gRonV");
const $5e0fa06f0646e9d9$export$626d401ce90fce61 = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    gap: 10px;
`;
const $5e0fa06f0646e9d9$export$6fb71ba7b3169d46 = (0, $gRonV.default).label`
    position: relative;
    display: inline-block;
    width: 48px;
    min-width: 48px;
    height: 30px;
    border-radius: 34px;
    background-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    border: 1px solid #a1a1a1;
    padding: 4px;
    margin-bottom: unset;
    transition: all 0.2s ease-in;
    transform: ${({ size: size })=>{
    if (size === "sm") return "scale(0.6)";
    if (size === "md") return "scale(0.8)";
    return "scale(1)";
}};

    &.toggled {
        background-color: ${({ theme: theme })=>theme.font.successColor};
        & > #slider:before {
            -webkit-transform: translateX(18px);
            -ms-transform: translateX(18px);
            transform: translateX(18px);
        }
    }

    &.disabled {
        opacity: 0.5;
    }

    &:before {
        border-radius: 50%;
    }
    @media (max-width: 600px) {
        font-size: 14px;
    }
`;
const $5e0fa06f0646e9d9$export$472062a354075cee = (0, $gRonV.default).span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 100%;

    &:before {
        position: absolute;
        content: '';
        height: 22px;
        width: 22px;
        left: 3px;
        top: 3px;
        background-color: white;
        border: 1px solid #a1a1a1;
        border-radius: 100%;
        transition: all 0.2s ease-in;
    }

    &.disabled {
        cursor: not-allowed;
    }
`;

});


parcelRegister("auuMO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $954787bffbb67b4c$export$2e2bcd8739ae039; });
const $954787bffbb67b4c$var$findOcppConfig = (key, ocppConfigKeys)=>{
    if (!ocppConfigKeys || !ocppConfigKeys.length) return null;
    return ocppConfigKeys?.find((x)=>x.key === key)?.value;
};
var $954787bffbb67b4c$export$2e2bcd8739ae039 = $954787bffbb67b4c$var$findOcppConfig;

});

parcelRegister("2NaMI", function(module, exports) {
$parcel$export(module.exports, "getConfigValue", function () { return (parcelRequire("a7txM")).getConfigValue; });
parcelRequire("a7txM");

});
parcelRegister("a7txM", function(module, exports) {

$parcel$export(module.exports, "getConfigValue", function () { return $42f589be93de9feb$export$81dc98ed13b87921; });

var $auuMO = parcelRequire("auuMO");
function $42f589be93de9feb$export$81dc98ed13b87921(key, configKeys, connectorId) {
    const value = (0, $auuMO.default)(key, configKeys);
    if (value === null || value === undefined) return null;
    return connectorId ? value.split(",")[connectorId - 1]?.replace(`${connectorId}.`, "") : value;
}

});


parcelRegister("iCzEn", function(module, exports) {
$parcel$export(module.exports, "RemoteControlRow", function () { return (parcelRequire("haBsc")).RemoteControlRow; });
parcelRequire("haBsc");

});
parcelRegister("haBsc", function(module, exports) {

$parcel$export(module.exports, "RemoteControlRow", function () { return $76a67d03f7896b9e$export$49bffa91338a86fc; });

var $7E7Dk = parcelRequire("7E7Dk");
function $76a67d03f7896b9e$export$49bffa91338a86fc({ button: button, title: title, status: status, remoteChargingControl: remoteChargingControl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-3 py-3 border-bottom-1 border-200 flex-wrap lg:flex-nowrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "lg:flex-shrink-0"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex-1"
    }, status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2 lg:flex-shrink-0"
    }, remoteChargingControl, button));
}

});


parcelRegister("7xC39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df9d9b3a9bec0082$export$2e2bcd8739ae039; });
const $df9d9b3a9bec0082$var$setOcppConfigValue = (key, value, configKeys)=>{
    if (!configKeys || configKeys.length === 0) return null;
    return configKeys.map((item)=>({
            ...item,
            ...item.key === key && {
                value: value
            }
        }));
};
var $df9d9b3a9bec0082$export$2e2bcd8739ae039 = $df9d9b3a9bec0082$var$setOcppConfigValue;

});

parcelRegister("dxLcn", function(module, exports) {
$parcel$export(module.exports, "ConnectorState", function () { return (parcelRequire("8KtsS")).ConnectorState; });
$parcel$export(module.exports, "getConnectorState", function () { return (parcelRequire("8KtsS")).getConnectorState; });
$parcel$export(module.exports, "remoteStartIsAvailable", function () { return (parcelRequire("8KtsS")).remoteStartIsAvailable; });
$parcel$export(module.exports, "remoteStopIsAvailable", function () { return (parcelRequire("8KtsS")).remoteStopIsAvailable; });
parcelRequire("8KtsS");

});
parcelRegister("8KtsS", function(module, exports) {

$parcel$export(module.exports, "getConnectorState", function () { return $964fdef0a128001c$export$eebd2f6de297e061; });
$parcel$export(module.exports, "remoteStartIsAvailable", function () { return $964fdef0a128001c$export$54569065c27263b2; });
$parcel$export(module.exports, "remoteStopIsAvailable", function () { return $964fdef0a128001c$export$3331f0ee6e6ae1d2; });
$parcel$export(module.exports, "ConnectorState", function () { return $964fdef0a128001c$export$d0aa683445069f84; });
function $964fdef0a128001c$export$eebd2f6de297e061(connector, isOcpp) {
    if (connector && isOcpp) switch(connector.ocppStatus){
        case "Available":
            return 0;
        case "Preparing":
            return 1;
        case "Charging":
            return 3;
        case "SuspendedEVSE":
            return 4;
        case "SuspendedEV":
            return 5;
        case "Finishing":
            return 6;
        case "Reserved":
            return 7;
        case "Unavailable":
            return 8;
        case "Faulted":
            return 9;
        default:
            return 11;
    }
    if (connector?.isCharging) return 3;
    if (connector?.offByUser) return 8;
    if (connector?.evConnectorState === null) return 0;
    switch(connector?.evConnectorState){
        case "A1NotConnected":
        case "A2NotConnected":
            return 0;
        case "B1Connected":
        case "B2Connected":
        case "C2WaitLock":
        case "C1ConnectedRequestingCharge":
            return 2;
        case "C1WaitStop":
        case "C2ConnectedCharging":
            return 3;
        default:
            return 11;
    }
}
const $964fdef0a128001c$export$54569065c27263b2 = (connector)=>{
    const connectorState = $964fdef0a128001c$export$eebd2f6de297e061(connector, true);
    return connectorState === 1 || connectorState === 6;
};
const $964fdef0a128001c$export$3331f0ee6e6ae1d2 = (connector)=>{
    const connectorState = $964fdef0a128001c$export$eebd2f6de297e061(connector, true);
    return connectorState === 3 || connectorState === 4 || connectorState === 5;
};
var $964fdef0a128001c$export$4111e904f934f9b2;
(function(ConnectorMode) {
    ConnectorMode["ON"] = "On";
    ConnectorMode["OFF"] = "Off";
})($964fdef0a128001c$export$4111e904f934f9b2 || ($964fdef0a128001c$export$4111e904f934f9b2 = {}));
var $964fdef0a128001c$export$d0aa683445069f84;
(function(ConnectorState) {
    ConnectorState[ConnectorState["AVAILABLE"] = 0] = "AVAILABLE";
    ConnectorState[ConnectorState["PREPARING"] = 1] = "PREPARING";
    ConnectorState[ConnectorState["CONNECTED"] = 2] = "CONNECTED";
    ConnectorState[ConnectorState["CHARGING"] = 3] = "CHARGING";
    ConnectorState[ConnectorState["PAUSED_BY_CHARGER"] = 4] = "PAUSED_BY_CHARGER";
    ConnectorState[ConnectorState["PAUSED_BY_VEHICLE"] = 5] = "PAUSED_BY_VEHICLE";
    ConnectorState[ConnectorState["FINISHING"] = 6] = "FINISHING";
    ConnectorState[ConnectorState["RESERVED"] = 7] = "RESERVED";
    ConnectorState[ConnectorState["UNAVAILABLE"] = 8] = "UNAVAILABLE";
    ConnectorState[ConnectorState["FAULTED"] = 9] = "FAULTED";
    ConnectorState[ConnectorState["OFF"] = 10] = "OFF";
    ConnectorState[ConnectorState["ERROR"] = 11] = "ERROR";
})($964fdef0a128001c$export$d0aa683445069f84 || ($964fdef0a128001c$export$d0aa683445069f84 = {}));

});


parcelRegister("5DZBN", function(module, exports) {
$parcel$export(module.exports, "ChargePointDawnControlWidget", function () { return (parcelRequire("2KaGD")).ChargePointDawnControlWidget; });
$parcel$export(module.exports, "onGoingTransactionStates", function () { return (parcelRequire("2KaGD")).onGoingTransactionStates; });
parcelRequire("2KaGD");

});
parcelRegister("2KaGD", function(module, exports) {

$parcel$export(module.exports, "onGoingTransactionStates", function () { return $e8f814367ffa46cf$export$4be52908f3e33dee; });
$parcel$export(module.exports, "ChargePointDawnControlWidget", function () { return $e8f814367ffa46cf$export$603dbbe125da361a; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $c9GjL = parcelRequire("c9GjL");

var $ilUpc = parcelRequire("ilUpc");
parcelRequire("1cTx9");
var $3uHTN = parcelRequire("3uHTN");

var $1O9Jh = parcelRequire("1O9Jh");

var $b10kV = parcelRequire("b10kV");

var $igvrl = parcelRequire("igvrl");

var $eIymc = parcelRequire("eIymc");

var $4LjKQ = parcelRequire("4LjKQ");
parcelRequire("2NaMI");
var $a7txM = parcelRequire("a7txM");
parcelRequire("dxLcn");
var $8KtsS = parcelRequire("8KtsS");
parcelRequire("gRHjN");
var $jsfFW = parcelRequire("jsfFW");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");
parcelRequire("idbtm");
var $jjP9q = parcelRequire("jjP9q");

var $7xC39 = parcelRequire("7xC39");

var $6GGmy = parcelRequire("6GGmy");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
var $e8f814367ffa46cf$var$NfcLockState;
(function(NfcLockState) {
    NfcLockState["ON"] = "false";
    NfcLockState["OFF"] = "true";
})($e8f814367ffa46cf$var$NfcLockState || ($e8f814367ffa46cf$var$NfcLockState = {}));
var $e8f814367ffa46cf$var$CableLockState;
(function(CableLockState) {
    CableLockState["ON"] = "true";
    CableLockState["OFF"] = "false";
})($e8f814367ffa46cf$var$CableLockState || ($e8f814367ffa46cf$var$CableLockState = {}));
const $e8f814367ffa46cf$var$fwVersionWithCableLockSupport = "1.2.1";
const $e8f814367ffa46cf$export$4be52908f3e33dee = [
    "Charging",
    "SuspendedEV",
    "SuspendedEVSE"
];
function $e8f814367ffa46cf$export$603dbbe125da361a({ isReadOnly: isReadOnly = false, chargePoint: chargePoint }) {
    const text = (0, $5u6k9.default)();
    const [configKeys, setConfigKeys] = (0, $7E7Dk.useState)(chargePoint?.ocppConfigKeys || []);
    const [chargingConnector, setChargingConnector] = (0, $7E7Dk.useState)((0, $4LjKQ.default)(chargePoint?.connectors ?? []));
    const [selectRfidDialogIsOpen, setSelectRfidDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: chargePoint.id
    });
    const [saveConfigKey] = (0, $1O9Jh.useOcppCommandUpdateConfigKeyMutation)();
    const [remoteStart] = (0, $1O9Jh.useChargePointRemoteStartMutation)();
    const [remoteStop] = (0, $1O9Jh.useChargePointRemoteStopMutation)();
    const [overrideSchedule] = (0, $1O9Jh.useChargePointOverrideScheduleForOngoingChargingSessionMutation)();
    const toast = (0, $eBlmY.useToast)();
    const { data: schedules } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id
    });
    const connectorHasSchedule = (connectorId)=>{
        return schedules?.some((schedule)=>schedule.connectorId === connectorId);
    };
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const isOnline = chargePoint.chargePointStatus !== "Offline";
    const isNfcLockOn = (0, $a7txM.getConfigValue)((0, $jsfFW.KEY_FREE_CHARGING), configKeys) === "false";
    const isCableLockOn = (0, $a7txM.getConfigValue)((0, $jsfFW.KEY_CABLE_LOCK), configKeys) === "true";
    const remoteStartIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStartIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    const remoteStopIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStopIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (chargePoint) {
            setConfigKeys(chargePoint.ocppConfigKeys);
            setChargingConnector((0, $4LjKQ.default)(chargePoint.connectors ?? []));
        }
    }, [
        chargePoint
    ]);
    const toggleOcppConfigValue = async (key, value)=>{
        const updatedConfigKeys = (0, $7xC39.default)(key, value, configKeys);
        if (!(updatedConfigKeys && chargePoint)) return;
        await saveConfigKey({
            chargePointId: chargePoint.id,
            keyValue: updatedConfigKeys.find((configKeys)=>configKeys.key === key)
        }).unwrap().then(()=>setConfigKeys(updatedConfigKeys)).catch(()=>toast.notifyError(text("msgRemoteControlCommandFailed")));
    };
    const handleRemoteStart = async (rfidTag)=>{
        await remoteStart({
            chargePointId: chargePoint.id,
            connectorId: 1,
            rfidTag: rfidTag
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStartSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStartAdminFailed" : "msgRemoteStartFailed")));
    };
    const handleRemoteControl = async ()=>{
        if (remoteStopIsVisible) await remoteStop({
            chargePointId: chargePoint.id,
            connectorId: 1
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStopSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStopAdminFailed" : "msgRemoteStopFailed")));
        else {
            if (isNfcLockOn) setSelectRfidDialogIsOpen(true);
            else if (chargingConnector?.defaultNfcTagId) handleRemoteStart(chargingConnector?.defaultNfcTagId);
            else toast.notifyError(text("msgRemoteStartFailed"));
        }
    };
    const handleOverrideSchedule = async ()=>{
        await overrideSchedule({
            connectorId: 1,
            chargePointId: chargePoint.id
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgIgnoreScheduleSuccess"));
        }).catch((error)=>{
            toast.notifyError((0, $6GGmy.showErrorMessagesForIgnoreSchedule)(error.data.error));
        });
    };
    const fwVersion = (0, $7E7Dk.useMemo)(()=>(0, $b10kV.getFirmwareVersion)(configKeys), [
        configKeys
    ]);
    const hasCableLockSupport = (0, $b10kV.compareSemanticVersions)(fwVersion, $e8f814367ffa46cf$var$fwVersionWithCableLockSupport);
    const showStartStopChargingButton = !(0, $eIymc.isUserappDomain) && isOnline && (remoteStartIsVisible || remoteStopIsVisible);
    const showIgnoreScheduleButton = !(0, $eIymc.isUserappDomain) && isOnline && remoteStopIsVisible && chargingConnector?.mode === "Schedule";
    const handleConnectorStateChange = (connectorId)=>async (state)=>{
            if (state === "Schedule" && !connectorHasSchedule(connectorId)) return (0, $c9GjL.confirmDialog)({
                header: text("msgNoSchedulesHeader"),
                message: text("msgNoSchedulesText"),
                acceptClassName: "hidden",
                rejectLabel: text("btnClose")
            });
            // Optimistically update the UI immediately
            setChargingConnector((prev)=>prev ? {
                    ...prev,
                    mode: state
                } : prev);
            try {
                await updateChargePoint({
                    chargePoint: {
                        ...chargePoint,
                        connectors: chargePoint.connectors?.map((c)=>c.connectorId === connectorId ? {
                                ...c,
                                mode: state
                            } : c)
                    }
                }).unwrap();
            } catch (error) {
                // Revert the optimistic update on error
                setChargingConnector((0, $4LjKQ.default)(chargePoint.connectors ?? []));
                toast.notifyError(text("msgFailedToUpdateAvailability"));
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblDawnControlOcppWidget"
    }, chargingConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `chargerText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCharger"
        })),
        remoteChargingControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex gap-2 flex-column sm:flex-row"
        }, showStartStopChargingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: remoteStartIsVisible ? text("lblStartChargingInfo") : text("lblStopSession"),
            size: "small",
            "data-testid": "remote-control-button",
            onClick: handleRemoteControl,
            label: text(remoteStopIsVisible ? "lblStop" : "lblStart"),
            outlined: true,
            severity: "info",
            icon: remoteStopIsVisible ? "pi pi-stop-circle" : "pi pi-play-circle"
        }), showIgnoreScheduleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: text("lblIgnoreSchedule"),
            style: {
                padding: "6px"
            },
            "data-testid": "remote-control-button-ignoreSchedule",
            onClick: handleOverrideSchedule,
            outlined: true,
            severity: "info",
            icon: "pi pi-calendar-times"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
            id: `charger-mode-${chargePoint.id}`,
            ariaLabel: text("lblCharger"),
            options: [
                {
                    label: text("lblOff"),
                    value: "Off"
                },
                {
                    label: text("lblConnectorSchedule"),
                    value: "Schedule"
                },
                {
                    label: text("lblConnectorAlwaysOn"),
                    value: "On"
                }
            ],
            value: chargingConnector.mode,
            onChange: handleConnectorStateChange(1),
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            className: "w-20rem max-w-full",
            "data-testid": `charger-toggle-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `rfidText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDLock"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue((0, $jsfFW.KEY_FREE_CHARGING), isNfcLockOn ? "true" : "false"),
            isToggled: isNfcLockOn,
            disabled: isReadOnly || $e8f814367ffa46cf$export$4be52908f3e33dee.includes(chargePoint?.connectors[0]?.ocppStatus) || !isOnline || chargePoint?.ocppEnabled,
            "data-testid": `toggle-rfid-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jjP9q.RemoteOcppDimmerControl), {
        chargePoint: chargePoint,
        isReadOnly: isReadOnly
    }), hasCableLockSupport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue((0, $jsfFW.KEY_CABLE_LOCK), isCableLockOn ? "false" : "true"),
            disabled: !isOnline || chargePoint?.ocppEnabled,
            isToggled: isCableLockOn,
            "data-testid": `toggle-cableLock-${chargePoint.id}`
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `toggleText-cableLock-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCableLock"
        }))
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3uHTN.SelectRfidTagDialog), {
        visible: selectRfidDialogIsOpen,
        chargePointId: chargePoint.id,
        connectorId: chargingConnector?.connectorId ?? 1,
        onStartCharging: (rfidTag)=>{
            handleRemoteStart(rfidTag);
            setSelectRfidDialogIsOpen(false);
        },
        onHide: ()=>setSelectRfidDialogIsOpen(false)
    }));
}

});
parcelRegister("1cTx9", function(module, exports) {
$parcel$export(module.exports, "SelectRfidTagDialog", function () { return (parcelRequire("3uHTN")).SelectRfidTagDialog; });
parcelRequire("3uHTN");

});
parcelRegister("3uHTN", function(module, exports) {

$parcel$export(module.exports, "SelectRfidTagDialog", function () { return $5bcd01ae79961ff0$export$487268eaa14a469c; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");

var $1O9Jh = parcelRequire("1O9Jh");
parcelRequire("MMfqT");
var $eySth = parcelRequire("eySth");
parcelRequire("c6fcw");
var $3ABLj = parcelRequire("3ABLj");
const $5bcd01ae79961ff0$var$formId = "select-rfid-tag-form";
const $5bcd01ae79961ff0$export$487268eaa14a469c = ({ visible: visible, chargePointId: chargePointId, connectorId: connectorId, onHide: onHide, onStartCharging: onStartCharging })=>{
    const text = (0, $5u6k9.default)();
    const [selectedRfid, setSelectedRfid] = (0, $7E7Dk.useState)("");
    const { data: rfidTags = [], isLoading: isLoading } = (0, $1O9Jh.useChargePointGetRemoteStartTagsQuery)({
        chargePointId: chargePointId,
        connectorId: connectorId
    });
    const rfidTagsOptions = (0, $7E7Dk.useMemo)(()=>rfidTags.map((tag)=>({
                value: tag.id || "",
                label: `${tag.chargePointUserId ? tag.fullName : tag.companyName} - ${tag.id}`
            })), [
        rfidTags
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        setSelectedRfid(rfidTagsOptions[0]?.value ?? "");
    }, [
        rfidTagsOptions
    ]);
    const startCharging = ()=>{
        if (!isLoading && selectedRfid) onStartCharging(selectedRfid);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        startCharging();
    };
    const renderContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": "shimmer-loading",
            className: "shimmer-container shimmer-small"
        });
        if (rfidTagsOptions.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3ABLj.Dropdown), {
            id: "rfid-tag-select",
            label: text("lblSelectRFIDToStartCharging"),
            value: selectedRfid,
            options: rfidTagsOptions,
            onChange: (event)=>setSelectedRfid(event.value),
            showClear: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
            className: "m-0 text-color-secondary"
        }, text("msgNoRfidTagsAvailable"));
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide,
        "data-testid": "btn-cancel"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnStartCharging"),
        type: "submit",
        form: $5bcd01ae79961ff0$var$formId,
        disabled: isLoading || rfidTagsOptions.length === 0,
        "data-testid": "btn-on-starting-charging"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eySth.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("lblRemoteStartCharging"),
        footer: footer,
        "data-testid": "select-rfid-tag-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $5bcd01ae79961ff0$var$formId,
        className: "flex flex-column gap-3",
        onSubmit: handleSubmit,
        noValidate: true
    }, renderContent()));
};

});
parcelRegister("c6fcw", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("3ABLj")).Dropdown; });
parcelRequire("3ABLj");

});
parcelRegister("3ABLj", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $38279e72e4a684ca$export$931cbfb6bfb85fc; });

var $7E7Dk = parcelRequire("7E7Dk");

var $9tPRX = parcelRequire("9tPRX");

var $dE8RX = parcelRequire("dE8RX");

var $76MyM = parcelRequire("76MyM");

var $cpfnh = parcelRequire("cpfnh");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("9w3V4");
var $QrRvA = parcelRequire("QrRvA");
const $38279e72e4a684ca$export$931cbfb6bfb85fc = /*#__PURE__*/ (0, $7E7Dk.forwardRef)(({ infoText: infoText, disabledReason: disabledReason, className: className, endButton: endButton, ...props }, ref)=>{
    const text = (0, $5u6k9.default)();
    const [filter, setFilter] = (0, $7E7Dk.useState)("");
    const rootClassName = (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("flex flex-column", className);
    const { processedOptions: processedOptions, filteredOptionsCount: filteredOptionsCount } = (0, $7E7Dk.useMemo)(()=>{
        if (!props.options || props.options.length <= 1000) return {
            processedOptions: props.options,
            filteredOptionsCount: props.options?.length ?? 0
        };
        const allOptions = props.options ?? [];
        const filteredOptions = filter ? allOptions.filter((opt)=>String(opt.label).toLowerCase().includes(filter.toLowerCase())) : allOptions;
        const first1000 = filteredOptions.slice(0, 1000);
        if (props.value !== null) {
            const selectedOption = allOptions.find((opt)=>opt.value === props.value);
            if (selectedOption && !first1000.some((opt)=>opt.value === selectedOption.value)) return {
                processedOptions: [
                    selectedOption,
                    ...first1000
                ],
                filteredOptionsCount: filteredOptions.length
            };
        }
        return {
            processedOptions: first1000,
            filteredOptionsCount: filteredOptions.length
        };
    }, [
        props.options,
        props.value,
        filter
    ]);
    // Auto-enable virtual scrolling for large datasets
    const virtualScrollerOptions = (0, $7E7Dk.useMemo)(()=>{
        if (!props.options || props.options.length <= 1000) return props.virtualScrollerOptions // No virtual scrolling for small datasets
        ;
        if (filteredOptionsCount <= 1000) return props.virtualScrollerOptions;
        return {
            itemSize: 38,
            showLoader: false,
            ...props.virtualScrollerOptions
        };
    }, [
        props.options,
        props.virtualScrollerOptions,
        filteredOptionsCount
    ]);
    // Force re-mount when options first load to fix PrimeReact layout calculation bug
    const optionsKey = props.options?.length ? "loaded" : "empty";
    const dropdownElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9tPRX.Dropdown), {
        key: optionsKey,
        emptyMessage: text("msgNoResultsFound"),
        emptyFilterMessage: text("msgNoAvailableOptions"),
        showClear: true,
        filter: true,
        onFilter: (e)=>setFilter(e.filter),
        ...props,
        filterInputAutoFocus: props.filterInputAutoFocus ?? props.filter ?? true,
        options: processedOptions,
        virtualScrollerOptions: virtualScrollerOptions,
        pt: {
            root: {
                className: "w-full"
            },
            input: {
                "data-testid": `${props.id}-input`
            },
            clearIcon: {
                "data-testid": `${props.id}-clear-icon`
            },
            panel: {
                style: {
                    width: "250px"
                }
            }
        },
        ref: ref,
        value: props.value,
        disabled: props.disabled,
        "data-testid": props.disabled ? `${props.id}-disabled` : `${props.id}`,
        inputId: props.id
    });
    const dropdownWithEndButton = endButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: `p-inputgroup dropdown-group-${props.id}`
    }, dropdownElement, endButton) : dropdownElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: rootClassName
    }, props.label || infoText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-between"
    }, props.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            "required-label": props.required
        }, "p-label"),
        htmlFor: props.id
    }, props.label) : null, infoText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $QrRvA.FieldInfoButton), {
        ariaLabel: text("lblMoreInformation"),
        text: infoText,
        testId: `${props.id}-info-button`
    }) : null) : null, dropdownWithEndButton, disabledReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cpfnh.Tooltip), {
        target: endButton ? `.dropdown-group-${props.id}` : `#${props.id}`,
        className: "w-2",
        showOnDisabled: true,
        position: "top"
    }, disabledReason), props.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "error",
        text: props.error,
        "data-testid": `error-text:${props.error}`,
        className: "mt-2 justify-content-start"
    }));
});

});
parcelRegister("9tPRX", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $6e6f0ea78cb8b2ba$export$931cbfb6bfb85fc; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $9pANH = parcelRequire("9pANH");

var $difhH = parcelRequire("difhH");

var $bRIbs = parcelRequire("bRIbs");

var $2v3zC = parcelRequire("2v3zC");

var $hB9Eg = parcelRequire("hB9Eg");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");

var $5B1eM = parcelRequire("5B1eM");

var $fQRXQ = parcelRequire("fQRXQ");

var $ingJg = parcelRequire("ingJg");

var $dL2Vy = parcelRequire("dL2Vy");

var $1PxL0 = parcelRequire("1PxL0");

var $eXeTx = parcelRequire("eXeTx");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $6e6f0ea78cb8b2ba$var$_extends() {
    return $6e6f0ea78cb8b2ba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6e6f0ea78cb8b2ba$var$_extends.apply(null, arguments);
}
function $6e6f0ea78cb8b2ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e6f0ea78cb8b2ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e6f0ea78cb8b2ba$var$_typeof(o);
}
function $6e6f0ea78cb8b2ba$var$toPrimitive(t, r) {
    if ("object" != $6e6f0ea78cb8b2ba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6e6f0ea78cb8b2ba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6e6f0ea78cb8b2ba$var$toPropertyKey(t) {
    var i = $6e6f0ea78cb8b2ba$var$toPrimitive(t, "string");
    return "symbol" == $6e6f0ea78cb8b2ba$var$_typeof(i) ? i : i + "";
}
function $6e6f0ea78cb8b2ba$var$_defineProperty(e, r, t) {
    return (r = $6e6f0ea78cb8b2ba$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6e6f0ea78cb8b2ba$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $6e6f0ea78cb8b2ba$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6e6f0ea78cb8b2ba$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6e6f0ea78cb8b2ba$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $6e6f0ea78cb8b2ba$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6e6f0ea78cb8b2ba$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $6e6f0ea78cb8b2ba$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e6f0ea78cb8b2ba$var$_slicedToArray(r, e) {
    return $6e6f0ea78cb8b2ba$var$_arrayWithHoles(r) || $6e6f0ea78cb8b2ba$var$_iterableToArrayLimit(r, e) || $6e6f0ea78cb8b2ba$var$_unsupportedIterableToArray$1(r, e) || $6e6f0ea78cb8b2ba$var$_nonIterableRest();
}
function $6e6f0ea78cb8b2ba$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e6f0ea78cb8b2ba$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e6f0ea78cb8b2ba$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $6e6f0ea78cb8b2ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e6f0ea78cb8b2ba$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e6f0ea78cb8b2ba$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, overlayVisibleState = _ref.overlayVisibleState, context = _ref.context;
        return (0, $7nrKB.classNames)("p-dropdown p-component p-inputwrapper", {
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-focus": focusedState,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled",
            "p-dropdown-clearable": props.showClear && !props.disabled,
            "p-inputwrapper-filled": (0, $7nrKB.ObjectUtils).isNotEmpty(props.value),
            "p-inputwrapper-focus": focusedState || overlayVisibleState
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, label = _ref2.label;
        return props.editable ? "p-dropdown-label p-inputtext" : (0, $7nrKB.classNames)("p-dropdown-label p-inputtext", {
            "p-placeholder": label === null && props.placeholder,
            "p-dropdown-label-empty": label === null && !props.placeholder
        });
    },
    trigger: "p-dropdown-trigger",
    emptyMessage: "p-dropdown-empty-message",
    itemGroup: function itemGroup(_ref3) {
        var optionGroupLabel = _ref3.optionGroupLabel;
        return (0, $7nrKB.classNames)("p-dropdown-item-group", {
            "p-dropdown-item-empty": !optionGroupLabel || optionGroupLabel.length === 0
        });
    },
    itemGroupLabel: "p-dropdown-item-group-label",
    dropdownIcon: "p-dropdown-trigger-icon p-clickable",
    loadingIcon: "p-dropdown-trigger-icon p-clickable",
    clearIcon: "p-dropdown-clear-icon p-clickable",
    filterIcon: "p-dropdown-filter-icon",
    filterClearIcon: "p-dropdown-filter-clear-icon",
    filterContainer: function filterContainer(_ref4) {
        var clearIcon = _ref4.clearIcon;
        return (0, $7nrKB.classNames)("p-dropdown-filter-container", {
            "p-dropdown-clearable-filter": !!clearIcon
        });
    },
    filterInput: function filterInput(_ref5) {
        var props = _ref5.props, context = _ref5.context;
        return (0, $7nrKB.classNames)("p-dropdown-filter p-inputtext p-component", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    list: function list(_ref6) {
        var virtualScrollerOptions = _ref6.virtualScrollerOptions;
        return virtualScrollerOptions ? "p-dropdown-items" : "p-dropdown-items";
    },
    panel: function panel(_ref7) {
        var context = _ref7.context;
        return (0, $7nrKB.classNames)("p-dropdown-panel p-component", {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    item: function item(_ref8) {
        var selected = _ref8.selected, disabled = _ref8.disabled, label = _ref8.label, index = _ref8.index, focusedOptionIndex = _ref8.focusedOptionIndex, highlightOnSelect = _ref8.highlightOnSelect;
        return (0, $7nrKB.classNames)("p-dropdown-item", {
            "p-highlight": selected && highlightOnSelect,
            "p-disabled": disabled,
            "p-focus": index === focusedOptionIndex,
            "p-dropdown-item-empty": !label || label.length === 0
        });
    },
    itemLabel: "p-dropdown-item-label",
    checkIcon: "p-dropdown-check-icon",
    blankIcon: "p-dropdown-blank-icon",
    wrapper: "p-dropdown-items-wrapper",
    header: "p-dropdown-header",
    footer: "p-dropdown-footer",
    transition: "p-connected-overlay"
};
var $6e6f0ea78cb8b2ba$var$styles = "\n@layer primereact {\n    .p-dropdown {\n        display: inline-flex;\n        cursor: pointer;\n        position: relative;\n        user-select: none;\n    }\n    \n    .p-dropdown-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n    \n    .p-dropdown-label {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        flex: 1 1 auto;\n        width: 1%;\n        text-overflow: ellipsis;\n        cursor: pointer;\n    }\n    \n    .p-dropdown-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n    \n    input.p-dropdown-label  {\n        cursor: default;\n    }\n    \n    .p-dropdown .p-dropdown-panel {\n        min-width: 100%;\n    }\n    \n    .p-dropdown-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-dropdown-items-wrapper {\n        overflow: auto;\n    }\n    \n    .p-dropdown-item {\n        cursor: pointer;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-dropdown-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-dropdown-filter {\n        width: 100%;\n    }\n    \n    .p-dropdown-filter-container {\n        position: relative;\n    }\n    \n    .p-dropdown-clear-icon,\n    .p-dropdown-filter-icon,\n    .p-dropdown-filter-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n        right: 2rem;\n    }\n    \n    .p-fluid .p-dropdown {\n        display: flex;\n    }\n    \n    .p-fluid .p-dropdown .p-dropdown-label {\n        width: 1%;\n    }\n}\n";
var $6e6f0ea78cb8b2ba$var$inlineStyles = {
    wrapper: function wrapper(_ref9) {
        var props = _ref9.props;
        return {
            maxHeight: props.scrollHeight || "auto"
        };
    },
    panel: function panel(_ref10) {
        var props = _ref10.props;
        return $6e6f0ea78cb8b2ba$var$_objectSpread$2({}, props.panelStyle);
    }
};
var $6e6f0ea78cb8b2ba$var$DropdownBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Dropdown",
        __parentMetadata: null,
        appendTo: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        autoFocus: false,
        autoOptionFocus: false,
        checkmark: false,
        children: undefined,
        className: null,
        clearIcon: null,
        collapseIcon: null,
        dataKey: null,
        disabled: false,
        dropdownIcon: null,
        editable: false,
        emptyFilterMessage: null,
        emptyMessage: null,
        filter: false,
        filterBy: null,
        filterClearIcon: null,
        filterDelay: 300,
        filterIcon: null,
        filterInputAutoFocus: false,
        filterLocale: undefined,
        filterMatchMode: "contains",
        filterPlaceholder: null,
        filterTemplate: null,
        focusInputRef: null,
        focusOnHover: true,
        highlightOnSelect: true,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        itemTemplate: null,
        loading: false,
        loadingIcon: null,
        maxLength: null,
        name: null,
        onBlur: null,
        onChange: null,
        onClick: null,
        onContextMenu: null,
        onFilter: null,
        onFocus: null,
        onHide: null,
        onMouseDown: null,
        onShow: null,
        optionDisabled: null,
        optionGroupChildren: "items",
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        options: null,
        optionValue: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        required: false,
        resetFilterOnHide: false,
        scrollHeight: "200px",
        selectOnFocus: false,
        showClear: false,
        showFilterClear: false,
        showOnFocus: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        useOptionAsValue: false,
        value: null,
        valueTemplate: null,
        variant: null,
        virtualScrollerOptions: null
    },
    css: {
        classes: $6e6f0ea78cb8b2ba$var$classes,
        styles: $6e6f0ea78cb8b2ba$var$styles,
        inlineStyles: $6e6f0ea78cb8b2ba$var$inlineStyles
    }
});
var $6e6f0ea78cb8b2ba$var$BlankIcon = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $6e6f0ea78cb8b2ba$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("rect", {
        width: "1",
        height: "1",
        fill: "currentColor",
        fillOpacity: "0"
    }));
}));
$6e6f0ea78cb8b2ba$var$BlankIcon.displayName = "BlankIcon";
var $6e6f0ea78cb8b2ba$var$DropdownItem = /*#__PURE__*/ $7E7Dk.memo(function(props) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, selected = props.selected, disabled = props.disabled, option = props.option, label = props.label, index = props.index, focusedOptionIndex = props.focusedOptionIndex, ariaSetSize = props.ariaSetSize, checkmark = props.checkmark, highlightOnSelect = props.highlightOnSelect, onInputKeyDown = props.onInputKeyDown;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            context: {
                selected: selected,
                disabled: disabled,
                focused: index === focusedOptionIndex
            }
        });
    };
    var _onClick = function onClick(event, i) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: option
        });
    };
    var content = props.template ? (0, $7nrKB.ObjectUtils).getJSXElement(props.template, props.option) : props.label;
    var itemProps = mergeProps({
        id: "dropdownItem_".concat(index),
        role: "option",
        className: (0, $7nrKB.classNames)(option.className, cx("item", {
            selected: selected,
            disabled: disabled,
            label: label,
            index: index,
            focusedOptionIndex: focusedOptionIndex,
            highlightOnSelect: highlightOnSelect
        })),
        style: props.style,
        tabIndex: 0,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            return onInputKeyDown(e);
        },
        onMouseMove: function onMouseMove(e) {
            return props === null || props === void 0 ? void 0 : props.onMouseMove(e, index);
        },
        "aria-setsize": ariaSetSize,
        "aria-posinset": index + 1,
        "aria-label": label,
        "aria-selected": selected,
        "data-p-highlight": selected,
        "data-p-focused": focusedOptionIndex === index,
        "data-p-disabled": disabled
    }, getPTOptions("item"));
    var itemGroupLabelProps = mergeProps({
        className: cx("itemLabel")
    }, getPTOptions("itemLabel"));
    var iconRenderer = function iconRenderer() {
        if (selected) {
            var checkIconProps = mergeProps({
                className: cx("checkIcon")
            }, getPTOptions("checkIcon"));
            return /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), checkIconProps);
        }
        var blankIconProps = mergeProps({
            className: cx("blankIcon")
        }, getPTOptions("blankIcon"));
        return /*#__PURE__*/ $7E7Dk.createElement($6e6f0ea78cb8b2ba$var$BlankIcon, blankIconProps);
    };
    return /*#__PURE__*/ $7E7Dk.createElement("li", $6e6f0ea78cb8b2ba$var$_extends({
        key: props.label
    }, itemProps), checkmark && iconRenderer(), /*#__PURE__*/ $7E7Dk.createElement("span", itemGroupLabelProps, content), /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
});
$6e6f0ea78cb8b2ba$var$DropdownItem.displayName = "DropdownItem";
function $6e6f0ea78cb8b2ba$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e6f0ea78cb8b2ba$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e6f0ea78cb8b2ba$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $6e6f0ea78cb8b2ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e6f0ea78cb8b2ba$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e6f0ea78cb8b2ba$var$DropdownPanel = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(props, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var filterInputRef = $7E7Dk.useRef(null);
    var isEmptyFilter = !(props.visibleOptions && props.visibleOptions.length) && props.hasFilter;
    var ariaSetSize = props.visibleOptions ? props.visibleOptions.length : 0;
    var filterOptions = {
        filter: function filter(e) {
            return onFilterInputChange(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $6e6f0ea78cb8b2ba$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onEnter = function onEnter() {
        props.onEnter(function() {
            if (props.virtualScrollerRef.current) {
                var selectedIndex = props.getSelectedOptionIndex();
                if (selectedIndex !== -1) setTimeout(function() {
                    return props.virtualScrollerRef.current.scrollToIndex(selectedIndex);
                }, 0);
            }
        });
    };
    var onEntered = function onEntered() {
        props.onEntered(function() {
            if (props.filter && props.filterInputAutoFocus) (0, $7nrKB.DomHandler).focus(filterInputRef.current, false);
        });
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        props.onFilterInputChange && props.onFilterInputChange(event);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $7nrKB.ObjectUtils).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx("footer")
            }, getPTOptions("footer"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", footerProps, content);
        }
        return null;
    };
    var changeFocusedItemOnHover = function changeFocusedItemOnHover(event, index) {
        if (props.focusOnHover) {
            var _props$changeFocusedO;
            props === null || props === void 0 || (_props$changeFocusedO = props.changeFocusedOptionIndex) === null || _props$changeFocusedO === void 0 || _props$changeFocusedO.call(props, event, index);
        }
    };
    var createEmptyMessage = function createEmptyMessage(emptyMessage, isFilter) {
        var message = (0, $7nrKB.ObjectUtils).getJSXElement(emptyMessage, props) || (0, $eHYdO.localeOption)(isFilter ? "emptyFilterMessage" : "emptyMessage");
        var emptyMessageProps = mergeProps({
            className: cx("emptyMessage")
        }, getPTOptions("emptyMessage"));
        return /*#__PURE__*/ $7E7Dk.createElement("li", emptyMessageProps, message);
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        style = $6e6f0ea78cb8b2ba$var$_objectSpread$1($6e6f0ea78cb8b2ba$var$_objectSpread$1({}, style), option.style);
        if (option.group && props.optionGroupLabel) {
            var optionGroupLabel = props.optionGroupLabel;
            var groupContent = props.optionGroupTemplate ? (0, $7nrKB.ObjectUtils).getJSXElement(props.optionGroupTemplate, option, index) : props.getOptionGroupLabel(option);
            var key = index + "_" + props.getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: cx("itemGroup", {
                    optionGroupLabel: optionGroupLabel
                }),
                style: style,
                "data-p-highlight": props.selected
            }, getPTOptions("itemGroup"));
            var itemGroupLabelProps = mergeProps({
                className: cx("itemGroupLabel")
            }, getPTOptions("itemGroupLabel"));
            return /*#__PURE__*/ $7E7Dk.createElement("li", $6e6f0ea78cb8b2ba$var$_extends({
                key: key
            }, itemGroupProps), /*#__PURE__*/ $7E7Dk.createElement("span", itemGroupLabelProps, groupContent));
        }
        var optionKey = props.getOptionRenderKey(option) + "_" + index;
        var optionLabel = props.getOptionLabel(option);
        var disabled = props.isOptionDisabled(option);
        return /*#__PURE__*/ $7E7Dk.createElement($6e6f0ea78cb8b2ba$var$DropdownItem, {
            key: optionKey,
            label: optionLabel,
            index: index,
            focusedOptionIndex: props.focusedOptionIndex,
            option: option,
            ariaSetSize: ariaSetSize,
            onInputKeyDown: props.onInputKeyDown,
            style: style,
            template: props.itemTemplate,
            selected: props.isSelected(option),
            highlightOnSelect: props.highlightOnSelect,
            disabled: disabled,
            onClick: props.onOptionClick,
            onMouseMove: changeFocusedItemOnHover,
            ptm: ptm,
            cx: cx,
            checkmark: props.checkmark
        });
    };
    var createItems = function createItems() {
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(props.visibleOptions)) return props.visibleOptions.map(createItem);
        else if (props.hasFilter) return createEmptyMessage(props.emptyFilterMessage, true);
        return createEmptyMessage(props.emptyMessage);
    };
    var createFilterClearIcon = function createFilterClearIcon() {
        if (props.showFilterClear && props.filterValue) {
            var ariaLabelFilterClear = (0, $eHYdO.localeOption)("clear");
            var clearIconProps = mergeProps({
                className: cx("filterClearIcon"),
                "aria-label": ariaLabelFilterClear,
                onClick: function onClick() {
                    return props.onFilterClearIconClick(function() {
                        return (0, $7nrKB.DomHandler).focus(filterInputRef.current);
                    });
                }
            }, getPTOptions("filterClearIcon"));
            var icon = props.filterClearIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), clearIconProps);
            var filterClearIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $6e6f0ea78cb8b2ba$var$_objectSpread$1({}, clearIconProps), {
                props: props
            });
            return filterClearIcon;
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filter) {
            var clearIcon = createFilterClearIcon();
            var filterIconProps = mergeProps({
                className: cx("filterIcon")
            }, getPTOptions("filterIcon"));
            var icon = props.filterIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $fQRXQ.SearchIcon), filterIconProps);
            var filterIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $6e6f0ea78cb8b2ba$var$_objectSpread$1({}, filterIconProps), {
                props: props
            });
            var filterContainerProps = mergeProps({
                className: cx("filterContainer", {
                    clearIcon: clearIcon
                })
            }, getPTOptions("filterContainer"));
            var filterInputProps = mergeProps({
                ref: filterInputRef,
                type: "text",
                autoComplete: "off",
                className: cx("filterInput", {
                    context: context
                }),
                placeholder: props.filterPlaceholder,
                onKeyDown: props.onFilterInputKeyDown,
                onChange: function onChange(e) {
                    return onFilterInputChange(e);
                },
                value: props.filterValue
            }, getPTOptions("filterInput"));
            var content = /*#__PURE__*/ $7E7Dk.createElement("div", filterContainerProps, /*#__PURE__*/ $7E7Dk.createElement("input", filterInputProps), clearIcon, filterIcon);
            if (props.filterTemplate) {
                var defaultContentOptions = {
                    className: (0, $7nrKB.classNames)("p-dropdown-filter-container", {
                        "p-dropdown-clearable-filter": !!clearIcon
                    }),
                    element: content,
                    filterOptions: filterOptions,
                    filterInputKeyDown: props.onFilterInputKeyDown,
                    filterInputChange: onFilterInputChange,
                    filterIconClassName: "p-dropdown-filter-icon",
                    clearIcon: clearIcon,
                    props: props
                };
                content = (0, $7nrKB.ObjectUtils).getJSXElement(props.filterTemplate, defaultContentOptions);
            }
            var headerProps = mergeProps({
                className: cx("header")
            }, getPTOptions("header"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", headerProps, content);
        }
        return null;
    };
    var createContent = function createContent() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $6e6f0ea78cb8b2ba$var$_objectSpread$1($6e6f0ea78cb8b2ba$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $6e6f0ea78cb8b2ba$var$_objectSpread$1($6e6f0ea78cb8b2ba$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                className: (0, $7nrKB.classNames)("p-dropdown-items-wrapper", props.virtualScrollerOptions.className),
                items: props.visibleOptions,
                autoSize: true,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($6e6f0ea78cb8b2ba$var$_objectSpread$1($6e6f0ea78cb8b2ba$var$_objectSpread$1({}, event), {
                        filter: props.filterValue
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var emptyMessage = props.hasFilter ? props.emptyFilterMessage : props.emptyMessage;
                    var content = isEmptyFilter ? createEmptyMessage(emptyMessage) : options.children;
                    var listProps = mergeProps({
                        ref: options.contentRef,
                        style: options.style,
                        className: (0, $7nrKB.classNames)(options.className, cx("list", {
                            virtualScrollerProps: props.virtualScrollerOptions
                        })),
                        role: "listbox",
                        "aria-label": (0, $eHYdO.ariaLabel)("listLabel")
                    }, getPTOptions("list"));
                    return /*#__PURE__*/ $7E7Dk.createElement("ul", listProps, content);
                }
            });
            return /*#__PURE__*/ $7E7Dk.createElement((0, $dL2Vy.VirtualScroller), $6e6f0ea78cb8b2ba$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptm("virtualScroller")
            }));
        }
        var items = createItems();
        var wrapperProps = mergeProps({
            className: cx("wrapper"),
            style: sx("wrapper")
        }, getPTOptions("wrapper"));
        var listProps = mergeProps({
            className: cx("list"),
            role: "listbox",
            "aria-label": (0, $eHYdO.ariaLabel)("listLabel")
        }, getPTOptions("list"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", wrapperProps, /*#__PURE__*/ $7E7Dk.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var filter = createFilter();
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $7nrKB.classNames)(props.panelClassName, cx("panel", {
                context: context
            })),
            style: sx("panel"),
            onClick: props.onClick
        }, getPTOptions("panel"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, getPTOptions("transition"));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $6e6f0ea78cb8b2ba$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", $6e6f0ea78cb8b2ba$var$_extends({
            ref: ref
        }, panelProps), props.firstFocusableElement, filter, content, footer, props.lastFocusableElement));
    };
    var element = createElement();
    return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$6e6f0ea78cb8b2ba$var$DropdownPanel.displayName = "DropdownPanel";
function $6e6f0ea78cb8b2ba$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6e6f0ea78cb8b2ba$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6e6f0ea78cb8b2ba$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6e6f0ea78cb8b2ba$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6e6f0ea78cb8b2ba$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6e6f0ea78cb8b2ba$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6e6f0ea78cb8b2ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e6f0ea78cb8b2ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e6f0ea78cb8b2ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6e6f0ea78cb8b2ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e6f0ea78cb8b2ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e6f0ea78cb8b2ba$export$931cbfb6bfb85fc = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $6e6f0ea78cb8b2ba$var$DropdownBase.getProps(inProps, context);
    var _useDebounce = (0, $jr5t3.useDebounce)("", props.filterDelay || 0), _useDebounce2 = $6e6f0ea78cb8b2ba$var$_slicedToArray(_useDebounce, 3), filterValue = _useDebounce2[0], filterState = _useDebounce2[1], setFilterState = _useDebounce2[2];
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $6e6f0ea78cb8b2ba$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(-1), _React$useState4 = $6e6f0ea78cb8b2ba$var$_slicedToArray(_React$useState3, 2), focusedOptionIndex = _React$useState4[0], setFocusedOptionIndex = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(false), _React$useState6 = $6e6f0ea78cb8b2ba$var$_slicedToArray(_React$useState5, 2), overlayVisibleState = _React$useState6[0], setOverlayVisibleState = _React$useState6[1];
    var clickedRef = $7E7Dk.useRef(false);
    var elementRef = $7E7Dk.useRef(null);
    var overlayRef = $7E7Dk.useRef(null);
    var firstHiddenFocusableElementOnOverlay = $7E7Dk.useRef(null);
    var lastHiddenFocusableElementOnOverlay = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var focusInputRef = $7E7Dk.useRef(props.focusInputRef);
    var virtualScrollerRef = $7E7Dk.useRef(null);
    var searchTimeout = $7E7Dk.useRef(null);
    var searchValue = $7E7Dk.useRef(null);
    var isLazy = props.virtualScrollerOptions && props.virtualScrollerOptions.lazy;
    var hasFilter = (0, $7nrKB.ObjectUtils).isNotEmpty(filterState);
    var appendTo = props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo;
    var _DropdownBase$setMeta = $6e6f0ea78cb8b2ba$var$DropdownBase.setMetaData($6e6f0ea78cb8b2ba$var$_objectSpread($6e6f0ea78cb8b2ba$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            filter: filterState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    })), ptm = _DropdownBase$setMeta.ptm, cx = _DropdownBase$setMeta.cx, sx = _DropdownBase$setMeta.sx, isUnstyled = _DropdownBase$setMeta.isUnstyled;
    (0, $kHEnT.useHandleStyle)($6e6f0ea78cb8b2ba$var$DropdownBase.css.styles, isUnstyled, {
        name: "dropdown"
    });
    var _useOverlayListener = (0, $jr5t3.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) {
                if (type === "outside") {
                    if (!isClearClicked(event)) hide();
                } else if (context.hideOverlaysOnDocumentScrolling) hide();
                else if (!(0, $7nrKB.DomHandler).isDocument(event.target)) alignOverlay();
            }
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $6e6f0ea78cb8b2ba$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push($6e6f0ea78cb8b2ba$var$_objectSpread($6e6f0ea78cb8b2ba$var$_objectSpread({}, option), {}, {
                group: true,
                index: index
            }));
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter && !isLazy) {
            var _filterValue = filterState.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(",") : [
                props.optionLabel || "label"
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator = $6e6f0ea78cb8b2ba$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optgroup = _step.value;
                        var filteredSubOptions = (0, $eHYdO.FilterService).filter(getOptionGroupChildren(optgroup), searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($6e6f0ea78cb8b2ba$var$_objectSpread($6e6f0ea78cb8b2ba$var$_objectSpread({}, optgroup), $6e6f0ea78cb8b2ba$var$_defineProperty({}, "".concat(props.optionGroupChildren), filteredSubOptions)));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $eHYdO.FilterService).filter(options, searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var onFirstHiddenFocus = function onFirstHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $7nrKB.DomHandler).getFirstFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $7nrKB.DomHandler).focus(focusableEl);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $7nrKB.DomHandler).getLastFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $7nrKB.DomHandler).focus(focusableEl);
    };
    var isClearClicked = function isClearClicked(event) {
        return (0, $7nrKB.DomHandler).isAttributeEquals(event.target, "data-pc-section", "clearicon") || (0, $7nrKB.DomHandler).isAttributeEquals(event.target.parentElement || event.target, "data-pc-section", "filterclearicon");
    };
    var _onClick = function onClick(event) {
        if (props.disabled || props.loading) return;
        props.onClick && props.onClick(event);
        // do not continue if the user defined click wants to prevent it
        if (event.defaultPrevented) return;
        if (isClearClicked(event) || event.target.tagName === "INPUT") return;
        else if (!overlayRef.current || !(overlayRef.current && overlayRef.current.contains(event.target))) {
            (0, $7nrKB.DomHandler).focus(focusInputRef.current);
            overlayVisibleState ? hide() : show();
        }
        event.preventDefault();
        clickedRef.current = true;
    };
    var onInputFocus = function onInputFocus(event) {
        if (props.showOnFocus && !overlayVisibleState) show();
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.onBlur) setTimeout(function() {
            var currentValue = inputRef.current ? inputRef.current.value : undefined;
            props.onBlur({
                originalEvent: event.originalEvent,
                value: currentValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: currentValue
                }
            });
        }, 200);
    };
    var onOptionSelect = function onOptionSelect(event, option) {
        var isHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        selectItem({
            originalEvent: event,
            option: option
        });
        if (isHide) {
            hide();
            (0, $7nrKB.DomHandler).focus(focusInputRef.current);
        }
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $hB9Eg.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var code = (0, $7nrKB.DomHandler).isAndroid() ? event.key : event.code;
        switch(code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "ArrowLeft":
            case "ArrowRight":
                onArrowLeftKey(event, props.editable);
                break;
            case "Home":
                onHomeKey(event);
                break;
            case "End":
                onEndKey(event);
                break;
            case "PageDown":
                onPageDownKey(event);
                break;
            case "PageUp":
                onPageUpKey(event);
                break;
            case "Space":
                onSpaceKey(event, props.editable);
                break;
            case "NumpadEnter":
            case "Enter":
                onEnterKey(event);
                break;
            case "Escape":
                onEscapeKey(event);
                break;
            case "Tab":
                onTabKey(event);
                break;
            case "Backspace":
                onBackspaceKey(event, props.editable);
                break;
            case "ShiftLeft":
            case "ShiftRight":
                break;
            default:
                var metaKey = event.metaKey || event.ctrlKey || event.altKey;
                // Only handle printable characters when no meta keys are pressed
                if (!metaKey && (0, $7nrKB.ObjectUtils).isPrintableCharacter(event.key)) {
                    !overlayVisibleState && !props.editable && show();
                    !props.editable && searchOptions(event, event.key);
                }
                break;
        }
        clickedRef.current = false;
    };
    var onFilterInputKeyDown = function onFilterInputKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "ArrowLeft":
            case "ArrowRight":
                onArrowLeftKey(event, true);
                break;
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event);
                event.preventDefault();
                break;
            case "Escape":
                onEscapeKey(event);
                break;
        }
    };
    var hasFocusableElements = function hasFocusableElements() {
        return (0, $7nrKB.DomHandler).getFocusableElements(overlayRef.current, ':not([data-p-hidden-focusable="true"])').length > 0;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.current.toLocaleLowerCase(props.filterLocale)));
    };
    var isValidOption = function isValidOption(option) {
        return (0, $7nrKB.ObjectUtils).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $7nrKB.ObjectUtils).isNotEmpty(props.value);
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        return hasSelectedOption ? visibleOptions.findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var searchOptions = function searchOptions(event, _char) {
        searchValue.current = (searchValue.current || "") + _char;
        var optionIndex = -1;
        var matched = false;
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(searchValue.current)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex !== -1) matched = true;
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = "";
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $7nrKB.ObjectUtils).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $7nrKB.ObjectUtils).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            focusOnItem(index);
            if (props.selectOnFocus) onOptionSelect(event, visibleOptions[index], false);
        }
    };
    var focusOnItem = function focusOnItem(index) {
        var focusedItem = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'li[id="dropdownItem_'.concat(index, '"]'));
        focusedItem && focusedItem.focus();
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        if (!overlayVisibleState) {
            show();
            props.editable && changeFocusedOptionIndex(event, findSelectedOptionIndex());
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : clickedRef.current ? findFirstOptionIndex() : findFirstFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event.altKey && !pressedInInputText) {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            state.overlayVisible && hide();
            event.preventDefault();
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : clickedRef.current ? findLastOptionIndex() : findLastFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
            event.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        pressedInInputText && setFocusedOptionIndex(-1);
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            event.currentTarget.setSelectionRange(0, 0);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findFirstOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            var target = event.currentTarget;
            var len = target.value.length;
            target.setSelectionRange(len, len);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findLastOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        !pressedInInputText && onEnterKey(event);
    };
    var onEnterKey = function onEnterKey(event) {
        event.preventDefault();
        if (!overlayVisibleState) {
            setFocusedOptionIndex(-1);
            onArrowDownKey(event);
        } else {
            if (focusedOptionIndex === -1) return;
            var focusedOption = visibleOptions[focusedOptionIndex];
            var optionValue = getOptionValue(focusedOption);
            if (optionValue == null || optionValue == undefined) {
                hide();
                resetFilter();
                updateEditableLabel(selectedOption);
                return;
            }
            onOptionSelect(event, focusedOption);
        }
    };
    var onEscapeKey = function onEscapeKey(event) {
        overlayVisibleState && hide();
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!pressedInInputText) {
            if (overlayVisibleState && !hasFocusableElements()) {
                (0, $7nrKB.DomHandler).focus(firstHiddenFocusableElementOnOverlay.current);
                event.preventDefault();
            } else {
                if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
                overlayVisibleState && hide();
            }
        }
    };
    var onBackspaceKey = function onBackspaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event && pressedInInputText) !overlayVisibleState && show();
    };
    var findInArray = function findInArray(visibleOptions, searchText) {
        if (!searchText || !(visibleOptions !== null && visibleOptions !== void 0 && visibleOptions.length)) return -1;
        var normalizedSearch = searchText.toLocaleLowerCase();
        var exactMatch = visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase() === normalizedSearch;
        });
        if (exactMatch !== -1) return exactMatch;
        return visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase().startsWith(normalizedSearch);
        });
    };
    var onEditableInputChange = function onEditableInputChange(event) {
        !overlayVisibleState && show();
        var searchIndex = null;
        if (event.target.value && visibleOptions) searchIndex = findInArray(visibleOptions, event.target.value);
        setFocusedOptionIndex(searchIndex);
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: event.target.value,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: event.target.value
            }
        });
    };
    var onEditableInputFocus = function onEditableInputFocus(event) {
        setFocusedState(true);
        hide();
        props.onFocus && props.onFocus(event);
    };
    var onOptionClick = function onOptionClick(event) {
        var option = event.option;
        if (!option.disabled) {
            selectItem(event);
            (0, $7nrKB.DomHandler).focus(focusInputRef.current);
        }
        hide();
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        var filter = event.target.value;
        setFilterState(filter);
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            filter: filter
        });
    };
    var onFilterClearIconClick = function onFilterClearIconClick(callback) {
        resetFilter(callback);
    };
    var resetFilter = function resetFilter(callback) {
        setFilterState("");
        props.onFilter && props.onFilter({
            filter: ""
        });
        callback && callback();
    };
    var clear = function clear(event) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: undefined,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: undefined
            }
        });
        if (props.filter) resetFilter();
        updateEditableLabel();
        setFocusedOptionIndex(-1);
    };
    var selectItem = function selectItem(event) {
        if (selectedOption !== event.option) {
            updateEditableLabel(event.option);
            setFocusedOptionIndex(-1);
            var optionValue = getOptionValue(event.option);
            var selectedOptionIndex = findOptionIndexInList(event.option, visibleOptions);
            if (props.onChange) props.onChange({
                originalEvent: event.originalEvent,
                value: optionValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: optionValue
                }
            });
            changeFocusedOptionIndex(event.originalEvent, selectedOptionIndex);
        }
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex(options) {
        options = options || visibleOptions;
        if (options) {
            if (props.optionGroupLabel) for(var i = 0; i < options.length; i++){
                var selectedOptionIndex = findOptionIndexInList(props.value, getOptionGroupChildren(options[i]));
                if (selectedOptionIndex !== -1) return {
                    group: i,
                    option: selectedOptionIndex
                };
            }
            else return findOptionIndexInList(props.value, options);
        }
        return -1;
    };
    var equalityKey = function equalityKey() {
        return props.optionValue ? null : props.dataKey;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        var key = equalityKey();
        return list.findIndex(function(item) {
            return (0, $7nrKB.ObjectUtils).equals(value, getOptionValue(item), key);
        });
    };
    var isSelected = function isSelected(option) {
        return (0, $7nrKB.ObjectUtils).equals(props.value, getOptionValue(option), equalityKey());
    };
    var show = function show() {
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : props.editable ? -1 : findSelectedOptionIndex());
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        clickedRef.current = false;
    };
    var onFocus = function onFocus() {
        if (props.editable && !overlayVisibleState && clickedRef.current === false) (0, $7nrKB.DomHandler).focus(inputRef.current);
    };
    var onOverlayEnter = function onOverlayEnter(callback) {
        (0, $7nrKB.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, context && context.zIndex.overlay || (0, $eHYdO.default).zIndex.overlay);
        (0, $7nrKB.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
        callback && callback();
    };
    var onOverlayEntered = function onOverlayEntered(callback) {
        callback && callback();
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        if (props.filter && props.resetFilterOnHide) resetFilter();
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $7nrKB.DomHandler).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo);
    };
    var scrollInView = function scrollInView() {
        var focusedItem = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'li[data-p-focused="true"]');
        if (focusedItem && focusedItem.scrollIntoView) focusedItem.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
        else {
            var highlightItem = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            if (highlightItem && highlightItem.scrollIntoView) highlightItem.scrollIntoView({
                block: "nearest",
                inline: "nearest"
            });
        }
    };
    var updateEditableLabel = function updateEditableLabel(option) {
        if (inputRef.current) {
            inputRef.current.value = option ? getOptionLabel(option) : props.value || "";
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = inputRef.current.value;
        }
    };
    var getOptionLabel = function getOptionLabel(option) {
        if ((0, $7nrKB.ObjectUtils).isScalar(option)) return "".concat(option);
        var optionLabel = props.optionLabel ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionLabel) : option["label"];
        return "".concat(optionLabel);
    };
    var getOptionValue = function getOptionValue(option) {
        if (props.useOptionAsValue) return option;
        var optionValue = props.optionValue ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionValue) : option ? option["value"] : (0, $7nrKB.ObjectUtils).resolveFieldData(option, "value");
        return props.optionValue || (0, $7nrKB.ObjectUtils).isNotEmpty(optionValue) ? optionValue : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.group;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $7nrKB.ObjectUtils).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var updateInputField = function updateInputField() {
        if (props.editable && inputRef.current) {
            var label = selectedOption ? getOptionLabel(selectedOption) : null;
            var value = label || props.value || "";
            inputRef.current.value = value;
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = value;
        }
    };
    var getSelectedOption = function getSelectedOption() {
        var index = getSelectedOptionIndex(props.options);
        return index !== -1 ? props.optionGroupLabel ? getOptionGroupChildren(props.options[index.group])[index.option] : props.options[index] : null;
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            clear: clear,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(focusInputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getFocusInput: function getFocusInput() {
                return focusInputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
        (0, $7nrKB.ObjectUtils).combinedRefs(focusInputRef, props.focusInputRef);
    }, [
        inputRef,
        props.inputRef,
        focusInputRef,
        props.focusInputRef
    ]);
    (0, $jr5t3.useMountEffect)(function() {
        if (props.autoFocus) (0, $7nrKB.DomHandler).focus(focusInputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        if (overlayVisibleState && (props.value || focusedOptionIndex >= 0)) scrollInView();
    }, [
        overlayVisibleState,
        props.value,
        focusedOptionIndex
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (overlayVisibleState && filterState && props.filter) alignOverlay();
    }, [
        overlayVisibleState,
        filterState,
        props.filter
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        virtualScrollerRef.current && virtualScrollerRef.current.scrollInView(0);
    }, [
        filterState
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        updateInputField();
        if (inputRef.current) inputRef.current.selectedIndex = 1;
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
    });
    var createHiddenSelect = function createHiddenSelect() {
        var option = {
            value: "",
            label: props.placeholder
        };
        if (selectedOption) {
            var optionValue = getOptionValue(selectedOption);
            option = {
                value: $6e6f0ea78cb8b2ba$var$_typeof(optionValue) === "object" ? props.options.findIndex(function(o) {
                    return o === optionValue;
                }) : optionValue,
                label: getOptionLabel(selectedOption)
            };
        }
        var hiddenSelectedMessageProps = mergeProps({
            className: "p-hidden-accessible p-dropdown-hidden-select"
        }, ptm("hiddenSelectedMessage"));
        var selectProps = mergeProps({
            ref: inputRef,
            required: props.required,
            defaultValue: option.value,
            name: props.name,
            tabIndex: -1
        }, ptm("select"));
        var optionProps = mergeProps({
            value: option.value
        }, ptm("option"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $7E7Dk.createElement("select", selectProps, /*#__PURE__*/ $7E7Dk.createElement("option", optionProps, option.label)));
    };
    var createKeyboardHelper = function createKeyboardHelper() {
        var value = (0, $7nrKB.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) value = value || props.value || "";
        var hiddenSelectedMessageProps = mergeProps({
            className: "p-hidden-accessible"
        }, ptm("hiddenSelectedMessage"));
        var inputProps = mergeProps($6e6f0ea78cb8b2ba$var$_objectSpread({
            ref: focusInputRef,
            id: props.inputId,
            defaultValue: value,
            type: "text",
            readOnly: true,
            "aria-haspopup": "listbox",
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            disabled: props.disabled,
            tabIndex: !props.disabled ? props.tabIndex || 0 : -1
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $7E7Dk.createElement("input", inputProps));
    };
    var createLabel = function createLabel() {
        var label = (0, $7nrKB.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) {
            var value = label || props.value || "";
            var _inputProps = mergeProps($6e6f0ea78cb8b2ba$var$_objectSpread({
                ref: inputRef,
                type: "text",
                defaultValue: value,
                className: cx("input", {
                    label: label
                }),
                disabled: props.disabled,
                placeholder: props.placeholder,
                maxLength: props.maxLength,
                onInput: onEditableInputChange,
                onFocus: onEditableInputFocus,
                onKeyDown: onInputKeyDown,
                onBlur: onInputBlur,
                tabIndex: !props.disabled ? props.tabIndex || 0 : -1,
                "aria-haspopup": "listbox"
            }, ariaProps), ptm("input"));
            return /*#__PURE__*/ $7E7Dk.createElement("input", _inputProps);
        }
        var content = props.valueTemplate ? (0, $7nrKB.ObjectUtils).getJSXElement(props.valueTemplate, selectedOption, props) : label || props.placeholder || props.emptyMessage || /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, "\xa0");
        var inputProps = mergeProps({
            ref: inputRef,
            className: cx("input", {
                label: label
            }),
            tabIndex: "-1"
        }, ptm("input"));
        return /*#__PURE__*/ $7E7Dk.createElement("span", inputProps, content);
    };
    var onClearIconKeyDown = function onClearIconKeyDown(event) {
        if (event.key === "Enter" || event.code === "Space") {
            clear(event);
            event.preventDefault();
        }
    };
    var createClearIcon = function createClearIcon() {
        if (props.value != null && props.showClear && !props.disabled && !(0, $7nrKB.ObjectUtils).isEmpty(props.options)) {
            var clearIconProps = mergeProps({
                className: cx("clearIcon"),
                onPointerUp: clear,
                tabIndex: props.editable ? -1 : props.tabIndex || "0",
                onKeyDown: onClearIconKeyDown,
                "aria-label": (0, $eHYdO.localeOption)("clear")
            }, ptm("clearIcon"));
            var icon = props.clearIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), clearIconProps);
            return (0, $7nrKB.IconUtils).getJSXIcon(icon, $6e6f0ea78cb8b2ba$var$_objectSpread({}, clearIconProps), {
                props: props
            });
        }
        return null;
    };
    var createLoadingIcon = function createLoadingIcon() {
        var loadingIconProps = mergeProps({
            className: cx("loadingIcon"),
            "data-pr-overlay-visible": overlayVisibleState
        }, ptm("loadingIcon"));
        var icon = props.loadingIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $bRIbs.SpinnerIcon), {
            spin: true
        });
        var loadingIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $6e6f0ea78cb8b2ba$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var loadingButtonProps = mergeProps({
            className: cx("trigger"),
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            "aria-label": ariaLabel
        }, ptm("trigger"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", loadingButtonProps, loadingIcon);
    };
    var createDropdownIcon = function createDropdownIcon() {
        var dropdownIconProps = mergeProps({
            className: cx("dropdownIcon"),
            "data-pr-overlay-visible": overlayVisibleState
        }, ptm("dropdownIcon"));
        var icon = !overlayVisibleState ? props.dropdownIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $9pANH.ChevronDownIcon), dropdownIconProps) : props.collapseIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $difhH.ChevronUpIcon), dropdownIconProps);
        var dropdownIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $6e6f0ea78cb8b2ba$var$_objectSpread({}, dropdownIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var triggerProps = mergeProps({
            className: cx("trigger"),
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            "aria-label": ariaLabel
        }, ptm("trigger"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", triggerProps, dropdownIcon);
    };
    var visibleOptions = getVisibleOptions();
    var selectedOption = getSelectedOption();
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $6e6f0ea78cb8b2ba$var$DropdownBase.getOtherProps(props);
    var ariaProps = (0, $7nrKB.ObjectUtils).reduceKeys(otherProps, (0, $7nrKB.DomHandler).ARIA_PROPS);
    var hiddenSelect = createHiddenSelect();
    var keyboardHelper = createKeyboardHelper();
    var labelElement = createLabel();
    var dropdownIcon = props.loading ? createLoadingIcon() : createDropdownIcon();
    var clearIcon = createClearIcon();
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            context: context,
            focusedState: focusedState,
            overlayVisibleState: overlayVisibleState
        })),
        style: props.style,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onMouseDown: props.onMouseDown,
        onContextMenu: props.onContextMenu,
        onFocus: onFocus,
        "data-p-disabled": props.disabled,
        "data-p-focus": focusedState,
        "aria-activedescendant": focusedState ? "dropdownItem_".concat(focusedOptionIndex) : undefined
    }, otherProps, ptm("root"));
    var firstHiddenFocusableElementProps = mergeProps({
        ref: firstHiddenFocusableElementOnOverlay,
        role: "presentation",
        className: "p-hidden-accessible p-hidden-focusable",
        tabIndex: "0",
        onFocus: onFirstHiddenFocus,
        "data-p-hidden-accessible": true,
        "data-p-hidden-focusable": true
    }, ptm("hiddenFirstFocusableEl"));
    var lastHiddenFocusableElementProps = mergeProps({
        ref: lastHiddenFocusableElementOnOverlay,
        role: "presentation",
        className: "p-hidden-accessible p-hidden-focusable",
        tabIndex: "0",
        onFocus: onLastHiddenFocus,
        "data-p-hidden-accessible": true,
        "data-p-hidden-focusable": true
    }, ptm("hiddenLastFocusableEl"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, keyboardHelper, hiddenSelect, labelElement, clearIcon, dropdownIcon, /*#__PURE__*/ $7E7Dk.createElement($6e6f0ea78cb8b2ba$var$DropdownPanel, $6e6f0ea78cb8b2ba$var$_extends({
        hostName: "Dropdown",
        ref: overlayRef,
        visibleOptions: visibleOptions,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        appendTo: appendTo,
        cx: cx,
        filterValue: filterValue,
        focusedOptionIndex: focusedOptionIndex,
        getOptionGroupChildren: getOptionGroupChildren,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupRenderKey: getOptionGroupRenderKey,
        getOptionLabel: getOptionLabel,
        getOptionRenderKey: getOptionRenderKey,
        getSelectedOptionIndex: getSelectedOptionIndex,
        hasFilter: hasFilter,
        "in": overlayVisibleState,
        isOptionDisabled: isOptionDisabled,
        isSelected: isSelected,
        onOverlayHide: hide,
        onClick: onPanelClick,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        onFilterClearIconClick: onFilterClearIconClick,
        onFilterInputChange: onFilterInputChange,
        onFilterInputKeyDown: onFilterInputKeyDown,
        onOptionClick: onOptionClick,
        onInputKeyDown: onInputKeyDown,
        ptm: ptm,
        resetFilter: resetFilter,
        changeFocusedOptionIndex: changeFocusedOptionIndex,
        firstFocusableElement: /*#__PURE__*/ $7E7Dk.createElement("span", firstHiddenFocusableElementProps),
        lastFocusableElement: /*#__PURE__*/ $7E7Dk.createElement("span", lastHiddenFocusableElementProps),
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $6e6f0ea78cb8b2ba$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$6e6f0ea78cb8b2ba$export$931cbfb6bfb85fc.displayName = "Dropdown";

});
parcelRegister("9pANH", function(module, exports) {

$parcel$export(module.exports, "ChevronDownIcon", function () { return $6da2feabd518c912$export$4857d3f3f5f8319b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $6da2feabd518c912$var$_extends() {
    return $6da2feabd518c912$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6da2feabd518c912$var$_extends.apply(null, arguments);
}
var $6da2feabd518c912$export$4857d3f3f5f8319b = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $6da2feabd518c912$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
        fill: "currentColor"
    }));
}));
$6da2feabd518c912$export$4857d3f3f5f8319b.displayName = "ChevronDownIcon";

});

parcelRegister("difhH", function(module, exports) {

$parcel$export(module.exports, "ChevronUpIcon", function () { return $9ad8cff84a857ee3$export$7f01a6cbee61a0f2; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $9ad8cff84a857ee3$var$_extends() {
    return $9ad8cff84a857ee3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9ad8cff84a857ee3$var$_extends.apply(null, arguments);
}
var $9ad8cff84a857ee3$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $9ad8cff84a857ee3$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
        fill: "currentColor"
    }));
}));
$9ad8cff84a857ee3$export$7f01a6cbee61a0f2.displayName = "ChevronUpIcon";

});

parcelRegister("fQRXQ", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $b8a592875b7ad471$export$82eafebb825fc23f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $b8a592875b7ad471$var$_extends() {
    return $b8a592875b7ad471$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8a592875b7ad471$var$_extends.apply(null, arguments);
}
var $b8a592875b7ad471$export$82eafebb825fc23f = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $b8a592875b7ad471$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
        fill: "currentColor"
    }));
}));
$b8a592875b7ad471$export$82eafebb825fc23f.displayName = "SearchIcon";

});

parcelRegister("dL2Vy", function(module, exports) {

$parcel$export(module.exports, "VirtualScroller", function () { return $a041ef77ba2f8bcd$export$fbd4ea7fe0fb889; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $jr5t3 = parcelRequire("jr5t3");

var $bRIbs = parcelRequire("bRIbs");

var $7nrKB = parcelRequire("7nrKB");

var $kHEnT = parcelRequire("kHEnT");
"use client";
function $a041ef77ba2f8bcd$var$_extends() {
    return $a041ef77ba2f8bcd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a041ef77ba2f8bcd$var$_extends.apply(null, arguments);
}
function $a041ef77ba2f8bcd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a041ef77ba2f8bcd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a041ef77ba2f8bcd$var$_typeof(o);
}
function $a041ef77ba2f8bcd$var$toPrimitive(t, r) {
    if ("object" != $a041ef77ba2f8bcd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a041ef77ba2f8bcd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a041ef77ba2f8bcd$var$toPropertyKey(t) {
    var i = $a041ef77ba2f8bcd$var$toPrimitive(t, "string");
    return "symbol" == $a041ef77ba2f8bcd$var$_typeof(i) ? i : i + "";
}
function $a041ef77ba2f8bcd$var$_defineProperty(e, r, t) {
    return (r = $a041ef77ba2f8bcd$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a041ef77ba2f8bcd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $a041ef77ba2f8bcd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a041ef77ba2f8bcd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a041ef77ba2f8bcd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a041ef77ba2f8bcd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a041ef77ba2f8bcd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a041ef77ba2f8bcd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a041ef77ba2f8bcd$var$_slicedToArray(r, e) {
    return $a041ef77ba2f8bcd$var$_arrayWithHoles(r) || $a041ef77ba2f8bcd$var$_iterableToArrayLimit(r, e) || $a041ef77ba2f8bcd$var$_unsupportedIterableToArray(r, e) || $a041ef77ba2f8bcd$var$_nonIterableRest();
}
var $a041ef77ba2f8bcd$var$styles = "\n.p-virtualscroller {\n    position: relative;\n    overflow: auto;\n    contain: strict;\n    transform: translateZ(0);\n    will-change: scroll-position;\n    outline: 0 none;\n}\n\n.p-virtualscroller-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*contain: content;*/\n    min-height: 100%;\n    min-width: 100%;\n    will-change: transform;\n}\n\n.p-virtualscroller-spacer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1px;\n    width: 1px;\n    transform-origin: 0 0;\n    pointer-events: none;\n}\n\n.p-virtualscroller-loader {\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.p-virtualscroller-loader.p-component-overlay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-virtualscroller-loading-icon {\n    font-size: 2rem;\n}\n\n.p-virtualscroller-horizontal > .p-virtualscroller-content {\n    display: flex;\n}\n\n/* Inline */\n.p-virtualscroller-inline .p-virtualscroller-content {\n    position: static;\n}\n";
var $a041ef77ba2f8bcd$var$VirtualScrollerBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "VirtualScroller",
        __parentMetadata: null,
        id: null,
        style: null,
        className: null,
        tabIndex: 0,
        items: null,
        itemSize: 0,
        scrollHeight: null,
        scrollWidth: null,
        orientation: "vertical",
        step: 0,
        numToleratedItems: null,
        delay: 0,
        resizeDelay: 10,
        appendOnly: false,
        inline: false,
        lazy: false,
        disabled: false,
        loaderDisabled: false,
        loadingIcon: null,
        columns: null,
        loading: undefined,
        autoSize: false,
        showSpacer: true,
        showLoader: false,
        loadingTemplate: null,
        loaderIconTemplate: null,
        itemTemplate: null,
        contentTemplate: null,
        onScroll: null,
        onScrollIndexChange: null,
        onLazyLoad: null,
        children: undefined
    },
    css: {
        styles: $a041ef77ba2f8bcd$var$styles
    }
});
function $a041ef77ba2f8bcd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a041ef77ba2f8bcd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a041ef77ba2f8bcd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a041ef77ba2f8bcd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a041ef77ba2f8bcd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a041ef77ba2f8bcd$export$fbd4ea7fe0fb889 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $a041ef77ba2f8bcd$var$VirtualScrollerBase.getProps(inProps, context);
    var prevProps = (0, $jr5t3.usePrevious)(inProps) || {};
    var vertical = props.orientation === "vertical";
    var horizontal = props.orientation === "horizontal";
    var both = props.orientation === "both";
    var _React$useState = $7E7Dk.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState2 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState4 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState3, 2), lastState = _React$useState4[0], setLastState = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(0), _React$useState6 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState5, 2), pageState = _React$useState6[0], setPageState = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState8 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState7, 2), numItemsInViewportState = _React$useState8[0], setNumItemsInViewportState = _React$useState8[1];
    var _React$useState9 = $7E7Dk.useState(props.numToleratedItems), _React$useState10 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState9, 2), numToleratedItemsState = _React$useState10[0], setNumToleratedItemsState = _React$useState10[1];
    var _React$useState11 = $7E7Dk.useState(props.loading || false), _React$useState12 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState11, 2), loadingState = _React$useState12[0], setLoadingState = _React$useState12[1];
    var _React$useState13 = $7E7Dk.useState([]), _React$useState14 = $a041ef77ba2f8bcd$var$_slicedToArray(_React$useState13, 2), loaderArrState = _React$useState14[0], setLoaderArrState = _React$useState14[1];
    var _VirtualScrollerBase$ = $a041ef77ba2f8bcd$var$VirtualScrollerBase.setMetaData({
        props: props,
        state: {
            first: firstState,
            last: lastState,
            page: pageState,
            numItemsInViewport: numItemsInViewportState,
            numToleratedItems: numToleratedItemsState,
            loading: loadingState,
            loaderArr: loaderArrState
        }
    }), ptm = _VirtualScrollerBase$.ptm;
    (0, $jr5t3.useStyle)($a041ef77ba2f8bcd$var$VirtualScrollerBase.css.styles, {
        name: "virtualscroller"
    });
    var elementRef = $7E7Dk.useRef(null);
    var _contentRef = $7E7Dk.useRef(null);
    var _spacerRef = $7E7Dk.useRef(null);
    var _stickyRef = $7E7Dk.useRef(null);
    var lastScrollPos = $7E7Dk.useRef(both ? {
        top: 0,
        left: 0
    } : 0);
    var scrollTimeout = $7E7Dk.useRef(null);
    var resizeTimeout = $7E7Dk.useRef(null);
    var contentStyle = $7E7Dk.useRef({});
    var spacerStyle = $7E7Dk.useRef({});
    var defaultWidth = $7E7Dk.useRef(null);
    var defaultHeight = $7E7Dk.useRef(null);
    var defaultContentWidth = $7E7Dk.useRef(null);
    var defaultContentHeight = $7E7Dk.useRef(null);
    var isItemRangeChanged = $7E7Dk.useRef(false);
    var lazyLoadState = $7E7Dk.useRef(null);
    var viewInitialized = $7E7Dk.useRef(false);
    var _useResizeListener = (0, $jr5t3.useResizeListener)({
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useResizeListener2 = $a041ef77ba2f8bcd$var$_slicedToArray(_useResizeListener, 1), bindWindowResizeListener = _useResizeListener2[0];
    var _useEventListener = (0, $jr5t3.useEventListener)({
        target: "window",
        type: "orientationchange",
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useEventListener2 = $a041ef77ba2f8bcd$var$_slicedToArray(_useEventListener, 1), bindOrientationChangeListener = _useEventListener2[0];
    var getElementRef = function getElementRef() {
        return elementRef;
    };
    var getPageByFirst = function getPageByFirst(first) {
        return Math.floor((first + numToleratedItemsState * 4) / (props.step || 1));
    };
    var setContentElement = function setContentElement(element) {
        _contentRef.current = element || _contentRef.current || (0, $7nrKB.DomHandler).findSingle(elementRef.current, ".p-virtualscroller-content");
    };
    var isPageChanged = function isPageChanged(first) {
        return props.step ? pageState !== getPageByFirst(first) : true;
    };
    var scrollTo = function scrollTo(options) {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
        elementRef.current && elementRef.current.scrollTo(options);
    };
    var scrollToIndex = function scrollToIndex(index) {
        var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
        var _calculateNumItems = calculateNumItems(), numToleratedItems = _calculateNumItems.numToleratedItems;
        var contentPos = getContentPosition();
        var calculateFirst = function calculateFirst() {
            var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var _numT = arguments.length > 1 ? arguments[1] : undefined;
            return _index <= _numT ? 0 : _index;
        };
        var calculateCoord = function calculateCoord(_first, _size, _cpos) {
            return _first * _size + _cpos;
        };
        var scrollToItem = function scrollToItem() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return scrollTo({
                left: left,
                top: top,
                behavior: behavior
            });
        };
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var isRangeChanged = false;
        if (both) {
            newFirst = {
                rows: calculateFirst(index[0], numToleratedItems[0]),
                cols: calculateFirst(index[1], numToleratedItems[1])
            };
            scrollToItem(calculateCoord(newFirst.cols, props.itemSize[1], contentPos.left), calculateCoord(newFirst.rows, props.itemSize[0], contentPos.top));
            isRangeChanged = firstState.rows !== newFirst.rows || firstState.cols !== newFirst.cols;
        } else {
            newFirst = calculateFirst(index, numToleratedItems);
            horizontal ? scrollToItem(calculateCoord(newFirst, props.itemSize, contentPos.left), 0) : scrollToItem(0, calculateCoord(newFirst, props.itemSize, contentPos.top));
            isRangeChanged = firstState !== newFirst;
        }
        isItemRangeChanged.current = isRangeChanged;
        setFirstState(newFirst);
    };
    var scrollInView = function scrollInView(index, to) {
        var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "auto";
        if (to) {
            var _getRenderedRange = getRenderedRange(), first = _getRenderedRange.first, viewport = _getRenderedRange.viewport;
            var scrollToItem = function scrollToItem() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return scrollTo({
                    left: left,
                    top: top,
                    behavior: behavior
                });
            };
            var isToStart = to === "to-start";
            var isToEnd = to === "to-end";
            if (isToStart) {
                if (both) {
                    if (viewport.first.rows - first.rows > index[0]) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows - 1) * props.itemSize[0]);
                    else if (viewport.first.cols - first.cols > index[1]) scrollToItem((viewport.first.cols - 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.first - first > index) {
                    var pos = (viewport.first - 1) * props.itemSize;
                    horizontal ? scrollToItem(pos, 0) : scrollToItem(0, pos);
                }
            } else if (isToEnd) {
                if (both) {
                    if (viewport.last.rows - first.rows <= index[0] + 1) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows + 1) * props.itemSize[0]);
                    else if (viewport.last.cols - first.cols <= index[1] + 1) scrollToItem((viewport.first.cols + 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.last - first <= index + 1) {
                    var _pos2 = (viewport.first + 1) * props.itemSize;
                    horizontal ? scrollToItem(_pos2, 0) : scrollToItem(0, _pos2);
                }
            }
        } else scrollToIndex(index, behavior);
    };
    var getRows = function getRows() {
        return loadingState ? props.loaderDisabled ? loaderArrState : [] : loadedItems();
    };
    var getColumns = function getColumns() {
        if (props.columns && both || horizontal) return loadingState && props.loaderDisabled ? both ? loaderArrState[0] : loaderArrState : props.columns.slice(both ? firstState.cols : firstState, both ? lastState.cols : lastState);
        return props.columns;
    };
    var getRenderedRange = function getRenderedRange() {
        var calculateFirstInViewport = function calculateFirstInViewport(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var firstInViewport = firstState;
        var lastInViewport = 0;
        if (elementRef.current) {
            var _elementRef$current = elementRef.current, scrollTop = _elementRef$current.scrollTop, scrollLeft = _elementRef$current.scrollLeft;
            if (both) {
                firstInViewport = {
                    rows: calculateFirstInViewport(scrollTop, props.itemSize[0]),
                    cols: calculateFirstInViewport(scrollLeft, props.itemSize[1])
                };
                lastInViewport = {
                    rows: firstInViewport.rows + numItemsInViewportState.rows,
                    cols: firstInViewport.cols + numItemsInViewportState.cols
                };
            } else {
                var scrollPos = horizontal ? scrollLeft : scrollTop;
                firstInViewport = calculateFirstInViewport(scrollPos, props.itemSize);
                lastInViewport = firstInViewport + numItemsInViewportState;
            }
        }
        return {
            first: firstState,
            last: lastState,
            viewport: {
                first: firstInViewport,
                last: lastInViewport
            }
        };
    };
    var calculateNumItems = function calculateNumItems() {
        var contentPos = getContentPosition();
        var contentWidth = elementRef.current ? elementRef.current.offsetWidth - contentPos.left : 0;
        var contentHeight = elementRef.current ? elementRef.current.offsetHeight - contentPos.top : 0;
        var calculateNumItemsInViewport = function calculateNumItemsInViewport(_contentSize, _itemSize) {
            return Math.ceil(_contentSize / (_itemSize || _contentSize));
        };
        var calculateNumToleratedItems = function calculateNumToleratedItems(_numItems) {
            return Math.ceil(_numItems / 2);
        };
        var numItemsInViewport = both ? {
            rows: calculateNumItemsInViewport(contentHeight, props.itemSize[0]),
            cols: calculateNumItemsInViewport(contentWidth, props.itemSize[1])
        } : calculateNumItemsInViewport(horizontal ? contentWidth : contentHeight, props.itemSize);
        var numToleratedItems = numToleratedItemsState || (both ? [
            calculateNumToleratedItems(numItemsInViewport.rows),
            calculateNumToleratedItems(numItemsInViewport.cols)
        ] : calculateNumToleratedItems(numItemsInViewport));
        return {
            numItemsInViewport: numItemsInViewport,
            numToleratedItems: numToleratedItems
        };
    };
    var calculateOptions = function calculateOptions() {
        var _calculateNumItems2 = calculateNumItems(), numItemsInViewport = _calculateNumItems2.numItemsInViewport, numToleratedItems = _calculateNumItems2.numToleratedItems;
        var calculateLast = function calculateLast(_first, _num, _numT) {
            var _isCols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return getLast(_first + _num + (_first < _numT ? 2 : 3) * _numT, _isCols);
        };
        var last = both ? {
            rows: calculateLast(firstState.rows, numItemsInViewport.rows, numToleratedItems[0]),
            cols: calculateLast(firstState.cols, numItemsInViewport.cols, numToleratedItems[1], true)
        } : calculateLast(firstState, numItemsInViewport, numToleratedItems);
        setNumItemsInViewportState(numItemsInViewport);
        setNumToleratedItemsState(numToleratedItems);
        setLastState(last);
        if (props.showLoader) setLoaderArrState(both ? Array.from({
            length: numItemsInViewport.rows
        }).map(function() {
            return Array.from({
                length: numItemsInViewport.cols
            });
        }) : Array.from({
            length: numItemsInViewport
        }));
        if (props.lazy) Promise.resolve().then(function() {
            lazyLoadState.current = {
                first: props.step ? both ? {
                    rows: 0,
                    cols: firstState.cols
                } : 0 : firstState,
                last: Math.min(props.step ? props.step : last, (props.items || []).length)
            };
            props.onLazyLoad && props.onLazyLoad(lazyLoadState.current);
        });
    };
    var calculateAutoSize = function calculateAutoSize(loading) {
        if (props.autoSize && !loading) Promise.resolve().then(function() {
            if (_contentRef.current) {
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = "auto";
                _contentRef.current.style.position = "relative";
                elementRef.current.style.contain = "none";
                /*const [contentWidth, contentHeight] = [DomHandler.getWidth(contentRef.current), DomHandler.getHeight(contentRef.current)];
           contentWidth !== defaultContentWidth.current && (elementRef.current.style.width = '');
          contentHeight !== defaultContentHeight.current && (elementRef.current.style.height = '');*/ var _ref = [
                    (0, $7nrKB.DomHandler).getWidth(elementRef.current),
                    (0, $7nrKB.DomHandler).getHeight(elementRef.current)
                ], width = _ref[0], height = _ref[1];
                (both || horizontal) && (elementRef.current.style.width = (width < defaultWidth.current ? width : props.scrollWidth || defaultWidth.current) + "px");
                (both || vertical) && (elementRef.current.style.height = (height < defaultHeight.current ? height : props.scrollHeight || defaultHeight.current) + "px");
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = "";
                _contentRef.current.style.position = "";
                elementRef.current.style.contain = "";
            }
        });
    };
    var getLast = function getLast() {
        var _ref2;
        var last = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var isCols = arguments.length > 1 ? arguments[1] : undefined;
        return props.items ? Math.min(isCols ? ((_ref2 = props.columns || props.items[0]) === null || _ref2 === void 0 ? void 0 : _ref2.length) || 0 : (props.items || []).length, last) : 0;
    };
    var getContentPosition = function getContentPosition() {
        if (_contentRef.current) {
            var style = getComputedStyle(_contentRef.current);
            var left = parseFloat(style.paddingLeft) + Math.max(parseFloat(style.left) || 0, 0);
            var right = parseFloat(style.paddingRight) + Math.max(parseFloat(style.right) || 0, 0);
            var top = parseFloat(style.paddingTop) + Math.max(parseFloat(style.top) || 0, 0);
            var bottom = parseFloat(style.paddingBottom) + Math.max(parseFloat(style.bottom) || 0, 0);
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                x: left + right,
                y: top + bottom
            };
        }
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            x: 0,
            y: 0
        };
    };
    var setSize = function setSize() {
        if (elementRef.current) {
            var parentElement = elementRef.current.parentElement;
            var width = props.scrollWidth || "".concat(elementRef.current.offsetWidth || parentElement.offsetWidth, "px");
            var height = props.scrollHeight || "".concat(elementRef.current.offsetHeight || parentElement.offsetHeight, "px");
            var setProp = function setProp(_name, _value) {
                return elementRef.current.style[_name] = _value;
            };
            if (both || horizontal) {
                setProp("height", height);
                setProp("width", width);
            } else setProp("height", height);
        }
    };
    var setSpacerSize = function setSpacerSize() {
        var items = props.items;
        if (items) {
            var contentPos = getContentPosition();
            var setProp = function setProp(_name, _value, _size) {
                var _cpos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                return spacerStyle.current = $a041ef77ba2f8bcd$var$_objectSpread($a041ef77ba2f8bcd$var$_objectSpread({}, spacerStyle.current), $a041ef77ba2f8bcd$var$_defineProperty({}, "".concat(_name), (_value || []).length * _size + _cpos + "px"));
            };
            if (both) {
                setProp("height", items, props.itemSize[0], contentPos.y);
                setProp("width", props.columns || items[1], props.itemSize[1], contentPos.x);
            } else horizontal ? setProp("width", props.columns || items, props.itemSize, contentPos.x) : setProp("height", items, props.itemSize, contentPos.y);
        }
    };
    var setContentPosition = function setContentPosition(pos) {
        if (_contentRef.current && !props.appendOnly) {
            var first = pos ? pos.first : firstState;
            var calculateTranslateVal = function calculateTranslateVal(_first, _size) {
                return _first * _size;
            };
            var setTransform = function setTransform() {
                var _x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var _y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _stickyRef.current && (_stickyRef.current.style.top = "-".concat(_y, "px"));
                contentStyle.current = $a041ef77ba2f8bcd$var$_objectSpread($a041ef77ba2f8bcd$var$_objectSpread({}, contentStyle.current), {
                    transform: "translate3d(".concat(_x, "px, ").concat(_y, "px, 0)")
                });
            };
            if (both) setTransform(calculateTranslateVal(first.cols, props.itemSize[1]), calculateTranslateVal(first.rows, props.itemSize[0]));
            else {
                var translateVal = calculateTranslateVal(first, props.itemSize);
                horizontal ? setTransform(translateVal, 0) : setTransform(0, translateVal);
            }
        }
    };
    var onScrollPositionChange = function onScrollPositionChange(event) {
        var target = event.target;
        var contentPos = getContentPosition();
        var calculateScrollPos = function calculateScrollPos(_pos, _cpos) {
            return _pos ? _pos > _cpos ? _pos - _cpos : _pos : 0;
        };
        var calculateCurrentIndex = function calculateCurrentIndex(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var calculateTriggerIndex = function calculateTriggerIndex(_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            return _currentIndex <= _numT ? _numT : _isScrollDownOrRight ? _last - _num - _numT : _first + _numT - 1;
        };
        var calculateFirst = function calculateFirst(_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            if (_currentIndex <= _numT) return 0;
            return Math.max(0, _isScrollDownOrRight ? _currentIndex < _triggerIndex ? _first : _currentIndex - _numT : _currentIndex > _triggerIndex ? _first : _currentIndex - 2 * _numT);
        };
        var calculateLast = function calculateLast(_currentIndex, _first, _last, _num, _numT, _isCols) {
            var lastValue = _first + _num + 2 * _numT;
            if (_currentIndex >= _numT) lastValue = lastValue + (_numT + 1);
            return getLast(lastValue, _isCols);
        };
        var scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
        var scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var newLast = lastState;
        var isRangeChanged = false;
        var newScrollPos = lastScrollPos.current;
        if (both) {
            var isScrollDown = lastScrollPos.current.top <= scrollTop;
            var isScrollRight = lastScrollPos.current.left <= scrollLeft;
            if (!props.appendOnly || props.appendOnly && (isScrollDown || isScrollRight)) {
                var currentIndex = {
                    rows: calculateCurrentIndex(scrollTop, props.itemSize[0]),
                    cols: calculateCurrentIndex(scrollLeft, props.itemSize[1])
                };
                var triggerIndex = {
                    rows: calculateTriggerIndex(currentIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateTriggerIndex(currentIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newFirst = {
                    rows: calculateFirst(currentIndex.rows, triggerIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateFirst(currentIndex.cols, triggerIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newLast = {
                    rows: calculateLast(currentIndex.rows, newFirst.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0]),
                    cols: calculateLast(currentIndex.cols, newFirst.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], true)
                };
                isRangeChanged = newFirst.rows !== firstState.rows || newLast.rows !== lastState.rows || newFirst.cols !== firstState.cols || newLast.cols !== lastState.cols || isItemRangeChanged.current;
                newScrollPos = {
                    top: scrollTop,
                    left: scrollLeft
                };
            }
        } else {
            var scrollPos = horizontal ? scrollLeft : scrollTop;
            var isScrollDownOrRight = lastScrollPos.current <= scrollPos;
            if (!props.appendOnly || props.appendOnly && isScrollDownOrRight) {
                var _currentIndex2 = calculateCurrentIndex(scrollPos, props.itemSize);
                var _triggerIndex2 = calculateTriggerIndex(_currentIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newFirst = calculateFirst(_currentIndex2, _triggerIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newLast = calculateLast(_currentIndex2, newFirst, lastState, numItemsInViewportState, numToleratedItemsState);
                isRangeChanged = newFirst !== firstState || newLast !== lastState || isItemRangeChanged.current;
                newScrollPos = scrollPos;
            }
        }
        return {
            first: newFirst,
            last: newLast,
            isRangeChanged: isRangeChanged,
            scrollPos: newScrollPos
        };
    };
    var onScrollChange = function onScrollChange(event) {
        var _onScrollPositionChan = onScrollPositionChange(event), first = _onScrollPositionChan.first, last = _onScrollPositionChan.last, isRangeChanged = _onScrollPositionChan.isRangeChanged, scrollPos = _onScrollPositionChan.scrollPos;
        if (isRangeChanged) {
            var newState = {
                first: first,
                last: last
            };
            setContentPosition(newState);
            setFirstState(first);
            setLastState(last);
            lastScrollPos.current = scrollPos;
            props.onScrollIndexChange && props.onScrollIndexChange(newState);
            if (props.lazy && isPageChanged(first)) {
                var newLazyLoadState = {
                    first: props.step ? Math.min(getPageByFirst(first) * props.step, (props.items || []).length - props.step) : first,
                    last: Math.min(props.step ? (getPageByFirst(first) + 1) * props.step : last, (props.items || []).length)
                };
                var isLazyStateChanged = !lazyLoadState.current || lazyLoadState.current.first !== newLazyLoadState.first || lazyLoadState.current.last !== newLazyLoadState.last;
                isLazyStateChanged && props.onLazyLoad && props.onLazyLoad(newLazyLoadState);
                lazyLoadState.current = newLazyLoadState;
            }
        }
    };
    var _onScroll = function onScroll(event) {
        props.onScroll && props.onScroll(event);
        if (props.delay) {
            if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
            if (isPageChanged(firstState)) {
                if (!loadingState && props.showLoader) {
                    var _onScrollPositionChan2 = onScrollPositionChange(event), isRangeChanged = _onScrollPositionChan2.isRangeChanged;
                    var changed = isRangeChanged || (props.step ? isPageChanged(firstState) : false);
                    changed && setLoadingState(true);
                }
                scrollTimeout.current = setTimeout(function() {
                    onScrollChange(event);
                    if (loadingState && props.showLoader && (!props.lazy || props.loading === undefined)) {
                        setLoadingState(false);
                        setPageState(getPageByFirst(firstState));
                    }
                }, props.delay);
            }
        } else onScrollChange(event);
    };
    var onResize = function onResize() {
        if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
        resizeTimeout.current = setTimeout(function() {
            if (elementRef.current) {
                var _ref3 = [
                    (0, $7nrKB.DomHandler).getWidth(elementRef.current),
                    (0, $7nrKB.DomHandler).getHeight(elementRef.current)
                ], width = _ref3[0], height = _ref3[1];
                var isDiffWidth = width !== defaultWidth.current, isDiffHeight = height !== defaultHeight.current;
                var reinit = both ? isDiffWidth || isDiffHeight : horizontal ? isDiffWidth : vertical ? isDiffHeight : false;
                if (reinit) {
                    setNumToleratedItemsState(props.numToleratedItems);
                    defaultWidth.current = width;
                    defaultHeight.current = height;
                    defaultContentWidth.current = (0, $7nrKB.DomHandler).getWidth(_contentRef.current);
                    defaultContentHeight.current = (0, $7nrKB.DomHandler).getHeight(_contentRef.current);
                }
            }
        }, props.resizeDelay);
    };
    var getOptions = function getOptions(renderedIndex) {
        var count = (props.items || []).length;
        var index = both ? firstState.rows + renderedIndex : firstState + renderedIndex;
        return {
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        };
    };
    var loaderOptions = function loaderOptions(index, extOptions) {
        var count = loaderArrState.length || 0;
        return $a041ef77ba2f8bcd$var$_objectSpread({
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        }, extOptions);
    };
    var loadedItems = function loadedItems() {
        var items = props.items;
        if (items && !loadingState) {
            if (both) return items.slice(props.appendOnly ? 0 : firstState.rows, lastState.rows).map(function(item) {
                return props.columns ? item : item.slice(props.appendOnly ? 0 : firstState.cols, lastState.cols);
            });
            else if (horizontal && props.columns) return items;
            return items.slice(props.appendOnly ? 0 : firstState, lastState);
        }
        return [];
    };
    var viewInit = function viewInit() {
        if (elementRef.current && isVisible()) {
            setContentElement(_contentRef.current);
            init();
            bindWindowResizeListener();
            bindOrientationChangeListener();
            defaultWidth.current = (0, $7nrKB.DomHandler).getWidth(elementRef.current);
            defaultHeight.current = (0, $7nrKB.DomHandler).getHeight(elementRef.current);
            defaultContentWidth.current = (0, $7nrKB.DomHandler).getWidth(_contentRef.current);
            defaultContentHeight.current = (0, $7nrKB.DomHandler).getHeight(_contentRef.current);
        }
    };
    var init = function init() {
        if (!props.disabled && isVisible()) {
            setSize();
            calculateOptions();
            setSpacerSize();
        }
    };
    var isVisible = function isVisible() {
        if ((0, $7nrKB.DomHandler).isVisible(elementRef.current)) {
            var rect = elementRef.current.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0;
        }
        return false;
    };
    $7E7Dk.useEffect(function() {
        if (!viewInitialized.current && isVisible()) {
            viewInit();
            viewInitialized.current = true;
        }
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        init();
    }, [
        props.itemSize,
        props.scrollHeight,
        props.scrollWidth
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (props.numToleratedItems !== numToleratedItemsState) setNumToleratedItemsState(props.numToleratedItems);
    }, [
        props.numToleratedItems
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (props.numToleratedItems === numToleratedItemsState) init(); // reinit after resizing
    }, [
        numToleratedItemsState
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        // Check if the previous/current rows array exists
        var prevRowsExist = prevProps.items !== undefined && prevProps.items !== null;
        var currentRowsExist = props.items !== undefined && props.items !== null;
        // Get the length of the previous/current rows array, or 0 if it doesn't exist
        var prevRowsLength = prevRowsExist ? prevProps.items.length : 0;
        var currentRowsLength = currentRowsExist ? props.items.length : 0;
        // Check if the length of the rows arrays has changed
        var valuesChanged = prevRowsLength !== currentRowsLength;
        // If both is true, we also need to check the lengths of the first element (assuming it's a matrix)
        if (both && !valuesChanged) {
            // Get the length of the columns or 0
            var prevColumnsLength = prevRowsExist && prevProps.items.length > 0 ? prevProps.items[0].length : 0;
            var currentColumnsLength = currentRowsExist && props.items.length > 0 ? props.items[0].length : 0;
            // Check if the length of the columns has changed
            valuesChanged = prevColumnsLength !== currentColumnsLength;
        }
        // If the previous items array doesn't exist or if any values have changed, call the init function
        if (!prevRowsExist || valuesChanged) init();
        var loading = loadingState;
        if (props.lazy && prevProps.loading !== props.loading && props.loading !== loadingState) {
            setLoadingState(props.loading);
            loading = props.loading;
        }
        calculateAutoSize(loading);
    });
    (0, $jr5t3.useUpdateEffect)(function() {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
    }, [
        props.orientation
    ]);
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElementRef: getElementRef,
            scrollTo: scrollTo,
            scrollToIndex: scrollToIndex,
            scrollInView: scrollInView,
            getRenderedRange: getRenderedRange
        };
    });
    var createLoaderItem = function createLoaderItem(index) {
        var extOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = loaderOptions(index, extOptions);
        var content = (0, $7nrKB.ObjectUtils).getJSXElement(props.loadingTemplate, options);
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, {
            key: index
        }, content);
    };
    var createLoader = function createLoader() {
        var iconClassName = "p-virtualscroller-loading-icon";
        var loadingIconProps = mergeProps({
            className: iconClassName
        }, ptm("loadingIcon"));
        var icon = props.loadingIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $bRIbs.SpinnerIcon), $a041ef77ba2f8bcd$var$_extends({}, loadingIconProps, {
            spin: true
        }));
        var loadingIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $a041ef77ba2f8bcd$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        if (!props.loaderDisabled && props.showLoader && loadingState) {
            var _className = (0, $7nrKB.classNames)("p-virtualscroller-loader", {
                "p-component-overlay": !props.loadingTemplate
            });
            var _content = loadingIcon;
            if (props.loadingTemplate) _content = loaderArrState.map(function(_, index) {
                return createLoaderItem(index, both && {
                    numCols: numItemsInViewportState.cols
                });
            });
            else if (props.loaderIconTemplate) {
                var defaultContentOptions = {
                    iconClassName: iconClassName,
                    element: _content,
                    props: props
                };
                _content = (0, $7nrKB.ObjectUtils).getJSXElement(props.loaderIconTemplate, defaultContentOptions);
            }
            var loaderProps = mergeProps({
                className: _className
            }, ptm("loader"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", loaderProps, _content);
        }
        return null;
    };
    var createSpacer = function createSpacer() {
        if (props.showSpacer) {
            var spacerProps = mergeProps({
                ref: _spacerRef,
                style: spacerStyle.current,
                className: "p-virtualscroller-spacer"
            }, ptm("spacer"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", spacerProps);
        }
        return null;
    };
    var createItem = function createItem(item, index) {
        var options = getOptions(index);
        var content = (0, $7nrKB.ObjectUtils).getJSXElement(props.itemTemplate, item, options);
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, {
            key: options.index
        }, content);
    };
    var createItems = function createItems() {
        var items = loadedItems();
        return items.map(createItem);
    };
    var createContent = function createContent() {
        var items = createItems();
        var className = (0, $7nrKB.classNames)("p-virtualscroller-content", {
            "p-virtualscroller-loading": loadingState
        });
        var contentProps = mergeProps({
            ref: _contentRef,
            style: contentStyle.current,
            className: className
        }, ptm("content"));
        var content = /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, items);
        if (props.contentTemplate) {
            var defaultOptions = {
                style: contentStyle.current,
                className: className,
                spacerStyle: spacerStyle.current,
                contentRef: function contentRef(el) {
                    return _contentRef.current = (0, $7nrKB.ObjectUtils).getRefElement(el);
                },
                spacerRef: function spacerRef(el) {
                    return _spacerRef.current = (0, $7nrKB.ObjectUtils).getRefElement(el);
                },
                stickyRef: function stickyRef(el) {
                    return _stickyRef.current = (0, $7nrKB.ObjectUtils).getRefElement(el);
                },
                items: loadedItems(),
                getItemOptions: function getItemOptions(index) {
                    return getOptions(index);
                },
                children: items,
                element: content,
                props: props,
                loading: loadingState,
                getLoaderOptions: function getLoaderOptions(index, ext) {
                    return loaderOptions(index, ext);
                },
                loadingTemplate: props.loadingTemplate,
                itemSize: props.itemSize,
                rows: getRows(),
                columns: getColumns(),
                vertical: vertical,
                horizontal: horizontal,
                both: both
            };
            return (0, $7nrKB.ObjectUtils).getJSXElement(props.contentTemplate, defaultOptions);
        }
        return content;
    };
    if (props.disabled) {
        var _content2 = (0, $7nrKB.ObjectUtils).getJSXElement(props.contentTemplate, {
            items: props.items,
            rows: props.items,
            columns: props.columns
        });
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, props.children, _content2);
    }
    var className = (0, $7nrKB.classNames)("p-virtualscroller", {
        "p-virtualscroller-inline": props.inline,
        "p-virtualscroller-both p-both-scroll": both,
        "p-virtualscroller-horizontal p-horizontal-scroll": horizontal
    }, props.className);
    var loader = createLoader();
    var content = createContent();
    var spacer = createSpacer();
    var rootProps = mergeProps({
        ref: elementRef,
        className: className,
        tabIndex: props.tabIndex,
        style: props.style,
        onScroll: function onScroll(e) {
            return _onScroll(e);
        }
    }, $a041ef77ba2f8bcd$var$VirtualScrollerBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, content, spacer, loader);
}));
$a041ef77ba2f8bcd$export$fbd4ea7fe0fb889.displayName = "VirtualScroller";

});


parcelRegister("dE8RX", function(module, exports) {

$parcel$export(module.exports, "Message", function () { return $9ef5e407812f7300$export$f69c19e57285b83a; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $eXeTx = parcelRequire("eXeTx");

var $dgIaN = parcelRequire("dgIaN");

var $8Murc = parcelRequire("8Murc");

var $f6Dhj = parcelRequire("f6Dhj");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $9ef5e407812f7300$var$_extends() {
    return $9ef5e407812f7300$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9ef5e407812f7300$var$_extends.apply(null, arguments);
}
function $9ef5e407812f7300$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ef5e407812f7300$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ef5e407812f7300$var$_typeof(o);
}
function $9ef5e407812f7300$var$toPrimitive(t, r) {
    if ("object" != $9ef5e407812f7300$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ef5e407812f7300$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9ef5e407812f7300$var$toPropertyKey(t) {
    var i = $9ef5e407812f7300$var$toPrimitive(t, "string");
    return "symbol" == $9ef5e407812f7300$var$_typeof(i) ? i : i + "";
}
function $9ef5e407812f7300$var$_defineProperty(e, r, t) {
    return (r = $9ef5e407812f7300$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $9ef5e407812f7300$var$MessageBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Message",
        id: null,
        className: null,
        style: null,
        text: null,
        icon: null,
        severity: "info",
        content: null,
        children: undefined
    },
    css: {
        classes: {
            root: function root(_ref) {
                var severity = _ref.props.severity;
                return (0, $7nrKB.classNames)("p-inline-message p-component", $9ef5e407812f7300$var$_defineProperty({}, "p-inline-message-".concat(severity), severity));
            },
            icon: "p-inline-message-icon",
            text: "p-inline-message-text"
        },
        styles: "\n        @layer primereact {\n            .p-inline-message {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                vertical-align: top;\n            }\n\n            .p-inline-message-icon {\n                flex-shrink: 0;\n            }\n            \n            .p-inline-message-icon-only .p-inline-message-text {\n                visibility: hidden;\n                width: 0;\n            }\n            \n            .p-fluid .p-inline-message {\n                display: flex;\n            }        \n        }\n        "
    }
});
function $9ef5e407812f7300$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ef5e407812f7300$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ef5e407812f7300$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ef5e407812f7300$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ef5e407812f7300$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ef5e407812f7300$export$f69c19e57285b83a = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $9ef5e407812f7300$var$MessageBase.getProps(inProps, context);
    var elementRef = $7E7Dk.useRef(null);
    var _MessageBase$setMetaD = $9ef5e407812f7300$var$MessageBase.setMetaData({
        props: props
    }), ptm = _MessageBase$setMetaD.ptm, cx = _MessageBase$setMetaD.cx, isUnstyled = _MessageBase$setMetaD.isUnstyled;
    (0, $kHEnT.useHandleStyle)($9ef5e407812f7300$var$MessageBase.css.styles, isUnstyled, {
        name: "message"
    });
    var createContent = function createContent() {
        if (props.content) return (0, $7nrKB.ObjectUtils).getJSXElement(props.content, props);
        var text = (0, $7nrKB.ObjectUtils).getJSXElement(props.text, props);
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var icon = props.icon;
        if (!icon) switch(props.severity){
            case "info":
                icon = /*#__PURE__*/ $7E7Dk.createElement((0, $8Murc.InfoCircleIcon), iconProps);
                break;
            case "warn":
                icon = /*#__PURE__*/ $7E7Dk.createElement((0, $dgIaN.ExclamationTriangleIcon), iconProps);
                break;
            case "error":
                icon = /*#__PURE__*/ $7E7Dk.createElement((0, $f6Dhj.TimesCircleIcon), iconProps);
                break;
            case "success":
                icon = /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), iconProps);
                break;
        }
        var messageIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $9ef5e407812f7300$var$_objectSpread({}, iconProps), {
            props: props
        });
        var textProps = mergeProps({
            className: cx("text")
        }, ptm("text"));
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, messageIcon, /*#__PURE__*/ $7E7Dk.createElement("span", textProps, text));
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var content = createContent();
    var rootProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("root")),
        style: props.style,
        role: "alert",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, $9ef5e407812f7300$var$MessageBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", $9ef5e407812f7300$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), content);
}));
$9ef5e407812f7300$export$f69c19e57285b83a.displayName = "Message";

});

parcelRegister("9w3V4", function(module, exports) {
$parcel$export(module.exports, "FieldInfoButton", function () { return (parcelRequire("QrRvA")).FieldInfoButton; });
parcelRequire("QrRvA");

});
parcelRegister("QrRvA", function(module, exports) {

$parcel$export(module.exports, "FieldInfoButton", function () { return $66ede2875ae71887$export$b3112576d17c3c5; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5L4Lm = parcelRequire("5L4Lm");
const $66ede2875ae71887$export$b3112576d17c3c5 = ({ ariaLabel: ariaLabel, text: text, testId: testId = "field-info-button" })=>{
    const overlayPanelRef = (0, $7E7Dk.useRef)(null);
    const [isOpen, setIsOpen] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        icon: "pi pi-info-circle",
        unstyled: true,
        className: "inline-flex align-items-center justify-content-center p-0 border-none bg-transparent text-blue-500 cursor-pointer w-2rem h-2rem",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        "data-testid": testId,
        pt: {
            icon: {
                className: "text-xl"
            },
            label: {
                className: "hidden"
            }
        },
        onClick: (event)=>{
            setIsOpen((open)=>!open);
            overlayPanelRef.current?.toggle(event);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5L4Lm.OverlayPanel), {
        ref: overlayPanelRef,
        closeOnEscape: true,
        className: "max-w-20rem",
        "data-testid": `${testId}-overlay`,
        onHide: ()=>setIsOpen(false),
        onShow: ()=>setIsOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "block px-3 py-2 line-height-3"
    }, text)));
};

});
parcelRegister("5L4Lm", function(module, exports) {

$parcel$export(module.exports, "OverlayPanel", function () { return $4315095691d46c6d$export$500eae29f537c78b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $2v3zC = parcelRequire("2v3zC");

var $hB9Eg = parcelRequire("hB9Eg");

var $ingJg = parcelRequire("ingJg");

var $1PxL0 = parcelRequire("1PxL0");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $4315095691d46c6d$var$_extends() {
    return $4315095691d46c6d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4315095691d46c6d$var$_extends.apply(null, arguments);
}
function $4315095691d46c6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4315095691d46c6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4315095691d46c6d$var$_typeof(o);
}
function $4315095691d46c6d$var$toPrimitive(t, r) {
    if ("object" != $4315095691d46c6d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4315095691d46c6d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4315095691d46c6d$var$toPropertyKey(t) {
    var i = $4315095691d46c6d$var$toPrimitive(t, "string");
    return "symbol" == $4315095691d46c6d$var$_typeof(i) ? i : i + "";
}
function $4315095691d46c6d$var$_defineProperty(e, r, t) {
    return (r = $4315095691d46c6d$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4315095691d46c6d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4315095691d46c6d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4315095691d46c6d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4315095691d46c6d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4315095691d46c6d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4315095691d46c6d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4315095691d46c6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4315095691d46c6d$var$_slicedToArray(r, e) {
    return $4315095691d46c6d$var$_arrayWithHoles(r) || $4315095691d46c6d$var$_iterableToArrayLimit(r, e) || $4315095691d46c6d$var$_unsupportedIterableToArray(r, e) || $4315095691d46c6d$var$_nonIterableRest();
}
var $4315095691d46c6d$var$classes = {
    root: function root(_ref) {
        _ref.props;
        var context = _ref.context;
        return (0, $7nrKB.classNames)("p-overlaypanel p-component", {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    closeIcon: "p-overlaypanel-close-icon",
    closeButton: "p-overlaypanel-close p-link",
    content: "p-overlaypanel-content",
    transition: "p-overlaypanel"
};
var $4315095691d46c6d$var$styles = '\n@layer primereact {\n    .p-overlaypanel {\n        position: absolute;\n        margin-top: 10px;\n        /* Github #3122: Prevent animation flickering  */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-overlaypanel-flipped {\n        margin-top: -10px;\n        margin-bottom: 10px;\n    }\n    \n    .p-overlaypanel-close {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    /* Animation */\n    .p-overlaypanel-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n    \n    .p-overlaypanel-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n    \n    .p-overlaypanel-enter-done {\n        transform: none;\n    }\n    \n    .p-overlaypanel-exit {\n        opacity: 1;\n    }\n    \n    .p-overlaypanel-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n    \n    .p-overlaypanel:after, .p-overlaypanel:before {\n        bottom: 100%;\n        left: calc(var(--overlayArrowLeft, 0) + 1.25rem);\n        content: " ";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n    \n    .p-overlaypanel:after {\n        border-width: 8px;\n        margin-left: -8px;\n    }\n    \n    .p-overlaypanel:before {\n        border-width: 10px;\n        margin-left: -10px;\n    }\n    \n    .p-overlaypanel-flipped:after, .p-overlaypanel-flipped:before {\n        bottom: auto;\n        top: 100%;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:after {\n        border-bottom-color: transparent;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:before {\n        border-bottom-color: transparent\n    }\n}\n';
var $4315095691d46c6d$var$OverlayPanelBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "OverlayPanel",
        id: null,
        dismissable: true,
        showCloseIcon: false,
        closeIcon: null,
        style: null,
        className: null,
        appendTo: null,
        breakpoints: null,
        ariaCloseLabel: null,
        transitionOptions: null,
        onShow: null,
        onHide: null,
        children: undefined,
        closeOnEscape: true
    },
    css: {
        classes: $4315095691d46c6d$var$classes,
        styles: $4315095691d46c6d$var$styles
    }
});
function $4315095691d46c6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4315095691d46c6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4315095691d46c6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4315095691d46c6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4315095691d46c6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4315095691d46c6d$export$500eae29f537c78b = /*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $4315095691d46c6d$var$OverlayPanelBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $4315095691d46c6d$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _OverlayPanelBase$set = $4315095691d46c6d$var$OverlayPanelBase.setMetaData({
        props: props,
        state: {
            visible: visibleState
        }
    }), ptm = _OverlayPanelBase$set.ptm, cx = _OverlayPanelBase$set.cx;
    _OverlayPanelBase$set.sx;
    var isUnstyled = _OverlayPanelBase$set.isUnstyled;
    (0, $kHEnT.useHandleStyle)($4315095691d46c6d$var$OverlayPanelBase.css.styles, isUnstyled, {
        name: "overlaypanel"
    });
    var attributeSelector = $7E7Dk.useRef("");
    var overlayRef = $7E7Dk.useRef(null);
    var currentTargetRef = $7E7Dk.useRef(null);
    var isPanelClicked = $7E7Dk.useRef(false);
    var styleElement = $7E7Dk.useRef(null);
    var overlayEventListener = $7E7Dk.useRef(null);
    var _useOverlayListener = (0, $jr5t3.useOverlayListener)({
        target: currentTargetRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) {
                if (type === "outside") {
                    if (props.dismissable && !isPanelClicked.current) hide();
                    isPanelClicked.current = false;
                } else if (context.hideOverlaysOnDocumentScrolling) hide();
                else if (!(0, $7nrKB.DomHandler).isDocument(event.target)) align();
            }
        },
        when: visibleState
    }), _useOverlayListener2 = $4315095691d46c6d$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var isCloseOnEscape = visibleState && props.closeOnEscape;
    var overlayPanelDisplayOrder = (0, $jr5t3.useDisplayOrder)("overlay-panel", isCloseOnEscape);
    (0, $jr5t3.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: isCloseOnEscape && overlayPanelDisplayOrder,
        priority: [
            (0, $jr5t3.ESC_KEY_HANDLING_PRIORITIES).OVERLAY_PANEL,
            overlayPanelDisplayOrder
        ]
    });
    var isOutsideClicked = function isOutsideClicked(target) {
        return overlayRef && overlayRef.current && !(overlayRef.current.isSameNode(target) || overlayRef.current.contains(target));
    };
    var hasTargetChanged = function hasTargetChanged(event, target) {
        return currentTargetRef.current != null && currentTargetRef.current !== (target || event.currentTarget || event.target);
    };
    var onCloseClick = function onCloseClick(event) {
        hide();
        event.preventDefault();
    };
    var onPanelClick = function onPanelClick(event) {
        isPanelClicked.current = true;
        (0, $hB9Eg.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: currentTargetRef.current
        });
    };
    var onContentClick = function onContentClick() {
        isPanelClicked.current = true;
    };
    var toggle = function toggle(event, target) {
        if (visibleState) {
            hide();
            if (hasTargetChanged(event, target)) {
                currentTargetRef.current = target || event.currentTarget || event.target;
                setTimeout(function() {
                    show(event, currentTargetRef.current);
                }, 200);
            }
        } else show(event, target);
    };
    var show = function show(event, target) {
        currentTargetRef.current = target || event.currentTarget || event.target;
        if (visibleState) align();
        else {
            setVisibleState(true);
            overlayEventListener.current = function(e) {
                !isOutsideClicked(e.target) && (isPanelClicked.current = true);
            };
            (0, $hB9Eg.OverlayService).on("overlay-click", overlayEventListener.current);
        }
    };
    var hide = function hide() {
        setVisibleState(false);
        (0, $hB9Eg.OverlayService).off("overlay-click", overlayEventListener.current);
        overlayEventListener.current = null;
    };
    var onEnter = function onEnter() {
        overlayRef.current.setAttribute(attributeSelector.current, "");
        (0, $7nrKB.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, context && context.zIndex.overlay || (0, $eHYdO.default).zIndex.overlay);
        (0, $7nrKB.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        align();
    };
    var onEntered = function onEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onExit = function onExit() {
        unbindOverlayListener();
    };
    var onExited = function onExited() {
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var align = function align() {
        if (currentTargetRef.current && overlayRef.current) {
            (0, $7nrKB.DomHandler).absolutePosition(overlayRef.current, currentTargetRef.current);
            var containerOffset = (0, $7nrKB.DomHandler).getOffset(overlayRef.current);
            var targetOffset = (0, $7nrKB.DomHandler).getOffset(currentTargetRef.current);
            var arrowLeft = 0;
            if (containerOffset.left < targetOffset.left) arrowLeft = targetOffset.left - containerOffset.left;
            overlayRef.current.style.setProperty("--overlayArrowLeft", "".concat(arrowLeft, "px"));
            if (containerOffset.top < targetOffset.top) {
                overlayRef.current.setAttribute("data-p-overlaypanel-flipped", "true");
                isUnstyled && (0, $7nrKB.DomHandler).addClass(overlayRef.current, "p-overlaypanel-flipped");
            } else {
                overlayRef.current.setAttribute("data-p-overlaypanel-flipped", "false");
                isUnstyled && (0, $7nrKB.DomHandler).removeClass(overlayRef.current, "p-overlaypanel-flipped");
            }
        }
    };
    var createStyle = function createStyle() {
        if (!styleElement.current) {
            styleElement.current = (0, $7nrKB.DomHandler).createInlineStyle(context && context.nonce || (0, $eHYdO.default).nonce, context && context.styleContainer);
            var innerHTML = "";
            for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                    @media screen and (max-width: ".concat(breakpoint, ") {\n                        .p-overlaypanel[").concat(attributeSelector.current, "] {\n                            width: ").concat(props.breakpoints[breakpoint], ";\n                        }\n                    }\n                ");
            styleElement.current.innerHTML = innerHTML;
        }
    };
    (0, $jr5t3.useMountEffect)(function() {
        attributeSelector.current = (0, $7nrKB.UniqueComponentId)();
        if (props.breakpoints) createStyle();
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        styleElement.current = (0, $7nrKB.DomHandler).removeInlineStyle(styleElement.current);
        if (overlayEventListener.current) {
            (0, $hB9Eg.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        }
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            align: align,
            isVisible: function isVisible() {
                return visibleState;
            },
            getElement: function getElement() {
                return overlayRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        var closeIconProps = mergeProps({
            className: cx("closeIcon"),
            "aria-hidden": true
        }, ptm("closeIcon"));
        var icon = props.closeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), closeIconProps);
        var closeIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $4315095691d46c6d$var$_objectSpread({}, closeIconProps), {
            props: props
        });
        var closeButtonProps = mergeProps({
            type: "button",
            className: cx("closeButton"),
            onClick: function onClick(e) {
                return onCloseClick(e);
            },
            "aria-label": props.ariaCloseLabel || (0, $eHYdO.ariaLabel)("close")
        }, ptm("closeButton"));
        if (props.showCloseIcon) return /*#__PURE__*/ $7E7Dk.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
        return null;
    };
    var createElement = function createElement() {
        var closeIcon = createCloseIcon();
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $7nrKB.classNames)(props.className, cx("root", {
                context: context
            })),
            style: props.style,
            onClick: function onClick(e) {
                return onPanelClick(e);
            }
        }, $4315095691d46c6d$var$OverlayPanelBase.getOtherProps(props), ptm("root"));
        var contentProps = mergeProps({
            className: cx("content"),
            onClick: function onClick(e) {
                return onContentClick();
            },
            onMouseDown: onContentClick
        }, $4315095691d46c6d$var$OverlayPanelBase.getOtherProps(props), ptm("content"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": visibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm("transition"));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $4315095691d46c6d$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", $4315095691d46c6d$var$_extends({
            ref: overlayRef
        }, rootProps), /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, props.children), closeIcon));
    };
    var element = createElement();
    return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    });
});
$4315095691d46c6d$export$500eae29f537c78b.displayName = "OverlayPanel";

});







parcelRegister("b10kV", function(module, exports) {

$parcel$export(module.exports, "isEuMember", function () { return $5e1ea971ddba8f3a$export$c2391e90246c6f8b; });
$parcel$export(module.exports, "getFailureReasonFromError", function () { return $5e1ea971ddba8f3a$export$120f5b653822e59b; });
$parcel$export(module.exports, "SWEDISH_VAT", function () { return $5e1ea971ddba8f3a$export$a018aca56259b691; });
$parcel$export(module.exports, "SWEDISH_CURRENCY", function () { return $5e1ea971ddba8f3a$export$e92eecadf76d04dd; });
$parcel$export(module.exports, "formatToCurrencyString", function () { return $5e1ea971ddba8f3a$export$aa47c8fd6d236220; });
$parcel$export(module.exports, "convertPriceStringToNumber", function () { return $5e1ea971ddba8f3a$export$bcda6b9150ac9fea; });
$parcel$export(module.exports, "getFirmwareVersion", function () { return $5e1ea971ddba8f3a$export$2f3a6ae1f24d7121; });
$parcel$export(module.exports, "compareSemanticVersions", function () { return $5e1ea971ddba8f3a$export$4a0e13c777139e12; });
$parcel$export(module.exports, "earthingSystemReadOnly", function () { return $5e1ea971ddba8f3a$export$27a8af12c6b3ae6; });
$parcel$export(module.exports, "pad", function () { return $5e1ea971ddba8f3a$export$5d04458e2a6c373e; });

var $auuMO = parcelRequire("auuMO");
parcelRequire("erUAr");
var $bV30D = parcelRequire("bV30D");

var $aAxde = parcelRequire("aAxde");
function $5e1ea971ddba8f3a$export$dfdc1655ccc5b9cb(obj, capitalize) {
    const str = [];
    if (!obj || typeof obj !== "object") return "";
    const record = obj;
    for(const p in record)if (Object.prototype.hasOwnProperty.call(record, p) && typeof record[p] !== "undefined") {
        let p1 = p;
        if (capitalize) p1 = p.charAt(0).toUpperCase() + p.slice(1);
        str.push(encodeURIComponent(p1) + "=" + encodeURIComponent(String(record[p])));
    }
    return str.join("&");
}
function $5e1ea971ddba8f3a$export$9a00dee1beb8f576(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
const $5e1ea971ddba8f3a$export$c2391e90246c6f8b = (countryISO2)=>{
    const EUISO2List = [
        "AT",
        "BE",
        "BG",
        "HR",
        "CY",
        "CZ",
        "DK",
        "EE",
        "FI",
        "FR",
        "DE",
        "GR",
        "HU",
        "IE",
        "IT",
        "LV",
        "LT",
        "LU",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SK",
        "SI",
        "ES",
        "SE"
    ];
    return EUISO2List.includes(countryISO2);
};
const $5e1ea971ddba8f3a$export$120f5b653822e59b = (err)=>{
    const status = err?.status;
    if (status === 400) return "bad_request";
    if (status === 500) return "server_error";
    if (status === "FETCH_ERROR") return "network_error";
    return "unknown";
};
const $5e1ea971ddba8f3a$export$a018aca56259b691 = 1.25;
const $5e1ea971ddba8f3a$export$81d60b023ed0b8b6 = "SE";
const $5e1ea971ddba8f3a$export$e92eecadf76d04dd = "SEK";
const $5e1ea971ddba8f3a$export$b29a7941421e73c9 = "SV";
const $5e1ea971ddba8f3a$export$aa47c8fd6d236220 = (currency, value, locale = "sv-SE")=>{
    const normalizedCurrency = currency?.trim() ? currency.trim() : "SEK";
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: normalizedCurrency,
        currencyDisplay: "narrowSymbol",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
    return formatter.format(value);
};
const $5e1ea971ddba8f3a$export$bcda6b9150ac9fea = (price)=>{
    return Number((price ?? "0").replace(",", ".")) || 0;
};
const $5e1ea971ddba8f3a$export$2f3a6ae1f24d7121 = (configKeys)=>{
    const firmwareVersionConfig = (0, $auuMO.default)("FirmwareVersion", configKeys);
    const fwVersionKey = firmwareVersionConfig?.match((0, $aAxde.default));
    const fwVersion = fwVersionKey ? fwVersionKey[0] : firmwareVersionConfig ?? "0";
    const versionNumber = fwVersion.slice(0, 5);
    return versionNumber;
};
const $5e1ea971ddba8f3a$export$4a0e13c777139e12 = (version1, version2)=>{
    if (version1 && version2) {
        const v1Components = version1?.toString().split(".").map(Number);
        const v2Components = version2?.toString().split(".").map(Number);
        // Handle cases where version1 or version2 are undefined or empty
        if (!v1Components || !v2Components) return false;
        // Make the version arrays the same length by padding with zeros
        while(v1Components.length < v2Components.length)v1Components.push(0);
        while(v2Components.length < v1Components.length)v2Components.push(0);
        // Compare each component of the version numbers
        for(let i = 0; i < Math.max(v1Components.length, v2Components.length); i++){
            if (v1Components[i] > v2Components[i]) return true;
            else if (v1Components[i] < v2Components[i]) return false;
        // If they are equal, continue to the next component
        }
    }
    // If all components are equal, return false
    return false;
};
const $5e1ea971ddba8f3a$export$27a8af12c6b3ae6 = (configKeys)=>{
    return (0, $bV30D.isConfigReadonly)("EarthingSystem", configKeys);
};
const $5e1ea971ddba8f3a$export$5d04458e2a6c373e = (toPad, isReverse)=>{
    let retVal;
    let toAdd;
    if (toPad.length <= 8) toAdd = 8 - toPad.length;
    else if (toPad.length <= 14) toAdd = 14 - toPad.length;
    else if (toPad.length <= 20) toAdd = 20 - toPad.length;
    else toAdd = toPad.length % 2;
    if (isReverse) retVal = toPad + "0".repeat(toAdd);
    else retVal = "0".repeat(toAdd) + toPad;
    return retVal;
};
const $5e1ea971ddba8f3a$export$2d83c160d19b8d50 = (hex)=>{
    const match = hex.match(/[a-fA-F0-9]{2}/g);
    if (match === null) return "";
    return match.reverse().join("");
};

});
parcelRegister("erUAr", function(module, exports) {
$parcel$export(module.exports, "isConfigReadonly", function () { return (parcelRequire("bV30D")).isConfigReadonly; });
parcelRequire("bV30D");

});
parcelRegister("bV30D", function(module, exports) {

$parcel$export(module.exports, "isConfigReadonly", function () { return $89c9a1b59b3d4471$export$3df49480585b7271; });
function $89c9a1b59b3d4471$export$3df49480585b7271(key, configKeys) {
    const config = configKeys?.find((x)=>x.key === key);
    if (!config || config.readonly) return true;
    return false;
}

});


parcelRegister("aAxde", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27a9a660f69e18d$export$2e2bcd8739ae039; });
const $a27a9a660f69e18d$var$SEMANTIC_VERSIONING_REGEX = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
var $a27a9a660f69e18d$export$2e2bcd8739ae039 = $a27a9a660f69e18d$var$SEMANTIC_VERSIONING_REGEX;

});


parcelRegister("4LjKQ", function(module, exports) {

$parcel$export(module.exports, "isChargingConnector", function () { return $0e922b4bf6318677$export$6e157f7db77b95c6; });
$parcel$export(module.exports, "isChargingConnectorImport", function () { return $0e922b4bf6318677$export$cb1d42aaa3be4371; });
$parcel$export(module.exports, "default", function () { return $0e922b4bf6318677$export$2e2bcd8739ae039; });
const $0e922b4bf6318677$var$findChargingConnector = (connectors)=>connectors?.find($0e922b4bf6318677$export$6e157f7db77b95c6);
const $0e922b4bf6318677$export$6e157f7db77b95c6 = (connector)=>connector?.connectorFunctionType === "Charger";
const $0e922b4bf6318677$export$cb1d42aaa3be4371 = (connector)=>{
    return connector?.name === "Charger" || connector?.name === "Left connector" || connector?.name === "Right connector" || connector?.name === "Left socket" || connector?.name === "Right socket" || connector?.name === "Socket";
};
var $0e922b4bf6318677$export$2e2bcd8739ae039 = $0e922b4bf6318677$var$findChargingConnector;

});

parcelRegister("2fUds", function(module, exports) {
$parcel$export(module.exports, "RemoteControlWidget", function () { return (parcelRequire("8KPaL")).RemoteControlWidget; });
parcelRequire("8KPaL");

});
parcelRegister("8KPaL", function(module, exports) {

$parcel$export(module.exports, "RemoteControlWidget", function () { return $b4c3bcf34d6cc1c4$export$af29ee412c78ceec; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $bKDGD = parcelRequire("bKDGD");

var $1ot1u = parcelRequire("1ot1u");

var $c9GjL = parcelRequire("c9GjL");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $eIymc = parcelRequire("eIymc");
parcelRequire("hWELq");
var $6QMPc = parcelRequire("6QMPc");

var $34PLY = parcelRequire("34PLY");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
const $b4c3bcf34d6cc1c4$var$SGreenChargingIconWrapper = (0, $gRonV.default).span`
    padding-left: 8px;
    align-self: center;
`;
function $b4c3bcf34d6cc1c4$export$af29ee412c78ceec({ children: children, greenChargingStatus: greenChargingStatus, isReadOnly: isReadOnly, chargePoint: chargePoint, showNameInTitle: showNameInTitle = (0, $eIymc.isUserappDomain) }) {
    const text = (0, $5u6k9.default)();
    const [updateChargePoint, { isLoading: chargePointUpdating }] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const toast = (0, $eBlmY.useToast)();
    const isChargerOnline = (0, $7E7Dk.useMemo)(()=>{
        return (0, $34PLY.default)(chargePoint);
    }, [
        chargePoint
    ]);
    const [startChargePointReboot] = (0, $1O9Jh.useChargePointRebootMutation)();
    const startReboot = async ()=>{
        try {
            await startChargePointReboot({
                chargePointId: chargePoint.id
            }).unwrap().then(()=>{
                toast.notifySuccess(text("msgRebootRequestAlert"));
            });
        } catch (error) {
            toast.notifyError(text("msgRebootRequestFail"));
        }
    };
    const startTest = async ()=>{
        try {
            await updateChargePoint({
                chargePoint: {
                    ...chargePoint,
                    startTest: true
                }
            }).unwrap().then(()=>{
                toast.notifySuccess(text("msgStartTestSuccess"));
            });
        } catch (error) {
            toast.notifyError(text("msgStartTestFail"));
        }
    };
    const rebootChargerConfirmation = ()=>{
        (0, $c9GjL.confirmDialog)({
            message: text("msgRebootChargerConfirm"),
            header: text("msgRebootingCharger"),
            icon: "pi pi-info-circle",
            defaultFocus: "accept",
            accept: ()=>startReboot()
        });
    };
    const testChargerConfirmation = ()=>{
        (0, $c9GjL.confirmDialog)({
            message: text("msgStartTestConfirm"),
            header: text("lblStartTestTitle"),
            icon: "pi pi-info-circle",
            defaultFocus: "accept",
            accept: ()=>startTest()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bKDGD.Panel), {
        "data-testid": "remote-control",
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "flex align-items-center gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, showNameInTitle ? chargePoint.name : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRemoteControlPage"
        })), greenChargingStatus?.greenChargingOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($b4c3bcf34d6cc1c4$var$SGreenChargingIconWrapper, {
            "data-testid": "greenCharging"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6QMPc.GreenChargingIcon), {
            size: 21,
            color: isChargerOnline ? "#006C5C" : "#808080"
        }))),
        toggleable: true,
        style: chargePoint?.isOcpp && (!isChargerOnline || chargePoint?.ocppEnabled) ? {
            opacity: "50%"
        } : {}
    }, chargePoint ? children : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, (0, $eIymc.isSupportDomain) && isChargerOnline && !chargePoint.isOcpp && chargePoint.productId && chargePoint.productId > 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnTest"),
        disabled: chargePoint.startTest,
        onClick: testChargerConfirmation,
        loading: chargePoint.startTest,
        "data-testid": "test-btn"
    }), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        disabled: !isChargerOnline || chargePoint.reboot || chargePointUpdating || chargePoint?.isOcpp && chargePoint?.ocppEnabled,
        className: "mt-3",
        onClick: rebootChargerConfirmation,
        label: text("btnReboot"),
        loading: !chargePoint.isOcpp && chargePoint.reboot,
        "data-testid": "reboot-btn"
    })));
}

});
parcelRegister("bKDGD", function(module, exports) {

$parcel$export(module.exports, "Panel", function () { return $88e2c681e577124f$export$2ddb90ad54e5f587; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $9R5U5 = parcelRequire("9R5U5");

var $lLGzy = parcelRequire("lLGzy");

var $1PxL0 = parcelRequire("1PxL0");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $88e2c681e577124f$var$_extends() {
    return $88e2c681e577124f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88e2c681e577124f$var$_extends.apply(null, arguments);
}
function $88e2c681e577124f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $88e2c681e577124f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $88e2c681e577124f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $88e2c681e577124f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $88e2c681e577124f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $88e2c681e577124f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $88e2c681e577124f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88e2c681e577124f$var$_slicedToArray(r, e) {
    return $88e2c681e577124f$var$_arrayWithHoles(r) || $88e2c681e577124f$var$_iterableToArrayLimit(r, e) || $88e2c681e577124f$var$_unsupportedIterableToArray(r, e) || $88e2c681e577124f$var$_nonIterableRest();
}
var $88e2c681e577124f$var$PanelBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Panel",
        id: null,
        header: null,
        headerTemplate: null,
        footer: null,
        footerTemplate: null,
        toggleable: null,
        style: null,
        className: null,
        collapsed: null,
        expandIcon: null,
        collapseIcon: null,
        icons: null,
        transitionOptions: null,
        onExpand: null,
        onCollapse: null,
        onToggle: null,
        children: undefined
    },
    css: {
        classes: {
            root: function root(_ref) {
                var props = _ref.props;
                return (0, $7nrKB.classNames)("p-panel p-component", {
                    "p-panel-toggleable": props.toggleable
                });
            },
            header: "p-panel-header",
            title: "p-panel-title",
            icons: "p-panel-icons",
            toggler: "p-panel-header-icon p-panel-toggler p-link",
            togglerIcon: "p-panel-header-icon p-panel-toggler p-link",
            toggleableContent: "p-toggleable-content",
            content: "p-panel-content",
            footer: "p-panel-footer",
            transition: "p-toggleable-content"
        },
        styles: "\n        @layer primereact {\n            .p-panel-header {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n            }\n            \n            .p-panel-title {\n              line-height: 1;\n            }\n            \n            .p-panel-header-icon {\n              display: inline-flex;\n              justify-content: center;\n              align-items: center;\n              cursor: pointer;\n              text-decoration: none;\n              overflow: hidden;\n              position: relative;\n            }\n        }\n        "
    }
});
var $88e2c681e577124f$export$2ddb90ad54e5f587 = /*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $88e2c681e577124f$var$PanelBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(props.id), _React$useState2 = $88e2c681e577124f$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(props.collapsed), _React$useState4 = $88e2c681e577124f$var$_slicedToArray(_React$useState3, 2), collapsedState = _React$useState4[0], setCollapsedState = _React$useState4[1];
    var elementRef = $7E7Dk.useRef(null);
    var contentRef = $7E7Dk.useRef(null);
    var collapsed = props.toggleable ? props.onToggle ? props.collapsed : collapsedState : false;
    var headerId = idState + "_header";
    var contentId = idState + "_content";
    var _PanelBase$setMetaDat = $88e2c681e577124f$var$PanelBase.setMetaData({
        props: props,
        state: {
            id: idState,
            collapsed: collapsed
        }
    }), ptm = _PanelBase$setMetaDat.ptm, cx = _PanelBase$setMetaDat.cx, isUnstyled = _PanelBase$setMetaDat.isUnstyled;
    (0, $kHEnT.useHandleStyle)($88e2c681e577124f$var$PanelBase.css.styles, isUnstyled, {
        name: "panel"
    });
    var toggle = function toggle(event) {
        if (!props.toggleable) return;
        collapsed ? expand(event) : collapse(event);
        if (event) {
            if (props.onToggle) props.onToggle({
                originalEvent: event,
                value: !collapsed
            });
            event.preventDefault();
        }
    };
    var expand = function expand(event) {
        if (!props.onToggle) setCollapsedState(false);
        props.onExpand && event && props.onExpand(event);
    };
    var collapse = function collapse(event) {
        if (!props.onToggle) setCollapsedState(true);
        props.onCollapse && event && props.onCollapse(event);
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            expand: expand,
            collapse: collapse,
            getElement: function getElement() {
                return elementRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            }
        };
    });
    (0, $jr5t3.useMountEffect)(function() {
        if (!idState) setIdState((0, $7nrKB.UniqueComponentId)());
    });
    var createToggleIcon = function createToggleIcon() {
        if (props.toggleable) {
            var buttonId = idState + "_label";
            var togglerProps = mergeProps({
                className: cx("toggler"),
                onClick: toggle,
                id: buttonId,
                "aria-controls": contentId,
                "aria-expanded": !collapsed,
                type: "button",
                role: "button",
                "aria-label": props.header
            }, ptm("toggler"));
            var togglerIconProps = mergeProps(ptm("togglericon"));
            var icon = collapsed ? props.expandIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $lLGzy.PlusIcon), togglerIconProps) : props.collapseIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $9R5U5.MinusIcon), togglerIconProps);
            var toggleIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, togglerIconProps, {
                props: props,
                collapsed: collapsed
            });
            return /*#__PURE__*/ $7E7Dk.createElement("button", togglerProps, toggleIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        var header = (0, $7nrKB.ObjectUtils).getJSXElement(props.header, props);
        var icons = (0, $7nrKB.ObjectUtils).getJSXElement(props.icons, props);
        var togglerElement = createToggleIcon();
        var titleProps = mergeProps({
            id: headerId,
            className: cx("title")
        }, ptm("title"));
        var titleElement = /*#__PURE__*/ $7E7Dk.createElement("span", titleProps, header);
        var iconsProps = mergeProps({
            className: cx("icons")
        }, ptm("icons"));
        var iconsElement = /*#__PURE__*/ $7E7Dk.createElement("div", iconsProps, icons, togglerElement);
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        var content = /*#__PURE__*/ $7E7Dk.createElement("div", headerProps, titleElement, iconsElement);
        if (props.headerTemplate) {
            var defaultContentOptions = {
                className: "p-panel-header",
                titleClassName: "p-panel-title",
                iconsClassName: "p-panel-icons",
                togglerClassName: "p-panel-header-icon p-panel-toggler p-link",
                onTogglerClick: toggle,
                titleElement: titleElement,
                iconsElement: iconsElement,
                togglerElement: togglerElement,
                element: content,
                id: idState + "_header",
                props: props,
                collapsed: collapsed
            };
            return (0, $7nrKB.ObjectUtils).getJSXElement(props.headerTemplate, defaultContentOptions);
        } else if (props.header || props.toggleable) return content;
        return null;
    };
    var createFooter = function createFooter() {
        var footer = (0, $7nrKB.ObjectUtils).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            className: cx("footer")
        }, ptm("footer"));
        var content = /*#__PURE__*/ $7E7Dk.createElement("div", footerProps, footer);
        if (props.footerTemplate) {
            var defaultContentOptions = {
                className: cx("footer"),
                element: content,
                props: props
            };
            return (0, $7nrKB.ObjectUtils).getJSXElement(props.footerTemplate, defaultContentOptions);
        } else if (props.footer) return content;
        return null;
    };
    var createContent = function createContent() {
        var toggleableContentProps = mergeProps({
            ref: contentRef,
            className: cx("toggleableContent"),
            "aria-hidden": collapsed,
            role: "region",
            id: contentId,
            "aria-labelledby": headerId
        }, ptm("toggleablecontent"));
        var contentProps = mergeProps({
            className: cx("content")
        }, ptm("content"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            timeout: {
                enter: 1000,
                exit: 450
            },
            "in": !collapsed,
            unmountOnExit: true,
            options: props.transitionOptions
        }, ptm("transition"));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $88e2c681e577124f$var$_extends({
            nodeRef: contentRef
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", toggleableContentProps, /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, props.children)));
    };
    var rootProps = mergeProps({
        id: idState,
        ref: elementRef,
        style: props.style,
        className: (0, $7nrKB.classNames)(props.className, cx("root"))
    }, $88e2c681e577124f$var$PanelBase.getOtherProps(props), ptm("root"));
    var header = createHeader();
    var content = createContent();
    var footer = createFooter();
    return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, header, content, footer);
});
$88e2c681e577124f$export$2ddb90ad54e5f587.displayName = "Panel";

});
parcelRegister("9R5U5", function(module, exports) {

$parcel$export(module.exports, "MinusIcon", function () { return $72cda4a471dfff8e$export$cb808a3c41736d8e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $72cda4a471dfff8e$var$_extends() {
    return $72cda4a471dfff8e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $72cda4a471dfff8e$var$_extends.apply(null, arguments);
}
var $72cda4a471dfff8e$export$cb808a3c41736d8e = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $72cda4a471dfff8e$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M13.2222 7.77778H0.777778C0.571498 7.77778 0.373667 7.69584 0.227806 7.54998C0.0819442 7.40412 0 7.20629 0 7.00001C0 6.79373 0.0819442 6.5959 0.227806 6.45003C0.373667 6.30417 0.571498 6.22223 0.777778 6.22223H13.2222C13.4285 6.22223 13.6263 6.30417 13.7722 6.45003C13.9181 6.5959 14 6.79373 14 7.00001C14 7.20629 13.9181 7.40412 13.7722 7.54998C13.6263 7.69584 13.4285 7.77778 13.2222 7.77778Z",
        fill: "currentColor"
    }));
}));
$72cda4a471dfff8e$export$cb808a3c41736d8e.displayName = "MinusIcon";

});

parcelRegister("lLGzy", function(module, exports) {

$parcel$export(module.exports, "PlusIcon", function () { return $fd8f02bd56a6e158$export$f21ab0717a89c77f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $fd8f02bd56a6e158$var$_extends() {
    return $fd8f02bd56a6e158$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fd8f02bd56a6e158$var$_extends.apply(null, arguments);
}
var $fd8f02bd56a6e158$export$f21ab0717a89c77f = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $fd8f02bd56a6e158$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M7.67742 6.32258V0.677419C7.67742 0.497757 7.60605 0.325452 7.47901 0.198411C7.35197 0.0713707 7.17966 0 7 0C6.82034 0 6.64803 0.0713707 6.52099 0.198411C6.39395 0.325452 6.32258 0.497757 6.32258 0.677419V6.32258H0.677419C0.497757 6.32258 0.325452 6.39395 0.198411 6.52099C0.0713707 6.64803 0 6.82034 0 7C0 7.17966 0.0713707 7.35197 0.198411 7.47901C0.325452 7.60605 0.497757 7.67742 0.677419 7.67742H6.32258V13.3226C6.32492 13.5015 6.39704 13.6725 6.52358 13.799C6.65012 13.9255 6.82106 13.9977 7 14C7.17966 14 7.35197 13.9286 7.47901 13.8016C7.60605 13.6745 7.67742 13.5022 7.67742 13.3226V7.67742H13.3226C13.5022 7.67742 13.6745 7.60605 13.8016 7.47901C13.9286 7.35197 14 7.17966 14 7C13.9977 6.82106 13.9255 6.65012 13.799 6.52358C13.6725 6.39704 13.5015 6.32492 13.3226 6.32258H7.67742Z",
        fill: "currentColor"
    }));
}));
$fd8f02bd56a6e158$export$f21ab0717a89c77f.displayName = "PlusIcon";

});


parcelRegister("hWELq", function(module, exports) {
$parcel$export(module.exports, "GreenChargingIcon", function () { return (parcelRequire("6QMPc")).GreenChargingIcon; });
parcelRequire("6QMPc");

});
parcelRegister("6QMPc", function(module, exports) {

$parcel$export(module.exports, "GreenChargingIcon", function () { return $2435710ad7687f68$export$58b87fd25cee4912; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $2435710ad7687f68$export$58b87fd25cee4912({ className: className, style: style, size: size = 65, color: color = "#006c5c" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 81 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": `greenCharging`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#a)",
        fill: color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M36.273 43.599c-7.485 21.623-6.845 22.39-6.013 23.126l.575.544h.736c.896 0 2.111 0 24.886-30.356l1.92-2.59H44.398c4.638-20.217 3.55-20.729 2.303-21.304-1.247-.576-2.463-1.184-23.03 30.292l-1.632 2.495H32.5v-3.2H28.02c6.11-9.307 12.635-18.872 16.185-23.67-.64 4.095-2.015 10.652-3.39 16.666l-.48 1.983h11.58c-5.727 7.58-13.244 17.305-17.658 22.71 1.216-4.126 3.199-10.043 5.086-15.545l-3.07-1.151Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M39.92 76.674A37.265 37.265 0 0 1 7.933 58.056l8.093 1.92.735-3.2-13.37-3.198-3.2 13.53 3.2.736 1.95-8.093a40.463 40.463 0 0 0 34.579 20.12 40.336 40.336 0 0 0 40.304-40.304h-3.199A37.105 37.105 0 0 1 39.92 76.674ZM40.4 3.103A37.265 37.265 0 0 1 72.547 21.75l-8.093-1.92-.767 3.2 13.402 3.198 3.2-13.53-3.2-.768-1.919 8.125A40.56 40.56 0 0 0 40.4-.096 40.368 40.368 0 0 0 .096 40.208h3.199A37.137 37.137 0 0 1 40.4 3.103Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fill: "#fff",
        d: "M0 0h80.288v80H0z"
    }))));
}

});


parcelRegister("34PLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafd94058a3188d8$export$2e2bcd8739ae039; });
const $cafd94058a3188d8$var$isOnline = (chargePoint)=>chargePoint?.chargePointStatus === "Online";
var $cafd94058a3188d8$export$2e2bcd8739ae039 = $cafd94058a3188d8$var$isOnline;

});



parcelRegister("idbtm", function(module, exports) {
$parcel$export(module.exports, "RemoteOcppDimmerControl", function () { return (parcelRequire("jjP9q")).RemoteOcppDimmerControl; });
$parcel$export(module.exports, "SDimmerButton", function () { return (parcelRequire("jjP9q")).SDimmerButton; });
parcelRequire("jjP9q");

});
parcelRegister("jjP9q", function(module, exports) {

$parcel$export(module.exports, "SDimmerButton", function () { return $8547543e64d875c6$export$287922a64cf8f0d3; });
$parcel$export(module.exports, "RemoteOcppDimmerControl", function () { return $8547543e64d875c6$export$d2bfff850438d96e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $leSVD = parcelRequire("leSVD");

var $hC3GQ = parcelRequire("hC3GQ");

var $1O9Jh = parcelRequire("1O9Jh");

var $6GGmy = parcelRequire("6GGmy");

var $igvrl = parcelRequire("igvrl");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");

var $7xC39 = parcelRequire("7xC39");

var $34PLY = parcelRequire("34PLY");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
const $8547543e64d875c6$export$287922a64cf8f0d3 = (0, $gRonV.default).button`
    display: inline-block;
    border: 1px solid transparent;
    padding: 4px 15px;
    font-size: 14px;
    border-radius: 3px;
    text-transform: uppercase;
    color: #ffffff;
    background-color: ${({ isOn: isOn, theme: theme })=>isOn ? theme.font.successColor : theme.font.errorColor};
    border: none;
    border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Mid_Gray};
`;
function $8547543e64d875c6$export$d2bfff850438d96e({ chargePoint: chargePoint, isReadOnly: isReadOnly }) {
    const text = (0, $5u6k9.default)();
    const [configKeys, setConfigKeys] = (0, $7E7Dk.useState)(chargePoint?.ocppConfigKeys);
    const [dimmerValue, setDimmerValue] = (0, $7E7Dk.useState)((0, $6GGmy.getDimmerValue)(chargePoint?.ocppConfigKeys));
    const [saveConfigKey] = (0, $1O9Jh.useOcppCommandUpdateConfigKeyMutation)();
    const toast = (0, $eBlmY.useToast)();
    (0, $7E7Dk.useEffect)(()=>{
        setConfigKeys(chargePoint?.ocppConfigKeys);
    }, [
        chargePoint
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        setDimmerValue((0, $6GGmy.getDimmerValue)(configKeys));
    }, [
        configKeys
    ]);
    const getDimmerValueText = ()=>{
        if (dimmerValue === (0, $hC3GQ.OcppDimmerState).OFF) return text("lblOff");
        else if (dimmerValue === (0, $hC3GQ.OcppDimmerState).LOW) return text("lblDimmerValueLow");
        else if (dimmerValue === (0, $hC3GQ.OcppDimmerState).MEDIUM) return text("lblDimmerValueMed");
        else if (dimmerValue === (0, $hC3GQ.OcppDimmerState).HIGH) return text("lblDimmerValueHigh");
        else return text("btnDimmerValueCustom");
    };
    const changeDimmer = async ()=>{
        let newDimmerValue;
        if (+dimmerValue === +(0, $hC3GQ.OcppDimmerState).OFF) newDimmerValue = (0, $hC3GQ.OcppDimmerState).LOW;
        else if (+dimmerValue <= +(0, $hC3GQ.OcppDimmerState).LOW) newDimmerValue = (0, $hC3GQ.OcppDimmerState).MEDIUM;
        else if (+dimmerValue <= +(0, $hC3GQ.OcppDimmerState).MEDIUM) newDimmerValue = (0, $hC3GQ.OcppDimmerState).HIGH;
        else newDimmerValue = (0, $hC3GQ.OcppDimmerState).OFF;
        const updatedConfigKeys = (0, $7xC39.default)((0, $leSVD.KEY_LIGHT_INTENSITY), newDimmerValue, configKeys);
        if (!updatedConfigKeys) return;
        await saveConfigKey({
            chargePointId: chargePoint.id,
            keyValue: updatedConfigKeys.find((configKey)=>configKey.key === (0, $leSVD.KEY_LIGHT_INTENSITY))
        }).unwrap().then(()=>setConfigKeys(updatedConfigKeys)).catch(()=>toast.notifyError(text("msgRemoteControlCommandFailed")));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8547543e64d875c6$export$287922a64cf8f0d3, {
            isOn: dimmerValue !== (0, $hC3GQ.OcppDimmerState).OFF,
            onClick: changeDimmer,
            disabled: isReadOnly || !(0, $34PLY.default)(chargePoint) || chargePoint?.ocppEnabled,
            "data-testid": `dimmer-control-${chargePoint.id}`
        }, getDimmerValueText()),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblLEDBrightness"
        })
    });
}

});
parcelRegister("leSVD", function(module, exports) {

$parcel$export(module.exports, "KEY_LIGHT_INTENSITY", function () { return $66a29eea0dd37d7e$export$211a28e117932d84; });
const $66a29eea0dd37d7e$export$211a28e117932d84 = "LightIntensity";

});

parcelRegister("hC3GQ", function(module, exports) {

$parcel$export(module.exports, "OcppDimmerState", function () { return $2d095121845c79d8$export$1d151c1a4cfa1847; });
var $2d095121845c79d8$export$1d151c1a4cfa1847;
(function(OcppDimmerState) {
    OcppDimmerState["OFF"] = "0";
    OcppDimmerState["LOW"] = "10";
    OcppDimmerState["MEDIUM"] = "50";
    OcppDimmerState["HIGH"] = "100";
})($2d095121845c79d8$export$1d151c1a4cfa1847 || ($2d095121845c79d8$export$1d151c1a4cfa1847 = {}));

});

parcelRegister("6GGmy", function(module, exports) {

$parcel$export(module.exports, "getDimmerValue", function () { return $5f613f09afcc7680$export$163077c1adda0573; });
$parcel$export(module.exports, "getExternalServerLink", function () { return $5f613f09afcc7680$export$4525577aec853df3; });
$parcel$export(module.exports, "getChargePointWithLowestSupplyCurrent", function () { return $5f613f09afcc7680$export$a7eabe93a1c4a197; });
$parcel$export(module.exports, "getChargerPhaseList", function () { return $5f613f09afcc7680$export$d15935c552360061; });
$parcel$export(module.exports, "getChargerPhaseListByImport", function () { return $5f613f09afcc7680$export$4b838ebd1a9f4a26; });
$parcel$export(module.exports, "getOwner", function () { return $5f613f09afcc7680$export$5f4ed0d56c2c0edf; });
$parcel$export(module.exports, "getChargerIcon", function () { return $5f613f09afcc7680$export$59e197e1a3804e5c; });
$parcel$export(module.exports, "showErrorMessagesForIgnoreSchedule", function () { return $5f613f09afcc7680$export$9a97ff7837082710; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("2NaMI");
var $a7txM = parcelRequire("a7txM");

var $lFIQ9 = parcelRequire("lFIQ9");

var $leSVD = parcelRequire("leSVD");

var $hC3GQ = parcelRequire("hC3GQ");

var $4rrnU = parcelRequire("4rrnU");

var $3T1QU = parcelRequire("3T1QU");

var $1hIPE = parcelRequire("1hIPE");

var $hohPv = parcelRequire("hohPv");

var $3rYDT = parcelRequire("3rYDT");

var $1KIb5 = parcelRequire("1KIb5");

var $9Hg3P = parcelRequire("9Hg3P");

var $gIoGi = parcelRequire("gIoGi");

var $7Ers9 = parcelRequire("7Ers9");

var $igvrl = parcelRequire("igvrl");
const $5f613f09afcc7680$export$31f57859cb32e4e6 = (customerList)=>customerList.map((customer)=>({
            label: customer.callbackBaseUrl ? `[${customer.id}: ${customer.callbackBaseUrl}] ${customer.name}` : `[${customer.id}] ${customer.name}`,
            value: customer.id
        })).sort((a, b)=>a.label.split("] ")[1].localeCompare(b.label.split("] ")[1]));
const $5f613f09afcc7680$export$163077c1adda0573 = (configKeys)=>{
    const dimmerConfigValue = (0, $a7txM.getConfigValue)((0, $leSVD.KEY_LIGHT_INTENSITY), configKeys);
    if (!dimmerConfigValue || isNaN(+dimmerConfigValue)) return (0, $hC3GQ.OcppDimmerState).OFF;
    return dimmerConfigValue;
};
const $5f613f09afcc7680$export$4525577aec853df3 = (id, externalServersList)=>externalServersList.find((server)=>server?.id === +id)?.url;
const $5f613f09afcc7680$export$a7eabe93a1c4a197 = (chargePoints)=>chargePoints.reduce((acc, val)=>{
        return val.supplyCurrent && val.supplyCurrent < (acc.supplyCurrent ?? 0) ? val : acc;
    }, chargePoints[0]);
const $5f613f09afcc7680$var$getPhaseList = (isLuna, earthingSystem, installationPhaseMode)=>{
    let phasesList;
    if (isLuna) phasesList = earthingSystem === (0, $4rrnU.EarthingSchemeLB).IT ? (0, $3T1QU.LUNA_PHASES_LIST_IT) : (0, $3T1QU.LUNA_PHASES_LIST);
    else phasesList = earthingSystem === (0, $4rrnU.EarthingSchemeLB).IT ? (0, $3T1QU.PHASES_LIST_IT) : (0, $3T1QU.PHASES_LIST_TN);
    if (installationPhaseMode !== "3P") return phasesList.filter((phase)=>phase !== (0, $3T1QU.Phases).L123);
    return phasesList;
};
const $5f613f09afcc7680$export$d15935c552360061 = (chargePointProductId, earthingSystem, installationPhaseMode)=>{
    return $5f613f09afcc7680$var$getPhaseList(chargePointProductId && (0, $lFIQ9.default)(chargePointProductId), earthingSystem, installationPhaseMode);
};
const $5f613f09afcc7680$export$4b838ebd1a9f4a26 = (chargePoint, earthingSystem, installationPhaseMode)=>{
    return $5f613f09afcc7680$var$getPhaseList((0, $lFIQ9.isLunaImport)(chargePoint), earthingSystem, installationPhaseMode);
};
const $5f613f09afcc7680$export$5f4ed0d56c2c0edf = (chargePoint)=>{
    if (chargePoint?.ownerName) return chargePoint?.ownerName;
    if ((0, $1hIPE.default)(chargePoint) && chargePoint.connectors && chargePoint.connectors.length > 1) {
        const leftConnector = chargePoint.connectors[0]?.connectorUserName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "font-bold mr-1"
        }, "L:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "overflow-ellipsis"
        }, chargePoint.connectors[0]?.connectorUserName));
        const rightConnector = chargePoint.connectors[1]?.connectorUserName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "font-bold mr-1"
        }, "R:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "text-overflow-ellipsis"
        }, chargePoint.connectors[1]?.connectorUserName));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex flex-column"
        }, leftConnector, rightConnector);
    }
};
const $5f613f09afcc7680$export$59e197e1a3804e5c = (chargePoint, size, className)=>{
    if ((0, $1hIPE.default)(chargePoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1KIb5.default), {
        size: size
    }));
    if ((0, $hohPv.default)(chargePoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9Hg3P.default), {
        size: size
    }));
    if ((0, $3rYDT.default)(chargePoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gIoGi.default), {
        size: size
    }));
    if ((0, $lFIQ9.default)(chargePoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7Ers9.default), {
        size: size
    }));
};
const $5f613f09afcc7680$export$9a97ff7837082710 = (error)=>{
    if (error === "NoOngoingSession") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "NoOngoingSession"
    });
    if (error === "NoScheduleForConnector") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "NoScheduleForConnector"
    });
    if (error === "OverridingScheduleExists") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "OverridingScheduleExists"
    });
    if (error === "OtherInvalid") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgIgnoreScheduleFailed"
    });
};

});
parcelRegister("lFIQ9", function(module, exports) {

$parcel$export(module.exports, "isLunaImport", function () { return $2fe34de1cf9e28da$export$34eae1ee68d2b41b; });
$parcel$export(module.exports, "default", function () { return $2fe34de1cf9e28da$export$2e2bcd8739ae039; });

var $4qITT = parcelRequire("4qITT");
const $2fe34de1cf9e28da$var$isLuna = (entity)=>{
    if (typeof entity === "number") return entity === (0, $4qITT.ChargerProducts).Luna;
    else if (typeof entity === "string") return entity.toLowerCase() === "luna";
    else if (typeof entity === "object" && entity.productId) return entity.productId === (0, $4qITT.ChargerProducts).Luna;
    return false;
};
const $2fe34de1cf9e28da$export$34eae1ee68d2b41b = (chargePoint)=>chargePoint && chargePoint.productType === "Luna";
var $2fe34de1cf9e28da$export$2e2bcd8739ae039 = $2fe34de1cf9e28da$var$isLuna;

});

parcelRegister("4rrnU", function(module, exports) {

$parcel$export(module.exports, "EarthingSchemeLB", function () { return $916961199e9802ab$export$7c8b009118c811cd; });
var $916961199e9802ab$export$3b5662891bba0212;
(function(EarthingScheme) {
    EarthingScheme["STANDARD"] = "Standard (TN/TT)";
    EarthingScheme["ITNET"] = "IT-net";
})($916961199e9802ab$export$3b5662891bba0212 || ($916961199e9802ab$export$3b5662891bba0212 = {}));
var $916961199e9802ab$export$7c8b009118c811cd;
(function(EarthingSchemeLB) {
    EarthingSchemeLB["IT"] = "IT";
    EarthingSchemeLB["TN"] = "TN";
})($916961199e9802ab$export$7c8b009118c811cd || ($916961199e9802ab$export$7c8b009118c811cd = {}));

});

parcelRegister("3T1QU", function(module, exports) {

$parcel$export(module.exports, "Phases", function () { return $34fc9a5ee1feba04$export$47f8e7036efcc4d6; });
$parcel$export(module.exports, "PhaseMode", function () { return $34fc9a5ee1feba04$export$ea1dcfe4dbd23dc1; });
$parcel$export(module.exports, "CHARGEPOINT_MIN_CURRENT", function () { return $34fc9a5ee1feba04$export$f8eab79aa9720142; });
$parcel$export(module.exports, "capiPhaseModeOptions", function () { return $34fc9a5ee1feba04$export$43176880513f15f6; });
$parcel$export(module.exports, "singlePhaseOptions", function () { return $34fc9a5ee1feba04$export$ac95cc763ef5f9ae; });
$parcel$export(module.exports, "loadBalancerItPhaseOptions", function () { return $34fc9a5ee1feba04$export$843fe000dad1d98; });
$parcel$export(module.exports, "PHASES_LIST_TN", function () { return $34fc9a5ee1feba04$export$d017ed1a88b0e38c; });
$parcel$export(module.exports, "PHASES_LIST_IT", function () { return $34fc9a5ee1feba04$export$88fd692419e3e33; });
$parcel$export(module.exports, "LUNA_PHASES_LIST", function () { return $34fc9a5ee1feba04$export$f5f811006e225d9d; });
$parcel$export(module.exports, "LUNA_PHASES_LIST_IT", function () { return $34fc9a5ee1feba04$export$23b132b63e6c9da6; });
$parcel$export(module.exports, "installationPhasesOptionsTN", function () { return $34fc9a5ee1feba04$export$b6ce56cf492eb525; });
$parcel$export(module.exports, "installationPhasesOptionsIT", function () { return $34fc9a5ee1feba04$export$fb31632cec0ed5db; });
$parcel$export(module.exports, "installationPhasesOrderOptions", function () { return $34fc9a5ee1feba04$export$f19ec29289f16716; });
$parcel$export(module.exports, "getSupplyPhase", function () { return $34fc9a5ee1feba04$export$4b48e4ef70a63942; });
$parcel$export(module.exports, "getInstallationCurrentLimit", function () { return $34fc9a5ee1feba04$export$8f44bbe26958d030; });
var $34fc9a5ee1feba04$export$47f8e7036efcc4d6;
(function(Phases) {
    Phases["L1"] = "L1";
    Phases["L2"] = "L2";
    Phases["L3"] = "L3";
    Phases["L123"] = "L123";
    Phases["L1L2"] = "L1L2";
    Phases["L2L3"] = "L2L3";
    Phases["L3L1"] = "L3L1";
    Phases["L1L2L3"] = "L1,L2,L3";
})($34fc9a5ee1feba04$export$47f8e7036efcc4d6 || ($34fc9a5ee1feba04$export$47f8e7036efcc4d6 = {}));
var $34fc9a5ee1feba04$export$ea1dcfe4dbd23dc1;
(function(PhaseMode) {
    PhaseMode["onePhase"] = "1P";
    PhaseMode["twoPhase"] = "2P";
    PhaseMode["threePhase"] = "3P";
})($34fc9a5ee1feba04$export$ea1dcfe4dbd23dc1 || ($34fc9a5ee1feba04$export$ea1dcfe4dbd23dc1 = {}));
const $34fc9a5ee1feba04$export$f8eab79aa9720142 = 6;
const $34fc9a5ee1feba04$export$43176880513f15f6 = [
    "1P",
    "3P"
].map((x)=>({
        value: x,
        label: x
    }));
const $34fc9a5ee1feba04$var$singlePhases = [
    "L1",
    "L2",
    "L3"
];
const $34fc9a5ee1feba04$export$ac95cc763ef5f9ae = $34fc9a5ee1feba04$var$singlePhases.map((value)=>({
        value: value,
        label: value
    }));
const $34fc9a5ee1feba04$export$843fe000dad1d98 = [
    {
        value: "L1,L2,L3",
        label: "L1,L2,L3"
    }
];
const $34fc9a5ee1feba04$export$d017ed1a88b0e38c = [
    ...$34fc9a5ee1feba04$var$singlePhases,
    "L123"
];
const $34fc9a5ee1feba04$export$88fd692419e3e33 = [
    "L1L2",
    "L2L3",
    "L3L1"
];
const $34fc9a5ee1feba04$export$f5f811006e225d9d = [
    "L1",
    "L123"
];
const $34fc9a5ee1feba04$export$23b132b63e6c9da6 = [
    "L1L2"
];
const $34fc9a5ee1feba04$export$b6ce56cf492eb525 = [
    "1",
    "3"
].map((x)=>({
        value: x,
        label: x
    }));
const $34fc9a5ee1feba04$export$fb31632cec0ed5db = [
    "2",
    "3"
].map((x)=>({
        value: x,
        label: x
    }));
const $34fc9a5ee1feba04$export$f19ec29289f16716 = [
    "RST",
    "RTS",
    "SRT",
    "STR",
    "TRS",
    "TSR"
].map((x)=>({
        value: x,
        label: x
    }));
const $34fc9a5ee1feba04$var$phaseIndices = {
    L1: [
        0
    ],
    L2: [
        1
    ],
    L3: [
        2
    ],
    L123: [
        0,
        1,
        2
    ],
    L1L2: [
        0,
        1
    ],
    L2L3: [
        1,
        2
    ],
    L3L1: [
        2,
        0
    ]
};
const $34fc9a5ee1feba04$var$supplyPhases = {
    R: "L1",
    S: "L2",
    T: "L3",
    RS: "L1L2",
    ST: "L2L3",
    RT: "L3L1",
    RST: "L123"
};
const $34fc9a5ee1feba04$export$4b48e4ef70a63942 = (phase, rotation)=>{
    if (!phase) return undefined;
    if (phase === "L123") return phase;
    if (!rotation) return undefined;
    return $34fc9a5ee1feba04$var$supplyPhases[$34fc9a5ee1feba04$var$phaseIndices[phase].map((index)=>rotation[index]).sort().join("")];
};
const $34fc9a5ee1feba04$export$8f44bbe26958d030 = (supplyCurrent, factoryCurrent)=>Math.min(supplyCurrent, factoryCurrent ?? supplyCurrent);

});

parcelRegister("hohPv", function(module, exports) {

$parcel$export(module.exports, "isDawnImport", function () { return $27bae14ccfc17893$export$635c751643e3dac; });
$parcel$export(module.exports, "default", function () { return $27bae14ccfc17893$export$2e2bcd8739ae039; });

var $4qITT = parcelRequire("4qITT");
const $27bae14ccfc17893$var$isDawn = (entity)=>{
    if (typeof entity === "number") return entity === (0, $4qITT.ChargerProducts).Dawn;
    else if (typeof entity === "string") return entity.toLowerCase() === "dawn";
    else if (typeof entity === "object" && entity.productId) return entity.productId === (0, $4qITT.ChargerProducts).Dawn;
    return false;
};
const $27bae14ccfc17893$export$635c751643e3dac = (chargePoint)=>chargePoint && chargePoint.productType === "Dawn";
var $27bae14ccfc17893$export$2e2bcd8739ae039 = $27bae14ccfc17893$var$isDawn;

});

parcelRegister("3rYDT", function(module, exports) {

$parcel$export(module.exports, "isHaloImport", function () { return $65bae92daaf786eb$export$b845f48fc6b0f756; });
$parcel$export(module.exports, "default", function () { return $65bae92daaf786eb$export$2e2bcd8739ae039; });

var $4qITT = parcelRequire("4qITT");
const $65bae92daaf786eb$var$isHalo = (entity)=>{
    const productId = typeof entity === "number" ? entity : entity?.productId;
    if (!productId) return false;
    return productId === (0, $4qITT.ChargerProducts).Halo1 || productId === (0, $4qITT.ChargerProducts).Halo2;
};
const $65bae92daaf786eb$export$b845f48fc6b0f756 = (chargePoint)=>chargePoint?.productType === "Halo1" || chargePoint?.productType === "Halo2";
var $65bae92daaf786eb$export$2e2bcd8739ae039 = $65bae92daaf786eb$var$isHalo;

});

parcelRegister("1KIb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d63d6ca86597d87$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $7d63d6ca86597d87$var$AuraIcon = ({ fill: fill = "#535353", title: title, id: id = "info-icon", size: size = 147 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        className: "align-items-center justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 120 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M84.556 130.28C101.594 129.431 108.174 118.725 110.477 112.98C112.779 107.236 116.7 95.0906 118.175 68.3284C119.651 41.5663 119.289 21.6505 111.565 12.0906C103.844 2.5307 77.2667 1.13916 60.0013 1.13916C42.7331 1.13916 16.1591 2.5307 8.43506 12.0906C0.713859 21.6533 0.352059 41.5663 1.8273 68.3284C3.30255 95.0906 7.22345 107.236 9.52607 112.98C11.8287 118.725 18.4084 129.431 35.4466 130.28C52.4849 131.129 67.5178 131.129 84.556 130.28V130.28Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M60.0014 9.92535C67.6188 9.92535 86.8419 10.6378 92.3446 14.3699C96.6021 17.2588 96.7086 20.7209 96.8657 26.3038C97.0228 31.8867 95.5615 48.1371 92.8691 57.8417C90.1766 67.5464 88.3368 69.7311 86.0033 71.5123C83.6698 73.2934 78.3017 75.3668 68.4125 75.6535C63.0753 75.8066 56.9275 75.8066 51.5874 75.6535C41.6983 75.3668 36.3302 73.2934 33.9967 71.5123C31.6632 69.7311 29.8234 67.5491 27.1309 57.8417C24.4384 48.1343 22.9772 31.8839 23.1343 26.3038C23.2913 20.7237 23.3951 17.2588 27.6554 14.3699C33.1609 10.6378 52.384 9.92535 59.9986 9.92535H60.0014Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M60.0013 11.3531C66.825 11.3531 84.0427 11.9765 88.9733 15.241C92.7876 17.7681 92.883 20.7961 93.0232 25.6776C93.1635 30.5591 91.8565 44.7724 89.4445 53.2636C87.0325 61.7547 85.2095 63.4524 83.2939 65.2197C81.2577 67.0955 76.9722 68.5733 67.5374 68.8405C62.7555 68.9769 57.2499 68.9769 52.468 68.8405C43.0332 68.5705 38.7477 67.0955 36.7115 65.2197C34.7959 63.4524 32.9729 61.7547 30.5609 53.2636C28.1489 44.7724 26.8419 30.5619 26.9822 25.6776C27.1224 20.7961 27.2149 17.7653 31.0321 15.241C35.9626 11.9765 53.1832 11.3531 60.0041 11.3531H60.0013Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M60.0015 13.7911C66.1941 13.7911 81.8244 14.3198 86.3007 17.0862C89.7644 19.2292 89.8485 21.798 89.9747 25.9364C90.1009 30.0749 88.9146 42.1257 86.7242 49.3255C84.5337 56.5226 82.879 57.9642 81.1429 59.4615C79.2946 61.0534 75.4046 62.303 66.8392 62.5312C62.4976 62.6481 57.4997 62.6481 53.1581 62.5312C44.5955 62.303 40.7027 61.0506 38.8544 59.4615C37.1155 57.9642 35.4608 56.5226 33.2732 49.3255C31.0827 42.1284 29.8964 30.0777 30.0226 25.9364C30.1488 21.798 30.2357 19.2292 33.6967 17.0862C38.1729 14.3171 53.8032 13.7911 59.9959 13.7911H60.0015Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M56.2825 130.903L56.95 131.566V134.861H63.0529V131.566L63.7232 130.903",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M63.0529 131.605H56.95",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M106.528 109.101C109.344 99.5634 104.15 89.6577 94.9266 86.9761C85.703 84.2945 75.9429 89.8524 73.1268 99.3901C70.3107 108.928 75.505 118.833 84.7286 121.515C93.9522 124.197 103.712 118.639 106.528 109.101Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M86.5473 119.534C78.9803 117.138 74.7593 108.909 77.0984 100.985C78.5821 95.9589 82.3543 92.2462 86.8726 90.7183",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M93.6207 119.632C99.1683 118.455 103.903 114.372 105.611 108.591C107.896 100.852 103.953 92.7695 96.6918 89.6274L84.2728 89.4715C79.9256 91.2304 76.4001 94.8679 74.9782 99.6854C72.4989 108.079 77.3481 116.877 85.8069 119.337C86.5333 119.548 87.2597 119.704 87.989 119.813",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M94.9976 89.6051L96.8403 90.8491V94.5033C101.855 97.0554 104.461 103.039 102.752 108.822C101.645 112.577 98.9606 115.429 95.6791 116.821C93.2671 117.845 90.5298 118.079 87.8598 117.302C81.5577 115.471 78.0099 108.705 79.9339 102.187C80.4808 100.337 81.4119 98.7058 82.6067 97.3588C83.8015 96.0145 85.2627 94.9542 86.8725 94.2473V90.7155L85.0439 89.4771L94.9976 89.6051V89.6051Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M95.6792 116.824L93.1046 120.333H88.3338L85.7788 116.473",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M35.2735 121.515C44.4971 118.834 49.6914 108.928 46.8753 99.3905C44.0592 89.8528 34.2991 84.2949 25.0755 86.9766C15.852 89.6582 10.6576 99.5639 13.4737 109.102C16.2898 118.639 26.0499 124.197 35.2735 121.515Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M33.1272 90.7183C37.6455 92.2463 41.4177 95.9589 42.9014 100.985C45.2405 108.909 41.0195 117.138 33.4525 119.534",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M26.3794 119.632C20.8318 118.455 16.0976 114.372 14.3895 108.591C12.1038 100.852 16.0471 92.7695 23.3083 89.6274L35.7273 89.4715C40.0745 91.2304 43.6 94.8679 45.0219 99.6854C47.5012 108.079 42.652 116.877 34.1932 119.337C33.4668 119.548 32.7404 119.704 32.0111 119.813",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M25.0023 89.6051L23.1597 90.8491V94.5033C18.1449 97.0554 15.5394 103.039 17.2475 108.822C18.3553 112.577 21.0393 115.429 24.3208 116.821C26.7328 117.845 29.4701 118.079 32.1401 117.302C38.4422 115.471 41.9901 108.705 40.0661 102.187C39.5192 100.337 38.588 98.7058 37.3932 97.3588C36.1985 96.0146 34.7372 94.9542 33.1274 94.2473V90.7155V90.7128L34.956 89.4771L25.0023 89.6051V89.6051Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M24.3208 116.824L26.8955 120.333H31.6662L34.2212 116.473",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M71.6126 45.0868H69.8709L66.152 38.7219C65.9921 38.4492 65.7229 38.2933 65.4284 38.2933H65.4087C65.1114 38.3017 64.8338 38.477 64.6851 38.7609L62.0852 43.7871C61.6758 44.5775 60.8792 45.0674 60.0014 45.0674C59.1235 45.0674 58.327 44.5803 57.9175 43.7871L55.3148 38.7581C55.1718 38.4798 54.8941 38.2961 54.5968 38.2906C54.3023 38.2794 54.0163 38.4436 53.8536 38.7247L50.1318 45.0896H48.3845L52.5466 37.9733C52.9869 37.2246 53.7919 36.771 54.6333 36.7988C55.4831 36.8183 56.2572 37.3109 56.6526 38.079L59.2553 43.1025C59.4348 43.4504 59.7546 43.5701 59.9986 43.5701C60.2426 43.5701 60.5623 43.4476 60.7418 43.1025L63.3417 38.079C63.7428 37.3109 64.5169 36.8183 65.3667 36.7988C66.2165 36.7766 67.013 37.2274 67.4533 37.9761L71.607 45.0868H71.6126Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M65.9527 35.385H64.2111L60.7221 29.4181C60.5089 29.0479 60.1471 29.0034 60.0041 29.0034C59.861 29.0034 59.4992 29.0479 59.2805 29.4181L55.7971 35.385H54.0498L57.9735 28.6666C58.397 27.943 59.1571 27.5089 60.0013 27.5089C60.8455 27.5089 61.5999 27.943 62.0262 28.6666L65.9499 35.385H65.9527Z",
        fill: fill
    })));
};
var $7d63d6ca86597d87$export$2e2bcd8739ae039 = $7d63d6ca86597d87$var$AuraIcon;

});

parcelRegister("9Hg3P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $234fa25640781f0d$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $234fa25640781f0d$var$DawnIcon = ({ fill: fill = "#535353", title: title, id: id = "info-icon", size: size = 147 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        className: "align-items-center justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 84 126",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M30.136 102.455L29.4829 101.663C29.4029 101.565 29.2455 101.63 29.2532 101.756C29.39 103.702 29.6404 105.49 29.9812 107.146C30.0044 107.261 30.1593 107.285 30.2212 107.184L30.6807 106.4C30.7117 106.346 30.722 106.284 30.7091 106.223C30.4716 105.055 30.2987 103.846 30.1954 102.597C30.1902 102.545 30.1722 102.496 30.1386 102.455H30.136Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M44.9376 39.6401H39.0624C38.8662 39.6401 38.7887 39.8946 38.9514 40.0026L39.5373 40.3961C39.6044 40.4424 39.6845 40.4655 39.7671 40.4655H44.2354C44.318 40.4655 44.3981 40.4424 44.4652 40.3961L45.0511 40.0026C45.2138 39.8946 45.1363 39.6401 44.9401 39.6401H44.9376Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42.0001 124.871C50.4076 124.871 65.0414 123.727 71.4045 117.388C80.9711 107.858 82.871 75.7549 82.871 56.278C82.871 36.1582 80.5581 15.8815 73.7226 9.07208C69.0477 4.41244 58.9675 1.12857 42.0001 1.12857C25.0327 1.12857 14.9524 4.41244 10.2775 9.06951C3.44206 15.879 1.12915 36.1556 1.12915 56.2754C1.12915 76.3952 3.02904 107.855 12.5956 117.386C18.9587 123.725 33.5951 124.869 42.0001 124.869V124.871Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42 71.7741C51.0115 71.7741 57.4005 70.8432 60.4645 67.7908C63.446 64.8207 64.223 58.1141 64.223 52.4001C64.223 47.5682 63.1285 43.1579 60.4723 40.5118C57.3101 37.3617 49.2898 36.9091 41.9974 36.9091C34.7076 36.9091 26.6872 37.3617 23.5225 40.5118C20.8662 43.1579 19.7717 47.5682 19.7717 52.4001C19.7717 58.1141 20.5513 64.8232 23.5302 67.7908C26.5943 70.8432 32.9832 71.7741 41.9948 71.7741H42Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M55.3923 113.117C56.8662 111.649 60.5163 104.122 60.5163 96.389C60.5163 93.2697 60.5163 90.8138 58.2215 88.5277C57.1605 87.4708 53.4537 85.0099 42.0001 85.0099C30.5491 85.0099 26.8423 87.4708 25.7787 88.5277C23.4839 90.8138 23.4839 93.2697 23.4839 96.389C23.4839 104.124 27.134 111.651 28.6079 113.117",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42.0001 119.949C48.2883 119.949 50.7897 119.222 53.0097 117.01C55.9163 114.115 58.9675 103.867 58.9675 96.389C58.9675 93.4291 58.9701 91.4542 57.1244 89.6181C54.876 87.3783 47.9011 86.5502 42.0001 86.5502C36.0991 86.5502 29.1242 87.3757 26.8758 89.6181C25.0301 91.4567 25.0327 93.4291 25.0327 96.389C25.0327 103.867 28.0865 114.115 30.9905 117.01C33.2105 119.222 35.7119 119.949 42.0001 119.949Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M41.9999 118.851C47.2091 118.851 49.8241 118.545 51.9589 116.419C53.5929 114.791 55.9368 106.714 55.9368 97.199C55.9368 95.9415 56.0607 93.982 54.4783 92.4056C52.8133 90.747 47.3718 90.4101 41.9999 90.4101C36.6307 90.4101 31.1865 90.747 29.5215 92.4056C27.9392 93.982 28.0631 95.9415 28.0631 97.199C28.0631 106.714 30.407 114.788 32.041 116.419C34.1758 118.545 36.7907 118.851 41.9999 118.851V118.851Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M53.8639 102.455L54.517 101.663C54.597 101.565 54.7545 101.63 54.7467 101.756C54.6099 103.702 54.3595 105.49 54.0188 107.146C53.9955 107.261 53.8407 107.285 53.7787 107.184L53.3192 106.4C53.2883 106.346 53.2779 106.284 53.2908 106.223C53.5283 105.055 53.7013 103.846 53.8045 102.597C53.8097 102.545 53.8278 102.496 53.8613 102.455H53.8639Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42 42.5639H46.76C52.1344 42.5639 52.0492 40.0515 54.5454 40.0515C57.3049 40.0515 58.3788 40.8564 59.6643 42.1345C61.2209 43.6851 62.4367 47.2596 62.4367 51.644C62.4367 59.4513 61.6959 64.0338 59.1997 66.5204C56.6854 69.0251 50.4772 70.1335 42.0025 70.1335C33.5279 70.1335 27.3171 69.0226 24.8054 66.5204C22.2937 64.0183 21.5684 59.4513 21.5684 51.644C21.5684 47.2596 22.7842 43.6851 24.3408 42.1345C25.6263 40.8538 26.7001 40.0515 29.4596 40.0515C31.9558 40.0515 31.8706 42.5639 37.2451 42.5639H42.0051H42Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42 68.0659C46.107 68.0659 51.848 67.5053 53.5749 65.785C55.6116 63.756 56.3009 59.7393 56.3009 54.3416C56.3009 49.3991 55.0153 47.5296 53.6885 46.2078C51.657 44.184 47.2377 44.1866 42 44.1866C36.7624 44.1866 32.3431 44.1814 30.3116 46.2078C28.9847 47.5296 27.6992 49.3991 27.6992 54.3416C27.6992 59.7393 28.3884 63.756 30.4252 65.785C32.1521 67.5053 37.8931 68.0659 42 68.0659Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42.0001 120.88C51.7577 120.88 63.1854 119.35 63.1854 96.7798C63.1854 95.1932 63.2035 90.3201 59.9974 87.1262C56.35 83.4926 46.0709 83.3281 41.9975 83.3281C37.9241 83.3281 27.6451 83.4952 23.9976 87.1262C20.7915 90.3201 20.8096 95.1958 20.8096 96.7798C20.8096 119.35 32.2373 120.88 41.9949 120.88H42.0001Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M42.514 22.7064C42.514 22.9878 42.2848 23.2176 41.9999 23.2176C41.7151 23.2176 41.4858 22.9878 41.4858 22.7064C41.4858 22.425 41.7151 22.1953 41.9999 22.1953C42.2847 22.1953 42.514 22.425 42.514 22.7064Z",
        stroke: fill,
        strokeWidth: "0.5",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M44.6024 22.7039C44.6024 23.3132 44.3928 23.8922 44.0076 24.3527L43.8136 24.1585C44.1465 23.7494 44.328 23.241 44.328 22.7039C44.328 22.1662 44.1461 21.6598 43.8136 21.25L44.0078 21.0566C44.3934 21.5202 44.6024 22.0954 44.6024 22.7039Z",
        stroke: fill,
        strokeWidth: "0.5",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M40.1863 21.2526C39.8537 21.663 39.6719 22.171 39.6719 22.7064C39.6719 23.242 39.8538 23.7502 40.1866 24.1607L39.9925 24.355C39.6068 23.8932 39.3975 23.3177 39.3975 22.7064C39.3975 22.0958 39.6064 21.5224 39.992 21.0591L40.1863 21.2526Z",
        stroke: fill,
        strokeWidth: "0.5",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M38.5251 25.8152C37.7516 24.9579 37.3298 23.8655 37.3298 22.7064C37.3298 21.5475 37.7516 20.4573 38.525 19.6002L38.7185 19.7929C37.9988 20.5971 37.6042 21.6226 37.6042 22.7064C37.6042 23.7901 37.9987 24.8179 38.7185 25.6225L38.5251 25.8152Z",
        stroke: fill,
        strokeWidth: "0.5",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M45.2814 19.7929L45.4748 19.6002C46.2483 20.4575 46.67 21.5498 46.67 22.7064C46.67 23.8632 46.2482 24.9577 45.4748 25.8152L45.2814 25.6225C46.0012 24.8179 46.3956 23.7901 46.3956 22.7064C46.3956 21.6226 46.0011 20.5971 45.2814 19.7929Z",
        stroke: fill,
        strokeWidth: "0.5",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M49.4861 61.2771H48.3632L45.9651 57.1574C45.8619 56.9826 45.6889 56.8797 45.5005 56.8797H45.4876C45.2965 56.8849 45.1158 57.0006 45.0229 57.1832L43.3476 60.4362C43.0843 60.9479 42.5706 61.2642 42.0053 61.2642C41.44 61.2642 40.9263 60.9479 40.663 60.4362L38.9851 57.1806C38.8921 57.0006 38.714 56.8823 38.523 56.8771C38.3346 56.8694 38.1487 56.9774 38.0454 57.1574L35.6448 61.2771H34.5193L37.2039 56.6714C37.4879 56.188 38.0067 55.8948 38.5488 55.9128C39.0961 55.9257 39.5943 56.2445 39.8498 56.7409L41.5277 59.9939C41.6439 60.2176 41.8504 60.2973 42.0053 60.2973C42.1602 60.2973 42.3693 60.2176 42.4828 59.9939L44.1581 56.7409C44.4163 56.2445 44.9145 55.9257 45.4617 55.9128C46.009 55.8974 46.5227 56.1905 46.8066 56.674L49.4861 61.2771Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M45.836 54.9999H44.7131L42.4647 51.14C42.3253 50.9009 42.093 50.8726 42.0027 50.8726C41.9123 50.8726 41.6774 50.9009 41.538 51.14L39.2922 54.9999H38.1667L40.6965 50.6514C40.9701 50.1834 41.458 49.9031 42.0027 49.9031C42.5473 49.9031 43.0326 50.1834 43.3063 50.6514L45.836 54.9999Z",
        fill: fill
    })));
};
var $234fa25640781f0d$export$2e2bcd8739ae039 = $234fa25640781f0d$var$DawnIcon;

});

parcelRegister("gIoGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cabbf93c99b44dc5$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $cabbf93c99b44dc5$var$HaloIcon = ({ fill: fill = "#535353", title: title, id: id = "info-icon", size: size = 147 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        className: "align-items-center justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 147 115",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M73.4999 34.7876C83.9722 34.7876 93.1217 38.8413 95.5594 50.891C97.997 62.9406 94.0968 72.2222 89.4684 75.8496C84.8368 79.4769 78.3103 80.7691 73.4999 80.7691C68.6928 80.7691 62.1631 79.4769 57.5315 75.8496C52.8999 72.2222 49.0028 62.9406 51.4405 50.891C53.8782 38.8413 63.0276 34.7876 73.4999 34.7876V34.7876Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M73.4999 114.258C88.7078 114.258 107.806 113.346 123.976 103.511C140.146 93.6748 150.277 70.6512 143.91 41.4749C137.533 12.2658 113.286 1.16399 73.4999 1.16399C33.7137 1.16399 9.46685 12.2658 3.08986 41.4749C-3.28062 70.6512 6.8504 93.6748 23.0236 103.511C39.1968 113.346 58.2953 114.258 73.4999 114.258Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M73.5 113.11C88.3992 113.11 107.111 112.215 122.953 102.579C138.794 92.9434 148.721 70.3888 142.48 41.8062C136.233 13.1874 112.477 2.31189 73.5 2.31189C34.5231 2.31189 10.767 13.1874 4.52004 41.8029C-1.72043 70.3856 8.20582 92.9401 24.0475 102.576C39.8892 112.212 58.6009 113.107 73.5 113.107V113.11Z",
        stroke: fill,
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M86.956 66.3679H84.9376L80.6278 58.8672C80.4425 58.5458 80.1305 58.3621 79.7892 58.3621H79.7665C79.422 58.372 79.1002 58.5786 78.9279 58.9131L75.9149 64.8363C75.4404 65.7677 74.5173 66.345 73.5 66.345C72.4827 66.345 71.5596 65.771 71.0851 64.8363L68.0688 58.9099C67.9031 58.5819 67.5813 58.3654 67.2368 58.3589C66.8955 58.3457 66.564 58.5392 66.3755 58.8705L62.0624 66.3712H60.0375L64.8608 57.985C65.3711 57.1027 66.304 56.5681 67.279 56.6009C68.2639 56.6239 69.1609 57.2044 69.6192 58.1096L72.6354 64.0295C72.8434 64.4394 73.214 64.5805 73.4968 64.5805C73.7795 64.5805 74.15 64.4362 74.3581 64.0295L77.371 58.1096C77.8358 57.2044 78.7329 56.6239 79.7177 56.6009C80.7026 56.5747 81.6256 57.106 82.1359 57.9882L86.9495 66.3679H86.956Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M80.3971 54.9381H78.3787L74.3354 47.9064C74.0883 47.4702 73.6691 47.4177 73.5033 47.4177C73.3375 47.4177 72.9183 47.4702 72.6647 47.9064L68.6279 54.9381H66.603L71.1501 47.0209C71.6409 46.1682 72.5217 45.6565 73.5 45.6565C74.4784 45.6565 75.3527 46.1682 75.8467 47.0209L80.3938 54.9381H80.3971Z",
        fill: fill
    })));
};
var $cabbf93c99b44dc5$export$2e2bcd8739ae039 = $cabbf93c99b44dc5$var$HaloIcon;

});

parcelRegister("7Ers9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e6e1a58815cffa1$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $6e6e1a58815cffa1$var$LunaIcon = ({ fill: fill = "#535353", title: title, id: id = "info-icon", size: size = 147 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size,
        className: "align-items-center justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 574.667 601.333"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "m1966.68 3316.99 50 86.25m4.02-86.25h-54.02m104.53 87.19-50.51-87.19m107.23-240.66 5.43-7.38 7.62-5.12 8.4-2.03 1.52-.08m-103.56 171.37 80.59-156.76m-143.09 196.68 23.29-4.57 20.5-11.96 15.82-18.24 2.89-5.15m-127.14 3.32 16.09 19.25 21.6 12.86 26.95 4.49m-193.47-258.56 128.83 221.96m-74.73-221.96h-54.1m169.29 198.52-115.19-198.52m138.16 212.03-6.48-.66-7.54-3.32-6.17-5.55-2.78-3.98m45.2-1.1-5.47 7.39-7.62 5.15-9.14 2.07M2086.45 3055l-80.59 156.87m145.04-196.79-23.67 4.02-20.98 11.6-16.09 17.85-3.71 6.45m-384.89-921.02h449.34m-449.34-20.43-3.4.59-3 1.64-2.27 2.58-1.29 3.16-.19 3.44.97 3.28 2 2.78 2.81 1.99 3.28.9 1.09.07m449.34-20.43h-449.34m449.34 20.43h449.33m-449.29 881.1h-.04m64.53 39.92-14.84-19.92-20.71-13.91-23.55-5.9-5.39-.19m145.04 196.79L2215.43 3055m102.77 171.48-6.52-1.09-7.58-3.87-5.97-6.09-2.15-3.56m45.19 1.1-5.97 7.3-8.13 4.81-8.87 1.4m138.21-212.03-115.24 198.52m169.26-198.52h-54.02m-74.85 221.96 128.87-221.96m-193.48 258.56 23.32-3.24 20.9-10.67 16.96-17.3 3.43-5.39m-127.15-3.32 14.93 20 20.78 13.9 23.75 5.9 3.08.12m-143.08-196.68 80.54 156.76m-103.51-171.37 6.4.9 7.86 3.63 6.17 6.02 2.54 4.06m107.22 240.7-50.54 87.15m104.49-87.15h-53.95m3.95 86.21 50-86.21m265.19-1203.48H2150.9m449.33 20.43 3.4-.58 3.01-1.64 2.27-2.58 1.29-3.16.19-3.44-.98-3.28-1.99-2.82-2.81-1.95-3.28-.94-1.1-.04m-512.07 1413.01-71.52-123.32m134.26 159.46-23.91-3.99-21.21-11.68-15.9-17.66-1.72-2.81m196.92-123.32-71.49 123.32m0 0-15.58 18.83-21.1 12.58-25.97 4.73m0 0h-.04m-22.35-59.58 5.51 6.72 7.5 4.46 8.09 1.68 1.25.04m-79.69-111.88 57.34 98.98m22.39 12.9 6.25-.79 7.85-3.36 6.13-5.78 1.99-2.97m0 0 57.39-98.98m-79.65 111.88h.04m-.04-1880.08-115.16-1.92-115-6.29-86.4-8.16-85.9-11.99-57.46-10.78-56.49-14.85-53.9-21.64-34.69-20.62-30.59-26.17m-94.88-659.93-10.66 126.332-2.19 126.948 3.98 87.27 10.04 86.91 18.36 85.4 17.77 53.59 25.36 51.56 32.22 41.92m-94.88-659.93 26.41-147.379 39.84-143.672 24.41-64.648 19.96-39.922M2786.52 1513.52l-22.85 20.46-36.4 23.21-39.61 17.54-84.96 25.11-87.7 15.67-89.06 9.29-89.06 5.9-185.98 5.24m618.36-1182.581 24.57 52.071 21.25 57.109 39.88 143.672 26.41 147.379m-94.85 659.93 30.32-38.91 23.51-45.47 18.52-52.15 13.4-53.75 16.28-112.34 5.36-88.99.15-89.02-12.69-179.3M2150.9 5.27l-313.6 5.199-313.55 16.37-312.66 29.372m0 0-8.47 1.02-10.9 1.359m0 0-150.94 21.96m-19.33 3.321 9.64-1.68 9.69-1.64m-19.33 3.32-95.79 18.711-95.269 22.688-93.942 28.05-74.07 28.711-70.539 35.778-66.102 43.832-61.008 51.058-55.589 57.071-49.801 62.031-63.442 100.039-51.679 106.359-42.071 110.633-34.726 112.887-31.094 123.511-25.508 124.34m0 0-3.519 19.3m-24.492 151.52 24.492-151.52M80.039 1299.8l1.371-9.68 1.399-9.73m-2.77 19.41L44.41 1611.91 21.88 1918.28l-12.27 303.13-3.32 245.54 3.55 248.4 11.962 253.36m0 0 1.289 19.61m13 152.93-13-152.93m15 172.46-1.02-9.76-.98-9.77m2 19.53 18.2 146.17 25.081 145.9 34.57 144.53 36.399 114.26 45.75 111.21 56.789 106.02 69.422 98.47 82.929 88.56 94.532 76.13 103.508 62.7 110.16 50.86 153.09 52.93 156.79 39.6 159.07 29.5 240.66 31.48 241.64 20.82 242.15 11.68 242.07 3.91m2112.81-1334.73-16.52 134.61-22.23 134.41-29.88 133.4-39.65 131.64-51.72 128.01-56.8 106.02-69.41 98.47-82.93 88.56-94.53 76.13-103.52 62.7-110.15 50.86-153.09 52.93-156.8 39.6-159.02 29.5-240.66 31.48-241.68 20.82-242.15 11.68-242.07 3.91m2112.81-1334.73 1.99-19.53m12.97-152.93-12.97 152.93m14.34-172.54-.66 9.81-.71 9.8m-56.91-1688.52 2.85 20.51 33.98 305.08 21.68 299.53 11.92 296.49 3.32 245.54-3.56 248.4-11.91 253.36m-58.28-1668.91-2.78-19.41m-24.49-151.52 24.49 151.52m-28-170.82 1.79 9.65 1.72 9.65M3280.31 83.871l95.82 18.711 95.28 22.688 93.94 28.05 74.03 28.711 70.58 35.778 66.09 43.832 61.02 51.058 55.59 57.071 49.8 62.031 63.44 100.039 51.68 106.359 42.07 110.633 34.73 112.887 31.09 123.511 25.51 124.34M3280.31 83.871l-19.29-3.32m0 0L3110.08 58.59m-19.38-2.38 9.69 1.169 9.69 1.21M2150.9 5.27l313.59 5.2 313.56 16.37 312.65 29.372m-282.89 540.781 11.37 52.379 10.04 53.359 8.48 52.469 7.22 52.961 5.86 52.461 4.69 52.539 3.48 52.82 2.77 70.74.55 73.2-2.31 75.78-6.41 73.87-10.42 64.14-1.61 7.34m-69.84-870.191 1.91 6.411 2.15 7.339 2.42 8.321 2.66 9.34 1.6 5.66 4.42 15.902 3.28 12.219 6.36 24.461 5.79 23.16 5.54 23.32M2150.9 75.981l55.66.43 54.3 1.288 54.88 2.262 54.81 3.52 37.65 3.671 35.86 5.079 34.73 7.03 51.52 16.048 47.11 23.48 27.93 19.652 24.77 22.258 22.18 24.891 13.4 17.691 13.05 19.418 12.73 21.133 12.43 22.848 25.78 55.312 22.5 58.629 19.49 60.238M2150.9 75.981l-55.67.43-54.29 1.288-54.89 2.262-54.8 3.52-37.66 3.671-35.86 5.079-34.72 7.03-51.53 16.048-47.1 23.48-27.93 19.652-24.77 22.258-22.19 24.891-13.4 17.691-13.04 19.418-12.74 21.133-12.42 22.848-25.78 55.312-22.5 58.629-19.49 60.238m0 0-1.92 6.411-2.15 7.339-2.42 8.321-2.65 9.34-1.6 5.66-4.42 15.902-3.28 12.219-6.37 24.461-5.78 23.16-5.55 23.32m0 0-11.36 52.379-10.04 53.359-8.48 52.469-7.22 52.961-5.9 52.461-4.65 52.539-3.48 52.82-2.77 70.74-.59 73.2 2.35 75.78 6.4 73.87 10.43 64.14 1.56 7.23m1170.2-1044.42-1.09-1.75m0 0-13.32-20.079-30.94-37.543-33.17-28.988-35.23-21.64-38.83-16.211-64.88-15.7-66.68-7.929-97.38-5.391-98.01-1.68m0 0-26.45.121-105.66 2.969-52.66 3.121-66.79 7.11-53.79 10.902-46.49 16.09-36.99 19.848-32.62 25.031-27.89 29.258-29.1 40.711m0 0-1.09 1.75M2779.3 803.051l2.89 26.008 8.71 104.851 3.75 105.46-2.03 105.86-4.38 52.82-7.81 52.54-12.62 51.68-27.03 64.64m-1179.76 0-10.82-21.52-18.29-50.12-11.87-51.83-11.25-105.74-1.52-105.86 4.68-114.649 10.59-114.179m38.44 563.898 1.25 2.23m.04 0 .62 1.06m224.38 15.07-224.38-15.07m951.76 15.35 224.18-15.16m0 0 .7-1.25m.04 0 1.25-2.23M2630.43 286.52l12.27 21.019 21.91 43.512 19.18 45.59 17.23 47.621 15.31 49.57 13.9 50.969 13.01 51.801 11.68 52.347 9.61 52.383 8.09 50.816 6.64 50.864m-1256.72 0 2.73-22.192 13.64-88.711 8.24-44.648 9.84-44.57 22.5-88.161 12.58-42.82 28.63-82.07 23.13-52.891 27.54-50.429m1107.89 516.492.31-.043m-1257.34 0 .31.043m992.5 612.498-.24 37.34-.35 37.15m-727.11 0-.35-36.37-.23-38.12m.7 79.06-.04-1.02-.04-1.09-.04-2.46m2.74 72.73-1.33-32.22-1.29-35.94m726.88 0-1.29 35.74-1.33 32.42m2.73-72.73-.04 1.41v1.29l-.07 1.87m-950.39 28.83-27.35-23.75-23.71-29.26-23.91-43.4-17.93-47.77-4.21-14.45m131.36 178.98-34.25-20.35m586.95 90.78-212.81-7.31-106.8-9.29-105.98-15.71-28.12-5.82-50.12-13.39-48.87-18.91m1105.39 0-58.28 22.11-61.01 14.8-61.96 10.2-17.96 2.42-72.08 8.05-140.54 9.69-140.86 3.16m586.95-90.78-34.26 20.35m131.37-178.98-14.57 44.18-19.61 42.1-20.04 30.51-24.49 26.76-16.29 13.52-2.11 1.56m-947.77 39.33c.35 1.96 1.48 3.99 3.47 4.89.59.5 1.61.86 2.11 1.17l1.68.7 1.76.43m351.8 21.25-122.31-2.3-111.13-6.68-118.36-12.27m703.6 0 1.75-.43 1.68-.7 1.68-.82 1.49-1.13 1.33-1.57 1.09-2.54m-9.02 7.19-118.36 12.27-111.14 6.68-122.3 2.3m-684.06-226.4-.36-3.32-6.25-30.51m1381.29.11-6.32 32.58-.24 1.14M1693.52 161.09l-24.61 6.25-57.07 21.101-40.47 20.739-37.46 25.191-34.18 29.848-29.65 33.672-32.81 49.808-26.72 53.391-22.15 54.808-27.66 84.262-21.99 86.36-31.6 176.839-17.42 179.762-2.97 120.399 4.29 120.43 13.44 120.46 18.67 89.5 28.32 86.91 18.79 41.68 22.74 39.37 27.46 36.65 32.11 32.38 35.82 27.69 39.18 23.48 41.37 19.14 42.69 15.27 88.36 21.68 89.84 13.91 180.28 15 180.78 3.4m0 0 181.76-3.44 181.17-15.19 67.5-9.97 66.52-13.67 64.73-19.22 62.3-27.26 39.22-23.63 35.9-27.89 32.07-32.58 27.38-36.72 22.66-39.57 18.75-41.84 28.09-86.68 18.43-88.98 13.44-120.86 4.22-121.02-3.09-120.86-11.83-135.149-19.81-133.242-28.04-131.219-39.81-128.16-22.5-55.121L2863.01 345 2830 295.66l-29.92-33.43-34.22-29.421-37.46-24.797-40.51-20.512-56.99-20.738-22.66-5.711M1786.76 1415.51l.23-17.62.28-12.62m727.38.28.15 12.34.24 17.62",
        style: {
            fill: "none",
            stroke: fill,
            strokeWidth: 35,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
        },
        transform: "matrix(.13333 0 0 -.13333 0 601.333)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M1976.48 3323.52c.36.7 26.92 46.56 58.99 101.91l58.36 100.59 15.23 16.95 9.81 5.39 9.84 5.43 11.09 1.83 11.1 1.88 12.19-2.27 12.18-2.22 19.38-11.64 7.42-9.03 7.42-8.98 57.66-99.45c31.72-54.73 57.93-99.96 58.28-100.59l.59-1.09h-42l-5.9 10.19c-23.16 40.08-98.47 169.85-100.42 173.01-5.9 9.73-16.06 15.55-27.04 15.51-2.93 0-9.96-1.37-11.71-2.31-6.14-3.2-8.75-5.23-11.96-9.25-2.42-3.09-17.3-28.4-56.25-95.67l-52.97-91.48h-41.95z",
        style: {
            fill: fill,
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        transform: "matrix(.13333 0 0 -.13333 0 601.333)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M1976.48 3323.52c.36.7 26.92 46.56 58.99 101.91l58.36 100.59 15.23 16.95 9.81 5.39 9.84 5.43 11.09 1.83 11.1 1.88 12.19-2.27 12.18-2.22 19.38-11.64 7.42-9.03 7.42-8.98 57.66-99.45c31.72-54.73 57.93-99.96 58.28-100.59l.59-1.09h-42l-5.9 10.19c-23.16 40.08-98.47 169.85-100.42 173.01-5.9 9.73-16.06 15.55-27.04 15.51-2.93 0-9.96-1.37-11.71-2.31-6.14-3.2-8.75-5.23-11.96-9.25-2.42-3.09-17.3-28.4-56.25-95.67l-52.97-91.48h-41.95z",
        style: {
            fill: "none",
            stroke: fill,
            strokeWidth: 3,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
        },
        transform: "matrix(.13333 0 0 -.13333 0 601.333)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M1800.51 3019.69c0 .11 27.89 48.24 61.95 106.91l61.92 106.72 7.57 9.1 7.54 9.1 10.12 6.02 10.12 6.05 12.54 2.11 12.53 2.07 10.71-2.07 10.66-2.07 9.49-5.51 9.46-5.5 7.3-8.36c3.99-4.61 7.93-9.49 8.75-10.82.82-1.37 19.73-37.93 41.99-81.25 45.39-88.36 43.44-84.89 50.98-90 4.34-2.97 6.72-3.87 14.06-5.28 3.79-.7 9.96.43 15.12 2.78 3.67 1.68 5.12 2.65 8.16 5.58 2 2 4.38 4.69 5.24 6.02.86 1.33 19.69 37.62 41.8 80.62l40.19 78.21 7.11 9.61 7.15 9.61 9.61 6.44 9.57 6.41 11.76 2.93 11.71 2.93 11.41-1.57 11.37-1.56 9.61-4.88 9.61-4.92 8.12-8.05c6.56-6.56 8.6-8.87 10.82-12.5 3.52-5.74 124.73-214.57 124.73-214.92 0-.12-9.41-.2-20.98-.12l-20.97.12-56.57 97.5c-31.13 53.63-57.5 98.75-58.59 100.27-3.36 4.61-6.91 7.85-11.25 10.28-3.55 1.95-4.73 2.34-9.49 3.12-5 .82-5.71.82-9.46.2-2.96-.55-5.27-1.33-8.55-2.97-3.83-1.92-5.12-2.89-8.28-6.21-4.49-4.73.15 4.02-49.03-91.8l-37.14-72.42-14.07-18.75-9.64-6.49-9.65-6.44-11.1-2.82c-6.64-1.64-12.14-2.77-13.59-2.77-1.37 0-7.27.82-13.13 1.8l-10.62 1.83-9.73 5.32-9.72 5.35-7.46 8.2c-4.11 4.49-8.01 9.03-8.68 10.08-.7 1.02-19.72 37.85-42.3 81.8-32.74 63.71-41.72 80.82-44.18 84.18-2.7 3.67-3.75 4.68-7.62 7.22-4.02 2.66-5.04 3.09-9.96 4.26-5.15 1.25-5.78 1.29-9.73.82-8.47-.98-17.34-6.37-22.1-13.44-.98-1.48-27.31-46.72-58.52-100.5l-56.72-97.82-20.98-.04c-11.52 0-20.97.12-20.97.28z",
        style: {
            fill: fill,
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none"
        },
        transform: "matrix(.13333 0 0 -.13333 0 601.333)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M1800.51 3019.69c0 .11 27.89 48.24 61.95 106.91l61.92 106.72 7.57 9.1 7.54 9.1 10.12 6.02 10.12 6.05 12.54 2.11 12.53 2.07 10.71-2.07 10.66-2.07 9.49-5.51 9.46-5.5 7.3-8.36c3.99-4.61 7.93-9.49 8.75-10.82.82-1.37 19.73-37.93 41.99-81.25 45.39-88.36 43.44-84.89 50.98-90 4.34-2.97 6.72-3.87 14.06-5.28 3.79-.7 9.96.43 15.12 2.78 3.67 1.68 5.12 2.65 8.16 5.58 2 2 4.38 4.69 5.24 6.02.86 1.33 19.69 37.62 41.8 80.62l40.19 78.21 7.11 9.61 7.15 9.61 9.61 6.44 9.57 6.41 11.76 2.93 11.71 2.93 11.41-1.57 11.37-1.56 9.61-4.88 9.61-4.92 8.12-8.05c6.56-6.56 8.6-8.87 10.82-12.5 3.52-5.74 124.73-214.57 124.73-214.92 0-.12-9.41-.2-20.98-.12l-20.97.12-56.57 97.5c-31.13 53.63-57.5 98.75-58.59 100.27-3.36 4.61-6.91 7.85-11.25 10.28-3.55 1.95-4.73 2.34-9.49 3.12-5 .82-5.71.82-9.46.2-2.96-.55-5.27-1.33-8.55-2.97-3.83-1.92-5.12-2.89-8.28-6.21-4.49-4.73.15 4.02-49.03-91.8l-37.14-72.42-14.07-18.75-9.64-6.49-9.65-6.44-11.1-2.82c-6.64-1.64-12.14-2.77-13.59-2.77-1.37 0-7.27.82-13.13 1.8l-10.62 1.83-9.73 5.32-9.72 5.35-7.46 8.2c-4.11 4.49-8.01 9.03-8.68 10.08-.7 1.02-19.72 37.85-42.3 81.8-32.74 63.71-41.72 80.82-44.18 84.18-2.7 3.67-3.75 4.68-7.62 7.22-4.02 2.66-5.04 3.09-9.96 4.26-5.15 1.25-5.78 1.29-9.73.82-8.47-.98-17.34-6.37-22.1-13.44-.98-1.48-27.31-46.72-58.52-100.5l-56.72-97.82-20.98-.04c-11.52 0-20.97.12-20.97.28z",
        style: {
            fill: "none",
            stroke: fill,
            strokeWidth: 3,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
        },
        transform: "matrix(.13333 0 0 -.13333 0 601.333)"
    })));
};
var $6e6e1a58815cffa1$export$2e2bcd8739ae039 = $6e6e1a58815cffa1$var$LunaIcon;

});




parcelRegister("hPpPu", function(module, exports) {
$parcel$export(module.exports, "SelectButton", function () { return (parcelRequire("1zWXi")).SelectButton; });
parcelRequire("1zWXi");

});
parcelRegister("1zWXi", function(module, exports) {

$parcel$export(module.exports, "SelectButton", function () { return $6df2beb636148f25$export$115094ee16241d93; });

var $7E7Dk = parcelRequire("7E7Dk");

var $cpfnh = parcelRequire("cpfnh");

var $76MyM = parcelRequire("76MyM");

var $jmSj6 = parcelRequire("jmSj6");
const $6df2beb636148f25$export$115094ee16241d93 = ({ id: id, label: label, ariaLabel: ariaLabel, value: value, options: options, onChange: onChange, disabledReason: disabledReason, className: className, containerClassName: containerClassName, fullWidth: fullWidth = false, optionClassName: optionClassName, optionContentClassName: optionContentClassName, optionLabelClassName: optionLabelClassName, optionTestId: optionTestId, showSelectedCheckmark: showSelectedCheckmark = false, ...props })=>{
    const lockRef = (0, $7E7Dk.useRef)(null);
    const labelId = `${id}-label`;
    const disabledReasonId = `${id}-disabled-reason`;
    const hasCustomOptionContent = showSelectedCheckmark || Boolean(optionContentClassName) || options.some((option)=>option.icon);
    const hasDisabledOptions = options.some((option)=>option.disabled !== undefined);
    const renderOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("inline-flex align-items-center gap-2", optionContentClassName)
        }, option.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: option.icon,
            "aria-hidden": "true"
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, option.label), showSelectedCheckmark && Object.is(value, option.value) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: "pi pi-check",
            "aria-hidden": "true"
        }) : null);
    const handleChange = ({ value: nextValue })=>{
        const isOptionValue = options.some((option)=>Object.is(option.value, nextValue));
        if (nextValue !== undefined && (nextValue !== null || isOptionValue)) onChange(nextValue);
    };
    const selectButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jmSj6.SelectButton), {
        ...props,
        id: id,
        value: value,
        options: options,
        optionLabel: "label",
        optionValue: "value",
        optionDisabled: hasDisabledOptions ? "disabled" : undefined,
        allowEmpty: false,
        "aria-label": ariaLabel,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": props.disabled && disabledReason ? disabledReasonId : props["aria-describedby"],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(fullWidth ? "flex w-full" : "inline-flex", className),
        itemTemplate: hasCustomOptionContent ? renderOption : undefined,
        pt: {
            button: (passThroughOptions)=>{
                const option = passThroughOptions?.context.option;
                const state = {
                    selected: passThroughOptions?.context.selected ?? false,
                    disabled: passThroughOptions?.context.disabled ?? false
                };
                return {
                    "data-testid": optionTestId?.(option),
                    style: options.length === 1 ? {
                        minWidth: "4.75rem"
                    } : undefined,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("surface-border font-normal white-space-nowrap flex-1 justify-content-center", {
                        "bg-green-300 text-900": state.selected
                    }, typeof optionClassName === "function" ? optionClassName(option, state) : optionClassName)
                };
            },
            label: {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("font-normal", optionLabelClassName)
            }
        },
        onChange: handleChange
    });
    const selectButtonWithDisabledReason = props.disabled && disabledReason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("inline-flex align-items-center gap-2", {
            "w-full": fullWidth
        })
    }, selectButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cpfnh.Tooltip), {
        target: lockRef,
        content: disabledReason,
        event: "both"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        ref: lockRef,
        tabIndex: 0,
        role: "img",
        "aria-label": disabledReason,
        className: "inline-flex flex-shrink-0 align-items-center justify-content-center surface-100 border-round px-3 py-3 text-color-secondary cursor-help"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-lock",
        "aria-hidden": "true"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        hidden: true,
        id: disabledReasonId
    }, disabledReason)) : selectButton;
    if (!label) return selectButtonWithDisabledReason;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("flex flex-column", containerClassName)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "p-label",
        id: labelId
    }, label), selectButtonWithDisabledReason);
};

});
parcelRegister("jmSj6", function(module, exports) {

$parcel$export(module.exports, "SelectButton", function () { return $e19a32a58f2b9ae2$export$115094ee16241d93; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");

var $1PxL0 = parcelRequire("1PxL0");
"use client";
function $e19a32a58f2b9ae2$var$_extends() {
    return $e19a32a58f2b9ae2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e19a32a58f2b9ae2$var$_extends.apply(null, arguments);
}
function $e19a32a58f2b9ae2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e19a32a58f2b9ae2$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e19a32a58f2b9ae2$var$_arrayLikeToArray(r);
}
function $e19a32a58f2b9ae2$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e19a32a58f2b9ae2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e19a32a58f2b9ae2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e19a32a58f2b9ae2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e19a32a58f2b9ae2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e19a32a58f2b9ae2$var$_toConsumableArray(r) {
    return $e19a32a58f2b9ae2$var$_arrayWithoutHoles(r) || $e19a32a58f2b9ae2$var$_iterableToArray(r) || $e19a32a58f2b9ae2$var$_unsupportedIterableToArray(r) || $e19a32a58f2b9ae2$var$_nonIterableSpread();
}
function $e19a32a58f2b9ae2$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e19a32a58f2b9ae2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e19a32a58f2b9ae2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e19a32a58f2b9ae2$var$_slicedToArray(r, e) {
    return $e19a32a58f2b9ae2$var$_arrayWithHoles(r) || $e19a32a58f2b9ae2$var$_iterableToArrayLimit(r, e) || $e19a32a58f2b9ae2$var$_unsupportedIterableToArray(r, e) || $e19a32a58f2b9ae2$var$_nonIterableRest();
}
var $e19a32a58f2b9ae2$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $7nrKB.classNames)("p-selectbutton p-button-group p-component", {
            "p-invalid": props.invalid
        });
    },
    button: function button(_ref2) {
        var props = _ref2.itemProps, focusedState = _ref2.focusedState;
        return (0, $7nrKB.classNames)("p-button p-component", {
            "p-highlight": props.selected,
            "p-disabled": props.disabled,
            "p-focus": focusedState
        });
    },
    label: "p-button-label p-c"
};
var $e19a32a58f2b9ae2$var$SelectButtonBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "SelectButton",
        id: null,
        value: null,
        options: null,
        optionLabel: null,
        optionValue: null,
        optionDisabled: null,
        tabIndex: null,
        multiple: false,
        invalid: false,
        unselectable: true,
        allowEmpty: true,
        disabled: false,
        style: null,
        className: null,
        dataKey: null,
        tooltip: null,
        tooltipOptions: null,
        itemTemplate: null,
        onChange: null,
        children: undefined
    },
    css: {
        classes: $e19a32a58f2b9ae2$var$classes
    }
});
var $e19a32a58f2b9ae2$var$SelectButtonItem = /*#__PURE__*/ $7E7Dk.memo(function(props) {
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $e19a32a58f2b9ae2$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                selected: props.selected,
                disabled: props.disabled,
                option: props.option
            }
        });
    };
    var _onClick = function onClick(event, index) {
        props.setFocusedIndex(index);
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: props.option
        });
    };
    var onFocus = function onFocus() {
        setFocusedState(true);
    };
    var onBlur = function onBlur() {
        setFocusedState(false);
    };
    var _onKeyDown = function onKeyDown(event, index) {
        switch(event.code){
            case "Space":
                _onClick(event, index);
                event.preventDefault();
                break;
            case "ArrowDown":
            case "ArrowRight":
                changeTabIndexes(event, "next");
                event.preventDefault();
                break;
            case "ArrowUp":
            case "ArrowLeft":
                changeTabIndexes(event, "prev");
                event.preventDefault();
                break;
        }
    };
    var changeTabIndexes = function changeTabIndexes(event, direction) {
        var firstTabableChild;
        var index;
        for(var i = 0; i <= props.elementRef.current.children.length - 1; i++)if (props.elementRef.current.children[i].getAttribute("tabindex") === "0") firstTabableChild = {
            elem: props.elementRef.current.children[i],
            index: i
        };
        if (direction === "prev") {
            if (firstTabableChild.index === 0) index = props.elementRef.current.children.length - 1;
            else index = firstTabableChild.index - 1;
        } else if (firstTabableChild.index === props.elementRef.current.children.length - 1) index = 0;
        else index = firstTabableChild.index + 1;
        props.setFocusedIndex(index);
        props.elementRef.current.children[index].focus();
    };
    var createContent = function createContent() {
        var labelProps = mergeProps({
            className: cx("label")
        }, getPTOptions("label"));
        return props.template ? (0, $7nrKB.ObjectUtils).getJSXElement(props.template, props.option) : /*#__PURE__*/ $7E7Dk.createElement("span", labelProps, props.label);
    };
    var content = createContent();
    var buttonProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("button", {
            itemProps: props,
            focusedState: focusedState
        })),
        role: "button",
        "aria-label": props.label,
        "aria-pressed": props.selected,
        onClick: function onClick(event) {
            return _onClick(event, props.index);
        },
        onKeyDown: function onKeyDown(event) {
            return _onKeyDown(event, props.index);
        },
        tabIndex: props.tabIndex,
        "aria-disabled": props.disabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, getPTOptions("button"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", buttonProps, content, !props.disabled && /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
});
$e19a32a58f2b9ae2$var$SelectButtonItem.displayName = "SelectButtonItem";
var $e19a32a58f2b9ae2$export$115094ee16241d93 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $e19a32a58f2b9ae2$var$SelectButtonBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(0), _React$useState2 = $e19a32a58f2b9ae2$var$_slicedToArray(_React$useState, 2), focusedIndex = _React$useState2[0], setFocusedIndex = _React$useState2[1];
    var elementRef = $7E7Dk.useRef(null);
    var _SelectButtonBase$set = $e19a32a58f2b9ae2$var$SelectButtonBase.setMetaData({
        props: props
    }), ptm = _SelectButtonBase$set.ptm, cx = _SelectButtonBase$set.cx, isUnstyled = _SelectButtonBase$set.isUnstyled;
    (0, $kHEnT.useHandleStyle)($e19a32a58f2b9ae2$var$SelectButtonBase.css.styles, isUnstyled, {
        name: "selectbutton",
        styled: true
    });
    var onOptionClick = function onOptionClick(event) {
        if (props.disabled || isOptionDisabled(event.option)) return;
        var selected = isSelected(event.option);
        if (selected && !(props.unselectable && props.allowEmpty)) return;
        var optionValue = getOptionValue(event.option);
        var newValue;
        if (props.multiple) {
            var currentValue = props.value ? $e19a32a58f2b9ae2$var$_toConsumableArray(props.value) : [];
            newValue = selected ? currentValue.filter(function(val) {
                return !(0, $7nrKB.ObjectUtils).equals(val, optionValue, props.dataKey);
            }) : [].concat($e19a32a58f2b9ae2$var$_toConsumableArray(currentValue), [
                optionValue
            ]);
        } else newValue = selected ? null : optionValue;
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: newValue,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: newValue
            }
        });
    };
    var getOptionLabel = function getOptionLabel(option) {
        return props.optionLabel ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionLabel) : option && option.label !== undefined ? option.label : option;
    };
    var getOptionValue = function getOptionValue(option) {
        return props.optionValue ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionValue) : option && option.value !== undefined ? option.value : option;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $7nrKB.ObjectUtils).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var isSelected = function isSelected(option) {
        var optionValue = getOptionValue(option);
        if (props.multiple) {
            if (props.value && props.value.length) return props.value.some(function(val) {
                return (0, $7nrKB.ObjectUtils).equals(val, optionValue, props.dataKey);
            });
        } else return (0, $7nrKB.ObjectUtils).equals(props.value, optionValue, props.dataKey);
        return false;
    };
    var createItems = function createItems() {
        if (props.options && props.options.length) return props.options.map(function(option, index) {
            var isDisabled = props.disabled || isOptionDisabled(option);
            var optionLabel = getOptionLabel(option);
            var tabIndex = props.disabled || index !== focusedIndex ? "-1" : "0";
            var selected = isSelected(option);
            var key = optionLabel + "_" + index;
            return /*#__PURE__*/ $7E7Dk.createElement($e19a32a58f2b9ae2$var$SelectButtonItem, {
                hostName: "SelectButton",
                key: key,
                label: optionLabel,
                className: option.className,
                option: option,
                setFocusedIndex: setFocusedIndex,
                onClick: onOptionClick,
                template: props.itemTemplate,
                selected: selected,
                tabIndex: tabIndex,
                index: index,
                disabled: isDisabled,
                ptm: ptm,
                cx: cx,
                elementRef: elementRef
            });
        });
        return null;
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focusFirstElement(elementRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var items = createItems();
    var rootProps = mergeProps({
        ref: elementRef,
        id: props.id,
        className: (0, $7nrKB.classNames)(props.className, cx("root")),
        style: props.style,
        role: "group"
    }, $e19a32a58f2b9ae2$var$SelectButtonBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, items, props.children), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $e19a32a58f2b9ae2$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$e19a32a58f2b9ae2$export$115094ee16241d93.displayName = "SelectButton";

});









parcelRegister("33umL", function(module, exports) {
$parcel$export(module.exports, "ChargePointCapiAuraControlWidget", function () { return (parcelRequire("fbWYz")).ChargePointCapiAuraControlWidget; });
parcelRequire("fbWYz");

});
parcelRegister("fbWYz", function(module, exports) {

$parcel$export(module.exports, "ChargePointCapiAuraControlWidget", function () { return $35746fc7d21601da$export$463c38e520c1ef95; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $r38ZI = parcelRequire("r38ZI");

var $1O9Jh = parcelRequire("1O9Jh");
parcelRequire("9oiYv");
var $1kiAJ = parcelRequire("1kiAJ");
parcelRequire("aOtT6");
var $8jOMy = parcelRequire("8jOMy");
parcelRequire("aXjyL");
var $dKubr = parcelRequire("dKubr");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");

var $5u6k9 = parcelRequire("5u6k9");
function $35746fc7d21601da$export$463c38e520c1ef95({ chargePoint: initialChargePoint, userId: userId, isReadOnly: isReadOnly = false, className: className, style: style }) {
    (0, $7E7Dk.useEffect)(()=>setChargePoint(initialChargePoint), [
        initialChargePoint
    ]);
    const text = (0, $5u6k9.default)();
    const isOnline = initialChargePoint.chargePointStatus !== "Offline";
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: initialChargePoint.id
    });
    const [chargePoint, setChargePoint] = (0, $7E7Dk.useState)(initialChargePoint);
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const applyChargePoint = async (val)=>{
        try {
            const tempChargePoint = {
                ...chargePoint,
                ...val
            };
            await updateChargePoint({
                chargePoint: {
                    ...chargePoint,
                    ...val
                }
            }).unwrap();
            setChargePoint(tempChargePoint);
        } catch (_) {
            (0, $r38ZI.notifyError)(text("msgChargerFailedToUpdate"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblAuraControl",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, chargePoint?.connectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, chargePoint?.connectors?.map((connector, index)=>(0, $8jOMy.isUserHasAccessToConnector)(connector, chargePoint.ownerId, userId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1kiAJ.CapiAuraConnectorControl), {
            key: `capi-control-${index}`,
            connector: connector,
            applyChargePoint: applyChargePoint,
            isReadOnly: isReadOnly,
            isOnline: isOnline,
            chargePoint: chargePoint,
            greenChargingStatus: chargePointStatus?.greenChargingStatus
        })), (0, $8jOMy.isUserHasAccessToAnyConnector)(chargePoint.connectors, chargePoint.ownerId, userId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dKubr.RemoteCapiDimmerControl), {
        chargePoint: chargePoint,
        applyChargePoint: applyChargePoint,
        isReadOnly: isReadOnly
    })));
}

});
parcelRegister("9oiYv", function(module, exports) {
$parcel$export(module.exports, "CapiAuraConnectorControl", function () { return (parcelRequire("1kiAJ")).CapiAuraConnectorControl; });
parcelRequire("1kiAJ");

});
parcelRegister("1kiAJ", function(module, exports) {

$parcel$export(module.exports, "CapiAuraConnectorControl", function () { return $a7c63650eee9831b$export$36ac427523793f54; });

var $7E7Dk = parcelRequire("7E7Dk");

var $ilUpc = parcelRequire("ilUpc");

var $igvrl = parcelRequire("igvrl");
parcelRequire("1jrD6");
var $peQdw = parcelRequire("peQdw");
parcelRequire("3j9Ix");
var $hFlAE = parcelRequire("hFlAE");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("7HuGJ");
var $efuUw = parcelRequire("efuUw");
parcelRequire("2dEG5");
var $kX7aL = parcelRequire("kX7aL");

var $5u6k9 = parcelRequire("5u6k9");
function $a7c63650eee9831b$export$36ac427523793f54({ connector: connector, chargePoint: chargePoint, applyChargePoint: applyChargePoint, greenChargingStatus: greenChargingStatus, isOnline: isOnline, isReadOnly: isReadOnly }) {
    const text = (0, $5u6k9.default)();
    const toggleCableLock = async ()=>{
        const tempChargePoint = {
            ...chargePoint,
            connectors: chargePoint.connectors?.map((connectorItem)=>{
                if (connectorItem.connectorId !== connector.connectorId) return connectorItem;
                return {
                    ...connectorItem,
                    cableLocked: !connector.cableLocked
                };
            })
        };
        await applyChargePoint(tempChargePoint);
    };
    const applyConnectorAvailabilityStatus = async (chargingConnector)=>{
        await applyChargePoint((0, $efuUw.toggleConnectorAvailabilityStatus)(chargingConnector, !!greenChargingStatus?.greenChargingOn, chargePoint));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `charger-${chargePoint.id}-connector-${connector.connectorId}`
        }, text(connector.connectorId === 1 ? "lblLeftSocket" : "lblRightSocket")),
        button: connector.mode !== "Schedule" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleText: text(connector.mode === "On" ? "btnSocketIsOn" : "btnSocketIsOff"),
            isToggled: connector.onByUser,
            disabled: isReadOnly,
            toggleFn: ()=>applyConnectorAvailabilityStatus(connector),
            "data-testid": `toggle-charger-${chargePoint.id}-connector-${connector.connectorId}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleText: text(connector.mode === "Schedule" ? "btnChargerIsOnBySchedule" : "btnChargerIsOffBySchedule"),
            isToggled: connector.onBySchedule,
            toggleFn: ()=>applyConnectorAvailabilityStatus(connector),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $peQdw.ClockIcon), {
                size: 18
            }),
            disabled: isReadOnly,
            "data-testid": `toggle-chargerScheduling-${chargePoint.id}-connector-${connector.connectorId}`
        }),
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, isOnline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
            connector: connector,
            isOcpp: chargePoint?.isOcpp,
            key: connector?.connectorId,
            showConsumption: true
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hFlAE.RemoteCapiNfcControl), {
        chargePoint: chargePoint,
        selectedConnector: connector,
        isReadOnly: isReadOnly,
        applyChargePoint: applyChargePoint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `calbeLockTitle-${chargePoint.id}-connector-${connector.connectorId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCableLock"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: connector.cableLocked,
            toggleFn: ()=>toggleCableLock(),
            disabled: isReadOnly,
            "data-testid": `toggle-cablelock-${chargePoint.id}-connector-${connector.connectorId}`
        })
    }));
}

});
parcelRegister("1jrD6", function(module, exports) {
$parcel$export(module.exports, "ClockIcon", function () { return (parcelRequire("peQdw")).ClockIcon; });
parcelRequire("peQdw");

});
parcelRegister("peQdw", function(module, exports) {

$parcel$export(module.exports, "ClockIcon", function () { return $a397813cbe2fafbd$export$8099ab97743c966c; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
const $a397813cbe2fafbd$var$SSPan = (0, $gRonV.default).span`
    display: flex;
    align-items: center;
`;
function $a397813cbe2fafbd$export$8099ab97743c966c({ fill: fill, size: size = 14, title: title, dataTestid: dataTestid, id: id = "clock-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a397813cbe2fafbd$var$SSPan, {
        title: title,
        id: id,
        "data-testid": dataTestid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-clock"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("polyline", {
        points: "12 6 12 12 16 14"
    })));
}

});


parcelRegister("3j9Ix", function(module, exports) {
$parcel$export(module.exports, "RemoteCapiNfcControl", function () { return (parcelRequire("hFlAE")).RemoteCapiNfcControl; });
parcelRequire("hFlAE");

});
parcelRegister("hFlAE", function(module, exports) {

$parcel$export(module.exports, "RemoteCapiNfcControl", function () { return $bc671b682a77811d$export$551262232c5df4ce; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $gRonV = parcelRequire("gRonV");

var $ilUpc = parcelRequire("ilUpc");

var $r38ZI = parcelRequire("r38ZI");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $eIymc = parcelRequire("eIymc");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("b1Qo2");
var $7Xfdd = parcelRequire("7Xfdd");

var $jtrK9 = parcelRequire("jtrK9");
parcelRequire("1cTx9");
var $3uHTN = parcelRequire("3uHTN");

var $5u6k9 = parcelRequire("5u6k9");
const $bc671b682a77811d$var$SNfcDisabledIcon = (0, $gRonV.default).span`
    color: #888888;
    font-size: 21px;
`;
const $bc671b682a77811d$var$SNfcDisabledText = (0, $gRonV.default).span`
    font-size: 13px;
    font-weight: var(--font-weight-extra-bold);
    text-transform: uppercase;
    color: #888888;
`;
function $bc671b682a77811d$export$551262232c5df4ce({ chargePoint: chargePoint, selectedConnector: selectedConnector, isReadOnly: isReadOnly, applyChargePoint: applyChargePoint }) {
    const text = (0, $5u6k9.default)();
    const toggleNfcStatus = async ()=>{
        await applyChargePoint({
            connectors: chargePoint?.connectors?.map((connector)=>{
                if (connector.connectorId !== selectedConnector?.connectorId) return connector;
                return {
                    ...connector,
                    nfcLocked: !connector.nfcLocked
                };
            }),
            id: chargePoint.id
        });
    };
    const [remoteStart] = (0, $1O9Jh.useChargePointRemoteStartMutation)();
    const [selectRfidDialogIsOpen, setSelectRfidDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const handleRemoteStart = async (rfidTag)=>{
        await remoteStart({
            chargePointId: chargePoint.id,
            connectorId: selectedConnector?.connectorId ?? 1,
            rfidTag: rfidTag
        }).unwrap().then(()=>(0, $r38ZI.notifySuccess)(text("msgRemoteStartSuccess"))).catch(()=>(0, $r38ZI.notifyError)(text("msgRemoteStartFailed")));
    };
    const handleRemoteControl = async ()=>{
        if (selectedConnector?.nfcLocked) setSelectRfidDialogIsOpen(true);
        else if (selectedConnector && selectedConnector.defaultNfcTagId) handleRemoteStart(selectedConnector.defaultNfcTagId);
        else (0, $r38ZI.notifyError)(text("msgRemoteStartFailed"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": selectedConnector ? `rfid-${chargePoint.id}-connector-${selectedConnector.connectorId}` : `rfid-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDLock"
        })),
        button: chargePoint.nfcEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.default), {
            isToggled: !!selectedConnector?.nfcLocked,
            disabled: isReadOnly,
            toggleFn: toggleNfcStatus,
            "data-testid": selectedConnector ? `nfc-${chargePoint.id}-connector-${selectedConnector.connectorId}` : `nfc-${chargePoint.id}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7Xfdd.SToggleButton), {
            disabled: true,
            "data-testid": selectedConnector ? `nfcDisabled-${chargePoint.id}-connector-${selectedConnector.connectorId}` : `nfcDisabled-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($bc671b682a77811d$var$SNfcDisabledIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("fa fa-toggle-off")
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($bc671b682a77811d$var$SNfcDisabledText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "btnOff"
        }))),
        status: (0, $eIymc.isSupportDomain) && selectedConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: handleRemoteControl,
            label: text("btnRFIDStart"),
            icon: "pi pi-play-circle",
            "data-testid": `rfid-${(0, $jtrK9.isLeftConnector)(selectedConnector?.connectorId) ? "left" : "right"}-btn`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3uHTN.SelectRfidTagDialog), {
        visible: selectRfidDialogIsOpen,
        chargePointId: chargePoint.id,
        connectorId: selectedConnector?.connectorId ?? 1,
        onStartCharging: (rfidTag)=>{
            handleRemoteStart(rfidTag);
            setSelectRfidDialogIsOpen(false);
        },
        onHide: ()=>setSelectRfidDialogIsOpen(false)
    }));
}

});
parcelRegister("b1Qo2", function(module, exports) {
$parcel$export(module.exports, "SToggleButton", function () { return (parcelRequire("7Xfdd")).SToggleButton; });
parcelRequire("7Xfdd");

});
parcelRegister("7Xfdd", function(module, exports) {

$parcel$export(module.exports, "SToggleButton", function () { return $a2d27232844305af$export$f2d52db5bc740d8d; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $76MyM = parcelRequire("76MyM");

var $igvrl = parcelRequire("igvrl");
const $a2d27232844305af$export$f2d52db5bc740d8d = (0, $gRonV.default).button`
    display: flex;
    align-items: center;
    gap: 3px;
    background: none;
    border: none;
    flex-wrap: wrap;
    padding: 0px;
`;
const $a2d27232844305af$export$f01c1a460ac9059d = (0, $gRonV.default).div`
    font-size: 21px;
    color: ${({ isOn: isOn, theme: theme })=>isOn ? theme.font.successColor : theme.font.errorColor};
`;
const $a2d27232844305af$export$163ba4779384292a = (0, $gRonV.default).div`
    line-height: 1;
    font-weight: var(--font-weight-bold);
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    text-transform: uppercase;
    margin-top: 4px;
`;
function $a2d27232844305af$export$d2b052e7b4be1756({ isOn: isOn, onClick: onClick, title: title, isReadOnly: isReadOnly, testid: testid, hideText: hideText }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a2d27232844305af$export$f2d52db5bc740d8d, {
        title: title,
        onClick: onClick,
        disabled: isReadOnly,
        "data-testid": `toggle-${testid}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a2d27232844305af$export$f01c1a460ac9059d, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("fa", isOn ? "fa-toggle-on" : "fa-toggle-off"),
        isOn: isOn,
        "data-testid": `toggleIcon-${testid}`
    }), !hideText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a2d27232844305af$export$163ba4779384292a, {
        isOn: isOn,
        "data-testid": `toggleText-${testid}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: isOn ? "btnOn" : "btnOff"
    })));
}

});


parcelRegister("jtrK9", function(module, exports) {

$parcel$export(module.exports, "isLeftConnector", function () { return $7b114e03fa01bc55$export$d2e69bfe2aad508a; });
const $7b114e03fa01bc55$export$d2e69bfe2aad508a = (connectorId)=>connectorId === 1;
// TODO: Add typing for [connectors]
const $7b114e03fa01bc55$var$findLeftConnector = (connectors)=>{
    if (!connectors || !connectors.length) return null;
    return connectors.find((connector)=>$7b114e03fa01bc55$export$d2e69bfe2aad508a(connector.connectorId)) || null;
};
var $7b114e03fa01bc55$export$2e2bcd8739ae039 = $7b114e03fa01bc55$var$findLeftConnector;

});



parcelRegister("7HuGJ", function(module, exports) {
$parcel$export(module.exports, "toggleConnectorAvailabilityStatus", function () { return (parcelRequire("efuUw")).toggleConnectorAvailabilityStatus; });
parcelRequire("efuUw");

});
parcelRegister("efuUw", function(module, exports) {

$parcel$export(module.exports, "toggleConnectorAvailabilityStatus", function () { return $d84bb23efa89abae$export$4e207f3a1ae016d2; });
parcelRequire("4uFSF");
var $3zjYC = parcelRequire("3zjYC");
function $d84bb23efa89abae$export$4e207f3a1ae016d2(connector, isGreenChargingOn, chargePoint) {
    let selectedConnector = Object.assign(connector);
    if (selectedConnector.mode === (0, $3zjYC.CapiConnectorMode).ON) selectedConnector = {
        ...selectedConnector,
        mode: (0, $3zjYC.CapiConnectorMode).OFF,
        onByUser: false,
        offByUser: true,
        onByUserOrSchedule: false
    };
    else if (selectedConnector.mode === (0, $3zjYC.CapiConnectorMode).OFF && isGreenChargingOn) selectedConnector = {
        ...selectedConnector,
        mode: (0, $3zjYC.CapiConnectorMode).ON,
        onByUser: true,
        offByUser: false,
        onByUserOrSchedule: false
    };
    else if (selectedConnector.mode === (0, $3zjYC.CapiConnectorMode).OFF) selectedConnector = {
        ...selectedConnector,
        mode: (0, $3zjYC.CapiConnectorMode).SCHEDULE,
        isCharging: false,
        onByUser: false,
        offByUser: false,
        onBySchedule: false,
        offBySchedule: true,
        onByUserOrSchedule: false
    };
    else if (selectedConnector.mode === (0, $3zjYC.CapiConnectorMode).SCHEDULE) selectedConnector = {
        ...selectedConnector,
        mode: (0, $3zjYC.CapiConnectorMode).ON,
        onByUser: true,
        offByUser: false,
        onByUserOrSchedule: false
    };
    const connectors = chargePoint?.connectors?.map((connector)=>{
        if (selectedConnector.connectorId !== connector.connectorId) return connector;
        return selectedConnector;
    });
    return {
        ...chargePoint,
        connectors: connectors
    };
}

});
parcelRegister("4uFSF", function(module, exports) {
$parcel$export(module.exports, "CapiConnectorMode", function () { return (parcelRequire("3zjYC")).CapiConnectorMode; });
$parcel$export(module.exports, "ChargePointCapiHaloControlWidget", function () { return (parcelRequire("3zjYC")).ChargePointCapiHaloControlWidget; });
parcelRequire("3zjYC");

});
parcelRegister("3zjYC", function(module, exports) {

$parcel$export(module.exports, "CapiConnectorMode", function () { return $87ec9aa15ac610b4$export$ef1195bfa8c07443; });
$parcel$export(module.exports, "ChargePointCapiHaloControlWidget", function () { return $87ec9aa15ac610b4$export$f6e5649fe68275a4; });

var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $4LjKQ = parcelRequire("4LjKQ");

var $kPOSY = parcelRequire("kPOSY");
parcelRequire("aXjyL");
var $dKubr = parcelRequire("dKubr");
parcelRequire("3j9Ix");
var $hFlAE = parcelRequire("hFlAE");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");
parcelRequire("7HuGJ");
var $efuUw = parcelRequire("efuUw");

var $ilUpc = parcelRequire("ilUpc");

var $r38ZI = parcelRequire("r38ZI");
parcelRequire("1jrD6");
var $peQdw = parcelRequire("peQdw");
parcelRequire("2dEG5");
var $kX7aL = parcelRequire("kX7aL");

var $5u6k9 = parcelRequire("5u6k9");
const $87ec9aa15ac610b4$var$SSocketIcon = (0, $gRonV.default).span`
    left: 4px;
    font-size: 19px;
    position: relative;
    top: 3px;
`;
const $87ec9aa15ac610b4$var$SLightIcon = (0, $gRonV.default).span`
    font-size: 21px;
    position: relative;
    top: 0;
    left: 4px;
`;
var $87ec9aa15ac610b4$export$ef1195bfa8c07443;
(function(CapiConnectorMode) {
    CapiConnectorMode["ON"] = "On";
    CapiConnectorMode["OFF"] = "Off";
    CapiConnectorMode["SCHEDULE"] = "Schedule";
})($87ec9aa15ac610b4$export$ef1195bfa8c07443 || ($87ec9aa15ac610b4$export$ef1195bfa8c07443 = {}));
function $87ec9aa15ac610b4$export$f6e5649fe68275a4({ chargePoint: initialChargePoint, isReadOnly: isReadOnly = false, className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const [chargePoint, setChargePoint] = (0, $7E7Dk.useState)(initialChargePoint);
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const isOnline = chargePoint.chargePointStatus !== "Offline";
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: chargePoint.id
    });
    const chargingConnector = (0, $4LjKQ.default)(chargePoint.connectors ?? []);
    const socketConnector = (0, $kPOSY.default)(chargePoint.connectors ?? []);
    const applyChargePoint = async (value)=>{
        try {
            const tempChargePoint = {
                ...chargePoint,
                ...value
            };
            await updateChargePoint({
                chargePoint: {
                    ...chargePoint,
                    ...value
                }
            }).unwrap();
            setChargePoint(tempChargePoint);
        } catch (_) {
            (0, $r38ZI.notifyError)(text("msgChargerFailedToUpdate"));
        }
    };
    const toggleLightStatus = ()=>{
        try {
            const tempChargePoint = {
                ...chargePoint,
                downLight: !chargePoint.downLight
            };
            updateChargePoint({
                chargePoint: tempChargePoint
            }).unwrap();
            setChargePoint(tempChargePoint);
        } catch (_) {
            (0, $r38ZI.notifyError)(text("msgFailToUpdateDownlight"));
        }
    };
    const applyConnectorAvailabilityStatus = (chargingConnector)=>{
        try {
            const tempChargePoint = (0, $efuUw.toggleConnectorAvailabilityStatus)(chargingConnector, !!chargePointStatus?.greenChargingStatus?.greenChargingOn, chargePoint);
            updateChargePoint({
                chargePoint: tempChargePoint
            });
            setChargePoint(tempChargePoint);
        } catch (_) {
            (0, $r38ZI.notifyError)(text("msgFailToUpdateConnectorStatus"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblHaloControlWidget",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, chargingConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `charger-${chargePoint.id}`
        }, text("lblCharger")),
        button: chargingConnector.mode !== "Schedule" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: chargingConnector.onByUser,
            disabled: isReadOnly,
            toggleFn: ()=>applyConnectorAvailabilityStatus(chargingConnector),
            "data-testid": `charger-${chargePoint.id}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: chargingConnector.onBySchedule,
            toggleFn: ()=>applyConnectorAvailabilityStatus(chargingConnector),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $peQdw.ClockIcon), {
                size: 18
            }),
            disabled: isReadOnly,
            "data-testid": `chargerScheduling-${chargePoint.id}`
        }),
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, isOnline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
            connector: chargingConnector,
            isOcpp: chargePoint?.isOcpp,
            key: chargingConnector?.connectorId,
            showConsumption: true
        }))
    }), socketConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `socketText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblSocket"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($87ec9aa15ac610b4$var$SSocketIcon, {
            className: "icon-socket",
            "data-testid": `socketIcon-${chargePoint.id}`
        }))),
        button: socketConnector.mode !== "Schedule" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: socketConnector.onByUser,
            disabled: isReadOnly,
            toggleFn: ()=>applyConnectorAvailabilityStatus(socketConnector),
            "data-testid": `socket-${chargePoint.id}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: socketConnector.onBySchedule,
            toggleFn: ()=>applyConnectorAvailabilityStatus(socketConnector),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $peQdw.ClockIcon), {
                size: 18
            }),
            disabled: isReadOnly,
            "data-testid": `socketScheduling-${chargePoint.id}`
        }),
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": "connstate-value"
        }, isOnline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
            connector: socketConnector,
            isOcpp: chargePoint?.isOcpp,
            key: chargingConnector?.connectorId
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `lightText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblLight"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($87ec9aa15ac610b4$var$SLightIcon, {
            className: "fa fa-lightbulb-o",
            "data-testid": `lightIcon-${chargePoint.id}`
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            isToggled: chargePoint.downLight ?? false,
            disabled: isReadOnly,
            toggleFn: toggleLightStatus,
            "data-testid": `light-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dKubr.RemoteCapiDimmerControl), {
        chargePoint: chargePoint,
        isReadOnly: isReadOnly,
        applyChargePoint: applyChargePoint
    }), chargePoint.nfcEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hFlAE.RemoteCapiNfcControl), {
        chargePoint: chargePoint,
        selectedConnector: chargingConnector,
        isReadOnly: isReadOnly,
        applyChargePoint: applyChargePoint
    }));
}

});
parcelRegister("kPOSY", function(module, exports) {

$parcel$export(module.exports, "IsSchukoConnector", function () { return $725766172d725ebb$export$7d2d81dd10ffbc2c; });
$parcel$export(module.exports, "default", function () { return $725766172d725ebb$export$2e2bcd8739ae039; });
const $725766172d725ebb$export$7d2d81dd10ffbc2c = (connector)=>connector?.connectorFunctionType === "Schuko";
const $725766172d725ebb$var$findSchukoConnector = (connectors)=>connectors?.find($725766172d725ebb$export$7d2d81dd10ffbc2c);
var $725766172d725ebb$export$2e2bcd8739ae039 = $725766172d725ebb$var$findSchukoConnector;

});

parcelRegister("aXjyL", function(module, exports) {
$parcel$export(module.exports, "RemoteCapiDimmerControl", function () { return (parcelRequire("dKubr")).RemoteCapiDimmerControl; });
parcelRequire("dKubr");

});
parcelRegister("dKubr", function(module, exports) {

$parcel$export(module.exports, "RemoteCapiDimmerControl", function () { return $219174b0c983bd70$export$f8ac2cbb647b12bc; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");

var $igvrl = parcelRequire("igvrl");
parcelRequire("idbtm");
var $jjP9q = parcelRequire("jjP9q");

var $5u6k9 = parcelRequire("5u6k9");
var $219174b0c983bd70$var$CapiDimmerState;
(function(CapiDimmerState) {
    CapiDimmerState[CapiDimmerState["OFF"] = 0] = "OFF";
    CapiDimmerState[CapiDimmerState["LOW"] = 8] = "LOW";
    CapiDimmerState[CapiDimmerState["MEDIUM"] = 64] = "MEDIUM";
    CapiDimmerState[CapiDimmerState["HIGH"] = 255] = "HIGH";
})($219174b0c983bd70$var$CapiDimmerState || ($219174b0c983bd70$var$CapiDimmerState = {}));
function $219174b0c983bd70$export$f8ac2cbb647b12bc({ chargePoint: chargePoint, isReadOnly: isReadOnly, applyChargePoint: applyChargePoint }) {
    const text = (0, $5u6k9.default)();
    const getDimmerValueText = ()=>{
        if (chargePoint.dimmer === 0) return text("lblOff");
        else if (chargePoint.dimmer === 8) return text("lblDimmerValueLow");
        else if (chargePoint.dimmer === 64) return text("lblDimmerValueMed");
        else if (chargePoint.dimmer === 255) return text("lblDimmerValueHigh");
        else return text("btnDimmerValueCustom");
    };
    const changeDimmer = async ()=>{
        let newDimmerValue;
        if (chargePoint.dimmer === 0) newDimmerValue = 8;
        else if (chargePoint.dimmer <= 8) newDimmerValue = 64;
        else if (chargePoint.dimmer <= 64) newDimmerValue = 255;
        else newDimmerValue = 0;
        await applyChargePoint({
            dimmer: newDimmerValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jjP9q.SDimmerButton), {
            isOn: chargePoint.dimmer !== 0,
            onClick: changeDimmer,
            disabled: isReadOnly,
            "data-testid": `dimmer-${chargePoint.id}`
        }, getDimmerValueText()),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `dimmerText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblLEDBrightness"
        }))
    });
}

});


parcelRegister("2dEG5", function(module, exports) {
$parcel$export(module.exports, "SConnectorStatusIcon", function () { return (parcelRequire("kX7aL")).SConnectorStatusIcon; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("kX7aL")).default; });

var $kX7aL = parcelRequire("kX7aL");

});
parcelRegister("kX7aL", function(module, exports) {

$parcel$export(module.exports, "SConnectorStatusIcon", function () { return $7f2644eaaa7a4879$export$3024c0866ddf1db6; });
$parcel$export(module.exports, "default", function () { return $7f2644eaaa7a4879$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $g7dDc = parcelRequire("g7dDc");

var $a9SdK = parcelRequire("a9SdK");

var $dE8RX = parcelRequire("dE8RX");

var $5L4Lm = parcelRequire("5L4Lm");

var $3um4r = parcelRequire("3um4r");
parcelRequire("6jTiL");
var $braoP = parcelRequire("braoP");
parcelRequire("dxLcn");
var $8KtsS = parcelRequire("8KtsS");

var $1O9Jh = parcelRequire("1O9Jh");
parcelRequire("8jKNp");
var $2U3Dz = parcelRequire("2U3Dz");

var $6FRVF = parcelRequire("6FRVF");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");

var $gDiVz = parcelRequire("gDiVz");
const $7f2644eaaa7a4879$export$3024c0866ddf1db6 = (0, $gRonV.default).span`
    font-size: 1.5em;
    color: ${({ color: color })=>{
    switch(color){
        case "yellow":
            return "#ffcc4c";
        case "green":
            return "#00c400";
        case "darkGreen":
            return "#006c5c";
        case "blue":
            return "#2277dd";
        case "red":
            return "#dd0000";
        case "gray":
            return "#888888";
        default:
            return "#000000";
    }
}};
`;
function $7f2644eaaa7a4879$var$ConnectorStatus({ connector: connector, isOcpp: isOcpp, labeled: labeled, showErrorStatus: showErrorStatus, showConsumption: showConsumption, productId: productId, connectorTopLimitation: connectorTopLimitation }) {
    const text = (0, $5u6k9.default)();
    const state = (0, $7E7Dk.useMemo)(()=>connector && (0, $8KtsS.getConnectorState)(connector, isOcpp), [
        connector,
        isOcpp
    ]);
    const toggleOverlay = (0, $7E7Dk.useRef)(null);
    const getErrorcode = (0, $7E7Dk.useCallback)((externalError, errorCode)=>{
        switch(externalError){
            case (0, $gDiVz.ErrorCode).ConnectorLockFailure:
                return text("errorConnectorLockFailure");
            case (0, $gDiVz.ErrorCode).GroundFailure:
                return text("errorGroundFailure");
            case (0, $gDiVz.ErrorCode).HighTemperature:
                return text("errorHighTemperature");
            case (0, $gDiVz.ErrorCode).OverCurrentFailure:
                return text("errorOverCurrentFailure");
            case (0, $gDiVz.ErrorCode).PowerMeterFailure:
                return text("errorPowerMeterFailure");
            case (0, $gDiVz.ErrorCode).UnderVoltage:
                return text("errorUnderVoltage");
            case (0, $gDiVz.ErrorCode).EvSignalingError:
                return text("errorEvSignalingError");
            case (0, $gDiVz.ErrorCode).InternalError:
                return text("errorInternalError");
            default:
                return (externalError ? externalError : errorCode) ?? undefined;
        }
    }, [
        text
    ]);
    const { data: errorCodeInfo } = (0, $1O9Jh.useTroubleshootingGetErrorCodeTroubleshootingInfoQuery)({
        productId: productId,
        errorCode: connector?.errorCode ?? ""
    }, {
        skip: !isOcpp || connector?.errorCode === "NoError"
    });
    const showErrorStatusIcon = connector?.errorCode !== "NoError" && !showErrorStatus && errorCodeInfo;
    const showErrorInfo = showErrorStatus && connector?.errorCode !== "NoError" && errorCodeInfo;
    const showChargingLimitation = !showErrorInfo && connectorTopLimitation;
    const userInstructions = errorCodeInfo?.instructions?.map((instruction, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            key: `${instruction}-${index}`,
            className: "flex flex-column gap-4 p-1 pl-2"
        }, (0, $6FRVF.getErrorcodeInstructions)(instruction));
    });
    const icon = (0, $7E7Dk.useMemo)(()=>{
        switch(state){
            case (0, $8KtsS.ConnectorState).AVAILABLE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-check text-green-300 font-bold",
                    title: text("lblConnectorAvailableStatus"),
                    "data-testid": `status-available-${connector?.name}`
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo.externalErrorCode, connector?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).PREPARING:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faEllipsisH),
                    color: "#23c421",
                    title: text("lblConnectorPreparingStatus"),
                    "data-testid": "status-preparing",
                    "aria-labelledby": "color",
                    titleId: "icon"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).CONNECTED:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faEllipsisH),
                    color: "#23c421",
                    title: text("lblConnectorConnectedToEVStatus"),
                    "data-testid": "status-connected",
                    "aria-labelledby": "color",
                    titleId: "icon"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).CHARGING:
                return showConsumption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2U3Dz.ConnectorChargingInfo), {
                    connector: connector
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faBolt),
                    color: "#2277dd",
                    title: text("lblConnectorChargingStatus"),
                    "data-testid": "status-charging",
                    className: "mt-1 pointer"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).PAUSED_BY_CHARGER:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faPause),
                    color: "#2277dd",
                    title: text("lblConnectorPausedByChargerStatus"),
                    "data-testid": "pausedByCharger-status"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).PAUSED_BY_VEHICLE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
                    title: text("lblConnectorPausedByVehicleStatus")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $braoP.IconSuspendedEv), {
                    width: 23,
                    height: 12
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).FINISHING:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faEllipsisH),
                    color: "#888888",
                    title: text("lblConnectorFinishingStatus"),
                    "data-testid": "finishing-status"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).RESERVED:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faLock),
                    color: "#888888",
                    title: text("lblConnectorReservedStatus"),
                    "data-testid": "reserved-status"
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).UNAVAILABLE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-times text-gray-500 font-bold",
                    title: text("lblConnectorNotAvailableStatus")
                }), showErrorStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-exclamation-triangle text-yellow-500 pointer",
                    title: getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode)
                }));
            case (0, $8KtsS.ConnectorState).FAULTED:
                return !showErrorStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faExclamation),
                    color: "#dd2222",
                    title: connector?.errorCode && !showErrorStatus ? getErrorcode(connector?.errorCode) : text("lblConnectorErrorStatus"),
                    "data-testid": "faulted-status"
                });
            default:
                return !showErrorStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g7dDc.FontAwesomeIcon), {
                    icon: (0, $a9SdK.faExclamation),
                    className: "pointer",
                    color: "#dd2222",
                    title: connector?.errorCode && !showErrorStatus ? getErrorcode(connector?.errorCode) : text("lblConnectorErrorStatus"),
                    "data-testid": "fa-exclamation"
                });
        }
    }, [
        state,
        text,
        connector,
        showErrorStatusIcon,
        getErrorcode,
        errorCodeInfo,
        showConsumption,
        showErrorStatus
    ]);
    const getConnectorStatusLabel = (state)=>{
        return ({
            [(0, $8KtsS.ConnectorState).AVAILABLE]: text("lblConnectorAvailableStatus"),
            [(0, $8KtsS.ConnectorState).PREPARING]: text("lblConnectorPreparingStatus"),
            [(0, $8KtsS.ConnectorState).CHARGING]: text("lblConnectorChargingStatus"),
            [(0, $8KtsS.ConnectorState).CONNECTED]: text("lblConnectorConnectedToEVStatus"),
            [(0, $8KtsS.ConnectorState).FAULTED]: text("lblConnectorErrorStatus"),
            [(0, $8KtsS.ConnectorState).FINISHING]: text("lblConnectorFinishingStatus"),
            [(0, $8KtsS.ConnectorState).PAUSED_BY_CHARGER]: text("lblConnectorPausedByChargerStatus"),
            [(0, $8KtsS.ConnectorState).PAUSED_BY_VEHICLE]: text("lblConnectorPausedByVehicleStatus"),
            [(0, $8KtsS.ConnectorState).RESERVED]: text("lblConnectorReservedStatus"),
            [(0, $8KtsS.ConnectorState).UNAVAILABLE]: text("lblConnectorNotAvailableStatus")
        })[state ?? -1];
    };
    const getConnectorChargingLimitationLabel = (limitation)=>{
        const labels = {
            LoadbalancerCurrentLimitScheme: text("lblLoadbalancerCurrentLimitSchemeChargingLimitation"),
            MdOfflineFallback: text("lblMdOfflineFallbackChargingLimitation"),
            UserCurrentLimitZero: text("lblUserCurrentLimitZeroChargingLimitation"),
            Schedule: text("lblScheduleChargingLimitation"),
            AvailableCurrent: text("lblAvailableCurrentChargingLimitation"),
            GreenCharging: text("lblGreenChargingChargingLimitation")
        };
        return labels[limitation];
    };
    const showLeftContent = labeled && state !== undefined || showChargingLimitation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-row gap-2 w-12 text-md justify-content-between"
    }, showLeftContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-center align-items-center gap-4"
    }, labeled && state !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "mb-0"
    }, getConnectorStatusLabel(state)), showChargingLimitation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        "data-testid": "charging-limitation-message",
        severity: "warn",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: "pi pi-exclamation-triangle mr-1"
        }), getConnectorChargingLimitationLabel(connectorTopLimitation.factor)),
        className: "flex align-items-center text-xs p-2 ml-1 sm:text-sm"
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-row text-md align-items-center gap-4"
    }, showErrorInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        "data-testid": "error-status-message",
        severity: connector?.ocppStatus === "Faulted" && connector?.errorCode ? "error" : "warn",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: "pi pi-exclamation-triangle mr-1"
        }), getErrorcode(errorCodeInfo?.externalErrorCode, errorCodeInfo?.errorCode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: "custom-target-icon-error pi pi-question-circle ml-1 pointer",
            "data-pr-classname": "col-3",
            onMouseEnter: (e)=>toggleOverlay.current?.toggle(e)
        })),
        className: "flex align-items-center text-xs p-2 ml-1 sm:text-sm"
    })), icon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5L4Lm.OverlayPanel), {
        ref: toggleOverlay,
        className: "border-400 mr-5 sm:max-w-17rem"
    }, userInstructions && userInstructions.length > 0 ? userInstructions : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "ml-2 mr-2 flex align-items-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-whatsapp"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lbllinkSupport"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        to: text("linkHelpCenter"),
        target: "_blank",
        "data-testid": "go-to-support-page",
        className: "pi pi-external-link text-xs mt-1"
    }))));
}
var $7f2644eaaa7a4879$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($7f2644eaaa7a4879$var$ConnectorStatus);

});
parcelRegister("6jTiL", function(module, exports) {
$parcel$export(module.exports, "IconSuspendedEv", function () { return (parcelRequire("braoP")).IconSuspendedEv; });
parcelRequire("braoP");

});
parcelRegister("braoP", function(module, exports) {

$parcel$export(module.exports, "IconSuspendedEv", function () { return $31d9b10bceb772a4$export$c04e20156b9faab0; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
const $31d9b10bceb772a4$export$c04e20156b9faab0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function IconSuspendedEv({ color: color = "#2277DD", width: width = 57, height: height = 36, className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 57 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "icon-suspended-ev"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1C0 0.447716 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V35C12 35.5523 11.5523 36 11 36H1C0.447715 36 0 35.5523 0 35V1ZM33 30.125H45.3125V32.0625C45.3125 34.2371 47.0754 36 49.25 36C51.4247 36 53.1875 34.2371 53.1875 32.0625V30.125H56.5625V17.625C56.5625 15.9681 55.2194 14.625 53.5625 14.625H50.9375L48.4569 3.87573C47.9333 1.60706 45.9132 0 43.585 0H33V5.625H43.0625L45.3125 14.625H33V30.125ZM49.25 25.875C51.4247 25.875 53.1875 24.1121 53.1875 21.9375C53.1875 19.7629 51.4247 18 49.25 18C47.0754 18 45.3125 19.7629 45.3125 21.9375C45.3125 24.1121 47.0754 25.875 49.25 25.875ZM17 0C16.4477 0 16 0.447716 16 1V35C16 35.5523 16.4477 36 17 36H27C27.5523 36 28 35.5523 28 35V1C28 0.447715 27.5523 0 27 0H17Z",
        fill: color
    }));
});

});


parcelRegister("8jKNp", function(module, exports) {
$parcel$export(module.exports, "ConnectorChargingInfo", function () { return (parcelRequire("2U3Dz")).ConnectorChargingInfo; });
parcelRequire("2U3Dz");

});
parcelRegister("2U3Dz", function(module, exports) {

$parcel$export(module.exports, "ConnectorChargingInfo", function () { return $81680c04dae32167$export$e347c5c39a854b49; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $5L4Lm = parcelRequire("5L4Lm");

var $igvrl = parcelRequire("igvrl");
parcelRequire("2dEG5");
var $kX7aL = parcelRequire("kX7aL");
const $81680c04dae32167$var$SContainer = (0, $gRonV.default).div`
    display: flex;
    gap: 4px;
    align-items: center;
    padding-bottom: 3px;
`;
const $81680c04dae32167$var$SCurrent = (0, $gRonV.default).div`
    padding: 8px;
    border-top: 1px solid #dddddd;
`;
function $81680c04dae32167$export$e347c5c39a854b49({ connector: connector }) {
    const [isConnectorCurrentShown, setIsConnectorCurrentShown] = (0, $7E7Dk.useState)(false);
    const op = (0, $7E7Dk.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($81680c04dae32167$var$SContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.SConnectorStatusIcon), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("fa fa-flash"),
        color: "blue",
        "data-testid": "status-charging"
    }), connector?.totalConsumptionKwh?.toFixed(1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        "data-testid": "consumption"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblKWh"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.SConnectorStatusIcon), {
        onClick: (e)=>{
            op.current?.toggle(e);
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("fa pointer", isConnectorCurrentShown ? "fa-caret-up" : "fa-caret-down")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5L4Lm.OverlayPanel), {
        ref: op,
        onHide: ()=>setIsConnectorCurrentShown(false),
        onShow: ()=>setIsConnectorCurrentShown(true),
        pt: {
            content: {
                className: "p-0"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($81680c04dae32167$var$SCurrent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblL1",
        values: {
            current1: connector?.current1?.toFixed(1),
            voltage1: connector?.voltage1?.toFixed(1)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($81680c04dae32167$var$SCurrent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblL2",
        values: {
            current2: connector?.current2?.toFixed(1),
            voltage2: connector?.voltage2?.toFixed(1)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($81680c04dae32167$var$SCurrent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblL3",
        values: {
            current3: connector?.current3?.toFixed(1),
            voltage3: connector?.voltage3?.toFixed(1)
        }
    })))));
}

});


parcelRegister("6FRVF", function(module, exports) {

$parcel$export(module.exports, "getErrorcodeInstructions", function () { return $09282dbe8024edd1$export$f57d640a26232462; });

var $7E7Dk = parcelRequire("7E7Dk");

var $igvrl = parcelRequire("igvrl");

var $eIymc = parcelRequire("eIymc");

var $gDiVz = parcelRequire("gDiVz");
const $09282dbe8024edd1$export$f57d640a26232462 = (errorInstruction)=>{
    let instructionTranslationKey = "errorInstruction" + errorInstruction;
    if (((0, $eIymc.isSupportDomain) || (0, $eIymc.isPartnerDomain)) && (errorInstruction === (0, $gDiVz.ErrorCodeInstructions).ContactSupport || errorInstruction === (0, $gDiVz.ErrorCodeInstructions).IfProblemRemainsContactSupport)) instructionTranslationKey = "errorInstruction" + errorInstruction + "ForPartnerAndSupport";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2 align-items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-check-circle text-green-500"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: instructionTranslationKey
    }));
};
const $09282dbe8024edd1$export$9a97ff7837082710 = (error)=>{
    if (error === "NoOngoingSession") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "NoOngoingSession"
    });
    if (error === "NoScheduleForConnector") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "NoScheduleForConnector"
    });
    if (error === "OverridingScheduleExists") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "OverridingScheduleExists"
    });
    if (error === "OtherInvalid") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgIgnoreScheduleFailed"
    });
};

});
parcelRegister("gDiVz", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $53344de320cebfaf$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "ErrorCodeInstructions", function () { return $53344de320cebfaf$export$71333513509a2fbd; });
var $53344de320cebfaf$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ConnectorLockFailure"] = "ConnectorLockFailure";
    ErrorCode["GroundFailure"] = "GroundFailure";
    ErrorCode["HighTemperature"] = "HighTemperature";
    ErrorCode["InternalError"] = "InternalError";
    ErrorCode["OverCurrentFailure"] = "OverCurrentFailure";
    ErrorCode["PowerMeterFailure"] = "PowerMeterFailure";
    ErrorCode["UnderVoltage"] = "UnderVoltage";
    ErrorCode["EvSignalingError"] = "EvSignalingError";
})($53344de320cebfaf$export$d4e71bc0b80dc0fb || ($53344de320cebfaf$export$d4e71bc0b80dc0fb = {}));
var $53344de320cebfaf$export$71333513509a2fbd;
(function(ErrorCodeInstructions) {
    ErrorCodeInstructions["FirmlyInsertCableInCharger"] = "FirmlyInsertCableInCharger";
    ErrorCodeInstructions["CheckRcbo"] = "CheckRcbo";
    ErrorCodeInstructions["CheckCableCondition"] = "CheckCableCondition";
    ErrorCodeInstructions["ConnectedEvChargingOverLimit"] = "ConnectedEvChargingOverLimit";
    ErrorCodeInstructions["CheckSupplyOnAllPhases"] = "CheckSupplyOnAllPhases";
    ErrorCodeInstructions["HighTemperatureInfo"] = "HighTemperatureInfo";
    ErrorCodeInstructions["RestartCharger"] = "RestartCharger";
    ErrorCodeInstructions["RestartChargingSession"] = "RestartChargingSession";
    ErrorCodeInstructions["ContactSupport"] = "ContactSupport";
    ErrorCodeInstructions["IfProblemRemainsContactSupport"] = "IfProblemRemainsContactSupport";
})($53344de320cebfaf$export$71333513509a2fbd || ($53344de320cebfaf$export$71333513509a2fbd = {}));

});












parcelRegister("9Lv7o", function(module, exports) {
$parcel$export(module.exports, "ChargePointOcppHaloControlWidget", function () { return (parcelRequire("k9R3A")).ChargePointOcppHaloControlWidget; });
parcelRequire("k9R3A");

});
parcelRegister("k9R3A", function(module, exports) {

$parcel$export(module.exports, "ChargePointOcppHaloControlWidget", function () { return $d1257e7dab00aaca$export$6514c3bc5dc92d89; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $c9GjL = parcelRequire("c9GjL");

var $igvrl = parcelRequire("igvrl");

var $4LjKQ = parcelRequire("4LjKQ");

var $kPOSY = parcelRequire("kPOSY");
parcelRequire("2NaMI");
var $a7txM = parcelRequire("a7txM");
parcelRequire("dxLcn");
var $8KtsS = parcelRequire("8KtsS");

var $kGLxT = parcelRequire("kGLxT");
parcelRequire("gRHjN");
var $jsfFW = parcelRequire("jsfFW");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");
parcelRequire("idbtm");
var $jjP9q = parcelRequire("jjP9q");

var $7xC39 = parcelRequire("7xC39");

var $1O9Jh = parcelRequire("1O9Jh");

var $ilUpc = parcelRequire("ilUpc");
parcelRequire("1cTx9");
var $3uHTN = parcelRequire("3uHTN");

var $eIymc = parcelRequire("eIymc");
parcelRequire("5DZBN");
var $2KaGD = parcelRequire("2KaGD");

var $6GGmy = parcelRequire("6GGmy");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");

var $1gy6g = parcelRequire("1gy6g");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
const $d1257e7dab00aaca$var$KEY_DOWN_LIGHT = "Downlight";
var $d1257e7dab00aaca$var$LightState;
(function(LightState) {
    LightState["ON"] = "1";
    LightState["OFF"] = "0";
})($d1257e7dab00aaca$var$LightState || ($d1257e7dab00aaca$var$LightState = {}));
var $d1257e7dab00aaca$var$NfcLockState;
(function(NfcLockState) {
    NfcLockState["ON"] = "false";
    NfcLockState["OFF"] = "true";
})($d1257e7dab00aaca$var$NfcLockState || ($d1257e7dab00aaca$var$NfcLockState = {}));
function $d1257e7dab00aaca$export$6514c3bc5dc92d89({ isReadOnly: isReadOnly = false, chargePoint: chargePoint }) {
    const text = (0, $5u6k9.default)();
    const [configKeys, setConfigKeys] = (0, $7E7Dk.useState)(()=>chargePoint.ocppConfigKeys ?? []);
    const [chargingConnector, setChargingConnector] = (0, $7E7Dk.useState)((0, $4LjKQ.default)(chargePoint.connectors ?? []));
    const [socketConnector, setSocketConnector] = (0, $7E7Dk.useState)((0, $kPOSY.default)(chargePoint.connectors ?? []));
    const toast = (0, $eBlmY.useToast)();
    const { data: schedules } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id
    }, {
        pollingInterval: (0, $1gy6g.CHARGE_POINT_REFRESH_TIMEOUT)
    });
    const connectorHasSchedule = (connectorId)=>{
        return schedules?.some((schedule)=>schedule.connectorId === connectorId);
    };
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    const [saveConfigKey] = (0, $1O9Jh.useOcppCommandUpdateConfigKeyMutation)();
    const [remoteStart] = (0, $1O9Jh.useChargePointRemoteStartMutation)();
    const [remoteStop] = (0, $1O9Jh.useChargePointRemoteStopMutation)();
    const [overrideSchedule] = (0, $1O9Jh.useChargePointOverrideScheduleForOngoingChargingSessionMutation)();
    const [selectRfidDialogIsOpen, setSelectRfidDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const isOnline = chargePoint.chargePointStatus !== "Offline";
    const isLightOn = (0, $a7txM.getConfigValue)($d1257e7dab00aaca$var$KEY_DOWN_LIGHT, configKeys) === "1";
    const isNfcLockOn = (0, $a7txM.getConfigValue)((0, $jsfFW.KEY_FREE_CHARGING), configKeys) === "false";
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: chargePoint.id
    });
    const remoteStartIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStartIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    const remoteStopIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStopIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        setConfigKeys(chargePoint.ocppConfigKeys);
        setChargingConnector((0, $4LjKQ.default)(chargePoint.connectors ?? []));
        setSocketConnector((0, $kPOSY.default)(chargePoint.connectors ?? []));
    }, [
        chargePoint
    ]);
    const toggleOcppConfigValue = async (key, value)=>{
        const updatedConfigKeys = (0, $7xC39.default)(key, value, configKeys);
        if (!updatedConfigKeys) return;
        await saveConfigKey({
            chargePointId: chargePoint.id,
            keyValue: updatedConfigKeys.find((configKeys)=>configKeys.key === key)
        }).unwrap().then(()=>setConfigKeys(updatedConfigKeys)).catch(()=>toast.notifyError(text("msgRemoteControlCommandFailed")));
    };
    const handleRemoteStart = async (rfidTag)=>{
        await remoteStart({
            chargePointId: chargePoint.id,
            connectorId: 1,
            rfidTag: rfidTag
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgRemoteStartSuccess"));
        }).catch(()=>{
            toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStartAdminFailed" : "msgRemoteStartFailed"));
        });
    };
    const handleRemoteControl = async ()=>{
        if (remoteStopIsVisible) await remoteStop({
            chargePointId: chargePoint.id,
            connectorId: 1
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgRemoteStopSuccess"));
        }).catch(()=>{
            toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStopAdminFailed" : "msgRemoteStopAdminFailed"));
        });
        else {
            if (isNfcLockOn) setSelectRfidDialogIsOpen(true);
            else if (chargingConnector?.defaultNfcTagId) handleRemoteStart(chargingConnector?.defaultNfcTagId);
            else toast.notifyError(text("msgRemoteStartFailed"));
        }
    };
    const handleOverrideSchedule = async ()=>{
        await overrideSchedule({
            chargePointId: chargePoint.id,
            connectorId: 1
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgIgnoreScheduleSuccess"));
        }).catch((error)=>{
            toast.notifyError((0, $6GGmy.showErrorMessagesForIgnoreSchedule)(error.data.error));
        });
    };
    const showStartStopChargingButton = !(0, $eIymc.isUserappDomain) && isOnline && (remoteStartIsVisible || remoteStopIsVisible);
    const showIgnoreScheduleButton = !(0, $eIymc.isUserappDomain) && isOnline && remoteStopIsVisible && chargingConnector?.mode == "Schedule";
    const handleConnectorStateChange = (connectorId)=>async (state)=>{
            if (state === "Schedule" && !connectorHasSchedule(connectorId)) return (0, $c9GjL.confirmDialog)({
                header: text("msgNoSchedulesHeader"),
                message: text("msgNoSchedulesText"),
                acceptClassName: "hidden",
                rejectLabel: text("btnClose")
            });
            const connector = connectorId === 1 ? chargingConnector : socketConnector;
            const updatedConnector = {
                ...connector,
                mode: state
            };
            // Optimistically update the UI immediately
            if (connectorId === 1) setChargingConnector(updatedConnector);
            else if (connectorId === 2) setSocketConnector(updatedConnector);
            const updatedChargingConnector = connectorId === 1 ? updatedConnector : chargingConnector;
            const updatedSocketConnector = connectorId === 2 ? updatedConnector : socketConnector;
            const updatedConnectors = [];
            if (updatedChargingConnector) updatedConnectors.push(updatedChargingConnector);
            if (updatedSocketConnector) updatedConnectors.push(updatedSocketConnector);
            try {
                await updateChargePoint({
                    chargePoint: {
                        ...chargePoint,
                        connectors: updatedConnectors
                    }
                }).unwrap();
            } catch (error) {
                // Revert the optimistic update on error
                const originalConnector = connectorId === 1 ? (0, $4LjKQ.default)(chargePoint.connectors ?? []) : (0, $kPOSY.default)(chargePoint.connectors ?? []);
                if (connectorId === 1) setChargingConnector(originalConnector);
                else if (connectorId === 2) setSocketConnector(originalConnector);
                toast.notifyError(text("msgFailedToUpdateAvailability"));
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblHaloControlWidget"
    }, chargingConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `chargerText-${chargePoint.id}`
        }, text("lblCharger")),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
            id: `charger-mode-${chargePoint.id}`,
            ariaLabel: text("lblCharger"),
            options: [
                {
                    label: text("lblOff"),
                    value: "Off"
                },
                {
                    label: text("lblConnectorSchedule"),
                    value: "Schedule"
                },
                {
                    label: text("lblConnectorAlwaysOn"),
                    value: "On"
                }
            ],
            value: chargingConnector?.mode,
            onChange: handleConnectorStateChange(1),
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            className: "w-20rem max-w-full",
            "data-testid": `charger-${chargePoint.id}`
        }),
        remoteChargingControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex gap-2 flex-column sm:flex-row"
        }, showStartStopChargingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: remoteStartIsVisible ? text("lblStartChargingInfo") : text("lblStopSession"),
            size: "small",
            "data-testid": "remote-control-button",
            onClick: handleRemoteControl,
            label: text(remoteStopIsVisible ? "lblStop" : "lblStart"),
            outlined: true,
            severity: "info",
            icon: remoteStopIsVisible ? "pi pi-stop-circle" : "pi pi-play-circle"
        }), showIgnoreScheduleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: text("lblIgnoreSchedule"),
            style: {
                padding: "6px"
            },
            "data-testid": "remote-control-button-ignoreSchedule",
            onClick: handleOverrideSchedule,
            outlined: true,
            severity: "info",
            icon: "pi pi-calendar-times"
        }))
    }), (0, $kGLxT.default)(chargePoint) && socketConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `socketText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblSocket"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
            id: `socket-mode-${chargePoint.id}`,
            ariaLabel: text("lblSocket"),
            options: [
                {
                    label: text("lblOff"),
                    value: "Off"
                },
                {
                    label: text("lblConnectorSchedule"),
                    value: "Schedule"
                },
                {
                    label: text("btnOn"),
                    value: "On"
                }
            ],
            value: socketConnector.mode,
            onChange: handleConnectorStateChange(2),
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            className: "w-20rem max-w-full",
            "data-testid": `socket-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `lightText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblLight",
            "data-testid": `lightText-${chargePoint.id}`
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue($d1257e7dab00aaca$var$KEY_DOWN_LIGHT, isLightOn ? "0" : "1"),
            isToggled: isLightOn,
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            "data-testid": `light-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jjP9q.RemoteOcppDimmerControl), {
        chargePoint: chargePoint,
        isReadOnly: isReadOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `rfidText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDLock"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue((0, $jsfFW.KEY_FREE_CHARGING), isNfcLockOn ? "true" : "false"),
            isToggled: isNfcLockOn,
            disabled: isReadOnly || (0, $2KaGD.onGoingTransactionStates).includes(chargePoint.connectors[0]?.ocppStatus) || !isOnline || chargePoint?.ocppEnabled,
            "data-testid": `rfid-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3uHTN.SelectRfidTagDialog), {
        visible: selectRfidDialogIsOpen,
        chargePointId: chargePoint.id,
        connectorId: chargingConnector?.connectorId ?? 1,
        onStartCharging: (rfidTag)=>{
            handleRemoteStart(rfidTag);
            setSelectRfidDialogIsOpen(false);
        },
        onHide: ()=>setSelectRfidDialogIsOpen(false)
    }));
}

});
parcelRegister("kGLxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f57df16ebd769725$export$2e2bcd8739ae039; });
const $f57df16ebd769725$var$isSchukoEnabled = (chargePoint)=>(chargePoint?.numberOfConnectors ?? 0) > 1;
var $f57df16ebd769725$export$2e2bcd8739ae039 = $f57df16ebd769725$var$isSchukoEnabled;

});



parcelRegister("rLEIN", function(module, exports) {

$parcel$export(module.exports, "AlertType", function () { return $92bb5c3c02c6ab32$export$5b4a8869eb24d061; });
$parcel$export(module.exports, "default", function () { return $92bb5c3c02c6ab32$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
parcelRequire("18mUD");
var $jb3Im = parcelRequire("jb3Im");
parcelRequire("eGqzt");
var $jPnjU = parcelRequire("jPnjU");
var $92bb5c3c02c6ab32$export$5b4a8869eb24d061;
(function(AlertType) {
    AlertType[AlertType["Info"] = 0] = "Info";
    AlertType[AlertType["Warning"] = 1] = "Warning";
    AlertType[AlertType["Error"] = 2] = "Error";
})($92bb5c3c02c6ab32$export$5b4a8869eb24d061 || ($92bb5c3c02c6ab32$export$5b4a8869eb24d061 = {}));
const $92bb5c3c02c6ab32$var$SInlineAlert = (0, $gRonV.default).div`
    border: 1px solid transparent;
    border-radius: 4px;
    color: black;
    display: flex;
    align-items: center;
    gap: ${({ theme: theme })=>theme.sizing.margin.m};
    margin-top: ${({ theme: theme })=>theme.sizing.padding.l};
    margin-bottom: ${({ theme: theme })=>theme.sizing.padding.l};
    overflow: hidden;

    .icon {
        margin-right: ${({ theme: theme })=>theme.sizing.margin.l};
        padding: ${({ theme: theme })=>theme.sizing.padding.m};
    }

    @media screen and (max-width: ${({ theme: theme })=>theme.breakPoints.sm}) {
        flex-wrap: wrap;

        .icon {
            width: 100%;
            margin-right: unset;
        }

        #inline-alert-text {
            margin-left: ${({ theme: theme })=>theme.sizing.margin.s};
            margin-right: ${({ theme: theme })=>theme.sizing.margin.s};
        }

        #inline-alert-btn {
            width: 100%;

            button {
                width: inherit;
            }
        }
    }

    &.error {
        background-color: ${({ theme: theme })=>theme.font.errorColor + "0a"};
        .icon {
            background-color: ${({ theme: theme })=>theme.font.errorColor};
        }
    }

    &.warning {
        background-color: ${({ theme: theme })=>theme.font.warningColor + "0a"};
        .icon {
            background-color: ${({ theme: theme })=>theme.font.warningColor};
        }
    }
    &.info {
        background-color: ${({ theme: theme })=>theme.font.infoColor + "2a"};
        .icon {
            background-color: ${({ theme: theme })=>theme.font.infoColor};
        }
    }
`;
const $92bb5c3c02c6ab32$var$InlineAlert = ({ text: text, alertType: alertType = 0, actionBtn: actionBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($92bb5c3c02c6ab32$var$SInlineAlert, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            warning: alertType === 1,
            error: alertType === 2,
            info: alertType === 0
        }),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "icon"
    }, alertType === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jPnjU.InfoIcon), {
        size: 20,
        fill: "white"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jb3Im.AlertIcon), {
        size: 25,
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        "data-testid": "inline-alert-text",
        id: "inline-alert-text"
    }, text), actionBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        "data-testid": "inline-alert-btn",
        className: "ml-auto flex flex-shrink-0 align-items-center justify-content-end p-2",
        id: "inline-alert-btn"
    }, actionBtn));
};
var $92bb5c3c02c6ab32$export$2e2bcd8739ae039 = $92bb5c3c02c6ab32$var$InlineAlert;

});
parcelRegister("18mUD", function(module, exports) {
$parcel$export(module.exports, "AlertIcon", function () { return (parcelRequire("jb3Im")).AlertIcon; });
parcelRequire("jb3Im");

});
parcelRegister("jb3Im", function(module, exports) {

$parcel$export(module.exports, "AlertIcon", function () { return $4fcc61072557d823$export$4a143c8822a09fb4; });

var $7E7Dk = parcelRequire("7E7Dk");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $hhoFb = parcelRequire("hhoFb");
function $4fcc61072557d823$export$4a143c8822a09fb4({ fill: fill = (0, $3CLIQ.theme).brandColors.CA_Black, size: size = 14, title: title, id: id = "info-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 25 25",
        version: "1.1",
        id: "svg4",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", {
        id: "defs8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: fill,
        d: "m 17.282704,4.5823521 c -1.482,-0.89517 -3.1968,-1.36291 -4.9518,-1.33082 -2.3567896,0.04309 -4.6081896,0.98428 -6.2944096,2.63134 -1.68621,1.64706 -2.67997,3.87571 -2.77841,6.2308099 -0.09844,2.3551 0.70594,4.6589 2.24882,6.4409 1.54288,1.782 3.70784,2.9079 6.0527996,3.1475 2.3449,0.2396 4.6928,-0.4251 6.5643,-1.8582 1.8714,-1.4332 3.1251,-3.5267 3.505,-5.853 0.3728,-2.2826 -0.1232,-4.6204499 -1.3874,-6.5534899 l -0.1684,-0.25754 -1.1067,1.10674 0.1053,0.16865 c 0.9715,1.5546099 1.3555,3.4100399 1.0748,5.2292399 -0.2978,1.9305 -1.3217,3.6744 -2.8623,4.8753 -1.5406,1.2009 -3.4817,1.7681 -5.4266,1.5857 -1.9448296,-0.1825 -3.7465896,-1.1007 -5.0370496,-2.5671 -1.29046,-1.4665 -1.97222,-3.3704 -1.90588,-5.3226 0.06633,-1.95228 0.87575,-3.8054999 2.26277,-5.1809499 1.38702,-1.37545 3.2469596,-2.16928 5.1996596,-2.21926 1.3629,-0.03488 2.6991,0.29438 3.8768,0.93933 l 0.1644,0.09 1.1375,-1.13751 z m -3.7827,10.6676299 h -2 v 2 h 2 z m 0,-7.9999999 h -2 v 6.4999999 h 2 z",
        id: "path2"
    })));
}

});



parcelRegister("f12mB", function(module, exports) {
$parcel$export(module.exports, "ChargePointLunaControlWidget", function () { return (parcelRequire("kRBbO")).ChargePointLunaControlWidget; });
parcelRequire("kRBbO");

});
parcelRegister("kRBbO", function(module, exports) {

$parcel$export(module.exports, "ChargePointLunaControlWidget", function () { return $6c0a06966f3d3cd9$export$ea575826e611232; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $c9GjL = parcelRequire("c9GjL");

var $ilUpc = parcelRequire("ilUpc");
parcelRequire("1cTx9");
var $3uHTN = parcelRequire("3uHTN");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $eIymc = parcelRequire("eIymc");

var $4LjKQ = parcelRequire("4LjKQ");
parcelRequire("2NaMI");
var $a7txM = parcelRequire("a7txM");
parcelRequire("dxLcn");
var $8KtsS = parcelRequire("8KtsS");
parcelRequire("gRHjN");
var $jsfFW = parcelRequire("jsfFW");
parcelRequire("iCzEn");
var $haBsc = parcelRequire("haBsc");
parcelRequire("2fUds");
var $8KPaL = parcelRequire("8KPaL");
parcelRequire("idbtm");
var $jjP9q = parcelRequire("jjP9q");

var $7xC39 = parcelRequire("7xC39");
parcelRequire("5DZBN");
var $2KaGD = parcelRequire("2KaGD");

var $6GGmy = parcelRequire("6GGmy");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
var $6c0a06966f3d3cd9$var$NfcLockState;
(function(NfcLockState) {
    NfcLockState["ON"] = "false";
    NfcLockState["OFF"] = "true";
})($6c0a06966f3d3cd9$var$NfcLockState || ($6c0a06966f3d3cd9$var$NfcLockState = {}));
var $6c0a06966f3d3cd9$var$CableLockState;
(function(CableLockState) {
    CableLockState["ON"] = "true";
    CableLockState["OFF"] = "false";
})($6c0a06966f3d3cd9$var$CableLockState || ($6c0a06966f3d3cd9$var$CableLockState = {}));
function $6c0a06966f3d3cd9$export$ea575826e611232({ isReadOnly: isReadOnly = false, chargePoint: chargePoint }) {
    const text = (0, $5u6k9.default)();
    const [configKeys, setConfigKeys] = (0, $7E7Dk.useState)(chargePoint?.ocppConfigKeys || []);
    const [chargingConnector, setChargingConnector] = (0, $7E7Dk.useState)((0, $4LjKQ.default)(chargePoint?.connectors ?? []) ?? null);
    const [selectRfidDialogIsOpen, setSelectRfidDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const { data: chargePointStatus } = (0, $1O9Jh.useGreenChargingChargePointStatusQuery)({
        chargePointId: chargePoint.id
    });
    const [saveConfigKey] = (0, $1O9Jh.useOcppCommandUpdateConfigKeyMutation)();
    const [remoteStart] = (0, $1O9Jh.useChargePointRemoteStartMutation)();
    const [remoteStop] = (0, $1O9Jh.useChargePointRemoteStopMutation)();
    const isOnline = chargePoint.chargePointStatus !== "Offline";
    const isNfcLockOn = (0, $a7txM.getConfigValue)((0, $jsfFW.KEY_FREE_CHARGING), configKeys) === "false";
    const isCableLockOn = (0, $a7txM.getConfigValue)((0, $jsfFW.KEY_CABLE_LOCK), configKeys) === "true";
    const remoteStartIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStartIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    const remoteStopIsVisible = (0, $7E7Dk.useMemo)(()=>(0, $8KtsS.remoteStopIsAvailable)(chargingConnector), [
        chargingConnector
    ]);
    const [overrideSchedule] = (0, $1O9Jh.useChargePointOverrideScheduleForOngoingChargingSessionMutation)();
    const toast = (0, $eBlmY.useToast)();
    const { data: schedules } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id
    });
    const connectorHasSchedule = (connectorId)=>{
        return schedules?.some((schedule)=>schedule.connectorId === connectorId);
    };
    const [updateChargePoint] = (0, $1O9Jh.useChargePointUpdateMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (chargePoint) {
            setConfigKeys(chargePoint.ocppConfigKeys ?? []);
            setChargingConnector((0, $4LjKQ.default)(chargePoint.connectors ?? []) ?? null);
        }
    }, [
        chargePoint
    ]);
    const toggleOcppConfigValue = async (key, value)=>{
        const updatedConfigKeys = (0, $7xC39.default)(key, value, configKeys);
        if (!(updatedConfigKeys && chargePoint)) return;
        await saveConfigKey({
            chargePointId: chargePoint.id,
            keyValue: updatedConfigKeys.find((configKeys)=>configKeys.key === key)
        }).unwrap().then(()=>setConfigKeys(updatedConfigKeys)).catch(()=>toast.notifyError(text("msgRemoteControlCommandFailed")));
    };
    const handleRemoteStart = async (rfidTag)=>{
        await remoteStart({
            chargePointId: chargePoint.id,
            connectorId: 1,
            rfidTag: rfidTag
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStartSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStartAdminFailed" : "msgRemoteStartFailed")));
    };
    const handleRemoteControl = async ()=>{
        if (remoteStopIsVisible) await remoteStop({
            chargePointId: chargePoint.id,
            connectorId: 1
        }).unwrap().then(()=>toast.notifySuccess(text("msgRemoteStopSuccess"))).catch(()=>toast.notifyError(text((0, $eIymc.isAdminDomain) ? "msgRemoteStopAdminFailed" : "msgRemoteStopFailed")));
        else {
            if (isNfcLockOn) setSelectRfidDialogIsOpen(true);
            else if (chargingConnector?.defaultNfcTagId) handleRemoteStart(chargingConnector?.defaultNfcTagId);
            else toast.notifyError(text("msgRemoteStartFailed"));
        }
    };
    const handleOverrideSchedule = async ()=>{
        await overrideSchedule({
            chargePointId: chargePoint.id,
            connectorId: 1
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgIgnoreScheduleSuccess"));
        }).catch((error)=>{
            toast.notifyError((0, $6GGmy.showErrorMessagesForIgnoreSchedule)(error.data.error));
        });
    };
    const showStartStopChargingButton = !(0, $eIymc.isUserappDomain) && isOnline && (remoteStartIsVisible || remoteStopIsVisible);
    const showIgnoreScheduleButton = !(0, $eIymc.isUserappDomain) && isOnline && remoteStopIsVisible && chargingConnector?.mode === "Schedule";
    const handleConnectorStateChange = (connectorId)=>async (state)=>{
            if (state === "Schedule" && !connectorHasSchedule(connectorId)) return (0, $c9GjL.confirmDialog)({
                header: text("msgNoSchedulesHeader"),
                message: text("msgNoSchedulesText"),
                acceptClassName: "hidden",
                rejectLabel: text("btnClose")
            });
            // Optimistically update the UI immediately
            setChargingConnector((prev)=>prev ? {
                    ...prev,
                    mode: state
                } : prev);
            try {
                await updateChargePoint({
                    chargePoint: {
                        ...chargePoint,
                        connectors: chargePoint.connectors?.map((c)=>c.connectorId === connectorId ? {
                                ...c,
                                mode: state
                            } : c)
                    }
                }).unwrap();
            } catch (error) {
                // Revert the optimistic update on error
                setChargingConnector((0, $4LjKQ.default)(chargePoint.connectors ?? []) ?? null);
                toast.notifyError(text("msgFailedToUpdateAvailability"));
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8KPaL.RemoteControlWidget), {
        greenChargingStatus: chargePointStatus?.greenChargingStatus,
        isReadOnly: isReadOnly,
        chargePoint: chargePoint,
        title: "lblLunaControlOcppWidget"
    }, chargingConnector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `chargerText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCharger"
        })),
        remoteChargingControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex gap-2 flex-column sm:flex-row"
        }, showStartStopChargingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: remoteStartIsVisible ? text("lblStartChargingInfo") : text("lblStopSession"),
            size: "small",
            "data-testid": "remote-control-button",
            onClick: handleRemoteControl,
            label: text(remoteStopIsVisible ? "lblStop" : "lblStart"),
            outlined: true,
            severity: "info",
            icon: remoteStopIsVisible ? "pi pi-stop-circle" : "pi pi-play-circle"
        }), showIgnoreScheduleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            tooltip: text("lblIgnoreSchedule"),
            style: {
                padding: "6px"
            },
            "data-testid": "remote-control-button-ignoreSchedule",
            onClick: handleOverrideSchedule,
            outlined: true,
            severity: "info",
            icon: "pi pi-calendar-times"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
            id: `charger-mode-${chargePoint.id}`,
            ariaLabel: text("lblCharger"),
            options: [
                {
                    label: text("lblOff"),
                    value: "Off"
                },
                {
                    label: text("lblConnectorSchedule"),
                    value: "Schedule"
                },
                {
                    label: text("lblConnectorAlwaysOn"),
                    value: "On"
                }
            ],
            value: chargingConnector.mode,
            onChange: handleConnectorStateChange(1),
            disabled: isReadOnly || !isOnline || chargePoint?.ocppEnabled,
            className: "w-20rem max-w-full",
            "data-testid": `toggle-charger-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `rfidText-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDLock"
        })),
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue((0, $jsfFW.KEY_FREE_CHARGING), isNfcLockOn ? "true" : "false"),
            isToggled: isNfcLockOn,
            disabled: isReadOnly || (0, $2KaGD.onGoingTransactionStates).includes(chargePoint.connectors[0]?.ocppStatus) || !isOnline || chargePoint?.ocppEnabled,
            "data-testid": `toggle-rfid-${chargePoint.id}`
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jjP9q.RemoteOcppDimmerControl), {
        chargePoint: chargePoint,
        isReadOnly: isReadOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $haBsc.RemoteControlRow), {
        button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            toggleFn: ()=>toggleOcppConfigValue((0, $jsfFW.KEY_CABLE_LOCK), isCableLockOn ? "false" : "true"),
            isToggled: isCableLockOn,
            "data-testid": `toggle-cableLock-${chargePoint.id}`,
            disabled: !isOnline || chargePoint?.ocppEnabled
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": `toggleText-cableLock-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblCableLock"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3uHTN.SelectRfidTagDialog), {
        visible: selectRfidDialogIsOpen,
        chargePointId: chargePoint.id,
        connectorId: chargingConnector?.connectorId ?? 1,
        onStartCharging: (rfidTag)=>{
            handleRemoteStart(rfidTag);
            setSelectRfidDialogIsOpen(false);
        },
        onHide: ()=>setSelectRfidDialogIsOpen(false)
    }));
}

});


parcelRegister("7u8z6", function(module, exports) {
$parcel$export(module.exports, "ChargePointStatusWidget", function () { return (parcelRequire("cYvR1")).ChargePointStatusWidget; });
parcelRequire("cYvR1");

});
parcelRegister("cYvR1", function(module, exports) {

$parcel$export(module.exports, "ChargePointStatusWidget", function () { return $80ee87f7090b8f40$export$555a3c75cc9dace2; });

var $7E7Dk = parcelRequire("7E7Dk");

var $bKDGD = parcelRequire("bKDGD");

var $4LjKQ = parcelRequire("4LjKQ");

var $kPOSY = parcelRequire("kPOSY");
parcelRequire("2dEG5");
var $kX7aL = parcelRequire("kX7aL");

var $3rYDT = parcelRequire("3rYDT");

var $1hIPE = parcelRequire("1hIPE");

var $lFIQ9 = parcelRequire("lFIQ9");

var $hohPv = parcelRequire("hohPv");

var $kGLxT = parcelRequire("kGLxT");

var $igvrl = parcelRequire("igvrl");

var $34PLY = parcelRequire("34PLY");
function $80ee87f7090b8f40$export$555a3c75cc9dace2({ chargePoint: chargePoint, nameInTitle: nameInTitle }) {
    const chargingConnector = (0, $4LjKQ.default)(chargePoint?.connectors ?? []);
    const socketConnector = (0, $kPOSY.default)(chargePoint?.connectors ?? []);
    const showSocketStatus = (0, $3rYDT.default)(chargePoint) && (0, $kGLxT.default)(chargePoint) && Boolean(socketConnector);
    const chargerIsOnline = (0, $34PLY.default)(chargePoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bKDGD.Panel), {
        toggleable: true,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, nameInTitle ? chargePoint.name : "", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblStatus"
        }))),
        "data-testid": "charge-point-status-widget"
    }, ((0, $3rYDT.default)(chargePoint) || (0, $hohPv.default)(chargePoint) || (0, $lFIQ9.default)(chargePoint)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column " + (showSocketStatus ? "mb-4" : "mb-0")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-700",
        "data-testid": "charger-status-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblCharger"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "mobile-value",
        className: "mt-2"
    }, chargerIsOnline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
        connector: chargingConnector,
        connectorTopLimitation: chargingConnector?.topLimitingFactor,
        isOcpp: chargePoint?.isOcpp,
        showConsumption: true,
        showErrorStatus: true,
        productId: chargePoint?.productId,
        labeled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblOffline"
    }))), showSocketStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-700",
        "data-testid": "socket-status-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSocket"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "mobile-value",
        className: "mt-2"
    }, chargerIsOnline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
        connector: socketConnector,
        isOcpp: chargePoint?.isOcpp,
        showConsumption: true,
        showErrorStatus: true,
        productId: chargePoint?.productId,
        labeled: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblOffline"
    }))), (0, $1hIPE.default)(chargePoint) && chargePoint?.connectors?.map((connector, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            key: `aura-${connector.connectorId}-${connector.name ?? "connector"}-${index}`,
            className: "flex flex-column " + (connector.connectorId === 1 ? "mb-4" : "mb-0")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "text-700",
            "data-testid": "aura-socket-status-section"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: connector.connectorId === 1 ? "lblLeftSocket" : "lblRightSocket"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": "mobile-value",
            className: "mt-2"
        }, chargerIsOnline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kX7aL.default), {
            connectorTopLimitation: connector.topLimitingFactor,
            connector: connector,
            isOcpp: chargePoint?.isOcpp,
            showConsumption: true,
            showErrorStatus: true,
            productId: chargePoint?.productId,
            labeled: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblOffline"
        })));
    }));
}

});


parcelRegister("eSg49", function(module, exports) {

$parcel$export(module.exports, "SAlert", function () { return $33e02e7f13c81974$export$482b9c7dc6688edd; });
$parcel$export(module.exports, "SActions", function () { return $33e02e7f13c81974$export$bfeb875ada73e906; });
$parcel$export(module.exports, "SConnectorWrapper", function () { return $33e02e7f13c81974$export$fe7b5f279d680a20; });

var $gRonV = parcelRequire("gRonV");

var $g7dDc = parcelRequire("g7dDc");

var $hKZtL = parcelRequire("hKZtL");
const $33e02e7f13c81974$export$482b9c7dc6688edd = (0, $gRonV.default).div`
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: ${({ theme: theme })=>theme.font.darkestColor};

    ${({ type: type, theme: theme })=>{
    if (type === "error") return `
                background-color: ${theme.brandColors.CA_Light_Coral};
            `;
    else if (type === "success") return `
                background-color: ${theme.brandColors.CA_Light_Green};
            `;
    else return `
                background-color: ${theme.brandColors.CA_Mid_Blue};
            `;
}}
`;
const $33e02e7f13c81974$export$3fe6efe730f2f339 = {
    ...(0, $hKZtL.dropdownStyles),
    option: (styles)=>({
            ...styles,
            padding: "10px 10px"
        }),
    singleValue: (styles, state)=>({
            ...styles,
            fontSize: 14,
            color: state.isDisabled ? "#a1a1a1" : "#555555",
            padding: "19px 10px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "100%",
            textOverflow: "ellipsis",
            cursor: "pointer"
        }),
    placeholder: (styles)=>({
            ...styles,
            fontSize: 14,
            color: "#555555",
            padding: "0 10px"
        })
};
const $33e02e7f13c81974$export$84e6e4860f1fd9c = (0, $gRonV.default).input`
    max-width: 100%;
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1em;
    color: #555;
    font-weight: var(--font-weight-light);
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);

    &:disabled {
        cursor: not-allowed;
        background-color: #eee;
        opacity: 1;
    }
`;
const $33e02e7f13c81974$export$31f29fe805867a44 = (0, $gRonV.default).table`
    width: 100%;
    overflow: auto;
    table-layout: fixed;
`;
const $33e02e7f13c81974$export$9441de15316dd32f = (0, $gRonV.default).button`
    color: ${({ theme: theme })=>theme.font.linkColor};
    background: none;
    border: none;
    padding: 0;

    &:hover {
        color: ${({ theme: theme })=>theme.brandColors.CA_Blue};
        text-decoration: underline;
    }
    &:active {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: none;
    }
`;
const $33e02e7f13c81974$export$bfeb875ada73e906 = (0, $gRonV.default).div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 15px;
    margin-top: 20px;
`;
const $33e02e7f13c81974$export$c3be67af907b16c4 = (0, $gRonV.default).p`
    border: 1px solid orange;
    border-radius: 4px;
    padding: 15px;
    color: black;
    font-weight: var(--font-weight-bold);
    background-color: #f9e49c6b;
`;
const $33e02e7f13c81974$export$52ac26c6bddf9b90 = (0, $gRonV.default).div`
    display: flex;
    flex-direction: row;
`;
const $33e02e7f13c81974$export$fe7b5f279d680a20 = (0, $gRonV.default).div`
    display: flex;
    gap: ${({ theme: theme })=>theme.sizing.margin.xl};
`;
const $33e02e7f13c81974$export$e0f1a01cdb377cab = (0, $gRonV.default).div`
    width: 100%;
`;
const $33e02e7f13c81974$export$d0efd35e50779e9a = (0, $gRonV.default).div`
    border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    border-width: 0px 0px 1px 0px;
    width: 100%;
    margin: 20px 0px;
`;
const $33e02e7f13c81974$export$b299b66281555f68 = (0, $gRonV.default)((0, $g7dDc.FontAwesomeIcon))`
    margin-top: 7px;
    font-size: 19px;
`;
const $33e02e7f13c81974$export$4b0426763b2b8935 = (0, $gRonV.default).div`
    display: flex;
    justify-content: space-between;
    gap: 3px;
`;

});
parcelRegister("hKZtL", function(module, exports) {

$parcel$export(module.exports, "dropdownStyles", function () { return $c1137705367db82f$export$b6ce307c6d0f7d96; });

var $gRonV = parcelRequire("gRonV");
const $c1137705367db82f$export$b6ce307c6d0f7d96 = {
    indicatorSeparator: ()=>({
            display: "none"
        }),
    control: (styles, state)=>{
        if (state.selectProps.disabledWidget) return {
            ...styles,
            backgroundColor: state.isDisabled ? "#eeeeee" : "#ffffff",
            borderColor: state.isDisabled ? "#c5c5c5" : "#cccccc"
        };
        return {
            ...styles,
            backgroundColor: state.isDisabled ? "#eeeeee" : "#ffffff",
            borderColor: "#e7e7e7"
        };
    },
    singleValue: (_styles, state)=>{
        if (state.selectProps.disabledWidget) return {
            color: state.isDisabled ? "#000000" : "#555555",
            fontWeight: state.isDisabled ? "var(--font-weight-normal)" : "var(--font-weight-light)"
        };
        return {
            color: state.isDisabled ? "#5b5b5b" : "#555555"
        };
    },
    dropdownIndicator: (styles)=>({
            ...styles,
            color: "#000000"
        })
};
const $c1137705367db82f$export$b7daefd791aed23e = (0, $gRonV.default).div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 5px;
`;
const $c1137705367db82f$export$2a8c3e0df8be1b4a = (0, $gRonV.default).div`
    font-size: 16px;
    font-weight: var(--font-weight-bold);
    padding: 5px 3px;
    color: ${({ theme: theme })=>theme.brandColors.CA_Black};
`;
const $c1137705367db82f$export$105cc70f0549431b = (0, $gRonV.default).span`
    margin-left: 10px;
`;
const $c1137705367db82f$export$88914fc79142f541 = (0, $gRonV.default).div`
    color: #ff0000;
    font-weight: var(--font-weight-bold);
    padding: 0px 5px 10px 5px;
    font-size: 14px;
`;
const $c1137705367db82f$export$626d401ce90fce61 = (0, $gRonV.default).div`
    padding: 5px;
    margin-bottom: 5px;
`;
const $c1137705367db82f$export$12108c20201adae4 = (0, $gRonV.default).div`
    display: ${({ isOpen: isOpen })=>isOpen ? "block" : "none"};
`;

});


parcelRegister("20ecU", function(module, exports) {

$parcel$export(module.exports, "useSessionUser", function () { return $0e4e3048476589bc$export$a69ca7ae03d9fe40; });

var $2rQNl = parcelRequire("2rQNl");
const $0e4e3048476589bc$export$a69ca7ae03d9fe40 = ()=>(0, $2rQNl.useSelector)((state)=>state.user);

});

parcelRegister("cCnqE", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $0bc69b778beb11d3$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "useFormContext", function () { return $0bc69b778beb11d3$export$4d957a5e1be13b03; });
$parcel$export(module.exports, "FormProvider", function () { return $0bc69b778beb11d3$export$8ce1ff4f94d08846; });
$parcel$export(module.exports, "useWatch", function () { return $0bc69b778beb11d3$export$3c773aa2b84f29e0; });
$parcel$export(module.exports, "set", function () { return $0bc69b778beb11d3$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "Controller", function () { return $0bc69b778beb11d3$export$bd0bf19f25da8474; });
$parcel$export(module.exports, "appendErrors", function () { return $0bc69b778beb11d3$export$b196c2a4f765bd30; });
$parcel$export(module.exports, "useForm", function () { return $0bc69b778beb11d3$export$87c0cf8eb5a167e0; });

var $7E7Dk = parcelRequire("7E7Dk");
var $0bc69b778beb11d3$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0bc69b778beb11d3$var$isDateObject = (value1)=>value1 instanceof Date;
var $0bc69b778beb11d3$var$isNullOrUndefined = (value1)=>value1 == null;
const $0bc69b778beb11d3$var$isObjectType = (value1)=>typeof value1 === "object";
var $0bc69b778beb11d3$var$isObject = (value1)=>!$0bc69b778beb11d3$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0bc69b778beb11d3$var$isObjectType(value1) && !$0bc69b778beb11d3$var$isDateObject(value1);
var $0bc69b778beb11d3$var$getEventValue = (event)=>$0bc69b778beb11d3$var$isObject(event) && event.target ? $0bc69b778beb11d3$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0bc69b778beb11d3$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0bc69b778beb11d3$var$isNameInFieldArray = (names, name)=>names.has($0bc69b778beb11d3$var$getNodeParentName(name));
var $0bc69b778beb11d3$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0bc69b778beb11d3$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $0bc69b778beb11d3$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $0bc69b778beb11d3$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0bc69b778beb11d3$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0bc69b778beb11d3$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0bc69b778beb11d3$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0bc69b778beb11d3$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0bc69b778beb11d3$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0bc69b778beb11d3$var$isUndefined = (val)=>val === undefined;
var $0bc69b778beb11d3$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0bc69b778beb11d3$var$isObject(object)) return defaultValue;
    const result = $0bc69b778beb11d3$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0bc69b778beb11d3$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0bc69b778beb11d3$var$isUndefined(result) || result === object ? $0bc69b778beb11d3$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0bc69b778beb11d3$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $0bc69b778beb11d3$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0bc69b778beb11d3$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0bc69b778beb11d3$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0bc69b778beb11d3$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useContext($0bc69b778beb11d3$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0bc69b778beb11d3$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($0bc69b778beb11d3$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0bc69b778beb11d3$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0bc69b778beb11d3$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0bc69b778beb11d3$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0bc69b778beb11d3$var$isEmptyObject = (value1)=>$0bc69b778beb11d3$var$isObject(value1) && !Object.keys(value1).length;
var $0bc69b778beb11d3$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0bc69b778beb11d3$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0bc69b778beb11d3$var$VALIDATION_MODE.all));
};
var $0bc69b778beb11d3$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0bc69b778beb11d3$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0bc69b778beb11d3$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0bc69b778beb11d3$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0bc69b778beb11d3$export$606f11b2eb45ecc6(props) {
    const methods = $0bc69b778beb11d3$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(name);
    _name.current = name;
    $0bc69b778beb11d3$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0bc69b778beb11d3$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0bc69b778beb11d3$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0bc69b778beb11d3$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0bc69b778beb11d3$var$isString = (value1)=>typeof value1 === "string";
var $0bc69b778beb11d3$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0bc69b778beb11d3$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0bc69b778beb11d3$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0bc69b778beb11d3$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0bc69b778beb11d3$export$3c773aa2b84f29e0(props) {
    const methods = $0bc69b778beb11d3$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(name);
    _name.current = name;
    $0bc69b778beb11d3$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0bc69b778beb11d3$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0bc69b778beb11d3$var$cloneObject($0bc69b778beb11d3$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $0bc69b778beb11d3$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0bc69b778beb11d3$var$stringToPath = (input)=>$0bc69b778beb11d3$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $0bc69b778beb11d3$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0bc69b778beb11d3$var$isKey(path) ? [
        path
    ] : $0bc69b778beb11d3$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0bc69b778beb11d3$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0bc69b778beb11d3$export$e8c786024a2b0a79(props) {
    const methods = $0bc69b778beb11d3$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0bc69b778beb11d3$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0bc69b778beb11d3$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0bc69b778beb11d3$export$3988ae62b71be9a3(control._formValues, name, $0bc69b778beb11d3$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0bc69b778beb11d3$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0bc69b778beb11d3$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0bc69b778beb11d3$var$cloneObject($0bc69b778beb11d3$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0bc69b778beb11d3$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0bc69b778beb11d3$var$isUndefined($0bc69b778beb11d3$export$3988ae62b71be9a3(control._formValues, name))) $0bc69b778beb11d3$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if ($0bc69b778beb11d3$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $0bc69b778beb11d3$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$0bc69b778beb11d3$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0bc69b778beb11d3$var$getEventValue(event),
                        name: name
                    },
                    type: $0bc69b778beb11d3$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0bc69b778beb11d3$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0bc69b778beb11d3$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0bc69b778beb11d3$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0bc69b778beb11d3$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0bc69b778beb11d3$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0bc69b778beb11d3$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0bc69b778beb11d3$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0bc69b778beb11d3$export$bd0bf19f25da8474 = (props)=>props.render($0bc69b778beb11d3$export$e8c786024a2b0a79(props));
const $0bc69b778beb11d3$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0bc69b778beb11d3$export$a7fed597f4b8afd8(props) {
    const methods = $0bc69b778beb11d3$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0bc69b778beb11d3$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $0bc69b778beb11d3$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0bc69b778beb11d3$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0bc69b778beb11d3$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0bc69b778beb11d3$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0bc69b778beb11d3$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0bc69b778beb11d3$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0bc69b778beb11d3$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0bc69b778beb11d3$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0bc69b778beb11d3$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0bc69b778beb11d3$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0bc69b778beb11d3$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0bc69b778beb11d3$var$VALIDATION_MODE.onTouched
    });
var $0bc69b778beb11d3$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0bc69b778beb11d3$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $0bc69b778beb11d3$var$iterateFieldsByAction(currentField, action);
            } else if ($0bc69b778beb11d3$var$isObject(currentField)) $0bc69b778beb11d3$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $0bc69b778beb11d3$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0bc69b778beb11d3$var$compact($0bc69b778beb11d3$export$3988ae62b71be9a3(errors, name));
    $0bc69b778beb11d3$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $0bc69b778beb11d3$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0bc69b778beb11d3$var$isFileInput = (element)=>element.type === "file";
var $0bc69b778beb11d3$var$isFunction = (value1)=>typeof value1 === "function";
var $0bc69b778beb11d3$var$isHTMLElement = (value1)=>{
    if (!$0bc69b778beb11d3$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0bc69b778beb11d3$var$isMessage = (value1)=>$0bc69b778beb11d3$var$isString(value1);
var $0bc69b778beb11d3$var$isRadioInput = (element)=>element.type === "radio";
var $0bc69b778beb11d3$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0bc69b778beb11d3$var$defaultResult = {
    value: false,
    isValid: false
};
const $0bc69b778beb11d3$var$validResult = {
    value: true,
    isValid: true
};
var $0bc69b778beb11d3$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0bc69b778beb11d3$var$isUndefined(options[0].attributes.value) ? $0bc69b778beb11d3$var$isUndefined(options[0].value) || options[0].value === "" ? $0bc69b778beb11d3$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0bc69b778beb11d3$var$validResult : $0bc69b778beb11d3$var$defaultResult;
    }
    return $0bc69b778beb11d3$var$defaultResult;
};
const $0bc69b778beb11d3$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0bc69b778beb11d3$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0bc69b778beb11d3$var$defaultReturn) : $0bc69b778beb11d3$var$defaultReturn;
function $0bc69b778beb11d3$var$getValidateError(result, ref, type = "validate") {
    if ($0bc69b778beb11d3$var$isMessage(result) || Array.isArray(result) && result.every($0bc69b778beb11d3$var$isMessage) || $0bc69b778beb11d3$var$isBoolean(result) && !result) return {
        type: type,
        message: $0bc69b778beb11d3$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0bc69b778beb11d3$var$getValueAndMessage = (validationData)=>$0bc69b778beb11d3$var$isObject(validationData) && !$0bc69b778beb11d3$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0bc69b778beb11d3$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $0bc69b778beb11d3$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0bc69b778beb11d3$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0bc69b778beb11d3$var$isRadioInput(ref);
    const isCheckBox = $0bc69b778beb11d3$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0bc69b778beb11d3$var$isFileInput(ref)) && $0bc69b778beb11d3$var$isUndefined(ref.value) && $0bc69b778beb11d3$var$isUndefined(inputValue) || $0bc69b778beb11d3$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0bc69b778beb11d3$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.maxLength, minType = $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0bc69b778beb11d3$var$isNullOrUndefined(inputValue)) || $0bc69b778beb11d3$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0bc69b778beb11d3$var$getCheckboxValue(refs).isValid || isRadio && !$0bc69b778beb11d3$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0bc69b778beb11d3$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0bc69b778beb11d3$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0bc69b778beb11d3$var$isNullOrUndefined(min) || !$0bc69b778beb11d3$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0bc69b778beb11d3$var$getValueAndMessage(max);
        const minOutput = $0bc69b778beb11d3$var$getValueAndMessage(min);
        if (!$0bc69b778beb11d3$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0bc69b778beb11d3$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0bc69b778beb11d3$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($0bc69b778beb11d3$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0bc69b778beb11d3$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.max, $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0bc69b778beb11d3$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0bc69b778beb11d3$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0bc69b778beb11d3$var$getValueAndMessage(minLength);
        const exceedMax = !$0bc69b778beb11d3$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0bc69b778beb11d3$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0bc69b778beb11d3$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0bc69b778beb11d3$var$getValueAndMessage(pattern);
        if ($0bc69b778beb11d3$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0bc69b778beb11d3$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0bc69b778beb11d3$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0bc69b778beb11d3$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0bc69b778beb11d3$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0bc69b778beb11d3$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0bc69b778beb11d3$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0bc69b778beb11d3$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $0bc69b778beb11d3$var$appendAt = (data, value1)=>[
        ...data,
        ...$0bc69b778beb11d3$var$convertToArrayPayload(value1)
    ];
var $0bc69b778beb11d3$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0bc69b778beb11d3$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0bc69b778beb11d3$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0bc69b778beb11d3$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0bc69b778beb11d3$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0bc69b778beb11d3$var$prependAt = (data, value1)=>[
        ...$0bc69b778beb11d3$var$convertToArrayPayload(value1),
        ...$0bc69b778beb11d3$var$convertToArrayPayload(data)
    ];
function $0bc69b778beb11d3$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0bc69b778beb11d3$var$compact(temp).length ? temp : [];
}
var $0bc69b778beb11d3$var$removeArrayAt = (data, index)=>$0bc69b778beb11d3$var$isUndefined(index) ? [] : $0bc69b778beb11d3$var$removeAtIndexes(data, $0bc69b778beb11d3$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0bc69b778beb11d3$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $0bc69b778beb11d3$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0bc69b778beb11d3$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0bc69b778beb11d3$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0bc69b778beb11d3$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0bc69b778beb11d3$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0bc69b778beb11d3$var$isKey(path) ? [
        path
    ] : $0bc69b778beb11d3$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0bc69b778beb11d3$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0bc69b778beb11d3$var$isObject(childObject) && $0bc69b778beb11d3$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0bc69b778beb11d3$var$isEmptyArray(childObject))) $0bc69b778beb11d3$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0bc69b778beb11d3$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0bc69b778beb11d3$export$310131896651d559(props) {
    const methods = $0bc69b778beb11d3$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(control._getFieldArray(name).map($0bc69b778beb11d3$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0bc69b778beb11d3$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0bc69b778beb11d3$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0bc69b778beb11d3$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0bc69b778beb11d3$var$convertToArrayPayload($0bc69b778beb11d3$var$cloneObject(value1));
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0bc69b778beb11d3$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0bc69b778beb11d3$var$appendAt(ids.current, appendValue.map($0bc69b778beb11d3$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$appendAt, {
            argA: $0bc69b778beb11d3$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0bc69b778beb11d3$var$convertToArrayPayload($0bc69b778beb11d3$var$cloneObject(value1));
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0bc69b778beb11d3$var$getFocusFieldName(name, 0, options);
        ids.current = $0bc69b778beb11d3$var$prependAt(ids.current, prependValue.map($0bc69b778beb11d3$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$prependAt, {
            argA: $0bc69b778beb11d3$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0bc69b778beb11d3$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0bc69b778beb11d3$var$convertToArrayPayload($0bc69b778beb11d3$var$cloneObject(value1));
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0bc69b778beb11d3$var$getFocusFieldName(name, index, options);
        ids.current = $0bc69b778beb11d3$var$insert(ids.current, index, insertValue.map($0bc69b778beb11d3$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$insert, {
            argA: index,
            argB: $0bc69b778beb11d3$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0bc69b778beb11d3$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0bc69b778beb11d3$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0bc69b778beb11d3$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0bc69b778beb11d3$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0bc69b778beb11d3$var$cloneObject(value1);
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0bc69b778beb11d3$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0bc69b778beb11d3$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0bc69b778beb11d3$var$convertToArrayPayload($0bc69b778beb11d3$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0bc69b778beb11d3$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        control._state.action = false;
        $0bc69b778beb11d3$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0bc69b778beb11d3$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0bc69b778beb11d3$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0bc69b778beb11d3$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0bc69b778beb11d3$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0bc69b778beb11d3$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0bc69b778beb11d3$var$getValidationModes(control._options.mode).isOnSubmit)) $0bc69b778beb11d3$var$validateField(field, control._formValues, control._options.criteriaMode === $0bc69b778beb11d3$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0bc69b778beb11d3$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0bc69b778beb11d3$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0bc69b778beb11d3$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        !$0bc69b778beb11d3$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0bc69b778beb11d3$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $0bc69b778beb11d3$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0bc69b778beb11d3$var$isPrimitive = (value1)=>$0bc69b778beb11d3$var$isNullOrUndefined(value1) || !$0bc69b778beb11d3$var$isObjectType(value1);
function $0bc69b778beb11d3$var$deepEqual(object1, object2) {
    if ($0bc69b778beb11d3$var$isPrimitive(object1) || $0bc69b778beb11d3$var$isPrimitive(object2)) return object1 === object2;
    if ($0bc69b778beb11d3$var$isDateObject(object1) && $0bc69b778beb11d3$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0bc69b778beb11d3$var$isDateObject(val1) && $0bc69b778beb11d3$var$isDateObject(val2) || $0bc69b778beb11d3$var$isObject(val1) && $0bc69b778beb11d3$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0bc69b778beb11d3$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0bc69b778beb11d3$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0bc69b778beb11d3$var$isRadioOrCheckbox = (ref)=>$0bc69b778beb11d3$var$isRadioInput(ref) || $0bc69b778beb11d3$var$isCheckBoxInput(ref);
var $0bc69b778beb11d3$var$live = (ref)=>$0bc69b778beb11d3$var$isHTMLElement(ref) && ref.isConnected;
var $0bc69b778beb11d3$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0bc69b778beb11d3$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0bc69b778beb11d3$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0bc69b778beb11d3$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0bc69b778beb11d3$var$isObject(data[key]) && !$0bc69b778beb11d3$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0bc69b778beb11d3$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0bc69b778beb11d3$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0bc69b778beb11d3$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0bc69b778beb11d3$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0bc69b778beb11d3$var$isObject(data[key]) && !$0bc69b778beb11d3$var$objectHasFunction(data[key])) {
            if ($0bc69b778beb11d3$var$isUndefined(formValues) || $0bc69b778beb11d3$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0bc69b778beb11d3$var$markFieldsDirty(data[key], []) : {
                ...$0bc69b778beb11d3$var$markFieldsDirty(data[key])
            };
            else $0bc69b778beb11d3$var$getDirtyFieldsFromDefaultValues(data[key], $0bc69b778beb11d3$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0bc69b778beb11d3$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0bc69b778beb11d3$var$getDirtyFields = (defaultValues, formValues)=>$0bc69b778beb11d3$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0bc69b778beb11d3$var$markFieldsDirty(formValues));
var $0bc69b778beb11d3$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0bc69b778beb11d3$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $0bc69b778beb11d3$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0bc69b778beb11d3$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0bc69b778beb11d3$var$isFileInput(ref)) return ref.files;
    if ($0bc69b778beb11d3$var$isRadioInput(ref)) return $0bc69b778beb11d3$var$getRadioValue(_f.refs).value;
    if ($0bc69b778beb11d3$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0bc69b778beb11d3$var$isCheckBoxInput(ref)) return $0bc69b778beb11d3$var$getCheckboxValue(_f.refs).value;
    return $0bc69b778beb11d3$var$getFieldValueAs($0bc69b778beb11d3$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0bc69b778beb11d3$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        field && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0bc69b778beb11d3$var$getRuleValue = (rule)=>$0bc69b778beb11d3$var$isUndefined(rule) ? rule : $0bc69b778beb11d3$var$isRegex(rule) ? rule.source : $0bc69b778beb11d3$var$isObject(rule) ? $0bc69b778beb11d3$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0bc69b778beb11d3$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0bc69b778beb11d3$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0bc69b778beb11d3$export$3988ae62b71be9a3(errors, name);
    if (error || $0bc69b778beb11d3$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0bc69b778beb11d3$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0bc69b778beb11d3$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0bc69b778beb11d3$var$unsetEmptyArray = (ref, name)=>!$0bc69b778beb11d3$var$compact($0bc69b778beb11d3$export$3988ae62b71be9a3(ref, name)).length && $0bc69b778beb11d3$var$unset(ref, name);
const $0bc69b778beb11d3$var$defaultOptions = {
    mode: $0bc69b778beb11d3$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0bc69b778beb11d3$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0bc69b778beb11d3$var$createFormControl(props = {}) {
    let _options = {
        ...$0bc69b778beb11d3$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0bc69b778beb11d3$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0bc69b778beb11d3$var$isObject(_options.defaultValues) || $0bc69b778beb11d3$var$isObject(_options.values) ? $0bc69b778beb11d3$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0bc69b778beb11d3$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0bc69b778beb11d3$var$createSubject(),
        array: $0bc69b778beb11d3$var$createSubject(),
        state: $0bc69b778beb11d3$var$createSubject()
    };
    const validationModeBeforeSubmit = $0bc69b778beb11d3$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0bc69b778beb11d3$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0bc69b778beb11d3$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $0bc69b778beb11d3$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0bc69b778beb11d3$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0bc69b778beb11d3$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0bc69b778beb11d3$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0bc69b778beb11d3$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0bc69b778beb11d3$export$3988ae62b71be9a3(_formValues, name, $0bc69b778beb11d3$var$isUndefined(value1) ? $0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0bc69b778beb11d3$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0bc69b778beb11d3$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name) && $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $0bc69b778beb11d3$var$deepEqual($0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $0bc69b778beb11d3$var$unset(_formState.dirtyFields, name) : $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0bc69b778beb11d3$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0bc69b778beb11d3$var$unset(_formState.errors, name);
        }
        if ((error ? !$0bc69b778beb11d3$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0bc69b778beb11d3$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0bc69b778beb11d3$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0bc69b778beb11d3$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0bc69b778beb11d3$export$3988ae62b71be9a3(errors, name);
            error ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0bc69b778beb11d3$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $0bc69b778beb11d3$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0bc69b778beb11d3$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0bc69b778beb11d3$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0bc69b778beb11d3$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0bc69b778beb11d3$var$live(ref)) : !$0bc69b778beb11d3$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, data), !$0bc69b778beb11d3$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0bc69b778beb11d3$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0bc69b778beb11d3$var$isUndefined(defaultValue) ? _defaultValues : $0bc69b778beb11d3$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0bc69b778beb11d3$var$compact($0bc69b778beb11d3$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, $0bc69b778beb11d3$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0bc69b778beb11d3$var$isHTMLElement(fieldReference.ref) && $0bc69b778beb11d3$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0bc69b778beb11d3$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0bc69b778beb11d3$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0bc69b778beb11d3$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0bc69b778beb11d3$var$isPrimitive(fieldValue) || field && !field._f) && !$0bc69b778beb11d3$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0bc69b778beb11d3$var$cloneObject(value1);
        $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0bc69b778beb11d3$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0bc69b778beb11d3$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0bc69b778beb11d3$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0bc69b778beb11d3$var$getFieldValue(field._f) : $0bc69b778beb11d3$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $0bc69b778beb11d3$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0bc69b778beb11d3$var$EVENTS.BLUR || event.type === $0bc69b778beb11d3$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0bc69b778beb11d3$var$hasValidation(field._f) && !_options.resolver && !$0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0bc69b778beb11d3$var$skipValidation(isBlurEvent, $0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0bc69b778beb11d3$var$isWatched(name, _names, isBlurEvent);
            $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0bc69b778beb11d3$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0bc69b778beb11d3$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0bc69b778beb11d3$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0bc69b778beb11d3$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0bc69b778beb11d3$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0bc69b778beb11d3$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0bc69b778beb11d3$var$isUndefined(name) ? name : fieldNames);
            isValid = $0bc69b778beb11d3$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0bc69b778beb11d3$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0bc69b778beb11d3$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0bc69b778beb11d3$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $0bc69b778beb11d3$var$isUndefined(fieldNames) ? values : $0bc69b778beb11d3$var$isString(fieldNames) ? $0bc69b778beb11d3$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0bc69b778beb11d3$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0bc69b778beb11d3$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0bc69b778beb11d3$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0bc69b778beb11d3$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            isValidating: !!$0bc69b778beb11d3$export$3988ae62b71be9a3((formState || _formState).validatingFields, name),
            error: $0bc69b778beb11d3$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $0bc69b778beb11d3$var$convertToArrayPayload(name).forEach((inputName)=>$0bc69b778beb11d3$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0bc69b778beb11d3$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0bc69b778beb11d3$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0bc69b778beb11d3$var$unset(_fields, fieldName);
                $0bc69b778beb11d3$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0bc69b778beb11d3$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0bc69b778beb11d3$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0bc69b778beb11d3$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0bc69b778beb11d3$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0bc69b778beb11d3$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($0bc69b778beb11d3$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $0bc69b778beb11d3$var$isUndefined(value1) ? $0bc69b778beb11d3$var$getFieldValue(field ? field._f : $0bc69b778beb11d3$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0bc69b778beb11d3$var$isBoolean(options.disabled);
        $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0bc69b778beb11d3$var$getRuleValue(options.min),
                max: $0bc69b778beb11d3$var$getRuleValue(options.max),
                minLength: $0bc69b778beb11d3$var$getRuleValue(options.minLength),
                maxLength: $0bc69b778beb11d3$var$getRuleValue(options.maxLength),
                pattern: $0bc69b778beb11d3$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0bc69b778beb11d3$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0bc69b778beb11d3$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0bc69b778beb11d3$var$live),
                                    fieldRef,
                                    ...Array.isArray($0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0bc69b778beb11d3$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0bc69b778beb11d3$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0bc69b778beb11d3$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0bc69b778beb11d3$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $0bc69b778beb11d3$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0bc69b778beb11d3$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0bc69b778beb11d3$var$unset(_formState.errors, "root");
            if ($0bc69b778beb11d3$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0bc69b778beb11d3$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name)) {
            if ($0bc69b778beb11d3$var$isUndefined(options.defaultValue)) setValue(name, $0bc69b778beb11d3$var$cloneObject($0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0bc69b778beb11d3$export$adaa4cf7ef1b65be(_defaultValues, name, $0bc69b778beb11d3$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0bc69b778beb11d3$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0bc69b778beb11d3$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0bc69b778beb11d3$var$cloneObject($0bc69b778beb11d3$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0bc69b778beb11d3$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0bc69b778beb11d3$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0bc69b778beb11d3$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0bc69b778beb11d3$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$0bc69b778beb11d3$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0bc69b778beb11d3$export$adaa4cf7ef1b65be(values, fieldName, $0bc69b778beb11d3$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0bc69b778beb11d3$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($0bc69b778beb11d3$var$isWeb && $0bc69b778beb11d3$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0bc69b778beb11d3$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0bc69b778beb11d3$var$cloneObject(_defaultValues) : {} : $0bc69b778beb11d3$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0bc69b778beb11d3$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0bc69b778beb11d3$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0bc69b778beb11d3$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0bc69b778beb11d3$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0bc69b778beb11d3$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0bc69b778beb11d3$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0bc69b778beb11d3$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0bc69b778beb11d3$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $0bc69b778beb11d3$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0bc69b778beb11d3$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0bc69b778beb11d3$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0bc69b778beb11d3$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if (props.values && !$0bc69b778beb11d3$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $0bc69b778beb11d3$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("ljoiY", function(module, exports) {
$parcel$export(module.exports, "useSignOut", function () { return (parcelRequire("6f5ta")).useSignOut; });
parcelRequire("6f5ta");

});
parcelRegister("6f5ta", function(module, exports) {

$parcel$export(module.exports, "useSignOut", function () { return $2329c730e7a2ceeb$export$68089b5bbafb026b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $1O9Jh = parcelRequire("1O9Jh");

var $eFTdF = parcelRequire("eFTdF");

var $1IBeB = parcelRequire("1IBeB");

var $1sDHO = parcelRequire("1sDHO");

var $eIymc = parcelRequire("eIymc");
const $2329c730e7a2ceeb$var$applyLocalSignOutSideEffects = ({ showNotificationMessage: showNotificationMessage = true } = {})=>{
    if (0, $eIymc.isPartnerDomain) (0, $1sDHO.default).removeItem("iw_state");
    showNotificationMessage && (0, $1sDHO.default).setItem("notification", {
        text: "lblSignedOutMessage",
        type: "notice"
    });
};
const $2329c730e7a2ceeb$export$68089b5bbafb026b = ({ showNotificationMessage: showNotificationMessage = true } = {})=>{
    const dispatch = (0, $2rQNl.useDispatch)();
    const [logout] = (0, $1O9Jh.useAuthLogoutMutation)();
    return (0, $7E7Dk.useCallback)(()=>{
        const logoutRequest = (0, $eIymc.isPortalDomain) ? logout() : null;
        $2329c730e7a2ceeb$var$applyLocalSignOutSideEffects({
            showNotificationMessage: showNotificationMessage
        });
        Promise.resolve(logoutRequest?.unwrap()).catch(()=>{
        // Clear local session state even if backend logout fails or the session is already gone.
        }).finally(()=>{
            dispatch((0, $eFTdF.requestPortalSessionReset)());
            (0, $1IBeB.triggerAuthChange)();
        });
    }, [
        dispatch,
        logout,
        showNotificationMessage
    ]);
};

});


parcelRegister("1o9MR", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("lMbZo")).Input; });
parcelRequire("lMbZo");

});
parcelRegister("lMbZo", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $bd5a31e397927cae$export$f5b8910cec6cf069; });

var $7E7Dk = parcelRequire("7E7Dk");

var $kl2VR = parcelRequire("kl2VR");

var $76MyM = parcelRequire("76MyM");

var $dE8RX = parcelRequire("dE8RX");

var $f3EWq = parcelRequire("f3EWq");

var $8iVRC = parcelRequire("8iVRC");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("9w3V4");
var $QrRvA = parcelRequire("QrRvA");
const $bd5a31e397927cae$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $7E7Dk.forwardRef)(({ label: label, className: className, inputClassName: inputClassName, icon: icon, keyFilter: keyFilter, infoText: infoText, disabledReason: disabledReason, endButton: endButton, ...props }, ref)=>{
    const text = (0, $5u6k9.default)();
    const inputValue = props.value === null || props.value === undefined ? props.value : String(props.value);
    const inputElement = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f3EWq.IconField), {
        iconPosition: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8iVRC.InputIcon), {
        className: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kl2VR.InputText), {
        ref: ref,
        autoComplete: "off",
        ...props,
        value: inputValue,
        invalid: !!props.error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("w-full", inputClassName),
        keyfilter: keyFilter,
        tooltip: props.disabled && disabledReason ? disabledReason : undefined,
        tooltipOptions: {
            position: "bottom",
            showOnDisabled: true
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kl2VR.InputText), {
        ref: ref,
        autoComplete: "off",
        ...props,
        value: inputValue,
        invalid: !!props.error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("w-full", inputClassName),
        tooltip: props.disabled && disabledReason ? disabledReason : undefined,
        tooltipOptions: {
            position: "bottom",
            showOnDisabled: true
        }
    });
    const inputWithEndButton = endButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "p-inputgroup"
    }, inputElement, endButton) : inputElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: className
    }, label || infoText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-between"
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            "required-label": props.required
        }, "p-label"),
        htmlFor: props.id
    }, label) : null, infoText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $QrRvA.FieldInfoButton), {
        ariaLabel: text("lblMoreInformation"),
        text: infoText,
        testId: `${props.id}-info-button`
    }) : null) : null, inputWithEndButton, props.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        id: "help-text",
        className: "block",
        style: {
            color: "var(--text-color-secondary)"
        },
        "data-testid": `${props["data-testid"] ?? "input"}-help-text`
    }, props.subtitle), props.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "error",
        text: props.error,
        "data-testid": `${props["data-testid"] ?? "input"}-error-message`,
        className: "mt-2 flex justify-content-start"
    }));
});

});
parcelRegister("kl2VR", function(module, exports) {

$parcel$export(module.exports, "InputText", function () { return $ece80b13154d32a4$export$7034fcb7d6351061; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $eTu3s = parcelRequire("eTu3s");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $ece80b13154d32a4$var$_extends() {
    return $ece80b13154d32a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ece80b13154d32a4$var$_extends.apply(null, arguments);
}
function $ece80b13154d32a4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ece80b13154d32a4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ece80b13154d32a4$var$_typeof(o);
}
function $ece80b13154d32a4$var$toPrimitive(t, r) {
    if ("object" != $ece80b13154d32a4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ece80b13154d32a4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ece80b13154d32a4$var$toPropertyKey(t) {
    var i = $ece80b13154d32a4$var$toPrimitive(t, "string");
    return "symbol" == $ece80b13154d32a4$var$_typeof(i) ? i : i + "";
}
function $ece80b13154d32a4$var$_defineProperty(e, r, t) {
    return (r = $ece80b13154d32a4$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $ece80b13154d32a4$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, isFilled = _ref.isFilled, context = _ref.context;
        return (0, $7nrKB.classNames)("p-inputtext p-component", {
            "p-disabled": props.disabled,
            "p-filled": isFilled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $ece80b13154d32a4$var$InputTextBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputText",
        __parentMetadata: null,
        children: undefined,
        className: null,
        invalid: false,
        variant: null,
        keyfilter: null,
        onBeforeInput: null,
        onInput: null,
        onKeyDown: null,
        onPaste: null,
        tooltip: null,
        tooltipOptions: null,
        validateOnly: false,
        iconPosition: null
    },
    css: {
        classes: $ece80b13154d32a4$var$classes
    }
});
function $ece80b13154d32a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ece80b13154d32a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ece80b13154d32a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ece80b13154d32a4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ece80b13154d32a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ece80b13154d32a4$export$7034fcb7d6351061 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $ece80b13154d32a4$var$InputTextBase.getProps(inProps, context);
    var _InputTextBase$setMet = $ece80b13154d32a4$var$InputTextBase.setMetaData($ece80b13154d32a4$var$_objectSpread($ece80b13154d32a4$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: props.disabled,
            iconPosition: props.iconPosition
        }
    })), ptm = _InputTextBase$setMet.ptm, cx = _InputTextBase$setMet.cx, isUnstyled = _InputTextBase$setMet.isUnstyled;
    (0, $kHEnT.useHandleStyle)($ece80b13154d32a4$var$InputTextBase.css.styles, isUnstyled, {
        name: "inputtext",
        styled: true
    });
    var elementRef = $7E7Dk.useRef(ref);
    var onKeyDown = function onKeyDown(event) {
        props.onKeyDown && props.onKeyDown(event);
        if (props.keyfilter) (0, $eTu3s.KeyFilter).onKeyPress(event, props.keyfilter, props.validateOnly);
    };
    var onBeforeInput = function onBeforeInput(event) {
        props.onBeforeInput && props.onBeforeInput(event);
        if (props.keyfilter) (0, $eTu3s.KeyFilter).onBeforeInput(event, props.keyfilter, props.validateOnly);
    };
    var onInput = function onInput(event) {
        var target = event.target;
        var validatePattern = true;
        if (props.keyfilter && props.validateOnly) validatePattern = (0, $eTu3s.KeyFilter).validate(event, props.keyfilter);
        props.onInput && props.onInput(event, validatePattern);
        // for uncontrolled changes
        (0, $7nrKB.ObjectUtils).isNotEmpty(target.value) ? (0, $7nrKB.DomHandler).addClass(target, "p-filled") : (0, $7nrKB.DomHandler).removeClass(target, "p-filled");
    };
    var onPaste = function onPaste(event) {
        props.onPaste && props.onPaste(event);
        if (props.keyfilter) (0, $eTu3s.KeyFilter).onPaste(event, props.keyfilter, props.validateOnly);
    };
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    var isFilled = $7E7Dk.useMemo(function() {
        return (0, $7nrKB.ObjectUtils).isNotEmpty(props.value) || (0, $7nrKB.ObjectUtils).isNotEmpty(props.defaultValue);
    }, [
        props.value,
        props.defaultValue
    ]);
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    $7E7Dk.useEffect(function() {
        var _elementRef$current;
        if (isFilled || (_elementRef$current = elementRef.current) !== null && _elementRef$current !== void 0 && _elementRef$current.value) (0, $7nrKB.DomHandler).addClass(elementRef.current, "p-filled");
        else (0, $7nrKB.DomHandler).removeClass(elementRef.current, "p-filled");
    }, [
        props.disabled,
        isFilled
    ]);
    var rootProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            context: context,
            isFilled: isFilled
        })),
        onBeforeInput: onBeforeInput,
        onInput: onInput,
        onKeyDown: onKeyDown,
        onPaste: onPaste
    }, $ece80b13154d32a4$var$InputTextBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("input", $ece80b13154d32a4$var$_extends({
        ref: elementRef
    }, rootProps)), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $ece80b13154d32a4$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$ece80b13154d32a4$export$7034fcb7d6351061.displayName = "InputText";

});
parcelRegister("eTu3s", function(module, exports) {

$parcel$export(module.exports, "KeyFilter", function () { return $ad7d8401f9a9c86b$export$9dbdc44a13de1b0d; });

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $ad7d8401f9a9c86b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ad7d8401f9a9c86b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ad7d8401f9a9c86b$var$_arrayLikeToArray(r);
}
function $ad7d8401f9a9c86b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $ad7d8401f9a9c86b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ad7d8401f9a9c86b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ad7d8401f9a9c86b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ad7d8401f9a9c86b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad7d8401f9a9c86b$var$_toConsumableArray(r) {
    return $ad7d8401f9a9c86b$var$_arrayWithoutHoles(r) || $ad7d8401f9a9c86b$var$_iterableToArray(r) || $ad7d8401f9a9c86b$var$_unsupportedIterableToArray(r) || $ad7d8401f9a9c86b$var$_nonIterableSpread();
}
var $ad7d8401f9a9c86b$export$9dbdc44a13de1b0d = {
    /* eslint-disable */ DEFAULT_MASKS: {
        pint: /[\d]/,
        "int": /[\d\-]/,
        pnum: /[\d\.]/,
        money: /[\d\.\s,]/,
        num: /[\d\-\.]/,
        hex: /[0-9a-f]/i,
        email: /[a-z0-9_\.\-@]/i,
        alpha: /[a-z_]/i,
        alphanum: /[a-z0-9_]/i
    },
    /* eslint-enable */ getRegex: function getRegex(keyfilter) {
        return $ad7d8401f9a9c86b$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] ? $ad7d8401f9a9c86b$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] : keyfilter;
    },
    onBeforeInput: function onBeforeInput(e, keyfilter, validateOnly) {
        // android devices must use beforeinput https://stackoverflow.com/questions/36753548/keycode-on-android-is-always-229
        if (validateOnly || !(0, $7nrKB.DomHandler).isAndroid()) return;
        this.validateKey(e, e.data, keyfilter);
    },
    onKeyPress: function onKeyPress(e, keyfilter, validateOnly) {
        // non android devices use keydown
        if (validateOnly || (0, $7nrKB.DomHandler).isAndroid()) return;
        if (e.ctrlKey || e.altKey || e.metaKey) return;
        this.validateKey(e, e.key, keyfilter);
    },
    onPaste: function onPaste(e, keyfilter, validateOnly) {
        if (validateOnly) return;
        var regex = this.getRegex(keyfilter);
        var clipboard = e.clipboardData.getData("text");
        // loop over each letter pasted and if any fail prevent the paste
        $ad7d8401f9a9c86b$var$_toConsumableArray(clipboard).forEach(function(c) {
            if (!regex.test(c)) {
                e.preventDefault();
                return false;
            }
        });
    },
    validateKey: function validateKey(e, key, keyfilter) {
        if (key === null || key === undefined) return;
        // some AZERTY keys come in with 2 chars like ´ç if Dead key is pressed first
        var isPrintableKey = key.length <= 2;
        if (!isPrintableKey) return;
        var regex = this.getRegex(keyfilter);
        if (!regex.test(key)) e.preventDefault();
    },
    validate: function validate(e, keyfilter) {
        var value = e.target.value;
        var validatePattern = true;
        var regex = this.getRegex(keyfilter);
        if (value && !regex.test(value)) validatePattern = false;
        return validatePattern;
    }
};

});


parcelRegister("f3EWq", function(module, exports) {

$parcel$export(module.exports, "IconField", function () { return $af66e4e9ff323471$export$abf6ae16d7844889; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $kHEnT = parcelRequire("kHEnT");
"use client";
function $af66e4e9ff323471$var$_extends() {
    return $af66e4e9ff323471$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af66e4e9ff323471$var$_extends.apply(null, arguments);
}
function $af66e4e9ff323471$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af66e4e9ff323471$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af66e4e9ff323471$var$_typeof(o);
}
function $af66e4e9ff323471$var$toPrimitive(t, r) {
    if ("object" != $af66e4e9ff323471$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $af66e4e9ff323471$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $af66e4e9ff323471$var$toPropertyKey(t) {
    var i = $af66e4e9ff323471$var$toPrimitive(t, "string");
    return "symbol" == $af66e4e9ff323471$var$_typeof(i) ? i : i + "";
}
function $af66e4e9ff323471$var$_defineProperty(e, r, t) {
    return (r = $af66e4e9ff323471$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $af66e4e9ff323471$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $7nrKB.classNames)("p-icon-field", {
            "p-icon-field-right": props.iconPosition === "right",
            "p-icon-field-left": props.iconPosition === "left"
        });
    }
};
var $af66e4e9ff323471$var$IconFieldBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "IconField",
        __parentMetadata: null,
        children: undefined,
        className: null,
        iconPosition: "right"
    },
    css: {
        classes: $af66e4e9ff323471$var$classes
    }
});
function $af66e4e9ff323471$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af66e4e9ff323471$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af66e4e9ff323471$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af66e4e9ff323471$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af66e4e9ff323471$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $af66e4e9ff323471$export$abf6ae16d7844889 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $7E7Dk.useRef)(ref);
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = (0, $7E7Dk.useContext)((0, $eHYdO.PrimeReactContext));
    var props = $af66e4e9ff323471$var$IconFieldBase.getProps(inProps, context);
    var _IconFieldBase$setMet = $af66e4e9ff323471$var$IconFieldBase.setMetaData($af66e4e9ff323471$var$_objectSpread($af66e4e9ff323471$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            iconPosition: props.iconPosition
        }
    })), ptm = _IconFieldBase$setMet.ptm, cx = _IconFieldBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            iconPosition: props.iconPosition
        }))
    }, $af66e4e9ff323471$var$IconFieldBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", $af66e4e9ff323471$var$_extends({}, rootProps, {
        ref: elementRef
    }), (0, $7E7Dk.Children).map(props.children, function(child, index) {
        return /*#__PURE__*/ (0, $7E7Dk.cloneElement)(child, {
            iconPosition: props.iconPosition
        });
    }));
}));
$af66e4e9ff323471$export$abf6ae16d7844889.displayName = "IconField";

});

parcelRegister("8iVRC", function(module, exports) {

$parcel$export(module.exports, "InputIcon", function () { return $60bce3bb3bb686a2$export$f8fea9f50a4bfae6; });

var $7E7Dk = parcelRequire("7E7Dk");

var $jr5t3 = parcelRequire("jr5t3");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $60bce3bb3bb686a2$var$_extends() {
    return $60bce3bb3bb686a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $60bce3bb3bb686a2$var$_extends.apply(null, arguments);
}
function $60bce3bb3bb686a2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $60bce3bb3bb686a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $60bce3bb3bb686a2$var$_typeof(o);
}
function $60bce3bb3bb686a2$var$toPrimitive(t, r) {
    if ("object" != $60bce3bb3bb686a2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $60bce3bb3bb686a2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $60bce3bb3bb686a2$var$toPropertyKey(t) {
    var i = $60bce3bb3bb686a2$var$toPrimitive(t, "string");
    return "symbol" == $60bce3bb3bb686a2$var$_typeof(i) ? i : i + "";
}
function $60bce3bb3bb686a2$var$_defineProperty(e, r, t) {
    return (r = $60bce3bb3bb686a2$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $60bce3bb3bb686a2$var$classes = {
    root: "p-input-icon"
};
var $60bce3bb3bb686a2$var$InputIconBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputIcon",
        __parentMetadata: null,
        className: null,
        iconPosition: null
    },
    css: {
        classes: $60bce3bb3bb686a2$var$classes
    }
});
function $60bce3bb3bb686a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60bce3bb3bb686a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60bce3bb3bb686a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $60bce3bb3bb686a2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60bce3bb3bb686a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $60bce3bb3bb686a2$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $7E7Dk.useRef)(ref);
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = (0, $7E7Dk.useContext)((0, $eHYdO.PrimeReactContext));
    var props = $60bce3bb3bb686a2$var$InputIconBase.getProps(inProps, context);
    var _InputIconBase$setMet = $60bce3bb3bb686a2$var$InputIconBase.setMetaData($60bce3bb3bb686a2$var$_objectSpread($60bce3bb3bb686a2$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            iconPosition: props.iconPosition
        }
    })), ptm = _InputIconBase$setMet.ptm, cx = _InputIconBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("root"))
    }, $60bce3bb3bb686a2$var$InputIconBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", $60bce3bb3bb686a2$var$_extends({}, rootProps, {
        ref: elementRef
    }), props.children));
}));
$60bce3bb3bb686a2$export$f8fea9f50a4bfae6.displayName = "InputIcon";

});



parcelRegister("9c3iL", function(module, exports) {

$parcel$export(module.exports, "doesSupportSmartSchedule", function () { return $2dea881cc4e0ca17$export$580ac36201920ad8; });
$parcel$export(module.exports, "canShowSmartScheduling", function () { return $2dea881cc4e0ca17$export$e97515a0c08dcae; });

var $7Wx6Z = parcelRequire("7Wx6Z");

var $e3A9f = parcelRequire("e3A9f");

var $1hIPE = parcelRequire("1hIPE");

var $hohPv = parcelRequire("hohPv");

var $lFIQ9 = parcelRequire("lFIQ9");
const $2dea881cc4e0ca17$var$MIN_AURA_SMART_SCHEDULE_FIRMWARE = 110;
const $2dea881cc4e0ca17$var$MIN_HALO2_SMART_SCHEDULE_FIRMWARE = 130;
const $2dea881cc4e0ca17$var$hasSmartSchedulingFeature = (chargePoint)=>((0, $hohPv.default)(chargePoint) || (0, $lFIQ9.default)(chargePoint)) && (0, $7Wx6Z.hasFeature)("SmartCharging", chargePoint.ocppConfigKeys);
function $2dea881cc4e0ca17$export$580ac36201920ad8(chargePoint) {
    if (!chargePoint) return false;
    if ((0, $e3A9f.isAura2)(chargePoint)) return true;
    if ((0, $1hIPE.default)(chargePoint) && Number(chargePoint.installedFirmwareVersion) >= $2dea881cc4e0ca17$var$MIN_AURA_SMART_SCHEDULE_FIRMWARE) return true;
    if (chargePoint.productType === "Halo2" && Number(chargePoint.installedFirmwareVersion) >= $2dea881cc4e0ca17$var$MIN_HALO2_SMART_SCHEDULE_FIRMWARE) return true;
    if ($2dea881cc4e0ca17$var$hasSmartSchedulingFeature(chargePoint)) return true;
    return false;
}
const $2dea881cc4e0ca17$export$e97515a0c08dcae = (chargePoint, isSuperAdmin = false)=>{
    if (!chargePoint) return false;
    if (!(0, $hohPv.default)(chargePoint) && chargePoint.ocppServerMode === "Internal") return true;
    return $2dea881cc4e0ca17$var$hasSmartSchedulingFeature(chargePoint) || ((0, $hohPv.default)(chargePoint) || (0, $lFIQ9.default)(chargePoint)) && isSuperAdmin;
};

});
parcelRegister("7Wx6Z", function(module, exports) {

$parcel$export(module.exports, "hasFeature", function () { return $ed5a6638bdc8c0bb$export$805ddaeeece0413e; });

var $auuMO = parcelRequire("auuMO");
const $ed5a6638bdc8c0bb$export$805ddaeeece0413e = (feature, configKeys)=>{
    if (!configKeys) return false;
    const config = (0, $auuMO.default)("SupportedFeatureProfiles", configKeys);
    if (!config) return false;
    const features = config.split(",");
    if (features.find((r)=>r === feature)) return true;
    return false;
};

});

parcelRegister("e3A9f", function(module, exports) {

$parcel$export(module.exports, "isAura2", function () { return $b7da3bb065f610f2$export$283b1d62d02e8a92; });
$parcel$export(module.exports, "getSupportedEarthingSystem", function () { return $b7da3bb065f610f2$export$96c2a3f023395142; });
$parcel$export(module.exports, "supportsSimImsi", function () { return $b7da3bb065f610f2$export$adcbb80315ae05ae; });

var $hohPv = parcelRequire("hohPv");

var $lFIQ9 = parcelRequire("lFIQ9");

var $4qITT = parcelRequire("4qITT");

var $4rrnU = parcelRequire("4rrnU");
const $b7da3bb065f610f2$export$283b1d62d02e8a92 = (entity)=>{
    const productId = typeof entity === "number" ? entity : entity?.productId;
    return productId === (0, $4qITT.ChargerProducts).Aura2;
};
const $b7da3bb065f610f2$export$96c2a3f023395142 = (chargePoint)=>$b7da3bb065f610f2$export$283b1d62d02e8a92(chargePoint) ? (0, $4rrnU.EarthingSchemeLB).TN : chargePoint.earthingSystem;
const $b7da3bb065f610f2$export$adcbb80315ae05ae = (entity)=>{
    if (entity == null) return false;
    return (0, $hohPv.default)(entity) || (0, $lFIQ9.default)(entity) || typeof entity !== "string" && $b7da3bb065f610f2$export$283b1d62d02e8a92(entity);
};

});


parcelRegister("hDXS9", function(module, exports) {
$parcel$export(module.exports, "ChargePointCapiScheduledChargingWidget", function () { return (parcelRequire("asbzH")).ChargePointCapiScheduledChargingWidget; });
parcelRequire("asbzH");

});
parcelRegister("asbzH", function(module, exports) {

$parcel$export(module.exports, "ChargePointCapiScheduledChargingWidget", function () { return $504f440d6b9c1c0e$export$d99d5976a1653ae2; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");
parcelRequire("2nOeJ");
var $bJ69a = parcelRequire("bJ69a");
parcelRequire("eGlQL");
var $drGjh = parcelRequire("drGjh");

var $igvrl = parcelRequire("igvrl");

var $bLM2s = parcelRequire("bLM2s");
parcelRequire("5aWjz");
var $aHnLz = parcelRequire("aHnLz");

var $eIymc = parcelRequire("eIymc");
parcelRequire("fz1dI");
var $doZ3j = parcelRequire("doZ3j");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $5u6k9 = parcelRequire("5u6k9");

var $4gSsL = parcelRequire("4gSsL");
const $504f440d6b9c1c0e$var$FlexRow = (0, $gRonV.default).div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const $504f440d6b9c1c0e$var$Row = (0, $gRonV.default).div`
    padding-bottom: 2px;
`;
const $504f440d6b9c1c0e$var$NameField = (0, $gRonV.default).span`
    font-weight: var(--font-weight-bold);
    color: ${({ theme: theme })=>theme.brandColors.CA_Blue};

    &:hover {
        cursor: pointer;
    }
`;
const $504f440d6b9c1c0e$var$IconContainer = (0, $gRonV.default).div`
    display: flex;
    gap: 2px;
`;
const $504f440d6b9c1c0e$var$Icon = (0, $gRonV.default).span`
    transition: 0.2s ease all;
    color: ${({ theme: theme })=>theme.brandColors.CA_Blue};

    &:hover {
        cursor: pointer;
        color: ${({ theme: theme })=>theme.brandColors.CA_Mid_Blue};
    }
`;
const $504f440d6b9c1c0e$var$Title = (0, $gRonV.default).span`
    font-weight: var(--font-weight-bold);
`;
const $504f440d6b9c1c0e$var$SText = (0, $gRonV.default).span`
    font-weight: var(--font-weight-light);
`;
const $504f440d6b9c1c0e$var$SDisabledOverlay = (0, $gRonV.default).div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    opacity: 50%;
    background-color: #d4d4d4;

    &.transparent {
        background-color: transparent;
    }
`;
const $504f440d6b9c1c0e$var$GreenChargingContainer = (0, $gRonV.default).div`
    margin-top: 12px;
`;
const $504f440d6b9c1c0e$export$d99d5976a1653ae2 = /*#__PURE__*/ (0, $7E7Dk.memo)(function ChargePointCapiScheduledChargingWidget({ chargePoint: chargePoint, isGreenChargingEnabled: isGreenChargingEnabled }) {
    const text = (0, $5u6k9.default)();
    const [scheduleDialogIsOpen, setScheduleDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [selectedSchedule, setSelectedSchedule] = (0, $7E7Dk.useState)(undefined);
    const shortDatesNames = (0, $bLM2s.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    const { data: schedules, refetch: refreshSchedule, isLoading: isLoadingSchedules } = (0, $1O9Jh.useScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id
    });
    const [removeScheduleRequest] = (0, $1O9Jh.useScheduleDeleteScheduleMutation)();
    const removeSchedule = async (scheduleId)=>{
        try {
            await removeScheduleRequest({
                scheduleId: scheduleId
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("msgSchedulesRemoved"));
        } catch (exception) {
            (0, $r38ZI.notifyError)(text("msgScheduleFailedToRemove"));
        }
    };
    const [copySchedulesRequest] = (0, $1O9Jh.useScheduleCopyScheduleFromChargePointMutation)();
    const copySchedules = async ()=>{
        try {
            await copySchedulesRequest({
                chargePointId: chargePoint.id
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("msgSchedulesCopied"));
        } catch (exception) {
            (0, $r38ZI.notifyError)(text("msgScheduleFailedToRemove"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bJ69a.WidgetLayout), {
        title: text("lblSchedulingWidget"),
        "data-testid": "scheduleTitle",
        loadingStatus: isLoadingSchedules,
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, (0, $eIymc.isAdminDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: ()=>copySchedules(),
            "data-testid": "copySchedules",
            label: text("lblCopyToAllChargersLink"),
            icon: "pi pi-copy",
            disabled: !schedules || schedules.length === 0
        }), (!chargePoint.ownerReadOnly && (0, $eIymc.isUserappDomain) || (0, $eIymc.isAdminDomain)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: ()=>{
                setSelectedSchedule(undefined);
                setScheduleDialogIsOpen(true);
            },
            "data-testid": "addSchedule",
            label: text("lblCreateScheduleLink"),
            icon: "pi pi-calendar-plus"
        }))
    }, isLoadingSchedules ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-medium margin-bottom-10"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, schedules && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $drGjh.Table), {
        "data-testid": "schedules-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $drGjh.TableBody), null, schedules.map((schedule, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $drGjh.TableRow), {
            key: index,
            onClick: ()=>(0, $eIymc.isAdminDomain) ? ()=>{
                    setSelectedSchedule(schedule);
                    setScheduleDialogIsOpen(true);
                } : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $drGjh.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$NameField, {
            onClick: !chargePoint.ownerReadOnly && (0, $eIymc.isUserappDomain) || (0, $eIymc.isAdminDomain) ? ()=>{
                setSelectedSchedule(schedule);
                setScheduleDialogIsOpen(true);
            } : ()=>null,
            "data-testid": "schedule-" + schedule.id
        }, schedule.name, !schedule.active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            "data-testid": "inactiveText"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblInactiveSchedule"
        }))), (!chargePoint.ownerReadOnly && (0, $eIymc.isUserappDomain) || (0, $eIymc.isAdminDomain)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Icon, {
            className: "fa fa-trash aweFontSize",
            onClick: ()=>{
                if (schedule.id) removeSchedule(schedule.id);
            },
            "data-testid": "scheduleRemove-" + schedule.id
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Title, {
            "data-testid": "scheduleAvg-" + schedule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblChargeActive"
        })), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$SText, {
            "data-testid": "scheduleAvgVal-" + schedule.id
        }, schedule.weekdaySummary && shortDatesNames(schedule.weekdaySummary))), chargePoint.connectors.map((c, j)=>{
            if (schedule.connectorIds?.includes(c.connectorId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Row, {
                key: j
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Title, {
                "data-testid": "scheduleConn-" + c.connectorId
            }, adaptConnectorNaming(c.name)), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$SText, {
                "data-testid": "scheduleConnVal-" + c.connectorId
            }, schedule.summary));
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Row, {
                key: j
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$Title, {
                "data-testid": "scheduleConn-" + c.connectorId
            }, adaptConnectorNaming(c.name)), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$SText, {
                "data-testid": "scheduleConnVal-" + c.connectorId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
                code: "lblUnaffectedConnector"
            })));
        })))))), isGreenChargingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$GreenChargingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aHnLz.GreenChargingBadge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($504f440d6b9c1c0e$var$SDisabledOverlay, null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $doZ3j.CapiScheduleDialog), {
        visible: scheduleDialogIsOpen,
        onHide: ()=>setScheduleDialogIsOpen(false),
        onSave: ()=>void refreshSchedule(),
        chargePoint: chargePoint,
        schedule: selectedSchedule
    }));
});

});
parcelRegister("eGlQL", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("drGjh")).Table; });
$parcel$export(module.exports, "TableBody", function () { return (parcelRequire("drGjh")).TableBody; });
$parcel$export(module.exports, "TableBodyCell", function () { return (parcelRequire("drGjh")).TableBodyCell; });
$parcel$export(module.exports, "TableHeader", function () { return (parcelRequire("drGjh")).TableHeader; });
$parcel$export(module.exports, "TableHeaderCell", function () { return (parcelRequire("drGjh")).TableHeaderCell; });
$parcel$export(module.exports, "TableRow", function () { return (parcelRequire("drGjh")).TableRow; });
parcelRequire("drGjh");

});
parcelRegister("drGjh", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $42b6af1d9ba133b1$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "TableHeader", function () { return $42b6af1d9ba133b1$export$f850895b287ef28e; });
$parcel$export(module.exports, "TableRow", function () { return $42b6af1d9ba133b1$export$b05581f4e764e162; });
$parcel$export(module.exports, "TableHeaderCell", function () { return $42b6af1d9ba133b1$export$9e1517a3035b3e5c; });
$parcel$export(module.exports, "TableBody", function () { return $42b6af1d9ba133b1$export$76ccd210b9029917; });
$parcel$export(module.exports, "TableBodyCell", function () { return $42b6af1d9ba133b1$export$948e91fcef170792; });

var $76MyM = parcelRequire("76MyM");

var $7nrKB = parcelRequire("7nrKB");

var $7E7Dk = parcelRequire("7E7Dk");

var $igvrl = parcelRequire("igvrl");

var $gWMOV = parcelRequire("gWMOV");
function $42b6af1d9ba133b1$export$54ec01a60f47d33d({ children: children, style: style, isLoading: isLoading, dataTestId: dataTestId, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gWMOV.Wrapper), {
        style: style,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gWMOV.STable), {
        className: (0, $7nrKB.classNames)("table table-responsive", {
            "table-hover": !isLoading
        }),
        "data-testid": dataTestId ?? "table"
    }, children));
}
function $42b6af1d9ba133b1$export$f850895b287ef28e({ children: children, className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gWMOV.THead), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, children);
}
function $42b6af1d9ba133b1$export$b05581f4e764e162({ children: children, className: className, "data-testid": dataTestId, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gWMOV.SStyledRow), {
        "data-testid": dataTestId ?? "table-row",
        ...className && {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className)
        },
        ...rest
    }, children);
}
function $42b6af1d9ba133b1$export$9e1517a3035b3e5c({ children: children, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("th", {
        "data-testid": rest["data-testid"] ?? "table-header-cell",
        ...className && {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className)
        },
        ...rest
    }, children);
}
function $42b6af1d9ba133b1$export$76ccd210b9029917({ children: children, dataTestId: dataTestId, isLoading: isLoading, numberOfLoadingItems: numberOfLoadingItems = 7, numberOfLoadingColumns: numberOfLoadingColumns = 4 }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("tbody", {
        "data-testid": dataTestId ?? "table-body"
    }, isLoading ? Array(numberOfLoadingItems).fill(true).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($42b6af1d9ba133b1$export$62da3b1eae3a6aef, {
            key: index,
            items: numberOfLoadingColumns
        })) : children);
}
function $42b6af1d9ba133b1$export$948e91fcef170792({ children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("td", {
        "data-testid": rest["data-testid"] ?? "table-body-cell",
        ...rest
    }, children);
}
const $42b6af1d9ba133b1$export$62da3b1eae3a6aef = ({ items: items = 4 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($42b6af1d9ba133b1$export$b05581f4e764e162, null, Array(items).fill(true).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($42b6af1d9ba133b1$export$948e91fcef170792, {
            key: `loader-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "shimmer-container w-full h-3rem border-round-3xl",
            "data-testid": `loader-${index}`
        }))));
function $42b6af1d9ba133b1$export$7709f3121c8ef1e({ code: code, id: id, sortType: sortType, descending: descending, onClick: onClick }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("a", {
        className: "pointer",
        onClick: ()=>onClick(id, !descending),
        "data-testid": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: code
    }), sortType === id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: `fa fa-caret-${!descending ? "down" : "up"}`
    }));
}

});
parcelRegister("gWMOV", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $7b01a128ea48ee14$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "STable", function () { return $7b01a128ea48ee14$export$31f29fe805867a44; });
$parcel$export(module.exports, "STableLink", function () { return $7b01a128ea48ee14$export$5d205f1ff8469dd8; });
$parcel$export(module.exports, "THead", function () { return $7b01a128ea48ee14$export$c4c2bc57f2e82919; });
$parcel$export(module.exports, "SStyledRow", function () { return $7b01a128ea48ee14$export$72a06ff62c26c441; });

var $gRonV = parcelRequire("gRonV");
const $7b01a128ea48ee14$export$e6dfd72ab29f8598 = (0, $gRonV.default).div`
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
        display: none;
    }
    & > table {
        width: auto;
        min-width: 100%;
        margin-bottom: unset;
    }
`;
const $7b01a128ea48ee14$export$8d7e657f252b8e7b = (0, $gRonV.keyframes)`
    from {
        opacity: 0;
        top: 0;
    }

    to {
        opacity: 1;
        top:  calc(-100% - 5px);
    }
`;
const $7b01a128ea48ee14$export$31f29fe805867a44 = (0, $gRonV.default).table`
    table-layout: fixed;

    & > tbody > tr > td {
        word-wrap: break-word;
        max-width: 320px;
    }

    & > thead > tr > th {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: var(--font-weight-bold);
    }

    tbody > tr:last-child > td > div > ul {
        top: calc(-100% - 5px);
        animation: ${$7b01a128ea48ee14$export$8d7e657f252b8e7b} 0.2s ease-in-out;
    }
`;
const $7b01a128ea48ee14$export$5d205f1ff8469dd8 = (0, $gRonV.default).a`
    cursor: auto;
    -webkit-user-select: text;
    -moz-select: text;
    -ms-select: text;
    user-select: text;
    &:not(:hover) {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: underline;
        font-size: 14px;
    }

    &:hover {
        text-decoration: underline;
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        text-decoration: underline;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $7b01a128ea48ee14$export$c4c2bc57f2e82919 = (0, $gRonV.default).thead`
    position: sticky;
    top: 0;
    background-color: #ffff;
    z-index: 1;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 900px) {
        table-layout: auto;
    }
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    font-size: 13px;
`;
const $7b01a128ea48ee14$export$72a06ff62c26c441 = (0, $gRonV.default).tr`
    &.clickable {
        cursor: pointer;
        transition: background-color ${({ theme: theme })=>theme.transition};
    }
`;

});



parcelRegister("bLM2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dacb325df4be708c$export$2e2bcd8739ae039; });

var $5u6k9 = parcelRequire("5u6k9");
const $dacb325df4be708c$var$useShortDatesNames = ()=>{
    const text = (0, $5u6k9.default)();
    const dayOfWeek = (dayNumber)=>{
        switch(dayNumber){
            case 1:
                return text("lblMonday");
            case 2:
                return text("lblTuesday");
            case 3:
                return text("lblWednesday");
            case 4:
                return text("lblThursday");
            case 5:
                return text("lblFriday");
            case 6:
                return text("lblSaturday");
            case 7:
                return text("lblSunday");
            default:
                return text("lblMonday");
        }
    };
    return (days)=>days.split("").map((item, index)=>{
            if (item === "-") return item;
            return dayOfWeek(index + 1).charAt(0);
        });
};
var $dacb325df4be708c$export$2e2bcd8739ae039 = $dacb325df4be708c$var$useShortDatesNames;

});

parcelRegister("5aWjz", function(module, exports) {
$parcel$export(module.exports, "GreenChargingBadge", function () { return (parcelRequire("aHnLz")).GreenChargingBadge; });
parcelRequire("aHnLz");

});
parcelRegister("aHnLz", function(module, exports) {

$parcel$export(module.exports, "GreenChargingBadge", function () { return $8333074a9c284795$export$24b5d58d0787b41; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");
parcelRequire("hWELq");
var $6QMPc = parcelRequire("6QMPc");

var $igvrl = parcelRequire("igvrl");
parcelRequire("eGqzt");
var $jPnjU = parcelRequire("jPnjU");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $5u6k9 = parcelRequire("5u6k9");
const $8333074a9c284795$var$SContainer = (0, $gRonV.default).div`
    border: 1px solid transparent;
    border-radius: 4px;
    color: black;
    display: flex;
    justify-content: space-between;
    font-weight: var(--font-weight-bold);
    margin-bottom: ${({ theme: theme })=>theme.sizing.padding.l};
    padding: ${({ theme: theme })=>theme.sizing.padding.s};
    overflow: hidden;
    background-color: ${({ theme: theme })=>theme.font.successColor + "2a"};
`;
const $8333074a9c284795$var$SGreenChargingIconWrapper = (0, $gRonV.default).div`
    margin-right: ${({ theme: theme })=>theme.sizing.margin.l};
    padding: ${({ theme: theme })=>theme.sizing.padding.m};
    background-color: ${({ theme: theme })=>theme.font.successColor};
    svg {
        position: relative;
        top: -1px;
    }
`;
const $8333074a9c284795$var$SInfoIconWrapper = (0, $gRonV.default).div`
    padding: 0 14px;
`;
const $8333074a9c284795$var$SInfoContainer = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
`;
function $8333074a9c284795$export$24b5d58d0787b41(props) {
    const text = (0, $5u6k9.default)();
    const { onTurnOff: onTurnOff, turnOffDisabled: turnOffDisabled, className: className, style: style, infoIconTooltip: infoIconTooltip = text("msgScheduleDisabledWhileGreenCharging"), isTurnOffRequestLoading: isTurnOffRequestLoading } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8333074a9c284795$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8333074a9c284795$var$SInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8333074a9c284795$var$SGreenChargingIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6QMPc.GreenChargingIcon), {
        size: 18
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgChargerIsInGreenChargingMode"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8333074a9c284795$var$SInfoIconWrapper, {
        "data-testid": "info-icon",
        title: infoIconTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jPnjU.InfoIcon), {
        fill: (0, $3CLIQ.theme).brandColors.CA_Blue,
        size: 19
    }))), onTurnOff && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnOff"),
        onClick: onTurnOff,
        disabled: turnOffDisabled,
        loading: isTurnOffRequestLoading
    }));
}

});


parcelRegister("fz1dI", function(module, exports) {
$parcel$export(module.exports, "CapiScheduleDialog", function () { return (parcelRequire("doZ3j")).CapiScheduleDialog; });
parcelRequire("doZ3j");

});
parcelRegister("doZ3j", function(module, exports) {

$parcel$export(module.exports, "CapiScheduleDialog", function () { return $9e3838ef322906d8$export$6fa05e1f01bc1a62; });

var $76MyM = parcelRequire("76MyM");

var $2kyoL = parcelRequire("2kyoL");

var $1ot1u = parcelRequire("1ot1u");

var $k6jwa = parcelRequire("k6jwa");

var $56EgM = parcelRequire("56EgM");

var $dE8RX = parcelRequire("dE8RX");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $5u6k9 = parcelRequire("5u6k9");

var $1O9Jh = parcelRequire("1O9Jh");
parcelRequire("MMfqT");
var $eySth = parcelRequire("eySth");
parcelRequire("1o9MR");
var $lMbZo = parcelRequire("lMbZo");
parcelRequire("j8chc");
var $6OeGJ = parcelRequire("6OeGJ");

var $4gSsL = parcelRequire("4gSsL");

var $igvrl = parcelRequire("igvrl");
const $9e3838ef322906d8$var$formId = "capi-schedule-form";
const $9e3838ef322906d8$var$dayFields = [
    {
        name: "monday",
        label: "lblShortestMonday"
    },
    {
        name: "tuesday",
        label: "lblShortestTuesday"
    },
    {
        name: "wednesday",
        label: "lblShortestWednesday"
    },
    {
        name: "thursday",
        label: "lblShortestThursday"
    },
    {
        name: "friday",
        label: "lblShortestFriday"
    },
    {
        name: "saturday",
        label: "lblShortestSaturday"
    },
    {
        name: "sunday",
        label: "lblShortestSunday"
    }
];
const $9e3838ef322906d8$var$createTime = (hours = 0, minutes = 0)=>{
    const time = new Date(0);
    time.setHours(hours, minutes, 0, 0);
    return time;
};
const $9e3838ef322906d8$var$getFormValues = (schedule)=>({
        name: schedule ? schedule.name : "",
        active: schedule ? schedule.active : true,
        startTime: $9e3838ef322906d8$var$createTime(schedule?.startHours, schedule?.startMinutes),
        endTime: $9e3838ef322906d8$var$createTime(schedule?.endHours, schedule?.endMinutes),
        monday: schedule?.monday ?? false,
        tuesday: schedule?.tuesday ?? false,
        wednesday: schedule?.wednesday ?? false,
        thursday: schedule?.thursday ?? false,
        friday: schedule?.friday ?? false,
        saturday: schedule?.saturday ?? false,
        sunday: schedule?.sunday ?? false,
        connectorIds: schedule ? schedule.connectorIds : [
            1,
            2
        ]
    });
const $9e3838ef322906d8$export$6fa05e1f01bc1a62 = /*#__PURE__*/ (0, $7E7Dk.memo)(function CapiScheduleDialog({ className: className, visible: visible, onHide: onHide, onSave: onSave, schedule: editableSchedule, chargePoint: chargePoint }) {
    const text = (0, $5u6k9.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    const [showInfo, setShowInfo] = (0, $7E7Dk.useState)(false);
    const [saveError, setSaveError] = (0, $7E7Dk.useState)(false);
    const initialValues = (0, $7E7Dk.useMemo)(()=>$9e3838ef322906d8$var$getFormValues(editableSchedule), [
        editableSchedule
    ]);
    const { control: control, handleSubmit: handleSubmit, register: register, reset: reset, watch: watch, formState: { errors: errors, isSubmitted: isSubmitted, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: initialValues,
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const [createSchedule, { isLoading: isCreating }] = (0, $1O9Jh.useScheduleCreateScheduleMutation)();
    const [updateSchedule, { isLoading: isUpdating }] = (0, $1O9Jh.useScheduleUpdateScheduleMutation)();
    const isSaving = isCreating || isUpdating;
    const scheduleName = watch("name");
    const connectors = [
        ...chargePoint.connectors ?? []
    ];
    connectors.sort((a, b)=>a.connectorId - b.connectorId);
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) {
            reset(initialValues);
            setShowInfo(false);
            setSaveError(false);
        }
    }, [
        initialValues,
        reset,
        visible
    ]);
    const save = async (formValues)=>{
        setSaveError(false);
        const selectedConnectorIds = connectors.filter((connector)=>formValues.connectorIds.includes(connector.connectorId)).map((connector)=>connector.connectorId);
        const schedule = {
            ...editableSchedule,
            name: formValues.name,
            active: formValues.active,
            chargePointId: chargePoint.id,
            connectorIdList: selectedConnectorIds.join(","),
            connectorIds: editableSchedule ? editableSchedule.connectorIds : [
                1,
                2
            ],
            connectors: chargePoint.connectors ? connectors.map((connector)=>({
                    name: adaptConnectorNaming(connector.name),
                    connectorId: connector.connectorId,
                    affected: formValues.connectorIds.includes(connector.connectorId)
                })) : undefined,
            startHours: formValues.startTime.getHours(),
            startMinutes: formValues.startTime.getMinutes(),
            endHours: formValues.endTime.getHours(),
            endMinutes: formValues.endTime.getMinutes(),
            timeZone: editableSchedule ? editableSchedule.timeZone : (0, (/*@__PURE__*/$parcel$interopDefault($2kyoL))).determine().name(),
            monday: formValues.monday,
            tuesday: formValues.tuesday,
            wednesday: formValues.wednesday,
            thursday: formValues.thursday,
            friday: formValues.friday,
            saturday: formValues.saturday,
            sunday: formValues.sunday
        };
        try {
            if (editableSchedule?.id) await updateSchedule({
                schedule: schedule
            }).unwrap();
            else await createSchedule({
                schedule: schedule
            }).unwrap();
            onSave();
            onHide();
        } catch  {
            setSaveError(true);
        }
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        text: true,
        label: text("btnCancel"),
        onClick: onHide,
        "data-testid": "btn-cancel"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        form: $9e3838ef322906d8$var$formId,
        label: text("btnSave"),
        loading: isSaving,
        disabled: isSaving || isSubmitted && !isValid,
        "data-testid": "btn-save"
    }));
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, editableSchedule ? text("lblSchedule", {
        name: scheduleName
    }) : text("lblNewScheduleModal")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        text: true,
        rounded: true,
        size: "small",
        icon: "pi pi-info-circle",
        "aria-label": text("lblInfo"),
        "aria-expanded": showInfo,
        onClick: ()=>setShowInfo((isVisible)=>!isVisible),
        "data-testid": "info-btn"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eySth.Dialog), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        visible: visible,
        onHide: onHide,
        header: title,
        footer: footer,
        "data-testid": "capi-schedule-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $9e3838ef322906d8$var$formId,
        className: "flex flex-column gap-4",
        onSubmit: handleSubmit(save),
        noValidate: true
    }, showInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "info",
        className: "w-full",
        "data-testid": "info-text",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgScheduleInfo",
            values: {
                test: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
                    className: "inline-flex align-items-center gap-1"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-toggle-off"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                    className: "pi pi-clock text-red-500"
                }))
            }
        })
    }) : null, saveError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "error",
        text: text("msgScheduleError"),
        className: "w-full"
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lMbZo.Input), {
        id: "schedule-name-input",
        label: text("lblName"),
        "data-testid": "name-field",
        required: true,
        error: errors.name?.message,
        ...register("name", {
            required: text("msgNameRequired")
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "active",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6OeGJ.Switch), {
                inputId: "schedule-active",
                checked: field.value,
                onChange: (event)=>field.onChange(Boolean(event.value)),
                label: text(field.value ? "lblActive" : "lblInactiveStatus"),
                "data-testid": "schedule-active"
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("fieldset", {
        className: "border-none p-0 m-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("legend", {
        className: "p-label mb-2"
    }, text("lblActiveDaysField")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap gap-3"
    }, $9e3838ef322906d8$var$dayFields.map(({ name: name, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
            key: name,
            name: name,
            control: control,
            render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    className: "flex align-items-center gap-2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
                    inputId: `schedule-${name}`,
                    checked: field.value,
                    onChange: (event)=>field.onChange(Boolean(event.checked))
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                    htmlFor: `schedule-${name}`
                }, text(label)))
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column sm:flex-row gap-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "startTime",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2 flex-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                className: "p-label",
                htmlFor: "schedule-start-time"
            }, text("lblFromField")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k6jwa.Calendar), {
                inputId: "schedule-start-time",
                value: field.value,
                onChange: (event)=>{
                    if (event.value instanceof Date) field.onChange(event.value);
                },
                timeOnly: true,
                hourFormat: "24",
                showIcon: true,
                icon: "pi pi-clock"
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "endTime",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2 flex-1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                className: "p-label",
                htmlFor: "schedule-end-time"
            }, text("lblToField")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k6jwa.Calendar), {
                inputId: "schedule-end-time",
                value: field.value,
                onChange: (event)=>{
                    if (event.value instanceof Date) field.onChange(event.value);
                },
                timeOnly: true,
                hourFormat: "24",
                showIcon: true,
                icon: "pi pi-clock"
            }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "connectorIds",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("fieldset", {
                className: "border-none p-0 m-0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("legend", {
                className: "p-label mb-2"
            }, text("lblAffectedByScheduleSection")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2"
            }, connectors.map((connector)=>{
                const inputId = `schedule-connector-${connector.connectorId}`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    key: connector.connectorId,
                    className: "flex align-items-center gap-2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
                    inputId: inputId,
                    checked: field.value.includes(connector.connectorId),
                    onChange: (event)=>field.onChange(event.checked ? [
                            ...field.value,
                            connector.connectorId
                        ] : field.value.filter((id)=>id !== connector.connectorId)),
                    "data-testid": `connector-${connector.connectorId}`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                    htmlFor: inputId
                }, adaptConnectorNaming(connector.name)));
            })))
    })));
});

});
parcelRegister("2kyoL", function(module, exports) {

module.exports = (parcelRequire("bSg4A"));

});
parcelRegister("bSg4A", function(module, exports) {
(function(root) {
    /**
 * This script gives you the zone info key representing your device's time zone setting.
 *
 * @name jsTimezoneDetect
 * @version 1.0.6
 * @author Jon Nylander
 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
 *
 * For usage and examples, visit:
 * http://pellepim.bitbucket.org/jstz/
 *
 * Copyright (c) Jon Nylander
 */ /**
 * Namespace to hold all the code for timezone detection.
 */ var jstz = function() {
        "use strict";
        var HEMISPHERE_SOUTH = "s", consts = {
            DAY: 86400000,
            HOUR: 3600000,
            MINUTE: 60000,
            SECOND: 1000,
            BASELINE_YEAR: 2014,
            MAX_SCORE: 864000000,
            AMBIGUITIES: {
                "America/Denver": [
                    "America/Mazatlan"
                ],
                "Europe/London": [
                    "Africa/Casablanca"
                ],
                "America/Chicago": [
                    "America/Mexico_City"
                ],
                "America/Asuncion": [
                    "America/Campo_Grande",
                    "America/Santiago"
                ],
                "America/Montevideo": [
                    "America/Sao_Paulo",
                    "America/Santiago"
                ],
                // Europe/Minsk should not be in this list... but Windows.
                "Asia/Beirut": [
                    "Asia/Amman",
                    "Asia/Jerusalem",
                    "Europe/Helsinki",
                    "Asia/Damascus",
                    "Africa/Cairo",
                    "Asia/Gaza",
                    "Europe/Minsk"
                ],
                "Pacific/Auckland": [
                    "Pacific/Fiji"
                ],
                "America/Los_Angeles": [
                    "America/Santa_Isabel"
                ],
                "America/New_York": [
                    "America/Havana"
                ],
                "America/Halifax": [
                    "America/Goose_Bay"
                ],
                "America/Godthab": [
                    "America/Miquelon"
                ],
                "Asia/Dubai": [
                    "Asia/Yerevan"
                ],
                "Asia/Jakarta": [
                    "Asia/Krasnoyarsk"
                ],
                "Asia/Shanghai": [
                    "Asia/Irkutsk",
                    "Australia/Perth"
                ],
                "Australia/Sydney": [
                    "Australia/Lord_Howe"
                ],
                "Asia/Tokyo": [
                    "Asia/Yakutsk"
                ],
                "Asia/Dhaka": [
                    "Asia/Omsk"
                ],
                // In the real world Yerevan is not ambigous for Baku... but Windows.
                "Asia/Baku": [
                    "Asia/Yerevan"
                ],
                "Australia/Brisbane": [
                    "Asia/Vladivostok"
                ],
                "Pacific/Noumea": [
                    "Asia/Vladivostok"
                ],
                "Pacific/Majuro": [
                    "Asia/Kamchatka",
                    "Pacific/Fiji"
                ],
                "Pacific/Tongatapu": [
                    "Pacific/Apia"
                ],
                "Asia/Baghdad": [
                    "Europe/Minsk",
                    "Europe/Moscow"
                ],
                "Asia/Karachi": [
                    "Asia/Yekaterinburg"
                ],
                "Africa/Johannesburg": [
                    "Asia/Gaza",
                    "Africa/Cairo"
                ]
            }
        }, /**
         * Gets the offset in minutes from UTC for a certain date.
         * @param {Date} date
         * @returns {Number}
         */ get_date_offset = function get_date_offset(date) {
            var offset = -date.getTimezoneOffset();
            return offset !== null ? offset : 0;
        }, /**
         * This function does some basic calculations to create information about
         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
         * the script has been tested rather than depend on the year set by the
         * client device.
         *
         * Returns a key that can be used to do lookups in jstz.olson.timezones.
         * eg: "720,1,2".
         *
         * @returns {String}
         */ lookup_key = function lookup_key() {
            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)), june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)), diff = january_offset - june_offset;
            if (diff < 0) return january_offset + ",1";
            else if (diff > 0) return june_offset + ",1," + HEMISPHERE_SOUTH;
            return january_offset + ",0";
        }, /**
         * Tries to get the time zone key directly from the operating system for those
         * environments that support the ECMAScript Internationalization API.
         */ get_from_internationalization_api = function get_from_internationalization_api() {
            var format, timezone;
            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") return;
            format = Intl.DateTimeFormat();
            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") return;
            timezone = format.resolvedOptions().timeZone;
            if (timezone && (timezone.indexOf("/") > -1 || timezone === "UTC") && timezone.indexOf("Etc") != 0) return timezone;
        }, /**
         * Starting point for getting all the DST rules for a specific year
         * for the current timezone (as described by the client system).
         *
         * Returns an object with start and end attributes, or false if no
         * DST rules were found for the year.
         *
         * @param year
         * @returns {Object} || {Boolean}
         */ dst_dates = function dst_dates(year) {
            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
            var current = yearstart;
            var offset = new Date(current).getTimezoneOffset();
            var dst_start = null;
            var dst_end = null;
            while(current < yearend - 86400000){
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
                if (dateToCheckOffset !== offset) {
                    if (dateToCheckOffset < offset) dst_start = dateToCheck;
                    if (dateToCheckOffset > offset) dst_end = dateToCheck;
                    offset = dateToCheckOffset;
                }
                current += 86400000;
            }
            if (dst_start && dst_end) return {
                s: find_dst_fold(dst_start).getTime(),
                e: find_dst_fold(dst_end).getTime()
            };
            return false;
        }, /**
         * Probably completely unnecessary function that recursively finds the
         * exact (to the second) time when a DST rule was changed.
         *
         * @param a_date - The candidate Date.
         * @param padding - integer specifying the padding to allow around the candidate
         *                  date for finding the fold.
         * @param iterator - integer specifying how many milliseconds to iterate while
         *                   searching for the fold.
         *
         * @returns {Date}
         */ find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
            if (typeof padding === "undefined") {
                padding = consts.DAY;
                iterator = consts.HOUR;
            }
            var date_start = new Date(a_date.getTime() - padding).getTime();
            var date_end = a_date.getTime() + padding;
            var offset = new Date(date_start).getTimezoneOffset();
            var current = date_start;
            var dst_change = null;
            while(current < date_end - iterator){
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
                if (dateToCheckOffset !== offset) {
                    dst_change = dateToCheck;
                    break;
                }
                current += iterator;
            }
            if (padding === consts.DAY) return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
            if (padding === consts.HOUR) return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
            return dst_change;
        }, windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
            if (score !== "N/A") return score;
            if (preliminary_timezone === "Asia/Beirut") {
                if (sample.name === "Africa/Cairo") {
                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) return 0;
                }
                if (sample.name === "Asia/Jerusalem") {
                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) return 0;
                }
            } else if (preliminary_timezone === "America/Santiago") {
                if (sample.name === "America/Asuncion") {
                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) return 0;
                }
                if (sample.name === "America/Campo_Grande") {
                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) return 0;
                }
            } else if (preliminary_timezone === "America/Montevideo") {
                if (sample.name === "America/Sao_Paulo") {
                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) return 0;
                }
            } else if (preliminary_timezone === "Pacific/Auckland") {
                if (sample.name === "Pacific/Fiji") {
                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) return 0;
                }
            }
            return score;
        }, /**
         * Takes the DST rules for the current timezone, and proceeds to find matches
         * in the jstz.olson.dst_rules.zones array.
         *
         * Compares samples to the current timezone on a scoring basis.
         *
         * Candidates are ruled immediately if either the candidate or the current zone
         * has a DST rule where the other does not.
         *
         * Candidates are ruled out immediately if the current zone has a rule that is
         * outside the DST scope of the candidate.
         *
         * Candidates are included for scoring if the current zones rules fall within the
         * span of the samples rules.
         *
         * Low score is best, the score is calculated by summing up the differences in DST
         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
         *
         * Yah follow? :)
         *
         * @param rule_list
         * @param preliminary_timezone
         * @returns {*}
         */ best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
            var score_sample = function score_sample(sample) {
                var score = 0;
                for(var j = 0; j < rule_list.length; j++)// Both sample and current time zone report DST during the year.
                if (!!sample.rules[j] && !!rule_list[j]) {
                    // The current time zone's DST rules are inside the sample's. Include.
                    if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
                        score = 0;
                        score += Math.abs(rule_list[j].s - sample.rules[j].s);
                        score += Math.abs(sample.rules[j].e - rule_list[j].e);
                    // The current time zone's DST rules are outside the sample's. Discard.
                    } else {
                        score = "N/A";
                        break;
                    }
                    // The max score has been reached. Discard.
                    if (score > consts.MAX_SCORE) {
                        score = "N/A";
                        break;
                    }
                }
                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);
                return score;
            };
            var scoreboard = {};
            var dst_zones = jstz.olson.dst_rules.zones;
            var dst_zones_length = dst_zones.length;
            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];
            for(var i = 0; i < dst_zones_length; i++){
                var sample = dst_zones[i];
                var score = score_sample(dst_zones[i]);
                if (score !== "N/A") scoreboard[sample.name] = score;
            }
            for(var tz in scoreboard){
                if (scoreboard.hasOwnProperty(tz)) for(var j = 0; j < ambiguities.length; j++){
                    if (ambiguities[j] === tz) return tz;
                }
            }
            return preliminary_timezone;
        }, /**
         * Takes the preliminary_timezone as detected by lookup_key().
         *
         * Builds up the current timezones DST rules for the years defined
         * in the jstz.olson.dst_rules.years array.
         *
         * If there are no DST occurences for those years, immediately returns
         * the preliminary timezone. Otherwise proceeds and tries to solve
         * ambiguities.
         *
         * @param preliminary_timezone
         * @returns {String} timezone_name
         */ get_by_dst = function get_by_dst(preliminary_timezone) {
            var get_rules = function get_rules() {
                var rule_list = [];
                for(var i = 0; i < jstz.olson.dst_rules.years.length; i++){
                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
                    rule_list.push(year_rules);
                }
                return rule_list;
            };
            var check_has_dst = function check_has_dst(rules) {
                for(var i = 0; i < rules.length; i++){
                    if (rules[i] !== false) return true;
                }
                return false;
            };
            var rules = get_rules();
            var has_dst = check_has_dst(rules);
            if (has_dst) return best_dst_match(rules, preliminary_timezone);
            return preliminary_timezone;
        }, /**
         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
         *
         * Returns an object with one function ".name()"
         *
         * @returns Object
         */ determine = function determine() {
            var preliminary_tz = get_from_internationalization_api();
            if (!preliminary_tz) {
                preliminary_tz = jstz.olson.timezones[lookup_key()];
                if (typeof consts.AMBIGUITIES[preliminary_tz] !== "undefined") preliminary_tz = get_by_dst(preliminary_tz);
            }
            return {
                name: function() {
                    return preliminary_tz;
                },
                stdTimezoneOffset: function() {
                    // negative to match what (new Date).getTimezoneOffset() will return
                    return -lookup_key().split(",")[0];
                },
                timezoneOffset: function() {
                    // negative to match what (new Date).getTimezoneOffset() will return
                    return -get_date_offset(new Date());
                }
            };
        };
        return {
            determine: determine
        };
    }();
    jstz.olson = jstz.olson || {};
    /**
 * The keys in this dictionary are comma separated as such:
 *
 * First the offset compared to UTC time in minutes.
 *
 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
 * does.
 *
 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
 * only interesting for timezones with DST.
 *
 * The mapped arrays is used for constructing the jstz.TimeZone object from within
 * jstz.determine();
 */ jstz.olson.timezones = {
        "-720,0": "Etc/GMT+12",
        "-660,0": "Pacific/Pago_Pago",
        "-660,1,s": "Pacific/Apia",
        "-600,1": "America/Adak",
        "-600,0": "Pacific/Honolulu",
        "-570,0": "Pacific/Marquesas",
        "-540,0": "Pacific/Gambier",
        "-540,1": "America/Anchorage",
        "-480,1": "America/Los_Angeles",
        "-480,0": "Pacific/Pitcairn",
        "-420,0": "America/Phoenix",
        "-420,1": "America/Denver",
        "-360,0": "America/Guatemala",
        "-360,1": "America/Chicago",
        "-360,1,s": "Pacific/Easter",
        "-300,0": "America/Bogota",
        "-300,1": "America/New_York",
        "-270,0": "America/Caracas",
        "-240,1": "America/Halifax",
        "-240,0": "America/Santo_Domingo",
        "-240,1,s": "America/Asuncion",
        "-210,1": "America/St_Johns",
        "-180,1": "America/Godthab",
        "-180,0": "America/Argentina/Buenos_Aires",
        "-180,1,s": "America/Montevideo",
        "-120,0": "America/Noronha",
        "-120,1": "America/Noronha",
        "-60,1": "Atlantic/Azores",
        "-60,0": "Atlantic/Cape_Verde",
        "0,0": "UTC",
        "0,1": "Europe/London",
        "60,1": "Europe/Berlin",
        "60,0": "Africa/Lagos",
        "60,1,s": "Africa/Windhoek",
        "120,1": "Asia/Beirut",
        "120,0": "Africa/Johannesburg",
        "180,0": "Asia/Baghdad",
        "180,1": "Europe/Moscow",
        "210,1": "Asia/Tehran",
        "240,0": "Asia/Dubai",
        "240,1": "Asia/Baku",
        "270,0": "Asia/Kabul",
        "300,1": "Asia/Yekaterinburg",
        "300,0": "Asia/Karachi",
        "330,0": "Asia/Kolkata",
        "345,0": "Asia/Kathmandu",
        "360,0": "Asia/Dhaka",
        "360,1": "Asia/Omsk",
        "390,0": "Asia/Rangoon",
        "420,1": "Asia/Krasnoyarsk",
        "420,0": "Asia/Jakarta",
        "480,0": "Asia/Shanghai",
        "480,1": "Asia/Irkutsk",
        "525,0": "Australia/Eucla",
        "525,1,s": "Australia/Eucla",
        "540,1": "Asia/Yakutsk",
        "540,0": "Asia/Tokyo",
        "570,0": "Australia/Darwin",
        "570,1,s": "Australia/Adelaide",
        "600,0": "Australia/Brisbane",
        "600,1": "Asia/Vladivostok",
        "600,1,s": "Australia/Sydney",
        "630,1,s": "Australia/Lord_Howe",
        "660,1": "Asia/Kamchatka",
        "660,0": "Pacific/Noumea",
        "690,0": "Pacific/Norfolk",
        "720,1,s": "Pacific/Auckland",
        "720,0": "Pacific/Majuro",
        "765,1,s": "Pacific/Chatham",
        "780,0": "Pacific/Tongatapu",
        "780,1,s": "Pacific/Apia",
        "840,0": "Pacific/Kiritimati"
    };
    /* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */ jstz.olson.dst_rules = {
        "years": [
            2008,
            2009,
            2010,
            2011,
            2012,
            2013,
            2014
        ],
        "zones": [
            {
                "name": "Africa/Cairo",
                "rules": [
                    {
                        "e": 1219957200000,
                        "s": 1209074400000
                    },
                    {
                        "e": 1250802000000,
                        "s": 1240524000000
                    },
                    {
                        "e": 1285880400000,
                        "s": 1284069600000
                    },
                    false,
                    false,
                    false,
                    {
                        "e": 1411678800000,
                        "s": 1406844000000
                    }
                ]
            },
            {
                "name": "Africa/Casablanca",
                "rules": [
                    {
                        "e": 1220223600000,
                        "s": 1212278400000
                    },
                    {
                        "e": 1250809200000,
                        "s": 1243814400000
                    },
                    {
                        "e": 1281222000000,
                        "s": 1272758400000
                    },
                    {
                        "e": 1312066800000,
                        "s": 1301788800000
                    },
                    {
                        "e": 1348970400000,
                        "s": 1345428000000
                    },
                    {
                        "e": 1382839200000,
                        "s": 1376100000000
                    },
                    {
                        "e": 1414288800000,
                        "s": 1406944800000
                    }
                ]
            },
            {
                "name": "America/Asuncion",
                "rules": [
                    {
                        "e": 1205031600000,
                        "s": 1224388800000
                    },
                    {
                        "e": 1236481200000,
                        "s": 1255838400000
                    },
                    {
                        "e": 1270954800000,
                        "s": 1286078400000
                    },
                    {
                        "e": 1302404400000,
                        "s": 1317528000000
                    },
                    {
                        "e": 1333854000000,
                        "s": 1349582400000
                    },
                    {
                        "e": 1364094000000,
                        "s": 1381032000000
                    },
                    {
                        "e": 1395543600000,
                        "s": 1412481600000
                    }
                ]
            },
            {
                "name": "America/Campo_Grande",
                "rules": [
                    {
                        "e": 1203217200000,
                        "s": 1224388800000
                    },
                    {
                        "e": 1234666800000,
                        "s": 1255838400000
                    },
                    {
                        "e": 1266721200000,
                        "s": 1287288000000
                    },
                    {
                        "e": 1298170800000,
                        "s": 1318737600000
                    },
                    {
                        "e": 1330225200000,
                        "s": 1350792000000
                    },
                    {
                        "e": 1361070000000,
                        "s": 1382241600000
                    },
                    {
                        "e": 1392519600000,
                        "s": 1413691200000
                    }
                ]
            },
            {
                "name": "America/Goose_Bay",
                "rules": [
                    {
                        "e": 1225594860000,
                        "s": 1205035260000
                    },
                    {
                        "e": 1257044460000,
                        "s": 1236484860000
                    },
                    {
                        "e": 1289098860000,
                        "s": 1268539260000
                    },
                    {
                        "e": 1320555600000,
                        "s": 1299988860000
                    },
                    {
                        "e": 1352005200000,
                        "s": 1331445600000
                    },
                    {
                        "e": 1383454800000,
                        "s": 1362895200000
                    },
                    {
                        "e": 1414904400000,
                        "s": 1394344800000
                    }
                ]
            },
            {
                "name": "America/Havana",
                "rules": [
                    {
                        "e": 1224997200000,
                        "s": 1205643600000
                    },
                    {
                        "e": 1256446800000,
                        "s": 1236488400000
                    },
                    {
                        "e": 1288501200000,
                        "s": 1268542800000
                    },
                    {
                        "e": 1321160400000,
                        "s": 1300597200000
                    },
                    {
                        "e": 1352005200000,
                        "s": 1333256400000
                    },
                    {
                        "e": 1383454800000,
                        "s": 1362891600000
                    },
                    {
                        "e": 1414904400000,
                        "s": 1394341200000
                    }
                ]
            },
            {
                "name": "America/Mazatlan",
                "rules": [
                    {
                        "e": 1225008000000,
                        "s": 1207472400000
                    },
                    {
                        "e": 1256457600000,
                        "s": 1238922000000
                    },
                    {
                        "e": 1288512000000,
                        "s": 1270371600000
                    },
                    {
                        "e": 1319961600000,
                        "s": 1301821200000
                    },
                    {
                        "e": 1351411200000,
                        "s": 1333270800000
                    },
                    {
                        "e": 1382860800000,
                        "s": 1365325200000
                    },
                    {
                        "e": 1414310400000,
                        "s": 1396774800000
                    }
                ]
            },
            {
                "name": "America/Mexico_City",
                "rules": [
                    {
                        "e": 1225004400000,
                        "s": 1207468800000
                    },
                    {
                        "e": 1256454000000,
                        "s": 1238918400000
                    },
                    {
                        "e": 1288508400000,
                        "s": 1270368000000
                    },
                    {
                        "e": 1319958000000,
                        "s": 1301817600000
                    },
                    {
                        "e": 1351407600000,
                        "s": 1333267200000
                    },
                    {
                        "e": 1382857200000,
                        "s": 1365321600000
                    },
                    {
                        "e": 1414306800000,
                        "s": 1396771200000
                    }
                ]
            },
            {
                "name": "America/Miquelon",
                "rules": [
                    {
                        "e": 1225598400000,
                        "s": 1205038800000
                    },
                    {
                        "e": 1257048000000,
                        "s": 1236488400000
                    },
                    {
                        "e": 1289102400000,
                        "s": 1268542800000
                    },
                    {
                        "e": 1320552000000,
                        "s": 1299992400000
                    },
                    {
                        "e": 1352001600000,
                        "s": 1331442000000
                    },
                    {
                        "e": 1383451200000,
                        "s": 1362891600000
                    },
                    {
                        "e": 1414900800000,
                        "s": 1394341200000
                    }
                ]
            },
            {
                "name": "America/Santa_Isabel",
                "rules": [
                    {
                        "e": 1225011600000,
                        "s": 1207476000000
                    },
                    {
                        "e": 1256461200000,
                        "s": 1238925600000
                    },
                    {
                        "e": 1288515600000,
                        "s": 1270375200000
                    },
                    {
                        "e": 1319965200000,
                        "s": 1301824800000
                    },
                    {
                        "e": 1351414800000,
                        "s": 1333274400000
                    },
                    {
                        "e": 1382864400000,
                        "s": 1365328800000
                    },
                    {
                        "e": 1414314000000,
                        "s": 1396778400000
                    }
                ]
            },
            {
                "name": "America/Santiago",
                "rules": [
                    {
                        "e": 1206846000000,
                        "s": 1223784000000
                    },
                    {
                        "e": 1237086000000,
                        "s": 1255233600000
                    },
                    {
                        "e": 1270350000000,
                        "s": 1286683200000
                    },
                    {
                        "e": 1304823600000,
                        "s": 1313899200000
                    },
                    {
                        "e": 1335668400000,
                        "s": 1346558400000
                    },
                    {
                        "e": 1367118000000,
                        "s": 1378612800000
                    },
                    {
                        "e": 1398567600000,
                        "s": 1410062400000
                    }
                ]
            },
            {
                "name": "America/Sao_Paulo",
                "rules": [
                    {
                        "e": 1203213600000,
                        "s": 1224385200000
                    },
                    {
                        "e": 1234663200000,
                        "s": 1255834800000
                    },
                    {
                        "e": 1266717600000,
                        "s": 1287284400000
                    },
                    {
                        "e": 1298167200000,
                        "s": 1318734000000
                    },
                    {
                        "e": 1330221600000,
                        "s": 1350788400000
                    },
                    {
                        "e": 1361066400000,
                        "s": 1382238000000
                    },
                    {
                        "e": 1392516000000,
                        "s": 1413687600000
                    }
                ]
            },
            {
                "name": "Asia/Amman",
                "rules": [
                    {
                        "e": 1225404000000,
                        "s": 1206655200000
                    },
                    {
                        "e": 1256853600000,
                        "s": 1238104800000
                    },
                    {
                        "e": 1288303200000,
                        "s": 1269554400000
                    },
                    {
                        "e": 1319752800000,
                        "s": 1301608800000
                    },
                    false,
                    false,
                    {
                        "e": 1414706400000,
                        "s": 1395957600000
                    }
                ]
            },
            {
                "name": "Asia/Damascus",
                "rules": [
                    {
                        "e": 1225486800000,
                        "s": 1207260000000
                    },
                    {
                        "e": 1256850000000,
                        "s": 1238104800000
                    },
                    {
                        "e": 1288299600000,
                        "s": 1270159200000
                    },
                    {
                        "e": 1319749200000,
                        "s": 1301608800000
                    },
                    {
                        "e": 1351198800000,
                        "s": 1333058400000
                    },
                    {
                        "e": 1382648400000,
                        "s": 1364508000000
                    },
                    {
                        "e": 1414702800000,
                        "s": 1395957600000
                    }
                ]
            },
            {
                "name": "Asia/Dubai",
                "rules": [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Gaza",
                "rules": [
                    {
                        "e": 1219957200000,
                        "s": 1206655200000
                    },
                    {
                        "e": 1252015200000,
                        "s": 1238104800000
                    },
                    {
                        "e": 1281474000000,
                        "s": 1269640860000
                    },
                    {
                        "e": 1312146000000,
                        "s": 1301608860000
                    },
                    {
                        "e": 1348178400000,
                        "s": 1333058400000
                    },
                    {
                        "e": 1380229200000,
                        "s": 1364508000000
                    },
                    {
                        "e": 1414098000000,
                        "s": 1395957600000
                    }
                ]
            },
            {
                "name": "Asia/Irkutsk",
                "rules": [
                    {
                        "e": 1224957600000,
                        "s": 1206813600000
                    },
                    {
                        "e": 1256407200000,
                        "s": 1238263200000
                    },
                    {
                        "e": 1288461600000,
                        "s": 1269712800000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Jerusalem",
                "rules": [
                    {
                        "e": 1223161200000,
                        "s": 1206662400000
                    },
                    {
                        "e": 1254006000000,
                        "s": 1238112000000
                    },
                    {
                        "e": 1284246000000,
                        "s": 1269561600000
                    },
                    {
                        "e": 1317510000000,
                        "s": 1301616000000
                    },
                    {
                        "e": 1348354800000,
                        "s": 1333065600000
                    },
                    {
                        "e": 1382828400000,
                        "s": 1364515200000
                    },
                    {
                        "e": 1414278000000,
                        "s": 1395964800000
                    }
                ]
            },
            {
                "name": "Asia/Kamchatka",
                "rules": [
                    {
                        "e": 1224943200000,
                        "s": 1206799200000
                    },
                    {
                        "e": 1256392800000,
                        "s": 1238248800000
                    },
                    {
                        "e": 1288450800000,
                        "s": 1269698400000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Krasnoyarsk",
                "rules": [
                    {
                        "e": 1224961200000,
                        "s": 1206817200000
                    },
                    {
                        "e": 1256410800000,
                        "s": 1238266800000
                    },
                    {
                        "e": 1288465200000,
                        "s": 1269716400000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Omsk",
                "rules": [
                    {
                        "e": 1224964800000,
                        "s": 1206820800000
                    },
                    {
                        "e": 1256414400000,
                        "s": 1238270400000
                    },
                    {
                        "e": 1288468800000,
                        "s": 1269720000000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Vladivostok",
                "rules": [
                    {
                        "e": 1224950400000,
                        "s": 1206806400000
                    },
                    {
                        "e": 1256400000000,
                        "s": 1238256000000
                    },
                    {
                        "e": 1288454400000,
                        "s": 1269705600000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Yakutsk",
                "rules": [
                    {
                        "e": 1224954000000,
                        "s": 1206810000000
                    },
                    {
                        "e": 1256403600000,
                        "s": 1238259600000
                    },
                    {
                        "e": 1288458000000,
                        "s": 1269709200000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Yekaterinburg",
                "rules": [
                    {
                        "e": 1224968400000,
                        "s": 1206824400000
                    },
                    {
                        "e": 1256418000000,
                        "s": 1238274000000
                    },
                    {
                        "e": 1288472400000,
                        "s": 1269723600000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Asia/Yerevan",
                "rules": [
                    {
                        "e": 1224972000000,
                        "s": 1206828000000
                    },
                    {
                        "e": 1256421600000,
                        "s": 1238277600000
                    },
                    {
                        "e": 1288476000000,
                        "s": 1269727200000
                    },
                    {
                        "e": 1319925600000,
                        "s": 1301176800000
                    },
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Australia/Lord_Howe",
                "rules": [
                    {
                        "e": 1207407600000,
                        "s": 1223134200000
                    },
                    {
                        "e": 1238857200000,
                        "s": 1254583800000
                    },
                    {
                        "e": 1270306800000,
                        "s": 1286033400000
                    },
                    {
                        "e": 1301756400000,
                        "s": 1317483000000
                    },
                    {
                        "e": 1333206000000,
                        "s": 1349537400000
                    },
                    {
                        "e": 1365260400000,
                        "s": 1380987000000
                    },
                    {
                        "e": 1396710000000,
                        "s": 1412436600000
                    }
                ]
            },
            {
                "name": "Australia/Perth",
                "rules": [
                    {
                        "e": 1206813600000,
                        "s": 1224957600000
                    },
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Europe/Helsinki",
                "rules": [
                    {
                        "e": 1224982800000,
                        "s": 1206838800000
                    },
                    {
                        "e": 1256432400000,
                        "s": 1238288400000
                    },
                    {
                        "e": 1288486800000,
                        "s": 1269738000000
                    },
                    {
                        "e": 1319936400000,
                        "s": 1301187600000
                    },
                    {
                        "e": 1351386000000,
                        "s": 1332637200000
                    },
                    {
                        "e": 1382835600000,
                        "s": 1364691600000
                    },
                    {
                        "e": 1414285200000,
                        "s": 1396141200000
                    }
                ]
            },
            {
                "name": "Europe/Minsk",
                "rules": [
                    {
                        "e": 1224979200000,
                        "s": 1206835200000
                    },
                    {
                        "e": 1256428800000,
                        "s": 1238284800000
                    },
                    {
                        "e": 1288483200000,
                        "s": 1269734400000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Europe/Moscow",
                "rules": [
                    {
                        "e": 1224975600000,
                        "s": 1206831600000
                    },
                    {
                        "e": 1256425200000,
                        "s": 1238281200000
                    },
                    {
                        "e": 1288479600000,
                        "s": 1269730800000
                    },
                    false,
                    false,
                    false,
                    false
                ]
            },
            {
                "name": "Pacific/Apia",
                "rules": [
                    false,
                    false,
                    false,
                    {
                        "e": 1301752800000,
                        "s": 1316872800000
                    },
                    {
                        "e": 1333202400000,
                        "s": 1348927200000
                    },
                    {
                        "e": 1365256800000,
                        "s": 1380376800000
                    },
                    {
                        "e": 1396706400000,
                        "s": 1411826400000
                    }
                ]
            },
            {
                "name": "Pacific/Fiji",
                "rules": [
                    false,
                    false,
                    {
                        "e": 1269698400000,
                        "s": 1287842400000
                    },
                    {
                        "e": 1327154400000,
                        "s": 1319292000000
                    },
                    {
                        "e": 1358604000000,
                        "s": 1350741600000
                    },
                    {
                        "e": 1390050000000,
                        "s": 1382796000000
                    },
                    {
                        "e": 1421503200000,
                        "s": 1414850400000
                    }
                ]
            },
            {
                "name": "Europe/London",
                "rules": [
                    {
                        "e": 1224982800000,
                        "s": 1206838800000
                    },
                    {
                        "e": 1256432400000,
                        "s": 1238288400000
                    },
                    {
                        "e": 1288486800000,
                        "s": 1269738000000
                    },
                    {
                        "e": 1319936400000,
                        "s": 1301187600000
                    },
                    {
                        "e": 1351386000000,
                        "s": 1332637200000
                    },
                    {
                        "e": 1382835600000,
                        "s": 1364691600000
                    },
                    {
                        "e": 1414285200000,
                        "s": 1396141200000
                    }
                ]
            }
        ]
    };
    if (typeof module.exports !== "undefined") module.exports = jstz;
    else if (typeof define !== "undefined" && define !== null && define.amd != null) define([], function() {
        return jstz;
    });
    else if (typeof root === "undefined") window.jstz = jstz;
    else root.jstz = jstz;
})();

});


parcelRegister("k6jwa", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $ea238209e381f15e$export$e1aef45b828286de; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $1ot1u = parcelRequire("1ot1u");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $jrCCO = parcelRequire("jrCCO");

var $9pANH = parcelRequire("9pANH");

var $5o5UD = parcelRequire("5o5UD");

var $62XPz = parcelRequire("62XPz");

var $difhH = parcelRequire("difhH");

var $kl2VR = parcelRequire("kl2VR");

var $hB9Eg = parcelRequire("hB9Eg");

var $1PxL0 = parcelRequire("1PxL0");

var $7nrKB = parcelRequire("7nrKB");

var $5B1eM = parcelRequire("5B1eM");

var $ingJg = parcelRequire("ingJg");
"use client";
function $ea238209e381f15e$var$_extends() {
    return $ea238209e381f15e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea238209e381f15e$var$_extends.apply(null, arguments);
}
function $ea238209e381f15e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ea238209e381f15e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea238209e381f15e$var$_typeof(o);
}
function $ea238209e381f15e$var$toPrimitive(t, r) {
    if ("object" != $ea238209e381f15e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ea238209e381f15e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ea238209e381f15e$var$toPropertyKey(t) {
    var i = $ea238209e381f15e$var$toPrimitive(t, "string");
    return "symbol" == $ea238209e381f15e$var$_typeof(i) ? i : i + "";
}
function $ea238209e381f15e$var$_defineProperty(e, r, t) {
    return (r = $ea238209e381f15e$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ea238209e381f15e$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ea238209e381f15e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ea238209e381f15e$var$_arrayLikeToArray$1(r);
}
function $ea238209e381f15e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $ea238209e381f15e$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $ea238209e381f15e$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ea238209e381f15e$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $ea238209e381f15e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea238209e381f15e$var$_toConsumableArray(r) {
    return $ea238209e381f15e$var$_arrayWithoutHoles(r) || $ea238209e381f15e$var$_iterableToArray(r) || $ea238209e381f15e$var$_unsupportedIterableToArray$1(r) || $ea238209e381f15e$var$_nonIterableSpread();
}
function $ea238209e381f15e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ea238209e381f15e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ea238209e381f15e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea238209e381f15e$var$_slicedToArray(r, e) {
    return $ea238209e381f15e$var$_arrayWithHoles(r) || $ea238209e381f15e$var$_iterableToArrayLimit(r, e) || $ea238209e381f15e$var$_unsupportedIterableToArray$1(r, e) || $ea238209e381f15e$var$_nonIterableRest();
}
var $ea238209e381f15e$var$styles = "\n@layer primereact {\n    .p-calendar {\n        position: relative;\n        display: inline-flex;\n        max-width: 100%;\n    }\n\n    .p-calendar .p-inputtext {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-calendar-w-btn-right .p-inputtext {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .p-calendar-w-btn-right .p-datepicker-trigger {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-inputtext {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-datepicker-trigger {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    /* Fluid */\n    .p-fluid .p-calendar {\n        display: flex;\n    }\n\n    .p-fluid .p-calendar .p-inputtext {\n        width: 1%;\n    }\n\n    /* Datepicker */\n    .p-calendar .p-datepicker {\n        min-width: 100%;\n    }\n\n    .p-datepicker {\n        width: auto;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-datepicker-inline {\n        display: inline-block;\n        position: static;\n        overflow-x: auto;\n    }\n\n    /* Header */\n    .p-datepicker-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-datepicker-header .p-datepicker-title {\n        margin: 0 auto;\n    }\n\n    .p-datepicker-prev,\n    .p-datepicker-next {\n        cursor: pointer;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    .p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {\n        flex: 1 1 auto;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    /* DatePicker Table */\n    .p-datepicker table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .p-datepicker td > span {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin: 0 auto;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Month Picker */\n    .p-monthpicker-month {\n        width: 33.3%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /*  Button Bar */\n    .p-datepicker-buttonbar {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    /* Time Picker */\n    .p-timepicker {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .p-timepicker button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-timepicker > div {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    /* Touch UI */\n    .p-datepicker-touch-ui,\n    .p-calendar .p-datepicker-touch-ui {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        min-width: 80vw;\n        transform: translate(-50%, -50%);\n    }\n\n    /* Year Picker */\n    .p-yearpicker-year {\n        width: 50%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n}\n";
var $ea238209e381f15e$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, isFilled = _ref.isFilled, panelVisible = _ref.panelVisible;
        return (0, $7nrKB.classNames)("p-calendar p-component p-inputwrapper", $ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty($ea238209e381f15e$var$_defineProperty({}, "p-calendar-w-btn p-calendar-w-btn-".concat(props.iconPos), props.showIcon), "p-calendar-disabled", props.disabled), "p-invalid", props.invalid), "p-calendar-timeonly", props.timeOnly), "p-inputwrapper-filled", props.value || isFilled), "p-inputwrapper-focus", focusedState), "p-focus", focusedState || panelVisible));
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $7nrKB.classNames)("p-inputtext p-component", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    dropdownButton: "p-datepicker-trigger",
    buttonbar: "p-datepicker-buttonbar",
    todayButton: "p-button-text",
    clearButton: "p-button-text",
    footer: "p-datepicker-footer",
    yearPicker: "p-yearpicker",
    year: function year(_ref3) {
        var isYearSelected = _ref3.isYearSelected, y = _ref3.y, isMonthYearDisabled = _ref3.isMonthYearDisabled;
        return (0, $7nrKB.classNames)("p-yearpicker-year", {
            "p-highlight": isYearSelected(y),
            "p-disabled": isMonthYearDisabled(-1, y)
        });
    },
    monthPicker: "p-monthpicker",
    month: function month(_ref4) {
        var isMonthSelected = _ref4.isMonthSelected, isMonthYearDisabled = _ref4.isMonthYearDisabled, i = _ref4.i, currentYear = _ref4.currentYear;
        return (0, $7nrKB.classNames)("p-monthpicker-month", {
            "p-highlight": isMonthSelected(i),
            "p-disabled": isMonthYearDisabled(i, currentYear)
        });
    },
    hourPicker: "p-hour-picker",
    secondPicker: "p-second-picker",
    minutePicker: "p-minute-picker",
    millisecondPicker: "p-millisecond-picker",
    ampmPicker: "p-ampm-picker",
    separatorContainer: "p-separator",
    dayLabel: function dayLabel(_ref5) {
        var className = _ref5.className;
        return className;
    },
    day: function day(_ref6) {
        var date = _ref6.date;
        return (0, $7nrKB.classNames)({
            "p-datepicker-other-month": date.otherMonth,
            "p-datepicker-today": date.today
        });
    },
    panel: function panel(_ref7) {
        var panelClassName = _ref7.panelClassName;
        return panelClassName;
    },
    previousIcon: "p-datepicker-prev-icon",
    previousButton: "p-datepicker-prev",
    nextIcon: "p-datepicker-next-icon",
    nextButton: "p-datepicker-next",
    incrementButton: "p-link",
    decrementButton: "p-link",
    title: "p-datepicker-title",
    timePicker: "p-timepicker",
    monthTitle: "p-datepicker-month p-link",
    yearTitle: "p-datepicker-year p-link",
    decadeTitle: "p-datepicker-decade",
    header: "p-datepicker-header",
    groupContainer: "p-datepicker-group-container",
    group: "p-datepicker-group",
    select: function select(_ref8) {
        var props = _ref8.props;
        return props.monthNavigator && props.view !== "month" ? "p-datepicker-month" : props.yearNavigator ? "p-datepicker-year" : undefined;
    },
    weekHeader: "p-datepicker-weekheader p-disabled",
    weekNumber: "p-datepicker-weeknumber",
    weekLabelContainer: "p-disabled",
    container: "p-datepicker-calendar-container",
    table: "p-datepicker-calendar",
    transition: "p-connected-overlay"
};
var $ea238209e381f15e$var$CalendarBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Calendar",
        appendTo: null,
        ariaLabelledBy: null,
        ariaLabel: null,
        autoZIndex: true,
        autoFocus: false,
        baseZIndex: 0,
        className: null,
        clearButtonClassName: "p-button-secondary",
        dateFormat: null,
        dateTemplate: null,
        decadeTemplate: null,
        decrementIcon: null,
        disabled: false,
        disabledDates: null,
        disabledDays: null,
        enabledDates: null,
        footerTemplate: null,
        formatDateTime: null,
        headerTemplate: null,
        hideOnDateTimeSelect: false,
        hideOnRangeSelection: false,
        hourFormat: "24",
        icon: null,
        iconPos: "right",
        id: null,
        incrementIcon: null,
        inline: false,
        inputClassName: null,
        inputId: null,
        inputMode: "none",
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        keepInvalid: false,
        locale: null,
        mask: null,
        maskSlotChar: "_",
        maxDate: null,
        maxDateCount: null,
        minDate: null,
        monthNavigator: false,
        monthNavigatorTemplate: null,
        name: null,
        nextIcon: null,
        numberOfMonths: 1,
        onBlur: null,
        onChange: null,
        onClearButtonClick: null,
        onFocus: null,
        onHide: null,
        onInput: null,
        onMonthChange: null,
        onSelect: null,
        onShow: null,
        onTodayButtonClick: null,
        onViewDateChange: null,
        onVisibleChange: null,
        panelClassName: null,
        panelStyle: null,
        parseDateTime: null,
        placeholder: null,
        prevIcon: null,
        readOnlyInput: false,
        required: false,
        selectOtherMonths: false,
        selectionMode: "single",
        shortYearCutoff: "+10",
        showButtonBar: false,
        showIcon: false,
        showMillisec: false,
        showMinMaxRange: false,
        showOnFocus: true,
        showOtherMonths: true,
        showSeconds: false,
        showTime: false,
        showWeek: false,
        stepHour: 1,
        stepMillisec: 1,
        stepMinute: 1,
        stepSecond: 1,
        style: null,
        tabIndex: null,
        timeOnly: false,
        todayButtonClassName: "p-button-secondary",
        tooltip: null,
        tooltipOptions: null,
        touchUI: false,
        transitionOptions: null,
        value: null,
        view: "date",
        viewDate: null,
        visible: false,
        yearNavigator: false,
        yearNavigatorTemplate: null,
        yearRange: null,
        children: undefined
    },
    css: {
        classes: $ea238209e381f15e$var$classes,
        styles: $ea238209e381f15e$var$styles
    }
});
var $ea238209e381f15e$var$CalendarPanel = /*#__PURE__*/ $7E7Dk.forwardRef(function(props, ref) {
    var cx = props.cx;
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var createElement = function createElement() {
        var panelProps = mergeProps({
            className: cx("panel", {
                panelClassName: props.className
            }),
            style: props.style,
            role: props.inline ? null : "dialog",
            id: props.id,
            "aria-label": (0, $eHYdO.localeOption)("chooseDate", props.locale),
            "aria-modal": props.inline ? null : "true",
            onClick: props.onClick,
            onMouseUp: props.onMouseUp
        }, props.ptm("panel", {
            hostName: props.hostName
        }));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, props.ptm("transition", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $ea238209e381f15e$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", $ea238209e381f15e$var$_extends({
            ref: ref
        }, panelProps), props.children));
    };
    var element = createElement();
    return props.inline ? element : /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    });
});
$ea238209e381f15e$var$CalendarPanel.displayName = "CalendarPanel";
function $ea238209e381f15e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea238209e381f15e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea238209e381f15e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea238209e381f15e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea238209e381f15e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea238209e381f15e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ea238209e381f15e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ea238209e381f15e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ea238209e381f15e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ea238209e381f15e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ea238209e381f15e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $ea238209e381f15e$export$e1aef45b828286de = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $ea238209e381f15e$var$CalendarBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $ea238209e381f15e$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(false), _React$useState4 = $ea238209e381f15e$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(null), _React$useState6 = $ea238209e381f15e$var$_slicedToArray(_React$useState5, 2), viewDateState = _React$useState6[0], setViewDateState = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(props.id), _React$useState8 = $ea238209e381f15e$var$_slicedToArray(_React$useState7, 2), idState = _React$useState8[0], setIdState = _React$useState8[1];
    var isCloseOnEscape = overlayVisibleState && props.closeOnEscape;
    var overlayDisplayOrder = (0, $jr5t3.useDisplayOrder)("overlay-panel", isCloseOnEscape);
    var metaData = {
        props: props,
        state: {
            focused: focusedState,
            overlayVisible: overlayVisibleState,
            viewDate: viewDateState
        }
    };
    var _CalendarBase$setMeta = $ea238209e381f15e$var$CalendarBase.setMetaData(metaData), ptm = _CalendarBase$setMeta.ptm, cx = _CalendarBase$setMeta.cx, isUnstyled = _CalendarBase$setMeta.isUnstyled;
    (0, $jr5t3.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide(null, reFocusInputField);
        },
        when: overlayVisibleState && overlayDisplayOrder,
        priority: [
            (0, $jr5t3.ESC_KEY_HANDLING_PRIORITIES).OVERLAY_PANEL,
            overlayDisplayOrder
        ]
    });
    (0, $kHEnT.useHandleStyle)($ea238209e381f15e$var$CalendarBase.css.styles, isUnstyled, {
        name: "calendar"
    });
    var elementRef = $7E7Dk.useRef(null);
    var overlayRef = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var navigation = $7E7Dk.useRef(null);
    var ignoreFocusFunctionality = $7E7Dk.useRef(false);
    var timePickerTimer = $7E7Dk.useRef(null);
    var viewStateChanged = $7E7Dk.useRef(false);
    var touchUIMask = $7E7Dk.useRef(null);
    var overlayEventListener = $7E7Dk.useRef(null);
    var touchUIMaskClickListener = $7E7Dk.useRef(null);
    var isOverlayClicked = $7E7Dk.useRef(false);
    var previousButton = $7E7Dk.useRef(false);
    var nextButton = $7E7Dk.useRef(false);
    var viewChangedWithKeyDown = $7E7Dk.useRef(false);
    var onChangeRef = $7E7Dk.useRef(null);
    var isClearClicked = $7E7Dk.useRef(false);
    var _React$useState9 = $7E7Dk.useState("date"), _React$useState10 = $ea238209e381f15e$var$_slicedToArray(_React$useState9, 2), currentView = _React$useState10[0], setCurrentView = _React$useState10[1];
    var _React$useState11 = $7E7Dk.useState(null), _React$useState12 = $ea238209e381f15e$var$_slicedToArray(_React$useState11, 2), currentMonth = _React$useState12[0], setCurrentMonth = _React$useState12[1];
    var _React$useState13 = $7E7Dk.useState(null), _React$useState14 = $ea238209e381f15e$var$_slicedToArray(_React$useState13, 2), currentYear = _React$useState14[0], setCurrentYear = _React$useState14[1];
    var _React$useState15 = $7E7Dk.useState([]), _React$useState16 = $ea238209e381f15e$var$_slicedToArray(_React$useState15, 2), yearOptions = _React$useState16[0], setYearOptions = _React$useState16[1];
    var previousValue = (0, $jr5t3.usePrevious)(props.value);
    var visible = props.inline || (props.onVisibleChange ? props.visible : overlayVisibleState);
    var attributeSelector = (0, $7nrKB.UniqueComponentId)();
    var panelId = idState + "_panel";
    var _useOverlayListener = (0, $jr5t3.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) {
                if (type === "outside") {
                    if (!isOverlayClicked.current && !isNavIconClicked(event.target)) hide("outside");
                } else if (context.hideOverlaysOnDocumentScrolling) hide();
                else if (!(0, $7nrKB.DomHandler).isDocument(event.target)) alignOverlay();
            }
            isOverlayClicked.current = false;
        },
        when: !(props.touchUI || props.inline) && visible,
        type: "mousedown"
    }), _useOverlayListener2 = $ea238209e381f15e$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var getDateFormat = function getDateFormat() {
        return props.dateFormat || (0, $eHYdO.localeOption)("dateFormat", props.locale);
    };
    var onInputFocus = function onInputFocus(event) {
        if (ignoreFocusFunctionality.current) {
            setFocusedState(true);
            ignoreFocusFunctionality.current = false;
        } else {
            if (props.showOnFocus && !visible) show();
            setFocusedState(true);
            props.onFocus && props.onFocus(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        updateInputfield(props.value);
        props.onBlur && props.onBlur(event);
        setFocusedState(false);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                if (!overlayVisibleState) show();
                else {
                    focusToFirstCell();
                    event.preventDefault();
                }
                break;
            case "Escape":
                hide();
                props.touchUI && disableModality();
                break;
            case "Tab":
                if (overlayRef && overlayRef.current) {
                    (0, $7nrKB.DomHandler).getFocusableElements(overlayRef.current).forEach(function(el) {
                        return el.tabIndex = "-1";
                    });
                    hide();
                    props.touchUI && disableModality();
                }
                break;
        }
    };
    var onUserInput = function onUserInput(event) {
        updateValueOnInput(event, event.target.value);
        props.onInput && props.onInput(event);
    };
    var updateValueOnInput = function updateValueOnInput(event, rawValue, invalidCallback) {
        try {
            var value = parseValueFromString(props.timeOnly ? rawValue.replace("_", "") : rawValue);
            if (isValidSelection(value)) {
                validateDate(value);
                updateModel(event, value);
                var date = value.length ? value[0] : value;
                updateViewDate(event, date);
            }
        } catch (err) {
            //invalid date
            if (invalidCallback) invalidCallback();
            else {
                var _value = props.keepInvalid ? rawValue : null;
                updateModel(event, _value);
            }
        }
    };
    var onViewDateSelect = function onViewDateSelect(_ref2) {
        var event = _ref2.event, date = _ref2.date;
        if (date && props.onSelect) {
            var day = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();
            onDateSelect(event, {
                day: day,
                month: month,
                year: year,
                selectable: isSelectable(day, month, year)
            }, null, true);
        }
    };
    var reFocusInputField = function reFocusInputField() {
        if (!props.inline && inputRef.current) {
            ignoreFocusFunctionality.current = true;
            (0, $7nrKB.DomHandler).focus(inputRef.current);
        }
    };
    var isValidSelection = function isValidSelection(value) {
        var isValid = true;
        if (isSingleSelection()) {
            if (!(isSelectable(value.getDate(), value.getMonth(), value.getFullYear(), false) && isSelectableTime(value))) isValid = false;
        } else if (value.every(function(v) {
            return isSelectable(v.getDate(), v.getMonth(), v.getFullYear(), false) && isSelectableTime(v);
        })) {
            if (isRangeSelection()) isValid = value.length > 1 && value[1] >= value[0];
        }
        return isValid;
    };
    var onButtonClick = function onButtonClick() {
        visible ? hide() : show();
    };
    var onPrevButtonClick = function onPrevButtonClick(event) {
        navigation.current = {
            backward: true,
            button: true
        };
        navBackward(event);
    };
    var onNextButtonClick = function onNextButtonClick(event) {
        navigation.current = {
            backward: false,
            button: true
        };
        navForward(event);
    };
    var onContainerButtonKeydown = function onContainerButtonKeydown(event) {
        switch(event.code){
            case "Tab":
                !props.inline && trapFocus(event);
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
        }
    };
    var onPickerKeyDown = function onPickerKeyDown(event, type, direction) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseDown(event, type, direction);
            event.preventDefault();
            return;
        }
        onContainerButtonKeydown(event);
    };
    var onPickerKeyUp = function onPickerKeyUp(event) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseUp();
            event.preventDefault();
            return;
        }
    };
    var trapFocus = function trapFocus(event) {
        event === null || event === void 0 || event.preventDefault();
        var focusableElements = (0, $7nrKB.DomHandler).getFocusableElements(overlayRef.current);
        if (focusableElements && focusableElements.length > 0) {
            if (!document.activeElement) focusableElements[0].focus();
            else {
                var focusedIndex = focusableElements.indexOf(document.activeElement);
                if (event !== null && event !== void 0 && event.shiftKey) {
                    if (focusedIndex === -1 || focusedIndex === 0) focusableElements[focusableElements.length - 1].focus();
                    else focusableElements[focusedIndex - 1].focus();
                } else if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) focusableElements[0].focus();
                else focusableElements[focusedIndex + 1].focus();
            }
        }
    };
    var updateFocus = function updateFocus() {
        if (navigation.current) {
            if (navigation.current.button) {
                initFocusableCell();
                if (navigation.current.backward) previousButton.current.focus();
                else nextButton.current.focus();
            } else {
                var cell;
                if (navigation.current.backward) {
                    var cells = (0, $7nrKB.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                    cell = cells[cells.length - 1];
                } else cell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                if (cell) {
                    cell.tabIndex = "0";
                    cell.focus();
                }
            }
            navigation.current = null;
        } else initFocusableCell();
    };
    var initFocusableCell = function initFocusableCell() {
        var cell;
        if (currentView === "month") {
            var cells = (0, $7nrKB.DomHandler).find(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"]');
            var selectedCell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"][data-p-highlight="true"]');
            cells.forEach(function(cell) {
                return cell.tabIndex = -1;
            });
            cell = selectedCell || cells[0];
        } else {
            cell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
            if (!cell) {
                var todayCell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                cell = todayCell || (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
            }
        }
        if (cell) cell.tabIndex = "0";
    };
    var focusToFirstCell = function focusToFirstCell() {
        if (currentView) {
            var cell;
            if (currentView === "date") {
                cell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) {
                    var todayCell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                    cell = todayCell || (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                }
            } else if (currentView === "month" || currentView === "year") {
                cell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) cell = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, '[data-pc-section="'.concat(currentView, 'picker"] [data-pc-section="').concat(currentView, '"]:not([data-p-disabled="true"])'));
            }
            if (cell) {
                cell.tabIndex = "0";
                cell && cell.focus();
            }
        }
    };
    var navBackward = function navBackward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 0) {
                var newYear = decrementYear();
                newViewDate.setMonth(11);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 11,
                    year: newYear
                });
                setCurrentMonth(11);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() - 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth - 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState - 1;
                });
            }
        } else if (currentView === "month") {
            var _newYear = newViewDate.getFullYear() - 1;
            if (props.yearNavigator) {
                var minYear = parseInt(props.yearRange.split(":")[0], 10);
                if (_newYear < minYear) _newYear = minYear;
            }
            newViewDate.setFullYear(_newYear);
        }
        if (currentView === "month") newViewDate.setFullYear(decrementYear());
        else if (currentView === "year") newViewDate.setFullYear(decrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var navForward = function navForward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 11) {
                var newYear = incrementYear();
                newViewDate.setMonth(0);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 0,
                    year: newYear
                });
                setCurrentMonth(0);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() + 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth + 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState + 1;
                });
            }
        } else if (currentView === "month") {
            var _newYear2 = newViewDate.getFullYear() + 1;
            if (props.yearNavigator) {
                var maxYear = parseInt(props.yearRange.split(":")[1], 10);
                if (_newYear2 > maxYear) _newYear2 = maxYear;
            }
            newViewDate.setFullYear(_newYear2);
        }
        if (currentView === "month") newViewDate.setFullYear(incrementYear());
        else if (currentView === "year") newViewDate.setFullYear(incrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var populateYearOptions = function populateYearOptions(start, end) {
        var _yearOptions = [];
        for(var i = start; i <= end; i++)yearOptions.push(i);
        setYearOptions(_yearOptions);
    };
    var decrementYear = function decrementYear() {
        var year = getViewYear();
        var _currentYear = year - 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear < yearOptions[0]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] - difference, yearOptions[yearOptions.length - 1] - difference);
        }
        return _currentYear;
    };
    var incrementYear = function incrementYear() {
        var year = getViewYear();
        var _currentYear = year + 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear.current > yearOptions[yearOptions.length - 1]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] + difference, yearOptions[yearOptions.length - 1] + difference);
        }
        return _currentYear;
    };
    var onMonthDropdownChange = function onMonthDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setDate(1);
        newViewDate.setMonth(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onYearDropdownChange = function onYearDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setFullYear(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onTodayButtonClick = function onTodayButtonClick(event) {
        var today = new Date();
        var dateMeta = {
            day: today.getDate(),
            month: today.getMonth(),
            year: today.getFullYear(),
            today: true,
            selectable: true
        };
        var timeMeta = {
            hours: today.getHours(),
            minutes: today.getMinutes(),
            seconds: today.getSeconds(),
            milliseconds: today.getMilliseconds()
        };
        updateViewDate(event, today);
        onDateSelect(event, dateMeta, timeMeta);
        props.onTodayButtonClick && props.onTodayButtonClick(event);
    };
    var onClearButtonClick = function onClearButtonClick(event) {
        isClearClicked.current = true;
        updateModel(event, null);
        updateInputfield(null);
        setCurrentYear(new Date().getFullYear()); // #7581
        hide();
        props.onClearButtonClick && props.onClearButtonClick(event);
    };
    var onPanelClick = function onPanelClick(event) {
        if (!props.inline) (0, $hB9Eg.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onPanelMouseUp = function onPanelMouseUp(event) {
        onPanelClick(event);
    };
    var onTimePickerElementMouseDown = function onTimePickerElementMouseDown(event, type, direction) {
        if (!props.disabled) {
            _repeat(event, null, type, direction);
            event.preventDefault();
        }
    };
    var onTimePickerElementMouseUp = function onTimePickerElementMouseUp() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var onTimePickerElementMouseLeave = function onTimePickerElementMouseLeave() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var _repeat = function repeat(event, interval, type, direction) {
        clearTimePickerTimer();
        timePickerTimer.current = setTimeout(function() {
            _repeat(event, 100, type, direction);
        }, interval || 500);
        switch(type){
            case 0:
                if (direction === 1) incrementHour(event);
                else decrementHour(event);
                break;
            case 1:
                if (direction === 1) incrementMinute(event);
                else decrementMinute(event);
                break;
            case 2:
                if (direction === 1) incrementSecond(event);
                else decrementSecond(event);
                break;
            case 3:
                if (direction === 1) incrementMilliSecond(event);
                else decrementMilliSecond(event);
                break;
        }
    };
    var clearTimePickerTimer = function clearTimePickerTimer() {
        if (timePickerTimer.current) clearTimeout(timePickerTimer.current);
    };
    var roundMinutesToStep = function roundMinutesToStep(minutes) {
        if (props.stepMinute) return Math.round(minutes / props.stepMinute) * props.stepMinute;
        return minutes;
    };
    var incrementHour = function incrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour + props.stepHour;
        newHour = newHour >= 24 ? newHour - 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getHours() === newHour) {
                if (props.maxDate.getMinutes() < currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.maxDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementHour = function decrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour - props.stepHour;
        newHour = newHour < 0 ? newHour + 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getHours() === newHour) {
                if (props.minDate.getMinutes() > currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.minDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var doStepMinute = function doStepMinute(currentMinute, step) {
        if (props.stepMinute <= 1) return step ? currentMinute + step : currentMinute;
        if (!step) {
            step = props.stepMinute;
            if (currentMinute % step === 0) return currentMinute;
        }
        return Math.floor((currentMinute + step) / step) * step;
    };
    var incrementMinute = function incrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, props.stepMinute);
        newMinute = newMinute > 59 ? newMinute - 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getMinutes() === newMinute) {
                if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                    if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementMinute = function decrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, -props.stepMinute);
        newMinute = newMinute < 0 ? newMinute + 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getMinutes() === newMinute) {
                if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                    if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), props.minDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementSecond = function incrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond + props.stepSecond;
        newSecond = newSecond > 59 ? newSecond - 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getSeconds() === newSecond) {
                if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.maxDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementSecond = function decrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond - props.stepSecond;
        newSecond = newSecond < 0 ? newSecond + 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getSeconds() === newSecond) {
                if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.minDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementMilliSecond = function incrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond + props.stepMillisec;
        newMillisecond = newMillisecond > 999 ? newMillisecond - 1000 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var decrementMilliSecond = function decrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond - props.stepMillisec;
        newMillisecond = newMillisecond < 0 ? newMillisecond + 999 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var toggleAmPm = function toggleAmPm(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour >= 12 ? currentHour - 12 : currentHour + 12;
        if (validateHour(convertTo24Hour(newHour, currentHour > 11), currentTime)) updateTime(event, newHour, currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
        event.preventDefault();
    };
    var getViewDate = function getViewDate(date) {
        var propValue = props.value;
        var viewDate = date || (props.onViewDateChange ? props.viewDate : viewDateState);
        if (Array.isArray(propValue)) propValue = propValue[0];
        return viewDate && isValidDate(viewDate) ? viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
    };
    var getCurrentDateTime = function getCurrentDateTime() {
        if (isSingleSelection()) return props.value && props.value instanceof Date ? cloneDate(props.value) : getViewDate();
        else if (isMultipleSelection()) {
            if (props.value && props.value.length) return cloneDate(props.value[props.value.length - 1]);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = cloneDate(props.value[0]);
                var endDate = cloneDate(props.value[1]);
                return endDate || startDate;
            }
        }
        return new Date();
    };
    var cloneDate = function cloneDate(date) {
        return isValidDate(date) ? new Date(date.valueOf()) : date;
    };
    var isValidDate = function isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    };
    var convertTo24Hour = function convertTo24Hour(hour, pm) {
        if (props.hourFormat === "12") return hour === 12 ? pm ? 12 : 0 : pm ? hour + 12 : hour;
        return hour;
    };
    var validateHour = function validateHour(hour, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (props.minDate.getHours() > hour) valid = false;
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (props.maxDate.getHours() < hour) valid = false;
        }
        return valid;
    };
    var validateMinute = function validateMinute(minute, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours()) {
                if (props.minDate.getMinutes() > minute) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours()) {
                if (props.maxDate.getMinutes() < minute) valid = false;
            }
        }
        return valid;
    };
    var validateSecond = function validateSecond(second, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getSeconds() > second) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getSeconds() < second) valid = false;
            }
        }
        return valid;
    };
    var validateMillisecond = function validateMillisecond(millisecond, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getSeconds() === props.minDate.getSeconds() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getMilliseconds() > millisecond) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getSeconds() === props.maxDate.getSeconds() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getMilliseconds() < millisecond) valid = false;
            }
        }
        return valid;
    };
    var validateDate = function validateDate(value) {
        if (props.yearNavigator) {
            var _ref3 = props.yearRange ? props.yearRange.split(":").map(function(year) {
                return parseInt(year, 10);
            }) : [
                null,
                null
            ], _ref4 = $ea238209e381f15e$var$_slicedToArray(_ref3, 2), minRangeYear = _ref4[0], maxRangeYear = _ref4[1];
            var viewYear = value.getFullYear();
            var minYear = null;
            var maxYear = null;
            if (minRangeYear !== null) minYear = props.minDate ? Math.max(props.minDate.getFullYear(), minRangeYear) : minRangeYear;
            else {
                var _props$minDate;
                minYear = ((_props$minDate = props.minDate) === null || _props$minDate === void 0 ? void 0 : _props$minDate.getFullYear()) || minRangeYear;
            }
            if (maxRangeYear !== null) maxYear = props.maxDate ? Math.min(props.maxDate.getFullYear(), maxRangeYear) : maxRangeYear;
            else {
                var _props$maxDate;
                maxYear = ((_props$maxDate = props.maxDate) === null || _props$maxDate === void 0 ? void 0 : _props$maxDate.getFullYear()) || maxRangeYear;
            }
            if (minYear && minYear > viewYear) viewYear = minYear;
            if (maxYear && maxYear < viewYear) viewYear = maxYear;
            value.setFullYear(viewYear);
        }
        if (renderMonthsNavigator(0)) {
            var viewMonth = value.getMonth();
            var viewMonthWithMinMax = parseInt(isInMinYear(value) && Math.max(props.minDate.getMonth(), viewMonth).toString() || isInMaxYear(value) && Math.min(props.maxDate.getMonth(), viewMonth).toString() || viewMonth);
            value.setMonth(viewMonthWithMinMax);
        }
    };
    var updateTime = function updateTime(event, hour, minute, second, millisecond) {
        var newDateTime = getCurrentDateTime();
        newDateTime.setHours(hour);
        newDateTime.setMinutes(minute);
        newDateTime.setSeconds(second);
        newDateTime.setMilliseconds(millisecond);
        if (isMultipleSelection()) {
            if (props.value && props.value.length) {
                var value = $ea238209e381f15e$var$_toConsumableArray(props.value);
                value[value.length - 1] = newDateTime;
                newDateTime = value;
            } else newDateTime = [
                newDateTime
            ];
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                newDateTime = endDate ? [
                    startDate,
                    newDateTime
                ] : [
                    newDateTime,
                    null
                ];
            } else newDateTime = [
                newDateTime,
                null
            ];
        }
        updateModel(event, newDateTime);
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: newDateTime
        });
        updateInputfield(newDateTime);
    };
    var updateViewDate = function updateViewDate(event, value) {
        validateDate(value);
        if (props.onViewDateChange && event) props.onViewDateChange({
            originalEvent: event,
            value: value
        });
        else {
            viewStateChanged.current = true;
            setViewDateState(value);
        }
        if (!value) onClearButtonClick(event);
    };
    var setNavigationState = function setNavigationState(newViewDate) {
        if (!newViewDate || !props.showMinMaxRange || props.view !== "date" || !overlayRef.current) return;
        var navPrev = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, '[data-pc-section="previousbutton"]');
        var navNext = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, '[data-pc-section="nextbutton"]');
        if (props.disabled) {
            !isUnstyled() && (0, $7nrKB.DomHandler).addClass(navPrev, "p-disabled");
            navPrev.setAttribute("data-p-disabled", true);
            !isUnstyled() && (0, $7nrKB.DomHandler).addClass(navNext, "p-disabled");
            navNext.setAttribute("data-p-disabled", true);
            return;
        }
        // previous (check first day of month at 00:00:00)
        if (props.minDate) {
            var firstDayOfMonth = cloneDate(newViewDate);
            if (firstDayOfMonth.getMonth() === 0) {
                firstDayOfMonth.setMonth(11, 1);
                firstDayOfMonth.setFullYear(firstDayOfMonth.getFullYear() - 1);
            } else firstDayOfMonth.setMonth(firstDayOfMonth.getMonth(), 1);
            firstDayOfMonth.setHours(0);
            firstDayOfMonth.setMinutes(0);
            firstDayOfMonth.setSeconds(0);
            if (props.minDate > firstDayOfMonth) (0, $7nrKB.DomHandler).addClass(navPrev, "p-disabled");
            else (0, $7nrKB.DomHandler).removeClass(navPrev, "p-disabled");
        }
        // next (check last day of month at 11:59:59)
        if (props.maxDate) {
            var lastDayOfMonth = cloneDate(newViewDate);
            if (lastDayOfMonth.getMonth() === 11) {
                lastDayOfMonth.setMonth(0, 1);
                lastDayOfMonth.setFullYear(lastDayOfMonth.getFullYear() + 1);
            } else lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1, 1);
            lastDayOfMonth.setHours(0);
            lastDayOfMonth.setMinutes(0);
            lastDayOfMonth.setSeconds(0);
            lastDayOfMonth.setSeconds(-1);
            if (props.maxDate < lastDayOfMonth) (0, $7nrKB.DomHandler).addClass(navNext, "p-disabled");
            else (0, $7nrKB.DomHandler).removeClass(navNext, "p-disabled");
        }
    };
    var onDateCellKeydown = function onDateCellKeydown(event, date, groupIndex) {
        var cellContent = event.currentTarget;
        var cell = cellContent.parentElement;
        var cellIndex = (0, $7nrKB.DomHandler).index(cell);
        switch(event.code){
            case "ArrowDown":
                cellContent.tabIndex = "-1";
                var nextRow = cell.parentElement.nextElementSibling;
                if (nextRow) {
                    var tableRowIndex = (0, $7nrKB.DomHandler).index(cell.parentElement);
                    var tableRows = Array.from(cell.parentElement.parentElement.children);
                    var nextTableRows = tableRows.slice(tableRowIndex + 1);
                    var hasNextFocusableDate = nextTableRows.find(function(el) {
                        var focusCell = el.children[cellIndex].children[0];
                        return !(0, $7nrKB.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (hasNextFocusableDate) {
                        var focusCell = hasNextFocusableDate.children[cellIndex].children[0];
                        focusCell.tabIndex = "0";
                        focusCell.focus();
                    } else {
                        navigation.current = {
                            backward: false
                        };
                        navForward(event);
                    }
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "ArrowUp":
                cellContent.tabIndex = "-1";
                if (event.altKey) hide(null, reFocusInputField);
                else {
                    var prevRow = cell.parentElement.previousElementSibling;
                    if (prevRow) {
                        var _tableRowIndex = (0, $7nrKB.DomHandler).index(cell.parentElement);
                        var _tableRows = Array.from(cell.parentElement.parentElement.children);
                        var prevTableRows = _tableRows.slice(0, _tableRowIndex).reverse();
                        var _hasNextFocusableDate = prevTableRows.find(function(el) {
                            var focusCell = el.children[cellIndex].children[0];
                            return !(0, $7nrKB.DomHandler).getAttribute(focusCell, "data-p-disabled");
                        });
                        if (_hasNextFocusableDate) {
                            var _focusCell = _hasNextFocusableDate.children[cellIndex].children[0];
                            _focusCell.tabIndex = "0";
                            _focusCell.focus();
                        } else {
                            navigation.current = {
                                backward: true
                            };
                            navBackward(event);
                        }
                    } else {
                        navigation.current = {
                            backward: true
                        };
                        navBackward(event);
                    }
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cellContent.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    var cells = Array.from(cell.parentElement.children);
                    var prevCells = cells.slice(0, cellIndex).reverse();
                    var _hasNextFocusableDate2 = prevCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $7nrKB.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate2) {
                        var _focusCell2 = _hasNextFocusableDate2.children[0];
                        _focusCell2.tabIndex = "0";
                        _focusCell2.focus();
                    } else navigateToMonth(true, groupIndex, event);
                } else navigateToMonth(true, groupIndex, event);
                event.preventDefault();
                break;
            case "ArrowRight":
                cellContent.tabIndex = "-1";
                var nextCell = cell.nextElementSibling;
                if (nextCell) {
                    var _cells = Array.from(cell.parentElement.children);
                    var nextCells = _cells.slice(cellIndex + 1);
                    var _hasNextFocusableDate3 = nextCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $7nrKB.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate3) {
                        var _focusCell3 = _hasNextFocusableDate3.children[0];
                        _focusCell3.tabIndex = "0";
                        _focusCell3.focus();
                    } else navigateToMonth(false, groupIndex, event);
                } else navigateToMonth(false, groupIndex, event);
                event.preventDefault();
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                onDateSelect(event, date);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                if (!props.inline) trapFocus(event);
                break;
            case "Home":
                cellContent.tabIndex = "-1";
                var currentRow = cell.parentElement;
                var _focusCell4 = currentRow.children[0].children[0];
                if ((0, $7nrKB.DomHandler).getAttribute(_focusCell4, "data-p-disabled")) navigateToMonth(groupIndex, true, event);
                else {
                    _focusCell4.tabIndex = "0";
                    _focusCell4.focus();
                }
                event.preventDefault();
                break;
            case "End":
                cellContent.tabIndex = "-1";
                var _currentRow = cell.parentElement;
                var _focusCell5 = _currentRow.children[_currentRow.children.length - 1].children[0];
                if ((0, $7nrKB.DomHandler).getAttribute(_focusCell5, "data-p-disabled")) navigateToMonth(groupIndex, false, event);
                else {
                    _focusCell5.tabIndex = "0";
                    _focusCell5.focus();
                }
                event.preventDefault();
                break;
            case "PageUp":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                } else navigateToMonth(groupIndex, true, event);
                event.preventDefault();
                break;
            case "PageDown":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                } else navigateToMonth(groupIndex, false, event);
                event.preventDefault();
                break;
        }
    };
    var navigateToMonth = function navigateToMonth(prev, groupIndex, event) {
        if (prev) {
            if (props.numberOfMonths === 1 || groupIndex === 0) {
                navigation.current = {
                    backward: true
                };
                navBackward(event);
            } else {
                var prevMonthContainer = overlayRef.current.children[0].children[groupIndex - 1];
                var cells = (0, $7nrKB.DomHandler).find(prevMonthContainer, 'table td span:not([data-p-disabled="true"])');
                var focusCell = cells[cells.length - 1];
                focusCell.tabIndex = "0";
                focusCell.focus();
            }
        } else if (props.numberOfMonths === 1 || groupIndex === props.numberOfMonths - 1) {
            navigation.current = {
                backward: false
            };
            navForward(event);
        } else {
            var nextMonthContainer = overlayRef.current.children[0].children[groupIndex + 1];
            var _focusCell6 = (0, $7nrKB.DomHandler).findSingle(nextMonthContainer, 'table td span:not([data-p-disabled="true"])');
            _focusCell6.tabIndex = "0";
            _focusCell6.focus();
        }
    };
    var onMonthCellKeydown = function onMonthCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $7nrKB.DomHandler).index(cell);
                var nextCell = cells[event.which === 40 ? cellIndex + 3 : cellIndex - 3];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell = cell.nextElementSibling;
                if (_nextCell) {
                    _nextCell.tabIndex = "0";
                    _nextCell.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "month") viewChangedWithKeyDown.current = true;
                onMonthSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onYearCellKeydown = function onYearCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $7nrKB.DomHandler).index(cell);
                var nextCell = cells[event.code === "ArrowDown" ? cellIndex + 2 : cellIndex - 2];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell2 = cell.nextElementSibling;
                if (_nextCell2) {
                    _nextCell2.tabIndex = "0";
                    _nextCell2.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "year") viewChangedWithKeyDown.current = true;
                onYearSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onDateSelect = function onDateSelect(event, dateMeta, timeMeta, isUpdateViewDate) {
        if (!event) return;
        if (props.disabled || !dateMeta.selectable) {
            event.preventDefault();
            return;
        }
        (0, $7nrKB.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])').forEach(function(cell) {
            return cell.tabIndex = -1;
        });
        event.currentTarget.focus();
        if (isMultipleSelection()) {
            if (isSelected(dateMeta)) {
                var value = props.value.filter(function(date) {
                    return !isDateEquals(date, dateMeta);
                });
                updateModel(event, value);
                updateInputfield(value);
            } else if (!props.maxDateCount || !props.value || props.maxDateCount > props.value.length) selectDate(event, dateMeta, timeMeta);
        } else selectDate(event, dateMeta, timeMeta);
        if (!props.inline && isSingleSelection() && (!props.showTime || props.hideOnDateTimeSelect) && !isUpdateViewDate) {
            setTimeout(function() {
                hide("dateselect");
                reFocusInputField();
            }, 100);
            if (touchUIMask.current) disableModality();
        }
        event.preventDefault();
    };
    var selectTime = function selectTime(date, timeMeta) {
        if (props.showTime) {
            var hours;
            var minutes;
            var seconds;
            var milliseconds;
            if (timeMeta) {
                hours = timeMeta.hours;
                minutes = timeMeta.minutes;
                seconds = timeMeta.seconds;
                milliseconds = timeMeta.milliseconds;
            } else {
                var time = getCurrentDateTime();
                var _ref5 = [
                    time.getHours(),
                    time.getMinutes(),
                    time.getSeconds(),
                    time.getMilliseconds()
                ];
                hours = _ref5[0];
                minutes = _ref5[1];
                seconds = _ref5[2];
                milliseconds = _ref5[3];
            }
            date.setHours(hours);
            date.setMinutes(doStepMinute(minutes));
            date.setSeconds(seconds);
            date.setMilliseconds(milliseconds);
        }
    };
    var selectDate = function selectDate(event, dateMeta, timeMeta) {
        var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
        selectTime(date, timeMeta);
        if (props.minDate && props.minDate > date) date = props.minDate;
        if (props.maxDate && props.maxDate < date) date = props.maxDate;
        var selectedValues = date;
        if (isSingleSelection()) updateModel(event, date);
        else if (isMultipleSelection()) {
            selectedValues = props.value ? [].concat($ea238209e381f15e$var$_toConsumableArray(props.value), [
                date
            ]) : [
                date
            ];
            updateModel(event, selectedValues);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                if (!endDate) {
                    if (date.getTime() >= startDate.getTime()) endDate = date;
                    else {
                        endDate = startDate;
                        startDate = date;
                    }
                } else {
                    startDate = date;
                    endDate = null;
                }
                selectedValues = [
                    startDate,
                    endDate
                ];
                updateModel(event, selectedValues);
                if (props.hideOnRangeSelection && endDate !== null) setTimeout(function() {
                    setOverlayVisibleState(false);
                }, 150);
            } else {
                selectedValues = [
                    date,
                    null
                ];
                updateModel(event, selectedValues);
            }
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: date
        });
        updateInputfield(selectedValues);
    };
    var decrementDecade = function decrementDecade() {
        var _currentYear = currentYear - 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var incrementDecade = function incrementDecade() {
        var _currentYear = currentYear + 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var switchToMonthView = function switchToMonthView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("month");
        event.preventDefault();
    };
    var switchToYearView = function switchToYearView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("year");
        event.preventDefault();
    };
    var onMonthSelect = function onMonthSelect(event, month) {
        if (props.view === "month") {
            var year = getViewYear();
            onDateSelect(event, {
                year: year,
                month: month,
                day: 1,
                selectable: true
            });
            event.preventDefault();
        } else {
            setCurrentMonth(month);
            createMonthsMeta(month, currentYear);
            var currentDate = cloneDate(getCurrentDateTime());
            currentDate.setDate(1); // #2948 always set to 1st of month
            currentDate.setMonth(month);
            currentDate.setYear(currentYear);
            setViewDateState(currentDate);
            setCurrentView("date");
            props.onMonthChange && props.onMonthChange({
                month: month + 1,
                year: currentYear
            });
            updateViewDate(event, currentDate);
            onViewDateSelect({
                event: event,
                date: currentDate
            });
        }
    };
    var getViewYear = function getViewYear() {
        return props.yearNavigator ? getViewDate().getFullYear() : currentYear;
    };
    var onYearSelect = function onYearSelect(event, year) {
        if (props.view === "year") onDateSelect(event, {
            year: year,
            month: 0,
            day: 1,
            selectable: true
        });
        else {
            setCurrentYear(year);
            setCurrentView("month");
            props.onMonthChange && props.onMonthChange({
                month: currentMonth + 1,
                year: year
            });
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) {
            var newValue = cloneDate(value);
            viewStateChanged.current = true;
            onChangeRef.current({
                originalEvent: event,
                value: newValue,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: newValue
                }
            });
        }
    };
    var show = function show(type) {
        if (props.onVisibleChange) props.onVisibleChange({
            visible: true,
            type: type
        });
        else {
            setOverlayVisibleState(true);
            overlayEventListener.current = function(e) {
                if (!isOutsideClicked(e) && visible) isOverlayClicked.current = true;
            };
            (0, $hB9Eg.OverlayService).on("overlay-click", overlayEventListener.current);
        }
    };
    var hide = function hide(type, callback) {
        var _hideCallback = function _hideCallback() {
            viewStateChanged.current = false;
            ignoreFocusFunctionality.current = false;
            isOverlayClicked.current = false;
            callback && callback();
            (0, $hB9Eg.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        };
        props.touchUI && disableModality();
        if (props.onVisibleChange) props.onVisibleChange({
            visible: type !== "dateselect",
            // false only if selecting a value to close panel
            type: type,
            callback: _hideCallback
        });
        else {
            setOverlayVisibleState(false);
            _hideCallback();
        }
    };
    var onOverlayEnter = function onOverlayEnter() {
        var styles = props.touchUI ? {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        } : !props.inline ? {
            position: "absolute",
            top: "0",
            left: "0"
        } : undefined;
        (0, $7nrKB.DomHandler).addStyles(overlayRef.current, styles);
        if (props.autoZIndex) {
            var key = props.touchUI ? "modal" : "overlay";
            (0, $7nrKB.ZIndexUtils).set(key, overlayRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, props.baseZIndex || context && context.zIndex[key] || (0, $eHYdO.default).zIndex[key]);
        }
        if (!props.touchUI && overlayRef && overlayRef.current && inputRef && inputRef.current && !appendDisabled()) {
            var inputWidth = (0, $7nrKB.DomHandler).getOuterWidth(inputRef.current);
            // #5435 must have reasonable width if input is too small
            if (inputWidth < 220) inputWidth = 220;
            if (props.view === "date") overlayRef.current.style.width = (0, $7nrKB.DomHandler).getOuterWidth(overlayRef.current) + "px";
            else overlayRef.current.style.width = inputWidth + "px";
            // #5830 Tailwind does not need a min width it breaks the styling
            if (!isUnstyled()) overlayRef.current.style.minWidth = inputWidth + "px";
        }
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
        setFocusedState(false);
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var appendDisabled = function appendDisabled() {
        var appendTo = props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo;
        return appendTo === "self" || props.inline;
    };
    var alignOverlay = function alignOverlay() {
        if (props.touchUI) enableModality();
        else if (overlayRef && overlayRef.current && inputRef && inputRef.current) {
            (0, $7nrKB.DomHandler).alignOverlay(overlayRef.current, inputRef.current, props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo);
            if (appendDisabled()) (0, $7nrKB.DomHandler).relativePosition(overlayRef.current, inputRef.current);
            else (0, $7nrKB.DomHandler).absolutePosition(overlayRef.current, inputRef.current);
        }
        // #6093 Forcibly remove minWidth when in unstyled mode
        if (isUnstyled()) overlayRef.current.style.minWidth = "";
    };
    var enableModality = function enableModality() {
        if (!touchUIMask.current) {
            touchUIMask.current = document.createElement("div");
            touchUIMask.current.style.zIndex = String((0, $7nrKB.ZIndexUtils).get(overlayRef.current) - 1);
            !isUnstyled() && (0, $7nrKB.DomHandler).addMultipleClasses(touchUIMask.current, "p-component-overlay p-datepicker-mask p-datepicker-mask-scrollblocker p-component-overlay-enter");
            touchUIMaskClickListener.current = function() {
                disableModality();
                hide();
            };
            touchUIMask.current.addEventListener("click", touchUIMaskClickListener.current);
            document.body.appendChild(touchUIMask.current);
            (0, $7nrKB.DomHandler).blockBodyScroll();
        }
    };
    var disableModality = function disableModality() {
        if (touchUIMask.current) {
            if (isUnstyled) destroyMask();
            else {
                !isUnstyled() && (0, $7nrKB.DomHandler).addClass(touchUIMask.current, "p-component-overlay-leave");
                if ((0, $7nrKB.DomHandler).hasCSSAnimation(touchUIMask.current) > 0) touchUIMask.current.addEventListener("animationend", function() {
                    destroyMask();
                });
                else destroyMask();
            }
        }
    };
    var destroyMask = function destroyMask() {
        if (touchUIMask.current) {
            touchUIMask.current.removeEventListener("click", touchUIMaskClickListener.current);
            touchUIMaskClickListener.current = null;
            document.body.removeChild(touchUIMask.current);
            touchUIMask.current = null;
        }
        var bodyChildren = document.body.children;
        var hasBlockerMasks;
        for(var i = 0; i < bodyChildren.length; i++){
            var bodyChild = bodyChildren[i];
            if ((0, $7nrKB.DomHandler).hasClass(bodyChild, "p-datepicker-mask-scrollblocker")) {
                hasBlockerMasks = true;
                break;
            }
        }
        if (!hasBlockerMasks) (0, $7nrKB.DomHandler).unblockBodyScroll();
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return elementRef.current && !(elementRef.current.isSameNode(event.target) || isNavIconClicked(event.target) || elementRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var isNavIconClicked = function isNavIconClicked(target) {
        return previousButton.current && (previousButton.current.isSameNode(target) || previousButton.current.contains(target)) || nextButton.current && (nextButton.current.isSameNode(target) || nextButton.current.contains(target));
    };
    var getFirstDayOfMonthIndex = function getFirstDayOfMonthIndex(month, year) {
        var day = new Date();
        day.setDate(1);
        day.setMonth(month);
        day.setFullYear(year);
        var dayIndex = day.getDay() + getSundayIndex();
        return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
    };
    var getDaysCountInMonth = function getDaysCountInMonth(month, year) {
        return 32 - daylightSavingAdjust(new Date(year, month, 32)).getDate();
    };
    var getDaysCountInPrevMonth = function getDaysCountInPrevMonth(month, year) {
        var prev = getPreviousMonthAndYear(month, year);
        return getDaysCountInMonth(prev.month, prev.year);
    };
    var daylightSavingAdjust = function daylightSavingAdjust(date) {
        if (!date) return null;
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    };
    var getPreviousMonthAndYear = function getPreviousMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 0) {
            m = 11;
            y = year - 1;
        } else {
            m = month - 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getNextMonthAndYear = function getNextMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 11) {
            m = 0;
            y = year + 1;
        } else {
            m = month + 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getSundayIndex = function getSundayIndex() {
        var firstDayOfWeek = (0, $eHYdO.localeOption)("firstDayOfWeek", props.locale);
        return firstDayOfWeek > 0 ? 7 - firstDayOfWeek : 0;
    };
    var createWeekDaysMeta = function createWeekDaysMeta() {
        var weekDays = [];
        var _localeOptions = (0, $eHYdO.localeOptions)(props.locale), dayIndex = _localeOptions.firstDayOfWeek, dayNamesMin = _localeOptions.dayNamesMin;
        for(var i = 0; i < 7; i++){
            weekDays.push(dayNamesMin[dayIndex]);
            dayIndex = dayIndex === 6 ? 0 : ++dayIndex;
        }
        return weekDays;
    };
    var createMonthsMeta = function createMonthsMeta(month, year) {
        var months = [];
        for(var i = 0; i < props.numberOfMonths; i++){
            var m = month + i;
            var y = year;
            if (m > 11) {
                m = m % 11 - 1;
                y = year + 1;
            }
            months.push(createMonthMeta(m, y));
        }
        return months;
    };
    var createMonthMeta = function createMonthMeta(month, year) {
        var dates = [];
        var firstDay = getFirstDayOfMonthIndex(month, year);
        var daysLength = getDaysCountInMonth(month, year);
        var prevMonthDaysLength = getDaysCountInPrevMonth(month, year);
        var dayNo = 1;
        var today = new Date();
        var weekNumbers = [];
        var monthRows = Math.ceil((daysLength + firstDay) / 7);
        for(var i = 0; i < monthRows; i++){
            var week = [];
            if (i === 0) {
                for(var j = prevMonthDaysLength - firstDay + 1; j <= prevMonthDaysLength; j++){
                    var prev = getPreviousMonthAndYear(month, year);
                    week.push({
                        day: j,
                        month: prev.month,
                        year: prev.year,
                        otherMonth: true,
                        today: isToday(today, j, prev.month, prev.year),
                        selectable: isSelectable(j, prev.month, prev.year, true)
                    });
                }
                var remainingDaysLength = 7 - week.length;
                for(var _j = 0; _j < remainingDaysLength; _j++){
                    week.push({
                        day: dayNo,
                        month: month,
                        year: year,
                        today: isToday(today, dayNo, month, year),
                        selectable: isSelectable(dayNo, month, year, false)
                    });
                    dayNo++;
                }
            } else for(var _j2 = 0; _j2 < 7; _j2++){
                if (dayNo > daysLength) {
                    var next = getNextMonthAndYear(month, year);
                    week.push({
                        day: dayNo - daysLength,
                        month: next.month,
                        year: next.year,
                        otherMonth: true,
                        today: isToday(today, dayNo - daysLength, next.month, next.year),
                        selectable: isSelectable(dayNo - daysLength, next.month, next.year, true)
                    });
                } else week.push({
                    day: dayNo,
                    month: month,
                    year: year,
                    today: isToday(today, dayNo, month, year),
                    selectable: isSelectable(dayNo, month, year, false)
                });
                dayNo++;
            }
            if (props.showWeek) weekNumbers.push(getWeekNumber(new Date(week[0].year, week[0].month, week[0].day)));
            dates.push(week);
        }
        return {
            month: month,
            year: year,
            dates: dates,
            weekNumbers: weekNumbers
        };
    };
    var getWeekNumber = function getWeekNumber(date) {
        var checkDate = cloneDate(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    var isSelectable = function isSelectable(day, month, year, otherMonth) {
        var validMin = true;
        var validMax = true;
        var validDate = true;
        var validDay = true;
        var validMonth = true;
        if (props.minDate) {
            if (props.minDate.getFullYear() > year) validMin = false;
            else if (props.minDate.getFullYear() === year) {
                if (month > -1 && props.minDate.getMonth() > month) validMin = false;
                else if (month > -1 && props.minDate.getMonth() === month) {
                    if (day > 0 && props.minDate.getDate() > day) validMin = false;
                }
            }
        }
        if (props.maxDate) {
            if (props.maxDate.getFullYear() < year) validMax = false;
            else if (props.maxDate.getFullYear() === year) {
                if (month > -1 && props.maxDate.getMonth() < month) validMax = false;
                else if (month > -1 && props.maxDate.getMonth() === month) {
                    if (day > 0 && props.maxDate.getDate() < day) validMax = false;
                }
            }
        }
        if (props.disabledDates || props.enabledDates || props.disabledDays) validDay = !isDayDisabled(day, month, year);
        if (props.selectOtherMonths === false && otherMonth) validMonth = false;
        return validMin && validMax && validDate && validDay && validMonth;
    };
    var isSelectableTime = function isSelectableTime(value) {
        var validMin = true;
        var validMax = true;
        if (props.minDate && props.minDate.toDateString() === value.toDateString()) {
            if (props.minDate.getHours() > value.getHours()) validMin = false;
            else if (props.minDate.getHours() === value.getHours()) {
                if (props.minDate.getMinutes() > value.getMinutes()) validMin = false;
                else if (props.minDate.getMinutes() === value.getMinutes()) {
                    if (props.minDate.getSeconds() > value.getSeconds()) validMin = false;
                    else if (props.minDate.getSeconds() === value.getSeconds()) {
                        if (props.minDate.getMilliseconds() > value.getMilliseconds()) validMin = false;
                    }
                }
            }
        }
        if (props.maxDate && props.maxDate.toDateString() === value.toDateString()) {
            if (props.maxDate.getHours() < value.getHours()) validMax = false;
            else if (props.maxDate.getHours() === value.getHours()) {
                if (props.maxDate.getMinutes() < value.getMinutes()) validMax = false;
                else if (props.maxDate.getMinutes() === value.getMinutes()) {
                    if (props.maxDate.getSeconds() < value.getSeconds()) validMax = false;
                    else if (props.maxDate.getSeconds() === value.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < value.getMilliseconds()) validMax = false;
                    }
                }
            }
        }
        return validMin && validMax;
    };
    var isSelected = function isSelected(dateMeta) {
        if (props.value) {
            if (isSingleSelection()) return isDateEquals(props.value, dateMeta);
            else if (isMultipleSelection()) {
                var selected = false;
                var _iterator = $ea238209e381f15e$var$_createForOfIteratorHelper(props.value), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var date = _step.value;
                        selected = isDateEquals(date, dateMeta);
                        if (selected) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return selected;
            } else if (isRangeSelection()) {
                if (props.value[1]) return isDateEquals(props.value[0], dateMeta) || isDateEquals(props.value[1], dateMeta) || isDateBetween(props.value[0], props.value[1], dateMeta);
                return isDateEquals(props.value[0], dateMeta);
            }
        } else return false;
    };
    var isComparable = function isComparable() {
        return props.value != null && typeof props.value !== "string";
    };
    var isMonthSelected = function isMonthSelected(month) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getMonth() === month && v.getFullYear() === currentYear;
        });
        else if (isRangeSelection()) {
            var _props$value = $ea238209e381f15e$var$_slicedToArray(props.value, 2), start = _props$value[0], end = _props$value[1];
            var startYear = start ? start.getFullYear() : null;
            var endYear = end ? end.getFullYear() : null;
            var startMonth = start ? start.getMonth() : null;
            var endMonth = end ? end.getMonth() : null;
            if (!end) return startYear === currentYear && startMonth === month;
            else {
                var currentDate = new Date(currentYear, month, 1);
                var startDate = new Date(startYear, startMonth, 1);
                var endDate = new Date(endYear, endMonth, 1);
                return currentDate >= startDate && currentDate <= endDate;
            }
        } else return props.value.getMonth() === month && props.value.getFullYear() === currentYear;
    };
    var isYearSelected = function isYearSelected(year) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getFullYear() === year;
        });
        else if (isRangeSelection()) {
            var start = props.value[0] ? props.value[0].getFullYear() : null;
            var end = props.value[1] ? props.value[1].getFullYear() : null;
            return start === year || end === year || start < year && end > year;
        } else return props.value.getFullYear() === year;
    };
    var switchViewButtonDisabled = function switchViewButtonDisabled() {
        return props.numberOfMonths > 1 || props.disabled;
    };
    var isDateEquals = function isDateEquals(value, dateMeta) {
        if (value && value instanceof Date) return value.getDate() === dateMeta.day && value.getMonth() === dateMeta.month && value.getFullYear() === dateMeta.year;
        return false;
    };
    var isDateBetween = function isDateBetween(start, end, dateMeta) {
        var between = false;
        if (start && end) {
            var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
            return start.getTime() <= date.getTime() && end.getTime() >= date.getTime();
        }
        return between;
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === "single";
    };
    var isRangeSelection = function isRangeSelection() {
        return props.selectionMode === "range";
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === "multiple";
    };
    var isToday = function isToday(today, day, month, year) {
        return today.getDate() === day && today.getMonth() === month && today.getFullYear() === year;
    };
    var isDayDisabled = function isDayDisabled(day, month, year) {
        var isDisabled = false;
        // first check for disabled dates
        if (props.disabledDates) {
            if (props.disabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            })) isDisabled = true;
        }
        // next if not disabled then check for disabled days
        if (!isDisabled && props.disabledDays && currentView === "date") {
            var weekday = new Date(year, month, day);
            var weekdayNumber = weekday.getDay();
            if (props.disabledDays.indexOf(weekdayNumber) !== -1) isDisabled = true;
        }
        // last check for enabled dates to force dates enabled
        if (props.enabledDates) {
            var isEnabled = props.enabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            });
            if (isEnabled) isDisabled = false;
            else if (!props.disabledDays && !props.disabledDates) // disable other dates when only enabledDates are present
            isDisabled = true;
        }
        return isDisabled;
    };
    var isMonthYearDisabled = function isMonthYearDisabled(month, year) {
        var daysCountInAllMonth = month === -1 ? new Array(12).fill(0).map(function(_, i) {
            return getDaysCountInMonth(i, year);
        }) : [
            getDaysCountInMonth(month, year)
        ];
        for(var i = 0; i < daysCountInAllMonth.length; i++){
            var monthDays = daysCountInAllMonth[i];
            var _month = month === -1 ? i : month;
            for(var day = 1; day <= monthDays; day++){
                var isDateSelectable = isSelectable(day, _month, year);
                if (isDateSelectable) return false;
            }
        }
        return true;
    };
    var updateInputfield = function updateInputfield(value) {
        if (!inputRef.current) return;
        var formattedValue = "";
        if (value) try {
            if (isSingleSelection()) formattedValue = isValidDate(value) ? formatDateTime(value) : props.keepInvalid ? value : "";
            else if (isMultipleSelection()) for(var i = 0; i < value.length; i++){
                var selectedValue = value[i];
                var dateAsString = isValidDate(selectedValue) ? formatDateTime(selectedValue) : "";
                formattedValue = formattedValue + dateAsString;
                if (i !== value.length - 1) formattedValue = formattedValue + ", ";
            }
            else if (isRangeSelection()) {
                if (value && value.length) {
                    var startDate = value[0];
                    var endDate = value[1];
                    formattedValue = isValidDate(startDate) ? formatDateTime(startDate) : "";
                    if (endDate) formattedValue = formattedValue + (isValidDate(endDate) ? " - " + formatDateTime(endDate) : "");
                }
            }
        } catch (err) {
            formattedValue = value;
        }
        inputRef.current.value = formattedValue;
    };
    var formatDateTime = function formatDateTime(date) {
        if (props.formatDateTime) return props.formatDateTime(date);
        var formattedValue = null;
        if (date) {
            if (props.timeOnly) formattedValue = formatTime(date);
            else {
                formattedValue = formatDate(date, getDateFormat());
                if (props.showTime) formattedValue = formattedValue + (" " + formatTime(date));
            }
        }
        return formattedValue;
    };
    var formatDate = function formatDate(date, format) {
        if (!date) return "";
        var iFormat;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var formatNumber = function formatNumber(match, value, len) {
            var num = "" + value;
            if (lookAhead(match)) while(num.length < len)num = "0" + num;
            return num;
        };
        var formatName = function formatName(match, value, shortNames, longNames) {
            return lookAhead(match) ? longNames[value] : shortNames[value];
        };
        var output = "";
        var literal = false;
        var _localeOptions2 = (0, $eHYdO.localeOptions)(props.locale), dayNamesShort = _localeOptions2.dayNamesShort, dayNames = _localeOptions2.dayNames, monthNamesShort = _localeOptions2.monthNamesShort, monthNames = _localeOptions2.monthNames;
        if (date) {
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else output = output + format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                    output = output + formatNumber("d", date.getDate(), 2);
                    break;
                case "D":
                    output = output + formatName("D", date.getDay(), dayNamesShort, dayNames);
                    break;
                case "o":
                    output = output + formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                    break;
                case "m":
                    output = output + formatNumber("m", date.getMonth() + 1, 2);
                    break;
                case "M":
                    output = output + formatName("M", date.getMonth(), monthNamesShort, monthNames);
                    break;
                case "y":
                    output = output + (lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100);
                    break;
                case "@":
                    output = output + date.getTime();
                    break;
                case "!":
                    output = output + (date.getTime() * 10000 + ticksTo1970);
                    break;
                case "'":
                    if (lookAhead("'")) output = output + "'";
                    else literal = true;
                    break;
                default:
                    output = output + format.charAt(iFormat);
            }
        }
        return output;
    };
    var formatTime = function formatTime(date) {
        if (!date) return "";
        var output = "";
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var milliseconds = date.getMilliseconds();
        if (props.hourFormat === "12" && hours > 11 && hours !== 12) hours = hours - 12;
        if (props.hourFormat === "12") output = output + (hours === 0 ? 12 : hours < 10 ? "0" + hours : hours);
        else output = output + (hours < 10 ? "0" + hours : hours);
        output = output + ":";
        output = output + (minutes < 10 ? "0" + minutes : minutes);
        if (props.showSeconds) {
            output = output + ":";
            output = output + (seconds < 10 ? "0" + seconds : seconds);
        }
        if (props.showMillisec) {
            output = output + ".";
            output = output + (milliseconds < 100 ? (milliseconds < 10 ? "00" : "0") + milliseconds : milliseconds);
        }
        if (props.hourFormat === "12") output = output + (date.getHours() > 11 ? " PM" : " AM");
        return output;
    };
    var parseValueFromString = function parseValueFromString(text) {
        if (!text || text.trim().length === 0) return null;
        var value;
        if (isSingleSelection()) value = parseDateTime(text);
        else if (isMultipleSelection()) {
            var tokens = text.split(",");
            value = [];
            var _iterator2 = $ea238209e381f15e$var$_createForOfIteratorHelper(tokens), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var token = _step2.value;
                    value.push(parseDateTime(token.trim()));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } else if (isRangeSelection()) {
            var _tokens = text.split(" - ");
            value = [];
            for(var i = 0; i < _tokens.length; i++)value[i] = parseDateTime(_tokens[i].trim());
        }
        return value;
    };
    var parseDateTime = function parseDateTime(text) {
        if (props.parseDateTime) return props.parseDateTime(text);
        var date;
        if (props.timeOnly) {
            date = new Date();
            var match = text.match(/(\d{1,2}:\d{2}(?::\d{2})?(?:\.\d{1,3})?)\s?(AM|PM)?/i);
            if (match) populateTime(date, match[1], match[2]);
            else return null;
        } else if (props.showTime) {
            var time12 = /(\d{1,2}:\d{2}(?::\d{2})?(?:\.\d{1,3})?)\s?(AM|PM)/i;
            var time24 = /(\d{1,2}:\d{2}(?::\d{2})?(?:\.\d{1,3})?)$/;
            var _match, datePart, timePart, ampm;
            if (props.hourFormat === "12" && (_match = text.match(time12))) {
                timePart = _match[1];
                ampm = _match[2];
                datePart = text.replace(time12, "").trim();
            } else if (props.hourFormat === "24" && (_match = text.match(time24))) {
                timePart = _match[1];
                datePart = text.replace(time24, "").trim();
            }
            if (datePart && timePart) {
                date = parseDate(datePart, getDateFormat());
                populateTime(date, timePart, ampm);
            } else date = parseDate(text, getDateFormat());
        } else date = parseDate(text, getDateFormat());
        return date;
    };
    var populateTime = function populateTime(value, timeString, ampm) {
        if (props.hourFormat === "12" && ampm !== "PM" && ampm !== "AM") throw new Error("Invalid Time");
        var time = parseTime(timeString, ampm);
        value.setHours(time.hour);
        value.setMinutes(time.minute);
        value.setSeconds(time.second);
        value.setMilliseconds(time.millisecond);
    };
    var parseTime = function parseTime(value, ampm) {
        value = props.showMillisec ? value.replace(".", ":") : value;
        var tokens = value.split(":");
        var validTokenLength = props.showSeconds ? 3 : 2;
        validTokenLength = props.showMillisec ? validTokenLength + 1 : validTokenLength;
        if (tokens.length !== validTokenLength || tokens[0].length !== 2 || tokens[1].length !== 2 || props.showSeconds && tokens[2].length !== 2 || props.showMillisec && tokens[3].length !== 3) throw new Error("Invalid time");
        var h = parseInt(tokens[0], 10);
        var m = parseInt(tokens[1], 10);
        var s = props.showSeconds ? parseInt(tokens[2], 10) : null;
        var ms = props.showMillisec ? parseInt(tokens[3], 10) : null;
        if (isNaN(h) || isNaN(m) || h > 23 || m > 59 || props.hourFormat === "12" && h > 12 || props.showSeconds && (isNaN(s) || s > 59) || props.showMillisec && (isNaN(s) || s > 1000)) throw new Error("Invalid time");
        else {
            if (props.hourFormat === "12") {
                if (h !== 12 && ampm === "PM") h = h + 12;
                if (h === 12 && ampm === "AM") h = h - 12;
            }
            return {
                hour: h,
                minute: m,
                second: s,
                millisecond: ms
            };
        }
    };
    // Ported from jquery-ui datepicker parseDate
    var parseDate = function parseDate(value, format) {
        if (format == null || value == null) throw new Error("Invalid arguments");
        value = $ea238209e381f15e$var$_typeof(value) === "object" ? value.toString() : value + "";
        if (value === "") return null;
        var iFormat;
        var dim;
        var extra;
        var iValue = 0;
        var shortYearCutoff = typeof props.shortYearCutoff !== "string" ? props.shortYearCutoff : new Date().getFullYear() % 100 + parseInt(props.shortYearCutoff, 10);
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        var date;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var getNumber = function getNumber(match) {
            var isDoubled = lookAhead(match);
            var size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2;
            var minSize = match === "y" ? size : 1;
            var digits = new RegExp("^\\d{" + minSize + "," + size + "}");
            var num = value.substring(iValue).match(digits);
            if (!num) throw new Error("Missing number at position " + iValue);
            iValue = iValue + num[0].length;
            return parseInt(num[0], 10);
        };
        var getName = function getName(match, shortNames, longNames) {
            var index = -1;
            var arr = lookAhead(match) ? longNames : shortNames;
            var names = [];
            for(var i = 0; i < arr.length; i++)names.push([
                i,
                arr[i]
            ]);
            names.sort(function(a, b) {
                return -(a[1].length - b[1].length);
            });
            for(var _i = 0; _i < names.length; _i++){
                var name = names[_i][1];
                if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                    index = names[_i][0];
                    iValue = iValue + name.length;
                    break;
                }
            }
            if (index !== -1) return index + 1;
            throw new Error("Unknown name at position " + iValue);
        };
        var checkLiteral = function checkLiteral() {
            if (value.charAt(iValue) !== format.charAt(iFormat)) throw new Error("Unexpected literal at position " + iValue);
            iValue++;
        };
        if (props.view === "month") day = 1;
        if (props.view === "year") {
            day = 1;
            month = 1;
        }
        var _localeOptions3 = (0, $eHYdO.localeOptions)(props.locale), dayNamesShort = _localeOptions3.dayNamesShort, dayNames = _localeOptions3.dayNames, monthNamesShort = _localeOptions3.monthNamesShort, monthNames = _localeOptions3.monthNames;
        for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
            if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
            else checkLiteral();
        } else switch(format.charAt(iFormat)){
            case "d":
                day = getNumber("d");
                break;
            case "D":
                getName("D", dayNamesShort, dayNames);
                break;
            case "o":
                doy = getNumber("o");
                break;
            case "m":
                month = getNumber("m");
                break;
            case "M":
                month = getName("M", monthNamesShort, monthNames);
                break;
            case "y":
                year = getNumber("y");
                break;
            case "@":
                date = new Date(getNumber("@"));
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "!":
                date = new Date((getNumber("!") - ticksTo1970) / 10000);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "'":
                if (lookAhead("'")) checkLiteral();
                else literal = true;
                break;
            default:
                checkLiteral();
        }
        if (iValue < value.length) {
            extra = value.substr(iValue);
            if (!/^\s+/.test(extra)) throw new Error("Extra/unparsed characters found in date: " + extra);
        }
        if (year === -1) year = new Date().getFullYear();
        else if (year < 100) year = year + (new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100));
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                dim = getDaysCountInMonth(year, month - 1);
                if (day <= dim) break;
                month++;
                day = day - dim;
            }while (true);
        }
        date = daylightSavingAdjust(new Date(year, month - 1, day));
        if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw new Error("Invalid date"); // E.g. 31/02/00
        return date;
    };
    var isInMinYear = function isInMinYear(viewDate) {
        return props.minDate && props.minDate.getFullYear() === viewDate.getFullYear();
    };
    var isInMaxYear = function isInMaxYear(viewDate) {
        return props.maxDate && props.maxDate.getFullYear() === viewDate.getFullYear();
    };
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $jr5t3.useMountEffect)(function() {
        var viewDate = getViewDate(props.viewDate);
        validateDate(viewDate);
        setViewDateState(viewDate);
        setCurrentMonth(viewDate.getMonth());
        setCurrentYear(viewDate.getFullYear());
        setCurrentView(props.view);
        if (!idState) {
            var uniqueId = (0, $7nrKB.UniqueComponentId)();
            !idState && setIdState(uniqueId);
        }
        if (props.inline) {
            overlayRef && overlayRef.current.setAttribute(attributeSelector, "");
            if (!props.disabled) {
                initFocusableCell();
                if (props.numberOfMonths === 1) overlayRef.current.style.width = (0, $7nrKB.DomHandler).getOuterWidth(overlayRef.current) + "px";
            }
        }
        if (props.value) {
            updateInputfield(props.value);
            setValue(props.value);
        }
        if (props.autoFocus) // delay showing until rendered so `alignPanel()` method aligns the popup in the right location
        setTimeout(function() {
            return (0, $7nrKB.DomHandler).focus(inputRef.current, props.autoFocus);
        }, 200);
    });
    $7E7Dk.useEffect(function() {
        // see https://github.com/primefaces/primereact/issues/4030
        onChangeRef.current = props.onChange;
    }, [
        props.onChange
    ]);
    $7E7Dk.useEffect(function() {
        var unbindMaskEvents = null;
        if (props.mask) unbindMaskEvents = (0, $7nrKB.mask)(inputRef.current, {
            mask: props.mask,
            slotChar: props.maskSlotChar,
            readOnly: props.readOnlyInput || props.disabled,
            onChange: function onChange(e) {
                updateValueOnInput(e.originalEvent, e.value, function() {
                    return false;
                });
            },
            onBlur: function onBlur(e) {
                updateValueOnInput(e, e.target.value);
            }
        }).unbindEvents;
        return function() {
            props.mask && unbindMaskEvents && unbindMaskEvents();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.mask,
        props.readOnlyInput
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (viewChangedWithKeyDown.current) setCurrentView(props.view);
        viewChangedWithKeyDown.current = false;
    }, [
        props.view
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (visible && !props.inline) focusToFirstCell();
    }, [
        visible,
        currentView,
        props.inline
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (!props.onViewDateChange && !viewStateChanged.current) setValue(props.value);
        if (props.viewDate) {
            var date = getViewDate(props.viewDate);
            updateViewDate(null, date);
            onViewDateSelect({
                event: null,
                date: date
            });
        }
    }, [
        props.onViewDateChange,
        props.value,
        props.viewDate
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (overlayVisibleState || props.visible) // Github #5529
        setTimeout(function() {
            alignOverlay();
        });
    }, [
        currentView,
        overlayVisibleState,
        props.visible
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        var newDate = props.value;
        if (previousValue !== newDate) {
            var isInputFocused = document.activeElement === inputRef.current;
            // Do not update value in input if user types something in it:
            if (!isInputFocused) updateInputfield(newDate);
            // #3516 view date not updated when value set programatically
            if (!newDate) return;
            var viewDate = newDate;
            if (isMultipleSelection()) {
                if (newDate.length) viewDate = newDate[newDate.length - 1];
            } else if (isRangeSelection()) {
                if (newDate.length) {
                    var startDate = newDate[0];
                    var endDate = newDate[1];
                    viewDate = endDate || startDate;
                }
            }
            if (viewDate instanceof Date) {
                validateDate(viewDate);
                setViewDateState(viewDate);
                setCurrentMonth(viewDate.getMonth());
                setCurrentYear(viewDate.getFullYear());
            }
        }
    }, [
        props.value,
        visible
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        updateInputfield(props.value);
    }, [
        props.dateFormat,
        props.hourFormat,
        props.timeOnly,
        props.showSeconds,
        props.showMillisec,
        props.showTime,
        props.locale
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (overlayRef.current) {
            setNavigationState(viewDateState);
            updateFocus();
        }
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        if (touchUIMask.current) {
            disableModality();
            touchUIMask.current = null;
        }
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getCurrentDateTime: getCurrentDateTime,
            getViewDate: getViewDate,
            updateViewDate: updateViewDate,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    var setValue = function setValue(propValue) {
        if (Array.isArray(propValue)) propValue = propValue[0];
        var prevPropValue = previousValue;
        if (Array.isArray(prevPropValue)) prevPropValue = prevPropValue[0];
        var viewDate = props.viewDate && isValidDate(props.viewDate) ? props.viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
        if (isClearClicked.current && props.showTime) {
            viewDate.setHours(0, 0, 0);
            isClearClicked.current = false;
        }
        if (!prevPropValue && propValue || propValue && propValue instanceof Date && prevPropValue instanceof Date && propValue.getTime() !== prevPropValue.getTime()) validateDate(viewDate);
        setViewDateState(viewDate);
        viewStateChanged.current = true;
    };
    var createBackwardNavigator = function createBackwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onPrevButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var previousIconProps = mergeProps({
            className: cx("previousIcon")
        }, ptm("previousIcon"));
        var icon = props.prevIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $5o5UD.ChevronLeftIcon), previousIconProps);
        var backwardNavigatorIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $ea238209e381f15e$var$_objectSpread({}, previousIconProps), {
            props: props
        });
        var _localeOptions4 = (0, $eHYdO.localeOptions)(props.locale), prevDecade = _localeOptions4.prevDecade, prevYear = _localeOptions4.prevYear, prevMonth = _localeOptions4.prevMonth;
        var previousButtonLabel = currentView === "year" ? prevDecade : currentView === "month" ? prevYear : prevMonth;
        var previousButtonProps = mergeProps($ea238209e381f15e$var$_objectSpread({
            type: "button",
            className: cx("previousButton"),
            "aria-label": previousButtonLabel
        }, navigatorProps), ptm("previousButton"));
        return /*#__PURE__*/ $7E7Dk.createElement("button", $ea238209e381f15e$var$_extends({
            ref: previousButton
        }, previousButtonProps), backwardNavigatorIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
    };
    var createForwardNavigator = function createForwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onNextButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var nextIconProps = mergeProps({
            className: cx("nextIcon")
        }, ptm("nextIcon"));
        var icon = props.nextIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $62XPz.ChevronRightIcon), nextIconProps);
        var forwardNavigatorIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $ea238209e381f15e$var$_objectSpread({}, nextIconProps), {
            props: props
        });
        var _localeOptions5 = (0, $eHYdO.localeOptions)(props.locale), nextDecade = _localeOptions5.nextDecade, nextYear = _localeOptions5.nextYear, nextMonth = _localeOptions5.nextMonth;
        var nextButtonLabel = currentView === "year" ? nextDecade : currentView === "month" ? nextYear : nextMonth;
        var nextButtonProps = mergeProps($ea238209e381f15e$var$_objectSpread({
            type: "button",
            className: cx("nextButton"),
            "aria-label": nextButtonLabel
        }, navigatorProps), ptm("nextButton"));
        return /*#__PURE__*/ $7E7Dk.createElement("button", $ea238209e381f15e$var$_extends({
            ref: nextButton
        }, nextButtonProps), forwardNavigatorIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
    };
    var renderMonthsNavigator = function renderMonthsNavigator(index) {
        return props.monthNavigator && props.view !== "month" && (props.numberOfMonths === 1 || index === 0);
    };
    var createTitleMonthElement = function createTitleMonthElement(month, monthIndex) {
        var monthNames = (0, $eHYdO.localeOption)("monthNames", props.locale);
        if (renderMonthsNavigator(monthIndex)) {
            var viewDate = getViewDate();
            var viewMonth = viewDate.getMonth();
            var displayedMonthOptions = monthNames.map(function(month, index) {
                return (!isInMinYear(viewDate) || index >= props.minDate.getMonth()) && (!isInMaxYear(viewDate) || index <= props.maxDate.getMonth()) ? {
                    label: month,
                    value: index,
                    index: index
                } : null;
            }).filter(function(option) {
                return !!option;
            });
            var displayedMonthNames = displayedMonthOptions.map(function(option) {
                return option.label;
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onMonthDropdownChange(e, e.target.value);
                },
                value: viewMonth
            }, ptm("select"));
            var _content = /*#__PURE__*/ $7E7Dk.createElement("select", selectProps, displayedMonthOptions.map(function(option) {
                var optionProps = mergeProps({
                    value: option.value
                }, ptm("option"));
                return /*#__PURE__*/ $7E7Dk.createElement("option", $ea238209e381f15e$var$_extends({}, optionProps, {
                    key: option.label
                }), option.label);
            }));
            if (props.monthNavigatorTemplate) {
                var defaultContentOptions = {
                    onChange: onMonthDropdownChange,
                    className: "p-datepicker-month",
                    value: viewMonth,
                    names: displayedMonthNames,
                    options: displayedMonthOptions,
                    element: _content,
                    props: props
                };
                return (0, $7nrKB.ObjectUtils).getJSXElement(props.monthNavigatorTemplate, defaultContentOptions);
            }
            return _content;
        }
        var monthTitleProps = mergeProps({
            className: cx("monthTitle"),
            onKeyDown: onContainerButtonKeydown,
            "aria-label": (0, $eHYdO.localeOption)("chooseMonth", props.locale),
            onClick: switchToMonthView,
            disabled: switchViewButtonDisabled()
        }, ptm("monthTitle"));
        return currentView === "date" && /*#__PURE__*/ $7E7Dk.createElement("button", monthTitleProps, monthNames[month]);
    };
    var createTitleYearElement = function createTitleYearElement(metaYear) {
        var viewDate = getViewDate();
        var viewYear = viewDate.getFullYear();
        var displayYear = props.numberOfMonths > 1 || props.yearNavigator ? metaYear : currentYear;
        if (props.yearNavigator) {
            var _yearOptions2 = [];
            if (props.yearRange) {
                var years = props.yearRange.split(":");
                var yearStart = parseInt(years[0], 10);
                var yearEnd = parseInt(years[1], 10);
                for(var i = yearStart; i <= yearEnd; i++)_yearOptions2.push(i);
            } else {
                var base = viewYear - viewYear % 10;
                for(var _i2 = 0; _i2 < 10; _i2++)_yearOptions2.push(base + _i2);
            }
            var displayedYearNames = _yearOptions2.filter(function(year) {
                return !(props.minDate && props.minDate.getFullYear() > year) && !(props.maxDate && props.maxDate.getFullYear() < year);
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onYearDropdownChange(e, e.target.value);
                },
                value: displayYear
            }, ptm("select"));
            var _content2 = /*#__PURE__*/ $7E7Dk.createElement("select", selectProps, displayedYearNames.map(function(year) {
                var optionProps = mergeProps({
                    value: year
                }, ptm("option"));
                return /*#__PURE__*/ $7E7Dk.createElement("option", $ea238209e381f15e$var$_extends({}, optionProps, {
                    key: year
                }), year);
            }));
            if (props.yearNavigatorTemplate) {
                var options = displayedYearNames.map(function(name, i) {
                    return {
                        label: name,
                        value: name,
                        index: i
                    };
                });
                var defaultContentOptions = {
                    onChange: onYearDropdownChange,
                    className: "p-datepicker-year",
                    value: viewYear,
                    names: displayedYearNames,
                    options: options,
                    element: _content2,
                    props: props
                };
                return (0, $7nrKB.ObjectUtils).getJSXElement(props.yearNavigatorTemplate, defaultContentOptions);
            }
            return _content2;
        }
        var yearTitleProps = mergeProps({
            className: cx("yearTitle"),
            "aria-label": (0, $eHYdO.localeOption)("chooseYear", props.locale),
            onClick: function onClick(e) {
                return switchToYearView(e);
            },
            disabled: switchViewButtonDisabled()
        }, ptm("yearTitle"));
        return currentView !== "year" && /*#__PURE__*/ $7E7Dk.createElement("button", yearTitleProps, displayYear);
    };
    var createTitleDecadeElement = function createTitleDecadeElement() {
        var years = yearPickerValues();
        var decadeTitleProps = mergeProps({
            className: cx("decadeTitle")
        }, ptm("decadeTitle"));
        if (currentView === "year") {
            var decadeTitleTextProps = mergeProps(ptm("decadeTitleText"));
            return /*#__PURE__*/ $7E7Dk.createElement("span", decadeTitleProps, props.decadeTemplate ? props.decadeTemplate(years) : /*#__PURE__*/ $7E7Dk.createElement("span", decadeTitleTextProps, "".concat(yearPickerValues()[0], " - ").concat(yearPickerValues()[yearPickerValues().length - 1])));
        }
        return null;
    };
    var createTitle = function createTitle(monthMetaData, index) {
        var month = createTitleMonthElement(monthMetaData.month, index);
        var year = createTitleYearElement(monthMetaData.year);
        var decade = createTitleDecadeElement();
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        var showMonthAfterYear = (0, $eHYdO.localeOption)("showMonthAfterYear", props.locale);
        return /*#__PURE__*/ $7E7Dk.createElement("div", titleProps, showMonthAfterYear ? year : month, showMonthAfterYear ? month : year, decade);
    };
    var createDayNames = function createDayNames(weekDays) {
        var weekDayProps = mergeProps(ptm("weekDay"));
        var tableHeaderCellProps = mergeProps({
            scope: "col"
        }, ptm("tableHeaderCell"));
        var dayNames = weekDays.map(function(weekDay, index) {
            return /*#__PURE__*/ $7E7Dk.createElement("th", $ea238209e381f15e$var$_extends({}, tableHeaderCellProps, {
                key: "".concat(weekDay, "-").concat(index)
            }), /*#__PURE__*/ $7E7Dk.createElement("span", weekDayProps, weekDay));
        });
        if (props.showWeek) {
            var weekHeaderProps = mergeProps({
                scope: "col",
                className: cx("weekHeader"),
                "data-p-disabled": props.showWeek
            }, ptm("weekHeader", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekLabel = mergeProps(ptm("weekLabel"));
            var weekHeader = /*#__PURE__*/ $7E7Dk.createElement("th", $ea238209e381f15e$var$_extends({}, weekHeaderProps, {
                key: "wn"
            }), /*#__PURE__*/ $7E7Dk.createElement("span", weekLabel, (0, $eHYdO.localeOption)("weekHeader", props.locale)));
            return [
                weekHeader
            ].concat($ea238209e381f15e$var$_toConsumableArray(dayNames));
        }
        return dayNames;
    };
    var createDateCellContent = function createDateCellContent(date, className, groupIndex) {
        var content = props.dateTemplate ? props.dateTemplate(date) : date.day;
        var selected = isSelected(date);
        var dayLabelProps = mergeProps({
            className: cx("dayLabel", {
                className: className
            }),
            "aria-selected": selected,
            "aria-disabled": !date.selectable,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            onClick: function onClick(e) {
                return onDateSelect(e, date);
            },
            onKeyDown: function onKeyDown(e) {
                return onDateCellKeydown(e, date, groupIndex);
            },
            "data-p-highlight": selected,
            "data-p-disabled": !date.selectable
        }, ptm("dayLabel", {
            context: {
                selected: selected,
                disabled: !date.selectable
            }
        }));
        return /*#__PURE__*/ $7E7Dk.createElement("span", dayLabelProps, content, selected && /*#__PURE__*/ $7E7Dk.createElement("div", {
            "aria-live": "polite",
            className: "p-hidden-accessible",
            "data-p-hidden-accessible": true,
            pt: ptm("hiddenSelectedDay")
        }));
    };
    var createWeek = function createWeek(weekDates, weekNumber, groupIndex) {
        var week = weekDates.map(function(date) {
            var selected = isSelected(date);
            var dateClassName = (0, $7nrKB.classNames)({
                "p-highlight": selected,
                "p-disabled": !date.selectable
            });
            var content = date.otherMonth && !props.showOtherMonths ? null : createDateCellContent(date, dateClassName, groupIndex);
            var formattedValue = formatDate(new Date(date.year, date.month, date.day), getDateFormat());
            var dayProps = mergeProps({
                className: cx("day", {
                    date: date
                }),
                "aria-label": formattedValue,
                "data-p-today": date.today,
                "data-p-other-month": date.otherMonth,
                "data-p-day": date.day,
                "data-p-month": date.month,
                "data-p-year": date.year
            }, ptm("day", {
                context: {
                    date: date,
                    today: date.today,
                    otherMonth: date.otherMonth
                }
            }));
            return /*#__PURE__*/ $7E7Dk.createElement("td", $ea238209e381f15e$var$_extends({}, dayProps, {
                key: date.day
            }), content);
        });
        if (props.showWeek) {
            var weekNumberProps = mergeProps({
                className: cx("weekNumber")
            }, ptm("weekNumber"));
            var weekLabelContainerProps = mergeProps({
                className: cx("weekLabelContainer"),
                "data-p-disabled": props.showWeek
            }, ptm("weekLabelContainer", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekNumberCell = /*#__PURE__*/ $7E7Dk.createElement("td", $ea238209e381f15e$var$_extends({}, weekNumberProps, {
                key: "wn" + weekNumber
            }), /*#__PURE__*/ $7E7Dk.createElement("span", weekLabelContainerProps, weekNumber));
            return [
                weekNumberCell
            ].concat($ea238209e381f15e$var$_toConsumableArray(week));
        }
        return week;
    };
    var createDates = function createDates(monthMetaData, groupIndex) {
        var tableBodyRowProps = mergeProps(ptm("tableBodyRowProps"));
        return monthMetaData.dates.map(function(weekDates, index) {
            return /*#__PURE__*/ $7E7Dk.createElement("tr", $ea238209e381f15e$var$_extends({}, tableBodyRowProps, {
                key: index
            }), createWeek(weekDates, monthMetaData.weekNumbers[index], groupIndex));
        });
    };
    var createDateViewGrid = function createDateViewGrid(monthMetaData, weekDays, groupIndex) {
        var dayNames = createDayNames(weekDays);
        var dates = createDates(monthMetaData, groupIndex);
        var containerProps = mergeProps({
            className: cx("container")
        }, ptm("container"));
        var tableProps = mergeProps({
            role: "grid",
            className: cx("table")
        }, ptm("table"));
        var tableHeaderProps = mergeProps(ptm("tableHeader"));
        var tableHeaderRowProps = mergeProps(ptm("tableHeaderRow"));
        var tableBodyProps = mergeProps(ptm("tableBody"));
        return currentView === "date" && /*#__PURE__*/ $7E7Dk.createElement("div", $ea238209e381f15e$var$_extends({}, containerProps, {
            key: (0, $7nrKB.UniqueComponentId)("calendar_container_")
        }), /*#__PURE__*/ $7E7Dk.createElement("table", tableProps, /*#__PURE__*/ $7E7Dk.createElement("thead", tableHeaderProps, /*#__PURE__*/ $7E7Dk.createElement("tr", tableHeaderRowProps, dayNames)), /*#__PURE__*/ $7E7Dk.createElement("tbody", tableBodyProps, dates)));
    };
    var createMonth = function createMonth(monthMetaData, index) {
        var weekDays = createWeekDaysMeta();
        var backwardNavigator = createBackwardNavigator(index === 0);
        var forwardNavigator = createForwardNavigator(props.numberOfMonths === 1 || index === props.numberOfMonths - 1);
        var title = createTitle(monthMetaData, index);
        var dateViewGrid = createDateViewGrid(monthMetaData, weekDays, index);
        var header = props.headerTemplate ? props.headerTemplate() : null;
        var monthKey = monthMetaData.month + "-" + monthMetaData.year;
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", $ea238209e381f15e$var$_extends({}, groupProps, {
            key: monthKey
        }), /*#__PURE__*/ $7E7Dk.createElement("div", $ea238209e381f15e$var$_extends({}, headerProps, {
            key: index
        }), header, backwardNavigator, title, forwardNavigator), dateViewGrid);
    };
    var createMonths = function createMonths(monthsMetaData) {
        var groups = monthsMetaData.map(createMonth);
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", groupContainerProps, groups);
    };
    var createDateView = function createDateView() {
        var viewDate = getViewDate();
        var monthsMetaData = createMonthsMeta(viewDate.getMonth(), viewDate.getFullYear());
        var months = createMonths(monthsMetaData);
        return months;
    };
    var monthPickerValues = function monthPickerValues() {
        var monthPickerValues = [];
        var monthNamesShort = (0, $eHYdO.localeOption)("monthNamesShort", props.locale);
        for(var i = 0; i <= 11; i++)monthPickerValues.push(monthNamesShort[i]);
        return monthPickerValues;
    };
    var yearPickerValues = function yearPickerValues() {
        var yearPickerValues = [];
        var base = currentYear - currentYear % 10;
        for(var i = 0; i < 10; i++)yearPickerValues.push(base + i);
        return yearPickerValues;
    };
    var createMonthYearView = function createMonthYearView() {
        var backwardNavigator = createBackwardNavigator(true);
        var forwardNavigator = createForwardNavigator(true);
        var yearElement = createTitleYearElement(getViewDate().getFullYear());
        var decade = createTitleDecadeElement();
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", groupContainerProps, /*#__PURE__*/ $7E7Dk.createElement("div", groupProps, /*#__PURE__*/ $7E7Dk.createElement("div", headerProps, backwardNavigator, /*#__PURE__*/ $7E7Dk.createElement("div", titleProps, yearElement, decade), forwardNavigator))));
    };
    var createDatePicker = function createDatePicker() {
        if (!props.timeOnly) {
            if (props.view === "date") return createDateView();
            return createMonthYearView();
        }
        return null;
    };
    var incrementIconProps = mergeProps(ptm("incrementIcon"));
    var decrementIconProps = mergeProps(ptm("decrementIcon"));
    var incrementIcon = (0, $7nrKB.IconUtils).getJSXIcon(props.incrementIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $difhH.ChevronUpIcon), incrementIconProps), $ea238209e381f15e$var$_objectSpread({}, incrementIconProps), {
        props: props
    });
    var decrementIcon = (0, $7nrKB.IconUtils).getJSXIcon(props.decrementIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $9pANH.ChevronDownIcon), decrementIconProps), $ea238209e381f15e$var$_objectSpread({}, decrementIconProps), {
        props: props
    });
    var createHourPicker = function createHourPicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        var hour = currentTime.getHours();
        // #3770 account for step minutes rolling to next hour
        hour = minute > 59 ? hour + 1 : hour;
        if (props.hourFormat === "12") {
            if (hour === 0) hour = 12;
            else if (hour > 11 && hour !== 12) hour = hour - 12;
        }
        var hourProps = mergeProps(ptm("hour"));
        var _localeOptions6 = (0, $eHYdO.localeOptions)(props.locale), nextHour = _localeOptions6.nextHour, prevHour = _localeOptions6.prevHour;
        var hourDisplay = hour < 10 ? "0" + hour : hour;
        var hourPickerProps = mergeProps({
            className: cx("hourPicker")
        }, ptm("hourPicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", hourPickerProps, /*#__PURE__*/ $7E7Dk.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), /*#__PURE__*/ $7E7Dk.createElement("span", hourProps, hourDisplay), /*#__PURE__*/ $7E7Dk.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
    };
    var createMinutePicker = function createMinutePicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        minute = minute > 59 ? minute - 60 : minute;
        var minuteProps = mergeProps(ptm("minute"));
        var _localeOptions7 = (0, $eHYdO.localeOptions)(props.locale), nextMinute = _localeOptions7.nextMinute, prevMinute = _localeOptions7.prevMinute;
        var minuteDisplay = minute < 10 ? "0" + minute : minute;
        var minutePickerProps = mergeProps({
            className: cx("minutePicker")
        }, ptm("minutePicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", minutePickerProps, /*#__PURE__*/ $7E7Dk.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), /*#__PURE__*/ $7E7Dk.createElement("span", minuteProps, minuteDisplay), /*#__PURE__*/ $7E7Dk.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
    };
    var createSecondPicker = function createSecondPicker() {
        if (props.showSeconds) {
            var currentTime = getCurrentDateTime();
            var _localeOptions8 = (0, $eHYdO.localeOptions)(props.locale), nextSecond = _localeOptions8.nextSecond, prevSecond = _localeOptions8.prevSecond;
            var secondProps = mergeProps(ptm("second"));
            var second = currentTime.getSeconds();
            var secondDisplay = second < 10 ? "0" + second : second;
            var secondPickerProps = mergeProps({
                className: cx("secondPicker")
            }, ptm("secondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", secondPickerProps, /*#__PURE__*/ $7E7Dk.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), /*#__PURE__*/ $7E7Dk.createElement("span", secondProps, secondDisplay), /*#__PURE__*/ $7E7Dk.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
        }
        return null;
    };
    var createMiliSecondPicker = function createMiliSecondPicker() {
        if (props.showMillisec) {
            var currentTime = getCurrentDateTime();
            var _localeOptions9 = (0, $eHYdO.localeOptions)(props.locale), nextMilliSecond = _localeOptions9.nextMilliSecond, prevMilliSecond = _localeOptions9.prevMilliSecond;
            var millisecondProps = mergeProps(ptm("millisecond"));
            var millisecond = currentTime.getMilliseconds();
            var millisecondDisplay = millisecond < 100 ? (millisecond < 10 ? "00" : "0") + millisecond : millisecond;
            var millisecondPickerProps = mergeProps({
                className: cx("millisecondPicker")
            }, ptm("millisecondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", millisecondPickerProps, /*#__PURE__*/ $7E7Dk.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), /*#__PURE__*/ $7E7Dk.createElement("span", millisecondProps, millisecondDisplay), /*#__PURE__*/ $7E7Dk.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
        }
        return null;
    };
    var createAmPmPicker = function createAmPmPicker() {
        if (props.hourFormat === "12") {
            var currentTime = getCurrentDateTime();
            var _localeOptions10 = (0, $eHYdO.localeOptions)(props.locale), am = _localeOptions10.am, pm = _localeOptions10.pm;
            var hour = currentTime.getHours();
            var display = hour > 11 ? "PM" : "AM";
            var ampmProps = mergeProps(ptm("ampm"));
            var ampmPickerProps = mergeProps({
                className: cx("ampmPicker")
            }, ptm("ampmPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": am,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": pm,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", ampmPickerProps, /*#__PURE__*/ $7E7Dk.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)), /*#__PURE__*/ $7E7Dk.createElement("span", ampmProps, display), /*#__PURE__*/ $7E7Dk.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
        }
        return null;
    };
    var createSeparator = function createSeparator(separator) {
        var separatorContainerProps = mergeProps({
            className: cx("separatorContainer")
        }, ptm("separatorContainer"));
        var separatorProps = mergeProps(ptm("separator"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", separatorContainerProps, /*#__PURE__*/ $7E7Dk.createElement("span", separatorProps, separator));
    };
    var createTimePicker = function createTimePicker() {
        if ((props.showTime || props.timeOnly) && currentView === "date") {
            var timePickerProps = mergeProps({
                className: cx("timePicker")
            }, ptm("timePicker"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", timePickerProps, createHourPicker(), createSeparator(":"), createMinutePicker(), props.showSeconds && createSeparator(":"), createSecondPicker(), props.showMillisec && createSeparator("."), createMiliSecondPicker(), props.hourFormat === "12" && createSeparator(":"), createAmPmPicker());
        }
        return null;
    };
    var createInputElement = function createInputElement() {
        if (!props.inline) return /*#__PURE__*/ $7E7Dk.createElement((0, $kl2VR.InputText), {
            ref: inputRef,
            id: props.inputId,
            name: props.name,
            type: "text",
            role: "combobox",
            className: (0, $7nrKB.classNames)(props.inputClassName, cx("input", {
                context: context
            })),
            style: props.inputStyle,
            readOnly: props.readOnlyInput,
            disabled: props.disabled,
            required: props.required,
            autoComplete: "off",
            placeholder: props.placeholder,
            tabIndex: props.tabIndex,
            onInput: onUserInput,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            "aria-expanded": overlayVisibleState,
            "aria-autocomplete": "none",
            "aria-haspopup": "dialog",
            "aria-controls": panelId,
            "aria-labelledby": props.ariaLabelledBy,
            "aria-label": props.ariaLabel,
            inputMode: props.inputMode,
            tooltip: props.tooltip,
            tooltipOptions: props.tooltipOptions,
            pt: ptm("input"),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createButton = function createButton() {
        if (props.showIcon) return /*#__PURE__*/ $7E7Dk.createElement((0, $1ot1u.Button), {
            type: "button",
            icon: props.icon || /*#__PURE__*/ $7E7Dk.createElement((0, $jrCCO.CalendarIcon), null),
            onClick: onButtonClick,
            tabIndex: "-1",
            disabled: props.disabled,
            "aria-haspopup": "dialog",
            "aria-label": (0, $eHYdO.localeOption)("chooseDate", props.locale),
            "aria-expanded": overlayVisibleState,
            "aria-controls": panelId,
            className: cx("dropdownButton"),
            pt: ptm("dropdownButton"),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createContent = function createContent() {
        var input = createInputElement();
        var button = createButton();
        if (props.iconPos === "left") return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, button, input);
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, input, button);
    };
    var isPastMaxDateWithBuffer = function isPastMaxDateWithBuffer() {
        var bufferInSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var now = new Date();
        var maxDate = props.maxDate;
        return maxDate < now && Math.abs((now.getTime() - maxDate.getTime()) / 1000) > bufferInSeconds;
    };
    var createButtonBar = function createButtonBar() {
        if (props.showButtonBar) {
            var _localeOptions11 = (0, $eHYdO.localeOptions)(props.locale), today = _localeOptions11.today, clear = _localeOptions11.clear, now = _localeOptions11.now;
            var nowDate = new Date();
            var isHidden = props.minDate && props.minDate > nowDate || props.maxDate && isPastMaxDateWithBuffer();
            var buttonbarProps = mergeProps({
                className: cx("buttonbar")
            }, ptm("buttonbar"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", buttonbarProps, /*#__PURE__*/ $7E7Dk.createElement((0, $1ot1u.Button), {
                type: "button",
                label: props.showTime ? now : today,
                onClick: onTodayButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $7nrKB.classNames)(props.todayButtonClassName, cx("todayButton")),
                pt: ptm("todayButton"),
                style: isHidden ? {
                    visibility: "hidden"
                } : undefined
            }), /*#__PURE__*/ $7E7Dk.createElement((0, $1ot1u.Button), {
                type: "button",
                label: clear,
                onClick: onClearButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $7nrKB.classNames)(props.clearButtonClassName, cx("clearButton")),
                pt: ptm("clearButton")
            }));
        }
        return null;
    };
    var createFooter = function createFooter() {
        if (props.footerTemplate) {
            var _content3 = props.footerTemplate();
            var footerProps = mergeProps({
                className: cx("footer")
            }, ptm("footer"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", footerProps, _content3);
        }
        return null;
    };
    var createMonthPicker = function createMonthPicker() {
        if (currentView === "month") {
            var monthPickerProps = mergeProps({
                className: cx("monthPicker")
            }, ptm("monthPicker"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", monthPickerProps, monthPickerValues().map(function(m, i) {
                var selected = isMonthSelected(i);
                var monthProps = mergeProps({
                    className: cx("month", {
                        isMonthSelected: isMonthSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        i: i,
                        currentYear: currentYear
                    }),
                    onClick: function onClick(event) {
                        return onMonthSelect(event, i);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onMonthCellKeydown(event, i);
                    },
                    "data-p-disabled": isMonthYearDisabled(i, currentYear),
                    "data-p-highlight": selected
                }, ptm("month", {
                    context: {
                        month: m,
                        monthIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(i, currentYear)
                    }
                }));
                return /*#__PURE__*/ $7E7Dk.createElement("span", $ea238209e381f15e$var$_extends({}, monthProps, {
                    key: "month".concat(i + 1)
                }), m, selected && /*#__PURE__*/ $7E7Dk.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenMonth")
                }, m));
            }));
        }
        return null;
    };
    var createYearPicker = function createYearPicker() {
        if (currentView === "year") {
            var yearPickerProps = mergeProps({
                className: cx("yearPicker")
            }, ptm("yearPicker"));
            return /*#__PURE__*/ $7E7Dk.createElement("div", yearPickerProps, yearPickerValues().map(function(y, i) {
                var selected = isYearSelected(y);
                var yearProps = mergeProps({
                    className: cx("year", {
                        isYearSelected: isYearSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        y: y
                    }),
                    onClick: function onClick(event) {
                        return onYearSelect(event, y);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onYearCellKeydown(event, y);
                    },
                    "data-p-highlight": isYearSelected(y),
                    "data-p-disabled": isMonthYearDisabled(-1, y)
                }, ptm("year", {
                    context: {
                        year: y,
                        yearIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(-1, y)
                    }
                }));
                return /*#__PURE__*/ $7E7Dk.createElement("span", $ea238209e381f15e$var$_extends({}, yearProps, {
                    key: "year".concat(i + 1)
                }), y, selected && /*#__PURE__*/ $7E7Dk.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenYear")
                }, y));
            }));
        }
        return null;
    };
    var panelClassName = (0, $7nrKB.classNames)("p-datepicker p-component", props.panelClassName, {
        "p-datepicker-inline": props.inline,
        "p-disabled": props.disabled,
        "p-datepicker-timeonly": props.timeOnly,
        "p-datepicker-multiple-month": props.numberOfMonths > 1,
        "p-datepicker-monthpicker": currentView === "month",
        "p-datepicker-touch-ui": props.touchUI,
        "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
        "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
    });
    var content = createContent();
    var datePicker = createDatePicker();
    var timePicker = createTimePicker();
    var buttonBar = createButtonBar();
    var footer = createFooter();
    var monthPicker = createMonthPicker();
    var yearPicker = createYearPicker();
    var isFilled = (0, $7nrKB.DomHandler).hasClass(inputRef.current, "p-filled") && inputRef.current.value !== "";
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            focusedState: focusedState,
            isFilled: isFilled,
            panelVisible: visible
        })),
        style: props.style
    }, $ea238209e381f15e$var$CalendarBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $7E7Dk.createElement("span", $ea238209e381f15e$var$_extends({
        ref: elementRef
    }, rootProps), content, /*#__PURE__*/ $7E7Dk.createElement($ea238209e381f15e$var$CalendarPanel, {
        hostName: "Calendar",
        id: panelId,
        locale: props.locale,
        ref: overlayRef,
        className: panelClassName,
        style: props.panelStyle,
        appendTo: props.appendTo,
        inline: props.inline,
        onClick: onPanelClick,
        onMouseUp: onPanelMouseUp,
        "in": visible,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        transitionOptions: props.transitionOptions,
        ptm: ptm,
        cx: cx
    }, datePicker, timePicker, monthPicker, yearPicker, buttonBar, footer));
}));
$ea238209e381f15e$export$e1aef45b828286de.displayName = "Calendar";

});
parcelRegister("jrCCO", function(module, exports) {

$parcel$export(module.exports, "CalendarIcon", function () { return $e27e800f6c2f6615$export$5fda1783bb83f57b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $e27e800f6c2f6615$var$_extends() {
    return $e27e800f6c2f6615$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e27e800f6c2f6615$var$_extends.apply(null, arguments);
}
var $e27e800f6c2f6615$export$5fda1783bb83f57b = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $e27e800f6c2f6615$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
        fill: "currentColor"
    }));
}));
$e27e800f6c2f6615$export$5fda1783bb83f57b.displayName = "CalendarIcon";

});

parcelRegister("5o5UD", function(module, exports) {

$parcel$export(module.exports, "ChevronLeftIcon", function () { return $3ec3c7bd80ccf5e7$export$20bc5960c3c9eebb; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $3ec3c7bd80ccf5e7$var$_extends() {
    return $3ec3c7bd80ccf5e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ec3c7bd80ccf5e7$var$_extends.apply(null, arguments);
}
var $3ec3c7bd80ccf5e7$export$20bc5960c3c9eebb = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $3ec3c7bd80ccf5e7$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
        fill: "currentColor"
    }));
}));
$3ec3c7bd80ccf5e7$export$20bc5960c3c9eebb.displayName = "ChevronLeftIcon";

});

parcelRegister("62XPz", function(module, exports) {

$parcel$export(module.exports, "ChevronRightIcon", function () { return $4671571c3e5a351d$export$b837bd7eac09a33e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $dbTKA = parcelRequire("dbTKA");
"use client";
function $4671571c3e5a351d$var$_extends() {
    return $4671571c3e5a351d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4671571c3e5a351d$var$_extends.apply(null, arguments);
}
var $4671571c3e5a351d$export$b837bd7eac09a33e = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var pti = (0, $dbTKA.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $7E7Dk.createElement("svg", $4671571c3e5a351d$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $7E7Dk.createElement("path", {
        d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
        fill: "currentColor"
    }));
}));
$4671571c3e5a351d$export$b837bd7eac09a33e.displayName = "ChevronRightIcon";

});


parcelRegister("j8chc", function(module, exports) {
$parcel$export(module.exports, "Switch", function () { return (parcelRequire("6OeGJ")).Switch; });
parcelRequire("6OeGJ");

});
parcelRegister("6OeGJ", function(module, exports) {

$parcel$export(module.exports, "Switch", function () { return $e6b26978a4476904$export$b5d5cf8927ab7262; });

var $iel6A = parcelRequire("iel6A");

var $7E7Dk = parcelRequire("7E7Dk");
const $e6b26978a4476904$export$b5d5cf8927ab7262 = ({ checked: checked, onChange: onChange, disabled: disabled, loading: loading, label: label, inputId: inputId, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iel6A.InputSwitch), {
        checked: checked,
        onChange: onChange,
        disabled: loading || disabled,
        inputId: inputId,
        ...props
    }), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-spin pi-spinner text-lg"
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "m-0",
        htmlFor: inputId
    }, label));
};

});
parcelRegister("iel6A", function(module, exports) {

$parcel$export(module.exports, "InputSwitch", function () { return $d459e7d893500ee0$export$b9b970c64c06506e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $d459e7d893500ee0$var$_extends() {
    return $d459e7d893500ee0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d459e7d893500ee0$var$_extends.apply(null, arguments);
}
function $d459e7d893500ee0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d459e7d893500ee0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d459e7d893500ee0$var$_typeof(o);
}
function $d459e7d893500ee0$var$toPrimitive(t, r) {
    if ("object" != $d459e7d893500ee0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d459e7d893500ee0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d459e7d893500ee0$var$toPropertyKey(t) {
    var i = $d459e7d893500ee0$var$toPrimitive(t, "string");
    return "symbol" == $d459e7d893500ee0$var$_typeof(i) ? i : i + "";
}
function $d459e7d893500ee0$var$_defineProperty(e, r, t) {
    return (r = $d459e7d893500ee0$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
var $d459e7d893500ee0$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked;
        return (0, $7nrKB.classNames)("p-inputswitch p-component", {
            "p-highlight": checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid
        });
    },
    input: "p-inputswitch-input",
    slider: "p-inputswitch-slider"
};
var $d459e7d893500ee0$var$InputSwitchBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputSwitch",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        name: null,
        onBlur: null,
        onChange: null,
        onFocus: null,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        children: undefined
    },
    css: {
        classes: $d459e7d893500ee0$var$classes
    }
});
function $d459e7d893500ee0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d459e7d893500ee0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d459e7d893500ee0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d459e7d893500ee0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d459e7d893500ee0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d459e7d893500ee0$export$b9b970c64c06506e = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $d459e7d893500ee0$var$InputSwitchBase.getProps(inProps, context);
    var _InputSwitchBase$setM = $d459e7d893500ee0$var$InputSwitchBase.setMetaData({
        props: props
    }), ptm = _InputSwitchBase$setM.ptm, cx = _InputSwitchBase$setM.cx, isUnstyled = _InputSwitchBase$setM.isUnstyled;
    (0, $kHEnT.useHandleStyle)($d459e7d893500ee0$var$InputSwitchBase.css.styles, isUnstyled, {
        name: "inputswitch"
    });
    var elementRef = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var checked = props.checked === props.trueValue;
    var onChange = function onChange(event) {
        if (props.onChange) {
            var value = checked ? props.falseValue : props.trueValue;
            props.onChange({
                originalEvent: event,
                value: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: value
                }
            });
        }
    };
    var onFocus = function onFocus(event) {
        var _props$onFocus;
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var onBlur = function onBlur(event) {
        var _props$onBlur;
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $jr5t3.useMountEffect)(function() {
        if (props.autoFocus) (0, $7nrKB.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $d459e7d893500ee0$var$InputSwitchBase.getOtherProps(props);
    var ariaProps = (0, $7nrKB.ObjectUtils).reduceKeys(otherProps, (0, $7nrKB.DomHandler).ARIA_PROPS);
    var rootProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            checked: checked
        })),
        style: props.style,
        role: "checkbox",
        "aria-checked": checked,
        "data-p-highlight": checked,
        "data-p-disabled": props.disabled
    }, otherProps, ptm("root"));
    var inputProps = mergeProps($d459e7d893500ee0$var$_objectSpread({
        type: "checkbox",
        id: props.inputId,
        name: props.name,
        checked: checked,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: props.disabled,
        role: "switch",
        tabIndex: props.tabIndex,
        "aria-checked": checked,
        className: cx("input")
    }, ariaProps), ptm("input"));
    var sliderProps = mergeProps({
        className: cx("slider")
    }, ptm("slider"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", $d459e7d893500ee0$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), /*#__PURE__*/ $7E7Dk.createElement("input", $d459e7d893500ee0$var$_extends({
        ref: inputRef
    }, inputProps)), /*#__PURE__*/ $7E7Dk.createElement("span", sliderProps)), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $d459e7d893500ee0$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$d459e7d893500ee0$export$b9b970c64c06506e.displayName = "InputSwitch";

});







parcelRegister("9yRvd", function(module, exports) {

$parcel$export(module.exports, "SButtonsGroupContainer", function () { return $9bdbc109e8ba6cd3$export$897f0f2efdac0c79; });

var $gRonV = parcelRequire("gRonV");
const $9bdbc109e8ba6cd3$export$897f0f2efdac0c79 = (0, $gRonV.default).div`
    margin-top: ${({ theme: theme })=>theme.sizing.margin.m};
    margin-bottom: ${({ theme: theme })=>theme.sizing.margin.m};
    display: flex;
    justify-content: space-between;
    gap: 10px;

    &.action-btns {
        justify-content: flex-end;
    }
`;

});

parcelRegister("2OWYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494e86574226b3fb$export$2e2bcd8739ae039; });

var $cbseE = parcelRequire("cbseE");

var $cRXmD = parcelRequire("cRXmD");

var $eIymc = parcelRequire("eIymc");
const $494e86574226b3fb$var$isConnectorOwner = (user, chargePoint)=>{
    for (const connector of chargePoint.connectors ?? []){
        if (user.id === connector.connectorUserId) return true;
    }
    return false;
};
const $494e86574226b3fb$var$isOwnerWithEditPermission = (user, chargePoint)=>{
    return (user.id === chargePoint.ownerId || $494e86574226b3fb$var$isConnectorOwner(user, chargePoint)) && !chargePoint.ownerReadOnly;
};
const $494e86574226b3fb$var$isCompanyAdmin = (user, chargePoint)=>chargePoint.companyId && (0, $cbseE.default)(user, chargePoint.companyId, (0, $cRXmD.default).Admin);
function $494e86574226b3fb$export$2e2bcd8739ae039(chargePoint, user) {
    if (0, $eIymc.isPartnerDomain) return false;
    if (!chargePoint) return false;
    if (!user) return false;
    if (user.isSuperAdmin) return true;
    if ($494e86574226b3fb$var$isOwnerWithEditPermission(user, chargePoint)) return true;
    if ($494e86574226b3fb$var$isCompanyAdmin(user, chargePoint)) return true;
    if ((0, $eIymc.isUserappDomain) && chargePoint.ownerReadOnly) return false;
    return false;
}

});

parcelRegister("5ZFCf", function(module, exports) {
$parcel$export(module.exports, "Panel", function () { return (parcelRequire("agFp5")).Panel; });
parcelRequire("agFp5");

});
parcelRegister("agFp5", function(module, exports) {

$parcel$export(module.exports, "Panel", function () { return $0cbc94e91a1a4ae2$export$2ddb90ad54e5f587; });

var $bKDGD = parcelRequire("bKDGD");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $1ot1u = parcelRequire("1ot1u");

var $e6olx = parcelRequire("e6olx");

var $eHYdO = parcelRequire("eHYdO");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("1o9MR");
var $lMbZo = parcelRequire("lMbZo");
const $0cbc94e91a1a4ae2$export$2ddb90ad54e5f587 = ({ headerActions: headerActions, footerActions: footerActions, headerIcon: headerIcon, className: className, onSearchValueChange: onSearchValueChange, searchValue: searchValue, testId: testId = "panel", ...props })=>{
    const text = (0, $5u6k9.default)();
    const [isFilterVisible, setIsFilterVisible] = (0, $7E7Dk.useState)(false);
    const inputRef = (0, $7E7Dk.useRef)(null);
    (0, $7E7Dk.useEffect)(()=>{
        if (isFilterVisible && inputRef.current) inputRef.current.focus();
        onSearchValueChange?.("");
    }, [
        isFilterVisible,
        onSearchValueChange
    ]);
    const headerTemplate = (options)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: `${options.className} flex-wrap gap-3`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex gap-2 align-items-center"
        }, typeof headerIcon === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            className: headerIcon
        }) : headerIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "p-panel-title"
        }, props.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center gap-3"
        }, headerActions, onSearchValueChange && headerActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e6olx.Divider), {
            layout: "vertical",
            className: "align-self-stretch m-0 p-0"
        }), isFilterVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lMbZo.Input), {
            ref: inputRef,
            id: `${testId}-filter-input`,
            "aria-label": text("lblFilterModal"),
            type: "search",
            value: searchValue,
            onChange: (e)=>onSearchValueChange?.(e.target.value),
            placeholder: text("lblFilterModal"),
            icon: (0, $eHYdO.PrimeIcons).SEARCH,
            className: "p-inputtext-sm",
            inputClassName: "pl-5",
            "data-testid": `${testId}-filter-input`
        }), onSearchValueChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            icon: `pi ${isFilterVisible ? "pi-filter-slash" : "pi-filter"}`,
            "data-testid": `${testId}-filter-toggle-btn`,
            "aria-label": text(isFilterVisible ? "btnClearFilter" : "lblFilterModal"),
            outlined: true,
            size: "small",
            onClick: ()=>setIsFilterVisible(!isFilterVisible)
        })));
    };
    const footerTemplate = (options)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: `${options.className} flex justify-content-end`
        }, footerActions);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bKDGD.Panel), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        headerTemplate: headerTemplate,
        footerTemplate: footerActions && footerTemplate,
        "data-testid": testId,
        ...props
    });
};

});
parcelRegister("e6olx", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $a44482ed3cc95d8b$export$2e0a83ec2e27ecbb; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");
"use client";
var $a44482ed3cc95d8b$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, horizontal = _ref.horizontal, vertical = _ref.vertical;
        return (0, $7nrKB.classNames)("p-divider p-component p-divider-".concat(props.layout, " p-divider-").concat(props.type), {
            "p-divider-left": horizontal && (!props.align || props.align === "left"),
            "p-divider-right": horizontal && props.align === "right",
            "p-divider-center": horizontal && props.align === "center" || vertical && (!props.align || props.align === "center"),
            "p-divider-top": vertical && props.align === "top",
            "p-divider-bottom": vertical && props.align === "bottom"
        }, props.className);
    },
    content: "p-divider-content"
};
var $a44482ed3cc95d8b$var$styles = '\n@layer primereact {\n    .p-divider-horizontal {\n        display: flex;\n        width: 100%;\n        position: relative;\n        align-items: center;\n    }\n    \n    .p-divider-horizontal:before {\n        position: absolute;\n        display: block;\n        top: 50%;\n        left: 0;\n        width: 100%;\n        content: "";\n    }\n    \n    .p-divider-horizontal.p-divider-left {\n        justify-content: flex-start;\n    }\n    \n    .p-divider-horizontal.p-divider-right {\n        justify-content: flex-end;\n    }\n    \n    .p-divider-horizontal.p-divider-center {\n        justify-content: center;\n    }\n    \n    .p-divider-content {\n        z-index: 1;\n    }\n    \n    .p-divider-vertical {\n        min-height: 100%;\n        margin: 0 1rem;\n        display: flex;\n        position: relative;\n        justify-content: center;\n    }\n    \n    .p-divider-vertical:before {\n        position: absolute;\n        display: block;\n        top: 0;\n        left: 50%;\n        height: 100%;\n        content: "";\n    }\n    \n    .p-divider-vertical.p-divider-top {\n        align-items: flex-start;\n    }\n    \n    .p-divider-vertical.p-divider-center {\n        align-items: center;\n    }\n    \n    .p-divider-vertical.p-divider-bottom {\n        align-items: flex-end;\n    }\n    \n    .p-divider-solid.p-divider-horizontal:before {\n        border-top-style: solid;\n    }\n    \n    .p-divider-solid.p-divider-vertical:before {\n        border-left-style: solid;\n    }\n    \n    .p-divider-dashed.p-divider-horizontal:before {\n        border-top-style: dashed;\n    }\n    \n    .p-divider-dashed.p-divider-vertical:before {\n        border-left-style: dashed;\n    }\n    \n    .p-divider-dotted.p-divider-horizontal:before {\n        border-top-style: dotted;\n    }\n    \n    .p-divider-dotted.p-divider-horizontal:before {\n        border-left-style: dotted;\n    }\n}\n';
var $a44482ed3cc95d8b$var$inlineStyles = {
    root: function root(_ref2) {
        var props = _ref2.props;
        return {
            justifyContent: props.layout === "horizontal" ? props.align === "center" || props.align === null ? "center" : props.align === "left" ? "flex-start" : props.align === "right" ? "flex-end" : null : null,
            alignItems: props.layout === "vertical" ? props.align === "center" || props.align === null ? "center" : props.align === "top" ? "flex-start" : props.align === "bottom" ? "flex-end" : null : null
        };
    }
};
var $a44482ed3cc95d8b$var$DividerBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Divider",
        align: null,
        layout: "horizontal",
        type: "solid",
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $a44482ed3cc95d8b$var$classes,
        styles: $a44482ed3cc95d8b$var$styles,
        inlineStyles: $a44482ed3cc95d8b$var$inlineStyles
    }
});
var $a44482ed3cc95d8b$export$2e0a83ec2e27ecbb = /*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $a44482ed3cc95d8b$var$DividerBase.getProps(inProps, context);
    var _DividerBase$setMetaD = $a44482ed3cc95d8b$var$DividerBase.setMetaData({
        props: props
    }), ptm = _DividerBase$setMetaD.ptm, cx = _DividerBase$setMetaD.cx, sx = _DividerBase$setMetaD.sx, isUnstyled = _DividerBase$setMetaD.isUnstyled;
    (0, $kHEnT.useHandleStyle)($a44482ed3cc95d8b$var$DividerBase.css.styles, isUnstyled, {
        name: "divider"
    });
    var elementRef = $7E7Dk.useRef(null);
    var horizontal = props.layout === "horizontal";
    var vertical = props.layout === "vertical";
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        style: sx("root"),
        className: cx("root", {
            horizontal: horizontal,
            vertical: vertical
        }),
        "aria-orientation": props.layout,
        role: "separator"
    }, $a44482ed3cc95d8b$var$DividerBase.getOtherProps(props), ptm("root"));
    var contentProps = mergeProps({
        className: cx("content")
    }, ptm("content"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, props.children));
});
$a44482ed3cc95d8b$export$2e0a83ec2e27ecbb.displayName = "Divider";

});



parcelRegister("h9iNZ", function(module, exports) {

$parcel$export(module.exports, "getProductName", function () { return $27a16a5b25f4eb37$export$aa3f36fe5dd1f237; });
$parcel$export(module.exports, "getShortProductName", function () { return $27a16a5b25f4eb37$export$7c0de4f0f2c99e6e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $igvrl = parcelRequire("igvrl");

var $4qITT = parcelRequire("4qITT");
const $27a16a5b25f4eb37$export$aa3f36fe5dd1f237 = (productId, formatted = true)=>{
    if (!productId) return "";
    const id = Number(productId);
    if (id === (0, $4qITT.MeasurementDeviceProducts).AmpGuard) return "Charge Amps Amp Guard";
    if (id === (0, $4qITT.MeasurementDeviceProducts).AmpGuard2) return "Charge Amps Amp Guard 2";
    if (id === (0, $4qITT.MeasurementDeviceProducts).Enegic) return "Perific";
    const chargerProduct = (0, $4qITT.getChargerProductDefinition)(id);
    if (chargerProduct) return formatted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: chargerProduct.translationKey
    }) : chargerProduct.brandedName;
    return "";
};
const $27a16a5b25f4eb37$export$7c0de4f0f2c99e6e = (productId)=>{
    switch(productId){
        case (0, $4qITT.MeasurementDeviceProducts).AmpGuard:
            return "AG1";
        case (0, $4qITT.MeasurementDeviceProducts).AmpGuard2:
            return "AG2";
        case (0, $4qITT.MeasurementDeviceProducts).Enegic:
            return "PRFC";
        default:
            return "";
    }
};

});

parcelRegister("sVPXf", function(module, exports) {

$parcel$export(module.exports, "ocppChargerDefaultValues", function () { return $99c4eae1e155d8a6$export$dcd7037d16923c21; });
$parcel$export(module.exports, "useInstallationWizardValidationSchema", function () { return $99c4eae1e155d8a6$export$35dba9556216d26; });
$parcel$export(module.exports, "useOcppFormValidationSchema", function () { return $99c4eae1e155d8a6$export$942a78f3591b0dc8; });
$parcel$export(module.exports, "useOcppUserCurrentValidation", function () { return $99c4eae1e155d8a6$export$4c4b3000fe3e418a; });
$parcel$export(module.exports, "default", function () { return $99c4eae1e155d8a6$export$2e2bcd8739ae039; });

var $l6tdd = parcelRequire("l6tdd");

var $cCnqE = parcelRequire("cCnqE");
parcelRequire("7FGDK");
var $bTUek = parcelRequire("bTUek");
var $Gcg6o = parcelRequire("Gcg6o");
var $jpUpC = parcelRequire("jpUpC");

var $4gSsL = parcelRequire("4gSsL");

var $1hIPE = parcelRequire("1hIPE");

var $3T1QU = parcelRequire("3T1QU");

var $c4hCO = parcelRequire("c4hCO");

var $btwIF = parcelRequire("btwIF");

var $e3A9f = parcelRequire("e3A9f");

var $5u6k9 = parcelRequire("5u6k9");
const $99c4eae1e155d8a6$export$dcd7037d16923c21 = (chargePoint)=>{
    let retVal = {
        name: chargePoint.name,
        earthingSystem: (0, $e3A9f.getSupportedEarthingSystem)(chargePoint),
        supplyCurrent: chargePoint.supplyCurrent,
        connectorPhaseRotation: chargePoint.connectorPhaseRotation,
        installationPhases: (0, $btwIF.default)(chargePoint.connectors?.at(0))
    };
    chargePoint.connectors?.forEach((connector)=>{
        retVal = {
            ...retVal,
            [`installationPhaseMode_${connector.connectorId}`]: connector.installationPhaseMode,
            [`installationPhase_${connector.connectorId}`]: connector.installationPhase,
            [`ic_${connector.connectorId}`]: connector.installationCurrent,
            [`uc_${connector.connectorId}`]: connector.userCurrent,
            [`lbc_${connector.connectorId}`]: connector.loadBalancerOfflineCurrent,
            [`lbOfflinePhase_${connector.connectorId}`]: connector.loadBalancerOfflinePhase,
            [`externalId_${connector.connectorId}`]: connector.externalId
        };
    });
    return retVal;
};
const $99c4eae1e155d8a6$var$inputTransformation = (value)=>{
    return !value || isNaN(value) ? 0 : value;
};
const $99c4eae1e155d8a6$var$useSupplyCurrentValidationSchema = ()=>{
    const text = (0, $5u6k9.default)();
    return (factoryCurrent)=>$bTUek.create().positive().integer().required(text("msgSupplyCurrentRequired")).test("more-than-maxCurrent", function(value) {
            if (factoryCurrent && value && value > factoryCurrent) return this.createError({
                path: this.path,
                message: text("msgSupplyCurrentMoreThanMaxCurrent", {
                    factoryCurrent: factoryCurrent
                })
            });
            return true;
        }).min((0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("msgValueCannotBeBelowChargerMinCurrent", {
            minCurrent: (0, $3T1QU.CHARGEPOINT_MIN_CURRENT)
        })).transform($99c4eae1e155d8a6$var$inputTransformation);
};
const $99c4eae1e155d8a6$var$useInstallationCurrentValidationSchema = ()=>{
    const text = (0, $5u6k9.default)();
    return (chargePoint, connectorId)=>$bTUek.create().positive().integer().required(text("msgInstallationCurrentRequired")).min(chargePoint.connectors?.find((connector)=>connector?.connectorId === connectorId)?.minCurrent ?? (0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("msgInstallationCurrentLimitLowerThanMin")).test("less-than-maxCurrent", function(value, form) {
            const factoryCurrent = chargePoint.connectors?.find((connector)=>connector?.connectorId === connectorId)?.factoryCurrent;
            const maxCurrent = (0, $3T1QU.getInstallationCurrentLimit)(form.parent.supplyCurrent, factoryCurrent);
            if (value !== undefined && value > maxCurrent) return this.createError({
                path: this.path,
                message: text("msgInstallationCurrentMoreThanConnectorMaxCurrent", {
                    maxCurrent: maxCurrent
                })
            });
            return true;
        }).test("more-than-user-current", text("msgInstallationCurrentLessThanUserCurrent"), function(value, form) {
            const ucVal = form.parent[`uc_${connectorId}`];
            if (!ucVal || isNaN(ucVal)) return true;
            return value === undefined || ucVal <= value;
        }).transform((value)=>isNaN(value) ? undefined : value);
};
const $99c4eae1e155d8a6$var$useLoadbalancerOfflineCurrentValidationSchema = ()=>{
    const text = (0, $5u6k9.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    return (chargePoint, connectorId, connectorName, minCurrent)=>$bTUek.create().required(text("msgLBOfflineCurrent")).min(chargePoint.connectors?.find((connector)=>connector?.connectorId === connectorId)?.minCurrent ?? (0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("lblInstallationCurrentOfflineValidation", {
            connectorType: adaptConnectorNaming(connectorName ?? ""),
            minCurrent: minCurrent
        })).transform((value)=>isNaN(value) ? undefined : value).test("less-than-installation-current", function(value, form) {
            if (value !== undefined && form.parent[`ic_${connectorId}`] < value) return this.createError({
                path: this.path,
                message: text("lblInstallationCurrentOfflineValidationMax", {
                    connectorType: connectorName ? adaptConnectorNaming(connectorName) : "",
                    installationCurrent: form.parent[`ic_${connectorId}`]
                })
            });
            return true;
        });
};
const $99c4eae1e155d8a6$var$useLoadbalancerOfflinePhaseSchema = ()=>{
    const text = (0, $5u6k9.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    return (connectorName)=>$jpUpC.create().required(text("lblLoadBalancerOfflinePhaseValidationConnector", {
            name: adaptConnectorNaming(connectorName ?? "")
        }));
};
const $99c4eae1e155d8a6$var$useUserCurrentValidationSchema = ()=>{
    const text = (0, $5u6k9.default)();
    return (chargePoint, connectorId)=>$bTUek.create().test("lower-than-min-not-zero", function(value) {
            const minValue = chargePoint.connectors?.find((connector)=>connector?.connectorId === connectorId)?.minCurrent ?? (0, $3T1QU.CHARGEPOINT_MIN_CURRENT);
            if (value && value < minValue && value !== 0) return this.createError({
                path: this.path,
                message: text("msgUserCurrentLimitLowerThanMin")
            });
            return true;
        }).test("less-than-user-current", function(value, form) {
            const maxCurrent = form.parent[`ic_${connectorId}`];
            if (value && maxCurrent < value) return this.createError({
                path: this.path,
                message: text("msgUserCurrentMoreThanInstallationCurrent")
            });
            return true;
        }).transform((value)=>isNaN(value) ? undefined : value).nullable().optional();
};
const $99c4eae1e155d8a6$export$35dba9556216d26 = ()=>{
    const text = (0, $5u6k9.default)();
    const supplyCurrentValidationSchema = $99c4eae1e155d8a6$var$useSupplyCurrentValidationSchema();
    const userCurrentValidationSchema = $99c4eae1e155d8a6$var$useUserCurrentValidationSchema();
    const installationCurrentValidationSchema = $99c4eae1e155d8a6$var$useInstallationCurrentValidationSchema();
    const loadbalancerOfflineCurrentValidationSchema = $99c4eae1e155d8a6$var$useLoadbalancerOfflineCurrentValidationSchema();
    const loadbalancerOfflinePhaseValidationSchema = $99c4eae1e155d8a6$var$useLoadbalancerOfflinePhaseSchema();
    return (chargePoint)=>{
        const factoryCurrent = chargePoint.factoryCurrent;
        return $Gcg6o.create({
            name: $jpUpC.create().required().max((0, $c4hCO.MAX_NAME_LENGTH), text("lblNameError")),
            supplyCurrent: supplyCurrentValidationSchema(factoryCurrent),
            ic_1: installationCurrentValidationSchema(chargePoint, 1),
            uc_1: userCurrentValidationSchema(chargePoint, 1),
            ...(0, $1hIPE.default)(chargePoint) && {
                ic_2: installationCurrentValidationSchema(chargePoint, 2),
                uc_2: userCurrentValidationSchema(chargePoint, 2)
            },
            ...chargePoint.loadBalancerGroupId && chargePoint.connectors && {
                lbc_1: loadbalancerOfflineCurrentValidationSchema(chargePoint, 1, chargePoint.connectors[0]?.name ?? "", chargePoint.connectors[0]?.minCurrent ?? 0),
                lbOfflinePhase_1: loadbalancerOfflinePhaseValidationSchema(chargePoint.connectors[0]?.name),
                ...(0, $1hIPE.default)(chargePoint) && {
                    lbc_2: loadbalancerOfflineCurrentValidationSchema(chargePoint, 2, chargePoint.connectors[1]?.name ?? "", chargePoint.connectors[1]?.minCurrent ?? 0),
                    lbOfflinePhase_2: loadbalancerOfflinePhaseValidationSchema(chargePoint.connectors[1]?.name)
                }
            }
        }).required();
    };
};
const $99c4eae1e155d8a6$export$942a78f3591b0dc8 = ()=>{
    const supplyCurrentValidationSchema = $99c4eae1e155d8a6$var$useSupplyCurrentValidationSchema();
    const userCurrentValidationSchema = $99c4eae1e155d8a6$var$useUserCurrentValidationSchema();
    const installationCurrentValidationSchema = $99c4eae1e155d8a6$var$useInstallationCurrentValidationSchema();
    const loadbalancerOfflineCurrentValidationSchema = $99c4eae1e155d8a6$var$useLoadbalancerOfflineCurrentValidationSchema();
    const loadbalancerOfflinePhaseValidationSchema = $99c4eae1e155d8a6$var$useLoadbalancerOfflinePhaseSchema();
    const text = (0, $5u6k9.default)();
    return (chargePoint)=>{
        const factoryCurrent = chargePoint.factoryCurrent;
        return $Gcg6o.create({
            name: $jpUpC.create().required().max((0, $c4hCO.MAX_NAME_LENGTH), text("lblNameError")),
            supplyCurrent: supplyCurrentValidationSchema(factoryCurrent),
            ic_1: installationCurrentValidationSchema(chargePoint, 1),
            uc_1: userCurrentValidationSchema(chargePoint, 1),
            ...(0, $1hIPE.default)(chargePoint) && {
                ic_2: installationCurrentValidationSchema(chargePoint, 2),
                uc_2: userCurrentValidationSchema(chargePoint, 2)
            },
            ...chargePoint.loadBalancerGroupId && chargePoint.connectors && {
                lbc_1: loadbalancerOfflineCurrentValidationSchema(chargePoint, 1, chargePoint.connectors[0]?.name ?? "", chargePoint.connectors[0]?.minCurrent ?? 0),
                lbOfflinePhase_1: loadbalancerOfflinePhaseValidationSchema(chargePoint.connectors[0]?.name),
                ...(0, $1hIPE.default)(chargePoint) && {
                    lbc_2: loadbalancerOfflineCurrentValidationSchema(chargePoint, 2, chargePoint.connectors[1]?.name ?? "", chargePoint.connectors[1]?.minCurrent ?? 0),
                    lbOfflinePhase_2: loadbalancerOfflinePhaseValidationSchema(chargePoint.connectors[1]?.name)
                }
            }
        }).required();
    };
};
const $99c4eae1e155d8a6$var$formConfig = {
    mode: "onChange",
    reValidateMode: "onChange",
    delayError: 500
};
const $99c4eae1e155d8a6$var$useOcppFormValidation = (chargePoint)=>{
    const defaultValues = $99c4eae1e155d8a6$export$dcd7037d16923c21(chargePoint);
    const ocppFormValidationSchema = $99c4eae1e155d8a6$export$942a78f3591b0dc8();
    return (0, $cCnqE.useForm)({
        ...$99c4eae1e155d8a6$var$formConfig,
        defaultValues: defaultValues,
        resolver: (0, $l6tdd.yupResolver)(ocppFormValidationSchema(chargePoint))
    });
};
const $99c4eae1e155d8a6$export$4c4b3000fe3e418a = (chargePoint)=>{
    const userCurrentValidationSchema = $99c4eae1e155d8a6$var$useUserCurrentValidationSchema();
    const defaultValues = $99c4eae1e155d8a6$export$dcd7037d16923c21(chargePoint);
    const schema = $Gcg6o.create({
        uc_1: userCurrentValidationSchema(chargePoint, 1),
        ...(0, $1hIPE.default)(chargePoint) && {
            uc_2: userCurrentValidationSchema(chargePoint, 2)
        }
    }).required();
    return (0, $cCnqE.useForm)({
        mode: "onSubmit",
        reValidateMode: "onChange",
        delayError: 0,
        defaultValues: defaultValues,
        resolver: (0, $l6tdd.yupResolver)(schema)
    });
};
var $99c4eae1e155d8a6$export$2e2bcd8739ae039 = $99c4eae1e155d8a6$var$useOcppFormValidation;

});
parcelRegister("l6tdd", function(module, exports) {

$parcel$export(module.exports, "yupResolver", function () { return $f5d0d16d4a7e1f27$export$d55832dfcd4989a; });

var $exkac = parcelRequire("exkac");

var $cCnqE = parcelRequire("cCnqE");
function $f5d0d16d4a7e1f27$export$d55832dfcd4989a(o, n, a) {
    return void 0 === n && (n = {}), void 0 === a && (a = {}), function(s, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (n.context, Promise.resolve(o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $exkac.validateFieldsNatively)({}, c), {
                            values: a.raw ? s : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $exkac.toNestErrors)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, a = o && o[t.type];
                            e[t.path] = (0, $cCnqE.appendErrors)(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
}

});
parcelRegister("exkac", function(module, exports) {

$parcel$export(module.exports, "validateFieldsNatively", function () { return $a953c9cf90092ac1$export$6bd436d70894afff; });
$parcel$export(module.exports, "toNestErrors", function () { return $a953c9cf90092ac1$export$f0545b73a179e3a2; });

var $cCnqE = parcelRequire("cCnqE");
var $a953c9cf90092ac1$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $cCnqE.get)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $a953c9cf90092ac1$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $a953c9cf90092ac1$var$t(n.ref, i, r) : n.refs && n.refs.forEach(function(e) {
            return $a953c9cf90092ac1$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $a953c9cf90092ac1$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $a953c9cf90092ac1$export$6bd436d70894afff(t, n);
    var f = {};
    for(var a in t){
        var s = (0, $cCnqE.get)(n.fields, a), u = Object.assign(t[a] || {}, {
            ref: s && s.ref
        });
        if ($a953c9cf90092ac1$var$o(n.names || Object.keys(t), a)) {
            var c = Object.assign({}, (0, $cCnqE.get)(f, a));
            (0, $cCnqE.set)(c, "root", u), (0, $cCnqE.set)(f, a, c);
        } else (0, $cCnqE.set)(f, a, u);
    }
    return f;
}, $a953c9cf90092ac1$var$o = function(r, e) {
    return r.some(function(r) {
        return r.startsWith(e + ".");
    });
};

});


parcelRegister("btwIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b688e89f1d8c6d2$export$2e2bcd8739ae039; });
function $9b688e89f1d8c6d2$var$getInstallationPhases(connector) {
    return connector?.installationPhaseMode?.replace("P", "");
}
var $9b688e89f1d8c6d2$export$2e2bcd8739ae039 = $9b688e89f1d8c6d2$var$getInstallationPhases;

});


parcelRegister("6K6p8", function(module, exports) {

$parcel$export(module.exports, "capiChargerDefaultValues", function () { return $71aa935e027d45c7$export$39c8ad52f1b60b3; });
$parcel$export(module.exports, "useLoadbalancerOfflineCurrentSchema", function () { return $71aa935e027d45c7$export$5004c71c0d27267c; });
$parcel$export(module.exports, "useLoadbalancerOfflinePhaseSchema", function () { return $71aa935e027d45c7$export$3dd0612ea8b2c097; });
$parcel$export(module.exports, "useCapiFormValidationSchema", function () { return $71aa935e027d45c7$export$3954fce40553b302; });
$parcel$export(module.exports, "useCapiUserCurrentValidation", function () { return $71aa935e027d45c7$export$1cfe2995d9361241; });
$parcel$export(module.exports, "default", function () { return $71aa935e027d45c7$export$2e2bcd8739ae039; });

var $l6tdd = parcelRequire("l6tdd");

var $cCnqE = parcelRequire("cCnqE");
parcelRequire("7FGDK");
var $bTUek = parcelRequire("bTUek");
var $Gcg6o = parcelRequire("Gcg6o");
var $jpUpC = parcelRequire("jpUpC");

var $4gSsL = parcelRequire("4gSsL");

var $4LjKQ = parcelRequire("4LjKQ");

var $1hIPE = parcelRequire("1hIPE");

var $3T1QU = parcelRequire("3T1QU");

var $c4hCO = parcelRequire("c4hCO");

var $5u6k9 = parcelRequire("5u6k9");
const $71aa935e027d45c7$export$39c8ad52f1b60b3 = (chargePoint)=>{
    let retVal = {
        name: chargePoint.name,
        nfcEnabled: chargePoint.nfcEnabled ?? false,
        supplyCurrent: chargePoint.supplyCurrent
    };
    chargePoint.connectors?.forEach((connector)=>{
        retVal = {
            ...retVal,
            [`connectorType_${connector.connectorId}`]: connector.connectorType,
            [`installationPhaseMode_${connector.connectorId}`]: connector.installationPhaseMode,
            [`installationPhase_${connector.connectorId}`]: connector.installationPhase,
            [`ic_${connector.connectorId}`]: connector.installationCurrent,
            [`uc_${connector.connectorId}`]: connector.userCurrent,
            [`lbc_${connector.connectorId}`]: connector.loadBalancerOfflineCurrent,
            [`lbOfflinePhase_${connector.connectorId}`]: connector.loadBalancerOfflinePhase
        };
    });
    return retVal;
};
const $71aa935e027d45c7$var$useUserCurrentValidationSchema = ()=>{
    const text = (0, $5u6k9.default)();
    return (chargePoint, connectorId, defaultValues)=>$bTUek.create().min(chargePoint.connectors?.find((connector)=>connector.connectorId === connectorId)?.minCurrent ?? (0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("msgUserCurrentLimitLowerThanMin")).test("less-than-installation-current", text("msgUserCurrentMoreThanInstallationCurrent"), function(value, form) {
            if (!value || isNaN(value)) return true;
            const maxValKey = `ic_${connectorId}`;
            const maxVal = form.parent[maxValKey] ? form.parent[maxValKey] : defaultValues[maxValKey];
            return value <= maxVal;
        }).transform((value)=>isNaN(value) ? undefined : value).nullable().optional();
};
const $71aa935e027d45c7$export$5004c71c0d27267c = ()=>{
    const text = (0, $5u6k9.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    return (connectorId, connectorName, minCurrent = (0, $3T1QU.CHARGEPOINT_MIN_CURRENT))=>$bTUek.create().required(text("msgLBOfflineCurrent")).min((0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("lblInstallationCurrentOfflineValidation", {
            connectorType: adaptConnectorNaming(connectorName ?? ""),
            minCurrent: minCurrent
        })).transform((value)=>isNaN(value) ? undefined : value).test("less-than-installation-current", function(value, form) {
            if (value) {
                if (form.parent[`ic_${connectorId}`] < value) return this.createError({
                    path: this.path,
                    message: text("lblInstallationCurrentOfflineValidationMax", {
                        connectorType: adaptConnectorNaming(connectorName),
                        installationCurrent: form.parent[`ic_${connectorId}`]
                    })
                });
            }
            return true;
        });
};
const $71aa935e027d45c7$export$3dd0612ea8b2c097 = ()=>{
    const text = (0, $5u6k9.default)();
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    return (connectorName)=>$jpUpC.create().required(text("lblLoadBalancerOfflinePhaseValidationConnector", {
            name: adaptConnectorNaming(connectorName ?? "")
        }));
};
const $71aa935e027d45c7$export$3954fce40553b302 = ()=>{
    const text = (0, $5u6k9.default)();
    const userCurrentValidationSchema = $71aa935e027d45c7$var$useUserCurrentValidationSchema();
    const loadbalancerOfflinePhaseSchema = $71aa935e027d45c7$export$3dd0612ea8b2c097();
    const loadbalancerOfflineCurrentSchema = $71aa935e027d45c7$export$5004c71c0d27267c();
    return (chargePoint, defaultValues)=>{
        const allConnectorsMaxCurrent = chargePoint.connectors?.filter((0, $4LjKQ.isChargingConnector)).reduce((acc, curr)=>acc + Number(curr.factoryCurrent), 0);
        const capiDefaultValues = defaultValues ?? $71aa935e027d45c7$export$39c8ad52f1b60b3(chargePoint);
        const supplyCurrentValidationFactory = ()=>$bTUek.create().positive().integer().required(text("msgSupplyCurrentRequired")).max(allConnectorsMaxCurrent, text("msgSupplyCurrentMoreThanMaxCurrent", {
                factoryCurrent: allConnectorsMaxCurrent
            })).min((0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("msgValueCannotBeBelowChargerMinCurrent", {
                minCurrent: (0, $3T1QU.CHARGEPOINT_MIN_CURRENT)
            })).transform((value)=>isNaN(value) ? undefined : value);
        const installationCurrentValidationFactory = (connectorId)=>$bTUek.create().positive().integer().required(text("msgInstallationCurrentRequired")).min(chargePoint.connectors?.find((connector)=>connector.connectorId === connectorId)?.minCurrent ?? (0, $3T1QU.CHARGEPOINT_MIN_CURRENT), text("msgInstallationCurrentLimitLowerThanMin")).test("less-than-maxCurrent", function(value, form) {
                const factoryCurrent = chargePoint.connectors?.find((connector)=>connector?.connectorId === connectorId)?.factoryCurrent;
                const maxCurrent = (0, $3T1QU.getInstallationCurrentLimit)(form.parent.supplyCurrent, factoryCurrent);
                if (value > maxCurrent) return this.createError({
                    path: this.path,
                    message: text("msgInstallationCurrentMoreThanConnectorMaxCurrent", {
                        maxCurrent: maxCurrent
                    })
                });
                return true;
            }).transform((value)=>isNaN(value) ? undefined : value);
        return $Gcg6o.create({
            name: $jpUpC.create().required().max((0, $c4hCO.MAX_NAME_LENGTH), text("lblNameError")),
            supplyCurrent: supplyCurrentValidationFactory(),
            ic_1: installationCurrentValidationFactory(1),
            uc_1: userCurrentValidationSchema(chargePoint, 1, capiDefaultValues),
            ...(0, $1hIPE.default)(chargePoint) && {
                ic_2: installationCurrentValidationFactory(2),
                uc_2: userCurrentValidationSchema(chargePoint, 2, capiDefaultValues)
            },
            ...chargePoint.loadBalancerGroupId && chargePoint.connectors && {
                lbc_1: loadbalancerOfflineCurrentSchema(1, chargePoint.connectors[0]?.name ?? "", chargePoint.connectors?.find((connector)=>connector.connectorId === 1)?.minCurrent),
                lbOfflinePhase_1: loadbalancerOfflinePhaseSchema(chargePoint.connectors[0]?.name),
                ...(0, $1hIPE.default)(chargePoint) && {
                    lbc_2: loadbalancerOfflineCurrentSchema(2, chargePoint.connectors[1]?.name ?? "", chargePoint.connectors?.find((connector)=>connector.connectorId === 2)?.minCurrent),
                    lbOfflinePhase_2: loadbalancerOfflinePhaseSchema(chargePoint.connectors[1]?.name)
                }
            }
        }).required();
    };
};
const $71aa935e027d45c7$var$useCapiFormValidation = (chargePoint)=>{
    const defaultValues = $71aa935e027d45c7$export$39c8ad52f1b60b3(chargePoint);
    const capiValidationSchema = $71aa935e027d45c7$export$3954fce40553b302();
    return $71aa935e027d45c7$var$useCreateForm(capiValidationSchema(chargePoint, defaultValues), defaultValues, chargePoint);
};
const $71aa935e027d45c7$export$1cfe2995d9361241 = (chargePoint)=>{
    const defaultValues = $71aa935e027d45c7$export$39c8ad52f1b60b3(chargePoint);
    const userCurrentValidationSchema = $71aa935e027d45c7$var$useUserCurrentValidationSchema();
    const schema = $Gcg6o.create({
        uc_1: userCurrentValidationSchema(chargePoint, 1, defaultValues),
        ...(0, $1hIPE.default)(chargePoint) && {
            uc_2: userCurrentValidationSchema(chargePoint, 2, defaultValues)
        }
    }).required();
    return $71aa935e027d45c7$var$useCreateForm(schema, defaultValues, chargePoint, "onSubmit");
};
const $71aa935e027d45c7$var$useCreateForm = (validationSchema, defaultValues, chargePoint, mode = "onChange")=>(0, $cCnqE.useForm)({
        mode: mode,
        reValidateMode: "onChange",
        delayError: 500,
        defaultValues: {
            ...defaultValues,
            lbOfflinePhase_1: chargePoint.connectors && chargePoint.connectors[0].loadBalancerOfflinePhase ? chargePoint.connectors[0].loadBalancerOfflinePhase : "L1",
            lbOfflinePhase_2: chargePoint.connectors && chargePoint.connectors[0].loadBalancerOfflinePhase ? chargePoint.connectors[0].loadBalancerOfflinePhase : "L1"
        },
        resolver: (0, $l6tdd.yupResolver)(validationSchema)
    });
var $71aa935e027d45c7$export$2e2bcd8739ae039 = $71aa935e027d45c7$var$useCapiFormValidation;

});

parcelRegister("26yAo", function(module, exports) {
$parcel$export(module.exports, "PageLayoutContainer", function () { return (parcelRequire("lUaaI")).PageLayoutContainer; });
parcelRequire("lUaaI");

});
parcelRegister("lUaaI", function(module, exports) {

$parcel$export(module.exports, "PageLayoutContainer", function () { return $c8a8e1ca7862574f$export$17d53907ac066cc3; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
const $c8a8e1ca7862574f$var$Wrapper = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    padding: 15px 60px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;
    width: 100%;
    max-width: 1400px;

    @media (max-width: 990px) {
        padding: 15px 20px;
    }
`;
const $c8a8e1ca7862574f$export$17d53907ac066cc3 = /*#__PURE__*/ (0, $7E7Dk.memo)(function PageLayoutContainer({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($c8a8e1ca7862574f$var$Wrapper, props, children);
});

});


parcelRegister("j1D7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e48860f591c07492$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
parcelRequire("3RqY6");
var $ickdp = parcelRequire("ickdp");

var $5u6k9 = parcelRequire("5u6k9");
const $e48860f591c07492$var$SLinkButtonContainer = (0, $gRonV.default).div`
    margin-top: 0.7em;
    display: flex;
`;
const $e48860f591c07492$var$SLink = (0, $gRonV.default)((0, $3um4r.Link))`
    & {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: underline;
        font-size: 16px;
        line-height: 30px;
        margin-left: 0.5em;
        align-self: end;
    }

    &:hover {
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $e48860f591c07492$var$LinkButton = ({ titleCode: titleCode, href: href, dataTestId: dataTestId })=>{
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e48860f591c07492$var$SLinkButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ickdp.GoToIcon), {
        style: {
            alignSelf: "center"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e48860f591c07492$var$SLink, {
        to: href,
        target: "_blank",
        "data-testid": dataTestId
    }, text(titleCode)));
};
var $e48860f591c07492$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($e48860f591c07492$var$LinkButton);

});
parcelRegister("3RqY6", function(module, exports) {
$parcel$export(module.exports, "GoToIcon", function () { return (parcelRequire("ickdp")).GoToIcon; });
parcelRequire("ickdp");

});
parcelRegister("ickdp", function(module, exports) {

$parcel$export(module.exports, "GoToIcon", function () { return $3c71a2825811a2ee$export$e11e67653b795d6b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $3c71a2825811a2ee$export$e11e67653b795d6b({ className: className, style: style, size: size = 22, color: color = "#000" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "goToIcon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#clip0_2453_18296)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.3128 18.3378L3.66218 18.3211V3.66218H9.32529V2H3.67889C2.75174 2 2 2.75174 2 3.67889V18.3211C2 19.2483 2.75174 20 3.67889 20H18.3211C19.2483 20 20 19.2483 20 18.3211V12.6664H18.3211V18.3295L18.3128 18.3378ZM14.4783 6.18184L9.75336 10.9068L10.9346 12.0881L15.6596 7.36308L14.4783 6.18184ZM18.3211 5.34107C18.3295 4.45568 17.5527 3.67889 16.659 3.67889H13.8107L12.1318 2H16.659C17.5443 2 18.3963 2.34246 19.0228 2.97726C19.6492 3.61206 20 4.44733 20 5.34107V9.86821L18.3211 8.18933V5.34107Z",
        fill: color
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("clipPath", {
        id: "clip0_2453_18296"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("rect", {
        width: "18",
        height: "18",
        fill: "white",
        transform: "translate(2 2)"
    }))));
}

});



parcelRegister("1HK60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91b31120f1fe23fc$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");
parcelRequire("hyFRo");
var $gRg4a = parcelRequire("gRg4a");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $hhoFb = parcelRequire("hhoFb");
const $91b31120f1fe23fc$var$SArrowIcon = (0, $gRonV.default)((0, $gRg4a.ArrowIcon))`
    z-index: 1;
    transform: rotate(${({ flipped: flipped })=>flipped ? 0 : "180deg"});
    transition: transform 0.2s ease-in;
`;
const $91b31120f1fe23fc$var$Chevron = ({ color: color, flipped: flipped, size: size = 14, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        onClick: onClick,
        "data-testid": "chevron",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($91b31120f1fe23fc$var$SArrowIcon, {
        flipped: !flipped,
        color: color ?? (0, $3CLIQ.theme).brandColors.CA_Black
    }));
};
var $91b31120f1fe23fc$export$2e2bcd8739ae039 = $91b31120f1fe23fc$var$Chevron;

});

parcelRegister("iEUKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8af0fa47df68ff$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $lSvU6 = parcelRequire("lSvU6");

var $cDXvQ = parcelRequire("cDXvQ");
const $3d8af0fa47df68ff$var$PartnerInfoCard = ({ name: name, email: email, phone: phone })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lSvU6.default), {
        dataTestId: "title-text-field-provider-name",
        titleCode: "lblProvider",
        text: name ?? "-"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cDXvQ.default), {
        dataTestId: "title-text-field-contact-email",
        titleCode: "lblContactEmail",
        text: email ?? "-",
        href: `mailto:${email}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lSvU6.default), {
        dataTestId: "title-text-field-contact-phone",
        titleCode: "lblContactNumberField",
        text: phone ?? "-"
    }));
};
var $3d8af0fa47df68ff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($3d8af0fa47df68ff$var$PartnerInfoCard);

});
parcelRegister("lSvU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fbe04fae2e11c3a$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $igvrl = parcelRequire("igvrl");
const $4fbe04fae2e11c3a$var$SInfoField = (0, $gRonV.default).label`
    font-size: 21px;
    line-height: 28px;
    display: block;
`;
const $4fbe04fae2e11c3a$var$TitleTextField = ({ titleCode: titleCode, text: text, dataTestId: dataTestId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: titleCode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($4fbe04fae2e11c3a$var$SInfoField, {
        "data-testid": `${dataTestId}-text`
    }, text));
};
var $4fbe04fae2e11c3a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($4fbe04fae2e11c3a$var$TitleTextField);

});

parcelRegister("cDXvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b4a1048a358c9a3$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $igvrl = parcelRequire("igvrl");
const $3b4a1048a358c9a3$var$SLink = (0, $gRonV.default).a`
    & {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        font-size: 21px;
        line-height: 28px;
        display: block;
        display: block;
    }

    &:hover {
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $3b4a1048a358c9a3$var$TitleLinkField = ({ titleCode: titleCode, text: text, dataTestId: dataTestId, href: href })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: titleCode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($3b4a1048a358c9a3$var$SLink, {
        href: href,
        target: "_blank",
        "data-testid": dataTestId
    }, text));
};
var $3b4a1048a358c9a3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7E7Dk.memo)($3b4a1048a358c9a3$var$TitleLinkField);

});


parcelRegister("51TcK", function(module, exports) {
$parcel$export(module.exports, "LoadBalancerStatistics", function () { return (parcelRequire("NBDt7")).LoadBalancerStatistics; });
$parcel$export(module.exports, "SNoAvailableDataAlert", function () { return (parcelRequire("NBDt7")).SNoAvailableDataAlert; });
parcelRequire("NBDt7");

});
parcelRegister("NBDt7", function(module, exports) {

$parcel$export(module.exports, "SNoAvailableDataAlert", function () { return $e713f1e26c1a04ca$export$f3873ea90e60bbe2; });
$parcel$export(module.exports, "LoadBalancerStatistics", function () { return $e713f1e26c1a04ca$export$6ec061ec2b016eb0; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $igvrl = parcelRequire("igvrl");
parcelRequire("2quSP");
var $bnffI = parcelRequire("bnffI");

var $1O9Jh = parcelRequire("1O9Jh");

var $hJiTg = parcelRequire("hJiTg");

var $5u6k9 = parcelRequire("5u6k9");
const $e713f1e26c1a04ca$export$87affdc2a9ef8697 = (0, $gRonV.default).div`
    font-size: 14px;
    text-align: center;
    padding: 10px 0;
`;
const $e713f1e26c1a04ca$export$f3873ea90e60bbe2 = (0, $gRonV.default).div`
    text-align: center;
    font-size: 14px;
    padding: 25px 15px 35px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
`;
function $e713f1e26c1a04ca$export$6ec061ec2b016eb0(props) {
    const text = (0, $5u6k9.default)();
    const { graphTitle: graphTitle = text("lblCurrentConsumption"), device: device, className: className, style: style } = props;
    const { data: snapShotData = [], isFetching: snapshotDataIsFetching } = (0, $1O9Jh.useLoadBalancerGroupGetSnapshotByDeviceIdQuery)({
        measurementDeviceId: device?.id ?? 0
    }, {
        skip: !device?.id
    });
    const chartData = (0, $7E7Dk.useMemo)(()=>{
        const measured1 = [];
        const measured2 = [];
        const measured3 = [];
        const charging1 = [];
        const charging2 = [];
        const charging3 = [];
        const maxCurrentDataset = [];
        const supplyMaxCurrent = device?.loadBalancerGroupSupplyMaxCurrent ?? NaN;
        if (snapShotData && snapShotData.length > 0) for (const item of snapShotData){
            const x = new Date(item.timestamp).getTime();
            measured1.push({
                y: item.measurementCurrent1 ?? NaN,
                x: x
            });
            measured2.push({
                y: item.measurementCurrent2 ?? NaN,
                x: x
            });
            measured3.push({
                y: item.measurementCurrent3 ?? NaN,
                x: x
            });
            charging1.push({
                y: item.chargingCurrent1 ?? NaN,
                x: x
            });
            charging2.push({
                y: item.chargingCurrent2 ?? NaN,
                x: x
            });
            charging3.push({
                y: item.chargingCurrent3 ?? NaN,
                x: x
            });
            maxCurrentDataset.push({
                y: supplyMaxCurrent ?? NaN,
                x: x
            });
        }
        const datasets = [
            {
                label: `L1 ${text("lblConnectorChargingStatus")}`,
                data: charging1
            },
            {
                label: `L2 ${text("lblConnectorChargingStatus")}`,
                data: charging2
            },
            {
                label: `L3 ${text("lblConnectorChargingStatus")}`,
                data: charging3
            },
            {
                label: `L1 ${text("lblMeasured")}`,
                data: measured1
            },
            {
                label: `L2 ${text("lblMeasured")}`,
                data: measured2
            },
            {
                label: `L3 ${text("lblMeasured")}`,
                data: measured3
            },
            {
                label: text("lblSupplyMaxCurrent"),
                data: maxCurrentDataset
            }
        ];
        return {
            datasets: datasets
        };
    }, [
        device?.loadBalancerGroupSupplyMaxCurrent,
        snapShotData
    ]);
    const hasData = snapShotData && snapShotData.length > 0;
    const renderContent = ()=>{
        if (snapshotDataIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "shimmer-container shimmer-small"
        });
        return hasData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e713f1e26c1a04ca$export$87affdc2a9ef8697, {
            "data-testid": "title-loadbalancer"
        }, graphTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hJiTg.LineChart), {
            yAxisLabel: text("lblCurrentAxis"),
            xAxisLabel: text("lblTime"),
            data: chartData,
            enableZoomShortcuts: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e713f1e26c1a04ca$export$f3873ea90e60bbe2, {
            "data-testid": "no-data-loadbalancer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgNoAvailableData"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bnffI.ConsumptionWidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: text("lblLBStatisticsForAWeek"),
        dataTestId: "loadbalancer"
    }, renderContent());
}

});
parcelRegister("2quSP", function(module, exports) {
$parcel$export(module.exports, "ConsumptionWidgetLayout", function () { return (parcelRequire("bnffI")).ConsumptionWidgetLayout; });
parcelRequire("bnffI");

});
parcelRegister("bnffI", function(module, exports) {

$parcel$export(module.exports, "ConsumptionWidgetLayout", function () { return $0622e8f1057e703f$export$f71f8ebb84ff74d7; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
parcelRequire("2nOeJ");
var $bJ69a = parcelRequire("bJ69a");
function $0622e8f1057e703f$export$f71f8ebb84ff74d7({ loadingStatus: loadingStatus, title: title, children: children, className: className, style: style, dataTestId: dataTestId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bJ69a.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": "widget-" + dataTestId,
        title: title,
        isLoading: loadingStatus
    }, children);
}

});


parcelRegister("hJiTg", function(module, exports) {

$parcel$export(module.exports, "LineChart", function () { return $ad33b507c08dfeb7$export$54d0e8420ac838ac; });
parcelRequire("h0Ico");

var $fN2cW = parcelRequire("fN2cW");

var $cpJpP = parcelRequire("cpJpP");

var $i2nlv = parcelRequire("i2nlv");
var $lhFGA = parcelRequire("lhFGA");

var $12XdK = parcelRequire("12XdK");

var $cpfnh = parcelRequire("cpfnh");

var $7E7Dk = parcelRequire("7E7Dk");

var $kT5QR = parcelRequire("kT5QR");

var $6ozyP = parcelRequire("6ozyP");
parcelRequire("eGqzt");
var $jPnjU = parcelRequire("jPnjU");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
(0, $fN2cW.Chart).register((0, $cpJpP.default), (0, $fN2cW.LinearScale), (0, $fN2cW.TimeScale), (0, $fN2cW.PointElement), (0, $fN2cW.LineElement), (0, $fN2cW.Tooltip));
const $ad33b507c08dfeb7$var$colors = [
    (0, $3CLIQ.theme).brandColors.CA_Blue,
    (0, $3CLIQ.theme).brandColors.CA_Green,
    (0, $3CLIQ.theme).brandColors.CA_Mid_Gray,
    (0, $3CLIQ.theme).brandColors.CA_Yellow,
    (0, $3CLIQ.theme).brandColors.CA_Coral,
    (0, $3CLIQ.theme).brandColors.CA_Purple,
    (0, $3CLIQ.theme).brandColors.CA_Error_Red
];
const $ad33b507c08dfeb7$var$yOffset = 1;
function $ad33b507c08dfeb7$var$Legend({ datasets: datasets, onVisibilityChange: onVisibilityChange, ...rest }) {
    const value = datasets.filter((item)=>!item.hidden).map((item)=>item.label);
    const options = datasets.map((item)=>item.label);
    const itemTemplate = (option)=>{
        const item = datasets.find((item)=>item.label === option);
        return item ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center",
            "data-testid": item.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "w-1rem h-1rem inline mr-1",
            style: {
                backgroundColor: item.backgroundColor || "transparent"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, option)) : null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $12XdK.MultiSelect), {
        ...rest,
        placeholder: "Filter",
        value: value,
        options: options,
        onChange: onVisibilityChange,
        itemTemplate: itemTemplate,
        "data-testid": "legend-multiselect",
        className: "w-10 xl:w-7"
    });
}
// usage of spread operator on long arrays passed as parameter exceeds the maximum call stack size of the functions,
// like Math.max in Chrome, so I had to write a custom function
function $ad33b507c08dfeb7$var$arrayMax(arr) {
    let len = arr.length;
    let max = -Infinity;
    while(len--)if (arr[len] > max) max = arr[len];
    return max;
}
const $ad33b507c08dfeb7$export$54d0e8420ac838ac = ({ data: data, yAxisLabel: yAxisLabel, xAxisLabel: xAxisLabel, aspectRatio: aspectRatio = 2, enableZoomShortcuts: enableZoomShortcuts, className: className, ...rest })=>{
    const text = (0, $5u6k9.default)();
    const maxY = (0, $7E7Dk.useMemo)(()=>$ad33b507c08dfeb7$var$arrayMax(data.datasets.map((dataset)=>$ad33b507c08dfeb7$var$arrayMax(dataset.data.map((point)=>typeof point === "number" ? point : point?.y || 0)))), [
        data.datasets
    ]);
    const zoomLevels = (0, $7E7Dk.useMemo)(()=>({
            "24h": {
                min: (0, $lhFGA.default)(new Date(), 24).getTime(),
                max: new Date().getTime()
            },
            "7d": {
                min: (0, $i2nlv.default)(new Date(), 7).getTime(),
                max: new Date().getTime()
            }
        }), []);
    const scales = (0, $7E7Dk.useMemo)(()=>({
            x: {
                position: "bottom",
                type: "time",
                ticks: {
                    autoSkip: true,
                    autoSkipPadding: 20,
                    maxRotation: 0,
                    color: (0, $3CLIQ.theme).brandColors.CA_Black,
                    font: {
                        family: (0, $3CLIQ.theme).chartFont.family,
                        size: 12,
                        weight: (0, $3CLIQ.theme).chartFont.normalWeight,
                        lineHeight: 1.2
                    },
                    callback: function(value) {
                        const date = new Date(value);
                        const hour = date.getHours();
                        const minute = date.getMinutes();
                        const second = date.getSeconds();
                        // This tick is a day
                        if (hour === 0 && minute === 0 && second === 0) return (0, $6ozyP.default)(date, "MMM d");
                        else if (minute === 0 && second === 0) return (0, $6ozyP.default)(date, "HH:mm");
                        else if (second === 0) return (0, $6ozyP.default)(date, "HH:mm");
                        else return (0, $6ozyP.default)(date, "HH:mm:ss");
                    }
                },
                time: {
                    bounds: "data",
                    displayFormats: {
                        hour: "HH:mm",
                        minute: "HH:mm",
                        second: "HH:mm:ss",
                        millisecond: "HH:mm:ss",
                        day: "d eee"
                    }
                },
                title: {
                    display: xAxisLabel !== undefined,
                    text: xAxisLabel,
                    color: (0, $3CLIQ.theme).brandColors.CA_Black,
                    font: {
                        family: (0, $3CLIQ.theme).chartFont.family,
                        size: 14,
                        weight: (0, $3CLIQ.theme).chartFont.normalWeight,
                        lineHeight: 1.2
                    }
                }
            },
            y: {
                max: maxY + $ad33b507c08dfeb7$var$yOffset,
                position: "left",
                ticks: {
                    callback: (val, index, ticks)=>{
                        if (index === 0 || index === ticks.length - 1) return null;
                        if (typeof val !== "number") return val;
                        return Number.isInteger(val) ? val : val.toFixed(3);
                    },
                    color: (0, $3CLIQ.theme).brandColors.CA_Black,
                    font: {
                        family: (0, $3CLIQ.theme).chartFont.family,
                        size: 12,
                        weight: (0, $3CLIQ.theme).chartFont.normalWeight,
                        lineHeight: 1.2
                    }
                },
                grid: {
                    color: (0, $3CLIQ.theme).brandColors.CA_Gray
                },
                title: {
                    display: yAxisLabel !== undefined,
                    text: yAxisLabel,
                    color: (0, $3CLIQ.theme).brandColors.CA_Black,
                    font: {
                        family: (0, $3CLIQ.theme).chartFont.family,
                        size: 14,
                        weight: (0, $3CLIQ.theme).chartFont.normalWeight,
                        lineHeight: 1.2
                    }
                }
            }
        }), [
        maxY,
        xAxisLabel,
        yAxisLabel
    ]);
    const [currentZoomLevel, setCurrentZoomLevel] = (0, $7E7Dk.useState)(null);
    const chartRef = (0, $7E7Dk.useRef)(null);
    const legendRef = (0, $7E7Dk.useRef)(null);
    // Set the initial zoom level after the component has mounted
    (0, $7E7Dk.useLayoutEffect)(()=>{
        if (!enableZoomShortcuts) return;
        setTimeout(()=>{
            setCurrentZoomLevel("24h");
        }, 0);
    }, [
        enableZoomShortcuts
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (chartRef.current && currentZoomLevel !== null) {
            const chart = chartRef.current;
            const zoomLevel = zoomLevels[currentZoomLevel];
            chart.zoomScale("x", zoomLevel, "zoom");
            // Update the chart
            chart.update();
        }
    }, [
        currentZoomLevel,
        zoomLevels
    ]);
    const zoomOptions = (0, $7E7Dk.useMemo)(()=>({
            pan: {
                enabled: true,
                mode: "xy",
                scaleMode: "xy",
                wheel: {
                    enabled: false
                },
                modifierKey: "alt"
            },
            zoom: {
                wheel: {
                    enabled: true
                },
                pinch: {
                    enabled: true
                },
                drag: {
                    enabled: true,
                    borderColor: (0, $3CLIQ.theme).brandColors.CA_Mid_Blue,
                    borderWidth: 1,
                    backgroundColor: (0, $3CLIQ.theme).brandColors.CA_Light_Blue,
                    threshold: 10
                },
                mode: "x",
                scaleMode: "x"
            },
            limits: {
                x: {
                    minRange: 600000,
                    min: "original",
                    max: "original"
                },
                y: {
                    minRange: 10,
                    min: "original",
                    max: maxY + $ad33b507c08dfeb7$var$yOffset
                }
            }
        }), [
        maxY,
        zoomLevels
    ]);
    const coloredData = (0, $7E7Dk.useMemo)(()=>({
            ...data,
            datasets: data.datasets.map((dataset, index)=>({
                    borderColor: $ad33b507c08dfeb7$var$colors[index % $ad33b507c08dfeb7$var$colors.length],
                    backgroundColor: $ad33b507c08dfeb7$var$colors[index % $ad33b507c08dfeb7$var$colors.length],
                    borderWidth: 1,
                    ...dataset
                }))
        }), [
        data
    ]);
    (0, $7E7Dk.useLayoutEffect)(()=>{
        if (legendRef.current) {
            legendRef.current.innerHTML = "" // Clear the legend
            ;
            const title = document.createElement("div");
            // Generate legend items
            const bodyItems = coloredData.datasets.map((dataset)=>{
                const legendItem = document.createElement("div");
                const legendColor = document.createElement("span");
                legendColor.setAttribute("style", "display: inline-block; width: 10px; height: 10px; background-color: " + dataset.backgroundColor);
                legendItem.append(legendColor);
                const textNode = document.createTextNode(` ${dataset.label}`);
                legendItem.appendChild(textNode);
                return legendItem;
            });
            const body = document.createElement("div");
            // Calculate the width of the items based on the parent's width and the number of items
            const itemWidth = Math.floor(legendRef.current.width / Math.ceil(bodyItems.length / 3));
            bodyItems.forEach((item)=>{
                item.style.width = `${itemWidth}px`;
            });
            body.setAttribute("style", "display: flex; flex-direction: column; flex-wrap: wrap; height: 60px;");
            body.append(...bodyItems);
            legendRef.current.append(title, body);
        }
    }, [
        coloredData
    ]);
    const options = (0, $7E7Dk.useMemo)(()=>({
            normalized: true,
            parsing: false,
            interaction: {
                mode: "index",
                intersect: false
            },
            tension: false,
            stepped: 0,
            borderDash: [],
            spanGaps: true,
            animation: false,
            maintainAspectRatio: false,
            responsive: true,
            aspectRatio: aspectRatio,
            plugins: {
                zoom: zoomOptions,
                decimation: {
                    enabled: false
                },
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false,
                    external: function(context) {
                        // Update the custom legend with the data from the hovered dataset
                        if (legendRef.current === null) return;
                        const tooltipModel = context.tooltip;
                        if (tooltipModel.opacity === 0) return;
                        const dataPoint = tooltipModel.dataPoints[0];
                        if (!dataPoint) return;
                        const datasets = context.chart.data.datasets;
                        const label = new Date(datasets[0].data[dataPoint.dataIndex].x).toLocaleString("sv-SE");
                        const legend = legendRef.current.children;
                        const title = legend[0];
                        title.innerHTML = label;
                        title.classList.add("mb-4", "font-bold");
                        const body = legend[1];
                        for(let i = 0; i < context.chart.data.datasets.length; i++){
                            const datasetLabel = context.chart.data.datasets[i].label;
                            const value = datasets[i].data[dataPoint.dataIndex].y;
                            const legendItem = body.children[i];
                            legendItem.innerHTML = "" // Clear the content of the legend item
                            ;
                            const legendColor = document.createElement("span");
                            legendColor.textContent = " ";
                            legendColor.setAttribute("style", "display: inline-block; width: 10px; height: 10px; background-color: " + datasets[i].backgroundColor);
                            legendItem.append(legendColor);
                            const textNode = document.createTextNode(` ${datasetLabel}: ${isNaN(value) ? "-" : value}`);
                            legendItem.appendChild(textNode);
                        }
                    }
                }
            },
            scales: scales,
            datasets: {
                line: {
                    pointRadius: 0
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            }
        }), [
        scales,
        zoomOptions
    ]);
    const [datasets, setDatasets] = (0, $7E7Dk.useState)([]);
    (0, $7E7Dk.useEffect)(()=>{
        if (chartRef.current) {
            const chart = chartRef.current;
            setDatasets(chart.data.datasets.map((dataset, index)=>({
                    label: dataset.label,
                    backgroundColor: dataset.backgroundColor,
                    hidden: chart.getDatasetMeta(index).hidden
                })));
        }
    }, [
        data.datasets
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-between align-items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ad33b507c08dfeb7$var$Legend, {
        ...rest,
        datasets: datasets,
        onVisibilityChange: (event)=>{
            const chart = chartRef.current;
            if (chart === null) return;
            if (Array.isArray(event.selectedOption)) {
                const selectAll = event.selectedOption.length === datasets.length;
                datasets.forEach((_, index)=>{
                    chart.setDatasetVisibility(index, selectAll);
                });
                chart.update();
                setDatasets(chart.data.datasets.map((dataset, index)=>({
                        label: dataset.label,
                        backgroundColor: dataset.backgroundColor,
                        hidden: chart.getDatasetMeta(index).hidden
                    })));
                return;
            }
            const index = datasets.findIndex((item)=>event.selectedOption === item.label);
            chart.setDatasetVisibility(index, !chart.isDatasetVisible(index));
            chart.update();
            setDatasets(chart.data.datasets.map((dataset, index)=>({
                    label: dataset.label,
                    backgroundColor: dataset.backgroundColor,
                    hidden: chart.getDatasetMeta(index).hidden
                })));
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cpfnh.Tooltip), {
        target: "#line-chart-tooltip"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "line-chart-tooltip",
        className: "cursor-pointer z-1",
        "data-pr-tooltip": text("msgLineChartHelpText"),
        "data-pr-position": "top",
        "data-pr-at": "right+8 top-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jPnjU.InfoIcon), {
        size: 20
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "relative h-30rem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kT5QR.Line), {
        key: "line-chart",
        ref: chartRef,
        data: coloredData,
        options: options,
        "data-testid": "line-chart",
        plugins: [
            {
                id: "customEventListener",
                afterEvent: (chart, evt)=>{
                    if (evt.event.type !== "click") return;
                    // zoom out on double click
                    if (evt.event.native?.detail === 2) chart.resetZoom();
                }
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "pb-4",
        ref: legendRef
    }), enableZoomShortcuts ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
        fullWidth: true,
        id: "zoom-shortcuts",
        ariaLabel: text("lblZoomInterval"),
        value: currentZoomLevel,
        options: [
            {
                label: text("lbl24h"),
                value: "24h"
            },
            {
                label: text("lbl7days"),
                value: "7d"
            }
        ],
        onChange: (value)=>setCurrentZoomLevel(value)
    }) : null);
};

});
parcelRegister("h0Ico", function(module, exports) {
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */ 
var $fN2cW = parcelRequire("fN2cW");

var $hmFZG = parcelRequire("hmFZG");
var $7mQI5 = parcelRequire("7mQI5");
var $fijNH = parcelRequire("fijNH");
var $2m9Ca = parcelRequire("2m9Ca");
var $9ega8 = parcelRequire("9ega8");
var $60HcZ = parcelRequire("60HcZ");
var $kahi4 = parcelRequire("kahi4");
var $xO2rg = parcelRequire("xO2rg");
var $c5mhl = parcelRequire("c5mhl");
var $dpfnB = parcelRequire("dpfnB");
var $7m9gT = parcelRequire("7m9gT");
var $DHFLy = parcelRequire("DHFLy");
var $h3gWA = parcelRequire("h3gWA");
var $9VIW7 = parcelRequire("9VIW7");
var $fHaeb = parcelRequire("fHaeb");
var $thBP8 = parcelRequire("thBP8");
var $3moXH = parcelRequire("3moXH");
var $hyGVt = parcelRequire("hyGVt");
var $90NQT = parcelRequire("90NQT");
var $92mZR = parcelRequire("92mZR");
var $gl4rg = parcelRequire("gl4rg");
var $d7PJE = parcelRequire("d7PJE");
var $ipBL5 = parcelRequire("ipBL5");
var $dAj82 = parcelRequire("dAj82");
var $dWX9T = parcelRequire("dWX9T");
var $khqR8 = parcelRequire("khqR8");
var $jW4vR = parcelRequire("jW4vR");
var $lA9bK = parcelRequire("lA9bK");
var $bkTjt = parcelRequire("bkTjt");
var $9fldd = parcelRequire("9fldd");
var $6Wotx = parcelRequire("6Wotx");
var $cDFIV = parcelRequire("cDFIV");
var $31iWy = parcelRequire("31iWy");
var $ajiUn = parcelRequire("ajiUn");
var $kYtYW = parcelRequire("kYtYW");
var $2X1xy = parcelRequire("2X1xy");
var $4V6Kt = parcelRequire("4V6Kt");
var $lmK01 = parcelRequire("lmK01");
var $922t6 = parcelRequire("922t6");
const $c624b8bfe7617838$var$FORMATS = {
    datetime: "MMM d, yyyy, h:mm:ss aaaa",
    millisecond: "h:mm:ss.SSS aaaa",
    second: "h:mm:ss aaaa",
    minute: "h:mm aaaa",
    hour: "ha",
    day: "MMM d",
    week: "PP",
    month: "MMM yyyy",
    quarter: "qqq - yyyy",
    year: "yyyy"
};
(0, $fN2cW._adapters)._date.override({
    _id: "date-fns",
    formats: function() {
        return $c624b8bfe7617838$var$FORMATS;
    },
    parse: function(value, fmt) {
        if (value === null || typeof value === "undefined") return null;
        const type = typeof value;
        if (type === "number" || value instanceof Date) value = (0, $922t6.default)(value);
        else if (type === "string") {
            if (typeof fmt === "string") value = (0, $bkTjt.default)(value, fmt, new Date(), this.options);
            else value = (0, $9fldd.default)(value, this.options);
        }
        return (0, $lA9bK.default)(value) ? value.getTime() : null;
    },
    format: function(time, fmt) {
        return (0, $jW4vR.default)(time, fmt, this.options);
    },
    add: function(time, amount, unit) {
        switch(unit){
            case "millisecond":
                return (0, $fijNH.default)(time, amount);
            case "second":
                return (0, $kahi4.default)(time, amount);
            case "minute":
                return (0, $2m9Ca.default)(time, amount);
            case "hour":
                return (0, $7mQI5.default)(time, amount);
            case "day":
                return (0, $hmFZG.default)(time, amount);
            case "week":
                return (0, $xO2rg.default)(time, amount);
            case "month":
                return (0, $9ega8.default)(time, amount);
            case "quarter":
                return (0, $60HcZ.default)(time, amount);
            case "year":
                return (0, $c5mhl.default)(time, amount);
            default:
                return time;
        }
    },
    diff: function(max, min, unit) {
        switch(unit){
            case "millisecond":
                return (0, $DHFLy.default)(max, min);
            case "second":
                return (0, $thBP8.default)(max, min);
            case "minute":
                return (0, $h3gWA.default)(max, min);
            case "hour":
                return (0, $7m9gT.default)(max, min);
            case "day":
                return (0, $dpfnB.default)(max, min);
            case "week":
                return (0, $3moXH.default)(max, min);
            case "month":
                return (0, $9VIW7.default)(max, min);
            case "quarter":
                return (0, $fHaeb.default)(max, min);
            case "year":
                return (0, $hyGVt.default)(max, min);
            default:
                return 0;
        }
    },
    startOf: function(time, unit, weekday) {
        switch(unit){
            case "second":
                return (0, $2X1xy.default)(time);
            case "minute":
                return (0, $31iWy.default)(time);
            case "hour":
                return (0, $cDFIV.default)(time);
            case "day":
                return (0, $6Wotx.default)(time);
            case "week":
                return (0, $4V6Kt.default)(time);
            case "isoWeek":
                return (0, $4V6Kt.default)(time, {
                    weekStartsOn: +weekday
                });
            case "month":
                return (0, $ajiUn.default)(time);
            case "quarter":
                return (0, $kYtYW.default)(time);
            case "year":
                return (0, $lmK01.default)(time);
            default:
                return time;
        }
    },
    endOf: function(time, unit) {
        switch(unit){
            case "second":
                return (0, $dAj82.default)(time);
            case "minute":
                return (0, $gl4rg.default)(time);
            case "hour":
                return (0, $92mZR.default)(time);
            case "day":
                return (0, $90NQT.default)(time);
            case "week":
                return (0, $dWX9T.default)(time);
            case "month":
                return (0, $d7PJE.default)(time);
            case "quarter":
                return (0, $ipBL5.default)(time);
            case "year":
                return (0, $khqR8.default)(time);
            default:
                return time;
        }
    }
});

});
parcelRegister("fN2cW", function(module, exports) {

$parcel$export(module.exports, "BarController", function () { return $02f77014d6aeddf6$export$e97d5dc64e999004; });
$parcel$export(module.exports, "BubbleController", function () { return $02f77014d6aeddf6$export$19b5c4773f17abe; });
$parcel$export(module.exports, "DoughnutController", function () { return $02f77014d6aeddf6$export$e04603e7d8b77172; });
$parcel$export(module.exports, "LineController", function () { return $02f77014d6aeddf6$export$3c9b5d28c11cbfd0; });
$parcel$export(module.exports, "PolarAreaController", function () { return $02f77014d6aeddf6$export$2a270b3a0d973c85; });
$parcel$export(module.exports, "PieController", function () { return $02f77014d6aeddf6$export$b21a3f1286706191; });
$parcel$export(module.exports, "RadarController", function () { return $02f77014d6aeddf6$export$48dbc6ac651bf8be; });
$parcel$export(module.exports, "ScatterController", function () { return $02f77014d6aeddf6$export$b2f2bae6713db87; });
$parcel$export(module.exports, "_adapters", function () { return $02f77014d6aeddf6$export$f32766ea09ec8bc4; });
$parcel$export(module.exports, "Chart", function () { return $02f77014d6aeddf6$export$acaa6426d77a227e; });
$parcel$export(module.exports, "LineElement", function () { return $02f77014d6aeddf6$export$55e463fa7bcd3469; });
$parcel$export(module.exports, "PointElement", function () { return $02f77014d6aeddf6$export$bd159b522b230b7a; });
$parcel$export(module.exports, "Tooltip", function () { return $02f77014d6aeddf6$export$28c660c63b792dea; });
$parcel$export(module.exports, "LinearScale", function () { return $02f77014d6aeddf6$export$e7f4e5e8656f0b93; });
$parcel$export(module.exports, "TimeScale", function () { return $02f77014d6aeddf6$export$a894c72689ff3ec; });
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ 
var $ffh6R = parcelRequire("ffh6R");

class $02f77014d6aeddf6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $ffh6R.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $02f77014d6aeddf6$export$a424a0aa8f687495 = /* #__PURE__ */ new $02f77014d6aeddf6$var$Animator();
const $02f77014d6aeddf6$var$transparent = "transparent";
const $02f77014d6aeddf6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $ffh6R.c)(from || $02f77014d6aeddf6$var$transparent);
        const c1 = c0.valid && (0, $ffh6R.c)(to || $02f77014d6aeddf6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $02f77014d6aeddf6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $ffh6R.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $ffh6R.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $02f77014d6aeddf6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $ffh6R.e)[cfg.easing] || (0, $ffh6R.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $ffh6R.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $ffh6R.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $02f77014d6aeddf6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $ffh6R.i)(config)) return;
        const animationOptions = Object.keys((0, $ffh6R.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $ffh6R.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $ffh6R.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $02f77014d6aeddf6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $02f77014d6aeddf6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $02f77014d6aeddf6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $02f77014d6aeddf6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $02f77014d6aeddf6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $02f77014d6aeddf6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $02f77014d6aeddf6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $02f77014d6aeddf6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $02f77014d6aeddf6$var$scaleClip(xScale, allowedOverflow);
    const y = $02f77014d6aeddf6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $02f77014d6aeddf6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $ffh6R.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $02f77014d6aeddf6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $02f77014d6aeddf6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $ffh6R.g)(otherValue) && (singleMode || value === 0 || (0, $ffh6R.s)(value) === (0, $ffh6R.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $02f77014d6aeddf6$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $02f77014d6aeddf6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $02f77014d6aeddf6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $02f77014d6aeddf6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $02f77014d6aeddf6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $02f77014d6aeddf6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $02f77014d6aeddf6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $02f77014d6aeddf6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $02f77014d6aeddf6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $02f77014d6aeddf6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $02f77014d6aeddf6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $02f77014d6aeddf6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $02f77014d6aeddf6$var$createDatasetContext(parent, index) {
    return (0, $ffh6R.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $02f77014d6aeddf6$var$createDataContext(parent, index, element) {
    return (0, $ffh6R.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $02f77014d6aeddf6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $02f77014d6aeddf6$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $02f77014d6aeddf6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $02f77014d6aeddf6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $02f77014d6aeddf6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $02f77014d6aeddf6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $02f77014d6aeddf6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $ffh6R.v)(dataset.xAxisID, $02f77014d6aeddf6$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $ffh6R.v)(dataset.yAxisID, $02f77014d6aeddf6$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $ffh6R.v)(dataset.rAxisID, $02f77014d6aeddf6$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $ffh6R.u)(this._data, this);
        if (meta._stacked) $02f77014d6aeddf6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $ffh6R.i)(data)) this._data = $02f77014d6aeddf6$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $ffh6R.u)(_data, this);
                const meta = this._cachedMeta;
                $02f77014d6aeddf6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $ffh6R.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $02f77014d6aeddf6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $02f77014d6aeddf6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $02f77014d6aeddf6$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $ffh6R.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $ffh6R.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $02f77014d6aeddf6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $ffh6R.f)(item, xAxisKey), index),
                y: yScale.parse((0, $ffh6R.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $02f77014d6aeddf6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $02f77014d6aeddf6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $02f77014d6aeddf6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $02f77014d6aeddf6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $02f77014d6aeddf6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $ffh6R.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $ffh6R.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $02f77014d6aeddf6$var$toClip((0, $ffh6R.v)(this.options.clip, $02f77014d6aeddf6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $02f77014d6aeddf6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $02f77014d6aeddf6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $ffh6R.h)(index);
        if (cached) return $02f77014d6aeddf6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $ffh6R.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($02f77014d6aeddf6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $02f77014d6aeddf6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $02f77014d6aeddf6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($02f77014d6aeddf6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$02f77014d6aeddf6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $02f77014d6aeddf6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
function $02f77014d6aeddf6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $ffh6R._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $02f77014d6aeddf6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $02f77014d6aeddf6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $ffh6R.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $02f77014d6aeddf6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $ffh6R.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $02f77014d6aeddf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $02f77014d6aeddf6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $02f77014d6aeddf6$var$parseValue(entry, item, vScale, i) {
    if ((0, $ffh6R.b)(entry)) $02f77014d6aeddf6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $02f77014d6aeddf6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($02f77014d6aeddf6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $02f77014d6aeddf6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $02f77014d6aeddf6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $ffh6R.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $02f77014d6aeddf6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $02f77014d6aeddf6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $02f77014d6aeddf6$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$02f77014d6aeddf6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$02f77014d6aeddf6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $02f77014d6aeddf6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $02f77014d6aeddf6$var$swap(edge, a, b);
        edge = $02f77014d6aeddf6$var$startEnd(edge, b, a);
    } else edge = $02f77014d6aeddf6$var$startEnd(edge, a, b);
    return edge;
}
function $02f77014d6aeddf6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $02f77014d6aeddf6$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $02f77014d6aeddf6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $02f77014d6aeddf6$export$e97d5dc64e999004 extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "bar";
    static defaults = {
        datasetElementType: false,
        dataElementType: "bar",
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $02f77014d6aeddf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $02f77014d6aeddf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $ffh6R.f)(obj, iAxisKey), i);
            parsed.push($02f77014d6aeddf6$var$parseValue((0, $ffh6R.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $02f77014d6aeddf6$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $ffh6R.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $02f77014d6aeddf6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $02f77014d6aeddf6$var$setBorderSkipped(properties, options, stack, index);
            $02f77014d6aeddf6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $ffh6R.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $02f77014d6aeddf6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $02f77014d6aeddf6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $ffh6R.s)(value) !== (0, $ffh6R.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $ffh6R.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $02f77014d6aeddf6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $ffh6R.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $ffh6R.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $02f77014d6aeddf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $02f77014d6aeddf6$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class $02f77014d6aeddf6$export$19b5c4773f17abe extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "bubble";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $ffh6R.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $ffh6R.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $ffh6R.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function $02f77014d6aeddf6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $ffh6R.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $ffh6R.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $ffh6R.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $ffh6R.H), startY, endY);
        const minX = calcMin((0, $ffh6R.P), startX, endX);
        const minY = calcMin((0, $ffh6R.P) + (0, $ffh6R.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $02f77014d6aeddf6$export$e04603e7d8b77172 extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "doughnut";
    static defaults = {
        datasetElementType: false,
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    };
    static descriptors = {
        _scriptable: (name)=>name !== "spacing",
        _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $ffh6R.i)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $ffh6R.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $ffh6R.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $ffh6R.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $ffh6R.T);
        let max = -(0, $ffh6R.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $ffh6R.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $02f77014d6aeddf6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $ffh6R.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $ffh6R.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $ffh6R.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $ffh6R.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $ffh6R.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $02f77014d6aeddf6$export$3c9b5d28c11cbfd0 extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "line";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $ffh6R.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $ffh6R.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $ffh6R.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $ffh6R.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $02f77014d6aeddf6$export$2a270b3a0d973c85 extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "polarArea";
    static defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $ffh6R.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $ffh6R.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $ffh6R.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $ffh6R.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $02f77014d6aeddf6$export$b21a3f1286706191 extends $02f77014d6aeddf6$export$e04603e7d8b77172 {
    static id = "pie";
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
}
class $02f77014d6aeddf6$export$48dbc6ac651bf8be extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "radar";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: true,
        elements: {
            line: {
                fill: "start"
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $ffh6R.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $02f77014d6aeddf6$export$b2f2bae6713db87 extends $02f77014d6aeddf6$export$75572ec5c55b4048 {
    static id = "scatter";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $ffh6R.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $ffh6R.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $ffh6R.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $ffh6R.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $02f77014d6aeddf6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $02f77014d6aeddf6$export$e97d5dc64e999004,
    BubbleController: $02f77014d6aeddf6$export$19b5c4773f17abe,
    DoughnutController: $02f77014d6aeddf6$export$e04603e7d8b77172,
    LineController: $02f77014d6aeddf6$export$3c9b5d28c11cbfd0,
    PieController: $02f77014d6aeddf6$export$b21a3f1286706191,
    PolarAreaController: $02f77014d6aeddf6$export$2a270b3a0d973c85,
    RadarController: $02f77014d6aeddf6$export$48dbc6ac651bf8be,
    ScatterController: $02f77014d6aeddf6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $02f77014d6aeddf6$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $02f77014d6aeddf6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($02f77014d6aeddf6$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $02f77014d6aeddf6$var$abstract();
    }
    parse() {
        return $02f77014d6aeddf6$var$abstract();
    }
    format() {
        return $02f77014d6aeddf6$var$abstract();
    }
    add() {
        return $02f77014d6aeddf6$var$abstract();
    }
    diff() {
        return $02f77014d6aeddf6$var$abstract();
    }
    startOf() {
        return $02f77014d6aeddf6$var$abstract();
    }
    endOf() {
        return $02f77014d6aeddf6$var$abstract();
    }
}
var $02f77014d6aeddf6$export$f32766ea09ec8bc4 = {
    _date: $02f77014d6aeddf6$var$DateAdapterBase
};
function $02f77014d6aeddf6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $ffh6R.A) : (0, $ffh6R.B);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $02f77014d6aeddf6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $02f77014d6aeddf6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $02f77014d6aeddf6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $02f77014d6aeddf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $ffh6R.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $02f77014d6aeddf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $02f77014d6aeddf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $ffh6R.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $ffh6R.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $02f77014d6aeddf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $02f77014d6aeddf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $02f77014d6aeddf6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $02f77014d6aeddf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $02f77014d6aeddf6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $02f77014d6aeddf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $02f77014d6aeddf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $02f77014d6aeddf6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $02f77014d6aeddf6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $02f77014d6aeddf6$export$a13296960cae0384 = {
    evaluateInteractionItems: $02f77014d6aeddf6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $02f77014d6aeddf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $02f77014d6aeddf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $02f77014d6aeddf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $02f77014d6aeddf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $02f77014d6aeddf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $02f77014d6aeddf6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            return $02f77014d6aeddf6$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $ffh6R.z)(e, chart);
            return $02f77014d6aeddf6$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $02f77014d6aeddf6$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $02f77014d6aeddf6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $02f77014d6aeddf6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$02f77014d6aeddf6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $02f77014d6aeddf6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $02f77014d6aeddf6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $02f77014d6aeddf6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$02f77014d6aeddf6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $02f77014d6aeddf6$var$setLayoutDims(layouts, params) {
    const stacks = $02f77014d6aeddf6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $02f77014d6aeddf6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $02f77014d6aeddf6$var$wrapBoxes(boxes);
    const fullSize = $02f77014d6aeddf6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $02f77014d6aeddf6$var$sortByWeight($02f77014d6aeddf6$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $02f77014d6aeddf6$var$sortByWeight($02f77014d6aeddf6$var$filterByPosition(layoutBoxes, "right"));
    const top = $02f77014d6aeddf6$var$sortByWeight($02f77014d6aeddf6$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $02f77014d6aeddf6$var$sortByWeight($02f77014d6aeddf6$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $02f77014d6aeddf6$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $02f77014d6aeddf6$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $02f77014d6aeddf6$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $02f77014d6aeddf6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $02f77014d6aeddf6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $02f77014d6aeddf6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $ffh6R.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $02f77014d6aeddf6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $02f77014d6aeddf6$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $02f77014d6aeddf6$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $02f77014d6aeddf6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $02f77014d6aeddf6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $02f77014d6aeddf6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $02f77014d6aeddf6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $02f77014d6aeddf6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $02f77014d6aeddf6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $02f77014d6aeddf6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $02f77014d6aeddf6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $ffh6R.h)(stack.start)) y = stack.start;
            if (box.fullSize) $02f77014d6aeddf6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $02f77014d6aeddf6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $ffh6R.h)(stack.start)) x = stack.start;
            if (box.fullSize) $02f77014d6aeddf6$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $02f77014d6aeddf6$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $02f77014d6aeddf6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $ffh6R.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $02f77014d6aeddf6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $ffh6R.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $02f77014d6aeddf6$var$updateMaxPadding(maxPadding, (0, $ffh6R.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $02f77014d6aeddf6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $02f77014d6aeddf6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $02f77014d6aeddf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($02f77014d6aeddf6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $02f77014d6aeddf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $02f77014d6aeddf6$var$handleMaxPadding(chartArea);
        $02f77014d6aeddf6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $02f77014d6aeddf6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $ffh6R.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $02f77014d6aeddf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $02f77014d6aeddf6$export$a40a96b24b46cf35 extends $02f77014d6aeddf6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $02f77014d6aeddf6$var$EXPANDO_KEY = "$chartjs";
const $02f77014d6aeddf6$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $02f77014d6aeddf6$var$isNullOrEmpty = (value)=>value === null || value === "";
function $02f77014d6aeddf6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$02f77014d6aeddf6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($02f77014d6aeddf6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $ffh6R.J)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($02f77014d6aeddf6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $ffh6R.J)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $02f77014d6aeddf6$var$eventListenerOptions = (0, $ffh6R.K) ? {
    passive: true
} : false;
function $02f77014d6aeddf6$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $02f77014d6aeddf6$var$eventListenerOptions);
}
function $02f77014d6aeddf6$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $02f77014d6aeddf6$var$eventListenerOptions);
}
function $02f77014d6aeddf6$var$fromNativeEvent(event, chart) {
    const type = $02f77014d6aeddf6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $ffh6R.z)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $02f77014d6aeddf6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $02f77014d6aeddf6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $02f77014d6aeddf6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$02f77014d6aeddf6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $02f77014d6aeddf6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $02f77014d6aeddf6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$02f77014d6aeddf6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $02f77014d6aeddf6$var$drpListeningCharts = new Map();
let $02f77014d6aeddf6$var$oldDevicePixelRatio = 0;
function $02f77014d6aeddf6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $02f77014d6aeddf6$var$oldDevicePixelRatio) return;
    $02f77014d6aeddf6$var$oldDevicePixelRatio = dpr;
    $02f77014d6aeddf6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $02f77014d6aeddf6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$02f77014d6aeddf6$var$drpListeningCharts.size) window.addEventListener("resize", $02f77014d6aeddf6$var$onWindowResize);
    $02f77014d6aeddf6$var$drpListeningCharts.set(chart, resize);
}
function $02f77014d6aeddf6$var$unlistenDevicePixelRatioChanges(chart) {
    $02f77014d6aeddf6$var$drpListeningCharts.delete(chart);
    if (!$02f77014d6aeddf6$var$drpListeningCharts.size) window.removeEventListener("resize", $02f77014d6aeddf6$var$onWindowResize);
}
function $02f77014d6aeddf6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $ffh6R.I)(canvas);
    if (!container) return;
    const resize = (0, $ffh6R.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $02f77014d6aeddf6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $02f77014d6aeddf6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $02f77014d6aeddf6$var$unlistenDevicePixelRatioChanges(chart);
}
function $02f77014d6aeddf6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $ffh6R.L)((event)=>{
        if (chart.ctx !== null) listener($02f77014d6aeddf6$var$fromNativeEvent(event, chart));
    }, chart);
    $02f77014d6aeddf6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $02f77014d6aeddf6$export$f02da7f882cf6b2e extends $02f77014d6aeddf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $02f77014d6aeddf6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$02f77014d6aeddf6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$02f77014d6aeddf6$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $ffh6R.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$02f77014d6aeddf6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $02f77014d6aeddf6$var$createAttachObserver,
            detach: $02f77014d6aeddf6$var$createDetachObserver,
            resize: $02f77014d6aeddf6$var$createResizeObserver
        };
        const handler = handlers[type] || $02f77014d6aeddf6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $02f77014d6aeddf6$var$releaseObserver,
            detach: $02f77014d6aeddf6$var$releaseObserver,
            resize: $02f77014d6aeddf6$var$releaseObserver
        };
        const handler = handlers[type] || $02f77014d6aeddf6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $ffh6R.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $ffh6R.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function $02f77014d6aeddf6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $ffh6R.M)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $02f77014d6aeddf6$export$a40a96b24b46cf35;
    return $02f77014d6aeddf6$export$f02da7f882cf6b2e;
}
class $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $ffh6R.x)(this.x) && (0, $ffh6R.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $02f77014d6aeddf6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $02f77014d6aeddf6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $02f77014d6aeddf6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $02f77014d6aeddf6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $02f77014d6aeddf6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $02f77014d6aeddf6$var$skip(ticks, newTicks, spacing, (0, $ffh6R.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$02f77014d6aeddf6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $02f77014d6aeddf6$var$skip(ticks, newTicks, spacing, last, (0, $ffh6R.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $02f77014d6aeddf6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $02f77014d6aeddf6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $02f77014d6aeddf6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $02f77014d6aeddf6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $ffh6R.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $02f77014d6aeddf6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $02f77014d6aeddf6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $02f77014d6aeddf6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $ffh6R.v)(majorStart, 0);
    const end = Math.min((0, $ffh6R.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $02f77014d6aeddf6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $02f77014d6aeddf6$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $02f77014d6aeddf6$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const $02f77014d6aeddf6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $02f77014d6aeddf6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $02f77014d6aeddf6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $02f77014d6aeddf6$var$garbageCollect(caches, length) {
    (0, $ffh6R.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $02f77014d6aeddf6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $02f77014d6aeddf6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $ffh6R.a0)(options.font, fallback);
    const padding = (0, $ffh6R.E)(options.padding);
    const lines = (0, $ffh6R.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $02f77014d6aeddf6$var$createScaleContext(parent, scale) {
    return (0, $ffh6R.j)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $02f77014d6aeddf6$var$createTickContext(parent, index, tick) {
    return (0, $ffh6R.j)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $02f77014d6aeddf6$var$titleAlign(align, position, reverse) {
    let ret = (0, $ffh6R.a1)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $02f77014d6aeddf6$var$reverseAlign(ret);
    return ret;
}
function $02f77014d6aeddf6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $ffh6R.a2)(align, left, right);
        if ((0, $ffh6R.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $02f77014d6aeddf6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $ffh6R.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $02f77014d6aeddf6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $ffh6R.a2)(align, bottom, top);
        rotation = position === "left" ? -(0, $ffh6R.H) : (0, $ffh6R.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $02f77014d6aeddf6$export$d60cfc58d3c358b6 extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $ffh6R.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $ffh6R.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $ffh6R.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $ffh6R.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $ffh6R.O)(_userMin, _suggestedMin),
            max: (0, $ffh6R.O)(_userMax, _suggestedMax),
            minDefined: (0, $ffh6R.g)(_userMin),
            maxDefined: (0, $ffh6R.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $ffh6R.O)(min, (0, $ffh6R.O)(max, min)),
            max: (0, $ffh6R.O)(max, (0, $ffh6R.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $ffh6R.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $ffh6R.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $02f77014d6aeddf6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $02f77014d6aeddf6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $ffh6R.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $ffh6R.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $ffh6R.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $ffh6R.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $ffh6R.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $ffh6R.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $ffh6R.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $ffh6R.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $02f77014d6aeddf6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $ffh6R.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $02f77014d6aeddf6$var$getTickMarkLength(options.grid) - tickOpts.padding - $02f77014d6aeddf6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $ffh6R.U)(Math.min(Math.asin((0, $ffh6R.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $ffh6R.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $ffh6R.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $ffh6R.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $ffh6R.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $02f77014d6aeddf6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $02f77014d6aeddf6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $02f77014d6aeddf6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $ffh6R.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $ffh6R.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $ffh6R.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $02f77014d6aeddf6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $02f77014d6aeddf6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $ffh6R.k)(label) && !(0, $ffh6R.b)(label)) {
                width = (0, $ffh6R.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $ffh6R.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $ffh6R.k)(nestedLabel) && !(0, $ffh6R.b)(nestedLabel)) {
                    width = (0, $ffh6R.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $02f77014d6aeddf6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $ffh6R.W)(this._alignToPixels ? (0, $ffh6R.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $02f77014d6aeddf6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $02f77014d6aeddf6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $ffh6R.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $02f77014d6aeddf6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $ffh6R.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $ffh6R.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $ffh6R.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $ffh6R.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $02f77014d6aeddf6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $ffh6R.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $02f77014d6aeddf6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $ffh6R.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $ffh6R.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $ffh6R.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $ffh6R.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $ffh6R.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $ffh6R.t)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $ffh6R.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $ffh6R.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $ffh6R.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $ffh6R.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $ffh6R.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $ffh6R.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $ffh6R.$)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $ffh6R.a0)(title.font);
        const padding = (0, $ffh6R.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $ffh6R.i)(position)) {
            offset += padding.bottom;
            if ((0, $ffh6R.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $02f77014d6aeddf6$var$titleArgs(this, offset, position, align);
        (0, $ffh6R.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $02f77014d6aeddf6$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $ffh6R.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, $ffh6R.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $02f77014d6aeddf6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $ffh6R.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $02f77014d6aeddf6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($02f77014d6aeddf6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $02f77014d6aeddf6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $ffh6R.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $ffh6R.d)[scope]) {
            delete (0, $ffh6R.d)[scope][id];
            if (this.override) delete (0, $ffh6R.a3)[id];
        }
    }
}
function $02f77014d6aeddf6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $ffh6R.a4)(Object.create(null), [
        parentScope ? (0, $ffh6R.d).get(parentScope) : {},
        (0, $ffh6R.d).get(scope),
        item.defaults
    ]);
    (0, $ffh6R.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $02f77014d6aeddf6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $ffh6R.d).describe(scope, item.descriptors);
}
function $02f77014d6aeddf6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $ffh6R.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $02f77014d6aeddf6$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $02f77014d6aeddf6$var$Registry {
    constructor(){
        this.controllers = new $02f77014d6aeddf6$var$TypedRegistry($02f77014d6aeddf6$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $02f77014d6aeddf6$var$TypedRegistry($02f77014d6aeddf6$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $02f77014d6aeddf6$var$TypedRegistry(Object, "plugins");
        this.scales = new $02f77014d6aeddf6$var$TypedRegistry($02f77014d6aeddf6$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $ffh6R.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $ffh6R.a5)(method);
        (0, $ffh6R.Q)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $ffh6R.Q)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $02f77014d6aeddf6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $02f77014d6aeddf6$var$Registry();
class $02f77014d6aeddf6$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $ffh6R.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $ffh6R.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $ffh6R.v)(config.options && config.options.plugins, {});
        const plugins = $02f77014d6aeddf6$var$allPlugins(config);
        return options === false && !all ? [] : $02f77014d6aeddf6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $02f77014d6aeddf6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($02f77014d6aeddf6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($02f77014d6aeddf6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $02f77014d6aeddf6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $02f77014d6aeddf6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $02f77014d6aeddf6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $02f77014d6aeddf6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $02f77014d6aeddf6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $02f77014d6aeddf6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $ffh6R.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $02f77014d6aeddf6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $02f77014d6aeddf6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $02f77014d6aeddf6$var$idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function $02f77014d6aeddf6$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $02f77014d6aeddf6$var$determineAxis(id, ...scaleOptions) {
    if ($02f77014d6aeddf6$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $02f77014d6aeddf6$var$axisFromPosition(opts.position) || id.length > 1 && $02f77014d6aeddf6$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $02f77014d6aeddf6$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis: axis
    };
}
function $02f77014d6aeddf6$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $02f77014d6aeddf6$var$getAxisFromDataset(id, "x", boundDs[0]) || $02f77014d6aeddf6$var$getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function $02f77014d6aeddf6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $ffh6R.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $02f77014d6aeddf6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $ffh6R.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $02f77014d6aeddf6$var$determineAxis(id, scaleConf, $02f77014d6aeddf6$var$retrieveAxisFromDatasets(id, config), (0, $ffh6R.d).scales[scaleConf.type]);
        const defaultId = $02f77014d6aeddf6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $ffh6R.ab)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $02f77014d6aeddf6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $ffh6R.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $02f77014d6aeddf6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $ffh6R.ab)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $ffh6R.ab)(scale, [
            (0, $ffh6R.d).scales[scale.type],
            (0, $ffh6R.d).scale
        ]);
    });
    return scales;
}
function $02f77014d6aeddf6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $ffh6R.v)(options.plugins, {});
    options.scales = $02f77014d6aeddf6$var$mergeScaleConfig(config, options);
}
function $02f77014d6aeddf6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $02f77014d6aeddf6$var$initConfig(config) {
    config = config || {};
    config.data = $02f77014d6aeddf6$var$initData(config.data);
    $02f77014d6aeddf6$var$initOptions(config);
    return config;
}
const $02f77014d6aeddf6$var$keyCache = new Map();
const $02f77014d6aeddf6$var$keysCached = new Set();
function $02f77014d6aeddf6$var$cachedKeys(cacheKey, generate) {
    let keys = $02f77014d6aeddf6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $02f77014d6aeddf6$var$keyCache.set(cacheKey, keys);
        $02f77014d6aeddf6$var$keysCached.add(keys);
    }
    return keys;
}
const $02f77014d6aeddf6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $ffh6R.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $02f77014d6aeddf6$var$Config {
    constructor(config){
        this._config = $02f77014d6aeddf6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $02f77014d6aeddf6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $02f77014d6aeddf6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $02f77014d6aeddf6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $02f77014d6aeddf6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $02f77014d6aeddf6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $02f77014d6aeddf6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$02f77014d6aeddf6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$02f77014d6aeddf6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$02f77014d6aeddf6$var$addIfFound(scopes, (0, $ffh6R.a3)[type] || {}, key));
            keys.forEach((key)=>$02f77014d6aeddf6$var$addIfFound(scopes, (0, $ffh6R.d), key));
            keys.forEach((key)=>$02f77014d6aeddf6$var$addIfFound(scopes, (0, $ffh6R.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($02f77014d6aeddf6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $ffh6R.a3)[type] || {},
            (0, $ffh6R.d).datasets[type] || {},
            {
                type: type
            },
            (0, $ffh6R.d),
            (0, $ffh6R.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $02f77014d6aeddf6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($02f77014d6aeddf6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $ffh6R.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $ffh6R.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $02f77014d6aeddf6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $ffh6R.i)(context) ? (0, $ffh6R.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $02f77014d6aeddf6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $ffh6R.a9)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $02f77014d6aeddf6$var$hasFunction = (value)=>(0, $ffh6R.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $ffh6R.a7)(value[key]));
function $02f77014d6aeddf6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $ffh6R.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $ffh6R.a7)(value) || $02f77014d6aeddf6$var$hasFunction(value)) || indexable && (0, $ffh6R.b)(value)) return true;
    }
    return false;
}
var $02f77014d6aeddf6$var$version = "4.4.2";
const $02f77014d6aeddf6$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $02f77014d6aeddf6$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $02f77014d6aeddf6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $02f77014d6aeddf6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $02f77014d6aeddf6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $ffh6R.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $02f77014d6aeddf6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $ffh6R.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $02f77014d6aeddf6$var$getCanvas(item) {
    if ((0, $ffh6R.M)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $02f77014d6aeddf6$var$instances = {};
const $02f77014d6aeddf6$var$getChart = (key)=>{
    const canvas = $02f77014d6aeddf6$var$getCanvas(key);
    return Object.values($02f77014d6aeddf6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $02f77014d6aeddf6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $02f77014d6aeddf6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function $02f77014d6aeddf6$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $02f77014d6aeddf6$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $02f77014d6aeddf6$var$getSizeForArea(xScale, chartArea, "left"),
        right: $02f77014d6aeddf6$var$getSizeForArea(xScale, chartArea, "right"),
        top: $02f77014d6aeddf6$var$getSizeForArea(yScale, chartArea, "top"),
        bottom: $02f77014d6aeddf6$var$getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
class $02f77014d6aeddf6$export$acaa6426d77a227e {
    static defaults = (0, $ffh6R.d);
    static instances = $02f77014d6aeddf6$var$instances;
    static overrides = (0, $ffh6R.a3);
    static registry = $02f77014d6aeddf6$export$4bb7493d241fd8a5;
    static version = $02f77014d6aeddf6$var$version;
    static getChart = $02f77014d6aeddf6$var$getChart;
    static register(...items) {
        $02f77014d6aeddf6$export$4bb7493d241fd8a5.add(...items);
        $02f77014d6aeddf6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $02f77014d6aeddf6$export$4bb7493d241fd8a5.remove(...items);
        $02f77014d6aeddf6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $02f77014d6aeddf6$var$Config(userConfig);
        const initialCanvas = $02f77014d6aeddf6$var$getCanvas(item);
        const existingChart = $02f77014d6aeddf6$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $02f77014d6aeddf6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $ffh6R.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $02f77014d6aeddf6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $ffh6R.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $02f77014d6aeddf6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $02f77014d6aeddf6$export$a424a0aa8f687495.listen(this, "complete", $02f77014d6aeddf6$var$onAnimationsComplete);
        $02f77014d6aeddf6$export$a424a0aa8f687495.listen(this, "progress", $02f77014d6aeddf6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $ffh6R.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $02f77014d6aeddf6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $ffh6R.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $ffh6R.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $02f77014d6aeddf6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$02f77014d6aeddf6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $ffh6R.ae)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $ffh6R.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $ffh6R.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $02f77014d6aeddf6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $ffh6R.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $02f77014d6aeddf6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $ffh6R.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $02f77014d6aeddf6$var$positionIsHorizontal(scaleOptions.position, axis) !== $02f77014d6aeddf6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $02f77014d6aeddf6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $ffh6R.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $ffh6R.F)(scales, (scale)=>{
            $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $02f77014d6aeddf6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($02f77014d6aeddf6$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $02f77014d6aeddf6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $02f77014d6aeddf6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $ffh6R.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $02f77014d6aeddf6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $02f77014d6aeddf6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $ffh6R.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $ffh6R.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($02f77014d6aeddf6$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $ffh6R.F)(this.scales, (scale)=>{
            $02f77014d6aeddf6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $ffh6R.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $02f77014d6aeddf6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $ffh6R.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $ffh6R.F)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $ffh6R.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($02f77014d6aeddf6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$02f77014d6aeddf6$export$a424a0aa8f687495.running(this)) $02f77014d6aeddf6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $02f77014d6aeddf6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $02f77014d6aeddf6$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $ffh6R.Y)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $ffh6R.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $ffh6R.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $02f77014d6aeddf6$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $ffh6R.j)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $ffh6R.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $02f77014d6aeddf6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $ffh6R.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $02f77014d6aeddf6$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $ffh6R.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $ffh6R.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $ffh6R.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $ffh6R.ah)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $ffh6R.ai)(e);
        const lastEvent = $02f77014d6aeddf6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $ffh6R.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $ffh6R.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $ffh6R.ah)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $02f77014d6aeddf6$var$invalidatePlugins() {
    return (0, $ffh6R.F)($02f77014d6aeddf6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $02f77014d6aeddf6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $ffh6R.H), startAngle - (0, $ffh6R.H));
    ctx.closePath();
    ctx.clip();
}
function $02f77014d6aeddf6$var$toRadiusCorners(value) {
    return (0, $ffh6R.ak)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $02f77014d6aeddf6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $02f77014d6aeddf6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $ffh6R.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $ffh6R.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $ffh6R.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $02f77014d6aeddf6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $02f77014d6aeddf6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $ffh6R.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $02f77014d6aeddf6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $02f77014d6aeddf6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $ffh6R.H));
        }
        // The line from point 3 to point 4
        const p4 = $02f77014d6aeddf6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $02f77014d6aeddf6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $ffh6R.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $02f77014d6aeddf6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $ffh6R.H));
        }
        // The line from point 7 to point 8
        const p8 = $02f77014d6aeddf6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $02f77014d6aeddf6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $ffh6R.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $02f77014d6aeddf6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $02f77014d6aeddf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $ffh6R.T) || (0, $ffh6R.T));
    }
    $02f77014d6aeddf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $02f77014d6aeddf6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $02f77014d6aeddf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $ffh6R.T) || (0, $ffh6R.T));
    }
    if (inner) $02f77014d6aeddf6$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $02f77014d6aeddf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $02f77014d6aeddf6$export$d48203c759d6a1fc extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static id = "arc";
    static defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash"
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $ffh6R.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $ffh6R.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $ffh6R.T) || (0, $ffh6R.p)(angle, startAngle, endAngle);
        const withinRadius = (0, $ffh6R.aj)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $ffh6R.T) ? Math.floor(circumference / (0, $ffh6R.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $ffh6R.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $02f77014d6aeddf6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $02f77014d6aeddf6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $02f77014d6aeddf6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $ffh6R.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $ffh6R.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $ffh6R.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $ffh6R.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $ffh6R.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $ffh6R.v)(style.borderColor, options.borderColor);
}
function $02f77014d6aeddf6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $02f77014d6aeddf6$var$getLineMethod(options) {
    if (options.stepped) return 0, $ffh6R.ar;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $ffh6R.as;
    return $02f77014d6aeddf6$var$lineTo;
}
function $02f77014d6aeddf6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $02f77014d6aeddf6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $02f77014d6aeddf6$var$pathVars(points, segment, params);
    const lineMethod = $02f77014d6aeddf6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $02f77014d6aeddf6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $02f77014d6aeddf6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $02f77014d6aeddf6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $02f77014d6aeddf6$var$fastPathSegment : $02f77014d6aeddf6$var$pathSegment;
}
function $02f77014d6aeddf6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $ffh6R.ao;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $ffh6R.ap;
    return 0, $ffh6R.aq;
}
function $02f77014d6aeddf6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $02f77014d6aeddf6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $02f77014d6aeddf6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $02f77014d6aeddf6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $02f77014d6aeddf6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $02f77014d6aeddf6$var$usePath2D = typeof Path2D === "function";
function $02f77014d6aeddf6$var$draw(ctx, line, start, count) {
    if ($02f77014d6aeddf6$var$usePath2D && !line.options.segment) $02f77014d6aeddf6$var$strokePathWithCache(ctx, line, start, count);
    else $02f77014d6aeddf6$var$strokePathDirect(ctx, line, start, count);
}
class $02f77014d6aeddf6$export$55e463fa7bcd3469 extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static id = "line";
    static defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: "default",
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash" && name !== "fill"
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $ffh6R.al)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $ffh6R.am)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $ffh6R.an)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $02f77014d6aeddf6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $02f77014d6aeddf6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $02f77014d6aeddf6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $02f77014d6aeddf6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $02f77014d6aeddf6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $02f77014d6aeddf6$export$bd159b522b230b7a extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static id = "point";
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $02f77014d6aeddf6$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $02f77014d6aeddf6$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $ffh6R.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $ffh6R.at)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $02f77014d6aeddf6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $02f77014d6aeddf6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $ffh6R.S)(value, min, max);
}
function $02f77014d6aeddf6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $ffh6R.av)(value);
    return {
        t: $02f77014d6aeddf6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $02f77014d6aeddf6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $02f77014d6aeddf6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $02f77014d6aeddf6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $02f77014d6aeddf6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $ffh6R.aw)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $ffh6R.i)(value);
    return {
        topLeft: $02f77014d6aeddf6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $02f77014d6aeddf6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $02f77014d6aeddf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $02f77014d6aeddf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $02f77014d6aeddf6$var$boundingRects(bar) {
    const bounds = $02f77014d6aeddf6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $02f77014d6aeddf6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $02f77014d6aeddf6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $02f77014d6aeddf6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $02f77014d6aeddf6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $ffh6R.aj)(x, bounds.left, bounds.right)) && (skipY || (0, $ffh6R.aj)(y, bounds.top, bounds.bottom));
}
function $02f77014d6aeddf6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $02f77014d6aeddf6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $02f77014d6aeddf6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $02f77014d6aeddf6$export$a16ed71bf4b07672 extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static id = "bar";
    static defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $02f77014d6aeddf6$var$boundingRects(this);
        const addRectPath = $02f77014d6aeddf6$var$hasRadius(outer.radius) ? (0, $ffh6R.au) : $02f77014d6aeddf6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $02f77014d6aeddf6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $02f77014d6aeddf6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $02f77014d6aeddf6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $02f77014d6aeddf6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $02f77014d6aeddf6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $02f77014d6aeddf6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
var $02f77014d6aeddf6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $02f77014d6aeddf6$export$d48203c759d6a1fc,
    BarElement: $02f77014d6aeddf6$export$a16ed71bf4b07672,
    LineElement: $02f77014d6aeddf6$export$55e463fa7bcd3469,
    PointElement: $02f77014d6aeddf6$export$bd159b522b230b7a
});
const $02f77014d6aeddf6$var$BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const $02f77014d6aeddf6$var$BACKGROUND_COLORS = /* #__PURE__ */ $02f77014d6aeddf6$var$BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function $02f77014d6aeddf6$var$getBorderColor(i) {
    return $02f77014d6aeddf6$var$BORDER_COLORS[i % $02f77014d6aeddf6$var$BORDER_COLORS.length];
}
function $02f77014d6aeddf6$var$getBackgroundColor(i) {
    return $02f77014d6aeddf6$var$BACKGROUND_COLORS[i % $02f77014d6aeddf6$var$BACKGROUND_COLORS.length];
}
function $02f77014d6aeddf6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $02f77014d6aeddf6$var$getBorderColor(i);
    dataset.backgroundColor = $02f77014d6aeddf6$var$getBackgroundColor(i);
    return ++i;
}
function $02f77014d6aeddf6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$02f77014d6aeddf6$var$getBorderColor(i++));
    return i;
}
function $02f77014d6aeddf6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$02f77014d6aeddf6$var$getBackgroundColor(i++));
    return i;
}
function $02f77014d6aeddf6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $02f77014d6aeddf6$export$e04603e7d8b77172) i = $02f77014d6aeddf6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $02f77014d6aeddf6$export$2a270b3a0d973c85) i = $02f77014d6aeddf6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $02f77014d6aeddf6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $02f77014d6aeddf6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $02f77014d6aeddf6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $02f77014d6aeddf6$export$c537fa0d021d010b = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($02f77014d6aeddf6$var$containsColorsDefinitions(datasets) || $02f77014d6aeddf6$var$containsColorsDefinition(chartOptions) || elements && $02f77014d6aeddf6$var$containsColorsDefinitions(elements))) return;
        const colorizer = $02f77014d6aeddf6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $02f77014d6aeddf6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $02f77014d6aeddf6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $ffh6R.k)(minIndex) && !(0, $ffh6R.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $02f77014d6aeddf6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $02f77014d6aeddf6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $02f77014d6aeddf6$var$cleanDecimatedDataset(dataset);
    });
}
function $02f77014d6aeddf6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $ffh6R.S)((0, $ffh6R.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $ffh6R.S)((0, $ffh6R.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $02f77014d6aeddf6$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $02f77014d6aeddf6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $ffh6R.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $02f77014d6aeddf6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $02f77014d6aeddf6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $ffh6R.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $02f77014d6aeddf6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $02f77014d6aeddf6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $02f77014d6aeddf6$var$cleanDecimatedData(chart);
    }
};
function $02f77014d6aeddf6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $02f77014d6aeddf6$var$_findSegmentEnd(start, end, points);
        const bounds = $02f77014d6aeddf6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $ffh6R.an)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $02f77014d6aeddf6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $ffh6R.ax)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $02f77014d6aeddf6$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $02f77014d6aeddf6$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $02f77014d6aeddf6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $ffh6R.ay)(start);
        end = (0, $ffh6R.ay)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $02f77014d6aeddf6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $02f77014d6aeddf6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $02f77014d6aeddf6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $02f77014d6aeddf6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $02f77014d6aeddf6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $ffh6R.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $02f77014d6aeddf6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $02f77014d6aeddf6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $02f77014d6aeddf6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $02f77014d6aeddf6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $ffh6R.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $02f77014d6aeddf6$var$_decodeFill(line, index, count) {
    const fill = $02f77014d6aeddf6$var$parseFillOption(line);
    if ((0, $ffh6R.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $ffh6R.g)(target) && Math.floor(target) === target) return $02f77014d6aeddf6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $02f77014d6aeddf6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $02f77014d6aeddf6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $ffh6R.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $02f77014d6aeddf6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $ffh6R.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $02f77014d6aeddf6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $ffh6R.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $02f77014d6aeddf6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $02f77014d6aeddf6$var$getLinesBelow(scale, index);
    linesBelow.push($02f77014d6aeddf6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$02f77014d6aeddf6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $02f77014d6aeddf6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $02f77014d6aeddf6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $02f77014d6aeddf6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $02f77014d6aeddf6$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $02f77014d6aeddf6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $ffh6R.aj)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $02f77014d6aeddf6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $ffh6R.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $02f77014d6aeddf6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $ffh6R.g)(fill)) return $02f77014d6aeddf6$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $02f77014d6aeddf6$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $02f77014d6aeddf6$var$computeBoundary(source);
    if (boundary instanceof $02f77014d6aeddf6$var$simpleArc) return boundary;
    return $02f77014d6aeddf6$var$_createBoundaryLine(boundary, line);
}
function $02f77014d6aeddf6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $02f77014d6aeddf6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $02f77014d6aeddf6$var$computeCircularBoundary(source);
    return $02f77014d6aeddf6$var$computeLinearBoundary(source);
}
function $02f77014d6aeddf6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $02f77014d6aeddf6$var$_getTargetPixel(fill, scale);
    if ((0, $ffh6R.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $02f77014d6aeddf6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $02f77014d6aeddf6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $02f77014d6aeddf6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $02f77014d6aeddf6$var$_drawfill(ctx, source, area) {
    const target = $02f77014d6aeddf6$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $ffh6R.Y)(ctx, area);
        $02f77014d6aeddf6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $ffh6R.$)(ctx);
    }
}
function $02f77014d6aeddf6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $02f77014d6aeddf6$var$clipVertical(ctx, target, area.top);
        $02f77014d6aeddf6$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $02f77014d6aeddf6$var$clipVertical(ctx, target, area.bottom);
    }
    $02f77014d6aeddf6$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $02f77014d6aeddf6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$02f77014d6aeddf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $02f77014d6aeddf6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $02f77014d6aeddf6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $02f77014d6aeddf6$var$clipBounds(ctx, scale, notShape && $02f77014d6aeddf6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $02f77014d6aeddf6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $02f77014d6aeddf6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $02f77014d6aeddf6$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $02f77014d6aeddf6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $02f77014d6aeddf6$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $02f77014d6aeddf6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $02f77014d6aeddf6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $02f77014d6aeddf6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $02f77014d6aeddf6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($02f77014d6aeddf6$var$_shouldApplyFill(source)) $02f77014d6aeddf6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$02f77014d6aeddf6$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $02f77014d6aeddf6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $02f77014d6aeddf6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $02f77014d6aeddf6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $02f77014d6aeddf6$var$Legend extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $ffh6R.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $ffh6R.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $02f77014d6aeddf6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $02f77014d6aeddf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $ffh6R.az)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $ffh6R.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $ffh6R.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $ffh6R.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $ffh6R.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $ffh6R.Y)(ctx, this);
            this._draw();
            (0, $ffh6R.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $ffh6R.d).color;
        const rtlHelper = (0, $ffh6R.az)(opts.rtl, this.left, this.width);
        const labelFont = (0, $ffh6R.a0)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $02f77014d6aeddf6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $ffh6R.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $ffh6R.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $ffh6R.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $ffh6R.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $ffh6R.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $ffh6R.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $ffh6R.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $ffh6R.aD)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $ffh6R.aw)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $ffh6R.au)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $ffh6R.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $ffh6R.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $ffh6R.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $ffh6R.aA)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $ffh6R.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $ffh6R.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $ffh6R.aB)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $02f77014d6aeddf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $ffh6R.aC)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $ffh6R.a0)(titleOpts.font);
        const titlePadding = (0, $ffh6R.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $ffh6R.az)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $ffh6R.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $ffh6R.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $ffh6R.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $ffh6R.a1)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $ffh6R.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $ffh6R.a0)(titleOpts.font);
        const titlePadding = (0, $ffh6R.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $ffh6R.aj)(x, this.left, this.right) && (0, $ffh6R.aj)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $ffh6R.aj)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $ffh6R.aj)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$02f77014d6aeddf6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $02f77014d6aeddf6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $ffh6R.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $ffh6R.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $ffh6R.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $02f77014d6aeddf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $02f77014d6aeddf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $02f77014d6aeddf6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $02f77014d6aeddf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $02f77014d6aeddf6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = $02f77014d6aeddf6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $02f77014d6aeddf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $02f77014d6aeddf6$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $02f77014d6aeddf6$export$ed247974535929c7 = {
    id: "legend",
    _element: $02f77014d6aeddf6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $02f77014d6aeddf6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $ffh6R.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $02f77014d6aeddf6$var$Title extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $ffh6R.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $ffh6R.E)(opts.padding);
        const textSize = lineCount * (0, $ffh6R.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $ffh6R.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $ffh6R.a2)(align, bottom, top);
                rotation = (0, $ffh6R.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $ffh6R.a2)(align, top, bottom);
                rotation = (0, $ffh6R.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $ffh6R.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $ffh6R.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $ffh6R.a1)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $02f77014d6aeddf6$var$createTitle(chart, titleOpts) {
    const title = new $02f77014d6aeddf6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $02f77014d6aeddf6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $02f77014d6aeddf6$export$f99233281efd08a0 = {
    id: "title",
    _element: $02f77014d6aeddf6$var$Title,
    start (chart, _args, options) {
        $02f77014d6aeddf6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $02f77014d6aeddf6$var$map = new WeakMap();
var $02f77014d6aeddf6$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $02f77014d6aeddf6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.addBox(chart, title);
        $02f77014d6aeddf6$var$map.set(chart, title);
    },
    stop (chart) {
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.removeBox(chart, $02f77014d6aeddf6$var$map.get(chart));
        $02f77014d6aeddf6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $02f77014d6aeddf6$var$map.get(chart);
        $02f77014d6aeddf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $02f77014d6aeddf6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $ffh6R.aE)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $02f77014d6aeddf6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $ffh6R.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $02f77014d6aeddf6$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $02f77014d6aeddf6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $02f77014d6aeddf6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $ffh6R.a0)(options.bodyFont);
    const titleFont = (0, $ffh6R.a0)(options.titleFont);
    const footerFont = (0, $ffh6R.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $ffh6R.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $ffh6R.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $ffh6R.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $ffh6R.F)(body, (bodyItem)=>{
        (0, $ffh6R.F)(bodyItem.before, maxLineWidth);
        (0, $ffh6R.F)(bodyItem.lines, maxLineWidth);
        (0, $ffh6R.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $ffh6R.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $02f77014d6aeddf6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $02f77014d6aeddf6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $02f77014d6aeddf6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($02f77014d6aeddf6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $02f77014d6aeddf6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $02f77014d6aeddf6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $02f77014d6aeddf6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $02f77014d6aeddf6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $02f77014d6aeddf6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $02f77014d6aeddf6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $ffh6R.aw)(cornerRadius);
    let x = $02f77014d6aeddf6$var$alignX(size, xAlign);
    const y = $02f77014d6aeddf6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $ffh6R.S)(x, 0, chart.width - size.width),
        y: (0, $ffh6R.S)(y, 0, chart.height - size.height)
    };
}
function $02f77014d6aeddf6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $ffh6R.E)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $02f77014d6aeddf6$var$getBeforeAfterBodyLines(callback) {
    return $02f77014d6aeddf6$var$pushOrConcat([], $02f77014d6aeddf6$var$splitNewlines(callback));
}
function $02f77014d6aeddf6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $ffh6R.j)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $02f77014d6aeddf6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $02f77014d6aeddf6$var$defaultCallbacks = {
    beforeTitle: (0, $ffh6R.aF),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, $ffh6R.aF),
    beforeBody: (0, $ffh6R.aF),
    beforeLabel: (0, $ffh6R.aF),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, $ffh6R.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $ffh6R.aF),
    afterBody: (0, $ffh6R.aF),
    beforeFooter: (0, $ffh6R.aF),
    footer: (0, $ffh6R.aF),
    afterFooter: (0, $ffh6R.aF)
};
function $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return $02f77014d6aeddf6$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $02f77014d6aeddf6$var$Tooltip extends $02f77014d6aeddf6$export$db77ccec0bb4ccac {
    static positioners = $02f77014d6aeddf6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $02f77014d6aeddf6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $02f77014d6aeddf6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(beforeTitle));
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(title));
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $02f77014d6aeddf6$var$getBeforeAfterBodyLines($02f77014d6aeddf6$var$invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $ffh6R.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $02f77014d6aeddf6$var$overrideCallbacks(callbacks, context);
            $02f77014d6aeddf6$var$pushOrConcat(bodyItem.before, $02f77014d6aeddf6$var$splitNewlines($02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            $02f77014d6aeddf6$var$pushOrConcat(bodyItem.lines, $02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "label", this, context));
            $02f77014d6aeddf6$var$pushOrConcat(bodyItem.after, $02f77014d6aeddf6$var$splitNewlines($02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $02f77014d6aeddf6$var$getBeforeAfterBodyLines($02f77014d6aeddf6$var$invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = $02f77014d6aeddf6$var$invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(beforeFooter));
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(footer));
        lines = $02f77014d6aeddf6$var$pushOrConcat(lines, $02f77014d6aeddf6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($02f77014d6aeddf6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $ffh6R.F)(tooltipItems, (context)=>{
            const scoped = $02f77014d6aeddf6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push($02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push($02f77014d6aeddf6$var$invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $02f77014d6aeddf6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $02f77014d6aeddf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $02f77014d6aeddf6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $02f77014d6aeddf6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $ffh6R.aw)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $ffh6R.az)(options.rtl, this.x, this.width);
            pt.x = $02f77014d6aeddf6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $ffh6R.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $ffh6R.a0)(options.bodyFont);
        const colorX = $02f77014d6aeddf6$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $ffh6R.at)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $ffh6R.at)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $ffh6R.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $ffh6R.aw)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $ffh6R.au)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $ffh6R.au)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $ffh6R.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $ffh6R.az)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $02f77014d6aeddf6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $ffh6R.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $ffh6R.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $ffh6R.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $ffh6R.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $ffh6R.az)(options.rtl, this.x, this.width);
            pt.x = $02f77014d6aeddf6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $ffh6R.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $ffh6R.aw)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $02f77014d6aeddf6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $02f77014d6aeddf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $02f77014d6aeddf6$var$determineAlignment(chart, options, positionAndSize);
            const point = $02f77014d6aeddf6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $ffh6R.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $ffh6R.aA)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $ffh6R.aC)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $ffh6R.ah)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $ffh6R.ah)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $02f77014d6aeddf6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $02f77014d6aeddf6$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $02f77014d6aeddf6$var$Tooltip,
    positioners: $02f77014d6aeddf6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $02f77014d6aeddf6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: $02f77014d6aeddf6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $02f77014d6aeddf6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $02f77014d6aeddf6$export$c537fa0d021d010b,
    Decimation: $02f77014d6aeddf6$export$be17f937e9aa7533,
    Filler: $02f77014d6aeddf6$export$d19ba4d812bed757,
    Legend: $02f77014d6aeddf6$export$ed247974535929c7,
    SubTitle: $02f77014d6aeddf6$export$d5c56664638992a4,
    Title: $02f77014d6aeddf6$export$f99233281efd08a0,
    Tooltip: $02f77014d6aeddf6$export$28c660c63b792dea
});
const $02f77014d6aeddf6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $02f77014d6aeddf6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $02f77014d6aeddf6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $02f77014d6aeddf6$var$validIndex = (index, max)=>index === null ? null : (0, $ffh6R.S)(Math.round(index), 0, max);
function $02f77014d6aeddf6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $02f77014d6aeddf6$export$29e663ba4d09fe7 extends $02f77014d6aeddf6$export$d60cfc58d3c358b6 {
    static id = "category";
    static defaults = {
        ticks: {
            callback: $02f77014d6aeddf6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $ffh6R.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $02f77014d6aeddf6$var$findOrAddLabel(labels, raw, (0, $ffh6R.v)(index, raw), this._addedLabels);
        return $02f77014d6aeddf6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $02f77014d6aeddf6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $02f77014d6aeddf6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $ffh6R.k)(min);
    const maxDefined = !(0, $ffh6R.k)(max);
    const countDefined = !(0, $ffh6R.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $ffh6R.aH)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $ffh6R.aH)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $ffh6R.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $ffh6R.aI)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $ffh6R.aJ)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $ffh6R.aK)(spacing), (0, $ffh6R.aK)(niceMin));
    factor = Math.pow(10, (0, $ffh6R.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $ffh6R.aJ)(Math.round((niceMin + j * spacing) * factor) / factor, min, $02f77014d6aeddf6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $ffh6R.aJ)(ticks[ticks.length - 1].value, max, $02f77014d6aeddf6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $02f77014d6aeddf6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $ffh6R.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $02f77014d6aeddf6$var$LinearScaleBase extends $02f77014d6aeddf6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $ffh6R.k)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $ffh6R.s)(min);
            const maxSign = (0, $ffh6R.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $02f77014d6aeddf6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $ffh6R.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $ffh6R.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $02f77014d6aeddf6$export$e7f4e5e8656f0b93 extends $02f77014d6aeddf6$var$LinearScaleBase {
    static id = "linear";
    static defaults = {
        ticks: {
            callback: (0, $ffh6R.aL).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $ffh6R.g)(min) ? min : 0;
        this.max = (0, $ffh6R.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $ffh6R.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $02f77014d6aeddf6$var$log10Floor = (v)=>Math.floor((0, $ffh6R.aM)(v));
const $02f77014d6aeddf6$var$changeExponent = (v, m)=>Math.pow(10, $02f77014d6aeddf6$var$log10Floor(v) + m);
function $02f77014d6aeddf6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $02f77014d6aeddf6$var$log10Floor(tickVal));
    return remain === 1;
}
function $02f77014d6aeddf6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $02f77014d6aeddf6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $02f77014d6aeddf6$var$log10Floor(range);
    while($02f77014d6aeddf6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($02f77014d6aeddf6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $02f77014d6aeddf6$var$log10Floor(min));
}
function $02f77014d6aeddf6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $ffh6R.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = $02f77014d6aeddf6$var$log10Floor(min);
    let exp = $02f77014d6aeddf6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $ffh6R.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $02f77014d6aeddf6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $ffh6R.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $02f77014d6aeddf6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $02f77014d6aeddf6$export$85295eaf7cb3ac3e extends $02f77014d6aeddf6$export$d60cfc58d3c358b6 {
    static id = "logarithmic";
    static defaults = {
        ticks: {
            callback: (0, $ffh6R.aL).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $02f77014d6aeddf6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $ffh6R.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $ffh6R.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $ffh6R.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $ffh6R.g)(this._userMin)) this.min = min === $02f77014d6aeddf6$var$changeExponent(this.min, 0) ? $02f77014d6aeddf6$var$changeExponent(this.min, -1) : $02f77014d6aeddf6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($02f77014d6aeddf6$var$changeExponent(min, -1));
                setMax($02f77014d6aeddf6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($02f77014d6aeddf6$var$changeExponent(max, -1));
        if (max <= 0) setMax($02f77014d6aeddf6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $02f77014d6aeddf6$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $ffh6R.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $ffh6R.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $ffh6R.aM)(start);
        this._valueRange = (0, $ffh6R.aM)(this.max) - (0, $ffh6R.aM)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $ffh6R.aM)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $02f77014d6aeddf6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $ffh6R.E)(tickOpts.backdropPadding);
        return (0, $ffh6R.v)(tickOpts.font && tickOpts.font.size, (0, $ffh6R.d).font.size) + padding.height;
    }
    return 0;
}
function $02f77014d6aeddf6$var$measureLabelSize(ctx, font, label) {
    label = (0, $ffh6R.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $ffh6R.aN)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $02f77014d6aeddf6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $02f77014d6aeddf6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $ffh6R.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $ffh6R.a0)(opts.font);
        const textSize = $02f77014d6aeddf6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $ffh6R.ay)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $ffh6R.U)(angleRadians));
        const hLimits = $02f77014d6aeddf6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $02f77014d6aeddf6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $02f77014d6aeddf6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $02f77014d6aeddf6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $02f77014d6aeddf6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $02f77014d6aeddf6$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $ffh6R.U)((0, $ffh6R.ay)(pointLabelPosition.angle + (0, $ffh6R.H))));
    const y = $02f77014d6aeddf6$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $02f77014d6aeddf6$var$getTextAlignForAngle(angle);
    const left = $02f77014d6aeddf6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $02f77014d6aeddf6$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $ffh6R.C)({
        x: left,
        y: top
    }, area) || (0, $ffh6R.C)({
        x: left,
        y: bottom
    }, area) || (0, $ffh6R.C)({
        x: right,
        y: top
    }, area) || (0, $ffh6R.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $02f77014d6aeddf6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $02f77014d6aeddf6$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $ffh6R.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $02f77014d6aeddf6$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = $02f77014d6aeddf6$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $02f77014d6aeddf6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $02f77014d6aeddf6$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $02f77014d6aeddf6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $02f77014d6aeddf6$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $ffh6R.k)(backdropColor)) {
        const borderRadius = (0, $ffh6R.aw)(opts.borderRadius);
        const padding = (0, $ffh6R.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $ffh6R.au)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $02f77014d6aeddf6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $02f77014d6aeddf6$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $ffh6R.a0)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $ffh6R.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $02f77014d6aeddf6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $ffh6R.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $02f77014d6aeddf6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $02f77014d6aeddf6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $02f77014d6aeddf6$var$createPointLabelContext(parent, index, label) {
    return (0, $ffh6R.j)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $02f77014d6aeddf6$export$cfafc36d95386d38 extends $02f77014d6aeddf6$var$LinearScaleBase {
    static id = "radialLinear";
    static defaults = {
        display: true,
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $ffh6R.aL).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    };
    static descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $ffh6R.E)($02f77014d6aeddf6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $ffh6R.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $ffh6R.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $02f77014d6aeddf6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $02f77014d6aeddf6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $ffh6R.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $02f77014d6aeddf6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $ffh6R.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $ffh6R.ay)(index * angleMultiplier + (0, $ffh6R.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $ffh6R.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $ffh6R.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $02f77014d6aeddf6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $ffh6R.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $02f77014d6aeddf6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $02f77014d6aeddf6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $02f77014d6aeddf6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $ffh6R.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $ffh6R.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $ffh6R.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $02f77014d6aeddf6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $02f77014d6aeddf6$var$UNITS = /* #__PURE__ */ Object.keys($02f77014d6aeddf6$var$INTERVALS);
function $02f77014d6aeddf6$var$sorter(a, b) {
    return a - b;
}
function $02f77014d6aeddf6$var$parse(scale, input) {
    if ((0, $ffh6R.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $ffh6R.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $ffh6R.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $02f77014d6aeddf6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $02f77014d6aeddf6$var$UNITS.length;
    for(let i = $02f77014d6aeddf6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $02f77014d6aeddf6$var$INTERVALS[$02f77014d6aeddf6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $02f77014d6aeddf6$var$UNITS[i];
    }
    return $02f77014d6aeddf6$var$UNITS[ilen - 1];
}
function $02f77014d6aeddf6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $02f77014d6aeddf6$var$UNITS.length - 1; i >= $02f77014d6aeddf6$var$UNITS.indexOf(minUnit); i--){
        const unit = $02f77014d6aeddf6$var$UNITS[i];
        if ($02f77014d6aeddf6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $02f77014d6aeddf6$var$UNITS[minUnit ? $02f77014d6aeddf6$var$UNITS.indexOf(minUnit) : 0];
}
function $02f77014d6aeddf6$var$determineMajorUnit(unit) {
    for(let i = $02f77014d6aeddf6$var$UNITS.indexOf(unit) + 1, ilen = $02f77014d6aeddf6$var$UNITS.length; i < ilen; ++i){
        if ($02f77014d6aeddf6$var$INTERVALS[$02f77014d6aeddf6$var$UNITS[i]].common) return $02f77014d6aeddf6$var$UNITS[i];
    }
}
function $02f77014d6aeddf6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $ffh6R.aP)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $02f77014d6aeddf6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $02f77014d6aeddf6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $02f77014d6aeddf6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $02f77014d6aeddf6$export$a894c72689ff3ec extends $02f77014d6aeddf6$export$d60cfc58d3c358b6 {
    static id = "time";
    static defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $02f77014d6aeddf6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $ffh6R.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $02f77014d6aeddf6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $ffh6R.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $ffh6R.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $ffh6R.aO)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $02f77014d6aeddf6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $02f77014d6aeddf6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $02f77014d6aeddf6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $02f77014d6aeddf6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $ffh6R.S)(start, 0, limit);
        end = (0, $ffh6R.S)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $02f77014d6aeddf6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $ffh6R.v)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $ffh6R.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$02f77014d6aeddf6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $02f77014d6aeddf6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($02f77014d6aeddf6$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $ffh6R.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $ffh6R.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $02f77014d6aeddf6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($02f77014d6aeddf6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $ffh6R._)(values.sort($02f77014d6aeddf6$var$sorter));
    }
}
function $02f77014d6aeddf6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $ffh6R.B)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $ffh6R.B)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $02f77014d6aeddf6$export$85df64a8eb6dc986 extends $02f77014d6aeddf6$export$a894c72689ff3ec {
    static id = "timeseries";
    static defaults = $02f77014d6aeddf6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $02f77014d6aeddf6$var$interpolate(table, this.min);
        this._tableRange = $02f77014d6aeddf6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($02f77014d6aeddf6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $02f77014d6aeddf6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $02f77014d6aeddf6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $02f77014d6aeddf6$export$29e663ba4d09fe7,
    LinearScale: $02f77014d6aeddf6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $02f77014d6aeddf6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $02f77014d6aeddf6$export$cfafc36d95386d38,
    TimeScale: $02f77014d6aeddf6$export$a894c72689ff3ec,
    TimeSeriesScale: $02f77014d6aeddf6$export$85df64a8eb6dc986
});
const $02f77014d6aeddf6$export$e8959e79e3af550f = [
    $02f77014d6aeddf6$export$a6506504f799c5d5,
    $02f77014d6aeddf6$export$7a5d735b2ab6389d,
    $02f77014d6aeddf6$export$8b3ca321c77fdea6,
    $02f77014d6aeddf6$export$bcac1c16f1530ec2
];

});
parcelRegister("ffh6R", function(module, exports) {

$parcel$export(module.exports, "aF", function () { return $b195875aef0fb1af$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "ac", function () { return $b195875aef0fb1af$export$2219238a014317b0; });
$parcel$export(module.exports, "k", function () { return $b195875aef0fb1af$export$342063e11d6c3cad; });
$parcel$export(module.exports, "b", function () { return $b195875aef0fb1af$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $b195875aef0fb1af$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $b195875aef0fb1af$export$39b482c5e57630a8; });
$parcel$export(module.exports, "O", function () { return $b195875aef0fb1af$export$c4ce752e73470fba; });
$parcel$export(module.exports, "v", function () { return $b195875aef0fb1af$export$90a7f3efeed30595; });
$parcel$export(module.exports, "m", function () { return $b195875aef0fb1af$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $b195875aef0fb1af$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "Q", function () { return $b195875aef0fb1af$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "F", function () { return $b195875aef0fb1af$export$d66501df72047452; });
$parcel$export(module.exports, "ah", function () { return $b195875aef0fb1af$export$995eb9fca571757; });
$parcel$export(module.exports, "a4", function () { return $b195875aef0fb1af$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "ab", function () { return $b195875aef0fb1af$export$555508cbc6add439; });
$parcel$export(module.exports, "f", function () { return $b195875aef0fb1af$export$2d1720544b23b823; });
$parcel$export(module.exports, "a5", function () { return $b195875aef0fb1af$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "h", function () { return $b195875aef0fb1af$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a7", function () { return $b195875aef0fb1af$export$a93c5207d687da10; });
$parcel$export(module.exports, "ag", function () { return $b195875aef0fb1af$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "ai", function () { return $b195875aef0fb1af$export$f38c853ae54ed474; });
$parcel$export(module.exports, "P", function () { return $b195875aef0fb1af$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $b195875aef0fb1af$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $b195875aef0fb1af$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "aM", function () { return $b195875aef0fb1af$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "s", function () { return $b195875aef0fb1af$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aJ", function () { return $b195875aef0fb1af$export$a05254e7c3aeba6e; });
$parcel$export(module.exports, "aH", function () { return $b195875aef0fb1af$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "N", function () { return $b195875aef0fb1af$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "x", function () { return $b195875aef0fb1af$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "aI", function () { return $b195875aef0fb1af$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "aG", function () { return $b195875aef0fb1af$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "t", function () { return $b195875aef0fb1af$export$625550452a3fa3ec; });
$parcel$export(module.exports, "U", function () { return $b195875aef0fb1af$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "aK", function () { return $b195875aef0fb1af$export$23ebac1979863676; });
$parcel$export(module.exports, "D", function () { return $b195875aef0fb1af$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aE", function () { return $b195875aef0fb1af$export$158acd800e1ef08b; });
$parcel$export(module.exports, "ay", function () { return $b195875aef0fb1af$export$28f7fcd39efa255; });
$parcel$export(module.exports, "p", function () { return $b195875aef0fb1af$export$ffb5f4729a158638; });
$parcel$export(module.exports, "S", function () { return $b195875aef0fb1af$export$25ce5a424b770e84; });
$parcel$export(module.exports, "W", function () { return $b195875aef0fb1af$export$71cec2538cb2c617; });
$parcel$export(module.exports, "aj", function () { return $b195875aef0fb1af$export$3b513254972cfc9c; });
$parcel$export(module.exports, "aP", function () { return $b195875aef0fb1af$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "B", function () { return $b195875aef0fb1af$export$ef35774e6d314e91; });
$parcel$export(module.exports, "A", function () { return $b195875aef0fb1af$export$ebd11618f299a286; });
$parcel$export(module.exports, "aO", function () { return $b195875aef0fb1af$export$c03999cb2f36933f; });
$parcel$export(module.exports, "l", function () { return $b195875aef0fb1af$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $b195875aef0fb1af$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $b195875aef0fb1af$export$71511d61b312f219; });
$parcel$export(module.exports, "r", function () { return $b195875aef0fb1af$export$43caf9889c228507; });
$parcel$export(module.exports, "L", function () { return $b195875aef0fb1af$export$61196ced6d74a310; });
$parcel$export(module.exports, "ad", function () { return $b195875aef0fb1af$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "a1", function () { return $b195875aef0fb1af$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $b195875aef0fb1af$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "aB", function () { return $b195875aef0fb1af$export$9d398bebfec1c039; });
$parcel$export(module.exports, "q", function () { return $b195875aef0fb1af$export$9e5f44173e64f162; });
$parcel$export(module.exports, "w", function () { return $b195875aef0fb1af$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "e", function () { return $b195875aef0fb1af$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $b195875aef0fb1af$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $b195875aef0fb1af$export$ae1af26003f05816; });
$parcel$export(module.exports, "aL", function () { return $b195875aef0fb1af$export$91477dc880baac21; });
$parcel$export(module.exports, "a3", function () { return $b195875aef0fb1af$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a6", function () { return $b195875aef0fb1af$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "d", function () { return $b195875aef0fb1af$export$4368d992c4eafac0; });
$parcel$export(module.exports, "V", function () { return $b195875aef0fb1af$export$e7c866399fa523f5; });
$parcel$export(module.exports, "aN", function () { return $b195875aef0fb1af$export$faec65b429be379; });
$parcel$export(module.exports, "X", function () { return $b195875aef0fb1af$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "af", function () { return $b195875aef0fb1af$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "at", function () { return $b195875aef0fb1af$export$493d36ec626b6698; });
$parcel$export(module.exports, "aD", function () { return $b195875aef0fb1af$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "C", function () { return $b195875aef0fb1af$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Y", function () { return $b195875aef0fb1af$export$8743009a87fcb00f; });
$parcel$export(module.exports, "$", function () { return $b195875aef0fb1af$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "ar", function () { return $b195875aef0fb1af$export$d24c54395ce0c509; });
$parcel$export(module.exports, "as", function () { return $b195875aef0fb1af$export$6554612db691658e; });
$parcel$export(module.exports, "Z", function () { return $b195875aef0fb1af$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "au", function () { return $b195875aef0fb1af$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "ak", function () { return $b195875aef0fb1af$export$21579262ef46735b; });
$parcel$export(module.exports, "av", function () { return $b195875aef0fb1af$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "aw", function () { return $b195875aef0fb1af$export$92108d983e8ee699; });
$parcel$export(module.exports, "E", function () { return $b195875aef0fb1af$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "a0", function () { return $b195875aef0fb1af$export$34aec0b863436764; });
$parcel$export(module.exports, "a", function () { return $b195875aef0fb1af$export$407448d2b89b1813; });
$parcel$export(module.exports, "R", function () { return $b195875aef0fb1af$export$db202ddc8be9136; });
$parcel$export(module.exports, "j", function () { return $b195875aef0fb1af$export$35e795649ee09318; });
$parcel$export(module.exports, "a9", function () { return $b195875aef0fb1af$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "a8", function () { return $b195875aef0fb1af$export$c3950d9923825c02; });
$parcel$export(module.exports, "aa", function () { return $b195875aef0fb1af$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $b195875aef0fb1af$export$4a5767248b18ef41; });
$parcel$export(module.exports, "al", function () { return $b195875aef0fb1af$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "M", function () { return $b195875aef0fb1af$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "I", function () { return $b195875aef0fb1af$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $b195875aef0fb1af$export$df995fae86a55f06; });
$parcel$export(module.exports, "G", function () { return $b195875aef0fb1af$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ae", function () { return $b195875aef0fb1af$export$f787f51d84a910ad; });
$parcel$export(module.exports, "K", function () { return $b195875aef0fb1af$export$3466f893ebf79586; });
$parcel$export(module.exports, "J", function () { return $b195875aef0fb1af$export$b4171a6734a65d42; });
$parcel$export(module.exports, "aq", function () { return $b195875aef0fb1af$export$8a5498727ef6be21; });
$parcel$export(module.exports, "ao", function () { return $b195875aef0fb1af$export$7a38258bbe170828; });
$parcel$export(module.exports, "ap", function () { return $b195875aef0fb1af$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "az", function () { return $b195875aef0fb1af$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "aA", function () { return $b195875aef0fb1af$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aC", function () { return $b195875aef0fb1af$export$890c4ad488842ce7; });
$parcel$export(module.exports, "ax", function () { return $b195875aef0fb1af$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "an", function () { return $b195875aef0fb1af$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "am", function () { return $b195875aef0fb1af$export$1a82df3d29112e01; });
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ 
var $87OUJ = parcelRequire("87OUJ");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $b195875aef0fb1af$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $b195875aef0fb1af$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b195875aef0fb1af$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $b195875aef0fb1af$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $b195875aef0fb1af$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $b195875aef0fb1af$export$39b482c5e57630a8(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $b195875aef0fb1af$export$c4ce752e73470fba(value, defaultValue) {
    return $b195875aef0fb1af$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $b195875aef0fb1af$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $b195875aef0fb1af$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const $b195875aef0fb1af$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $b195875aef0fb1af$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $b195875aef0fb1af$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($b195875aef0fb1af$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($b195875aef0fb1af$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $b195875aef0fb1af$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $b195875aef0fb1af$export$d377dcb2b61d6c4e(source) {
    if ($b195875aef0fb1af$export$8b22cf2602fb60ce(source)) return source.map($b195875aef0fb1af$export$d377dcb2b61d6c4e);
    if ($b195875aef0fb1af$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $b195875aef0fb1af$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $b195875aef0fb1af$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $b195875aef0fb1af$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$b195875aef0fb1af$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b195875aef0fb1af$export$23f2a1d2818174ef(tval) && $b195875aef0fb1af$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $b195875aef0fb1af$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $b195875aef0fb1af$export$d377dcb2b61d6c4e(sval);
}
function $b195875aef0fb1af$export$efca4cbe5dd06740(target, source, options) {
    const sources = $b195875aef0fb1af$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$b195875aef0fb1af$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $b195875aef0fb1af$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$b195875aef0fb1af$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $b195875aef0fb1af$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $b195875aef0fb1af$export$efca4cbe5dd06740(target, source, {
        merger: $b195875aef0fb1af$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $b195875aef0fb1af$export$317a3d46287192d8(key, target, source) {
    if (!$b195875aef0fb1af$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($b195875aef0fb1af$export$23f2a1d2818174ef(tval) && $b195875aef0fb1af$export$23f2a1d2818174ef(sval)) $b195875aef0fb1af$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $b195875aef0fb1af$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $b195875aef0fb1af$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $b195875aef0fb1af$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $b195875aef0fb1af$export$9d0e2d13d04f7070(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $b195875aef0fb1af$var$_getKeyResolver(key) {
    const keys = $b195875aef0fb1af$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $b195875aef0fb1af$export$2d1720544b23b823(obj, key) {
    const resolver = $b195875aef0fb1af$var$keyResolvers[key] || ($b195875aef0fb1af$var$keyResolvers[key] = $b195875aef0fb1af$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $b195875aef0fb1af$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $b195875aef0fb1af$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $b195875aef0fb1af$export$a93c5207d687da10 = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $b195875aef0fb1af$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $b195875aef0fb1af$export$f38c853ae54ed474(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $b195875aef0fb1af$export$56c0d5a1e737357d = Math.PI;
const $b195875aef0fb1af$export$971d5caa766a69d7 = 2 * $b195875aef0fb1af$export$56c0d5a1e737357d;
const $b195875aef0fb1af$export$d29e374196577086 = $b195875aef0fb1af$export$971d5caa766a69d7 + $b195875aef0fb1af$export$56c0d5a1e737357d;
const $b195875aef0fb1af$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $b195875aef0fb1af$export$53c86fa97d611818 = $b195875aef0fb1af$export$56c0d5a1e737357d / 180;
const $b195875aef0fb1af$export$7f8ddf7c7c20b3cd = $b195875aef0fb1af$export$56c0d5a1e737357d / 2;
const $b195875aef0fb1af$export$39c1cc7c062529d4 = $b195875aef0fb1af$export$56c0d5a1e737357d / 4;
const $b195875aef0fb1af$export$7a0bdf7d4a91ea88 = $b195875aef0fb1af$export$56c0d5a1e737357d * 2 / 3;
const $b195875aef0fb1af$export$9f4f30ee63539e24 = Math.log10;
const $b195875aef0fb1af$export$2408f22a0fab9ae5 = Math.sign;
function $b195875aef0fb1af$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $b195875aef0fb1af$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $b195875aef0fb1af$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($b195875aef0fb1af$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $b195875aef0fb1af$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $b195875aef0fb1af$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $b195875aef0fb1af$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $b195875aef0fb1af$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $b195875aef0fb1af$export$625550452a3fa3ec(degrees) {
    return degrees * ($b195875aef0fb1af$export$56c0d5a1e737357d / 180);
}
function $b195875aef0fb1af$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $b195875aef0fb1af$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $b195875aef0fb1af$export$23ebac1979863676(x) {
    if (!$b195875aef0fb1af$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $b195875aef0fb1af$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $b195875aef0fb1af$export$56c0d5a1e737357d) angle += $b195875aef0fb1af$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $b195875aef0fb1af$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $b195875aef0fb1af$export$c18d01048907ea92(a, b) {
    return (a - b + $b195875aef0fb1af$export$d29e374196577086) % $b195875aef0fb1af$export$971d5caa766a69d7 - $b195875aef0fb1af$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $b195875aef0fb1af$export$28f7fcd39efa255(a) {
    return (a % $b195875aef0fb1af$export$971d5caa766a69d7 + $b195875aef0fb1af$export$971d5caa766a69d7) % $b195875aef0fb1af$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $b195875aef0fb1af$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $b195875aef0fb1af$export$28f7fcd39efa255(angle);
    const s = $b195875aef0fb1af$export$28f7fcd39efa255(start);
    const e = $b195875aef0fb1af$export$28f7fcd39efa255(end);
    const angleToStart = $b195875aef0fb1af$export$28f7fcd39efa255(s - a);
    const angleToEnd = $b195875aef0fb1af$export$28f7fcd39efa255(e - a);
    const startToAngle = $b195875aef0fb1af$export$28f7fcd39efa255(a - s);
    const endToAngle = $b195875aef0fb1af$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $b195875aef0fb1af$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $b195875aef0fb1af$export$71cec2538cb2c617(value) {
    return $b195875aef0fb1af$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $b195875aef0fb1af$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $b195875aef0fb1af$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $b195875aef0fb1af$export$ef35774e6d314e91 = (table, key, value, last)=>$b195875aef0fb1af$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $b195875aef0fb1af$export$ebd11618f299a286 = (table, key, value)=>$b195875aef0fb1af$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $b195875aef0fb1af$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $b195875aef0fb1af$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $b195875aef0fb1af$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $b195875aef0fb1af$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $b195875aef0fb1af$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $b195875aef0fb1af$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $b195875aef0fb1af$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $b195875aef0fb1af$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $b195875aef0fb1af$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const $b195875aef0fb1af$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $b195875aef0fb1af$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $b195875aef0fb1af$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $b195875aef0fb1af$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $b195875aef0fb1af$export$3c2fa207a37baaea = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $b195875aef0fb1af$export$ce26c07117d59d6a = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $b195875aef0fb1af$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $b195875aef0fb1af$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $b195875aef0fb1af$export$25ce5a424b770e84(Math.min($b195875aef0fb1af$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $b195875aef0fb1af$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $b195875aef0fb1af$export$25ce5a424b770e84(Math.max($b195875aef0fb1af$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $b195875aef0fb1af$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $b195875aef0fb1af$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $b195875aef0fb1af$var$atEdge = (t)=>t === 0 || t === 1;
const $b195875aef0fb1af$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $b195875aef0fb1af$export$971d5caa766a69d7 / p));
const $b195875aef0fb1af$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $b195875aef0fb1af$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $b195875aef0fb1af$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $b195875aef0fb1af$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $b195875aef0fb1af$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($b195875aef0fb1af$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$b195875aef0fb1af$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$b195875aef0fb1af$var$atEdge(t) ? t : $b195875aef0fb1af$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$b195875aef0fb1af$var$atEdge(t) ? t : $b195875aef0fb1af$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $b195875aef0fb1af$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $b195875aef0fb1af$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $b195875aef0fb1af$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $b195875aef0fb1af$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $b195875aef0fb1af$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $b195875aef0fb1af$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $b195875aef0fb1af$export$f96d196f7728bb5(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $b195875aef0fb1af$export$db3b6bfb95261072(value) {
    return $b195875aef0fb1af$export$f96d196f7728bb5(value) ? value : new (0, $87OUJ.Color)(value);
}
function $b195875aef0fb1af$export$738ab4df8bf92ae9(value) {
    return $b195875aef0fb1af$export$f96d196f7728bb5(value) ? value : new (0, $87OUJ.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const $b195875aef0fb1af$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $b195875aef0fb1af$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function $b195875aef0fb1af$var$applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: $b195875aef0fb1af$var$colors
        },
        numbers: {
            type: "number",
            properties: $b195875aef0fb1af$var$numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $b195875aef0fb1af$var$applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $b195875aef0fb1af$var$intlCache = new Map();
function $b195875aef0fb1af$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $b195875aef0fb1af$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $b195875aef0fb1af$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $b195875aef0fb1af$export$ae1af26003f05816(num, locale, options) {
    return $b195875aef0fb1af$var$getNumberFormat(locale, options).format(num);
}
const $b195875aef0fb1af$var$formatters = {
    values (value) {
        return $b195875aef0fb1af$export$8b22cf2602fb60ce(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $b195875aef0fb1af$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $b195875aef0fb1af$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $b195875aef0fb1af$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($b195875aef0fb1af$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $b195875aef0fb1af$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $b195875aef0fb1af$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $b195875aef0fb1af$export$91477dc880baac21 = {
    formatters: $b195875aef0fb1af$var$formatters
};
function $b195875aef0fb1af$var$applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $b195875aef0fb1af$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const $b195875aef0fb1af$export$6559d589eb85fbb6 = Object.create(null);
const $b195875aef0fb1af$export$2e2af4578d910ddf = Object.create(null);
function $b195875aef0fb1af$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $b195875aef0fb1af$var$set(root, scope, values) {
    if (typeof scope === "string") return $b195875aef0fb1af$export$efca4cbe5dd06740($b195875aef0fb1af$var$getScope$1(root, scope), values);
    return $b195875aef0fb1af$export$efca4cbe5dd06740($b195875aef0fb1af$var$getScope$1(root, ""), scope);
}
class $b195875aef0fb1af$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$b195875aef0fb1af$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$b195875aef0fb1af$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$b195875aef0fb1af$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $b195875aef0fb1af$var$set(this, scope, values);
    }
    get(scope) {
        return $b195875aef0fb1af$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $b195875aef0fb1af$var$set($b195875aef0fb1af$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $b195875aef0fb1af$var$set($b195875aef0fb1af$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $b195875aef0fb1af$var$getScope$1(this, scope);
        const targetScopeObject = $b195875aef0fb1af$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($b195875aef0fb1af$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $b195875aef0fb1af$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $b195875aef0fb1af$export$4368d992c4eafac0 = /* #__PURE__ */ new $b195875aef0fb1af$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $b195875aef0fb1af$var$applyAnimationsDefaults,
    $b195875aef0fb1af$var$applyLayoutsDefaults,
    $b195875aef0fb1af$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $b195875aef0fb1af$export$1a8f5705751d8277(font) {
    if (!font || $b195875aef0fb1af$export$342063e11d6c3cad(font.size) || $b195875aef0fb1af$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function $b195875aef0fb1af$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $b195875aef0fb1af$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$b195875aef0fb1af$export$8b22cf2602fb60ce(thing)) longest = $b195875aef0fb1af$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($b195875aef0fb1af$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$b195875aef0fb1af$export$8b22cf2602fb60ce(nestedThing)) longest = $b195875aef0fb1af$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $b195875aef0fb1af$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $b195875aef0fb1af$export$c9170ad7d4cd7e57(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $b195875aef0fb1af$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $b195875aef0fb1af$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $b195875aef0fb1af$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $b195875aef0fb1af$export$53c86fa97d611818;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $b195875aef0fb1af$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $b195875aef0fb1af$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b195875aef0fb1af$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $b195875aef0fb1af$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $b195875aef0fb1af$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $b195875aef0fb1af$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $b195875aef0fb1af$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $b195875aef0fb1af$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $b195875aef0fb1af$export$56c0d5a1e737357d, rad - $b195875aef0fb1af$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $b195875aef0fb1af$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $b195875aef0fb1af$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $b195875aef0fb1af$export$7f8ddf7c7c20b3cd, rad + $b195875aef0fb1af$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $b195875aef0fb1af$export$39c1cc7c062529d4;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $b195875aef0fb1af$export$39c1cc7c062529d4;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $b195875aef0fb1af$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $b195875aef0fb1af$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $b195875aef0fb1af$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $b195875aef0fb1af$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $b195875aef0fb1af$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $b195875aef0fb1af$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $b195875aef0fb1af$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$b195875aef0fb1af$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $b195875aef0fb1af$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $b195875aef0fb1af$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $b195875aef0fb1af$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $b195875aef0fb1af$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $b195875aef0fb1af$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $b195875aef0fb1af$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$b195875aef0fb1af$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $b195875aef0fb1af$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $b195875aef0fb1af$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $b195875aef0fb1af$export$56c0d5a1e737357d, $b195875aef0fb1af$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $b195875aef0fb1af$export$56c0d5a1e737357d, $b195875aef0fb1af$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $b195875aef0fb1af$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$b195875aef0fb1af$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $b195875aef0fb1af$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $b195875aef0fb1af$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $b195875aef0fb1af$export$8c78c7c36408ea29(value, size) {
    const matches = ("" + value).match($b195875aef0fb1af$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $b195875aef0fb1af$var$numberOrZero = (v)=>+v || 0;
function $b195875aef0fb1af$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $b195875aef0fb1af$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $b195875aef0fb1af$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$b195875aef0fb1af$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $b195875aef0fb1af$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $b195875aef0fb1af$export$d66dc83d8cfc8dd(value) {
    return $b195875aef0fb1af$export$21579262ef46735b(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $b195875aef0fb1af$export$92108d983e8ee699(value) {
    return $b195875aef0fb1af$export$21579262ef46735b(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $b195875aef0fb1af$export$a9c23c6ac3fc3eca(value) {
    const obj = $b195875aef0fb1af$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $b195875aef0fb1af$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $b195875aef0fb1af$export$4368d992c4eafac0.font;
    let size = $b195875aef0fb1af$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $b195875aef0fb1af$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($b195875aef0fb1af$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $b195875aef0fb1af$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $b195875aef0fb1af$export$8c78c7c36408ea29($b195875aef0fb1af$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $b195875aef0fb1af$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $b195875aef0fb1af$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $b195875aef0fb1af$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $b195875aef0fb1af$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $b195875aef0fb1af$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $b195875aef0fb1af$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $b195875aef0fb1af$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $b195875aef0fb1af$export$a9c996f45e5784d0(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = $b195875aef0fb1af$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$b195875aef0fb1af$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $b195875aef0fb1af$var$_cached(target, prop, ()=>$b195875aef0fb1af$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $b195875aef0fb1af$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $b195875aef0fb1af$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $b195875aef0fb1af$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $b195875aef0fb1af$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$b195875aef0fb1af$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$b195875aef0fb1af$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $b195875aef0fb1af$var$_cached(target, prop, ()=>$b195875aef0fb1af$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $b195875aef0fb1af$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $b195875aef0fb1af$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $b195875aef0fb1af$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $b195875aef0fb1af$var$readKey = (prefix, name)=>prefix ? prefix + $b195875aef0fb1af$export$a8550f7dbe79f93a(name) : name;
const $b195875aef0fb1af$var$needsSubResolver = (prop, value)=>$b195875aef0fb1af$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $b195875aef0fb1af$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $b195875aef0fb1af$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($b195875aef0fb1af$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $b195875aef0fb1af$var$_resolveScriptable(prop, value, target, receiver);
    if ($b195875aef0fb1af$export$8b22cf2602fb60ce(value) && value.length) value = $b195875aef0fb1af$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($b195875aef0fb1af$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $b195875aef0fb1af$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $b195875aef0fb1af$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($b195875aef0fb1af$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $b195875aef0fb1af$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $b195875aef0fb1af$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if ($b195875aef0fb1af$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $b195875aef0fb1af$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($b195875aef0fb1af$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $b195875aef0fb1af$var$resolveFallback(fallback, prop, value) {
    return $b195875aef0fb1af$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $b195875aef0fb1af$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $b195875aef0fb1af$export$2d1720544b23b823(parent, key) : undefined;
function $b195875aef0fb1af$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $b195875aef0fb1af$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $b195875aef0fb1af$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $b195875aef0fb1af$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $b195875aef0fb1af$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $b195875aef0fb1af$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = $b195875aef0fb1af$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $b195875aef0fb1af$export$a9c996f45e5784d0(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$b195875aef0fb1af$var$subGetTarget(resolver, prop, value));
}
function $b195875aef0fb1af$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $b195875aef0fb1af$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $b195875aef0fb1af$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($b195875aef0fb1af$export$8b22cf2602fb60ce(target) && $b195875aef0fb1af$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $b195875aef0fb1af$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $b195875aef0fb1af$var$_resolve($b195875aef0fb1af$var$readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return $b195875aef0fb1af$var$needsSubResolver(prop, value) ? $b195875aef0fb1af$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $b195875aef0fb1af$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function $b195875aef0fb1af$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $b195875aef0fb1af$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $b195875aef0fb1af$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $b195875aef0fb1af$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($b195875aef0fb1af$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $b195875aef0fb1af$var$EPSILON = Number.EPSILON || 1e-14;
const $b195875aef0fb1af$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $b195875aef0fb1af$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $b195875aef0fb1af$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $b195875aef0fb1af$export$158acd800e1ef08b(current, previous);
    const d12 = $b195875aef0fb1af$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $b195875aef0fb1af$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $b195875aef0fb1af$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $b195875aef0fb1af$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($b195875aef0fb1af$export$a05254e7c3aeba6e(deltaK[i], 0, $b195875aef0fb1af$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $b195875aef0fb1af$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $b195875aef0fb1af$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $b195875aef0fb1af$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b195875aef0fb1af$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $b195875aef0fb1af$export$527e9aa3390079e9(points, indexAxis = "x") {
    const valueAxis = $b195875aef0fb1af$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $b195875aef0fb1af$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $b195875aef0fb1af$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $b195875aef0fb1af$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $b195875aef0fb1af$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $b195875aef0fb1af$var$monotoneAdjust(points, deltaK, mK);
    $b195875aef0fb1af$var$monotoneCompute(points, mK, indexAxis);
}
function $b195875aef0fb1af$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $b195875aef0fb1af$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $b195875aef0fb1af$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $b195875aef0fb1af$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $b195875aef0fb1af$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $b195875aef0fb1af$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $b195875aef0fb1af$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $b195875aef0fb1af$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $b195875aef0fb1af$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $b195875aef0fb1af$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $b195875aef0fb1af$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $b195875aef0fb1af$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $b195875aef0fb1af$export$3a1a48c8f6ef640e() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function $b195875aef0fb1af$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $b195875aef0fb1af$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $b195875aef0fb1af$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $b195875aef0fb1af$export$a17c37559e1db147(el, property) {
    return $b195875aef0fb1af$var$getComputedStyle(el).getPropertyValue(property);
}
const $b195875aef0fb1af$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $b195875aef0fb1af$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $b195875aef0fb1af$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $b195875aef0fb1af$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $b195875aef0fb1af$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($b195875aef0fb1af$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $b195875aef0fb1af$export$df995fae86a55f06(event, chart) {
    if ("native" in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $b195875aef0fb1af$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $b195875aef0fb1af$var$getPositionedStyle(style, "padding");
    const borders = $b195875aef0fb1af$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $b195875aef0fb1af$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $b195875aef0fb1af$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $b195875aef0fb1af$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $b195875aef0fb1af$var$getComputedStyle(container);
            const containerBorder = $b195875aef0fb1af$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $b195875aef0fb1af$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $b195875aef0fb1af$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $b195875aef0fb1af$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $b195875aef0fb1af$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $b195875aef0fb1af$export$2ec5befb9e6c97d4
    };
}
const $b195875aef0fb1af$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $b195875aef0fb1af$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $b195875aef0fb1af$var$getComputedStyle(canvas);
    const margins = $b195875aef0fb1af$var$getPositionedStyle(style, "margin");
    const maxWidth = $b195875aef0fb1af$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $b195875aef0fb1af$export$2ec5befb9e6c97d4;
    const maxHeight = $b195875aef0fb1af$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $b195875aef0fb1af$export$2ec5befb9e6c97d4;
    const containerSize = $b195875aef0fb1af$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $b195875aef0fb1af$var$getPositionedStyle(style, "border", "width");
        const paddings = $b195875aef0fb1af$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $b195875aef0fb1af$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $b195875aef0fb1af$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $b195875aef0fb1af$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $b195875aef0fb1af$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $b195875aef0fb1af$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $b195875aef0fb1af$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($b195875aef0fb1af$export$3a1a48c8f6ef640e()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $b195875aef0fb1af$export$b4171a6734a65d42(element, property) {
    const value = $b195875aef0fb1af$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $b195875aef0fb1af$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $b195875aef0fb1af$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $b195875aef0fb1af$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $b195875aef0fb1af$export$8a5498727ef6be21(p1, cp1, t);
    const b = $b195875aef0fb1af$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $b195875aef0fb1af$export$8a5498727ef6be21(cp2, p2, t);
    const d = $b195875aef0fb1af$export$8a5498727ef6be21(a, b, t);
    const e = $b195875aef0fb1af$export$8a5498727ef6be21(b, c, t);
    return $b195875aef0fb1af$export$8a5498727ef6be21(d, e, t);
}
const $b195875aef0fb1af$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $b195875aef0fb1af$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $b195875aef0fb1af$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $b195875aef0fb1af$var$getRightToLeftAdapter(rectX, width) : $b195875aef0fb1af$var$getLeftToRightAdapter();
}
function $b195875aef0fb1af$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $b195875aef0fb1af$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $b195875aef0fb1af$var$propertyFn(property) {
    if (property === "angle") return {
        between: $b195875aef0fb1af$export$ffb5f4729a158638,
        compare: $b195875aef0fb1af$export$c18d01048907ea92,
        normalize: $b195875aef0fb1af$export$28f7fcd39efa255
    };
    return {
        between: $b195875aef0fb1af$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $b195875aef0fb1af$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $b195875aef0fb1af$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $b195875aef0fb1af$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $b195875aef0fb1af$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $b195875aef0fb1af$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $b195875aef0fb1af$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($b195875aef0fb1af$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($b195875aef0fb1af$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $b195875aef0fb1af$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $b195875aef0fb1af$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $b195875aef0fb1af$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $b195875aef0fb1af$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $b195875aef0fb1af$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $b195875aef0fb1af$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $b195875aef0fb1af$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $b195875aef0fb1af$var$splitByStyles(line, $b195875aef0fb1af$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $b195875aef0fb1af$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $b195875aef0fb1af$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $b195875aef0fb1af$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $b195875aef0fb1af$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $b195875aef0fb1af$var$readStyle(segmentOptions.setContext($b195875aef0fb1af$export$35e795649ee09318(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($b195875aef0fb1af$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $b195875aef0fb1af$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $b195875aef0fb1af$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$b195875aef0fb1af$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

});
parcelRegister("87OUJ", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $5ea678a7007ca647$export$892596cec99bc70e; });
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $5ea678a7007ca647$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $5ea678a7007ca647$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $5ea678a7007ca647$export$bcc6e673dfa14d36(v) {
    return $5ea678a7007ca647$export$837ba5c449269406($5ea678a7007ca647$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $5ea678a7007ca647$export$869b26d4e1bbdb63(v) {
    return $5ea678a7007ca647$export$837ba5c449269406($5ea678a7007ca647$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $5ea678a7007ca647$export$ed9bd8dcaeba14f6(v) {
    return $5ea678a7007ca647$export$837ba5c449269406($5ea678a7007ca647$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $5ea678a7007ca647$export$dbf961a8d278dbef(v) {
    return $5ea678a7007ca647$export$837ba5c449269406($5ea678a7007ca647$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $5ea678a7007ca647$export$aa35ef1f24408ab9(v) {
    return $5ea678a7007ca647$export$837ba5c449269406($5ea678a7007ca647$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $5ea678a7007ca647$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $5ea678a7007ca647$var$hex = [
    ..."0123456789ABCDEF"
];
const $5ea678a7007ca647$var$h1 = (b)=>$5ea678a7007ca647$var$hex[b & 0xF];
const $5ea678a7007ca647$var$h2 = (b)=>$5ea678a7007ca647$var$hex[(b & 0xF0) >> 4] + $5ea678a7007ca647$var$hex[b & 0xF];
const $5ea678a7007ca647$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $5ea678a7007ca647$var$isShort = (v)=>$5ea678a7007ca647$var$eq(v.r) && $5ea678a7007ca647$var$eq(v.g) && $5ea678a7007ca647$var$eq(v.b) && $5ea678a7007ca647$var$eq(v.a);
function $5ea678a7007ca647$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $5ea678a7007ca647$var$map$1[str[1]] * 17,
            g: 255 & $5ea678a7007ca647$var$map$1[str[2]] * 17,
            b: 255 & $5ea678a7007ca647$var$map$1[str[3]] * 17,
            a: len === 5 ? $5ea678a7007ca647$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $5ea678a7007ca647$var$map$1[str[1]] << 4 | $5ea678a7007ca647$var$map$1[str[2]],
            g: $5ea678a7007ca647$var$map$1[str[3]] << 4 | $5ea678a7007ca647$var$map$1[str[4]],
            b: $5ea678a7007ca647$var$map$1[str[5]] << 4 | $5ea678a7007ca647$var$map$1[str[6]],
            a: len === 9 ? $5ea678a7007ca647$var$map$1[str[7]] << 4 | $5ea678a7007ca647$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $5ea678a7007ca647$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $5ea678a7007ca647$export$1b06654353ef9f67(v) {
    var f = $5ea678a7007ca647$var$isShort(v) ? $5ea678a7007ca647$var$h1 : $5ea678a7007ca647$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $5ea678a7007ca647$var$alpha(v.a, f) : undefined;
}
const $5ea678a7007ca647$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5ea678a7007ca647$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $5ea678a7007ca647$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $5ea678a7007ca647$var$hwb2rgbn(h, w, b) {
    const rgb = $5ea678a7007ca647$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $5ea678a7007ca647$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $5ea678a7007ca647$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $5ea678a7007ca647$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $5ea678a7007ca647$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($5ea678a7007ca647$export$ed9bd8dcaeba14f6);
}
function $5ea678a7007ca647$export$4c15bd42559b811d(h, s, l) {
    return $5ea678a7007ca647$var$calln($5ea678a7007ca647$var$hsl2rgbn, h, s, l);
}
function $5ea678a7007ca647$export$e2710022c70fc9ee(h, w, b) {
    return $5ea678a7007ca647$var$calln($5ea678a7007ca647$var$hwb2rgbn, h, w, b);
}
function $5ea678a7007ca647$export$b785a357c84e4a04(h, s, v) {
    return $5ea678a7007ca647$var$calln($5ea678a7007ca647$var$hsv2rgbn, h, s, v);
}
function $5ea678a7007ca647$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $5ea678a7007ca647$export$5e91288c399be4f9(str) {
    const m = $5ea678a7007ca647$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $5ea678a7007ca647$export$bcc6e673dfa14d36(+m[5]) : $5ea678a7007ca647$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $5ea678a7007ca647$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $5ea678a7007ca647$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === "hsv") v = $5ea678a7007ca647$export$b785a357c84e4a04(h, p1, p2);
    else v = $5ea678a7007ca647$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $5ea678a7007ca647$export$bb628a54ab399bc9(v, deg) {
    var h = $5ea678a7007ca647$export$b5ba70b240f8f7f(v);
    h[0] = $5ea678a7007ca647$var$hue(h[0] + deg);
    h = $5ea678a7007ca647$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $5ea678a7007ca647$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $5ea678a7007ca647$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $5ea678a7007ca647$export$aa35ef1f24408ab9(a[1]);
    const l = $5ea678a7007ca647$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$5ea678a7007ca647$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $5ea678a7007ca647$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $5ea678a7007ca647$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $5ea678a7007ca647$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($5ea678a7007ca647$var$names$1);
    const tkeys = Object.keys($5ea678a7007ca647$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $5ea678a7007ca647$var$map[k]);
        }
        k = parseInt($5ea678a7007ca647$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $5ea678a7007ca647$var$names;
function $5ea678a7007ca647$export$b2f06b640faad956(str) {
    if (!$5ea678a7007ca647$var$names) {
        $5ea678a7007ca647$var$names = $5ea678a7007ca647$var$unpack();
        $5ea678a7007ca647$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $5ea678a7007ca647$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $5ea678a7007ca647$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5ea678a7007ca647$export$91aedb20f296e541(str) {
    const m = $5ea678a7007ca647$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $5ea678a7007ca647$export$bcc6e673dfa14d36(v) : $5ea678a7007ca647$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $5ea678a7007ca647$export$bcc6e673dfa14d36(r) : $5ea678a7007ca647$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $5ea678a7007ca647$export$bcc6e673dfa14d36(g) : $5ea678a7007ca647$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $5ea678a7007ca647$export$bcc6e673dfa14d36(b) : $5ea678a7007ca647$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $5ea678a7007ca647$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$5ea678a7007ca647$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $5ea678a7007ca647$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $5ea678a7007ca647$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $5ea678a7007ca647$var$interpolate(rgb1, rgb2, t) {
    const r = $5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb1.r));
    const g = $5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb1.g));
    const b = $5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $5ea678a7007ca647$export$ed9bd8dcaeba14f6($5ea678a7007ca647$var$to(r + t * ($5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $5ea678a7007ca647$export$ed9bd8dcaeba14f6($5ea678a7007ca647$var$to(g + t * ($5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $5ea678a7007ca647$export$ed9bd8dcaeba14f6($5ea678a7007ca647$var$to(b + t * ($5ea678a7007ca647$var$from($5ea678a7007ca647$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $5ea678a7007ca647$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $5ea678a7007ca647$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $5ea678a7007ca647$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $5ea678a7007ca647$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $5ea678a7007ca647$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $5ea678a7007ca647$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $5ea678a7007ca647$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $5ea678a7007ca647$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $5ea678a7007ca647$var$functionParse(str) {
    if (str.charAt(0) === "r") return $5ea678a7007ca647$export$91aedb20f296e541(str);
    return $5ea678a7007ca647$export$5e91288c399be4f9(str);
}
class $5ea678a7007ca647$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $5ea678a7007ca647$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $5ea678a7007ca647$var$fromObject(input);
        else if (type === "string") v = $5ea678a7007ca647$export$625a38b961e8b5e9(input) || $5ea678a7007ca647$export$b2f06b640faad956(input) || $5ea678a7007ca647$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $5ea678a7007ca647$var$clone(this._rgb);
        if (v) v.a = $5ea678a7007ca647$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $5ea678a7007ca647$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $5ea678a7007ca647$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $5ea678a7007ca647$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $5ea678a7007ca647$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $5ea678a7007ca647$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $5ea678a7007ca647$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $5ea678a7007ca647$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $5ea678a7007ca647$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $5ea678a7007ca647$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $5ea678a7007ca647$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $5ea678a7007ca647$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $5ea678a7007ca647$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $5ea678a7007ca647$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $5ea678a7007ca647$export$2e2bcd8739ae039(input) {
    return new $5ea678a7007ca647$export$892596cec99bc70e(input);
}

});



parcelRegister("hmFZG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca4510e00875404c$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $ca4510e00875404c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("9xbCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f103646320f57cc$export$2e2bcd8739ae039; });
function $6f103646320f57cc$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("922t6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69363727f9474ca8$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");

var $7GcJU = parcelRequire("7GcJU");
function $69363727f9474ca8$export$2e2bcd8739ae039(argument) {
    (0, $7GcJU.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $7gMEg.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("7gMEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54afc39096c3da09$export$2e2bcd8739ae039; });
function $54afc39096c3da09$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $54afc39096c3da09$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $54afc39096c3da09$export$2e2bcd8739ae039(o);
}

});

parcelRegister("7GcJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5976566d6ce4aac7$export$2e2bcd8739ae039; });
function $5976566d6ce4aac7$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});



parcelRegister("7mQI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55d379949d0826e1$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $fijNH = parcelRequire("fijNH");

var $7GcJU = parcelRequire("7GcJU");
var $55d379949d0826e1$var$MILLISECONDS_IN_HOUR = 3600000;
function $55d379949d0826e1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $fijNH.default)(dirtyDate, amount * $55d379949d0826e1$var$MILLISECONDS_IN_HOUR);
}

});
parcelRegister("fijNH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b227e5743cd15469$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $b227e5743cd15469$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var timestamp = (0, $922t6.default)(dirtyDate).getTime();
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("2m9Ca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b751816caf0410c$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $fijNH = parcelRequire("fijNH");

var $7GcJU = parcelRequire("7GcJU");
var $1b751816caf0410c$var$MILLISECONDS_IN_MINUTE = 60000;
function $1b751816caf0410c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $fijNH.default)(dirtyDate, amount * $1b751816caf0410c$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("9ega8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b81f55fb57391a3$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $6b81f55fb57391a3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("60HcZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4604427e0c13d02b$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $9ega8 = parcelRequire("9ega8");

var $7GcJU = parcelRequire("7GcJU");
function $4604427e0c13d02b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    var months = amount * 3;
    return (0, $9ega8.default)(dirtyDate, months);
}

});

parcelRegister("kahi4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae22753fbf6663a$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $fijNH = parcelRequire("fijNH");

var $7GcJU = parcelRequire("7GcJU");
function $eae22753fbf6663a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $fijNH.default)(dirtyDate, amount * 1000);
}

});

parcelRegister("xO2rg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0659e5c0c0823169$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $hmFZG = parcelRequire("hmFZG");

var $7GcJU = parcelRequire("7GcJU");
function $0659e5c0c0823169$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $hmFZG.default)(dirtyDate, days);
}

});

parcelRegister("c5mhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc73bbfd741d5e5$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $9ega8 = parcelRequire("9ega8");

var $7GcJU = parcelRequire("7GcJU");
function $8cc73bbfd741d5e5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $9ega8.default)(dirtyDate, amount * 12);
}

});

parcelRegister("dpfnB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c298a456aad812d$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $goMAP = parcelRequire("goMAP");

var $7GcJU = parcelRequire("7GcJU");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $9c298a456aad812d$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $9c298a456aad812d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    var sign = $9c298a456aad812d$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $goMAP.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($9c298a456aad812d$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("goMAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf0494ce90eb30af$export$2e2bcd8739ae039; });

var $8M12Y = parcelRequire("8M12Y");

var $6Wotx = parcelRequire("6Wotx");

var $7GcJU = parcelRequire("7GcJU");
var $bf0494ce90eb30af$var$MILLISECONDS_IN_DAY = 86400000;
function $bf0494ce90eb30af$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var startOfDayLeft = (0, $6Wotx.default)(dirtyDateLeft);
    var startOfDayRight = (0, $6Wotx.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $8M12Y.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $8M12Y.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $bf0494ce90eb30af$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("8M12Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66339e572baa62ee$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $66339e572baa62ee$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("6Wotx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50db252622568c88$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $50db252622568c88$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("7m9gT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55b1c798124a700b$export$2e2bcd8739ae039; });

var $b53tR = parcelRequire("b53tR");

var $DHFLy = parcelRequire("DHFLy");

var $7GcJU = parcelRequire("7GcJU");

var $76jtk = parcelRequire("76jtk");
function $55b1c798124a700b$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $7GcJU.default)(2, arguments);
    var diff = (0, $DHFLy.default)(dateLeft, dateRight) / (0, $b53tR.millisecondsInHour);
    return (0, $76jtk.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("b53tR", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $8112dc8003d27018$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $8112dc8003d27018$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $8112dc8003d27018$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $8112dc8003d27018$export$dfd9b671c89acc8e = 7;
var $8112dc8003d27018$export$3913210603d8e9ae = 365.2425;
var $8112dc8003d27018$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $8112dc8003d27018$export$91246f0b9bd9beff = 60000;
var $8112dc8003d27018$export$7f72910d6dfd237a = 3600000;
var $8112dc8003d27018$export$397c2d5776aa9055 = 1000;
var $8112dc8003d27018$export$4dec998e48f9c246 = -$8112dc8003d27018$export$81caae6e1cc7a622;
var $8112dc8003d27018$export$f2f5ae5a8e2d8f9f = 60;
var $8112dc8003d27018$export$3c58128db900d44e = 3;
var $8112dc8003d27018$export$80d7e435f744f319 = 12;
var $8112dc8003d27018$export$4db7641526e3241f = 4;
var $8112dc8003d27018$export$698aec755e92c695 = 3600;
var $8112dc8003d27018$export$a77c1a7ebebe2a5a = 60;
var $8112dc8003d27018$export$815a9362476d2fe3 = $8112dc8003d27018$export$698aec755e92c695 * 24;
var $8112dc8003d27018$export$34804a017b31e2fe = $8112dc8003d27018$export$815a9362476d2fe3 * 7;
var $8112dc8003d27018$export$7271e9e3478110d1 = $8112dc8003d27018$export$815a9362476d2fe3 * $8112dc8003d27018$export$3913210603d8e9ae;
var $8112dc8003d27018$export$8e6600bbdee7dabb = $8112dc8003d27018$export$7271e9e3478110d1 / 12;
var $8112dc8003d27018$export$be1dccf2de902d31 = $8112dc8003d27018$export$8e6600bbdee7dabb * 3;

});

parcelRegister("DHFLy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0775851c49a21798$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $0775851c49a21798$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $7GcJU.default)(2, arguments);
    return (0, $922t6.default)(dateLeft).getTime() - (0, $922t6.default)(dateRight).getTime();
}

});

parcelRegister("76jtk", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $52b832ae00f71d7a$export$b6474a47258c1211; });
var $52b832ae00f71d7a$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $52b832ae00f71d7a$var$defaultRoundingMethod = "trunc";
function $52b832ae00f71d7a$export$b6474a47258c1211(method) {
    return method ? $52b832ae00f71d7a$var$roundingMap[method] : $52b832ae00f71d7a$var$roundingMap[$52b832ae00f71d7a$var$defaultRoundingMethod];
}

});


parcelRegister("h3gWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c69fdc376c9d7f9d$export$2e2bcd8739ae039; });

var $b53tR = parcelRequire("b53tR");

var $DHFLy = parcelRequire("DHFLy");

var $7GcJU = parcelRequire("7GcJU");

var $76jtk = parcelRequire("76jtk");
function $c69fdc376c9d7f9d$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $7GcJU.default)(2, arguments);
    var diff = (0, $DHFLy.default)(dateLeft, dateRight) / (0, $b53tR.millisecondsInMinute);
    return (0, $76jtk.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("9VIW7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73ac4b61771efc48$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $30QlX = parcelRequire("30QlX");

var $8scIC = parcelRequire("8scIC");

var $7GcJU = parcelRequire("7GcJU");

var $9V4ch = parcelRequire("9V4ch");
function $73ac4b61771efc48$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    var sign = (0, $8scIC.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $30QlX.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $8scIC.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $9V4ch.default)((0, $922t6.default)(dirtyDateLeft)) && difference === 1 && (0, $8scIC.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("30QlX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2319fb7231f8b094$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $2319fb7231f8b094$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("8scIC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $627acdeb01528328$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $627acdeb01528328$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("9V4ch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $738cb163341572fd$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $90NQT = parcelRequire("90NQT");

var $d7PJE = parcelRequire("d7PJE");

var $7GcJU = parcelRequire("7GcJU");
function $738cb163341572fd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    return (0, $90NQT.default)(date).getTime() === (0, $d7PJE.default)(date).getTime();
}

});
parcelRegister("90NQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68fac8c0b8d58863$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $68fac8c0b8d58863$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("d7PJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98e40f58ad9bb9f0$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $98e40f58ad9bb9f0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("fHaeb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6d2ce3478408109$export$2e2bcd8739ae039; });

var $9VIW7 = parcelRequire("9VIW7");

var $7GcJU = parcelRequire("7GcJU");

var $76jtk = parcelRequire("76jtk");
function $b6d2ce3478408109$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $7GcJU.default)(2, arguments);
    var diff = (0, $9VIW7.default)(dateLeft, dateRight) / 3;
    return (0, $76jtk.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("thBP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05805e5755ed00cc$export$2e2bcd8739ae039; });

var $DHFLy = parcelRequire("DHFLy");

var $7GcJU = parcelRequire("7GcJU");

var $76jtk = parcelRequire("76jtk");
function $05805e5755ed00cc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $7GcJU.default)(2, arguments);
    var diff = (0, $DHFLy.default)(dateLeft, dateRight) / 1000;
    return (0, $76jtk.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("3moXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2726ca11c5620a68$export$2e2bcd8739ae039; });

var $dpfnB = parcelRequire("dpfnB");

var $7GcJU = parcelRequire("7GcJU");

var $76jtk = parcelRequire("76jtk");
function $2726ca11c5620a68$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $7GcJU.default)(2, arguments);
    var diff = (0, $dpfnB.default)(dateLeft, dateRight) / 7;
    return (0, $76jtk.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hyGVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc86e8d47be8d350$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $8H0yE = parcelRequire("8H0yE");

var $8scIC = parcelRequire("8scIC");

var $7GcJU = parcelRequire("7GcJU");
function $cc86e8d47be8d350$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    var sign = (0, $8scIC.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $8H0yE.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $8scIC.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("8H0yE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6542c5a7a40a3b2e$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $6542c5a7a40a3b2e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7GcJU.default)(2, arguments);
    var dateLeft = (0, $922t6.default)(dirtyDateLeft);
    var dateRight = (0, $922t6.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});


parcelRegister("92mZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $694623a432814cc1$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $694623a432814cc1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setMinutes(59, 59, 999);
    return date;
}

});

parcelRegister("gl4rg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be520cf2eb4e0079$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $be520cf2eb4e0079$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setSeconds(59, 999);
    return date;
}

});

parcelRegister("ipBL5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d677d9d18e77f8a9$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $d677d9d18e77f8a9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("dAj82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e3d79b6b2e24c3f$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $9e3d79b6b2e24c3f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setMilliseconds(999);
    return date;
}

});

parcelRegister("dWX9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a27e94c6f8aeb201$export$2e2bcd8739ae039; });

var $1anZ2 = parcelRequire("1anZ2");

var $922t6 = parcelRequire("922t6");

var $9xbCI = parcelRequire("9xbCI");

var $7GcJU = parcelRequire("7GcJU");
function $a27e94c6f8aeb201$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(1, arguments);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var weekStartsOn = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $922t6.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("1anZ2", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $0d995437538c7660$export$430a3269e24b912e; });
var $0d995437538c7660$var$defaultOptions = {};
function $0d995437538c7660$export$430a3269e24b912e() {
    return $0d995437538c7660$var$defaultOptions;
}
function $0d995437538c7660$export$95365be1b0704abc(newOptions) {
    $0d995437538c7660$var$defaultOptions = newOptions;
}

});


parcelRegister("khqR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec3a3a3c476fd2df$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $ec3a3a3c476fd2df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("jW4vR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e836ef4618a9533d$export$2e2bcd8739ae039; });

var $lA9bK = parcelRequire("lA9bK");

var $7wI43 = parcelRequire("7wI43");

var $922t6 = parcelRequire("922t6");

var $dQjvk = parcelRequire("dQjvk");

var $A8QNv = parcelRequire("A8QNv");

var $8M12Y = parcelRequire("8M12Y");

var $efJgp = parcelRequire("efJgp");

var $9xbCI = parcelRequire("9xbCI");

var $7GcJU = parcelRequire("7GcJU");

var $1anZ2 = parcelRequire("1anZ2");

var $8iPa2 = parcelRequire("8iPa2");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e836ef4618a9533d$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e836ef4618a9533d$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e836ef4618a9533d$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e836ef4618a9533d$var$doubleQuoteRegExp = /''/g;
var $e836ef4618a9533d$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e836ef4618a9533d$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $7GcJU.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8iPa2.default);
    var firstWeekContainsDate = (0, $9xbCI.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $9xbCI.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $922t6.default)(dirtyDate);
    if (!(0, $lA9bK.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8M12Y.default)(originalDate);
    var utcDate = (0, $7wI43.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e836ef4618a9533d$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $A8QNv.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e836ef4618a9533d$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e836ef4618a9533d$var$cleanEscapedString(substring);
        var formatter = (0, $dQjvk.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $efJgp.isProtectedWeekYearToken)(substring)) (0, $efJgp.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $efJgp.isProtectedDayOfYearToken)(substring)) (0, $efJgp.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e836ef4618a9533d$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $e836ef4618a9533d$var$cleanEscapedString(input) {
    var matched = input.match($e836ef4618a9533d$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e836ef4618a9533d$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lA9bK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb64166cb87f3f74$export$2e2bcd8739ae039; });

var $eNVMn = parcelRequire("eNVMn");

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $fb64166cb87f3f74$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    if (!(0, $eNVMn.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $922t6.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("eNVMn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac7276119e74324f$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");

var $7GcJU = parcelRequire("7GcJU");
function $ac7276119e74324f$export$2e2bcd8739ae039(value) {
    (0, $7GcJU.default)(1, arguments);
    return value instanceof Date || (0, $7gMEg.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRegister("7wI43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57adb3d5e4d8c305$export$2e2bcd8739ae039; });

var $fijNH = parcelRequire("fijNH");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");
function $57adb3d5e4d8c305$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $fijNH.default)(dirtyDate, -amount);
}

});

parcelRegister("dQjvk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a13f42dc21d272e2$export$2e2bcd8739ae039; });

var $ewUrd = parcelRequire("ewUrd");

var $79kgC = parcelRequire("79kgC");

var $4Wdec = parcelRequire("4Wdec");

var $bpUef = parcelRequire("bpUef");

var $eu6SD = parcelRequire("eu6SD");

var $ao2yc = parcelRequire("ao2yc");

var $gTZEy = parcelRequire("gTZEy");
var $a13f42dc21d272e2$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $a13f42dc21d272e2$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $gTZEy.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $eu6SD.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $ao2yc.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $ao2yc.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $4Wdec.default)(date);
        // Padding
        return (0, $ao2yc.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $ao2yc.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $ao2yc.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $ao2yc.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $gTZEy.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $ao2yc.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bpUef.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $ao2yc.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $79kgC.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $ao2yc.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $gTZEy.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $ewUrd.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $ao2yc.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $ao2yc.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $ao2yc.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $ao2yc.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a13f42dc21d272e2$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $gTZEy.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $gTZEy.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ao2yc.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ao2yc.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $gTZEy.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $gTZEy.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $gTZEy.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a13f42dc21d272e2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $a13f42dc21d272e2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a13f42dc21d272e2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a13f42dc21d272e2$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $a13f42dc21d272e2$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a13f42dc21d272e2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a13f42dc21d272e2$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a13f42dc21d272e2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a13f42dc21d272e2$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a13f42dc21d272e2$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $ao2yc.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $ao2yc.default)(timestamp, token.length);
    }
};
function $a13f42dc21d272e2$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $ao2yc.default)(minutes, 2);
}
function $a13f42dc21d272e2$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $ao2yc.default)(Math.abs(offset) / 60, 2);
    }
    return $a13f42dc21d272e2$var$formatTimezone(offset, dirtyDelimiter);
}
function $a13f42dc21d272e2$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $ao2yc.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $ao2yc.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $a13f42dc21d272e2$export$2e2bcd8739ae039 = $a13f42dc21d272e2$var$formatters;

});
parcelRegister("ewUrd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93fd5427dcdc4ee$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
var $a93fd5427dcdc4ee$var$MILLISECONDS_IN_DAY = 86400000;
function $a93fd5427dcdc4ee$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $a93fd5427dcdc4ee$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("79kgC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534918489fc9e0a2$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $16hMD = parcelRequire("16hMD");

var $ftinO = parcelRequire("ftinO");

var $7GcJU = parcelRequire("7GcJU");
var $534918489fc9e0a2$var$MILLISECONDS_IN_WEEK = 604800000;
function $534918489fc9e0a2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var diff = (0, $16hMD.default)(date).getTime() - (0, $ftinO.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $534918489fc9e0a2$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("16hMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd4256688f8af45$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $0cd4256688f8af45$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $922t6.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("ftinO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b437d2f08eeb1bc5$export$2e2bcd8739ae039; });

var $4Wdec = parcelRequire("4Wdec");

var $16hMD = parcelRequire("16hMD");

var $7GcJU = parcelRequire("7GcJU");
function $b437d2f08eeb1bc5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var year = (0, $4Wdec.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $16hMD.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("4Wdec", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3986d7047d88500e$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");

var $16hMD = parcelRequire("16hMD");
function $3986d7047d88500e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $16hMD.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $16hMD.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bpUef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84fda55cb1dfec45$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $3Jc1i = parcelRequire("3Jc1i");

var $6J2wm = parcelRequire("6J2wm");

var $7GcJU = parcelRequire("7GcJU");
var $84fda55cb1dfec45$var$MILLISECONDS_IN_WEEK = 604800000;
function $84fda55cb1dfec45$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var diff = (0, $3Jc1i.default)(date, options).getTime() - (0, $6J2wm.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $84fda55cb1dfec45$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("3Jc1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6ee5fe7e68bdf0$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");

var $1anZ2 = parcelRequire("1anZ2");
function $2b6ee5fe7e68bdf0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(1, arguments);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var weekStartsOn = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $922t6.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6J2wm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e58e6ab012b3557$export$2e2bcd8739ae039; });

var $eu6SD = parcelRequire("eu6SD");

var $7GcJU = parcelRequire("7GcJU");

var $3Jc1i = parcelRequire("3Jc1i");

var $9xbCI = parcelRequire("9xbCI");

var $1anZ2 = parcelRequire("1anZ2");
function $4e58e6ab012b3557$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(1, arguments);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var firstWeekContainsDate = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $eu6SD.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $3Jc1i.default)(firstWeek, options);
    return date;
}

});
parcelRegister("eu6SD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b93450e610e0ef$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");

var $3Jc1i = parcelRequire("3Jc1i");

var $9xbCI = parcelRequire("9xbCI");

var $1anZ2 = parcelRequire("1anZ2");
function $a8b93450e610e0ef$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var firstWeekContainsDate = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3Jc1i.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3Jc1i.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("ao2yc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78fe1fc3e4b1f9cc$export$2e2bcd8739ae039; });
function $78fe1fc3e4b1f9cc$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("gTZEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e19b6e629cd0fe$export$2e2bcd8739ae039; });

var $ao2yc = parcelRequire("ao2yc");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $c4e19b6e629cd0fe$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $ao2yc.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $ao2yc.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $ao2yc.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $ao2yc.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $ao2yc.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $ao2yc.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $ao2yc.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $ao2yc.default)(fractionalSeconds, token.length);
    }
};
var $c4e19b6e629cd0fe$export$2e2bcd8739ae039 = $c4e19b6e629cd0fe$var$formatters;

});


parcelRegister("A8QNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06ca3a724d1f23a4$export$2e2bcd8739ae039; });
var $06ca3a724d1f23a4$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $06ca3a724d1f23a4$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $06ca3a724d1f23a4$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $06ca3a724d1f23a4$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $06ca3a724d1f23a4$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $06ca3a724d1f23a4$var$timeLongFormatter(timePattern, formatLong));
};
var $06ca3a724d1f23a4$var$longFormatters = {
    p: $06ca3a724d1f23a4$var$timeLongFormatter,
    P: $06ca3a724d1f23a4$var$dateTimeLongFormatter
};
var $06ca3a724d1f23a4$export$2e2bcd8739ae039 = $06ca3a724d1f23a4$var$longFormatters;

});

parcelRegister("efJgp", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $a60593d082b7f7a9$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $a60593d082b7f7a9$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $a60593d082b7f7a9$export$8073c1ae88f0e727; });
var $a60593d082b7f7a9$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a60593d082b7f7a9$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a60593d082b7f7a9$export$c6cc36aa33304772(token) {
    return $a60593d082b7f7a9$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a60593d082b7f7a9$export$c6b49d6dceb604a1(token) {
    return $a60593d082b7f7a9$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a60593d082b7f7a9$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("8iPa2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60b7b0af2dd218bf$export$2e2bcd8739ae039; });

var $4PKKQ = parcelRequire("4PKKQ");
var $60b7b0af2dd218bf$export$2e2bcd8739ae039 = (0, $4PKKQ.default);

});


parcelRegister("bkTjt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $840c77f8bd5af4d6$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");

var $fr6PO = parcelRequire("fr6PO");

var $8iPa2 = parcelRequire("8iPa2");

var $7wI43 = parcelRequire("7wI43");

var $922t6 = parcelRequire("922t6");

var $5UPpA = parcelRequire("5UPpA");

var $A8QNv = parcelRequire("A8QNv");

var $8M12Y = parcelRequire("8M12Y");

var $efJgp = parcelRequire("efJgp");

var $9xbCI = parcelRequire("9xbCI");

var $7GcJU = parcelRequire("7GcJU");

var $bfCmf = parcelRequire("bfCmf");

var $a5046 = parcelRequire("a5046");

var $1anZ2 = parcelRequire("1anZ2");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $840c77f8bd5af4d6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $840c77f8bd5af4d6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $840c77f8bd5af4d6$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $840c77f8bd5af4d6$var$doubleQuoteRegExp = /''/g;
var $840c77f8bd5af4d6$var$notWhitespaceRegExp = /\S/;
var $840c77f8bd5af4d6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $840c77f8bd5af4d6$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $7GcJU.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8iPa2.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $9xbCI.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $9xbCI.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $922t6.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $bfCmf.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($840c77f8bd5af4d6$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $A8QNv.default)) {
            var longFormatter = (0, $A8QNv.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($840c77f8bd5af4d6$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $fr6PO.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $efJgp.isProtectedWeekYearToken)(token)) (0, $efJgp.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $efJgp.isProtectedDayOfYearToken)(token)) (0, $efJgp.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $a5046.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($840c77f8bd5af4d6$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $840c77f8bd5af4d6$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $7gMEg.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $840c77f8bd5af4d6$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $922t6.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $7wI43.default)(date, (0, $8M12Y.default)(date));
    var flags = {};
    var _iterator2 = (0, $fr6PO.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $5UPpA.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $840c77f8bd5af4d6$var$cleanEscapedString(input) {
    return input.match($840c77f8bd5af4d6$var$escapedStringRegExp)[1].replace($840c77f8bd5af4d6$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("fr6PO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3ceadda0be423f3$export$2e2bcd8739ae039; });

var $ga9Zu = parcelRequire("ga9Zu");
function $b3ceadda0be423f3$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $ga9Zu.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

});
parcelRegister("ga9Zu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc455478618b535b$export$2e2bcd8739ae039; });

var $2eq3g = parcelRequire("2eq3g");
function $bc455478618b535b$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2eq3g.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2eq3g.default)(o, minLen);
}

});
parcelRegister("2eq3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a0118deddeef85f$export$2e2bcd8739ae039; });
function $1a0118deddeef85f$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("5UPpA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44ea0ffeb0244980$export$2e2bcd8739ae039; });
function $44ea0ffeb0244980$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("bfCmf", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $830ed9780ea817a9$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $830ed9780ea817a9$export$5aaf7ff7f09ea4ee; });

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $9ltZq = parcelRequire("9ltZq");
var $830ed9780ea817a9$var$TIMEZONE_UNIT_PRIORITY = 10;
var $830ed9780ea817a9$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $acn1E.default)(this, Setter);
        (0, $9ltZq.default)(this, "priority", void 0);
        (0, $9ltZq.default)(this, "subPriority", 0);
    }
    (0, $llawT.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $830ed9780ea817a9$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $gTLjp.default)(ValueSetter, _Setter);
    var _super = (0, $699FT.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $acn1E.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $llawT.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($830ed9780ea817a9$export$81d53e3678089a6);
var $830ed9780ea817a9$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $gTLjp.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $699FT.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $acn1E.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this2), "priority", $830ed9780ea817a9$var$TIMEZONE_UNIT_PRIORITY);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $llawT.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($830ed9780ea817a9$export$81d53e3678089a6);

});
parcelRegister("gTLjp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4d67b99fd1786cf$export$2e2bcd8739ae039; });

var $1QmDZ = parcelRequire("1QmDZ");
function $c4d67b99fd1786cf$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $1QmDZ.default)(subClass, superClass);
}

});

parcelRegister("699FT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479b168e0e190cf8$export$2e2bcd8739ae039; });

var $3Mkyp = parcelRequire("3Mkyp");

var $95ZVc = parcelRequire("95ZVc");

var $HC80n = parcelRequire("HC80n");
function $479b168e0e190cf8$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $95ZVc.default)();
    return function _createSuperInternal() {
        var Super = (0, $3Mkyp.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $3Mkyp.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $HC80n.default)(this, result);
    };
}

});
parcelRegister("3Mkyp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c05cc63f32e245b$export$2e2bcd8739ae039; });
function $2c05cc63f32e245b$export$2e2bcd8739ae039(o) {
    $2c05cc63f32e245b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2c05cc63f32e245b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("95ZVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69f49d026d6c5e2c$export$2e2bcd8739ae039; });
function $69f49d026d6c5e2c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($69f49d026d6c5e2c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("HC80n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $083197b7505d938c$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");

var $jUqC3 = parcelRequire("jUqC3");
function $083197b7505d938c$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $7gMEg.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jUqC3.default)(self);
}

});


parcelRegister("acn1E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76cce2c79c009ef1$export$2e2bcd8739ae039; });
function $76cce2c79c009ef1$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("llawT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f893ba1343a50f92$export$2e2bcd8739ae039; });

var $lSYeM = parcelRequire("lSYeM");
function $f893ba1343a50f92$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $lSYeM.default)(descriptor.key), descriptor);
    }
}
function $f893ba1343a50f92$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $f893ba1343a50f92$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f893ba1343a50f92$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("lSYeM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feed5dfd3c56474b$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");

var $duntn = parcelRequire("duntn");
function $feed5dfd3c56474b$export$2e2bcd8739ae039(t) {
    var i = (0, $duntn.default)(t, "string");
    return "symbol" == (0, $7gMEg.default)(i) ? i : i + "";
}

});
parcelRegister("duntn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d2048e684006847$export$2e2bcd8739ae039; });

var $7gMEg = parcelRequire("7gMEg");
function $9d2048e684006847$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7gMEg.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7gMEg.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9ltZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cdd568d18908e2a$export$2e2bcd8739ae039; });

var $lSYeM = parcelRequire("lSYeM");
function $6cdd568d18908e2a$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $lSYeM.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("a5046", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $756a6bfae1401ae2$export$19131010e7fd8373; });

var $aNppF = parcelRequire("aNppF");

var $kT9YQ = parcelRequire("kT9YQ");

var $7CixY = parcelRequire("7CixY");

var $dv38G = parcelRequire("dv38G");

var $2WvJI = parcelRequire("2WvJI");

var $i02cw = parcelRequire("i02cw");

var $8v1oq = parcelRequire("8v1oq");

var $9df2o = parcelRequire("9df2o");

var $c82tG = parcelRequire("c82tG");

var $3CrXF = parcelRequire("3CrXF");

var $eEx5q = parcelRequire("eEx5q");

var $go6bP = parcelRequire("go6bP");

var $9YRPD = parcelRequire("9YRPD");

var $ktEAg = parcelRequire("ktEAg");

var $3czqp = parcelRequire("3czqp");

var $hFVFA = parcelRequire("hFVFA");

var $fVjse = parcelRequire("fVjse");

var $fbalk = parcelRequire("fbalk");

var $1Gj9X = parcelRequire("1Gj9X");

var $6hwIk = parcelRequire("6hwIk");

var $4dSG6 = parcelRequire("4dSG6");

var $76keT = parcelRequire("76keT");

var $hWn6b = parcelRequire("hWn6b");

var $egAcN = parcelRequire("egAcN");

var $iS7Nh = parcelRequire("iS7Nh");

var $bkwz8 = parcelRequire("bkwz8");

var $g2AYP = parcelRequire("g2AYP");

var $aOB0H = parcelRequire("aOB0H");

var $56ZQl = parcelRequire("56ZQl");

var $jVrsY = parcelRequire("jVrsY");

var $c4kUt = parcelRequire("c4kUt");
var $756a6bfae1401ae2$export$19131010e7fd8373 = {
    G: new (0, $aNppF.EraParser)(),
    y: new (0, $kT9YQ.YearParser)(),
    Y: new (0, $7CixY.LocalWeekYearParser)(),
    R: new (0, $dv38G.ISOWeekYearParser)(),
    u: new (0, $2WvJI.ExtendedYearParser)(),
    Q: new (0, $i02cw.QuarterParser)(),
    q: new (0, $8v1oq.StandAloneQuarterParser)(),
    M: new (0, $9df2o.MonthParser)(),
    L: new (0, $c82tG.StandAloneMonthParser)(),
    w: new (0, $3CrXF.LocalWeekParser)(),
    I: new (0, $eEx5q.ISOWeekParser)(),
    d: new (0, $go6bP.DateParser)(),
    D: new (0, $9YRPD.DayOfYearParser)(),
    E: new (0, $ktEAg.DayParser)(),
    e: new (0, $3czqp.LocalDayParser)(),
    c: new (0, $hFVFA.StandAloneLocalDayParser)(),
    i: new (0, $fVjse.ISODayParser)(),
    a: new (0, $fbalk.AMPMParser)(),
    b: new (0, $1Gj9X.AMPMMidnightParser)(),
    B: new (0, $6hwIk.DayPeriodParser)(),
    h: new (0, $4dSG6.Hour1to12Parser)(),
    H: new (0, $76keT.Hour0to23Parser)(),
    K: new (0, $hWn6b.Hour0To11Parser)(),
    k: new (0, $egAcN.Hour1To24Parser)(),
    m: new (0, $iS7Nh.MinuteParser)(),
    s: new (0, $bkwz8.SecondParser)(),
    S: new (0, $g2AYP.FractionOfSecondParser)(),
    X: new (0, $aOB0H.ISOTimezoneWithZParser)(),
    x: new (0, $56ZQl.ISOTimezoneParser)(),
    t: new (0, $jVrsY.TimestampSecondsParser)(),
    T: new (0, $c4kUt.TimestampMillisecondsParser)()
};

});
parcelRegister("aNppF", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $7dc23179eb91aa4c$export$8e5a1d3f85a9688; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");
var $7dc23179eb91aa4c$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(EraParser, _Parser);
    var _super = (0, $699FT.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $acn1E.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 140);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("kT1Cn", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $f34a33024d477ecf$export$7acfa6ed01010e37; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $9ltZq = parcelRequire("9ltZq");

var $bfCmf = parcelRequire("bfCmf");
var $f34a33024d477ecf$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $acn1E.default)(this, Parser);
        (0, $9ltZq.default)(this, "incompatibleTokens", void 0);
        (0, $9ltZq.default)(this, "priority", void 0);
        (0, $9ltZq.default)(this, "subPriority", void 0);
    }
    (0, $llawT.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $bfCmf.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("kT9YQ", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $f350af9aa960675c$export$48d352de7cd4a988; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $f350af9aa960675c$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(YearParser, _Parser);
    var _super = (0, $699FT.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $acn1E.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 130);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fx3H3.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("fx3H3", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $b4eccd851f9cc3cd$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $b4eccd851f9cc3cd$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $b4eccd851f9cc3cd$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $b4eccd851f9cc3cd$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $b4eccd851f9cc3cd$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $b4eccd851f9cc3cd$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $b4eccd851f9cc3cd$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $b4eccd851f9cc3cd$export$3d50627710b84d75; });

var $b53tR = parcelRequire("b53tR");

var $k5l6E = parcelRequire("k5l6E");
function $b4eccd851f9cc3cd$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b4eccd851f9cc3cd$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $b53tR.millisecondsInHour) + minutes * (0, $b53tR.millisecondsInMinute) + seconds * (0, $b53tR.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b4eccd851f9cc3cd$export$d931c43c4608a164(dateString) {
    return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).anyDigitsSigned, dateString);
}
function $b4eccd851f9cc3cd$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).singleDigit, dateString);
        case 2:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).twoDigits, dateString);
        case 3:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).threeDigits, dateString);
        case 4:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).fourDigits, dateString);
        default:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $b4eccd851f9cc3cd$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388((0, $k5l6E.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $b4eccd851f9cc3cd$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $b4eccd851f9cc3cd$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $b4eccd851f9cc3cd$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $b4eccd851f9cc3cd$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("k5l6E", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $e9f4a58d295e480a$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $e9f4a58d295e480a$export$a7ee192b982af9c1; });
var $e9f4a58d295e480a$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $e9f4a58d295e480a$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("7CixY", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $58ba7808dcea0b78$export$b8ef38dfcf05d5db; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");

var $eu6SD = parcelRequire("eu6SD");

var $3Jc1i = parcelRequire("3Jc1i");
var $58ba7808dcea0b78$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $699FT.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $acn1E.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 130);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $eu6SD.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $fx3H3.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $3Jc1i.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $3Jc1i.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("dv38G", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $9d409afb8115cb19$export$951d1df011fde06f; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");

var $16hMD = parcelRequire("16hMD");
var $9d409afb8115cb19$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $699FT.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $acn1E.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 130);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $fx3H3.parseNDigitsSigned)(4, dateString);
                return (0, $fx3H3.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $16hMD.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("2WvJI", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $22499dbd5182064b$export$bad9d2ea38e8f1a; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $22499dbd5182064b$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ExtendedYearParser, _Parser);
    var _super = (0, $699FT.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $acn1E.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 130);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $fx3H3.parseNDigitsSigned)(4, dateString);
                return (0, $fx3H3.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("i02cw", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $d1a9ef2b78b10f4a$export$5cb0f701186dde1d; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $d1a9ef2b78b10f4a$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(QuarterParser, _Parser);
    var _super = (0, $699FT.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $acn1E.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 120);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("8v1oq", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $0198cfafcd456444$export$300c0c2990e20e6d; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $0198cfafcd456444$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $699FT.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $acn1E.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 120);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("9df2o", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $6b50fe1f077b5d11$export$400dd8b40ef138a3; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $fx3H3 = parcelRequire("fx3H3");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");
var $6b50fe1f077b5d11$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(MonthParser, _Parser);
    var _super = (0, $699FT.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $acn1E.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 110);
        return _this;
    }
    (0, $llawT.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("c82tG", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $8d4827710738dc8a$export$1d7eaa53eaa5deba; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $8d4827710738dc8a$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $699FT.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $acn1E.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 110);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("3CrXF", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $2a2a9c3d7ceb7ddf$export$c4005ffc174e07c0; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");

var $kmWrq = parcelRequire("kmWrq");

var $3Jc1i = parcelRequire("3Jc1i");
var $2a2a9c3d7ceb7ddf$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(LocalWeekParser, _Parser);
    var _super = (0, $699FT.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $acn1E.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 100);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $3Jc1i.default)((0, $kmWrq.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("kmWrq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d3aa18a28bf667$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $922t6 = parcelRequire("922t6");

var $bpUef = parcelRequire("bpUef");

var $7GcJU = parcelRequire("7GcJU");
function $03d3aa18a28bf667$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $7GcJU.default)(2, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var week = (0, $9xbCI.default)(dirtyWeek);
    var diff = (0, $bpUef.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("eEx5q", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $02c0bfdc9bf81b40$export$6fc8dbedd560a6af; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");

var $ioDHc = parcelRequire("ioDHc");

var $16hMD = parcelRequire("16hMD");
var $02c0bfdc9bf81b40$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ISOWeekParser, _Parser);
    var _super = (0, $699FT.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $acn1E.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 100);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $16hMD.default)((0, $ioDHc.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("ioDHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d649429e167c0f1e$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $922t6 = parcelRequire("922t6");

var $79kgC = parcelRequire("79kgC");

var $7GcJU = parcelRequire("7GcJU");
function $d649429e167c0f1e$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $7GcJU.default)(2, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var isoWeek = (0, $9xbCI.default)(dirtyISOWeek);
    var diff = (0, $79kgC.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("go6bP", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $bee3b06864e51968$export$e8d4b28a20981dd2; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $fx3H3 = parcelRequire("fx3H3");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");
var $bee3b06864e51968$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bee3b06864e51968$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bee3b06864e51968$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(DateParser, _Parser);
    var _super = (0, $699FT.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $acn1E.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "subPriority", 1);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fx3H3.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $bee3b06864e51968$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $bee3b06864e51968$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("9YRPD", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $74437986aa42218e$export$6cfe0d613455f615; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $74437986aa42218e$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(DayOfYearParser, _Parser);
    var _super = (0, $699FT.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $acn1E.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "subpriority", 1);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $fx3H3.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("ktEAg", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $ee85ff2c821bc597$export$1b03c8b76262f7bd; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $8ahix = parcelRequire("8ahix");
var $ee85ff2c821bc597$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(DayParser, _Parser);
    var _super = (0, $699FT.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $acn1E.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $8ahix.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("8ahix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1cacecb9d38880$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");

var $1anZ2 = parcelRequire("1anZ2");
function $5f1cacecb9d38880$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(2, arguments);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var weekStartsOn = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $922t6.default)(dirtyDate);
    var day = (0, $9xbCI.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("3czqp", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $254df8beb7bad374$export$44d1c127ab42c480; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");

var $8ahix = parcelRequire("8ahix");
var $254df8beb7bad374$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(LocalDayParser, _Parser);
    var _super = (0, $699FT.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $acn1E.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $8ahix.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("hFVFA", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $cde30003a0666dd2$export$e447a647caaaec1d; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");

var $8ahix = parcelRequire("8ahix");
var $cde30003a0666dd2$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $699FT.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $acn1E.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $fx3H3.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $8ahix.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("fVjse", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $b97b451f99e37bef$export$693fb1e525095b2a; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");

var $i3Nnv = parcelRequire("i3Nnv");
var $b97b451f99e37bef$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ISODayParser, _Parser);
    var _super = (0, $699FT.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $acn1E.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 90);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $fx3H3.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $fx3H3.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $fx3H3.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $fx3H3.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $i3Nnv.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $kT1Cn.Parser));

});
parcelRegister("i3Nnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d25ecf43303f6eb3$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");
function $d25ecf43303f6eb3$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $7GcJU.default)(2, arguments);
    var day = (0, $9xbCI.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $922t6.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("fbalk", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $b0cfe80393bfb40f$export$8d1e08492351df91; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $b0cfe80393bfb40f$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(AMPMParser, _Parser);
    var _super = (0, $699FT.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $acn1E.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 80);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fx3H3.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("1Gj9X", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $1398936328fd7ea2$export$73ca2bd0a17d273; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $1398936328fd7ea2$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $699FT.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $acn1E.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 80);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fx3H3.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("6hwIk", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $492db4ecbd43ac74$export$bb9212adf05373db; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $492db4ecbd43ac74$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(DayPeriodParser, _Parser);
    var _super = (0, $699FT.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $acn1E.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 80);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $fx3H3.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("4dSG6", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $3132ca4630c1c5c1$export$8a04050a727a1756; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $3132ca4630c1c5c1$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(Hour1to12Parser, _Parser);
    var _super = (0, $699FT.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $acn1E.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 70);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $kT1Cn.Parser));

});

parcelRegister("76keT", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $52b8cb07e5abd412$export$e56f4dea2c3e56dd; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $52b8cb07e5abd412$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(Hour0to23Parser, _Parser);
    var _super = (0, $699FT.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $acn1E.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 70);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $kT1Cn.Parser));

});

parcelRegister("hWn6b", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $d0f9c55aa59db415$export$cbbe855312f87d77; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $d0f9c55aa59db415$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(Hour0To11Parser, _Parser);
    var _super = (0, $699FT.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $acn1E.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 70);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $kT1Cn.Parser));

});

parcelRegister("egAcN", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $a62ea4f6c58a7666$export$6008046d2b34b6a5; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $a62ea4f6c58a7666$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(Hour1To24Parser, _Parser);
    var _super = (0, $699FT.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $acn1E.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 70);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $kT1Cn.Parser));

});

parcelRegister("iS7Nh", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $dbd350d4556d6106$export$2b52670d9e2be53; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $dbd350d4556d6106$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(MinuteParser, _Parser);
    var _super = (0, $699FT.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $acn1E.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 60);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("bkwz8", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $83fad2cf5180b020$export$94d46d540cf1366a; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $83fad2cf5180b020$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(SecondParser, _Parser);
    var _super = (0, $699FT.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $acn1E.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 50);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $fx3H3.parseNumericPattern)((0, $k5l6E.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $fx3H3.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("g2AYP", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $bad984bd3a6e1dc2$export$b8e6f8b2d70893b1; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $bad984bd3a6e1dc2$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $699FT.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $acn1E.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 30);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $llawT.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $fx3H3.mapValue)((0, $fx3H3.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("aOB0H", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $7dfb4858cdb0fe9d$export$104d901d49fea29b; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $7dfb4858cdb0fe9d$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $699FT.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $acn1E.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 10);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $llawT.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("56ZQl", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $3b8d7c13e9bd0d3b$export$12910e5204b52b9; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $k5l6E = parcelRequire("k5l6E");

var $fx3H3 = parcelRequire("fx3H3");
var $3b8d7c13e9bd0d3b$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $699FT.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $acn1E.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 10);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $llawT.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $fx3H3.parseTimezonePattern)((0, $k5l6E.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("jVrsY", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $e818a56b7b35b172$export$2cd8bf877a05e96; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $e818a56b7b35b172$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $699FT.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $acn1E.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 40);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $llawT.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fx3H3.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $kT1Cn.Parser));

});

parcelRegister("c4kUt", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $8c96140b6687a7cd$export$6d8f69c6906d6368; });

var $acn1E = parcelRequire("acn1E");

var $llawT = parcelRequire("llawT");

var $jUqC3 = parcelRequire("jUqC3");

var $gTLjp = parcelRequire("gTLjp");

var $699FT = parcelRequire("699FT");

var $9ltZq = parcelRequire("9ltZq");

var $kT1Cn = parcelRequire("kT1Cn");

var $fx3H3 = parcelRequire("fx3H3");
var $8c96140b6687a7cd$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $gTLjp.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $699FT.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $acn1E.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "priority", 20);
        (0, $9ltZq.default)((0, $jUqC3.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $llawT.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $fx3H3.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $kT1Cn.Parser));

});



parcelRegister("9fldd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bb5f80d8e2cb5d2$export$2e2bcd8739ae039; });

var $b53tR = parcelRequire("b53tR");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");
function $6bb5f80d8e2cb5d2$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $7GcJU.default)(1, arguments);
    var additionalDigits = (0, $9xbCI.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $6bb5f80d8e2cb5d2$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $6bb5f80d8e2cb5d2$var$parseYear(dateStrings.date, additionalDigits);
        date = $6bb5f80d8e2cb5d2$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $6bb5f80d8e2cb5d2$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $6bb5f80d8e2cb5d2$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $6bb5f80d8e2cb5d2$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $6bb5f80d8e2cb5d2$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $6bb5f80d8e2cb5d2$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $6bb5f80d8e2cb5d2$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $6bb5f80d8e2cb5d2$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($6bb5f80d8e2cb5d2$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($6bb5f80d8e2cb5d2$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($6bb5f80d8e2cb5d2$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $6bb5f80d8e2cb5d2$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6bb5f80d8e2cb5d2$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $6bb5f80d8e2cb5d2$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($6bb5f80d8e2cb5d2$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $6bb5f80d8e2cb5d2$var$parseDateUnit(captures[1]);
    var month = $6bb5f80d8e2cb5d2$var$parseDateUnit(captures[2]) - 1;
    var day = $6bb5f80d8e2cb5d2$var$parseDateUnit(captures[3]);
    var week = $6bb5f80d8e2cb5d2$var$parseDateUnit(captures[4]);
    var dayOfWeek = $6bb5f80d8e2cb5d2$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$6bb5f80d8e2cb5d2$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $6bb5f80d8e2cb5d2$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$6bb5f80d8e2cb5d2$var$validateDate(year, month, day) || !$6bb5f80d8e2cb5d2$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $6bb5f80d8e2cb5d2$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $6bb5f80d8e2cb5d2$var$parseTime(timeString) {
    var captures = timeString.match($6bb5f80d8e2cb5d2$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $6bb5f80d8e2cb5d2$var$parseTimeUnit(captures[1]);
    var minutes = $6bb5f80d8e2cb5d2$var$parseTimeUnit(captures[2]);
    var seconds = $6bb5f80d8e2cb5d2$var$parseTimeUnit(captures[3]);
    if (!$6bb5f80d8e2cb5d2$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $b53tR.millisecondsInHour) + minutes * (0, $b53tR.millisecondsInMinute) + seconds * 1000;
}
function $6bb5f80d8e2cb5d2$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $6bb5f80d8e2cb5d2$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($6bb5f80d8e2cb5d2$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$6bb5f80d8e2cb5d2$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $b53tR.millisecondsInHour) + minutes * (0, $b53tR.millisecondsInMinute));
}
function $6bb5f80d8e2cb5d2$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $6bb5f80d8e2cb5d2$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6bb5f80d8e2cb5d2$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6bb5f80d8e2cb5d2$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($6bb5f80d8e2cb5d2$var$daysInMonths[month] || ($6bb5f80d8e2cb5d2$var$isLeapYearIndex(year) ? 29 : 28));
}
function $6bb5f80d8e2cb5d2$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($6bb5f80d8e2cb5d2$var$isLeapYearIndex(year) ? 366 : 365);
}
function $6bb5f80d8e2cb5d2$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $6bb5f80d8e2cb5d2$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $6bb5f80d8e2cb5d2$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("cDFIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93397dff099307b5$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $93397dff099307b5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

});

parcelRegister("31iWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233028e25837bb4f$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $233028e25837bb4f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setSeconds(0, 0);
    return date;
}

});

parcelRegister("ajiUn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781a5884a134fffa$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $781a5884a134fffa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kYtYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03f0c8f3b5442778$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $03f0c8f3b5442778$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("2X1xy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2262495513b7ee90$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $2262495513b7ee90$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var date = (0, $922t6.default)(dirtyDate);
    date.setMilliseconds(0);
    return date;
}

});

parcelRegister("4V6Kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3951b865852b9ce3$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $9xbCI = parcelRequire("9xbCI");

var $7GcJU = parcelRequire("7GcJU");

var $1anZ2 = parcelRequire("1anZ2");
function $3951b865852b9ce3$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7GcJU.default)(1, arguments);
    var defaultOptions = (0, $1anZ2.getDefaultOptions)();
    var weekStartsOn = (0, $9xbCI.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $922t6.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("lmK01", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8df55935d7a26f4$export$2e2bcd8739ae039; });

var $922t6 = parcelRequire("922t6");

var $7GcJU = parcelRequire("7GcJU");
function $f8df55935d7a26f4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7GcJU.default)(1, arguments);
    var cleanDate = (0, $922t6.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("cpJpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $909b0c6b115083b5$export$2e2bcd8739ae039; });
/*!
* chartjs-plugin-zoom v2.0.1
* undefined
 * (c) 2016-2023 chartjs-plugin-zoom Contributors
 * Released under the MIT License
 */ 
var $eO6Q6 = parcelRequire("eO6Q6");
parcelRequire("kkOd7");
var $ffh6R = parcelRequire("ffh6R");
const $909b0c6b115083b5$var$getModifierKey = (opts)=>opts && opts.enabled && opts.modifierKey;
const $909b0c6b115083b5$var$keyPressed = (key, event)=>key && event[key + "Key"];
const $909b0c6b115083b5$var$keyNotPressed = (key, event)=>key && !event[key + "Key"];
/**
 * @param {string|function} mode can be 'x', 'y' or 'xy'
 * @param {string} dir can be 'x' or 'y'
 * @param {import('chart.js').Chart} chart instance of the chart in question
 * @returns {boolean}
 */ function $909b0c6b115083b5$var$directionEnabled(mode, dir, chart) {
    if (mode === undefined) return true;
    else if (typeof mode === "string") return mode.indexOf(dir) !== -1;
    else if (typeof mode === "function") return mode({
        chart: chart
    }).indexOf(dir) !== -1;
    return false;
}
function $909b0c6b115083b5$var$directionsEnabled(mode, chart) {
    if (typeof mode === "function") mode = mode({
        chart: chart
    });
    if (typeof mode === "string") return {
        x: mode.indexOf("x") !== -1,
        y: mode.indexOf("y") !== -1
    };
    return {
        x: false,
        y: false
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 * @param {function} fn - Function to call. No arguments are passed.
 * @param {number} delay - Delay in ms. 0 = immediate invocation.
 * @returns {function}
 */ function $909b0c6b115083b5$var$debounce(fn, delay) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(fn, delay);
        return delay;
    };
}
/**
 * Checks which axis is under the mouse cursor.
 * @param {{x: number, y: number}} point - the mouse location
 * @param {import('chart.js').Chart} [chart] instance of the chart in question
 * @return {import('chart.js').Scale}
 */ function $909b0c6b115083b5$var$getScaleUnderPoint({ x: x, y: y }, chart) {
    const scales = chart.scales;
    const scaleIds = Object.keys(scales);
    for(let i = 0; i < scaleIds.length; i++){
        const scale = scales[scaleIds[i]];
        if (y >= scale.top && y <= scale.bottom && x >= scale.left && x <= scale.right) return scale;
    }
    return null;
}
/**
 * Evaluate the chart's mode, scaleMode, and overScaleMode properties to
 * determine which axes are eligible for scaling.
 * options.overScaleMode can be a function if user want zoom only one scale of many for example.
 * @param options - Zoom or pan options
 * @param {{x: number, y: number}} point - the mouse location
 * @param {import('chart.js').Chart} [chart] instance of the chart in question
 * @return {import('chart.js').Scale[]}
 */ function $909b0c6b115083b5$var$getEnabledScalesByPoint(options, point, chart) {
    const { mode: mode = "xy", scaleMode: scaleMode, overScaleMode: overScaleMode } = options || {};
    const scale = $909b0c6b115083b5$var$getScaleUnderPoint(point, chart);
    const enabled = $909b0c6b115083b5$var$directionsEnabled(mode, chart);
    const scaleEnabled = $909b0c6b115083b5$var$directionsEnabled(scaleMode, chart);
    // Convert deprecated overScaleEnabled to new scaleEnabled.
    if (overScaleMode) {
        const overScaleEnabled = $909b0c6b115083b5$var$directionsEnabled(overScaleMode, chart);
        for (const axis of [
            "x",
            "y"
        ])if (overScaleEnabled[axis]) {
            scaleEnabled[axis] = enabled[axis];
            enabled[axis] = false;
        }
    }
    if (scale && scaleEnabled[scale.axis]) return [
        scale
    ];
    const enabledScales = [];
    (0, $ffh6R.F)(chart.scales, function(scaleItem) {
        if (enabled[scaleItem.axis]) enabledScales.push(scaleItem);
    });
    return enabledScales;
}
const $909b0c6b115083b5$var$chartStates = new WeakMap();
function $909b0c6b115083b5$var$getState(chart) {
    let state = $909b0c6b115083b5$var$chartStates.get(chart);
    if (!state) {
        state = {
            originalScaleLimits: {},
            updatedScaleLimits: {},
            handlers: {},
            panDelta: {}
        };
        $909b0c6b115083b5$var$chartStates.set(chart, state);
    }
    return state;
}
function $909b0c6b115083b5$var$removeState(chart) {
    $909b0c6b115083b5$var$chartStates.delete(chart);
}
function $909b0c6b115083b5$var$zoomDelta(scale, zoom, center) {
    const range = scale.max - scale.min;
    const newRange = range * (zoom - 1);
    const centerPoint = scale.isHorizontal() ? center.x : center.y;
    // `scale.getValueForPixel()` can return a value less than the `scale.min` or
    // greater than `scale.max` when `centerPoint` is outside chartArea.
    const minPercent = Math.max(0, Math.min(1, (scale.getValueForPixel(centerPoint) - scale.min) / range || 0));
    const maxPercent = 1 - minPercent;
    return {
        min: newRange * minPercent,
        max: newRange * maxPercent
    };
}
function $909b0c6b115083b5$var$getLimit(state, scale, scaleLimits, prop, fallback) {
    let limit = scaleLimits[prop];
    if (limit === "original") {
        const original = state.originalScaleLimits[scale.id][prop];
        limit = (0, $ffh6R.v)(original.options, original.scale);
    }
    return (0, $ffh6R.v)(limit, fallback);
}
function $909b0c6b115083b5$var$getRange(scale, pixel0, pixel1) {
    const v0 = scale.getValueForPixel(pixel0);
    const v1 = scale.getValueForPixel(pixel1);
    return {
        min: Math.min(v0, v1),
        max: Math.max(v0, v1)
    };
}
function $909b0c6b115083b5$var$updateRange(scale, { min: min, max: max }, limits, zoom = false) {
    const state = $909b0c6b115083b5$var$getState(scale.chart);
    const { id: id, axis: axis, options: scaleOpts } = scale;
    const scaleLimits = limits && (limits[id] || limits[axis]) || {};
    const { minRange: minRange = 0 } = scaleLimits;
    const minLimit = $909b0c6b115083b5$var$getLimit(state, scale, scaleLimits, "min", -Infinity);
    const maxLimit = $909b0c6b115083b5$var$getLimit(state, scale, scaleLimits, "max", Infinity);
    const range = zoom ? Math.max(max - min, minRange) : scale.max - scale.min;
    const offset = (range - max + min) / 2;
    min -= offset;
    max += offset;
    if (min < minLimit) {
        min = minLimit;
        max = Math.min(minLimit + range, maxLimit);
    } else if (max > maxLimit) {
        max = maxLimit;
        min = Math.max(maxLimit - range, minLimit);
    }
    scaleOpts.min = min;
    scaleOpts.max = max;
    state.updatedScaleLimits[scale.id] = {
        min: min,
        max: max
    };
    // return true if the scale range is changed
    return scale.parse(min) !== scale.min || scale.parse(max) !== scale.max;
}
function $909b0c6b115083b5$var$zoomNumericalScale(scale, zoom, center, limits) {
    const delta = $909b0c6b115083b5$var$zoomDelta(scale, zoom, center);
    const newRange = {
        min: scale.min + delta.min,
        max: scale.max - delta.max
    };
    return $909b0c6b115083b5$var$updateRange(scale, newRange, limits, true);
}
function $909b0c6b115083b5$var$zoomRectNumericalScale(scale, from, to, limits) {
    $909b0c6b115083b5$var$updateRange(scale, $909b0c6b115083b5$var$getRange(scale, from, to), limits, true);
}
const $909b0c6b115083b5$var$integerChange = (v)=>v === 0 || isNaN(v) ? 0 : v < 0 ? Math.min(Math.round(v), -1) : Math.max(Math.round(v), 1);
function $909b0c6b115083b5$var$existCategoryFromMaxZoom(scale) {
    const labels = scale.getLabels();
    const maxIndex = labels.length - 1;
    if (scale.min > 0) scale.min -= 1;
    if (scale.max < maxIndex) scale.max += 1;
}
function $909b0c6b115083b5$var$zoomCategoryScale(scale, zoom, center, limits) {
    const delta = $909b0c6b115083b5$var$zoomDelta(scale, zoom, center);
    if (scale.min === scale.max && zoom < 1) $909b0c6b115083b5$var$existCategoryFromMaxZoom(scale);
    const newRange = {
        min: scale.min + $909b0c6b115083b5$var$integerChange(delta.min),
        max: scale.max - $909b0c6b115083b5$var$integerChange(delta.max)
    };
    return $909b0c6b115083b5$var$updateRange(scale, newRange, limits, true);
}
function $909b0c6b115083b5$var$scaleLength(scale) {
    return scale.isHorizontal() ? scale.width : scale.height;
}
function $909b0c6b115083b5$var$panCategoryScale(scale, delta, limits) {
    const labels = scale.getLabels();
    const lastLabelIndex = labels.length - 1;
    let { min: min, max: max } = scale;
    // The visible range. Ticks can be skipped, and thus not reliable.
    const range = Math.max(max - min, 1);
    // How many pixels of delta is required before making a step. stepSize, but limited to max 1/10 of the scale length.
    const stepDelta = Math.round($909b0c6b115083b5$var$scaleLength(scale) / Math.max(range, 10));
    const stepSize = Math.round(Math.abs(delta / stepDelta));
    let applied;
    if (delta < -stepDelta) {
        max = Math.min(max + stepSize, lastLabelIndex);
        min = range === 1 ? max : max - range;
        applied = max === lastLabelIndex;
    } else if (delta > stepDelta) {
        min = Math.max(0, min - stepSize);
        max = range === 1 ? min : min + range;
        applied = min === 0;
    }
    return $909b0c6b115083b5$var$updateRange(scale, {
        min: min,
        max: max
    }, limits) || applied;
}
const $909b0c6b115083b5$var$OFFSETS = {
    second: 500,
    minute: 30000,
    hour: 1800000,
    day: 43200000,
    week: 302400000,
    month: 1296000000,
    quarter: 5184000000,
    year: 15724800000 // 182 d
};
function $909b0c6b115083b5$var$panNumericalScale(scale, delta, limits, canZoom = false) {
    const { min: prevStart, max: prevEnd, options: options } = scale;
    const round = options.time && options.time.round;
    const offset = $909b0c6b115083b5$var$OFFSETS[round] || 0;
    const newMin = scale.getValueForPixel(scale.getPixelForValue(prevStart + offset) - delta);
    const newMax = scale.getValueForPixel(scale.getPixelForValue(prevEnd + offset) - delta);
    const { min: minLimit = -Infinity, max: maxLimit = Infinity } = canZoom && limits && limits[scale.axis] || {};
    if (isNaN(newMin) || isNaN(newMax) || newMin < minLimit || newMax > maxLimit) // At limit: No change but return true to indicate no need to store the delta.
    // NaN can happen for 0-dimension scales (either because they were configured
    // with min === max or because the chart has 0 plottable area).
    return true;
    return $909b0c6b115083b5$var$updateRange(scale, {
        min: newMin,
        max: newMax
    }, limits, canZoom);
}
function $909b0c6b115083b5$var$panNonLinearScale(scale, delta, limits) {
    return $909b0c6b115083b5$var$panNumericalScale(scale, delta, limits, true);
}
const $909b0c6b115083b5$var$zoomFunctions = {
    category: $909b0c6b115083b5$var$zoomCategoryScale,
    default: $909b0c6b115083b5$var$zoomNumericalScale
};
const $909b0c6b115083b5$var$zoomRectFunctions = {
    default: $909b0c6b115083b5$var$zoomRectNumericalScale
};
const $909b0c6b115083b5$var$panFunctions = {
    category: $909b0c6b115083b5$var$panCategoryScale,
    default: $909b0c6b115083b5$var$panNumericalScale,
    logarithmic: $909b0c6b115083b5$var$panNonLinearScale,
    timeseries: $909b0c6b115083b5$var$panNonLinearScale
};
function $909b0c6b115083b5$var$shouldUpdateScaleLimits(scale, originalScaleLimits, updatedScaleLimits) {
    const { id: id, options: { min: min, max: max } } = scale;
    if (!originalScaleLimits[id] || !updatedScaleLimits[id]) return true;
    const previous = updatedScaleLimits[id];
    return previous.min !== min || previous.max !== max;
}
function $909b0c6b115083b5$var$removeMissingScales(limits, scales) {
    (0, $ffh6R.F)(limits, (opt, key)=>{
        if (!scales[key]) delete limits[key];
    });
}
function $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state) {
    const { scales: scales } = chart;
    const { originalScaleLimits: originalScaleLimits, updatedScaleLimits: updatedScaleLimits } = state;
    (0, $ffh6R.F)(scales, function(scale) {
        if ($909b0c6b115083b5$var$shouldUpdateScaleLimits(scale, originalScaleLimits, updatedScaleLimits)) originalScaleLimits[scale.id] = {
            min: {
                scale: scale.min,
                options: scale.options.min
            },
            max: {
                scale: scale.max,
                options: scale.options.max
            }
        };
    });
    $909b0c6b115083b5$var$removeMissingScales(originalScaleLimits, scales);
    $909b0c6b115083b5$var$removeMissingScales(updatedScaleLimits, scales);
    return originalScaleLimits;
}
function $909b0c6b115083b5$var$doZoom(scale, amount, center, limits) {
    const fn = $909b0c6b115083b5$var$zoomFunctions[scale.type] || $909b0c6b115083b5$var$zoomFunctions.default;
    (0, $ffh6R.Q)(fn, [
        scale,
        amount,
        center,
        limits
    ]);
}
function $909b0c6b115083b5$var$doZoomRect(scale, amount, from, to, limits) {
    const fn = $909b0c6b115083b5$var$zoomRectFunctions[scale.type] || $909b0c6b115083b5$var$zoomRectFunctions.default;
    (0, $ffh6R.Q)(fn, [
        scale,
        amount,
        from,
        to,
        limits
    ]);
}
function $909b0c6b115083b5$var$getCenter(chart) {
    const ca = chart.chartArea;
    return {
        x: (ca.left + ca.right) / 2,
        y: (ca.top + ca.bottom) / 2
    };
}
/**
 * @param chart The chart instance
 * @param {number | {x?: number, y?: number, focalPoint?: {x: number, y: number}}} amount The zoom percentage or percentages and focal point
 * @param {string} [transition] Which transition mode to use. Defaults to 'none'
 */ function $909b0c6b115083b5$export$e83f174dbf56adcc(chart, amount, transition = "none") {
    const { x: x = 1, y: y = 1, focalPoint: focalPoint = $909b0c6b115083b5$var$getCenter(chart) } = typeof amount === "number" ? {
        x: amount,
        y: amount
    } : amount;
    const state = $909b0c6b115083b5$var$getState(chart);
    const { options: { limits: limits, zoom: zoomOptions } } = state;
    $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = x !== 1;
    const yEnabled = y !== 1;
    const enabledScales = $909b0c6b115083b5$var$getEnabledScalesByPoint(zoomOptions, focalPoint, chart);
    (0, $ffh6R.F)(enabledScales || chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $909b0c6b115083b5$var$doZoom(scale, x, focalPoint, limits);
        else if (!scale.isHorizontal() && yEnabled) $909b0c6b115083b5$var$doZoom(scale, y, focalPoint, limits);
    });
    chart.update(transition);
    (0, $ffh6R.Q)(zoomOptions.onZoom, [
        {
            chart: chart
        }
    ]);
}
function $909b0c6b115083b5$export$5e8e70b5f122ac9(chart, p0, p1, transition = "none") {
    const state = $909b0c6b115083b5$var$getState(chart);
    const { options: { limits: limits, zoom: zoomOptions } } = state;
    const { mode: mode = "xy" } = zoomOptions;
    $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = $909b0c6b115083b5$var$directionEnabled(mode, "x", chart);
    const yEnabled = $909b0c6b115083b5$var$directionEnabled(mode, "y", chart);
    (0, $ffh6R.F)(chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $909b0c6b115083b5$var$doZoomRect(scale, p0.x, p1.x, limits);
        else if (!scale.isHorizontal() && yEnabled) $909b0c6b115083b5$var$doZoomRect(scale, p0.y, p1.y, limits);
    });
    chart.update(transition);
    (0, $ffh6R.Q)(zoomOptions.onZoom, [
        {
            chart: chart
        }
    ]);
}
function $909b0c6b115083b5$export$bd064d51d863101c(chart, scaleId, range, transition = "none") {
    $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, $909b0c6b115083b5$var$getState(chart));
    const scale = chart.scales[scaleId];
    $909b0c6b115083b5$var$updateRange(scale, range, undefined, true);
    chart.update(transition);
}
function $909b0c6b115083b5$export$ac12f90bdc1d9b7(chart, transition = "default") {
    const state = $909b0c6b115083b5$var$getState(chart);
    const originalScaleLimits = $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state);
    (0, $ffh6R.F)(chart.scales, function(scale) {
        const scaleOptions = scale.options;
        if (originalScaleLimits[scale.id]) {
            scaleOptions.min = originalScaleLimits[scale.id].min.options;
            scaleOptions.max = originalScaleLimits[scale.id].max.options;
        } else {
            delete scaleOptions.min;
            delete scaleOptions.max;
        }
    });
    chart.update(transition);
    (0, $ffh6R.Q)(state.options.zoom.onZoomComplete, [
        {
            chart: chart
        }
    ]);
}
function $909b0c6b115083b5$var$getOriginalRange(state, scaleId) {
    const original = state.originalScaleLimits[scaleId];
    if (!original) return;
    const { min: min, max: max } = original;
    return (0, $ffh6R.v)(max.options, max.scale) - (0, $ffh6R.v)(min.options, min.scale);
}
function $909b0c6b115083b5$var$getZoomLevel(chart) {
    const state = $909b0c6b115083b5$var$getState(chart);
    let min = 1;
    let max = 1;
    (0, $ffh6R.F)(chart.scales, function(scale) {
        const origRange = $909b0c6b115083b5$var$getOriginalRange(state, scale.id);
        if (origRange) {
            const level = Math.round(origRange / (scale.max - scale.min) * 100) / 100;
            min = Math.min(min, level);
            max = Math.max(max, level);
        }
    });
    return min < 1 ? min : max;
}
function $909b0c6b115083b5$var$panScale(scale, delta, limits, state) {
    const { panDelta: panDelta } = state;
    // Add possible cumulative delta from previous pan attempts where scale did not change
    const storedDelta = panDelta[scale.id] || 0;
    if ((0, $ffh6R.s)(storedDelta) === (0, $ffh6R.s)(delta)) delta += storedDelta;
    const fn = $909b0c6b115083b5$var$panFunctions[scale.type] || $909b0c6b115083b5$var$panFunctions.default;
    if ((0, $ffh6R.Q)(fn, [
        scale,
        delta,
        limits
    ])) // The scale changed, reset cumulative delta
    panDelta[scale.id] = 0;
    else // The scale did not change, store cumulative delta
    panDelta[scale.id] = delta;
}
function $909b0c6b115083b5$export$4c486572e961a974(chart, delta, enabledScales, transition = "none") {
    const { x: x = 0, y: y = 0 } = typeof delta === "number" ? {
        x: delta,
        y: delta
    } : delta;
    const state = $909b0c6b115083b5$var$getState(chart);
    const { options: { pan: panOptions, limits: limits } } = state;
    const { onPan: onPan } = panOptions || {};
    $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = x !== 0;
    const yEnabled = y !== 0;
    (0, $ffh6R.F)(enabledScales || chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $909b0c6b115083b5$var$panScale(scale, x, limits, state);
        else if (!scale.isHorizontal() && yEnabled) $909b0c6b115083b5$var$panScale(scale, y, limits, state);
    });
    chart.update(transition);
    (0, $ffh6R.Q)(onPan, [
        {
            chart: chart
        }
    ]);
}
function $909b0c6b115083b5$var$getInitialScaleBounds(chart) {
    const state = $909b0c6b115083b5$var$getState(chart);
    $909b0c6b115083b5$var$storeOriginalScaleLimits(chart, state);
    const scaleBounds = {};
    for (const scaleId of Object.keys(chart.scales)){
        const { min: min, max: max } = state.originalScaleLimits[scaleId] || {
            min: {},
            max: {}
        };
        scaleBounds[scaleId] = {
            min: min.scale,
            max: max.scale
        };
    }
    return scaleBounds;
}
function $909b0c6b115083b5$var$isZoomedOrPanned(chart) {
    const scaleBounds = $909b0c6b115083b5$var$getInitialScaleBounds(chart);
    for (const scaleId of Object.keys(chart.scales)){
        const { min: originalMin, max: originalMax } = scaleBounds[scaleId];
        if (originalMin !== undefined && chart.scales[scaleId].min !== originalMin) return true;
        if (originalMax !== undefined && chart.scales[scaleId].max !== originalMax) return true;
    }
    return false;
}
function $909b0c6b115083b5$var$removeHandler(chart, type) {
    const { handlers: handlers } = $909b0c6b115083b5$var$getState(chart);
    const handler = handlers[type];
    if (handler && handler.target) {
        handler.target.removeEventListener(type, handler);
        delete handlers[type];
    }
}
function $909b0c6b115083b5$var$addHandler(chart, target, type, handler) {
    const { handlers: handlers, options: options } = $909b0c6b115083b5$var$getState(chart);
    const oldHandler = handlers[type];
    if (oldHandler && oldHandler.target === target) // already attached
    return;
    $909b0c6b115083b5$var$removeHandler(chart, type);
    handlers[type] = (event)=>handler(chart, event, options);
    handlers[type].target = target;
    target.addEventListener(type, handlers[type]);
}
function $909b0c6b115083b5$var$mouseMove(chart, event) {
    const state = $909b0c6b115083b5$var$getState(chart);
    if (state.dragStart) {
        state.dragging = true;
        state.dragEnd = event;
        chart.update("none");
    }
}
function $909b0c6b115083b5$var$keyDown(chart, event) {
    const state = $909b0c6b115083b5$var$getState(chart);
    if (!state.dragStart || event.key !== "Escape") return;
    $909b0c6b115083b5$var$removeHandler(chart, "keydown");
    state.dragging = false;
    state.dragStart = state.dragEnd = null;
    chart.update("none");
}
function $909b0c6b115083b5$var$zoomStart(chart, event, zoomOptions) {
    const { onZoomStart: onZoomStart, onZoomRejected: onZoomRejected } = zoomOptions;
    if (onZoomStart) {
        const point = (0, $ffh6R.z)(event, chart);
        if ((0, $ffh6R.Q)(onZoomStart, [
            {
                chart: chart,
                event: event,
                point: point
            }
        ]) === false) {
            (0, $ffh6R.Q)(onZoomRejected, [
                {
                    chart: chart,
                    event: event
                }
            ]);
            return false;
        }
    }
}
function $909b0c6b115083b5$var$mouseDown(chart, event) {
    const state = $909b0c6b115083b5$var$getState(chart);
    const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
    if (event.button !== 0 || $909b0c6b115083b5$var$keyPressed($909b0c6b115083b5$var$getModifierKey(panOptions), event) || $909b0c6b115083b5$var$keyNotPressed($909b0c6b115083b5$var$getModifierKey(zoomOptions.drag), event)) return (0, $ffh6R.Q)(zoomOptions.onZoomRejected, [
        {
            chart: chart,
            event: event
        }
    ]);
    if ($909b0c6b115083b5$var$zoomStart(chart, event, zoomOptions) === false) return;
    state.dragStart = event;
    $909b0c6b115083b5$var$addHandler(chart, chart.canvas, "mousemove", $909b0c6b115083b5$var$mouseMove);
    $909b0c6b115083b5$var$addHandler(chart, window.document, "keydown", $909b0c6b115083b5$var$keyDown);
}
function $909b0c6b115083b5$var$computeDragRect(chart, mode, beginPointEvent, endPointEvent) {
    const xEnabled = $909b0c6b115083b5$var$directionEnabled(mode, "x", chart);
    const yEnabled = $909b0c6b115083b5$var$directionEnabled(mode, "y", chart);
    let { top: top, left: left, right: right, bottom: bottom, width: chartWidth, height: chartHeight } = chart.chartArea;
    const beginPoint = (0, $ffh6R.z)(beginPointEvent, chart);
    const endPoint = (0, $ffh6R.z)(endPointEvent, chart);
    if (xEnabled) {
        left = Math.min(beginPoint.x, endPoint.x);
        right = Math.max(beginPoint.x, endPoint.x);
    }
    if (yEnabled) {
        top = Math.min(beginPoint.y, endPoint.y);
        bottom = Math.max(beginPoint.y, endPoint.y);
    }
    const width = right - left;
    const height = bottom - top;
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        width: width,
        height: height,
        zoomX: xEnabled && width ? 1 + (chartWidth - width) / chartWidth : 1,
        zoomY: yEnabled && height ? 1 + (chartHeight - height) / chartHeight : 1
    };
}
function $909b0c6b115083b5$var$mouseUp(chart, event) {
    const state = $909b0c6b115083b5$var$getState(chart);
    if (!state.dragStart) return;
    $909b0c6b115083b5$var$removeHandler(chart, "mousemove");
    const { mode: mode, onZoomComplete: onZoomComplete, drag: { threshold: threshold = 0 } } = state.options.zoom;
    const rect = $909b0c6b115083b5$var$computeDragRect(chart, mode, state.dragStart, event);
    const distanceX = $909b0c6b115083b5$var$directionEnabled(mode, "x", chart) ? rect.width : 0;
    const distanceY = $909b0c6b115083b5$var$directionEnabled(mode, "y", chart) ? rect.height : 0;
    const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
    // Remove drag start and end before chart update to stop drawing selected area
    state.dragStart = state.dragEnd = null;
    if (distance <= threshold) {
        state.dragging = false;
        chart.update("none");
        return;
    }
    $909b0c6b115083b5$export$5e8e70b5f122ac9(chart, {
        x: rect.left,
        y: rect.top
    }, {
        x: rect.right,
        y: rect.bottom
    }, "zoom");
    setTimeout(()=>state.dragging = false, 500);
    (0, $ffh6R.Q)(onZoomComplete, [
        {
            chart: chart
        }
    ]);
}
function $909b0c6b115083b5$var$wheelPreconditions(chart, event, zoomOptions) {
    // Before preventDefault, check if the modifier key required and pressed
    if ($909b0c6b115083b5$var$keyNotPressed($909b0c6b115083b5$var$getModifierKey(zoomOptions.wheel), event)) {
        (0, $ffh6R.Q)(zoomOptions.onZoomRejected, [
            {
                chart: chart,
                event: event
            }
        ]);
        return;
    }
    if ($909b0c6b115083b5$var$zoomStart(chart, event, zoomOptions) === false) return;
    // Prevent the event from triggering the default behavior (e.g. content scrolling).
    if (event.cancelable) event.preventDefault();
    // Firefox always fires the wheel event twice:
    // First without the delta and right after that once with the delta properties.
    if (event.deltaY === undefined) return;
    return true;
}
function $909b0c6b115083b5$var$wheel(chart, event) {
    const { handlers: { onZoomComplete: onZoomComplete }, options: { zoom: zoomOptions } } = $909b0c6b115083b5$var$getState(chart);
    if (!$909b0c6b115083b5$var$wheelPreconditions(chart, event, zoomOptions)) return;
    const rect = event.target.getBoundingClientRect();
    const speed = 1 + (event.deltaY >= 0 ? -zoomOptions.wheel.speed : zoomOptions.wheel.speed);
    const amount = {
        x: speed,
        y: speed,
        focalPoint: {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
        }
    };
    $909b0c6b115083b5$export$e83f174dbf56adcc(chart, amount);
    if (onZoomComplete) onZoomComplete();
}
function $909b0c6b115083b5$var$addDebouncedHandler(chart, name, handler, delay) {
    if (handler) $909b0c6b115083b5$var$getState(chart).handlers[name] = $909b0c6b115083b5$var$debounce(()=>(0, $ffh6R.Q)(handler, [
            {
                chart: chart
            }
        ]), delay);
}
function $909b0c6b115083b5$var$addListeners(chart, options) {
    const canvas = chart.canvas;
    const { wheel: wheelOptions, drag: dragOptions, onZoomComplete: onZoomComplete } = options.zoom;
    // Install listeners. Do this dynamically based on options so that we can turn zoom on and off
    // We also want to make sure listeners aren't always on. E.g. if you're scrolling down a page
    // and the mouse goes over a chart you don't want it intercepted unless the plugin is enabled
    if (wheelOptions.enabled) {
        $909b0c6b115083b5$var$addHandler(chart, canvas, "wheel", $909b0c6b115083b5$var$wheel);
        $909b0c6b115083b5$var$addDebouncedHandler(chart, "onZoomComplete", onZoomComplete, 250);
    } else $909b0c6b115083b5$var$removeHandler(chart, "wheel");
    if (dragOptions.enabled) {
        $909b0c6b115083b5$var$addHandler(chart, canvas, "mousedown", $909b0c6b115083b5$var$mouseDown);
        $909b0c6b115083b5$var$addHandler(chart, canvas.ownerDocument, "mouseup", $909b0c6b115083b5$var$mouseUp);
    } else {
        $909b0c6b115083b5$var$removeHandler(chart, "mousedown");
        $909b0c6b115083b5$var$removeHandler(chart, "mousemove");
        $909b0c6b115083b5$var$removeHandler(chart, "mouseup");
        $909b0c6b115083b5$var$removeHandler(chart, "keydown");
    }
}
function $909b0c6b115083b5$var$removeListeners(chart) {
    $909b0c6b115083b5$var$removeHandler(chart, "mousedown");
    $909b0c6b115083b5$var$removeHandler(chart, "mousemove");
    $909b0c6b115083b5$var$removeHandler(chart, "mouseup");
    $909b0c6b115083b5$var$removeHandler(chart, "wheel");
    $909b0c6b115083b5$var$removeHandler(chart, "click");
    $909b0c6b115083b5$var$removeHandler(chart, "keydown");
}
function $909b0c6b115083b5$var$createEnabler(chart, state) {
    return function(recognizer, event) {
        const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
        if (!panOptions || !panOptions.enabled) return false;
        const srcEvent = event && event.srcEvent;
        if (!srcEvent) return true;
        if (!state.panning && event.pointerType === "mouse" && ($909b0c6b115083b5$var$keyNotPressed($909b0c6b115083b5$var$getModifierKey(panOptions), srcEvent) || $909b0c6b115083b5$var$keyPressed($909b0c6b115083b5$var$getModifierKey(zoomOptions.drag), srcEvent))) {
            (0, $ffh6R.Q)(panOptions.onPanRejected, [
                {
                    chart: chart,
                    event: event
                }
            ]);
            return false;
        }
        return true;
    };
}
function $909b0c6b115083b5$var$pinchAxes(p0, p1) {
    // fingers position difference
    const pinchX = Math.abs(p0.clientX - p1.clientX);
    const pinchY = Math.abs(p0.clientY - p1.clientY);
    // diagonal fingers will change both (xy) axes
    const p = pinchX / pinchY;
    let x, y;
    if (p > 0.3 && p < 1.7) x = y = true;
    else if (pinchX > pinchY) x = true;
    else y = true;
    return {
        x: x,
        y: y
    };
}
function $909b0c6b115083b5$var$handlePinch(chart, state, e) {
    if (state.scale) {
        const { center: center, pointers: pointers } = e;
        // Hammer reports the total scaling. We need the incremental amount
        const zoomPercent = 1 / state.scale * e.scale;
        const rect = e.target.getBoundingClientRect();
        const pinch = $909b0c6b115083b5$var$pinchAxes(pointers[0], pointers[1]);
        const mode = state.options.zoom.mode;
        const amount = {
            x: pinch.x && $909b0c6b115083b5$var$directionEnabled(mode, "x", chart) ? zoomPercent : 1,
            y: pinch.y && $909b0c6b115083b5$var$directionEnabled(mode, "y", chart) ? zoomPercent : 1,
            focalPoint: {
                x: center.x - rect.left,
                y: center.y - rect.top
            }
        };
        $909b0c6b115083b5$export$e83f174dbf56adcc(chart, amount);
        // Keep track of overall scale
        state.scale = e.scale;
    }
}
function $909b0c6b115083b5$var$startPinch(chart, state) {
    if (state.options.zoom.pinch.enabled) state.scale = 1;
}
function $909b0c6b115083b5$var$endPinch(chart, state, e) {
    if (state.scale) {
        $909b0c6b115083b5$var$handlePinch(chart, state, e);
        state.scale = null; // reset
        (0, $ffh6R.Q)(state.options.zoom.onZoomComplete, [
            {
                chart: chart
            }
        ]);
    }
}
function $909b0c6b115083b5$var$handlePan(chart, state, e) {
    const delta = state.delta;
    if (delta) {
        state.panning = true;
        $909b0c6b115083b5$export$4c486572e961a974(chart, {
            x: e.deltaX - delta.x,
            y: e.deltaY - delta.y
        }, state.panScales);
        state.delta = {
            x: e.deltaX,
            y: e.deltaY
        };
    }
}
function $909b0c6b115083b5$var$startPan(chart, state, event) {
    const { enabled: enabled, onPanStart: onPanStart, onPanRejected: onPanRejected } = state.options.pan;
    if (!enabled) return;
    const rect = event.target.getBoundingClientRect();
    const point = {
        x: event.center.x - rect.left,
        y: event.center.y - rect.top
    };
    if ((0, $ffh6R.Q)(onPanStart, [
        {
            chart: chart,
            event: event,
            point: point
        }
    ]) === false) return (0, $ffh6R.Q)(onPanRejected, [
        {
            chart: chart,
            event: event
        }
    ]);
    state.panScales = $909b0c6b115083b5$var$getEnabledScalesByPoint(state.options.pan, point, chart);
    state.delta = {
        x: 0,
        y: 0
    };
    clearTimeout(state.panEndTimeout);
    $909b0c6b115083b5$var$handlePan(chart, state, event);
}
function $909b0c6b115083b5$var$endPan(chart, state) {
    state.delta = null;
    if (state.panning) {
        state.panEndTimeout = setTimeout(()=>state.panning = false, 500);
        (0, $ffh6R.Q)(state.options.pan.onPanComplete, [
            {
                chart: chart
            }
        ]);
    }
}
const $909b0c6b115083b5$var$hammers = new WeakMap();
function $909b0c6b115083b5$var$startHammer(chart, options) {
    const state = $909b0c6b115083b5$var$getState(chart);
    const canvas = chart.canvas;
    const { pan: panOptions, zoom: zoomOptions } = options;
    const mc = new (0, (/*@__PURE__*/$parcel$interopDefault($eO6Q6))).Manager(canvas);
    if (zoomOptions && zoomOptions.pinch.enabled) {
        mc.add(new (0, (/*@__PURE__*/$parcel$interopDefault($eO6Q6))).Pinch());
        mc.on("pinchstart", ()=>$909b0c6b115083b5$var$startPinch(chart, state));
        mc.on("pinch", (e)=>$909b0c6b115083b5$var$handlePinch(chart, state, e));
        mc.on("pinchend", (e)=>$909b0c6b115083b5$var$endPinch(chart, state, e));
    }
    if (panOptions && panOptions.enabled) {
        mc.add(new (0, (/*@__PURE__*/$parcel$interopDefault($eO6Q6))).Pan({
            threshold: panOptions.threshold,
            enable: $909b0c6b115083b5$var$createEnabler(chart, state)
        }));
        mc.on("panstart", (e)=>$909b0c6b115083b5$var$startPan(chart, state, e));
        mc.on("panmove", (e)=>$909b0c6b115083b5$var$handlePan(chart, state, e));
        mc.on("panend", ()=>$909b0c6b115083b5$var$endPan(chart, state));
    }
    $909b0c6b115083b5$var$hammers.set(chart, mc);
}
function $909b0c6b115083b5$var$stopHammer(chart) {
    const mc = $909b0c6b115083b5$var$hammers.get(chart);
    if (mc) {
        mc.remove("pinchstart");
        mc.remove("pinch");
        mc.remove("pinchend");
        mc.remove("panstart");
        mc.remove("pan");
        mc.remove("panend");
        mc.destroy();
        $909b0c6b115083b5$var$hammers.delete(chart);
    }
}
var $909b0c6b115083b5$var$version = "2.0.1";
function $909b0c6b115083b5$var$draw(chart, caller, options) {
    const dragOptions = options.zoom.drag;
    const { dragStart: dragStart, dragEnd: dragEnd } = $909b0c6b115083b5$var$getState(chart);
    if (dragOptions.drawTime !== caller || !dragEnd) return;
    const { left: left, top: top, width: width, height: height } = $909b0c6b115083b5$var$computeDragRect(chart, options.zoom.mode, dragStart, dragEnd);
    const ctx = chart.ctx;
    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = dragOptions.backgroundColor || "rgba(225,225,225,0.3)";
    ctx.fillRect(left, top, width, height);
    if (dragOptions.borderWidth > 0) {
        ctx.lineWidth = dragOptions.borderWidth;
        ctx.strokeStyle = dragOptions.borderColor || "rgba(225,225,225)";
        ctx.strokeRect(left, top, width, height);
    }
    ctx.restore();
}
var $909b0c6b115083b5$export$2e2bcd8739ae039 = {
    id: "zoom",
    version: $909b0c6b115083b5$var$version,
    defaults: {
        pan: {
            enabled: false,
            mode: "xy",
            threshold: 10,
            modifierKey: null
        },
        zoom: {
            wheel: {
                enabled: false,
                speed: 0.1,
                modifierKey: null
            },
            drag: {
                enabled: false,
                drawTime: "beforeDatasetsDraw",
                modifierKey: null
            },
            pinch: {
                enabled: false
            },
            mode: "xy"
        }
    },
    start: function(chart, _args, options) {
        const state = $909b0c6b115083b5$var$getState(chart);
        state.options = options;
        if (Object.prototype.hasOwnProperty.call(options.zoom, "enabled")) console.warn("The option `zoom.enabled` is no longer supported. Please use `zoom.wheel.enabled`, `zoom.drag.enabled`, or `zoom.pinch.enabled`.");
        if (Object.prototype.hasOwnProperty.call(options.zoom, "overScaleMode") || Object.prototype.hasOwnProperty.call(options.pan, "overScaleMode")) console.warn("The option `overScaleMode` is deprecated. Please use `scaleMode` instead (and update `mode` as desired).");
        if (0, (/*@__PURE__*/$parcel$interopDefault($eO6Q6))) $909b0c6b115083b5$var$startHammer(chart, options);
        chart.pan = (delta, panScales, transition)=>$909b0c6b115083b5$export$4c486572e961a974(chart, delta, panScales, transition);
        chart.zoom = (args, transition)=>$909b0c6b115083b5$export$e83f174dbf56adcc(chart, args, transition);
        chart.zoomRect = (p0, p1, transition)=>$909b0c6b115083b5$export$5e8e70b5f122ac9(chart, p0, p1, transition);
        chart.zoomScale = (id, range, transition)=>$909b0c6b115083b5$export$bd064d51d863101c(chart, id, range, transition);
        chart.resetZoom = (transition)=>$909b0c6b115083b5$export$ac12f90bdc1d9b7(chart, transition);
        chart.getZoomLevel = ()=>$909b0c6b115083b5$var$getZoomLevel(chart);
        chart.getInitialScaleBounds = ()=>$909b0c6b115083b5$var$getInitialScaleBounds(chart);
        chart.isZoomedOrPanned = ()=>$909b0c6b115083b5$var$isZoomedOrPanned(chart);
    },
    beforeEvent (chart) {
        const state = $909b0c6b115083b5$var$getState(chart);
        if (state.panning || state.dragging) // cancel any event handling while panning or dragging
        return false;
    },
    beforeUpdate: function(chart, args, options) {
        const state = $909b0c6b115083b5$var$getState(chart);
        state.options = options;
        $909b0c6b115083b5$var$addListeners(chart, options);
    },
    beforeDatasetsDraw (chart, _args, options) {
        $909b0c6b115083b5$var$draw(chart, "beforeDatasetsDraw", options);
    },
    afterDatasetsDraw (chart, _args, options) {
        $909b0c6b115083b5$var$draw(chart, "afterDatasetsDraw", options);
    },
    beforeDraw (chart, _args, options) {
        $909b0c6b115083b5$var$draw(chart, "beforeDraw", options);
    },
    afterDraw (chart, _args, options) {
        $909b0c6b115083b5$var$draw(chart, "afterDraw", options);
    },
    stop: function(chart) {
        $909b0c6b115083b5$var$removeListeners(chart);
        if (0, (/*@__PURE__*/$parcel$interopDefault($eO6Q6))) $909b0c6b115083b5$var$stopHammer(chart);
        $909b0c6b115083b5$var$removeState(chart);
    },
    panFunctions: $909b0c6b115083b5$var$panFunctions,
    zoomFunctions: $909b0c6b115083b5$var$zoomFunctions,
    zoomRectFunctions: $909b0c6b115083b5$var$zoomRectFunctions
};

});
parcelRegister("eO6Q6", function(module, exports) {
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    "use strict";
    var VENDOR_PREFIXES = [
        "",
        "webkit",
        "Moz",
        "MS",
        "ms",
        "o"
    ];
    var TEST_ELEMENT = document1.createElement("div");
    var TYPE_FUNCTION = "function";
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function() {
            var e = new Error("get-stack-trace");
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== "function") assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, "extend", "Use `assign`.");
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, "merge", "Use `assign`.");
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, "PointerEvent") !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        "x",
        "y"
    ];
    var PROPS_CLIENT_XY = [
        "clientX",
        "clientY"
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit("hammer.input", input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = "MSPointerDown";
        POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, "pointerId");
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), "identifier", true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation"; // not implemented
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(" "));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            "auto",
            "manipulation",
            "pan-y",
            "pan-x",
            "pan-x pan-y",
            "none"
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports("touch-action", val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "requireFailure", this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return "cancel";
        else if (state & STATE_ENDED) return "end";
        else if (state & STATE_CHANGED) return "move";
        else if (state & STATE_BEGAN) return "start";
        return "";
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return "down";
        else if (direction == DIRECTION_UP) return "up";
        else if (direction == DIRECTION_LEFT) return "left";
        else if (direction == DIRECTION_RIGHT) return "right";
        return "";
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? "in" : "out";
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: "press",
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: "swipe",
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = "2.0.7";
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    "rotate"
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    "swipe"
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: "doubletap",
                    taps: 2
                },
                [
                    "tap"
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: "none",
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: "none",
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: "none",
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: "none",
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: "none",
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || "";
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== "undefined" ? window1 : typeof self !== "undefined" ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === "function" && define.amd) define(function() {
        return Hammer;
    });
    else if (0, module.exports) module.exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, "Hammer");

});

parcelRegister("kkOd7", function(module, exports) {

$parcel$export(module.exports, "callback", function () { return (parcelRequire("ffh6R")).Q; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("ffh6R")).F; });
$parcel$export(module.exports, "getRelativePosition", function () { return (parcelRequire("ffh6R")).z; });
$parcel$export(module.exports, "sign", function () { return (parcelRequire("ffh6R")).s; });
$parcel$export(module.exports, "valueOrDefault", function () { return (parcelRequire("ffh6R")).v; });

var $ffh6R = parcelRequire("ffh6R");

});


parcelRegister("i2nlv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d21a85e2a53ec164$export$2e2bcd8739ae039; });

var $hmFZG = parcelRequire("hmFZG");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");
function $d21a85e2a53ec164$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $hmFZG.default)(dirtyDate, -amount);
}

});

parcelRegister("lhFGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7eb85728f709540$export$2e2bcd8739ae039; });

var $7mQI5 = parcelRequire("7mQI5");

var $7GcJU = parcelRequire("7GcJU");

var $9xbCI = parcelRequire("9xbCI");
function $f7eb85728f709540$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $7mQI5.default)(dirtyDate, -amount);
}

});

parcelRegister("12XdK", function(module, exports) {

$parcel$export(module.exports, "MultiSelect", function () { return $0c33ea58ec2feee1$export$1e7dfd31545b5809; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $jr5t3 = parcelRequire("jr5t3");

var $9pANH = parcelRequire("9pANH");

var $bRIbs = parcelRequire("bRIbs");

var $2v3zC = parcelRequire("2v3zC");

var $f6Dhj = parcelRequire("f6Dhj");

var $hB9Eg = parcelRequire("hB9Eg");

var $cpfnh = parcelRequire("cpfnh");

var $7nrKB = parcelRequire("7nrKB");

var $5B1eM = parcelRequire("5B1eM");

var $ingJg = parcelRequire("ingJg");

var $dL2Vy = parcelRequire("dL2Vy");

var $eXeTx = parcelRequire("eXeTx");

var $fQRXQ = parcelRequire("fQRXQ");

var $kl2VR = parcelRequire("kl2VR");

var $1PxL0 = parcelRequire("1PxL0");
"use client";
function $0c33ea58ec2feee1$var$_extends() {
    return $0c33ea58ec2feee1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c33ea58ec2feee1$var$_extends.apply(null, arguments);
}
function $0c33ea58ec2feee1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c33ea58ec2feee1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c33ea58ec2feee1$var$_typeof(o);
}
function $0c33ea58ec2feee1$var$toPrimitive(t, r) {
    if ("object" != $0c33ea58ec2feee1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c33ea58ec2feee1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0c33ea58ec2feee1$var$toPropertyKey(t) {
    var i = $0c33ea58ec2feee1$var$toPrimitive(t, "string");
    return "symbol" == $0c33ea58ec2feee1$var$_typeof(i) ? i : i + "";
}
function $0c33ea58ec2feee1$var$_defineProperty(e, r, t) {
    return (r = $0c33ea58ec2feee1$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0c33ea58ec2feee1$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0c33ea58ec2feee1$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $0c33ea58ec2feee1$var$_arrayLikeToArray$1(r);
}
function $0c33ea58ec2feee1$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $0c33ea58ec2feee1$var$_unsupportedIterableToArray$1(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c33ea58ec2feee1$var$_arrayLikeToArray$1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c33ea58ec2feee1$var$_arrayLikeToArray$1(r, a) : void 0;
    }
}
function $0c33ea58ec2feee1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c33ea58ec2feee1$var$_toConsumableArray(r) {
    return $0c33ea58ec2feee1$var$_arrayWithoutHoles(r) || $0c33ea58ec2feee1$var$_iterableToArray(r) || $0c33ea58ec2feee1$var$_unsupportedIterableToArray$1(r) || $0c33ea58ec2feee1$var$_nonIterableSpread();
}
function $0c33ea58ec2feee1$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
function $0c33ea58ec2feee1$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $0c33ea58ec2feee1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0c33ea58ec2feee1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c33ea58ec2feee1$var$_slicedToArray(r, e) {
    return $0c33ea58ec2feee1$var$_arrayWithHoles(r) || $0c33ea58ec2feee1$var$_iterableToArrayLimit(r, e) || $0c33ea58ec2feee1$var$_unsupportedIterableToArray$1(r, e) || $0c33ea58ec2feee1$var$_nonIterableRest();
}
var $0c33ea58ec2feee1$var$classes$1 = {
    root: function root(_ref) {
        var _props$value;
        var props = _ref.props, context = _ref.context, focusedState = _ref.focusedState, overlayVisibleState = _ref.overlayVisibleState;
        return (0, $7nrKB.classNames)("p-multiselect p-component p-inputwrapper", {
            "p-multiselect-chip": props.display === "chip" && (props.maxSelectedLabels == null ? true : ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) <= props.maxSelectedLabels),
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled",
            "p-multiselect-clearable": props.showClear && !props.disabled,
            "p-focus": focusedState,
            "p-inputwrapper-filled": (0, $7nrKB.ObjectUtils).isNotEmpty(props.value),
            "p-inputwrapper-focus": focusedState || overlayVisibleState
        });
    },
    label: function label(_ref2) {
        var _props$value2;
        var props = _ref2.props, empty = _ref2.empty;
        return (0, $7nrKB.classNames)("p-multiselect-label", {
            "p-placeholder": empty && props.placeholder,
            "p-multiselect-label-empty": empty && !props.placeholder && !props.selectedItemTemplate,
            "p-multiselect-items-label": !empty && props.display !== "chip" && ((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.length) > props.maxSelectedLabels
        });
    },
    panel: function panel(_ref3) {
        var props = _ref3.panelProps, context = _ref3.context, allowOptionSelect = _ref3.allowOptionSelect;
        return (0, $7nrKB.classNames)("p-multiselect-panel p-component", {
            "p-multiselect-inline": props.inline,
            "p-multiselect-flex": props.flex,
            "p-multiselect-limited": !allowOptionSelect,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    list: function list(_ref4) {
        var virtualScrollerOptions = _ref4.virtualScrollerOptions;
        return virtualScrollerOptions ? "p-multiselect-items p-component" : "p-multiselect-items p-component";
    },
    labelContainer: "p-multiselect-label-container",
    triggerIcon: "p-multiselect-trigger-icon p-c",
    trigger: "p-multiselect-trigger",
    clearIcon: "p-multiselect-clear-icon",
    tokenLabel: "p-multiselect-token-label",
    token: "p-multiselect-token",
    removeTokenIcon: "p-multiselect-token-icon",
    wrapper: "p-multiselect-items-wrapper",
    emptyMessage: "p-multiselect-empty-message",
    itemGroup: "p-multiselect-item-group",
    closeButton: "p-multiselect-close p-link",
    header: "p-multiselect-header",
    closeIcon: "p-multiselect-close-icon",
    headerCheckboxContainer: "p-multiselect-select-all",
    headerCheckboxIcon: "p-multiselect-select-all p-checkbox-icon p-c",
    headerSelectAllLabel: "p-multiselect-select-all-label",
    filterContainer: "p-multiselect-filter-container",
    filterIcon: "p-multiselect-filter-icon",
    item: function item(_ref5) {
        var props = _ref5.itemProps;
        return (0, $7nrKB.classNames)("p-multiselect-item", {
            "p-highlight": props.selected,
            "p-disabled": props.disabled,
            "p-focus": props.focusedOptionIndex === props.index
        });
    },
    checkboxContainer: "p-multiselect-checkbox",
    checkboxIcon: "p-checkbox-icon p-c",
    transition: "p-connected-overlay"
};
var $0c33ea58ec2feee1$var$styles = "\n@layer primereact {\n    .p-multiselect {\n        display: inline-flex;\n        user-select: none;\n        cursor: pointer;\n    }\n    \n    .p-multiselect-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        cursor: pointer;\n    }\n    \n    .p-multiselect-label-container {\n        overflow: hidden;\n        flex: 1 1 auto;\n        cursor: pointer;\n    }\n    \n    .p-multiselect-label  {\n        display: block;\n        white-space: nowrap;\n        cursor: pointer;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    \n    .p-multiselect-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n    \n    .p-multiselect-token {\n        cursor: default;\n        display: inline-flex;\n        align-items: center;\n        flex: 0 0 auto;\n    }\n    \n    .p-multiselect-token-icon {\n        cursor: pointer;\n    }\n    \n    .p-multiselect .p-multiselect-panel {\n        min-width: 100%;\n    }\n    \n    .p-multiselect-inline.p-multiselect-panel {\n        border: none;\n        position: initial;\n        background: none;\n        box-shadow: none;\n    }\n    \n    .p-multiselect-inline.p-multiselect-panel .p-multiselect-items {\n        padding: 0;\n    }\n    \n    .p-multiselect-flex.p-multiselect-panel .p-multiselect-items {\n        display: flex;\n        flex-wrap: wrap;\n    }\n    \n    .p-multiselect-items-wrapper {\n        overflow: auto;\n    }\n    \n    .p-multiselect-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-multiselect-item {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n        outline: none;\n    }\n    \n    .p-multiselect-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    \n    .p-multiselect-select-all-label {\n        margin-left: 0.5rem;\n    }\n    \n    .p-multiselect-filter-container {\n        position: relative;\n        flex: 1 1 auto;\n    }\n    \n    .p-multiselect-filter-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n    }\n    \n    .p-multiselect-filter-container .p-inputtext {\n        width: 100%;\n    }\n    \n    .p-multiselect-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        overflow: hidden;\n        position: relative;\n        margin-left: auto;\n    }\n    \n    .p-multiselect-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n        right: 3rem;\n    }\n    \n    .p-fluid .p-multiselect {\n        display: flex;\n    }\n}\n";
var $0c33ea58ec2feee1$var$inlineStyles = {
    root: function root(_ref6) {
        var props = _ref6.props;
        return props.showClear && !props.disabled && {
            position: "relative"
        };
    },
    itemGroup: function itemGroup(_ref7) {
        var scrollerOptions = _ref7.scrollerOptions;
        return {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
    }
};
var $0c33ea58ec2feee1$var$MultiSelectBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "MultiSelect",
        appendTo: null,
        ariaLabelledBy: null,
        checkboxIcon: null,
        className: null,
        clearIcon: null,
        closeIcon: null,
        dataKey: null,
        disabled: false,
        display: "comma",
        dropdownIcon: null,
        emptyFilterMessage: null,
        emptyMessage: null,
        filter: false,
        filterBy: null,
        filterDelay: 300,
        filterInputAutoFocus: true,
        filterLocale: undefined,
        selectOnFocus: false,
        focusOnHover: true,
        autoOptionFocus: false,
        filterMatchMode: "contains",
        filterPlaceholder: null,
        filterTemplate: null,
        fixedPlaceholder: false,
        flex: false,
        id: null,
        inline: false,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        itemCheckboxIcon: null,
        itemClassName: null,
        itemTemplate: null,
        loading: false,
        loadingIcon: null,
        maxSelectedLabels: null,
        name: null,
        onBlur: null,
        onChange: null,
        onClick: null,
        onFilter: null,
        onFocus: null,
        onHide: null,
        onRemove: null,
        onSelectAll: null,
        onShow: null,
        optionDisabled: null,
        optionGroupChildren: null,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        optionValue: null,
        options: null,
        overlayVisible: false,
        panelClassName: null,
        panelFooterTemplate: null,
        panelHeaderTemplate: null,
        panelStyle: null,
        placeholder: null,
        removeIcon: null,
        resetFilterOnHide: false,
        scrollHeight: "200px",
        selectAll: false,
        selectAllLabel: null,
        selectedItemTemplate: null,
        selectedItemsLabel: undefined,
        selectionLimit: null,
        showClear: false,
        showSelectAll: true,
        style: null,
        tabIndex: 0,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        useOptionAsValue: false,
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        classes: $0c33ea58ec2feee1$var$classes$1,
        styles: $0c33ea58ec2feee1$var$styles,
        inlineStyles: $0c33ea58ec2feee1$var$inlineStyles
    }
});
var $0c33ea58ec2feee1$var$classes = {
    box: "p-checkbox-box",
    input: "p-checkbox-input",
    icon: "p-checkbox-icon",
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $7nrKB.classNames)("p-checkbox p-component", {
            "p-highlight": checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $0c33ea58ec2feee1$var$CheckboxBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Checkbox",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $0c33ea58ec2feee1$var$classes
    }
});
function $0c33ea58ec2feee1$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c33ea58ec2feee1$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c33ea58ec2feee1$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $0c33ea58ec2feee1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c33ea58ec2feee1$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c33ea58ec2feee1$var$Checkbox = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $0c33ea58ec2feee1$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $0c33ea58ec2feee1$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $kHEnT.useHandleStyle)($0c33ea58ec2feee1$var$CheckboxBase.css.styles, isUnstyled, {
        name: "checkbox"
    });
    var elementRef = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readOnly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: "checkbox",
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $7nrKB.DomHandler).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus(event) {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var _onBlur = function onBlur(event) {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $jr5t3.useMountEffect)(function() {
        if (props.autoFocus) (0, $7nrKB.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $0c33ea58ec2feee1$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            checked: checked,
            context: context
        })),
        style: props.style,
        "data-p-highlight": checked,
        "data-p-disabled": props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm("root"));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $7nrKB.ObjectUtils).reduceKeys(otherProps, (0, $7nrKB.DomHandler).ARIA_PROPS);
        var inputProps = mergeProps($0c33ea58ec2feee1$var$_objectSpread$4({
            id: props.inputId,
            type: "checkbox",
            className: cx("input"),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus(e);
            },
            onBlur: function onBlur(e) {
                return _onBlur(e);
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            "aria-invalid": props.invalid,
            checked: checked
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $7E7Dk.createElement("input", $0c33ea58ec2feee1$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var boxProps = mergeProps({
            className: cx("box", {
                checked: checked
            }),
            "data-p-highlight": checked,
            "data-p-disabled": props.disabled
        }, ptm("box"));
        var icon = checked ? props.icon || /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), iconProps) : null;
        var checkboxIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $0c33ea58ec2feee1$var$_objectSpread$4({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $7E7Dk.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", $0c33ea58ec2feee1$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $0c33ea58ec2feee1$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$0c33ea58ec2feee1$var$Checkbox.displayName = "Checkbox";
function $0c33ea58ec2feee1$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c33ea58ec2feee1$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c33ea58ec2feee1$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $0c33ea58ec2feee1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c33ea58ec2feee1$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c33ea58ec2feee1$var$MultiSelectHeader = /*#__PURE__*/ $7E7Dk.memo(function(props) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, isUnstyled = props.isUnstyled;
    var filterOptions = {
        filter: function filter1(e) {
            return onFilter(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $0c33ea58ec2feee1$var$_objectSpread$3({
            hostName: props.hostName
        }, options));
    };
    var onFilter = function onFilter(event) {
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            query: event.target.value
        });
    };
    var onToggleAll = function onToggleAll(event) {
        if (props.onSelectAll) props.onSelectAll({
            originalEvent: event,
            checked: props.selectAll
        });
        else {
            var value = props.isAllSelected() ? [] : props.visibleOptions.filter(function(option) {
                return props.isValidOption(option);
            }).map(function(option) {
                return props.getOptionValue(option);
            });
            props.updateModel(event, value, value);
        }
    };
    var createFilterElement = function createFilterElement() {
        var filterIconProps = mergeProps({
            className: cx("filterIcon")
        }, getPTOptions("filterIcon"));
        var icon = props.filterIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $fQRXQ.SearchIcon), filterIconProps);
        var filterIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $0c33ea58ec2feee1$var$_objectSpread$3({}, filterIconProps), {
            props: props
        });
        if (props.filter) {
            var filterContainerProps = mergeProps({
                className: cx("filterContainer")
            }, getPTOptions("filterContainer"));
            var content = /*#__PURE__*/ $7E7Dk.createElement("div", filterContainerProps, /*#__PURE__*/ $7E7Dk.createElement((0, $kl2VR.InputText), {
                ref: props.filterRef,
                type: "text",
                role: "searchbox",
                value: props.filterValue,
                onChange: onFilter,
                onKeyDown: props.onFilterKeyDown,
                className: "p-multiselect-filter",
                placeholder: props.filterPlaceholder,
                pt: ptm("filterInput"),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                }
            }), filterIcon);
            if (props.filterTemplate) {
                var defaultContentOptions = {
                    className: filterContainerProps.className,
                    element: content,
                    filterOptions: filterOptions,
                    onFilter: onFilter,
                    filterIconClassName: props.filterIconClassName,
                    props: props
                };
                content = (0, $7nrKB.ObjectUtils).getJSXElement(props.filterTemplate, defaultContentOptions);
            }
            return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, content);
        }
        return null;
    };
    var filterElement = createFilterElement();
    var selectAllId = props.id ? props.id + "_selectall" : (0, $7nrKB.UniqueComponentId)();
    var headerSelectAllLabelProps = mergeProps({
        htmlFor: selectAllId,
        className: cx("headerSelectAllLabel")
    }, getPTOptions("headerSelectAllLabel"));
    var headerCheckboxIconProps = mergeProps({
        className: cx("headerCheckboxIcon")
    }, getPTOptions("headerCheckbox.icon"));
    var headerCheckboxContainerProps = mergeProps({
        className: cx("headerCheckboxContainer")
    }, getPTOptions("headerCheckboxContainer"));
    var checkedIcon = props.itemCheckboxIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), headerCheckboxIconProps);
    var itemCheckboxIcon = (0, $7nrKB.IconUtils).getJSXIcon(checkedIcon, $0c33ea58ec2feee1$var$_objectSpread$3({}, headerCheckboxIconProps), {
        selected: props.selected
    });
    var checkboxElement = props.showSelectAll && /*#__PURE__*/ $7E7Dk.createElement("div", headerCheckboxContainerProps, /*#__PURE__*/ $7E7Dk.createElement($0c33ea58ec2feee1$var$Checkbox, {
        id: selectAllId,
        checked: props.selectAll,
        onChange: onToggleAll,
        role: "checkbox",
        "aria-checked": props.selectAll,
        icon: itemCheckboxIcon,
        pt: ptm("headerCheckbox"),
        unstyled: isUnstyled()
    }), !props.filter && /*#__PURE__*/ $7E7Dk.createElement("label", headerSelectAllLabelProps, props.selectAllLabel));
    var iconProps = mergeProps({
        className: cx("closeIcon"),
        "aria-hidden": true
    }, getPTOptions("closeIcon"));
    var icon = props.closeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), iconProps);
    var closeIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $0c33ea58ec2feee1$var$_objectSpread$3({}, iconProps), {
        props: props
    });
    var headerProps = mergeProps({
        className: cx("header")
    }, getPTOptions("header"));
    var closeButtonProps = mergeProps({
        type: "button",
        className: cx("closeButton"),
        "aria-label": (0, $eHYdO.ariaLabel)("close"),
        onClick: props.onClose
    }, getPTOptions("closeButton"));
    var closeElement = /*#__PURE__*/ $7E7Dk.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
    var element = /*#__PURE__*/ $7E7Dk.createElement("div", headerProps, checkboxElement, filterElement, closeElement);
    if (props.template) {
        var defaultOptions = {
            className: "p-multiselect-header",
            checkboxElement: checkboxElement,
            checked: props.selectAll,
            onChange: onToggleAll,
            filterElement: filterElement,
            closeElement: closeElement,
            closeElementClassName: "p-multiselect-close p-link",
            closeIconClassName: "p-multiselect-close-icon",
            onCloseClick: props.onClose,
            element: element,
            itemCheckboxIcon: itemCheckboxIcon,
            props: props
        };
        return (0, $7nrKB.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$0c33ea58ec2feee1$var$MultiSelectHeader.displayName = "MultiSelectHeader";
function $0c33ea58ec2feee1$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c33ea58ec2feee1$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c33ea58ec2feee1$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $0c33ea58ec2feee1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c33ea58ec2feee1$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c33ea58ec2feee1$var$MultiSelectItem = /*#__PURE__*/ $7E7Dk.memo(function(props) {
    var _React$useState = $7E7Dk.useState(false), _React$useState2 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var checkboxRef = $7E7Dk.useRef(null);
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, isUnstyled = props.isUnstyled;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                selected: props.selected,
                disabled: props.disabled,
                focused: focusedState,
                focusedIndex: props.focusedIndex,
                index: props.index
            }
        });
    };
    var onFocus = function onFocus(event) {
        var _checkboxRef$current;
        setFocusedState(true);
        checkboxRef === null || checkboxRef === void 0 || (_checkboxRef$current = checkboxRef.current) === null || _checkboxRef$current === void 0 || _checkboxRef$current.getInput().focus();
    };
    var onBlur = function onBlur(event) {
        setFocusedState(false);
    };
    var onClick = function onClick(event) {
        if (props.onClick) props.onClick(event, props.option);
        event.preventDefault();
        event.stopPropagation();
    };
    var checkboxIconProps = mergeProps({
        className: cx("checkboxIcon")
    }, getPTOptions("checkbox.icon"));
    var icon = props.checkboxIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), checkboxIconProps);
    var checkboxIcon = props.selected ? (0, $7nrKB.IconUtils).getJSXIcon(icon, $0c33ea58ec2feee1$var$_objectSpread$2({}, checkboxIconProps), {
        selected: props.selected
    }) : null;
    var content = props.template ? (0, $7nrKB.ObjectUtils).getJSXElement(props.template, props.option) : props.label;
    var checkboxContainerProps = mergeProps({
        className: cx("checkboxContainer")
    }, getPTOptions("checkboxContainer"));
    var itemProps = mergeProps({
        className: (0, $7nrKB.classNames)(props.className, props.option.className, cx("item", {
            itemProps: props
        })),
        style: props.style,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseMove: function onMouseMove(e) {
            return props === null || props === void 0 ? void 0 : props.onMouseMove(e, props.index);
        },
        role: "option",
        "aria-selected": props.selected,
        "data-p-highlight": props.selected,
        "data-p-disabled": props.disabled
    }, getPTOptions("item"));
    return /*#__PURE__*/ $7E7Dk.createElement("li", itemProps, /*#__PURE__*/ $7E7Dk.createElement("div", checkboxContainerProps, /*#__PURE__*/ $7E7Dk.createElement($0c33ea58ec2feee1$var$Checkbox, {
        ref: checkboxRef,
        checked: props.selected,
        icon: checkboxIcon,
        pt: ptm("checkbox"),
        unstyled: isUnstyled(),
        tabIndex: -1
    })), /*#__PURE__*/ $7E7Dk.createElement("span", null, content), /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
});
$0c33ea58ec2feee1$var$MultiSelectItem.displayName = "MultiSelectItem";
function $0c33ea58ec2feee1$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c33ea58ec2feee1$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c33ea58ec2feee1$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $0c33ea58ec2feee1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c33ea58ec2feee1$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c33ea58ec2feee1$var$MultiSelectPanel = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(props, ref) {
    var virtualScrollerRef = $7E7Dk.useRef(null);
    var filterInputRef = $7E7Dk.useRef(null);
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var ptm = props.ptm, cx = props.cx, sx = props.sx, isUnstyled = props.isUnstyled;
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $0c33ea58ec2feee1$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onEnter = function onEnter() {
        props.onEnter(function() {
            if (virtualScrollerRef.current) {
                var selectedIndex = props.getSelectedOptionIndex();
                if (selectedIndex !== -1) setTimeout(function() {
                    return virtualScrollerRef.current.scrollToIndex(selectedIndex);
                }, 0);
            }
        });
    };
    var onEntered = function onEntered() {
        props.onEntered(function() {
            if (props.filter && props.filterInputAutoFocus && filterInputRef.current) (0, $7nrKB.DomHandler).focus(filterInputRef.current, false);
        });
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        if (virtualScrollerRef.current) virtualScrollerRef.current.scrollToIndex(0);
        props.onFilterInputChange && props.onFilterInputChange(event);
    };
    var isEmptyFilter = function isEmptyFilter() {
        return !(props.visibleOptions && props.visibleOptions.length) && props.hasFilter;
    };
    var createHeader = function createHeader() {
        return /*#__PURE__*/ $7E7Dk.createElement($0c33ea58ec2feee1$var$MultiSelectHeader, {
            hostName: props.hostName,
            id: props.id,
            filter: props.filter,
            filterRef: filterInputRef,
            filterValue: props.filterValue,
            filterTemplate: props.filterTemplate,
            visibleOptions: props.visibleOptions,
            isValidOption: props.isValidOption,
            getOptionValue: props.getOptionValue,
            updateModel: props.updateModel,
            onFilter: onFilterInputChange,
            onFilterKeyDown: props.onFilterKeyDown,
            filterPlaceholder: props.filterPlaceholder,
            onClose: props.onCloseClick,
            showSelectAll: props.showSelectAll,
            selectAll: props.isAllSelected(),
            selectAllLabel: props.selectAllLabel,
            onSelectAll: props.onSelectAll,
            template: props.panelHeaderTemplate,
            resetFilter: props.resetFilter,
            closeIcon: props.closeIcon,
            filterIcon: props.filterIcon,
            itemCheckboxIcon: props.itemCheckboxIcon,
            ptm: ptm,
            cx: cx,
            isUnstyled: isUnstyled,
            metaData: props.metaData
        });
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $7nrKB.ObjectUtils).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            return /*#__PURE__*/ $7E7Dk.createElement("div", {
                className: "p-multiselect-footer"
            }, content);
        }
        return null;
    };
    var changeFocusedItemOnHover = function changeFocusedItemOnHover(event, index) {
        if (props.focusOnHover) {
            var _props$changeFocusedO;
            props === null || props === void 0 || (_props$changeFocusedO = props.changeFocusedOptionIndex) === null || _props$changeFocusedO === void 0 || _props$changeFocusedO.call(props, event, index);
        }
    };
    var createEmptyFilter = function createEmptyFilter() {
        var emptyFilterMessage = (0, $7nrKB.ObjectUtils).getJSXElement(props.emptyFilterMessage, props) || (0, $eHYdO.localeOption)("emptyFilterMessage");
        var emptyMessageProps = mergeProps({
            className: cx("emptyMessage")
        }, getPTOptions("emptyMessage"));
        return /*#__PURE__*/ $7E7Dk.createElement("li", $0c33ea58ec2feee1$var$_extends({}, emptyMessageProps, {
            key: "emptyFilterMessage"
        }), emptyFilterMessage);
    };
    var createEmptyContent = function createEmptyContent() {
        var emptyMessage = (0, $7nrKB.ObjectUtils).getJSXElement(props.emptyMessage, props) || (0, $eHYdO.localeOption)("emptyMessage");
        var emptyMessageProps = mergeProps({
            className: cx("emptyMessage")
        }, getPTOptions("emptyMessage"));
        return /*#__PURE__*/ $7E7Dk.createElement("li", $0c33ea58ec2feee1$var$_extends({}, emptyMessageProps, {
            key: "emptyMessage"
        }), emptyMessage);
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        var isItemGroup = option.group === true && props.optionGroupLabel;
        if (isItemGroup) {
            var groupContent = props.optionGroupTemplate ? (0, $7nrKB.ObjectUtils).getJSXElement(props.optionGroupTemplate, option, index) : props.getOptionGroupLabel(option);
            var key = index + "_" + props.getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: cx("itemGroup"),
                style: sx("itemGroup", {
                    scrollerOptions: scrollerOptions
                })
            }, getPTOptions("itemGroup"));
            return /*#__PURE__*/ $7E7Dk.createElement("li", $0c33ea58ec2feee1$var$_extends({
                key: key
            }, itemGroupProps), groupContent);
        }
        var optionLabel = props.getOptionLabel(option);
        var optionKey = index + "_" + props.getOptionRenderKey(option);
        var disabled = props.isOptionDisabled(option);
        var selected = props.isSelected(option);
        return /*#__PURE__*/ $7E7Dk.createElement($0c33ea58ec2feee1$var$MultiSelectItem, {
            hostName: props.hostName,
            key: optionKey,
            focusedOptionIndex: props.focusedOptionIndex,
            label: optionLabel,
            option: option,
            style: style,
            index: index,
            template: props.itemTemplate,
            selected: selected,
            onClick: props.onOptionSelect,
            onMouseMove: changeFocusedItemOnHover,
            disabled: disabled,
            className: props.itemClassName,
            checkboxIcon: props.checkboxIcon,
            isUnstyled: isUnstyled,
            ptm: ptm,
            cx: cx
        });
    };
    var createItems = function createItems() {
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(props.visibleOptions)) return props.visibleOptions.map(createItem);
        return props.hasFilter ? createEmptyFilter() : createEmptyContent();
    };
    var createContent = function createContent() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $0c33ea58ec2feee1$var$_objectSpread$1($0c33ea58ec2feee1$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $0c33ea58ec2feee1$var$_objectSpread$1($0c33ea58ec2feee1$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                className: (0, $7nrKB.classNames)("p-multiselect-items-wrapper", props.virtualScrollerOptions.className),
                items: props.visibleOptions,
                autoSize: true,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($0c33ea58ec2feee1$var$_objectSpread$1($0c33ea58ec2feee1$var$_objectSpread$1({}, event), {
                        filter: props.filterValue
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var content = isEmptyFilter() ? createEmptyFilter() : options.children;
                    var listProps = mergeProps({
                        ref: options.contentRef,
                        style: options.style,
                        className: (0, $7nrKB.classNames)(options.className, cx("list", {
                            virtualScrollerProps: props.virtualScrollerOptions
                        })),
                        role: "listbox",
                        "aria-multiselectable": true
                    }, getPTOptions("list"));
                    return /*#__PURE__*/ $7E7Dk.createElement("ul", listProps, content);
                }
            });
            return /*#__PURE__*/ $7E7Dk.createElement((0, $dL2Vy.VirtualScroller), $0c33ea58ec2feee1$var$_extends({
                ref: virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptm("virtualScroller"),
                __parentMetadata: {
                    parent: props.metaData
                }
            }));
        }
        var items = createItems();
        var wrapperProps = mergeProps({
            className: cx("wrapper"),
            style: {
                maxHeight: props.scrollHeight
            }
        }, getPTOptions("wrapper"));
        var listProps = mergeProps({
            className: cx("list"),
            role: "listbox",
            "aria-multiselectable": true
        }, getPTOptions("list"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", wrapperProps, /*#__PURE__*/ $7E7Dk.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var allowOptionSelect = props.allowOptionSelect();
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $7nrKB.classNames)(props.panelClassName, cx("panel", {
                panelProps: props,
                context: context,
                allowOptionSelect: allowOptionSelect
            })),
            style: props.panelStyle,
            onClick: props.onClick
        }, getPTOptions("panel"));
        if (props.inline) return /*#__PURE__*/ $7E7Dk.createElement("div", $0c33ea58ec2feee1$var$_extends({
            ref: ref
        }, panelProps), content, footer);
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            appear: true,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, getPTOptions("transition"));
        var firstHiddenElementProps = mergeProps({
            ref: props.firstHiddenFocusableElementOnOverlay,
            role: "presentation",
            className: "p-hidden-accessible p-hidden-focusable",
            tabIndex: "0",
            onFocus: props.onFirstHiddenFocus,
            "data-p-hidden-accessible": true,
            "data-p-hidden-focusable": true
        }, ptm("hiddenFirstFocusableEl"));
        var lastHiddenElementProps = mergeProps({
            ref: props.lastHiddenFocusableElementOnOverlay,
            role: "presentation",
            className: "p-hidden-accessible p-hidden-focusable",
            tabIndex: "0",
            onFocus: props.onLastHiddenFocus,
            "data-p-hidden-accessible": true,
            "data-p-hidden-focusable": true
        }, ptm("hiddenLastFocusableEl"));
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $0c33ea58ec2feee1$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", $0c33ea58ec2feee1$var$_extends({
            ref: ref
        }, panelProps), /*#__PURE__*/ $7E7Dk.createElement("span", firstHiddenElementProps), header, content, footer, /*#__PURE__*/ $7E7Dk.createElement("span", lastHiddenElementProps)));
    };
    var element = createElement();
    if (props.inline) return element;
    return /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$0c33ea58ec2feee1$var$MultiSelectPanel.displayName = "MultiSelectPanel";
function $0c33ea58ec2feee1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c33ea58ec2feee1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c33ea58ec2feee1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c33ea58ec2feee1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c33ea58ec2feee1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c33ea58ec2feee1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0c33ea58ec2feee1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0c33ea58ec2feee1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c33ea58ec2feee1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c33ea58ec2feee1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0c33ea58ec2feee1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0c33ea58ec2feee1$export$1e7dfd31545b5809 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $0c33ea58ec2feee1$var$MultiSelectBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(null), _React$useState2 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState, 2), focusedOptionIndex = _React$useState2[0], setFocusedOptionIndex = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(false), _React$useState4 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState3, 2), clicked = _React$useState4[0], setClicked = _React$useState4[1];
    var _useDebounce = (0, $jr5t3.useDebounce)("", props.filterDelay || 0), _useDebounce2 = $0c33ea58ec2feee1$var$_slicedToArray(_useDebounce, 3), filterValue = _useDebounce2[0], filterState = _useDebounce2[1], setFilterState = _useDebounce2[2];
    var _React$useState5 = $7E7Dk.useState(-1), _React$useState6 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState5, 2), startRangeIndex = _React$useState6[0], setStartRangeIndex = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(false), _React$useState8 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState7, 2), focusedState = _React$useState8[0], setFocusedState = _React$useState8[1];
    var _React$useState9 = $7E7Dk.useState(props.inline), _React$useState10 = $0c33ea58ec2feee1$var$_slicedToArray(_React$useState9, 2), overlayVisibleState = _React$useState10[0], setOverlayVisibleState = _React$useState10[1];
    var elementRef = $7E7Dk.useRef(null);
    var searchValue = $7E7Dk.useRef(null);
    var searchTimeout = $7E7Dk.useRef(null);
    var firstHiddenFocusableElementOnOverlay = $7E7Dk.useRef(null);
    var lastHiddenFocusableElementOnOverlay = $7E7Dk.useRef(null);
    var inputRef = $7E7Dk.useRef(props.inputRef);
    var labelContainerRef = $7E7Dk.useRef(null);
    var overlayRef = $7E7Dk.useRef(null);
    var labelRef = $7E7Dk.useRef(null);
    var hasFilter = filterState && filterState.trim().length > 0;
    var empty = (0, $7nrKB.ObjectUtils).isEmpty(props.value);
    var equalityKey = props.optionValue ? null : props.dataKey;
    var metaData = {
        props: props,
        state: {
            filterState: filterState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    };
    var _MultiSelectBase$setM = $0c33ea58ec2feee1$var$MultiSelectBase.setMetaData(metaData), ptm = _MultiSelectBase$setM.ptm, cx = _MultiSelectBase$setM.cx, sx = _MultiSelectBase$setM.sx, isUnstyled = _MultiSelectBase$setM.isUnstyled;
    (0, $kHEnT.useHandleStyle)($0c33ea58ec2feee1$var$MultiSelectBase.css.styles, isUnstyled, {
        name: "multiselect"
    });
    var _useOverlayListener = (0, $jr5t3.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) {
                if (type === "outside") {
                    if (!isClearClicked(event) && !isSelectAllClicked(event)) hide();
                } else if (context.hideOverlaysOnDocumentScrolling) hide();
                else if (!(0, $7nrKB.DomHandler).isDocument(event.target)) alignOverlay();
            }
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $0c33ea58ec2feee1$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var onFirstHiddenFocus = function onFirstHiddenFocus(event) {
        var focusableEl = event.relatedTarget === inputRef.current ? (0, $7nrKB.DomHandler).getFirstFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : inputRef.current;
        (0, $7nrKB.DomHandler).focus(focusableEl);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var focusableEl = event.relatedTarget === inputRef.current ? (0, $7nrKB.DomHandler).getLastFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : inputRef.current;
        (0, $7nrKB.DomHandler).focus(focusableEl);
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $hB9Eg.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var allowOptionSelect = function allowOptionSelect() {
        return !props.selectionLimit || !props.value || props.value && props.value.length < props.selectionLimit;
    };
    var findNextSelectedOptionIndex = function findNextSelectedOptionIndex(index) {
        var matchedOptionIndex = hasSelectedOption() && index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : -1;
    };
    var findPrevSelectedOptionIndex = function findPrevSelectedOptionIndex(index) {
        var matchedOptionIndex = hasSelectedOption() && index > 0 ? (0, $7nrKB.ObjectUtils).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidSelectedOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : -1;
    };
    var findNearestSelectedOptionIndex = function findNearestSelectedOptionIndex(index) {
        var firstCheckUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var matchedOptionIndex = -1;
        if (hasSelectedOption()) {
            if (firstCheckUp) {
                matchedOptionIndex = findPrevSelectedOptionIndex(index);
                matchedOptionIndex = matchedOptionIndex === -1 ? findNextSelectedOptionIndex(index) : matchedOptionIndex;
            } else {
                matchedOptionIndex = findNextSelectedOptionIndex(index);
                matchedOptionIndex = matchedOptionIndex === -1 ? findPrevSelectedOptionIndex(index) : matchedOptionIndex;
            }
        }
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var onOptionSelectRange = function onOptionSelectRange(event) {
        var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        start === -1 && (start = findNearestSelectedOptionIndex(end, true));
        end === -1 && (end = findNearestSelectedOptionIndex(start));
        if (start !== -1 && end !== -1) {
            var rangeStart = Math.min(start, end);
            var rangeEnd = Math.max(start, end);
            var value = visibleOptions.slice(rangeStart, rangeEnd + 1).filter(function(option) {
                return isValidOption(option);
            }).map(function(option) {
                return getOptionValue(option);
            });
            updateModel(event, value, value);
        }
    };
    var onOptionSelect = function onOptionSelect(event, option) {
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        if (props.disabled || isOptionDisabled(option)) return;
        var selected = isSelected(option);
        var value = null;
        if (selected) value = props.value.filter(function(val) {
            return !(0, $7nrKB.ObjectUtils).equals(val, getOptionValue(option), equalityKey);
        });
        else value = [].concat($0c33ea58ec2feee1$var$_toConsumableArray(props.value || []), [
            getOptionValue(option)
        ]);
        updateModel(event, value, option);
        index !== -1 && setFocusedOptionIndex(index);
    };
    var onClick = function onClick(event) {
        if (!props.inline && !props.disabled && !props.loading && !isPanelClicked(event) && !isClearClicked(event)) {
            overlayVisibleState ? hide() : show();
            (0, $7nrKB.DomHandler).focus(inputRef.current);
            event.preventDefault();
        }
        setClicked(true);
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        if (!overlayVisibleState) {
            show();
            props.editable && changeFocusedOptionIndex(event, findSelectedOptionIndex());
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : clicked ? findFirstOptionIndex() : findFirstFocusedOptionIndex();
            if (event.shiftKey) onOptionSelectRange(event, startRangeIndex, optionIndex);
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event.altKey && !pressedInInputText) {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            overlayVisibleState && hide();
            event.preventDefault();
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : clicked ? findLastOptionIndex() : findLastFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
            event.preventDefault();
        }
    };
    var onEnterKey = function onEnterKey(event) {
        if (!overlayVisibleState) {
            setFocusedOptionIndex(-1);
            onArrowDownKey(event);
        } else if (focusedOptionIndex !== -1) {
            if (event.shiftKey) onOptionSelectRange(event, focusedOptionIndex);
            else onOptionSelect(event, visibleOptions[focusedOptionIndex]);
        }
        event.preventDefault();
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var currentTarget = event.currentTarget;
        if (pressedInInputText) {
            var len = currentTarget.value.length;
            currentTarget.setSelectionRange(0, event.shiftKey ? len : 0);
            setFocusedOptionIndex(-1);
        } else {
            var metaKey = event.metaKey || event.ctrlKey;
            var optionIndex = findFirstOptionIndex();
            if (event.shiftKey && metaKey) onOptionSelectRange(event, optionIndex, startRangeIndex);
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var currentTarget = event.currentTarget;
        if (pressedInInputText) {
            var len = currentTarget.value.length;
            currentTarget.setSelectionRange(event.shiftKey ? 0 : len, len);
            $0c33ea58ec2feee1$var$_readOnlyError("focusedOptionIndex");
        } else {
            var metaKey = event.metaKey || event.ctrlKey;
            var optionIndex = findLastOptionIndex();
            if (event.shiftKey && metaKey) onOptionSelectRange(event, startRangeIndex, optionIndex);
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!pressedInInputText) {
            if (overlayVisibleState && hasFocusableElements()) {
                (0, $7nrKB.DomHandler).focus(event.shiftKey ? lastHiddenFocusableElementOnOverlay.current : firstHiddenFocusableElementOnOverlay.current);
                event.preventDefault();
            } else {
                if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
                overlayVisibleState && hide(filter);
            }
        }
    };
    var onShiftKey = function onShiftKey() {
        setStartRangeIndex(focusedOptionIndex);
    };
    var onKeyDown = function onKeyDown(event) {
        var metaKey = event.metaKey || event.ctrlKey;
        switch(event.code){
            case "ArrowUp":
                if (props.inline) break;
                onArrowUpKey(event);
                break;
            case "ArrowDown":
                if (props.inline) break;
                onArrowDownKey(event);
                break;
            case "Space":
            case "NumpadEnter":
            case "Enter":
                if (props.inline) break;
                onEnterKey(event);
                break;
            case "Home":
                if (props.inline) break;
                onHomeKey(event);
                event.preventDefault();
                break;
            case "End":
                if (props.inline) break;
                onEndKey(event);
                event.preventDefault();
                break;
            case "PageDown":
                onPageDownKey(event);
                break;
            case "PageUp":
                onPageUpKey(event);
                break;
            case "Escape":
                if (props.inline) break;
                hide();
                break;
            case "Tab":
                onTabKey(event);
                break;
            case "ShiftLeft":
            case "ShiftRight":
                onShiftKey();
                break;
            default:
                if (event.key === "a" && metaKey) {
                    var value = visibleOptions.filter(function(option) {
                        return isValidOption(option);
                    }).map(function(option) {
                        return getOptionValue(option);
                    });
                    updateModel(event, value, value);
                    event.preventDefault();
                    break;
                }
                if (!metaKey && (0, $7nrKB.ObjectUtils).isPrintableCharacter(event.key)) {
                    !overlayVisibleState && show();
                    searchOptions(event);
                    event.preventDefault();
                }
                break;
        }
        setClicked(false);
    };
    var onFilterKeyDown = function onFilterKeyDown(event) {
        switch(event.code){
            case "ArrowUp":
                if (props.inline) break;
                onArrowUpKey(event);
                break;
            case "ArrowDown":
                if (props.inline) break;
                onArrowDownKey(event);
                break;
            case "NumpadEnter":
            case "Enter":
                if (props.inline) break;
                onEnterKey(event);
                break;
            case "Home":
                if (props.inline) break;
                onHomeKey(event);
                event.preventDefault();
                break;
            case "End":
                if (props.inline) break;
                onEndKey(event);
                event.preventDefault();
                break;
            case "Escape":
                if (props.inline) break;
                hide();
                break;
            case "Tab":
                onTabKey(event);
                break;
        }
    };
    var onSelectAll = function onSelectAll(event) {
        if (props.onSelectAll) props.onSelectAll(event);
        else {
            var value = null;
            if (event.checked) value = [];
            else {
                var validOptions = visibleOptions.filter(function(option) {
                    return isValidOption(option) && !isOptionDisabled(option);
                });
                if (validOptions) value = validOptions.map(function(option) {
                    return getOptionValue(option);
                });
            }
            // make sure not to exceed the selection limit
            if (props.selectionLimit && value && value.length) value = value.slice(0, props.selectionLimit);
            updateModel(event.originalEvent, value, value);
        }
    };
    var updateModel = function updateModel(event, value, selectedOption) {
        if (props.onChange) {
            props.onChange({
                originalEvent: event,
                value: value,
                selectedOption: selectedOption,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: value
                }
            });
            (0, $7nrKB.DomHandler).focus(inputRef.current);
        }
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        var filter1 = event.query;
        setFilterState(filter1);
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            filter: filter1
        });
    };
    var resetFilter = function resetFilter() {
        setFilterState("");
        props.onFilter && props.onFilter({
            filter: ""
        });
    };
    var scrollInView = function scrollInView(event) {
        if (!overlayVisibleState) return;
        var focusedItem;
        if (event) focusedItem = event.currentTarget;
        else focusedItem = (0, $7nrKB.DomHandler).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
        if (focusedItem && focusedItem.scrollIntoView) focusedItem.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
    };
    var show = function show() {
        setOverlayVisibleState(true);
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : findSelectedOptionIndex());
        (0, $7nrKB.DomHandler).focus(inputRef.current);
    };
    var hide = function hide() {
        setFocusedOptionIndex(-1);
        setOverlayVisibleState(false);
        setClicked(false);
    };
    var onOverlayEnter = function onOverlayEnter(callback) {
        (0, $7nrKB.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, context && context.zIndex.overlay || (0, $eHYdO.default).zIndex.overlay);
        (0, $7nrKB.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
        scrollInView();
        callback && callback();
    };
    var onOverlayEntered = function onOverlayEntered(callback) {
        callback && callback();
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        if (props.filter && props.resetFilterOnHide) resetFilter();
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        !props.inline && (0, $7nrKB.DomHandler).alignOverlay(overlayRef.current, labelContainerRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $eHYdO.default).appendTo);
    };
    var isClearClicked = function isClearClicked(event) {
        return (0, $7nrKB.DomHandler).getAttribute(event.target, "data-pc-section") === "clearicon";
    };
    var isSelectAllClicked = function isSelectAllClicked(event) {
        return (0, $7nrKB.DomHandler).getAttribute(event.target, "data-pc-section") === "headercheckboxcontainer";
    };
    var isPanelClicked = function isPanelClicked(event) {
        return overlayRef.current && overlayRef.current.contains(event.target);
    };
    var onCloseClick = function onCloseClick(event) {
        hide();
        (0, $7nrKB.DomHandler).focus(inputRef.current);
        event.preventDefault();
        event.stopPropagation();
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex() {
        if (props.value != null && props.options) {
            if (props.optionGroupLabel) {
                var groupIndex = 0;
                var optionIndex = props.options.findIndex(function(optionGroup, i) {
                    return (groupIndex = i) && findOptionIndexInList(props.value, getOptionGroupChildren(optionGroup)) !== -1;
                });
                return optionIndex !== -1 ? {
                    group: groupIndex,
                    option: optionIndex
                } : -1;
            }
            return findOptionIndexInList(props.value, props.options);
        }
        return -1;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        return list.findIndex(function(item) {
            return value.some(function(val) {
                return (0, $7nrKB.ObjectUtils).equals(val, getOptionValue(item), equalityKey);
            });
        });
    };
    var isEquals = function isEquals(value1, value2) {
        return (0, $7nrKB.ObjectUtils).equals(value1, value2, equalityKey);
    };
    var isSelected = function isSelected(option) {
        if (props.value) {
            var optionValue = getOptionValue(option);
            var isUsed = isOptionValueUsed(option);
            return props.value.some(function(val) {
                return (0, $7nrKB.ObjectUtils).equals(isUsed ? val : getOptionValue(val), optionValue, equalityKey);
            });
        }
        return false;
    };
    var getLabelByValue = function getLabelByValue(val) {
        var option;
        if (props.options) {
            if (props.optionGroupLabel) {
                var _iterator = $0c33ea58ec2feee1$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optionGroup = _step.value;
                        option = findOptionByValue(val, getOptionGroupChildren(optionGroup));
                        if (option) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            } else {
                option = findOptionByValue(val, props.options);
                if ((0, $7nrKB.ObjectUtils).isEmpty(option)) option = findOptionByValue(val, props.value);
            }
        }
        return option ? getOptionLabel(option) : null;
    };
    var findOptionByValue = function findOptionByValue(val, list) {
        return list.find(function(option) {
            return (0, $7nrKB.ObjectUtils).equals(getOptionValue(option), val, equalityKey);
        });
    };
    var onFocus = function onFocus(event) {
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var onBlur = function onBlur(event) {
        setFocusedState(false);
        props.onBlur && props.onBlur(event);
    };
    var isAllSelected = function isAllSelected() {
        if (props.onSelectAll) return props.selectAll;
        if ((0, $7nrKB.ObjectUtils).isEmpty(visibleOptions)) return false;
        var options = visibleOptions.filter(function(option) {
            return !isOptionDisabled(option) && isValidOption(option);
        });
        return !options.some(function(option) {
            return !isSelected(option);
        });
    };
    var getOptionLabel = function getOptionLabel(option) {
        return props.optionLabel ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionLabel) : option && option.label !== undefined ? option.label : option;
    };
    var getOptionValue = function getOptionValue(option) {
        if (props.useOptionAsValue) return option;
        if (props.optionValue) return (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.optionValue);
        return option && option.value !== undefined ? option.value : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $7nrKB.ObjectUtils).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $7nrKB.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        var _option$disabled;
        // disable if we have hit our selection limit
        if (!allowOptionSelect() && !isSelected(option)) return true;
        // check if custom optionDisabled function is being used
        var optionDisabled = props.optionDisabled;
        if (optionDisabled) return (0, $7nrKB.ObjectUtils).isFunction(optionDisabled) ? optionDisabled(option) : (0, $7nrKB.ObjectUtils).resolveFieldData(option, optionDisabled);
        // fallback to the option itself disabled value
        return option && ((_option$disabled = option.disabled) !== null && _option$disabled !== void 0 ? _option$disabled : false);
    };
    var isOptionValueUsed = function isOptionValueUsed(option) {
        return !props.useOptionAsValue && props.optionValue || option && option.value !== undefined;
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.group;
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $7nrKB.ObjectUtils).isNotEmpty(props.value);
    };
    var hasFocusableElements = function hasFocusableElements() {
        return (0, $7nrKB.DomHandler).getFocusableElements(overlayRef.current, ':not([data-p-hidden-focusable="true"])').length > 0;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.current.toLocaleLowerCase(props.filterLocale)));
    };
    var isValidOption = function isValidOption(option) {
        return (0, $7nrKB.ObjectUtils).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        if (hasSelectedOption()) {
            var _loop = function _loop() {
                var value = props.value[index];
                var matchedOptionIndex = visibleOptions.findIndex(function(option) {
                    return isValidSelectedOption(option) && isEquals(value, getOptionValue(option));
                });
                if (matchedOptionIndex > -1) return {
                    v: matchedOptionIndex
                };
            }, _ret;
            for(var index = props.value.length - 1; index >= 0; index--){
                _ret = _loop();
                if (_ret) return _ret.v;
            }
        }
        return -1;
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $7nrKB.ObjectUtils).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $7nrKB.ObjectUtils).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var searchOptions = function searchOptions(event) {
        searchValue.current = (searchValue.current || "") + event.key;
        var optionIndex = -1;
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(searchValue.current)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = "";
            searchTimeout.current = null;
        }, 500);
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            scrollInView(event);
            if (props.selectOnFocus) onOptionSelect(event, visibleOptions[index], false);
        }
    };
    var removeChip = function removeChip(event, item) {
        event.stopPropagation();
        if (!isVisible(event.currentTarget)) return;
        var value = props.value.filter(function(val) {
            return !(0, $7nrKB.ObjectUtils).equals(val, item, equalityKey);
        });
        if (props.onRemove) props.onRemove({
            originalEvent: event,
            value: value
        });
        updateModel(event, value, item);
    };
    var isVisible = function isVisible(element) {
        var parentElement = labelRef.current;
        var isOverflow = parentElement.clientWidth < parentElement.scrollWidth;
        if (!isOverflow) return true;
        var target = element.closest('[data-pc-section="token"]');
        var parentStyles = window.getComputedStyle(parentElement);
        var targetStyles = window.getComputedStyle(target);
        var parentWidth = parentElement.clientWidth - parseFloat(parentStyles.paddingLeft) - parseFloat(parentStyles.paddingRight);
        var targetRight = target.getBoundingClientRect().right + parseFloat(targetStyles.marginRight) - parentElement.getBoundingClientRect().left;
        return targetRight <= parentWidth;
    };
    var getSelectedItemsLabel = function getSelectedItemsLabel() {
        var pattern = /{(.*?)}/;
        var selectedItemsLabel = props.selectedItemsLabel || (0, $eHYdO.localeOption)("selectionMessage");
        var valueLength = props.value ? props.value.length : 0;
        if (pattern.test(selectedItemsLabel)) return selectedItemsLabel.replace(selectedItemsLabel.match(pattern)[0], valueLength + "");
        return selectedItemsLabel;
    };
    var getLabel = function getLabel() {
        var _props$value;
        if (empty || props.fixedPlaceholder) return "";
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(props.maxSelectedLabels) && ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) > props.maxSelectedLabels) return getSelectedItemsLabel();
        if ((0, $7nrKB.ObjectUtils).isArray(props.value)) return props.value.reduce(function(acc, value, index) {
            return acc + (index !== 0 ? ", " : "") + getLabelByValue(value);
        }, "");
        return "";
    };
    var getLabelContent = function getLabelContent() {
        var valueLength = props.value ? props.value.length : 0;
        if ((0, $7nrKB.ObjectUtils).isNotEmpty(props.maxSelectedLabels) && valueLength > props.maxSelectedLabels) return getSelectedItemsLabel();
        if (props.selectedItemTemplate) {
            if (!empty) return props.value.map(function(val, index) {
                var item = (0, $7nrKB.ObjectUtils).getJSXElement(props.selectedItemTemplate, val);
                return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, {
                    key: index
                }, item);
            });
            return (0, $7nrKB.ObjectUtils).getJSXElement(props.selectedItemTemplate);
        }
        if (props.display === "chip" && !empty) {
            var value = props.value.slice(0, props.maxSelectedLabels || valueLength);
            return value.map(function(val, i) {
                var context = {
                    context: {
                        value: val,
                        index: i
                    }
                };
                var label = getLabelByValue(val);
                var labelKey = label + "_" + i;
                var iconProps = mergeProps({
                    "aria-label": (0, $eHYdO.localeOption)("removeTokenIcon"),
                    className: cx("removeTokenIcon"),
                    onClick: function onClick(e) {
                        return removeChip(e, val);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onRemoveTokenIconKeyDown(e, val);
                    },
                    tabIndex: props.tabIndex || "0"
                }, ptm("removeTokenIcon", context));
                var icon = !props.disabled && (props.removeIcon ? (0, $7nrKB.IconUtils).getJSXIcon(props.removeIcon, $0c33ea58ec2feee1$var$_objectSpread({}, iconProps), {
                    props: props
                }) : /*#__PURE__*/ $7E7Dk.createElement((0, $f6Dhj.TimesCircleIcon), iconProps));
                var tokenProps = mergeProps({
                    className: cx("token")
                }, ptm("token", context));
                var tokenLabelProps = mergeProps({
                    className: cx("tokenLabel")
                }, ptm("tokenLabel", context));
                return /*#__PURE__*/ $7E7Dk.createElement("div", $0c33ea58ec2feee1$var$_extends({}, tokenProps, {
                    key: labelKey
                }), /*#__PURE__*/ $7E7Dk.createElement("span", tokenLabelProps, label), icon);
            });
        }
        return getLabel();
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter) {
            var _filterValue = filterState.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(",") : [
                props.optionLabel || "label"
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator2 = $0c33ea58ec2feee1$var$_createForOfIteratorHelper(props.options), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var optgroup = _step2.value;
                        var filteredSubOptions = (0, $eHYdO.FilterService).filter(getOptionGroupChildren(optgroup), searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($0c33ea58ec2feee1$var$_objectSpread($0c33ea58ec2feee1$var$_objectSpread({}, optgroup), $0c33ea58ec2feee1$var$_defineProperty({}, props.optionGroupChildren, filteredSubOptions)));
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $eHYdO.FilterService).filter(options, searchFields, _filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push($0c33ea58ec2feee1$var$_objectSpread($0c33ea58ec2feee1$var$_objectSpread({}, option), {}, {
                group: true,
                index: index
            }));
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var onClearIconKeyDown = function onClearIconKeyDown(event) {
        switch(event.code){
            case "Space":
            case "NumpadEnter":
            case "Enter":
                if (props.inline) break;
                updateModel(event, [], []);
                event.preventDefault();
                event.stopPropagation();
                break;
        }
    };
    var onRemoveTokenIconKeyDown = function onRemoveTokenIconKeyDown(event, val) {
        switch(event.code){
            case "Space":
            case "NumpadEnter":
            case "Enter":
                if (props.inline) break;
                removeChip(event, val);
                event.preventDefault();
                event.stopPropagation();
                break;
        }
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            focus: function focus() {
                return (0, $7nrKB.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    (0, $jr5t3.useMountEffect)(function() {
        alignOverlay();
    });
    $7E7Dk.useEffect(function() {
        (0, $7nrKB.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    $7E7Dk.useEffect(function() {
        if (props.overlayVisible === true) show();
        else if (props.overlayVisible === false) hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.overlayVisible
    ]);
    (0, $jr5t3.useUpdateEffect)(function() {
        if (overlayVisibleState && filterState && hasFilter) alignOverlay();
    }, [
        overlayVisibleState,
        filterState,
        hasFilter
    ]);
    (0, $jr5t3.useUnmountEffect)(function() {
        (0, $7nrKB.ZIndexUtils).clear(overlayRef.current);
    });
    var createClearIcon = function createClearIcon() {
        var clearIconProps = mergeProps({
            className: cx("clearIcon"),
            "aria-label": (0, $eHYdO.localeOption)("clear"),
            onClick: function onClick(e) {
                return updateModel(e, [], []);
            },
            onKeyDown: function onKeyDown(e) {
                return onClearIconKeyDown(e);
            },
            tabIndex: props.tabIndex || "0"
        }, ptm("clearIcon"));
        var icon = props.clearIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), clearIconProps);
        var clearIcon = (0, $7nrKB.IconUtils).getJSXIcon(icon, $0c33ea58ec2feee1$var$_objectSpread({}, clearIconProps), {
            props: props
        });
        if (!empty && props.showClear && !props.disabled) return clearIcon;
        return null;
    };
    var createLabel = function createLabel() {
        var content = getLabelContent();
        var labelContainerProps = mergeProps({
            ref: labelContainerRef,
            className: cx("labelContainer")
        }, ptm("labelContainer"));
        var labelProps = mergeProps({
            ref: labelRef,
            className: cx("label", {
                empty: empty
            })
        }, ptm("label"));
        return /*#__PURE__*/ $7E7Dk.createElement("div", labelContainerProps, /*#__PURE__*/ $7E7Dk.createElement("div", labelProps, content || props.placeholder || props.emptyMessage || "empty"));
    };
    var visibleOptions = getVisibleOptions();
    var hasTooltip = (0, $7nrKB.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $0c33ea58ec2feee1$var$MultiSelectBase.getOtherProps(props);
    var ariaProps = (0, $7nrKB.ObjectUtils).reduceKeys(otherProps, (0, $7nrKB.DomHandler).ARIA_PROPS);
    var triggerIconProps = mergeProps({
        className: cx("triggerIcon")
    }, ptm("triggerIcon"));
    var triggerProps = mergeProps({
        className: cx("trigger")
    }, ptm("trigger"));
    var loadingIcon = props.loadingIcon ? (0, $7nrKB.IconUtils).getJSXIcon(props.loadingIcon, $0c33ea58ec2feee1$var$_objectSpread({}, triggerIconProps), {
        props: props
    }) : /*#__PURE__*/ $7E7Dk.createElement((0, $bRIbs.SpinnerIcon), $0c33ea58ec2feee1$var$_extends({
        spin: true
    }, triggerIconProps));
    var dropdownIcon = props.dropdownIcon ? (0, $7nrKB.IconUtils).getJSXIcon(props.dropdownIcon, $0c33ea58ec2feee1$var$_objectSpread({}, triggerIconProps), {
        props: props
    }) : /*#__PURE__*/ $7E7Dk.createElement((0, $9pANH.ChevronDownIcon), triggerIconProps);
    var triggerIcon = /*#__PURE__*/ $7E7Dk.createElement("div", triggerProps, props.loading ? loadingIcon : dropdownIcon);
    var label = !props.inline && createLabel();
    var clearIcon = !props.inline && createClearIcon();
    var rootProps = mergeProps($0c33ea58ec2feee1$var$_objectSpread($0c33ea58ec2feee1$var$_objectSpread({
        ref: elementRef,
        id: props.id,
        style: $0c33ea58ec2feee1$var$_objectSpread($0c33ea58ec2feee1$var$_objectSpread({}, props.style), sx("root")),
        className: (0, $7nrKB.classNames)(props.className, cx("root", {
            focusedState: focusedState,
            context: context,
            overlayVisibleState: overlayVisibleState
        }))
    }, otherProps), {}, {
        onClick: onClick
    }), $0c33ea58ec2feee1$var$MultiSelectBase.getOtherProps(props), ptm("root"));
    var hiddenInputWrapperProps = mergeProps({
        className: "p-hidden-accessible",
        "data-p-hidden-accessible": true
    }, ptm("hiddenInputWrapper"));
    var inputProps = mergeProps($0c33ea58ec2feee1$var$_objectSpread({
        ref: inputRef,
        id: props.inputId,
        name: props.name,
        type: "text",
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        role: "combobox",
        "aria-expanded": overlayVisibleState,
        disabled: props.disabled,
        tabIndex: !props.disabled ? props.tabIndex : -1,
        value: getLabel()
    }, ariaProps), ptm("input"));
    return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement("div", hiddenInputWrapperProps, /*#__PURE__*/ $7E7Dk.createElement("input", $0c33ea58ec2feee1$var$_extends({}, inputProps, {
        readOnly: true
    }))), !props.inline && /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, label, clearIcon, triggerIcon), /*#__PURE__*/ $7E7Dk.createElement($0c33ea58ec2feee1$var$MultiSelectPanel, $0c33ea58ec2feee1$var$_extends({
        hostName: "MultiSelect",
        ref: overlayRef,
        visibleOptions: visibleOptions
    }, props, {
        onClick: onPanelClick,
        onOverlayHide: hide,
        filterValue: filterValue,
        focusedOptionIndex: focusedOptionIndex,
        onFirstHiddenFocus: onFirstHiddenFocus,
        onLastHiddenFocus: onLastHiddenFocus,
        firstHiddenFocusableElementOnOverlay: firstHiddenFocusableElementOnOverlay,
        lastHiddenFocusableElementOnOverlay: lastHiddenFocusableElementOnOverlay,
        setFocusedOptionIndex: setFocusedOptionIndex,
        hasFilter: hasFilter,
        isValidOption: isValidOption,
        getOptionValue: getOptionValue,
        updateModel: updateModel,
        onFilterInputChange: onFilterInputChange,
        onFilterKeyDown: onFilterKeyDown,
        resetFilter: resetFilter,
        onCloseClick: onCloseClick,
        onSelectAll: onSelectAll,
        getOptionLabel: getOptionLabel,
        getOptionRenderKey: getOptionRenderKey,
        isOptionDisabled: isOptionDisabled,
        getOptionGroupChildren: getOptionGroupChildren,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupRenderKey: getOptionGroupRenderKey,
        isSelected: isSelected,
        getSelectedOptionIndex: getSelectedOptionIndex,
        isAllSelected: isAllSelected,
        onOptionSelect: onOptionSelect,
        allowOptionSelect: allowOptionSelect,
        "in": overlayVisibleState,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        ptm: ptm,
        cx: cx,
        sx: sx,
        isUnstyled: isUnstyled,
        metaData: metaData,
        changeFocusedOptionIndex: changeFocusedOptionIndex
    }))), hasTooltip && /*#__PURE__*/ $7E7Dk.createElement((0, $cpfnh.Tooltip), $0c33ea58ec2feee1$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$0c33ea58ec2feee1$export$1e7dfd31545b5809.displayName = "MultiSelect";

});

parcelRegister("kT5QR", function(module, exports) {

$parcel$export(module.exports, "Line", function () { return $f34d7bbacbe9fb51$export$17d680238e50603e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $fN2cW = parcelRequire("fN2cW");
const $f34d7bbacbe9fb51$var$defaultDatasetIdKey = "label";
function $f34d7bbacbe9fb51$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $f34d7bbacbe9fb51$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $f34d7bbacbe9fb51$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $f34d7bbacbe9fb51$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f34d7bbacbe9fb51$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $f34d7bbacbe9fb51$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f34d7bbacbe9fb51$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $f34d7bbacbe9fb51$var$setLabels(nextData, data.labels);
    $f34d7bbacbe9fb51$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f34d7bbacbe9fb51$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f34d7bbacbe9fb51$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f34d7bbacbe9fb51$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $f34d7bbacbe9fb51$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $7E7Dk.useRef)(null);
    const chartRef = (0, $7E7Dk.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $fN2cW.Chart)(canvasRef.current, {
            type: type,
            data: $f34d7bbacbe9fb51$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $f34d7bbacbe9fb51$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $f34d7bbacbe9fb51$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $7E7Dk.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $f34d7bbacbe9fb51$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (!redraw && chartRef.current) $f34d7bbacbe9fb51$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $f34d7bbacbe9fb51$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $f34d7bbacbe9fb51$export$acaa6426d77a227e = /*#__PURE__*/ (0, $7E7Dk.forwardRef)($f34d7bbacbe9fb51$var$ChartComponent);
function $f34d7bbacbe9fb51$var$createTypedChart(type, registerables) {
    (0, $fN2cW.Chart).register(registerables);
    return /*#__PURE__*/ (0, $7E7Dk.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($f34d7bbacbe9fb51$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $f34d7bbacbe9fb51$export$17d680238e50603e = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("line", (0, $fN2cW.LineController));
const $f34d7bbacbe9fb51$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("bar", (0, $fN2cW.BarController));
const $f34d7bbacbe9fb51$export$bace472c466fdd25 = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("radar", (0, $fN2cW.RadarController));
const $f34d7bbacbe9fb51$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("doughnut", (0, $fN2cW.DoughnutController));
const $f34d7bbacbe9fb51$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("polarArea", (0, $fN2cW.PolarAreaController));
const $f34d7bbacbe9fb51$export$646feb54fbadbe06 = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("bubble", (0, $fN2cW.BubbleController));
const $f34d7bbacbe9fb51$export$2ae8800cf67c848c = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("pie", (0, $fN2cW.PieController));
const $f34d7bbacbe9fb51$export$1c460fb4285edadc = /* #__PURE__ */ $f34d7bbacbe9fb51$var$createTypedChart("scatter", (0, $fN2cW.ScatterController));

});

parcelRegister("6ozyP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13eb955a5c18585a$export$2e2bcd8739ae039; });

var $jW4vR = parcelRequire("jW4vR");
const $13eb955a5c18585a$var$formatDate = (date, format)=>(0, $jW4vR.default)(date, format);
var $13eb955a5c18585a$export$2e2bcd8739ae039 = $13eb955a5c18585a$var$formatDate;

});




parcelRegister("grlRk", function(module, exports) {

$parcel$export(module.exports, "ChargePointSchedulesPage", function () { return $dc0ba7c329fcb0c3$export$cccdba2244ccd230; });

var $7E7Dk = parcelRequire("7E7Dk");

var $4AX6R = parcelRequire("4AX6R");

var $2ATxG = parcelRequire("2ATxG");
var $gtjDQ = parcelRequire("gtjDQ");

var $5E6A5 = parcelRequire("5E6A5");

var $8jp0J = parcelRequire("8jp0J");

var $9c3iL = parcelRequire("9c3iL");

var $4UHsX = parcelRequire("4UHsX");

var $2OWYS = parcelRequire("2OWYS");
parcelRequire("d7pE6");
var $hT3PR = parcelRequire("hT3PR");

var $1hIPE = parcelRequire("1hIPE");

var $eIymc = parcelRequire("eIymc");

var $5u6k9 = parcelRequire("5u6k9");

var $1O9Jh = parcelRequire("1O9Jh");
parcelRequire("5zuE9");
var $cFm7A = parcelRequire("cFm7A");

var $1gy6g = parcelRequire("1gy6g");
parcelRequire("aCffN");
var $eBlmY = parcelRequire("eBlmY");

var $gGcRO = parcelRequire("gGcRO");
parcelRequire("9p3YO");
var $iguOG = parcelRequire("iguOG");

var $20ecU = parcelRequire("20ecU");
parcelRequire("5EmX1");
var $c6OxJ = parcelRequire("c6OxJ");
parcelRequire("iBnrJ");
var $3F5fJ = parcelRequire("3F5fJ");

var $1pilk = parcelRequire("1pilk");

var $6bmOU = parcelRequire("6bmOU");

var $hMQzl = parcelRequire("hMQzl");
const $dc0ba7c329fcb0c3$var$defaultTimeZone = (0, $4UHsX.default)();
const $dc0ba7c329fcb0c3$var$hasAccessToConnector = (connector, userId)=>{
    if (connector === null || connector === undefined) return false;
    return userId === undefined || userId === null || //Admin
    connector.connectorUserId === userId;
};
const $dc0ba7c329fcb0c3$var$hasAccess = (chargePoint, userId)=>{
    const numberOfConnectorsWithAccess = [];
    for (const c of chargePoint?.connectors ?? [])if ($dc0ba7c329fcb0c3$var$hasAccessToConnector(c, userId) && c.connectorId) numberOfConnectorsWithAccess.push(c.connectorId);
    return numberOfConnectorsWithAccess;
};
const $dc0ba7c329fcb0c3$var$selectSchedulesWithPeriodIds = (0, $2ATxG.createSelector)((result)=>result.data, ()=>undefined, (data)=>data?.map((schedule)=>({
            ...schedule,
            schedulePeriods: schedule.schedulePeriods?.map((period)=>({
                    id: (0, $gtjDQ.nanoid)(),
                    ...period
                }))
        })));
const $dc0ba7c329fcb0c3$export$cccdba2244ccd230 = /*#__PURE__*/ (0, $7E7Dk.memo)(function() {
    const text = (0, $5u6k9.default)();
    const { chargePointId: chargePointId } = (0, $4AX6R.useParams)();
    const toast = (0, $eBlmY.useToast)();
    const scheduleActionsMenuRef = (0, $7E7Dk.useRef)(null);
    const user = (0, $20ecU.useSessionUser)();
    const hasAuthenticatedSession = Boolean(user.id);
    const { data: chargePoint, refetch: refetchChargePoint } = (0, $1O9Jh.useChargePointGetQuery)({
        chargePointId: chargePointId ?? "",
        expand: "ocppConfig"
    }, {
        pollingInterval: (0, $1gy6g.CHARGE_POINT_REFRESH_TIMEOUT)
    });
    const { data: chargePointSchedules, isLoading: isSchedulesLoading } = (0, $1O9Jh.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePointId ?? ""
    }, {
        selectFromResult: (result)=>({
                ...result,
                data: $dc0ba7c329fcb0c3$var$selectSchedulesWithPeriodIds(result)
            })
    });
    const { data: chargePointScheduleStatus } = (0, $1O9Jh.useSmartChargingScheduleGetChargePointScheduleStatusQuery)({
        chargePointId: chargePointId ?? ""
    }, {
        pollingInterval: 5000
    });
    const [deleteSchedule, { isLoading: deleteScheduleIsLoading }] = (0, $1O9Jh.useSmartChargingScheduleClearMutation)();
    const [updateSchedule, { isLoading: updateScheduleIsLoading }] = (0, $1O9Jh.useSmartChargingScheduleUpdateMutation)();
    const isScheduleSynced = chargePointScheduleStatus === "Synced";
    const [showStatusIcon, setShowStatusIcon] = (0, $7E7Dk.useState)(false);
    const [selectedConnectorId, selectConnectorId] = (0, $7E7Dk.useState)(1);
    const [isTimeSlotEditorDialogVisible, setIsTimeSlotEditorDialogVisible] = (0, $7E7Dk.useState)(false);
    const [selectedSchedulePeriod, setSelectedSchedulePeriod] = (0, $7E7Dk.useState)(null);
    const isChargerOffline = chargePoint?.chargePointStatus === "Offline";
    const checkIsChargerEditable = (0, $7E7Dk.useCallback)(()=>{
        if (chargePoint?.chargePointStatus === "Online") return Promise.resolve();
        return refetchChargePoint().then(({ data: data })=>{
            if (data?.chargePointStatus === "Online") return;
            return Promise.reject();
        });
    }, [
        chargePoint?.chargePointStatus,
        refetchChargePoint
    ]);
    const numberOfConnectors = (0, $7E7Dk.useMemo)(()=>{
        return chargePoint?.numberOfConnectors || chargePoint?.connectors?.length || 0;
    }, [
        chargePoint?.connectors?.length,
        chargePoint?.numberOfConnectors
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if ((0, $eIymc.isUserappDomain) && chargePoint && chargePoint?.ownerId === null) {
            const numberOfConnectorsWithAccess = $dc0ba7c329fcb0c3$var$hasAccess(chargePoint, user.id || undefined);
            selectConnectorId(numberOfConnectorsWithAccess[0] ?? 1);
        }
    }, [
        chargePoint,
        user.id
    ]);
    const [minPossibleCurrent, maxPossibleCurrent] = (0, $7E7Dk.useMemo)(()=>{
        const selectedConnector = chargePoint?.connectors?.find((c)=>c.connectorId === selectedConnectorId);
        if (selectedConnector?.connectorFunctionType === "Schuko") return [
            (0, $hMQzl.SCHUKO_CURRENT),
            (0, $hMQzl.SCHUKO_CURRENT)
        ];
        const connectorsLimit = (0, $hT3PR.getConnectorSelectedCurrentLimit)(chargePoint?.ocppConfigKeys ?? [], selectedConnectorId);
        return [
            (0, $hMQzl.MIN_SAFE_CURRENT),
            connectorsLimit
        ];
    }, [
        selectedConnectorId,
        chargePoint
    ]);
    const getDefaultSchedule = (0, $7E7Dk.useCallback)((connectorId = selectedConnectorId)=>({
            isActive: false,
            scheduleId: undefined,
            defaultCurrent: 0,
            schedulePeriods: [],
            timeZone: $dc0ba7c329fcb0c3$var$defaultTimeZone,
            connectorId: connectorId,
            chargePointId: chargePointId
        }), [
        chargePointId,
        selectedConnectorId
    ]);
    const [selectedSchedule, setSelectedSchedule] = (0, $7E7Dk.useState)(chargePointSchedules?.find((schedule)=>schedule.connectorId === selectedConnectorId) || getDefaultSchedule());
    const onSchedulesChange = (0, $7E7Dk.useCallback)((schedulePeriods)=>setSelectedSchedule((selectedSchedule)=>({
                ...selectedSchedule,
                schedulePeriods: schedulePeriods,
                isActive: true
            })), []);
    const scheduleHasChanges = (0, $7E7Dk.useMemo)(()=>{
        const existingSchedule = chargePointSchedules?.find((schedule)=>schedule.connectorId === selectedConnectorId);
        if (existingSchedule) return !(0, $5E6A5.isEqual)(existingSchedule, selectedSchedule);
        return selectedSchedule?.schedulePeriods?.length;
    }, [
        selectedSchedule,
        chargePointSchedules,
        selectedConnectorId
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        setSelectedSchedule(()=>{
            return chargePointSchedules?.find((schedule)=>schedule.connectorId === selectedConnectorId) || getDefaultSchedule();
        });
    }, [
        chargePointSchedules,
        getDefaultSchedule,
        selectedConnectorId
    ]);
    const changeConnector = async (connectorId)=>{
        if (selectedConnectorId === connectorId) return;
        if (connectorId > numberOfConnectors) return;
        if (scheduleHasChanges) {
            const confirmed = await (0, $iguOG.confirm)({
                header: text("lblProceedConfirmation"),
                message: text("msgChangeConnectorConfirm"),
                variant: "danger"
            });
            if (!confirmed) return;
        }
        setShowStatusIcon(false);
        setSelectedSchedule(chargePointSchedules?.find((schedule)=>schedule.connectorId === connectorId) || getDefaultSchedule(connectorId));
        selectConnectorId(connectorId);
    };
    (0, $7E7Dk.useEffect)(()=>{
        const handler = (ev)=>{
            if (!scheduleHasChanges || !hasAuthenticatedSession) return;
            ev.preventDefault();
            return ev.returnValue = text("msgUnsavedChangesConfirm");
        };
        window.addEventListener("beforeunload", handler, {
            capture: true
        });
        return ()=>window.removeEventListener("beforeunload", handler, {
                capture: true
            });
    }, [
        hasAuthenticatedSession,
        scheduleHasChanges,
        text
    ]);
    function hideSyncedIcon() {
        setTimeout(function() {
            setShowStatusIcon(false);
        }, 5000);
    }
    const saveSchedule = (0, $7E7Dk.useCallback)(()=>{
        toast.notifyInfo(text("msgSavingSchedule"));
        return updateSchedule({
            smartChargingSchedule: selectedSchedule
        }).unwrap().then(()=>{
            refetchChargePoint().then(()=>{
                setShowStatusIcon(true);
                if (selectedConnectorId === (0, $1pilk.ConnectorType).CHARGER || (0, $1hIPE.default)(chargePoint)) toast.notifySuccess(text("msgSchedulesSaved"));
                else toast.notifySuccess(text("msgSocketScheduleSaved", {
                    isCurrentLimitLowerThanDefaultCurrent: (selectedSchedule?.defaultCurrent || minPossibleCurrent) > maxPossibleCurrent,
                    connectorSelectedCurrentLimit: maxPossibleCurrent
                }));
            });
        }).catch((error)=>{
            if ((0, $gGcRO.isFetchBaseQueryError)(error)) {
                if (error.status === 410) return toast.notifyError(text("msgOfflineChargerScheduleIsNotEditable"));
            } else toast.notifyError(text("msgFailedToUpdateSchedule"));
        });
    }, [
        chargePoint,
        maxPossibleCurrent,
        minPossibleCurrent,
        refetchChargePoint,
        selectedConnectorId,
        selectedSchedule,
        text,
        toast,
        updateSchedule
    ]);
    const handleClearSchedule = (0, $7E7Dk.useCallback)(async ()=>{
        const confirmed = await (0, $iguOG.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgClearScheduleConfirm"),
            variant: "danger"
        });
        if (!confirmed) return;
        toast.notifyInfo(text("msgClearingSchedule"));
        setShowStatusIcon(true);
        return checkIsChargerEditable().then(()=>{
            deleteSchedule({
                chargePointId: chargePointId ?? "",
                connectorId: selectedConnectorId
            }).unwrap();
            setSelectedSchedule(getDefaultSchedule());
        }).finally(()=>{
            hideSyncedIcon();
        });
    }, [
        chargePointId,
        checkIsChargerEditable,
        deleteSchedule,
        getDefaultSchedule,
        selectedConnectorId,
        text,
        toast
    ]);
    const [isCurrentConflictInformationDialogVisible, setIsCurrentConflictInformationDialogVisible] = (0, $7E7Dk.useState)(false);
    const saveIfConfirmed = (0, $7E7Dk.useCallback)(()=>{
        if (!hasAuthenticatedSession) {
            history.back() // will redirect user to the login page
            ;
            return;
        }
        if (!selectedSchedule.schedulePeriods?.length) return handleClearSchedule();
        const hasCurrentOverlap = selectedSchedule.schedulePeriods.some((period)=>period.maxCurrent === selectedSchedule.defaultCurrent);
        if (hasCurrentOverlap) setIsCurrentConflictInformationDialogVisible(true);
        else saveSchedule();
    }, [
        hasAuthenticatedSession,
        selectedSchedule.schedulePeriods,
        selectedSchedule.defaultCurrent,
        saveSchedule,
        handleClearSchedule
    ]);
    const scheduleDisabled = isSchedulesLoading || updateScheduleIsLoading || deleteScheduleIsLoading || isChargerOffline || !chargePoint || !(0, $9c3iL.doesSupportSmartSchedule)(chargePoint) || !(0, $2OWYS.default)(chargePoint, user);
    const scheduleDisabledReason = (()=>{
        if (isSchedulesLoading || !chargePoint) return text("msgScheduleLoading");
        if (updateScheduleIsLoading) return text("msgSavingSchedule");
        if (deleteScheduleIsLoading) return text("msgClearingSchedule");
        if (isChargerOffline) return text("msgOfflineChargerScheduleIsNotEditable");
        if (!(0, $9c3iL.doesSupportSmartSchedule)(chargePoint)) return text("msgSmartSchedulingNotSupported");
        if (!(0, $2OWYS.default)(chargePoint, user)) return text("msgNoPermissionToEditCharger");
        return undefined;
    })();
    const disabledClear = !selectedSchedule.schedulePeriods || scheduleDisabled || isChargerOffline || !(selectedSchedule?.schedulePeriods?.length > 0 || scheduleHasChanges);
    const disabledClearReason = disabledClear ? scheduleDisabledReason ?? text("msgNoSchedulesHeader") : undefined;
    const disabledSaveReason = scheduleDisabled ? scheduleDisabledReason : !scheduleHasChanges ? text("msgNoChangesToSave") : !isScheduleSynced ? text("msgScheduleChangesStillSyncing") : undefined;
    const onEditSchedulePeriod = ()=>{
        if (selectedSchedulePeriod) setIsTimeSlotEditorDialogVisible(true);
    };
    const onDeleteSchedulePeriod = ()=>{
        if (selectedSchedulePeriod && selectedSchedule) {
            const filtered = selectedSchedule.schedulePeriods?.filter((nextPeriod)=>!(nextPeriod.from === selectedSchedulePeriod.from && nextPeriod.to === selectedSchedulePeriod.to));
            setSelectedSchedule({
                ...selectedSchedule,
                schedulePeriods: filtered
            });
        }
    };
    const scheduleActions = [
        {
            label: text("btnEdit"),
            icon: "pi pi-pencil",
            command: ()=>{
                onEditSchedulePeriod();
            }
        },
        {
            label: text("lblDelete"),
            icon: "pi pi-trash",
            command: ()=>{
                onDeleteSchedulePeriod();
            }
        }
    ];
    const getWarningMessage = (0, $7E7Dk.useCallback)((schedulePeriod)=>{
        if (schedulePeriod.maxCurrent === selectedSchedule.defaultCurrent) return text("msgTimeRangeEqualsDefaultCurrent");
        if (maxPossibleCurrent < schedulePeriod.maxCurrent) {
            if (selectedConnectorId === (0, $1pilk.ConnectorType).CHARGER || (0, $1hIPE.default)(chargePoint)) return text("msgChargingUpTo", {
                connectorSelectedCurrentLimit: maxPossibleCurrent
            });
            return text("msgSocketMightNotBeChargingOptimally", {
                connectorSelectedCurrentLimit: maxPossibleCurrent
            });
        }
        return null;
    }, [
        chargePoint,
        maxPossibleCurrent,
        selectedConnectorId,
        selectedSchedule.defaultCurrent,
        text
    ]);
    const getCustomStyle = (0, $7E7Dk.useCallback)((schedulePeriod)=>{
        if (schedulePeriod.maxCurrent === selectedSchedule.defaultCurrent) return {
            backgroundColor: "var(--lightCoral)"
        };
        return {};
    }, [
        selectedSchedule.defaultCurrent
    ]);
    const getCustomMessage = (0, $7E7Dk.useCallback)(()=>{
        if ((0, $1hIPE.default)(chargePoint)) return selectedConnectorId === 1 ? text("lblLeftSocket") : text("lblRightSocket");
        return selectedConnectorId === (0, $1pilk.ConnectorType).CHARGER ? text("lblChargerOnly") : text("lblSocketOnly");
    }, [
        chargePoint,
        selectedConnectorId,
        text
    ]);
    const isSocketConnector = !(0, $1hIPE.default)(chargePoint) && selectedConnectorId === (0, $1pilk.ConnectorType).SOCKET;
    const formatCurrent = (0, $7E7Dk.useCallback)((maxCurrent)=>{
        if (isSocketConnector) return maxCurrent ? text("lblOn") : text("lblOff");
        return maxCurrent ? text("msgAmpereValue", {
            current: maxCurrent
        }) : text("lblDisabledStatus");
    }, [
        isSocketConnector,
        text
    ]);
    const openScheduleActions = (0, $7E7Dk.useCallback)((event, schedulePeriod)=>{
        setSelectedSchedulePeriod(schedulePeriod);
        scheduleActionsMenuRef.current?.toggle(event);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6OxJ.InformationDialog), {
        visible: isCurrentConflictInformationDialogVisible,
        title: text("lblScheduleCurrentConflictDialogTitle"),
        message: text("msgChangeDefaultCurrent"),
        onHide: ()=>setIsCurrentConflictInformationDialogVisible(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6bmOU.default), {
        schedule: selectedSchedule,
        onUpdateSchedule: setSelectedSchedule,
        onSaveSchedule: saveIfConfirmed,
        onClearSchedule: handleClearSchedule,
        chargePoint: chargePoint,
        numberOfConnectors: numberOfConnectors,
        connectorId: selectedConnectorId,
        onChangeConnectorId: changeConnector,
        disabledDefaultCurrent: !selectedSchedule?.schedulePeriods?.length,
        minPossibleCurrent: minPossibleCurrent,
        maxPossibleCurrent: maxPossibleCurrent,
        disabledSave: disabledSaveReason ?? false,
        syncStatus: chargePointScheduleStatus,
        disabledControls: scheduleDisabled,
        disabledClear: disabledClear,
        disabledClearReason: disabledClearReason,
        showSyncedStatusIcon: showStatusIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cFm7A.Scheduler), {
        maxCurrent: maxPossibleCurrent,
        isActive: selectedSchedule?.isActive,
        schedules: selectedSchedule?.schedulePeriods ?? [],
        onSchedulesChange: onSchedulesChange,
        disabled: scheduleDisabled,
        getWarningMessage: getWarningMessage,
        getCustomStyle: getCustomStyle,
        getCustomMessage: getCustomMessage,
        formatCurrent: formatCurrent,
        actionsLabel: text("lblScheduledTimeSlotActions"),
        onOpenActions: openScheduleActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3F5fJ.ScheduledTimeSlotEditorDialog), {
        visible: isTimeSlotEditorDialogVisible,
        onHide: ()=>setIsTimeSlotEditorDialogVisible(false),
        selectedSchedulePeriod: selectedSchedulePeriod,
        minPossibleCurrent: minPossibleCurrent,
        maxPossibleCurrent: maxPossibleCurrent,
        onSave: (schedulePeriod)=>{
            setIsTimeSlotEditorDialogVisible(false);
            if (selectedSchedule) setSelectedSchedule({
                ...selectedSchedule,
                schedulePeriods: selectedSchedule.schedulePeriods?.map((period)=>period.id === schedulePeriod.id ? schedulePeriod : period)
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8jp0J.Menu), {
        id: "scheduled-time-slot-actions-menu",
        model: scheduleActions,
        ref: scheduleActionsMenuRef,
        popup: true
    }));
});

});
parcelRegister("8jp0J", function(module, exports) {

$parcel$export(module.exports, "Menu", function () { return $60d37fae974719d0$export$d9b273488cd8ce6f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $hB9Eg = parcelRequire("hB9Eg");

var $ingJg = parcelRequire("ingJg");

var $1PxL0 = parcelRequire("1PxL0");

var $7nrKB = parcelRequire("7nrKB");
"use client";
function $60d37fae974719d0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $60d37fae974719d0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $60d37fae974719d0$var$_typeof(o);
}
function $60d37fae974719d0$var$toPrimitive(t, r) {
    if ("object" != $60d37fae974719d0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $60d37fae974719d0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $60d37fae974719d0$var$toPropertyKey(t) {
    var i = $60d37fae974719d0$var$toPrimitive(t, "string");
    return "symbol" == $60d37fae974719d0$var$_typeof(i) ? i : i + "";
}
function $60d37fae974719d0$var$_defineProperty(e, r, t) {
    return (r = $60d37fae974719d0$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $60d37fae974719d0$var$_extends() {
    return $60d37fae974719d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $60d37fae974719d0$var$_extends.apply(null, arguments);
}
function $60d37fae974719d0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $60d37fae974719d0$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $60d37fae974719d0$var$_arrayLikeToArray(r);
}
function $60d37fae974719d0$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $60d37fae974719d0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $60d37fae974719d0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $60d37fae974719d0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $60d37fae974719d0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $60d37fae974719d0$var$_toConsumableArray(r) {
    return $60d37fae974719d0$var$_arrayWithoutHoles(r) || $60d37fae974719d0$var$_iterableToArray(r) || $60d37fae974719d0$var$_unsupportedIterableToArray(r) || $60d37fae974719d0$var$_nonIterableSpread();
}
function $60d37fae974719d0$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $60d37fae974719d0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $60d37fae974719d0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $60d37fae974719d0$var$_slicedToArray(r, e) {
    return $60d37fae974719d0$var$_arrayWithHoles(r) || $60d37fae974719d0$var$_iterableToArrayLimit(r, e) || $60d37fae974719d0$var$_unsupportedIterableToArray(r, e) || $60d37fae974719d0$var$_nonIterableRest();
}
var $60d37fae974719d0$var$styles = "\n@layer primereact {\n    .p-menu-overlay {\n        position: absolute;\n        /* Github #3122: Prevent animation flickering  */\n        top: -9999px;\n        left: -9999px;\n    }\n\n    .p-menu ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-menu .p-menuitem-text {\n        line-height: 1;\n    }\n}\n";
var $60d37fae974719d0$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $7nrKB.classNames)("p-menu p-component", {
            "p-menu-overlay": props.popup,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $eHYdO.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $eHYdO.default).ripple === false
        });
    },
    menu: "p-menu-list p-reset",
    content: function content(_ref2) {
        var item = _ref2.item;
        return (0, $7nrKB.classNames)("p-menuitem-content", {
            "p-disabled": item.disabled
        });
    },
    action: function action(_ref3) {
        var item = _ref3.item;
        return (0, $7nrKB.classNames)("p-menuitem-link", {
            "p-disabled": item.disabled
        });
    },
    menuitem: function menuitem(_ref4) {
        var focused = _ref4.focused;
        return (0, $7nrKB.classNames)("p-menuitem", {
            "p-focus": focused
        });
    },
    submenuHeader: function submenuHeader(_ref5) {
        var submenu = _ref5.submenu;
        return (0, $7nrKB.classNames)("p-submenu-header", {
            "p-disabled": submenu.disabled
        });
    },
    separator: "p-menu-separator",
    label: "p-menuitem-text",
    icon: "p-menuitem-icon",
    transition: "p-connected-overlay"
};
var $60d37fae974719d0$var$inlineStyles = {
    submenuHeader: function submenuHeader(_ref6) {
        var submenu = _ref6.submenu;
        return submenu.style;
    },
    menuitem: function menuitem(_ref7) {
        var item = _ref7.item;
        return item.style;
    }
};
var $60d37fae974719d0$var$MenuBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Menu",
        id: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        tabIndex: 0,
        model: null,
        popup: false,
        popupAlignment: "left",
        style: null,
        className: null,
        autoZIndex: true,
        baseZIndex: 0,
        appendTo: null,
        onFocus: null,
        onBlur: null,
        transitionOptions: null,
        onShow: null,
        onHide: null,
        children: undefined,
        closeOnEscape: true
    },
    css: {
        classes: $60d37fae974719d0$var$classes,
        styles: $60d37fae974719d0$var$styles,
        inlineStyles: $60d37fae974719d0$var$inlineStyles
    }
});
function $60d37fae974719d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60d37fae974719d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60d37fae974719d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $60d37fae974719d0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60d37fae974719d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $60d37fae974719d0$export$d9b273488cd8ce6f = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $60d37fae974719d0$var$MenuBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState(props.id), _React$useState2 = $60d37fae974719d0$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $7E7Dk.useState(!props.popup), _React$useState4 = $60d37fae974719d0$var$_slicedToArray(_React$useState3, 2), visibleState = _React$useState4[0], setVisibleState = _React$useState4[1];
    var _React$useState5 = $7E7Dk.useState(-1), _React$useState6 = $60d37fae974719d0$var$_slicedToArray(_React$useState5, 2), focusedOptionIndex = _React$useState6[0], setFocusedOptionIndex = _React$useState6[1];
    var _React$useState7 = $7E7Dk.useState(-1), _React$useState8 = $60d37fae974719d0$var$_slicedToArray(_React$useState7, 2), selectedOptionIndex = _React$useState8[0], setSelectedOptionIndex = _React$useState8[1];
    var _React$useState9 = $7E7Dk.useState(false), _React$useState10 = $60d37fae974719d0$var$_slicedToArray(_React$useState9, 2), focused = _React$useState10[0], setFocused = _React$useState10[1];
    var _MenuBase$setMetaData = $60d37fae974719d0$var$MenuBase.setMetaData({
        props: props,
        state: {
            id: idState,
            visible: visibleState,
            focused: focused
        }
    }), ptm = _MenuBase$setMetaData.ptm, cx = _MenuBase$setMetaData.cx, sx = _MenuBase$setMetaData.sx, isUnstyled = _MenuBase$setMetaData.isUnstyled;
    var getMenuItemPTOptions = function getMenuItemPTOptions(key, menuContext) {
        return ptm(key, {
            context: menuContext
        });
    };
    (0, $kHEnT.useHandleStyle)($60d37fae974719d0$var$MenuBase.css.styles, isUnstyled, {
        name: "menu"
    });
    var menuRef = $7E7Dk.useRef(null);
    var listRef = $7E7Dk.useRef(null);
    var targetRef = $7E7Dk.useRef(null);
    var isCloseOnEscape = !!(visibleState && props.popup && props.closeOnEscape);
    var popupMenuDisplayOrder = (0, $jr5t3.useDisplayOrder)("menu", isCloseOnEscape);
    (0, $jr5t3.useGlobalOnEscapeKey)({
        callback: function callback(event) {
            hide(event);
        },
        when: isCloseOnEscape && popupMenuDisplayOrder,
        priority: [
            (0, $jr5t3.ESC_KEY_HANDLING_PRIORITIES).MENU,
            popupMenuDisplayOrder
        ]
    });
    var _useOverlayListener = (0, $jr5t3.useOverlayListener)({
        target: targetRef,
        overlay: menuRef,
        listener: function listener(event, _ref) {
            var valid = _ref.valid, type = _ref.type;
            if (valid) {
                if (context.hideOverlaysOnDocumentScrolling || type === "outside") {
                    hide(event);
                    setFocusedOptionIndex(-1);
                } else if (!(0, $7nrKB.DomHandler).isDocument(event.target)) (0, $7nrKB.DomHandler).absolutePosition(menuRef.current, targetRef.current, props.popupAlignment);
            }
        },
        when: visibleState
    }), _useOverlayListener2 = $60d37fae974719d0$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var onPanelClick = function onPanelClick(event) {
        if (props.popup) (0, $hB9Eg.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: targetRef.current
        });
    };
    var onItemClick = function onItemClick(event, item, key) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event,
            item: item
        });
        if (props.popup) hide(event);
        if (!props.popup && focusedOptionIndex !== key) setFocusedOptionIndex(key);
        if (!item.url) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var onItemMouseMove = function onItemMouseMove(event, key) {
        if (event && props.popup && focusedOptionIndex !== key) setFocusedOptionIndex(key);
    };
    var onListFocus = function onListFocus(event) {
        setFocused(true);
        if (!props.popup) {
            if (selectedOptionIndex !== -1) {
                changeFocusedOptionIndex(selectedOptionIndex);
                setSelectedOptionIndex(-1);
            } else changeFocusedOptionIndex(0);
        }
        props.onFocus && props.onFocus(event);
    };
    var onListBlur = function onListBlur(event) {
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        if (relatedTarget && currentTarget.contains(relatedTarget)) return;
        setFocused(false);
        setFocusedOptionIndex(-1);
        props.onBlur && props.onBlur(event);
    };
    var onListKeyDown = function onListKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "Home":
                onHomeKey(event);
                break;
            case "End":
                onEndKey(event);
                break;
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event);
                break;
            case "Space":
                onSpaceKey(event);
                break;
            case "Escape":
                if (props.popup) {
                    (0, $7nrKB.DomHandler).focus(targetRef.current);
                    hide(event);
                }
            case "Tab":
                props.popup && visibleState && hide(event);
                break;
        }
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        var optionIndex = findNextOptionIndex(focusedOptionIndex);
        changeFocusedOptionIndex(optionIndex);
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        if (event.altKey && props.popup) {
            (0, $7nrKB.DomHandler).focus(targetRef.current);
            hide(event);
            event.preventDefault();
        } else {
            var optionIndex = findPrevOptionIndex(focusedOptionIndex);
            changeFocusedOptionIndex(optionIndex);
            event.preventDefault();
        }
    };
    var onHomeKey = function onHomeKey(event) {
        changeFocusedOptionIndex(0);
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        changeFocusedOptionIndex((0, $7nrKB.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]').length - 1);
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(event) {
        var element = (0, $7nrKB.DomHandler).findSingle(menuRef.current, 'li[id="'.concat("".concat(focusedOptionIndex), '"]'));
        var anchorElement = element && (0, $7nrKB.DomHandler).findSingle(element, 'a[data-pc-section="action"]');
        props.popup && (0, $7nrKB.DomHandler).focus(targetRef.current);
        anchorElement ? anchorElement.click() : element && element.click();
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        onEnterKey(event);
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var links = (0, $7nrKB.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var matchedOptionIndex = $60d37fae974719d0$var$_toConsumableArray(links).findIndex(function(link) {
            return link.id === index;
        });
        return matchedOptionIndex > -1 ? matchedOptionIndex + 1 : 0;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var links = (0, $7nrKB.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var matchedOptionIndex = $60d37fae974719d0$var$_toConsumableArray(links).findIndex(function(link) {
            return link.id === index;
        });
        return matchedOptionIndex > -1 ? matchedOptionIndex - 1 : 0;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(index) {
        var links = (0, $7nrKB.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var order = index >= links.length ? links.length - 1 : index < 0 ? 0 : index;
        order > -1 && setFocusedOptionIndex(links[order].getAttribute("id"));
    };
    var focusedOptionId = function focusedOptionId() {
        return focusedOptionIndex !== -1 ? focusedOptionIndex : null;
    };
    var toggle = function toggle(event) {
        if (props.popup) visibleState ? hide(event) : show(event);
    };
    var show = function show(event) {
        targetRef.current = event.currentTarget;
        setVisibleState(true);
        props.onShow && props.onShow(event);
    };
    var hide = function hide(event) {
        targetRef.current = event.currentTarget;
        setVisibleState(false);
        props.onHide && props.onHide(event);
    };
    var onEnter = function onEnter() {
        (0, $7nrKB.DomHandler).addStyles(menuRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        (0, $7nrKB.ZIndexUtils).set("menu", menuRef.current, context && context.autoZIndex || (0, $eHYdO.default).autoZIndex, props.baseZIndex || context && context.zIndex.menu || (0, $eHYdO.default).zIndex.menu);
        (0, $7nrKB.DomHandler).absolutePosition(menuRef.current, targetRef.current, props.popupAlignment);
        if (props.popup) {
            (0, $7nrKB.DomHandler).focus(listRef.current);
            changeFocusedOptionIndex(0);
        }
    };
    var onEntered = function onEntered() {
        bindOverlayListener();
    };
    var onExit = function onExit() {
        targetRef.current = null;
        unbindOverlayListener();
    };
    var onExited = function onExited() {
        (0, $7nrKB.ZIndexUtils).clear(menuRef.current);
    };
    (0, $jr5t3.useMountEffect)(function() {
        if (!idState) setIdState((0, $7nrKB.UniqueComponentId)());
    });
    (0, $jr5t3.useUnmountEffect)(function() {
        (0, $7nrKB.ZIndexUtils).clear(menuRef.current);
    });
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return menuRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    var createSubmenu = function createSubmenu(submenu, index) {
        var key = idState + "_sub_" + index;
        var items = submenu.items.map(function(item, index) {
            return createMenuItem(item, index, key);
        });
        var submenuHeaderProps = mergeProps({
            id: key,
            role: "none",
            className: (0, $7nrKB.classNames)(submenu.className, cx("submenuHeader", {
                submenu: submenu
            })),
            style: sx("submenuHeader", {
                submenu: submenu
            }),
            "data-p-disabled": submenu.disabled
        }, ptm("submenuHeader"));
        return /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, {
            key: key
        }, /*#__PURE__*/ $7E7Dk.createElement("li", $60d37fae974719d0$var$_extends({}, submenuHeaderProps, {
            key: key
        }), submenu.label), items);
    };
    var createSeparator = function createSeparator(item, index) {
        if (item.visible === false) return null;
        var key = idState + "_separator_" + index;
        var separatorProps = mergeProps({
            id: key,
            className: (0, $7nrKB.classNames)(item.className, cx("separator")),
            role: "separator"
        }, ptm("separator"));
        return /*#__PURE__*/ $7E7Dk.createElement("li", $60d37fae974719d0$var$_extends({}, separatorProps, {
            key: key
        }));
    };
    var createMenuItem = function createMenuItem(item, index) {
        var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (item.visible === false) return null;
        var menuContext = {
            item: item,
            index: index,
            parentId: parentId
        };
        var linkClassName = (0, $7nrKB.classNames)("p-menuitem-link", {
            "p-disabled": item.disabled
        });
        var iconClassName = (0, $7nrKB.classNames)("p-menuitem-icon", item.icon);
        var iconProps = mergeProps({
            className: cx("icon")
        }, getMenuItemPTOptions("icon", menuContext));
        var icon = (0, $7nrKB.IconUtils).getJSXIcon(item.icon, $60d37fae974719d0$var$_objectSpread({}, iconProps), {
            props: props
        });
        var labelProps = mergeProps({
            className: cx("label")
        }, getMenuItemPTOptions("label", menuContext));
        var label = item.label && /*#__PURE__*/ $7E7Dk.createElement("span", labelProps, item.label);
        var key = item.id || (parentId || idState) + "_" + index;
        var contentProps = mergeProps({
            onClick: function onClick(event) {
                return onItemClick(event, item, key);
            },
            onMouseMove: function onMouseMove(event) {
                return onItemMouseMove(event, key);
            },
            className: cx("content", {
                item: item
            })
        }, getMenuItemPTOptions("content", menuContext));
        var actionProps = mergeProps({
            href: item.url || "#",
            className: cx("action", {
                item: item
            }),
            onFocus: function onFocus(event) {
                return event.stopPropagation();
            },
            target: item.target,
            tabIndex: "-1",
            "aria-label": item.label,
            "aria-disabled": item.disabled,
            "data-p-disabled": item.disabled
        }, getMenuItemPTOptions("action", menuContext));
        var content = /*#__PURE__*/ $7E7Dk.createElement("div", contentProps, /*#__PURE__*/ $7E7Dk.createElement("a", actionProps, icon, label, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null)));
        if (item.template) {
            var defaultContentOptions = {
                onClick: function onClick(event) {
                    return onItemClick(event, item, key);
                },
                onMouseMove: function onMouseMove(event) {
                    return onItemMouseMove(event, key);
                },
                className: linkClassName,
                tabIndex: "-1",
                labelClassName: "p-menuitem-text",
                iconClassName: iconClassName,
                element: content,
                props: props
            };
            content = (0, $7nrKB.ObjectUtils).getJSXElement(item.template, item, defaultContentOptions);
        }
        var menuitemProps = mergeProps({
            id: key,
            className: (0, $7nrKB.classNames)(item.className, cx("menuitem", {
                focused: focusedOptionIndex === key
            })),
            onClick: function onClick(event) {
                return onItemClick(event, item, key);
            },
            style: sx("menuitem", {
                item: item
            }),
            role: "menuitem",
            "aria-label": item.label,
            "aria-disabled": item.disabled,
            "data-p-focused": focusedOptionId() === key,
            "data-p-disabled": item.disabled || false
        }, getMenuItemPTOptions("menuitem", menuContext));
        return /*#__PURE__*/ $7E7Dk.createElement("li", $60d37fae974719d0$var$_extends({}, menuitemProps, {
            key: key
        }), content);
    };
    var createItem = function createItem(item, index) {
        if (item.visible === false) return null;
        return item.separator ? createSeparator(item, index) : item.items ? createSubmenu(item, index) : createMenuItem(item, index);
    };
    var createMenu = function createMenu() {
        return props.model.map(createItem);
    };
    var createElement = function createElement() {
        if (props.model) {
            var menuitems = createMenu();
            var rootProps = mergeProps({
                className: (0, $7nrKB.classNames)(props.className, cx("root", {
                    context: context
                })),
                style: props.style,
                onClick: function onClick(e) {
                    return onPanelClick(e);
                }
            }, $60d37fae974719d0$var$MenuBase.getOtherProps(props), ptm("root"));
            var menuProps = mergeProps({
                ref: listRef,
                className: cx("menu"),
                id: idState + "_list",
                tabIndex: props.tabIndex || "0",
                role: "menu",
                "aria-label": props.ariaLabel,
                "aria-labelledby": props.ariaLabelledBy,
                "aria-activedescendant": focused ? focusedOptionId() : undefined,
                onFocus: onListFocus,
                onKeyDown: onListKeyDown,
                onBlur: onListBlur
            }, ptm("menu"));
            var transitionProps = mergeProps({
                classNames: cx("transition"),
                "in": visibleState,
                timeout: {
                    enter: 120,
                    exit: 100
                },
                options: props.transitionOptions,
                unmountOnExit: true,
                onEnter: onEnter,
                onEntered: onEntered,
                onExit: onExit,
                onExited: onExited
            }, ptm("transition"));
            return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $60d37fae974719d0$var$_extends({
                nodeRef: menuRef
            }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement("div", $60d37fae974719d0$var$_extends({
                id: props.id,
                ref: menuRef
            }, rootProps), /*#__PURE__*/ $7E7Dk.createElement("ul", menuProps, menuitems)));
        }
        return null;
    };
    var element = createElement();
    return props.popup ? /*#__PURE__*/ $7E7Dk.createElement((0, $ingJg.Portal), {
        element: element,
        appendTo: props.appendTo
    }) : element;
}));
$60d37fae974719d0$export$d9b273488cd8ce6f.displayName = "Menu";

});

parcelRegister("4UHsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74fd65fd087d2691$export$2e2bcd8739ae039; });

var $gGzon = parcelRequire("gGzon");

var $bezpU = parcelRequire("bezpU");
let $74fd65fd087d2691$var$currentTimeZone;
function $74fd65fd087d2691$export$2e2bcd8739ae039() {
    if (!$74fd65fd087d2691$var$currentTimeZone) {
        const intlTimeZone = window.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
        if (intlTimeZone) $74fd65fd087d2691$var$currentTimeZone = intlTimeZone;
        else {
            const tzOffsetString = (0, $bezpU.default)(new Date().getTimezoneOffset());
            $74fd65fd087d2691$var$currentTimeZone = (0, $gGzon.default).find((tz)=>tz.utc === tzOffsetString)?.code;
        }
    }
    return $74fd65fd087d2691$var$currentTimeZone;
}

});
parcelRegister("gGzon", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e6094275b67adb$export$2e2bcd8739ae039; });
var $35e6094275b67adb$export$2e2bcd8739ae039 = [
    {
        utc: "-11:00",
        code: "Pacific/Midway",
        name: "Midway"
    },
    {
        utc: "-11:00",
        code: "Pacific/Niue",
        name: "Alofi"
    },
    {
        utc: "-11:00",
        code: "Pacific/Pago_Pago",
        name: "Pago Pago, T\u0101funa, Ta`\u016B, Taulaga"
    },
    {
        utc: "-10:00",
        code: "America/Adak",
        name: "Adak"
    },
    {
        utc: "-10:00",
        code: "Pacific/Honolulu",
        name: "Honolulu, East Honolulu, Pearl City, Hilo, Kailua"
    },
    {
        utc: "-10:00",
        code: "Pacific/Rarotonga",
        name: "Avarua"
    },
    {
        utc: "-10:00",
        code: "Pacific/Tahiti",
        name: "Faaa, Papeete, Punaauia, Pirae, Mahina"
    },
    {
        utc: "-09:30",
        code: "Pacific/Marquesas",
        name: "Taiohae"
    },
    {
        utc: "-09:00",
        code: "America/Anchorage",
        name: "Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview"
    },
    {
        utc: "-09:00",
        code: "America/Juneau",
        name: "Juneau"
    },
    {
        utc: "-09:00",
        code: "America/Metlakatla",
        name: "Metlakatla"
    },
    {
        utc: "-09:00",
        code: "America/Nome",
        name: "Nome"
    },
    {
        utc: "-09:00",
        code: "America/Sitka",
        name: "Sitka, Ketchikan"
    },
    {
        utc: "-09:00",
        code: "America/Yakutat",
        name: "Yakutat"
    },
    {
        utc: "-09:00",
        code: "Pacific/Gambier",
        name: "Gambier"
    },
    {
        utc: "-08:00",
        code: "America/Los_Angeles",
        name: "Los Angeles, San Diego, San Jose, San Francisco, Seattle"
    },
    {
        utc: "-08:00",
        code: "America/Tijuana",
        name: "Tijuana, Mexicali, Ensenada, Rosarito, Tecate"
    },
    {
        utc: "-08:00",
        code: "America/Vancouver",
        name: "Vancouver, Surrey, Okanagan, Victoria, Burnaby"
    },
    {
        utc: "-08:00",
        code: "Pacific/Pitcairn",
        name: "Adamstown"
    },
    {
        utc: "-07:00",
        code: "America/Boise",
        name: "Boise, Meridian, Nampa, Idaho Falls, Pocatello"
    },
    {
        utc: "-07:00",
        code: "America/Cambridge_Bay",
        name: "Cambridge Bay"
    },
    {
        utc: "-07:00",
        code: "America/Chihuahua",
        name: "Chihuahua, Ciudad Delicias, Cuauht\xe9moc, Parral, Nuevo Casas Grandes"
    },
    {
        utc: "-07:00",
        code: "America/Creston",
        name: "Creston"
    },
    {
        utc: "-07:00",
        code: "America/Dawson",
        name: "Dawson"
    },
    {
        utc: "-07:00",
        code: "America/Dawson_Creek",
        name: "Fort St. John, Dawson Creek"
    },
    {
        utc: "-07:00",
        code: "America/Denver",
        name: "Denver, El Paso, Albuquerque, Colorado Springs, Aurora"
    },
    {
        utc: "-07:00",
        code: "America/Edmonton",
        name: "Calgary, Edmonton, Fort McMurray, Red Deer, Lethbridge"
    },
    {
        utc: "-07:00",
        code: "America/Fort_Nelson",
        name: "Fort Nelson"
    },
    {
        utc: "-07:00",
        code: "America/Hermosillo",
        name: "Hermosillo, Ciudad Obreg\xf3n, Nogales, San Luis R\xedo Colorado, Navojoa"
    },
    {
        utc: "-07:00",
        code: "America/Inuvik",
        name: "Inuvik"
    },
    {
        utc: "-07:00",
        code: "America/Mazatlan",
        name: "Culiac\xe1n, Mazatl\xe1n, Tepic, Los Mochis, La Paz"
    },
    {
        utc: "-07:00",
        code: "America/Ojinaga",
        name: "Ciudad Ju\xe1rez, Manuel Ojinaga, Ojinaga"
    },
    {
        utc: "-07:00",
        code: "America/Phoenix",
        name: "Phoenix, Tucson, Mesa, Chandler, Gilbert"
    },
    {
        utc: "-07:00",
        code: "America/Whitehorse",
        name: "Whitehorse"
    },
    {
        utc: "-07:00",
        code: "America/Yellowknife",
        name: "Yellowknife"
    },
    {
        utc: "-06:00",
        code: "America/Bahia_Banderas",
        name: "Mezcales, San Vicente, Bucer\xedas, Valle de Banderas"
    },
    {
        utc: "-06:00",
        code: "America/Belize",
        name: "Belize City, San Ignacio, Orange Walk, Belmopan, Dangriga"
    },
    {
        utc: "-06:00",
        code: "America/Chicago",
        name: "Chicago, Houston, San Antonio, Dallas, Austin"
    },
    {
        utc: "-06:00",
        code: "America/Costa_Rica",
        name: "San Jos\xe9, Lim\xf3n, San Francisco, Alajuela, Liberia"
    },
    {
        utc: "-06:00",
        code: "America/El_Salvador",
        name: "San Salvador, Soyapango, Santa Ana, San Miguel, Mejicanos"
    },
    {
        utc: "-06:00",
        code: "America/Guatemala",
        name: "Guatemala City, Mixco, Villa Nueva, Petapa, San Juan Sacatep\xe9quez"
    },
    {
        utc: "-06:00",
        code: "America/Indiana/Knox",
        name: "Knox"
    },
    {
        utc: "-06:00",
        code: "America/Indiana/Tell_City",
        name: "Tell City"
    },
    {
        utc: "-06:00",
        code: "America/Managua",
        name: "Managua, Le\xf3n, Masaya, Chinandega, Matagalpa"
    },
    {
        utc: "-06:00",
        code: "America/Matamoros",
        name: "Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras, Ciudad Acu\xf1a"
    },
    {
        utc: "-06:00",
        code: "America/Menominee",
        name: "Menominee, Iron Mountain, Kingsford, Ironwood, Iron River"
    },
    {
        utc: "-06:00",
        code: "America/Merida",
        name: "M\xe9rida, Campeche, Ciudad del Carmen, Kanas\xedn, Valladolid"
    },
    {
        utc: "-06:00",
        code: "America/Mexico_City",
        name: "Mexico City, Iztapalapa, Ecatepec de Morelos, Guadalajara, Puebla"
    },
    {
        utc: "-06:00",
        code: "America/Monterrey",
        name: "Monterrey, Saltillo, Guadalupe, Torre\xf3n, Victoria de Durango"
    },
    {
        utc: "-06:00",
        code: "America/North_Dakota/Beulah",
        name: "Beulah"
    },
    {
        utc: "-06:00",
        code: "America/North_Dakota/Center",
        name: "Center"
    },
    {
        utc: "-06:00",
        code: "America/North_Dakota/New_Salem",
        name: "Mandan"
    },
    {
        utc: "-06:00",
        code: "America/Rainy_River",
        name: "Rainy River"
    },
    {
        utc: "-06:00",
        code: "America/Rankin_Inlet",
        name: "Rankin Inlet"
    },
    {
        utc: "-06:00",
        code: "America/Regina",
        name: "Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford"
    },
    {
        utc: "-06:00",
        code: "America/Resolute",
        name: "Resolute"
    },
    {
        utc: "-06:00",
        code: "America/Swift_Current",
        name: "Swift Current"
    },
    {
        utc: "-06:00",
        code: "America/Tegucigalpa",
        name: "Tegucigalpa, San Pedro Sula, Choloma, La Ceiba, El Progreso"
    },
    {
        utc: "-06:00",
        code: "America/Winnipeg",
        name: "Winnipeg, Brandon, Kenora, Portage la Prairie, Thompson"
    },
    {
        utc: "-06:00",
        code: "Pacific/Easter",
        name: "Easter"
    },
    {
        utc: "-06:00",
        code: "Pacific/Galapagos",
        name: "Puerto Ayora, Puerto Baquerizo Moreno"
    },
    {
        utc: "-05:00",
        code: "America/Atikokan",
        name: "Atikokan"
    },
    {
        utc: "-05:00",
        code: "America/Bogota",
        name: "Bogot\xe1, Cali, Medell\xedn, Barranquilla, Cartagena"
    },
    {
        utc: "-05:00",
        code: "America/Cancun",
        name: "Canc\xfan, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto"
    },
    {
        utc: "-05:00",
        code: "America/Cayman",
        name: "George Town, West Bay, Bodden Town, East End, North Side"
    },
    {
        utc: "-05:00",
        code: "America/Detroit",
        name: "Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor"
    },
    {
        utc: "-05:00",
        code: "America/Eirunepe",
        name: "Eirunep\xe9, Benjamin Constant, Envira"
    },
    {
        utc: "-05:00",
        code: "America/Grand_Turk",
        name: "Cockburn Town"
    },
    {
        utc: "-05:00",
        code: "America/Guayaquil",
        name: "Guayaquil, Quito, Cuenca, Santo Domingo de los Colorados, Machala"
    },
    {
        utc: "-05:00",
        code: "America/Havana",
        name: "Havana, Santiago de Cuba, Camag\xfcey, Holgu\xedn, Guant\xe1namo"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Indianapolis",
        name: "Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Marengo",
        name: "Marengo"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Petersburg",
        name: "Petersburg"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Vevay",
        name: "Vevay"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Vincennes",
        name: "Vincennes, Jasper, Washington, Huntingburg"
    },
    {
        utc: "-05:00",
        code: "America/Indiana/Winamac",
        name: "Winamac"
    },
    {
        utc: "-05:00",
        code: "America/Iqaluit",
        name: "Iqaluit"
    },
    {
        utc: "-05:00",
        code: "America/Jamaica",
        name: "Kingston, New Kingston, Spanish Town, Portmore, Montego Bay"
    },
    {
        utc: "-05:00",
        code: "America/Kentucky/Louisville",
        name: "Louisville, Jeffersonville, New Albany, Jeffersontown, Pleasure Ridge Park"
    },
    {
        utc: "-05:00",
        code: "America/Kentucky/Monticello",
        name: "Monticello"
    },
    {
        utc: "-05:00",
        code: "America/Lima",
        name: "Lima, Arequipa, Callao, Trujillo, Chiclayo"
    },
    {
        utc: "-05:00",
        code: "America/Nassau",
        name: "Nassau, Lucaya, Freeport, West End, Cooper\u2019s Town"
    },
    {
        utc: "-05:00",
        code: "America/New_York",
        name: "New York City, Brooklyn, Queens, Philadelphia, Manhattan"
    },
    {
        utc: "-05:00",
        code: "America/Nipigon",
        name: "Nipigon"
    },
    {
        utc: "-05:00",
        code: "America/Panama",
        name: "Panam\xe1, San Miguelito, Juan D\xedaz, David, Arraij\xe1n"
    },
    {
        utc: "-05:00",
        code: "America/Pangnirtung",
        name: "Pangnirtung"
    },
    {
        utc: "-05:00",
        code: "America/Port-au-Prince",
        name: "Port-au-Prince, Carrefour, Delmas 73, P\xe9tionville, Port-de-Paix"
    },
    {
        utc: "-05:00",
        code: "America/Rio_Branco",
        name: "Rio Branco, Cruzeiro do Sul, Sena Madureira, Tarauac\xe1, Feij\xf3"
    },
    {
        utc: "-05:00",
        code: "America/Thunder_Bay",
        name: "Thunder Bay"
    },
    {
        utc: "-05:00",
        code: "America/Toronto",
        name: "Toronto, Montr\xe9al, Ottawa, Mississauga, Qu\xe9bec"
    },
    {
        utc: "-04:00",
        code: "America/AnguillaSandy Hill",
        name: "The Valley, Blowing Point Village, Sandy Ground Village, The Quarter, Sandy Hill"
    },
    {
        utc: "-04:00",
        code: "America/Antigua",
        name: "Saint John\u2019s, Piggotts, Bolands, Codrington, Parham"
    },
    {
        utc: "-04:00",
        code: "America/Aruba",
        name: "Oranjestad, Tanki Leendert, San Nicolas, Santa Cruz, Paradera"
    },
    {
        utc: "-04:00",
        code: "America/Asuncion",
        name: "Asunci\xf3n, Ciudad del Este, San Lorenzo, Capiat\xe1, Lambar\xe9"
    },
    {
        utc: "-04:00",
        code: "America/Barbados",
        name: "Bridgetown, Speightstown, Oistins, Bathsheba, Holetown"
    },
    {
        utc: "-04:00",
        code: "America/Blanc-Sablon",
        name: "L\xe9vis"
    },
    {
        utc: "-04:00",
        code: "America/Boa_Vista",
        name: "Boa Vista"
    },
    {
        utc: "-04:00",
        code: "America/Campo_Grande",
        name: "Campo Grande, Dourados, Corumb\xe1, Tr\xeas Lagoas, Ponta Por\xe3"
    },
    {
        utc: "-04:00",
        code: "America/Caracas",
        name: "Caracas, Maracaibo, Maracay, Valencia, Barquisimeto"
    },
    {
        utc: "-04:00",
        code: "America/Cuiaba",
        name: "Cuiab\xe1, V\xe1rzea Grande, Rondon\xf3polis, Sinop, Barra do Gar\xe7as"
    },
    {
        utc: "-04:00",
        code: "America/Curacao",
        name: "Willemstad, Sint Michiel Liber"
    },
    {
        utc: "-04:00",
        code: "America/Dominica",
        name: "Roseau, Portsmouth, Berekua, Saint Joseph, Wesley"
    },
    {
        utc: "-04:00",
        code: "America/Glace_Bay",
        name: "Sydney, Glace Bay, Sydney Mines"
    },
    {
        utc: "-04:00",
        code: "America/Goose_Bay",
        name: "Labrador City, Happy Valley-Goose Bay"
    },
    {
        utc: "-04:00",
        code: "America/Grenada",
        name: "Saint George's, Gouyave, Grenville, Victoria, Saint David\u2019s"
    },
    {
        utc: "-04:00",
        code: "America/Guadeloupe",
        name: "Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg, Sainte-Anne"
    },
    {
        utc: "-04:00",
        code: "America/Guyana",
        name: "Georgetown, Linden, New Amsterdam, Anna Regina, Bartica"
    },
    {
        utc: "-04:00",
        code: "America/Halifax",
        name: "Halifax, Dartmouth, Charlottetown, Lower Sackville, Truro"
    },
    {
        utc: "-04:00",
        code: "America/Kralendijk",
        name: "Kralendijk, Oranjestad, The Bottom"
    },
    {
        utc: "-04:00",
        code: "America/La_Paz",
        name: "Santa Cruz de la Sierra, Cochabamba, La Paz, Sucre, Oruro"
    },
    {
        utc: "-04:00",
        code: "America/Lower_Princes",
        name: "Cul de Sac, Lower Prince\u2019s Quarter, Koolbaai, Philipsburg"
    },
    {
        utc: "-04:00",
        code: "America/Manaus",
        name: "Manaus, Itacoatiara, Parintins, Manacapuru, Coari"
    },
    {
        utc: "-04:00",
        code: "America/Marigot",
        name: "Marigot"
    },
    {
        utc: "-04:00",
        code: "America/Martinique",
        name: "Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie, Le Fran\xe7ois"
    },
    {
        utc: "-04:00",
        code: "America/Moncton",
        name: "Moncton, Saint John, Fredericton, Dieppe, Miramichi"
    },
    {
        utc: "-04:00",
        code: "America/Montserrat",
        name: "Brades, Saint Peters, Plymouth"
    },
    {
        utc: "-04:00",
        code: "America/Porto_Velho",
        name: "Porto Velho, Ji Paran\xe1, Vilhena, Ariquemes, Cacoal"
    },
    {
        utc: "-04:00",
        code: "America/Port_of_Spain",
        name: "Chaguanas, Mon Repos, San Fernando, Port of Spain, Rio Claro"
    },
    {
        utc: "-04:00",
        code: "America/Puerto_Rico",
        name: "San Juan, Bayam\xf3n, Carolina, Ponce, Caguas"
    },
    {
        utc: "-04:00",
        code: "America/Santiago",
        name: "Santiago, Puente Alto, Antofagasta, Vi\xf1a del Mar, Valpara\xedso"
    },
    {
        utc: "-04:00",
        code: "America/Santo_Domingo",
        name: "Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este, San Pedro de Macor\xeds"
    },
    {
        utc: "-04:00",
        code: "America/St_Barthelemy",
        name: "Gustavia"
    },
    {
        utc: "-04:00",
        code: "America/St_Kitts",
        name: "Basseterre, Fig Tree, Market Shop, Saint Paul\u2019s, Middle Island"
    },
    {
        utc: "-04:00",
        code: "America/St_Lucia",
        name: "Castries, Bisee, Vieux Fort, Micoud, Soufri\xe8re"
    },
    {
        utc: "-04:00",
        code: "America/St_Thomas",
        name: "Saint Croix, Charlotte Amalie, Cruz Bay"
    },
    {
        utc: "-04:00",
        code: "America/St_Vincent",
        name: "Kingstown, Kingstown Park, Georgetown, Barrouallie, Port Elizabeth"
    },
    {
        utc: "-04:00",
        code: "America/Thule",
        name: "Thule"
    },
    {
        utc: "-04:00",
        code: "America/Tortola",
        name: "Road Town"
    },
    {
        utc: "-04:00",
        code: "Atlantic/Bermuda",
        name: "Hamilton"
    },
    {
        utc: "-03:30",
        code: "America/St_Johns",
        name: "St. John's, Mount Pearl, Corner Brook, Conception Bay South, Bay Roberts"
    },
    {
        utc: "-03:00",
        code: "America/Araguaina",
        name: "Palmas, Aragua\xedna, Gurupi, Miracema do Tocantins, Porto Franco"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Buenos_Aires",
        name: "Buenos Aires, La Plata, Mar del Plata, Mor\xf3n, Bah\xeda Blanca"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Catamarca",
        name: "San Fernando del Valle de Catamarca, Trelew, Puerto Madryn, Esquel, Rawson"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Cordoba",
        name: "C\xf3rdoba, Rosario, Santa Fe, Resistencia, Santiago del Estero"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Jujuy",
        name: "San Salvador de Jujuy, San Pedro de Jujuy, Libertador General San Mart\xedn, Palpal\xe1, La Quiaca"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/La_Rioja",
        name: "La Rioja, Chilecito, Arauco, Chamical"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Mendoza",
        name: "Mendoza, San Rafael, San Mart\xedn"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Rio_Gallegos",
        name: "Comodoro Rivadavia, R\xedo Gallegos, Caleta Olivia, Pico Truncado, Puerto Deseado"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Salta",
        name: "Salta, Neuqu\xe9n, Santa Rosa, San Carlos de Bariloche, Cipolletti"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/San_Juan",
        name: "San Juan, Chimbas, Santa Luc\xeda, Pocito, Caucete"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/San_Luis",
        name: "San Luis, Villa Mercedes, La Punta, Merlo, Justo Daract"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Tucuman",
        name: "San Miguel de Tucum\xe1n, Yerba Buena, Taf\xed Viejo, Alderetes, Aguilares"
    },
    {
        utc: "-03:00",
        code: "America/Argentina/Ushuaia",
        name: "Ushuaia, R\xedo Grande"
    },
    {
        utc: "-03:00",
        code: "America/Bahia",
        name: "Salvador, Feira de Santana, Vit\xf3ria da Conquista, Itabuna, Cama\xe7ari"
    },
    {
        utc: "-03:00",
        code: "America/Belem",
        name: "Bel\xe9m, Ananindeua, Macap\xe1, Parauapebas, Marab\xe1"
    },
    {
        utc: "-03:00",
        code: "America/Cayenne",
        name: "Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou, R\xe9mire-Montjoly"
    },
    {
        utc: "-03:00",
        code: "America/Fortaleza",
        name: "Fortaleza, S\xe3o Lu\xeds, Natal, Teresina, Jo\xe3o Pessoa"
    },
    {
        utc: "-03:00",
        code: "America/Godthab",
        name: "Nuuk, Sisimiut, Ilulissat, Qaqortoq, Aasiaat"
    },
    {
        utc: "-03:00",
        code: "America/Maceio",
        name: "Macei\xf3, Aracaju, Arapiraca, Nossa Senhora do Socorro, S\xe3o Crist\xf3v\xe3o"
    },
    {
        utc: "-03:00",
        code: "America/Miquelon",
        name: "Saint-Pierre, Miquelon"
    },
    {
        utc: "-03:00",
        code: "America/Montevideo",
        name: "Montevideo, Salto, Paysand\xfa, Las Piedras, Rivera"
    },
    {
        utc: "-03:00",
        code: "America/Paramaribo",
        name: "Paramaribo, Lelydorp, Brokopondo, Nieuw Nickerie, Moengo"
    },
    {
        utc: "-03:00",
        code: "America/Punta_Arenas",
        name: "Punta Arenas, Puerto Natales"
    },
    {
        utc: "-03:00",
        code: "America/Recife",
        name: "Recife, Jaboat\xe3o, Jaboat\xe3o dos Guararapes, Olinda, Paulista"
    },
    {
        utc: "-03:00",
        code: "America/Santarem",
        name: "Santar\xe9m, Altamira, Itaituba, Oriximin\xe1, Alenquer"
    },
    {
        utc: "-03:00",
        code: "America/Sao_Paulo",
        name: "S\xe3o Paulo, Rio de Janeiro, Belo Horizonte, Bras\xedlia, Curitiba"
    },
    {
        utc: "-03:00",
        code: "Antarctica/Palmer",
        name: "Palmer"
    },
    {
        utc: "-03:00",
        code: "Antarctica/Rothera",
        name: "Rothera"
    },
    {
        utc: "-03:00",
        code: "Atlantic/Stanley",
        name: "Stanley"
    },
    {
        utc: "-02:00",
        code: "America/Noronha",
        name: "Itamarac\xe1"
    },
    {
        utc: "-02:00",
        code: "Atlantic/South_Georgia",
        name: "Grytviken"
    },
    {
        utc: "-01:00",
        code: "America/Scoresbysund",
        name: "Scoresbysund"
    },
    {
        utc: "-01:00",
        code: "Atlantic/Azores",
        name: "Ponta Delgada, Lagoa, Angra do Hero\xedsmo, Rosto de C\xe3o, Rabo de Peixe"
    },
    {
        utc: "-01:00",
        code: "Atlantic/Cape_Verde",
        name: "Praia, Mindelo, Santa Maria, Cova Figueira, Santa Cruz"
    },
    {
        utc: "+00:00",
        code: "Africa/Abidjan",
        name: "Abidjan, Abobo, Bouak\xe9, Daloa, San-P\xe9dro"
    },
    {
        utc: "+00:00",
        code: "Africa/Accra",
        name: "Accra, Kumasi, Tamale, Takoradi, Atsiaman"
    },
    {
        utc: "+00:00",
        code: "Africa/Bamako",
        name: "Bamako, Sikasso, Mopti, Koutiala, S\xe9gou"
    },
    {
        utc: "+00:00",
        code: "Africa/Banjul",
        name: "Serekunda, Brikama, Bakau, Banjul, Farafenni"
    },
    {
        utc: "+00:00",
        code: "Africa/Bissau",
        name: "Bissau, Bafat\xe1, Gab\xfa, Bissor\xe3, Bolama"
    },
    {
        utc: "+00:00",
        code: "Africa/Casablanca",
        name: "Casablanca, Rabat, F\xe8s, Sale, Marrakesh"
    },
    {
        utc: "+00:00",
        code: "Africa/Conakry",
        name: "Camayenne, Conakry, Nz\xe9r\xe9kor\xe9, Kindia, Kankan"
    },
    {
        utc: "+00:00",
        code: "Africa/Dakar",
        name: "Dakar, Pikine, Touba, Thi\xe8s, Thi\xe8s Nones"
    },
    {
        utc: "+00:00",
        code: "Africa/El_Aaiun",
        name: "Laayoune, Dakhla, Laayoune Plage"
    },
    {
        utc: "+00:00",
        code: "Africa/Freetown",
        name: "Freetown, Bo, Kenema, Koidu, Makeni"
    },
    {
        utc: "+00:00",
        code: "Africa/Lome",
        name: "Lom\xe9, Sokod\xe9, Kara, Atakpam\xe9, Kpalim\xe9"
    },
    {
        utc: "+00:00",
        code: "Africa/Monrovia",
        name: "Monrovia, Gbarnga, Kakata, Bensonville, Harper"
    },
    {
        utc: "+00:00",
        code: "Africa/Nouakchott",
        name: "Nouakchott, Nouadhibou, N\xe9ma, Ka\xe9di, Rosso"
    },
    {
        utc: "+00:00",
        code: "Africa/Ouagadougou",
        name: "Ouagadougou, Bobo-Dioulasso, Koudougou, Ouahigouya, Banfora"
    },
    {
        utc: "+00:00",
        code: "Africa/Sao_Tome",
        name: "S\xe3o Tom\xe9, Santo Ant\xf3nio"
    },
    {
        utc: "+00:00",
        code: "America/Danmarkshavn",
        name: "Danmarkshavn"
    },
    {
        utc: "+00:00",
        code: "Antarctica/Troll",
        name: "Troll"
    },
    {
        utc: "+00:00",
        code: "Atlantic/Canary",
        name: "Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde, Arona"
    },
    {
        utc: "+00:00",
        code: "Atlantic/Faroe",
        name: "T\xf3rshavn, Klaksv\xedk, Fuglafj\xf8r\xf0ur, Tv\xf8royri, Mi\xf0v\xe1gur"
    },
    {
        utc: "+00:00",
        code: "Atlantic/Madeira",
        name: "Funchal, C\xe2mara de Lobos, S\xe3o Martinho, Cani\xe7o, Machico"
    },
    {
        utc: "+00:00",
        code: "Atlantic/Reykjavik",
        name: "Reykjav\xedk, K\xf3pavogur, Hafnarfj\xf6r\xf0ur, Akureyri, Gar\xf0ab\xe6r"
    },
    {
        utc: "+00:00",
        code: "Atlantic/St_Helena",
        name: "Jamestown, Georgetown, Edinburgh of the Seven Seas"
    },
    {
        utc: "+00:00",
        code: "Europe/Dublin",
        name: "Dublin, Cork, Luimneach, Gaillimh, Tallaght"
    },
    {
        utc: "+00:00",
        code: "Europe/Guernsey",
        name: "Saint Peter Port, St Martin, Saint Sampson, St Anne, Saint Saviour"
    },
    {
        utc: "+00:00",
        code: "Europe/Isle_of_Man",
        name: "Douglas, Ramsey, Peel, Port Erin, Castletown"
    },
    {
        utc: "+00:00",
        code: "Europe/Jersey",
        name: "Saint Helier, Le Hocq"
    },
    {
        utc: "+00:00",
        code: "Europe/Lisbon",
        name: "Lisbon, Porto, Amadora, Braga, Set\xfabal"
    },
    {
        utc: "+00:00",
        code: "Europe/London",
        name: "London, Birmingham, Liverpool, Sheffield, Bristol"
    },
    {
        utc: "+01:00",
        code: "Africa/Algiers",
        name: "Algiers, Boumerdas, Oran, T\xe9bessa, Constantine"
    },
    {
        utc: "+01:00",
        code: "Africa/Bangui",
        name: "Bangui, Bimbo, Mba\xefki, Berb\xe9rati, Kaga Bandoro"
    },
    {
        utc: "+01:00",
        code: "Africa/Brazzaville",
        name: "Brazzaville, Pointe-Noire, Dolisie, Kayes, Owando"
    },
    {
        utc: "+01:00",
        code: "Africa/Ceuta",
        name: "Ceuta, Melilla"
    },
    {
        utc: "+01:00",
        code: "Africa/Douala",
        name: "Douala, Yaound\xe9, Garoua, Kouss\xe9ri, Bamenda"
    },
    {
        utc: "+01:00",
        code: "Africa/Kinshasa",
        name: "Kinshasa, Masina, Kikwit, Mbandaka, Matadi"
    },
    {
        utc: "+01:00",
        code: "Africa/Lagos",
        name: "Lagos, Kano, Ibadan, Kaduna, Port Harcourt"
    },
    {
        utc: "+01:00",
        code: "Africa/Libreville",
        name: "Libreville, Port-Gentil, Franceville, Oyem, Moanda"
    },
    {
        utc: "+01:00",
        code: "Africa/Luanda",
        name: "Luanda, N\u2019dalatando, Huambo, Lobito, Benguela"
    },
    {
        utc: "+01:00",
        code: "Africa/Malabo",
        name: "Bata, Malabo, Ebebiyin, Aconibe, A\xf1isoc"
    },
    {
        utc: "+01:00",
        code: "Africa/Ndjamena",
        name: "N'Djamena, Moundou, Sarh, Ab\xe9ch\xe9, Kelo"
    },
    {
        utc: "+01:00",
        code: "Africa/Niamey",
        name: "Niamey, Zinder, Maradi, Agadez, Alaghsas"
    },
    {
        utc: "+01:00",
        code: "Africa/Porto-Novo",
        name: "Cotonou, Abomey-Calavi, Djougou, Porto-Novo, Parakou"
    },
    {
        utc: "+01:00",
        code: "Africa/Tunis",
        name: "Tunis, Sfax, Sousse, Kairouan, Bizerte"
    },
    {
        utc: "+01:00",
        code: "Africa/Windhoek",
        name: "Windhoek, Rundu, Walvis Bay, Oshakati, Swakopmund"
    },
    {
        utc: "+01:00",
        code: "Arctic/Longyearbyen",
        name: "Longyearbyen, Olonkinbyen"
    },
    {
        utc: "+01:00",
        code: "Europe/Amsterdam",
        name: "Amsterdam, Rotterdam, The Hague, Utrecht, Eindhoven"
    },
    {
        utc: "+01:00",
        code: "Europe/Andorra",
        name: "Andorra la Vella, les Escaldes, Encamp, Sant Juli\xe0 de L\xf2ria, la Massana"
    },
    {
        utc: "+01:00",
        code: "Europe/Belgrade",
        name: "Belgrade, Pristina, Ni\u0161, Novi Sad, Prizren"
    },
    {
        utc: "+01:00",
        code: "Europe/Berlin",
        name: "Berlin, Hamburg, Munich, K\xf6ln, Frankfurt am Main"
    },
    {
        utc: "+01:00",
        code: "Europe/Bratislava",
        name: "Bratislava, Ko\u0161ice, Pre\u0161ov, Nitra, \u017Dilina"
    },
    {
        utc: "+01:00",
        code: "Europe/Brussels",
        name: "Brussels, Antwerpen, Gent, Charleroi, Li\xe8ge"
    },
    {
        utc: "+01:00",
        code: "Europe/Budapest",
        name: "Budapest, Debrecen, Miskolc, Szeged, P\xe9cs"
    },
    {
        utc: "+01:00",
        code: "Europe/Copenhagen",
        name: "Copenhagen, \xc5rhus, Odense, Aalborg, Frederiksberg"
    },
    {
        utc: "+01:00",
        code: "Europe/Gibraltar",
        name: "Gibraltar"
    },
    {
        utc: "+01:00",
        code: "Europe/Ljubljana",
        name: "Ljubljana, Maribor, Celje, Kranj, Velenje"
    },
    {
        utc: "+01:00",
        code: "Europe/Luxembourg",
        name: "Luxembourg, Esch-sur-Alzette, Dudelange, Schifflange, Bettembourg"
    },
    {
        utc: "+01:00",
        code: "Europe/Madrid",
        name: "Madrid, Barcelona, Valencia, Sevilla, Zaragoza"
    },
    {
        utc: "+01:00",
        code: "Europe/Malta",
        name: "Birkirkara, Qormi, Mosta, \u017Babbar, San Pawl il-Ba\u0127ar"
    },
    {
        utc: "+01:00",
        code: "Europe/Monaco",
        name: "Monaco, Monte-Carlo, La Condamine"
    },
    {
        utc: "+01:00",
        code: "Europe/Oslo",
        name: "Oslo, Bergen, Trondheim, Stavanger, Drammen"
    },
    {
        utc: "+01:00",
        code: "Europe/Paris",
        name: "Paris, Marseille, Lyon, Toulouse, Nice"
    },
    {
        utc: "+01:00",
        code: "Europe/Podgorica",
        name: "Podgorica, Nik\u0161i\u0107, Herceg Novi, Pljevlja, Budva"
    },
    {
        utc: "+01:00",
        code: "Europe/Prague",
        name: "Prague, Brno, Ostrava, Pilsen, Olomouc"
    },
    {
        utc: "+01:00",
        code: "Europe/Rome",
        name: "Rome, Milan, Naples, Turin, Palermo"
    },
    {
        utc: "+01:00",
        code: "Europe/San_Marino",
        name: "Serravalle, Borgo Maggiore, San Marino, Domagnano, Fiorentino"
    },
    {
        utc: "+01:00",
        code: "Europe/Sarajevo",
        name: "Sarajevo, Banja Luka, Zenica, Tuzla, Mostar"
    },
    {
        utc: "+01:00",
        code: "Europe/Skopje",
        name: "Skopje, Bitola, Kumanovo, Prilep, Tetovo"
    },
    {
        utc: "+01:00",
        code: "Europe/Stockholm",
        name: "Stockholm, G\xf6teborg, Malm\xf6, Uppsala, Sollentuna"
    },
    {
        utc: "+01:00",
        code: "Europe/Tirane",
        name: "Tirana, Durr\xebs, Elbasan, Vlor\xeb, Shkod\xebr"
    },
    {
        utc: "+01:00",
        code: "Europe/Vaduz",
        name: "Schaan, Vaduz, Triesen, Balzers, Eschen"
    },
    {
        utc: "+01:00",
        code: "Europe/Vatican",
        name: "Vatican City"
    },
    {
        utc: "+01:00",
        code: "Europe/Vienna",
        name: "Vienna, Graz, Linz, Favoriten, Donaustadt"
    },
    {
        utc: "+01:00",
        code: "Europe/Warsaw",
        name: "Warsaw, \u0141\xf3d\u017A, Krak\xf3w, Wroc\u0142aw, Pozna\u0144"
    },
    {
        utc: "+01:00",
        code: "Europe/Zagreb",
        name: "Zagreb, Split, Rijeka, Osijek, Zadar"
    },
    {
        utc: "+01:00",
        code: "Europe/Zurich",
        name: "Z\xfcrich, Gen\xe8ve, Basel, Lausanne, Bern"
    },
    {
        utc: "+02:00",
        code: "Africa/Blantyre",
        name: "Lilongwe, Blantyre, Mzuzu, Zomba, Kasungu"
    },
    {
        utc: "+02:00",
        code: "Africa/Bujumbura",
        name: "Bujumbura, Muyinga, Gitega, Ruyigi, Ngozi"
    },
    {
        utc: "+02:00",
        code: "Africa/Cairo",
        name: "Cairo, Alexandria, Giza, Port Said, Suez"
    },
    {
        utc: "+02:00",
        code: "Africa/Gaborone",
        name: "Gaborone, Francistown, Molepolole, Selebi-Phikwe, Maun"
    },
    {
        utc: "+02:00",
        code: "Africa/Harare",
        name: "Harare, Bulawayo, Chitungwiza, Mutare, Gweru"
    },
    {
        utc: "+02:00",
        code: "Africa/Johannesburg",
        name: "Cape Town, Durban, Johannesburg, Soweto, Pretoria"
    },
    {
        utc: "+02:00",
        code: "Africa/Juba",
        name: "Juba, Winejok, Malakal, Wau, Kuacjok"
    },
    {
        utc: "+02:00",
        code: "Africa/Khartoum",
        name: "Khartoum, Omdurman, Nyala, Port Sudan, Kassala"
    },
    {
        utc: "+02:00",
        code: "Africa/Kigali",
        name: "Kigali, Butare, Gitarama, Musanze, Gisenyi"
    },
    {
        utc: "+02:00",
        code: "Africa/Lubumbashi",
        name: "Lubumbashi, Mbuji-Mayi, Kisangani, Kananga, Likasi"
    },
    {
        utc: "+02:00",
        code: "Africa/Lusaka",
        name: "Lusaka, Kitwe, Ndola, Kabwe, Chingola"
    },
    {
        utc: "+02:00",
        code: "Africa/Maputo",
        name: "Maputo, Matola, Beira, Nampula, Chimoio"
    },
    {
        utc: "+02:00",
        code: "Africa/Maseru",
        name: "Maseru, Mafeteng, Leribe, Maputsoe, Mohale\u2019s Hoek"
    },
    {
        utc: "+02:00",
        code: "Africa/Mbabane",
        name: "Manzini, Mbabane, Big Bend, Malkerns, Nhlangano"
    },
    {
        utc: "+02:00",
        code: "Africa/Tripoli",
        name: "Tripoli, Benghazi, Mi\u015Fr\u0101tah, Tarhuna, Al Khums"
    },
    {
        utc: "+02:00",
        code: "Asia/Amman",
        name: "Amman, Zarqa, Irbid, Russeifa, W\u0101d\u012B as S\u012Br"
    },
    {
        utc: "+02:00",
        code: "Asia/Beirut",
        name: "Beirut, Ra\u2019s Bayr\u016Bt, Tripoli, Sidon, Tyre"
    },
    {
        utc: "+02:00",
        code: "Asia/Damascus",
        name: "Aleppo, Damascus, Homs, \u1E28am\u0101h, Latakia"
    },
    {
        utc: "+02:00",
        code: "Asia/Famagusta",
        name: "Famagusta, Kyrenia, Protaras, Paral\xedmni, L\xe1pithos"
    },
    {
        utc: "+02:00",
        code: "Asia/Gaza",
        name: "Gaza, Kh\u0101n Y\u016Bnis, Jab\u0101ly\u0101, Rafa\u1E29, Dayr al Bala\u1E29"
    },
    {
        utc: "+02:00",
        code: "Asia/Hebron",
        name: "East Jerusalem, Hebron, Nablus, Battir, \u0162\u016Blkarm"
    },
    {
        utc: "+02:00",
        code: "Asia/Jerusalem",
        name: "Jerusalem, Tel Aviv, West Jerusalem, Haifa, Ashdod"
    },
    {
        utc: "+02:00",
        code: "Asia/Nicosia",
        name: "Nicosia, Limassol, Larnaca, Str\xf3volos, Paphos"
    },
    {
        utc: "+02:00",
        code: "Europe/Athens",
        name: "Athens, Thessalon\xedki, P\xe1tra, Piraeus, L\xe1risa"
    },
    {
        utc: "+02:00",
        code: "Europe/Bucharest",
        name: "Bucharest, Sector 3, Sector 6, Sector 2, Ia\u015Fi"
    },
    {
        utc: "+02:00",
        code: "Europe/Chisinau",
        name: "Chisinau, Tiraspol, B\u0103l\u0163i, Bender, R\xeebni\u0163a"
    },
    {
        utc: "+02:00",
        code: "Europe/Helsinki",
        name: "Helsinki, Espoo, Tampere, Vantaa, Turku"
    },
    {
        utc: "+02:00",
        code: "Europe/Kaliningrad",
        name: "Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk, Gusev"
    },
    {
        utc: "+02:00",
        code: "Europe/Kiev",
        name: "Kyiv, Kharkiv, Donetsk, Odessa, Dnipro"
    },
    {
        utc: "+02:00",
        code: "Europe/Mariehamn",
        name: "Mariehamn"
    },
    {
        utc: "+02:00",
        code: "Europe/Riga",
        name: "Riga, Daugavpils, Liep\u0101ja, Jelgava, J\u016Brmala"
    },
    {
        utc: "+02:00",
        code: "Europe/Sofia",
        name: "Sofia, Plovdiv, Varna, Burgas, Ruse"
    },
    {
        utc: "+02:00",
        code: "Europe/Tallinn",
        name: "Tallinn, Tartu, Narva, Kohtla-J\xe4rve, P\xe4rnu"
    },
    {
        utc: "+02:00",
        code: "Europe/Uzhgorod",
        name: "Uzhgorod, Mukachevo, Khust, Berehove, Tyachiv"
    },
    {
        utc: "+02:00",
        code: "Europe/Vilnius",
        name: "Vilnius, Kaunas, Klaip\u0117da, \u0160iauliai, Panev\u0117\u017Eys"
    },
    {
        utc: "+02:00",
        code: "Europe/Zaporozhye",
        name: "Luhansk, Sevastopol, Sievierodonetsk, Alchevsk, Lysychansk"
    },
    {
        utc: "+03:00",
        code: "Africa/Addis_Ababa",
        name: "Addis Ababa, Dire Dawa, Mek'ele, Nazr\u0113t, Bahir Dar"
    },
    {
        utc: "+03:00",
        code: "Africa/Asmara",
        name: "Asmara, Keren, Massawa, Assab, Mendefera"
    },
    {
        utc: "+03:00",
        code: "Africa/Dar_es_Salaam",
        name: "Dar es Salaam, Mwanza, Zanzibar, Arusha, Mbeya"
    },
    {
        utc: "+03:00",
        code: "Africa/Djibouti",
        name: "Djibouti, 'Ali Sabieh, Tadjourah, Obock, Dikhil"
    },
    {
        utc: "+03:00",
        code: "Africa/Kampala",
        name: "Kampala, Gulu, Lira, Mbarara, Jinja"
    },
    {
        utc: "+03:00",
        code: "Africa/Mogadishu",
        name: "Mogadishu, Hargeysa, Berbera, Kismayo, Marka"
    },
    {
        utc: "+03:00",
        code: "Africa/Nairobi",
        name: "Nairobi, Mombasa, Nakuru, Eldoret, Kisumu"
    },
    {
        utc: "+03:00",
        code: "Antarctica/Syowa",
        name: "Syowa"
    },
    {
        utc: "+03:00",
        code: "Asia/Aden",
        name: "Sanaa, Al \u1E28udaydah, Taiz, Aden, Mukalla"
    },
    {
        utc: "+03:00",
        code: "Asia/Baghdad",
        name: "Baghdad, Basrah, Al Maw\u015Fil al Jad\u012Bdah, Al Ba\u015Frah al Qad\u012Bmah, Mosul"
    },
    {
        utc: "+03:00",
        code: "Asia/Bahrain",
        name: "Manama, Al Muharraq, Ar Rif\u0101\u2018, D\u0101r Kulayb, Mad\u012Bnat \u1E28amad"
    },
    {
        utc: "+03:00",
        code: "Asia/Kuwait",
        name: "Al A\u1E29mad\u012B, \u1E28awall\u012B, As S\u0101lim\u012Byah, \u015Eab\u0101\u1E29 as S\u0101lim, Al Farw\u0101n\u012Byah"
    },
    {
        utc: "+03:00",
        code: "Asia/Qatar",
        name: "Doha, Ar Rayy\u0101n, Umm \u015Eal\u0101l Mu\u1E29ammad, Al Wakrah, Al Khawr"
    },
    {
        utc: "+03:00",
        code: "Asia/Riyadh",
        name: "Riyadh, Jeddah, Mecca, Medina, Sul\u0163\u0101nah"
    },
    {
        utc: "+03:00",
        code: "Europe/Istanbul",
        name: "Istanbul, Ankara, \u0130zmir, Bursa, Adana"
    },
    {
        utc: "+03:00",
        code: "Europe/Kirov",
        name: "Kirov, Kirovo-Chepetsk, Vyatskiye Polyany, Slobodskoy, Kotel\u2019nich"
    },
    {
        utc: "+03:00",
        code: "Europe/Minsk",
        name: "Minsk, Homyel', Mahilyow, Vitebsk, Hrodna"
    },
    {
        utc: "+03:00",
        code: "Europe/Moscow",
        name: "Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan, Rostov-na-Donu"
    },
    {
        utc: "+03:00",
        code: "Europe/Simferopol",
        name: "Simferopol, Kerch, Yevpatoriya, Yalta, Feodosiya"
    },
    {
        utc: "+03:00",
        code: "Europe/Volgograd",
        name: "Volgograd, Volzhskiy, Kamyshin, Mikhaylovka, Uryupinsk"
    },
    {
        utc: "+03:00",
        code: "Indian/Antananarivo",
        name: "Antananarivo, Toamasina, Antsirabe, Fianarantsoa, Mahajanga"
    },
    {
        utc: "+03:00",
        code: "Indian/Comoro",
        name: "Moroni, Moutsamoudou, Fomboni, Domoni, Tsimbeo"
    },
    {
        utc: "+03:00",
        code: "Indian/Mayotte",
        name: "Mamoudzou, Koungou, Dzaoudzi, Dembeni, Sada"
    },
    {
        utc: "+03:30",
        code: "Asia/Tehran",
        name: "Tehran, Mashhad, Isfahan, Karaj, Tabriz"
    },
    {
        utc: "+04:00",
        code: "Asia/Baku",
        name: "Baku, Ganja, Sumqay\u0131t, Lankaran, Yevlakh"
    },
    {
        utc: "+04:00",
        code: "Asia/Dubai",
        name: "Dubai, Sharjah, Abu Dhabi, Ajman City, Ras Al Khaimah City"
    },
    {
        utc: "+04:00",
        code: "Asia/Muscat",
        name: "Muscat, Seeb, \u015Eal\u0101lah, Bawshar, Sohar"
    },
    {
        utc: "+04:00",
        code: "Asia/Tbilisi",
        name: "Tbilisi, Kutaisi, Batumi, Sokhumi, Zugdidi"
    },
    {
        utc: "+04:00",
        code: "Asia/Yerevan",
        name: "Yerevan, Gyumri, Vanadzor, Vagharshapat, Hrazdan"
    },
    {
        utc: "+04:00",
        code: "Europe/Astrakhan",
        name: "Astrakhan, Akhtubinsk, Znamensk, Kharabali, Kamyzyak"
    },
    {
        utc: "+04:00",
        code: "Europe/Samara",
        name: "Samara, Togliatti-on-the-Volga, Izhevsk, Syzran\u2019, Novokuybyshevsk"
    },
    {
        utc: "+04:00",
        code: "Europe/Saratov",
        name: "Saratov, Balakovo, Engel\u2019s, Balashov, Vol\u2019sk"
    },
    {
        utc: "+04:00",
        code: "Europe/Ulyanovsk",
        name: "Ulyanovsk, Dimitrovgrad, Inza, Barysh, Novoul\u2019yanovsk"
    },
    {
        utc: "+04:00",
        code: "Indian/Mahe",
        name: "Victoria, Anse Boileau, Bel Ombre, Beau Vallon, Cascade"
    },
    {
        utc: "+04:00",
        code: "Indian/Mauritius",
        name: "Port Louis, Beau Bassin-Rose Hill, Vacoas, Curepipe, Quatre Bornes"
    },
    {
        utc: "+04:00",
        code: "Indian/Reunion",
        name: "Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon, Saint-Andr\xe9"
    },
    {
        utc: "+04:30",
        code: "Asia/Kabul",
        name: "Kabul, Kandah\u0101r, Maz\u0101r-e Shar\u012Bf, Her\u0101t, Jal\u0101l\u0101b\u0101d"
    },
    {
        utc: "+05:00",
        code: "Antarctica/Mawson",
        name: "Mawson"
    },
    {
        utc: "+05:00",
        code: "Asia/Aqtau",
        name: "Shevchenko, Zhanaozen, Beyneu, Shetpe, Yeraliyev"
    },
    {
        utc: "+05:00",
        code: "Asia/Aqtobe",
        name: "Aktobe, Kandyagash, Shalqar, Khromtau, Embi"
    },
    {
        utc: "+05:00",
        code: "Asia/Ashgabat",
        name: "Ashgabat, T\xfcrkmenabat, Da\u015Foguz, Mary, Balkanabat"
    },
    {
        utc: "+05:00",
        code: "Asia/Atyrau",
        name: "Atyrau, Qulsary, Shalkar, Balykshi, Maqat"
    },
    {
        utc: "+05:00",
        code: "Asia/Dushanbe",
        name: "Dushanbe, Khujand, K\u016Dlob, Bokhtar, Istaravshan"
    },
    {
        utc: "+05:00",
        code: "Asia/Karachi",
        name: "Karachi, Lahore, Faisalabad, Rawalpindi, Multan"
    },
    {
        utc: "+05:00",
        code: "Asia/Oral",
        name: "Oral, Aqsay, Zh\xe4nibek, Tasqala, Zhumysker"
    },
    {
        utc: "+05:00",
        code: "Asia/Qyzylorda",
        name: "Kyzylorda, Baikonur, Novokazalinsk, Aral, Chiili"
    },
    {
        utc: "+05:00",
        code: "Asia/Samarkand",
        name: "Samarkand, Bukhara, Nukus, Qarshi, Jizzax"
    },
    {
        utc: "+05:00",
        code: "Asia/Tashkent",
        name: "Tashkent, Namangan, Andijon, Qo\u2018qon, Chirchiq"
    },
    {
        utc: "+05:00",
        code: "Asia/Yekaterinburg",
        name: "Yekaterinburg, Chelyabinsk, Ufa, Perm, Orenburg"
    },
    {
        utc: "+05:00",
        code: "Indian/Kerguelen",
        name: "Port-aux-Fran\xe7ais"
    },
    {
        utc: "+05:00",
        code: "Indian/Maldives",
        name: "Male, Fuvahmulah, Hithadhoo, Kulhudhuffushi, Thinadhoo"
    },
    {
        utc: "+05:30",
        code: "Asia/Colombo",
        name: "Colombo, Dehiwala-Mount Lavinia, Moratuwa, Jaffna, Negombo"
    },
    {
        utc: "+05:30",
        code: "Asia/Kolkata",
        name: "Mumbai, Delhi, Bengaluru, Kolkata, Chennai"
    },
    {
        utc: "+05:45",
        code: "Asia/Kathmandu",
        name: "Kathmandu, Pokhara, P\u0101tan, Biratnagar, Birga\xf1j"
    },
    {
        utc: "+06:00",
        code: "Antarctica/Vostok",
        name: "Vostok"
    },
    {
        utc: "+06:00",
        code: "Asia/Almaty",
        name: "Almaty, Karagandy, Shymkent, Taraz, Nur-Sultan"
    },
    {
        utc: "+06:00",
        code: "Asia/Bishkek",
        name: "Bishkek, Osh, Jalal-Abad, Karakol, Tokmok"
    },
    {
        utc: "+06:00",
        code: "Asia/Dhaka",
        name: "Dhaka, Chattogram, Khulna, R\u0101jsh\u0101hi, Comilla"
    },
    {
        utc: "+06:00",
        code: "Asia/Omsk",
        name: "Omsk, Tara, Kalachinsk, Znamenskoye, Tavricheskoye"
    },
    {
        utc: "+06:00",
        code: "Asia/Qostanay",
        name: "Kostanay, Rudnyy, Dzhetygara, Arkalyk, Lisakovsk"
    },
    {
        utc: "+06:00",
        code: "Asia/Thimphu",
        name: "himphu, Pun\u0101kha, Tsirang, Phuntsholing, Pemagatshel"
    },
    {
        utc: "+06:00",
        code: "Asia/Urumqi",
        name: "Zhongshan, \xdcr\xfcmqi, Zhanjiang, Shihezi, Huocheng"
    },
    {
        utc: "+06:00",
        code: "Indian/Chagos",
        name: "British Indian Ocean Territory"
    },
    {
        utc: "+06:30",
        code: "Asia/Yangon",
        name: "Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township"
    },
    {
        utc: "+06:30",
        code: "Indian/Cocos",
        name: "West Island"
    },
    {
        utc: "+07:00",
        code: "Antarctica/Davis",
        name: "Davis"
    },
    {
        utc: "+07:00",
        code: "Asia/Bangkok",
        name: "Bangkok, Hanoi, Haiphong, Samut Prakan, Mueang Nonthaburi"
    },
    {
        utc: "+07:00",
        code: "Asia/Barnaul",
        name: "Barnaul, Biysk, Rubtsovsk, Novoaltaysk, Gorno-Altaysk"
    },
    {
        utc: "+07:00",
        code: "Asia/Hovd",
        name: "Khovd, \xd6lgii, Ulaangom, Uliastay, Altai"
    },
    {
        utc: "+07:00",
        code: "Asia/Ho_Chi_Minh",
        name: "Ho Chi Minh City, Da Nang, Bi\xean H\xf2a, Nha Trang, C\u1EA7n Th\u01A1"
    },
    {
        utc: "+07:00",
        code: "Asia/Jakarta",
        name: "Jakarta, Surabaya, Medan, Bandung, Bekasi"
    },
    {
        utc: "+07:00",
        code: "Asia/Krasnoyarsk",
        name: "Krasnoyarsk, Abakan, Norilsk, Achinsk, Kyzyl"
    },
    {
        utc: "+07:00",
        code: "Asia/Novokuznetsk",
        name: "Novokuznetsk, Kemerovo, Prokop\u2019yevsk, Leninsk-Kuznetsky, Kisel\xebvsk"
    },
    {
        utc: "+07:00",
        code: "Asia/Novosibirsk",
        name: "Novosibirsk, Berdsk, Iskitim, Akademgorodok, Kuybyshev"
    },
    {
        utc: "+07:00",
        code: "Asia/Phnom_Penh",
        name: "Phnom Penh, Takeo, Sihanoukville, Battambang, Siem Reap"
    },
    {
        utc: "+07:00",
        code: "Asia/Pontianak",
        name: "Pontianak, Tanjung Pinang, Palangkaraya, Singkawang, Sampit"
    },
    {
        utc: "+07:00",
        code: "Asia/Tomsk",
        name: "Tomsk, Seversk, Strezhevoy, Kolpashevo, Asino"
    },
    {
        utc: "+07:00",
        code: "Asia/Vientiane",
        name: "Vientiane, Pakse, Thakh\xe8k, Savannakhet, Luang Prabang"
    },
    {
        utc: "+07:00",
        code: "Indian/Christmas",
        name: "Flying Fish Cove"
    },
    {
        utc: "+08:00",
        code: "Asia/Brunei",
        name: "Bandar Seri Begawan, Kuala Belait, Seria, Tutong, Bangar"
    },
    {
        utc: "+08:00",
        code: "Asia/Choibalsan",
        name: "Baruun-Urt, Choibalsan"
    },
    {
        utc: "+08:00",
        code: "Asia/Hong_Kong",
        name: "Hong Kong, Kowloon, Tsuen Wan, Yuen Long Kau Hui, Tung Chung"
    },
    {
        utc: "+08:00",
        code: "Asia/Irkutsk",
        name: "Irkutsk, Ulan-Ude, Bratsk, Angarsk, Ust\u2019-Ilimsk"
    },
    {
        utc: "+08:00",
        code: "Asia/Kuala_Lumpur",
        name: "Kota Bharu, Kuala Lumpur, Klang, Kampung Baru Subang, Johor Bahru"
    },
    {
        utc: "+08:00",
        code: "Asia/Kuching",
        name: "Kuching, Kota Kinabalu, Sandakan, Tawau, Miri"
    },
    {
        utc: "+08:00",
        code: "Asia/Macau",
        name: "Macau"
    },
    {
        utc: "+08:00",
        code: "Asia/Makassar",
        name: "Makassar, Denpasar, City of Balikpapan, Banjarmasin, Manado"
    },
    {
        utc: "+08:00",
        code: "Asia/Manila",
        name: "Quezon City, Manila, Caloocan City, Budta, Davao"
    },
    {
        utc: "+08:00",
        code: "Asia/Shanghai",
        name: "Shanghai, Beijing, Tianjin, Guangzhou, Shenzhen"
    },
    {
        utc: "+08:00",
        code: "Asia/Singapore",
        name: "Singapore, Woodlands"
    },
    {
        utc: "+08:00",
        code: "Asia/Taipei",
        name: "Taipei, Kaohsiung, Taichung, Tainan, Banqiao"
    },
    {
        utc: "+08:00",
        code: "Asia/Ulaanbaatar",
        name: "Ulan Bator, Erdenet, Darhan, Hovd, M\xf6r\xf6n"
    },
    {
        utc: "+08:00",
        code: "Australia/Perth",
        name: "Perth, Rockingham, Mandurah, Bunbury, Albany"
    },
    {
        utc: "+08:45",
        code: "Australia/Eucla",
        name: "Eucla"
    },
    {
        utc: "+09:00",
        code: "Asia/Chita",
        name: "Chita, Krasnokamensk, Borzya, Petrovsk-Zabaykal\u2019skiy, Aginskoye"
    },
    {
        utc: "+09:00",
        code: "Asia/Dili",
        name: "Dili, Maliana, Suai, Likis\xe1, Aileu"
    },
    {
        utc: "+09:00",
        code: "Asia/Jayapura",
        name: "Ambon, Jayapura, Sorong, Ternate, Abepura"
    },
    {
        utc: "+09:00",
        code: "Asia/Khandyga",
        name: "Khandyga"
    },
    {
        utc: "+09:00",
        code: "Asia/Pyongyang",
        name: "Pyongyang, Hamh\u016Dng, Namp\u2019o, Sunch\u2019\u014Fn, H\u016Dngnam"
    },
    {
        utc: "+09:00",
        code: "Asia/Seoul",
        name: "Seoul, Busan, Incheon, Daegu, Daejeon"
    },
    {
        utc: "+09:00",
        code: "Asia/Tokyo",
        name: "Tokyo, Yokohama, Osaka, Nagoya, Sapporo"
    },
    {
        utc: "+09:00",
        code: "Asia/Yakutsk",
        name: "Yakutsk, Blagoveshchensk, Belogorsk, Neryungri, Svobodnyy"
    },
    {
        utc: "+09:00",
        code: "Pacific/Palau",
        name: "Koror, Koror Town, Kloulklubed, Ulimang, Mengellang"
    },
    {
        utc: "+09:30",
        code: "Australia/Adelaide",
        name: "Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler"
    },
    {
        utc: "+09:30",
        code: "Australia/Broken_Hill",
        name: "Broken Hill"
    },
    {
        utc: "+09:30",
        code: "Australia/Darwin",
        name: "Darwin, Alice Springs, Palmerston, Howard Springs"
    },
    {
        utc: "+10:00",
        code: "Antarctica/DumontDUrville",
        name: "DumontDUrville"
    },
    {
        utc: "+10:00",
        code: "Antarctica/Macquarie",
        name: "Macquarie"
    },
    {
        utc: "+10:00",
        code: "Asia/Ust-Nera",
        name: "Ust-Nera"
    },
    {
        utc: "+10:00",
        code: "Asia/Vladivostok",
        name: "Vladivostok, Khabarovsk, Khabarovsk Vtoroy, Komsomolsk-on-Amur, Ussuriysk"
    },
    {
        utc: "+10:00",
        code: "Australia/Brisbane",
        name: "Brisbane, Gold Coast, Logan City, Townsville, Cairns"
    },
    {
        utc: "+10:00",
        code: "Australia/Currie",
        name: "Currie"
    },
    {
        utc: "+10:00",
        code: "Australia/Hobart",
        name: "Hobart, Launceston, Burnie, Devonport, Sandy Bay"
    },
    {
        utc: "+10:00",
        code: "Australia/Lindeman",
        name: "Lindeman"
    },
    {
        utc: "+10:00",
        code: "Australia/Melbourne",
        name: "Melbourne, Geelong, Bendigo, Ballarat, Melbourne City Centre"
    },
    {
        utc: "+10:00",
        code: "Australia/Sydney",
        name: "Sydney, Canberra, Newcastle, Wollongong, Maitland"
    },
    {
        utc: "+10:00",
        code: "Pacific/Chuuk",
        name: "Weno, Colonia"
    },
    {
        utc: "+10:00",
        code: "Pacific/GuamVillage",
        name: "Dededo Village, Yigo Village, Tamuning, Tamuning-Tumon-Harmon Village, Mangilao Village"
    },
    {
        utc: "+10:00",
        code: "Pacific/Port_Moresby",
        name: "Port Moresby, Lae, Mount Hagen, Popondetta, Madang"
    },
    {
        utc: "+10:00",
        code: "Pacific/Saipan",
        name: "Saipan, San Jose Village"
    },
    {
        utc: "+10:30",
        code: "Australia/Lord_Howe",
        name: "Lord Howe"
    },
    {
        utc: "+11:00",
        code: "Antarctica/Casey",
        name: "Casey"
    },
    {
        utc: "+11:00",
        code: "Asia/Magadan",
        name: "Magadan, Ust-Nera, Susuman, Ola"
    },
    {
        utc: "+11:00",
        code: "Asia/Sakhalin",
        name: "Yuzhno-Sakhalinsk, Korsakov, Kholmsk, Okha, Nevel\u2019sk"
    },
    {
        utc: "+11:00",
        code: "Asia/Srednekolymsk",
        name: "Srednekolymsk"
    },
    {
        utc: "+11:00",
        code: "Pacific/Bougainville",
        name: "Arawa, Buka"
    },
    {
        utc: "+11:00",
        code: "Pacific/Efate",
        name: "Port-Vila, Luganville, Isangel, Sola, Lakatoro"
    },
    {
        utc: "+11:00",
        code: "Pacific/Guadalcanal",
        name: "Honiara, Malango, Auki, Gizo, Buala"
    },
    {
        utc: "+11:00",
        code: "Pacific/Kosrae",
        name: "Tofol"
    },
    {
        utc: "+11:00",
        code: "Pacific/Norfolk",
        name: "Kingston"
    },
    {
        utc: "+11:00",
        code: "Pacific/Noumea",
        name: "Noum\xe9a, Mont-Dore, Dumb\xe9a, Pa\xefta, W\xe9"
    },
    {
        utc: "+11:00",
        code: "Pacific/Pohnpei",
        name: "Kolonia, Kolonia Town, Palikir - National Government Center"
    },
    {
        utc: "+12:00",
        code: "Antarctica/McMurdo",
        name: "McMurdo"
    },
    {
        utc: "+12:00",
        code: "Asia/Anadyr",
        name: "Anadyr, Bilibino"
    },
    {
        utc: "+12:00",
        code: "Asia/Kamchatka",
        name: "Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Klyuchi, Mil\u2019kovo"
    },
    {
        utc: "+12:00",
        code: "Pacific/Auckland",
        name: "Auckland, Wellington, Christchurch, Manukau City, North Shore"
    },
    {
        utc: "+12:00",
        code: "Pacific/Fiji",
        name: "Suva, Lautoka, Nadi, Labasa, Ba"
    },
    {
        utc: "+12:00",
        code: "Pacific/Funafuti",
        name: "Funafuti, Savave Village, Tanrake Village, Toga Village, Asau Village"
    },
    {
        utc: "+12:00",
        code: "Pacific/Kwajalein",
        name: "Ebaye, Jabat"
    },
    {
        utc: "+12:00",
        code: "Pacific/Majuro",
        name: "Majuro, Arno, Jabor, Wotje, Mili"
    },
    {
        utc: "+12:00",
        code: "Pacific/Nauru",
        name: "Yaren, Baiti, Anabar, Uaboe, Ijuw"
    },
    {
        utc: "+12:00",
        code: "Pacific/Tarawa",
        name: "Tarawa, Betio Village, Bikenibeu Village"
    },
    {
        utc: "+12:00",
        code: "Pacific/Wake",
        name: "Wake"
    },
    {
        utc: "+12:00",
        code: "Pacific/Wallis",
        name: "Mata-Utu, Leava, Alo"
    },
    {
        utc: "+12:45",
        code: "Pacific/Chatham",
        name: "Waitangi"
    },
    {
        utc: "+13:00",
        code: "Pacific/Apia",
        name: "Apia, Asau, Mulifanua, Afega, Leulumoega"
    },
    {
        utc: "+13:00",
        code: "Pacific/Enderbury",
        name: "Enderbury"
    },
    {
        utc: "+13:00",
        code: "Pacific/Fakaofo",
        name: "Atafu Village, Nukunonu, Fale old settlement"
    },
    {
        utc: "+13:00",
        code: "Pacific/Tongatapu",
        name: "Nuku\u2018alofa, Lapaha, Neiafu, Pangai, \u2018Ohonua"
    },
    {
        utc: "+14:00",
        code: "Pacific/Kiritimati",
        name: "Kiritimati"
    }
];

});

parcelRegister("bezpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92325f02d24687b2$export$2e2bcd8739ae039; });
function $92325f02d24687b2$export$2e2bcd8739ae039(timeZoneOffset) {
    const sign = timeZoneOffset < 0 ? "-" : "+";
    const hours = Math.floor(Math.abs(timeZoneOffset) / 60).toString().padStart(2, "0");
    const minutes = (Math.abs(timeZoneOffset) % 60).toString().padStart(2, "0");
    return `${sign}${hours}:${minutes}`;
}

});


parcelRegister("d7pE6", function(module, exports) {
$parcel$export(module.exports, "getConnectorSelectedCurrentLimit", function () { return (parcelRequire("hT3PR")).getConnectorSelectedCurrentLimit; });
parcelRequire("hT3PR");

});
parcelRegister("hT3PR", function(module, exports) {

$parcel$export(module.exports, "getConnectorSelectedCurrentLimit", function () { return $298b6f70ac4c300d$export$27498b7291aa92f8; });
parcelRequire("5caji");
var $dPyPm = parcelRequire("dPyPm");
const $298b6f70ac4c300d$export$27498b7291aa92f8 = (configKeys, connectorId)=>{
    const installationMaxCurrent = (0, $dPyPm.getConnectorCurrentLimitFromConfig)(configKeys, (0, $dPyPm.CurrentLimitType).INSTALLATION_CURRENT, connectorId);
    const userMaxCurrent = (0, $dPyPm.getConnectorCurrentLimitFromConfig)(configKeys, (0, $dPyPm.CurrentLimitType).USER_CURRENT_LIMIT, connectorId);
    const maxCurrent = (0, $dPyPm.getConnectorCurrentLimitFromConfig)(configKeys, (0, $dPyPm.CurrentLimitType).MAX_CURRENT, connectorId);
    return Math.min(installationMaxCurrent, userMaxCurrent, maxCurrent);
};

});
parcelRegister("5caji", function(module, exports) {
$parcel$export(module.exports, "CurrentLimitType", function () { return (parcelRequire("dPyPm")).CurrentLimitType; });
$parcel$export(module.exports, "getConnectorCurrentLimitFromConfig", function () { return (parcelRequire("dPyPm")).getConnectorCurrentLimitFromConfig; });
parcelRequire("dPyPm");

});
parcelRegister("dPyPm", function(module, exports) {

$parcel$export(module.exports, "CurrentLimitType", function () { return $e25696e1a3cec21c$export$2be6779452ab463b; });
$parcel$export(module.exports, "getConnectorCurrentLimitFromConfig", function () { return $e25696e1a3cec21c$export$7eff23de5e81ffe2; });

var $hMQzl = parcelRequire("hMQzl");
var $e25696e1a3cec21c$export$2be6779452ab463b;
(function(CurrentLimitType) {
    CurrentLimitType["MAX_CURRENT"] = "MaxCurrent";
    CurrentLimitType["INSTALLATION_CURRENT"] = "InstallationCurrent";
    CurrentLimitType["USER_CURRENT_LIMIT"] = "UserCurrentLimit";
})($e25696e1a3cec21c$export$2be6779452ab463b || ($e25696e1a3cec21c$export$2be6779452ab463b = {}));
const $e25696e1a3cec21c$export$7eff23de5e81ffe2 = (configKeys, currentLimitType, connectorId)=>{
    const currentLimitConfig = configKeys.find((config)=>config.key === currentLimitType);
    if (!currentLimitConfig) return 0, $hMQzl.MAX_SAFE_CURRENT;
    const limits = currentLimitConfig.value.split(",").map((connectorValue)=>connectorValue.split(".")).reduce((limits, [key, strLimit])=>Object.assign(limits, {
            [key]: parseInt(strLimit)
        }), {});
    return limits[connectorId] || limits[0] || (0, $hMQzl.MAX_SAFE_CURRENT);
};

});
parcelRegister("hMQzl", function(module, exports) {

$parcel$export(module.exports, "MIN_SAFE_CURRENT", function () { return $108ce7633da6390f$export$bd74c3ee7f25459d; });
$parcel$export(module.exports, "MAX_SAFE_CURRENT", function () { return $108ce7633da6390f$export$f19b52a46e45ca9c; });
$parcel$export(module.exports, "SCHUKO_CURRENT", function () { return $108ce7633da6390f$export$3a40077a9bc7f4d7; });
$parcel$export(module.exports, "default", function () { return $108ce7633da6390f$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("c6fcw");
var $3ABLj = parcelRequire("3ABLj");
const $108ce7633da6390f$var$DISABLED_VALUE = 0;
const $108ce7633da6390f$export$bd74c3ee7f25459d = 6;
const $108ce7633da6390f$export$f19b52a46e45ca9c = 32;
const $108ce7633da6390f$export$3a40077a9bc7f4d7 = 10;
const $108ce7633da6390f$var$CurrentSelect = ({ value: value, disabled: disabled, minValue: minValue = $108ce7633da6390f$export$bd74c3ee7f25459d, maxValue: maxValue, onChange: onChange, placeholder: placeholder, isSocket: isSocket, error: error, ...props })=>{
    const text = (0, $5u6k9.default)();
    const currentValues = [];
    if (typeof maxValue === "number") for(let i = minValue; i <= maxValue; i++)currentValues.push(i);
    const dropdownOptions = [
        {
            label: isSocket ? text("lblOff") : text("lblDisabledStatus"),
            value: $108ce7633da6390f$var$DISABLED_VALUE
        },
        ...currentValues.map((current)=>({
                label: isSocket ? text("lblSocketChargingOnStatus", {
                    currentLimit: $108ce7633da6390f$export$3a40077a9bc7f4d7
                }) : `${current} ${text("lblAmpereShort")}`,
                value: current
            }))
    ];
    if (value && maxValue && value > maxValue && !isSocket) dropdownOptions.push({
        label: `${value} A`,
        value: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3ABLj.Dropdown), {
        value: value,
        placeholder: placeholder,
        options: dropdownOptions,
        onChange: onChange,
        disabled: disabled,
        error: error,
        // option and value need to set manually, because of the way Dropdown works with "0" value
        optionLabel: "label",
        optionValue: "value",
        id: "current-select",
        ...props
    });
};
var $108ce7633da6390f$export$2e2bcd8739ae039 = $108ce7633da6390f$var$CurrentSelect;

});





parcelRegister("5zuE9", function(module, exports) {
$parcel$export(module.exports, "Scheduler", function () { return (parcelRequire("cFm7A")).Scheduler; });

$parcel$export(module.exports, "formatTimeRange", function () { return (parcelRequire("2kTlz")).formatTimeRange; });
parcelRequire("cFm7A");

var $2kTlz = parcelRequire("2kTlz");

});
parcelRegister("cFm7A", function(module, exports) {

$parcel$export(module.exports, "Scheduler", function () { return $0953ddb50b709f9d$export$d3e54bb8584cda7c; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gtjDQ = parcelRequire("gtjDQ");

var $76MyM = parcelRequire("76MyM");

var $4LGpv = parcelRequire("4LGpv");

var $lFU12 = parcelRequire("lFU12");

var $gavWA = parcelRequire("gavWA");
const $0953ddb50b709f9d$var$SECONDS_IN_A_DAY = 86400;
const $0953ddb50b709f9d$var$daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $0953ddb50b709f9d$export$d3e54bb8584cda7c = ({ maxCurrent: maxCurrent, disabled: disabled = false, isActive: isActive, schedules: schedules, onSchedulesChange: onSchedulesChange, onOpenActions: onOpenActions, actionsLabel: actionsLabel, getWarningMessage: getWarningMessage, getCustomStyle: getCustomStyle, getCustomMessage: getCustomMessage, formatCurrent: formatCurrent })=>{
    const [isDragging, setIsDragging] = (0, $7E7Dk.useState)(false);
    const handleSlotClick = (0, $7E7Dk.useCallback)((e, dayIndex)=>{
        // Ignore the click if it originated not from the time slot
        if (!e.target.classList.contains("time-slot")) return;
        if (isDragging || disabled) {
            e.stopPropagation();
            return;
        }
        const rect = e.currentTarget.getBoundingClientRect();
        const y = e.clientY - rect.top;
        const minutesFromMidnight = y / (0, $gavWA.PIXELS_PER_MINUTE);
        // round minutes from the midnight to the hour
        let from = dayIndex * $0953ddb50b709f9d$var$SECONDS_IN_A_DAY + (minutesFromMidnight - minutesFromMidnight % 60) * 60;
        from = snapToGrid(from);
        const to = from + (0, $gavWA.DEFAULT_DURATION_MINUTES) * 60;
        const newSchedule = {
            id: (0, $gtjDQ.nanoid)(),
            from: from,
            to: to,
            maxCurrent: maxCurrent
        };
        const updatedSchedules = $0953ddb50b709f9d$var$mergeSchedules([
            ...schedules,
            newSchedule
        ]);
        onSchedulesChange(updatedSchedules);
    }, [
        maxCurrent,
        disabled,
        isDragging,
        onSchedulesChange,
        schedules
    ]);
    const handleScheduleUpdate = (0, $7E7Dk.useCallback)((updatedSchedule)=>{
        const updatedSchedules = $0953ddb50b709f9d$var$mergeSchedules(schedules.map((schedule)=>schedule.id === updatedSchedule.id ? updatedSchedule : schedule));
        onSchedulesChange(updatedSchedules);
    }, [
        onSchedulesChange,
        schedules
    ]);
    const onDragStart = (0, $7E7Dk.useCallback)(()=>{
        setIsDragging(true);
    }, []);
    const onDragEnd = (0, $7E7Dk.useCallback)(()=>{
        setIsDragging(false);
    }, []);
    const snapToGrid = (seconds)=>{
        const minutes = seconds / 60;
        const snappedMinutes = Math.round(minutes / (0, $gavWA.SNAP_INCREMENT_MINUTES)) * (0, $gavWA.SNAP_INCREMENT_MINUTES);
        return snappedMinutes * 60 // Convert back to seconds
        ;
    };
    const containerRef = (0, $7E7Dk.useRef)(null);
    const isVisible = (0, $4LGpv.useIsVisible)(containerRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "scheduler",
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("calendar-grid", {
            "is-active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "time-labels"
    }, [
        ...Array(24)
    ].map((_, hour)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            key: hour,
            className: "time-label"
        }, `${hour.toString().padStart(2, "0")}:00`))), isVisible && $0953ddb50b709f9d$var$daysOfWeek.map((day, dayIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            key: day,
            className: "day-column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "day-header"
        }, day), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("time-slots", {
                disabled: disabled
            }),
            onClick: (e)=>handleSlotClick(e, dayIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "time-slots-inner"
        }, [
            ...Array(24)
        ].map((_, hour)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                key: hour,
                className: "time-slot"
            }))), schedules.filter((schedule)=>{
            const scheduleStartDay = Math.floor(schedule.from / $0953ddb50b709f9d$var$SECONDS_IN_A_DAY);
            return scheduleStartDay === dayIndex || schedule.from < (dayIndex + 1) * $0953ddb50b709f9d$var$SECONDS_IN_A_DAY && schedule.to > dayIndex * $0953ddb50b709f9d$var$SECONDS_IN_A_DAY;
        }).map((schedule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lFU12.default), {
                key: `${schedule.id}-${dayIndex}`,
                schedule: schedule,
                onUpdate: handleScheduleUpdate,
                onDragStart: onDragStart,
                onDragEnd: onDragEnd,
                dayIndex: dayIndex,
                schedules: schedules,
                disabled: disabled,
                onOpenActions: (event)=>onOpenActions(event, schedule),
                actionsLabel: actionsLabel,
                warning: getWarningMessage?.(schedule),
                customStyle: getCustomStyle?.(schedule),
                customMessage: getCustomMessage?.(),
                formatCurrent: formatCurrent
            })))))));
};
const $0953ddb50b709f9d$var$mergeSchedules = (scheduleList)=>{
    const sortedSchedules = scheduleList.sort((a, b)=>a.from - b.from);
    const merged = [];
    for (const schedule of sortedSchedules){
        const last = merged[merged.length - 1];
        if (last && last.to >= schedule.from && // Adjacent or overlapping
        last.maxCurrent === schedule.maxCurrent && // Same current
        schedule.from - last.from <= $0953ddb50b709f9d$var$SECONDS_IN_A_DAY // Within 24 hours
        ) {
            const potentialNewTo = Math.max(last.to, schedule.to);
            if (potentialNewTo - last.from <= $0953ddb50b709f9d$var$SECONDS_IN_A_DAY) last.to = potentialNewTo // Merge schedules
            ;
            else // Cannot merge as it exceeds 24 hours
            merged.push({
                ...schedule
            });
        } else merged.push({
            ...schedule
        });
    }
    return merged;
};

});
parcelRegister("4LGpv", function(module, exports) {

$parcel$export(module.exports, "useIsVisible", function () { return $5cfcc7b1ad43adf1$export$6f8d6e7261983be1; });

var $7E7Dk = parcelRequire("7E7Dk");
const $5cfcc7b1ad43adf1$export$6f8d6e7261983be1 = (ref)=>{
    const [isVisible, setIsVisible] = (0, $7E7Dk.useState)(false);
    (0, $7E7Dk.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsVisible(entry.isIntersecting);
        }, {
            threshold: 0.1
        });
        observer.observe(element);
        return ()=>{
            observer.unobserve(element);
            observer.disconnect();
        };
    }, [
        ref
    ]);
    return isVisible;
};

});

parcelRegister("lFU12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44cdc38ba4c88538$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $f4iRw = parcelRequire("f4iRw");

var $cpfnh = parcelRequire("cpfnh");

var $1ot1u = parcelRequire("1ot1u");

var $gavWA = parcelRequire("gavWA");

var $2kTlz = parcelRequire("2kTlz");
const $44cdc38ba4c88538$var$gridSize = (0, $gavWA.PIXELS_PER_MINUTE) * (0, $gavWA.SNAP_INCREMENT_MINUTES // e.g., 0.6667 * 15 = 10 pixels
);
const $44cdc38ba4c88538$var$resizeGrid = [
    1,
    $44cdc38ba4c88538$var$gridSize
];
const $44cdc38ba4c88538$var$dragGrid = [
    1,
    $44cdc38ba4c88538$var$gridSize
];
const $44cdc38ba4c88538$var$ScheduleBlock = /*#__PURE__*/ (0, $7E7Dk.memo)(({ schedule: schedule, onUpdate: onUpdate, onDragStart: onDragStart, onDragEnd: onDragEnd, onOpenActions: onOpenActions, actionsLabel: actionsLabel, dayIndex: dayIndex, schedules: schedules, customMessage: customMessage, disabled: disabled, warning: warning, customStyle: customStyle, formatCurrent: formatCurrent })=>{
    const isDisabled = disabled;
    const segment = $44cdc38ba4c88538$var$splitSchedule(schedule, dayIndex);
    const topPosition = segment ? $44cdc38ba4c88538$var$calculateTopPosition(segment.startTimeInDay) : 0;
    const segmentHeight = segment ? $44cdc38ba4c88538$var$calculateHeight(segment.startTimeInDay, segment.endTimeInDay) : 0;
    const size = (0, $7E7Dk.useMemo)(()=>({
            width: "100%",
            height: segmentHeight
        }), [
        segmentHeight
    ]);
    const position = {
        x: 0,
        y: topPosition
    };
    const enableResizing = (0, $7E7Dk.useMemo)(()=>{
        if (isDisabled) return false;
        return {
            top: true,
            bottom: true
        };
    }, [
        isDisabled
    ]);
    const handleDragStop = (0, $7E7Dk.useCallback)((_event, d)=>{
        const deltaY = d.y - topPosition;
        const deltaMinutes = deltaY / (0, $gavWA.PIXELS_PER_MINUTE);
        const deltaSeconds = deltaMinutes * 60;
        let newFrom = schedule.from + deltaSeconds;
        let newTo = schedule.to + deltaSeconds;
        // Snap to grid
        newFrom = $44cdc38ba4c88538$var$snapToGrid(newFrom);
        newTo = $44cdc38ba4c88538$var$snapToGrid(newTo);
        // Enforce minimum start time
        if (newFrom < 0) {
            const duration = newTo - newFrom;
            newFrom = 0;
            newTo = newFrom + duration;
        }
        // Enforce maximum duration
        const duration = newTo - newFrom;
        if (duration > (0, $gavWA.MAX_DURATION_SECONDS)) // Adjust newTo to enforce maximum duration
        newTo = newFrom + (0, $gavWA.MAX_DURATION_SECONDS);
        // Handle overlaps
        if ($44cdc38ba4c88538$var$isOverlapping(newFrom, newTo, schedule.id, schedules)) {
            // Revert to original times if overlapping
            newFrom = schedule.from;
            newTo = schedule.to;
        }
        onUpdate({
            ...schedule,
            from: newFrom,
            to: newTo
        });
        onDragEnd();
    }, [
        onDragEnd,
        onUpdate,
        schedule,
        schedules,
        topPosition
    ]);
    const handleResizeStop = (0, $7E7Dk.useCallback)((_event, direction, ref, _delta, position)=>{
        let newFrom = schedule.from;
        let newTo = schedule.to;
        if (direction === "top") {
            const deltaY = position.y - topPosition;
            const deltaMinutes = deltaY / (0, $gavWA.PIXELS_PER_MINUTE);
            const deltaSeconds = deltaMinutes * 60;
            newFrom = schedule.from + deltaSeconds;
        } else if (direction === "bottom") {
            const deltaHeight = ref.offsetHeight - segmentHeight;
            const deltaMinutes = deltaHeight / (0, $gavWA.PIXELS_PER_MINUTE);
            const deltaSeconds = deltaMinutes * 60;
            newTo = schedule.to + deltaSeconds;
        }
        // Snap to grid
        newFrom = $44cdc38ba4c88538$var$snapToGrid(newFrom);
        newTo = $44cdc38ba4c88538$var$snapToGrid(newTo);
        // Enforce minimum duration
        const minDurationSeconds = (0, $gavWA.MIN_DURATION_MINUTES) * 60;
        if (newTo - newFrom < minDurationSeconds) {
            if (direction === "top") newFrom = newTo - minDurationSeconds;
            else newTo = newFrom + minDurationSeconds;
        }
        // Enforce maximum duration
        const duration = newTo - newFrom;
        if (duration > (0, $gavWA.MAX_DURATION_SECONDS)) {
            if (direction === "top") newFrom = newTo - (0, $gavWA.MAX_DURATION_SECONDS);
            else if (direction === "bottom") newTo = newFrom + (0, $gavWA.MAX_DURATION_SECONDS);
        }
        // Enforce minimum start time
        if (newFrom < 0) newFrom = 0;
        // Handle overlaps
        if ($44cdc38ba4c88538$var$isOverlapping(newFrom, newTo, schedule.id, schedules)) {
            // Revert to original times if overlapping
            newFrom = schedule.from;
            newTo = schedule.to;
        }
        onUpdate({
            ...schedule,
            from: newFrom,
            to: newTo
        });
        onDragEnd();
    }, [
        onDragEnd,
        onUpdate,
        schedule,
        schedules,
        segmentHeight,
        topPosition
    ]);
    const handleDragStart = (0, $7E7Dk.useCallback)(()=>{
        onDragStart();
    }, [
        onDragStart
    ]);
    const handleResizeStart = (0, $7E7Dk.useCallback)(()=>{
        onDragStart();
    }, [
        onDragStart
    ]);
    if (!segment) return null;
    const timeRange = (0, $2kTlz.formatTimeRange)(schedule.from, schedule.to);
    const resizeHandles = isDisabled ? {} : {
        top: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "custom-resize-handle custom-resize-handle-top react-resizable-handle",
            "data-direction": "top"
        }),
        bottom: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "custom-resize-handle custom-resize-handle-bottom react-resizable-handle",
            "data-direction": "bottom"
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f4iRw.Rnd), {
        className: "schedule-segment",
        size: size,
        position: position,
        onResizeStart: handleResizeStart,
        onResizeStop: handleResizeStop,
        onDragStart: handleDragStart,
        onDragStop: handleDragStop,
        bounds: "parent",
        enableResizing: enableResizing,
        disableDragging: isDisabled,
        dragAxis: "y",
        resizeGrid: $44cdc38ba4c88538$var$resizeGrid,
        dragGrid: $44cdc38ba4c88538$var$dragGrid,
        enableUserSelectHack: false,
        resizeHandleComponent: resizeHandles,
        cancel: ".react-resizable-handle, .schedule-actions-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "schedule-block"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "schedule-content",
        style: customStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2 align-items-center justify-content-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, timeRange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-1"
    }, warning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cpfnh.Tooltip), {
        target: ".schedule-tooltip-target"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        style: {
            color: "var(--text-color-info)"
        },
        className: "schedule-tooltip-target pi pi-info-circle cursor-pointer",
        "data-pr-tooltip": warning,
        "data-pr-position": "top"
    })) : null, !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        icon: "pi pi-ellipsis-v",
        text: true,
        rounded: true,
        size: "small",
        className: "schedule-actions-button w-1rem h-1rem p-0 flex-shrink-0",
        "aria-label": actionsLabel,
        "aria-haspopup": "menu",
        onClick: (event)=>{
            event.stopPropagation();
            onOpenActions(event);
        }
    }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm text-left mb-1"
    }, typeof formatCurrent === "function" ? formatCurrent(schedule.maxCurrent) : `${schedule.maxCurrent}A`), customMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-xs text-left text-color-secondary"
    }, customMessage)))));
});
var $44cdc38ba4c88538$export$2e2bcd8739ae039 = $44cdc38ba4c88538$var$ScheduleBlock;
const $44cdc38ba4c88538$var$splitSchedule = (schedule, dayIndex)=>{
    const dayStart = dayIndex * (0, $gavWA.SECONDS_IN_A_DAY);
    const dayEnd = (dayIndex + 1) * (0, $gavWA.SECONDS_IN_A_DAY);
    const scheduleStart = Math.max(schedule.from, dayStart);
    const scheduleEnd = Math.min(schedule.to, dayEnd);
    if (scheduleStart >= scheduleEnd) return null // Schedule does not overlap with this day
    ;
    return {
        dayIndex: dayIndex,
        startTimeInDay: scheduleStart - dayStart,
        endTimeInDay: scheduleEnd - dayStart
    };
};
const $44cdc38ba4c88538$var$calculateTopPosition = (startTimeInDay)=>{
    const minutesFromMidnight = startTimeInDay / 60;
    return minutesFromMidnight * (0, $gavWA.PIXELS_PER_MINUTE);
};
const $44cdc38ba4c88538$var$calculateHeight = (startTimeInDay, endTimeInDay)=>{
    let durationInMinutes = (endTimeInDay - startTimeInDay) / 60;
    if (durationInMinutes <= 0) durationInMinutes += (0, $gavWA.MINUTES_IN_A_DAY // Add 24 hours in minutes
    );
    return durationInMinutes * (0, $gavWA.PIXELS_PER_MINUTE);
};
const $44cdc38ba4c88538$var$snapToGrid = (seconds)=>{
    const minutes = seconds / 60;
    const snappedMinutes = Math.round(minutes / (0, $gavWA.SNAP_INCREMENT_MINUTES)) * (0, $gavWA.SNAP_INCREMENT_MINUTES);
    return snappedMinutes * 60 // Convert back to seconds
    ;
};
const $44cdc38ba4c88538$var$isOverlapping = (newFrom, newTo, scheduleId, schedules)=>{
    return schedules.some((s)=>s.id !== scheduleId && Math.max(s.from, newFrom) < Math.min(s.to, newTo));
};

});
parcelRegister("f4iRw", function(module, exports) {

$parcel$export(module.exports, "Rnd", function () { return $af85dc6427bb0673$export$1568a3397381fb0e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $3cUmk = parcelRequire("3cUmk");

var $gJbmc = parcelRequire("gJbmc");

var $hzbSh = parcelRequire("hzbSh");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $af85dc6427bb0673$var$extendStatics = function(d, b) {
    $af85dc6427bb0673$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $af85dc6427bb0673$var$extendStatics(d, b);
};
function $af85dc6427bb0673$var$__extends(d, b) {
    $af85dc6427bb0673$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $af85dc6427bb0673$var$__assign = function() {
    $af85dc6427bb0673$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af85dc6427bb0673$var$__assign.apply(this, arguments);
};
function $af85dc6427bb0673$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $af85dc6427bb0673$var$resizableStyle = {
    width: "auto",
    height: "auto",
    display: "inline-block",
    position: "absolute",
    top: 0,
    left: 0
};
var $af85dc6427bb0673$var$getEnableResizingByFlag = function(flag) {
    return {
        bottom: flag,
        bottomLeft: flag,
        bottomRight: flag,
        left: flag,
        right: flag,
        top: flag,
        topLeft: flag,
        topRight: flag
    };
};
var $af85dc6427bb0673$export$1568a3397381fb0e = /** @class */ function(_super) {
    $af85dc6427bb0673$var$__extends(Rnd, _super);
    function Rnd(props) {
        var _this = _super.call(this, props) || this;
        _this.resizingPosition = {
            x: 0,
            y: 0
        };
        _this.offsetFromParent = {
            left: 0,
            top: 0
        };
        _this.resizableElement = {
            current: null
        };
        _this.originalPosition = {
            x: 0,
            y: 0
        };
        _this.state = {
            resizing: false,
            bounds: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            maxWidth: props.maxWidth,
            maxHeight: props.maxHeight
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.onResizeStop = _this.onResizeStop.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrag = _this.onDrag.bind(_this);
        _this.onDragStop = _this.onDragStop.bind(_this);
        _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
        return _this;
    }
    Rnd.prototype.componentDidMount = function() {
        this.updateOffsetFromParent();
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        var _b = this.getDraggablePosition(), x = _b.x, y = _b.y;
        this.draggable.setState({
            x: x - left,
            y: y - top
        });
        // HACK: Apply position adjustment
        this.forceUpdate();
    };
    // HACK: To get `react-draggable` state x and y.
    Rnd.prototype.getDraggablePosition = function() {
        var _a = this.draggable.state, x = _a.x, y = _a.y;
        return {
            x: x,
            y: y
        };
    };
    Rnd.prototype.getParent = function() {
        return this.resizable && this.resizable.parentNode;
    };
    Rnd.prototype.getParentSize = function() {
        return this.resizable.getParentSize();
    };
    Rnd.prototype.getMaxSizesFromProps = function() {
        var maxWidth = typeof this.props.maxWidth === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
        var maxHeight = typeof this.props.maxHeight === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Rnd.prototype.getSelfElement = function() {
        return this.resizable && this.resizable.resizable;
    };
    Rnd.prototype.getOffsetHeight = function(boundary) {
        var scale = this.props.scale;
        switch(this.props.bounds){
            case "window":
                return window.innerHeight / scale;
            case "body":
                return document.body.offsetHeight / scale;
            default:
                return boundary.offsetHeight;
        }
    };
    Rnd.prototype.getOffsetWidth = function(boundary) {
        var scale = this.props.scale;
        switch(this.props.bounds){
            case "window":
                return window.innerWidth / scale;
            case "body":
                return document.body.offsetWidth / scale;
            default:
                return boundary.offsetWidth;
        }
    };
    Rnd.prototype.onDragStart = function(e, data) {
        if (this.props.onDragStart) this.props.onDragStart(e, data);
        var pos = this.getDraggablePosition();
        this.originalPosition = pos;
        if (!this.props.bounds) return;
        var parent = this.getParent();
        var scale = this.props.scale;
        var boundary;
        if (this.props.bounds === "parent") boundary = parent;
        else if (this.props.bounds === "body") {
            var parentRect_1 = parent.getBoundingClientRect();
            var parentLeft_1 = parentRect_1.left;
            var parentTop_1 = parentRect_1.top;
            var bodyRect = document.body.getBoundingClientRect();
            var left_1 = -(parentLeft_1 - parent.offsetLeft * scale - bodyRect.left) / scale;
            var top_1 = -(parentTop_1 - parent.offsetTop * scale - bodyRect.top) / scale;
            var right = (document.body.offsetWidth - this.resizable.size.width * scale) / scale + left_1;
            var bottom = (document.body.offsetHeight - this.resizable.size.height * scale) / scale + top_1;
            return this.setState({
                bounds: {
                    top: top_1,
                    right: right,
                    bottom: bottom,
                    left: left_1
                }
            });
        } else if (this.props.bounds === "window") {
            if (!this.resizable) return;
            var parentRect_2 = parent.getBoundingClientRect();
            var parentLeft_2 = parentRect_2.left;
            var parentTop_2 = parentRect_2.top;
            var left_2 = -(parentLeft_2 - parent.offsetLeft * scale) / scale;
            var top_2 = -(parentTop_2 - parent.offsetTop * scale) / scale;
            var right = (window.innerWidth - this.resizable.size.width * scale) / scale + left_2;
            var bottom = (window.innerHeight - this.resizable.size.height * scale) / scale + top_2;
            return this.setState({
                bounds: {
                    top: top_2,
                    right: right,
                    bottom: bottom,
                    left: left_2
                }
            });
        } else if (typeof this.props.bounds === "string") boundary = document.querySelector(this.props.bounds);
        else if (this.props.bounds instanceof HTMLElement) boundary = this.props.bounds;
        if (!(boundary instanceof HTMLElement) || !(parent instanceof HTMLElement)) return;
        var boundaryRect = boundary.getBoundingClientRect();
        var boundaryLeft = boundaryRect.left;
        var boundaryTop = boundaryRect.top;
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var left = (boundaryLeft - parentLeft) / scale;
        var top = boundaryTop - parentTop;
        if (!this.resizable) return;
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        this.setState({
            bounds: {
                top: top - offset.top,
                right: left + (boundary.offsetWidth - this.resizable.size.width) - offset.left / scale,
                bottom: top + (boundary.offsetHeight - this.resizable.size.height) - offset.top,
                left: left - offset.left / scale
            }
        });
    };
    Rnd.prototype.onDrag = function(e, data) {
        if (!this.props.onDrag) return;
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both") return this.props.onDrag(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: data.x + left,
            y: data.y + top
        }));
        else if (this.props.dragAxis === "x") return this.props.onDrag(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: data.x + left,
            y: this.originalPosition.y + top,
            deltaY: 0
        }));
        else if (this.props.dragAxis === "y") return this.props.onDrag(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: this.originalPosition.x + left,
            y: data.y + top,
            deltaX: 0
        }));
    };
    Rnd.prototype.onDragStop = function(e, data) {
        if (!this.props.onDragStop) return;
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both") return this.props.onDragStop(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: data.x + left,
            y: data.y + top
        }));
        else if (this.props.dragAxis === "x") return this.props.onDragStop(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: data.x + left,
            y: this.originalPosition.y + top,
            deltaY: 0
        }));
        else if (this.props.dragAxis === "y") return this.props.onDragStop(e, $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, data), {
            x: this.originalPosition.x + left,
            y: data.y + top,
            deltaX: 0
        }));
    };
    Rnd.prototype.onResizeStart = function(e, dir, elementRef) {
        e.stopPropagation();
        this.setState({
            resizing: true
        });
        var scale = this.props.scale;
        var offset = this.offsetFromParent;
        var pos = this.getDraggablePosition();
        this.resizingPosition = {
            x: pos.x + offset.left,
            y: pos.y + offset.top
        };
        this.originalPosition = pos;
        if (this.props.bounds) {
            var parent_1 = this.getParent();
            var boundary = void 0;
            if (this.props.bounds === "parent") boundary = parent_1;
            else if (this.props.bounds === "body") boundary = document.body;
            else if (this.props.bounds === "window") boundary = window;
            else if (typeof this.props.bounds === "string") boundary = document.querySelector(this.props.bounds);
            else if (this.props.bounds instanceof HTMLElement) boundary = this.props.bounds;
            var self_1 = this.getSelfElement();
            if (self_1 instanceof Element && (boundary instanceof HTMLElement || boundary === window) && parent_1 instanceof HTMLElement) {
                var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
                var parentSize = this.getParentSize();
                if (maxWidth && typeof maxWidth === "string") {
                    if (maxWidth.endsWith("%")) {
                        var ratio = Number(maxWidth.replace("%", "")) / 100;
                        maxWidth = parentSize.width * ratio;
                    } else if (maxWidth.endsWith("px")) maxWidth = Number(maxWidth.replace("px", ""));
                }
                if (maxHeight && typeof maxHeight === "string") {
                    if (maxHeight.endsWith("%")) {
                        var ratio = Number(maxHeight.replace("%", "")) / 100;
                        maxHeight = parentSize.height * ratio;
                    } else if (maxHeight.endsWith("px")) maxHeight = Number(maxHeight.replace("px", ""));
                }
                var selfRect = self_1.getBoundingClientRect();
                var selfLeft = selfRect.left;
                var selfTop = selfRect.top;
                var boundaryRect = this.props.bounds === "window" ? {
                    left: 0,
                    top: 0
                } : boundary.getBoundingClientRect();
                var boundaryLeft = boundaryRect.left;
                var boundaryTop = boundaryRect.top;
                var offsetWidth = this.getOffsetWidth(boundary);
                var offsetHeight = this.getOffsetHeight(boundary);
                var hasLeft = dir.toLowerCase().endsWith("left");
                var hasRight = dir.toLowerCase().endsWith("right");
                var hasTop = dir.startsWith("top");
                var hasBottom = dir.startsWith("bottom");
                if ((hasLeft || hasTop) && this.resizable) {
                    var max = (selfLeft - boundaryLeft) / scale + this.resizable.size.width;
                    this.setState({
                        maxWidth: max > Number(maxWidth) ? maxWidth : max
                    });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasRight || this.props.lockAspectRatio && !hasLeft && !hasTop) {
                    var max = offsetWidth + (boundaryLeft - selfLeft) / scale;
                    this.setState({
                        maxWidth: max > Number(maxWidth) ? maxWidth : max
                    });
                }
                if ((hasTop || hasLeft) && this.resizable) {
                    var max = (selfTop - boundaryTop) / scale + this.resizable.size.height;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max
                    });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasBottom || this.props.lockAspectRatio && !hasTop && !hasLeft) {
                    var max = offsetHeight + (boundaryTop - selfTop) / scale;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max
                    });
                }
            }
        } else this.setState({
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight
        });
        if (this.props.onResizeStart) this.props.onResizeStart(e, dir, elementRef);
    };
    Rnd.prototype.onResize = function(e, direction, elementRef, delta) {
        var _this = this;
        // INFO: Apply x and y position adjustments caused by resizing to draggable
        var newPos = {
            x: this.originalPosition.x,
            y: this.originalPosition.y
        };
        var left = -delta.width;
        var top = -delta.height;
        var directions = [
            "top",
            "left",
            "topLeft",
            "bottomLeft",
            "topRight"
        ];
        if (directions.includes(direction)) {
            if (direction === "bottomLeft") newPos.x += left;
            else if (direction === "topRight") newPos.y += top;
            else {
                newPos.x += left;
                newPos.y += top;
            }
        }
        var draggableState = this.draggable.state;
        if (newPos.x !== draggableState.x || newPos.y !== draggableState.y) (0, $hzbSh.flushSync)(function() {
            _this.draggable.setState(newPos);
        });
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        var x = this.getDraggablePosition().x + offset.left;
        var y = this.getDraggablePosition().y + offset.top;
        this.resizingPosition = {
            x: x,
            y: y
        };
        if (!this.props.onResize) return;
        this.props.onResize(e, direction, elementRef, delta, {
            x: x,
            y: y
        });
    };
    Rnd.prototype.onResizeStop = function(e, direction, elementRef, delta) {
        this.setState({
            resizing: false
        });
        var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
        this.setState({
            maxWidth: maxWidth,
            maxHeight: maxHeight
        });
        if (this.props.onResizeStop) this.props.onResizeStop(e, direction, elementRef, delta, this.resizingPosition);
    };
    Rnd.prototype.updateSize = function(size) {
        if (!this.resizable) return;
        this.resizable.updateSize({
            width: size.width,
            height: size.height
        });
    };
    Rnd.prototype.updatePosition = function(position) {
        this.draggable.setState(position);
    };
    Rnd.prototype.updateOffsetFromParent = function() {
        var scale = this.props.scale;
        var parent = this.getParent();
        var self = this.getSelfElement();
        if (!parent || self === null) return {
            top: 0,
            left: 0
        };
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var selfRect = self.getBoundingClientRect();
        var position = this.getDraggablePosition();
        var scrollLeft = parent.scrollLeft;
        var scrollTop = parent.scrollTop;
        this.offsetFromParent = {
            left: selfRect.left - parentLeft + scrollLeft - position.x * scale,
            top: selfRect.top - parentTop + scrollTop - position.y * scale
        };
    };
    Rnd.prototype.render = function() {
        var _this = this;
        var _a = this.props, disableDragging = _a.disableDragging, style = _a.style, dragHandleClassName = _a.dragHandleClassName, position = _a.position, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, dragAxis = _a.dragAxis, dragGrid = _a.dragGrid, bounds = _a.bounds, enableUserSelectHack = _a.enableUserSelectHack, cancel = _a.cancel, children = _a.children, onResizeStart = _a.onResizeStart, onResize = _a.onResize, onResizeStop = _a.onResizeStop, onDragStart = _a.onDragStart, onDrag = _a.onDrag, onDragStop = _a.onDragStop, resizeHandleStyles = _a.resizeHandleStyles, resizeHandleClasses = _a.resizeHandleClasses, resizeHandleComponent = _a.resizeHandleComponent, enableResizing = _a.enableResizing, resizeGrid = _a.resizeGrid, resizeHandleWrapperClass = _a.resizeHandleWrapperClass, resizeHandleWrapperStyle = _a.resizeHandleWrapperStyle, scale = _a.scale, allowAnyClick = _a.allowAnyClick, resizableProps = $af85dc6427bb0673$var$__rest(_a, [
            "disableDragging",
            "style",
            "dragHandleClassName",
            "position",
            "onMouseDown",
            "onMouseUp",
            "dragAxis",
            "dragGrid",
            "bounds",
            "enableUserSelectHack",
            "cancel",
            "children",
            "onResizeStart",
            "onResize",
            "onResizeStop",
            "onDragStart",
            "onDrag",
            "onDragStop",
            "resizeHandleStyles",
            "resizeHandleClasses",
            "resizeHandleComponent",
            "enableResizing",
            "resizeGrid",
            "resizeHandleWrapperClass",
            "resizeHandleWrapperStyle",
            "scale",
            "allowAnyClick"
        ]);
        var defaultValue = this.props.default ? $af85dc6427bb0673$var$__assign({}, this.props.default) : undefined;
        // Remove unknown props, see also https://reactjs.org/warnings/unknown-prop.html
        delete resizableProps.default;
        var cursorStyle = disableDragging || dragHandleClassName ? {
            cursor: "auto"
        } : {
            cursor: "move"
        };
        var innerStyle = $af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign($af85dc6427bb0673$var$__assign({}, $af85dc6427bb0673$var$resizableStyle), cursorStyle), style);
        var _b = this.offsetFromParent, left = _b.left, top = _b.top;
        var draggablePosition;
        if (position) draggablePosition = {
            x: position.x - left,
            y: position.y - top
        };
        // INFO: Make uncontorolled component when resizing to control position by setPostion.
        var pos = this.state.resizing ? undefined : draggablePosition;
        var dragAxisOrUndefined = this.state.resizing ? "both" : dragAxis;
        return (0, $7E7Dk.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($3cUmk))), {
            ref: function(c) {
                if (!c) return;
                _this.draggable = c;
            },
            handle: dragHandleClassName ? ".".concat(dragHandleClassName) : undefined,
            defaultPosition: defaultValue,
            onMouseDown: onMouseDown,
            // @ts-expect-error
            onMouseUp: onMouseUp,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            axis: dragAxisOrUndefined,
            disabled: disableDragging,
            grid: dragGrid,
            bounds: bounds ? this.state.bounds : undefined,
            position: pos,
            enableUserSelectHack: enableUserSelectHack,
            cancel: cancel,
            scale: scale,
            allowAnyClick: allowAnyClick,
            nodeRef: this.resizableElement
        }, (0, $7E7Dk.createElement)((0, $gJbmc.Resizable), $af85dc6427bb0673$var$__assign({}, resizableProps, {
            ref: function(c) {
                if (!c) return;
                _this.resizable = c;
                _this.resizableElement.current = c.resizable;
            },
            defaultSize: defaultValue,
            size: this.props.size,
            enable: typeof enableResizing === "boolean" ? $af85dc6427bb0673$var$getEnableResizingByFlag(enableResizing) : enableResizing,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            style: innerStyle,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth,
            maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight,
            grid: resizeGrid,
            handleWrapperClass: resizeHandleWrapperClass,
            handleWrapperStyle: resizeHandleWrapperStyle,
            lockAspectRatio: this.props.lockAspectRatio,
            lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth,
            lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight,
            handleStyles: resizeHandleStyles,
            handleClasses: resizeHandleClasses,
            handleComponent: resizeHandleComponent,
            scale: this.props.scale
        }), children));
    };
    Rnd.defaultProps = {
        maxWidth: Number.MAX_SAFE_INTEGER,
        maxHeight: Number.MAX_SAFE_INTEGER,
        scale: 1,
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        onDragStart: function() {},
        onDrag: function() {},
        onDragStop: function() {}
    };
    return Rnd;
}((0, $7E7Dk.PureComponent));

});
parcelRegister("3cUmk", function(module, exports) {
"use strict";

var $kt0Sl = parcelRequire("kt0Sl");
var $255e35d0720c09a7$require$Draggable = $kt0Sl.default;
var $255e35d0720c09a7$require$DraggableCore = $kt0Sl.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $255e35d0720c09a7$require$Draggable;
module.exports.default = $255e35d0720c09a7$require$Draggable;
module.exports.DraggableCore = $255e35d0720c09a7$require$DraggableCore;

});
parcelRegister("kt0Sl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $ee6731eeb2abd58e$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $ee6731eeb2abd58e$var$React = $ee6731eeb2abd58e$var$_interopRequireWildcard((parcelRequire("7E7Dk")));

var $ee6731eeb2abd58e$var$_propTypes = $ee6731eeb2abd58e$var$_interopRequireDefault((parcelRequire("jMvuK")));

var $ee6731eeb2abd58e$var$_reactDom = $ee6731eeb2abd58e$var$_interopRequireDefault((parcelRequire("hzbSh")));

var $ee6731eeb2abd58e$var$_clsx = $ee6731eeb2abd58e$var$_interopRequireDefault((parcelRequire("5QtR9")));

var $asyUn = parcelRequire("asyUn");

var $d8Yny = parcelRequire("d8Yny");

var $F7YrN = parcelRequire("F7YrN");

var $ee6731eeb2abd58e$var$_DraggableCore = $ee6731eeb2abd58e$var$_interopRequireDefault((parcelRequire("hydce")));

var $ee6731eeb2abd58e$var$_log = $ee6731eeb2abd58e$var$_interopRequireDefault((parcelRequire("2N40L")));
function $ee6731eeb2abd58e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee6731eeb2abd58e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ee6731eeb2abd58e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ee6731eeb2abd58e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ee6731eeb2abd58e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ee6731eeb2abd58e$var$_extends() {
    $ee6731eeb2abd58e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee6731eeb2abd58e$var$_extends.apply(this, arguments);
}
function $ee6731eeb2abd58e$var$_defineProperty(obj, key, value) {
    key = $ee6731eeb2abd58e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ee6731eeb2abd58e$var$_toPropertyKey(arg) {
    var key = $ee6731eeb2abd58e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ee6731eeb2abd58e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $ee6731eeb2abd58e$var$Draggable extends $ee6731eeb2abd58e$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $ee6731eeb2abd58e$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $ee6731eeb2abd58e$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $ee6731eeb2abd58e$var$_log.default)("Draggable: onDragStart: %j", coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $d8Yny.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $ee6731eeb2abd58e$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $ee6731eeb2abd58e$var$_log.default)("Draggable: onDrag: %j", coreData);
            const uiData = (0, $d8Yny.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $d8Yny.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $ee6731eeb2abd58e$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $d8Yny.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $ee6731eeb2abd58e$var$_log.default)("Draggable: onDragStop: %j", coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $ee6731eeb2abd58e$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $d8Yny.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $d8Yny.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $asyUn.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $asyUn.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $ee6731eeb2abd58e$var$_clsx.default)(children.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $ee6731eeb2abd58e$var$React.createElement($ee6731eeb2abd58e$var$_DraggableCore.default, $ee6731eeb2abd58e$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $ee6731eeb2abd58e$var$React.cloneElement($ee6731eeb2abd58e$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
module.exports.default = $ee6731eeb2abd58e$var$Draggable;
$ee6731eeb2abd58e$var$_defineProperty($ee6731eeb2abd58e$var$Draggable, "displayName", "Draggable");
$ee6731eeb2abd58e$var$_defineProperty($ee6731eeb2abd58e$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$ee6731eeb2abd58e$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $ee6731eeb2abd58e$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $ee6731eeb2abd58e$var$_propTypes.default.oneOfType([
        $ee6731eeb2abd58e$var$_propTypes.default.shape({
            left: $ee6731eeb2abd58e$var$_propTypes.default.number,
            right: $ee6731eeb2abd58e$var$_propTypes.default.number,
            top: $ee6731eeb2abd58e$var$_propTypes.default.number,
            bottom: $ee6731eeb2abd58e$var$_propTypes.default.number
        }),
        $ee6731eeb2abd58e$var$_propTypes.default.string,
        $ee6731eeb2abd58e$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $ee6731eeb2abd58e$var$_propTypes.default.string,
    defaultClassNameDragging: $ee6731eeb2abd58e$var$_propTypes.default.string,
    defaultClassNameDragged: $ee6731eeb2abd58e$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $ee6731eeb2abd58e$var$_propTypes.default.shape({
        x: $ee6731eeb2abd58e$var$_propTypes.default.number,
        y: $ee6731eeb2abd58e$var$_propTypes.default.number
    }),
    positionOffset: $ee6731eeb2abd58e$var$_propTypes.default.shape({
        x: $ee6731eeb2abd58e$var$_propTypes.default.oneOfType([
            $ee6731eeb2abd58e$var$_propTypes.default.number,
            $ee6731eeb2abd58e$var$_propTypes.default.string
        ]),
        y: $ee6731eeb2abd58e$var$_propTypes.default.oneOfType([
            $ee6731eeb2abd58e$var$_propTypes.default.number,
            $ee6731eeb2abd58e$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $ee6731eeb2abd58e$var$_propTypes.default.shape({
        x: $ee6731eeb2abd58e$var$_propTypes.default.number,
        y: $ee6731eeb2abd58e$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $F7YrN.dontSetMe,
    style: $F7YrN.dontSetMe,
    transform: $F7YrN.dontSetMe
});
$ee6731eeb2abd58e$var$_defineProperty($ee6731eeb2abd58e$var$Draggable, "defaultProps", {
    ...$ee6731eeb2abd58e$var$_DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("5QtR9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $4418f7e80f0e1613$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $4418f7e80f0e1613$export$2e2bcd8739ae039; });
function $4418f7e80f0e1613$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $4418f7e80f0e1613$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $4418f7e80f0e1613$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $4418f7e80f0e1613$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4418f7e80f0e1613$export$2e2bcd8739ae039 = $4418f7e80f0e1613$export$4f5d2d50c9deca37;

});

parcelRegister("asyUn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $79d798f8445a2942$var$addClassName;
module.exports.addEvent = $79d798f8445a2942$var$addEvent;
module.exports.addUserSelectStyles = $79d798f8445a2942$var$addUserSelectStyles;
module.exports.createCSSTransform = $79d798f8445a2942$var$createCSSTransform;
module.exports.createSVGTransform = $79d798f8445a2942$var$createSVGTransform;
module.exports.getTouch = $79d798f8445a2942$var$getTouch;
module.exports.getTouchIdentifier = $79d798f8445a2942$var$getTouchIdentifier;
module.exports.getTranslation = $79d798f8445a2942$var$getTranslation;
module.exports.innerHeight = $79d798f8445a2942$var$innerHeight;
module.exports.innerWidth = $79d798f8445a2942$var$innerWidth;
module.exports.matchesSelector = $79d798f8445a2942$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $79d798f8445a2942$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $79d798f8445a2942$var$offsetXYFromParent;
module.exports.outerHeight = $79d798f8445a2942$var$outerHeight;
module.exports.outerWidth = $79d798f8445a2942$var$outerWidth;
module.exports.removeClassName = $79d798f8445a2942$var$removeClassName;
module.exports.removeEvent = $79d798f8445a2942$var$removeEvent;
module.exports.removeUserSelectStyles = $79d798f8445a2942$var$removeUserSelectStyles;

var $F7YrN = parcelRequire("F7YrN");

var $79d798f8445a2942$var$_getPrefix = $79d798f8445a2942$var$_interopRequireWildcard((parcelRequire("d5uul")));
function $79d798f8445a2942$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($79d798f8445a2942$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $79d798f8445a2942$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $79d798f8445a2942$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $79d798f8445a2942$var$matchesSelectorFunc = "";
function $79d798f8445a2942$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$79d798f8445a2942$var$matchesSelectorFunc) $79d798f8445a2942$var$matchesSelectorFunc = (0, $F7YrN.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $F7YrN.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $F7YrN.isFunction)(el[$79d798f8445a2942$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$79d798f8445a2942$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $79d798f8445a2942$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($79d798f8445a2942$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $79d798f8445a2942$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $79d798f8445a2942$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $79d798f8445a2942$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $F7YrN.int)(computedStyle.borderTopWidth);
    height += (0, $F7YrN.int)(computedStyle.borderBottomWidth);
    return height;
}
function $79d798f8445a2942$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $F7YrN.int)(computedStyle.borderLeftWidth);
    width += (0, $F7YrN.int)(computedStyle.borderRightWidth);
    return width;
}
function $79d798f8445a2942$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $F7YrN.int)(computedStyle.paddingTop);
    height -= (0, $F7YrN.int)(computedStyle.paddingBottom);
    return height;
}
function $79d798f8445a2942$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $F7YrN.int)(computedStyle.paddingLeft);
    width -= (0, $F7YrN.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $79d798f8445a2942$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $79d798f8445a2942$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $79d798f8445a2942$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [(0, $79d798f8445a2942$var$_getPrefix.browserPrefixToKey)("transform", $79d798f8445a2942$var$_getPrefix.default)]: translation
    };
}
function $79d798f8445a2942$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $79d798f8445a2942$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $79d798f8445a2942$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $79d798f8445a2942$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $F7YrN.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $F7YrN.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $79d798f8445a2942$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $79d798f8445a2942$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $79d798f8445a2942$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $79d798f8445a2942$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $79d798f8445a2942$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $79d798f8445a2942$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $79d798f8445a2942$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("F7YrN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $07ba03e968a14b93$var$dontSetMe;
module.exports.findInArray = $07ba03e968a14b93$var$findInArray;
module.exports.int = $07ba03e968a14b93$var$int;
module.exports.isFunction = $07ba03e968a14b93$var$isFunction;
module.exports.isNum = $07ba03e968a14b93$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $07ba03e968a14b93$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $07ba03e968a14b93$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $07ba03e968a14b93$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $07ba03e968a14b93$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $07ba03e968a14b93$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("d5uul", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $987364579193c928$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $987364579193c928$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $987364579193c928$var$getPrefix;
const $987364579193c928$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $987364579193c928$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return "";
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $987364579193c928$var$prefixes.length; i++){
        if ($987364579193c928$var$browserPrefixToKey(prop, $987364579193c928$var$prefixes[i]) in style) return $987364579193c928$var$prefixes[i];
    }
    return "";
}
function $987364579193c928$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($987364579193c928$var$kebabToTitleCase(prop)) : prop;
}
function $987364579193c928$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $987364579193c928$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $987364579193c928$var$_default = module.exports.default = $987364579193c928$var$getPrefix();

});


parcelRegister("d8Yny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $991adbb8c49a4ddd$var$canDragX;
module.exports.canDragY = $991adbb8c49a4ddd$var$canDragY;
module.exports.createCoreData = $991adbb8c49a4ddd$var$createCoreData;
module.exports.createDraggableData = $991adbb8c49a4ddd$var$createDraggableData;
module.exports.getBoundPosition = $991adbb8c49a4ddd$var$getBoundPosition;
module.exports.getControlPosition = $991adbb8c49a4ddd$var$getControlPosition;
module.exports.snapToGrid = $991adbb8c49a4ddd$var$snapToGrid;

var $F7YrN = parcelRequire("F7YrN");

var $asyUn = parcelRequire("asyUn");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $991adbb8c49a4ddd$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $991adbb8c49a4ddd$var$cloneBounds(bounds);
    const node = $991adbb8c49a4ddd$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $F7YrN.int)(boundNodeStyle.paddingLeft) + (0, $F7YrN.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $F7YrN.int)(boundNodeStyle.paddingTop) + (0, $F7YrN.int)(nodeStyle.marginTop),
            right: (0, $asyUn.innerWidth)(boundNodeEl) - (0, $asyUn.outerWidth)(node) - node.offsetLeft + (0, $F7YrN.int)(boundNodeStyle.paddingRight) - (0, $F7YrN.int)(nodeStyle.marginRight),
            bottom: (0, $asyUn.innerHeight)(boundNodeEl) - (0, $asyUn.outerHeight)(node) - node.offsetTop + (0, $F7YrN.int)(boundNodeStyle.paddingBottom) - (0, $F7YrN.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $F7YrN.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $F7YrN.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $F7YrN.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $F7YrN.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $991adbb8c49a4ddd$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $991adbb8c49a4ddd$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $991adbb8c49a4ddd$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
// Get {x, y} positions from event.
function $991adbb8c49a4ddd$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === "number" ? (0, $asyUn.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    const node = $991adbb8c49a4ddd$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $asyUn.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $991adbb8c49a4ddd$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $F7YrN.isNum)(draggable.lastX);
    const node = $991adbb8c49a4ddd$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $991adbb8c49a4ddd$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $991adbb8c49a4ddd$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $991adbb8c49a4ddd$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("hydce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc6fd920a0008648$var$React = $cc6fd920a0008648$var$_interopRequireWildcard((parcelRequire("7E7Dk")));

var $cc6fd920a0008648$var$_propTypes = $cc6fd920a0008648$var$_interopRequireDefault((parcelRequire("jMvuK")));

var $cc6fd920a0008648$var$_reactDom = $cc6fd920a0008648$var$_interopRequireDefault((parcelRequire("hzbSh")));

var $asyUn = parcelRequire("asyUn");

var $d8Yny = parcelRequire("d8Yny");

var $F7YrN = parcelRequire("F7YrN");

var $cc6fd920a0008648$var$_log = $cc6fd920a0008648$var$_interopRequireDefault((parcelRequire("2N40L")));
function $cc6fd920a0008648$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc6fd920a0008648$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc6fd920a0008648$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc6fd920a0008648$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc6fd920a0008648$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc6fd920a0008648$var$_defineProperty(obj, key, value) {
    key = $cc6fd920a0008648$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc6fd920a0008648$var$_toPropertyKey(arg) {
    var key = $cc6fd920a0008648$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $cc6fd920a0008648$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $cc6fd920a0008648$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
// Default to mouse events.
let $cc6fd920a0008648$var$dragEventFor = $cc6fd920a0008648$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $cc6fd920a0008648$var$DraggableCore extends $cc6fd920a0008648$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $cc6fd920a0008648$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $cc6fd920a0008648$var$_defineProperty(this, "lastX", NaN);
        $cc6fd920a0008648$var$_defineProperty(this, "lastY", NaN);
        $cc6fd920a0008648$var$_defineProperty(this, "touchIdentifier", null);
        $cc6fd920a0008648$var$_defineProperty(this, "mounted", false);
        $cc6fd920a0008648$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $asyUn.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $asyUn.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $asyUn.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $d8Yny.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $d8Yny.createCoreData)(this, x, y);
            (0, $cc6fd920a0008648$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $cc6fd920a0008648$var$_log.default)("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $asyUn.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $asyUn.addEvent)(ownerDocument, $cc6fd920a0008648$var$dragEventFor.move, this.handleDrag);
            (0, $asyUn.addEvent)(ownerDocument, $cc6fd920a0008648$var$dragEventFor.stop, this.handleDragStop);
        });
        $cc6fd920a0008648$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $d8Yny.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $d8Yny.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $d8Yny.createCoreData)(this, x, y);
            (0, $cc6fd920a0008648$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent("MouseEvents");
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $cc6fd920a0008648$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $d8Yny.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $d8Yny.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $d8Yny.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $asyUn.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $cc6fd920a0008648$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $cc6fd920a0008648$var$_log.default)("DraggableCore: Removing handlers");
                (0, $asyUn.removeEvent)(thisNode.ownerDocument, $cc6fd920a0008648$var$dragEventFor.move, this.handleDrag);
                (0, $asyUn.removeEvent)(thisNode.ownerDocument, $cc6fd920a0008648$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $cc6fd920a0008648$var$_defineProperty(this, "onMouseDown", (e)=>{
            $cc6fd920a0008648$var$dragEventFor = $cc6fd920a0008648$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $cc6fd920a0008648$var$_defineProperty(this, "onMouseUp", (e)=>{
            $cc6fd920a0008648$var$dragEventFor = $cc6fd920a0008648$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $cc6fd920a0008648$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $cc6fd920a0008648$var$dragEventFor = $cc6fd920a0008648$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $cc6fd920a0008648$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $cc6fd920a0008648$var$dragEventFor = $cc6fd920a0008648$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $asyUn.addEvent)(thisNode, $cc6fd920a0008648$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $asyUn.removeEvent)(ownerDocument, $cc6fd920a0008648$var$eventsFor.mouse.move, this.handleDrag);
            (0, $asyUn.removeEvent)(ownerDocument, $cc6fd920a0008648$var$eventsFor.touch.move, this.handleDrag);
            (0, $asyUn.removeEvent)(ownerDocument, $cc6fd920a0008648$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $asyUn.removeEvent)(ownerDocument, $cc6fd920a0008648$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $asyUn.removeEvent)(thisNode, $cc6fd920a0008648$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $asyUn.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $cc6fd920a0008648$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $cc6fd920a0008648$var$React.cloneElement($cc6fd920a0008648$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $cc6fd920a0008648$var$DraggableCore;
$cc6fd920a0008648$var$_defineProperty($cc6fd920a0008648$var$DraggableCore, "displayName", "DraggableCore");
$cc6fd920a0008648$var$_defineProperty($cc6fd920a0008648$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $cc6fd920a0008648$var$_propTypes.default.bool,
    children: $cc6fd920a0008648$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $cc6fd920a0008648$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $cc6fd920a0008648$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $cc6fd920a0008648$var$_propTypes.default.arrayOf($cc6fd920a0008648$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $cc6fd920a0008648$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $cc6fd920a0008648$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $cc6fd920a0008648$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $cc6fd920a0008648$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $cc6fd920a0008648$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $cc6fd920a0008648$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $cc6fd920a0008648$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $cc6fd920a0008648$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $F7YrN.dontSetMe,
    style: $F7YrN.dontSetMe,
    transform: $F7YrN.dontSetMe
});
$cc6fd920a0008648$var$_defineProperty($cc6fd920a0008648$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("2N40L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $208344f4ae5f1791$var$log;
/*eslint no-console:0*/ function $208344f4ae5f1791$var$log() {}

});




parcelRegister("gJbmc", function(module, exports) {

$parcel$export(module.exports, "Resizable", function () { return $c2d9a8913b7c2e87$export$e82068809229c83c; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hzbSh = parcelRequire("hzbSh");

var $1C5L9 = parcelRequire("1C5L9");
var $c2d9a8913b7c2e87$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c2d9a8913b7c2e87$var$__assign = undefined && undefined.__assign || function() {
    $c2d9a8913b7c2e87$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2d9a8913b7c2e87$var$__assign.apply(this, arguments);
};
var $c2d9a8913b7c2e87$var$DEFAULT_SIZE = {
    width: "auto",
    height: "auto"
};
var $c2d9a8913b7c2e87$var$clamp = function(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var $c2d9a8913b7c2e87$var$snap = function(n, size, gridGap) {
    var v = Math.round(n / size);
    return v * size + gridGap * (v - 1);
};
var $c2d9a8913b7c2e87$var$hasDirection = function(dir, target) {
    return new RegExp(dir, "i").test(target);
};
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var $c2d9a8913b7c2e87$var$isTouchEvent = function(event) {
    return Boolean(event.touches && event.touches.length);
};
var $c2d9a8913b7c2e87$var$isMouseEvent = function(event) {
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var $c2d9a8913b7c2e87$var$findClosestSnap = function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
var $c2d9a8913b7c2e87$var$getStringSize = function(n) {
    n = n.toString();
    if (n === "auto") return n;
    if (n.endsWith("px")) return n;
    if (n.endsWith("%")) return n;
    if (n.endsWith("vh")) return n;
    if (n.endsWith("vw")) return n;
    if (n.endsWith("vmax")) return n;
    if (n.endsWith("vmin")) return n;
    return n + "px";
};
var $c2d9a8913b7c2e87$var$getPixelSize = function(size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === "string") {
        if (size.endsWith("px")) return Number(size.replace("px", ""));
        if (size.endsWith("%")) {
            var ratio = Number(size.replace("%", "")) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith("vw")) {
            var ratio = Number(size.replace("vw", "")) / 100;
            return innerWidth * ratio;
        }
        if (size.endsWith("vh")) {
            var ratio = Number(size.replace("vh", "")) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var $c2d9a8913b7c2e87$var$calculateNewMax = function(parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = $c2d9a8913b7c2e87$var$getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = $c2d9a8913b7c2e87$var$getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = $c2d9a8913b7c2e87$var$getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = $c2d9a8913b7c2e87$var$getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === "undefined" ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === "undefined" ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === "undefined" ? undefined : Number(minWidth),
        minHeight: typeof minHeight === "undefined" ? undefined : Number(minHeight)
    };
};
/**
 * transform T | [T, T] to [T, T]
 * @param val
 * @returns
 */ // tslint:disable-next-line
var $c2d9a8913b7c2e87$var$normalizeToPair = function(val) {
    return Array.isArray(val) ? val : [
        val,
        val
    ];
};
var $c2d9a8913b7c2e87$var$definedProps = [
    "as",
    "ref",
    "style",
    "className",
    "grid",
    "gridGap",
    "snap",
    "bounds",
    "boundsByDirection",
    "size",
    "defaultSize",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "lockAspectRatio",
    "lockAspectRatioExtraWidth",
    "lockAspectRatioExtraHeight",
    "enable",
    "handleStyles",
    "handleClasses",
    "handleWrapperStyle",
    "handleWrapperClass",
    "children",
    "onResizeStart",
    "onResize",
    "onResizeStop",
    "handleComponent",
    "scale",
    "resizeRatio",
    "snapGap"
];
// HACK: This class is used to calculate % size.
var $c2d9a8913b7c2e87$var$baseClassName = "__resizable_base__";
var $c2d9a8913b7c2e87$export$e82068809229c83c = /** @class */ function(_super) {
    $c2d9a8913b7c2e87$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function() {
            if (!_this.resizable || !_this.window) return null;
            var parent = _this.parentNode;
            if (!parent) return null;
            var element = _this.window.document.createElement("div");
            element.style.width = "100%";
            element.style.height = "100%";
            element.style.position = "absolute";
            element.style.transform = "scale(0, 0)";
            element.style.left = "0";
            element.style.flex = "0 0 100%";
            if (element.classList) element.classList.add($c2d9a8913b7c2e87$var$baseClassName);
            else element.className += $c2d9a8913b7c2e87$var$baseClassName;
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function(base) {
            var parent = _this.parentNode;
            if (!parent) return;
            parent.removeChild(base);
        };
        _this.state = {
            isResizing: false,
            width: (_b = (_a = _this.propsSize) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : "auto",
            height: (_d = (_c = _this.propsSize) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : "auto",
            direction: "right",
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0,0,0,0)",
                cursor: "auto",
                opacity: 0,
                position: "fixed",
                zIndex: 9999,
                top: "0",
                left: "0",
                bottom: "0",
                right: "0"
            },
            flexBasis: undefined
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function() {
            if (!this.resizable) return null;
            if (!this.resizable.ownerDocument) return null;
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $c2d9a8913b7c2e87$var$DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== "relative") this.resizable.style.position = "relative";
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                var _a;
                if (typeof _this.state[key] === "undefined" || _this.state[key] === "auto") return "auto";
                if (_this.propsSize && _this.propsSize[key] && ((_a = _this.propsSize[key]) === null || _a === void 0 ? void 0 : _a.toString().endsWith("%"))) {
                    if (_this.state[key].toString().endsWith("%")) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace("px", ""));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $c2d9a8913b7c2e87$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== "undefined" && !this.state.isResizing ? $c2d9a8913b7c2e87$var$getStringSize(size.width) : getSize("width");
            var height = size && typeof size.height !== "undefined" && !this.state.isResizing ? $c2d9a8913b7c2e87$var$getStringSize(size.height) : getSize("height");
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.parentNode) {
            if (!this.window) return {
                width: 0,
                height: 0
            };
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        var base = this.appendBase();
        if (!base) return {
            width: 0,
            height: 0
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== "wrap") {
            wrapChanged = true;
            this.parentNode.style.flexWrap = "wrap";
        // HACK: Use relative to get parent padding size
        }
        base.style.position = "relative";
        base.style.minWidth = "100%";
        base.style.minHeight = "100%";
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function() {
        if (this.window) {
            this.window.addEventListener("mouseup", this.onMouseUp);
            this.window.addEventListener("mousemove", this.onMouseMove);
            this.window.addEventListener("mouseleave", this.onMouseUp);
            this.window.addEventListener("touchmove", this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function() {
        if (this.window) {
            this.window.removeEventListener("mouseup", this.onMouseUp);
            this.window.removeEventListener("mousemove", this.onMouseMove);
            this.window.removeEventListener("mouseleave", this.onMouseUp);
            this.window.removeEventListener("touchmove", this.onMouseMove, true);
            this.window.removeEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function() {
        if (!this.resizable || !this.window) return;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== "auto" ? computedStyle.flexBasis : undefined
        });
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (this.window) this.unbindEvents();
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === "auto" && this.state.original[kind] === newSize && (typeof propsSize === "undefined" || propsSize === "auto") ? "auto" : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && $c2d9a8913b7c2e87$var$hasDirection("left", direction);
        var heightByDirection = boundsByDirection && $c2d9a8913b7c2e87$var$hasDirection("top", direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === "parent") {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === "window") {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        if (boundHeight && Number.isFinite(boundHeight)) maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var _a = $c2d9a8913b7c2e87$var$normalizeToPair(this.props.resizeRatio || 1), resizeRatioX = _a[0], resizeRatioY = _a[1];
        var _b = this.state, direction = _b.direction, original = _b.original;
        var _c = this.props, lockAspectRatio = _c.lockAspectRatio, lockAspectRatioExtraHeight = _c.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _c.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($c2d9a8913b7c2e87$var$hasDirection("right", direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($c2d9a8913b7c2e87$var$hasDirection("left", direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($c2d9a8913b7c2e87$var$hasDirection("bottom", direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($c2d9a8913b7c2e87$var$hasDirection("top", direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === "undefined" ? 10 : min.width;
        var computedMaxWidth = typeof max.width === "undefined" || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === "undefined" ? 10 : min.height;
        var computedMaxHeight = typeof max.height === "undefined" || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $c2d9a8913b7c2e87$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $c2d9a8913b7c2e87$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $c2d9a8913b7c2e87$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $c2d9a8913b7c2e87$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        var adjustedScale = 1 / (this.props.scale || 1);
        // For parent boundary
        if (this.props.bounds === "parent") {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left * adjustedScale;
                this.parentTop = parentRect.top * adjustedScale;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== "string") {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left * adjustedScale;
            this.targetTop = targetRect.top * adjustedScale;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left * adjustedScale;
            this.resizableRight = right * adjustedScale;
            this.resizableTop = top_1 * adjustedScale;
            this.resizableBottom = bottom * adjustedScale;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        if (!this.resizable || !this.window) return;
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && $c2d9a8913b7c2e87$var$isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && $c2d9a8913b7c2e87$var$isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== "undefined" && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== "undefined" && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== "auto") {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith("row") ? "row" : "column";
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: $c2d9a8913b7c2e87$var$__assign($c2d9a8913b7c2e87$var$__assign({}, this.state.backgroundStyle), {
                cursor: this.window.getComputedStyle(event.target).cursor || "auto"
            }),
            direction: direction,
            flexBasis: flexBasis
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function(event) {
        var _this = this;
        if (!this.state.isResizing || !this.resizable || !this.window) return;
        if (this.window.TouchEvent && $c2d9a8913b7c2e87$var$isTouchEvent(event)) try {
            event.preventDefault();
            event.stopPropagation();
        } catch (e) {
        // Ignore on fail
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = $c2d9a8913b7c2e87$var$isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = $c2d9a8913b7c2e87$var$isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $c2d9a8913b7c2e87$var$calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) newWidth = $c2d9a8913b7c2e87$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $c2d9a8913b7c2e87$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $c2d9a8913b7c2e87$var$snap(newWidth, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0);
            var newGridHeight = $c2d9a8913b7c2e87$var$snap(newHeight, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0);
            var gap = this.props.snapGap || 0;
            var w = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            var h = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
            newWidth = w;
            newHeight = h;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === "string") {
            if (width.endsWith("%")) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if (width.endsWith("vw")) {
                var vw = newWidth / this.window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if (width.endsWith("vh")) {
                var vh = newWidth / this.window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === "string") {
            if (height.endsWith("%")) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if (height.endsWith("vw")) {
                var vw = newHeight / this.window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if (height.endsWith("vh")) {
                var vh = newHeight / this.window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, "width"),
            height: this.createSizeForCssProperty(newHeight, "height")
        };
        if (this.flexDir === "row") newState.flexBasis = newState.width;
        else if (this.flexDir === "column") newState.flexBasis = newState.height;
        var widthChanged = this.state.width !== newState.width;
        var heightChanged = this.state.height !== newState.height;
        var flexBaseChanged = this.state.flexBasis !== newState.flexBasis;
        var changed = widthChanged || heightChanged || flexBaseChanged;
        if (changed) // For v18, update state sync
        (0, $hzbSh.flushSync)(function() {
            _this.setState(newState);
        });
        if (this.props.onResize) {
            if (changed) this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a, _b;
        var _c = this.state, isResizing = _c.isResizing, direction = _c.direction, original = _c.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState({
            width: (_a = this.props.size.width) !== null && _a !== void 0 ? _a : "auto",
            height: (_b = this.props.size.height) !== null && _b !== void 0 ? _b : "auto"
        });
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: $c2d9a8913b7c2e87$var$__assign($c2d9a8913b7c2e87$var$__assign({}, this.state.backgroundStyle), {
                cursor: "auto"
            })
        });
    };
    Resizable.prototype.updateSize = function(size) {
        var _a, _b;
        this.setState({
            width: (_a = size.width) !== null && _a !== void 0 ? _a : "auto",
            height: (_b = size.height) !== null && _b !== void 0 ? _b : "auto"
        });
    };
    Resizable.prototype.renderResizer = function(directions) {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = directions.filter(function(dir) {
            return enable[dir] !== false;
        }).map(function(dir) {
            if (enable[dir] !== false) return $7E7Dk.createElement((0, $1C5L9.Resizer), {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $7E7Dk.createElement("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($c2d9a8913b7c2e87$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = $c2d9a8913b7c2e87$var$__assign($c2d9a8913b7c2e87$var$__assign($c2d9a8913b7c2e87$var$__assign({
            position: "relative",
            userSelect: this.state.isResizing ? "none" : "auto"
        }, this.props.style), this.sizeStyle), {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: "border-box",
            flexShrink: 0
        });
        if (this.state.flexBasis) style.flexBasis = this.state.flexBasis;
        var Wrapper = this.props.as || "div";
        return $7E7Dk.createElement(Wrapper, $c2d9a8913b7c2e87$var$__assign({
            style: style,
            className: this.props.className
        }, extendsProps, {
            // `ref` is after `extendsProps` to ensure this one wins over a version
            // passed in
            ref: function(c) {
                if (c) _this.resizable = c;
            }
        }), this.state.isResizing && $7E7Dk.createElement("div", {
            style: this.state.backgroundStyle
        }), this.renderResizer([
            "topLeft",
            "top",
            "topRight",
            "left"
        ]), this.props.children, this.renderResizer([
            "right",
            "bottomLeft",
            "bottom",
            "bottomRight"
        ]));
    };
    Resizable.defaultProps = {
        as: "div",
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        gridGap: [
            0,
            0
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($7E7Dk.PureComponent);

});
parcelRegister("1C5L9", function(module, exports) {

$parcel$export(module.exports, "Resizer", function () { return $12cdcec6d943c91e$export$48a76196cafe3b93; });

var $7E7Dk = parcelRequire("7E7Dk");
var $12cdcec6d943c91e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $12cdcec6d943c91e$var$__assign = undefined && undefined.__assign || function() {
    $12cdcec6d943c91e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12cdcec6d943c91e$var$__assign.apply(this, arguments);
};
var $12cdcec6d943c91e$var$rowSizeBase = {
    width: "100%",
    height: "10px",
    top: "0px",
    left: "0px",
    cursor: "row-resize"
};
var $12cdcec6d943c91e$var$colSizeBase = {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "0px",
    cursor: "col-resize"
};
var $12cdcec6d943c91e$var$edgeBase = {
    width: "20px",
    height: "20px",
    position: "absolute"
};
var $12cdcec6d943c91e$var$styles = {
    top: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$rowSizeBase), {
        top: "-5px"
    }),
    right: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$colSizeBase), {
        left: undefined,
        right: "-5px"
    }),
    bottom: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$rowSizeBase), {
        top: undefined,
        bottom: "-5px"
    }),
    left: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$colSizeBase), {
        left: "-5px"
    }),
    topRight: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$edgeBase), {
        right: "-10px",
        top: "-10px",
        cursor: "ne-resize"
    }),
    bottomRight: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$edgeBase), {
        right: "-10px",
        bottom: "-10px",
        cursor: "se-resize"
    }),
    bottomLeft: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$edgeBase), {
        left: "-10px",
        bottom: "-10px",
        cursor: "sw-resize"
    }),
    topLeft: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({}, $12cdcec6d943c91e$var$edgeBase), {
        left: "-10px",
        top: "-10px",
        cursor: "nw-resize"
    })
};
var $12cdcec6d943c91e$export$48a76196cafe3b93 = /** @class */ function(_super) {
    $12cdcec6d943c91e$var$__extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function() {
        return $7E7Dk.createElement("div", {
            className: this.props.className || "",
            style: $12cdcec6d943c91e$var$__assign($12cdcec6d943c91e$var$__assign({
                position: "absolute",
                userSelect: "none"
            }, $12cdcec6d943c91e$var$styles[this.props.direction]), this.props.replaceStyles || {}),
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart
        }, this.props.children);
    };
    return Resizer;
}($7E7Dk.PureComponent);

});



parcelRegister("gavWA", function(module, exports) {

$parcel$export(module.exports, "SECONDS_IN_A_DAY", function () { return $883b8e2bd0cb58af$export$4d524ffb9e480934; });
$parcel$export(module.exports, "MINUTES_IN_A_DAY", function () { return $883b8e2bd0cb58af$export$8009aebd81f4c7e7; });
$parcel$export(module.exports, "MAX_DURATION_SECONDS", function () { return $883b8e2bd0cb58af$export$64499a03306c8adc; });
$parcel$export(module.exports, "SNAP_INCREMENT_MINUTES", function () { return $883b8e2bd0cb58af$export$fccbabbe7f59dec7; });
$parcel$export(module.exports, "MIN_DURATION_MINUTES", function () { return $883b8e2bd0cb58af$export$a91b697516f54527; });
$parcel$export(module.exports, "DEFAULT_DURATION_MINUTES", function () { return $883b8e2bd0cb58af$export$c1b20abdf19e9320; });
$parcel$export(module.exports, "PIXELS_PER_MINUTE", function () { return $883b8e2bd0cb58af$export$d5849d4172ceb5e2; });
const $883b8e2bd0cb58af$export$4d524ffb9e480934 = 86400 // 24 * 60 * 60
;
const $883b8e2bd0cb58af$export$8009aebd81f4c7e7 = 1440 // 24 * 60
;
const $883b8e2bd0cb58af$export$1b168b5c9cc46385 = 40 // Slot height in pixels
;
const $883b8e2bd0cb58af$export$802677262e924bef = 60;
const $883b8e2bd0cb58af$export$841f9feef894ee10 = 900;
const $883b8e2bd0cb58af$export$64499a03306c8adc = 86400 // 24 hours in seconds
;
const $883b8e2bd0cb58af$export$fccbabbe7f59dec7 = 15 // 15-minute increments
;
const $883b8e2bd0cb58af$export$a91b697516f54527 = 15 // Minimum duration of 15 minutes
;
const $883b8e2bd0cb58af$export$c1b20abdf19e9320 = 60 // Default duration of 60 minutes
;
const $883b8e2bd0cb58af$export$d5849d4172ceb5e2 = $883b8e2bd0cb58af$export$1b168b5c9cc46385 / $883b8e2bd0cb58af$export$802677262e924bef;

});

parcelRegister("2kTlz", function(module, exports) {

$parcel$export(module.exports, "formatTimeRange", function () { return $7cce161e6d555685$export$b40fc491ceb69c4e; });

var $gavWA = parcelRequire("gavWA");
const $7cce161e6d555685$export$195604d042fd3f87 = (seconds)=>{
    const increment = 900;
    return Math.round(seconds / increment) * increment;
};
const $7cce161e6d555685$export$ca57cf514421edf7 = (from, to)=>{
    const minDuration = 1800;
    return to - from < minDuration ? from + minDuration : to;
};
const $7cce161e6d555685$export$3203edd9e5edd663 = (seconds)=>{
    const SECONDS_IN_AN_HOUR = 3600;
    const SECONDS_IN_A_MINUTE = 60;
    const totalSecondsInDay = seconds % (0, $gavWA.SECONDS_IN_A_DAY);
    const hours = Math.floor(totalSecondsInDay / SECONDS_IN_AN_HOUR).toString().padStart(2, "0");
    const minutes = Math.floor(totalSecondsInDay % SECONDS_IN_AN_HOUR / SECONDS_IN_A_MINUTE).toString().padStart(2, "0");
    return `${hours}:${minutes}`;
};
const $7cce161e6d555685$export$b40fc491ceb69c4e = (from, to)=>{
    const isFullDay = to - from === (0, $gavWA.SECONDS_IN_A_DAY) && from % (0, $gavWA.SECONDS_IN_A_DAY) === 0;
    const endTime = isFullDay ? "24:00" : $7cce161e6d555685$export$3203edd9e5edd663(to);
    return `${$7cce161e6d555685$export$3203edd9e5edd663(from)} - ${endTime}`;
};

});




parcelRegister("5EmX1", function(module, exports) {
$parcel$export(module.exports, "InformationDialog", function () { return (parcelRequire("c6OxJ")).InformationDialog; });
parcelRequire("c6OxJ");

});
parcelRegister("c6OxJ", function(module, exports) {

$parcel$export(module.exports, "InformationDialog", function () { return $cf054b345cb2437e$export$e41b5fed7e5788b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("MMfqT");
var $eySth = parcelRequire("eySth");
function $cf054b345cb2437e$export$e41b5fed7e5788b({ visible: visible, title: title, message: message, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnOkay"),
        icon: "pi pi-check",
        onClick: onHide
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eySth.Dialog), {
        visible: visible,
        header: title,
        onHide: onHide,
        footer: footer,
        style: {
            width: "30rem"
        },
        "data-testid": "information-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm line-height-3",
        "data-testid": "information-dialog-message"
    }, message));
}

});


parcelRegister("iBnrJ", function(module, exports) {
$parcel$export(module.exports, "ScheduledTimeSlotEditorDialog", function () { return (parcelRequire("3F5fJ")).ScheduledTimeSlotEditorDialog; });
parcelRequire("3F5fJ");

});
parcelRegister("3F5fJ", function(module, exports) {

$parcel$export(module.exports, "ScheduledTimeSlotEditorDialog", function () { return $a4160012b01c6b79$export$3c45b5387ebc9efe; });

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $hMQzl = parcelRequire("hMQzl");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("MMfqT");
var $eySth = parcelRequire("eySth");
parcelRequire("5zuE9");
var $2kTlz = parcelRequire("2kTlz");
function $a4160012b01c6b79$export$3c45b5387ebc9efe({ minPossibleCurrent: minPossibleCurrent, maxPossibleCurrent: maxPossibleCurrent, selectedSchedulePeriod: selectedSchedulePeriod, isSocket: isSocket, visible: visible, onHide: onHide, onSave: onSave }) {
    const text = (0, $5u6k9.default)();
    const [currentDraft, setCurrentDraft] = (0, $7E7Dk.useState)(null);
    const currentValue = currentDraft && selectedSchedulePeriod && currentDraft.schedulePeriodId === selectedSchedulePeriod.id && currentDraft.sourceCurrent === selectedSchedulePeriod.maxCurrent ? currentDraft.value : selectedSchedulePeriod?.maxCurrent;
    const timeRange = selectedSchedulePeriod ? (0, $2kTlz.formatTimeRange)(selectedSchedulePeriod.from, selectedSchedulePeriod.to) : null;
    const save = ()=>{
        if (selectedSchedulePeriod && typeof currentValue === "number") {
            setCurrentDraft(null);
            onSave({
                ...selectedSchedulePeriod,
                maxCurrent: currentValue
            });
        }
    };
    const hide = ()=>{
        setCurrentDraft(null);
        onHide();
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        text: true,
        label: text("btnCancel"),
        type: "button",
        onClick: hide,
        "data-testid": "cancel-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnApply"),
        type: "button",
        onClick: save,
        "data-testid": "save-btn"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eySth.Dialog), {
        header: text("lblEditScheduledTimeSlotDialogTitle"),
        visible: visible,
        onHide: hide,
        footer: footer,
        "data-testid": "scheduled-time-slot-editor-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, timeRange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("dl", {
        className: "flex flex-column gap-2 m-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("dt", {
        className: "p-label"
    }, text("lblScheduledTimeSlotTimeRangeField")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("dd", {
        className: "m-0 font-semibold"
    }, timeRange)) : null, isSocket ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm font-bold py-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSocketChargingStatus",
        values: {
            isOn: !!selectedSchedulePeriod?.maxCurrent
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hMQzl.default), {
        label: text("lblScheduledTimeSlotMaximumCurrentField"),
        value: currentValue || 0,
        minValue: minPossibleCurrent,
        maxValue: maxPossibleCurrent,
        showClear: false,
        onChange: ({ value: value })=>{
            if (typeof value === "number" && selectedSchedulePeriod) setCurrentDraft({
                schedulePeriodId: selectedSchedulePeriod.id,
                sourceCurrent: selectedSchedulePeriod.maxCurrent,
                value: value
            });
        },
        placeholder: text("lblSelectOption"),
        error: typeof currentValue !== "number" ? text("msgMaxCurrentRequired") : undefined
    })));
}

});


parcelRegister("1pilk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9032300f7788ed99$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ConnectorType", function () { return $9032300f7788ed99$export$18dbf40ba8d1d9db; });

var $7E7Dk = parcelRequire("7E7Dk");

var $5u6k9 = parcelRequire("5u6k9");
parcelRequire("hPpPu");
var $1zWXi = parcelRequire("1zWXi");
const $9032300f7788ed99$export$995438c00bb67b1c = "Schuko";
const $9032300f7788ed99$export$a9d1e241b521e30d = "Socket";
function $9032300f7788ed99$export$2e2bcd8739ae039({ connectors: connectors, value: value, onChange: onChange }) {
    const text = (0, $5u6k9.default)();
    const getConnectorName = (connectorId, connectors)=>{
        const connector = connectors?.find((connector)=>connector.connectorId === connectorId);
        if (!connector || !connectors?.length) return "Connector";
        const hasSchuko = connectors.some((connector)=>connector.connectorFunctionType === $9032300f7788ed99$export$995438c00bb67b1c);
        if (hasSchuko) {
            if (connector.connectorFunctionType === $9032300f7788ed99$export$995438c00bb67b1c) {
                if (connectors.length > 1) return text("lblSocketOnly");
                return text("lblSocket");
            }
            if (connectors.length > 1) return text("lblChargerOnly");
            return text("lblCharger");
        }
        if (connectors.length > 1) {
            if (connectorId === 1) return text("lblLeftSocket");
            return text("lblRightSocket");
        }
        return text("lblSocketWithId", {
            connectorId: connectorId
        });
    };
    const options = connectors.map((connector)=>({
            label: getConnectorName(connector.connectorId, connectors),
            value: connector.connectorId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "sm:w-12 md:w-6 lg:w-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1zWXi.SelectButton), {
        id: "connector-select",
        ariaLabel: text("lblConnectorSettings"),
        value: value,
        options: options,
        onChange: onChange,
        fullWidth: true
    }));
}
var $9032300f7788ed99$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType[ConnectorType["CHARGER"] = 1] = "CHARGER";
    ConnectorType[ConnectorType["SOCKET"] = 2] = "SOCKET";
})($9032300f7788ed99$export$18dbf40ba8d1d9db || ($9032300f7788ed99$export$18dbf40ba8d1d9db = {}));

});

parcelRegister("6bmOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2986c940194fa811$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $cOkzk = parcelRequire("cOkzk");
parcelRequire("18mUD");
var $jb3Im = parcelRequire("jb3Im");

var $eIymc = parcelRequire("eIymc");

var $5u6k9 = parcelRequire("5u6k9");

var $1hIPE = parcelRequire("1hIPE");
parcelRequire("eUJ8c");
var $3CLIQ = parcelRequire("3CLIQ");

var $3rYDT = parcelRequire("3rYDT");

var $hohPv = parcelRequire("hohPv");

var $lFIQ9 = parcelRequire("lFIQ9");
parcelRequire("c6fcw");
var $3ABLj = parcelRequire("3ABLj");

var $gGzon = parcelRequire("gGzon");

var $igvrl = parcelRequire("igvrl");

var $1pilk = parcelRequire("1pilk");

var $hMQzl = parcelRequire("hMQzl");
const $2986c940194fa811$var$rotationKeyframes = (0, $gRonV.keyframes)`
    100% {
        transform:rotate(360deg);
    }
`;
const $2986c940194fa811$var$SyncStatusIcon = (0, $gRonV.default).img`
    ${(p)=>p.rotating && (0, $gRonV.css)`
            animation: ${$2986c940194fa811$var$rotationKeyframes} 4s linear infinite;
        `}
    width: 2em;
    margin-right: 0.5rem;
`;
const $2986c940194fa811$var$fadeOutKeyframes = (0, $gRonV.keyframes)`
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`;
const $2986c940194fa811$var$FadingWrapper = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    animation: ${$2986c940194fa811$var$fadeOutKeyframes} 2s forwards ease 5s;
`;
const $2986c940194fa811$var$SyncedStatus = ({ syncStatus: syncStatus })=>{
    if (syncStatus === "Synced") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$FadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$SyncStatusIcon, {
        src: "/common/content/images/synced.png"
    }), "Synced");
    return null;
};
const $2986c940194fa811$var$SyncStatus = ({ syncStatus: syncStatus })=>{
    if (syncStatus === "Syncing") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        title: "It take times to apply changes to charger. Please make sure your charger is online if charger is not charging according to latest schedule."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$SyncStatusIcon, {
        src: "/common/content/images/syncing.png",
        rotating: true
    }), "Syncing");
    if (syncStatus === "NotSynced") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        title: "It take times to apply changes to charger. Please make sure your charger is online if charger is not charging according to latest schedule."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$SyncStatusIcon, {
        src: "/common/content/images/not-synced.png"
    }), "Not synced");
    return null;
};
function $2986c940194fa811$export$2e2bcd8739ae039({ chargePoint: chargePoint, schedule: schedule, onUpdateSchedule: onUpdateSchedule, numberOfConnectors: numberOfConnectors, connectorId: connectorId, onChangeConnectorId: onChangeConnectorId, onClearSchedule: onClearSchedule, minPossibleCurrent: minPossibleCurrent, maxPossibleCurrent: maxPossibleCurrent, onSaveSchedule: onSaveSchedule, disabledSave: disabledSave, disabledDefaultCurrent: disabledDefaultCurrent, disabledControls: disabledControls, disabledClear: disabledClear, disabledClearReason: disabledClearReason, syncStatus: syncStatus = "Synced", showSyncedStatusIcon: showSyncedStatusIcon }) {
    const text = (0, $5u6k9.default)();
    const msgs = (0, $7E7Dk.useRef)(null);
    const getConnectorWarningText = ()=>{
        if (!schedule?.isActive || schedule?.isActive && schedule?.schedulePeriods?.length === 0) return null;
        const connectorMode = chargePoint?.connectors?.find((c)=>c.connectorId === connectorId)?.mode;
        if (connectorMode === "Off") return text("msgScheduleIsIgnoredChargerIsSetToOff");
        else if (connectorMode === "On") return text("msgScheduleIsIgnoreChargerIsSetToAlwaysOn");
        return null;
    };
    const connectorWarningText = getConnectorWarningText();
    (0, $7E7Dk.useEffect)(()=>{
        if (msgs.current) {
            msgs.current.clear();
            if (connectorWarningText) msgs.current.show([
                {
                    sticky: true,
                    severity: "warn",
                    detail: connectorWarningText,
                    closable: false
                }
            ]);
        }
    }, [
        connectorWarningText,
        text
    ]);
    if (!chargePoint) return null;
    const isSchukodisabledforAdmin = (0, $3rYDT.default)(chargePoint) && connectorId === (0, $1pilk.ConnectorType).CHARGER && (0, $eIymc.isAdminDomain);
    const isDefaultCurrentEnabled = (0, $eIymc.isSupportDomain) || (0, $eIymc.isPartnerDomain) || (0, $1hIPE.default)(chargePoint) || (0, $hohPv.default)(chargePoint) || (0, $lFIQ9.default)(chargePoint);
    const showMaximumCurrent = (0, $1hIPE.default)(chargePoint) || connectorId === (0, $1pilk.ConnectorType).CHARGER;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "ml-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, (0, $eIymc.isUserappDomain) && typeof schedule.defaultCurrent !== "undefined" && schedule.defaultCurrent > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "notification-class "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "alert-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $jb3Im.AlertIcon), {
        size: 28,
        fill: (0, $3CLIQ.theme).brandColors.CA_Black
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "mt-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgUserSmartSchedulingNotifications",
        values: {
            default: Math.round(schedule.defaultCurrent)
        }
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cOkzk.Messages), {
        ref: msgs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "grid"
    }, numberOfConnectors > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1pilk.default), {
        connectors: chargePoint.connectors ?? [],
        value: connectorId,
        onChange: onChangeConnectorId
    })), (isSchukodisabledforAdmin || isDefaultCurrentEnabled) && !(0, $eIymc.isUserappDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hMQzl.default), {
        label: text("msgSetFollowingCurrentForUnscheduledSlots"),
        infoText: !(0, $eIymc.isUserappDomain) && text("msgSmartScheduleChargerUseInstructionshort"),
        value: schedule.defaultCurrent,
        onChange: (event)=>onUpdateSchedule({
                ...schedule,
                defaultCurrent: event.value
            }),
        minValue: minPossibleCurrent,
        maxValue: maxPossibleCurrent,
        placeholder: text("lblSelectOption"),
        disabled: disabledControls || disabledDefaultCurrent,
        isSocket: !(0, $1hIPE.default)(chargePoint) && connectorId === (0, $1pilk.ConnectorType).SOCKET,
        error: (()=>{
            if (schedule.defaultCurrent && schedule.defaultCurrent > maxPossibleCurrent) return connectorId === (0, $1pilk.ConnectorType).CHARGER || (0, $1hIPE.default)(chargePoint) ? text("msgMaximumCurrentReached", {
                maxPossibleCurrent: maxPossibleCurrent
            }) : `Maximum current is set to ${maxPossibleCurrent} A. Socket might not be charging optimally. To ensure optimal charging for socket, set current to 10 A and above.`;
        })()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3ABLj.Dropdown), {
        label: text("lblSelectTimeZone"),
        infoText: text("msgTimeZoneShouldHaveSameLocationAsCharger"),
        disabled: disabledControls,
        value: schedule.timeZone,
        onChange: (event)=>{
            onUpdateSchedule({
                ...schedule,
                timeZone: event.value
            });
        },
        options: (0, $gGzon.default).map((tz)=>({
                label: `(GMT${tz.utc}) ${tz.name}`,
                value: tz.code
            })),
        error: schedule.timeZone ? undefined : text("errTimeZoneRequired"),
        id: "time-zone-select"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$SyncStatus, {
        syncStatus: syncStatus
    }), showSyncedStatusIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2986c940194fa811$var$SyncedStatus, {
        syncStatus: syncStatus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column md:flex-row md:align-items-end justify-content-between gap-2 mt-2 mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-sm text-color-secondary m-0"
    }, showMaximumCurrent ? text("msgMaximumChargingCurrentScheduleLimit", {
        maximumCurrent: maxPossibleCurrent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgSmartScheduleSocketUseInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2 align-self-end md:align-self-auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnClearSchedule"),
        icon: "pi pi-trash",
        severity: "danger",
        outlined: true,
        disabled: disabledClear,
        tooltip: disabledClearReason,
        tooltipOptions: {
            position: "top",
            showOnDisabled: true
        },
        onClick: ()=>onClearSchedule()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnSaveSchedule"),
        icon: "pi pi-save",
        onClick: onSaveSchedule,
        disabled: !!disabledSave || disabledControls,
        tooltip: typeof disabledSave === "string" ? disabledSave : undefined,
        tooltipOptions: {
            position: "top",
            showOnDisabled: true
        }
    }))));
}

});
parcelRegister("cOkzk", function(module, exports) {

$parcel$export(module.exports, "Messages", function () { return $953a1c1831c5af97$export$ceaacf8b390a3600; });

var $7E7Dk = parcelRequire("7E7Dk");

var $hySFd = parcelRequire("hySFd");

var $eHYdO = parcelRequire("eHYdO");

var $kHEnT = parcelRequire("kHEnT");

var $5B1eM = parcelRequire("5B1eM");

var $jr5t3 = parcelRequire("jr5t3");

var $7nrKB = parcelRequire("7nrKB");

var $eXeTx = parcelRequire("eXeTx");

var $dgIaN = parcelRequire("dgIaN");

var $8Murc = parcelRequire("8Murc");

var $2v3zC = parcelRequire("2v3zC");

var $f6Dhj = parcelRequire("f6Dhj");

var $1PxL0 = parcelRequire("1PxL0");
"use client";
function $953a1c1831c5af97$var$_extends() {
    return $953a1c1831c5af97$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $953a1c1831c5af97$var$_extends.apply(null, arguments);
}
function $953a1c1831c5af97$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $953a1c1831c5af97$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $953a1c1831c5af97$var$_arrayLikeToArray(r);
}
function $953a1c1831c5af97$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $953a1c1831c5af97$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $953a1c1831c5af97$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $953a1c1831c5af97$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $953a1c1831c5af97$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $953a1c1831c5af97$var$_toConsumableArray(r) {
    return $953a1c1831c5af97$var$_arrayWithoutHoles(r) || $953a1c1831c5af97$var$_iterableToArray(r) || $953a1c1831c5af97$var$_unsupportedIterableToArray(r) || $953a1c1831c5af97$var$_nonIterableSpread();
}
function $953a1c1831c5af97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $953a1c1831c5af97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $953a1c1831c5af97$var$_typeof(o);
}
function $953a1c1831c5af97$var$toPrimitive(t, r) {
    if ("object" != $953a1c1831c5af97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $953a1c1831c5af97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $953a1c1831c5af97$var$toPropertyKey(t) {
    var i = $953a1c1831c5af97$var$toPrimitive(t, "string");
    return "symbol" == $953a1c1831c5af97$var$_typeof(i) ? i : i + "";
}
function $953a1c1831c5af97$var$_defineProperty(e, r, t) {
    return (r = $953a1c1831c5af97$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $953a1c1831c5af97$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $953a1c1831c5af97$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $953a1c1831c5af97$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $953a1c1831c5af97$var$_slicedToArray(r, e) {
    return $953a1c1831c5af97$var$_arrayWithHoles(r) || $953a1c1831c5af97$var$_iterableToArrayLimit(r, e) || $953a1c1831c5af97$var$_unsupportedIterableToArray(r, e) || $953a1c1831c5af97$var$_nonIterableRest();
}
var $953a1c1831c5af97$var$styles = "\n@layer primereact {\n    .p-message-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-message-icon {\n        flex-shrink: 0;\n    }\n    \n    .p-message-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    .p-message-close.p-link {\n        margin-left: auto;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-message-enter {\n        opacity: 0;\n    }\n    \n    .p-message-enter-active {\n        opacity: 1;\n        transition: opacity .3s;\n    }\n    \n    .p-message-exit {\n        opacity: 1;\n        max-height: 1000px;\n    }\n    \n    .p-message-exit-active {\n        opacity: 0;\n        max-height: 0;\n        margin: 0;\n        overflow: hidden;\n        transition: max-height .3s cubic-bezier(0, 1, 0, 1), opacity .3s, margin .3s;\n    }\n    \n    .p-message-exit-active .p-message-close {\n        display: none;\n    }\n}\n";
var $953a1c1831c5af97$var$classes = {
    uimessage: {
        root: function root(_ref) {
            var severity = _ref.severity;
            return (0, $7nrKB.classNames)("p-message p-component", $953a1c1831c5af97$var$_defineProperty({}, "p-message-".concat(severity), severity));
        },
        wrapper: "p-message-wrapper",
        detail: "p-message-detail",
        summary: "p-message-summary",
        icon: "p-message-icon",
        buttonicon: "p-message-close-icon",
        button: "p-message-close p-link",
        transition: "p-message"
    }
};
var $953a1c1831c5af97$var$MessagesBase = (0, $kHEnT.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Messages",
        __parentMetadata: null,
        id: null,
        className: null,
        style: null,
        transitionOptions: null,
        onRemove: null,
        onClick: null,
        children: undefined
    },
    css: {
        classes: $953a1c1831c5af97$var$classes,
        styles: $953a1c1831c5af97$var$styles
    }
});
function $953a1c1831c5af97$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $953a1c1831c5af97$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $953a1c1831c5af97$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $953a1c1831c5af97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $953a1c1831c5af97$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $953a1c1831c5af97$var$UIMessage = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(props, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var messageInfo = props.message, parentMetaData = props.metaData, _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, index = props.index;
    var _messageInfo$message = messageInfo.message, severity = _messageInfo$message.severity, content = _messageInfo$message.content, summary = _messageInfo$message.summary, detail = _messageInfo$message.detail, closable = _messageInfo$message.closable, life = _messageInfo$message.life, sticky = _messageInfo$message.sticky, _className = _messageInfo$message.className, style = _messageInfo$message.style, _contentClassName = _messageInfo$message.contentClassName, contentStyle = _messageInfo$message.contentStyle, _icon = _messageInfo$message.icon, _closeIcon = _messageInfo$message.closeIcon, pt = _messageInfo$message.pt;
    var params = {
        index: index
    };
    var parentParams = $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, parentMetaData), params);
    var _useTimeout = (0, $jr5t3.useTimeout)(function() {
        onClose(null);
    }, life || 3000, !sticky), _useTimeout2 = $953a1c1831c5af97$var$_slicedToArray(_useTimeout, 1), clearTimer = _useTimeout2[0];
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $953a1c1831c5af97$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onClose = function onClose(event) {
        clearTimer();
        props.onClose && props.onClose(props.message);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var onClick = function onClick() {
        props.onClick && props.onClick(props.message);
    };
    var createCloseIcon = function createCloseIcon() {
        if (closable !== false) {
            var buttonIconProps = mergeProps({
                className: cx("uimessage.buttonicon")
            }, getPTOptions("buttonicon", parentParams), ptmo(pt, "buttonicon", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _closeIcon || /*#__PURE__*/ $7E7Dk.createElement((0, $2v3zC.TimesIcon), buttonIconProps);
            var _closeIcon2 = (0, $7nrKB.IconUtils).getJSXIcon(icon, $953a1c1831c5af97$var$_objectSpread$1({}, buttonIconProps), {
                props: props
            });
            var buttonProps = mergeProps({
                type: "button",
                className: cx("uimessage.button"),
                "aria-label": (0, $eHYdO.ariaLabel)("close"),
                onClick: onClose
            }, getPTOptions("button", parentParams), ptmo(pt, "button", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            return /*#__PURE__*/ $7E7Dk.createElement("button", buttonProps, _closeIcon2, /*#__PURE__*/ $7E7Dk.createElement((0, $1PxL0.Ripple), null));
        }
        return null;
    };
    var createMessage = function createMessage() {
        if (props.message) {
            var iconProps = mergeProps({
                className: cx("uimessage.icon")
            }, getPTOptions("icon", parentParams), ptmo(pt, "icon", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _icon;
            if (!_icon) switch(severity){
                case "info":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $8Murc.InfoCircleIcon), iconProps);
                    break;
                case "warn":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $dgIaN.ExclamationTriangleIcon), iconProps);
                    break;
                case "error":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $f6Dhj.TimesCircleIcon), iconProps);
                    break;
                case "success":
                    icon = /*#__PURE__*/ $7E7Dk.createElement((0, $eXeTx.CheckIcon), iconProps);
                    break;
            }
            var iconContent = (0, $7nrKB.IconUtils).getJSXIcon(icon, $953a1c1831c5af97$var$_objectSpread$1({}, iconProps), {
                props: props
            });
            var summaryProps = mergeProps({
                className: cx("uimessage.summary")
            }, getPTOptions("summary", parentParams), ptmo(pt, "summary", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var detailProps = mergeProps({
                className: cx("uimessage.detail")
            }, getPTOptions("detail", parentParams), ptmo(pt, "detail", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            return content || /*#__PURE__*/ $7E7Dk.createElement($7E7Dk.Fragment, null, iconContent, /*#__PURE__*/ $7E7Dk.createElement("span", summaryProps, summary), /*#__PURE__*/ $7E7Dk.createElement("span", detailProps, detail));
        }
        return null;
    };
    var closeIcon = createCloseIcon();
    var message = createMessage();
    var wrapperProps = mergeProps({
        className: (0, $7nrKB.classNames)(_contentClassName, cx("uimessage.wrapper")),
        style: contentStyle
    }, getPTOptions("wrapper", parentParams), ptmo(pt, "wrapper", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
        hostName: props.hostName
    })));
    var rootProps = mergeProps({
        ref: ref,
        className: (0, $7nrKB.classNames)(_className, cx("uimessage.root", {
            severity: severity
        })),
        style: style,
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        onClick: onClick
    }, getPTOptions("root", parentParams), ptmo(pt, "root", $953a1c1831c5af97$var$_objectSpread$1($953a1c1831c5af97$var$_objectSpread$1({}, params), {}, {
        hostName: props.hostName
    })));
    return /*#__PURE__*/ $7E7Dk.createElement("div", rootProps, /*#__PURE__*/ $7E7Dk.createElement("div", wrapperProps, message, closeIcon));
}));
$953a1c1831c5af97$var$UIMessage.displayName = "UIMessage";
function $953a1c1831c5af97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $953a1c1831c5af97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $953a1c1831c5af97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $953a1c1831c5af97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $953a1c1831c5af97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $953a1c1831c5af97$var$messageIdx = 0;
var $953a1c1831c5af97$export$ceaacf8b390a3600 = /*#__PURE__*/ $7E7Dk.memo(/*#__PURE__*/ $7E7Dk.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $jr5t3.useMergeProps)();
    var context = $7E7Dk.useContext((0, $eHYdO.PrimeReactContext));
    var props = $953a1c1831c5af97$var$MessagesBase.getProps(inProps, context);
    var _React$useState = $7E7Dk.useState([]), _React$useState2 = $953a1c1831c5af97$var$_slicedToArray(_React$useState, 2), messagesState = _React$useState2[0], setMessagesState = _React$useState2[1];
    var elementRef = $7E7Dk.useRef(null);
    var metaData = $953a1c1831c5af97$var$_objectSpread($953a1c1831c5af97$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            messages: messagesState
        }
    });
    var ptCallbacks = $953a1c1831c5af97$var$MessagesBase.setMetaData(metaData);
    (0, $kHEnT.useHandleStyle)($953a1c1831c5af97$var$MessagesBase.css.styles, ptCallbacks.isUnstyled, {
        name: "messages"
    });
    var show = function show(messageInfo) {
        if (messageInfo) setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, true);
        });
    };
    var assignIdentifiers = function assignIdentifiers(currentState, messageInfo, copy) {
        var messages;
        if (Array.isArray(messageInfo)) {
            var multipleMessages = messageInfo.reduce(function(acc, message) {
                acc.push({
                    _pId: $953a1c1831c5af97$var$messageIdx++,
                    message: message
                });
                return acc;
            }, []);
            if (copy) messages = currentState ? [].concat($953a1c1831c5af97$var$_toConsumableArray(currentState), $953a1c1831c5af97$var$_toConsumableArray(multipleMessages)) : multipleMessages;
            else messages = multipleMessages;
        } else {
            var message = {
                _pId: $953a1c1831c5af97$var$messageIdx++,
                message: messageInfo
            };
            if (copy) messages = currentState ? [].concat($953a1c1831c5af97$var$_toConsumableArray(currentState), [
                message
            ]) : [
                message
            ];
            else messages = [
                message
            ];
        }
        return messages;
    };
    var clear = function clear() {
        setMessagesState([]);
    };
    var replace = function replace(messageInfo) {
        setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, false);
        });
    };
    var remove = function remove(messageInfo) {
        // allow removal by ID or by message equality
        var removeMessage = (0, $7nrKB.ObjectUtils).isNotEmpty(messageInfo._pId) ? messageInfo._pId : messageInfo.message || messageInfo;
        setMessagesState(function(prev) {
            return prev.filter(function(msg) {
                return msg._pId !== messageInfo._pId && !(0, $7nrKB.ObjectUtils).deepEquals(msg.message, removeMessage);
            });
        });
        props.onRemove && props.onRemove(messageInfo.message || removeMessage);
    };
    var onClose = function onClose(messageInfo) {
        remove(messageInfo);
    };
    $7E7Dk.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            replace: replace,
            remove: remove,
            clear: clear,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        id: props.id,
        className: props.className,
        style: props.style
    }, $953a1c1831c5af97$var$MessagesBase.getOtherProps(props), ptCallbacks.ptm("root"));
    var transitionProps = mergeProps({
        classNames: ptCallbacks.cx("uimessage.transition"),
        unmountOnExit: true,
        timeout: {
            enter: 300,
            exit: 300
        },
        options: props.transitionOptions
    }, ptCallbacks.ptm("transition"));
    return /*#__PURE__*/ $7E7Dk.createElement("div", $953a1c1831c5af97$var$_extends({
        ref: elementRef
    }, rootProps), /*#__PURE__*/ $7E7Dk.createElement((0, $hySFd.default), null, messagesState && messagesState.map(function(message, index) {
        var messageRef = /*#__PURE__*/ $7E7Dk.createRef();
        return /*#__PURE__*/ $7E7Dk.createElement((0, $5B1eM.CSSTransition), $953a1c1831c5af97$var$_extends({
            nodeRef: messageRef,
            key: message._pId
        }, transitionProps), /*#__PURE__*/ $7E7Dk.createElement($953a1c1831c5af97$var$UIMessage, {
            hostName: "Messages",
            ref: messageRef,
            message: message,
            onClick: props.onClick,
            onClose: onClose,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            index: index
        }));
    })));
}));
$953a1c1831c5af97$export$ceaacf8b390a3600.displayName = "Messages";

});



parcelRegister("2eCtI", function(module, exports) {
$parcel$export(module.exports, "Link", function () { return (parcelRequire("ib1zn")).Link; });
$parcel$export(module.exports, "PageHeader", function () { return (parcelRequire("ib1zn")).PageHeader; });
parcelRequire("ib1zn");

});
parcelRegister("ib1zn", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $2f1f75128818a0f6$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "PageHeader", function () { return $2f1f75128818a0f6$export$53f1cd6809577fc5; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");
parcelRequire("f2ZGs");
var $l9BgE = parcelRequire("l9BgE");
parcelRequire("1XnpB");
var $8zepY = parcelRequire("8zepY");
const $2f1f75128818a0f6$var$Container = (0, $gRonV.default).header`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:after {
        position: absolute;
        content: '';
        right: 0;
        left: 0;
        bottom: 0;
        height: 1px;
        background-color: ${({ theme: theme, scrolled: scrolled })=>scrolled ? theme.brandColors.CA_Light_Gray : "transparent"};
        transition: background-color 0.2s;
    }
`;
const $2f1f75128818a0f6$export$a6c7ac8248d6e38a = (0, $gRonV.default).a.withConfig({
    shouldForwardProp: (p)=>p !== "light" && p !== "selected"
})`
    color: ${({ theme: theme, selected: selected, light: light })=>{
    if (selected) return theme.brandColors.CA_Green;
    if (light) return theme.font.lightestColor;
    return theme.font.midDarkColor;
}};
    transition: all 0.2s ease;
    letter-spacing: 0.01em;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: ${({ selected: selected })=>selected ? "none" : "underline"};
    }

    &:focus {
        text-decoration: none;
        color: ${({ theme: theme, selected: selected })=>selected ? theme.font.midLightColor : theme.font.midDarkColor};
    }
`;
function $2f1f75128818a0f6$export$53f1cd6809577fc5({ className: className, style: style, links: links, title: title, disableLogout: disableLogout, logoutDisabledReason: logoutDisabledReason }) {
    const [scrolled, setScrolled] = (0, $7E7Dk.useState)(false);
    const { pathname: pathname } = (0, $4AX6R.useLocation)();
    (0, $7E7Dk.useEffect)(()=>{
        const handleScroll = ()=>setScrolled(window.scrollY !== 0);
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2f1f75128818a0f6$var$Container, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        scrolled: scrolled,
        "data-testid": "header-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-3 md:gap-4 align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "caLogo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        to: "/dashboard",
        onClick: ()=>{
            if (pathname === "dashboard") window.scrollTo(0, 0);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8zepY.ChargeAmpsLandingPageLogo), null))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h1", {
        className: "m-0 mb-1 line-height-1 text-xl md:text-2xl",
        "data-testid": "header-title"
    }, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $l9BgE.PageHeaderDrawer), {
        links: links,
        disableLogout: disableLogout,
        logoutDisabledReason: logoutDisabledReason
    }));
}

});
parcelRegister("f2ZGs", function(module, exports) {
$parcel$export(module.exports, "PageHeaderDrawer", function () { return (parcelRequire("l9BgE")).PageHeaderDrawer; });
parcelRequire("l9BgE");

});
parcelRegister("l9BgE", function(module, exports) {

$parcel$export(module.exports, "PageHeaderDrawer", function () { return $a3429151ee87edef$export$d0c2268edd21513e; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");
parcelRequire("d9H69");
var $cjFhx = parcelRequire("cjFhx");

var $igvrl = parcelRequire("igvrl");
parcelRequire("ljoiY");
var $6f5ta = parcelRequire("6f5ta");
parcelRequire("htz5i");
var $e6Hwq = parcelRequire("e6Hwq");
parcelRequire("2eCtI");
var $ib1zn = parcelRequire("ib1zn");

var $43ttK = parcelRequire("43ttK");

var $5u6k9 = parcelRequire("5u6k9");
const $a3429151ee87edef$var$Wrapper = (0, $gRonV.default).div`
    font-weight: var(--font-weight-bold);
    display: flex;
    align-items: center;
    gap: 34px;
    font-size: 1.125rem;
`;
const $a3429151ee87edef$var$BurgerButton = (0, $gRonV.default).div`
    width: fit-content;
    height: 20px;
    z-index: 99999;

    &:hover {
        cursor: pointer;
    }

    @media screen and (max-width: 700px) {
        transform: scale(0.8);
    }
`;
const $a3429151ee87edef$var$SelectedRoute = (0, $gRonV.default).div`
    font-weight: var(--font-weight-bold);
    font-size: 1.25rem;
    letter-spacing: 0.01em;
    color: ${({ theme: theme })=>theme.font.midDarkColor};

    @media screen and (max-width: 700px) {
        display: none;
    }
`;
const $a3429151ee87edef$var$NotificationDot = (0, $gRonV.default).span`
    width: 8px;
    height: 8px;
    background: ${({ theme: theme })=>theme.brandColors.CA_Error_Red};
    border-radius: 50%;
    display: inline-block;
    margin-left: 6px;
`;
const $a3429151ee87edef$var$DrawerMenuItem = (0, $gRonV.default).div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
const $a3429151ee87edef$var$DrawerSubMenuHeader = (0, $gRonV.default).div`
    pointer-events: none;
    cursor: default;
    color: ${({ theme: theme })=>theme.font.midLightColor};
`;
const $a3429151ee87edef$export$d0c2268edd21513e = /*#__PURE__*/ (0, $7E7Dk.memo)(function HeaderDrawer({ links: links, disableLogout: disableLogout = false, logoutDisabledReason: logoutDisabledReason }) {
    const text = (0, $5u6k9.default)();
    const callSignOut = (0, $6f5ta.useSignOut)();
    const { pathname: pathname } = (0, $4AX6R.useLocation)();
    const [openDrawer, setOpenDrawer] = (0, $7E7Dk.useState)(false);
    const safeLinks = (0, $7E7Dk.useMemo)(()=>links.filter((l)=>!!l), [
        links
    ]);
    const containerRef = (0, $7E7Dk.useRef)(null);
    (0, $43ttK.default)(containerRef, ()=>{
        setOpenDrawer(false);
    });
    const selectedRoute = (0, $7E7Dk.useMemo)(()=>{
        const directMatch = safeLinks.find((l)=>l.href === pathname);
        if (directMatch) return directMatch.displayLabelCode || directMatch.labelCode;
        if (pathname.startsWith("/billing")) return "lblBilling";
        for (const link of safeLinks)if (link.subMenu) {
            const matchingSubLink = link.subMenu.find((subLink)=>subLink.href && pathname.includes(subLink.href.split("/")[1]));
            if (matchingSubLink) return matchingSubLink.displayLabelCode || matchingSubLink.labelCode;
        }
        return null;
    }, [
        pathname,
        safeLinks
    ]);
    const isMenuItemSelected = (item)=>{
        if (!item.href) return false;
        if (item.subMenu && item.subMenu.length > 0) {
            const itemBasePath = item.href.split("/")[1];
            const pathParts = pathname.split("/");
            return pathParts.length <= 2 && pathname.includes(itemBasePath);
        }
        return pathname?.includes(item.href.split("/")[1]);
    };
    const isSubmenuItemSelected = (href)=>{
        const subItemPath = href.split("/").filter(Boolean);
        const currentPathParts = pathname.split("/").filter(Boolean);
        if (subItemPath.length > 1) return subItemPath.every((part, index)=>currentPathParts[index] === part);
        return pathname.includes(href.split("/")[1]) && (currentPathParts.length === subItemPath.length || href.split("/")[1] === currentPathParts[0] && currentPathParts.length > 1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$Wrapper, {
        ref: containerRef
    }, selectedRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$SelectedRoute, {
        "data-testid": "location",
        style: {
            visibility: selectedRoute && !openDrawer ? "visible" : "hidden"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h4", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: selectedRoute
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$BurgerButton, {
        onClick: ()=>setOpenDrawer(!openDrawer),
        "data-testid": "burgerButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cjFhx.BurgerMenuButton), {
        open: openDrawer
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e6Hwq.Drawer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            open: openDrawer
        }, "gap-3"),
        "data-testid": "drawer-menu"
    }, safeLinks.map((l, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$DrawerMenuItem, null, l.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ib1zn.Link), {
            as: (0, $3um4r.Link),
            to: l.href,
            selected: isMenuItemSelected(l),
            "data-testid": l.href,
            onClick: ()=>setOpenDrawer(false),
            onMouseEnter: l.prefetch,
            light: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: l.labelCode
        }), l.hasNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$NotificationDot, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$DrawerSubMenuHeader, {
            "data-testid": `menu-${l.labelCode}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: l.labelCode
        }), l.hasNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$NotificationDot, null))), l.subMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex flex-column gap-3 mt-3 ml-4 font-bold text-base",
            "data-testid": `submenu-${l.href || l.labelCode}`
        }, l.subMenu.map((subLink, subIndex)=>subLink.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ib1zn.Link), {
                key: subIndex,
                as: (0, $3um4r.Link),
                to: subLink.href,
                light: true,
                onClick: ()=>setOpenDrawer(false),
                selected: isSubmenuItemSelected(subLink.href),
                "data-testid": subLink.href
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
                code: subLink.labelCode
            }), subLink.hasNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a3429151ee87edef$var$NotificationDot, null)) : null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ib1zn.Link), {
        onClick: disableLogout ? undefined : callSignOut,
        "data-testid": "logOut",
        selected: false,
        light: true,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            "pointer-events-none opacity-50": disableLogout
        }),
        "aria-disabled": disableLogout,
        tabIndex: disableLogout ? -1 : undefined
    }, text("btnLogout")), disableLogout && logoutDisabledReason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        "data-testid": "drawer-logout-disabled-reason",
        className: "mt-2 mb-0 text-sm line-height-3 text-600"
    }, logoutDisabledReason) : null));
});

});
parcelRegister("d9H69", function(module, exports) {
$parcel$export(module.exports, "BurgerMenuButton", function () { return (parcelRequire("cjFhx")).BurgerMenuButton; });
parcelRequire("cjFhx");

});
parcelRegister("cjFhx", function(module, exports) {

$parcel$export(module.exports, "BurgerMenuButton", function () { return $da1abe475fbc7468$export$5eabdef8a31ee04f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");
const $da1abe475fbc7468$var$Container = (0, $gRonV.default).div`
    width: 25px;
    height: 20px;
    position: relative;
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;

    &.open span {
        background: ${({ theme: theme })=>theme.font.lightestColor};
    }

    span:nth-child(1) {
        top: 0px;
        transform-origin: left center;
    }

    &.open span:nth-child(1) {
        transform: rotate(45deg);
        top: -4px;
        left: 8px;
    }

    span:nth-child(2) {
        top: 8px;
        transform-origin: left center;
    }

    &.open span:nth-child(2) {
        width: 0%;
        opacity: 0;
    }

    span:nth-child(3) {
        top: 16px;
        transform-origin: left center;
    }

    &.open span:nth-child(3) {
        transform: rotate(-45deg);
        top: 14px;
        left: 8px;
    }
`;
const $da1abe475fbc7468$var$Span = (0, $gRonV.default).span`
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${({ theme: theme })=>theme.font.darkestColor};
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
`;
const $da1abe475fbc7468$var$SmallerSpan = (0, $gRonV.default)($da1abe475fbc7468$var$Span)`
    width: 19px;
    left: 3px;
`;
const $da1abe475fbc7468$export$5eabdef8a31ee04f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function BurgerMenuButton({ open: open }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da1abe475fbc7468$var$Container, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            open: open
        }),
        "data-testid": "burgerButtonIcon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da1abe475fbc7468$var$Span, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da1abe475fbc7468$var$SmallerSpan, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($da1abe475fbc7468$var$Span, null));
});

});







//# sourceMappingURL=index.0b8d36bd.js.map
